(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea80d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea80d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7ArpZ", function(module, exports) {

$parcel$export(module.exports, "Easing", () => Easing);
$parcel$export(module.exports, "Group", () => Group);
$parcel$export(module.exports, "Tween", () => Tween);
$parcel$export(module.exports, "update", () => update);
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var Easing = {
    Linear: {
        None: function(amount) {
            return amount;
        }
    },
    Quadratic: {
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    },
    Cubic: {
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    },
    Quartic: {
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    },
    Quintic: {
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    },
    Sinusoidal: {
        In: function(amount) {
            return 1 - Math.sin((1.0 - amount) * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.sin(Math.PI * (0.5 - amount)));
        }
    },
    Exponential: {
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    },
    Circular: {
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    },
    Elastic: {
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    },
    Back: {
        In: function(amount) {
            var s = 1.70158;
            return amount === 1 ? 1 : amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return amount === 0 ? 0 : --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    },
    Bounce: {
        In: function(amount) {
            return 1 - Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return Easing.Bounce.In(amount * 2) * 0.5;
            return Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    },
    generatePow: function(power) {
        if (power === void 0) power = 4;
        power = power < Number.EPSILON ? Number.EPSILON : power;
        power = power > 10000 ? 10000 : power;
        return {
            In: function(amount) {
                return Math.pow(amount, power);
            },
            Out: function(amount) {
                return 1 - Math.pow(1 - amount, power);
            },
            InOut: function(amount) {
                if (amount < 0.5) return Math.pow(amount * 2, power) / 2;
                return (1 - Math.pow(2 - amount * 2, power)) / 2 + 0.5;
            }
        };
    }
};
var now;
// Include a performance.now polyfill.
// In node.js, use process.hrtime.
// eslint-disable-next-line
// @ts-ignore
// if (typeof self === 'undefined' && typeof process !== 'undefined' && process.hrtime) {
//     now = function () {
//         // eslint-disable-next-line
//         // @ts-ignore
//         var time = process.hrtime();
//         // Convert [seconds, nanoseconds] to milliseconds.
//         return time[0] * 1000 + time[1] / 1000000;
//     };
// }
// In a browser, use self.performance.now if it is available.
if (typeof self !== "undefined" && self.performance !== undefined && self.performance.now !== undefined) // This must be bound, because directly assigning this function
// leads to an invocation exception in Chrome.
now = self.performance.now.bind(self.performance);
else if (Date.now !== undefined) now = Date.now;
else now = function() {
    return new Date().getTime();
};
var now$1 = now;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var Group = /** @class */ function() {
    function Group() {
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function(tween) {
        this._tweens[tween.getId()] = tween;
        this._tweensAddedDuringUpdate[tween.getId()] = tween;
    };
    Group.prototype.remove = function(tween) {
        delete this._tweens[tween.getId()];
        delete this._tweensAddedDuringUpdate[tween.getId()];
    };
    Group.prototype.update = function(time, preserve) {
        if (time === void 0) time = now$1();
        if (preserve === void 0) preserve = false;
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return false;
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                var autoStart = !preserve;
                if (tween && tween.update(time, autoStart) === false && !preserve) delete this._tweens[tweenIds[i]];
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
        return true;
    };
    return Group;
}();
/**
 *
 */ var Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    Sequence._nextId = 0;
    return Sequence;
}();
var mainGroup = new Group();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var Tween = /** @class */ function() {
    function Tween(_object, _group) {
        if (_group === void 0) _group = mainGroup;
        this._object = _object;
        this._group = _group;
        this._isPaused = false;
        this._pauseStart = 0;
        this._valuesStart = {};
        this._valuesEnd = {};
        this._valuesStartRepeat = {};
        this._duration = 1000;
        this._initialRepeat = 0;
        this._repeat = 0;
        this._yoyo = false;
        this._isPlaying = false;
        this._reversed = false;
        this._delayTime = 0;
        this._startTime = 0;
        this._easingFunction = Easing.Linear.None;
        this._interpolationFunction = Interpolation.Linear;
        // eslint-disable-next-line
        this._chainedTweens = [];
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._id = Sequence.nextId();
        this._isChainStopped = false;
        this._goToEnd = false;
    }
    Tween.prototype.getId = function() {
        return this._id;
    };
    Tween.prototype.isPlaying = function() {
        return this._isPlaying;
    };
    Tween.prototype.isPaused = function() {
        return this._isPaused;
    };
    Tween.prototype.to = function(properties, duration) {
        // TODO? restore this, then update the 07_dynamic_to example to set fox
        // tween's to on each update. That way the behavior is opt-in (there's
        // currently no opt-out).
        // for (const prop in properties) this._valuesEnd[prop] = properties[prop]
        this._valuesEnd = Object.create(properties);
        if (duration !== undefined) this._duration = duration;
        return this;
    };
    Tween.prototype.duration = function(d) {
        if (d === void 0) d = 1000;
        this._duration = d;
        return this;
    };
    Tween.prototype.start = function(time) {
        if (time === void 0) time = now$1();
        if (this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = time;
        this._startTime += this._delayTime;
        this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat);
        return this;
    };
    Tween.prototype.copyTimingAndStart = function(tween, time) {
        if (time === void 0) time = now$1();
        if (this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = tween._startTime;
        this._duration = tween._duration;
        this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat);
        return this;
    };
    Tween.prototype._setupProperties = function(_object, _valuesStart, _valuesEnd, _valuesStartRepeat) {
        for(var property in _valuesEnd){
            var startValue = _object[property];
            var startValueIsArray = Array.isArray(startValue);
            var propType = startValueIsArray ? "array" : typeof startValue;
            var isInterpolationList = !startValueIsArray && Array.isArray(_valuesEnd[property]);
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (propType === "undefined" || propType === "function") continue;
            // Check if an Array was provided as property value
            if (isInterpolationList) {
                var endValues = _valuesEnd[property];
                if (endValues.length === 0) continue;
                // handle an array of relative values
                endValues = endValues.map(this._handleRelativeValue.bind(this, startValue));
                // Create a local copy of the Array with the start value at the front
                _valuesEnd[property] = [
                    startValue
                ].concat(endValues);
            }
            // handle the deepness of the values
            if ((propType === "object" || startValueIsArray) && startValue && !isInterpolationList) {
                _valuesStart[property] = startValueIsArray ? [] : {};
                // eslint-disable-next-line
                for(var prop in startValue)// eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property][prop] = startValue[prop];
                _valuesStartRepeat[property] = startValueIsArray ? [] : {}; // TODO? repeat nested values? And yoyo? And array values?
                // eslint-disable-next-line
                // @ts-ignore FIXME?
                this._setupProperties(startValue, _valuesStart[property], _valuesEnd[property], _valuesStartRepeat[property]);
            } else {
                // Save the starting value, but only once.
                if (typeof _valuesStart[property] === "undefined") _valuesStart[property] = startValue;
                if (!startValueIsArray) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                if (isInterpolationList) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStartRepeat[property] = _valuesEnd[property].slice().reverse();
                else _valuesStartRepeat[property] = _valuesStart[property] || 0;
            }
        }
    };
    Tween.prototype.stop = function() {
        if (!this._isChainStopped) {
            this._isChainStopped = true;
            this.stopChainedTweens();
        }
        if (!this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.remove(this);
        this._isPlaying = false;
        this._isPaused = false;
        if (this._onStopCallback) this._onStopCallback(this._object);
        return this;
    };
    Tween.prototype.end = function() {
        this._goToEnd = true;
        this.update(Infinity);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (time === void 0) time = now$1();
        if (this._isPaused || !this._isPlaying) return this;
        this._isPaused = true;
        this._pauseStart = time;
        // eslint-disable-next-line
        this._group && this._group.remove(this);
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (time === void 0) time = now$1();
        if (!this._isPaused || !this._isPlaying) return this;
        this._isPaused = false;
        this._startTime += time - this._pauseStart;
        this._pauseStart = 0;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)this._chainedTweens[i].stop();
        return this;
    };
    Tween.prototype.group = function(group) {
        if (group === void 0) group = mainGroup;
        this._group = group;
        return this;
    };
    Tween.prototype.delay = function(amount) {
        if (amount === void 0) amount = 0;
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        if (times === void 0) times = 0;
        this._initialRepeat = times;
        this._repeat = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this._repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        if (yoyo === void 0) yoyo = false;
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easingFunction) {
        if (easingFunction === void 0) easingFunction = Easing.Linear.None;
        this._easingFunction = easingFunction;
        return this;
    };
    Tween.prototype.interpolation = function(interpolationFunction) {
        if (interpolationFunction === void 0) interpolationFunction = Interpolation.Linear;
        this._interpolationFunction = interpolationFunction;
        return this;
    };
    // eslint-disable-next-line
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onEveryStart = function(callback) {
        this._onEveryStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this._onStopCallback = callback;
        return this;
    };
    /**
     * @returns true if the tween is still playing after the update, false
     * otherwise (calling update on a paused tween still returns true because
     * it is still playing, just paused).
     */ Tween.prototype.update = function(time, autoStart) {
        if (time === void 0) time = now$1();
        if (autoStart === void 0) autoStart = true;
        if (this._isPaused) return true;
        var property;
        var elapsed;
        var endTime = this._startTime + this._duration;
        if (!this._goToEnd && !this._isPlaying) {
            if (time > endTime) return false;
            if (autoStart) this.start(time);
        }
        this._goToEnd = false;
        if (time < this._startTime) return true;
        if (this._onStartCallbackFired === false) {
            if (this._onStartCallback) this._onStartCallback(this._object);
            this._onStartCallbackFired = true;
        }
        if (this._onEveryStartCallbackFired === false) {
            if (this._onEveryStartCallback) this._onEveryStartCallback(this._object);
            this._onEveryStartCallbackFired = true;
        }
        elapsed = (time - this._startTime) / this._duration;
        elapsed = this._duration === 0 || elapsed > 1 ? 1 : elapsed;
        var value = this._easingFunction(elapsed);
        // properties transformations
        this._updateProperties(this._object, this._valuesStart, this._valuesEnd, value);
        if (this._onUpdateCallback) this._onUpdateCallback(this._object, elapsed);
        if (elapsed === 1) {
            if (this._repeat > 0) {
                if (isFinite(this._repeat)) this._repeat--;
                // Reassign starting values, restart by making startTime = now
                for(property in this._valuesStartRepeat){
                    if (!this._yoyo && typeof this._valuesEnd[property] === "string") this._valuesStartRepeat[property] = // eslint-disable-next-line
                    // @ts-ignore FIXME?
                    this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                    if (this._yoyo) this._swapEndStartRepeatValues(property);
                    this._valuesStart[property] = this._valuesStartRepeat[property];
                }
                if (this._yoyo) this._reversed = !this._reversed;
                if (this._repeatDelayTime !== undefined) this._startTime = time + this._repeatDelayTime;
                else this._startTime = time + this._delayTime;
                if (this._onRepeatCallback) this._onRepeatCallback(this._object);
                this._onEveryStartCallbackFired = false;
                return true;
            } else {
                if (this._onCompleteCallback) this._onCompleteCallback(this._object);
                for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this._chainedTweens[i].start(this._startTime + this._duration);
                this._isPlaying = false;
                return false;
            }
        }
        return true;
    };
    Tween.prototype._updateProperties = function(_object, _valuesStart, _valuesEnd, value) {
        for(var property in _valuesEnd){
            // Don't update properties that do not exist in the source object
            if (_valuesStart[property] === undefined) continue;
            var start = _valuesStart[property] || 0;
            var end = _valuesEnd[property];
            var startIsArray = Array.isArray(_object[property]);
            var endIsArray = Array.isArray(end);
            var isInterpolationList = !startIsArray && endIsArray;
            if (isInterpolationList) _object[property] = this._interpolationFunction(end, value);
            else if (typeof end === "object" && end) // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._updateProperties(_object[property], start, end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                end = this._handleRelativeValue(start, end);
                // Protect against non numeric properties.
                if (typeof end === "number") // eslint-disable-next-line
                // @ts-ignore FIXME?
                _object[property] = start + (end - start) * value;
            }
        }
    };
    Tween.prototype._handleRelativeValue = function(start, end) {
        if (typeof end !== "string") return end;
        if (end.charAt(0) === "+" || end.charAt(0) === "-") return start + parseFloat(end);
        else return parseFloat(end);
    };
    Tween.prototype._swapEndStartRepeatValues = function(property) {
        var tmp = this._valuesStartRepeat[property];
        var endValue = this._valuesEnd[property];
        if (typeof endValue === "string") this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(endValue);
        else this._valuesStartRepeat[property] = this._valuesEnd[property];
        this._valuesEnd[property] = tmp;
    };
    return Tween;
}();
var VERSION = "18.6.4";
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var nextId = Sequence.nextId;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tweens.
 */ var TWEEN = mainGroup;
// This is the best way to export things in a way that's compatible with both ES
// Modules and CommonJS, without build hacks, and so as not to break the
// existing API.
// https://github.com/rollup/rollup/issues/1961#issuecomment-423037881
var getAll = TWEEN.getAll.bind(TWEEN);
var removeAll = TWEEN.removeAll.bind(TWEEN);
var add = TWEEN.add.bind(TWEEN);
var remove = TWEEN.remove.bind(TWEEN);
var update = TWEEN.update.bind(TWEEN);
var exports = {
    Easing: Easing,
    Group: Group,
    Interpolation: Interpolation,
    now: now$1,
    Sequence: Sequence,
    nextId: nextId,
    Tween: Tween,
    VERSION: VERSION,
    getAll: getAll,
    removeAll: removeAll,
    add: add,
    remove: remove,
    update: update
};
var $586129e5a5c2f6d5$export$2e2bcd8739ae039 = exports;

});

parcelRegister("8NFma", function(module, exports) {
"use strict";

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
"use strict";
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("6T1J1", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
"use strict";

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;

});
parcelRegister("2pmb0", function(module, exports) {
"use strict";
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("23wBm"));

});
parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $17f526922e4a857c$var$Mg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Ng = null, $17f526922e4a857c$var$Og = null, $17f526922e4a857c$var$Pg = null;
function $17f526922e4a857c$var$Qg() {
    $17f526922e4a857c$var$Pg = $17f526922e4a857c$var$Og = $17f526922e4a857c$var$Ng = null;
}
function $17f526922e4a857c$var$Rg(a) {
    var b = $17f526922e4a857c$var$Mg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Mg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$Tg(a, b) {
    $17f526922e4a857c$var$Ng = a;
    $17f526922e4a857c$var$Pg = $17f526922e4a857c$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$Ug = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$Vg(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Og) {
            if (null === $17f526922e4a857c$var$Ng) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Og = a;
            $17f526922e4a857c$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Og = $17f526922e4a857c$var$Og.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$Wg = null;
function $17f526922e4a857c$var$Xg(a) {
    null === $17f526922e4a857c$var$Wg ? $17f526922e4a857c$var$Wg = [
        a
    ] : $17f526922e4a857c$var$Wg.push(a);
}
function $17f526922e4a857c$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$Zg(a, d);
}
function $17f526922e4a857c$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$$g = !1;
function $17f526922e4a857c$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$Zg(a, c);
}
function $17f526922e4a857c$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$jh = (new $8NFma.Component).refs;
function $17f526922e4a857c$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$L(), e = $17f526922e4a857c$var$lh(a), f = $17f526922e4a857c$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$dh(a, f, e);
        null !== b && ($17f526922e4a857c$var$mh(b, a, e, d), $17f526922e4a857c$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$L(), e = $17f526922e4a857c$var$lh(a), f = $17f526922e4a857c$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$dh(a, f, e);
        null !== b && ($17f526922e4a857c$var$mh(b, a, e, d), $17f526922e4a857c$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$L(), d = $17f526922e4a857c$var$lh(a), e = $17f526922e4a857c$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$dh(a, e, d);
        null !== b && ($17f526922e4a857c$var$mh(b, a, d, c), $17f526922e4a857c$var$eh(b, a, d));
    }
};
function $17f526922e4a857c$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$ph(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$Vg(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$nh.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $17f526922e4a857c$var$jh;
    $17f526922e4a857c$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$Vg(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$nh.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $17f526922e4a857c$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$sh(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$sh(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$zh(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Ah(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Bh = $17f526922e4a857c$var$vh(!0), $17f526922e4a857c$var$Ch = $17f526922e4a857c$var$vh(!1), $17f526922e4a857c$var$Dh = {}, $17f526922e4a857c$var$Eh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Dh), $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Dh), $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Dh);
function $17f526922e4a857c$var$Hh(a) {
    if (a === $17f526922e4a857c$var$Dh) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$Ih(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Gh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Fh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Eh, $17f526922e4a857c$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Eh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Eh, b);
}
function $17f526922e4a857c$var$Jh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Eh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Fh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Gh);
}
function $17f526922e4a857c$var$Kh(a) {
    $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Gh.current);
    var b = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$Fh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$Eh, c));
}
function $17f526922e4a857c$var$Lh(a) {
    $17f526922e4a857c$var$Fh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$Eh), $17f526922e4a857c$var$E($17f526922e4a857c$var$Fh));
}
var $17f526922e4a857c$var$M = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nh = [];
function $17f526922e4a857c$var$Oh() {
    for(var a = 0; a < $17f526922e4a857c$var$Nh.length; a++)$17f526922e4a857c$var$Nh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Nh.length = 0;
}
var $17f526922e4a857c$var$Ph = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Qh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Rh = 0, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$P = null, $17f526922e4a857c$var$Sh = !1, $17f526922e4a857c$var$Th = !1, $17f526922e4a857c$var$Uh = 0, $17f526922e4a857c$var$Vh = 0;
function $17f526922e4a857c$var$Q() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Xh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Rh = f;
    $17f526922e4a857c$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Ph.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Yh : $17f526922e4a857c$var$Zh;
    a = c(d, e);
    if ($17f526922e4a857c$var$Th) {
        f = 0;
        do {
            $17f526922e4a857c$var$Th = !1;
            $17f526922e4a857c$var$Uh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$P = $17f526922e4a857c$var$O = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Ph.current = $17f526922e4a857c$var$$h;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Th);
    }
    $17f526922e4a857c$var$Ph.current = $17f526922e4a857c$var$ai;
    b = null !== $17f526922e4a857c$var$O && null !== $17f526922e4a857c$var$O.next;
    $17f526922e4a857c$var$Rh = 0;
    $17f526922e4a857c$var$P = $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
    $17f526922e4a857c$var$Sh = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$bi() {
    var a = 0 !== $17f526922e4a857c$var$Uh;
    $17f526922e4a857c$var$Uh = 0;
    return a;
}
function $17f526922e4a857c$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$P ? $17f526922e4a857c$var$N.memoizedState = $17f526922e4a857c$var$P = a : $17f526922e4a857c$var$P = $17f526922e4a857c$var$P.next = a;
    return $17f526922e4a857c$var$P;
}
function $17f526922e4a857c$var$di() {
    if (null === $17f526922e4a857c$var$O) {
        var a = $17f526922e4a857c$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$O.next;
    var b = null === $17f526922e4a857c$var$P ? $17f526922e4a857c$var$N.memoizedState : $17f526922e4a857c$var$P.next;
    if (null !== b) $17f526922e4a857c$var$P = b, $17f526922e4a857c$var$O = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$O = a;
        a = {
            memoizedState: $17f526922e4a857c$var$O.memoizedState,
            baseState: $17f526922e4a857c$var$O.baseState,
            baseQueue: $17f526922e4a857c$var$O.baseQueue,
            queue: $17f526922e4a857c$var$O.queue,
            next: null
        };
        null === $17f526922e4a857c$var$P ? $17f526922e4a857c$var$N.memoizedState = $17f526922e4a857c$var$P = a : $17f526922e4a857c$var$P = $17f526922e4a857c$var$P.next = a;
    }
    return $17f526922e4a857c$var$P;
}
function $17f526922e4a857c$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$di(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$N.lanes |= m;
                $17f526922e4a857c$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$N.lanes |= f, $17f526922e4a857c$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$gi(a) {
    var b = $17f526922e4a857c$var$di(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$hi() {}
function $17f526922e4a857c$var$ii(a, b) {
    var c = $17f526922e4a857c$var$N, d = $17f526922e4a857c$var$di(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$Ug = !0);
    d = d.queue;
    $17f526922e4a857c$var$ji($17f526922e4a857c$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$P && $17f526922e4a857c$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$li(9, $17f526922e4a857c$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$R) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Rh & 30) || $17f526922e4a857c$var$ni(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$oi(b) && $17f526922e4a857c$var$pi(a);
}
function $17f526922e4a857c$var$ki(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$oi(b) && $17f526922e4a857c$var$pi(a);
    });
}
function $17f526922e4a857c$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$pi(a) {
    var b = $17f526922e4a857c$var$Zg(a, 1);
    null !== b && $17f526922e4a857c$var$mh(b, a, 1, -1);
}
function $17f526922e4a857c$var$qi(a) {
    var b = $17f526922e4a857c$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ri.bind(null, $17f526922e4a857c$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$si() {
    return $17f526922e4a857c$var$di().memoizedState;
}
function $17f526922e4a857c$var$ti(a, b, c, d) {
    var e = $17f526922e4a857c$var$ci();
    $17f526922e4a857c$var$N.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$ui(a, b, c, d) {
    var e = $17f526922e4a857c$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$O) {
        var g = $17f526922e4a857c$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Wh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$li(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$N.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$li(1 | b, c, f, d);
}
function $17f526922e4a857c$var$vi(a, b) {
    return $17f526922e4a857c$var$ti(8390656, 8, a, b);
}
function $17f526922e4a857c$var$ji(a, b) {
    return $17f526922e4a857c$var$ui(2048, 8, a, b);
}
function $17f526922e4a857c$var$wi(a, b) {
    return $17f526922e4a857c$var$ui(4, 2, a, b);
}
function $17f526922e4a857c$var$xi(a, b) {
    return $17f526922e4a857c$var$ui(4, 4, a, b);
}
function $17f526922e4a857c$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$ui(4, 4, $17f526922e4a857c$var$yi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$Ai() {}
function $17f526922e4a857c$var$Bi(a, b) {
    var c = $17f526922e4a857c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$Ci(a, b) {
    var c = $17f526922e4a857c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$Di(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Rh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$Ug = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$N.lanes |= c, $17f526922e4a857c$var$hh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$Ei(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Qh.transition;
    $17f526922e4a857c$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Qh.transition = d;
    }
}
function $17f526922e4a857c$var$Fi() {
    return $17f526922e4a857c$var$di().memoizedState;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = $17f526922e4a857c$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$Hi(a)) $17f526922e4a857c$var$Ii(b, c);
    else if (c = $17f526922e4a857c$var$Yg(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$L();
        $17f526922e4a857c$var$mh(c, a, d, e);
        $17f526922e4a857c$var$Ji(c, b, d);
    }
}
function $17f526922e4a857c$var$ri(a, b, c) {
    var d = $17f526922e4a857c$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$Hi(a)) $17f526922e4a857c$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$Yg(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$L(), $17f526922e4a857c$var$mh(c, a, d, e), $17f526922e4a857c$var$Ji(c, b, d));
    }
}
function $17f526922e4a857c$var$Hi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$N || null !== b && b === $17f526922e4a857c$var$N;
}
function $17f526922e4a857c$var$Ii(a, b) {
    $17f526922e4a857c$var$Th = $17f526922e4a857c$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$ai = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: $17f526922e4a857c$var$Q,
    useContext: $17f526922e4a857c$var$Q,
    useEffect: $17f526922e4a857c$var$Q,
    useImperativeHandle: $17f526922e4a857c$var$Q,
    useInsertionEffect: $17f526922e4a857c$var$Q,
    useLayoutEffect: $17f526922e4a857c$var$Q,
    useMemo: $17f526922e4a857c$var$Q,
    useReducer: $17f526922e4a857c$var$Q,
    useRef: $17f526922e4a857c$var$Q,
    useState: $17f526922e4a857c$var$Q,
    useDebugValue: $17f526922e4a857c$var$Q,
    useDeferredValue: $17f526922e4a857c$var$Q,
    useTransition: $17f526922e4a857c$var$Q,
    useMutableSource: $17f526922e4a857c$var$Q,
    useSyncExternalStore: $17f526922e4a857c$var$Q,
    useId: $17f526922e4a857c$var$Q,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Yh = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$Vg,
    useEffect: $17f526922e4a857c$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ti(4194308, 4, $17f526922e4a857c$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$Gi.bind(null, $17f526922e4a857c$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$qi,
    useDebugValue: $17f526922e4a857c$var$Ai,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$qi(!1), b = a[0];
        a = $17f526922e4a857c$var$Ei.bind(null, a[1]);
        $17f526922e4a857c$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$N, e = $17f526922e4a857c$var$ci();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$R) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Rh & 30) || $17f526922e4a857c$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$vi($17f526922e4a857c$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$li(9, $17f526922e4a857c$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$ci(), b = $17f526922e4a857c$var$R.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Zh = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: $17f526922e4a857c$var$Bi,
    useContext: $17f526922e4a857c$var$Vg,
    useEffect: $17f526922e4a857c$var$ji,
    useImperativeHandle: $17f526922e4a857c$var$zi,
    useInsertionEffect: $17f526922e4a857c$var$wi,
    useLayoutEffect: $17f526922e4a857c$var$xi,
    useMemo: $17f526922e4a857c$var$Ci,
    useReducer: $17f526922e4a857c$var$fi,
    useRef: $17f526922e4a857c$var$si,
    useState: function() {
        return $17f526922e4a857c$var$fi($17f526922e4a857c$var$ei);
    },
    useDebugValue: $17f526922e4a857c$var$Ai,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$di();
        return $17f526922e4a857c$var$Di(b, $17f526922e4a857c$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$fi($17f526922e4a857c$var$ei)[0], b = $17f526922e4a857c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$hi,
    useSyncExternalStore: $17f526922e4a857c$var$ii,
    useId: $17f526922e4a857c$var$Fi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$$h = {
    readContext: $17f526922e4a857c$var$Vg,
    useCallback: $17f526922e4a857c$var$Bi,
    useContext: $17f526922e4a857c$var$Vg,
    useEffect: $17f526922e4a857c$var$ji,
    useImperativeHandle: $17f526922e4a857c$var$zi,
    useInsertionEffect: $17f526922e4a857c$var$wi,
    useLayoutEffect: $17f526922e4a857c$var$xi,
    useMemo: $17f526922e4a857c$var$Ci,
    useReducer: $17f526922e4a857c$var$gi,
    useRef: $17f526922e4a857c$var$si,
    useState: function() {
        return $17f526922e4a857c$var$gi($17f526922e4a857c$var$ei);
    },
    useDebugValue: $17f526922e4a857c$var$Ai,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$di();
        return null === $17f526922e4a857c$var$O ? b.memoizedState = a : $17f526922e4a857c$var$Di(b, $17f526922e4a857c$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$gi($17f526922e4a857c$var$ei)[0], b = $17f526922e4a857c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$hi,
    useSyncExternalStore: $17f526922e4a857c$var$ii,
    useId: $17f526922e4a857c$var$Fi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Oi(a, b, c) {
    c = $17f526922e4a857c$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Pi || ($17f526922e4a857c$var$Pi = !0, $17f526922e4a857c$var$Qi = d);
        $17f526922e4a857c$var$Mi(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Ri(a, b, c) {
    c = $17f526922e4a857c$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Mi(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Si ? $17f526922e4a857c$var$Si = new Set([
            this
        ]) : $17f526922e4a857c$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$ch(-1, 1), b.tag = 2, $17f526922e4a857c$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Xi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$Ug = !1;
function $17f526922e4a857c$var$Yi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Ch(b, null, c, d) : $17f526922e4a857c$var$Bh(b, a.child, c, d);
}
function $17f526922e4a857c$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$Tg(b, e);
    d = $17f526922e4a857c$var$Xh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$bi();
    if (null !== a && !$17f526922e4a857c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$$i(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Yi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$cj(a, b, f, d, e);
        a = $17f526922e4a857c$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$Ug = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$$i(a, b, e);
        }
    }
    return $17f526922e4a857c$var$dj(a, b, c, d, e);
}
function $17f526922e4a857c$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj), $17f526922e4a857c$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj), $17f526922e4a857c$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj);
            $17f526922e4a857c$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$fj, $17f526922e4a857c$var$gj), $17f526922e4a857c$var$gj |= d;
    $17f526922e4a857c$var$Yi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$dj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$Tg(b, e);
    c = $17f526922e4a857c$var$Xh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$bi();
    if (null !== a && !$17f526922e4a857c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$$i(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Yi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$Tg(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$jj(a, b), $17f526922e4a857c$var$ph(b, c, d), $17f526922e4a857c$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$Vg(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$qh(b, g, d, l);
        $17f526922e4a857c$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$$g ? ("function" === typeof m && ($17f526922e4a857c$var$kh(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$$g || $17f526922e4a857c$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$Vg(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$qh(b, g, d, k);
        $17f526922e4a857c$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$$g ? ("function" === typeof y && ($17f526922e4a857c$var$kh(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$$g || $17f526922e4a857c$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$kj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$kj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$$i(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Bh(b, a.child, null, f), b.child = $17f526922e4a857c$var$Bh(b, null, h, f)) : $17f526922e4a857c$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$Ih(a, b.containerInfo);
}
function $17f526922e4a857c$var$mj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Yi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$pj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$M, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$qj(g, d, 0, null), a = $17f526922e4a857c$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$oj(c), b.memoizedState = $17f526922e4a857c$var$nj, a) : $17f526922e4a857c$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$wh(h, f) : (f = $17f526922e4a857c$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$rj(a, b) {
    b = $17f526922e4a857c$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$tj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Bh(b, a.child, null, c);
    a = $17f526922e4a857c$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Li(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$oj(g);
        b.memoizedState = $17f526922e4a857c$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Li(f, d, void 0);
        return $17f526922e4a857c$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$Ug || h) {
        d = $17f526922e4a857c$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$Zg(a, e), $17f526922e4a857c$var$mh(d, a, e, -1));
        }
        $17f526922e4a857c$var$uj();
        d = $17f526922e4a857c$var$Li(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$Sg(a.return, b, c);
}
function $17f526922e4a857c$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Yi(a, b, d.children, c);
    d = $17f526922e4a857c$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$wj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$lj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Kh(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$pj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1);
                a = $17f526922e4a857c$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$ej(a, b, c);
    }
    return $17f526922e4a857c$var$$i(a, b, c);
}
var $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj, $17f526922e4a857c$var$Dj;
$17f526922e4a857c$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Bj = function() {};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Ej(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$Jh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Gj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Bj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Lh(b);
            var e = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Gh.current);
                $17f526922e4a857c$var$Hh($17f526922e4a857c$var$Eh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Gj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$M.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$Jh(), $17f526922e4a857c$var$Bj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$Rg(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Ej(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$M, $17f526922e4a857c$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Hj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$M.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$M, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$gj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Jj(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$Jh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Lh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$M), null;
        case 4:
            return $17f526922e4a857c$var$Jh(), null;
        case 10:
            return $17f526922e4a857c$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Kj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Oj = !1;
function $17f526922e4a857c$var$Pj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Oj;
    $17f526922e4a857c$var$Oj = !1;
    return n;
}
function $17f526922e4a857c$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Xj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Xj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Yj = !1;
function $17f526922e4a857c$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$ak(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$ak(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Mj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Yj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Zj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Yj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Yj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Yj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Yj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Yj = !0;
            $17f526922e4a857c$var$Zj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Nj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Zj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Zj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Zj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Zj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Zj(a, b, c);
    }
}
function $17f526922e4a857c$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Lj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Yj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Yj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$ak(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$ek(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Qj(3, a, a.return), $17f526922e4a857c$var$Rj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Qj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Mj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            break;
        case 13:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$gk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$dk(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$dk(b, a);
            $17f526922e4a857c$var$fk(a);
            d & 4 && $17f526922e4a857c$var$bk(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$dk(b, a), $17f526922e4a857c$var$fk(a);
    }
}
function $17f526922e4a857c$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Vj(a);
                    $17f526922e4a857c$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Vj(a);
                    $17f526922e4a857c$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$jk(a, b, c);
}
function $17f526922e4a857c$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Kj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Kj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$kk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$kk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$jk(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Kj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$lk(a, b, c);
    }
}
function $17f526922e4a857c$var$lk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Sj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$hk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Sj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Sj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$mk = Math.ceil, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$pk = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$R = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$gj = 0, $17f526922e4a857c$var$fj = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$qk = null, $17f526922e4a857c$var$hh = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = 0, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$gk = 0, $17f526922e4a857c$var$Hj = Infinity, $17f526922e4a857c$var$vk = null, $17f526922e4a857c$var$Pi = !1, $17f526922e4a857c$var$Qi = null, $17f526922e4a857c$var$Si = null, $17f526922e4a857c$var$wk = !1, $17f526922e4a857c$var$xk = null, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = 0, $17f526922e4a857c$var$Ak = null, $17f526922e4a857c$var$Bk = -1, $17f526922e4a857c$var$Ck = 0;
function $17f526922e4a857c$var$L() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Bk ? $17f526922e4a857c$var$Bk : $17f526922e4a857c$var$Bk = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Ck && ($17f526922e4a857c$var$Ck = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Ck;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$mh(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$zk) throw $17f526922e4a857c$var$zk = 0, $17f526922e4a857c$var$Ak = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$R) a === $17f526922e4a857c$var$R && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$rk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Ek(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Ek(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$R ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Fk.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Fk.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Gk(c, $17f526922e4a857c$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Hk(a, b) {
    $17f526922e4a857c$var$Bk = -1;
    $17f526922e4a857c$var$Ck = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Ik() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$R ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Jk(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Kk();
        if ($17f526922e4a857c$var$R !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$vk = null, $17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Lk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Mk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Nk(a, h);
        }
        $17f526922e4a857c$var$Qg();
        $17f526922e4a857c$var$nk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$R = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Ok(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$qk, $17f526922e4a857c$var$Lk(a, 0), $17f526922e4a857c$var$Dk(a, d), $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Pk(e) && (b = $17f526922e4a857c$var$Jk(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Ok(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$qk, $17f526922e4a857c$var$Lk(a, 0), $17f526922e4a857c$var$Dk(a, d), $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$gk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Qk.bind(null, a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Qk.bind(null, a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Hk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Ok(a, b) {
    var c = $17f526922e4a857c$var$tk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Lk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Jk(a, b);
    2 !== a && (b = $17f526922e4a857c$var$uk, $17f526922e4a857c$var$uk = c, null !== b && $17f526922e4a857c$var$Gj(b));
    return a;
}
function $17f526922e4a857c$var$Gj(a) {
    null === $17f526922e4a857c$var$uk ? $17f526922e4a857c$var$uk = a : $17f526922e4a857c$var$uk.push.apply($17f526922e4a857c$var$uk, a);
}
function $17f526922e4a857c$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Dk(a, b) {
    b &= ~$17f526922e4a857c$var$sk;
    b &= ~$17f526922e4a857c$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Fk(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Ik();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Ok(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$qk, $17f526922e4a857c$var$Lk(a, 0), $17f526922e4a857c$var$Dk(a, b), $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Qk(a, $17f526922e4a857c$var$uk, $17f526922e4a857c$var$vk);
    $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Rk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Sk(a) {
    null !== $17f526922e4a857c$var$xk && 0 === $17f526922e4a857c$var$xk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Ik();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$pk.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$pk.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$pk.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Ij() {
    $17f526922e4a857c$var$gj = $17f526922e4a857c$var$fj.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$fj);
}
function $17f526922e4a857c$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$Jh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Oh();
                break;
            case 5:
                $17f526922e4a857c$var$Lh(d);
                break;
            case 4:
                $17f526922e4a857c$var$Jh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$M);
                break;
            case 10:
                $17f526922e4a857c$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Ij();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$R = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$wh(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$gj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$qk = null;
    $17f526922e4a857c$var$sk = $17f526922e4a857c$var$rk = $17f526922e4a857c$var$hh = 0;
    $17f526922e4a857c$var$uk = $17f526922e4a857c$var$tk = null;
    if (null !== $17f526922e4a857c$var$Wg) {
        for(b = 0; b < $17f526922e4a857c$var$Wg.length; b++)if (c = $17f526922e4a857c$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$Wg = null;
    }
    return a;
}
function $17f526922e4a857c$var$Nk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$Qg();
            $17f526922e4a857c$var$Ph.current = $17f526922e4a857c$var$ai;
            if ($17f526922e4a857c$var$Sh) {
                for(var d = $17f526922e4a857c$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Sh = !1;
            }
            $17f526922e4a857c$var$Rh = 0;
            $17f526922e4a857c$var$P = $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            $17f526922e4a857c$var$Th = !1;
            $17f526922e4a857c$var$Uh = 0;
            $17f526922e4a857c$var$ok.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$qk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Ti(f, l, b);
                            $17f526922e4a857c$var$uj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Wi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ki(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = [
                    f
                ] : $17f526922e4a857c$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Oi(f, k, b);
                            $17f526922e4a857c$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Si || !$17f526922e4a857c$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Ri(f, h, b);
                                $17f526922e4a857c$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Tk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Kk() {
    var a = $17f526922e4a857c$var$nk.current;
    $17f526922e4a857c$var$nk.current = $17f526922e4a857c$var$ai;
    return null === a ? $17f526922e4a857c$var$ai : a;
}
function $17f526922e4a857c$var$uj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$R || 0 === ($17f526922e4a857c$var$hh & 268435455) && 0 === ($17f526922e4a857c$var$rk & 268435455) || $17f526922e4a857c$var$Dk($17f526922e4a857c$var$R, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Jk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Kk();
    if ($17f526922e4a857c$var$R !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$vk = null, $17f526922e4a857c$var$Lk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Uk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Nk(a, e);
    }
    $17f526922e4a857c$var$Qg();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$nk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$R = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Uk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Vk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Mk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Vk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Vk(a) {
    var b = $17f526922e4a857c$var$Wk(a.alternate, a, $17f526922e4a857c$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Tk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$ok.current = null;
}
function $17f526922e4a857c$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Fj(c, b, $17f526922e4a857c$var$gj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Qk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$pk.transition;
    try {
        $17f526922e4a857c$var$pk.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Xk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$pk.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Xk(a, b, c, d) {
    do $17f526922e4a857c$var$Ik();
    while (null !== $17f526922e4a857c$var$xk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$R && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$R = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$wk || ($17f526922e4a857c$var$wk = !0, $17f526922e4a857c$var$Gk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$pk.transition;
        $17f526922e4a857c$var$pk.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$ok.current = null;
        $17f526922e4a857c$var$Pj(a, c);
        $17f526922e4a857c$var$ek(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$ik(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$pk.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$wk && ($17f526922e4a857c$var$wk = !1, $17f526922e4a857c$var$xk = a, $17f526922e4a857c$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Si = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Ek(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Pi) throw $17f526922e4a857c$var$Pi = !1, a = $17f526922e4a857c$var$Qi, $17f526922e4a857c$var$Qi = null, a;
    0 !== ($17f526922e4a857c$var$yk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$zk++ : ($17f526922e4a857c$var$zk = 0, $17f526922e4a857c$var$Ak = a) : $17f526922e4a857c$var$zk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Ik() {
    if (null !== $17f526922e4a857c$var$xk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$yk), b = $17f526922e4a857c$var$pk.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$pk.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$xk) var d = !1;
            else {
                a = $17f526922e4a857c$var$xk;
                $17f526922e4a857c$var$xk = null;
                $17f526922e4a857c$var$yk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Tj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Rj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$pk.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Yk(a, b, c) {
    b = $17f526922e4a857c$var$Ki(c, b);
    b = $17f526922e4a857c$var$Oi(a, b, 1);
    a = $17f526922e4a857c$var$dh(a, b, 1);
    b = $17f526922e4a857c$var$L();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Ek(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Si || !$17f526922e4a857c$var$Si.has(d))) {
                a = $17f526922e4a857c$var$Ki(c, a);
                a = $17f526922e4a857c$var$Ri(b, a, 1);
                b = $17f526922e4a857c$var$dh(b, a, 1);
                a = $17f526922e4a857c$var$L();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$R === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$gk ? $17f526922e4a857c$var$Lk(a, 0) : $17f526922e4a857c$var$sk |= c);
    $17f526922e4a857c$var$Ek(a, b);
}
function $17f526922e4a857c$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$L();
    a = $17f526922e4a857c$var$Zg(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Ek(a, c));
}
function $17f526922e4a857c$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Zk(a, c);
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Zk(a, c);
}
var $17f526922e4a857c$var$Wk;
$17f526922e4a857c$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$Ug = !1, $17f526922e4a857c$var$zj(a, b, c);
            $17f526922e4a857c$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$Ug = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$jj(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$Tg(b, c);
            e = $17f526922e4a857c$var$Xh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$ah(b), e.updater = $17f526922e4a857c$var$nh, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$rh(b, d, a, c), b = $17f526922e4a857c$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$$k(d);
                a = $17f526922e4a857c$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$aj(null, b, d, $17f526922e4a857c$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$lj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$bh(a, b);
                $17f526922e4a857c$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$mj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$$i(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Kh(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$hj(a, b), $17f526922e4a857c$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$pj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Bh(b, null, d, c) : $17f526922e4a857c$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$Zi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$Tg(b, c), e = $17f526922e4a857c$var$Vg(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Lg(d, b.pendingProps), e = $17f526922e4a857c$var$Lg(d.type, e), $17f526922e4a857c$var$aj(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Lg(d, e), $17f526922e4a857c$var$jj(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$Tg(b, c), $17f526922e4a857c$var$ph(b, d, e), $17f526922e4a857c$var$rh(b, d, e, c), $17f526922e4a857c$var$kj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$yj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$ej(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Gk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$al(a, b, c, d);
}
function $17f526922e4a857c$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$$k(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Ah(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Ah(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$qj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$xh(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$zh(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$ah(f);
    return a;
}
function $17f526922e4a857c$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$el(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$el(null);
    c = a.current;
    d = $17f526922e4a857c$var$L();
    e = $17f526922e4a857c$var$lh(c);
    f = $17f526922e4a857c$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$dh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Ek(a, d);
    return a;
}
function $17f526922e4a857c$var$gl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$L(), g = $17f526922e4a857c$var$lh(e);
    c = $17f526922e4a857c$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$dh(e, b, g);
    null !== a && ($17f526922e4a857c$var$mh(a, e, g, f), $17f526922e4a857c$var$eh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$jl(a, b) {
    $17f526922e4a857c$var$il(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$il(a, b);
}
function $17f526922e4a857c$var$kl() {
    return null;
}
var $17f526922e4a857c$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$nl.prototype.render = $17f526922e4a857c$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$gl(a, b, null, null);
};
$17f526922e4a857c$var$nl.prototype.unmount = $17f526922e4a857c$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Sk(function() {
            $17f526922e4a857c$var$gl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$nl(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$ql() {}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$hl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$fl(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$ql);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$hl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$cl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$ql);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Sk(function() {
        $17f526922e4a857c$var$gl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$hl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$gl(b, g, a, e);
    } else g = $17f526922e4a857c$var$rl(c, b, a, e, d);
    return $17f526922e4a857c$var$hl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Ek(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Hj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Sk(function() {
                var b = $17f526922e4a857c$var$Zg(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$L();
                    $17f526922e4a857c$var$mh(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$jl(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$L();
            $17f526922e4a857c$var$mh(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$jl(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$lh(a), c = $17f526922e4a857c$var$Zg(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$L();
            $17f526922e4a857c$var$mh(c, a, b, d);
        }
        $17f526922e4a857c$var$jl(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Rk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Sk;
var $17f526922e4a857c$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Rk
    ]
}, $17f526922e4a857c$var$ul = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$vl = {
    bundleType: $17f526922e4a857c$var$ul.bundleType,
    version: $17f526922e4a857c$var$ul.version,
    rendererPackageName: $17f526922e4a857c$var$ul.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$ul.findFiberByHostInstance || $17f526922e4a857c$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$wl.isDisabled && $17f526922e4a857c$var$wl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$wl.inject($17f526922e4a857c$var$vl), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$wl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$tl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$dl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Sk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$pl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$sl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$nl(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$pl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$sl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$pl(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Sk(function() {
        $17f526922e4a857c$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Rk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$pl(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$sl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("clk2u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
"use strict";
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});





parcelRegister("1IdZj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("89wqa"));

});
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
"use strict";

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});


parcelRegister("9RWW6", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $72f6c7c6caa00984$export$307591e98609eddd, (v) => $72f6c7c6caa00984$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $72f6c7c6caa00984$export$eb3a06aef9e6ee51, (v) => $72f6c7c6caa00984$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $72f6c7c6caa00984$export$b23711c915539651, (v) => $72f6c7c6caa00984$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $72f6c7c6caa00984$export$80e7718417253a51, (v) => $72f6c7c6caa00984$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $72f6c7c6caa00984$export$83d89fbfd8236492, (v) => $72f6c7c6caa00984$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72f6c7c6caa00984$export$307591e98609eddd;
var $72f6c7c6caa00984$export$eb3a06aef9e6ee51;
var $72f6c7c6caa00984$export$b23711c915539651;
var $72f6c7c6caa00984$export$80e7718417253a51;
var $72f6c7c6caa00984$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $72f6c7c6caa00984$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $72f6c7c6caa00984$var$p = Object.prototype.hasOwnProperty, $72f6c7c6caa00984$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $72f6c7c6caa00984$var$ha = {}, $72f6c7c6caa00984$var$ia = {};
function $72f6c7c6caa00984$var$ja(a) {
    if ($72f6c7c6caa00984$var$p.call($72f6c7c6caa00984$var$ia, a)) return !0;
    if ($72f6c7c6caa00984$var$p.call($72f6c7c6caa00984$var$ha, a)) return !1;
    if ($72f6c7c6caa00984$var$fa.test(a)) return $72f6c7c6caa00984$var$ia[a] = !0;
    $72f6c7c6caa00984$var$ha[a] = !0;
    return !1;
}
function $72f6c7c6caa00984$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $72f6c7c6caa00984$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $72f6c7c6caa00984$var$t[b] = new $72f6c7c6caa00984$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $72f6c7c6caa00984$var$ka = /[\-:]([a-z])/g;
function $72f6c7c6caa00984$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($72f6c7c6caa00984$var$ka, $72f6c7c6caa00984$var$la);
    $72f6c7c6caa00984$var$t[b] = new $72f6c7c6caa00984$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($72f6c7c6caa00984$var$ka, $72f6c7c6caa00984$var$la);
    $72f6c7c6caa00984$var$t[b] = new $72f6c7c6caa00984$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($72f6c7c6caa00984$var$ka, $72f6c7c6caa00984$var$la);
    $72f6c7c6caa00984$var$t[b] = new $72f6c7c6caa00984$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$72f6c7c6caa00984$var$t.xlinkHref = new $72f6c7c6caa00984$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $72f6c7c6caa00984$var$t[a] = new $72f6c7c6caa00984$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $72f6c7c6caa00984$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $72f6c7c6caa00984$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($72f6c7c6caa00984$var$u).forEach(function(a) {
    $72f6c7c6caa00984$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $72f6c7c6caa00984$var$u[b] = $72f6c7c6caa00984$var$u[a];
    });
});
var $72f6c7c6caa00984$var$na = /["'&<>]/;
function $72f6c7c6caa00984$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $72f6c7c6caa00984$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $72f6c7c6caa00984$var$oa = /([A-Z])/g, $72f6c7c6caa00984$var$pa = /^ms-/, $72f6c7c6caa00984$var$qa = Array.isArray;
function $72f6c7c6caa00984$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $72f6c7c6caa00984$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $72f6c7c6caa00984$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $72f6c7c6caa00984$var$w(2, null);
        case "math":
            return $72f6c7c6caa00984$var$w(3, null);
        case "foreignObject":
            return $72f6c7c6caa00984$var$w(1, null);
        case "table":
            return $72f6c7c6caa00984$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $72f6c7c6caa00984$var$w(5, null);
        case "colgroup":
            return $72f6c7c6caa00984$var$w(7, null);
        case "tr":
            return $72f6c7c6caa00984$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $72f6c7c6caa00984$var$w(1, null) : a;
}
var $72f6c7c6caa00984$var$sa = new Map;
function $72f6c7c6caa00984$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($72f6c7c6caa00984$var$l(62));
    b = !0;
    for(var d in c)if ($72f6c7c6caa00984$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $72f6c7c6caa00984$var$v(d);
                f = $72f6c7c6caa00984$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $72f6c7c6caa00984$var$sa.get(e);
                void 0 !== g ? e = g : (g = $72f6c7c6caa00984$var$v(e.replace($72f6c7c6caa00984$var$oa, "-$1").toLowerCase().replace($72f6c7c6caa00984$var$pa, "-ms-")), $72f6c7c6caa00984$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $72f6c7c6caa00984$var$p.call($72f6c7c6caa00984$var$u, d) ? "" + f : f + "px" : $72f6c7c6caa00984$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $72f6c7c6caa00984$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $72f6c7c6caa00984$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $72f6c7c6caa00984$var$t.hasOwnProperty(c) ? $72f6c7c6caa00984$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $72f6c7c6caa00984$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $72f6c7c6caa00984$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $72f6c7c6caa00984$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $72f6c7c6caa00984$var$v(d), '"');
            }
        } else if ($72f6c7c6caa00984$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $72f6c7c6caa00984$var$v(d), '"');
        }
    }
}
function $72f6c7c6caa00984$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($72f6c7c6caa00984$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($72f6c7c6caa00984$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $72f6c7c6caa00984$var$ua(a) {
    var b = "";
    $8NFma.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $72f6c7c6caa00984$var$va(a, b, c, d) {
    a.push($72f6c7c6caa00984$var$A(c));
    var f = c = null, e;
    for(e in b)if ($72f6c7c6caa00984$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $72f6c7c6caa00984$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $72f6c7c6caa00984$var$y(a, f, c);
    return "string" === typeof c ? (a.push($72f6c7c6caa00984$var$v(c)), null) : c;
}
var $72f6c7c6caa00984$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $72f6c7c6caa00984$var$xa = new Map;
function $72f6c7c6caa00984$var$A(a) {
    var b = $72f6c7c6caa00984$var$xa.get(a);
    if (void 0 === b) {
        if (!$72f6c7c6caa00984$var$wa.test(a)) throw Error($72f6c7c6caa00984$var$l(65, a));
        b = "<" + a;
        $72f6c7c6caa00984$var$xa.set(a, b);
    }
    return b;
}
function $72f6c7c6caa00984$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($72f6c7c6caa00984$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($72f6c7c6caa00984$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $72f6c7c6caa00984$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $72f6c7c6caa00984$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($72f6c7c6caa00984$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($72f6c7c6caa00984$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $72f6c7c6caa00984$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $72f6c7c6caa00984$var$ua(h), $72f6c7c6caa00984$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $72f6c7c6caa00984$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($72f6c7c6caa00984$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($72f6c7c6caa00984$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($72f6c7c6caa00984$var$l(91));
                default:
                    $72f6c7c6caa00984$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($72f6c7c6caa00984$var$l(92));
                if ($72f6c7c6caa00984$var$qa(n) && 1 < n.length) throw Error($72f6c7c6caa00984$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($72f6c7c6caa00984$var$v("" + e));
            return null;
        case "input":
            a.push($72f6c7c6caa00984$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($72f6c7c6caa00984$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($72f6c7c6caa00984$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $72f6c7c6caa00984$var$x(a, d, g, m);
            }
            null !== n ? $72f6c7c6caa00984$var$x(a, d, "checked", n) : null !== k && $72f6c7c6caa00984$var$x(a, d, "checked", k);
            null !== e ? $72f6c7c6caa00984$var$x(a, d, "value", e) : null !== h && $72f6c7c6caa00984$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($72f6c7c6caa00984$var$A("menuitem"));
            for(var C in c)if ($72f6c7c6caa00984$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($72f6c7c6caa00984$var$l(400));
                default:
                    $72f6c7c6caa00984$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($72f6c7c6caa00984$var$A("title"));
            e = null;
            for(q in c)if ($72f6c7c6caa00984$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($72f6c7c6caa00984$var$l(434));
                default:
                    $72f6c7c6caa00984$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($72f6c7c6caa00984$var$A(b));
            g = e = null;
            for(k in c)if ($72f6c7c6caa00984$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $72f6c7c6caa00984$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($72f6c7c6caa00984$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($72f6c7c6caa00984$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($72f6c7c6caa00984$var$A(b));
            for(var D in c)if ($72f6c7c6caa00984$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($72f6c7c6caa00984$var$l(399, b));
                default:
                    $72f6c7c6caa00984$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $72f6c7c6caa00984$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $72f6c7c6caa00984$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $72f6c7c6caa00984$var$va(a, c, b, d);
            a.push($72f6c7c6caa00984$var$A(b));
            g = e = null;
            for(m in c)if ($72f6c7c6caa00984$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $72f6c7c6caa00984$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $72f6c7c6caa00984$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $72f6c7c6caa00984$var$v(h), '"');
            }
            a.push(">");
            $72f6c7c6caa00984$var$y(a, g, e);
            return e;
    }
}
function $72f6c7c6caa00984$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($72f6c7c6caa00984$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $72f6c7c6caa00984$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($72f6c7c6caa00984$var$l(397));
    }
}
function $72f6c7c6caa00984$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($72f6c7c6caa00984$var$l(397));
    }
}
var $72f6c7c6caa00984$var$Ca = /[<\u2028\u2029]/g;
function $72f6c7c6caa00984$var$Da(a) {
    return JSON.stringify(a).replace($72f6c7c6caa00984$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $72f6c7c6caa00984$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $72f6c7c6caa00984$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($72f6c7c6caa00984$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($72f6c7c6caa00984$var$v(b)), a = !0);
    return a;
}
var $72f6c7c6caa00984$var$B = Object.assign, $72f6c7c6caa00984$var$Ga = Symbol.for("react.element"), $72f6c7c6caa00984$var$Ha = Symbol.for("react.portal"), $72f6c7c6caa00984$var$Ia = Symbol.for("react.fragment"), $72f6c7c6caa00984$var$Ja = Symbol.for("react.strict_mode"), $72f6c7c6caa00984$var$Ka = Symbol.for("react.profiler"), $72f6c7c6caa00984$var$La = Symbol.for("react.provider"), $72f6c7c6caa00984$var$Ma = Symbol.for("react.context"), $72f6c7c6caa00984$var$Na = Symbol.for("react.forward_ref"), $72f6c7c6caa00984$var$Oa = Symbol.for("react.suspense"), $72f6c7c6caa00984$var$Pa = Symbol.for("react.suspense_list"), $72f6c7c6caa00984$var$Qa = Symbol.for("react.memo"), $72f6c7c6caa00984$var$Ra = Symbol.for("react.lazy"), $72f6c7c6caa00984$var$Sa = Symbol.for("react.scope"), $72f6c7c6caa00984$var$Ta = Symbol.for("react.debug_trace_mode"), $72f6c7c6caa00984$var$Ua = Symbol.for("react.legacy_hidden"), $72f6c7c6caa00984$var$Va = Symbol.for("react.default_value"), $72f6c7c6caa00984$var$Wa = Symbol.iterator;
function $72f6c7c6caa00984$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $72f6c7c6caa00984$var$Ia:
            return "Fragment";
        case $72f6c7c6caa00984$var$Ha:
            return "Portal";
        case $72f6c7c6caa00984$var$Ka:
            return "Profiler";
        case $72f6c7c6caa00984$var$Ja:
            return "StrictMode";
        case $72f6c7c6caa00984$var$Oa:
            return "Suspense";
        case $72f6c7c6caa00984$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $72f6c7c6caa00984$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $72f6c7c6caa00984$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $72f6c7c6caa00984$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $72f6c7c6caa00984$var$Qa:
            return b = a.displayName || null, null !== b ? b : $72f6c7c6caa00984$var$Xa(a.type) || "Memo";
        case $72f6c7c6caa00984$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $72f6c7c6caa00984$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $72f6c7c6caa00984$var$Ya = {};
function $72f6c7c6caa00984$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $72f6c7c6caa00984$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $72f6c7c6caa00984$var$E = null;
function $72f6c7c6caa00984$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($72f6c7c6caa00984$var$l(401));
        } else {
            if (null === c) throw Error($72f6c7c6caa00984$var$l(401));
            $72f6c7c6caa00984$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $72f6c7c6caa00984$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $72f6c7c6caa00984$var$$a(a);
}
function $72f6c7c6caa00984$var$ab(a) {
    var b = a.parent;
    null !== b && $72f6c7c6caa00984$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $72f6c7c6caa00984$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($72f6c7c6caa00984$var$l(402));
    a.depth === b.depth ? $72f6c7c6caa00984$var$F(a, b) : $72f6c7c6caa00984$var$bb(a, b);
}
function $72f6c7c6caa00984$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($72f6c7c6caa00984$var$l(402));
    a.depth === c.depth ? $72f6c7c6caa00984$var$F(a, c) : $72f6c7c6caa00984$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $72f6c7c6caa00984$var$G(a) {
    var b = $72f6c7c6caa00984$var$E;
    b !== a && (null === b ? $72f6c7c6caa00984$var$ab(a) : null === a ? $72f6c7c6caa00984$var$$a(b) : b.depth === a.depth ? $72f6c7c6caa00984$var$F(b, a) : b.depth > a.depth ? $72f6c7c6caa00984$var$bb(b, a) : $72f6c7c6caa00984$var$cb(b, a), $72f6c7c6caa00984$var$E = a);
}
var $72f6c7c6caa00984$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $72f6c7c6caa00984$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $72f6c7c6caa00984$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $72f6c7c6caa00984$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $72f6c7c6caa00984$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $72f6c7c6caa00984$var$B({}, e, h)) : $72f6c7c6caa00984$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $72f6c7c6caa00984$var$fb = {
    id: 1,
    overflow: ""
};
function $72f6c7c6caa00984$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $72f6c7c6caa00984$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $72f6c7c6caa00984$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $72f6c7c6caa00984$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $72f6c7c6caa00984$var$H = Math.clz32 ? Math.clz32 : $72f6c7c6caa00984$var$hb, $72f6c7c6caa00984$var$ib = Math.log, $72f6c7c6caa00984$var$jb = Math.LN2;
function $72f6c7c6caa00984$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($72f6c7c6caa00984$var$ib(a) / $72f6c7c6caa00984$var$jb | 0) | 0;
}
function $72f6c7c6caa00984$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $72f6c7c6caa00984$var$lb = "function" === typeof Object.is ? Object.is : $72f6c7c6caa00984$var$kb, $72f6c7c6caa00984$var$I = null, $72f6c7c6caa00984$var$ob = null, $72f6c7c6caa00984$var$J = null, $72f6c7c6caa00984$var$K = null, $72f6c7c6caa00984$var$L = !1, $72f6c7c6caa00984$var$M = !1, $72f6c7c6caa00984$var$N = 0, $72f6c7c6caa00984$var$O = null, $72f6c7c6caa00984$var$P = 0;
function $72f6c7c6caa00984$var$Q() {
    if (null === $72f6c7c6caa00984$var$I) throw Error($72f6c7c6caa00984$var$l(321));
    return $72f6c7c6caa00984$var$I;
}
function $72f6c7c6caa00984$var$pb() {
    if (0 < $72f6c7c6caa00984$var$P) throw Error($72f6c7c6caa00984$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $72f6c7c6caa00984$var$qb() {
    null === $72f6c7c6caa00984$var$K ? null === $72f6c7c6caa00984$var$J ? ($72f6c7c6caa00984$var$L = !1, $72f6c7c6caa00984$var$J = $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$pb()) : ($72f6c7c6caa00984$var$L = !0, $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$J) : null === $72f6c7c6caa00984$var$K.next ? ($72f6c7c6caa00984$var$L = !1, $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$K.next = $72f6c7c6caa00984$var$pb()) : ($72f6c7c6caa00984$var$L = !0, $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$K.next);
    return $72f6c7c6caa00984$var$K;
}
function $72f6c7c6caa00984$var$rb() {
    $72f6c7c6caa00984$var$ob = $72f6c7c6caa00984$var$I = null;
    $72f6c7c6caa00984$var$M = !1;
    $72f6c7c6caa00984$var$J = null;
    $72f6c7c6caa00984$var$P = 0;
    $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$O = null;
}
function $72f6c7c6caa00984$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $72f6c7c6caa00984$var$tb(a, b, c) {
    $72f6c7c6caa00984$var$I = $72f6c7c6caa00984$var$Q();
    $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$qb();
    if ($72f6c7c6caa00984$var$L) {
        var d = $72f6c7c6caa00984$var$K.queue;
        b = d.dispatch;
        if (null !== $72f6c7c6caa00984$var$O && (c = $72f6c7c6caa00984$var$O.get(d), void 0 !== c)) {
            $72f6c7c6caa00984$var$O.delete(d);
            d = $72f6c7c6caa00984$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $72f6c7c6caa00984$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $72f6c7c6caa00984$var$K.memoizedState,
            b
        ];
    }
    a = a === $72f6c7c6caa00984$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $72f6c7c6caa00984$var$K.memoizedState = a;
    a = $72f6c7c6caa00984$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $72f6c7c6caa00984$var$ub.bind(null, $72f6c7c6caa00984$var$I, a);
    return [
        $72f6c7c6caa00984$var$K.memoizedState,
        a
    ];
}
function $72f6c7c6caa00984$var$vb(a, b) {
    $72f6c7c6caa00984$var$I = $72f6c7c6caa00984$var$Q();
    $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $72f6c7c6caa00984$var$K) {
        var c = $72f6c7c6caa00984$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$72f6c7c6caa00984$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $72f6c7c6caa00984$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $72f6c7c6caa00984$var$ub(a, b, c) {
    if (25 <= $72f6c7c6caa00984$var$P) throw Error($72f6c7c6caa00984$var$l(301));
    if (a === $72f6c7c6caa00984$var$I) {
        if ($72f6c7c6caa00984$var$M = !0, a = {
            action: c,
            next: null
        }, null === $72f6c7c6caa00984$var$O && ($72f6c7c6caa00984$var$O = new Map), c = $72f6c7c6caa00984$var$O.get(b), void 0 === c) $72f6c7c6caa00984$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $72f6c7c6caa00984$var$wb() {
    throw Error($72f6c7c6caa00984$var$l(394));
}
function $72f6c7c6caa00984$var$R() {}
var $72f6c7c6caa00984$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $72f6c7c6caa00984$var$Q();
        return a._currentValue2;
    },
    useMemo: $72f6c7c6caa00984$var$vb,
    useReducer: $72f6c7c6caa00984$var$tb,
    useRef: function(a) {
        $72f6c7c6caa00984$var$I = $72f6c7c6caa00984$var$Q();
        $72f6c7c6caa00984$var$K = $72f6c7c6caa00984$var$qb();
        var b = $72f6c7c6caa00984$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $72f6c7c6caa00984$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $72f6c7c6caa00984$var$tb($72f6c7c6caa00984$var$sb, a);
    },
    useInsertionEffect: $72f6c7c6caa00984$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $72f6c7c6caa00984$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $72f6c7c6caa00984$var$R,
    useEffect: $72f6c7c6caa00984$var$R,
    useDebugValue: $72f6c7c6caa00984$var$R,
    useDeferredValue: function(a) {
        $72f6c7c6caa00984$var$Q();
        return a;
    },
    useTransition: function() {
        $72f6c7c6caa00984$var$Q();
        return [
            !1,
            $72f6c7c6caa00984$var$wb
        ];
    },
    useId: function() {
        var a = $72f6c7c6caa00984$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $72f6c7c6caa00984$var$H(a) - 1)).toString(32) + b;
        var c = $72f6c7c6caa00984$var$S;
        if (null === c) throw Error($72f6c7c6caa00984$var$l(404));
        b = $72f6c7c6caa00984$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $72f6c7c6caa00984$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($72f6c7c6caa00984$var$l(407));
        return c();
    }
}, $72f6c7c6caa00984$var$S = null, $72f6c7c6caa00984$var$yb = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $72f6c7c6caa00984$var$zb(a) {
    console.error(a);
    return null;
}
function $72f6c7c6caa00984$var$T() {}
function $72f6c7c6caa00984$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $72f6c7c6caa00984$var$zb : f,
        onAllReady: void 0 === e ? $72f6c7c6caa00984$var$T : e,
        onShellReady: void 0 === g ? $72f6c7c6caa00984$var$T : g,
        onShellError: void 0 === h ? $72f6c7c6caa00984$var$T : h,
        onFatalError: void 0 === k ? $72f6c7c6caa00984$var$T : k
    };
    c = $72f6c7c6caa00984$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $72f6c7c6caa00984$var$Bb(b, a, null, c, n, $72f6c7c6caa00984$var$Ya, null, $72f6c7c6caa00984$var$fb);
    m.push(a);
    return b;
}
function $72f6c7c6caa00984$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $72f6c7c6caa00984$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $72f6c7c6caa00984$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $72f6c7c6caa00984$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $72f6c7c6caa00984$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $72f6c7c6caa00984$var$Db(a, b, c, d, f) {
    $72f6c7c6caa00984$var$I = {};
    $72f6c7c6caa00984$var$ob = b;
    $72f6c7c6caa00984$var$N = 0;
    for(a = c(d, f); $72f6c7c6caa00984$var$M;)$72f6c7c6caa00984$var$M = !1, $72f6c7c6caa00984$var$N = 0, $72f6c7c6caa00984$var$P += 1, $72f6c7c6caa00984$var$K = null, a = c(d, f);
    $72f6c7c6caa00984$var$rb();
    return a;
}
function $72f6c7c6caa00984$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($72f6c7c6caa00984$var$l(108, $72f6c7c6caa00984$var$Xa(d) || "Unknown", h));
            d = $72f6c7c6caa00984$var$B({}, g, c);
        }
        b.legacyContext = d;
        $72f6c7c6caa00984$var$X(a, b, f);
        b.legacyContext = g;
    } else $72f6c7c6caa00984$var$X(a, b, f);
}
function $72f6c7c6caa00984$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $72f6c7c6caa00984$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $72f6c7c6caa00984$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $72f6c7c6caa00984$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $72f6c7c6caa00984$var$eb(e, c, d, f);
            $72f6c7c6caa00984$var$Eb(a, b, e, c);
        } else {
            e = $72f6c7c6caa00984$var$Za(c, b.legacyContext);
            f = $72f6c7c6caa00984$var$Db(a, b, c, d, e);
            var g = 0 !== $72f6c7c6caa00984$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $72f6c7c6caa00984$var$eb(f, c, d, e), $72f6c7c6caa00984$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $72f6c7c6caa00984$var$gb(d, 1, 0);
                try {
                    $72f6c7c6caa00984$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $72f6c7c6caa00984$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $72f6c7c6caa00984$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $72f6c7c6caa00984$var$ra(g, c, d);
        $72f6c7c6caa00984$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $72f6c7c6caa00984$var$Ua:
            case $72f6c7c6caa00984$var$Ta:
            case $72f6c7c6caa00984$var$Ja:
            case $72f6c7c6caa00984$var$Ka:
            case $72f6c7c6caa00984$var$Ia:
                $72f6c7c6caa00984$var$X(a, b, d.children);
                return;
            case $72f6c7c6caa00984$var$Pa:
                $72f6c7c6caa00984$var$X(a, b, d.children);
                return;
            case $72f6c7c6caa00984$var$Sa:
                throw Error($72f6c7c6caa00984$var$l(343));
            case $72f6c7c6caa00984$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $72f6c7c6caa00984$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $72f6c7c6caa00984$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($72f6c7c6caa00984$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $72f6c7c6caa00984$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $72f6c7c6caa00984$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $72f6c7c6caa00984$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $72f6c7c6caa00984$var$Na:
                d = $72f6c7c6caa00984$var$Db(a, b, c.render, d, f);
                if (0 !== $72f6c7c6caa00984$var$N) {
                    c = b.treeContext;
                    b.treeContext = $72f6c7c6caa00984$var$gb(c, 1, 0);
                    try {
                        $72f6c7c6caa00984$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $72f6c7c6caa00984$var$X(a, b, d);
                return;
            case $72f6c7c6caa00984$var$Qa:
                c = c.type;
                d = $72f6c7c6caa00984$var$Fb(c, d);
                $72f6c7c6caa00984$var$Gb(a, b, c, d, f);
                return;
            case $72f6c7c6caa00984$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $72f6c7c6caa00984$var$E;
                $72f6c7c6caa00984$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $72f6c7c6caa00984$var$X(a, b, f);
                a = $72f6c7c6caa00984$var$E;
                if (null === a) throw Error($72f6c7c6caa00984$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $72f6c7c6caa00984$var$Va ? a.context._defaultValue : d;
                a = $72f6c7c6caa00984$var$E = a.parent;
                b.context = a;
                return;
            case $72f6c7c6caa00984$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $72f6c7c6caa00984$var$X(a, b, d);
                return;
            case $72f6c7c6caa00984$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $72f6c7c6caa00984$var$Fb(c, d);
                $72f6c7c6caa00984$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($72f6c7c6caa00984$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $72f6c7c6caa00984$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $72f6c7c6caa00984$var$Ga:
                $72f6c7c6caa00984$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $72f6c7c6caa00984$var$Ha:
                throw Error($72f6c7c6caa00984$var$l(257));
            case $72f6c7c6caa00984$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $72f6c7c6caa00984$var$X(a, b, c);
                return;
        }
        if ($72f6c7c6caa00984$var$qa(c)) {
            $72f6c7c6caa00984$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $72f6c7c6caa00984$var$Wa && c[$72f6c7c6caa00984$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $72f6c7c6caa00984$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($72f6c7c6caa00984$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $72f6c7c6caa00984$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $72f6c7c6caa00984$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $72f6c7c6caa00984$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $72f6c7c6caa00984$var$gb(e, d, f);
        try {
            $72f6c7c6caa00984$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $72f6c7c6caa00984$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $72f6c7c6caa00984$var$X(a, b, c);
    } catch (k) {
        if ($72f6c7c6caa00984$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $72f6c7c6caa00984$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $72f6c7c6caa00984$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $72f6c7c6caa00984$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $72f6c7c6caa00984$var$G(e), k;
    }
}
function $72f6c7c6caa00984$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $72f6c7c6caa00984$var$Kb(this, b, a);
}
function $72f6c7c6caa00984$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($72f6c7c6caa00984$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $72f6c7c6caa00984$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $72f6c7c6caa00984$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $72f6c7c6caa00984$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $72f6c7c6caa00984$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($72f6c7c6caa00984$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $72f6c7c6caa00984$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $72f6c7c6caa00984$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($72f6c7c6caa00984$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($72f6c7c6caa00984$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $72f6c7c6caa00984$var$Cb(a) {
    if (2 !== a.status) {
        var b = $72f6c7c6caa00984$var$E, c = $72f6c7c6caa00984$var$yb.current;
        $72f6c7c6caa00984$var$yb.current = $72f6c7c6caa00984$var$xb;
        var d = $72f6c7c6caa00984$var$S;
        $72f6c7c6caa00984$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $72f6c7c6caa00984$var$G(g.context);
                    try {
                        $72f6c7c6caa00984$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $72f6c7c6caa00984$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($72f6c7c6caa00984$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $72f6c7c6caa00984$var$V(h, q);
                            null === n ? $72f6c7c6caa00984$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $72f6c7c6caa00984$var$Mb(a, a.destination);
        } catch (z) {
            $72f6c7c6caa00984$var$V(a, z), $72f6c7c6caa00984$var$W(a, z);
        } finally{
            $72f6c7c6caa00984$var$S = d, $72f6c7c6caa00984$var$yb.current = c, c === $72f6c7c6caa00984$var$xb && $72f6c7c6caa00984$var$G(b);
        }
    }
}
function $72f6c7c6caa00984$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $72f6c7c6caa00984$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($72f6c7c6caa00984$var$l(390));
    }
}
function $72f6c7c6caa00984$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $72f6c7c6caa00984$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $72f6c7c6caa00984$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $72f6c7c6caa00984$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $72f6c7c6caa00984$var$za(b, a.responseState, d);
        $72f6c7c6caa00984$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $72f6c7c6caa00984$var$za(b, a.responseState, d.id), $72f6c7c6caa00984$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($72f6c7c6caa00984$var$l(391));
    $72f6c7c6caa00984$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $72f6c7c6caa00984$var$Ob(a, b, c) {
    $72f6c7c6caa00984$var$Aa(b, a.responseState, c.formatContext, c.id);
    $72f6c7c6caa00984$var$Nb(a, b, c);
    return $72f6c7c6caa00984$var$Ba(b, c.formatContext);
}
function $72f6c7c6caa00984$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$72f6c7c6caa00984$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($72f6c7c6caa00984$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $72f6c7c6caa00984$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($72f6c7c6caa00984$var$l(392));
        return $72f6c7c6caa00984$var$Ob(a, b, d);
    }
    $72f6c7c6caa00984$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $72f6c7c6caa00984$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $72f6c7c6caa00984$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($72f6c7c6caa00984$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $72f6c7c6caa00984$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $72f6c7c6caa00984$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $72f6c7c6caa00984$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$72f6c7c6caa00984$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$72f6c7c6caa00984$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$72f6c7c6caa00984$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $72f6c7c6caa00984$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $72f6c7c6caa00984$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $72f6c7c6caa00984$var$Mb(a, a.destination);
    } catch (d) {
        $72f6c7c6caa00984$var$V(a, d), $72f6c7c6caa00984$var$W(a, d);
    }
}
function $72f6c7c6caa00984$var$Sb() {}
function $72f6c7c6caa00984$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $72f6c7c6caa00984$var$Ab(a, $72f6c7c6caa00984$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $72f6c7c6caa00984$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $72f6c7c6caa00984$var$Cb(a);
    $72f6c7c6caa00984$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $72f6c7c6caa00984$var$Mb(a, h);
        } catch (m) {
            $72f6c7c6caa00984$var$V(a, m), $72f6c7c6caa00984$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($72f6c7c6caa00984$var$l(426));
    return g;
}
$72f6c7c6caa00984$export$307591e98609eddd = function() {
    throw Error($72f6c7c6caa00984$var$l(207));
};
$72f6c7c6caa00984$export$eb3a06aef9e6ee51 = function(a, b) {
    return $72f6c7c6caa00984$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$72f6c7c6caa00984$export$b23711c915539651 = function() {
    throw Error($72f6c7c6caa00984$var$l(208));
};
$72f6c7c6caa00984$export$80e7718417253a51 = function(a, b) {
    return $72f6c7c6caa00984$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$72f6c7c6caa00984$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("bBFZG", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $8733b98c5ad59ddd$export$7020a3240b287705, (v) => $8733b98c5ad59ddd$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $8733b98c5ad59ddd$export$83d89fbfd8236492, (v) => $8733b98c5ad59ddd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8733b98c5ad59ddd$export$7020a3240b287705;
var $8733b98c5ad59ddd$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $8733b98c5ad59ddd$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8733b98c5ad59ddd$var$l = null, $8733b98c5ad59ddd$var$n = 0;
function $8733b98c5ad59ddd$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $8733b98c5ad59ddd$var$n && (a.enqueue(new Uint8Array($8733b98c5ad59ddd$var$l.buffer, 0, $8733b98c5ad59ddd$var$n)), $8733b98c5ad59ddd$var$l = new Uint8Array(512), $8733b98c5ad59ddd$var$n = 0), a.enqueue(b);
        else {
            var c = $8733b98c5ad59ddd$var$l.length - $8733b98c5ad59ddd$var$n;
            c < b.length && (0 === c ? a.enqueue($8733b98c5ad59ddd$var$l) : ($8733b98c5ad59ddd$var$l.set(b.subarray(0, c), $8733b98c5ad59ddd$var$n), a.enqueue($8733b98c5ad59ddd$var$l), b = b.subarray(c)), $8733b98c5ad59ddd$var$l = new Uint8Array(512), $8733b98c5ad59ddd$var$n = 0);
            $8733b98c5ad59ddd$var$l.set(b, $8733b98c5ad59ddd$var$n);
            $8733b98c5ad59ddd$var$n += b.length;
        }
    }
}
function $8733b98c5ad59ddd$var$t(a, b) {
    $8733b98c5ad59ddd$var$p(a, b);
    return !0;
}
function $8733b98c5ad59ddd$var$ba(a) {
    $8733b98c5ad59ddd$var$l && 0 < $8733b98c5ad59ddd$var$n && (a.enqueue(new Uint8Array($8733b98c5ad59ddd$var$l.buffer, 0, $8733b98c5ad59ddd$var$n)), $8733b98c5ad59ddd$var$l = null, $8733b98c5ad59ddd$var$n = 0);
}
var $8733b98c5ad59ddd$var$ca = new TextEncoder;
function $8733b98c5ad59ddd$var$u(a) {
    return $8733b98c5ad59ddd$var$ca.encode(a);
}
function $8733b98c5ad59ddd$var$w(a) {
    return $8733b98c5ad59ddd$var$ca.encode(a);
}
function $8733b98c5ad59ddd$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $8733b98c5ad59ddd$var$x = Object.prototype.hasOwnProperty, $8733b98c5ad59ddd$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8733b98c5ad59ddd$var$fa = {}, $8733b98c5ad59ddd$var$ha = {};
function $8733b98c5ad59ddd$var$ia(a) {
    if ($8733b98c5ad59ddd$var$x.call($8733b98c5ad59ddd$var$ha, a)) return !0;
    if ($8733b98c5ad59ddd$var$x.call($8733b98c5ad59ddd$var$fa, a)) return !1;
    if ($8733b98c5ad59ddd$var$ea.test(a)) return $8733b98c5ad59ddd$var$ha[a] = !0;
    $8733b98c5ad59ddd$var$fa[a] = !0;
    return !1;
}
function $8733b98c5ad59ddd$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $8733b98c5ad59ddd$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8733b98c5ad59ddd$var$z[b] = new $8733b98c5ad59ddd$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8733b98c5ad59ddd$var$ja = /[\-:]([a-z])/g;
function $8733b98c5ad59ddd$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8733b98c5ad59ddd$var$ja, $8733b98c5ad59ddd$var$ka);
    $8733b98c5ad59ddd$var$z[b] = new $8733b98c5ad59ddd$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8733b98c5ad59ddd$var$ja, $8733b98c5ad59ddd$var$ka);
    $8733b98c5ad59ddd$var$z[b] = new $8733b98c5ad59ddd$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8733b98c5ad59ddd$var$ja, $8733b98c5ad59ddd$var$ka);
    $8733b98c5ad59ddd$var$z[b] = new $8733b98c5ad59ddd$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8733b98c5ad59ddd$var$z.xlinkHref = new $8733b98c5ad59ddd$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8733b98c5ad59ddd$var$z[a] = new $8733b98c5ad59ddd$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $8733b98c5ad59ddd$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8733b98c5ad59ddd$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8733b98c5ad59ddd$var$B).forEach(function(a) {
    $8733b98c5ad59ddd$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8733b98c5ad59ddd$var$B[b] = $8733b98c5ad59ddd$var$B[a];
    });
});
var $8733b98c5ad59ddd$var$oa = /["'&<>]/;
function $8733b98c5ad59ddd$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $8733b98c5ad59ddd$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $8733b98c5ad59ddd$var$pa = /([A-Z])/g, $8733b98c5ad59ddd$var$qa = /^ms-/, $8733b98c5ad59ddd$var$ra = Array.isArray, $8733b98c5ad59ddd$var$sa = $8733b98c5ad59ddd$var$w("<script>"), $8733b98c5ad59ddd$var$ta = $8733b98c5ad59ddd$var$w("</script>"), $8733b98c5ad59ddd$var$ua = $8733b98c5ad59ddd$var$w('<script src="'), $8733b98c5ad59ddd$var$va = $8733b98c5ad59ddd$var$w('<script type="module" src="'), $8733b98c5ad59ddd$var$wa = $8733b98c5ad59ddd$var$w('" async=""></script>'), $8733b98c5ad59ddd$var$xa = /(<\/|<)(s)(cript)/gi;
function $8733b98c5ad59ddd$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $8733b98c5ad59ddd$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $8733b98c5ad59ddd$var$sa : $8733b98c5ad59ddd$var$w('<script nonce="' + $8733b98c5ad59ddd$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $8733b98c5ad59ddd$var$u(("" + c).replace($8733b98c5ad59ddd$var$xa, $8733b98c5ad59ddd$var$ya)), $8733b98c5ad59ddd$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($8733b98c5ad59ddd$var$ua, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d[c])), $8733b98c5ad59ddd$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($8733b98c5ad59ddd$var$va, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(f[d])), $8733b98c5ad59ddd$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $8733b98c5ad59ddd$var$w(a + "P:"),
        segmentPrefix: $8733b98c5ad59ddd$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $8733b98c5ad59ddd$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $8733b98c5ad59ddd$var$Aa(a) {
    return $8733b98c5ad59ddd$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $8733b98c5ad59ddd$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $8733b98c5ad59ddd$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $8733b98c5ad59ddd$var$D(2, null);
        case "math":
            return $8733b98c5ad59ddd$var$D(3, null);
        case "foreignObject":
            return $8733b98c5ad59ddd$var$D(1, null);
        case "table":
            return $8733b98c5ad59ddd$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $8733b98c5ad59ddd$var$D(5, null);
        case "colgroup":
            return $8733b98c5ad59ddd$var$D(7, null);
        case "tr":
            return $8733b98c5ad59ddd$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $8733b98c5ad59ddd$var$D(1, null) : a;
}
var $8733b98c5ad59ddd$var$Ca = $8733b98c5ad59ddd$var$w("<!-- -->");
function $8733b98c5ad59ddd$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($8733b98c5ad59ddd$var$Ca);
    a.push($8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(b)));
    return !0;
}
var $8733b98c5ad59ddd$var$Ea = new Map, $8733b98c5ad59ddd$var$Fa = $8733b98c5ad59ddd$var$w(' style="'), $8733b98c5ad59ddd$var$Ga = $8733b98c5ad59ddd$var$w(":"), $8733b98c5ad59ddd$var$Ha = $8733b98c5ad59ddd$var$w(";");
function $8733b98c5ad59ddd$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($8733b98c5ad59ddd$var$k(62));
    b = !0;
    for(var d in c)if ($8733b98c5ad59ddd$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d));
                f = $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $8733b98c5ad59ddd$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $8733b98c5ad59ddd$var$w($8733b98c5ad59ddd$var$C(e.replace($8733b98c5ad59ddd$var$pa, "-$1").toLowerCase().replace($8733b98c5ad59ddd$var$qa, "-ms-"))), $8733b98c5ad59ddd$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $8733b98c5ad59ddd$var$x.call($8733b98c5ad59ddd$var$B, d) ? $8733b98c5ad59ddd$var$u("" + f) : $8733b98c5ad59ddd$var$u(f + "px") : $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($8733b98c5ad59ddd$var$Fa, e, $8733b98c5ad59ddd$var$Ga, f)) : a.push($8733b98c5ad59ddd$var$Ha, e, $8733b98c5ad59ddd$var$Ga, f);
        }
    }
    b || a.push($8733b98c5ad59ddd$var$E);
}
var $8733b98c5ad59ddd$var$H = $8733b98c5ad59ddd$var$w(" "), $8733b98c5ad59ddd$var$I = $8733b98c5ad59ddd$var$w('="'), $8733b98c5ad59ddd$var$E = $8733b98c5ad59ddd$var$w('"'), $8733b98c5ad59ddd$var$Ja = $8733b98c5ad59ddd$var$w('=""');
function $8733b98c5ad59ddd$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $8733b98c5ad59ddd$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $8733b98c5ad59ddd$var$z.hasOwnProperty(c) ? $8733b98c5ad59ddd$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $8733b98c5ad59ddd$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($8733b98c5ad59ddd$var$H, c, $8733b98c5ad59ddd$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($8733b98c5ad59ddd$var$H, c, $8733b98c5ad59ddd$var$Ja) : !1 !== d && a.push($8733b98c5ad59ddd$var$H, c, $8733b98c5ad59ddd$var$I, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d)), $8733b98c5ad59ddd$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($8733b98c5ad59ddd$var$H, c, $8733b98c5ad59ddd$var$I, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d)), $8733b98c5ad59ddd$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($8733b98c5ad59ddd$var$H, c, $8733b98c5ad59ddd$var$I, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d)), $8733b98c5ad59ddd$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($8733b98c5ad59ddd$var$H, c, $8733b98c5ad59ddd$var$I, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d)), $8733b98c5ad59ddd$var$E);
            }
        } else if ($8733b98c5ad59ddd$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($8733b98c5ad59ddd$var$H, $8733b98c5ad59ddd$var$u(c), $8733b98c5ad59ddd$var$I, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d)), $8733b98c5ad59ddd$var$E);
        }
    }
}
var $8733b98c5ad59ddd$var$K = $8733b98c5ad59ddd$var$w(">"), $8733b98c5ad59ddd$var$Ka = $8733b98c5ad59ddd$var$w("/>");
function $8733b98c5ad59ddd$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($8733b98c5ad59ddd$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($8733b98c5ad59ddd$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($8733b98c5ad59ddd$var$u("" + b));
    }
}
function $8733b98c5ad59ddd$var$La(a) {
    var b = "";
    $8NFma.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $8733b98c5ad59ddd$var$Ma = $8733b98c5ad59ddd$var$w(' selected=""');
function $8733b98c5ad59ddd$var$Na(a, b, c, d) {
    a.push($8733b98c5ad59ddd$var$M(c));
    var f = c = null, e;
    for(e in b)if ($8733b98c5ad59ddd$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $8733b98c5ad59ddd$var$J(a, d, e, g);
        }
    }
    a.push($8733b98c5ad59ddd$var$K);
    $8733b98c5ad59ddd$var$L(a, f, c);
    return "string" === typeof c ? (a.push($8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(c))), null) : c;
}
var $8733b98c5ad59ddd$var$Oa = $8733b98c5ad59ddd$var$w("\n"), $8733b98c5ad59ddd$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $8733b98c5ad59ddd$var$Qa = new Map;
function $8733b98c5ad59ddd$var$M(a) {
    var b = $8733b98c5ad59ddd$var$Qa.get(a);
    if (void 0 === b) {
        if (!$8733b98c5ad59ddd$var$Pa.test(a)) throw Error($8733b98c5ad59ddd$var$k(65, a));
        b = $8733b98c5ad59ddd$var$w("<" + a);
        $8733b98c5ad59ddd$var$Qa.set(a, b);
    }
    return b;
}
var $8733b98c5ad59ddd$var$Ra = $8733b98c5ad59ddd$var$w("<!DOCTYPE html>");
function $8733b98c5ad59ddd$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($8733b98c5ad59ddd$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($8733b98c5ad59ddd$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $8733b98c5ad59ddd$var$J(a, d, r, h);
                }
            }
            a.push($8733b98c5ad59ddd$var$K);
            $8733b98c5ad59ddd$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($8733b98c5ad59ddd$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($8733b98c5ad59ddd$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $8733b98c5ad59ddd$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $8733b98c5ad59ddd$var$La(h), $8733b98c5ad59ddd$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($8733b98c5ad59ddd$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($8733b98c5ad59ddd$var$Ma);
            } else q && a.push($8733b98c5ad59ddd$var$Ma);
            a.push($8733b98c5ad59ddd$var$K);
            $8733b98c5ad59ddd$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($8733b98c5ad59ddd$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($8733b98c5ad59ddd$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($8733b98c5ad59ddd$var$k(91));
                default:
                    $8733b98c5ad59ddd$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($8733b98c5ad59ddd$var$K);
            if (null != r) {
                if (null != e) throw Error($8733b98c5ad59ddd$var$k(92));
                if ($8733b98c5ad59ddd$var$ra(r) && 1 < r.length) throw Error($8733b98c5ad59ddd$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($8733b98c5ad59ddd$var$Oa);
            null !== e && a.push($8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C("" + e)));
            return null;
        case "input":
            a.push($8733b98c5ad59ddd$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($8733b98c5ad59ddd$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8733b98c5ad59ddd$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $8733b98c5ad59ddd$var$J(a, d, g, q);
            }
            null !== r ? $8733b98c5ad59ddd$var$J(a, d, "checked", r) : null !== m && $8733b98c5ad59ddd$var$J(a, d, "checked", m);
            null !== e ? $8733b98c5ad59ddd$var$J(a, d, "value", e) : null !== h && $8733b98c5ad59ddd$var$J(a, d, "value", h);
            a.push($8733b98c5ad59ddd$var$Ka);
            return null;
        case "menuitem":
            a.push($8733b98c5ad59ddd$var$M("menuitem"));
            for(var A in c)if ($8733b98c5ad59ddd$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8733b98c5ad59ddd$var$k(400));
                default:
                    $8733b98c5ad59ddd$var$J(a, d, A, e);
            }
            a.push($8733b98c5ad59ddd$var$K);
            return null;
        case "title":
            a.push($8733b98c5ad59ddd$var$M("title"));
            e = null;
            for(v in c)if ($8733b98c5ad59ddd$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($8733b98c5ad59ddd$var$k(434));
                default:
                    $8733b98c5ad59ddd$var$J(a, d, v, g);
            }
            a.push($8733b98c5ad59ddd$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($8733b98c5ad59ddd$var$M(b));
            g = e = null;
            for(m in c)if ($8733b98c5ad59ddd$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $8733b98c5ad59ddd$var$J(a, d, m, h);
            }
            a.push($8733b98c5ad59ddd$var$K);
            if (null != g) {
                if (null != e) throw Error($8733b98c5ad59ddd$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($8733b98c5ad59ddd$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($8733b98c5ad59ddd$var$Oa, $8733b98c5ad59ddd$var$u(c)) : a.push($8733b98c5ad59ddd$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($8733b98c5ad59ddd$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($8733b98c5ad59ddd$var$M(b));
            for(var F in c)if ($8733b98c5ad59ddd$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8733b98c5ad59ddd$var$k(399, b));
                default:
                    $8733b98c5ad59ddd$var$J(a, d, F, e);
            }
            a.push($8733b98c5ad59ddd$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $8733b98c5ad59ddd$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($8733b98c5ad59ddd$var$Ra), $8733b98c5ad59ddd$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $8733b98c5ad59ddd$var$Na(a, c, b, d);
            a.push($8733b98c5ad59ddd$var$M(b));
            g = e = null;
            for(q in c)if ($8733b98c5ad59ddd$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $8733b98c5ad59ddd$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $8733b98c5ad59ddd$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($8733b98c5ad59ddd$var$H, $8733b98c5ad59ddd$var$u(q), $8733b98c5ad59ddd$var$I, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(h)), $8733b98c5ad59ddd$var$E);
            }
            a.push($8733b98c5ad59ddd$var$K);
            $8733b98c5ad59ddd$var$L(a, g, e);
            return e;
    }
}
var $8733b98c5ad59ddd$var$Ta = $8733b98c5ad59ddd$var$w("</"), $8733b98c5ad59ddd$var$Ua = $8733b98c5ad59ddd$var$w(">"), $8733b98c5ad59ddd$var$Va = $8733b98c5ad59ddd$var$w('<template id="'), $8733b98c5ad59ddd$var$Wa = $8733b98c5ad59ddd$var$w('"></template>'), $8733b98c5ad59ddd$var$Xa = $8733b98c5ad59ddd$var$w("<!--$-->"), $8733b98c5ad59ddd$var$Ya = $8733b98c5ad59ddd$var$w('<!--$?--><template id="'), $8733b98c5ad59ddd$var$Za = $8733b98c5ad59ddd$var$w('"></template>'), $8733b98c5ad59ddd$var$$a = $8733b98c5ad59ddd$var$w("<!--$!-->"), $8733b98c5ad59ddd$var$ab = $8733b98c5ad59ddd$var$w("<!--/$-->"), $8733b98c5ad59ddd$var$bb = $8733b98c5ad59ddd$var$w("<template"), $8733b98c5ad59ddd$var$cb = $8733b98c5ad59ddd$var$w('"'), $8733b98c5ad59ddd$var$db = $8733b98c5ad59ddd$var$w(' data-dgst="');
$8733b98c5ad59ddd$var$w(' data-msg="');
$8733b98c5ad59ddd$var$w(' data-stck="');
var $8733b98c5ad59ddd$var$eb = $8733b98c5ad59ddd$var$w("></template>");
function $8733b98c5ad59ddd$var$fb(a, b, c) {
    $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$Ya);
    if (null === c) throw Error($8733b98c5ad59ddd$var$k(395));
    $8733b98c5ad59ddd$var$p(a, c);
    return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$Za);
}
var $8733b98c5ad59ddd$var$gb = $8733b98c5ad59ddd$var$w('<div hidden id="'), $8733b98c5ad59ddd$var$hb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$ib = $8733b98c5ad59ddd$var$w("</div>"), $8733b98c5ad59ddd$var$jb = $8733b98c5ad59ddd$var$w('<svg aria-hidden="true" style="display:none" id="'), $8733b98c5ad59ddd$var$kb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$lb = $8733b98c5ad59ddd$var$w("</svg>"), $8733b98c5ad59ddd$var$mb = $8733b98c5ad59ddd$var$w('<math aria-hidden="true" style="display:none" id="'), $8733b98c5ad59ddd$var$nb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$ob = $8733b98c5ad59ddd$var$w("</math>"), $8733b98c5ad59ddd$var$pb = $8733b98c5ad59ddd$var$w('<table hidden id="'), $8733b98c5ad59ddd$var$qb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$rb = $8733b98c5ad59ddd$var$w("</table>"), $8733b98c5ad59ddd$var$sb = $8733b98c5ad59ddd$var$w('<table hidden><tbody id="'), $8733b98c5ad59ddd$var$tb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$ub = $8733b98c5ad59ddd$var$w("</tbody></table>"), $8733b98c5ad59ddd$var$vb = $8733b98c5ad59ddd$var$w('<table hidden><tr id="'), $8733b98c5ad59ddd$var$wb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$xb = $8733b98c5ad59ddd$var$w("</tr></table>"), $8733b98c5ad59ddd$var$yb = $8733b98c5ad59ddd$var$w('<table hidden><colgroup id="'), $8733b98c5ad59ddd$var$zb = $8733b98c5ad59ddd$var$w('">'), $8733b98c5ad59ddd$var$Ab = $8733b98c5ad59ddd$var$w("</colgroup></table>");
function $8733b98c5ad59ddd$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$gb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$hb);
        case 2:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$jb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$kb);
        case 3:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$mb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$nb);
        case 4:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$pb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$qb);
        case 5:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$sb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$tb);
        case 6:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$vb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$wb);
        case 7:
            return $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$yb), $8733b98c5ad59ddd$var$p(a, b.segmentPrefix), $8733b98c5ad59ddd$var$p(a, $8733b98c5ad59ddd$var$u(d.toString(16))), $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$zb);
        default:
            throw Error($8733b98c5ad59ddd$var$k(397));
    }
}
function $8733b98c5ad59ddd$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$ib);
        case 2:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$lb);
        case 3:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$ob);
        case 4:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$rb);
        case 5:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$ub);
        case 6:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$xb);
        case 7:
            return $8733b98c5ad59ddd$var$t(a, $8733b98c5ad59ddd$var$Ab);
        default:
            throw Error($8733b98c5ad59ddd$var$k(397));
    }
}
var $8733b98c5ad59ddd$var$Db = $8733b98c5ad59ddd$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $8733b98c5ad59ddd$var$Eb = $8733b98c5ad59ddd$var$w('$RS("'), $8733b98c5ad59ddd$var$Gb = $8733b98c5ad59ddd$var$w('","'), $8733b98c5ad59ddd$var$Hb = $8733b98c5ad59ddd$var$w('")</script>'), $8733b98c5ad59ddd$var$Ib = $8733b98c5ad59ddd$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $8733b98c5ad59ddd$var$Jb = $8733b98c5ad59ddd$var$w('$RC("'), $8733b98c5ad59ddd$var$Kb = $8733b98c5ad59ddd$var$w('","'), $8733b98c5ad59ddd$var$Lb = $8733b98c5ad59ddd$var$w('")</script>'), $8733b98c5ad59ddd$var$Mb = $8733b98c5ad59ddd$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $8733b98c5ad59ddd$var$Nb = $8733b98c5ad59ddd$var$w('$RX("'), $8733b98c5ad59ddd$var$Ob = $8733b98c5ad59ddd$var$w('"'), $8733b98c5ad59ddd$var$Pb = $8733b98c5ad59ddd$var$w(")</script>"), $8733b98c5ad59ddd$var$Qb = $8733b98c5ad59ddd$var$w(","), $8733b98c5ad59ddd$var$Rb = /[<\u2028\u2029]/g;
function $8733b98c5ad59ddd$var$Sb(a) {
    return JSON.stringify(a).replace($8733b98c5ad59ddd$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $8733b98c5ad59ddd$var$N = Object.assign, $8733b98c5ad59ddd$var$Tb = Symbol.for("react.element"), $8733b98c5ad59ddd$var$Ub = Symbol.for("react.portal"), $8733b98c5ad59ddd$var$Vb = Symbol.for("react.fragment"), $8733b98c5ad59ddd$var$Wb = Symbol.for("react.strict_mode"), $8733b98c5ad59ddd$var$Xb = Symbol.for("react.profiler"), $8733b98c5ad59ddd$var$Yb = Symbol.for("react.provider"), $8733b98c5ad59ddd$var$Zb = Symbol.for("react.context"), $8733b98c5ad59ddd$var$$b = Symbol.for("react.forward_ref"), $8733b98c5ad59ddd$var$ac = Symbol.for("react.suspense"), $8733b98c5ad59ddd$var$bc = Symbol.for("react.suspense_list"), $8733b98c5ad59ddd$var$cc = Symbol.for("react.memo"), $8733b98c5ad59ddd$var$dc = Symbol.for("react.lazy"), $8733b98c5ad59ddd$var$ec = Symbol.for("react.scope"), $8733b98c5ad59ddd$var$fc = Symbol.for("react.debug_trace_mode"), $8733b98c5ad59ddd$var$gc = Symbol.for("react.legacy_hidden"), $8733b98c5ad59ddd$var$hc = Symbol.for("react.default_value"), $8733b98c5ad59ddd$var$ic = Symbol.iterator;
function $8733b98c5ad59ddd$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8733b98c5ad59ddd$var$Vb:
            return "Fragment";
        case $8733b98c5ad59ddd$var$Ub:
            return "Portal";
        case $8733b98c5ad59ddd$var$Xb:
            return "Profiler";
        case $8733b98c5ad59ddd$var$Wb:
            return "StrictMode";
        case $8733b98c5ad59ddd$var$ac:
            return "Suspense";
        case $8733b98c5ad59ddd$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8733b98c5ad59ddd$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $8733b98c5ad59ddd$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $8733b98c5ad59ddd$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8733b98c5ad59ddd$var$cc:
            return b = a.displayName || null, null !== b ? b : $8733b98c5ad59ddd$var$jc(a.type) || "Memo";
        case $8733b98c5ad59ddd$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $8733b98c5ad59ddd$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $8733b98c5ad59ddd$var$kc = {};
function $8733b98c5ad59ddd$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $8733b98c5ad59ddd$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $8733b98c5ad59ddd$var$O = null;
function $8733b98c5ad59ddd$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($8733b98c5ad59ddd$var$k(401));
        } else {
            if (null === c) throw Error($8733b98c5ad59ddd$var$k(401));
            $8733b98c5ad59ddd$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $8733b98c5ad59ddd$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $8733b98c5ad59ddd$var$mc(a);
}
function $8733b98c5ad59ddd$var$nc(a) {
    var b = a.parent;
    null !== b && $8733b98c5ad59ddd$var$nc(b);
    a.context._currentValue = a.value;
}
function $8733b98c5ad59ddd$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($8733b98c5ad59ddd$var$k(402));
    a.depth === b.depth ? $8733b98c5ad59ddd$var$P(a, b) : $8733b98c5ad59ddd$var$oc(a, b);
}
function $8733b98c5ad59ddd$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($8733b98c5ad59ddd$var$k(402));
    a.depth === c.depth ? $8733b98c5ad59ddd$var$P(a, c) : $8733b98c5ad59ddd$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $8733b98c5ad59ddd$var$Q(a) {
    var b = $8733b98c5ad59ddd$var$O;
    b !== a && (null === b ? $8733b98c5ad59ddd$var$nc(a) : null === a ? $8733b98c5ad59ddd$var$mc(b) : b.depth === a.depth ? $8733b98c5ad59ddd$var$P(b, a) : b.depth > a.depth ? $8733b98c5ad59ddd$var$oc(b, a) : $8733b98c5ad59ddd$var$pc(b, a), $8733b98c5ad59ddd$var$O = a);
}
var $8733b98c5ad59ddd$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $8733b98c5ad59ddd$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $8733b98c5ad59ddd$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $8733b98c5ad59ddd$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $8733b98c5ad59ddd$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $8733b98c5ad59ddd$var$N({}, e, h)) : $8733b98c5ad59ddd$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $8733b98c5ad59ddd$var$sc = {
    id: 1,
    overflow: ""
};
function $8733b98c5ad59ddd$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $8733b98c5ad59ddd$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $8733b98c5ad59ddd$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $8733b98c5ad59ddd$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $8733b98c5ad59ddd$var$uc = Math.clz32 ? Math.clz32 : $8733b98c5ad59ddd$var$vc, $8733b98c5ad59ddd$var$wc = Math.log, $8733b98c5ad59ddd$var$xc = Math.LN2;
function $8733b98c5ad59ddd$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8733b98c5ad59ddd$var$wc(a) / $8733b98c5ad59ddd$var$xc | 0) | 0;
}
function $8733b98c5ad59ddd$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8733b98c5ad59ddd$var$zc = "function" === typeof Object.is ? Object.is : $8733b98c5ad59ddd$var$yc, $8733b98c5ad59ddd$var$R = null, $8733b98c5ad59ddd$var$Ac = null, $8733b98c5ad59ddd$var$Bc = null, $8733b98c5ad59ddd$var$S = null, $8733b98c5ad59ddd$var$T = !1, $8733b98c5ad59ddd$var$Cc = !1, $8733b98c5ad59ddd$var$U = 0, $8733b98c5ad59ddd$var$V = null, $8733b98c5ad59ddd$var$Dc = 0;
function $8733b98c5ad59ddd$var$W() {
    if (null === $8733b98c5ad59ddd$var$R) throw Error($8733b98c5ad59ddd$var$k(321));
    return $8733b98c5ad59ddd$var$R;
}
function $8733b98c5ad59ddd$var$Ec() {
    if (0 < $8733b98c5ad59ddd$var$Dc) throw Error($8733b98c5ad59ddd$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $8733b98c5ad59ddd$var$Fc() {
    null === $8733b98c5ad59ddd$var$S ? null === $8733b98c5ad59ddd$var$Bc ? ($8733b98c5ad59ddd$var$T = !1, $8733b98c5ad59ddd$var$Bc = $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$Ec()) : ($8733b98c5ad59ddd$var$T = !0, $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$Bc) : null === $8733b98c5ad59ddd$var$S.next ? ($8733b98c5ad59ddd$var$T = !1, $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$S.next = $8733b98c5ad59ddd$var$Ec()) : ($8733b98c5ad59ddd$var$T = !0, $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$S.next);
    return $8733b98c5ad59ddd$var$S;
}
function $8733b98c5ad59ddd$var$Gc() {
    $8733b98c5ad59ddd$var$Ac = $8733b98c5ad59ddd$var$R = null;
    $8733b98c5ad59ddd$var$Cc = !1;
    $8733b98c5ad59ddd$var$Bc = null;
    $8733b98c5ad59ddd$var$Dc = 0;
    $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$V = null;
}
function $8733b98c5ad59ddd$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8733b98c5ad59ddd$var$Ic(a, b, c) {
    $8733b98c5ad59ddd$var$R = $8733b98c5ad59ddd$var$W();
    $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$Fc();
    if ($8733b98c5ad59ddd$var$T) {
        var d = $8733b98c5ad59ddd$var$S.queue;
        b = d.dispatch;
        if (null !== $8733b98c5ad59ddd$var$V && (c = $8733b98c5ad59ddd$var$V.get(d), void 0 !== c)) {
            $8733b98c5ad59ddd$var$V.delete(d);
            d = $8733b98c5ad59ddd$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $8733b98c5ad59ddd$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $8733b98c5ad59ddd$var$S.memoizedState,
            b
        ];
    }
    a = a === $8733b98c5ad59ddd$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $8733b98c5ad59ddd$var$S.memoizedState = a;
    a = $8733b98c5ad59ddd$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $8733b98c5ad59ddd$var$Jc.bind(null, $8733b98c5ad59ddd$var$R, a);
    return [
        $8733b98c5ad59ddd$var$S.memoizedState,
        a
    ];
}
function $8733b98c5ad59ddd$var$Kc(a, b) {
    $8733b98c5ad59ddd$var$R = $8733b98c5ad59ddd$var$W();
    $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $8733b98c5ad59ddd$var$S) {
        var c = $8733b98c5ad59ddd$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$8733b98c5ad59ddd$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $8733b98c5ad59ddd$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8733b98c5ad59ddd$var$Jc(a, b, c) {
    if (25 <= $8733b98c5ad59ddd$var$Dc) throw Error($8733b98c5ad59ddd$var$k(301));
    if (a === $8733b98c5ad59ddd$var$R) {
        if ($8733b98c5ad59ddd$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $8733b98c5ad59ddd$var$V && ($8733b98c5ad59ddd$var$V = new Map), c = $8733b98c5ad59ddd$var$V.get(b), void 0 === c) $8733b98c5ad59ddd$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $8733b98c5ad59ddd$var$Lc() {
    throw Error($8733b98c5ad59ddd$var$k(394));
}
function $8733b98c5ad59ddd$var$Mc() {}
var $8733b98c5ad59ddd$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $8733b98c5ad59ddd$var$W();
        return a._currentValue;
    },
    useMemo: $8733b98c5ad59ddd$var$Kc,
    useReducer: $8733b98c5ad59ddd$var$Ic,
    useRef: function(a) {
        $8733b98c5ad59ddd$var$R = $8733b98c5ad59ddd$var$W();
        $8733b98c5ad59ddd$var$S = $8733b98c5ad59ddd$var$Fc();
        var b = $8733b98c5ad59ddd$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $8733b98c5ad59ddd$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $8733b98c5ad59ddd$var$Ic($8733b98c5ad59ddd$var$Hc, a);
    },
    useInsertionEffect: $8733b98c5ad59ddd$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $8733b98c5ad59ddd$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $8733b98c5ad59ddd$var$Mc,
    useEffect: $8733b98c5ad59ddd$var$Mc,
    useDebugValue: $8733b98c5ad59ddd$var$Mc,
    useDeferredValue: function(a) {
        $8733b98c5ad59ddd$var$W();
        return a;
    },
    useTransition: function() {
        $8733b98c5ad59ddd$var$W();
        return [
            !1,
            $8733b98c5ad59ddd$var$Lc
        ];
    },
    useId: function() {
        var a = $8733b98c5ad59ddd$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $8733b98c5ad59ddd$var$uc(a) - 1)).toString(32) + b;
        var c = $8733b98c5ad59ddd$var$Nc;
        if (null === c) throw Error($8733b98c5ad59ddd$var$k(404));
        b = $8733b98c5ad59ddd$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $8733b98c5ad59ddd$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($8733b98c5ad59ddd$var$k(407));
        return c();
    }
}, $8733b98c5ad59ddd$var$Nc = null, $8733b98c5ad59ddd$var$Pc = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $8733b98c5ad59ddd$var$Qc(a) {
    console.error(a);
    return null;
}
function $8733b98c5ad59ddd$var$X() {}
function $8733b98c5ad59ddd$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $8733b98c5ad59ddd$var$Qc : f,
        onAllReady: void 0 === e ? $8733b98c5ad59ddd$var$X : e,
        onShellReady: void 0 === g ? $8733b98c5ad59ddd$var$X : g,
        onShellError: void 0 === h ? $8733b98c5ad59ddd$var$X : h,
        onFatalError: void 0 === m ? $8733b98c5ad59ddd$var$X : m
    };
    c = $8733b98c5ad59ddd$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $8733b98c5ad59ddd$var$Tc(b, a, null, c, r, $8733b98c5ad59ddd$var$kc, null, $8733b98c5ad59ddd$var$sc);
    q.push(a);
    return b;
}
function $8733b98c5ad59ddd$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $8733b98c5ad59ddd$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $8733b98c5ad59ddd$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $8733b98c5ad59ddd$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $8733b98c5ad59ddd$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $8733b98c5ad59ddd$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $8733b98c5ad59ddd$var$Wc(a, b, c, d, f) {
    $8733b98c5ad59ddd$var$R = {};
    $8733b98c5ad59ddd$var$Ac = b;
    $8733b98c5ad59ddd$var$U = 0;
    for(a = c(d, f); $8733b98c5ad59ddd$var$Cc;)$8733b98c5ad59ddd$var$Cc = !1, $8733b98c5ad59ddd$var$U = 0, $8733b98c5ad59ddd$var$Dc += 1, $8733b98c5ad59ddd$var$S = null, a = c(d, f);
    $8733b98c5ad59ddd$var$Gc();
    return a;
}
function $8733b98c5ad59ddd$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($8733b98c5ad59ddd$var$k(108, $8733b98c5ad59ddd$var$jc(d) || "Unknown", h));
            d = $8733b98c5ad59ddd$var$N({}, g, c);
        }
        b.legacyContext = d;
        $8733b98c5ad59ddd$var$Z(a, b, f);
        b.legacyContext = g;
    } else $8733b98c5ad59ddd$var$Z(a, b, f);
}
function $8733b98c5ad59ddd$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $8733b98c5ad59ddd$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $8733b98c5ad59ddd$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $8733b98c5ad59ddd$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $8733b98c5ad59ddd$var$rc(e, c, d, f);
            $8733b98c5ad59ddd$var$Xc(a, b, e, c);
        } else {
            e = $8733b98c5ad59ddd$var$lc(c, b.legacyContext);
            f = $8733b98c5ad59ddd$var$Wc(a, b, c, d, e);
            var g = 0 !== $8733b98c5ad59ddd$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $8733b98c5ad59ddd$var$rc(f, c, d, e), $8733b98c5ad59ddd$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $8733b98c5ad59ddd$var$tc(d, 1, 0);
                try {
                    $8733b98c5ad59ddd$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $8733b98c5ad59ddd$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $8733b98c5ad59ddd$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $8733b98c5ad59ddd$var$Ba(g, c, d);
        $8733b98c5ad59ddd$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($8733b98c5ad59ddd$var$Ta, $8733b98c5ad59ddd$var$u(c), $8733b98c5ad59ddd$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $8733b98c5ad59ddd$var$gc:
            case $8733b98c5ad59ddd$var$fc:
            case $8733b98c5ad59ddd$var$Wb:
            case $8733b98c5ad59ddd$var$Xb:
            case $8733b98c5ad59ddd$var$Vb:
                $8733b98c5ad59ddd$var$Z(a, b, d.children);
                return;
            case $8733b98c5ad59ddd$var$bc:
                $8733b98c5ad59ddd$var$Z(a, b, d.children);
                return;
            case $8733b98c5ad59ddd$var$ec:
                throw Error($8733b98c5ad59ddd$var$k(343));
            case $8733b98c5ad59ddd$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $8733b98c5ad59ddd$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $8733b98c5ad59ddd$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($8733b98c5ad59ddd$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($8733b98c5ad59ddd$var$Ca), q.status = 1, $8733b98c5ad59ddd$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $8733b98c5ad59ddd$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $8733b98c5ad59ddd$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $8733b98c5ad59ddd$var$$b:
                d = $8733b98c5ad59ddd$var$Wc(a, b, c.render, d, f);
                if (0 !== $8733b98c5ad59ddd$var$U) {
                    c = b.treeContext;
                    b.treeContext = $8733b98c5ad59ddd$var$tc(c, 1, 0);
                    try {
                        $8733b98c5ad59ddd$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $8733b98c5ad59ddd$var$Z(a, b, d);
                return;
            case $8733b98c5ad59ddd$var$cc:
                c = c.type;
                d = $8733b98c5ad59ddd$var$Yc(c, d);
                $8733b98c5ad59ddd$var$Zc(a, b, c, d, f);
                return;
            case $8733b98c5ad59ddd$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $8733b98c5ad59ddd$var$O;
                $8733b98c5ad59ddd$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $8733b98c5ad59ddd$var$Z(a, b, f);
                a = $8733b98c5ad59ddd$var$O;
                if (null === a) throw Error($8733b98c5ad59ddd$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $8733b98c5ad59ddd$var$hc ? a.context._defaultValue : d;
                a = $8733b98c5ad59ddd$var$O = a.parent;
                b.context = a;
                return;
            case $8733b98c5ad59ddd$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $8733b98c5ad59ddd$var$Z(a, b, d);
                return;
            case $8733b98c5ad59ddd$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $8733b98c5ad59ddd$var$Yc(c, d);
                $8733b98c5ad59ddd$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($8733b98c5ad59ddd$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $8733b98c5ad59ddd$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $8733b98c5ad59ddd$var$Tb:
                $8733b98c5ad59ddd$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $8733b98c5ad59ddd$var$Ub:
                throw Error($8733b98c5ad59ddd$var$k(257));
            case $8733b98c5ad59ddd$var$dc:
                var d = c._init;
                c = d(c._payload);
                $8733b98c5ad59ddd$var$Z(a, b, c);
                return;
        }
        if ($8733b98c5ad59ddd$var$ra(c)) {
            $8733b98c5ad59ddd$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $8733b98c5ad59ddd$var$ic && c[$8733b98c5ad59ddd$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $8733b98c5ad59ddd$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($8733b98c5ad59ddd$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $8733b98c5ad59ddd$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $8733b98c5ad59ddd$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $8733b98c5ad59ddd$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $8733b98c5ad59ddd$var$tc(e, d, f);
        try {
            $8733b98c5ad59ddd$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $8733b98c5ad59ddd$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $8733b98c5ad59ddd$var$Z(a, b, c);
    } catch (m) {
        if ($8733b98c5ad59ddd$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $8733b98c5ad59ddd$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $8733b98c5ad59ddd$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $8733b98c5ad59ddd$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $8733b98c5ad59ddd$var$Q(e), m;
    }
}
function $8733b98c5ad59ddd$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $8733b98c5ad59ddd$var$dd(this, b, a);
}
function $8733b98c5ad59ddd$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($8733b98c5ad59ddd$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $8733b98c5ad59ddd$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $8733b98c5ad59ddd$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $8733b98c5ad59ddd$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $8733b98c5ad59ddd$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($8733b98c5ad59ddd$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $8733b98c5ad59ddd$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $8733b98c5ad59ddd$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($8733b98c5ad59ddd$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($8733b98c5ad59ddd$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $8733b98c5ad59ddd$var$Uc(a) {
    if (2 !== a.status) {
        var b = $8733b98c5ad59ddd$var$O, c = $8733b98c5ad59ddd$var$Pc.current;
        $8733b98c5ad59ddd$var$Pc.current = $8733b98c5ad59ddd$var$Oc;
        var d = $8733b98c5ad59ddd$var$Nc;
        $8733b98c5ad59ddd$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $8733b98c5ad59ddd$var$Q(g.context);
                    try {
                        $8733b98c5ad59ddd$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($8733b98c5ad59ddd$var$Ca), g.abortSet.delete(g), m.status = 1, $8733b98c5ad59ddd$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($8733b98c5ad59ddd$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $8733b98c5ad59ddd$var$Y(h, v);
                            null === r ? $8733b98c5ad59ddd$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $8733b98c5ad59ddd$var$fd(a, a.destination);
        } catch (G) {
            $8733b98c5ad59ddd$var$Y(a, G), $8733b98c5ad59ddd$var$Vc(a, G);
        } finally{
            $8733b98c5ad59ddd$var$Nc = d, $8733b98c5ad59ddd$var$Pc.current = c, c === $8733b98c5ad59ddd$var$Oc && $8733b98c5ad59ddd$var$Q(b);
        }
    }
}
function $8733b98c5ad59ddd$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Va);
            $8733b98c5ad59ddd$var$p(b, a.placeholderPrefix);
            a = $8733b98c5ad59ddd$var$u(d.toString(16));
            $8733b98c5ad59ddd$var$p(b, a);
            return $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$8733b98c5ad59ddd$var$p(b, d[e]);
                f = $8733b98c5ad59ddd$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$8733b98c5ad59ddd$var$p(b, d[e]);
            e < d.length && (f = $8733b98c5ad59ddd$var$t(b, d[e]));
            return f;
        default:
            throw Error($8733b98c5ad59ddd$var$k(390));
    }
}
function $8733b98c5ad59ddd$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $8733b98c5ad59ddd$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$$a), $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$bb), d && ($8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$db), $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$C(d))), $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$cb)), $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$eb), $8733b98c5ad59ddd$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $8733b98c5ad59ddd$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $8733b98c5ad59ddd$var$fb(b, a.responseState, d);
        $8733b98c5ad59ddd$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $8733b98c5ad59ddd$var$fb(b, a.responseState, d.id), $8733b98c5ad59ddd$var$gd(a, b, c);
    else {
        $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($8733b98c5ad59ddd$var$k(391));
        $8733b98c5ad59ddd$var$hd(a, b, c[0]);
    }
    return $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$ab);
}
function $8733b98c5ad59ddd$var$id(a, b, c) {
    $8733b98c5ad59ddd$var$Bb(b, a.responseState, c.formatContext, c.id);
    $8733b98c5ad59ddd$var$hd(a, b, c);
    return $8733b98c5ad59ddd$var$Cb(b, c.formatContext);
}
function $8733b98c5ad59ddd$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$8733b98c5ad59ddd$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $8733b98c5ad59ddd$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Ib));
    if (null === d) throw Error($8733b98c5ad59ddd$var$k(395));
    c = $8733b98c5ad59ddd$var$u(c.toString(16));
    $8733b98c5ad59ddd$var$p(b, d);
    $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Kb);
    $8733b98c5ad59ddd$var$p(b, a.segmentPrefix);
    $8733b98c5ad59ddd$var$p(b, c);
    return $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$Lb);
}
function $8733b98c5ad59ddd$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($8733b98c5ad59ddd$var$k(392));
        return $8733b98c5ad59ddd$var$id(a, b, d);
    }
    $8733b98c5ad59ddd$var$id(a, b, d);
    a = a.responseState;
    $8733b98c5ad59ddd$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Eb) : (a.sentCompleteSegmentFunction = !0, $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Db));
    $8733b98c5ad59ddd$var$p(b, a.segmentPrefix);
    f = $8733b98c5ad59ddd$var$u(f.toString(16));
    $8733b98c5ad59ddd$var$p(b, f);
    $8733b98c5ad59ddd$var$p(b, $8733b98c5ad59ddd$var$Gb);
    $8733b98c5ad59ddd$var$p(b, a.placeholderPrefix);
    $8733b98c5ad59ddd$var$p(b, f);
    return $8733b98c5ad59ddd$var$t(b, $8733b98c5ad59ddd$var$Hb);
}
function $8733b98c5ad59ddd$var$fd(a, b) {
    $8733b98c5ad59ddd$var$l = new Uint8Array(512);
    $8733b98c5ad59ddd$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $8733b98c5ad59ddd$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$8733b98c5ad59ddd$var$p(b, d[c]);
            c < d.length && $8733b98c5ad59ddd$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $8733b98c5ad59ddd$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$Nb) : (h.sentClientRenderFunction = !0, $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$Mb));
            if (null === m) throw Error($8733b98c5ad59ddd$var$k(395));
            $8733b98c5ad59ddd$var$p(d, m);
            $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$Ob);
            if (q || r || v) $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$Qb), $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$Sb(q || "")));
            if (r || v) $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$Qb), $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$Sb(r || "")));
            v && ($8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$Qb), $8733b98c5ad59ddd$var$p(d, $8733b98c5ad59ddd$var$u($8733b98c5ad59ddd$var$Sb(v))));
            if (!$8733b98c5ad59ddd$var$t(d, $8733b98c5ad59ddd$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$8733b98c5ad59ddd$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $8733b98c5ad59ddd$var$ba(b);
        $8733b98c5ad59ddd$var$l = new Uint8Array(512);
        $8733b98c5ad59ddd$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$8733b98c5ad59ddd$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$8733b98c5ad59ddd$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $8733b98c5ad59ddd$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $8733b98c5ad59ddd$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $8733b98c5ad59ddd$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $8733b98c5ad59ddd$var$fd(a, a.destination);
    } catch (d) {
        $8733b98c5ad59ddd$var$Y(a, d), $8733b98c5ad59ddd$var$Vc(a, d);
    }
}
$8733b98c5ad59ddd$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $8733b98c5ad59ddd$var$Rc(a, $8733b98c5ad59ddd$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $8733b98c5ad59ddd$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $8733b98c5ad59ddd$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $8733b98c5ad59ddd$var$fd(h, a);
                        } catch (A) {
                            $8733b98c5ad59ddd$var$Y(h, A), $8733b98c5ad59ddd$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $8733b98c5ad59ddd$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $8733b98c5ad59ddd$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $8733b98c5ad59ddd$var$Uc(h);
    });
};
$8733b98c5ad59ddd$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("7xV53", function(module, exports) {
"use strict";

var $kjGLy = parcelRequire("kjGLy");
var $57e7e4732e65e8e0$require$Queue = $kjGLy;
if ($57e7e4732e65e8e0$require$Queue.default) $57e7e4732e65e8e0$require$Queue = $57e7e4732e65e8e0$require$Queue.default; // temporary webpack fix
module.exports = $57e7e4732e65e8e0$var$polylabel;
module.exports.default = $57e7e4732e65e8e0$var$polylabel;
function $57e7e4732e65e8e0$var$polylabel(polygon, precision, debug) {
    precision = precision || 1.0;
    // find the bounding box of the outer ring
    var minX, minY, maxX, maxY;
    for(var i = 0; i < polygon[0].length; i++){
        var p = polygon[0][i];
        if (!i || p[0] < minX) minX = p[0];
        if (!i || p[1] < minY) minY = p[1];
        if (!i || p[0] > maxX) maxX = p[0];
        if (!i || p[1] > maxY) maxY = p[1];
    }
    var width = maxX - minX;
    var height = maxY - minY;
    var cellSize = Math.min(width, height);
    var h = cellSize / 2;
    if (cellSize === 0) {
        var degeneratePoleOfInaccessibility = [
            minX,
            minY
        ];
        degeneratePoleOfInaccessibility.distance = 0;
        return degeneratePoleOfInaccessibility;
    }
    // a priority queue of cells in order of their "potential" (max distance to polygon)
    var cellQueue = new $57e7e4732e65e8e0$require$Queue(undefined, $57e7e4732e65e8e0$var$compareMax);
    // cover polygon with initial cells
    for(var x = minX; x < maxX; x += cellSize)for(var y = minY; y < maxY; y += cellSize)cellQueue.push(new $57e7e4732e65e8e0$var$Cell(x + h, y + h, h, polygon));
    // take centroid as the first best guess
    var bestCell = $57e7e4732e65e8e0$var$getCentroidCell(polygon);
    // special case for rectangular polygons
    var bboxCell = new $57e7e4732e65e8e0$var$Cell(minX + width / 2, minY + height / 2, 0, polygon);
    if (bboxCell.d > bestCell.d) bestCell = bboxCell;
    var numProbes = cellQueue.length;
    while(cellQueue.length){
        // pick the most promising cell from the queue
        var cell = cellQueue.pop();
        // update the best cell if we found a better one
        if (cell.d > bestCell.d) {
            bestCell = cell;
            if (debug) console.log("found best %d after %d probes", Math.round(1e4 * cell.d) / 1e4, numProbes);
        }
        // do not drill down further if there's no chance of a better solution
        if (cell.max - bestCell.d <= precision) continue;
        // split the cell into four cells
        h = cell.h / 2;
        cellQueue.push(new $57e7e4732e65e8e0$var$Cell(cell.x - h, cell.y - h, h, polygon));
        cellQueue.push(new $57e7e4732e65e8e0$var$Cell(cell.x + h, cell.y - h, h, polygon));
        cellQueue.push(new $57e7e4732e65e8e0$var$Cell(cell.x - h, cell.y + h, h, polygon));
        cellQueue.push(new $57e7e4732e65e8e0$var$Cell(cell.x + h, cell.y + h, h, polygon));
        numProbes += 4;
    }
    if (debug) {
        console.log("num probes: " + numProbes);
        console.log("best distance: " + bestCell.d);
    }
    var poleOfInaccessibility = [
        bestCell.x,
        bestCell.y
    ];
    poleOfInaccessibility.distance = bestCell.d;
    return poleOfInaccessibility;
}
function $57e7e4732e65e8e0$var$compareMax(a, b) {
    return b.max - a.max;
}
function $57e7e4732e65e8e0$var$Cell(x, y, h, polygon) {
    this.x = x; // cell center x
    this.y = y; // cell center y
    this.h = h; // half the cell size
    this.d = $57e7e4732e65e8e0$var$pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}
// signed distance from point to polygon outline (negative if point is outside)
function $57e7e4732e65e8e0$var$pointToPolygonDist(x, y, polygon) {
    var inside = false;
    var minDistSq = Infinity;
    for(var k = 0; k < polygon.length; k++){
        var ring = polygon[k];
        for(var i = 0, len = ring.length, j = len - 1; i < len; j = i++){
            var a = ring[i];
            var b = ring[j];
            if (a[1] > y !== b[1] > y && x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0]) inside = !inside;
            minDistSq = Math.min(minDistSq, $57e7e4732e65e8e0$var$getSegDistSq(x, y, a, b));
        }
    }
    return minDistSq === 0 ? 0 : (inside ? 1 : -1) * Math.sqrt(minDistSq);
}
// get polygon centroid
function $57e7e4732e65e8e0$var$getCentroidCell(polygon) {
    var area = 0;
    var x = 0;
    var y = 0;
    var points = polygon[0];
    for(var i = 0, len = points.length, j = len - 1; i < len; j = i++){
        var a = points[i];
        var b = points[j];
        var f = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * f;
        y += (a[1] + b[1]) * f;
        area += f * 3;
    }
    if (area === 0) return new $57e7e4732e65e8e0$var$Cell(points[0][0], points[0][1], 0, polygon);
    return new $57e7e4732e65e8e0$var$Cell(x / area, y / area, 0, polygon);
}
// get squared distance from a point to a segment
function $57e7e4732e65e8e0$var$getSegDistSq(px, py, a, b) {
    var x = a[0];
    var y = a[1];
    var dx = b[0] - x;
    var dy = b[1] - y;
    if (dx !== 0 || dy !== 0) {
        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x = b[0];
            y = b[1];
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = px - x;
    dy = py - y;
    return dx * dx + dy * dy;
}

});
parcelRegister("kjGLy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eca6c16ee2a786cd$export$2e2bcd8739ae039);
class $eca6c16ee2a786cd$export$2e2bcd8739ae039 {
    constructor(data = [], compare = $eca6c16ee2a786cd$var$defaultCompare){
        this.data = data;
        this.length = this.data.length;
        this.compare = compare;
        if (this.length > 0) for(let i = (this.length >> 1) - 1; i >= 0; i--)this._down(i);
    }
    push(item) {
        this.data.push(item);
        this.length++;
        this._up(this.length - 1);
    }
    pop() {
        if (this.length === 0) return undefined;
        const top = this.data[0];
        const bottom = this.data.pop();
        this.length--;
        if (this.length > 0) {
            this.data[0] = bottom;
            this._down(0);
        }
        return top;
    }
    peek() {
        return this.data[0];
    }
    _up(pos) {
        const { data: data, compare: compare } = this;
        const item = data[pos];
        while(pos > 0){
            const parent = pos - 1 >> 1;
            const current = data[parent];
            if (compare(item, current) >= 0) break;
            data[pos] = current;
            pos = parent;
        }
        data[pos] = item;
    }
    _down(pos) {
        const { data: data, compare: compare } = this;
        const halfLength = this.length >> 1;
        const item = data[pos];
        while(pos < halfLength){
            let left = (pos << 1) + 1;
            let best = data[left];
            const right = left + 1;
            if (right < this.length && compare(data[right], best) < 0) {
                left = right;
                best = data[right];
            }
            if (compare(best, item) >= 0) break;
            data[pos] = best;
            pos = left;
        }
        data[pos] = item;
    }
}
function $eca6c16ee2a786cd$var$defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

});


parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) return elem.textContent;
            else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented
        // as part of Sizzle so let's maintain them in the 3.x line
        // for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $8725869b83961a04$export$3545e07a80636437 = "153";
const $8725869b83961a04$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $8725869b83961a04$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $8725869b83961a04$export$3237e1f2c1ea1f44 = 0;
const $8725869b83961a04$export$b9a7b4fc5cb15f9b = 1;
const $8725869b83961a04$export$b8058bcc7037d3f3 = 2;
const $8725869b83961a04$export$f24be24dcddeac0d = 3;
const $8725869b83961a04$export$346307dbae2b7447 = 0;
const $8725869b83961a04$export$5813f879eee7cd88 = 1;
const $8725869b83961a04$export$a47c4b43a1be34f0 = 2;
const $8725869b83961a04$export$896ae1ade6c829c4 = 3;
const $8725869b83961a04$export$2ede184fc2998901 = 0;
const $8725869b83961a04$export$d9f0486e75b5ace = 1;
const $8725869b83961a04$export$3b296b6f144d5b03 = 2;
const $8725869b83961a04$export$211211c00f97204d = 2; // r149
const $8725869b83961a04$export$63b8d6b580fc65ba = 0;
const $8725869b83961a04$export$5b29a26d96ee6af0 = 1;
const $8725869b83961a04$export$777d8f9551c2216b = 2;
const $8725869b83961a04$export$cdfa06f868e2e467 = 3;
const $8725869b83961a04$export$4138e1c684b46a20 = 4;
const $8725869b83961a04$export$eda4864c68df1fa2 = 5;
const $8725869b83961a04$export$20183a0484ce21a0 = 100;
const $8725869b83961a04$export$73e0df5177988548 = 101;
const $8725869b83961a04$export$28e582859cbec660 = 102;
const $8725869b83961a04$export$c8c1508da8d0600c = 103;
const $8725869b83961a04$export$99948c02fb51055f = 104;
const $8725869b83961a04$export$2110f05edf778d3d = 200;
const $8725869b83961a04$export$8805bad65e24940e = 201;
const $8725869b83961a04$export$7fbe15b28d28cf52 = 202;
const $8725869b83961a04$export$947829af9f2c17f6 = 203;
const $8725869b83961a04$export$d5773124e86cf28c = 204;
const $8725869b83961a04$export$11d468cc7f19e971 = 205;
const $8725869b83961a04$export$a78aed1ca2a87192 = 206;
const $8725869b83961a04$export$5d0fe17fd8773bac = 207;
const $8725869b83961a04$export$ef5f2dd8ffac5574 = 208;
const $8725869b83961a04$export$56b85b2686ab16 = 209;
const $8725869b83961a04$export$c05e2a1fc8609506 = 210;
const $8725869b83961a04$export$69025ce147cee220 = 0;
const $8725869b83961a04$export$7182eb52ea3b3f04 = 1;
const $8725869b83961a04$export$eedccec66ab7ebe = 2;
const $8725869b83961a04$export$296f78a0b892f81a = 3;
const $8725869b83961a04$export$a60d398fc7b7590e = 4;
const $8725869b83961a04$export$7d7234c1240a1fc4 = 5;
const $8725869b83961a04$export$c5e2c52991f30937 = 6;
const $8725869b83961a04$export$2f843afa843d8916 = 7;
const $8725869b83961a04$export$e50ac29801f1774d = 0;
const $8725869b83961a04$export$9f9d94f963c85479 = 1;
const $8725869b83961a04$export$e641dc52bc3494aa = 2;
const $8725869b83961a04$export$9fcb6b4294603b2 = 0;
const $8725869b83961a04$export$98f52c2a46c598ca = 1;
const $8725869b83961a04$export$74b25e54b3bcd548 = 2;
const $8725869b83961a04$export$932b3dd283d4a366 = 3;
const $8725869b83961a04$export$a0d98fe6d7e4af64 = 4;
const $8725869b83961a04$export$2c7b09c1e9abfb5e = 5;
const $8725869b83961a04$export$1beec6768cbb3d2d = 300;
const $8725869b83961a04$export$8759762a6477f2c4 = 301;
const $8725869b83961a04$export$dc59f8aed047f61d = 302;
const $8725869b83961a04$export$d64030b316d3b087 = 303;
const $8725869b83961a04$export$ee99d97d46898098 = 304;
const $8725869b83961a04$export$dbf3e70ff37af79 = 306;
const $8725869b83961a04$export$533346c8e8dac0f5 = 1000;
const $8725869b83961a04$export$9d9334239a5a5e06 = 1001;
const $8725869b83961a04$export$c7e7c00b14f51a4f = 1002;
const $8725869b83961a04$export$727aa5ec3fe39bf0 = 1003;
const $8725869b83961a04$export$d129e38cf6feaa8c = 1004;
const $8725869b83961a04$export$14a4936464a36496 = 1004;
const $8725869b83961a04$export$d2327c1afe5bfdf2 = 1005;
const $8725869b83961a04$export$cbc5b7f5647595d8 = 1005;
const $8725869b83961a04$export$8a72f490b25c56c8 = 1006;
const $8725869b83961a04$export$19a719f377145a13 = 1007;
const $8725869b83961a04$export$dbe96bee3fe9dbf0 = 1007;
const $8725869b83961a04$export$5d8599b6a933fb1b = 1008;
const $8725869b83961a04$export$90d80f1e3506775f = 1008;
const $8725869b83961a04$export$2e8ce08d3f6f5e10 = 1009;
const $8725869b83961a04$export$545fce0311a9796a = 1010;
const $8725869b83961a04$export$88572337f312435f = 1011;
const $8725869b83961a04$export$c63dc51868b06a9d = 1012;
const $8725869b83961a04$export$5c612977753abe2 = 1013;
const $8725869b83961a04$export$c3c7fc4518ebba96 = 1014;
const $8725869b83961a04$export$f6d331659b644596 = 1015;
const $8725869b83961a04$export$2697304443f382bc = 1016;
const $8725869b83961a04$export$b3969b01faf587f2 = 1017;
const $8725869b83961a04$export$18886f8ae33e90de = 1018;
const $8725869b83961a04$export$6c8ea339bfab1301 = 1020;
const $8725869b83961a04$export$988473390501ed4b = 1021;
const $8725869b83961a04$export$3f8bb04b555a363c = 1023;
const $8725869b83961a04$export$cc09ccbf6d1ed449 = 1024;
const $8725869b83961a04$export$9053a81c4a69c289 = 1025;
const $8725869b83961a04$export$c1b6b5136be58045 = 1026;
const $8725869b83961a04$export$1e113ac2d0905829 = 1027;
const $8725869b83961a04$export$4e041a7967d15c4b = 1028;
const $8725869b83961a04$export$aa92e870a709d190 = 1029;
const $8725869b83961a04$export$6cdf0b461c7ce8a0 = 1030;
const $8725869b83961a04$export$1ba1c45f9f77d4d7 = 1031;
const $8725869b83961a04$export$c200e7d26f592f21 = 1033;
const $8725869b83961a04$export$21d1799c6d552fc0 = 33776;
const $8725869b83961a04$export$afa304c3e981b668 = 33777;
const $8725869b83961a04$export$d2a1a68024a3e56c = 33778;
const $8725869b83961a04$export$9a79c424327dacf9 = 33779;
const $8725869b83961a04$export$19ada9bbb1af3573 = 35840;
const $8725869b83961a04$export$d0f0355bb3d948e4 = 35841;
const $8725869b83961a04$export$b82296714358084c = 35842;
const $8725869b83961a04$export$b71692456c47b6c3 = 35843;
const $8725869b83961a04$export$6ab91af2d757aee7 = 36196;
const $8725869b83961a04$export$7800993ef8106a6a = 37492;
const $8725869b83961a04$export$23ed8300a860e7d8 = 37496;
const $8725869b83961a04$export$dc5570b4a2b92d48 = 37808;
const $8725869b83961a04$export$68880cd325f8b2fb = 37809;
const $8725869b83961a04$export$7d2c0be323373d95 = 37810;
const $8725869b83961a04$export$22b52da301fc3a3e = 37811;
const $8725869b83961a04$export$c009e2cb4a66485e = 37812;
const $8725869b83961a04$export$118fff5afa255b63 = 37813;
const $8725869b83961a04$export$120713c829ae0667 = 37814;
const $8725869b83961a04$export$c79eeabbf53313e9 = 37815;
const $8725869b83961a04$export$443cf6567cdd6424 = 37816;
const $8725869b83961a04$export$6573984fc9840780 = 37817;
const $8725869b83961a04$export$e7aee563f30091de = 37818;
const $8725869b83961a04$export$2eb8634622ddeab7 = 37819;
const $8725869b83961a04$export$202b1ce7b5d25742 = 37820;
const $8725869b83961a04$export$18ab77abd087e467 = 37821;
const $8725869b83961a04$export$ce40b115e188bc81 = 36492;
const $8725869b83961a04$export$b1688df4c4c21670 = 36283;
const $8725869b83961a04$export$fc15e5d8261eed58 = 36284;
const $8725869b83961a04$export$d220f6ade8463a0f = 36285;
const $8725869b83961a04$export$768646d09dc1b6ef = 36286;
const $8725869b83961a04$export$d62fdc9d1b1cccad = 2200;
const $8725869b83961a04$export$dfaf4422ce096e29 = 2201;
const $8725869b83961a04$export$f8f6f2041b78e210 = 2202;
const $8725869b83961a04$export$995b32462a65e855 = 2300;
const $8725869b83961a04$export$30fac1aace31cf4d = 2301;
const $8725869b83961a04$export$198b11ff4c72bb30 = 2302;
const $8725869b83961a04$export$7f795934b84ab523 = 2400;
const $8725869b83961a04$export$24a4ccb5099273b5 = 2401;
const $8725869b83961a04$export$8e8c3ecdcd8e1fee = 2402;
const $8725869b83961a04$export$bcfbbdcf8de7f8cd = 2500;
const $8725869b83961a04$export$d875e029ef558d3 = 2501;
const $8725869b83961a04$export$4c28c87c2dc84758 = 0;
const $8725869b83961a04$export$b23a071aa286eb29 = 1;
const $8725869b83961a04$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $8725869b83961a04$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $8725869b83961a04$export$f32388edbb32674 = 3001;
const $8725869b83961a04$export$deeb383078690b50 = 3200;
const $8725869b83961a04$export$8f910f4c4f73df11 = 3201;
const $8725869b83961a04$export$2852a58ebdac27b8 = 0;
const $8725869b83961a04$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $8725869b83961a04$export$bfcb490c2dd3db51 = "";
const $8725869b83961a04$export$561f394b24edfcaa = "srgb";
const $8725869b83961a04$export$42429b3acfb233a4 = "srgb-linear";
const $8725869b83961a04$export$626af19ae879bdf6 = "display-p3";
const $8725869b83961a04$export$69433f11f42d5527 = 0;
const $8725869b83961a04$export$9f542ae4b5baca34 = 7680;
const $8725869b83961a04$export$8a4f28336ef203d3 = 7681;
const $8725869b83961a04$export$2928c0231297c036 = 7682;
const $8725869b83961a04$export$c0e9611c8a15f9a8 = 7683;
const $8725869b83961a04$export$9c2c08927385dcc4 = 34055;
const $8725869b83961a04$export$7c74ea00fa1315e6 = 34056;
const $8725869b83961a04$export$22e2e5726612443 = 5386;
const $8725869b83961a04$export$1343870698229224 = 512;
const $8725869b83961a04$export$8e1d8ed281997fa6 = 513;
const $8725869b83961a04$export$55648a1cde8329a7 = 514;
const $8725869b83961a04$export$2dff107857e6aca2 = 515;
const $8725869b83961a04$export$6f93765ab2f451a2 = 516;
const $8725869b83961a04$export$6f3fb2d2440f2b76 = 517;
const $8725869b83961a04$export$4119cf7b4c98fd5a = 518;
const $8725869b83961a04$export$14cf96713ddd97a8 = 519;
const $8725869b83961a04$export$d9e2d19a747baaab = 512;
const $8725869b83961a04$export$36bcf49c713b3eb7 = 513;
const $8725869b83961a04$export$66f28d946fc6a0d5 = 514;
const $8725869b83961a04$export$64eea11eb407ddf1 = 515;
const $8725869b83961a04$export$155af022118f3a38 = 516;
const $8725869b83961a04$export$67ab95dde6bed156 = 517;
const $8725869b83961a04$export$1cdcb70d53d65f61 = 518;
const $8725869b83961a04$export$187b73a3e352c145 = 519;
const $8725869b83961a04$export$763e8360f4d7f77d = 35044;
const $8725869b83961a04$export$8505d14ac8546ca = 35048;
const $8725869b83961a04$export$721e63549e51d81e = 35040;
const $8725869b83961a04$export$415731dc4f48e299 = 35045;
const $8725869b83961a04$export$9e809946455f13bc = 35049;
const $8725869b83961a04$export$2ed9499a35b5f832 = 35041;
const $8725869b83961a04$export$32ab2503ea19469a = 35046;
const $8725869b83961a04$export$ab4022c2c3f86315 = 35050;
const $8725869b83961a04$export$ba7f1db36a76a970 = 35042;
const $8725869b83961a04$export$43600cc67fabd9f = "100";
const $8725869b83961a04$export$f63012db5506e7dd = "300 es";
const $8725869b83961a04$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $8725869b83961a04$export$5a0e9190d10875d3 = 2000;
const $8725869b83961a04$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $8725869b83961a04$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $8725869b83961a04$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $8725869b83961a04$var$_seed = 1234567;
const $8725869b83961a04$var$DEG2RAD = Math.PI / 180;
const $8725869b83961a04$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $8725869b83961a04$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $8725869b83961a04$var$_lut[d0 & 0xff] + $8725869b83961a04$var$_lut[d0 >> 8 & 0xff] + $8725869b83961a04$var$_lut[d0 >> 16 & 0xff] + $8725869b83961a04$var$_lut[d0 >> 24 & 0xff] + "-" + $8725869b83961a04$var$_lut[d1 & 0xff] + $8725869b83961a04$var$_lut[d1 >> 8 & 0xff] + "-" + $8725869b83961a04$var$_lut[d1 >> 16 & 0x0f | 0x40] + $8725869b83961a04$var$_lut[d1 >> 24 & 0xff] + "-" + $8725869b83961a04$var$_lut[d2 & 0x3f | 0x80] + $8725869b83961a04$var$_lut[d2 >> 8 & 0xff] + "-" + $8725869b83961a04$var$_lut[d2 >> 16 & 0xff] + $8725869b83961a04$var$_lut[d2 >> 24 & 0xff] + $8725869b83961a04$var$_lut[d3 & 0xff] + $8725869b83961a04$var$_lut[d3 >> 8 & 0xff] + $8725869b83961a04$var$_lut[d3 >> 16 & 0xff] + $8725869b83961a04$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $8725869b83961a04$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $8725869b83961a04$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $8725869b83961a04$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $8725869b83961a04$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $8725869b83961a04$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $8725869b83961a04$var$damp(x, y, lambda, dt) {
    return $8725869b83961a04$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $8725869b83961a04$var$pingpong(x, length = 1) {
    return length - Math.abs($8725869b83961a04$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $8725869b83961a04$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $8725869b83961a04$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $8725869b83961a04$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $8725869b83961a04$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $8725869b83961a04$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $8725869b83961a04$var$seededRandom(s) {
    if (s !== undefined) $8725869b83961a04$var$_seed = s;
    // Mulberry32 generator
    let t = $8725869b83961a04$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $8725869b83961a04$var$degToRad(degrees) {
    return degrees * $8725869b83961a04$var$DEG2RAD;
}
function $8725869b83961a04$var$radToDeg(radians) {
    return radians * $8725869b83961a04$var$RAD2DEG;
}
function $8725869b83961a04$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $8725869b83961a04$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $8725869b83961a04$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $8725869b83961a04$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $8725869b83961a04$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $8725869b83961a04$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $8725869b83961a04$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $8725869b83961a04$var$DEG2RAD,
    RAD2DEG: $8725869b83961a04$var$RAD2DEG,
    generateUUID: $8725869b83961a04$var$generateUUID,
    clamp: $8725869b83961a04$var$clamp,
    euclideanModulo: $8725869b83961a04$var$euclideanModulo,
    mapLinear: $8725869b83961a04$var$mapLinear,
    inverseLerp: $8725869b83961a04$var$inverseLerp,
    lerp: $8725869b83961a04$var$lerp,
    damp: $8725869b83961a04$var$damp,
    pingpong: $8725869b83961a04$var$pingpong,
    smoothstep: $8725869b83961a04$var$smoothstep,
    smootherstep: $8725869b83961a04$var$smootherstep,
    randInt: $8725869b83961a04$var$randInt,
    randFloat: $8725869b83961a04$var$randFloat,
    randFloatSpread: $8725869b83961a04$var$randFloatSpread,
    seededRandom: $8725869b83961a04$var$seededRandom,
    degToRad: $8725869b83961a04$var$degToRad,
    radToDeg: $8725869b83961a04$var$radToDeg,
    isPowerOfTwo: $8725869b83961a04$var$isPowerOfTwo,
    ceilPowerOfTwo: $8725869b83961a04$var$ceilPowerOfTwo,
    floorPowerOfTwo: $8725869b83961a04$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $8725869b83961a04$var$setQuaternionFromProperEuler,
    normalize: $8725869b83961a04$var$normalize,
    denormalize: $8725869b83961a04$var$denormalize
};
class $8725869b83961a04$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $8725869b83961a04$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($8725869b83961a04$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $8725869b83961a04$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $8725869b83961a04$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($8725869b83961a04$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($8725869b83961a04$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($8725869b83961a04$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $8725869b83961a04$var$_m3 = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918();
function $8725869b83961a04$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $8725869b83961a04$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $8725869b83961a04$var$getTypedArray(type, buffer) {
    return new $8725869b83961a04$var$TYPED_ARRAYS[type](buffer);
}
function $8725869b83961a04$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $8725869b83961a04$var$_cache = {};
function $8725869b83961a04$var$warnOnce(message) {
    if (message in $8725869b83961a04$var$_cache) return;
    $8725869b83961a04$var$_cache[message] = true;
    console.warn(message);
}
function $8725869b83961a04$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $8725869b83961a04$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $8725869b83961a04$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $8725869b83961a04$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $8725869b83961a04$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($8725869b83961a04$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $8725869b83961a04$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($8725869b83961a04$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $8725869b83961a04$var$TO_LINEAR = {
    [$8725869b83961a04$export$42429b3acfb233a4]: (color)=>color,
    [$8725869b83961a04$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$8725869b83961a04$export$626af19ae879bdf6]: $8725869b83961a04$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $8725869b83961a04$var$FROM_LINEAR = {
    [$8725869b83961a04$export$42429b3acfb233a4]: (color)=>color,
    [$8725869b83961a04$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$8725869b83961a04$export$626af19ae879bdf6]: $8725869b83961a04$var$LinearSRGBToDisplayP3
};
const $8725869b83961a04$export$5e6fd513f44698c = {
    enabled: true,
    get legacyMode () {
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $8725869b83961a04$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $8725869b83961a04$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $8725869b83961a04$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $8725869b83961a04$var$_canvas;
class $8725869b83961a04$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($8725869b83961a04$var$_canvas === undefined) $8725869b83961a04$var$_canvas = $8725869b83961a04$var$createElementNS("canvas");
            $8725869b83961a04$var$_canvas.width = image.width;
            $8725869b83961a04$var$_canvas.height = image.height;
            const context = $8725869b83961a04$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $8725869b83961a04$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $8725869b83961a04$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $8725869b83961a04$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($8725869b83961a04$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $8725869b83961a04$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $8725869b83961a04$var$sourceId = 0;
class $8725869b83961a04$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, "id", {
            value: $8725869b83961a04$var$sourceId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($8725869b83961a04$var$serializeImage(data[i].image));
                else url.push($8725869b83961a04$var$serializeImage(data[i]));
            } else // texture
            url = $8725869b83961a04$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $8725869b83961a04$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $8725869b83961a04$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $8725869b83961a04$var$textureId = 0;
class $8725869b83961a04$export$5431306cf43de24a extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(image = $8725869b83961a04$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $8725869b83961a04$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $8725869b83961a04$export$9d9334239a5a5e06, wrapT = $8725869b83961a04$export$9d9334239a5a5e06, magFilter = $8725869b83961a04$export$8a72f490b25c56c8, minFilter = $8725869b83961a04$export$5d8599b6a933fb1b, format = $8725869b83961a04$export$3f8bb04b555a363c, type = $8725869b83961a04$export$2e8ce08d3f6f5e10, anisotropy = $8725869b83961a04$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $8725869b83961a04$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $8725869b83961a04$var$textureId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = "";
        this.source = new $8725869b83961a04$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $8725869b83961a04$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.center = new $8725869b83961a04$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $8725869b83961a04$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === "string") this.colorSpace = colorSpace1;
        else {
            $8725869b83961a04$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
            this.colorSpace = colorSpace1 === $8725869b83961a04$export$f32388edbb32674 ? $8725869b83961a04$export$561f394b24edfcaa : $8725869b83961a04$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $8725869b83961a04$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $8725869b83961a04$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $8725869b83961a04$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $8725869b83961a04$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $8725869b83961a04$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $8725869b83961a04$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $8725869b83961a04$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $8725869b83961a04$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        return this.colorSpace === $8725869b83961a04$export$561f394b24edfcaa ? $8725869b83961a04$export$f32388edbb32674 : $8725869b83961a04$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $8725869b83961a04$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        this.colorSpace = encoding === $8725869b83961a04$export$f32388edbb32674 ? $8725869b83961a04$export$561f394b24edfcaa : $8725869b83961a04$export$bfcb490c2dd3db51;
    }
}
$8725869b83961a04$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$8725869b83961a04$export$5431306cf43de24a.DEFAULT_MAPPING = $8725869b83961a04$export$1beec6768cbb3d2d;
$8725869b83961a04$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $8725869b83961a04$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $8725869b83961a04$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $8725869b83961a04$export$3c052beb2e51e23f extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $8725869b83961a04$var$warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $8725869b83961a04$export$f32388edbb32674 ? $8725869b83961a04$export$561f394b24edfcaa : $8725869b83961a04$export$bfcb490c2dd3db51;
        }
        this.texture = new $8725869b83961a04$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $8725869b83961a04$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $8725869b83961a04$export$dfac6c8e811406a3 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.wrapR = $8725869b83961a04$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $8725869b83961a04$export$c77a02c11ed180c7 extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $8725869b83961a04$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $8725869b83961a04$export$d7a3086320f856db extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.wrapR = $8725869b83961a04$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $8725869b83961a04$export$7ee06591009639df extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $8725869b83961a04$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $8725869b83961a04$export$bd934554fb721730 extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $8725869b83961a04$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($8725869b83961a04$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $8725869b83961a04$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $8725869b83961a04$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($8725869b83961a04$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($8725869b83961a04$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $8725869b83961a04$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($8725869b83961a04$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($8725869b83961a04$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($8725869b83961a04$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $8725869b83961a04$var$_vector$b = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion$4 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
class $8725869b83961a04$export$6f7d5a9418ab2aa3 {
    constructor(min = new $8725869b83961a04$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $8725869b83961a04$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($8725869b83961a04$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($8725869b83961a04$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $8725869b83961a04$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $8725869b83961a04$var$_box$3.copy(object.boundingBox);
            $8725869b83961a04$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($8725869b83961a04$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $8725869b83961a04$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($8725869b83961a04$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $8725869b83961a04$var$_box$3.copy(geometry.boundingBox);
                    $8725869b83961a04$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($8725869b83961a04$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $8725869b83961a04$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $8725869b83961a04$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($8725869b83961a04$var$_center);
        $8725869b83961a04$var$_extents.subVectors(this.max, $8725869b83961a04$var$_center);
        // translate triangle to aabb origin
        $8725869b83961a04$var$_v0$2.subVectors(triangle.a, $8725869b83961a04$var$_center);
        $8725869b83961a04$var$_v1$7.subVectors(triangle.b, $8725869b83961a04$var$_center);
        $8725869b83961a04$var$_v2$4.subVectors(triangle.c, $8725869b83961a04$var$_center);
        // compute edge vectors for triangle
        $8725869b83961a04$var$_f0.subVectors($8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v0$2);
        $8725869b83961a04$var$_f1.subVectors($8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_v1$7);
        $8725869b83961a04$var$_f2.subVectors($8725869b83961a04$var$_v0$2, $8725869b83961a04$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$8725869b83961a04$var$_f0.z,
            $8725869b83961a04$var$_f0.y,
            0,
            -$8725869b83961a04$var$_f1.z,
            $8725869b83961a04$var$_f1.y,
            0,
            -$8725869b83961a04$var$_f2.z,
            $8725869b83961a04$var$_f2.y,
            $8725869b83961a04$var$_f0.z,
            0,
            -$8725869b83961a04$var$_f0.x,
            $8725869b83961a04$var$_f1.z,
            0,
            -$8725869b83961a04$var$_f1.x,
            $8725869b83961a04$var$_f2.z,
            0,
            -$8725869b83961a04$var$_f2.x,
            -$8725869b83961a04$var$_f0.y,
            $8725869b83961a04$var$_f0.x,
            0,
            -$8725869b83961a04$var$_f1.y,
            $8725869b83961a04$var$_f1.x,
            0,
            -$8725869b83961a04$var$_f2.y,
            $8725869b83961a04$var$_f2.x,
            0
        ];
        if (!$8725869b83961a04$var$satForAxes(axes, $8725869b83961a04$var$_v0$2, $8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$8725869b83961a04$var$satForAxes(axes, $8725869b83961a04$var$_v0$2, $8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $8725869b83961a04$var$_triangleNormal.crossVectors($8725869b83961a04$var$_f0, $8725869b83961a04$var$_f1);
        axes = [
            $8725869b83961a04$var$_triangleNormal.x,
            $8725869b83961a04$var$_triangleNormal.y,
            $8725869b83961a04$var$_triangleNormal.z
        ];
        return $8725869b83961a04$var$satForAxes(axes, $8725869b83961a04$var$_v0$2, $8725869b83961a04$var$_v1$7, $8725869b83961a04$var$_v2$4, $8725869b83961a04$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $8725869b83961a04$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($8725869b83961a04$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $8725869b83961a04$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $8725869b83961a04$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $8725869b83961a04$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $8725869b83961a04$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $8725869b83961a04$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $8725869b83961a04$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $8725869b83961a04$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $8725869b83961a04$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($8725869b83961a04$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $8725869b83961a04$var$_points = [
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699()
];
const $8725869b83961a04$var$_vector$a = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_box$3 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $8725869b83961a04$var$_v0$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v1$7 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$4 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
// triangle edge vectors
const $8725869b83961a04$var$_f0 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_f1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_f2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_center = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_extents = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_triangleNormal = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_testAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
function $8725869b83961a04$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $8725869b83961a04$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($8725869b83961a04$var$_testAxis.x) + extents.y * Math.abs($8725869b83961a04$var$_testAxis.y) + extents.z * Math.abs($8725869b83961a04$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($8725869b83961a04$var$_testAxis);
        const p1 = v1.dot($8725869b83961a04$var$_testAxis);
        const p2 = v2.dot($8725869b83961a04$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $8725869b83961a04$var$_box$2 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_v1$6 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$805e8b72413ccaba {
    constructor(center = new $8725869b83961a04$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $8725869b83961a04$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $8725869b83961a04$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $8725869b83961a04$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($8725869b83961a04$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $8725869b83961a04$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($8725869b83961a04$var$_v1$6.copy(sphere.center).add($8725869b83961a04$var$_v2$3));
            this.expandByPoint($8725869b83961a04$var$_v1$6.copy(sphere.center).sub($8725869b83961a04$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_vector$9 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_segCenter = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_segDir = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_diff = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_edge1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_edge2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normal$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$a186db52eed6d40e {
    constructor(origin = new $8725869b83961a04$export$64b5c384219d3699(), direction = new $8725869b83961a04$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $8725869b83961a04$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $8725869b83961a04$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $8725869b83961a04$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $8725869b83961a04$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $8725869b83961a04$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $8725869b83961a04$var$_segDir.copy(v1).sub(v0).normalize();
        $8725869b83961a04$var$_diff.copy(this.origin).sub($8725869b83961a04$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($8725869b83961a04$var$_segDir);
        const b0 = $8725869b83961a04$var$_diff.dot(this.direction);
        const b1 = -$8725869b83961a04$var$_diff.dot($8725869b83961a04$var$_segDir);
        const c = $8725869b83961a04$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($8725869b83961a04$var$_segCenter).addScaledVector($8725869b83961a04$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $8725869b83961a04$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $8725869b83961a04$var$_vector$9.dot(this.direction);
        const d2 = $8725869b83961a04$var$_vector$9.dot($8725869b83961a04$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $8725869b83961a04$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $8725869b83961a04$var$_edge1.subVectors(b, a);
        $8725869b83961a04$var$_edge2.subVectors(c, a);
        $8725869b83961a04$var$_normal$1.crossVectors($8725869b83961a04$var$_edge1, $8725869b83961a04$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($8725869b83961a04$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $8725869b83961a04$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($8725869b83961a04$var$_edge2.crossVectors($8725869b83961a04$var$_diff, $8725869b83961a04$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($8725869b83961a04$var$_edge1.cross($8725869b83961a04$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $8725869b83961a04$var$_diff.dot($8725869b83961a04$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $8725869b83961a04$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $8725869b83961a04$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $8725869b83961a04$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $8725869b83961a04$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $8725869b83961a04$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $8725869b83961a04$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($8725869b83961a04$var$_zero, q, $8725869b83961a04$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $8725869b83961a04$var$_z.subVectors(eye, target);
        if ($8725869b83961a04$var$_z.lengthSq() === 0) // eye and target are in the same position
        $8725869b83961a04$var$_z.z = 1;
        $8725869b83961a04$var$_z.normalize();
        $8725869b83961a04$var$_x.crossVectors(up, $8725869b83961a04$var$_z);
        if ($8725869b83961a04$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $8725869b83961a04$var$_z.x += 0.0001;
            else $8725869b83961a04$var$_z.z += 0.0001;
            $8725869b83961a04$var$_z.normalize();
            $8725869b83961a04$var$_x.crossVectors(up, $8725869b83961a04$var$_z);
        }
        $8725869b83961a04$var$_x.normalize();
        $8725869b83961a04$var$_y.crossVectors($8725869b83961a04$var$_z, $8725869b83961a04$var$_x);
        te[0] = $8725869b83961a04$var$_x.x;
        te[4] = $8725869b83961a04$var$_y.x;
        te[8] = $8725869b83961a04$var$_z.x;
        te[1] = $8725869b83961a04$var$_x.y;
        te[5] = $8725869b83961a04$var$_y.y;
        te[9] = $8725869b83961a04$var$_z.y;
        te[2] = $8725869b83961a04$var$_x.z;
        te[6] = $8725869b83961a04$var$_y.z;
        te[10] = $8725869b83961a04$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $8725869b83961a04$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $8725869b83961a04$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $8725869b83961a04$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $8725869b83961a04$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $8725869b83961a04$var$_m1$2.elements[0] *= invSX;
        $8725869b83961a04$var$_m1$2.elements[1] *= invSX;
        $8725869b83961a04$var$_m1$2.elements[2] *= invSX;
        $8725869b83961a04$var$_m1$2.elements[4] *= invSY;
        $8725869b83961a04$var$_m1$2.elements[5] *= invSY;
        $8725869b83961a04$var$_m1$2.elements[6] *= invSY;
        $8725869b83961a04$var$_m1$2.elements[8] *= invSZ;
        $8725869b83961a04$var$_m1$2.elements[9] *= invSZ;
        $8725869b83961a04$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($8725869b83961a04$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $8725869b83961a04$var$_v1$5 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_m1$2 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_zero = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 0, 0);
const $8725869b83961a04$var$_one = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1);
const $8725869b83961a04$var$_x = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_y = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_z = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_matrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_quaternion$3 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
class $8725869b83961a04$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $8725869b83961a04$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($8725869b83961a04$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$8725869b83961a04$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($8725869b83961a04$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$8725869b83961a04$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($8725869b83961a04$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$8725869b83961a04$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $8725869b83961a04$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($8725869b83961a04$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $8725869b83961a04$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($8725869b83961a04$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$8725869b83961a04$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $8725869b83961a04$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $8725869b83961a04$var$_object3DId = 0;
const $8725869b83961a04$var$_v1$4 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_q1 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_m1$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_target = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_position$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_scale$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion$2 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_xAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 0, 0);
const $8725869b83961a04$var$_yAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0);
const $8725869b83961a04$var$_zAxis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1);
const $8725869b83961a04$var$_addedEvent = {
    type: "added"
};
const $8725869b83961a04$var$_removedEvent = {
    type: "removed"
};
class $8725869b83961a04$export$e4dd07dff30cc924 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $8725869b83961a04$var$_object3DId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $8725869b83961a04$export$64b5c384219d3699();
        const rotation = new $8725869b83961a04$export$d93cc409a0768c5f();
        const quaternion = new $8725869b83961a04$export$23d6a54f0bbc85a3();
        const scale = new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $8725869b83961a04$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $8725869b83961a04$export$8ff26dafa08918()
            }
        });
        this.matrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.matrixWorld = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $8725869b83961a04$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $8725869b83961a04$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($8725869b83961a04$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $8725869b83961a04$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($8725869b83961a04$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($8725869b83961a04$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($8725869b83961a04$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($8725869b83961a04$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $8725869b83961a04$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($8725869b83961a04$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($8725869b83961a04$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($8725869b83961a04$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($8725869b83961a04$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($8725869b83961a04$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $8725869b83961a04$var$_target.copy(x);
        else $8725869b83961a04$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $8725869b83961a04$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $8725869b83961a04$var$_m1$1.lookAt($8725869b83961a04$var$_position$3, $8725869b83961a04$var$_target, this.up);
        else $8725869b83961a04$var$_m1$1.lookAt($8725869b83961a04$var$_target, $8725869b83961a04$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($8725869b83961a04$var$_m1$1);
        if (parent) {
            $8725869b83961a04$var$_m1$1.extractRotation(parent.matrixWorld);
            $8725869b83961a04$var$_q1.setFromRotationMatrix($8725869b83961a04$var$_m1$1);
            this.quaternion.premultiply($8725869b83961a04$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($8725869b83961a04$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($8725869b83961a04$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($8725869b83961a04$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $8725869b83961a04$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $8725869b83961a04$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($8725869b83961a04$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($8725869b83961a04$var$_position$3, target, $8725869b83961a04$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($8725869b83961a04$var$_position$3, $8725869b83961a04$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0);
$8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $8725869b83961a04$var$_v0$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v1$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v3$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vab = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vac = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vbc = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vap = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vbp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vcp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
let $8725869b83961a04$var$warnedGetUV = false;
class $8725869b83961a04$export$5a465592bfe74b48 {
    constructor(a = new $8725869b83961a04$export$64b5c384219d3699(), b = new $8725869b83961a04$export$64b5c384219d3699(), c = new $8725869b83961a04$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $8725869b83961a04$var$_v0$1.subVectors(a, b);
        target.cross($8725869b83961a04$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $8725869b83961a04$var$_v0$1.subVectors(c, a);
        $8725869b83961a04$var$_v1$3.subVectors(b, a);
        $8725869b83961a04$var$_v2$2.subVectors(point, a);
        const dot00 = $8725869b83961a04$var$_v0$1.dot($8725869b83961a04$var$_v0$1);
        const dot01 = $8725869b83961a04$var$_v0$1.dot($8725869b83961a04$var$_v1$3);
        const dot02 = $8725869b83961a04$var$_v0$1.dot($8725869b83961a04$var$_v2$2);
        const dot11 = $8725869b83961a04$var$_v1$3.dot($8725869b83961a04$var$_v1$3);
        const dot12 = $8725869b83961a04$var$_v1$3.dot($8725869b83961a04$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $8725869b83961a04$var$_v3$1);
        return $8725869b83961a04$var$_v3$1.x >= 0 && $8725869b83961a04$var$_v3$1.y >= 0 && $8725869b83961a04$var$_v3$1.x + $8725869b83961a04$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($8725869b83961a04$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $8725869b83961a04$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $8725869b83961a04$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $8725869b83961a04$var$_v3$1.x);
        target.addScaledVector(v2, $8725869b83961a04$var$_v3$1.y);
        target.addScaledVector(v3, $8725869b83961a04$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $8725869b83961a04$var$_v0$1.subVectors(c, b);
        $8725869b83961a04$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $8725869b83961a04$var$_v0$1.cross($8725869b83961a04$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $8725869b83961a04$var$_v0$1.subVectors(this.c, this.b);
        $8725869b83961a04$var$_v1$3.subVectors(this.a, this.b);
        return $8725869b83961a04$var$_v0$1.cross($8725869b83961a04$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $8725869b83961a04$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $8725869b83961a04$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($8725869b83961a04$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $8725869b83961a04$var$warnedGetUV = true;
        }
        return $8725869b83961a04$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $8725869b83961a04$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $8725869b83961a04$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $8725869b83961a04$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $8725869b83961a04$var$_vab.subVectors(b, a);
        $8725869b83961a04$var$_vac.subVectors(c, a);
        $8725869b83961a04$var$_vap.subVectors(p, a);
        const d1 = $8725869b83961a04$var$_vab.dot($8725869b83961a04$var$_vap);
        const d2 = $8725869b83961a04$var$_vac.dot($8725869b83961a04$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $8725869b83961a04$var$_vbp.subVectors(p, b);
        const d3 = $8725869b83961a04$var$_vab.dot($8725869b83961a04$var$_vbp);
        const d4 = $8725869b83961a04$var$_vac.dot($8725869b83961a04$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($8725869b83961a04$var$_vab, v);
        }
        $8725869b83961a04$var$_vcp.subVectors(p, c);
        const d5 = $8725869b83961a04$var$_vab.dot($8725869b83961a04$var$_vcp);
        const d6 = $8725869b83961a04$var$_vac.dot($8725869b83961a04$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($8725869b83961a04$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $8725869b83961a04$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($8725869b83961a04$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($8725869b83961a04$var$_vab, v).addScaledVector($8725869b83961a04$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $8725869b83961a04$var$materialId = 0;
class $8725869b83961a04$export$a2d8b23205c25948 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $8725869b83961a04$var$materialId++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $8725869b83961a04$export$5b29a26d96ee6af0;
        this.side = $8725869b83961a04$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $8725869b83961a04$export$d5773124e86cf28c;
        this.blendDst = $8725869b83961a04$export$11d468cc7f19e971;
        this.blendEquation = $8725869b83961a04$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $8725869b83961a04$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $8725869b83961a04$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $8725869b83961a04$export$9f542ae4b5baca34;
        this.stencilZFail = $8725869b83961a04$export$9f542ae4b5baca34;
        this.stencilZPass = $8725869b83961a04$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $8725869b83961a04$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $8725869b83961a04$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $8725869b83961a04$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $8725869b83961a04$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $8725869b83961a04$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $8725869b83961a04$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $8725869b83961a04$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === "number") this.setHex(value);
            else if (typeof value === "string") this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $8725869b83961a04$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $8725869b83961a04$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $8725869b83961a04$var$euclideanModulo(h, 1);
        s = $8725869b83961a04$var$clamp(s, 0, 1);
        l = $8725869b83961a04$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $8725869b83961a04$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $8725869b83961a04$var$hue2rgb(q, p, h);
            this.b = $8725869b83961a04$var$hue2rgb(q, p, h - 1 / 3);
        }
        $8725869b83961a04$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        // color keywords
        const hex = $8725869b83961a04$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $8725869b83961a04$var$SRGBToLinear(color.r);
        this.g = $8725869b83961a04$var$SRGBToLinear(color.g);
        this.b = $8725869b83961a04$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $8725869b83961a04$var$LinearToSRGB(color.r);
        this.g = $8725869b83961a04$var$LinearToSRGB(color.g);
        this.b = $8725869b83961a04$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        return Math.round($8725869b83961a04$var$clamp($8725869b83961a04$var$_color.r * 255, 0, 255)) * 65536 + Math.round($8725869b83961a04$var$clamp($8725869b83961a04$var$_color.g * 255, 0, 255)) * 256 + Math.round($8725869b83961a04$var$clamp($8725869b83961a04$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        const r = $8725869b83961a04$var$_color.r, g = $8725869b83961a04$var$_color.g, b = $8725869b83961a04$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $8725869b83961a04$export$5e6fd513f44698c.workingColorSpace) {
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        target.r = $8725869b83961a04$var$_color.r;
        target.g = $8725869b83961a04$var$_color.g;
        target.b = $8725869b83961a04$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $8725869b83961a04$export$561f394b24edfcaa) {
        $8725869b83961a04$export$5e6fd513f44698c.fromWorkingColorSpace($8725869b83961a04$var$_color.copy(this), colorSpace1);
        const r = $8725869b83961a04$var$_color.r, g = $8725869b83961a04$var$_color.g, b = $8725869b83961a04$var$_color.b;
        if (colorSpace1 !== $8725869b83961a04$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($8725869b83961a04$var$_hslA);
        $8725869b83961a04$var$_hslA.h += h;
        $8725869b83961a04$var$_hslA.s += s;
        $8725869b83961a04$var$_hslA.l += l;
        this.setHSL($8725869b83961a04$var$_hslA.h, $8725869b83961a04$var$_hslA.s, $8725869b83961a04$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($8725869b83961a04$var$_hslA);
        color.getHSL($8725869b83961a04$var$_hslB);
        const h = $8725869b83961a04$var$lerp($8725869b83961a04$var$_hslA.h, $8725869b83961a04$var$_hslB.h, alpha);
        const s = $8725869b83961a04$var$lerp($8725869b83961a04$var$_hslA.s, $8725869b83961a04$var$_hslB.s, alpha);
        const l = $8725869b83961a04$var$lerp($8725869b83961a04$var$_hslA.l, $8725869b83961a04$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $8725869b83961a04$var$_color = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
$8725869b83961a04$export$892596cec99bc70e.NAMES = $8725869b83961a04$var$_colorKeywords;
class $8725869b83961a04$export$55cbcc9b622fe1f5 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $8725869b83961a04$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $8725869b83961a04$var$_tables = /*@__PURE__*/ $8725869b83961a04$var$_generateTables();
function $8725869b83961a04$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $8725869b83961a04$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $8725869b83961a04$var$clamp(val, -65504, 65504);
    $8725869b83961a04$var$_tables.floatView[0] = val;
    const f = $8725869b83961a04$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $8725869b83961a04$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $8725869b83961a04$var$_tables.shiftTable[e]);
}
// float16 to float32
function $8725869b83961a04$var$fromHalfFloat(val) {
    const m = val >> 10;
    $8725869b83961a04$var$_tables.uint32View[0] = $8725869b83961a04$var$_tables.mantissaTable[$8725869b83961a04$var$_tables.offsetTable[m] + (val & 0x3ff)] + $8725869b83961a04$var$_tables.exponentTable[m];
    return $8725869b83961a04$var$_tables.floatView[0];
}
const $8725869b83961a04$export$11ce8b759162cc80 = {
    toHalfFloat: $8725869b83961a04$var$toHalfFloat,
    fromHalfFloat: $8725869b83961a04$var$fromHalfFloat
};
const $8725869b83961a04$var$_vector$8 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vector2$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $8725869b83961a04$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $8725869b83961a04$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector2$1.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $8725869b83961a04$var$_vector2$1.x, $8725869b83961a04$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$8.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$8.x, $8725869b83961a04$var$_vector$8.y, $8725869b83961a04$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$8.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$8.x, $8725869b83961a04$var$_vector$8.y, $8725869b83961a04$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$8.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$8.x, $8725869b83961a04$var$_vector$8.y, $8725869b83961a04$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$8.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$8.x, $8725869b83961a04$var$_vector$8.y, $8725869b83961a04$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $8725869b83961a04$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $8725869b83961a04$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $8725869b83961a04$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $8725869b83961a04$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $8725869b83961a04$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $8725869b83961a04$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $8725869b83961a04$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $8725869b83961a04$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
            w = $8725869b83961a04$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $8725869b83961a04$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
}
//
class $8725869b83961a04$export$f9ff2d6a20248cbf extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$cacc90cf35d11cdd extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$baaa85a1a812c157 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$2b755a102ccdcefe extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$640a853f68025f2e extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$46b369aed2968a0a extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$7eb8c9fa25cd5bd6 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$dbd3698c64958d69 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $8725869b83961a04$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $8725869b83961a04$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $8725869b83961a04$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $8725869b83961a04$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $8725869b83961a04$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $8725869b83961a04$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $8725869b83961a04$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $8725869b83961a04$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $8725869b83961a04$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $8725869b83961a04$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $8725869b83961a04$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $8725869b83961a04$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $8725869b83961a04$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
        }
        this.array[index + 0] = $8725869b83961a04$var$toHalfFloat(x);
        this.array[index + 1] = $8725869b83961a04$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
        }
        this.array[index + 0] = $8725869b83961a04$var$toHalfFloat(x);
        this.array[index + 1] = $8725869b83961a04$var$toHalfFloat(y);
        this.array[index + 2] = $8725869b83961a04$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
            w = $8725869b83961a04$var$normalize(w, this.array);
        }
        this.array[index + 0] = $8725869b83961a04$var$toHalfFloat(x);
        this.array[index + 1] = $8725869b83961a04$var$toHalfFloat(y);
        this.array[index + 2] = $8725869b83961a04$var$toHalfFloat(z);
        this.array[index + 3] = $8725869b83961a04$var$toHalfFloat(w);
        return this;
    }
}
class $8725869b83961a04$export$cbe7a62641830ebd extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $8725869b83961a04$export$9e0ade74842adbb8 extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $8725869b83961a04$var$_id$1 = 0;
const $8725869b83961a04$var$_m1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_obj = /*@__PURE__*/ new $8725869b83961a04$export$e4dd07dff30cc924();
const $8725869b83961a04$var$_offset = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_box$1 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_boxMorphTargets = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_vector$7 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$b7be63a67df8959 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $8725869b83961a04$var$_id$1++
        });
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($8725869b83961a04$var$arrayNeedsUint32(index) ? $8725869b83961a04$export$7eb8c9fa25cd5bd6 : $8725869b83961a04$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $8725869b83961a04$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $8725869b83961a04$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($8725869b83961a04$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $8725869b83961a04$var$_m1.makeRotationX(angle);
        this.applyMatrix4($8725869b83961a04$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $8725869b83961a04$var$_m1.makeRotationY(angle);
        this.applyMatrix4($8725869b83961a04$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $8725869b83961a04$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($8725869b83961a04$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $8725869b83961a04$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($8725869b83961a04$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $8725869b83961a04$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($8725869b83961a04$var$_m1);
        return this;
    }
    lookAt(vector) {
        $8725869b83961a04$var$_obj.lookAt(vector);
        $8725869b83961a04$var$_obj.updateMatrix();
        this.applyMatrix4($8725869b83961a04$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($8725869b83961a04$var$_offset).negate();
        this.translate($8725869b83961a04$var$_offset.x, $8725869b83961a04$var$_offset.y, $8725869b83961a04$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $8725869b83961a04$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $8725869b83961a04$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $8725869b83961a04$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $8725869b83961a04$var$_vector$7.addVectors(this.boundingBox.min, $8725869b83961a04$var$_box$1.min);
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_vector$7);
                    $8725869b83961a04$var$_vector$7.addVectors(this.boundingBox.max, $8725869b83961a04$var$_box$1.max);
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_box$1.min);
                    this.boundingBox.expandByPoint($8725869b83961a04$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $8725869b83961a04$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $8725869b83961a04$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $8725869b83961a04$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $8725869b83961a04$var$_vector$7.addVectors($8725869b83961a04$var$_box$1.min, $8725869b83961a04$var$_boxMorphTargets.min);
                    $8725869b83961a04$var$_box$1.expandByPoint($8725869b83961a04$var$_vector$7);
                    $8725869b83961a04$var$_vector$7.addVectors($8725869b83961a04$var$_box$1.max, $8725869b83961a04$var$_boxMorphTargets.max);
                    $8725869b83961a04$var$_box$1.expandByPoint($8725869b83961a04$var$_vector$7);
                } else {
                    $8725869b83961a04$var$_box$1.expandByPoint($8725869b83961a04$var$_boxMorphTargets.min);
                    $8725869b83961a04$var$_box$1.expandByPoint($8725869b83961a04$var$_boxMorphTargets.max);
                }
            }
            $8725869b83961a04$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $8725869b83961a04$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($8725869b83961a04$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $8725869b83961a04$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $8725869b83961a04$var$_offset.fromBufferAttribute(position, j);
                        $8725869b83961a04$var$_vector$7.add($8725869b83961a04$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($8725869b83961a04$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $8725869b83961a04$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $8725869b83961a04$export$64b5c384219d3699();
            tan2[i] = new $8725869b83961a04$export$64b5c384219d3699();
        }
        const vA = new $8725869b83961a04$export$64b5c384219d3699(), vB = new $8725869b83961a04$export$64b5c384219d3699(), vC = new $8725869b83961a04$export$64b5c384219d3699(), uvA = new $8725869b83961a04$export$c977b3e384af9ae1(), uvB = new $8725869b83961a04$export$c977b3e384af9ae1(), uvC = new $8725869b83961a04$export$c977b3e384af9ae1(), sdir = new $8725869b83961a04$export$64b5c384219d3699(), tdir = new $8725869b83961a04$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $8725869b83961a04$export$64b5c384219d3699(), tmp2 = new $8725869b83961a04$export$64b5c384219d3699();
        const n = new $8725869b83961a04$export$64b5c384219d3699(), n2 = new $8725869b83961a04$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $8725869b83961a04$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $8725869b83961a04$export$64b5c384219d3699(), pB = new $8725869b83961a04$export$64b5c384219d3699(), pC = new $8725869b83961a04$export$64b5c384219d3699();
            const nA = new $8725869b83961a04$export$64b5c384219d3699(), nB = new $8725869b83961a04$export$64b5c384219d3699(), nC = new $8725869b83961a04$export$64b5c384219d3699();
            const cb = new $8725869b83961a04$export$64b5c384219d3699(), ab = new $8725869b83961a04$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge() {
        console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeGeometries() instead.");
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $8725869b83961a04$var$_vector$7.fromBufferAttribute(normals, i);
            $8725869b83961a04$var$_vector$7.normalize();
            normals.setXYZ(i, $8725869b83961a04$var$_vector$7.x, $8725869b83961a04$var$_vector$7.y, $8725869b83961a04$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $8725869b83961a04$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $8725869b83961a04$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $8725869b83961a04$var$_inverseMatrix$3 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray$3 = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
const $8725869b83961a04$var$_sphere$5 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_sphereHitAt = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vA$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vB$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vC$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_tempA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_morphA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_uvA$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvB$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvC$1 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_normalA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normalB = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normalC = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_intersectionPoint = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_intersectionPointWorld = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$e176487c05830cc5 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(geometry = new $8725869b83961a04$export$b7be63a67df8959(), material = new $8725869b83961a04$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $8725869b83961a04$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $8725869b83961a04$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $8725869b83961a04$var$_morphA.addScaledVector($8725869b83961a04$var$_tempA, influence);
                else $8725869b83961a04$var$_morphA.addScaledVector($8725869b83961a04$var$_tempA.sub(target), influence);
            }
            target.add($8725869b83961a04$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$5.copy(geometry.boundingSphere);
        $8725869b83961a04$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $8725869b83961a04$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($8725869b83961a04$var$_sphere$5.containsPoint($8725869b83961a04$var$_ray$3.origin) === false) {
            if ($8725869b83961a04$var$_ray$3.intersectSphere($8725869b83961a04$var$_sphere$5, $8725869b83961a04$var$_sphereHitAt) === null) return;
            if ($8725869b83961a04$var$_ray$3.origin.distanceToSquared($8725869b83961a04$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $8725869b83961a04$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray$3.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($8725869b83961a04$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $8725869b83961a04$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $8725869b83961a04$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $8725869b83961a04$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $8725869b83961a04$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $8725869b83961a04$var$_intersectionPointWorld.copy(point);
    $8725869b83961a04$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $8725869b83961a04$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $8725869b83961a04$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $8725869b83961a04$var$_vA$1);
    object.getVertexPosition(b, $8725869b83961a04$var$_vB$1);
    object.getVertexPosition(c, $8725869b83961a04$var$_vC$1);
    const intersection = $8725869b83961a04$var$checkIntersection(object, material, raycaster, ray, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $8725869b83961a04$var$_uvA$1.fromBufferAttribute(uv, a);
            $8725869b83961a04$var$_uvB$1.fromBufferAttribute(uv, b);
            $8725869b83961a04$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectionPoint, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_uvA$1, $8725869b83961a04$var$_uvB$1, $8725869b83961a04$var$_uvC$1, new $8725869b83961a04$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $8725869b83961a04$var$_uvA$1.fromBufferAttribute(uv1, a);
            $8725869b83961a04$var$_uvB$1.fromBufferAttribute(uv1, b);
            $8725869b83961a04$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectionPoint, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_uvA$1, $8725869b83961a04$var$_uvB$1, $8725869b83961a04$var$_uvC$1, new $8725869b83961a04$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $8725869b83961a04$var$_normalA.fromBufferAttribute(normal, a);
            $8725869b83961a04$var$_normalB.fromBufferAttribute(normal, b);
            $8725869b83961a04$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectionPoint, $8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, $8725869b83961a04$var$_normalA, $8725869b83961a04$var$_normalB, $8725869b83961a04$var$_normalC, new $8725869b83961a04$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $8725869b83961a04$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $8725869b83961a04$export$5a465592bfe74b48.getNormal($8725869b83961a04$var$_vA$1, $8725869b83961a04$var$_vB$1, $8725869b83961a04$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $8725869b83961a04$export$33e43285f7406bd5 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $8725869b83961a04$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $8725869b83961a04$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $8725869b83961a04$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $8725869b83961a04$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $8725869b83961a04$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $8725869b83961a04$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $8725869b83961a04$export$42429b3acfb233a4;
}
// Legacy
const $8725869b83961a04$export$d8ecdf8615bfea69 = {
    clone: $8725869b83961a04$var$cloneUniforms,
    merge: $8725869b83961a04$var$mergeUniforms
};
var $8725869b83961a04$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $8725869b83961a04$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $8725869b83961a04$export$83c7d75d550a8b0d extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $8725869b83961a04$var$default_vertex;
        this.fragmentShader = $8725869b83961a04$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $8725869b83961a04$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $8725869b83961a04$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $8725869b83961a04$export$79f141de891a5fed extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $8725869b83961a04$export$74e4ae24825f68d7 extends $8725869b83961a04$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $8725869b83961a04$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($8725869b83961a04$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $8725869b83961a04$var$RAD2DEG * 2 * Math.atan(Math.tan($8725869b83961a04$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($8725869b83961a04$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $8725869b83961a04$var$fov = -90; // negative fov is not an error
const $8725869b83961a04$var$aspect = 1;
class $8725869b83961a04$export$d0cdd0bd804995de extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        const cameraPX = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $8725869b83961a04$export$74e4ae24825f68d7($8725869b83961a04$var$fov, $8725869b83961a04$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $8725869b83961a04$export$ee2e5a18258a4049 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $8725869b83961a04$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $8725869b83961a04$export$ac386671d651941e extends $8725869b83961a04$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $8725869b83961a04$var$warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $8725869b83961a04$export$f32388edbb32674 ? $8725869b83961a04$export$561f394b24edfcaa : $8725869b83961a04$export$bfcb490c2dd3db51;
        }
        this.texture = new $8725869b83961a04$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $8725869b83961a04$export$33e43285f7406bd5(5, 5, 5);
        const material = new $8725869b83961a04$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $8725869b83961a04$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $8725869b83961a04$export$d9f0486e75b5ace,
            blending: $8725869b83961a04$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $8725869b83961a04$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $8725869b83961a04$export$5d8599b6a933fb1b) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
        const camera = new $8725869b83961a04$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $8725869b83961a04$var$_vector1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vector2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normalMatrix = /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918();
class $8725869b83961a04$export$7ff5ac152ef991b0 {
    constructor(normal = new $8725869b83961a04$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $8725869b83961a04$var$_vector1.subVectors(c, b).cross($8725869b83961a04$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($8725869b83961a04$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $8725869b83961a04$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($8725869b83961a04$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_sphere$4 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_vector$6 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$35efe6f4c85463d2 {
    constructor(p0 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p1 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p2 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p3 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p4 = new $8725869b83961a04$export$7ff5ac152ef991b0(), p5 = new $8725869b83961a04$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $8725869b83961a04$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $8725869b83961a04$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $8725869b83961a04$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $8725869b83961a04$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $8725869b83961a04$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($8725869b83961a04$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $8725869b83961a04$var$_sphere$4.center.set(0, 0, 0);
        $8725869b83961a04$var$_sphere$4.radius = 0.7071067811865476;
        $8725869b83961a04$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($8725869b83961a04$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $8725869b83961a04$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $8725869b83961a04$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $8725869b83961a04$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($8725869b83961a04$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $8725869b83961a04$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $8725869b83961a04$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $8725869b83961a04$export$967d831af31f69ce extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $8725869b83961a04$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $8725869b83961a04$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $8725869b83961a04$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $8725869b83961a04$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $8725869b83961a04$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $8725869b83961a04$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $8725869b83961a04$var$begin_vertex = "vec3 transformed = vec3( position );";
var $8725869b83961a04$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $8725869b83961a04$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $8725869b83961a04$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			 return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float R21 = R12;\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $8725869b83961a04$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = dFdx( surf_pos.xyz );\n		vec3 vSigmaY = dFdy( surf_pos.xyz );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $8725869b83961a04$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $8725869b83961a04$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $8725869b83961a04$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $8725869b83961a04$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $8725869b83961a04$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $8725869b83961a04$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $8725869b83961a04$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $8725869b83961a04$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $8725869b83961a04$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $8725869b83961a04$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $8725869b83961a04$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $8725869b83961a04$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $8725869b83961a04$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $8725869b83961a04$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $8725869b83961a04$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $8725869b83961a04$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $8725869b83961a04$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $8725869b83961a04$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $8725869b83961a04$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $8725869b83961a04$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $8725869b83961a04$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $8725869b83961a04$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $8725869b83961a04$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $8725869b83961a04$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $8725869b83961a04$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $8725869b83961a04$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $8725869b83961a04$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $8725869b83961a04$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $8725869b83961a04$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $8725869b83961a04$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $8725869b83961a04$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $8725869b83961a04$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $8725869b83961a04$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var $8725869b83961a04$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $8725869b83961a04$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $8725869b83961a04$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $8725869b83961a04$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $8725869b83961a04$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $8725869b83961a04$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $8725869b83961a04$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometry.viewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $8725869b83961a04$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $8725869b83961a04$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $8725869b83961a04$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $8725869b83961a04$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $8725869b83961a04$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $8725869b83961a04$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $8725869b83961a04$var$map_fragment = "#ifdef USE_MAP\n	diffuseColor *= texture2D( map, vMapUv );\n#endif";
var $8725869b83961a04$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $8725869b83961a04$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $8725869b83961a04$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $8725869b83961a04$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $8725869b83961a04$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $8725869b83961a04$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $8725869b83961a04$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $8725869b83961a04$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $8725869b83961a04$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $8725869b83961a04$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $8725869b83961a04$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $8725869b83961a04$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $8725869b83961a04$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $8725869b83961a04$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $8725869b83961a04$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $8725869b83961a04$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $8725869b83961a04$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $8725869b83961a04$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $8725869b83961a04$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $8725869b83961a04$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $8725869b83961a04$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $8725869b83961a04$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $8725869b83961a04$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $8725869b83961a04$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $8725869b83961a04$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $8725869b83961a04$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $8725869b83961a04$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $8725869b83961a04$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $8725869b83961a04$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $8725869b83961a04$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $8725869b83961a04$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $8725869b83961a04$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $8725869b83961a04$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $8725869b83961a04$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $8725869b83961a04$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $8725869b83961a04$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $8725869b83961a04$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $8725869b83961a04$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $8725869b83961a04$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $8725869b83961a04$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $8725869b83961a04$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var $8725869b83961a04$var$uv_pars_fragment = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $8725869b83961a04$var$uv_pars_vertex = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $8725869b83961a04$var$uv_vertex = "#ifdef USE_UV\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $8725869b83961a04$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $8725869b83961a04$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $8725869b83961a04$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $8725869b83961a04$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $8725869b83961a04$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $8725869b83961a04$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $8725869b83961a04$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $8725869b83961a04$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $8725869b83961a04$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $8725869b83961a04$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $8725869b83961a04$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $8725869b83961a04$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $8725869b83961a04$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $8725869b83961a04$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $8725869b83961a04$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $8725869b83961a04$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $8725869b83961a04$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $8725869b83961a04$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $8725869b83961a04$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $8725869b83961a04$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $8725869b83961a04$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $8725869b83961a04$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $8725869b83961a04$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $8725869b83961a04$export$955f9f2e84c43c8b = {
    alphamap_fragment: $8725869b83961a04$var$alphamap_fragment,
    alphamap_pars_fragment: $8725869b83961a04$var$alphamap_pars_fragment,
    alphatest_fragment: $8725869b83961a04$var$alphatest_fragment,
    alphatest_pars_fragment: $8725869b83961a04$var$alphatest_pars_fragment,
    aomap_fragment: $8725869b83961a04$var$aomap_fragment,
    aomap_pars_fragment: $8725869b83961a04$var$aomap_pars_fragment,
    begin_vertex: $8725869b83961a04$var$begin_vertex,
    beginnormal_vertex: $8725869b83961a04$var$beginnormal_vertex,
    bsdfs: $8725869b83961a04$var$bsdfs,
    iridescence_fragment: $8725869b83961a04$var$iridescence_fragment,
    bumpmap_pars_fragment: $8725869b83961a04$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $8725869b83961a04$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $8725869b83961a04$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $8725869b83961a04$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $8725869b83961a04$var$clipping_planes_vertex,
    color_fragment: $8725869b83961a04$var$color_fragment,
    color_pars_fragment: $8725869b83961a04$var$color_pars_fragment,
    color_pars_vertex: $8725869b83961a04$var$color_pars_vertex,
    color_vertex: $8725869b83961a04$var$color_vertex,
    common: $8725869b83961a04$var$common,
    cube_uv_reflection_fragment: $8725869b83961a04$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $8725869b83961a04$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $8725869b83961a04$var$displacementmap_pars_vertex,
    displacementmap_vertex: $8725869b83961a04$var$displacementmap_vertex,
    emissivemap_fragment: $8725869b83961a04$var$emissivemap_fragment,
    emissivemap_pars_fragment: $8725869b83961a04$var$emissivemap_pars_fragment,
    encodings_fragment: $8725869b83961a04$var$encodings_fragment,
    encodings_pars_fragment: $8725869b83961a04$var$encodings_pars_fragment,
    envmap_fragment: $8725869b83961a04$var$envmap_fragment,
    envmap_common_pars_fragment: $8725869b83961a04$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $8725869b83961a04$var$envmap_pars_fragment,
    envmap_pars_vertex: $8725869b83961a04$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $8725869b83961a04$var$envmap_physical_pars_fragment,
    envmap_vertex: $8725869b83961a04$var$envmap_vertex,
    fog_vertex: $8725869b83961a04$var$fog_vertex,
    fog_pars_vertex: $8725869b83961a04$var$fog_pars_vertex,
    fog_fragment: $8725869b83961a04$var$fog_fragment,
    fog_pars_fragment: $8725869b83961a04$var$fog_pars_fragment,
    gradientmap_pars_fragment: $8725869b83961a04$var$gradientmap_pars_fragment,
    lightmap_fragment: $8725869b83961a04$var$lightmap_fragment,
    lightmap_pars_fragment: $8725869b83961a04$var$lightmap_pars_fragment,
    lights_lambert_fragment: $8725869b83961a04$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $8725869b83961a04$var$lights_lambert_pars_fragment,
    lights_pars_begin: $8725869b83961a04$var$lights_pars_begin,
    lights_toon_fragment: $8725869b83961a04$var$lights_toon_fragment,
    lights_toon_pars_fragment: $8725869b83961a04$var$lights_toon_pars_fragment,
    lights_phong_fragment: $8725869b83961a04$var$lights_phong_fragment,
    lights_phong_pars_fragment: $8725869b83961a04$var$lights_phong_pars_fragment,
    lights_physical_fragment: $8725869b83961a04$var$lights_physical_fragment,
    lights_physical_pars_fragment: $8725869b83961a04$var$lights_physical_pars_fragment,
    lights_fragment_begin: $8725869b83961a04$var$lights_fragment_begin,
    lights_fragment_maps: $8725869b83961a04$var$lights_fragment_maps,
    lights_fragment_end: $8725869b83961a04$var$lights_fragment_end,
    logdepthbuf_fragment: $8725869b83961a04$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $8725869b83961a04$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $8725869b83961a04$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $8725869b83961a04$var$logdepthbuf_vertex,
    map_fragment: $8725869b83961a04$var$map_fragment,
    map_pars_fragment: $8725869b83961a04$var$map_pars_fragment,
    map_particle_fragment: $8725869b83961a04$var$map_particle_fragment,
    map_particle_pars_fragment: $8725869b83961a04$var$map_particle_pars_fragment,
    metalnessmap_fragment: $8725869b83961a04$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $8725869b83961a04$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $8725869b83961a04$var$morphcolor_vertex,
    morphnormal_vertex: $8725869b83961a04$var$morphnormal_vertex,
    morphtarget_pars_vertex: $8725869b83961a04$var$morphtarget_pars_vertex,
    morphtarget_vertex: $8725869b83961a04$var$morphtarget_vertex,
    normal_fragment_begin: $8725869b83961a04$var$normal_fragment_begin,
    normal_fragment_maps: $8725869b83961a04$var$normal_fragment_maps,
    normal_pars_fragment: $8725869b83961a04$var$normal_pars_fragment,
    normal_pars_vertex: $8725869b83961a04$var$normal_pars_vertex,
    normal_vertex: $8725869b83961a04$var$normal_vertex,
    normalmap_pars_fragment: $8725869b83961a04$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $8725869b83961a04$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $8725869b83961a04$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $8725869b83961a04$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $8725869b83961a04$var$iridescence_pars_fragment,
    output_fragment: $8725869b83961a04$var$output_fragment,
    packing: $8725869b83961a04$var$packing,
    premultiplied_alpha_fragment: $8725869b83961a04$var$premultiplied_alpha_fragment,
    project_vertex: $8725869b83961a04$var$project_vertex,
    dithering_fragment: $8725869b83961a04$var$dithering_fragment,
    dithering_pars_fragment: $8725869b83961a04$var$dithering_pars_fragment,
    roughnessmap_fragment: $8725869b83961a04$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $8725869b83961a04$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $8725869b83961a04$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $8725869b83961a04$var$shadowmap_pars_vertex,
    shadowmap_vertex: $8725869b83961a04$var$shadowmap_vertex,
    shadowmask_pars_fragment: $8725869b83961a04$var$shadowmask_pars_fragment,
    skinbase_vertex: $8725869b83961a04$var$skinbase_vertex,
    skinning_pars_vertex: $8725869b83961a04$var$skinning_pars_vertex,
    skinning_vertex: $8725869b83961a04$var$skinning_vertex,
    skinnormal_vertex: $8725869b83961a04$var$skinnormal_vertex,
    specularmap_fragment: $8725869b83961a04$var$specularmap_fragment,
    specularmap_pars_fragment: $8725869b83961a04$var$specularmap_pars_fragment,
    tonemapping_fragment: $8725869b83961a04$var$tonemapping_fragment,
    tonemapping_pars_fragment: $8725869b83961a04$var$tonemapping_pars_fragment,
    transmission_fragment: $8725869b83961a04$var$transmission_fragment,
    transmission_pars_fragment: $8725869b83961a04$var$transmission_pars_fragment,
    uv_pars_fragment: $8725869b83961a04$var$uv_pars_fragment,
    uv_pars_vertex: $8725869b83961a04$var$uv_pars_vertex,
    uv_vertex: $8725869b83961a04$var$uv_vertex,
    worldpos_vertex: $8725869b83961a04$var$worldpos_vertex,
    background_vert: $8725869b83961a04$var$vertex$h,
    background_frag: $8725869b83961a04$var$fragment$h,
    backgroundCube_vert: $8725869b83961a04$var$vertex$g,
    backgroundCube_frag: $8725869b83961a04$var$fragment$g,
    cube_vert: $8725869b83961a04$var$vertex$f,
    cube_frag: $8725869b83961a04$var$fragment$f,
    depth_vert: $8725869b83961a04$var$vertex$e,
    depth_frag: $8725869b83961a04$var$fragment$e,
    distanceRGBA_vert: $8725869b83961a04$var$vertex$d,
    distanceRGBA_frag: $8725869b83961a04$var$fragment$d,
    equirect_vert: $8725869b83961a04$var$vertex$c,
    equirect_frag: $8725869b83961a04$var$fragment$c,
    linedashed_vert: $8725869b83961a04$var$vertex$b,
    linedashed_frag: $8725869b83961a04$var$fragment$b,
    meshbasic_vert: $8725869b83961a04$var$vertex$a,
    meshbasic_frag: $8725869b83961a04$var$fragment$a,
    meshlambert_vert: $8725869b83961a04$var$vertex$9,
    meshlambert_frag: $8725869b83961a04$var$fragment$9,
    meshmatcap_vert: $8725869b83961a04$var$vertex$8,
    meshmatcap_frag: $8725869b83961a04$var$fragment$8,
    meshnormal_vert: $8725869b83961a04$var$vertex$7,
    meshnormal_frag: $8725869b83961a04$var$fragment$7,
    meshphong_vert: $8725869b83961a04$var$vertex$6,
    meshphong_frag: $8725869b83961a04$var$fragment$6,
    meshphysical_vert: $8725869b83961a04$var$vertex$5,
    meshphysical_frag: $8725869b83961a04$var$fragment$5,
    meshtoon_vert: $8725869b83961a04$var$vertex$4,
    meshtoon_frag: $8725869b83961a04$var$fragment$4,
    points_vert: $8725869b83961a04$var$vertex$3,
    points_frag: $8725869b83961a04$var$fragment$3,
    shadow_vert: $8725869b83961a04$var$vertex$2,
    shadow_frag: $8725869b83961a04$var$fragment$2,
    sprite_vert: $8725869b83961a04$var$vertex$1,
    sprite_frag: $8725869b83961a04$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $8725869b83961a04$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $8725869b83961a04$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.specularmap,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.fog
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.specularmap,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.specularmap,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.envmap,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.roughnessmap,
            $8725869b83961a04$export$6643083551874bf5.metalnessmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.aomap,
            $8725869b83961a04$export$6643083551874bf5.lightmap,
            $8725869b83961a04$export$6643083551874bf5.emissivemap,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.gradientmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            $8725869b83961a04$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            $8725869b83961a04$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.points,
            $8725869b83961a04$export$6643083551874bf5.fog
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.bumpmap,
            $8725869b83961a04$export$6643083551874bf5.normalmap,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.sprite,
            $8725869b83961a04$export$6643083551874bf5.fog
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.common,
            $8725869b83961a04$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
            $8725869b83961a04$export$6643083551874bf5.lights,
            $8725869b83961a04$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.shadow_frag
    }
};
$8725869b83961a04$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $8725869b83961a04$var$mergeUniforms([
        $8725869b83961a04$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $8725869b83961a04$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $8725869b83961a04$export$955f9f2e84c43c8b.meshphysical_frag
};
const $8725869b83961a04$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $8725869b83961a04$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const xr = renderer.xr;
        const environmentBlendMode = xr.getEnvironmentBlendMode();
        switch(environmentBlendMode){
            case "opaque":
                forceClear = true;
                break;
            case "additive":
                state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
                forceClear = true;
                break;
            case "alpha-blend":
                state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
                forceClear = true;
                break;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $8725869b83961a04$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$33e43285f7406bd5(1, 1, 1), new $8725869b83961a04$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $8725869b83961a04$var$cloneUniforms($8725869b83961a04$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $8725869b83961a04$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $8725869b83961a04$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $8725869b83961a04$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.colorSpace === $8725869b83961a04$export$561f394b24edfcaa ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$967d831af31f69ce(2, 2), new $8725869b83961a04$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $8725869b83961a04$var$cloneUniforms($8725869b83961a04$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $8725869b83961a04$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $8725869b83961a04$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $8725869b83961a04$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.colorSpace === $8725869b83961a04$export$561f394b24edfcaa ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($8725869b83961a04$var$_rgb, $8725869b83961a04$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($8725869b83961a04$var$_rgb.r, $8725869b83961a04$var$_rgb.g, $8725869b83961a04$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $8725869b83961a04$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $8725869b83961a04$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $8725869b83961a04$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $8725869b83961a04$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl.constructor.name === "WebGL2RenderingContext";
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $8725869b83961a04$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $8725869b83961a04$export$7ff5ac152ef991b0(), viewNormalMatrix = new $8725869b83961a04$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $8725869b83961a04$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $8725869b83961a04$export$d64030b316d3b087) texture.mapping = $8725869b83961a04$export$8759762a6477f2c4;
        else if (mapping === $8725869b83961a04$export$ee99d97d46898098) texture.mapping = $8725869b83961a04$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $8725869b83961a04$export$d64030b316d3b087 || mapping === $8725869b83961a04$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $8725869b83961a04$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $8725869b83961a04$export$9ebf355ee4ed261b extends $8725869b83961a04$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $8725869b83961a04$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $8725869b83961a04$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $8725869b83961a04$var$MAX_SAMPLES = 20;
const $8725869b83961a04$var$_flatCamera = /*@__PURE__*/ new $8725869b83961a04$export$9ebf355ee4ed261b();
const $8725869b83961a04$var$_clearColor = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
let $8725869b83961a04$var$_oldTarget = null;
// Golden Ratio
const $8725869b83961a04$var$PHI = (1 + Math.sqrt(5)) / 2;
const $8725869b83961a04$var$INV_PHI = 1 / $8725869b83961a04$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $8725869b83961a04$var$_axisDirections = [
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, $8725869b83961a04$var$PHI, $8725869b83961a04$var$INV_PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(0, $8725869b83961a04$var$PHI, -$8725869b83961a04$var$INV_PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699($8725869b83961a04$var$INV_PHI, 0, $8725869b83961a04$var$PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-$8725869b83961a04$var$INV_PHI, 0, $8725869b83961a04$var$PHI),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699($8725869b83961a04$var$PHI, $8725869b83961a04$var$INV_PHI, 0),
    /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699(-$8725869b83961a04$var$PHI, $8725869b83961a04$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $8725869b83961a04$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $8725869b83961a04$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $8725869b83961a04$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $8725869b83961a04$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($8725869b83961a04$var$_oldTarget);
        outputTarget.scissorTest = false;
        $8725869b83961a04$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $8725869b83961a04$export$8759762a6477f2c4 || texture.mapping === $8725869b83961a04$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $8725869b83961a04$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $8725869b83961a04$export$8a72f490b25c56c8,
            minFilter: $8725869b83961a04$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $8725869b83961a04$export$2697304443f382bc,
            format: $8725869b83961a04$export$3f8bb04b555a363c,
            colorSpace: $8725869b83961a04$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $8725869b83961a04$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $8725869b83961a04$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $8725869b83961a04$var$_createPlanes(_lodMax));
            this._blurMaterial = $8725869b83961a04$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $8725869b83961a04$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $8725869b83961a04$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $8725869b83961a04$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($8725869b83961a04$var$_clearColor);
        renderer.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $8725869b83961a04$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $8725869b83961a04$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($8725869b83961a04$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $8725869b83961a04$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $8725869b83961a04$export$8759762a6477f2c4 || texture.mapping === $8725869b83961a04$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $8725869b83961a04$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $8725869b83961a04$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $8725869b83961a04$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $8725869b83961a04$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $8725869b83961a04$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $8725869b83961a04$var$_axisDirections[(i - 1) % $8725869b83961a04$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $8725869b83961a04$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $8725869b83961a04$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $8725869b83961a04$var$MAX_SAMPLES;
        if (samples > $8725869b83961a04$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$8725869b83961a04$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $8725869b83961a04$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $8725869b83961a04$var$LOD_MIN ? lodOut - _lodMax + $8725869b83961a04$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $8725869b83961a04$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $8725869b83961a04$var$_flatCamera);
    }
}
function $8725869b83961a04$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $8725869b83961a04$var$LOD_MIN + 1 + $8725869b83961a04$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $8725869b83961a04$var$LOD_MIN) sigma = $8725869b83961a04$var$EXTRA_LOD_SIGMA[i - lodMax + $8725869b83961a04$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $8725869b83961a04$export$b7be63a67df8959();
        planes.setAttribute("position", new $8725869b83961a04$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $8725869b83961a04$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $8725869b83961a04$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $8725869b83961a04$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $8725869b83961a04$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $8725869b83961a04$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $8725869b83961a04$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $8725869b83961a04$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($8725869b83961a04$var$MAX_SAMPLES);
    const poleAxis = new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $8725869b83961a04$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $8725869b83961a04$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $8725869b83961a04$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $8725869b83961a04$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $8725869b83961a04$var$_getEquirectMaterial() {
    return new $8725869b83961a04$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $8725869b83961a04$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $8725869b83961a04$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $8725869b83961a04$var$_getCubemapMaterial() {
    return new $8725869b83961a04$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $8725869b83961a04$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $8725869b83961a04$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $8725869b83961a04$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $8725869b83961a04$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $8725869b83961a04$export$d64030b316d3b087 || mapping === $8725869b83961a04$export$ee99d97d46898098;
            const isCubeMap = mapping === $8725869b83961a04$export$8759762a6477f2c4 || mapping === $8725869b83961a04$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $8725869b83961a04$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $8725869b83961a04$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $8725869b83961a04$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $8725869b83961a04$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($8725869b83961a04$var$arrayNeedsUint32(indices) ? $8725869b83961a04$export$7eb8c9fa25cd5bd6 : $8725869b83961a04$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $8725869b83961a04$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $8725869b83961a04$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $8725869b83961a04$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $8725869b83961a04$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $8725869b83961a04$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $8725869b83961a04$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $8725869b83961a04$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $8725869b83961a04$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $8725869b83961a04$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($8725869b83961a04$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($8725869b83961a04$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $8725869b83961a04$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $8725869b83961a04$var$emptyTexture = /*@__PURE__*/ new $8725869b83961a04$export$5431306cf43de24a();
const $8725869b83961a04$var$emptyArrayTexture = /*@__PURE__*/ new $8725869b83961a04$export$dfac6c8e811406a3();
const $8725869b83961a04$var$empty3dTexture = /*@__PURE__*/ new $8725869b83961a04$export$d7a3086320f856db();
const $8725869b83961a04$var$emptyCubeTexture = /*@__PURE__*/ new $8725869b83961a04$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $8725869b83961a04$var$arrayCacheF32 = [];
const $8725869b83961a04$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $8725869b83961a04$var$mat4array = new Float32Array(16);
const $8725869b83961a04$var$mat3array = new Float32Array(9);
const $8725869b83961a04$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $8725869b83961a04$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $8725869b83961a04$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $8725869b83961a04$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $8725869b83961a04$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $8725869b83961a04$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $8725869b83961a04$var$allocTexUnits(textures, n) {
    let r = $8725869b83961a04$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $8725869b83961a04$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $8725869b83961a04$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $8725869b83961a04$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $8725869b83961a04$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $8725869b83961a04$var$copyArray(cache, v);
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, elements)) return;
        $8725869b83961a04$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $8725869b83961a04$var$mat2array);
        $8725869b83961a04$var$copyArray(cache, elements);
    }
}
function $8725869b83961a04$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $8725869b83961a04$var$copyArray(cache, v);
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, elements)) return;
        $8725869b83961a04$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $8725869b83961a04$var$mat3array);
        $8725869b83961a04$var$copyArray(cache, elements);
    }
}
function $8725869b83961a04$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $8725869b83961a04$var$copyArray(cache, v);
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, elements)) return;
        $8725869b83961a04$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $8725869b83961a04$var$mat4array);
        $8725869b83961a04$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $8725869b83961a04$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $8725869b83961a04$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $8725869b83961a04$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $8725869b83961a04$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
function $8725869b83961a04$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8725869b83961a04$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $8725869b83961a04$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $8725869b83961a04$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $8725869b83961a04$var$emptyTexture, unit);
}
function $8725869b83961a04$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $8725869b83961a04$var$empty3dTexture, unit);
}
function $8725869b83961a04$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $8725869b83961a04$var$emptyCubeTexture, unit);
}
function $8725869b83961a04$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $8725869b83961a04$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $8725869b83961a04$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $8725869b83961a04$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $8725869b83961a04$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $8725869b83961a04$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $8725869b83961a04$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $8725869b83961a04$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $8725869b83961a04$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $8725869b83961a04$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $8725869b83961a04$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $8725869b83961a04$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $8725869b83961a04$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $8725869b83961a04$var$setValueV4i; // _VEC4
        case 0x1405:
            return $8725869b83961a04$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $8725869b83961a04$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $8725869b83961a04$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $8725869b83961a04$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $8725869b83961a04$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $8725869b83961a04$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $8725869b83961a04$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $8725869b83961a04$var$setValueT2DArray1;
    }
}
// Array of scalars
function $8725869b83961a04$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $8725869b83961a04$var$setValueV2fArray(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $8725869b83961a04$var$setValueV3fArray(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $8725869b83961a04$var$setValueV4fArray(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $8725869b83961a04$var$setValueM2Array(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $8725869b83961a04$var$setValueM3Array(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $8725869b83961a04$var$setValueM4Array(gl, v) {
    const data = $8725869b83961a04$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $8725869b83961a04$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $8725869b83961a04$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $8725869b83961a04$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $8725869b83961a04$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $8725869b83961a04$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $8725869b83961a04$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $8725869b83961a04$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $8725869b83961a04$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $8725869b83961a04$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $8725869b83961a04$var$emptyTexture, units[i]);
}
function $8725869b83961a04$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $8725869b83961a04$var$empty3dTexture, units[i]);
}
function $8725869b83961a04$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $8725869b83961a04$var$emptyCubeTexture, units[i]);
}
function $8725869b83961a04$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8725869b83961a04$var$allocTexUnits(textures, n);
    if (!$8725869b83961a04$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8725869b83961a04$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $8725869b83961a04$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $8725869b83961a04$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $8725869b83961a04$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $8725869b83961a04$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $8725869b83961a04$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $8725869b83961a04$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $8725869b83961a04$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $8725869b83961a04$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $8725869b83961a04$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $8725869b83961a04$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $8725869b83961a04$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $8725869b83961a04$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $8725869b83961a04$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $8725869b83961a04$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $8725869b83961a04$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $8725869b83961a04$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $8725869b83961a04$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $8725869b83961a04$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $8725869b83961a04$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $8725869b83961a04$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $8725869b83961a04$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $8725869b83961a04$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $8725869b83961a04$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $8725869b83961a04$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $8725869b83961a04$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $8725869b83961a04$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $8725869b83961a04$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $8725869b83961a04$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $8725869b83961a04$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $8725869b83961a04$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $8725869b83961a04$var$RePathPart.exec(path), matchEnd = $8725869b83961a04$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $8725869b83961a04$var$addUniform(container, subscript === undefined ? new $8725869b83961a04$var$SingleUniform(id, activeInfo, addr) : new $8725869b83961a04$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $8725869b83961a04$var$StructuredUniform(id);
                $8725869b83961a04$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $8725869b83961a04$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $8725869b83961a04$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $8725869b83961a04$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $8725869b83961a04$var$programIdCount = 0;
function $8725869b83961a04$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $8725869b83961a04$var$getEncodingComponents(colorSpace1) {
    switch(colorSpace1){
        case $8725869b83961a04$export$42429b3acfb233a4:
            return [
                "Linear",
                "( value )"
            ];
        case $8725869b83961a04$export$561f394b24edfcaa:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $8725869b83961a04$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $8725869b83961a04$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $8725869b83961a04$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $8725869b83961a04$var$getEncodingComponents(colorSpace1);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $8725869b83961a04$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $8725869b83961a04$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $8725869b83961a04$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $8725869b83961a04$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $8725869b83961a04$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $8725869b83961a04$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $8725869b83961a04$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($8725869b83961a04$var$filterEmptyLine).join("\n");
}
function $8725869b83961a04$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $8725869b83961a04$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $8725869b83961a04$var$filterEmptyLine(string) {
    return string !== "";
}
function $8725869b83961a04$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $8725869b83961a04$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $8725869b83961a04$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $8725869b83961a04$var$resolveIncludes(string) {
    return string.replace($8725869b83961a04$var$includePattern, $8725869b83961a04$var$includeReplacer);
}
function $8725869b83961a04$var$includeReplacer(match, include) {
    const string = $8725869b83961a04$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $8725869b83961a04$var$resolveIncludes(string);
}
// Unroll Loops
const $8725869b83961a04$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $8725869b83961a04$var$unrollLoops(string) {
    return string.replace($8725869b83961a04$var$unrollLoopPattern, $8725869b83961a04$var$loopReplacer);
}
function $8725869b83961a04$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $8725869b83961a04$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $8725869b83961a04$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $8725869b83961a04$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $8725869b83961a04$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $8725869b83961a04$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $8725869b83961a04$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $8725869b83961a04$export$8759762a6477f2c4:
        case $8725869b83961a04$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $8725869b83961a04$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $8725869b83961a04$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $8725869b83961a04$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $8725869b83961a04$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $8725869b83961a04$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $8725869b83961a04$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $8725869b83961a04$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $8725869b83961a04$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $8725869b83961a04$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $8725869b83961a04$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $8725869b83961a04$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $8725869b83961a04$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $8725869b83961a04$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $8725869b83961a04$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $8725869b83961a04$var$generateExtensions(parameters);
    const customDefines = $8725869b83961a04$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($8725869b83961a04$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($8725869b83961a04$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $8725869b83961a04$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($8725869b83961a04$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $8725869b83961a04$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $8725869b83961a04$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $8725869b83961a04$export$9fcb6b4294603b2 ? $8725869b83961a04$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $8725869b83961a04$export$9fcb6b4294603b2 ? $8725869b83961a04$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $8725869b83961a04$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $8725869b83961a04$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($8725869b83961a04$var$filterEmptyLine).join("\n");
    }
    vertexShader = $8725869b83961a04$var$resolveIncludes(vertexShader);
    vertexShader = $8725869b83961a04$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $8725869b83961a04$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $8725869b83961a04$var$resolveIncludes(fragmentShader);
    fragmentShader = $8725869b83961a04$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $8725869b83961a04$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $8725869b83961a04$var$unrollLoops(vertexShader);
    fragmentShader = $8725869b83961a04$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $8725869b83961a04$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $8725869b83961a04$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $8725869b83961a04$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $8725869b83961a04$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $8725869b83961a04$var$getShaderErrors(gl, glVertexShader, "vertex");
                const fragmentErrors = $8725869b83961a04$var$getShaderErrors(gl, glFragmentShader, "fragment");
                console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
            }
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $8725869b83961a04$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $8725869b83961a04$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $8725869b83961a04$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $8725869b83961a04$var$_id = 0;
class $8725869b83961a04$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $8725869b83961a04$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $8725869b83961a04$var$WebGLShaderStage {
    constructor(code){
        this.id = $8725869b83961a04$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $8725869b83961a04$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $8725869b83961a04$export$89312ce47c0ca777();
    const _customShaders = new $8725869b83961a04$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        if (value === 0) return "uv";
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $8725869b83961a04$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $8725869b83961a04$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $8725869b83961a04$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $8725869b83961a04$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $8725869b83961a04$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $8725869b83961a04$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $8725869b83961a04$export$9fcb6b4294603b2,
            useLegacyLights: renderer.useLegacyLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $8725869b83961a04$export$3b296b6f144d5b03,
            flipSided: material.side === $8725869b83961a04$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $8725869b83961a04$export$bee4a7d47f8f5014[shaderID];
            uniforms = $8725869b83961a04$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $8725869b83961a04$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $8725869b83961a04$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $8725869b83961a04$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $8725869b83961a04$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $8725869b83961a04$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $8725869b83961a04$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $8725869b83961a04$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $8725869b83961a04$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $8725869b83961a04$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $8725869b83961a04$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $8725869b83961a04$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $8725869b83961a04$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $8725869b83961a04$export$64b5c384219d3699(),
                        color: new $8725869b83961a04$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $8725869b83961a04$export$64b5c384219d3699(),
                        direction: new $8725869b83961a04$export$64b5c384219d3699(),
                        color: new $8725869b83961a04$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $8725869b83961a04$export$64b5c384219d3699(),
                        color: new $8725869b83961a04$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $8725869b83961a04$export$64b5c384219d3699(),
                        skyColor: new $8725869b83961a04$export$892596cec99bc70e(),
                        groundColor: new $8725869b83961a04$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $8725869b83961a04$export$892596cec99bc70e(),
                        position: new $8725869b83961a04$export$64b5c384219d3699(),
                        halfWidth: new $8725869b83961a04$export$64b5c384219d3699(),
                        halfHeight: new $8725869b83961a04$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $8725869b83961a04$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $8725869b83961a04$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $8725869b83961a04$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $8725869b83961a04$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $8725869b83961a04$var$nextVersion = 0;
function $8725869b83961a04$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $8725869b83961a04$var$WebGLLights(extensions, capabilities) {
    const cache = new $8725869b83961a04$var$UniformsCache();
    const shadowCache = $8725869b83961a04$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $8725869b83961a04$export$64b5c384219d3699());
    const vector3 = new $8725869b83961a04$export$64b5c384219d3699();
    const matrix4 = new $8725869b83961a04$export$2ae72fc923e5eb5();
    const matrix42 = new $8725869b83961a04$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($8725869b83961a04$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $8725869b83961a04$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $8725869b83961a04$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $8725869b83961a04$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $8725869b83961a04$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $8725869b83961a04$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $8725869b83961a04$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $8725869b83961a04$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $8725869b83961a04$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $8725869b83961a04$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $8725869b83961a04$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $8725869b83961a04$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $8725869b83961a04$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $8725869b83961a04$export$2698c22ec13825db extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $8725869b83961a04$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $8725869b83961a04$export$33e187ed002f2a19 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $8725869b83961a04$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $8725869b83961a04$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $8725869b83961a04$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $8725869b83961a04$export$35efe6f4c85463d2();
    const _shadowMapSize = new $8725869b83961a04$export$c977b3e384af9ae1(), _viewportSize = new $8725869b83961a04$export$c977b3e384af9ae1(), _viewport = new $8725869b83961a04$export$fa7daccca11cdbe3(), _depthMaterial = new $8725869b83961a04$export$2698c22ec13825db({
        depthPacking: $8725869b83961a04$export$8f910f4c4f73df11
    }), _distanceMaterial = new $8725869b83961a04$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$8725869b83961a04$export$2ede184fc2998901]: $8725869b83961a04$export$d9f0486e75b5ace,
        [$8725869b83961a04$export$d9f0486e75b5ace]: $8725869b83961a04$export$2ede184fc2998901,
        [$8725869b83961a04$export$3b296b6f144d5b03]: $8725869b83961a04$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $8725869b83961a04$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $8725869b83961a04$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $8725869b83961a04$var$vertex,
        fragmentShader: $8725869b83961a04$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $8725869b83961a04$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $8725869b83961a04$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $8725869b83961a04$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $8725869b83961a04$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($8725869b83961a04$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $8725869b83961a04$export$896ae1ade6c829c4 && this.type === $8725869b83961a04$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $8725869b83961a04$export$896ae1ade6c829c4 && this.type !== $8725869b83961a04$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $8725869b83961a04$export$896ae1ade6c829c4 ? {
                    minFilter: $8725869b83961a04$export$727aa5ec3fe39bf0,
                    magFilter: $8725869b83961a04$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $8725869b83961a04$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $8725869b83961a04$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $8725869b83961a04$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $8725869b83961a04$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $8725869b83961a04$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $8725869b83961a04$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $8725869b83961a04$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $8725869b83961a04$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $8725869b83961a04$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $8725869b83961a04$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $8725869b83961a04$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $8725869b83961a04$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $8725869b83961a04$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $8725869b83961a04$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $8725869b83961a04$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $8725869b83961a04$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $8725869b83961a04$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($8725869b83961a04$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($8725869b83961a04$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($8725869b83961a04$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$8725869b83961a04$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$8725869b83961a04$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$8725869b83961a04$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$8725869b83961a04$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$8725869b83961a04$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$8725869b83961a04$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$8725869b83961a04$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$8725869b83961a04$export$2110f05edf778d3d]: gl.ZERO,
        [$8725869b83961a04$export$8805bad65e24940e]: gl.ONE,
        [$8725869b83961a04$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$8725869b83961a04$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$8725869b83961a04$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$8725869b83961a04$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$8725869b83961a04$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$8725869b83961a04$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$8725869b83961a04$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$8725869b83961a04$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$8725869b83961a04$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $8725869b83961a04$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $8725869b83961a04$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $8725869b83961a04$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $8725869b83961a04$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $8725869b83961a04$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $8725869b83961a04$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $8725869b83961a04$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $8725869b83961a04$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $8725869b83961a04$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $8725869b83961a04$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $8725869b83961a04$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $8725869b83961a04$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $8725869b83961a04$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $8725869b83961a04$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $8725869b83961a04$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $8725869b83961a04$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $8725869b83961a04$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($8725869b83961a04$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $8725869b83961a04$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $8725869b83961a04$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $8725869b83961a04$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $8725869b83961a04$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $8725869b83961a04$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $8725869b83961a04$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $8725869b83961a04$var$isPowerOfTwo(image.width) && $8725869b83961a04$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $8725869b83961a04$export$9d9334239a5a5e06 || texture.wrapT !== $8725869b83961a04$export$9d9334239a5a5e06 || texture.minFilter !== $8725869b83961a04$export$727aa5ec3fe39bf0 && texture.minFilter !== $8725869b83961a04$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $8725869b83961a04$export$727aa5ec3fe39bf0 && texture.minFilter !== $8725869b83961a04$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa && forceLinearTransfer === false ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $8725869b83961a04$export$727aa5ec3fe39bf0 && texture.minFilter !== $8725869b83961a04$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $8725869b83961a04$export$727aa5ec3fe39bf0 || f === $8725869b83961a04$export$d129e38cf6feaa8c || f === $8725869b83961a04$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$8725869b83961a04$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$8725869b83961a04$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$8725869b83961a04$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$8725869b83961a04$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$8725869b83961a04$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$8725869b83961a04$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$8725869b83961a04$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$8725869b83961a04$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$8725869b83961a04$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$8725869b83961a04$export$d9e2d19a747baaab]: _gl.NEVER,
        [$8725869b83961a04$export$187b73a3e352c145]: _gl.ALWAYS,
        [$8725869b83961a04$export$36bcf49c713b3eb7]: _gl.LESS,
        [$8725869b83961a04$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$8725869b83961a04$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$8725869b83961a04$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$8725869b83961a04$export$155af022118f3a38]: _gl.GREATER,
        [$8725869b83961a04$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $8725869b83961a04$export$9d9334239a5a5e06 || texture.wrapT !== $8725869b83961a04$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $8725869b83961a04$export$727aa5ec3fe39bf0 && texture.minFilter !== $8725869b83961a04$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.magFilter === $8725869b83961a04$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $8725869b83961a04$export$d2327c1afe5bfdf2 && texture.minFilter !== $8725869b83961a04$export$5d8599b6a933fb1b) return;
            if (texture.type === $8725869b83961a04$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $8725869b83961a04$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $8725869b83961a04$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $8725869b83961a04$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $8725869b83961a04$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $8725869b83961a04$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $8725869b83961a04$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $8725869b83961a04$export$c63dc51868b06a9d && texture.type !== $8725869b83961a04$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $8725869b83961a04$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $8725869b83961a04$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $8725869b83961a04$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $8725869b83961a04$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $8725869b83961a04$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $8725869b83961a04$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $8725869b83961a04$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $8725869b83961a04$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $8725869b83961a04$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $8725869b83961a04$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $8725869b83961a04$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.format === $8725869b83961a04$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $8725869b83961a04$export$42429b3acfb233a4 && colorSpace1 !== $8725869b83961a04$export$bfcb490c2dd3db51) {
            // sRGB
            if (colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $8725869b83961a04$export$3f8bb04b555a363c) {
                        texture.format = $8725869b83961a04$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $8725869b83961a04$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $8725869b83961a04$export$3f8bb04b555a363c || type !== $8725869b83961a04$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $8725869b83961a04$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $8725869b83961a04$export$bfcb490c2dd3db51) {
        let extension;
        if (p === $8725869b83961a04$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $8725869b83961a04$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $8725869b83961a04$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $8725869b83961a04$export$545fce0311a9796a) return gl.BYTE;
        if (p === $8725869b83961a04$export$88572337f312435f) return gl.SHORT;
        if (p === $8725869b83961a04$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $8725869b83961a04$export$5c612977753abe2) return gl.INT;
        if (p === $8725869b83961a04$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $8725869b83961a04$export$f6d331659b644596) return gl.FLOAT;
        if (p === $8725869b83961a04$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $8725869b83961a04$export$988473390501ed4b) return gl.ALPHA;
        if (p === $8725869b83961a04$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $8725869b83961a04$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $8725869b83961a04$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $8725869b83961a04$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $8725869b83961a04$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $8725869b83961a04$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $8725869b83961a04$export$4e041a7967d15c4b) return gl.RED;
        if (p === $8725869b83961a04$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $8725869b83961a04$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $8725869b83961a04$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $8725869b83961a04$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $8725869b83961a04$export$21d1799c6d552fc0 || p === $8725869b83961a04$export$afa304c3e981b668 || p === $8725869b83961a04$export$d2a1a68024a3e56c || p === $8725869b83961a04$export$9a79c424327dacf9) {
            if (colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $8725869b83961a04$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $8725869b83961a04$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $8725869b83961a04$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $8725869b83961a04$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $8725869b83961a04$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $8725869b83961a04$export$19ada9bbb1af3573 || p === $8725869b83961a04$export$d0f0355bb3d948e4 || p === $8725869b83961a04$export$b82296714358084c || p === $8725869b83961a04$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $8725869b83961a04$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $8725869b83961a04$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $8725869b83961a04$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $8725869b83961a04$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $8725869b83961a04$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $8725869b83961a04$export$7800993ef8106a6a || p === $8725869b83961a04$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $8725869b83961a04$export$7800993ef8106a6a) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $8725869b83961a04$export$23ed8300a860e7d8) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $8725869b83961a04$export$dc5570b4a2b92d48 || p === $8725869b83961a04$export$68880cd325f8b2fb || p === $8725869b83961a04$export$7d2c0be323373d95 || p === $8725869b83961a04$export$22b52da301fc3a3e || p === $8725869b83961a04$export$c009e2cb4a66485e || p === $8725869b83961a04$export$118fff5afa255b63 || p === $8725869b83961a04$export$120713c829ae0667 || p === $8725869b83961a04$export$c79eeabbf53313e9 || p === $8725869b83961a04$export$443cf6567cdd6424 || p === $8725869b83961a04$export$6573984fc9840780 || p === $8725869b83961a04$export$e7aee563f30091de || p === $8725869b83961a04$export$2eb8634622ddeab7 || p === $8725869b83961a04$export$202b1ce7b5d25742 || p === $8725869b83961a04$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $8725869b83961a04$export$dc5570b4a2b92d48) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $8725869b83961a04$export$68880cd325f8b2fb) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $8725869b83961a04$export$7d2c0be323373d95) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $8725869b83961a04$export$22b52da301fc3a3e) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $8725869b83961a04$export$c009e2cb4a66485e) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $8725869b83961a04$export$118fff5afa255b63) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $8725869b83961a04$export$120713c829ae0667) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $8725869b83961a04$export$c79eeabbf53313e9) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $8725869b83961a04$export$443cf6567cdd6424) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $8725869b83961a04$export$6573984fc9840780) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $8725869b83961a04$export$e7aee563f30091de) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $8725869b83961a04$export$2eb8634622ddeab7) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $8725869b83961a04$export$202b1ce7b5d25742) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $8725869b83961a04$export$18ab77abd087e467) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $8725869b83961a04$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $8725869b83961a04$export$ce40b115e188bc81) return colorSpace1 === $8725869b83961a04$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === $8725869b83961a04$export$b1688df4c4c21670 || p === $8725869b83961a04$export$fc15e5d8261eed58 || p === $8725869b83961a04$export$d220f6ade8463a0f || p === $8725869b83961a04$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $8725869b83961a04$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $8725869b83961a04$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $8725869b83961a04$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $8725869b83961a04$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $8725869b83961a04$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $8725869b83961a04$export$56b937d9e5581166 extends $8725869b83961a04$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $8725869b83961a04$export$eb2fcfdbd7ba97d4 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $8725869b83961a04$var$_moveEvent = {
    type: "move"
};
class $8725869b83961a04$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $8725869b83961a04$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $8725869b83961a04$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $8725869b83961a04$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $8725869b83961a04$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($8725869b83961a04$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $8725869b83961a04$export$fc830aa069cc8c2f extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $8725869b83961a04$export$c1b6b5136be58045;
        if (format !== $8725869b83961a04$export$c1b6b5136be58045 && format !== $8725869b83961a04$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $8725869b83961a04$export$c1b6b5136be58045) type = $8725869b83961a04$export$c3c7fc4518ebba96;
        if (type === undefined && format === $8725869b83961a04$export$1e113ac2d0905829) type = $8725869b83961a04$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
class $8725869b83961a04$var$WebXRManager extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        let userCamera = null;
        const cameraL = new $8725869b83961a04$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const cameraR = new $8725869b83961a04$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $8725869b83961a04$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true; // @deprecated, r153
        this.enabled = false;
        this.isPresenting = false;
        this.getCamera = function() {}; // @deprecated, r153
        this.setUserCamera = function(value) {
            userCamera = value;
        };
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $8725869b83961a04$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $8725869b83961a04$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $8725869b83961a04$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $8725869b83961a04$export$3f8bb04b555a363c,
                        type: $8725869b83961a04$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $8725869b83961a04$export$1e113ac2d0905829 : $8725869b83961a04$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $8725869b83961a04$export$6c8ea339bfab1301 : $8725869b83961a04$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $8725869b83961a04$export$3f8bb04b555a363c,
                        type: $8725869b83961a04$export$2e8ce08d3f6f5e10,
                        depthTexture: new $8725869b83961a04$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $8725869b83961a04$export$64b5c384219d3699();
        const cameraRPos = new $8725869b83961a04$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCameraXR = function(camera) {
            if (session === null) return camera;
            if (userCamera) camera = userCamera;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            if (userCamera) updateUserCamera(cameraXR, parent);
            return cameraXR;
        };
        function updateUserCamera(cameraXR, parent) {
            const camera = userCamera;
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $8725869b83961a04$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $8725869b83961a04$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: "planesdetected",
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $8725869b83961a04$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $8725869b83961a04$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $8725869b83961a04$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $8725869b83961a04$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $8725869b83961a04$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === "number") {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number") cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === "number") {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number") {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $8725869b83961a04$var$createCanvasElement() {
    const canvas = $8725869b83961a04$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
class $8725869b83961a04$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $8725869b83961a04$var$createCanvasElement(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputColorSpace = $8725869b83961a04$export$561f394b24edfcaa;
        // physical lights
        this.useLegacyLights = true;
        // tone mapping
        this.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const _currentScissor = new $8725869b83961a04$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $8725869b83961a04$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        const _vector2 = new $8725869b83961a04$export$c977b3e384af9ae1();
        const _vector3 = new $8725869b83961a04$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$8725869b83961a04$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    "webgl2",
                    "webgl",
                    "experimental-webgl"
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
            if (_gl instanceof WebGLRenderingContext) console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.");
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    "rangeMin": 1,
                    "rangeMax": 1,
                    "precision": 1
                };
            };
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $8725869b83961a04$var$WebGLExtensions(_gl);
            capabilities = new $8725869b83961a04$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $8725869b83961a04$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $8725869b83961a04$var$WebGLState(_gl, extensions, capabilities);
            info = new $8725869b83961a04$var$WebGLInfo(_gl);
            properties = new $8725869b83961a04$var$WebGLProperties();
            textures = new $8725869b83961a04$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $8725869b83961a04$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $8725869b83961a04$var$WebGLCubeUVMaps(_this);
            attributes = new $8725869b83961a04$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $8725869b83961a04$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $8725869b83961a04$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $8725869b83961a04$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $8725869b83961a04$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $8725869b83961a04$var$WebGLClipping(properties);
            programCache = new $8725869b83961a04$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $8725869b83961a04$var$WebGLMaterials(_this, properties);
            renderLists = new $8725869b83961a04$var$WebGLRenderLists();
            renderStates = new $8725869b83961a04$var$WebGLRenderStates(extensions, capabilities);
            background = new $8725869b83961a04$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $8725869b83961a04$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $8725869b83961a04$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $8725869b83961a04$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $8725869b83961a04$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $8725869b83961a04$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $8725869b83961a04$export$c200e7d26f592f21 || targetFormat === $8725869b83961a04$export$1ba1c45f9f77d4d7 || targetFormat === $8725869b83961a04$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $8725869b83961a04$export$2e8ce08d3f6f5e10 || targetType === $8725869b83961a04$export$c3c7fc4518ebba96 || targetType === $8725869b83961a04$export$c63dc51868b06a9d || targetType === $8725869b83961a04$export$6c8ea339bfab1301 || targetType === $8725869b83961a04$export$b3969b01faf587f2 || targetType === $8725869b83961a04$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    const __webglFramebuffer = properties.get(_currentRenderTarget).__webglFramebuffer;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, __webglFramebuffer, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, __webglFramebuffer, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $8725869b83961a04$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $8725869b83961a04$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $8725869b83961a04$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $8725869b83961a04$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this.useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $8725869b83961a04$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) camera = xr.updateCameraXR(camera); // use XR camera for rendering
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            this.info.render.frame++;
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this.useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        if (object.isSkinnedMesh) // update skeleton only once in a frame
                        {
                            if (object.skeleton.frame !== info.render.frame) {
                                object.skeleton.update();
                                object.skeleton.frame = info.render.frame;
                            }
                        }
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $8725869b83961a04$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has("EXT_color_buffer_half_float") ? $8725869b83961a04$export$2697304443f382bc : $8725869b83961a04$export$2e8ce08d3f6f5e10,
                minFilter: $8725869b83961a04$export$5d8599b6a933fb1b,
                samples: isWebGL2 && antialias === true ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($8725869b83961a04$var$floorPowerOfTwo(_vector2.x), $8725869b83961a04$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $8725869b83961a04$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $8725869b83961a04$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $8725869b83961a04$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $8725869b83961a04$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $8725869b83961a04$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $8725869b83961a04$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $8725869b83961a04$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $8725869b83961a04$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $8725869b83961a04$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            const toneMapping = material.toneMapped ? _this.toneMapping : $8725869b83961a04$export$9fcb6b4294603b2;
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
                // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                    const uCamPos = p_uniforms.map.cameraPosition;
                    if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                    } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $8725869b83961a04$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $8725869b83961a04$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                        console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $8725869b83961a04$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $8725869b83961a04$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                    if (textureType !== $8725869b83961a04$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $8725869b83961a04$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $8725869b83961a04$export$5a0e9190d10875d3;
    }
    get physicallyCorrectLights() {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        return this.outputColorSpace === $8725869b83961a04$export$561f394b24edfcaa ? $8725869b83961a04$export$f32388edbb32674 : $8725869b83961a04$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        this.outputColorSpace = encoding === $8725869b83961a04$export$f32388edbb32674 ? $8725869b83961a04$export$561f394b24edfcaa : $8725869b83961a04$export$42429b3acfb233a4;
    }
}
class $8725869b83961a04$export$a2f65229194348f9 extends $8725869b83961a04$export$f6cc00ef28d7cf97 {
}
$8725869b83961a04$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $8725869b83961a04$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $8725869b83961a04$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $8725869b83961a04$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $8725869b83961a04$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $8725869b83961a04$export$38af1803e3442a7f extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
    get autoUpdate() {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        return this.matrixWorldAutoUpdate;
    }
    set autoUpdate(value) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        this.matrixWorldAutoUpdate = value;
    }
}
class $8725869b83961a04$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $8725869b83961a04$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $8725869b83961a04$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $8725869b83961a04$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $8725869b83961a04$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $8725869b83961a04$var$_vector$5 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $8725869b83961a04$var$_vector$5.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$5.x, $8725869b83961a04$var$_vector$5.y, $8725869b83961a04$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$5.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$5.x, $8725869b83961a04$var$_vector$5.y, $8725869b83961a04$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $8725869b83961a04$var$_vector$5.fromBufferAttribute(this, i);
            $8725869b83961a04$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $8725869b83961a04$var$_vector$5.x, $8725869b83961a04$var$_vector$5.y, $8725869b83961a04$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $8725869b83961a04$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $8725869b83961a04$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $8725869b83961a04$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $8725869b83961a04$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $8725869b83961a04$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $8725869b83961a04$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $8725869b83961a04$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $8725869b83961a04$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $8725869b83961a04$var$normalize(x, this.array);
            y = $8725869b83961a04$var$normalize(y, this.array);
            z = $8725869b83961a04$var$normalize(z, this.array);
            w = $8725869b83961a04$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $8725869b83961a04$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $8725869b83961a04$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $8725869b83961a04$export$5ec7dd1c6994bf8e extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $8725869b83961a04$var$_geometry;
const $8725869b83961a04$var$_intersectPoint = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_worldScale = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_mvPosition = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_alignedPosition = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_rotatedPosition = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_viewWorldMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_vA = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vB = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_vC = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_uvA = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvB = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
const $8725869b83961a04$var$_uvC = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$3075603db8e6204c extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($8725869b83961a04$var$_geometry === undefined) {
            $8725869b83961a04$var$_geometry = new $8725869b83961a04$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $8725869b83961a04$export$3d5cd879f108f53f(float32Array, 5);
            $8725869b83961a04$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $8725869b83961a04$var$_geometry.setAttribute("position", new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $8725869b83961a04$var$_geometry.setAttribute("uv", new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $8725869b83961a04$var$_geometry;
        this.material = material !== undefined ? material : new $8725869b83961a04$export$5ec7dd1c6994bf8e();
        this.center = new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $8725869b83961a04$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $8725869b83961a04$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $8725869b83961a04$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $8725869b83961a04$var$_worldScale.multiplyScalar(-$8725869b83961a04$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vA.set(-0.5, -0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
        $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vB.set(0.5, -0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
        $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vC.set(0.5, 0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
        $8725869b83961a04$var$_uvA.set(0, 0);
        $8725869b83961a04$var$_uvB.set(1, 0);
        $8725869b83961a04$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($8725869b83961a04$var$_vA, $8725869b83961a04$var$_vB, $8725869b83961a04$var$_vC, false, $8725869b83961a04$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $8725869b83961a04$var$transformVertex($8725869b83961a04$var$_vB.set(-0.5, 0.5, 0), $8725869b83961a04$var$_mvPosition, center, $8725869b83961a04$var$_worldScale, sin, cos);
            $8725869b83961a04$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($8725869b83961a04$var$_vA, $8725869b83961a04$var$_vC, $8725869b83961a04$var$_vB, false, $8725869b83961a04$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $8725869b83961a04$var$_intersectPoint.clone(),
            uv: $8725869b83961a04$export$5a465592bfe74b48.getInterpolation($8725869b83961a04$var$_intersectPoint, $8725869b83961a04$var$_vA, $8725869b83961a04$var$_vB, $8725869b83961a04$var$_vC, $8725869b83961a04$var$_uvA, $8725869b83961a04$var$_uvB, $8725869b83961a04$var$_uvC, new $8725869b83961a04$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $8725869b83961a04$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $8725869b83961a04$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $8725869b83961a04$var$_rotatedPosition.x = cos * $8725869b83961a04$var$_alignedPosition.x - sin * $8725869b83961a04$var$_alignedPosition.y;
        $8725869b83961a04$var$_rotatedPosition.y = sin * $8725869b83961a04$var$_alignedPosition.x + cos * $8725869b83961a04$var$_alignedPosition.y;
    } else $8725869b83961a04$var$_rotatedPosition.copy($8725869b83961a04$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $8725869b83961a04$var$_rotatedPosition.x;
    vertexPosition.y += $8725869b83961a04$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($8725869b83961a04$var$_viewWorldMatrix);
}
const $8725869b83961a04$var$_v1$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$112e7237be0c5f30 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $8725869b83961a04$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($8725869b83961a04$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $8725869b83961a04$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $8725869b83961a04$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $8725869b83961a04$var$_v1$2.distanceTo($8725869b83961a04$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $8725869b83961a04$var$_basePosition = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_skinIndex = /*@__PURE__*/ new $8725869b83961a04$export$fa7daccca11cdbe3();
const $8725869b83961a04$var$_skinWeight = /*@__PURE__*/ new $8725869b83961a04$export$fa7daccca11cdbe3();
const $8725869b83961a04$var$_vector3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_matrix4 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_vertex = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_sphere$3 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_inverseMatrix$2 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray$2 = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
class $8725869b83961a04$export$b303577035157ecf extends $8725869b83961a04$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $8725869b83961a04$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $8725869b83961a04$var$_vertex);
            this.boundingBox.expandByPoint($8725869b83961a04$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $8725869b83961a04$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $8725869b83961a04$var$_vertex);
            this.boundingSphere.expandByPoint($8725869b83961a04$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$3.copy(this.boundingSphere);
        $8725869b83961a04$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $8725869b83961a04$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray$2.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($8725869b83961a04$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $8725869b83961a04$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $8725869b83961a04$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $8725869b83961a04$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $8725869b83961a04$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $8725869b83961a04$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $8725869b83961a04$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $8725869b83961a04$var$_skinIndex.getComponent(i);
                $8725869b83961a04$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($8725869b83961a04$var$_vector3.copy($8725869b83961a04$var$_basePosition).applyMatrix4($8725869b83961a04$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.");
        return this.applyBoneTransform(index, vector);
    }
}
class $8725869b83961a04$export$b127726e56765aa4 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $8725869b83961a04$export$b691f601014eabe1 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0, minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $8725869b83961a04$var$_offsetMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_identityMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $8725869b83961a04$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $8725869b83961a04$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $8725869b83961a04$var$_identityMatrix;
            $8725869b83961a04$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $8725869b83961a04$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $8725869b83961a04$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $8725869b83961a04$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $8725869b83961a04$export$b691f601014eabe1(boneMatrices, size, size, $8725869b83961a04$export$3f8bb04b555a363c, $8725869b83961a04$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $8725869b83961a04$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $8725869b83961a04$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $8725869b83961a04$export$32ea87a8b54d744a extends $8725869b83961a04$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $8725869b83961a04$var$_instanceLocalMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_instanceWorldMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_instanceIntersects = [];
const $8725869b83961a04$var$_box3 = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
const $8725869b83961a04$var$_identity = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_mesh = /*@__PURE__*/ new $8725869b83961a04$export$e176487c05830cc5();
const $8725869b83961a04$var$_sphere$2 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
class $8725869b83961a04$export$f3c979c331175ad7 extends $8725869b83961a04$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $8725869b83961a04$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $8725869b83961a04$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $8725869b83961a04$var$_instanceLocalMatrix);
            $8725869b83961a04$var$_box3.copy(geometry.boundingBox).applyMatrix4($8725869b83961a04$var$_instanceLocalMatrix);
            this.boundingBox.union($8725869b83961a04$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $8725869b83961a04$var$_instanceLocalMatrix);
            $8725869b83961a04$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($8725869b83961a04$var$_instanceLocalMatrix);
            this.boundingSphere.union($8725869b83961a04$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $8725869b83961a04$var$_mesh.geometry = this.geometry;
        $8725869b83961a04$var$_mesh.material = this.material;
        if ($8725869b83961a04$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$2.copy(this.boundingSphere);
        $8725869b83961a04$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $8725869b83961a04$var$_instanceLocalMatrix);
            $8725869b83961a04$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $8725869b83961a04$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $8725869b83961a04$var$_mesh.matrixWorld = $8725869b83961a04$var$_instanceWorldMatrix;
            $8725869b83961a04$var$_mesh.raycast(raycaster, $8725869b83961a04$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $8725869b83961a04$var$_instanceIntersects.length; i < l; i++){
                const intersect = $8725869b83961a04$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $8725869b83961a04$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $8725869b83961a04$export$fbaaa33907730a0c extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $8725869b83961a04$var$_start$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_end$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_inverseMatrix$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray$1 = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
const $8725869b83961a04$var$_sphere$1 = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
class $8725869b83961a04$export$17d680238e50603e extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(geometry = new $8725869b83961a04$export$b7be63a67df8959(), material = new $8725869b83961a04$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $8725869b83961a04$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $8725869b83961a04$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $8725869b83961a04$var$_start$1.distanceTo($8725869b83961a04$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $8725869b83961a04$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $8725869b83961a04$var$_sphere$1.copy(geometry.boundingSphere);
        $8725869b83961a04$var$_sphere$1.applyMatrix4(matrixWorld);
        $8725869b83961a04$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere$1) === false) return;
        //
        $8725869b83961a04$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray$1.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $8725869b83961a04$export$64b5c384219d3699();
        const vEnd = new $8725869b83961a04$export$64b5c384219d3699();
        const interSegment = new $8725869b83961a04$export$64b5c384219d3699();
        const interRay = new $8725869b83961a04$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $8725869b83961a04$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $8725869b83961a04$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $8725869b83961a04$var$_start = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_end = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$ff1ed10fedfdd604 extends $8725869b83961a04$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $8725869b83961a04$var$_start.fromBufferAttribute(positionAttribute, i);
                $8725869b83961a04$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $8725869b83961a04$var$_start.distanceTo($8725869b83961a04$var$_end);
            }
            geometry.setAttribute("lineDistance", new $8725869b83961a04$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $8725869b83961a04$export$f85a24d745e4f17d extends $8725869b83961a04$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $8725869b83961a04$export$a178c45366ce5d6b extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $8725869b83961a04$var$_inverseMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_ray = /*@__PURE__*/ new $8725869b83961a04$export$a186db52eed6d40e();
const $8725869b83961a04$var$_sphere = /*@__PURE__*/ new $8725869b83961a04$export$805e8b72413ccaba();
const $8725869b83961a04$var$_position$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$1c787534cb11aa3e extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(geometry = new $8725869b83961a04$export$b7be63a67df8959(), material = new $8725869b83961a04$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $8725869b83961a04$var$_sphere.copy(geometry.boundingSphere);
        $8725869b83961a04$var$_sphere.applyMatrix4(matrixWorld);
        $8725869b83961a04$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($8725869b83961a04$var$_sphere) === false) return;
        //
        $8725869b83961a04$var$_inverseMatrix.copy(matrixWorld).invert();
        $8725869b83961a04$var$_ray.copy(raycaster.ray).applyMatrix4($8725869b83961a04$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $8725869b83961a04$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $8725869b83961a04$var$testPoint($8725869b83961a04$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $8725869b83961a04$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $8725869b83961a04$var$testPoint($8725869b83961a04$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $8725869b83961a04$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $8725869b83961a04$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $8725869b83961a04$export$64b5c384219d3699();
        $8725869b83961a04$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $8725869b83961a04$export$6e09d1edf8d5a25c extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $8725869b83961a04$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $8725869b83961a04$export$9270d786f73ce6fe extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.minFilter = $8725869b83961a04$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $8725869b83961a04$export$3466bac9141a5cc4 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $8725869b83961a04$export$5fe6b8e34b274fcb extends $8725869b83961a04$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $8725869b83961a04$export$9d9334239a5a5e06;
    }
}
class $8725869b83961a04$export$f7189e49152d1c13 extends $8725869b83961a04$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $8725869b83961a04$export$c977b3e384af9ae1() : new $8725869b83961a04$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $8725869b83961a04$export$64b5c384219d3699();
        const mat = new $8725869b83961a04$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $8725869b83961a04$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $8725869b83961a04$export$64b5c384219d3699();
        binormals[0] = new $8725869b83961a04$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($8725869b83961a04$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($8725869b83961a04$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $8725869b83961a04$export$3f87a931616cde04 extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $8725869b83961a04$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $8725869b83961a04$export$b1eedc9aab6300e8 extends $8725869b83961a04$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $8725869b83961a04$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $8725869b83961a04$var$tmp = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$px = /*@__PURE__*/ new $8725869b83961a04$var$CubicPoly();
const $8725869b83961a04$var$py = /*@__PURE__*/ new $8725869b83961a04$var$CubicPoly();
const $8725869b83961a04$var$pz = /*@__PURE__*/ new $8725869b83961a04$var$CubicPoly();
class $8725869b83961a04$export$b9146b27c24b744c extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $8725869b83961a04$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $8725869b83961a04$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $8725869b83961a04$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $8725869b83961a04$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $8725869b83961a04$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $8725869b83961a04$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $8725869b83961a04$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $8725869b83961a04$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $8725869b83961a04$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $8725869b83961a04$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($8725869b83961a04$var$px.calc(weight), $8725869b83961a04$var$py.calc(weight), $8725869b83961a04$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $8725869b83961a04$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $8725869b83961a04$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $8725869b83961a04$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $8725869b83961a04$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $8725869b83961a04$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $8725869b83961a04$var$QuadraticBezier(t, p0, p1, p2) {
    return $8725869b83961a04$var$QuadraticBezierP0(t, p0) + $8725869b83961a04$var$QuadraticBezierP1(t, p1) + $8725869b83961a04$var$QuadraticBezierP2(t, p2);
}
//
function $8725869b83961a04$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $8725869b83961a04$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $8725869b83961a04$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $8725869b83961a04$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $8725869b83961a04$var$CubicBezier(t, p0, p1, p2, p3) {
    return $8725869b83961a04$var$CubicBezierP0(t, p0) + $8725869b83961a04$var$CubicBezierP1(t, p1) + $8725869b83961a04$var$CubicBezierP2(t, p2) + $8725869b83961a04$var$CubicBezierP3(t, p3);
}
class $8725869b83961a04$export$e36650d36468bb39 extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$c977b3e384af9ae1(), v1 = new $8725869b83961a04$export$c977b3e384af9ae1(), v2 = new $8725869b83961a04$export$c977b3e384af9ae1(), v3 = new $8725869b83961a04$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($8725869b83961a04$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $8725869b83961a04$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $8725869b83961a04$export$13d5f1c9525f246c extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$64b5c384219d3699(), v1 = new $8725869b83961a04$export$64b5c384219d3699(), v2 = new $8725869b83961a04$export$64b5c384219d3699(), v3 = new $8725869b83961a04$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($8725869b83961a04$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $8725869b83961a04$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $8725869b83961a04$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $8725869b83961a04$export$ab2e07e76531a47e extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $8725869b83961a04$export$c977b3e384af9ae1(), v2 = new $8725869b83961a04$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$1fdfd9d9cf487600 extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $8725869b83961a04$export$64b5c384219d3699(), v2 = new $8725869b83961a04$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$5938c4ee491a43ad extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$c977b3e384af9ae1(), v1 = new $8725869b83961a04$export$c977b3e384af9ae1(), v2 = new $8725869b83961a04$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($8725869b83961a04$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $8725869b83961a04$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$bf3f4c7e459f90fc extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $8725869b83961a04$export$64b5c384219d3699(), v1 = new $8725869b83961a04$export$64b5c384219d3699(), v2 = new $8725869b83961a04$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($8725869b83961a04$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $8725869b83961a04$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $8725869b83961a04$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $8725869b83961a04$export$d3bdd77da77afc1b extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $8725869b83961a04$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($8725869b83961a04$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $8725869b83961a04$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $8725869b83961a04$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $8725869b83961a04$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $8725869b83961a04$export$b9146b27c24b744c,
    CubicBezierCurve: $8725869b83961a04$export$e36650d36468bb39,
    CubicBezierCurve3: $8725869b83961a04$export$13d5f1c9525f246c,
    EllipseCurve: $8725869b83961a04$export$3f87a931616cde04,
    LineCurve: $8725869b83961a04$export$ab2e07e76531a47e,
    LineCurve3: $8725869b83961a04$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $8725869b83961a04$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $8725869b83961a04$export$bf3f4c7e459f90fc,
    SplineCurve: $8725869b83961a04$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $8725869b83961a04$export$4aaf9b66af1bbf2c extends $8725869b83961a04$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $8725869b83961a04$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $8725869b83961a04$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $8725869b83961a04$export$4b2950bdac9b6ee9 extends $8725869b83961a04$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $8725869b83961a04$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $8725869b83961a04$export$ab2e07e76531a47e(this.currentPoint.clone(), new $8725869b83961a04$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $8725869b83961a04$export$5938c4ee491a43ad(this.currentPoint.clone(), new $8725869b83961a04$export$c977b3e384af9ae1(aCPx, aCPy), new $8725869b83961a04$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $8725869b83961a04$export$e36650d36468bb39(this.currentPoint.clone(), new $8725869b83961a04$export$c977b3e384af9ae1(aCP1x, aCP1y), new $8725869b83961a04$export$c977b3e384af9ae1(aCP2x, aCP2y), new $8725869b83961a04$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $8725869b83961a04$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $8725869b83961a04$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $8725869b83961a04$export$6d839803fcd1882c extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(points = [
        new $8725869b83961a04$export$c977b3e384af9ae1(0, -0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0),
        new $8725869b83961a04$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $8725869b83961a04$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const curNormal = new $8725869b83961a04$export$64b5c384219d3699();
        const prevNormal = new $8725869b83961a04$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $8725869b83961a04$export$41680e8551036033 extends $8725869b83961a04$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $8725869b83961a04$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $8725869b83961a04$export$d5c0e8d607467193 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$68f745719dbe5198 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $8725869b83961a04$export$64b5c384219d3699();
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$a7a48974f285c9b3 extends $8725869b83961a04$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$60e57a7d3f20ff65 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $8725869b83961a04$export$64b5c384219d3699();
            const b = new $8725869b83961a04$export$64b5c384219d3699();
            const c = new $8725869b83961a04$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $8725869b83961a04$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $8725869b83961a04$export$64b5c384219d3699();
            const b = new $8725869b83961a04$export$64b5c384219d3699();
            const c = new $8725869b83961a04$export$64b5c384219d3699();
            const centroid = new $8725869b83961a04$export$64b5c384219d3699();
            const uvA = new $8725869b83961a04$export$c977b3e384af9ae1();
            const uvB = new $8725869b83961a04$export$c977b3e384af9ae1();
            const uvC = new $8725869b83961a04$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $8725869b83961a04$export$c0babfeb8708fc9c extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $8725869b83961a04$var$_v0 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v1$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_normal = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_triangle = /*@__PURE__*/ new $8725869b83961a04$export$5a465592bfe74b48();
class $8725869b83961a04$export$4730b1542707547f extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($8725869b83961a04$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $8725869b83961a04$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $8725869b83961a04$var$_triangle.getNormal($8725869b83961a04$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $8725869b83961a04$var$_triangle[vertKeys[j]];
                    const v1 = $8725869b83961a04$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($8725869b83961a04$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $8725869b83961a04$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $8725869b83961a04$var$_v0.fromBufferAttribute(positionAttr, index0);
                $8725869b83961a04$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($8725869b83961a04$var$_v0.x, $8725869b83961a04$var$_v0.y, $8725869b83961a04$var$_v0.z);
                vertices.push($8725869b83961a04$var$_v1$1.x, $8725869b83961a04$var$_v1$1.y, $8725869b83961a04$var$_v1$1.z);
            }
            this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $8725869b83961a04$export$6428a7f2611ef1fa extends $8725869b83961a04$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $8725869b83961a04$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $8725869b83961a04$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $8725869b83961a04$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $8725869b83961a04$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $8725869b83961a04$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $8725869b83961a04$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $8725869b83961a04$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $8725869b83961a04$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $8725869b83961a04$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $8725869b83961a04$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $8725869b83961a04$var$equals(last, last.next)) {
        $8725869b83961a04$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $8725869b83961a04$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($8725869b83961a04$var$equals(p, p.next) || $8725869b83961a04$var$area(p.prev, p, p.next) === 0)) {
            $8725869b83961a04$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $8725869b83961a04$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $8725869b83961a04$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $8725869b83961a04$var$isEarHashed(ear, minX, minY, invSize) : $8725869b83961a04$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $8725869b83961a04$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $8725869b83961a04$var$earcutLinked($8725869b83961a04$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $8725869b83961a04$var$cureLocalIntersections($8725869b83961a04$var$filterPoints(ear), triangles, dim);
                $8725869b83961a04$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $8725869b83961a04$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $8725869b83961a04$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($8725869b83961a04$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $8725869b83961a04$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $8725869b83961a04$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($8725869b83961a04$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $8725869b83961a04$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $8725869b83961a04$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $8725869b83961a04$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $8725869b83961a04$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $8725869b83961a04$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $8725869b83961a04$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $8725869b83961a04$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$8725869b83961a04$var$equals(a, b) && $8725869b83961a04$var$intersects(a, p, p.next, b) && $8725869b83961a04$var$locallyInside(a, b) && $8725869b83961a04$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $8725869b83961a04$var$removeNode(p);
            $8725869b83961a04$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $8725869b83961a04$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $8725869b83961a04$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $8725869b83961a04$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $8725869b83961a04$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $8725869b83961a04$var$filterPoints(a, a.next);
                c = $8725869b83961a04$var$filterPoints(c, c.next);
                // run earcut on each half
                $8725869b83961a04$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $8725869b83961a04$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $8725869b83961a04$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $8725869b83961a04$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($8725869b83961a04$var$getLeftmost(list));
    }
    queue.sort($8725869b83961a04$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $8725869b83961a04$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $8725869b83961a04$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $8725869b83961a04$var$eliminateHole(hole, outerNode) {
    const bridge = $8725869b83961a04$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $8725869b83961a04$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $8725869b83961a04$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $8725869b83961a04$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $8725869b83961a04$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $8725869b83961a04$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($8725869b83961a04$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $8725869b83961a04$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $8725869b83961a04$var$sectorContainsSector(m, p) {
    return $8725869b83961a04$var$area(m.prev, m, p.prev) < 0 && $8725869b83961a04$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $8725869b83961a04$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $8725869b83961a04$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $8725869b83961a04$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $8725869b83961a04$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $8725869b83961a04$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $8725869b83961a04$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $8725869b83961a04$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $8725869b83961a04$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$8725869b83961a04$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($8725869b83961a04$var$locallyInside(a, b) && $8725869b83961a04$var$locallyInside(b, a) && $8725869b83961a04$var$middleInside(a, b) && // locally visible
    ($8725869b83961a04$var$area(a.prev, a, b.prev) || $8725869b83961a04$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $8725869b83961a04$var$equals(a, b) && $8725869b83961a04$var$area(a.prev, a, a.next) > 0 && $8725869b83961a04$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $8725869b83961a04$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $8725869b83961a04$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $8725869b83961a04$var$intersects(p1, q1, p2, q2) {
    const o1 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p1, q1, p2));
    const o2 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p1, q1, q2));
    const o3 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p2, q2, p1));
    const o4 = $8725869b83961a04$var$sign($8725869b83961a04$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $8725869b83961a04$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $8725869b83961a04$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $8725869b83961a04$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $8725869b83961a04$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $8725869b83961a04$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $8725869b83961a04$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $8725869b83961a04$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $8725869b83961a04$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $8725869b83961a04$var$locallyInside(a, b) {
    return $8725869b83961a04$var$area(a.prev, a, a.next) < 0 ? $8725869b83961a04$var$area(a, b, a.next) >= 0 && $8725869b83961a04$var$area(a, a.prev, b) >= 0 : $8725869b83961a04$var$area(a, b, a.prev) < 0 || $8725869b83961a04$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $8725869b83961a04$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $8725869b83961a04$var$splitPolygon(a, b) {
    const a2 = new $8725869b83961a04$var$Node(a.i, a.x, a.y), b2 = new $8725869b83961a04$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $8725869b83961a04$var$insertNode(i, x, y, last) {
    const p = new $8725869b83961a04$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $8725869b83961a04$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $8725869b83961a04$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $8725869b83961a04$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $8725869b83961a04$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $8725869b83961a04$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $8725869b83961a04$var$removeDupEndPts(contour);
        $8725869b83961a04$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($8725869b83961a04$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $8725869b83961a04$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $8725869b83961a04$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $8725869b83961a04$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $8725869b83961a04$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $8725869b83961a04$export$598697a1efa63ca7 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(shapes = new $8725869b83961a04$export$6428a7f2611ef1fa([
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, 0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(-0.5, 0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(-0.5, -0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $8725869b83961a04$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $8725869b83961a04$export$64b5c384219d3699();
                normal = new $8725869b83961a04$export$64b5c384219d3699();
                position2 = new $8725869b83961a04$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $8725869b83961a04$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $8725869b83961a04$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $8725869b83961a04$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $8725869b83961a04$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $8725869b83961a04$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $8725869b83961a04$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $8725869b83961a04$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $8725869b83961a04$export$c977b3e384af9ae1(a_x, a_y),
            new $8725869b83961a04$export$c977b3e384af9ae1(b_x, b_y),
            new $8725869b83961a04$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $8725869b83961a04$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $8725869b83961a04$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $8725869b83961a04$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $8725869b83961a04$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $8725869b83961a04$export$9567cc828c9535da extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $8725869b83961a04$export$1954e2b809fe361e extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $8725869b83961a04$export$68cb731f50f614af extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$57a29a1c803e9065 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(shapes = new $8725869b83961a04$export$6428a7f2611ef1fa([
        new $8725869b83961a04$export$c977b3e384af9ae1(0, 0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(-0.5, -0.5),
        new $8725869b83961a04$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $8725869b83961a04$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $8725869b83961a04$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $8725869b83961a04$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $8725869b83961a04$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $8725869b83961a04$export$1b417fc3b307a251 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $8725869b83961a04$export$fb3f7adc68bd6e02 extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $8725869b83961a04$export$a2312a2a1fa56495 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $8725869b83961a04$export$64b5c384219d3699();
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $8725869b83961a04$export$77e9bfadfb9ab8c8 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const P1 = new $8725869b83961a04$export$64b5c384219d3699();
        const P2 = new $8725869b83961a04$export$64b5c384219d3699();
        const B = new $8725869b83961a04$export$64b5c384219d3699();
        const T = new $8725869b83961a04$export$64b5c384219d3699();
        const N = new $8725869b83961a04$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $8725869b83961a04$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $8725869b83961a04$export$7897d9d48904490c extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(path = new $8725869b83961a04$export$bf3f4c7e459f90fc(new $8725869b83961a04$export$64b5c384219d3699(-1, -1, 0), new $8725869b83961a04$export$64b5c384219d3699(-1, 1, 0), new $8725869b83961a04$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        const normal = new $8725869b83961a04$export$64b5c384219d3699();
        const uv = new $8725869b83961a04$export$c977b3e384af9ae1();
        let P = new $8725869b83961a04$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $8725869b83961a04$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $8725869b83961a04$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $8725869b83961a04$export$7897d9d48904490c(new $8725869b83961a04$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $8725869b83961a04$export$4b739da06d24892b extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $8725869b83961a04$export$64b5c384219d3699();
            const end = new $8725869b83961a04$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($8725869b83961a04$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($8725869b83961a04$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $8725869b83961a04$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $8725869b83961a04$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $8725869b83961a04$export$33e43285f7406bd5,
    CapsuleGeometry: $8725869b83961a04$export$41680e8551036033,
    CircleGeometry: $8725869b83961a04$export$d5c0e8d607467193,
    ConeGeometry: $8725869b83961a04$export$a7a48974f285c9b3,
    CylinderGeometry: $8725869b83961a04$export$68f745719dbe5198,
    DodecahedronGeometry: $8725869b83961a04$export$c0babfeb8708fc9c,
    EdgesGeometry: $8725869b83961a04$export$4730b1542707547f,
    ExtrudeGeometry: $8725869b83961a04$export$598697a1efa63ca7,
    IcosahedronGeometry: $8725869b83961a04$export$9567cc828c9535da,
    LatheGeometry: $8725869b83961a04$export$6d839803fcd1882c,
    OctahedronGeometry: $8725869b83961a04$export$1954e2b809fe361e,
    PlaneGeometry: $8725869b83961a04$export$967d831af31f69ce,
    PolyhedronGeometry: $8725869b83961a04$export$60e57a7d3f20ff65,
    RingGeometry: $8725869b83961a04$export$68cb731f50f614af,
    ShapeGeometry: $8725869b83961a04$export$57a29a1c803e9065,
    SphereGeometry: $8725869b83961a04$export$1b417fc3b307a251,
    TetrahedronGeometry: $8725869b83961a04$export$fb3f7adc68bd6e02,
    TorusGeometry: $8725869b83961a04$export$a2312a2a1fa56495,
    TorusKnotGeometry: $8725869b83961a04$export$77e9bfadfb9ab8c8,
    TubeGeometry: $8725869b83961a04$export$7897d9d48904490c,
    WireframeGeometry: $8725869b83961a04$export$4b739da06d24892b
});
class $8725869b83961a04$export$e8564da406055a3 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$21c421a2e1df9d22 extends $8725869b83961a04$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $8725869b83961a04$export$f2980790215acccd extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$28d04986c4269c9f extends $8725869b83961a04$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $8725869b83961a04$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $8725869b83961a04$export$24c72f71cbaf0678 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $8725869b83961a04$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $8725869b83961a04$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$df893cf97e765622 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$bfe8c0a091f41ae7 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $8725869b83961a04$export$5023a9a8114806b8 extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $8725869b83961a04$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $8725869b83961a04$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$6f5fef6235ec12ee extends $8725869b83961a04$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $8725869b83961a04$export$2852a58ebdac27b8;
        this.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $8725869b83961a04$export$327886a3efaeaebe extends $8725869b83961a04$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $8725869b83961a04$var$arraySlice(array, from, to) {
    if ($8725869b83961a04$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $8725869b83961a04$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $8725869b83961a04$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $8725869b83961a04$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $8725869b83961a04$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $8725869b83961a04$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $8725869b83961a04$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $8725869b83961a04$var$convertArray(times, track.times.constructor);
        track.values = $8725869b83961a04$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $8725869b83961a04$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $8725869b83961a04$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $8725869b83961a04$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $8725869b83961a04$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $8725869b83961a04$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $8725869b83961a04$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $8725869b83961a04$export$d875e029ef558d3;
    return targetClip;
}
const $8725869b83961a04$export$7ee8caa573e71ad1 = {
    arraySlice: $8725869b83961a04$var$arraySlice,
    convertArray: $8725869b83961a04$var$convertArray,
    isTypedArray: $8725869b83961a04$var$isTypedArray,
    getKeyframeOrder: $8725869b83961a04$var$getKeyframeOrder,
    sortedArray: $8725869b83961a04$var$sortedArray,
    flattenJSON: $8725869b83961a04$var$flattenJSON,
    subclip: $8725869b83961a04$var$subclip,
    makeClipAdditive: $8725869b83961a04$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $8725869b83961a04$export$3646682e7a3959 extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $8725869b83961a04$export$7f795934b84ab523,
            endingEnd: $8725869b83961a04$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $8725869b83961a04$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $8725869b83961a04$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $8725869b83961a04$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $8725869b83961a04$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $8725869b83961a04$export$a8e6009059f51e1a extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $8725869b83961a04$export$fb9758ef7ef8d5cc extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $8725869b83961a04$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $8725869b83961a04$var$convertArray(times, this.TimeBufferType);
        this.values = $8725869b83961a04$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $8725869b83961a04$var$convertArray(track.times, Array),
                "values": $8725869b83961a04$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $8725869b83961a04$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $8725869b83961a04$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $8725869b83961a04$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $8725869b83961a04$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $8725869b83961a04$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $8725869b83961a04$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $8725869b83961a04$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $8725869b83961a04$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $8725869b83961a04$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $8725869b83961a04$var$arraySlice(times, from, to);
            this.values = $8725869b83961a04$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($8725869b83961a04$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $8725869b83961a04$var$arraySlice(this.times), values = $8725869b83961a04$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $8725869b83961a04$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $8725869b83961a04$var$arraySlice(times, 0, writeIndex);
            this.values = $8725869b83961a04$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $8725869b83961a04$var$arraySlice(this.times, 0);
        const values = $8725869b83961a04$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$8725869b83961a04$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$8725869b83961a04$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$8725869b83961a04$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $8725869b83961a04$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $8725869b83961a04$export$d3a344b98cf0b775 extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$8725869b83961a04$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$8725869b83961a04$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $8725869b83961a04$export$995b32462a65e855;
$8725869b83961a04$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$8725869b83961a04$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $8725869b83961a04$export$83444c5d885347d8 extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $8725869b83961a04$export$d45f0d1a4d9a9314 extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $8725869b83961a04$export$2db1cfb7923d931e extends $8725869b83961a04$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$8725869b83961a04$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $8725869b83961a04$export$b8043f12b5aafbd7 extends $8725869b83961a04$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $8725869b83961a04$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$8725869b83961a04$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$8725869b83961a04$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $8725869b83961a04$export$30fac1aace31cf4d;
$8725869b83961a04$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $8725869b83961a04$export$6ce41d4f3a8df9cd extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $8725869b83961a04$export$995b32462a65e855;
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$8725869b83961a04$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $8725869b83961a04$export$5ce2dcb4cc9f2bff extends $8725869b83961a04$export$b0e479f45b7006d6 {
}
$8725869b83961a04$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $8725869b83961a04$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $8725869b83961a04$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $8725869b83961a04$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($8725869b83961a04$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($8725869b83961a04$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $8725869b83961a04$var$getKeyframeOrder(times);
            times = $8725869b83961a04$var$sortedArray(times, 1, order);
            values = $8725869b83961a04$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $8725869b83961a04$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $8725869b83961a04$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $8725869b83961a04$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($8725869b83961a04$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($8725869b83961a04$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($8725869b83961a04$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $8725869b83961a04$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $8725869b83961a04$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $8725869b83961a04$export$5ce2dcb4cc9f2bff;
        case "color":
            return $8725869b83961a04$export$83444c5d885347d8;
        case "quaternion":
            return $8725869b83961a04$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $8725869b83961a04$export$d3a344b98cf0b775;
        case "string":
            return $8725869b83961a04$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $8725869b83961a04$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $8725869b83961a04$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $8725869b83961a04$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $8725869b83961a04$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $8725869b83961a04$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $8725869b83961a04$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $8725869b83961a04$export$99cc795e99919eed();
class $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $8725869b83961a04$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $8725869b83961a04$var$loading = {};
class $8725869b83961a04$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $8725869b83961a04$export$98435a25b5cf7b2b extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $8725869b83961a04$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($8725869b83961a04$var$loading[url] !== undefined) {
            $8725869b83961a04$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $8725869b83961a04$var$loading[url] = [];
        $8725869b83961a04$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $8725869b83961a04$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("Content-Length") || response.headers.get("X-File-Size");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $8725869b83961a04$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $8725869b83961a04$export$94affb487e701bf2.add(url, data);
            const callbacks = $8725869b83961a04$var$loading[url];
            delete $8725869b83961a04$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $8725869b83961a04$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $8725869b83961a04$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $8725869b83961a04$export$29711c7e14f61db extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $8725869b83961a04$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $8725869b83961a04$export$bd73ce947a280350 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $8725869b83961a04$export$3466bac9141a5cc4();
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $8725869b83961a04$export$8905ce1c7a2464a1 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $8725869b83961a04$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $8725869b83961a04$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $8725869b83961a04$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $8725869b83961a04$export$2ec114afc2cf6308 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $8725869b83961a04$export$ee2e5a18258a4049();
        texture.colorSpace = $8725869b83961a04$export$561f394b24edfcaa;
        const loader = new $8725869b83961a04$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $8725869b83961a04$export$792d8a18f2c55855 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $8725869b83961a04$export$b691f601014eabe1();
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $8725869b83961a04$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $8725869b83961a04$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $8725869b83961a04$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $8725869b83961a04$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $8725869b83961a04$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $8725869b83961a04$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $8725869b83961a04$export$fd1bfc71f64c538c extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $8725869b83961a04$export$5431306cf43de24a();
        const loader = new $8725869b83961a04$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $8725869b83961a04$export$6ecadb6ed240d696 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $8725869b83961a04$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $8725869b83961a04$export$8d474f55edbb9624 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $8725869b83961a04$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $8725869b83961a04$var$_projScreenMatrix$1 = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_lightPositionWorld$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_lookTarget$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $8725869b83961a04$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $8725869b83961a04$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $8725869b83961a04$export$35efe6f4c85463d2();
        this._frameExtents = new $8725869b83961a04$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $8725869b83961a04$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $8725869b83961a04$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($8725869b83961a04$var$_lightPositionWorld$1);
        $8725869b83961a04$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($8725869b83961a04$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $8725869b83961a04$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($8725869b83961a04$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($8725869b83961a04$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $8725869b83961a04$var$SpotLightShadow extends $8725869b83961a04$var$LightShadow {
    constructor(){
        super(new $8725869b83961a04$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $8725869b83961a04$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $8725869b83961a04$export$81495cbb73897362 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $8725869b83961a04$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $8725869b83961a04$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $8725869b83961a04$var$_projScreenMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_lightPositionWorld = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_lookTarget = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$var$PointLightShadow extends $8725869b83961a04$var$LightShadow {
    constructor(){
        super(new $8725869b83961a04$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $8725869b83961a04$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $8725869b83961a04$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $8725869b83961a04$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $8725869b83961a04$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $8725869b83961a04$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $8725869b83961a04$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $8725869b83961a04$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $8725869b83961a04$export$64b5c384219d3699(1, 0, 0),
            new $8725869b83961a04$export$64b5c384219d3699(-1, 0, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, -1),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 1, 0),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1),
            new $8725869b83961a04$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $8725869b83961a04$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($8725869b83961a04$var$_lightPositionWorld);
        $8725869b83961a04$var$_lookTarget.copy(camera.position);
        $8725869b83961a04$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($8725869b83961a04$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$8725869b83961a04$var$_lightPositionWorld.x, -$8725869b83961a04$var$_lightPositionWorld.y, -$8725869b83961a04$var$_lightPositionWorld.z);
        $8725869b83961a04$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($8725869b83961a04$var$_projScreenMatrix);
    }
}
class $8725869b83961a04$export$4c9c1cb3f0b6f455 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $8725869b83961a04$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $8725869b83961a04$var$DirectionalLightShadow extends $8725869b83961a04$var$LightShadow {
    constructor(){
        super(new $8725869b83961a04$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $8725869b83961a04$export$3fea33cc9972c868 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($8725869b83961a04$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $8725869b83961a04$export$e4dd07dff30cc924();
        this.shadow = new $8725869b83961a04$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $8725869b83961a04$export$af279bfef9ec2c96 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $8725869b83961a04$export$61db2d908bbd2429 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $8725869b83961a04$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $8725869b83961a04$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $8725869b83961a04$export$e7ef036e309b38d2 extends $8725869b83961a04$export$6ecadb6ed240d696 {
    constructor(sh = new $8725869b83961a04$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $8725869b83961a04$export$3bd6d323353dcf96 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $8725869b83961a04$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $8725869b83961a04$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $8725869b83961a04$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $8725869b83961a04$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $8725869b83961a04$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $8725869b83961a04$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $8725869b83961a04$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $8725869b83961a04$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $8725869b83961a04$export$e8564da406055a3,
            SpriteMaterial: $8725869b83961a04$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $8725869b83961a04$export$21c421a2e1df9d22,
            ShaderMaterial: $8725869b83961a04$export$83c7d75d550a8b0d,
            PointsMaterial: $8725869b83961a04$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $8725869b83961a04$export$28d04986c4269c9f,
            MeshStandardMaterial: $8725869b83961a04$export$f2980790215acccd,
            MeshPhongMaterial: $8725869b83961a04$export$24c72f71cbaf0678,
            MeshToonMaterial: $8725869b83961a04$export$df893cf97e765622,
            MeshNormalMaterial: $8725869b83961a04$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $8725869b83961a04$export$5023a9a8114806b8,
            MeshDepthMaterial: $8725869b83961a04$export$2698c22ec13825db,
            MeshDistanceMaterial: $8725869b83961a04$export$33e187ed002f2a19,
            MeshBasicMaterial: $8725869b83961a04$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $8725869b83961a04$export$6f5fef6235ec12ee,
            LineDashedMaterial: $8725869b83961a04$export$327886a3efaeaebe,
            LineBasicMaterial: $8725869b83961a04$export$fbaaa33907730a0c,
            Material: $8725869b83961a04$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $8725869b83961a04$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $8725869b83961a04$export$231f009cbe414146 extends $8725869b83961a04$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $8725869b83961a04$export$dc275bb96327833a extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $8725869b83961a04$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $8725869b83961a04$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $8725869b83961a04$export$231f009cbe414146() : new $8725869b83961a04$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $8725869b83961a04$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $8725869b83961a04$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $8725869b83961a04$export$32ea87a8b54d744a : $8725869b83961a04$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $8725869b83961a04$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $8725869b83961a04$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $8725869b83961a04$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $8725869b83961a04$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $8725869b83961a04$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $8725869b83961a04$export$40110c8505c5ad19 extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $8725869b83961a04$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $8725869b83961a04$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $8725869b83961a04$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $8725869b83961a04$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $8725869b83961a04$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $8725869b83961a04$var$Geometries) geometry = $8725869b83961a04$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $8725869b83961a04$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $8725869b83961a04$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $8725869b83961a04$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $8725869b83961a04$export$99cc795e99919eed(onLoad);
            loader = new $8725869b83961a04$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $8725869b83961a04$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $8725869b83961a04$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $8725869b83961a04$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $8725869b83961a04$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $8725869b83961a04$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $8725869b83961a04$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $8725869b83961a04$export$b691f601014eabe1();
                else texture = new $8725869b83961a04$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $8725869b83961a04$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $8725869b83961a04$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $8725869b83961a04$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $8725869b83961a04$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $8725869b83961a04$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $8725869b83961a04$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $8725869b83961a04$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $8725869b83961a04$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $8725869b83961a04$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case "PerspectiveCamera":
                object = new $8725869b83961a04$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $8725869b83961a04$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $8725869b83961a04$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $8725869b83961a04$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $8725869b83961a04$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $8725869b83961a04$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $8725869b83961a04$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $8725869b83961a04$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $8725869b83961a04$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $8725869b83961a04$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $8725869b83961a04$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $8725869b83961a04$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $8725869b83961a04$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $8725869b83961a04$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $8725869b83961a04$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $8725869b83961a04$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $8725869b83961a04$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $8725869b83961a04$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $8725869b83961a04$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $8725869b83961a04$export$b127726e56765aa4();
                break;
            default:
                object = new $8725869b83961a04$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $8725869b83961a04$var$TEXTURE_MAPPING = {
    UVMapping: $8725869b83961a04$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $8725869b83961a04$export$8759762a6477f2c4,
    CubeRefractionMapping: $8725869b83961a04$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $8725869b83961a04$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $8725869b83961a04$export$ee99d97d46898098,
    CubeUVReflectionMapping: $8725869b83961a04$export$dbf3e70ff37af79
};
const $8725869b83961a04$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $8725869b83961a04$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $8725869b83961a04$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $8725869b83961a04$export$c7e7c00b14f51a4f
};
const $8725869b83961a04$var$TEXTURE_FILTER = {
    NearestFilter: $8725869b83961a04$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $8725869b83961a04$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $8725869b83961a04$export$d2327c1afe5bfdf2,
    LinearFilter: $8725869b83961a04$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $8725869b83961a04$export$19a719f377145a13,
    LinearMipmapLinearFilter: $8725869b83961a04$export$5d8599b6a933fb1b
};
class $8725869b83961a04$export$52286b55c4a9b51f extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $8725869b83961a04$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $8725869b83961a04$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $8725869b83961a04$var$_context;
class $8725869b83961a04$export$fcbc63750ec2a81f {
    static getContext() {
        if ($8725869b83961a04$var$_context === undefined) $8725869b83961a04$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $8725869b83961a04$var$_context;
    }
    static setContext(value) {
        $8725869b83961a04$var$_context = value;
    }
}
class $8725869b83961a04$export$d8d5fccfbf47714e extends $8725869b83961a04$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $8725869b83961a04$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
class $8725869b83961a04$export$2f22dadc8bc42820 extends $8725869b83961a04$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $8725869b83961a04$export$892596cec99bc70e().set(skyColor);
        const color2 = new $8725869b83961a04$export$892596cec99bc70e().set(groundColor);
        const sky = new $8725869b83961a04$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $8725869b83961a04$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $8725869b83961a04$export$afe310a21c86023d extends $8725869b83961a04$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $8725869b83961a04$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $8725869b83961a04$var$_eyeRight = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_eyeLeft = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_projectionMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $8725869b83961a04$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $8725869b83961a04$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $8725869b83961a04$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($8725869b83961a04$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $8725869b83961a04$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $8725869b83961a04$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $8725869b83961a04$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $8725869b83961a04$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($8725869b83961a04$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $8725869b83961a04$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $8725869b83961a04$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($8725869b83961a04$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($8725869b83961a04$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($8725869b83961a04$var$_eyeRight);
    }
}
class $8725869b83961a04$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $8725869b83961a04$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $8725869b83961a04$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $8725869b83961a04$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $8725869b83961a04$var$_position$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion$1 = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_scale$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_orientation$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$8a1b810c6fde8951 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $8725869b83961a04$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $8725869b83961a04$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($8725869b83961a04$var$_position$1, $8725869b83961a04$var$_quaternion$1, $8725869b83961a04$var$_scale$1);
        $8725869b83961a04$var$_orientation$1.set(0, 0, -1).applyQuaternion($8725869b83961a04$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($8725869b83961a04$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($8725869b83961a04$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($8725869b83961a04$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($8725869b83961a04$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($8725869b83961a04$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($8725869b83961a04$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($8725869b83961a04$var$_position$1.x, $8725869b83961a04$var$_position$1.y, $8725869b83961a04$var$_position$1.z);
            listener.setOrientation($8725869b83961a04$var$_orientation$1.x, $8725869b83961a04$var$_orientation$1.y, $8725869b83961a04$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $8725869b83961a04$export$153755f98d9861de extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $8725869b83961a04$var$_position = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_quaternion = /*@__PURE__*/ new $8725869b83961a04$export$23d6a54f0bbc85a3();
const $8725869b83961a04$var$_scale = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_orientation = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$4b3e397ef1832507 extends $8725869b83961a04$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($8725869b83961a04$var$_position, $8725869b83961a04$var$_quaternion, $8725869b83961a04$var$_scale);
        $8725869b83961a04$var$_orientation.set(0, 0, 1).applyQuaternion($8725869b83961a04$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($8725869b83961a04$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($8725869b83961a04$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($8725869b83961a04$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($8725869b83961a04$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($8725869b83961a04$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($8725869b83961a04$var$_orientation.z, endTime);
        } else {
            panner.setPosition($8725869b83961a04$var$_position.x, $8725869b83961a04$var$_position.y, $8725869b83961a04$var$_position.z);
            panner.setOrientation($8725869b83961a04$var$_orientation.x, $8725869b83961a04$var$_orientation.y, $8725869b83961a04$var$_orientation.z);
        }
    }
}
class $8725869b83961a04$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $8725869b83961a04$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $8725869b83961a04$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $8725869b83961a04$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $8725869b83961a04$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $8725869b83961a04$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $8725869b83961a04$var$_reservedRe = new RegExp("[" + $8725869b83961a04$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $8725869b83961a04$var$_wordChar = "[^" + $8725869b83961a04$var$_RESERVED_CHARS_RE + "]";
const $8725869b83961a04$var$_wordCharOrDot = "[^" + $8725869b83961a04$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $8725869b83961a04$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $8725869b83961a04$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $8725869b83961a04$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $8725869b83961a04$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $8725869b83961a04$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $8725869b83961a04$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $8725869b83961a04$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $8725869b83961a04$var$_wordChar);
const $8725869b83961a04$var$_trackRe = new RegExp("^" + $8725869b83961a04$var$_directoryRe + $8725869b83961a04$var$_nodeRe + $8725869b83961a04$var$_objectRe + $8725869b83961a04$var$_propertyRe + "$");
const $8725869b83961a04$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $8725869b83961a04$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $8725869b83961a04$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $8725869b83961a04$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $8725869b83961a04$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $8725869b83961a04$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $8725869b83961a04$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $8725869b83961a04$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($8725869b83961a04$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $8725869b83961a04$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($8725869b83961a04$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $8725869b83961a04$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$8725869b83961a04$export$7bf70fcf9f891893.Composite = $8725869b83961a04$var$Composite;
$8725869b83961a04$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$8725869b83961a04$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$8725869b83961a04$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_direct,
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_array,
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $8725869b83961a04$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$8725869b83961a04$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_direct,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_array,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $8725869b83961a04$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $8725869b83961a04$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $8725869b83961a04$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $8725869b83961a04$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $8725869b83961a04$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $8725869b83961a04$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $8725869b83961a04$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $8725869b83961a04$export$7f795934b84ab523,
            endingEnd: $8725869b83961a04$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $8725869b83961a04$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $8725869b83961a04$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $8725869b83961a04$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $8725869b83961a04$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $8725869b83961a04$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $8725869b83961a04$export$24a4ccb5099273b5;
            settings.endingEnd = $8725869b83961a04$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $8725869b83961a04$export$24a4ccb5099273b5 : $8725869b83961a04$export$7f795934b84ab523;
            else settings.endingStart = $8725869b83961a04$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $8725869b83961a04$export$24a4ccb5099273b5 : $8725869b83961a04$export$7f795934b84ab523;
            else settings.endingEnd = $8725869b83961a04$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $8725869b83961a04$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $8725869b83961a04$export$fbd77e5aefaa0102 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $8725869b83961a04$export$dfe0af1ca1acb78a($8725869b83961a04$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $8725869b83961a04$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $8725869b83961a04$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $8725869b83961a04$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $8725869b83961a04$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $8725869b83961a04$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $8725869b83961a04$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $8725869b83961a04$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $8725869b83961a04$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $8725869b83961a04$var$id = 0;
class $8725869b83961a04$export$c412d5ffe1f79209 extends $8725869b83961a04$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $8725869b83961a04$var$id++
        });
        this.name = "";
        this.usage = $8725869b83961a04$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $8725869b83961a04$export$25ec0e1af1389358 extends $8725869b83961a04$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $8725869b83961a04$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $8725869b83961a04$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $8725869b83961a04$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $8725869b83961a04$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $8725869b83961a04$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($8725869b83961a04$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$8725869b83961a04$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($8725869b83961a04$var$ascSort);
        return intersects;
    }
}
function $8725869b83961a04$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $8725869b83961a04$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$8725869b83961a04$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $8725869b83961a04$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($8725869b83961a04$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $8725869b83961a04$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_vector$4 = /*@__PURE__*/ new $8725869b83961a04$export$c977b3e384af9ae1();
class $8725869b83961a04$export$60f553fa130f08b0 {
    constructor(min = new $8725869b83961a04$export$c977b3e384af9ae1(Infinity, Infinity), max = new $8725869b83961a04$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $8725869b83961a04$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $8725869b83961a04$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $8725869b83961a04$var$_startP = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_startEnd = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$e0ba6359f1954fd3 {
    constructor(start = new $8725869b83961a04$export$64b5c384219d3699(), end = new $8725869b83961a04$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $8725869b83961a04$var$_startP.subVectors(point, this.start);
        $8725869b83961a04$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $8725869b83961a04$var$_startEnd.dot($8725869b83961a04$var$_startEnd);
        const startEnd_startP = $8725869b83961a04$var$_startEnd.dot($8725869b83961a04$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $8725869b83961a04$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $8725869b83961a04$var$_vector$3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$4b14638ffdd81e68 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(positions, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $8725869b83961a04$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $8725869b83961a04$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($8725869b83961a04$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $8725869b83961a04$var$_vector$2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_boneMatrix = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
const $8725869b83961a04$var$_matrixWorldInv = /*@__PURE__*/ new $8725869b83961a04$export$2ae72fc923e5eb5();
class $8725869b83961a04$export$5277df3c9e732259 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $8725869b83961a04$var$getBoneList(object);
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $8725869b83961a04$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $8725869b83961a04$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $8725869b83961a04$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $8725869b83961a04$var$_boneMatrix.multiplyMatrices($8725869b83961a04$var$_matrixWorldInv, bone.matrixWorld);
                $8725869b83961a04$var$_vector$2.setFromMatrixPosition($8725869b83961a04$var$_boneMatrix);
                position.setXYZ(j, $8725869b83961a04$var$_vector$2.x, $8725869b83961a04$var$_vector$2.y, $8725869b83961a04$var$_vector$2.z);
                $8725869b83961a04$var$_boneMatrix.multiplyMatrices($8725869b83961a04$var$_matrixWorldInv, bone.parent.matrixWorld);
                $8725869b83961a04$var$_vector$2.setFromMatrixPosition($8725869b83961a04$var$_boneMatrix);
                position.setXYZ(j + 1, $8725869b83961a04$var$_vector$2.x, $8725869b83961a04$var$_vector$2.y, $8725869b83961a04$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $8725869b83961a04$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $8725869b83961a04$var$getBoneList(object.children[i]));
    return boneList;
}
class $8725869b83961a04$export$9a9291685b9e4023 extends $8725869b83961a04$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $8725869b83961a04$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $8725869b83961a04$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $8725869b83961a04$var$_vector$1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_color1 = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
const $8725869b83961a04$var$_color2 = /*@__PURE__*/ new $8725869b83961a04$export$892596cec99bc70e();
class $8725869b83961a04$export$8dca15f13f4f8172 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $8725869b83961a04$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $8725869b83961a04$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $8725869b83961a04$export$8dea267bd6bde117(colors, 3));
        this.add(new $8725869b83961a04$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $8725869b83961a04$var$_color1.copy(this.light.color);
            $8725869b83961a04$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $8725869b83961a04$var$_color1 : $8725869b83961a04$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($8725869b83961a04$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $8725869b83961a04$export$3875d39926561055 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $8725869b83961a04$export$892596cec99bc70e(color1);
        color2 = new $8725869b83961a04$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$361430a10f533cd3 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $8725869b83961a04$export$892596cec99bc70e(color1);
        color2 = new $8725869b83961a04$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $8725869b83961a04$var$_v1 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v2 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_v3 = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
class $8725869b83961a04$export$f8e434dc14203e7d extends $8725869b83961a04$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $8725869b83961a04$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $8725869b83961a04$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $8725869b83961a04$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $8725869b83961a04$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $8725869b83961a04$var$_v3.subVectors($8725869b83961a04$var$_v2, $8725869b83961a04$var$_v1);
        this.lightPlane.lookAt($8725869b83961a04$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($8725869b83961a04$var$_v2);
        this.targetLine.scale.z = $8725869b83961a04$var$_v3.length();
    }
}
const $8725869b83961a04$var$_vector = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
const $8725869b83961a04$var$_camera = /*@__PURE__*/ new $8725869b83961a04$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $8725869b83961a04$export$ed8e93f853cd795 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $8725869b83961a04$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $8725869b83961a04$export$892596cec99bc70e(0xff0000);
        const colorUp = new $8725869b83961a04$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $8725869b83961a04$export$892596cec99bc70e(0xffffff);
        const colorCross = new $8725869b83961a04$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $8725869b83961a04$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $8725869b83961a04$var$setPoint("c", pointMap, geometry, $8725869b83961a04$var$_camera, 0, 0, -1);
        $8725869b83961a04$var$setPoint("t", pointMap, geometry, $8725869b83961a04$var$_camera, 0, 0, 1);
        // near
        $8725869b83961a04$var$setPoint("n1", pointMap, geometry, $8725869b83961a04$var$_camera, -w, -h, -1);
        $8725869b83961a04$var$setPoint("n2", pointMap, geometry, $8725869b83961a04$var$_camera, w, -h, -1);
        $8725869b83961a04$var$setPoint("n3", pointMap, geometry, $8725869b83961a04$var$_camera, -w, h, -1);
        $8725869b83961a04$var$setPoint("n4", pointMap, geometry, $8725869b83961a04$var$_camera, w, h, -1);
        // far
        $8725869b83961a04$var$setPoint("f1", pointMap, geometry, $8725869b83961a04$var$_camera, -w, -h, 1);
        $8725869b83961a04$var$setPoint("f2", pointMap, geometry, $8725869b83961a04$var$_camera, w, -h, 1);
        $8725869b83961a04$var$setPoint("f3", pointMap, geometry, $8725869b83961a04$var$_camera, -w, h, 1);
        $8725869b83961a04$var$setPoint("f4", pointMap, geometry, $8725869b83961a04$var$_camera, w, h, 1);
        // up
        $8725869b83961a04$var$setPoint("u1", pointMap, geometry, $8725869b83961a04$var$_camera, w * 0.7, h * 1.1, -1);
        $8725869b83961a04$var$setPoint("u2", pointMap, geometry, $8725869b83961a04$var$_camera, -w * 0.7, h * 1.1, -1);
        $8725869b83961a04$var$setPoint("u3", pointMap, geometry, $8725869b83961a04$var$_camera, 0, h * 2, -1);
        // cross
        $8725869b83961a04$var$setPoint("cf1", pointMap, geometry, $8725869b83961a04$var$_camera, -w, 0, 1);
        $8725869b83961a04$var$setPoint("cf2", pointMap, geometry, $8725869b83961a04$var$_camera, w, 0, 1);
        $8725869b83961a04$var$setPoint("cf3", pointMap, geometry, $8725869b83961a04$var$_camera, 0, -h, 1);
        $8725869b83961a04$var$setPoint("cf4", pointMap, geometry, $8725869b83961a04$var$_camera, 0, h, 1);
        $8725869b83961a04$var$setPoint("cn1", pointMap, geometry, $8725869b83961a04$var$_camera, -w, 0, -1);
        $8725869b83961a04$var$setPoint("cn2", pointMap, geometry, $8725869b83961a04$var$_camera, w, 0, -1);
        $8725869b83961a04$var$setPoint("cn3", pointMap, geometry, $8725869b83961a04$var$_camera, 0, -h, -1);
        $8725869b83961a04$var$setPoint("cn4", pointMap, geometry, $8725869b83961a04$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $8725869b83961a04$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $8725869b83961a04$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $8725869b83961a04$var$_vector.x, $8725869b83961a04$var$_vector.y, $8725869b83961a04$var$_vector.z);
    }
}
const $8725869b83961a04$var$_box = /*@__PURE__*/ new $8725869b83961a04$export$6f7d5a9418ab2aa3();
class $8725869b83961a04$export$38a664cc862a6a9d extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $8725869b83961a04$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $8725869b83961a04$var$_box.setFromObject(this.object);
        if ($8725869b83961a04$var$_box.isEmpty()) return;
        const min = $8725869b83961a04$var$_box.min;
        const max = $8725869b83961a04$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$ce39f4bb96c9a290 extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setIndex(new $8725869b83961a04$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$a34fe8156c66e5d7 extends $8725869b83961a04$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $8725869b83961a04$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $8725869b83961a04$export$e176487c05830cc5(geometry2, new $8725869b83961a04$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $8725869b83961a04$var$_axis = /*@__PURE__*/ new $8725869b83961a04$export$64b5c384219d3699();
let $8725869b83961a04$var$_lineGeometry, $8725869b83961a04$var$_coneGeometry;
class $8725869b83961a04$export$a3008e7bd8d2cbe7 extends $8725869b83961a04$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $8725869b83961a04$export$64b5c384219d3699(0, 0, 1), origin = new $8725869b83961a04$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($8725869b83961a04$var$_lineGeometry === undefined) {
            $8725869b83961a04$var$_lineGeometry = new $8725869b83961a04$export$b7be63a67df8959();
            $8725869b83961a04$var$_lineGeometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $8725869b83961a04$var$_coneGeometry = new $8725869b83961a04$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $8725869b83961a04$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $8725869b83961a04$export$17d680238e50603e($8725869b83961a04$var$_lineGeometry, new $8725869b83961a04$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $8725869b83961a04$export$e176487c05830cc5($8725869b83961a04$var$_coneGeometry, new $8725869b83961a04$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $8725869b83961a04$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($8725869b83961a04$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $8725869b83961a04$export$6c8303f35b8578fd extends $8725869b83961a04$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $8725869b83961a04$export$b7be63a67df8959();
        geometry.setAttribute("position", new $8725869b83961a04$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $8725869b83961a04$export$cbe7a62641830ebd(colors, 3));
        const material = new $8725869b83961a04$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $8725869b83961a04$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $8725869b83961a04$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $8725869b83961a04$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $8725869b83961a04$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $8725869b83961a04$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $8725869b83961a04$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $8725869b83961a04$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $8725869b83961a04$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $8725869b83961a04$export$ab3456a079aa7d80 extends $8725869b83961a04$export$33e43285f7406bd5 {
    constructor(width, height, depth, widthSegments, heightSegments, depthSegments){
        console.warn("THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.");
        super(width, height, depth, widthSegments, heightSegments, depthSegments);
    }
}
class $8725869b83961a04$export$f036d76f832848a extends $8725869b83961a04$export$41680e8551036033 {
    constructor(radius, length, capSegments, radialSegments){
        console.warn("THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.");
        super(radius, length, capSegments, radialSegments);
    }
}
class $8725869b83961a04$export$3f74fe60decf7462 extends $8725869b83961a04$export$d5c0e8d607467193 {
    constructor(radius, segments, thetaStart, thetaLength){
        console.warn("THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.");
        super(radius, segments, thetaStart, thetaLength);
    }
}
class $8725869b83961a04$export$59d971120dc8b6e7 extends $8725869b83961a04$export$a7a48974f285c9b3 {
    constructor(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.");
        super(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $8725869b83961a04$export$d4345c83207d7c68 extends $8725869b83961a04$export$68f745719dbe5198 {
    constructor(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.");
        super(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $8725869b83961a04$export$37cd4e52cce48c4c extends $8725869b83961a04$export$c0babfeb8708fc9c {
    constructor(radius, detail){
        console.warn("THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.");
        super(radius, detail);
    }
}
class $8725869b83961a04$export$91836d01b9f75a58 extends $8725869b83961a04$export$598697a1efa63ca7 {
    constructor(shapes, options){
        console.warn("THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.");
        super(shapes, options);
    }
}
class $8725869b83961a04$export$731fd4feef063ea2 extends $8725869b83961a04$export$9567cc828c9535da {
    constructor(radius, detail){
        console.warn("THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.");
        super(radius, detail);
    }
}
class $8725869b83961a04$export$dc3e1273c1dd9240 extends $8725869b83961a04$export$6d839803fcd1882c {
    constructor(points, segments, phiStart, phiLength){
        console.warn("THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.");
        super(points, segments, phiStart, phiLength);
    }
}
class $8725869b83961a04$export$8e05fc91596f4752 extends $8725869b83961a04$export$1954e2b809fe361e {
    constructor(radius, detail){
        console.warn("THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.");
        super(radius, detail);
    }
}
class $8725869b83961a04$export$e789a11a194ca4e0 extends $8725869b83961a04$export$967d831af31f69ce {
    constructor(width, height, widthSegments, heightSegments){
        console.warn("THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.");
        super(width, height, widthSegments, heightSegments);
    }
}
class $8725869b83961a04$export$38789b531813345c extends $8725869b83961a04$export$60e57a7d3f20ff65 {
    constructor(vertices, indices, radius, detail){
        console.warn("THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.");
        super(vertices, indices, radius, detail);
    }
}
class $8725869b83961a04$export$ee8b85b34b7d9cad extends $8725869b83961a04$export$68cb731f50f614af {
    constructor(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength){
        console.warn("THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.");
        super(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
    }
}
class $8725869b83961a04$export$233afc324766bed8 extends $8725869b83961a04$export$57a29a1c803e9065 {
    constructor(shapes, curveSegments){
        console.warn("THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.");
        super(shapes, curveSegments);
    }
}
class $8725869b83961a04$export$d5d06a966fec4192 extends $8725869b83961a04$export$1b417fc3b307a251 {
    constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength){
        console.warn("THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.");
        super(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
    }
}
class $8725869b83961a04$export$369e08f62a796c65 extends $8725869b83961a04$export$fb3f7adc68bd6e02 {
    constructor(radius, detail){
        console.warn("THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.");
        super(radius, detail);
    }
}
class $8725869b83961a04$export$19d55f905fa4f2cb extends $8725869b83961a04$export$a2312a2a1fa56495 {
    constructor(radius, tube, radialSegments, tubularSegments, arc){
        console.warn("THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.");
        super(radius, tube, radialSegments, tubularSegments, arc);
    }
}
class $8725869b83961a04$export$2b32466f4274fe5c extends $8725869b83961a04$export$77e9bfadfb9ab8c8 {
    constructor(radius, tube, tubularSegments, radialSegments, p, q){
        console.warn("THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.");
        super(radius, tube, tubularSegments, radialSegments, p, q);
    }
}
class $8725869b83961a04$export$d97a193ce44e691b extends $8725869b83961a04$export$7897d9d48904490c {
    constructor(path, tubularSegments, radius, radialSegments, closed){
        console.warn("THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.");
        super(path, tubularSegments, radius, radialSegments, closed);
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $8725869b83961a04$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $8725869b83961a04$export$3545e07a80636437;
}



class $030068288f21a614$export$f77b260d603937c7 {
    constructor(size){
        this.data = new Array(size);
        this.index = 0;
        this.size = size;
    }
    setNext(val) {
        this.data[this.index] = val;
        this.index = (this.index + 1) % this.size;
    }
    avg() {
        var sum = 0;
        for(var i = 0; i < this.size; i++)if (typeof this.data[i] != "undefined") sum += this.data[i];
        return sum / this.size;
    }
}


// FPS History tracker, optimized for per-frame sampling and secondarily for finding the median
// Internally this uses an array indexed by fps
class $f38646df962cc0f1$export$2e2bcd8739ae039 {
    constructor(minFPS, maxFPS){
        this.minFPS = minFPS;
        this.maxFPS = maxFPS;
        // Median data
        this.totalSamples = 0;
        this.data = new Array(maxFPS - minFPS + 1);
        for(var i = 0; i < this.data.length; i++)this.data[i] = 0;
        // Running average data
        this.runningAverage = 0;
        this.totalAverageSamples = 0;
    }
    // Calculate index to data array from integer fps value
    getIndex(fps) {
        return Math.max(this.minFPS, Math.min(this.maxFPS, fps - this.minFPS));
    }
    // Add a single integer fps sample to the data
    sample(fps) {
        // Update median data
        this.data[this.getIndex(fps)]++;
        this.totalSamples++;
        // Update running average data
        if (this.totalAverageSamples <= 0) {
            this.runningAverage = fps;
            this.totalAverageSamples = 1;
            return;
        }
        const totalSamplesPlusOne = this.totalAverageSamples + 1;
        this.runningAverage = this.totalAverageSamples / totalSamplesPlusOne * this.runningAverage + 1 / totalSamplesPlusOne * fps;
        this.totalAverageSamples = totalSamplesPlusOne;
    }
    // Return the median fps of the data set
    median() {
        const medianSampleNumber = Math.ceil(this.totalSamples / 2);
        var sum = 0;
        for(var i = 0; i < this.data.length; i++){
            sum += this.data[i];
            if (sum >= medianSampleNumber) return i;
        }
    }
    avg() {
        return this.runningAverage;
    }
    resetAvg() {
        this.runningAverage = 0;
        this.totalAverageSamples = 0;
    }
    getAverageSamples() {
        return this.totalAverageSamples;
    }
    stdDeviation() {
        const average = this.avg();
        // Calculate the numerator of the std. deviation formula
        const sum = this.data.reduce((accumulator, nItemsInBucket, index)=>{
            // Calculate what FPS this bucket's "label" is
            const bucketFPS = index + this.minFPS;
            var difference_squared = (bucketFPS - average) * (bucketFPS - average) * nItemsInBucket;
            return accumulator + difference_squared;
        }, 0);
        // Divide by number of items in the sample and sqrt
        return Math.sqrt(sum / this.totalSamples);
    }
}


class $266bd460549734c2$export$d1fdfb5c73f8786f {
    // Quality levels
    static QUALITY = {
        low: {
            "shadows": false,
            "pixelRatio": 0.5,
            "index": 0
        },
        medium: {
            "shadows": false,
            "pixelRatio": 0.8,
            "index": 1
        },
        high: {
            "shadows": true,
            "pixelRatio": 1,
            "index": 2
        }
    };
    static QUALITY_NAMES = [
        "low",
        "medium",
        "high"
    ];
    static targetFPS = 59;
    // Time to wait after changing quality to consider changing quality again
    static debounceTime = 1;
    // Time to wait initially before changing quality
    static gracePeriod = 2;
    constructor(renderer, gpuTier, minFPS = 0, maxFPS = 120){
        this.gpuTier = gpuTier;
        this.clock = new $8725869b83961a04$export$9735c82c4bae3302();
        // this.fpsHistory = new CircularArray(10);
        this.renderer = renderer;
        this.quality = "high";
        this.minFPS = minFPS;
        this.maxFPS = maxFPS;
        this.fpsHistory = {};
        this.averageTotalTime = 0; // seconds
        // this.averageResetTime = 2; // seconds
        this.debounceTimer = 0; // seconds
        // if (gpuTier.isMobile) {
        //     this.quality = 'low';
        // }
        // These get set later as resources are loaded in
        this.sun = null;
        this.performanceMonitorData = {};
        this.performanceMonitorData.currentQuality = "";
        this.performanceMonitorData.quality = {};
        for (const [key, value] of Object.entries($266bd460549734c2$export$d1fdfb5c73f8786f.QUALITY)){
            this.fpsHistory[key] = new (0, $f38646df962cc0f1$export$2e2bcd8739ae039)(minFPS, maxFPS);
            this.performanceMonitorData.quality[key] = {
                averageFPS: -1,
                medianFPS: -1,
                totalSamples: -1,
                stdDeviation: -1
            };
        }
    }
    setSun(sun) {
        this.sun = sun;
    }
    getOffsetQuality(offset) {
        const qIndex = $266bd460549734c2$export$d1fdfb5c73f8786f.QUALITY[this.quality].index;
        // Check if next quality is in bounds
        if (qIndex + offset < 0 || qIndex + offset >= $266bd460549734c2$export$d1fdfb5c73f8786f.QUALITY_NAMES.length) return null;
        return $266bd460549734c2$export$d1fdfb5c73f8786f.QUALITY_NAMES[qIndex + offset];
    }
    // If we were to switch, what quality would we switch to. Null means don't switch
    shouldSwitchQualityTo() {
        // if (this.debounceTimer > 0)
        //     return null;
        const avg = this.fpsHistory[this.quality].median();
        // Try switching down if our average fps is too low
        if (avg < $266bd460549734c2$export$d1fdfb5c73f8786f.targetFPS) return this.getOffsetQuality(-1);
        // Decide if we should switch up
        if (avg >= $266bd460549734c2$export$d1fdfb5c73f8786f.targetFPS) {
            const nextQuality = this.getOffsetQuality(1);
            if (!nextQuality) return null;
            // debugger;
            // Check if there's already an fps history for this quality
            // Don't switch if we've already established a median fps on that quality that's lower than the target
            // if (this.fpsHistory[nextQuality] && this.fpsHistory[nextQuality].median() < PerformanceManager.targetFPS)
            //     return null;
            return nextQuality;
        }
        return null;
    }
    tick() {
        const delta = this.clock.getDelta();
        if (delta <= 0) return;
        this.fpsHistory[this.quality].sample(Math.floor(1 / delta));
        // this.averageTotalTime += delta;
        this.debounceTimer -= delta;
        // Short circuit if we're still within the initial load grace period
        if (this.clock.getElapsedTime() < $266bd460549734c2$export$d1fdfb5c73f8786f.gracePeriod) return;
        if (this.debounceTimer <= 0) {
            // console.log('Considering a change of quality');
            const nextQuality = this.shouldSwitchQualityTo();
            // Reset the average
            // this.fpsHistory[this.quality].resetAvg();
            // Restart the debounce timer
            this.debounceTimer = $266bd460549734c2$export$d1fdfb5c73f8786f.debounceTime;
            if (nextQuality) {
                // Create the fps history object for the next quality if necessary
                if (!this.fpsHistory[nextQuality]) this.fpsHistory[nextQuality] = new (0, $f38646df962cc0f1$export$2e2bcd8739ae039)(this.minFPS, this.maxFPS);
                this.setQualityLevel(nextQuality);
            }
        }
        this.updatePerformanceMonitorData();
    }
    setQualityLevel(level) {
        // Short circuit if we're already at this quality
        if (this.quality == level) return;
        console.log("Setting quality to " + level);
        const quality = $266bd460549734c2$export$d1fdfb5c73f8786f.QUALITY[level];
        console.log(this.renderer.shadowMap);
        console.log(this.sun);
        this.renderer.shadowMap.enabled = quality.shadows;
        if (!quality.shadows) {
            if (this.sun) this.sun.castShadow = false;
        // this.renderer.setRenderTarget(this.sun.shadow.map);
        // this.renderer.clear();
        // this.renderer.setRenderTarget(null);
        // this.sun.shadow.needsUpdate = true;
        } else if (this.sun) this.sun.castShadow = true;
        this.renderer.needsUpdate = true;
        this.renderer.setPixelRatio(window.devicePixelRatio * quality.pixelRatio);
        this.quality = level;
    }
    updatePerformanceMonitorData() {
        this.performanceMonitorData.currentQuality = this.quality;
        for (const [key, value] of Object.entries($266bd460549734c2$export$d1fdfb5c73f8786f.QUALITY)){
            this.performanceMonitorData.quality[key].medianFPS = this.fpsHistory[key].median();
            this.performanceMonitorData.quality[key].averageFPS = this.fpsHistory[key].avg();
            this.performanceMonitorData.quality[key].totalSamples = this.fpsHistory[key].totalSamples;
            this.performanceMonitorData.quality[key].stdDeviation = this.fpsHistory[key].stdDeviation();
        }
    }
}


function $bd03118be7dadc3f$var$e(e, t, n, r) {
    return new (n || (n = Promise))(function(o, a) {
        function i(e) {
            try {
                d(r.next(e));
            } catch (e) {
                a(e);
            }
        }
        function c(e) {
            try {
                d(r.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function d(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(i, c);
        }
        d((r = r.apply(e, t || [])).next());
    });
}
const $bd03118be7dadc3f$var$t = [
    "geforce 320m",
    "geforce 8600",
    "geforce 8600m gt",
    "geforce 8800 gs",
    "geforce 8800 gt",
    "geforce 9400",
    "geforce 9400m g",
    "geforce 9400m",
    "geforce 9600m gt",
    "geforce 9600m",
    "geforce fx go5200",
    "geforce gt 120",
    "geforce gt 130",
    "geforce gt 330m",
    "geforce gtx 285",
    "google swiftshader",
    "intel g41",
    "intel g45",
    "intel gma 4500mhd",
    "intel gma x3100",
    "intel hd 3000",
    "intel q45",
    "legacy",
    "mali-2",
    "mali-3",
    "mali-4",
    "quadro fx 1500",
    "quadro fx 4",
    "quadro fx 5",
    "radeon hd 2400",
    "radeon hd 2600",
    "radeon hd 4670",
    "radeon hd 4850",
    "radeon hd 4870",
    "radeon hd 5670",
    "radeon hd 5750",
    "radeon hd 6290",
    "radeon hd 6300",
    "radeon hd 6310",
    "radeon hd 6320",
    "radeon hd 6490m",
    "radeon hd 6630m",
    "radeon hd 6750m",
    "radeon hd 6770m",
    "radeon hd 6970m",
    "sgx 543",
    "sgx543"
];
function $bd03118be7dadc3f$var$n(e) {
    return e = e.toLowerCase().replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
const $bd03118be7dadc3f$var$r = "undefined" == typeof window, $bd03118be7dadc3f$var$o = (()=>{
    if ($bd03118be7dadc3f$var$r) return;
    const { userAgent: e, platform: t, maxTouchPoints: n } = window.navigator, o = /(iphone|ipod|ipad)/i.test(e), a = "iPad" === t || "MacIntel" === t && n > 0 && !window.MSStream;
    return {
        isIpad: a,
        isMobile: /android/i.test(e) || o || a,
        isSafari12: /Version\/12.+Safari/.test(e)
    };
})();
function $bd03118be7dadc3f$var$a(e, t, n) {
    if (!n) return [
        t
    ];
    const r = function(e) {
        const t = "\n    precision highp float;\n    attribute vec3 aPosition;\n    varying float vvv;\n    void main() {\n      vvv = 0.31622776601683794;\n      gl_Position = vec4(aPosition, 1.0);\n    }\n  ", n = "\n    precision highp float;\n    varying float vvv;\n    void main() {\n      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\n      enc = fract(enc);\n      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\n      gl_FragColor = enc;\n    }\n  ", r = e.createShader(35633), o = e.createShader(35632), a = e.createProgram();
        if (!(o && r && a)) return;
        e.shaderSource(r, t), e.shaderSource(o, n), e.compileShader(r), e.compileShader(o), e.attachShader(a, r), e.attachShader(a, o), e.linkProgram(a), e.detachShader(a, r), e.detachShader(a, o), e.deleteShader(r), e.deleteShader(o), e.useProgram(a);
        const i = e.createBuffer();
        e.bindBuffer(34962, i), e.bufferData(34962, new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), 35044);
        const c = e.getAttribLocation(a, "aPosition");
        e.vertexAttribPointer(c, 3, 5126, !1, 0, 0), e.enableVertexAttribArray(c), e.clearColor(1, 1, 1, 1), e.clear(16384), e.viewport(0, 0, 1, 1), e.drawArrays(4, 0, 3);
        const d = new Uint8Array(4);
        return e.readPixels(0, 0, 1, 1, 6408, 5121, d), e.deleteProgram(a), e.deleteBuffer(i), d.join("");
    }(e), a = "801621810", i = "8016218135", c = "80162181161", d = (null == $bd03118be7dadc3f$var$o ? void 0 : $bd03118be7dadc3f$var$o.isIpad) ? [
        [
            "a7",
            c,
            12
        ],
        [
            "a8",
            i,
            15
        ],
        [
            "a8x",
            i,
            15
        ],
        [
            "a9",
            i,
            15
        ],
        [
            "a9x",
            i,
            15
        ],
        [
            "a10",
            i,
            15
        ],
        [
            "a10x",
            i,
            15
        ],
        [
            "a12",
            a,
            15
        ],
        [
            "a12x",
            a,
            15
        ],
        [
            "a12z",
            a,
            15
        ],
        [
            "a14",
            a,
            15
        ],
        [
            "m1",
            a,
            15
        ]
    ] : [
        [
            "a7",
            c,
            12
        ],
        [
            "a8",
            i,
            12
        ],
        [
            "a9",
            i,
            15
        ],
        [
            "a10",
            i,
            15
        ],
        [
            "a11",
            a,
            15
        ],
        [
            "a12",
            a,
            15
        ],
        [
            "a13",
            a,
            15
        ],
        [
            "a14",
            a,
            15
        ]
    ];
    let l;
    "80162181255" === r ? l = d.filter(([, , e])=>e >= 14) : (l = d.filter(([, e])=>e === r), l.length || (l = d));
    return l.map(([e])=>`apple ${e} gpu`);
}
class $bd03118be7dadc3f$var$i extends Error {
    constructor(e){
        super(e), Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $bd03118be7dadc3f$var$c = [], $bd03118be7dadc3f$var$d = [];
function $bd03118be7dadc3f$var$l(e, t) {
    if (e === t) return 0;
    const n = e;
    e.length > t.length && (e = t, t = n);
    let r = e.length, o = t.length;
    for(; r > 0 && e.charCodeAt(~-r) === t.charCodeAt(~-o);)r--, o--;
    let a, i = 0;
    for(; i < r && e.charCodeAt(i) === t.charCodeAt(i);)i++;
    if (r -= i, o -= i, 0 === r) return o;
    let l, s, f = 0, u = 0, h = 0;
    for(; u < r;)$bd03118be7dadc3f$var$d[u] = e.charCodeAt(i + u), $bd03118be7dadc3f$var$c[u] = ++u;
    for(; h < o;)for(a = t.charCodeAt(i + h), l = h++, f = h, u = 0; u < r; u++)s = a === $bd03118be7dadc3f$var$d[u] ? l : l + 1, l = $bd03118be7dadc3f$var$c[u], f = $bd03118be7dadc3f$var$c[u] = l > f ? s > f ? f + 1 : s : s > l ? l + 1 : s;
    return f;
}
function $bd03118be7dadc3f$var$s(e) {
    return null != e;
}
const $bd03118be7dadc3f$export$3c749a0234c63713 = ({ mobileTiers: c = [
    0,
    15,
    30,
    60
], desktopTiers: d = [
    0,
    15,
    30,
    60
], override: f = {}, glContext: u, failIfMajorPerformanceCaveat: h = !1, benchmarksURL: g = "https://unpkg.com/detect-gpu@5.0.26/dist/benchmarks" } = {})=>$bd03118be7dadc3f$var$e(void 0, void 0, void 0, function*() {
        const p = {};
        if ($bd03118be7dadc3f$var$r) return {
            tier: 0,
            type: "SSR"
        };
        const { isIpad: m = !!(null == $bd03118be7dadc3f$var$o ? void 0 : $bd03118be7dadc3f$var$o.isIpad), isMobile: v = !!(null == $bd03118be7dadc3f$var$o ? void 0 : $bd03118be7dadc3f$var$o.isMobile), screenSize: w = window.screen, loadBenchmarks: x = (t)=>$bd03118be7dadc3f$var$e(void 0, void 0, void 0, function*() {
                const e = yield fetch(`${g}/${t}`).then((e)=>e.json());
                if (parseInt(e.shift().split(".")[0], 10) < 4) throw new $bd03118be7dadc3f$var$i("Detect GPU benchmark data is out of date. Please update to version 4x");
                return e;
            }) } = f;
        let { renderer: A } = f;
        const P = (e, t, n, r, o)=>({
                device: o,
                fps: r,
                gpu: n,
                isMobile: v,
                tier: e,
                type: t
            });
        let b, S = "";
        if (A) A = $bd03118be7dadc3f$var$n(A), b = [
            A
        ];
        else {
            const e = u || function(e, t = !1) {
                const n = {
                    alpha: !1,
                    antialias: !1,
                    depth: !1,
                    failIfMajorPerformanceCaveat: t,
                    powerPreference: "high-performance",
                    stencil: !1
                };
                e && delete n.powerPreference;
                const r = window.document.createElement("canvas"), o = r.getContext("webgl", n) || r.getContext("experimental-webgl", n);
                return null != o ? o : void 0;
            }(null == $bd03118be7dadc3f$var$o ? void 0 : $bd03118be7dadc3f$var$o.isSafari12, h);
            if (!e) return P(0, "WEBGL_UNSUPPORTED");
            const t = e.getExtension("WEBGL_debug_renderer_info");
            if (t && (A = e.getParameter(t.UNMASKED_RENDERER_WEBGL)), !A) return P(1, "FALLBACK");
            S = A, A = $bd03118be7dadc3f$var$n(A), b = function(e, t, n) {
                return "apple gpu" === t ? $bd03118be7dadc3f$var$a(e, t, n) : [
                    t
                ];
            }(e, A, v);
        }
        const y = (yield Promise.all(b.map(function(t) {
            var n;
            return $bd03118be7dadc3f$var$e(this, void 0, void 0, function*() {
                const e = ((e)=>{
                    const t = v ? [
                        "adreno",
                        "apple",
                        "mali-t",
                        "mali",
                        "nvidia",
                        "powervr",
                        "samsung"
                    ] : [
                        "intel",
                        "apple",
                        "amd",
                        "radeon",
                        "nvidia",
                        "geforce"
                    ];
                    for (const n of t)if (e.includes(n)) return n;
                })(t);
                if (!e) return;
                const r = `${v ? "m" : "d"}-${e}${m ? "-ipad" : ""}.json`, o = p[r] = null !== (n = p[r]) && void 0 !== n ? n : x(r);
                let a;
                try {
                    a = yield o;
                } catch (e) {
                    if (e instanceof $bd03118be7dadc3f$var$i) throw e;
                    return;
                }
                const c = function(e) {
                    var t;
                    const n = (e = e.replace(/\([^)]+\)/, "")).match(/\d+/) || e.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
                    return null !== (t = null == n ? void 0 : n.join("").replace(/\W|amd/g, "")) && void 0 !== t ? t : "";
                }(t);
                let d = a.filter(([, e])=>e === c);
                d.length || (d = a.filter(([e])=>e.includes(t)));
                const s = d.length;
                if (0 === s) return;
                const f = t.split(/[.,()\[\]/\s]/g).sort().filter((e, t, n)=>0 === t || e !== n[t - 1]).join(" ");
                let u, [h, , , , g] = s > 1 ? d.map((e)=>[
                        e,
                        $bd03118be7dadc3f$var$l(f, e[2])
                    ]).sort(([, e], [, t])=>e - t)[0][0] : d[0], A = Number.MAX_VALUE;
                const { devicePixelRatio: P } = window, b = w.width * P * w.height * P;
                for (const e of g){
                    const [t, n] = e, r = t * n, o = Math.abs(b - r);
                    o < A && (A = o, u = e);
                }
                if (!u) return;
                const [, , S, y] = u;
                return [
                    A,
                    S,
                    h,
                    y
                ];
            });
        }))).filter($bd03118be7dadc3f$var$s).sort(([e = Number.MAX_VALUE, t], [n = Number.MAX_VALUE, r])=>e === n ? t - r : e - n);
        if (!y.length) {
            const e = $bd03118be7dadc3f$var$t.find((e)=>A.includes(e));
            return e ? P(0, "BLOCKLISTED", e) : P(1, "FALLBACK", `${A} (${S})`);
        }
        const [, C, E, L] = y[0];
        if (-1 === C) return P(0, "BLOCKLISTED", E, C, L);
        const M = v ? c : d;
        let $ = 0;
        for(let e = 0; e < M.length; e++)C >= M[e] && ($ = e);
        return P($, "BENCHMARK", E, C, L);
    });


/**
 * dat-gui JavaScript Controller Library
 * https://github.com/dataarts/dat.gui
 *
 * Copyright 2011 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $5804bae86b063b2c$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === "undefined") return;
    var style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
function $5804bae86b063b2c$var$colorToString(color, forceCSSHex) {
    var colorFormat = color.__state.conversionName.toString();
    var r = Math.round(color.r);
    var g = Math.round(color.g);
    var b = Math.round(color.b);
    var a = color.a;
    var h = Math.round(color.h);
    var s = color.s.toFixed(1);
    var v = color.v.toFixed(1);
    if (forceCSSHex || colorFormat === "THREE_CHAR_HEX" || colorFormat === "SIX_CHAR_HEX") {
        var str = color.hex.toString(16);
        while(str.length < 6)str = "0" + str;
        return "#" + str;
    } else if (colorFormat === "CSS_RGB") return "rgb(" + r + "," + g + "," + b + ")";
    else if (colorFormat === "CSS_RGBA") return "rgba(" + r + "," + g + "," + b + "," + a + ")";
    else if (colorFormat === "HEX") return "0x" + color.hex.toString(16);
    else if (colorFormat === "RGB_ARRAY") return "[" + r + "," + g + "," + b + "]";
    else if (colorFormat === "RGBA_ARRAY") return "[" + r + "," + g + "," + b + "," + a + "]";
    else if (colorFormat === "RGB_OBJ") return "{r:" + r + ",g:" + g + ",b:" + b + "}";
    else if (colorFormat === "RGBA_OBJ") return "{r:" + r + ",g:" + g + ",b:" + b + ",a:" + a + "}";
    else if (colorFormat === "HSV_OBJ") return "{h:" + h + ",s:" + s + ",v:" + v + "}";
    else if (colorFormat === "HSVA_OBJ") return "{h:" + h + ",s:" + s + ",v:" + v + ",a:" + a + "}";
    return "unknown format";
}
var $5804bae86b063b2c$var$ARR_EACH = Array.prototype.forEach;
var $5804bae86b063b2c$var$ARR_SLICE = Array.prototype.slice;
var $5804bae86b063b2c$var$Common = {
    BREAK: {},
    extend: function extend(target) {
        this.each($5804bae86b063b2c$var$ARR_SLICE.call(arguments, 1), function(obj) {
            var keys = this.isObject(obj) ? Object.keys(obj) : [];
            keys.forEach((function(key) {
                if (!this.isUndefined(obj[key])) target[key] = obj[key];
            }).bind(this));
        }, this);
        return target;
    },
    defaults: function defaults(target) {
        this.each($5804bae86b063b2c$var$ARR_SLICE.call(arguments, 1), function(obj) {
            var keys = this.isObject(obj) ? Object.keys(obj) : [];
            keys.forEach((function(key) {
                if (this.isUndefined(target[key])) target[key] = obj[key];
            }).bind(this));
        }, this);
        return target;
    },
    compose: function compose() {
        var toCall = $5804bae86b063b2c$var$ARR_SLICE.call(arguments);
        return function() {
            var args = $5804bae86b063b2c$var$ARR_SLICE.call(arguments);
            for(var i = toCall.length - 1; i >= 0; i--)args = [
                toCall[i].apply(this, args)
            ];
            return args[0];
        };
    },
    each: function each(obj, itr, scope) {
        if (!obj) return;
        if ($5804bae86b063b2c$var$ARR_EACH && obj.forEach && obj.forEach === $5804bae86b063b2c$var$ARR_EACH) obj.forEach(itr, scope);
        else if (obj.length === obj.length + 0) {
            var key = void 0;
            var l = void 0;
            for(key = 0, l = obj.length; key < l; key++){
                if (key in obj && itr.call(scope, obj[key], key) === this.BREAK) return;
            }
        } else for(var _key in obj){
            if (itr.call(scope, obj[_key], _key) === this.BREAK) return;
        }
    },
    defer: function defer(fnc) {
        setTimeout(fnc, 0);
    },
    debounce: function debounce(func, threshold, callImmediately) {
        var timeout = void 0;
        return function() {
            var obj = this;
            var args = arguments;
            function delayed() {
                timeout = null;
                if (!callImmediately) func.apply(obj, args);
            }
            var callNow = callImmediately || !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(delayed, threshold);
            if (callNow) func.apply(obj, args);
        };
    },
    toArray: function toArray(obj) {
        if (obj.toArray) return obj.toArray();
        return $5804bae86b063b2c$var$ARR_SLICE.call(obj);
    },
    isUndefined: function isUndefined(obj) {
        return obj === undefined;
    },
    isNull: function isNull(obj) {
        return obj === null;
    },
    isNaN: function(_isNaN) {
        function isNaN1(_x) {
            return _isNaN.apply(this, arguments);
        }
        isNaN1.toString = function() {
            return _isNaN.toString();
        };
        return isNaN1;
    }(function(obj) {
        return isNaN(obj);
    }),
    isArray: Array.isArray || function(obj) {
        return obj.constructor === Array;
    },
    isObject: function isObject(obj) {
        return obj === Object(obj);
    },
    isNumber: function isNumber(obj) {
        return obj === obj + 0;
    },
    isString: function isString(obj) {
        return obj === obj + "";
    },
    isBoolean: function isBoolean(obj) {
        return obj === false || obj === true;
    },
    isFunction: function isFunction(obj) {
        return obj instanceof Function;
    }
};
var $5804bae86b063b2c$var$INTERPRETATIONS = [
    {
        litmus: $5804bae86b063b2c$var$Common.isString,
        conversions: {
            THREE_CHAR_HEX: {
                read: function read(original) {
                    var test = original.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
                    if (test === null) return false;
                    return {
                        space: "HEX",
                        hex: parseInt("0x" + test[1].toString() + test[1].toString() + test[2].toString() + test[2].toString() + test[3].toString() + test[3].toString(), 0)
                    };
                },
                write: $5804bae86b063b2c$var$colorToString
            },
            SIX_CHAR_HEX: {
                read: function read(original) {
                    var test = original.match(/^#([A-F0-9]{6})$/i);
                    if (test === null) return false;
                    return {
                        space: "HEX",
                        hex: parseInt("0x" + test[1].toString(), 0)
                    };
                },
                write: $5804bae86b063b2c$var$colorToString
            },
            CSS_RGB: {
                read: function read(original) {
                    var test = original.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
                    if (test === null) return false;
                    return {
                        space: "RGB",
                        r: parseFloat(test[1]),
                        g: parseFloat(test[2]),
                        b: parseFloat(test[3])
                    };
                },
                write: $5804bae86b063b2c$var$colorToString
            },
            CSS_RGBA: {
                read: function read(original) {
                    var test = original.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
                    if (test === null) return false;
                    return {
                        space: "RGB",
                        r: parseFloat(test[1]),
                        g: parseFloat(test[2]),
                        b: parseFloat(test[3]),
                        a: parseFloat(test[4])
                    };
                },
                write: $5804bae86b063b2c$var$colorToString
            }
        }
    },
    {
        litmus: $5804bae86b063b2c$var$Common.isNumber,
        conversions: {
            HEX: {
                read: function read(original) {
                    return {
                        space: "HEX",
                        hex: original,
                        conversionName: "HEX"
                    };
                },
                write: function write(color) {
                    return color.hex;
                }
            }
        }
    },
    {
        litmus: $5804bae86b063b2c$var$Common.isArray,
        conversions: {
            RGB_ARRAY: {
                read: function read(original) {
                    if (original.length !== 3) return false;
                    return {
                        space: "RGB",
                        r: original[0],
                        g: original[1],
                        b: original[2]
                    };
                },
                write: function write(color) {
                    return [
                        color.r,
                        color.g,
                        color.b
                    ];
                }
            },
            RGBA_ARRAY: {
                read: function read(original) {
                    if (original.length !== 4) return false;
                    return {
                        space: "RGB",
                        r: original[0],
                        g: original[1],
                        b: original[2],
                        a: original[3]
                    };
                },
                write: function write(color) {
                    return [
                        color.r,
                        color.g,
                        color.b,
                        color.a
                    ];
                }
            }
        }
    },
    {
        litmus: $5804bae86b063b2c$var$Common.isObject,
        conversions: {
            RGBA_OBJ: {
                read: function read(original) {
                    if ($5804bae86b063b2c$var$Common.isNumber(original.r) && $5804bae86b063b2c$var$Common.isNumber(original.g) && $5804bae86b063b2c$var$Common.isNumber(original.b) && $5804bae86b063b2c$var$Common.isNumber(original.a)) return {
                        space: "RGB",
                        r: original.r,
                        g: original.g,
                        b: original.b,
                        a: original.a
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        r: color.r,
                        g: color.g,
                        b: color.b,
                        a: color.a
                    };
                }
            },
            RGB_OBJ: {
                read: function read(original) {
                    if ($5804bae86b063b2c$var$Common.isNumber(original.r) && $5804bae86b063b2c$var$Common.isNumber(original.g) && $5804bae86b063b2c$var$Common.isNumber(original.b)) return {
                        space: "RGB",
                        r: original.r,
                        g: original.g,
                        b: original.b
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        r: color.r,
                        g: color.g,
                        b: color.b
                    };
                }
            },
            HSVA_OBJ: {
                read: function read(original) {
                    if ($5804bae86b063b2c$var$Common.isNumber(original.h) && $5804bae86b063b2c$var$Common.isNumber(original.s) && $5804bae86b063b2c$var$Common.isNumber(original.v) && $5804bae86b063b2c$var$Common.isNumber(original.a)) return {
                        space: "HSV",
                        h: original.h,
                        s: original.s,
                        v: original.v,
                        a: original.a
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        h: color.h,
                        s: color.s,
                        v: color.v,
                        a: color.a
                    };
                }
            },
            HSV_OBJ: {
                read: function read(original) {
                    if ($5804bae86b063b2c$var$Common.isNumber(original.h) && $5804bae86b063b2c$var$Common.isNumber(original.s) && $5804bae86b063b2c$var$Common.isNumber(original.v)) return {
                        space: "HSV",
                        h: original.h,
                        s: original.s,
                        v: original.v
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        h: color.h,
                        s: color.s,
                        v: color.v
                    };
                }
            }
        }
    }
];
var $5804bae86b063b2c$var$result = void 0;
var $5804bae86b063b2c$var$toReturn = void 0;
var $5804bae86b063b2c$var$interpret = function interpret() {
    $5804bae86b063b2c$var$toReturn = false;
    var original = arguments.length > 1 ? $5804bae86b063b2c$var$Common.toArray(arguments) : arguments[0];
    $5804bae86b063b2c$var$Common.each($5804bae86b063b2c$var$INTERPRETATIONS, function(family) {
        if (family.litmus(original)) {
            $5804bae86b063b2c$var$Common.each(family.conversions, function(conversion, conversionName) {
                $5804bae86b063b2c$var$result = conversion.read(original);
                if ($5804bae86b063b2c$var$toReturn === false && $5804bae86b063b2c$var$result !== false) {
                    $5804bae86b063b2c$var$toReturn = $5804bae86b063b2c$var$result;
                    $5804bae86b063b2c$var$result.conversionName = conversionName;
                    $5804bae86b063b2c$var$result.conversion = conversion;
                    return $5804bae86b063b2c$var$Common.BREAK;
                }
            });
            return $5804bae86b063b2c$var$Common.BREAK;
        }
    });
    return $5804bae86b063b2c$var$toReturn;
};
var $5804bae86b063b2c$var$tmpComponent = void 0;
var $5804bae86b063b2c$var$ColorMath = {
    hsv_to_rgb: function hsv_to_rgb(h, s, v) {
        var hi = Math.floor(h / 60) % 6;
        var f = h / 60 - Math.floor(h / 60);
        var p = v * (1.0 - s);
        var q = v * (1.0 - f * s);
        var t = v * (1.0 - (1.0 - f) * s);
        var c = [
            [
                v,
                t,
                p
            ],
            [
                q,
                v,
                p
            ],
            [
                p,
                v,
                t
            ],
            [
                p,
                q,
                v
            ],
            [
                t,
                p,
                v
            ],
            [
                v,
                p,
                q
            ]
        ][hi];
        return {
            r: c[0] * 255,
            g: c[1] * 255,
            b: c[2] * 255
        };
    },
    rgb_to_hsv: function rgb_to_hsv(r, g, b) {
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h = void 0;
        var s = void 0;
        if (max !== 0) s = delta / max;
        else return {
            h: NaN,
            s: 0,
            v: 0
        };
        if (r === max) h = (g - b) / delta;
        else if (g === max) h = 2 + (b - r) / delta;
        else h = 4 + (r - g) / delta;
        h /= 6;
        if (h < 0) h += 1;
        return {
            h: h * 360,
            s: s,
            v: max / 255
        };
    },
    rgb_to_hex: function rgb_to_hex(r, g, b) {
        var hex = this.hex_with_component(0, 2, r);
        hex = this.hex_with_component(hex, 1, g);
        hex = this.hex_with_component(hex, 0, b);
        return hex;
    },
    component_from_hex: function component_from_hex(hex, componentIndex) {
        return hex >> componentIndex * 8 & 0xFF;
    },
    hex_with_component: function hex_with_component(hex, componentIndex, value) {
        return value << ($5804bae86b063b2c$var$tmpComponent = componentIndex * 8) | hex & ~(0xFF << $5804bae86b063b2c$var$tmpComponent);
    }
};
var $5804bae86b063b2c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5804bae86b063b2c$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $5804bae86b063b2c$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $5804bae86b063b2c$var$get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};
var $5804bae86b063b2c$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $5804bae86b063b2c$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $5804bae86b063b2c$var$Color = function() {
    function Color() {
        $5804bae86b063b2c$var$classCallCheck(this, Color);
        this.__state = $5804bae86b063b2c$var$interpret.apply(this, arguments);
        if (this.__state === false) throw new Error("Failed to interpret color arguments");
        this.__state.a = this.__state.a || 1;
    }
    $5804bae86b063b2c$var$createClass(Color, [
        {
            key: "toString",
            value: function toString() {
                return $5804bae86b063b2c$var$colorToString(this);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return $5804bae86b063b2c$var$colorToString(this, true);
            }
        },
        {
            key: "toOriginal",
            value: function toOriginal() {
                return this.__state.conversion.write(this);
            }
        }
    ]);
    return Color;
}();
function $5804bae86b063b2c$var$defineRGBComponent(target, component, componentHexIndex) {
    Object.defineProperty(target, component, {
        get: function get$$1() {
            if (this.__state.space === "RGB") return this.__state[component];
            $5804bae86b063b2c$var$Color.recalculateRGB(this, component, componentHexIndex);
            return this.__state[component];
        },
        set: function set$$1(v) {
            if (this.__state.space !== "RGB") {
                $5804bae86b063b2c$var$Color.recalculateRGB(this, component, componentHexIndex);
                this.__state.space = "RGB";
            }
            this.__state[component] = v;
        }
    });
}
function $5804bae86b063b2c$var$defineHSVComponent(target, component) {
    Object.defineProperty(target, component, {
        get: function get$$1() {
            if (this.__state.space === "HSV") return this.__state[component];
            $5804bae86b063b2c$var$Color.recalculateHSV(this);
            return this.__state[component];
        },
        set: function set$$1(v) {
            if (this.__state.space !== "HSV") {
                $5804bae86b063b2c$var$Color.recalculateHSV(this);
                this.__state.space = "HSV";
            }
            this.__state[component] = v;
        }
    });
}
$5804bae86b063b2c$var$Color.recalculateRGB = function(color, component, componentHexIndex) {
    if (color.__state.space === "HEX") color.__state[component] = $5804bae86b063b2c$var$ColorMath.component_from_hex(color.__state.hex, componentHexIndex);
    else if (color.__state.space === "HSV") $5804bae86b063b2c$var$Common.extend(color.__state, $5804bae86b063b2c$var$ColorMath.hsv_to_rgb(color.__state.h, color.__state.s, color.__state.v));
    else throw new Error("Corrupted color state");
};
$5804bae86b063b2c$var$Color.recalculateHSV = function(color) {
    var result = $5804bae86b063b2c$var$ColorMath.rgb_to_hsv(color.r, color.g, color.b);
    $5804bae86b063b2c$var$Common.extend(color.__state, {
        s: result.s,
        v: result.v
    });
    if (!$5804bae86b063b2c$var$Common.isNaN(result.h)) color.__state.h = result.h;
    else if ($5804bae86b063b2c$var$Common.isUndefined(color.__state.h)) color.__state.h = 0;
};
$5804bae86b063b2c$var$Color.COMPONENTS = [
    "r",
    "g",
    "b",
    "h",
    "s",
    "v",
    "hex",
    "a"
];
$5804bae86b063b2c$var$defineRGBComponent($5804bae86b063b2c$var$Color.prototype, "r", 2);
$5804bae86b063b2c$var$defineRGBComponent($5804bae86b063b2c$var$Color.prototype, "g", 1);
$5804bae86b063b2c$var$defineRGBComponent($5804bae86b063b2c$var$Color.prototype, "b", 0);
$5804bae86b063b2c$var$defineHSVComponent($5804bae86b063b2c$var$Color.prototype, "h");
$5804bae86b063b2c$var$defineHSVComponent($5804bae86b063b2c$var$Color.prototype, "s");
$5804bae86b063b2c$var$defineHSVComponent($5804bae86b063b2c$var$Color.prototype, "v");
Object.defineProperty($5804bae86b063b2c$var$Color.prototype, "a", {
    get: function get$$1() {
        return this.__state.a;
    },
    set: function set$$1(v) {
        this.__state.a = v;
    }
});
Object.defineProperty($5804bae86b063b2c$var$Color.prototype, "hex", {
    get: function get$$1() {
        if (this.__state.space !== "HEX") {
            this.__state.hex = $5804bae86b063b2c$var$ColorMath.rgb_to_hex(this.r, this.g, this.b);
            this.__state.space = "HEX";
        }
        return this.__state.hex;
    },
    set: function set$$1(v) {
        this.__state.space = "HEX";
        this.__state.hex = v;
    }
});
var $5804bae86b063b2c$var$Controller = function() {
    function Controller(object, property) {
        $5804bae86b063b2c$var$classCallCheck(this, Controller);
        this.initialValue = object[property];
        this.domElement = document.createElement("div");
        this.object = object;
        this.property = property;
        this.__onChange = undefined;
        this.__onFinishChange = undefined;
    }
    $5804bae86b063b2c$var$createClass(Controller, [
        {
            key: "onChange",
            value: function onChange(fnc) {
                this.__onChange = fnc;
                return this;
            }
        },
        {
            key: "onFinishChange",
            value: function onFinishChange(fnc) {
                this.__onFinishChange = fnc;
                return this;
            }
        },
        {
            key: "setValue",
            value: function setValue(newValue) {
                this.object[this.property] = newValue;
                if (this.__onChange) this.__onChange.call(this, newValue);
                this.updateDisplay();
                return this;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.object[this.property];
            }
        },
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                return this;
            }
        },
        {
            key: "isModified",
            value: function isModified() {
                return this.initialValue !== this.getValue();
            }
        }
    ]);
    return Controller;
}();
var $5804bae86b063b2c$var$EVENT_MAP = {
    HTMLEvents: [
        "change"
    ],
    MouseEvents: [
        "click",
        "mousemove",
        "mousedown",
        "mouseup",
        "mouseover"
    ],
    KeyboardEvents: [
        "keydown"
    ]
};
var $5804bae86b063b2c$var$EVENT_MAP_INV = {};
$5804bae86b063b2c$var$Common.each($5804bae86b063b2c$var$EVENT_MAP, function(v, k) {
    $5804bae86b063b2c$var$Common.each(v, function(e) {
        $5804bae86b063b2c$var$EVENT_MAP_INV[e] = k;
    });
});
var $5804bae86b063b2c$var$CSS_VALUE_PIXELS = /(\d+(\.\d+)?)px/;
function $5804bae86b063b2c$var$cssValueToPixels(val) {
    if (val === "0" || $5804bae86b063b2c$var$Common.isUndefined(val)) return 0;
    var match = val.match($5804bae86b063b2c$var$CSS_VALUE_PIXELS);
    if (!$5804bae86b063b2c$var$Common.isNull(match)) return parseFloat(match[1]);
    return 0;
}
var $5804bae86b063b2c$var$dom = {
    makeSelectable: function makeSelectable(elem, selectable) {
        if (elem === undefined || elem.style === undefined) return;
        elem.onselectstart = selectable ? function() {
            return false;
        } : function() {};
        elem.style.MozUserSelect = selectable ? "auto" : "none";
        elem.style.KhtmlUserSelect = selectable ? "auto" : "none";
        elem.unselectable = selectable ? "on" : "off";
    },
    makeFullscreen: function makeFullscreen(elem, hor, vert) {
        var vertical = vert;
        var horizontal = hor;
        if ($5804bae86b063b2c$var$Common.isUndefined(horizontal)) horizontal = true;
        if ($5804bae86b063b2c$var$Common.isUndefined(vertical)) vertical = true;
        elem.style.position = "absolute";
        if (horizontal) {
            elem.style.left = 0;
            elem.style.right = 0;
        }
        if (vertical) {
            elem.style.top = 0;
            elem.style.bottom = 0;
        }
    },
    fakeEvent: function fakeEvent(elem, eventType, pars, aux) {
        var params = pars || {};
        var className = $5804bae86b063b2c$var$EVENT_MAP_INV[eventType];
        if (!className) throw new Error("Event type " + eventType + " not supported.");
        var evt = document.createEvent(className);
        switch(className){
            case "MouseEvents":
                var clientX = params.x || params.clientX || 0;
                var clientY = params.y || params.clientY || 0;
                evt.initMouseEvent(eventType, params.bubbles || false, params.cancelable || true, window, params.clickCount || 1, 0, 0, clientX, clientY, false, false, false, false, 0, null);
                break;
            case "KeyboardEvents":
                var init = evt.initKeyboardEvent || evt.initKeyEvent;
                $5804bae86b063b2c$var$Common.defaults(params, {
                    cancelable: true,
                    ctrlKey: false,
                    altKey: false,
                    shiftKey: false,
                    metaKey: false,
                    keyCode: undefined,
                    charCode: undefined
                });
                init(eventType, params.bubbles || false, params.cancelable, window, params.ctrlKey, params.altKey, params.shiftKey, params.metaKey, params.keyCode, params.charCode);
                break;
            default:
                evt.initEvent(eventType, params.bubbles || false, params.cancelable || true);
                break;
        }
        $5804bae86b063b2c$var$Common.defaults(evt, aux);
        elem.dispatchEvent(evt);
    },
    bind: function bind(elem, event, func, newBool) {
        var bool = newBool || false;
        if (elem.addEventListener) elem.addEventListener(event, func, bool);
        else if (elem.attachEvent) elem.attachEvent("on" + event, func);
        return $5804bae86b063b2c$var$dom;
    },
    unbind: function unbind(elem, event, func, newBool) {
        var bool = newBool || false;
        if (elem.removeEventListener) elem.removeEventListener(event, func, bool);
        else if (elem.detachEvent) elem.detachEvent("on" + event, func);
        return $5804bae86b063b2c$var$dom;
    },
    addClass: function addClass(elem, className) {
        if (elem.className === undefined) elem.className = className;
        else if (elem.className !== className) {
            var classes = elem.className.split(/ +/);
            if (classes.indexOf(className) === -1) {
                classes.push(className);
                elem.className = classes.join(" ").replace(/^\s+/, "").replace(/\s+$/, "");
            }
        }
        return $5804bae86b063b2c$var$dom;
    },
    removeClass: function removeClass(elem, className) {
        if (className) {
            if (elem.className === className) elem.removeAttribute("class");
            else {
                var classes = elem.className.split(/ +/);
                var index = classes.indexOf(className);
                if (index !== -1) {
                    classes.splice(index, 1);
                    elem.className = classes.join(" ");
                }
            }
        } else elem.className = undefined;
        return $5804bae86b063b2c$var$dom;
    },
    hasClass: function hasClass(elem, className) {
        return new RegExp("(?:^|\\s+)" + className + "(?:\\s+|$)").test(elem.className) || false;
    },
    getWidth: function getWidth(elem) {
        var style = getComputedStyle(elem);
        return $5804bae86b063b2c$var$cssValueToPixels(style["border-left-width"]) + $5804bae86b063b2c$var$cssValueToPixels(style["border-right-width"]) + $5804bae86b063b2c$var$cssValueToPixels(style["padding-left"]) + $5804bae86b063b2c$var$cssValueToPixels(style["padding-right"]) + $5804bae86b063b2c$var$cssValueToPixels(style.width);
    },
    getHeight: function getHeight(elem) {
        var style = getComputedStyle(elem);
        return $5804bae86b063b2c$var$cssValueToPixels(style["border-top-width"]) + $5804bae86b063b2c$var$cssValueToPixels(style["border-bottom-width"]) + $5804bae86b063b2c$var$cssValueToPixels(style["padding-top"]) + $5804bae86b063b2c$var$cssValueToPixels(style["padding-bottom"]) + $5804bae86b063b2c$var$cssValueToPixels(style.height);
    },
    getOffset: function getOffset(el) {
        var elem = el;
        var offset = {
            left: 0,
            top: 0
        };
        if (elem.offsetParent) do {
            offset.left += elem.offsetLeft;
            offset.top += elem.offsetTop;
            elem = elem.offsetParent;
        }while (elem);
        return offset;
    },
    isActive: function isActive(elem) {
        return elem === document.activeElement && (elem.type || elem.href);
    }
};
var $5804bae86b063b2c$var$BooleanController = function(_Controller) {
    $5804bae86b063b2c$var$inherits(BooleanController, _Controller);
    function BooleanController(object, property) {
        $5804bae86b063b2c$var$classCallCheck(this, BooleanController);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (BooleanController.__proto__ || Object.getPrototypeOf(BooleanController)).call(this, object, property));
        var _this = _this2;
        _this2.__prev = _this2.getValue();
        _this2.__checkbox = document.createElement("input");
        _this2.__checkbox.setAttribute("type", "checkbox");
        function onChange() {
            _this.setValue(!_this.__prev);
        }
        $5804bae86b063b2c$var$dom.bind(_this2.__checkbox, "change", onChange, false);
        _this2.domElement.appendChild(_this2.__checkbox);
        _this2.updateDisplay();
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(BooleanController, [
        {
            key: "setValue",
            value: function setValue(v) {
                var toReturn = $5804bae86b063b2c$var$get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), "setValue", this).call(this, v);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
                this.__prev = this.getValue();
                return toReturn;
            }
        },
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                if (this.getValue() === true) {
                    this.__checkbox.setAttribute("checked", "checked");
                    this.__checkbox.checked = true;
                    this.__prev = true;
                } else {
                    this.__checkbox.checked = false;
                    this.__prev = false;
                }
                return $5804bae86b063b2c$var$get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), "updateDisplay", this).call(this);
            }
        }
    ]);
    return BooleanController;
}($5804bae86b063b2c$var$Controller);
var $5804bae86b063b2c$var$OptionController = function(_Controller) {
    $5804bae86b063b2c$var$inherits(OptionController, _Controller);
    function OptionController(object, property, opts) {
        $5804bae86b063b2c$var$classCallCheck(this, OptionController);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (OptionController.__proto__ || Object.getPrototypeOf(OptionController)).call(this, object, property));
        var options = opts;
        var _this = _this2;
        _this2.__select = document.createElement("select");
        if ($5804bae86b063b2c$var$Common.isArray(options)) {
            var map = {};
            $5804bae86b063b2c$var$Common.each(options, function(element) {
                map[element] = element;
            });
            options = map;
        }
        $5804bae86b063b2c$var$Common.each(options, function(value, key) {
            var opt = document.createElement("option");
            opt.innerHTML = key;
            opt.setAttribute("value", value);
            _this.__select.appendChild(opt);
        });
        _this2.updateDisplay();
        $5804bae86b063b2c$var$dom.bind(_this2.__select, "change", function() {
            var desiredValue = this.options[this.selectedIndex].value;
            _this.setValue(desiredValue);
        });
        _this2.domElement.appendChild(_this2.__select);
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(OptionController, [
        {
            key: "setValue",
            value: function setValue(v) {
                var toReturn = $5804bae86b063b2c$var$get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), "setValue", this).call(this, v);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
                return toReturn;
            }
        },
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                if ($5804bae86b063b2c$var$dom.isActive(this.__select)) return this;
                this.__select.value = this.getValue();
                return $5804bae86b063b2c$var$get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), "updateDisplay", this).call(this);
            }
        }
    ]);
    return OptionController;
}($5804bae86b063b2c$var$Controller);
var $5804bae86b063b2c$var$StringController = function(_Controller) {
    $5804bae86b063b2c$var$inherits(StringController, _Controller);
    function StringController(object, property) {
        $5804bae86b063b2c$var$classCallCheck(this, StringController);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (StringController.__proto__ || Object.getPrototypeOf(StringController)).call(this, object, property));
        var _this = _this2;
        function onChange() {
            _this.setValue(_this.__input.value);
        }
        function onBlur() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        _this2.__input = document.createElement("input");
        _this2.__input.setAttribute("type", "text");
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "keyup", onChange);
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "change", onChange);
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "blur", onBlur);
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "keydown", function(e) {
            if (e.keyCode === 13) this.blur();
        });
        _this2.updateDisplay();
        _this2.domElement.appendChild(_this2.__input);
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(StringController, [
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                if (!$5804bae86b063b2c$var$dom.isActive(this.__input)) this.__input.value = this.getValue();
                return $5804bae86b063b2c$var$get(StringController.prototype.__proto__ || Object.getPrototypeOf(StringController.prototype), "updateDisplay", this).call(this);
            }
        }
    ]);
    return StringController;
}($5804bae86b063b2c$var$Controller);
function $5804bae86b063b2c$var$numDecimals(x) {
    var _x = x.toString();
    if (_x.indexOf(".") > -1) return _x.length - _x.indexOf(".") - 1;
    return 0;
}
var $5804bae86b063b2c$var$NumberController = function(_Controller) {
    $5804bae86b063b2c$var$inherits(NumberController, _Controller);
    function NumberController(object, property, params) {
        $5804bae86b063b2c$var$classCallCheck(this, NumberController);
        var _this = $5804bae86b063b2c$var$possibleConstructorReturn(this, (NumberController.__proto__ || Object.getPrototypeOf(NumberController)).call(this, object, property));
        var _params = params || {};
        _this.__min = _params.min;
        _this.__max = _params.max;
        _this.__step = _params.step;
        if ($5804bae86b063b2c$var$Common.isUndefined(_this.__step)) {
            if (_this.initialValue === 0) _this.__impliedStep = 1;
            else _this.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(_this.initialValue)) / Math.LN10)) / 10;
        } else _this.__impliedStep = _this.__step;
        _this.__precision = $5804bae86b063b2c$var$numDecimals(_this.__impliedStep);
        return _this;
    }
    $5804bae86b063b2c$var$createClass(NumberController, [
        {
            key: "setValue",
            value: function setValue(v) {
                var _v = v;
                if (this.__min !== undefined && _v < this.__min) _v = this.__min;
                else if (this.__max !== undefined && _v > this.__max) _v = this.__max;
                if (this.__step !== undefined && _v % this.__step !== 0) _v = Math.round(_v / this.__step) * this.__step;
                return $5804bae86b063b2c$var$get(NumberController.prototype.__proto__ || Object.getPrototypeOf(NumberController.prototype), "setValue", this).call(this, _v);
            }
        },
        {
            key: "min",
            value: function min(minValue) {
                this.__min = minValue;
                return this;
            }
        },
        {
            key: "max",
            value: function max(maxValue) {
                this.__max = maxValue;
                return this;
            }
        },
        {
            key: "step",
            value: function step(stepValue) {
                this.__step = stepValue;
                this.__impliedStep = stepValue;
                this.__precision = $5804bae86b063b2c$var$numDecimals(stepValue);
                return this;
            }
        }
    ]);
    return NumberController;
}($5804bae86b063b2c$var$Controller);
function $5804bae86b063b2c$var$roundToDecimal(value, decimals) {
    var tenTo = Math.pow(10, decimals);
    return Math.round(value * tenTo) / tenTo;
}
var $5804bae86b063b2c$var$NumberControllerBox = function(_NumberController) {
    $5804bae86b063b2c$var$inherits(NumberControllerBox, _NumberController);
    function NumberControllerBox(object, property, params) {
        $5804bae86b063b2c$var$classCallCheck(this, NumberControllerBox);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (NumberControllerBox.__proto__ || Object.getPrototypeOf(NumberControllerBox)).call(this, object, property, params));
        _this2.__truncationSuspended = false;
        var _this = _this2;
        var prevY = void 0;
        function onChange() {
            var attempted = parseFloat(_this.__input.value);
            if (!$5804bae86b063b2c$var$Common.isNaN(attempted)) _this.setValue(attempted);
        }
        function onFinish() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        function onBlur() {
            onFinish();
        }
        function onMouseDrag(e) {
            var diff = prevY - e.clientY;
            _this.setValue(_this.getValue() + diff * _this.__impliedStep);
            prevY = e.clientY;
        }
        function onMouseUp() {
            $5804bae86b063b2c$var$dom.unbind(window, "mousemove", onMouseDrag);
            $5804bae86b063b2c$var$dom.unbind(window, "mouseup", onMouseUp);
            onFinish();
        }
        function onMouseDown(e) {
            $5804bae86b063b2c$var$dom.bind(window, "mousemove", onMouseDrag);
            $5804bae86b063b2c$var$dom.bind(window, "mouseup", onMouseUp);
            prevY = e.clientY;
        }
        _this2.__input = document.createElement("input");
        _this2.__input.setAttribute("type", "text");
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "change", onChange);
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "blur", onBlur);
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "mousedown", onMouseDown);
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "keydown", function(e) {
            if (e.keyCode === 13) {
                _this.__truncationSuspended = true;
                this.blur();
                _this.__truncationSuspended = false;
                onFinish();
            }
        });
        _this2.updateDisplay();
        _this2.domElement.appendChild(_this2.__input);
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(NumberControllerBox, [
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                this.__input.value = this.__truncationSuspended ? this.getValue() : $5804bae86b063b2c$var$roundToDecimal(this.getValue(), this.__precision);
                return $5804bae86b063b2c$var$get(NumberControllerBox.prototype.__proto__ || Object.getPrototypeOf(NumberControllerBox.prototype), "updateDisplay", this).call(this);
            }
        }
    ]);
    return NumberControllerBox;
}($5804bae86b063b2c$var$NumberController);
function $5804bae86b063b2c$var$map(v, i1, i2, o1, o2) {
    return o1 + (o2 - o1) * ((v - i1) / (i2 - i1));
}
var $5804bae86b063b2c$var$NumberControllerSlider = function(_NumberController) {
    $5804bae86b063b2c$var$inherits(NumberControllerSlider, _NumberController);
    function NumberControllerSlider(object, property, min, max, step) {
        $5804bae86b063b2c$var$classCallCheck(this, NumberControllerSlider);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (NumberControllerSlider.__proto__ || Object.getPrototypeOf(NumberControllerSlider)).call(this, object, property, {
            min: min,
            max: max,
            step: step
        }));
        var _this = _this2;
        _this2.__background = document.createElement("div");
        _this2.__foreground = document.createElement("div");
        $5804bae86b063b2c$var$dom.bind(_this2.__background, "mousedown", onMouseDown);
        $5804bae86b063b2c$var$dom.bind(_this2.__background, "touchstart", onTouchStart);
        $5804bae86b063b2c$var$dom.addClass(_this2.__background, "slider");
        $5804bae86b063b2c$var$dom.addClass(_this2.__foreground, "slider-fg");
        function onMouseDown(e) {
            document.activeElement.blur();
            $5804bae86b063b2c$var$dom.bind(window, "mousemove", onMouseDrag);
            $5804bae86b063b2c$var$dom.bind(window, "mouseup", onMouseUp);
            onMouseDrag(e);
        }
        function onMouseDrag(e) {
            e.preventDefault();
            var bgRect = _this.__background.getBoundingClientRect();
            _this.setValue($5804bae86b063b2c$var$map(e.clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
            return false;
        }
        function onMouseUp() {
            $5804bae86b063b2c$var$dom.unbind(window, "mousemove", onMouseDrag);
            $5804bae86b063b2c$var$dom.unbind(window, "mouseup", onMouseUp);
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        function onTouchStart(e) {
            if (e.touches.length !== 1) return;
            $5804bae86b063b2c$var$dom.bind(window, "touchmove", onTouchMove);
            $5804bae86b063b2c$var$dom.bind(window, "touchend", onTouchEnd);
            onTouchMove(e);
        }
        function onTouchMove(e) {
            var clientX = e.touches[0].clientX;
            var bgRect = _this.__background.getBoundingClientRect();
            _this.setValue($5804bae86b063b2c$var$map(clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
        }
        function onTouchEnd() {
            $5804bae86b063b2c$var$dom.unbind(window, "touchmove", onTouchMove);
            $5804bae86b063b2c$var$dom.unbind(window, "touchend", onTouchEnd);
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        _this2.updateDisplay();
        _this2.__background.appendChild(_this2.__foreground);
        _this2.domElement.appendChild(_this2.__background);
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(NumberControllerSlider, [
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                var pct = (this.getValue() - this.__min) / (this.__max - this.__min);
                this.__foreground.style.width = pct * 100 + "%";
                return $5804bae86b063b2c$var$get(NumberControllerSlider.prototype.__proto__ || Object.getPrototypeOf(NumberControllerSlider.prototype), "updateDisplay", this).call(this);
            }
        }
    ]);
    return NumberControllerSlider;
}($5804bae86b063b2c$var$NumberController);
var $5804bae86b063b2c$var$FunctionController = function(_Controller) {
    $5804bae86b063b2c$var$inherits(FunctionController, _Controller);
    function FunctionController(object, property, text) {
        $5804bae86b063b2c$var$classCallCheck(this, FunctionController);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (FunctionController.__proto__ || Object.getPrototypeOf(FunctionController)).call(this, object, property));
        var _this = _this2;
        _this2.__button = document.createElement("div");
        _this2.__button.innerHTML = text === undefined ? "Fire" : text;
        $5804bae86b063b2c$var$dom.bind(_this2.__button, "click", function(e) {
            e.preventDefault();
            _this.fire();
            return false;
        });
        $5804bae86b063b2c$var$dom.addClass(_this2.__button, "button");
        _this2.domElement.appendChild(_this2.__button);
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(FunctionController, [
        {
            key: "fire",
            value: function fire() {
                if (this.__onChange) this.__onChange.call(this);
                this.getValue().call(this.object);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
            }
        }
    ]);
    return FunctionController;
}($5804bae86b063b2c$var$Controller);
var $5804bae86b063b2c$var$ColorController = function(_Controller) {
    $5804bae86b063b2c$var$inherits(ColorController, _Controller);
    function ColorController(object, property) {
        $5804bae86b063b2c$var$classCallCheck(this, ColorController);
        var _this2 = $5804bae86b063b2c$var$possibleConstructorReturn(this, (ColorController.__proto__ || Object.getPrototypeOf(ColorController)).call(this, object, property));
        _this2.__color = new $5804bae86b063b2c$var$Color(_this2.getValue());
        _this2.__temp = new $5804bae86b063b2c$var$Color(0);
        var _this = _this2;
        _this2.domElement = document.createElement("div");
        $5804bae86b063b2c$var$dom.makeSelectable(_this2.domElement, false);
        _this2.__selector = document.createElement("div");
        _this2.__selector.className = "selector";
        _this2.__saturation_field = document.createElement("div");
        _this2.__saturation_field.className = "saturation-field";
        _this2.__field_knob = document.createElement("div");
        _this2.__field_knob.className = "field-knob";
        _this2.__field_knob_border = "2px solid ";
        _this2.__hue_knob = document.createElement("div");
        _this2.__hue_knob.className = "hue-knob";
        _this2.__hue_field = document.createElement("div");
        _this2.__hue_field.className = "hue-field";
        _this2.__input = document.createElement("input");
        _this2.__input.type = "text";
        _this2.__input_textShadow = "0 1px 1px ";
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "keydown", function(e) {
            if (e.keyCode === 13) onBlur.call(this);
        });
        $5804bae86b063b2c$var$dom.bind(_this2.__input, "blur", onBlur);
        $5804bae86b063b2c$var$dom.bind(_this2.__selector, "mousedown", function() {
            $5804bae86b063b2c$var$dom.addClass(this, "drag").bind(window, "mouseup", function() {
                $5804bae86b063b2c$var$dom.removeClass(_this.__selector, "drag");
            });
        });
        $5804bae86b063b2c$var$dom.bind(_this2.__selector, "touchstart", function() {
            $5804bae86b063b2c$var$dom.addClass(this, "drag").bind(window, "touchend", function() {
                $5804bae86b063b2c$var$dom.removeClass(_this.__selector, "drag");
            });
        });
        var valueField = document.createElement("div");
        $5804bae86b063b2c$var$Common.extend(_this2.__selector.style, {
            width: "122px",
            height: "102px",
            padding: "3px",
            backgroundColor: "#222",
            boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
        });
        $5804bae86b063b2c$var$Common.extend(_this2.__field_knob.style, {
            position: "absolute",
            width: "12px",
            height: "12px",
            border: _this2.__field_knob_border + (_this2.__color.v < 0.5 ? "#fff" : "#000"),
            boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
            borderRadius: "12px",
            zIndex: 1
        });
        $5804bae86b063b2c$var$Common.extend(_this2.__hue_knob.style, {
            position: "absolute",
            width: "15px",
            height: "2px",
            borderRight: "4px solid #fff",
            zIndex: 1
        });
        $5804bae86b063b2c$var$Common.extend(_this2.__saturation_field.style, {
            width: "100px",
            height: "100px",
            border: "1px solid #555",
            marginRight: "3px",
            display: "inline-block",
            cursor: "pointer"
        });
        $5804bae86b063b2c$var$Common.extend(valueField.style, {
            width: "100%",
            height: "100%",
            background: "none"
        });
        $5804bae86b063b2c$var$linearGradient(valueField, "top", "rgba(0,0,0,0)", "#000");
        $5804bae86b063b2c$var$Common.extend(_this2.__hue_field.style, {
            width: "15px",
            height: "100px",
            border: "1px solid #555",
            cursor: "ns-resize",
            position: "absolute",
            top: "3px",
            right: "3px"
        });
        $5804bae86b063b2c$var$hueGradient(_this2.__hue_field);
        $5804bae86b063b2c$var$Common.extend(_this2.__input.style, {
            outline: "none",
            textAlign: "center",
            color: "#fff",
            border: 0,
            fontWeight: "bold",
            textShadow: _this2.__input_textShadow + "rgba(0,0,0,0.7)"
        });
        $5804bae86b063b2c$var$dom.bind(_this2.__saturation_field, "mousedown", fieldDown);
        $5804bae86b063b2c$var$dom.bind(_this2.__saturation_field, "touchstart", fieldDown);
        $5804bae86b063b2c$var$dom.bind(_this2.__field_knob, "mousedown", fieldDown);
        $5804bae86b063b2c$var$dom.bind(_this2.__field_knob, "touchstart", fieldDown);
        $5804bae86b063b2c$var$dom.bind(_this2.__hue_field, "mousedown", fieldDownH);
        $5804bae86b063b2c$var$dom.bind(_this2.__hue_field, "touchstart", fieldDownH);
        function fieldDown(e) {
            setSV(e);
            $5804bae86b063b2c$var$dom.bind(window, "mousemove", setSV);
            $5804bae86b063b2c$var$dom.bind(window, "touchmove", setSV);
            $5804bae86b063b2c$var$dom.bind(window, "mouseup", fieldUpSV);
            $5804bae86b063b2c$var$dom.bind(window, "touchend", fieldUpSV);
        }
        function fieldDownH(e) {
            setH(e);
            $5804bae86b063b2c$var$dom.bind(window, "mousemove", setH);
            $5804bae86b063b2c$var$dom.bind(window, "touchmove", setH);
            $5804bae86b063b2c$var$dom.bind(window, "mouseup", fieldUpH);
            $5804bae86b063b2c$var$dom.bind(window, "touchend", fieldUpH);
        }
        function fieldUpSV() {
            $5804bae86b063b2c$var$dom.unbind(window, "mousemove", setSV);
            $5804bae86b063b2c$var$dom.unbind(window, "touchmove", setSV);
            $5804bae86b063b2c$var$dom.unbind(window, "mouseup", fieldUpSV);
            $5804bae86b063b2c$var$dom.unbind(window, "touchend", fieldUpSV);
            onFinish();
        }
        function fieldUpH() {
            $5804bae86b063b2c$var$dom.unbind(window, "mousemove", setH);
            $5804bae86b063b2c$var$dom.unbind(window, "touchmove", setH);
            $5804bae86b063b2c$var$dom.unbind(window, "mouseup", fieldUpH);
            $5804bae86b063b2c$var$dom.unbind(window, "touchend", fieldUpH);
            onFinish();
        }
        function onBlur() {
            var i = $5804bae86b063b2c$var$interpret(this.value);
            if (i !== false) {
                _this.__color.__state = i;
                _this.setValue(_this.__color.toOriginal());
            } else this.value = _this.__color.toString();
        }
        function onFinish() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.__color.toOriginal());
        }
        _this2.__saturation_field.appendChild(valueField);
        _this2.__selector.appendChild(_this2.__field_knob);
        _this2.__selector.appendChild(_this2.__saturation_field);
        _this2.__selector.appendChild(_this2.__hue_field);
        _this2.__hue_field.appendChild(_this2.__hue_knob);
        _this2.domElement.appendChild(_this2.__input);
        _this2.domElement.appendChild(_this2.__selector);
        _this2.updateDisplay();
        function setSV(e) {
            if (e.type.indexOf("touch") === -1) e.preventDefault();
            var fieldRect = _this.__saturation_field.getBoundingClientRect();
            var _ref = e.touches && e.touches[0] || e, clientX = _ref.clientX, clientY = _ref.clientY;
            var s = (clientX - fieldRect.left) / (fieldRect.right - fieldRect.left);
            var v = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
            if (v > 1) v = 1;
            else if (v < 0) v = 0;
            if (s > 1) s = 1;
            else if (s < 0) s = 0;
            _this.__color.v = v;
            _this.__color.s = s;
            _this.setValue(_this.__color.toOriginal());
            return false;
        }
        function setH(e) {
            if (e.type.indexOf("touch") === -1) e.preventDefault();
            var fieldRect = _this.__hue_field.getBoundingClientRect();
            var _ref2 = e.touches && e.touches[0] || e, clientY = _ref2.clientY;
            var h = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
            if (h > 1) h = 1;
            else if (h < 0) h = 0;
            _this.__color.h = h * 360;
            _this.setValue(_this.__color.toOriginal());
            return false;
        }
        return _this2;
    }
    $5804bae86b063b2c$var$createClass(ColorController, [
        {
            key: "updateDisplay",
            value: function updateDisplay() {
                var i = $5804bae86b063b2c$var$interpret(this.getValue());
                if (i !== false) {
                    var mismatch = false;
                    $5804bae86b063b2c$var$Common.each($5804bae86b063b2c$var$Color.COMPONENTS, function(component) {
                        if (!$5804bae86b063b2c$var$Common.isUndefined(i[component]) && !$5804bae86b063b2c$var$Common.isUndefined(this.__color.__state[component]) && i[component] !== this.__color.__state[component]) {
                            mismatch = true;
                            return {};
                        }
                    }, this);
                    if (mismatch) $5804bae86b063b2c$var$Common.extend(this.__color.__state, i);
                }
                $5804bae86b063b2c$var$Common.extend(this.__temp.__state, this.__color.__state);
                this.__temp.a = 1;
                var flip = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0;
                var _flip = 255 - flip;
                $5804bae86b063b2c$var$Common.extend(this.__field_knob.style, {
                    marginLeft: 100 * this.__color.s - 7 + "px",
                    marginTop: 100 * (1 - this.__color.v) - 7 + "px",
                    backgroundColor: this.__temp.toHexString(),
                    border: this.__field_knob_border + "rgb(" + flip + "," + flip + "," + flip + ")"
                });
                this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + "px";
                this.__temp.s = 1;
                this.__temp.v = 1;
                $5804bae86b063b2c$var$linearGradient(this.__saturation_field, "left", "#fff", this.__temp.toHexString());
                this.__input.value = this.__color.toString();
                $5804bae86b063b2c$var$Common.extend(this.__input.style, {
                    backgroundColor: this.__color.toHexString(),
                    color: "rgb(" + flip + "," + flip + "," + flip + ")",
                    textShadow: this.__input_textShadow + "rgba(" + _flip + "," + _flip + "," + _flip + ",.7)"
                });
            }
        }
    ]);
    return ColorController;
}($5804bae86b063b2c$var$Controller);
var $5804bae86b063b2c$var$vendors = [
    "-moz-",
    "-o-",
    "-webkit-",
    "-ms-",
    ""
];
function $5804bae86b063b2c$var$linearGradient(elem, x, a, b) {
    elem.style.background = "";
    $5804bae86b063b2c$var$Common.each($5804bae86b063b2c$var$vendors, function(vendor) {
        elem.style.cssText += "background: " + vendor + "linear-gradient(" + x + ", " + a + " 0%, " + b + " 100%); ";
    });
}
function $5804bae86b063b2c$var$hueGradient(elem) {
    elem.style.background = "";
    elem.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);";
    elem.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
    elem.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
    elem.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
    elem.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
}
var $5804bae86b063b2c$var$css = {
    load: function load(url, indoc) {
        var doc = indoc || document;
        var link = doc.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        doc.getElementsByTagName("head")[0].appendChild(link);
    },
    inject: function inject(cssContent, indoc) {
        var doc = indoc || document;
        var injected = document.createElement("style");
        injected.type = "text/css";
        injected.innerHTML = cssContent;
        var head = doc.getElementsByTagName("head")[0];
        try {
            head.appendChild(injected);
        } catch (e) {}
    }
};
var $5804bae86b063b2c$var$saveDialogContents = '<div id="dg-save" class="dg dialogue">\n\n  Here\'s the new load parameter for your <code>GUI</code>\'s constructor:\n\n  <textarea id="dg-new-constructor"></textarea>\n\n  <div id="dg-save-locally">\n\n    <input id="dg-local-storage" type="checkbox"/> Automatically save\n    values to <code>localStorage</code> on exit.\n\n    <div id="dg-local-explain">The values saved to <code>localStorage</code> will\n      override those passed to <code>dat.GUI</code>\'s constructor. This makes it\n      easier to work incrementally, but <code>localStorage</code> is fragile,\n      and your friends may not see the same values you do.\n\n    </div>\n\n  </div>\n\n</div>';
var $5804bae86b063b2c$var$ControllerFactory = function ControllerFactory(object, property) {
    var initialValue = object[property];
    if ($5804bae86b063b2c$var$Common.isArray(arguments[2]) || $5804bae86b063b2c$var$Common.isObject(arguments[2])) return new $5804bae86b063b2c$var$OptionController(object, property, arguments[2]);
    if ($5804bae86b063b2c$var$Common.isNumber(initialValue)) {
        if ($5804bae86b063b2c$var$Common.isNumber(arguments[2]) && $5804bae86b063b2c$var$Common.isNumber(arguments[3])) {
            if ($5804bae86b063b2c$var$Common.isNumber(arguments[4])) return new $5804bae86b063b2c$var$NumberControllerSlider(object, property, arguments[2], arguments[3], arguments[4]);
            return new $5804bae86b063b2c$var$NumberControllerSlider(object, property, arguments[2], arguments[3]);
        }
        if ($5804bae86b063b2c$var$Common.isNumber(arguments[4])) return new $5804bae86b063b2c$var$NumberControllerBox(object, property, {
            min: arguments[2],
            max: arguments[3],
            step: arguments[4]
        });
        return new $5804bae86b063b2c$var$NumberControllerBox(object, property, {
            min: arguments[2],
            max: arguments[3]
        });
    }
    if ($5804bae86b063b2c$var$Common.isString(initialValue)) return new $5804bae86b063b2c$var$StringController(object, property);
    if ($5804bae86b063b2c$var$Common.isFunction(initialValue)) return new $5804bae86b063b2c$var$FunctionController(object, property, "");
    if ($5804bae86b063b2c$var$Common.isBoolean(initialValue)) return new $5804bae86b063b2c$var$BooleanController(object, property);
    return null;
};
function $5804bae86b063b2c$var$requestAnimationFrame(callback) {
    setTimeout(callback, 1000 / 60);
}
var $5804bae86b063b2c$var$requestAnimationFrame$1 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || $5804bae86b063b2c$var$requestAnimationFrame;
var $5804bae86b063b2c$var$CenteredDiv = function() {
    function CenteredDiv() {
        $5804bae86b063b2c$var$classCallCheck(this, CenteredDiv);
        this.backgroundElement = document.createElement("div");
        $5804bae86b063b2c$var$Common.extend(this.backgroundElement.style, {
            backgroundColor: "rgba(0,0,0,0.8)",
            top: 0,
            left: 0,
            display: "none",
            zIndex: "1000",
            opacity: 0,
            WebkitTransition: "opacity 0.2s linear",
            transition: "opacity 0.2s linear"
        });
        $5804bae86b063b2c$var$dom.makeFullscreen(this.backgroundElement);
        this.backgroundElement.style.position = "fixed";
        this.domElement = document.createElement("div");
        $5804bae86b063b2c$var$Common.extend(this.domElement.style, {
            position: "fixed",
            display: "none",
            zIndex: "1001",
            opacity: 0,
            WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
            transition: "transform 0.2s ease-out, opacity 0.2s linear"
        });
        document.body.appendChild(this.backgroundElement);
        document.body.appendChild(this.domElement);
        var _this = this;
        $5804bae86b063b2c$var$dom.bind(this.backgroundElement, "click", function() {
            _this.hide();
        });
    }
    $5804bae86b063b2c$var$createClass(CenteredDiv, [
        {
            key: "show",
            value: function show() {
                var _this = this;
                this.backgroundElement.style.display = "block";
                this.domElement.style.display = "block";
                this.domElement.style.opacity = 0;
                this.domElement.style.webkitTransform = "scale(1.1)";
                this.layout();
                $5804bae86b063b2c$var$Common.defer(function() {
                    _this.backgroundElement.style.opacity = 1;
                    _this.domElement.style.opacity = 1;
                    _this.domElement.style.webkitTransform = "scale(1)";
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var hide = function hide() {
                    _this.domElement.style.display = "none";
                    _this.backgroundElement.style.display = "none";
                    $5804bae86b063b2c$var$dom.unbind(_this.domElement, "webkitTransitionEnd", hide);
                    $5804bae86b063b2c$var$dom.unbind(_this.domElement, "transitionend", hide);
                    $5804bae86b063b2c$var$dom.unbind(_this.domElement, "oTransitionEnd", hide);
                };
                $5804bae86b063b2c$var$dom.bind(this.domElement, "webkitTransitionEnd", hide);
                $5804bae86b063b2c$var$dom.bind(this.domElement, "transitionend", hide);
                $5804bae86b063b2c$var$dom.bind(this.domElement, "oTransitionEnd", hide);
                this.backgroundElement.style.opacity = 0;
                this.domElement.style.opacity = 0;
                this.domElement.style.webkitTransform = "scale(1.1)";
            }
        },
        {
            key: "layout",
            value: function layout() {
                this.domElement.style.left = window.innerWidth / 2 - $5804bae86b063b2c$var$dom.getWidth(this.domElement) / 2 + "px";
                this.domElement.style.top = window.innerHeight / 2 - $5804bae86b063b2c$var$dom.getHeight(this.domElement) / 2 + "px";
            }
        }
    ]);
    return CenteredDiv;
}();
var $5804bae86b063b2c$var$styleSheet = $5804bae86b063b2c$var$___$insertStyle(".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}\n");
$5804bae86b063b2c$var$css.inject($5804bae86b063b2c$var$styleSheet);
var $5804bae86b063b2c$var$CSS_NAMESPACE = "dg";
var $5804bae86b063b2c$var$HIDE_KEY_CODE = 72;
var $5804bae86b063b2c$var$CLOSE_BUTTON_HEIGHT = 20;
var $5804bae86b063b2c$var$DEFAULT_DEFAULT_PRESET_NAME = "Default";
var $5804bae86b063b2c$var$SUPPORTS_LOCAL_STORAGE = function() {
    try {
        return !!window.localStorage;
    } catch (e) {
        return false;
    }
}();
var $5804bae86b063b2c$var$SAVE_DIALOGUE = void 0;
var $5804bae86b063b2c$var$autoPlaceVirgin = true;
var $5804bae86b063b2c$var$autoPlaceContainer = void 0;
var $5804bae86b063b2c$var$hide = false;
var $5804bae86b063b2c$var$hideableGuis = [];
var $5804bae86b063b2c$var$GUI = function GUI(pars) {
    var _this = this;
    var params = pars || {};
    this.domElement = document.createElement("div");
    this.__ul = document.createElement("ul");
    this.domElement.appendChild(this.__ul);
    $5804bae86b063b2c$var$dom.addClass(this.domElement, $5804bae86b063b2c$var$CSS_NAMESPACE);
    this.__folders = {};
    this.__controllers = [];
    this.__rememberedObjects = [];
    this.__rememberedObjectIndecesToControllers = [];
    this.__listening = [];
    params = $5804bae86b063b2c$var$Common.defaults(params, {
        closeOnTop: false,
        autoPlace: true,
        width: GUI.DEFAULT_WIDTH
    });
    params = $5804bae86b063b2c$var$Common.defaults(params, {
        resizable: params.autoPlace,
        hideable: params.autoPlace
    });
    if (!$5804bae86b063b2c$var$Common.isUndefined(params.load)) {
        if (params.preset) params.load.preset = params.preset;
    } else params.load = {
        preset: $5804bae86b063b2c$var$DEFAULT_DEFAULT_PRESET_NAME
    };
    if ($5804bae86b063b2c$var$Common.isUndefined(params.parent) && params.hideable) $5804bae86b063b2c$var$hideableGuis.push(this);
    params.resizable = $5804bae86b063b2c$var$Common.isUndefined(params.parent) && params.resizable;
    if (params.autoPlace && $5804bae86b063b2c$var$Common.isUndefined(params.scrollable)) params.scrollable = true;
    var useLocalStorage = $5804bae86b063b2c$var$SUPPORTS_LOCAL_STORAGE && localStorage.getItem($5804bae86b063b2c$var$getLocalStorageHash(this, "isLocal")) === "true";
    var saveToLocalStorage = void 0;
    var titleRow = void 0;
    Object.defineProperties(this, {
        parent: {
            get: function get$$1() {
                return params.parent;
            }
        },
        scrollable: {
            get: function get$$1() {
                return params.scrollable;
            }
        },
        autoPlace: {
            get: function get$$1() {
                return params.autoPlace;
            }
        },
        closeOnTop: {
            get: function get$$1() {
                return params.closeOnTop;
            }
        },
        preset: {
            get: function get$$1() {
                if (_this.parent) return _this.getRoot().preset;
                return params.load.preset;
            },
            set: function set$$1(v) {
                if (_this.parent) _this.getRoot().preset = v;
                else params.load.preset = v;
                $5804bae86b063b2c$var$setPresetSelectIndex(this);
                _this.revert();
            }
        },
        width: {
            get: function get$$1() {
                return params.width;
            },
            set: function set$$1(v) {
                params.width = v;
                $5804bae86b063b2c$var$setWidth(_this, v);
            }
        },
        name: {
            get: function get$$1() {
                return params.name;
            },
            set: function set$$1(v) {
                params.name = v;
                if (titleRow) titleRow.innerHTML = params.name;
            }
        },
        closed: {
            get: function get$$1() {
                return params.closed;
            },
            set: function set$$1(v) {
                params.closed = v;
                if (params.closed) $5804bae86b063b2c$var$dom.addClass(_this.__ul, GUI.CLASS_CLOSED);
                else $5804bae86b063b2c$var$dom.removeClass(_this.__ul, GUI.CLASS_CLOSED);
                this.onResize();
                if (_this.__closeButton) _this.__closeButton.innerHTML = v ? GUI.TEXT_OPEN : GUI.TEXT_CLOSED;
            }
        },
        load: {
            get: function get$$1() {
                return params.load;
            }
        },
        useLocalStorage: {
            get: function get$$1() {
                return useLocalStorage;
            },
            set: function set$$1(bool) {
                if ($5804bae86b063b2c$var$SUPPORTS_LOCAL_STORAGE) {
                    useLocalStorage = bool;
                    if (bool) $5804bae86b063b2c$var$dom.bind(window, "unload", saveToLocalStorage);
                    else $5804bae86b063b2c$var$dom.unbind(window, "unload", saveToLocalStorage);
                    localStorage.setItem($5804bae86b063b2c$var$getLocalStorageHash(_this, "isLocal"), bool);
                }
            }
        }
    });
    if ($5804bae86b063b2c$var$Common.isUndefined(params.parent)) {
        this.closed = params.closed || false;
        $5804bae86b063b2c$var$dom.addClass(this.domElement, GUI.CLASS_MAIN);
        $5804bae86b063b2c$var$dom.makeSelectable(this.domElement, false);
        if ($5804bae86b063b2c$var$SUPPORTS_LOCAL_STORAGE) {
            if (useLocalStorage) {
                _this.useLocalStorage = true;
                var savedGui = localStorage.getItem($5804bae86b063b2c$var$getLocalStorageHash(this, "gui"));
                if (savedGui) params.load = JSON.parse(savedGui);
            }
        }
        this.__closeButton = document.createElement("div");
        this.__closeButton.innerHTML = GUI.TEXT_CLOSED;
        $5804bae86b063b2c$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BUTTON);
        if (params.closeOnTop) {
            $5804bae86b063b2c$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_TOP);
            this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0]);
        } else {
            $5804bae86b063b2c$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BOTTOM);
            this.domElement.appendChild(this.__closeButton);
        }
        $5804bae86b063b2c$var$dom.bind(this.__closeButton, "click", function() {
            _this.closed = !_this.closed;
        });
    } else {
        if (params.closed === undefined) params.closed = true;
        var titleRowName = document.createTextNode(params.name);
        $5804bae86b063b2c$var$dom.addClass(titleRowName, "controller-name");
        titleRow = $5804bae86b063b2c$var$addRow(_this, titleRowName);
        var onClickTitle = function onClickTitle(e) {
            e.preventDefault();
            _this.closed = !_this.closed;
            return false;
        };
        $5804bae86b063b2c$var$dom.addClass(this.__ul, GUI.CLASS_CLOSED);
        $5804bae86b063b2c$var$dom.addClass(titleRow, "title");
        $5804bae86b063b2c$var$dom.bind(titleRow, "click", onClickTitle);
        if (!params.closed) this.closed = false;
    }
    if (params.autoPlace) {
        if ($5804bae86b063b2c$var$Common.isUndefined(params.parent)) {
            if ($5804bae86b063b2c$var$autoPlaceVirgin) {
                $5804bae86b063b2c$var$autoPlaceContainer = document.createElement("div");
                $5804bae86b063b2c$var$dom.addClass($5804bae86b063b2c$var$autoPlaceContainer, $5804bae86b063b2c$var$CSS_NAMESPACE);
                $5804bae86b063b2c$var$dom.addClass($5804bae86b063b2c$var$autoPlaceContainer, GUI.CLASS_AUTO_PLACE_CONTAINER);
                document.body.appendChild($5804bae86b063b2c$var$autoPlaceContainer);
                $5804bae86b063b2c$var$autoPlaceVirgin = false;
            }
            $5804bae86b063b2c$var$autoPlaceContainer.appendChild(this.domElement);
            $5804bae86b063b2c$var$dom.addClass(this.domElement, GUI.CLASS_AUTO_PLACE);
        }
        if (!this.parent) $5804bae86b063b2c$var$setWidth(_this, params.width);
    }
    this.__resizeHandler = function() {
        _this.onResizeDebounced();
    };
    $5804bae86b063b2c$var$dom.bind(window, "resize", this.__resizeHandler);
    $5804bae86b063b2c$var$dom.bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler);
    $5804bae86b063b2c$var$dom.bind(this.__ul, "transitionend", this.__resizeHandler);
    $5804bae86b063b2c$var$dom.bind(this.__ul, "oTransitionEnd", this.__resizeHandler);
    this.onResize();
    if (params.resizable) $5804bae86b063b2c$var$addResizeHandle(this);
    saveToLocalStorage = function saveToLocalStorage() {
        if ($5804bae86b063b2c$var$SUPPORTS_LOCAL_STORAGE && localStorage.getItem($5804bae86b063b2c$var$getLocalStorageHash(_this, "isLocal")) === "true") localStorage.setItem($5804bae86b063b2c$var$getLocalStorageHash(_this, "gui"), JSON.stringify(_this.getSaveObject()));
    };
    this.saveToLocalStorageIfPossible = saveToLocalStorage;
    function resetWidth() {
        var root = _this.getRoot();
        root.width += 1;
        $5804bae86b063b2c$var$Common.defer(function() {
            root.width -= 1;
        });
    }
    if (!params.parent) resetWidth();
};
$5804bae86b063b2c$var$GUI.toggleHide = function() {
    $5804bae86b063b2c$var$hide = !$5804bae86b063b2c$var$hide;
    $5804bae86b063b2c$var$Common.each($5804bae86b063b2c$var$hideableGuis, function(gui) {
        gui.domElement.style.display = $5804bae86b063b2c$var$hide ? "none" : "";
    });
};
$5804bae86b063b2c$var$GUI.CLASS_AUTO_PLACE = "a";
$5804bae86b063b2c$var$GUI.CLASS_AUTO_PLACE_CONTAINER = "ac";
$5804bae86b063b2c$var$GUI.CLASS_MAIN = "main";
$5804bae86b063b2c$var$GUI.CLASS_CONTROLLER_ROW = "cr";
$5804bae86b063b2c$var$GUI.CLASS_TOO_TALL = "taller-than-window";
$5804bae86b063b2c$var$GUI.CLASS_CLOSED = "closed";
$5804bae86b063b2c$var$GUI.CLASS_CLOSE_BUTTON = "close-button";
$5804bae86b063b2c$var$GUI.CLASS_CLOSE_TOP = "close-top";
$5804bae86b063b2c$var$GUI.CLASS_CLOSE_BOTTOM = "close-bottom";
$5804bae86b063b2c$var$GUI.CLASS_DRAG = "drag";
$5804bae86b063b2c$var$GUI.DEFAULT_WIDTH = 245;
$5804bae86b063b2c$var$GUI.TEXT_CLOSED = "Close Controls";
$5804bae86b063b2c$var$GUI.TEXT_OPEN = "Open Controls";
$5804bae86b063b2c$var$GUI._keydownHandler = function(e) {
    if (document.activeElement.type !== "text" && (e.which === $5804bae86b063b2c$var$HIDE_KEY_CODE || e.keyCode === $5804bae86b063b2c$var$HIDE_KEY_CODE)) $5804bae86b063b2c$var$GUI.toggleHide();
};
$5804bae86b063b2c$var$dom.bind(window, "keydown", $5804bae86b063b2c$var$GUI._keydownHandler, false);
$5804bae86b063b2c$var$Common.extend($5804bae86b063b2c$var$GUI.prototype, {
    add: function add(object, property) {
        return $5804bae86b063b2c$var$_add(this, object, property, {
            factoryArgs: Array.prototype.slice.call(arguments, 2)
        });
    },
    addColor: function addColor(object, property) {
        return $5804bae86b063b2c$var$_add(this, object, property, {
            color: true
        });
    },
    remove: function remove(controller) {
        this.__ul.removeChild(controller.__li);
        this.__controllers.splice(this.__controllers.indexOf(controller), 1);
        var _this = this;
        $5804bae86b063b2c$var$Common.defer(function() {
            _this.onResize();
        });
    },
    destroy: function destroy() {
        if (this.parent) throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
        if (this.autoPlace) $5804bae86b063b2c$var$autoPlaceContainer.removeChild(this.domElement);
        var _this = this;
        $5804bae86b063b2c$var$Common.each(this.__folders, function(subfolder) {
            _this.removeFolder(subfolder);
        });
        $5804bae86b063b2c$var$dom.unbind(window, "keydown", $5804bae86b063b2c$var$GUI._keydownHandler, false);
        $5804bae86b063b2c$var$removeListeners(this);
    },
    addFolder: function addFolder(name) {
        if (this.__folders[name] !== undefined) throw new Error('You already have a folder in this GUI by the name "' + name + '"');
        var newGuiParams = {
            name: name,
            parent: this
        };
        newGuiParams.autoPlace = this.autoPlace;
        if (this.load && this.load.folders && this.load.folders[name]) {
            newGuiParams.closed = this.load.folders[name].closed;
            newGuiParams.load = this.load.folders[name];
        }
        var gui = new $5804bae86b063b2c$var$GUI(newGuiParams);
        this.__folders[name] = gui;
        var li = $5804bae86b063b2c$var$addRow(this, gui.domElement);
        $5804bae86b063b2c$var$dom.addClass(li, "folder");
        return gui;
    },
    removeFolder: function removeFolder(folder) {
        this.__ul.removeChild(folder.domElement.parentElement);
        delete this.__folders[folder.name];
        if (this.load && this.load.folders && this.load.folders[folder.name]) delete this.load.folders[folder.name];
        $5804bae86b063b2c$var$removeListeners(folder);
        var _this = this;
        $5804bae86b063b2c$var$Common.each(folder.__folders, function(subfolder) {
            folder.removeFolder(subfolder);
        });
        $5804bae86b063b2c$var$Common.defer(function() {
            _this.onResize();
        });
    },
    open: function open() {
        this.closed = false;
    },
    close: function close() {
        this.closed = true;
    },
    hide: function hide() {
        this.domElement.style.display = "none";
    },
    show: function show() {
        this.domElement.style.display = "";
    },
    onResize: function onResize() {
        var root = this.getRoot();
        if (root.scrollable) {
            var top = $5804bae86b063b2c$var$dom.getOffset(root.__ul).top;
            var h = 0;
            $5804bae86b063b2c$var$Common.each(root.__ul.childNodes, function(node) {
                if (!(root.autoPlace && node === root.__save_row)) h += $5804bae86b063b2c$var$dom.getHeight(node);
            });
            if (window.innerHeight - top - $5804bae86b063b2c$var$CLOSE_BUTTON_HEIGHT < h) {
                $5804bae86b063b2c$var$dom.addClass(root.domElement, $5804bae86b063b2c$var$GUI.CLASS_TOO_TALL);
                root.__ul.style.height = window.innerHeight - top - $5804bae86b063b2c$var$CLOSE_BUTTON_HEIGHT + "px";
            } else {
                $5804bae86b063b2c$var$dom.removeClass(root.domElement, $5804bae86b063b2c$var$GUI.CLASS_TOO_TALL);
                root.__ul.style.height = "auto";
            }
        }
        if (root.__resize_handle) $5804bae86b063b2c$var$Common.defer(function() {
            root.__resize_handle.style.height = root.__ul.offsetHeight + "px";
        });
        if (root.__closeButton) root.__closeButton.style.width = root.width + "px";
    },
    onResizeDebounced: $5804bae86b063b2c$var$Common.debounce(function() {
        this.onResize();
    }, 50),
    remember: function remember() {
        if ($5804bae86b063b2c$var$Common.isUndefined($5804bae86b063b2c$var$SAVE_DIALOGUE)) {
            $5804bae86b063b2c$var$SAVE_DIALOGUE = new $5804bae86b063b2c$var$CenteredDiv();
            $5804bae86b063b2c$var$SAVE_DIALOGUE.domElement.innerHTML = $5804bae86b063b2c$var$saveDialogContents;
        }
        if (this.parent) throw new Error("You can only call remember on a top level GUI.");
        var _this = this;
        $5804bae86b063b2c$var$Common.each(Array.prototype.slice.call(arguments), function(object) {
            if (_this.__rememberedObjects.length === 0) $5804bae86b063b2c$var$addSaveMenu(_this);
            if (_this.__rememberedObjects.indexOf(object) === -1) _this.__rememberedObjects.push(object);
        });
        if (this.autoPlace) $5804bae86b063b2c$var$setWidth(this, this.width);
    },
    getRoot: function getRoot() {
        var gui = this;
        while(gui.parent)gui = gui.parent;
        return gui;
    },
    getSaveObject: function getSaveObject() {
        var toReturn = this.load;
        toReturn.closed = this.closed;
        if (this.__rememberedObjects.length > 0) {
            toReturn.preset = this.preset;
            if (!toReturn.remembered) toReturn.remembered = {};
            toReturn.remembered[this.preset] = $5804bae86b063b2c$var$getCurrentPreset(this);
        }
        toReturn.folders = {};
        $5804bae86b063b2c$var$Common.each(this.__folders, function(element, key) {
            toReturn.folders[key] = element.getSaveObject();
        });
        return toReturn;
    },
    save: function save() {
        if (!this.load.remembered) this.load.remembered = {};
        this.load.remembered[this.preset] = $5804bae86b063b2c$var$getCurrentPreset(this);
        $5804bae86b063b2c$var$markPresetModified(this, false);
        this.saveToLocalStorageIfPossible();
    },
    saveAs: function saveAs(presetName) {
        if (!this.load.remembered) {
            this.load.remembered = {};
            this.load.remembered[$5804bae86b063b2c$var$DEFAULT_DEFAULT_PRESET_NAME] = $5804bae86b063b2c$var$getCurrentPreset(this, true);
        }
        this.load.remembered[presetName] = $5804bae86b063b2c$var$getCurrentPreset(this);
        this.preset = presetName;
        $5804bae86b063b2c$var$addPresetOption(this, presetName, true);
        this.saveToLocalStorageIfPossible();
    },
    revert: function revert(gui) {
        $5804bae86b063b2c$var$Common.each(this.__controllers, function(controller) {
            if (!this.getRoot().load.remembered) controller.setValue(controller.initialValue);
            else $5804bae86b063b2c$var$recallSavedValue(gui || this.getRoot(), controller);
            if (controller.__onFinishChange) controller.__onFinishChange.call(controller, controller.getValue());
        }, this);
        $5804bae86b063b2c$var$Common.each(this.__folders, function(folder) {
            folder.revert(folder);
        });
        if (!gui) $5804bae86b063b2c$var$markPresetModified(this.getRoot(), false);
    },
    listen: function listen(controller) {
        var init = this.__listening.length === 0;
        this.__listening.push(controller);
        if (init) $5804bae86b063b2c$var$updateDisplays(this.__listening);
    },
    updateDisplay: function updateDisplay() {
        $5804bae86b063b2c$var$Common.each(this.__controllers, function(controller) {
            controller.updateDisplay();
        });
        $5804bae86b063b2c$var$Common.each(this.__folders, function(folder) {
            folder.updateDisplay();
        });
    }
});
function $5804bae86b063b2c$var$addRow(gui, newDom, liBefore) {
    var li = document.createElement("li");
    if (newDom) li.appendChild(newDom);
    if (liBefore) gui.__ul.insertBefore(li, liBefore);
    else gui.__ul.appendChild(li);
    gui.onResize();
    return li;
}
function $5804bae86b063b2c$var$removeListeners(gui) {
    $5804bae86b063b2c$var$dom.unbind(window, "resize", gui.__resizeHandler);
    if (gui.saveToLocalStorageIfPossible) $5804bae86b063b2c$var$dom.unbind(window, "unload", gui.saveToLocalStorageIfPossible);
}
function $5804bae86b063b2c$var$markPresetModified(gui, modified) {
    var opt = gui.__preset_select[gui.__preset_select.selectedIndex];
    if (modified) opt.innerHTML = opt.value + "*";
    else opt.innerHTML = opt.value;
}
function $5804bae86b063b2c$var$augmentController(gui, li, controller) {
    controller.__li = li;
    controller.__gui = gui;
    $5804bae86b063b2c$var$Common.extend(controller, {
        options: function options(_options) {
            if (arguments.length > 1) {
                var nextSibling = controller.__li.nextElementSibling;
                controller.remove();
                return $5804bae86b063b2c$var$_add(gui, controller.object, controller.property, {
                    before: nextSibling,
                    factoryArgs: [
                        $5804bae86b063b2c$var$Common.toArray(arguments)
                    ]
                });
            }
            if ($5804bae86b063b2c$var$Common.isArray(_options) || $5804bae86b063b2c$var$Common.isObject(_options)) {
                var _nextSibling = controller.__li.nextElementSibling;
                controller.remove();
                return $5804bae86b063b2c$var$_add(gui, controller.object, controller.property, {
                    before: _nextSibling,
                    factoryArgs: [
                        _options
                    ]
                });
            }
        },
        name: function name(_name) {
            controller.__li.firstElementChild.firstElementChild.innerHTML = _name;
            return controller;
        },
        listen: function listen() {
            controller.__gui.listen(controller);
            return controller;
        },
        remove: function remove() {
            controller.__gui.remove(controller);
            return controller;
        }
    });
    if (controller instanceof $5804bae86b063b2c$var$NumberControllerSlider) {
        var box = new $5804bae86b063b2c$var$NumberControllerBox(controller.object, controller.property, {
            min: controller.__min,
            max: controller.__max,
            step: controller.__step
        });
        $5804bae86b063b2c$var$Common.each([
            "updateDisplay",
            "onChange",
            "onFinishChange",
            "step",
            "min",
            "max"
        ], function(method) {
            var pc = controller[method];
            var pb = box[method];
            controller[method] = box[method] = function() {
                var args = Array.prototype.slice.call(arguments);
                pb.apply(box, args);
                return pc.apply(controller, args);
            };
        });
        $5804bae86b063b2c$var$dom.addClass(li, "has-slider");
        controller.domElement.insertBefore(box.domElement, controller.domElement.firstElementChild);
    } else if (controller instanceof $5804bae86b063b2c$var$NumberControllerBox) {
        var r = function r(returned) {
            if ($5804bae86b063b2c$var$Common.isNumber(controller.__min) && $5804bae86b063b2c$var$Common.isNumber(controller.__max)) {
                var oldName = controller.__li.firstElementChild.firstElementChild.innerHTML;
                var wasListening = controller.__gui.__listening.indexOf(controller) > -1;
                controller.remove();
                var newController = $5804bae86b063b2c$var$_add(gui, controller.object, controller.property, {
                    before: controller.__li.nextElementSibling,
                    factoryArgs: [
                        controller.__min,
                        controller.__max,
                        controller.__step
                    ]
                });
                newController.name(oldName);
                if (wasListening) newController.listen();
                return newController;
            }
            return returned;
        };
        controller.min = $5804bae86b063b2c$var$Common.compose(r, controller.min);
        controller.max = $5804bae86b063b2c$var$Common.compose(r, controller.max);
    } else if (controller instanceof $5804bae86b063b2c$var$BooleanController) {
        $5804bae86b063b2c$var$dom.bind(li, "click", function() {
            $5804bae86b063b2c$var$dom.fakeEvent(controller.__checkbox, "click");
        });
        $5804bae86b063b2c$var$dom.bind(controller.__checkbox, "click", function(e) {
            e.stopPropagation();
        });
    } else if (controller instanceof $5804bae86b063b2c$var$FunctionController) {
        $5804bae86b063b2c$var$dom.bind(li, "click", function() {
            $5804bae86b063b2c$var$dom.fakeEvent(controller.__button, "click");
        });
        $5804bae86b063b2c$var$dom.bind(li, "mouseover", function() {
            $5804bae86b063b2c$var$dom.addClass(controller.__button, "hover");
        });
        $5804bae86b063b2c$var$dom.bind(li, "mouseout", function() {
            $5804bae86b063b2c$var$dom.removeClass(controller.__button, "hover");
        });
    } else if (controller instanceof $5804bae86b063b2c$var$ColorController) {
        $5804bae86b063b2c$var$dom.addClass(li, "color");
        controller.updateDisplay = $5804bae86b063b2c$var$Common.compose(function(val) {
            li.style.borderLeftColor = controller.__color.toString();
            return val;
        }, controller.updateDisplay);
        controller.updateDisplay();
    }
    controller.setValue = $5804bae86b063b2c$var$Common.compose(function(val) {
        if (gui.getRoot().__preset_select && controller.isModified()) $5804bae86b063b2c$var$markPresetModified(gui.getRoot(), true);
        return val;
    }, controller.setValue);
}
function $5804bae86b063b2c$var$recallSavedValue(gui, controller) {
    var root = gui.getRoot();
    var matchedIndex = root.__rememberedObjects.indexOf(controller.object);
    if (matchedIndex !== -1) {
        var controllerMap = root.__rememberedObjectIndecesToControllers[matchedIndex];
        if (controllerMap === undefined) {
            controllerMap = {};
            root.__rememberedObjectIndecesToControllers[matchedIndex] = controllerMap;
        }
        controllerMap[controller.property] = controller;
        if (root.load && root.load.remembered) {
            var presetMap = root.load.remembered;
            var preset = void 0;
            if (presetMap[gui.preset]) preset = presetMap[gui.preset];
            else if (presetMap[$5804bae86b063b2c$var$DEFAULT_DEFAULT_PRESET_NAME]) preset = presetMap[$5804bae86b063b2c$var$DEFAULT_DEFAULT_PRESET_NAME];
            else return;
            if (preset[matchedIndex] && preset[matchedIndex][controller.property] !== undefined) {
                var value = preset[matchedIndex][controller.property];
                controller.initialValue = value;
                controller.setValue(value);
            }
        }
    }
}
function $5804bae86b063b2c$var$_add(gui, object, property, params) {
    if (object[property] === undefined) throw new Error('Object "' + object + '" has no property "' + property + '"');
    var controller = void 0;
    if (params.color) controller = new $5804bae86b063b2c$var$ColorController(object, property);
    else {
        var factoryArgs = [
            object,
            property
        ].concat(params.factoryArgs);
        controller = $5804bae86b063b2c$var$ControllerFactory.apply(gui, factoryArgs);
    }
    if (params.before instanceof $5804bae86b063b2c$var$Controller) params.before = params.before.__li;
    $5804bae86b063b2c$var$recallSavedValue(gui, controller);
    $5804bae86b063b2c$var$dom.addClass(controller.domElement, "c");
    var name = document.createElement("span");
    $5804bae86b063b2c$var$dom.addClass(name, "property-name");
    name.innerHTML = controller.property;
    var container = document.createElement("div");
    container.appendChild(name);
    container.appendChild(controller.domElement);
    var li = $5804bae86b063b2c$var$addRow(gui, container, params.before);
    $5804bae86b063b2c$var$dom.addClass(li, $5804bae86b063b2c$var$GUI.CLASS_CONTROLLER_ROW);
    if (controller instanceof $5804bae86b063b2c$var$ColorController) $5804bae86b063b2c$var$dom.addClass(li, "color");
    else $5804bae86b063b2c$var$dom.addClass(li, $5804bae86b063b2c$var$_typeof(controller.getValue()));
    $5804bae86b063b2c$var$augmentController(gui, li, controller);
    gui.__controllers.push(controller);
    return controller;
}
function $5804bae86b063b2c$var$getLocalStorageHash(gui, key) {
    return document.location.href + "." + key;
}
function $5804bae86b063b2c$var$addPresetOption(gui, name, setSelected) {
    var opt = document.createElement("option");
    opt.innerHTML = name;
    opt.value = name;
    gui.__preset_select.appendChild(opt);
    if (setSelected) gui.__preset_select.selectedIndex = gui.__preset_select.length - 1;
}
function $5804bae86b063b2c$var$showHideExplain(gui, explain) {
    explain.style.display = gui.useLocalStorage ? "block" : "none";
}
function $5804bae86b063b2c$var$addSaveMenu(gui) {
    var div = gui.__save_row = document.createElement("li");
    $5804bae86b063b2c$var$dom.addClass(gui.domElement, "has-save");
    gui.__ul.insertBefore(div, gui.__ul.firstChild);
    $5804bae86b063b2c$var$dom.addClass(div, "save-row");
    var gears = document.createElement("span");
    gears.innerHTML = "&nbsp;";
    $5804bae86b063b2c$var$dom.addClass(gears, "button gears");
    var button = document.createElement("span");
    button.innerHTML = "Save";
    $5804bae86b063b2c$var$dom.addClass(button, "button");
    $5804bae86b063b2c$var$dom.addClass(button, "save");
    var button2 = document.createElement("span");
    button2.innerHTML = "New";
    $5804bae86b063b2c$var$dom.addClass(button2, "button");
    $5804bae86b063b2c$var$dom.addClass(button2, "save-as");
    var button3 = document.createElement("span");
    button3.innerHTML = "Revert";
    $5804bae86b063b2c$var$dom.addClass(button3, "button");
    $5804bae86b063b2c$var$dom.addClass(button3, "revert");
    var select = gui.__preset_select = document.createElement("select");
    if (gui.load && gui.load.remembered) $5804bae86b063b2c$var$Common.each(gui.load.remembered, function(value, key) {
        $5804bae86b063b2c$var$addPresetOption(gui, key, key === gui.preset);
    });
    else $5804bae86b063b2c$var$addPresetOption(gui, $5804bae86b063b2c$var$DEFAULT_DEFAULT_PRESET_NAME, false);
    $5804bae86b063b2c$var$dom.bind(select, "change", function() {
        for(var index = 0; index < gui.__preset_select.length; index++)gui.__preset_select[index].innerHTML = gui.__preset_select[index].value;
        gui.preset = this.value;
    });
    div.appendChild(select);
    div.appendChild(gears);
    div.appendChild(button);
    div.appendChild(button2);
    div.appendChild(button3);
    if ($5804bae86b063b2c$var$SUPPORTS_LOCAL_STORAGE) {
        var explain = document.getElementById("dg-local-explain");
        var localStorageCheckBox = document.getElementById("dg-local-storage");
        var saveLocally = document.getElementById("dg-save-locally");
        saveLocally.style.display = "block";
        if (localStorage.getItem($5804bae86b063b2c$var$getLocalStorageHash(gui, "isLocal")) === "true") localStorageCheckBox.setAttribute("checked", "checked");
        $5804bae86b063b2c$var$showHideExplain(gui, explain);
        $5804bae86b063b2c$var$dom.bind(localStorageCheckBox, "change", function() {
            gui.useLocalStorage = !gui.useLocalStorage;
            $5804bae86b063b2c$var$showHideExplain(gui, explain);
        });
    }
    var newConstructorTextArea = document.getElementById("dg-new-constructor");
    $5804bae86b063b2c$var$dom.bind(newConstructorTextArea, "keydown", function(e) {
        if (e.metaKey && (e.which === 67 || e.keyCode === 67)) $5804bae86b063b2c$var$SAVE_DIALOGUE.hide();
    });
    $5804bae86b063b2c$var$dom.bind(gears, "click", function() {
        newConstructorTextArea.innerHTML = JSON.stringify(gui.getSaveObject(), undefined, 2);
        $5804bae86b063b2c$var$SAVE_DIALOGUE.show();
        newConstructorTextArea.focus();
        newConstructorTextArea.select();
    });
    $5804bae86b063b2c$var$dom.bind(button, "click", function() {
        gui.save();
    });
    $5804bae86b063b2c$var$dom.bind(button2, "click", function() {
        var presetName = prompt("Enter a new preset name.");
        if (presetName) gui.saveAs(presetName);
    });
    $5804bae86b063b2c$var$dom.bind(button3, "click", function() {
        gui.revert();
    });
}
function $5804bae86b063b2c$var$addResizeHandle(gui) {
    var pmouseX = void 0;
    gui.__resize_handle = document.createElement("div");
    $5804bae86b063b2c$var$Common.extend(gui.__resize_handle.style, {
        width: "6px",
        marginLeft: "-3px",
        height: "200px",
        cursor: "ew-resize",
        position: "absolute"
    });
    function drag(e) {
        e.preventDefault();
        gui.width += pmouseX - e.clientX;
        gui.onResize();
        pmouseX = e.clientX;
        return false;
    }
    function dragStop() {
        $5804bae86b063b2c$var$dom.removeClass(gui.__closeButton, $5804bae86b063b2c$var$GUI.CLASS_DRAG);
        $5804bae86b063b2c$var$dom.unbind(window, "mousemove", drag);
        $5804bae86b063b2c$var$dom.unbind(window, "mouseup", dragStop);
    }
    function dragStart(e) {
        e.preventDefault();
        pmouseX = e.clientX;
        $5804bae86b063b2c$var$dom.addClass(gui.__closeButton, $5804bae86b063b2c$var$GUI.CLASS_DRAG);
        $5804bae86b063b2c$var$dom.bind(window, "mousemove", drag);
        $5804bae86b063b2c$var$dom.bind(window, "mouseup", dragStop);
        return false;
    }
    $5804bae86b063b2c$var$dom.bind(gui.__resize_handle, "mousedown", dragStart);
    $5804bae86b063b2c$var$dom.bind(gui.__closeButton, "mousedown", dragStart);
    gui.domElement.insertBefore(gui.__resize_handle, gui.domElement.firstElementChild);
}
function $5804bae86b063b2c$var$setWidth(gui, w) {
    gui.domElement.style.width = w + "px";
    if (gui.__save_row && gui.autoPlace) gui.__save_row.style.width = w + "px";
    if (gui.__closeButton) gui.__closeButton.style.width = w + "px";
}
function $5804bae86b063b2c$var$getCurrentPreset(gui, useInitialValues) {
    var toReturn = {};
    $5804bae86b063b2c$var$Common.each(gui.__rememberedObjects, function(val, index) {
        var savedValues = {};
        var controllerMap = gui.__rememberedObjectIndecesToControllers[index];
        $5804bae86b063b2c$var$Common.each(controllerMap, function(controller, property) {
            savedValues[property] = useInitialValues ? controller.initialValue : controller.getValue();
        });
        toReturn[index] = savedValues;
    });
    return toReturn;
}
function $5804bae86b063b2c$var$setPresetSelectIndex(gui) {
    for(var index = 0; index < gui.__preset_select.length; index++)if (gui.__preset_select[index].value === gui.preset) gui.__preset_select.selectedIndex = index;
}
function $5804bae86b063b2c$var$updateDisplays(controllerArray) {
    if (controllerArray.length !== 0) $5804bae86b063b2c$var$requestAnimationFrame$1.call(window, function() {
        $5804bae86b063b2c$var$updateDisplays(controllerArray);
    });
    $5804bae86b063b2c$var$Common.each(controllerArray, function(c) {
        c.updateDisplay();
    });
}
var $5804bae86b063b2c$export$35e9368ef982300f = {
    Color: $5804bae86b063b2c$var$Color,
    math: $5804bae86b063b2c$var$ColorMath,
    interpret: $5804bae86b063b2c$var$interpret
};
var $5804bae86b063b2c$export$a6506504f799c5d5 = {
    Controller: $5804bae86b063b2c$var$Controller,
    BooleanController: $5804bae86b063b2c$var$BooleanController,
    OptionController: $5804bae86b063b2c$var$OptionController,
    StringController: $5804bae86b063b2c$var$StringController,
    NumberController: $5804bae86b063b2c$var$NumberController,
    NumberControllerBox: $5804bae86b063b2c$var$NumberControllerBox,
    NumberControllerSlider: $5804bae86b063b2c$var$NumberControllerSlider,
    FunctionController: $5804bae86b063b2c$var$FunctionController,
    ColorController: $5804bae86b063b2c$var$ColorController
};
var $5804bae86b063b2c$export$df3a06d6289f983e = {
    dom: $5804bae86b063b2c$var$dom
};
var $5804bae86b063b2c$export$6367ea12ae86a4eb = {
    GUI: $5804bae86b063b2c$var$GUI
};
var $5804bae86b063b2c$export$983832d820c96993 = $5804bae86b063b2c$var$GUI;
var $5804bae86b063b2c$var$index = {
    color: $5804bae86b063b2c$export$35e9368ef982300f,
    controllers: $5804bae86b063b2c$export$a6506504f799c5d5,
    dom: $5804bae86b063b2c$export$df3a06d6289f983e,
    gui: $5804bae86b063b2c$export$6367ea12ae86a4eb,
    GUI: $5804bae86b063b2c$export$983832d820c96993
};
var $5804bae86b063b2c$export$2e2bcd8739ae039 = $5804bae86b063b2c$var$index;


/**
 * @license
 * Copyright Round Three LLC (test)
 */ 


function $e5162ea5560088cd$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
    if (!geometry.hasAttribute("position") || !geometry.hasAttribute("normal") || !geometry.hasAttribute("uv")) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute("tangent", new (0, $8725869b83961a04$export$8dea267bd6bde117)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $8725869b83961a04$export$b7be63a67df8959)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $e5162ea5560088cd$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $e5162ea5560088cd$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $e5162ea5560088cd$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.");
            return null;
        }
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attribute.array.length;
    }
    const array = new TypedArray(arrayLength);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        array.set(attributes[i].array, offset);
        offset += attributes[i].array.length;
    }
    const result = new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize, normalized);
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
function $e5162ea5560088cd$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $e5162ea5560088cd$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $8725869b83961a04$export$32ea87a8b54d744a)().copy(attribute);
    return new (0, $8725869b83961a04$export$8dea267bd6bde117)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $e5162ea5560088cd$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $8725869b83961a04$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $8725869b83961a04$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $e5162ea5560088cd$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $8725869b83961a04$export$32ea87a8b54d744a)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $e5162ea5560088cd$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $e5162ea5560088cd$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $e5162ea5560088cd$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */ function $e5162ea5560088cd$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new (0, $8725869b83961a04$export$8dea267bd6bde117)(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) tmpMorphAttributes[name] = new (0, $8725869b83961a04$export$8dea267bd6bde117)(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newarray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new (0, $8725869b83961a04$export$8dea267bd6bde117)(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new (0, $8725869b83961a04$export$8dea267bd6bde117)(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $e5162ea5560088cd$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $8725869b83961a04$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $8725869b83961a04$export$f0d8293634f88842) || drawMode === (0, $8725869b83961a04$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $8725869b83961a04$export$f0d8293634f88842)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $e5162ea5560088cd$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _vB = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _vC = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _tempA = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _tempB = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _tempC = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _morphA = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _morphB = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const _morphC = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $8725869b83961a04$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $8725869b83961a04$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $e5162ea5560088cd$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.");
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute("position");
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
// Creates a new, non-indexed geometry with smooth normals everywhere except faces that meet at
// an angle greater than the crease angle.
function $e5162ea5560088cd$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vertors
    const verts = [
        new (0, $8725869b83961a04$export$64b5c384219d3699)(),
        new (0, $8725869b83961a04$export$64b5c384219d3699)(),
        new (0, $8725869b83961a04$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const tempVec2 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const tempNorm = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.toNonIndexed();
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $8725869b83961a04$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $8725869b83961a04$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}
function $e5162ea5560088cd$export$728c051ccdf8a702(geometries, useGroups = false) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferGeometries() has been renamed to mergeGeometries()."); // @deprecated, r151
    return $e5162ea5560088cd$export$f06f69b3bf41d25c(geometries, useGroups);
}
function $e5162ea5560088cd$export$c4eef4c1c9d34ea9(attributes) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferAttributes() has been renamed to mergeAttributes()."); // @deprecated, r151
    return $e5162ea5560088cd$export$9f98db6234c4bd78(attributes);
}


class $f00a0cf390d4f349$export$aa93f11e7884f0f4 extends (0, $8725869b83961a04$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $f00a0cf390d4f349$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") resourcePath = this.path;
        else resourcePath = (0, $8725869b83961a04$export$b5d2dc08d867e41a).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $8725869b83961a04$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_BINARY_GLTF] = new $f00a0cf390d4f349$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $f00a0cf390d4f349$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $f00a0cf390d4f349$var$GLTFMaterialsUnlitExtension();
                    break;
                case $f00a0cf390d4f349$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $f00a0cf390d4f349$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $f00a0cf390d4f349$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $f00a0cf390d4f349$var$GLTFTextureTransformExtension();
                    break;
                case $f00a0cf390d4f349$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $f00a0cf390d4f349$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $f00a0cf390d4f349$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $f00a0cf390d4f349$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $f00a0cf390d4f349$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $8725869b83961a04$export$892596cec99bc70e)(0xffffff);
        if (lightDef.color !== undefined) color.fromArray(lightDef.color);
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $8725869b83961a04$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $8725869b83961a04$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $8725869b83961a04$export$81495cbb73897362)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $f00a0cf390d4f349$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $f00a0cf390d4f349$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $8725869b83961a04$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $8725869b83961a04$export$892596cec99bc70e)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $8725869b83961a04$export$561f394b24edfcaa)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $f00a0cf390d4f349$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $f00a0cf390d4f349$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $f00a0cf390d4f349$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $f00a0cf390d4f349$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $8725869b83961a04$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) materialParams.sheenColor.fromArray(extension.sheenColorFactor);
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, (0, $8725869b83961a04$export$561f394b24edfcaa)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $f00a0cf390d4f349$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $f00a0cf390d4f349$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $8725869b83961a04$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $f00a0cf390d4f349$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $f00a0cf390d4f349$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $8725869b83961a04$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, (0, $8725869b83961a04$export$561f394b24edfcaa)));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */ class $f00a0cf390d4f349$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $8725869b83961a04$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $f00a0cf390d4f349$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $f00a0cf390d4f349$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $f00a0cf390d4f349$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $f00a0cf390d4f349$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $f00a0cf390d4f349$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
                const p = new (0, $8725869b83961a04$export$64b5c384219d3699)();
                const q = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)();
                const s = new (0, $8725869b83961a04$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $8725869b83961a04$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes)if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                // Just in case
                (0, $8725869b83961a04$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $f00a0cf390d4f349$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $f00a0cf390d4f349$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2.0) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $f00a0cf390d4f349$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $f00a0cf390d4f349$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $f00a0cf390d4f349$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $f00a0cf390d4f349$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $f00a0cf390d4f349$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $f00a0cf390d4f349$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $f00a0cf390d4f349$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $f00a0cf390d4f349$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $f00a0cf390d4f349$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $f00a0cf390d4f349$var$GLTFCubicSplineInterpolant extends (0, $8725869b83961a04$export$b558baee9c0f72d3) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $f00a0cf390d4f349$var$_q = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)();
class $f00a0cf390d4f349$var$GLTFCubicSplineQuaternionInterpolant extends $f00a0cf390d4f349$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $f00a0cf390d4f349$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $f00a0cf390d4f349$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $f00a0cf390d4f349$var$WEBGL_FILTERS = {
    9728: (0, $8725869b83961a04$export$727aa5ec3fe39bf0),
    9729: (0, $8725869b83961a04$export$8a72f490b25c56c8),
    9984: (0, $8725869b83961a04$export$d129e38cf6feaa8c),
    9985: (0, $8725869b83961a04$export$19a719f377145a13),
    9986: (0, $8725869b83961a04$export$d2327c1afe5bfdf2),
    9987: (0, $8725869b83961a04$export$5d8599b6a933fb1b)
};
const $f00a0cf390d4f349$var$WEBGL_WRAPPINGS = {
    33071: (0, $8725869b83961a04$export$9d9334239a5a5e06),
    33648: (0, $8725869b83961a04$export$c7e7c00b14f51a4f),
    10497: (0, $8725869b83961a04$export$533346c8e8dac0f5)
};
const $f00a0cf390d4f349$var$WEBGL_TYPE_SIZES = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
};
const $f00a0cf390d4f349$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $f00a0cf390d4f349$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $f00a0cf390d4f349$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $8725869b83961a04$export$30fac1aace31cf4d),
    STEP: (0, $8725869b83961a04$export$995b32462a65e855)
};
const $f00a0cf390d4f349$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $f00a0cf390d4f349$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === undefined) cache["DefaultMaterial"] = new (0, $8725869b83961a04$export$f2980790215acccd)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $8725869b83961a04$export$2ede184fc2998901)
    });
    return cache["DefaultMaterial"];
}
function $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $f00a0cf390d4f349$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $f00a0cf390d4f349$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $f00a0cf390d4f349$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $f00a0cf390d4f349$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $f00a0cf390d4f349$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $f00a0cf390d4f349$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + $f00a0cf390d4f349$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $f00a0cf390d4f349$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $f00a0cf390d4f349$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $f00a0cf390d4f349$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $f00a0cf390d4f349$var$_identityMatrix = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
/* GLTF PARSER */ class $f00a0cf390d4f349$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $f00a0cf390d4f349$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $8725869b83961a04$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $8725869b83961a04$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $8725869b83961a04$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, result, json);
            $f00a0cf390d4f349$var$assignExtrasToUserData(result, json);
            Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $8725869b83961a04$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $f00a0cf390d4f349$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $f00a0cf390d4f349$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $8725869b83961a04$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $8725869b83961a04$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $f00a0cf390d4f349$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $8725869b83961a04$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $f00a0cf390d4f349$var$WEBGL_FILTERS[sampler.magFilter] || (0, $8725869b83961a04$export$8a72f490b25c56c8);
            texture.minFilter = $f00a0cf390d4f349$var$WEBGL_FILTERS[sampler.minFilter] || (0, $8725869b83961a04$export$5d8599b6a933fb1b);
            texture.wrapS = $f00a0cf390d4f349$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $8725869b83961a04$export$533346c8e8dac0f5);
            texture.wrapT = $f00a0cf390d4f349$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $8725869b83961a04$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $8725869b83961a04$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $8725869b83961a04$export$b5d2dc08d867e41a).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $f00a0cf390d4f349$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $8725869b83961a04$export$a178c45366ce5d6b)();
                (0, $8725869b83961a04$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $8725869b83961a04$export$fbaaa33907730a0c)();
                (0, $8725869b83961a04$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $8725869b83961a04$export$f2980790215acccd;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $8725869b83961a04$export$892596cec99bc70e)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $8725869b83961a04$export$561f394b24edfcaa)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $8725869b83961a04$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $f00a0cf390d4f349$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $f00a0cf390d4f349$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $f00a0cf390d4f349$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $8725869b83961a04$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $8725869b83961a04$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $8725869b83961a04$export$55cbcc9b622fe1f5)) materialParams.emissive = new (0, $8725869b83961a04$export$892596cec99bc70e)().fromArray(materialDef.emissiveFactor);
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $8725869b83961a04$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, (0, $8725869b83961a04$export$561f394b24edfcaa)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $f00a0cf390d4f349$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $8725869b83961a04$export$7bf70fcf9f891893).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $f00a0cf390d4f349$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $f00a0cf390d4f349$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$f00a0cf390d4f349$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $f00a0cf390d4f349$var$addPrimitiveAttributes(new (0, $8725869b83961a04$export$b7be63a67df8959)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $f00a0cf390d4f349$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $8725869b83961a04$export$b303577035157ecf)(geometry, material) : new (0, $8725869b83961a04$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $e5162ea5560088cd$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $8725869b83961a04$export$b23a071aa286eb29));
                    else if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $e5162ea5560088cd$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $8725869b83961a04$export$f0d8293634f88842));
                } else if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $8725869b83961a04$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $8725869b83961a04$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $8725869b83961a04$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $f00a0cf390d4f349$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $8725869b83961a04$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $f00a0cf390d4f349$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $f00a0cf390d4f349$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4)();
            if (meshDef.extensions) $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $8725869b83961a04$export$74e4ae24825f68d7)((0, $8725869b83961a04$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $8725869b83961a04$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $f00a0cf390d4f349$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $8725869b83961a04$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                node.updateMatrix();
                let TypedKeyframeTrack;
                switch($f00a0cf390d4f349$var$PATH_PROPERTIES[target.path]){
                    case $f00a0cf390d4f349$var$PATH_PROPERTIES.weights:
                        TypedKeyframeTrack = (0, $8725869b83961a04$export$d45f0d1a4d9a9314);
                        break;
                    case $f00a0cf390d4f349$var$PATH_PROPERTIES.rotation:
                        TypedKeyframeTrack = (0, $8725869b83961a04$export$b8043f12b5aafbd7);
                        break;
                    case $f00a0cf390d4f349$var$PATH_PROPERTIES.position:
                    case $f00a0cf390d4f349$var$PATH_PROPERTIES.scale:
                    default:
                        TypedKeyframeTrack = (0, $8725869b83961a04$export$5ce2dcb4cc9f2bff);
                        break;
                }
                const targetName = node.name ? node.name : node.uuid;
                const interpolation = sampler.interpolation !== undefined ? $f00a0cf390d4f349$var$INTERPOLATION[sampler.interpolation] : (0, $8725869b83961a04$export$30fac1aace31cf4d);
                const targetNames = [];
                if ($f00a0cf390d4f349$var$PATH_PROPERTIES[target.path] === $f00a0cf390d4f349$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
                    if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
                });
                else targetNames.push(targetName);
                let outputArray = outputAccessor.array;
                if (outputAccessor.normalized) {
                    const scale = $f00a0cf390d4f349$var$getNormalizedComponentScale(outputArray.constructor);
                    const scaled = new Float32Array(outputArray.length);
                    for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
                    outputArray = scaled;
                }
                for(let j = 0, jl = targetNames.length; j < jl; j++){
                    const track = new TypedKeyframeTrack(targetNames[j] + "." + $f00a0cf390d4f349$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
                    // Override interpolation with custom factory method.
                    if (sampler.interpolation === "CUBICSPLINE") {
                        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
                            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
                            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
                            // must be divided by three to get the interpolant's sampleSize argument.
                            const interpolantType = this instanceof (0, $8725869b83961a04$export$b8043f12b5aafbd7) ? $f00a0cf390d4f349$var$GLTFCubicSplineQuaternionInterpolant : $f00a0cf390d4f349$var$GLTFCubicSplineInterpolant;
                            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
                        };
                        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
                        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
                    }
                    tracks.push(track);
                }
            }
            return new (0, $8725869b83961a04$export$d942c706bf23829c)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $f00a0cf390d4f349$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $8725869b83961a04$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $8725869b83961a04$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $f00a0cf390d4f349$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $8725869b83961a04$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $f00a0cf390d4f349$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $f00a0cf390d4f349$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $8725869b83961a04$export$a2d8b23205c25948) || key instanceof (0, $8725869b83961a04$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $f00a0cf390d4f349$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $8725869b83961a04$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $8725869b83961a04$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $8725869b83961a04$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $f00a0cf390d4f349$var$getNormalizedComponentScale($f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        const vector = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $f00a0cf390d4f349$var$getNormalizedComponentScale($f00a0cf390d4f349$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $8725869b83961a04$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $f00a0cf390d4f349$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $f00a0cf390d4f349$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    $f00a0cf390d4f349$var$assignExtrasToUserData(geometry, primitiveDef);
    $f00a0cf390d4f349$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $f00a0cf390d4f349$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}



const $88f4ea66493b0ee5$var$_taskCache = new WeakMap();
class $88f4ea66493b0ee5$export$45c25de53be259ac extends (0, $8725869b83961a04$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.decoderPath = "";
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = "";
        this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        };
        this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new (0, $8725869b83961a04$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            this.parse(buffer, onLoad, onError);
        }, onProgress, onError);
    }
    parse(buffer, onLoad, onError) {
        this.decodeDracoFile(buffer, onLoad, null, null, (0, $8725869b83961a04$export$561f394b24edfcaa)).catch(onError);
    }
    decodeDracoFile(buffer, callback, attributeIDs, attributeTypes, vertexColorSpace = (0, $8725869b83961a04$export$42429b3acfb233a4)) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs,
            vertexColorSpace: vertexColorSpace
        };
        return this.decodeGeometry(buffer, taskConfig).then(callback);
    }
    decodeGeometry(buffer, taskConfig) {
        const taskKey = JSON.stringify(taskConfig);
        // Check for an existing task using this buffer. A transferred buffer cannot be transferred
        // again from this thread.
        if ($88f4ea66493b0ee5$var$_taskCache.has(buffer)) {
            const cachedTask = $88f4ea66493b0ee5$var$_taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) // Technically, it would be possible to wait for the previous task to complete,
            // transfer the buffer back, and decode again with the second configuration. That
            // is complex, and I don't know of any reason to decode a Draco buffer twice in
            // different ways, so this is left unimplemented.
            throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        //
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        // Obtain a worker and assign a task, and construct a geometry instance
        // when the task completes.
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: "decode",
                    id: taskID,
                    taskConfig: taskConfig,
                    buffer: buffer
                }, [
                    buffer
                ]);
            // this.debug();
            });
        }).then((message)=>this._createGeometry(message.geometry));
        // Remove task from the task list.
        // Note: replaced '.finally()' with '.catch().then()' block - iOS 11 support (#19416)
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        // Cache the task result.
        $88f4ea66493b0ee5$var$_taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, $8725869b83961a04$export$b7be63a67df8959)();
        if (geometryData.index) geometry.setIndex(new (0, $8725869b83961a04$export$8dea267bd6bde117)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const result = geometryData.attributes[i];
            const name = result.name;
            const array = result.array;
            const itemSize = result.itemSize;
            const attribute = new (0, $8725869b83961a04$export$8dea267bd6bde117)(array, itemSize);
            if (name === "color") {
                this._assignVertexColorSpace(attribute, result.vertexColorSpace);
                attribute.normalized = array instanceof Float32Array === false;
            }
            geometry.setAttribute(name, attribute);
        }
        return geometry;
    }
    _assignVertexColorSpace(attribute, inputColorSpace) {
        // While .drc files do not specify colorspace, the only 'official' tooling
        // is PLY and OBJ converters, which use sRGB. We'll assume sRGB when a .drc
        // file is passed into .load() or .parse(). GLTFLoader uses internal APIs
        // to decode geometry, and vertex colors are already Linear-sRGB in there.
        if (inputColorSpace !== (0, $8725869b83961a04$export$561f394b24edfcaa)) return;
        const _color = new (0, $8725869b83961a04$export$892596cec99bc70e)();
        for(let i = 0, il = attribute.count; i < il; i++){
            _color.fromBufferAttribute(attribute, i).convertSRGBToLinear();
            attribute.setXYZ(i, _color.r, _color.g, _color.b);
        }
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, $8725869b83961a04$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, undefined, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
        else {
            librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
            librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = $88f4ea66493b0ee5$var$DRACOWorker.toString();
            const body = [
                "/* draco decoder */",
                jsContent,
                "",
                "/* worker */",
                fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker = new Worker(this.workerSourceURL);
                worker._callbacks = {};
                worker._taskCosts = {};
                worker._taskLoad = 0;
                worker.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                });
                worker.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case "decode":
                            worker._callbacks[message.id].resolve(message);
                            break;
                        case "error":
                            worker._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        if (this.workerSourceURL !== "") URL.revokeObjectURL(this.workerSourceURL);
        return this;
    }
}
/* WEB WORKER */ function $88f4ea66493b0ee5$var$DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve /*, reject*/ ) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        // Module is Promise-like. Wrap before resolving to avoid loop.
                        resolve({
                            draco: draco
                        });
                    };
                    DracoDecoderModule(decoderConfig); // eslint-disable-line no-undef
                });
                break;
            case "decode":
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    try {
                        const geometry = decodeGeometry(draco, decoder, new Int8Array(buffer), taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: "decode",
                            id: message.id,
                            geometry: geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, array, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(array);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeArrayToMesh(array, array.byteLength, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeArrayToPointCloud(array, array.byteLength, dracoGeometry);
        } else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        // Gather all vertex attributes.
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            // A Draco file may be created with default vertex attributes, whose attribute IDs
            // are mapped 1:1 from their semantic name (POSITION, NORMAL, ...). Alternatively,
            // a Draco file may contain a custom set of attributes, identified by known unique
            // IDs. glTF files always do the latter, and `.drc` files typically do the former.
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            const attributeResult = decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute);
            if (attributeName === "color") attributeResult.vertexColorSpace = taskConfig.vertexColorSpace;
            geometry.attributes.push(attributeResult);
        }
        // Add index.
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
        const numComponents = attribute.num_components();
        const numPoints = dracoGeometry.num_points();
        const numValues = numPoints * numComponents;
        const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
        const dataType = getDracoDataType(draco, attributeType);
        const ptr = draco._malloc(byteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
        const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
        draco._free(ptr);
        return {
            name: attributeName,
            array: array,
            itemSize: numComponents
        };
    }
    function getDracoDataType(draco, attributeType) {
        switch(attributeType){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}


// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2021, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var $b9b5bad09e314aa5$export$1111800106ba519a = function() {
    "use strict";
    // Built with clang version 13.0.0 (https://github.com/llvm/llvm-project fd1d8c2f04dde23bee0fb3a7d069a9b1046da979)
    // Built from meshoptimizer 0.17
    var wasm_base = "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";
    var wasm_simd = "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";
    // Uses bulk-memory and simd extensions
    var detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    // Used to unpack wasm
    var wasmpack = new Uint8Array([
        32,
        0,
        65,
        2,
        1,
        106,
        34,
        33,
        3,
        128,
        11,
        4,
        13,
        64,
        6,
        253,
        10,
        7,
        15,
        116,
        127,
        5,
        8,
        12,
        40,
        16,
        19,
        54,
        20,
        9,
        27,
        255,
        113,
        17,
        42,
        67,
        24,
        23,
        146,
        148,
        18,
        14,
        22,
        45,
        70,
        69,
        56,
        114,
        101,
        21,
        25,
        63,
        75,
        136,
        108,
        28,
        118,
        29,
        73,
        115
    ]);
    if (typeof WebAssembly !== "object") // This module requires WebAssembly to function
    return {
        supported: false
    };
    var wasm = wasm_base;
    if (WebAssembly.validate(detector)) wasm = wasm_simd;
    var instance;
    var promise = WebAssembly.instantiate(unpack(wasm), {}).then(function(result) {
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        var result = new Uint8Array(data.length);
        for(var i = 0; i < data.length; ++i){
            var ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 71 : ch > 64 ? ch - 65 : ch > 47 ? ch + 4 : ch > 46 ? 63 : 62;
        }
        var write = 0;
        for(var i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(fun, target, count, size, source, filter) {
        var sbrk = instance.exports.sbrk;
        var count4 = count + 3 & -4; // pad for SIMD filter
        var tp = sbrk(count4 * size);
        var sp = sbrk(source.length);
        var heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        var res = fun(tp, count, size, sp, source.length);
        if (res == 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res != 0) throw new Error("Malformed buffer data: " + res);
    }
    var filters = {
        // legacy index-based enums for glTF
        0: "",
        1: "meshopt_decodeFilterOct",
        2: "meshopt_decodeFilterQuat",
        3: "meshopt_decodeFilterExp",
        // string-based enums for glTF
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    };
    var decoders = {
        // legacy index-based enums for glTF
        0: "meshopt_decodeVertexBuffer",
        1: "meshopt_decodeIndexBuffer",
        2: "meshopt_decodeIndexSequence",
        // string-based enums for glTF
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    };
    return {
        ready: promise,
        supported: true,
        decodeVertexBuffer: function(target, count, size, source, filter) {
            decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer: function(target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence: function(target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer: function(target, count, size, source, mode, filter) {
            decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        }
    };
}();



class $5859463f2a625df8$export$936f75e6792bf2dc extends (0, $8725869b83961a04$export$e4dd07dff30cc924) {
    constructor(element = document.createElement("div")){
        super();
        this.isCSS2DObject = true;
        this.element = element;
        this.element.style.position = "absolute";
        this.element.style.userSelect = "none";
        this.element.setAttribute("draggable", false);
        this.center = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(0.5, 0.5); // ( 0, 0 ) is the lower left; ( 1, 1 ) is the top right
        this.addEventListener("removed", function() {
            this.traverse(function(object) {
                if (object.element instanceof Element && object.element.parentNode !== null) object.element.parentNode.removeChild(object.element);
            });
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.element = source.element.cloneNode(true);
        this.center = source.center;
        return this;
    }
}
//
const $5859463f2a625df8$var$_vector = new (0, $8725869b83961a04$export$64b5c384219d3699)();
const $5859463f2a625df8$var$_viewMatrix = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
const $5859463f2a625df8$var$_viewProjectionMatrix = new (0, $8725869b83961a04$export$2ae72fc923e5eb5)();
const $5859463f2a625df8$var$_a = new (0, $8725869b83961a04$export$64b5c384219d3699)();
const $5859463f2a625df8$var$_b = new (0, $8725869b83961a04$export$64b5c384219d3699)();
class $5859463f2a625df8$export$508520281a983506 {
    constructor(parameters = {}){
        const _this = this;
        let _width, _height;
        let _widthHalf, _heightHalf;
        const cache = {
            objects: new WeakMap()
        };
        const domElement = parameters.element !== undefined ? parameters.element : document.createElement("div");
        domElement.style.overflow = "hidden";
        this.domElement = domElement;
        this.getSize = function() {
            return {
                width: _width,
                height: _height
            };
        };
        this.render = function(scene, camera) {
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            $5859463f2a625df8$var$_viewMatrix.copy(camera.matrixWorldInverse);
            $5859463f2a625df8$var$_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, $5859463f2a625df8$var$_viewMatrix);
            renderObject(scene, scene, camera);
            zOrder(scene);
        };
        this.setSize = function(width, height) {
            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;
            domElement.style.width = width + "px";
            domElement.style.height = height + "px";
        };
        function renderObject(object, scene, camera) {
            if (object.isCSS2DObject) {
                $5859463f2a625df8$var$_vector.setFromMatrixPosition(object.matrixWorld);
                $5859463f2a625df8$var$_vector.applyMatrix4($5859463f2a625df8$var$_viewProjectionMatrix);
                const visible = object.visible === true && $5859463f2a625df8$var$_vector.z >= -1 && $5859463f2a625df8$var$_vector.z <= 1 && object.layers.test(camera.layers) === true;
                object.element.style.display = visible === true ? "" : "none";
                if (visible === true) {
                    object.onBeforeRender(_this, scene, camera);
                    const element = object.element;
                    element.style.transform = "translate(" + -100 * object.center.x + "%," + -100 * object.center.y + "%)" + "translate(" + ($5859463f2a625df8$var$_vector.x * _widthHalf + _widthHalf) + "px," + (-$5859463f2a625df8$var$_vector.y * _heightHalf + _heightHalf) + "px)";
                    if (element.parentNode !== domElement) domElement.appendChild(element);
                    object.onAfterRender(_this, scene, camera);
                }
                const objectData = {
                    distanceToCameraSquared: getDistanceToSquared(camera, object)
                };
                cache.objects.set(object, objectData);
            }
            for(let i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera);
        }
        function getDistanceToSquared(object1, object2) {
            $5859463f2a625df8$var$_a.setFromMatrixPosition(object1.matrixWorld);
            $5859463f2a625df8$var$_b.setFromMatrixPosition(object2.matrixWorld);
            return $5859463f2a625df8$var$_a.distanceToSquared($5859463f2a625df8$var$_b);
        }
        function filterAndFlatten(scene) {
            const result = [];
            scene.traverse(function(object) {
                if (object.isCSS2DObject) result.push(object);
            });
            return result;
        }
        function zOrder(scene) {
            const sorted = filterAndFlatten(scene).sort(function(a, b) {
                if (a.renderOrder !== b.renderOrder) return b.renderOrder - a.renderOrder;
                const distanceA = cache.objects.get(a).distanceToCameraSquared;
                const distanceB = cache.objects.get(b).distanceToCameraSquared;
                return distanceA - distanceB;
            });
            const zMax = sorted.length;
            for(let i = 0, l = sorted.length; i < l; i++)sorted[i].element.style.zIndex = zMax - i;
        }
    }
}


const $12d34f3c78180d6b$export$c84b72fba115a40e = {
    "Alabama": {
        name: "Alabama",
        abbr: "AL",
        fips: "01"
    },
    "Alaska": {
        name: "Alaska",
        abbr: "AK",
        fips: "02"
    },
    "Arizona": {
        name: "Arizona",
        abbr: "AZ",
        fips: "04"
    },
    "Arkansas": {
        name: "Arkansas",
        abbr: "AR",
        fips: "05"
    },
    "California": {
        name: "California",
        abbr: "CA",
        fips: "06"
    },
    "Colorado": {
        name: "Colorado",
        abbr: "CO",
        fips: "08"
    },
    "Connecticut": {
        name: "Connecticut",
        abbr: "CT",
        fips: "09"
    },
    "Delaware": {
        name: "Delaware",
        abbr: "DE",
        fips: "10"
    },
    "District of Columbia": {
        name: "District of Columbia",
        abbr: "DC",
        fips: "11"
    },
    "Florida": {
        name: "Florida",
        abbr: "FL",
        fips: "12"
    },
    "Georgia": {
        name: "Georgia",
        abbr: "GA",
        fips: "13"
    },
    "Hawaii": {
        name: "Hawaii",
        abbr: "HI",
        fips: "15"
    },
    "Idaho": {
        name: "Idaho",
        abbr: "ID",
        fips: "16"
    },
    "Illinois": {
        name: "Illinois",
        abbr: "IL",
        fips: "17"
    },
    "Indiana": {
        name: "Indiana",
        abbr: "IN",
        fips: "18"
    },
    "Iowa": {
        name: "Iowa",
        abbr: "IA",
        fips: "19"
    },
    "Kansas": {
        name: "Kansas",
        abbr: "KS",
        fips: "20"
    },
    "Kentucky": {
        name: "Kentucky",
        abbr: "KY",
        fips: "21"
    },
    "Louisiana": {
        name: "Louisiana",
        abbr: "LA",
        fips: "22"
    },
    "Maine": {
        name: "Maine",
        abbr: "ME",
        fips: "23"
    },
    "Maryland": {
        name: "Maryland",
        abbr: "MD",
        fips: "24"
    },
    "Massachusetts": {
        name: "Massachusetts",
        abbr: "MA",
        fips: "25"
    },
    "Michigan": {
        name: "Michigan",
        abbr: "MI",
        fips: "26"
    },
    "Minnesota": {
        name: "Minnesota",
        abbr: "MN",
        fips: "27"
    },
    "Mississippi": {
        name: "Mississippi",
        abbr: "MS",
        fips: "28"
    },
    "Missouri": {
        name: "Missouri",
        abbr: "MO",
        fips: "29"
    },
    "Montana": {
        name: "Montana",
        abbr: "MT",
        fips: "30"
    },
    "Nebraska": {
        name: "Nebraska",
        abbr: "NE",
        fips: "31"
    },
    "Nevada": {
        name: "Nevada",
        abbr: "NV",
        fips: "32"
    },
    "New Hampshire": {
        name: "New Hampshire",
        abbr: "NH",
        fips: "33"
    },
    "New Jersey": {
        name: "New Jersey",
        abbr: "NJ",
        fips: "34"
    },
    "New Mexico": {
        name: "New Mexico",
        abbr: "NM",
        fips: "35"
    },
    "New York": {
        name: "New York",
        abbr: "NY",
        fips: "36"
    },
    "North Carolina": {
        name: "North Carolina",
        abbr: "NC",
        fips: "37"
    },
    "North Dakota": {
        name: "North Dakota",
        abbr: "ND",
        fips: "38"
    },
    "Ohio": {
        name: "Ohio",
        abbr: "OH",
        fips: "39"
    },
    "Oklahoma": {
        name: "Oklahoma",
        abbr: "OK",
        fips: "40"
    },
    "Oregon": {
        name: "Oregon",
        abbr: "OR",
        fips: "41"
    },
    "Pennsylvania": {
        name: "Pennsylvania",
        abbr: "PA",
        fips: "42"
    },
    "Rhode Island": {
        name: "Rhode Island",
        abbr: "RI",
        fips: "44"
    },
    "South Carolina": {
        name: "South Carolina",
        abbr: "SC",
        fips: "45"
    },
    "South Dakota": {
        name: "South Dakota",
        abbr: "SD",
        fips: "46"
    },
    "Tennessee": {
        name: "Tennessee",
        abbr: "TN",
        fips: "47"
    },
    "Texas": {
        name: "Texas",
        abbr: "TX",
        fips: "48"
    },
    "Utah": {
        name: "Utah",
        abbr: "UT",
        fips: "49"
    },
    "Vermont": {
        name: "Vermont",
        abbr: "VT",
        fips: "50"
    },
    "Virginia": {
        name: "Virginia",
        abbr: "VA",
        fips: "51"
    },
    "Washington": {
        name: "Washington",
        abbr: "WA",
        fips: "53"
    },
    "West Virginia": {
        name: "West Virginia",
        abbr: "WV",
        fips: "54"
    },
    "Wisconsin": {
        name: "Wisconsin",
        abbr: "WI",
        fips: "55"
    },
    "Wyoming": {
        name: "Wyoming",
        abbr: "WY",
        fips: "56"
    },
    "American Samoa": {
        name: "American Samoa",
        abbr: "AS",
        fips: "60"
    },
    "Guam": {
        name: "Guam",
        abbr: "GU",
        fips: "66"
    },
    "Northern Mariana Islands": {
        name: "Northern Mariana Islands",
        abbr: "MP",
        fips: "69"
    },
    "Puerto Rico": {
        name: "Puerto Rico",
        abbr: "PR",
        fips: "72"
    },
    "Virgin Islands": {
        name: "Virgin Islands",
        abbr: "VI",
        fips: "78"
    }
};
const $12d34f3c78180d6b$export$37abc93a7593198c = {
    "AL": {
        name: "Alabama",
        abbr: "AL",
        fips: "01"
    },
    "AK": {
        name: "Alaska",
        abbr: "AK",
        fips: "02"
    },
    "AZ": {
        name: "Arizona",
        abbr: "AZ",
        fips: "04"
    },
    "AR": {
        name: "Arkansas",
        abbr: "AR",
        fips: "05"
    },
    "CA": {
        name: "California",
        abbr: "CA",
        fips: "06"
    },
    "CO": {
        name: "Colorado",
        abbr: "CO",
        fips: "08"
    },
    "CT": {
        name: "Connecticut",
        abbr: "CT",
        fips: "09"
    },
    "DE": {
        name: "Delaware",
        abbr: "DE",
        fips: "10"
    },
    "DC": {
        name: "District of Columbia",
        abbr: "DC",
        fips: "11"
    },
    "FL": {
        name: "Florida",
        abbr: "FL",
        fips: "12"
    },
    "GA": {
        name: "Georgia",
        abbr: "GA",
        fips: "13"
    },
    "HI": {
        name: "Hawaii",
        abbr: "HI",
        fips: "15"
    },
    "ID": {
        name: "Idaho",
        abbr: "ID",
        fips: "16"
    },
    "IL": {
        name: "Illinois",
        abbr: "IL",
        fips: "17"
    },
    "IN": {
        name: "Indiana",
        abbr: "IN",
        fips: "18"
    },
    "IA": {
        name: "Iowa",
        abbr: "IA",
        fips: "19"
    },
    "KS": {
        name: "Kansas",
        abbr: "KS",
        fips: "20"
    },
    "KY": {
        name: "Kentucky",
        abbr: "KY",
        fips: "21"
    },
    "LA": {
        name: "Louisiana",
        abbr: "LA",
        fips: "22"
    },
    "ME": {
        name: "Maine",
        abbr: "ME",
        fips: "23"
    },
    "MD": {
        name: "Maryland",
        abbr: "MD",
        fips: "24"
    },
    "MA": {
        name: "Massachusetts",
        abbr: "MA",
        fips: "25"
    },
    "MI": {
        name: "Michigan",
        abbr: "MI",
        fips: "26"
    },
    "MN": {
        name: "Minnesota",
        abbr: "MN",
        fips: "27"
    },
    "MS": {
        name: "Mississippi",
        abbr: "MS",
        fips: "28"
    },
    "MO": {
        name: "Missouri",
        abbr: "MO",
        fips: "29"
    },
    "MT": {
        name: "Montana",
        abbr: "MT",
        fips: "30"
    },
    "NE": {
        name: "Nebraska",
        abbr: "NE",
        fips: "31"
    },
    "NV": {
        name: "Nevada",
        abbr: "NV",
        fips: "32"
    },
    "NH": {
        name: "New Hampshire",
        abbr: "NH",
        fips: "33"
    },
    "NJ": {
        name: "New Jersey",
        abbr: "NJ",
        fips: "34"
    },
    "NM": {
        name: "New Mexico",
        abbr: "NM",
        fips: "35"
    },
    "NY": {
        name: "New York",
        abbr: "NY",
        fips: "36"
    },
    "NC": {
        name: "North Carolina",
        abbr: "NC",
        fips: "37"
    },
    "ND": {
        name: "North Dakota",
        abbr: "ND",
        fips: "38"
    },
    "OH": {
        name: "Ohio",
        abbr: "OH",
        fips: "39"
    },
    "OK": {
        name: "Oklahoma",
        abbr: "OK",
        fips: "40"
    },
    "OR": {
        name: "Oregon",
        abbr: "OR",
        fips: "41"
    },
    "PA": {
        name: "Pennsylvania",
        abbr: "PA",
        fips: "42"
    },
    "RI": {
        name: "Rhode Island",
        abbr: "RI",
        fips: "44"
    },
    "SC": {
        name: "South Carolina",
        abbr: "SC",
        fips: "45"
    },
    "SD": {
        name: "South Dakota",
        abbr: "SD",
        fips: "46"
    },
    "TN": {
        name: "Tennessee",
        abbr: "TN",
        fips: "47"
    },
    "TX": {
        name: "Texas",
        abbr: "TX",
        fips: "48"
    },
    "UT": {
        name: "Utah",
        abbr: "UT",
        fips: "49"
    },
    "VT": {
        name: "Vermont",
        abbr: "VT",
        fips: "50"
    },
    "VA": {
        name: "Virginia",
        abbr: "VA",
        fips: "51"
    },
    "WA": {
        name: "Washington",
        abbr: "WA",
        fips: "53"
    },
    "WV": {
        name: "West Virginia",
        abbr: "WV",
        fips: "54"
    },
    "WI": {
        name: "Wisconsin",
        abbr: "WI",
        fips: "55"
    },
    "WY": {
        name: "Wyoming",
        abbr: "WY",
        fips: "56"
    },
    "AS": {
        name: "American Samoa",
        abbr: "AS",
        fips: "60"
    },
    "GU": {
        name: "Guam",
        abbr: "GU",
        fips: "66"
    },
    "MP": {
        name: "Northern Mariana Islands",
        abbr: "MP",
        fips: "69"
    },
    "PR": {
        name: "Puerto Rico",
        abbr: "PR",
        fips: "72"
    },
    "VI": {
        name: "Virgin Islands",
        abbr: "VI",
        fips: "78"
    }
};
const $12d34f3c78180d6b$export$b4c789cd45f7243f = {
    "01": {
        name: "Alabama",
        abbr: "AL",
        fips: "01",
        lat: 33.318230,
        lon: -86.902298
    },
    "02": {
        name: "Alaska",
        abbr: "AK",
        fips: "02",
        lat: 65.160507,
        lon: -148.369141
    },
    "04": {
        name: "Arizona",
        abbr: "AZ",
        fips: "04",
        lat: 34.048927,
        lon: -111.093735
    },
    "05": {
        name: "Arkansas",
        abbr: "AR",
        fips: "05",
        lat: 34.799999,
        lon: -92.199997
    },
    "06": {
        name: "California",
        abbr: "CA",
        fips: "06",
        lat: 36.778259,
        lon: -119.417931
    },
    "08": {
        name: "Colorado",
        abbr: "CO",
        fips: "08",
        lat: 39.113014,
        lon: -105.358887
    },
    "09": {
        name: "Connecticut",
        abbr: "CT",
        fips: "09",
        lat: 41.599998,
        lon: -72.699997
    },
    "10": {
        name: "Delaware",
        abbr: "DE",
        fips: "10",
        lat: 39,
        lon: 75.5
    },
    "11": {
        name: "District of Columbia",
        abbr: "DC",
        fips: "11"
    },
    "12": {
        name: "Florida",
        abbr: "FL",
        fips: "12",
        lat: 28.194402,
        lon: -81.760254
    },
    "13": {
        name: "Georgia",
        abbr: "GA",
        fips: "13",
        lat: 33.247875,
        lon: -83.441162
    },
    "15": {
        name: "Hawaii",
        abbr: "HI",
        fips: "15",
        lat: 19.741755,
        lon: -155.844437
    },
    "16": {
        name: "Idaho",
        abbr: "ID",
        fips: "16",
        lat: 44.068203,
        lon: -114.742043
    },
    "17": {
        name: "Illinois",
        abbr: "IL",
        fips: "17",
        lat: 40,
        lon: -89
    },
    "18": {
        name: "Indiana",
        abbr: "IN",
        fips: "18",
        lat: 38.273502,
        lon: -86.126976
    },
    "19": {
        name: "Iowa",
        abbr: "IA",
        fips: "19",
        lat: 42.032974,
        lon: -93.581543
    },
    "20": {
        name: "Kansas",
        abbr: "KS",
        fips: "20",
        lat: 38.5,
        lon: -98
    },
    "21": {
        name: "Kentucky",
        abbr: "KY",
        fips: "21",
        lat: 37.839333,
        lon: -84.27002
    },
    "22": {
        name: "Louisiana",
        abbr: "LA",
        fips: "22",
        lat: 32.391830,
        lon: -92.329102
    },
    "23": {
        name: "Maine",
        abbr: "ME",
        fips: "23",
        lat: 46.367584,
        lon: -68.972168
    },
    "24": {
        name: "Maryland",
        abbr: "MD",
        fips: "24",
        lat: 39.045753,
        lon: -76.641273
    },
    "25": {
        name: "Massachusetts",
        abbr: "MA",
        fips: "25",
        lat: 42.407211,
        lon: -71.382439
    },
    "26": {
        name: "Michigan",
        abbr: "MI",
        fips: "26",
        lat: 44.182205,
        lon: -84.506836
    },
    "27": {
        name: "Minnesota",
        abbr: "MN",
        fips: "27",
        lat: 46.392410,
        lon: -94.63623
    },
    "28": {
        name: "Mississippi",
        abbr: "MS",
        fips: "28",
        lat: 33,
        lon: 90
    },
    "29": {
        name: "Missouri",
        abbr: "MO",
        fips: "29",
        lat: 38.573936,
        lon: -92.60376
    },
    "30": {
        name: "Montana",
        abbr: "MT",
        fips: "30",
        lat: 46.965260,
        lon: -109.533691
    },
    "31": {
        name: "Nebraska",
        abbr: "NE",
        fips: "31",
        lat: 41.5,
        lon: -100
    },
    "32": {
        name: "Nevada",
        abbr: "NV",
        fips: "32",
        lat: 39.876019,
        lon: -117.224121
    },
    "33": {
        name: "New Hampshire",
        abbr: "NH",
        fips: "33",
        lat: 44,
        lon: -71.5
    },
    "34": {
        name: "New Jersey",
        abbr: "NJ",
        fips: "34",
        lat: 39.833851,
        lon: -74.871826
    },
    "35": {
        name: "New Mexico",
        abbr: "NM",
        fips: "35",
        lat: 34.307144,
        lon: -106.018066
    },
    "36": {
        name: "New York",
        abbr: "NY",
        fips: "36",
        lat: 43,
        lon: -75
    },
    "37": {
        name: "North Carolina",
        abbr: "NC",
        fips: "37",
        lat: 35.782169,
        lon: -80.793457
    },
    "38": {
        name: "North Dakota",
        abbr: "ND",
        fips: "38",
        lat: 47.650589,
        lon: -100.437012
    },
    "39": {
        name: "Ohio",
        abbr: "OH",
        fips: "39",
        lat: 40.367474,
        lon: -82.996216
    },
    "40": {
        name: "Oklahoma",
        abbr: "OK",
        fips: "40",
        lat: 36.084621,
        lon: -96.921387
    },
    "41": {
        name: "Oregon",
        abbr: "OR",
        fips: "41",
        lat: 44,
        lon: -120.5
    },
    "42": {
        name: "Pennsylvania",
        abbr: "PA",
        fips: "42",
        lat: 41.203323,
        lon: -77.194527
    },
    "44": {
        name: "Rhode Island",
        abbr: "RI",
        fips: "44",
        lat: 41.742325,
        lon: -71.742332
    },
    "45": {
        name: "South Carolina",
        abbr: "SC",
        fips: "45",
        lat: 34.336082,
        lon: -81.163727
    },
    "46": {
        name: "South Dakota",
        abbr: "SD",
        fips: "46",
        lat: 44.5,
        lon: -100
    },
    "47": {
        name: "Tennessee",
        abbr: "TN",
        fips: "47",
        lat: 35.860119,
        lon: -86.660156
    },
    "48": {
        name: "Texas",
        abbr: "TX",
        fips: "48",
        lat: 31,
        lon: -100
    },
    "49": {
        name: "Utah",
        abbr: "UT",
        fips: "49",
        lat: 39.419220,
        lon: -111.950684
    },
    "50": {
        name: "Vermont",
        abbr: "VT",
        fips: "50",
        lat: 44,
        lon: -72.699997
    },
    "51": {
        name: "Virginia",
        abbr: "VA",
        fips: "51",
        lat: 37.926868,
        lon: -78.024902
    },
    "53": {
        name: "Washington",
        abbr: "WA",
        fips: "53",
        lat: 47.751076,
        lon: -120.740135
    },
    "54": {
        name: "West Virginia",
        abbr: "WV",
        fips: "54",
        lat: 39,
        lon: -80.5
    },
    "55": {
        name: "Wisconsin",
        abbr: "WI",
        fips: "55",
        lat: 44.5,
        lon: -89.5
    },
    "56": {
        name: "Wyoming",
        abbr: "WY",
        fips: "56",
        lat: 43.075970,
        lon: -107.290283
    },
    "60": {
        name: "American Samoa",
        abbr: "AS",
        fips: "60",
        lat: -14.275632,
        lon: -170.702042
    },
    "66": {
        name: "Guam",
        abbr: "GU",
        fips: "66",
        lat: 13.444304,
        lon: 144.793732
    },
    "69": {
        name: "Northern Mariana Islands",
        abbr: "MP",
        fips: "69",
        lat: 15.183333,
        lon: 145.75
    },
    "72": {
        name: "Puerto Rico",
        abbr: "PR",
        fips: "72",
        lat: 18.200178,
        lon: -66.664513
    },
    "78": {
        name: "Virgin Islands",
        abbr: "VI",
        fips: "78",
        lat: 34.297878,
        lon: -83.824066
    }
};



var $7ArpZ = parcelRequire("7ArpZ");


parcelRequire("7ArpZ");
class $7392ee50b9a2c168$export$b1f97c3099fc6872 {
    #topBorder;
    #bottomBorder;
    #face;
    #anchor;
    #label;
    #visible;
    #disposed;
    /**
     *
     * @param {Mesh} mesh
     * @param {RegionDescriptor[]} regionDescriptorQueue - LIFO queue
     */ constructor(mesh){
        const { face: face, topBorder: topBorder, bottomBorder: bottomBorder, anchor: anchor } = this._parseObj(mesh);
        this.#face = face;
        this.#topBorder = topBorder;
        this.#bottomBorder = bottomBorder;
        this.#anchor = anchor;
        this.#visible = true;
        this.#disposed = false;
    }
    /**
     * Clean up resources associated with this region and remove it from the scene graph
     * @param {Boolean} disposeMaterials
     * @param {Boolean} disposeTextures
     */ dispose(disposeMaterials, disposeTextures) {
        this.#disposed = true;
        this.face.geometry.dispose();
        this.topBorder.geometry.dispose();
        this.bottomBorder.geometry.dispose();
        if (disposeTextures) this.disposeTextures();
        if (disposeMaterials) this.disposeMaterials();
        this.face.parent?.remove(this.face);
    }
    disposeTextures() {
        const materials = [
            this.face.material,
            this.topBorder.material,
            this.bottomBorder.material
        ];
        materials.forEach((material)=>{
            for (const key of Object.keys(material)){
                const value = material[key];
                if (value && typeof value === "object" && "minFilter" in value) value.dispose();
            }
        });
    }
    disposeMaterials() {
        this.face.material.dispose();
        this.topBorder.material.dispose();
        this.bottomBorder.material.dispose();
    }
    highlight(color = "#FFF") {}
    unhighlight() {}
    raise() {}
    lower() {}
    hide() {
        this.#visible = false;
        this.face.visible = false;
        this.topBorder.visible = false;
        this.bottomBorder.visible = false;
    }
    show() {
        this.#visible = true;
        this.face.visible = true;
        this.topBorder.visible = true;
        this.bottomBorder.visible = true;
    }
    get isRegion() {
        return true;
    }
    get face() {
        return this.#face;
    }
    get topBorder() {
        return this.#topBorder;
    }
    get bottomBorder() {
        return this.#bottomBorder;
    }
    get anchor() {
        return this.#anchor;
    }
    get label() {
        return this.#anchor.children.find((child)=>child.userData.labelType === "name");
    }
    get visible() {
        return this.#visible;
    }
    get disposed() {
        return this.#disposed;
    }
    /**
     * Separate a mesh into its components
     * @param {Mesh} obj
     * @returns {{face: Mesh, topBorder: Mesh, bottomBorder: Mesh, anchor: Object3D}}
     * @example const {face, topBorder, bottomBorder, anchor} = parseObj(mesh)
     */ _parseObj(obj) {
        if (!obj.name.includes("_")) return Object.assign({
            face: obj
        }, // Recursively parse each child mesh
        ...obj.children.map((obj)=>this._parseObj(obj)));
        const lastWord = obj.name.split("_").at(-1);
        if (lastWord.startsWith("TopBorder")) return {
            topBorder: obj
        };
        if (lastWord.startsWith("BottomBorder")) return {
            bottomBorder: obj
        };
        if (lastWord.startsWith("Anchor")) return {
            anchor: obj
        };
        return Object.assign({
            face: obj
        }, // Recursively parse each child mesh
        ...obj.children.map((obj)=>this._parseObj(obj)));
    }
    get id() {
        return this.#face.name;
    }
    /**
     * Get the Region associated with a particular mesh
     *
     * @param {Mesh} obj
     * @returns {Region}
     * @throws
     */ static lookup(mesh) {
        if ("region" in mesh && mesh.region instanceof $7392ee50b9a2c168$export$b1f97c3099fc6872) return mesh.region;
        else throw new Error("Mesh did not have a region property", mesh);
    }
}
class $7392ee50b9a2c168$export$a727a27b9798096f extends $7392ee50b9a2c168$export$b1f97c3099fc6872 {
    /**
     * 
     * @param {ColorRepresentation} color 
     */ highlight(color = "#FFF") {
        /**
         * @type Color
         */ const colorObject = this.face.material.color;
        colorObject.set(color);
    }
    unhighlight() {
        /**
         * @type Color
         */ const colorObject = this.face.material.color;
        colorObject.copy(this.face.userData.inactiveColor);
    }
}
class $7392ee50b9a2c168$export$6b244c454568e0ca extends $7392ee50b9a2c168$export$b1f97c3099fc6872 {
}
class $7392ee50b9a2c168$export$7e0fd72fe0a85f54 extends $7392ee50b9a2c168$export$b1f97c3099fc6872 {
    #materials;
    #mapLevel;
    #inactive;
    #holePunch;
    /**
     *
     * @param {Mesh} mesh
     * @param {{active: Material[], inactive: Material[], holePunch: Material[]}} materials
     */ constructor(mesh, materials){
        super(mesh);
        this.#materials = materials;
        this.#mapLevel = 0;
        this.#inactive = false;
        this.#holePunch = false;
    }
    highlight() {
        if (this.#inactive && !this.#holePunch) this.face.material = this.#materials.active[this.#mapLevel];
    }
    unhighlight() {
        if (this.#inactive && !this.#holePunch) this.face.material = this.#materials.inactive[this.#mapLevel];
    }
    deactivate() {
        this.#inactive = true;
        this._setMapMaterial();
    }
    activate() {
        this.#inactive = false;
        this._setMapMaterial();
    }
    setMapLevel(level) {
        this.#mapLevel = level;
        this._setMapMaterial(level);
    }
    /**
     * Set the material to the hole punch material
     *
     * Allows the vector map to be seen under the globe canvas
     */ holePunch() {
        this.#holePunch = true;
        this._setMapMaterial();
    }
    unHolePunch() {
        this.#holePunch = false;
        this._setMapMaterial();
    }
    get isMapRegion() {
        return true;
    }
    get isHolePunched() {
        return this.#holePunch;
    }
    _setMapMaterial() {
        let materials;
        if (this.#holePunch) materials = this.#materials.holePunch;
        else materials = this.#inactive ? this.#materials.inactive : this.#materials.active;
        this.face.material = materials[this.#mapLevel];
    }
}
class $7392ee50b9a2c168$export$919d458d4d808c07 {
    #topLevel;
    #topBorder;
    /**
     *
     * @param {Object3D} topLevelObject
     */ constructor(topLevel){
        this.#topLevel = topLevel;
        this.regions = [];
        this.#parseObj(topLevel);
    }
    get topBorder() {
        return this.#topBorder;
    }
    // TODO OPTIMIZATION-MEMORY: Don't construct a new list every time
    get faces() {
        return this.regions.map((region)=>region.face);
    }
    // TODO OPTIMIZATION-MEMORY: Don't construct a new list every time
    get topBorders() {
        return this.regions.map((region)=>region.topBorder);
    }
    #parseObj(obj) {
        if (!obj.children) {
            console.error("Object has no children", obj);
            return;
        }
        obj.children.forEach((child)=>{
            const lastWord = child.name.split("_").at(-1);
            if (lastWord.startsWith("TopBorder")) {
                this.#topBorder = child;
                return;
            }
            this.regions.push(new $7392ee50b9a2c168$export$b1f97c3099fc6872(child));
        });
    }
}


const $65867f75b82a314a$export$bafb4b606f8af778 = [
    "PR",
    "VI",
    "AS",
    "GU",
    "MP",
    "AK",
    "HI"
];
class $65867f75b82a314a$export$315d320af4304b5 {
    constructor(globe){
        this.scene = globe;
        this.loader = new (0, $f00a0cf390d4f349$export$aa93f11e7884f0f4)();
        this.loader.setMeshoptDecoder((0, $b9b5bad09e314aa5$export$1111800106ba519a));
        const dracoLoader = new (0, $88f4ea66493b0ee5$export$45c25de53be259ac)();
        dracoLoader.setDecoderPath("/vendor/draco/");
        this.loader.setDRACOLoader(dracoLoader);
    }
    // addGlobe(world){
    //   /** **GLTF Loader old way to import shapers***/
    //   const temp = this
    //   const colorMap = new Map();
    //   colorMap.set("Argentina", randGrayScale());
    //   colorMap.set("Bolivia", randGrayScale());
    //   colorMap.set("Brazil", randGrayScale());
    //   colorMap.set("Chile", randGrayScale());
    //   colorMap.set("Colombia", randGrayScale());
    //   colorMap.set("Ecuador", randGrayScale());
    //   colorMap.set("FrenchGuiana", randGrayScale());
    //   colorMap.set("Guyana", randGrayScale());
    //   colorMap.set("Paraguay", randGrayScale());
    //   colorMap.set("Peru", randGrayScale());
    //   colorMap.set("Suriname", randGrayScale());
    //   colorMap.set("Uruguay", randGrayScale());
    //   colorMap.set("Venezuela", randGrayScale());
    //   const defaultColor = randGrayScale();
    //   this.loader.load( '/assets/glb/GlobeEric5.glb', function ( gltf ) {
    //     let object = null; let mesh; let name;
    //     for (let i = 0; i<gltf.scene.children.length; i++){
    //       if (!gltf.scene.children[i].isMesh) {
    //         object = gltf.scene.children[i];
    //         mesh = object.children[0];
    //         name = object.name;
    //       } else {
    //         mesh = gltf.scene.children[i];
    //         object = mesh;
    //         name = object.name;
    //       }
    //       // Check for membership in the color map
    //       if (colorMap.has(name)) {
    //         // Clone the material so we don't affect all the other countries
    //         mesh.material = mesh.material.clone();
    //         // Set color to the color in the map
    //         mesh.material.color.set(colorMap.get(name))
    //       } else {
    //         if (mesh.material.name.includes("face")) {
    //           // TODO: This only needs to be done once technically
    //           mesh.material.color.set(defaultColor);
    //         }
    //       }
    //       if (mesh.isMesh) {
    //         mesh.castShadow = true;
    //         mesh.receiveShadow = true;
    //       }
    //       if (mesh.material){
    //         if (mesh.material.name.includes("Bords")) {
    //           mesh.material.dispose();
    //           mesh.material = new THREE.MeshLambertMaterial({
    //             color: "#5588FF",
    //           });
    //           mesh.material.side = THREE.DoubleSide;
    //           mesh.material.onBeforeCompile = function(shader, renderer) {
    //             temp.injectFakeAO(shader, renderer);
    //           }
    //         } else if (mesh.material.name.includes("conturs")) {
    //           // Replace the physical material on the contours with a simple material for performance
    //           mesh.material.dispose();
    //           mesh.material = new THREE.MeshBasicMaterial( {
    //             color: "#DDD"
    //           });
    //         } else {
    //           mesh.material.onBeforeCompile = function(shader, renderer) {
    //             let uniforms = {
    //               color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
    //               // +x is right
    //               // +y is up
    //               // +z is away (don't use)
    //               rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
    //               strength: { value: 2.9 },
    //               width: { value:   0.35}
    //             };
    //             temp.injectRimLight(shader, renderer, uniforms);
    //             uniforms = {
    //               color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
    //               // +x is right
    //               // +y is up
    //               // +z is away (don't use)
    //               rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
    //               strength: { value: 1.5 },
    //               width: { value:   0.35}
    //             };
    //             temp.injectRimLight(shader, renderer, uniforms, '2');
    //           }
    //         }
    //       }
    //     }
    //     temp.planet = gltf.scene
    //     temp.planet.name = 'Earth'
    //     temp.planet.scale.x = 50
    //     temp.planet.scale.y = 50
    //     temp.planet.scale.z = 50
    //     temp.planet.rotation.y = -Math.PI/2
    //     world.add(temp.planet)
    //     document.querySelector('canvas').setAttribute('globe',true);
    //     loadingScreen()
    //   }, // called while loading is progressing
    //   function ( xhr ) {
    // 		// console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
    //     if ((xhr.loaded / xhr.total * 100 ) == 100){
    //     }
    // 	}, function ( error ) {
    //     console.error( error );
    //   } );
    // }
    async addWater(renderer) {
        /** **GLTF Loader old way to import shapers***/ const temp = this;
        // const gray = new THREE.MeshBasicMaterial( { color: "#3c3c3c" } );
        const promise = new Promise((resolve, reject)=>{
            this.loader.load("/assets/glb/watermorg14_packed.glb", function(gltf) {
                let object, mesh, name;
                const b = new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
                const black = b.getHex();
                // console.log(black);
                for(let i = 0; i < gltf.scene.children.length; i++){
                    if (!gltf.scene.children[i].isMesh) {
                        object = gltf.scene.children[i];
                        mesh = object.children[0];
                        name = object.name;
                    } else {
                        mesh = gltf.scene.children[i];
                        object = mesh;
                        name = object.name;
                    }
                    // console.log(mesh);
                    // mesh.visible = false;
                    if (mesh.material) {
                        if (name === "waves") {
                            // Water wavies
                            const oldMaterial = mesh.material;
                            mesh.material = new $8725869b83961a04$export$55cbcc9b622fe1f5({
                                // map: oldMaterial.map,
                                color: "#182230"
                            });
                            mesh.castShadow = true;
                            mesh.receiveShadow = false;
                        // mesh.material.onBeforeCompile = function(shader, renderer) {
                        //   var uniforms = {
                        //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                        //     strength: { value: 2.9/16},
                        //     width: { value:   0.35}
                        //   };
                        //   temp.injectRimLight(shader, renderer, uniforms);
                        //   uniforms = {
                        //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                        //     strength: { value: 1.5/16},
                        //     width: { value:   0.35}
                        //   };
                        //   temp.injectRimLight(shader, renderer, uniforms, '2');
                        // }
                        // temp.addShader(
                        //   mesh,
                        //   "/assets/shaders/rimlight.vert",
                        //   "/assets/shaders/rimlight.frag",
                        //   // uniforms
                        //   {
                        //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                        //     strength: { value: 2.9/16 },
                        //     width: { value: 0.35}
                        //   }
                        // );
                        // temp.addShader(
                        //   mesh,
                        //   "/assets/shaders/rimlight.vert",
                        //   "/assets/shaders/rimlight.frag",
                        //   // uniforms
                        //   {
                        //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                        //     strength: { value: 1.5/16 },
                        //     width: { value:   0.35}
                        //   }
                        // );
                        // Add radial gradient to the swirlies
                        // temp.addShader(
                        //   mesh,
                        //   "assets/shaders/rimlight.vert",
                        //   "assets/shaders/fakeao.frag",
                        //   // uniforms
                        //   {
                        //     color: { value: new THREE.Vector3(1, 1, 1) },
                        //     center: { value: new THREE.Vector3(0, 50, 0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     attenuation: { value: 0.8 },
                        //     strength: { value: 0.1 },
                        //     startRadius: { value: 50},
                        //   },
                        //   THREE.MultiplyBlending
                        // );
                        }
                        // temp.addCustomShaders(mesh)
                        (mesh.material.color.getHex() == black || mesh.material.name == "contur_green") && name;
                        if (name === "Sphere") {
                            // console.log('Sphere')g
                            // console.log(mesh);
                            // mesh.material.polygonOffset = true;
                            // mesh.material.color.set("#232628");
                            mesh.material.polygonOffsetFactor = 0.2;
                            mesh.receiveShadow = true;
                            // mesh.castShadow = true;
                            // Add rim light shaders
                            mesh.material.onBeforeCompile = function(shader, renderer) {
                                let uniforms = {
                                    color: {
                                        value: new $8725869b83961a04$export$64b5c384219d3699(0.85, 0.97, 1.0)
                                    },
                                    // +x is right
                                    // +y is up
                                    // +z is away (don't use)
                                    rimOffset: {
                                        value: new $8725869b83961a04$export$64b5c384219d3699(-15, 30.0, 0.0)
                                    },
                                    strength: {
                                        value: 2.9
                                    },
                                    width: {
                                        value: 0.35
                                    }
                                };
                                temp.injectRimLight(shader, renderer, uniforms);
                                uniforms = {
                                    color: {
                                        value: new $8725869b83961a04$export$64b5c384219d3699(0.85, 0.97, 1.0)
                                    },
                                    // +x is right
                                    // +y is up
                                    // +z is away (don't use)
                                    rimOffset: {
                                        value: new $8725869b83961a04$export$64b5c384219d3699(0.0, -60, 0.0)
                                    },
                                    strength: {
                                        value: 1.5
                                    },
                                    width: {
                                        value: 0.35
                                    }
                                };
                                temp.injectRimLight(shader, renderer, uniforms, "2");
                            };
                        // temp.addShader(
                        //   mesh,
                        //   "/assets/shaders/rimlight.vert",
                        //   "/assets/shaders/rimlight.frag",
                        //   // uniforms
                        //   {
                        //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
                        //     strength: { value: 2.9 },
                        //     width: { value:   0.35}
                        //   },
                        //   null,
                        //   -0.10
                        // );
                        // temp.addShader(
                        //   mesh,
                        //   "/assets/shaders/rimlight.vert",
                        //   "/assets/shaders/rimlight.frag",
                        //   // uniforms
                        //   {
                        //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
                        //     // +x is right
                        //     // +y is up
                        //     // +z is away (don't use)
                        //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
                        //     strength: { value: 1.5 },
                        //     width: { value:   0.35}
                        //   },
                        //   null,
                        //   -0.10
                        // );
                        // console.log('hit');
                        // mesh.material.color.setHex('0x40424B');
                        // 2C2E37
                        // #65666C
                        // 696A70
                        // #7A8288
                        // #595E67
                        // #555F73
                        // #616773
                        // #686f7d
                        // #40424B
                        // #4D4F57
                        // #40424B
                        // console.log(mesh);
                        }
                    }
                // console.log(mesh.material.color);
                }
                // console.log(gltf.scene);
                temp.planet = gltf.scene;
                temp.planet.name = "Earth";
                // console.log(temp.planet);
                temp.planet.scale.x = 50;
                temp.planet.scale.y = 50;
                temp.planet.scale.z = 50;
                // temp.planet.rotation.y = -Math.PI/2 - Math.PI * 0.006
                // temp.planet.rotation.x = Math.PI * 0.003
                // temp.planet.rotation.z = Math.PI * 0.007
                temp.scene.add(temp.planet);
                // document.querySelector('canvas').setAttribute('water',true);
                // loadingScreen()
                resolve(gltf);
            }, function(xhr) {
                xhr.loaded, xhr.total;
            }, function(error) {
                console.error(error);
                reject(error);
            });
        });
        return promise;
    }
    // addBumpMap(mesh, path) {
    //   const textureLoader = new THREE.TextureLoader();
    //   textureLoader.load(
    //     path,
    //     function (texture) {
    //       // const newMat = new THREE.MeshPhongMaterial();
    //       var oldMat;
    //       if(Object.prototype.toString.call(mesh.material) == "[object Array]") {
    //         oldMat = mesh.material[0];
    //       } else {
    //         oldMat = mesh.material;
    //       }
    //       oldMat.normalMap = texture;
    //     }
    //   );
    // }
    addShader(mesh, vertPath, fragPath, uniforms, blendMode = null, polygonOffsetFactor = 0) {
        // TODO: Cache the materials so this doesnt generate 100+ fetch requests
        const loader = new $8725869b83961a04$export$98435a25b5cf7b2b();
        // Closure for loading both shaders
        let vertexShader = "";
        let fragmentShader = "";
        let nFilesLoaded = 0;
        function onShaderLoaded() {
            nFilesLoaded++;
            // Wait till we've loaded both files
            if (nFilesLoaded != 2) return;
            // Construct the material
            const material = new $8725869b83961a04$export$83c7d75d550a8b0d({
                depthWrite: false,
                uniforms: uniforms,
                vertexShader: vertexShader,
                fragmentShader: fragmentShader
            });
            if (blendMode) material.blending = blendMode;
            else {
                // Additive blending is good for lighting effects
                material.blending = $8725869b83961a04$export$eda4864c68df1fa2;
                material.blendEquation = $8725869b83961a04$export$20183a0484ce21a0;
                material.blendSrc = $8725869b83961a04$export$d5773124e86cf28c;
                material.blendDst = $8725869b83961a04$export$11d468cc7f19e971;
            }
            if (polygonOffsetFactor) {
                material.polygonOffset = true;
                material.polygonOffsetFactor = polygonOffsetFactor;
            }
            if (Object.prototype.toString.call(mesh.material) == "[object Array]") {
                const nextGroupIndex = mesh.material.length;
                mesh.geometry.addGroup(0, Infinity, nextGroupIndex);
                mesh.material.push(material);
            } else {
                // This is a hacky way to blend multiple materials on a mesh
                //  using overlapping vertex groups
                const materials = [
                    mesh.material,
                    material
                ];
                mesh.geometry.addGroup(0, Infinity, 0);
                mesh.geometry.addGroup(0, Infinity, 1);
                mesh.material = materials;
            }
        }
        // Do the loading
        loader.load(fragPath, function(data) {
            fragmentShader = data;
            onShaderLoaded();
        });
        loader.load(vertPath, function(data) {
            vertexShader = data;
            onShaderLoaded();
        });
    }
    isHawaiiOrAlaska(mesh) {
        if (mesh.parent.name.includes("Hawaii")) return true;
        if (mesh.parent.name.includes("Alaska")) return true;
        return false;
    }
    // Inject the fake AO shader chunk into the passed-in shader
    // Should be called in Material.onBeforeCompile
    injectFakeAO = (function() {
        const fakeAOFrag = `

    vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz - center;
    float fragRadius = length(worldPosition);
    float shadowStrength = max(0.0, 1.0 - (strength * (1.0 / (attenuation * (fragRadius - startRadius) + 1.0))));
    gl_FragColor.rgb = gl_FragColor.rgb * shadowStrength;`;
        const vPositionDef = "\nvarying vec3 vPosition;\n";
        const vPositionSet = "\nvPosition = position;\n";
        const uMatMatrix = "\nuniform mat4 modelMatrix;\n";
        return function injectFakeAO(shader, renderer, uniforms) {
            // Set default uniforms
            if (typeof uniforms === "undefined") uniforms = {
                color: {
                    value: new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
                },
                center: {
                    value: new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0)
                },
                attenuation: {
                    value: 0.8
                },
                strength: {
                    value: 0.25
                },
                startRadius: {
                    value: 50.0
                }
            };
            let declarations = "";
            const uniformPostfix = "";
            for(const key in uniforms){
                const newKey = key + uniformPostfix;
                if (newKey in shader.uniforms) {
                    console.log("WARNING: Key " + key + " already in rim light shader uniforms: ", shader.uniforms);
                    continue;
                }
                let type = "";
                const assignment = "";
                if (uniforms[key].value.isVector3) type = "vec3";
                else if (typeof uniforms[key].value === "number") type = "float";
                else {
                    console.log("ERROR: injectFakeAO: Unknown type passed in uniforms as " + key + ":", uniforms[key], uniforms[key].value.isVector3, typeof uniforms[key].value);
                    return;
                }
                declarations += "uniform " + type + " " + newKey + ";";
                shader.uniforms[newKey] = uniforms[key];
            }
            shader.vertexShader = shader.vertexShader.replace("void main() {", vPositionDef + "void main() {" + vPositionSet);
            // Modify frag shader
            shader.fragmentShader = shader.fragmentShader.replace("void main() {", declarations + uMatMatrix + vPositionDef + "void main() {");
            shader.fragmentShader = shader.fragmentShader.replace("#include <dithering_fragment>", "#include <dithering_fragment>" + fakeAOFrag);
        };
    })();
    injectRimLight = (function() {
        const rimLightFrag = `
    {
    vec3 center = vec3(0, 50, 0);
    vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz;
    vec3 worldNormal =  normalize( vec3( modelMatrix * vec4(vNormal2, 0.0 ) ) );
    mat4 inverseViewMatrix = inverse(viewMatrix);
    vec3 cameraWorld = (inverseViewMatrix * vec4(rimOffset, 1.0)).xyz;
    vec3 toCenter = center - cameraWorld;
    float dist = (length(toCenter) - 75.0) / 80.0;
    dist = clamp(dist, 0.0, 1.0);
    vec3 viewVector = normalize(cameraWorld - worldPosition);
    float rimndotv =  max(0.0, width - dot(worldNormal, viewVector));
    vec3 rimLight = color;
    vec3 finalLight = rimLight;
    gl_FragColor.rgb = gl_FragColor.rgb + (finalLight * rimndotv * rimndotv * strength * dist);
    }
    `;
        const vPositionDef = "\nvarying vec3 vPosition;\nvarying vec3 vNormal2;\n";
        const vPositionSet = "\nvPosition = position;\n";
        const vNormal2Set = "\nvNormal2 = normal;\n";
        // const uMatMatrix = "\nuniform mat4 modelMatrix;\n";
        const fragDeclarations = `
    uniform mat4 modelMatrix;
    uniform mat4 modelViewMatrix;

    varying vec3 vPosition;
    varying vec3 vNormal2;
    `;
        return function injectRimLight(shader, renderer, uniforms, uniformPostfix = "") {
            const rimLightFrag = `
      {
      vec3 center = vec3(0, 50, 0);
      vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz;
      vec3 worldNormal =  normalize( vec3( modelMatrix * vec4(vNormal2, 0.0 ) ) );
      mat4 inverseViewMatrix = inverse(viewMatrix);
      vec3 cameraWorld = (inverseViewMatrix * vec4(rimOffset` + uniformPostfix + `, 1.0)).xyz;
      vec3 toCenter = center - cameraWorld;
      float dist = (length(toCenter) - 75.0) / 80.0;
      dist = clamp(dist, 0.0, 1.0);
      vec3 viewVector = normalize(cameraWorld - worldPosition);
      float rimndotv =  max(0.0, width` + uniformPostfix + ` - dot(worldNormal, viewVector));
      vec3 rimLight = color` + uniformPostfix + `;
      vec3 finalLight = rimLight;
      gl_FragColor.rgb = gl_FragColor.rgb + (finalLight * rimndotv * rimndotv * strength` + uniformPostfix + ` * dist);
      }
      `;
            // uniform vec3 color;
            // uniform vec3 rimOffset;
            // uniform float strength;
            // uniform float width;
            // Bake in uniforms in shader declarations
            let declarations = "\n";
            for(const key in uniforms){
                const newKey = key + uniformPostfix;
                if (newKey in shader.uniforms) {
                    console.log("WARNING: Key " + key + " already in rim light shader uniforms: ", shader.uniforms);
                    continue;
                }
                let type = "";
                const assignment = "";
                if (uniforms[key].value.isVector3) type = "vec3";
                else if (typeof uniforms[key].value === "number") type = "float";
                else {
                    console.log("ERROR: injectRimLight: Unknown type passed in uniforms as " + key + ":", uniforms[key], uniforms[key].value.isVector3, typeof uniforms[key].value);
                    return;
                }
                declarations += "uniform " + type + " " + newKey + ";";
                shader.uniforms[newKey] = uniforms[key];
            }
            // Do first-run modifications
            if (!uniformPostfix) {
                shader.vertexShader = shader.vertexShader.replace("void main() {", vPositionDef + "void main() {" + vPositionSet + vNormal2Set);
                declarations += fragDeclarations;
            }
            shader.fragmentShader = declarations + shader.fragmentShader;
            shader.fragmentShader = shader.fragmentShader.replace("}", rimLightFrag + "}");
        // console.log('rim light shader', shader);
        };
    })();
    // Adds a label at the anchor point of mesh
    addLabel(mesh, text) {
        // Find the anchor
        let anchor = null;
        const nChildren = mesh.children.length;
        for(let i = 0; i < nChildren; i++){
            const name = mesh.children[i].name;
            if (name.substr(name.length - 6, 6).toLowerCase() == "anchor") {
                anchor = mesh.children[i];
                break;
            }
        }
        // Error check
        if (!anchor) {
            console.log("WARNING: tried to add label to " + mesh.name + " but no anchor found.");
            return;
        }
        // Create the label
        const div = document.createElement("div");
        div.className = "label";
        div.textContent = text;
        const label = new (0, $5859463f2a625df8$export$936f75e6792bf2dc)(div);
        label.userData.labelType = "name";
        // label.visible = false;
        // console.log(label);
        // Add the label as a child of anchor
        anchor.add(label);
    // console.log(mesh);
    // Add a small label offset
    // anchor.position.z -= 0.1;
    }
    addCountries(file) {
        const scope = this;
        // Construct and return a promise wrapping THREE's load procedure
        return new Promise((resolve, reject)=>{
            // Initialize the materials we'll need
            const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
                side: $8725869b83961a04$export$3b296b6f144d5b03,
                color: "#A0BDDA"
            });
            // Add radial gradient shader snippet to the bottom border material shader
            // bottomBorderMaterial.onBeforeCompile = function (shader, renderer) {
            //   scope.injectFakeAO(shader, renderer);
            // };
            const topBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8();
            // Add radial gradient shader snippet to the top border material shader
            // const uniforms = {
            //   color: {value: new THREE.Vector3(1, 1, 1)},
            //   center: {value: new THREE.Vector3(0, 50, 0)},
            //   attenuation: {value: 0.8},
            //   strength: {value: 0.25},
            //   startRadius: {value: 50.0}
            // }
            // topBorderMaterial.onBeforeCompile = function (shader, renderer) {
            //   scope.injectFakeAO(shader, renderer, uniforms);
            // };
            scope.loader.load(file, // onLoad
            function(gltf) {
                // Do per-object processing
                gltf.scene.traverse((obj)=>{
                    // Filter out objects that we don't care about
                    if (!obj.isMesh) return;
                    // We know obj is a mesh, so it gets a new name for clarity
                    const mesh = obj;
                    /// //////////////////////////////////////////
                    // Top-level mesh processing (face meshes)
                    /// //////////////////////////////////////////
                    if (mesh.parent == gltf.scene) {
                        mesh.receiveShadow = true;
                        mesh.region = new (0, $7392ee50b9a2c168$export$b1f97c3099fc6872)(mesh);
                        mesh.children.forEach((obj)=>obj.region = mesh.region);
                        // Query state info
                        const name = mesh.name.replace(/_/g, " ");
                        // Save state info
                        mesh.userData.name = name;
                        const gray = $65867f75b82a314a$var$randGrayNum();
                        mesh.material = mesh.material.clone();
                        mesh.material.color.set(gray);
                        // Save the base color
                        mesh.userData.baseColor = mesh.material.color.clone();
                        mesh.userData.baseEmissive = mesh.material.emissive.clone();
                        // Save the color that the state should be when inactive (unhighlighted)
                        mesh.userData.inactiveColor = mesh.material.color.clone();
                        mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
                        // Save the old scale
                        mesh.userData.loweredScale = mesh.scale.clone();
                        // Save the new scale
                        mesh.userData.randomScale = mesh.scale.clone();
                        // Randomly raise the countires
                        const scale = 1 + Math.random() * 0.025;
                        mesh.userData.randomScale.multiplyScalar(scale);
                        mesh.scale.multiplyScalar(scale);
                        // Special case for russia & Canada
                        // Prevent the geometry from sinking below the water sphere
                        if (name === "Russian Federation") {
                            mesh.userData.loweredScale.set(.01026, .01026, .01026);
                            mesh.userData.randomScale.set(.01026, .01026, .01026);
                            mesh.scale.copy(mesh.userData.randomScale);
                        }
                        if (name === "Canada") {
                            mesh.userData.loweredScale.set(.01020, .01020, .01020);
                            mesh.userData.randomScale.set(.01020, .01020, .01020);
                            mesh.scale.copy(mesh.userData.randomScale);
                        }
                    // Can be "lowered" or "raised"
                    // mesh.userData.state = "raised";
                    }
                    /// ///////////////////////////////////////////
                    // BottomBorder mesh processing
                    /// ///////////////////////////////////////////
                    if (mesh.name.endsWith("_BottomBorder")) {
                        mesh.material = bottomBorderMaterial.clone();
                        // Add radial gradient shader snippet to the bottom border material shader
                        mesh.material.onBeforeCompile = function(shader, renderer) {
                            scope.injectFakeAO(shader, renderer);
                        };
                        mesh.castShadow = true;
                    // mesh.receiveShadow = true
                    }
                    /// ///////////////////////////////////////////
                    // TopBorder mesh processing
                    /// ///////////////////////////////////////////
                    if (mesh.name.endsWith("_TopBorder")) {
                        mesh.material = topBorderMaterial.clone();
                        // Add radial gradient shader snippet to the top border material shader
                        // const uniforms = {
                        //   color: {value: new THREE.Vector3(1, 1, 1)},
                        //   center: {value: new THREE.Vector3(0, 50, 0)},
                        //   attenuation: {value: 0.8},
                        //   strength: {value: 0.25},
                        //   startRadius: {value: 50.0}
                        // }
                        // mesh.material.onBeforeCompile = function (shader, renderer) {
                        //   scope.injectFakeAO(shader, renderer, uniforms);
                        // };
                        mesh.castShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // General mesh processing
                    /// ///////////////////////////////////////////
                    // Save the base color
                    mesh.userData.baseColor = mesh.material.color.clone();
                    mesh.userData.baseEmissive = mesh.material.emissive.clone();
                    // Save the color that the state should be when inactive (unhighlighted)
                    mesh.userData.inactiveColor = mesh.material.color.clone();
                    mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
                    // Set the type of the mesh
                    // The type of the mesh (state, county, zip, city) is determined by what file it comes from
                    // Since that information isn't automatically attached to the mesh, we need to add it here
                    mesh.userData.type = "state";
                    mesh.tweens = new (0, $7ArpZ.Group)();
                });
                // Transform the scene as necessary
                gltf.scene.scale.multiplyScalar(49.5);
                // gltf.scene.rotation.x = -Math.PI * 0.003
                // gltf.scene.rotation.y = Math.PI * 0.006
                // gltf.scene.rotation.z = -Math.PI * 0.007
                // document.querySelector('canvas').setAttribute('globe',true);
                // loadingScreen()
                // Resolve the promise
                resolve(gltf);
            }, // onProgress - no Promise equivalent
            function(xhr) {
                xhr.loaded, xhr.total;
            }, // onError
            function(error) {
                reject(error);
            }); // End loader.load()
        }); // End Promise()
    }
    addStatesV2() {
        const scope = this;
        // Construct and return a promise wrapping THREE's load procedure
        return new Promise((resolve, reject)=>{
            // Initialize the materials we'll need
            const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
                side: $8725869b83961a04$export$3b296b6f144d5b03,
                color: "#A0BDDA"
            });
            // Add radial gradient shader snippet to the bottom border material shader
            // bottomBorderMaterial.onBeforeCompile = function (shader, renderer) {
            //   scope.injectFakeAO(shader, renderer);
            // };
            const topBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8();
            // Add radial gradient shader snippet to the top border material shader
            // const uniforms = {
            //   color: {value: new THREE.Vector3(1, 1, 1)},
            //   center: {value: new THREE.Vector3(0, 50, 0)},
            //   attenuation: {value: 0.8},
            //   strength: {value: 0.25},
            //   startRadius: {value: 50.0}
            // }
            // topBorderMaterial.onBeforeCompile = function (shader, renderer) {
            //   scope.injectFakeAO(shader, renderer, uniforms);
            // };
            scope.loader.load("/assets/glb/globe/states.glb", // onLoad
            function(gltf) {
                // console.log( "STATES LOADED: ", gltf )
                // Do per-object processing
                gltf.scene.traverse((obj)=>{
                    // Filter out objects that we don't care about
                    if (!obj.isMesh) return;
                    // We know obj is a mesh, so it gets a new name for clarity
                    const mesh = obj;
                    /// //////////////////////////////////////////
                    // Top-level mesh processing (face meshes)
                    /// //////////////////////////////////////////
                    if (mesh.parent == gltf.scene) {
                        // Query state info
                        const fips = mesh.name;
                        const state_info = (0, $12d34f3c78180d6b$export$b4c789cd45f7243f)[fips];
                        // Save state info
                        mesh.userData.name = state_info.name;
                        mesh.userData.abbr = state_info.abbr;
                        mesh.userData.fips = state_info.fips;
                        scope.addLabel(mesh, mesh.userData.name);
                        // Region is part of the upcoming refactor
                        mesh.region = new (0, $7392ee50b9a2c168$export$a727a27b9798096f)(mesh);
                        mesh.children.forEach((obj)=>obj.region = mesh.region);
                        const gray = $65867f75b82a314a$var$randGrayNum();
                        mesh.material = mesh.material.clone();
                        mesh.material.color.set(gray);
                        // Save the scale that the states will transition to when clicked
                        mesh.userData.clickedScale = new $8725869b83961a04$export$64b5c384219d3699(.0109, .0109, .0109);
                        // Save the initial scale
                        mesh.userData.initialScale = mesh.scale.clone();
                        // Save the scale that the states will lower to while they're interactive
                        mesh.userData.loweredScale = new $8725869b83961a04$export$64b5c384219d3699(.0106, .0106, .0106);
                        // All non-mainland states are permanently raised
                        if ($65867f75b82a314a$export$bafb4b606f8af778.includes(mesh.userData.abbr)) {
                            const scale = 1.025 * (49.5 / 48.2);
                            mesh.userData.randomScale = mesh.scale.clone().multiplyScalar(scale);
                            mesh.scale.multiplyScalar(scale);
                            // Save the scale that states will be when lowered
                            mesh.userData.hiddenScale = mesh.scale.clone();
                        } else {
                            // Save the randomized scale that the states will raise to when first presented afte zooming in
                            let scale = 1.045 + Math.random() * 0.025;
                            // Exception for Washington DC - since it's so small, we want it to always be pretty high
                            if (mesh.userData.fips === "11") scale = 1.045 + 0.025;
                            mesh.userData.randomScale = mesh.scale.clone().multiplyScalar(scale);
                            // Save the scale that states will be when lowered
                            mesh.userData.hiddenScale = mesh.scale.clone();
                        }
                        // Can be "lowered" or "raised"
                        mesh.userData.state = "raised";
                        mesh.tweens = new (0, $7ArpZ.Group)();
                    }
                    /// ///////////////////////////////////////////
                    // BottomBorder mesh processing
                    /// ///////////////////////////////////////////
                    if (mesh.name.endsWith("_BottomBorder")) {
                        mesh.material = bottomBorderMaterial.clone();
                        // Add radial gradient shader snippet to the bottom border material shader
                        mesh.material.onBeforeCompile = function(shader, renderer) {
                            scope.injectFakeAO(shader, renderer);
                        };
                        mesh.castShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // TopBorder mesh processing
                    /// ///////////////////////////////////////////
                    if (mesh.name.endsWith("_TopBorder")) {
                        mesh.material = topBorderMaterial.clone();
                        // Add radial gradient shader snippet to the top border material shader
                        // const uniforms = {
                        //   color: {value: new THREE.Vector3(1, 1, 1)},
                        //   center: {value: new THREE.Vector3(0, 50, 0)},
                        //   attenuation: {value: 0.8},
                        //   strength: {value: 0.25},
                        //   startRadius: {value: 50.0}
                        // }
                        // mesh.material.onBeforeCompile = function (shader, renderer) {
                        //   scope.injectFakeAO(shader, renderer, uniforms);
                        // };
                        mesh.castShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // General mesh processing
                    /// ///////////////////////////////////////////
                    // Save the base color
                    mesh.userData.baseColor = mesh.material.color.clone();
                    mesh.userData.baseEmissive = mesh.material.emissive.clone();
                    // Save the color that the state should be when inactive (unhighlighted)
                    mesh.userData.inactiveColor = mesh.material.color.clone();
                    mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
                    // Enable shadows
                    mesh.receiveShadow = true;
                    // Set the type of the mesh
                    // The type of the mesh (state, county, zip, city) is determined by what file it comes from
                    // Since that information isn't automatically attached to the mesh, we need to add it here
                    mesh.userData.type = "state";
                });
                // Transform the scene as necessary
                gltf.scene.scale.multiplyScalar(48.2);
                // gltf.scene.rotation.x = -Math.PI * 0.003
                // gltf.scene.rotation.y = Math.PI * 0.006
                // gltf.scene.rotation.z = -Math.PI * 0.007
                // document.querySelector ('canvas').setAttribute ('usa',true);
                // loadingScreen ()
                // Resolve the promise
                resolve(gltf);
            }, // onProgress - no Promise equivalent
            function(xhr) {
                xhr.loaded, xhr.total;
            }, // onError
            function(error) {
                reject(error);
            }); // End loader.load()
        }); // End Promise()
    }
    addMainland() {
        const scope = this;
        // Construct and return a promise wrapping THREE's load procedure
        return new Promise((resolve, reject)=>{
            // Initialize the materials we'll need
            const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
                side: $8725869b83961a04$export$3b296b6f144d5b03,
                color: "#A0BDDA"
            });
            // Add radial gradient shader snippet to the bottom border material shader
            // bottomBorderMaterial.onBeforeCompile = function (shader, renderer) {
            //   scope.injectFakeAO(shader, renderer);
            // };
            const topBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8();
            // Add radial gradient shader snippet to the top border material shader
            // const uniforms = {
            //   color: {value: new THREE.Vector3(1, 1, 1)},
            //   center: {value: new THREE.Vector3(0, 50, 0)},
            //   attenuation: {value: 0.8},
            //   strength: {value: 0.25},
            //   startRadius: {value: 50.0}
            // }
            // topBorderMaterial.onBeforeCompile = function (shader, renderer) {
            //   scope.injectFakeAO(shader, renderer, uniforms);
            // };
            scope.loader.load("/assets/glb/globe/mainland.glb", // onLoad
            function(gltf) {
                // console.log( "STATES LOADED: ", gltf )
                // Do per-object processing
                gltf.scene.traverse((obj)=>{
                    // Filter out objects that we don't care about
                    if (!obj.isMesh) return;
                    // We know obj is a mesh, so it gets a new name for clarity
                    const mesh = obj;
                    /// //////////////////////////////////////////
                    // Top-level mesh processing (face meshes)
                    /// //////////////////////////////////////////
                    if (mesh.parent == gltf.scene) {
                        scope.addLabel(mesh, "United States of America");
                        mesh.userData.state = "visible";
                        // Region is part of the upcoming refactor
                        mesh.region = new (0, $7392ee50b9a2c168$export$a727a27b9798096f)(mesh);
                        mesh.children.forEach((obj)=>obj.region = mesh.region);
                        const gray = $65867f75b82a314a$var$randGrayNum();
                        mesh.material = mesh.material.clone();
                        mesh.material.color.set(gray);
                        // Save the scale that the states will lower to while they're interactive
                        mesh.userData.loweredScale = new $8725869b83961a04$export$64b5c384219d3699(.0106, .0106, .0106);
                        // Save the scale that the states will transition to when clicked
                        mesh.userData.clickedScale = new $8725869b83961a04$export$64b5c384219d3699(.0109, .0109, .0109);
                        // Save the initial scale
                        mesh.userData.initialScale = mesh.scale.clone();
                        // Save the scale that states will be when lowered
                        mesh.userData.hiddenScale = mesh.scale.clone();
                        mesh.userData.randomScale = mesh.scale.clone();
                        // Raise the usa mesh
                        const scale = 1.025;
                        mesh.userData.randomScale.multiplyScalar(scale);
                        mesh.scale.multiplyScalar(scale);
                        mesh.tweens = new (0, $7ArpZ.Group)();
                    }
                    /// ///////////////////////////////////////////
                    // BottomBorder mesh processing
                    /// ///////////////////////////////////////////
                    if (mesh.name.endsWith("_BottomBorder")) {
                        mesh.material = bottomBorderMaterial.clone();
                        // Add radial gradient shader snippet to the bottom border material shader
                        mesh.material.onBeforeCompile = function(shader, renderer) {
                            scope.injectFakeAO(shader, renderer);
                        };
                        mesh.castShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // TopBorder mesh processing
                    /// ///////////////////////////////////////////
                    if (mesh.name.endsWith("_TopBorder")) {
                        mesh.material = topBorderMaterial.clone();
                        // Add radial gradient shader snippet to the top border material shader
                        // const uniforms = {
                        //   color: {value: new THREE.Vector3(1, 1, 1)},
                        //   center: {value: new THREE.Vector3(0, 50, 0)},
                        //   attenuation: {value: 0.8},
                        //   strength: {value: 0.25},
                        //   startRadius: {value: 50.0}
                        // }
                        // mesh.material.onBeforeCompile = function (shader, renderer) {
                        //   scope.injectFakeAO(shader, renderer, uniforms);
                        // };
                        mesh.castShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // General mesh processing
                    /// ///////////////////////////////////////////
                    // Save the base color
                    mesh.userData.baseColor = mesh.material.color.clone();
                    mesh.userData.baseEmissive = mesh.material.emissive.clone();
                    // Save the color that the state should be when inactive (unhighlighted)
                    mesh.userData.inactiveColor = mesh.material.color.clone();
                    mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
                    // Enable shadows
                    mesh.receiveShadow = true;
                    // Set the type of the mesh
                    // The type of the mesh (state, county, zip, city) is determined by what file it comes from
                    // Since that information isn't automatically attached to the mesh, we need to add it here
                    mesh.userData.type = "state";
                });
                // Transform the scene as necessary
                gltf.scene.scale.multiplyScalar(48.2);
                // gltf.scene.rotation.x = -Math.PI * 0.003
                // gltf.scene.rotation.y = Math.PI * 0.006
                // gltf.scene.rotation.z = -Math.PI * 0.007
                // document.querySelector ('canvas').setAttribute ('usa',true);
                // loadingScreen ()
                // Resolve the promise
                resolve(gltf);
            }, // onProgress - no Promise equivalent
            function(xhr) {
                xhr.loaded, xhr.total;
            }, // onError
            function(error) {
                reject(error);
            }); // End loader.load()
        }); // End Promise()
    }
    addStates(stateGroup, city_list, onLoaded) {
        const temp = this;
        let nLoaded = 0;
        let stateData;
        let anchorData;
        function onStateOrAnchorsLoaded(data, which) {
            nLoaded++;
            console.log("state or anchors loaded: " + which + nLoaded);
            if (which == "state") stateData = data;
            else if (which == "anchors") anchorData = data;
            if (nLoaded == 2) {
                // console.log("both loaded");
                // Both are loaded here
                const length = anchorData.scene.children.length;
                let anchor_index = 0;
                for(let i = 0; i < length; i++){
                    const anchor = anchorData.scene.children[anchor_index];
                    const name = anchor.name.substring(0, anchor.name.length - 7);
                    // Find the corresponding county object
                    const nStates = stateData.children.length;
                    let matchedState = null;
                    for(var j = 0; j < nStates; j++){
                        const state = stateData.children[j];
                        if (state.name == name) {
                            matchedState = state;
                            break;
                        }
                    }
                    // Error check
                    if (!matchedState) {
                        console.log("WARNING: no county match found for " + anchor.name + " (searching " + name + ")");
                        anchor_index++;
                        continue;
                    }
                    // Find the face of the state
                    let face = null;
                    for(var j = 0; j < matchedState.children.length; j++){
                        const mesh = matchedState.children[j];
                        if (mesh.material.name.includes("Material")) {
                            face = mesh;
                            break;
                        }
                    }
                    // Error check
                    if (!face) {
                        console.log("WARNING: Attaching state anchors: Could not find face of state group", matchedState);
                        return;
                    }
                    const anchorOffsetMagnitude = 0.002;
                    // Add a small offset
                    const anchorOffset = new $8725869b83961a04$export$64b5c384219d3699();
                    anchorOffset.copy(anchor.position);
                    // This is black magic. I have no idea why this works.
                    // Maybe I haven't been getting enough sleep lately.
                    matchedState.parent.updateWorldMatrix(true);
                    matchedState.parent.localToWorld(anchor.position);
                    anchor.position.sub(new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0));
                    face.attach(anchor);
                    let stateReadableName = matchedState.name;
                    // Replace underscores with spaces
                    stateReadableName = stateReadableName.replace(/_/g, " ");
                    temp.addLabel(face, stateReadableName);
                }
                if (onLoaded) onLoaded(stateData);
            }
        }
        // Load label anchors
        this.loader.load("/assets/glb/state_anchors.glb", function(gltf) {
            temp.scene.add(gltf.scene);
            onStateOrAnchorsLoaded(gltf, "anchors");
        }, // onProgress
        null, // onError
        function(error) {
            console.log("error loading anchors:", error);
        });
        this.loader.load("/assets/glb/USAMorg6_draco3.glb", function(gltf) {
            const length = gltf.scene.children.length;
            for(let i = 0; i < length; i++){
                const name = gltf.scene.children[0].name;
                // Skip puerto rico for now? 
                if (name.includes("Puerto_Rico")) {
                    gltf.scene.remove(gltf.scene.children[0]);
                    continue;
                }
                const j_len = gltf.scene.children[0].children.length;
                for(let j = 0; j < j_len; j++){
                    const mesh = gltf.scene.children[0].children[j];
                    if (!temp.isHawaiiOrAlaska(mesh)) {
                        mesh.scale.x = 0.98;
                        mesh.scale.y = 0.98;
                        mesh.scale.z = 0.98;
                    }
                    // clone all materials
                    // when we remove a state this will allow all other materials that would be otherwise linked to remain
                    // helps in highlighting as well
                    mesh.material = mesh.material.clone();
                    // Enable shadows
                    if (mesh.isMesh) {
                        mesh.castShadow = true;
                        mesh.receiveShadow = true;
                        mesh.userData.type = "state";
                    }
                    // Set state face color
                    if (mesh.material.name.includes("Material")) {
                        const grey = $65867f75b82a314a$var$randGrayNum();
                        mesh.material.color.set(grey);
                    }
                    // Add the fake AO shader to add radial gradient to the borders
                    if (mesh.material.name.includes("SOLID")) mesh.material.onBeforeCompile = function(shader, renderer) {
                        temp.injectFakeAO(shader, renderer);
                    };
                }
                // Below can be found Tim's secret number
                // 627485
                const city = city_list[name];
                // console.log(city);
                const lat = $65867f75b82a314a$var$deg2rad(city.center_lat);
                const lon = $65867f75b82a314a$var$deg2rad(city.center_long);
                // console.log(lon,lat);
                const R = 50;
                const x = R * Math.cos(lat) * Math.cos(lon);
                const y = R * Math.cos(lat) * Math.sin(lon);
                const z = R * Math.sin(lat);
                gltf.scene.children[0].abbr = city.abbr;
                gltf.scene.children[0].statePosition = {
                    x: x,
                    y: z,
                    z: -y
                };
                gltf.scene.children[0].stateRotation = {
                    x: -lat,
                    y: lon + Math.PI / 2,
                    z: -lat / 8
                };
                stateGroup.add(gltf.scene.children[0]);
            }
            stateGroup.scale.x = 50;
            stateGroup.scale.y = 50;
            stateGroup.scale.z = 50;
            stateGroup.rotation.y = -Math.PI / 2;
            onStateOrAnchorsLoaded(stateGroup, "state");
            // stateGroup.add(temp.usa)
            // console.log(this.pointer);
            debugger;
        // document.querySelector('canvas').setAttribute('usa',true);
        // loadingScreen()
        }, function(xhr) {
            xhr.loaded, xhr.total;
        }, function(error) {
            console.error(error);
        });
    }
    makeGray(obj) {
        if (!obj.isMesh) return;
        if (obj.material.color) {
            if (!obj.material.color.set) {
                console.log("no set on", obj.material.name, obj.parent.name);
                return;
            }
            obj.material.color.set("#121212");
        }
    }
    // addGlobeMap(world){
    //   /** **GLTF Loader old way to import shapers***/
    //   const temp = this
    //   this.loader.load( '/assets/glb/GlobeEric4.glb', function ( gltf ) {
    //     const b = new THREE.Color(1,1,1);
    //     const black = b.getHex()
    //     let object = null; let mesh; let name;
    //     // console.log('dumping globe')
    //     for (let i = 0; i<gltf.scene.children.length; i++){
    //       // console.log(gltf.scene.children[i].name + " is name");
    //       if (!gltf.scene.children[i].isMesh) {
    //         object = gltf.scene.children[i];
    //         mesh = object.children[0];
    //         name = object.name;
    //         mesh.material.color.set("#111");
    //         // console.log(mesh.material);
    //         // mesh.material.emissive.set("#222");
    //       } else {
    //         mesh = gltf.scene.children[i];
    //         object = mesh;
    //         name = object.name;
    //         mesh.material.color.set("#111");
    //         // mesh.material.emissive.set("#222");
    //         // console.log(name);
    //         // console.log(mesh.material);
    //       }
    //       if (mesh.isMesh) {
    //         // Doesn't produce noticeable shadows
    //         mesh.castShadow = true;
    //         mesh.receiveShadow = true;
    //       }
    //       if (mesh.material){
    //         if (mesh.material.name == "Bords.002" || mesh.material.name == "Bords.001") {
    //           mesh.material.onBeforeCompile = function(shader, renderer) {
    //             temp.injectFakeAO(shader, renderer);
    //           }
    //         } else {
    //           // mesh.material.onBeforeCompile = function(shader, renderer) {
    //           //   var uniforms = {
    //           //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
    //           //     // +x is right
    //           //     // +y is up
    //           //     // +z is away (don't use)
    //           //     rimOffset: { value: new THREE.Vector3(-15.0, 30.0, 0.0) },
    //           //     strength: { value: 2.9 },
    //           //     width: { value:   0.35}
    //           //   };
    //           //   temp.injectRimLight(shader, renderer, uniforms);
    //           //   uniforms = {
    //           //     color: { value: new THREE.Vector3(0.85, 0.97, 1.0) },
    //           //     // +x is right
    //           //     // +y is up
    //           //     // +z is away (don't use)
    //           //     rimOffset: { value: new THREE.Vector3(0.0, -60.0, 0.0) },
    //           //     strength: { value: 1.5 },
    //           //     width: { value:   0.35}
    //           //   };
    //           //   temp.injectRimLight(shader, renderer, uniforms, '2');
    //           // }
    //         }
    //       }
    //     }
    //     temp.planet = gltf.scene
    //     temp.planet.name = 'Earth'
    //     // console.log(temp.planet);
    //     temp.planet.scale.x = 50
    //     temp.planet.scale.y = 50
    //     temp.planet.scale.z = 50
    //     temp.planet.rotation.y = -Math.PI/2
    //     world.add(temp.planet)
    //     // console.log(this.pointer);
    //     document.querySelector('canvas').setAttribute('globe',true);
    //     loadingScreen()
    //   }, // called while loading is progressing
    //   function ( xhr ) {
    //     // console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
    //     if ((xhr.loaded / xhr.total * 100 ) == 100){
    //     }
    //   }, function ( error ) {
    //     console.error( error );
    //   } );
    // }
    // TODO: Promisify this?
    addLights(scene, controls, performanceManager, { shadowMapSize: shadowMapSize }) {
        /** **GLTF Loader old way to import shapers***/ const temp = this;
        // const gray = new THREE.MeshBasicMaterial( { color: "#3c3c3c" } );
        this.loader.load("/assets/glb/LightsOnlySun.glb", function(gltf) {
            // The actual DirectionalLight is nested 8 objects deep here
            let sun = gltf.scene.children[0];
            while(sun.type != "DirectionalLight")sun = sun.children[0];
            performanceManager.setSun(sun);
            controls.setLight(gltf.scene, sun);
            // TODO: Tie this with zoom level so shadows stay crisp at smaller scales
            sun.castShadow = true;
            sun.shadow.camera.near = 230;
            sun.shadow.camera.far = 300;
            sun.shadow.camera.left = -50;
            sun.shadow.camera.bottom = -50;
            sun.shadow.camera.right = 50;
            sun.shadow.camera.top = 50;
            sun.intensity = 0.8;
            sun.shadow.bias = -0.0003;
            // sun.shadow.radius = 4;
            // sun.shadow.blurSamples = 128;
            sun.shadow.mapSize.copy(shadowMapSize);
            sun.target.position.copy(new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0));
            scene.add(sun.target);
            // var helper = new THREE.CameraHelper( sun.shadow.camera );
            // scene.add(helper);
            // sun.userData.helper = helper;
            const b = new $8725869b83961a04$export$892596cec99bc70e(1, 1, 1);
            const black = b.getHex();
            // console.log(gltf.scene);
            temp.planet = gltf.scene;
            temp.planet.name = "Earth";
            // console.log(temp.planet);
            temp.planet.scale.x = 100;
            temp.planet.scale.y = 100;
            temp.planet.scale.z = 100;
            sun.position.copy(new $8725869b83961a04$export$64b5c384219d3699(3, -5.5, -1));
            // temp.planet.rotation.x = Math.PI/2
            // temp.planet.rotation.y = -Math.PI/16
            // temp.planet.rotation.z = Math.PI/2
            scene.add(temp.planet);
        // console.log(this.pointer);
        }, undefined, function(error) {
            console.error(error);
        });
    }
}
function $65867f75b82a314a$var$randGrayNum() {
    // Math.seed
    const value = Math.random() * 0x32 + 0x32;
    // var value = Math.random() * 0x10 | 0x43;
    const grayscale = value << 16 | value << 8 | value;
    let color = "#" + grayscale.toString(16);
    if (color.length == 6) color = color + "0";
    // console.log(color);
    return color // new THREE.MeshLambertMaterial( { color: color } );
    ;
}
function $65867f75b82a314a$var$randGrayScale() {
    // Math.seed
    const value = Math.random() * 0x66 + 68;
    // var value = Math.random() * 0x10 | 0x43;
    const grayscale = value << 16 | value << 8 | value;
    let color = "#" + grayscale.toString(16);
    if (color.length == 6) color = color + "0";
    return color // new THREE.MeshLambertMaterial( { color: color } );
    ;
}
function $65867f75b82a314a$var$deg2rad(degrees) {
    const pi = Math.PI;
    return degrees * (pi / 180);
}









var $7ArpZ = parcelRequire("7ArpZ");


const $022332a56efc487a$export$2a3dc93c5bb503de = function() {
    const fakeAOFrag = `

vec3 worldPosition = ( modelMatrix * vec4( vPosition, 1.0 )).xyz - center;
float fragRadius = length(worldPosition);
float shadowStrength = max(0.0, 1.0 - (strength * (1.0 / (attenuation * (fragRadius - startRadius) + 1.0))));
gl_FragColor.rgb = gl_FragColor.rgb * shadowStrength;`;
    const vPositionDef = "\nvarying vec3 vPosition;\n";
    const vPositionSet = "\nvPosition = position;\n";
    const uMatMatrix = "\nuniform mat4 modelMatrix;\n";
    const uniforms = {
        color: {
            value: new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
        },
        center: {
            value: new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0)
        },
        attenuation: {
            value: 0.5
        },
        strength: {
            value: 0.9
        },
        startRadius: {
            value: 49.5
        }
    };
    let declarations = "";
    const uniformPostfix = "";
    let type = "";
    // let assignment = ""
    return function injectFakeAO(shader, renderer) {
        declarations = "";
        for(const key in uniforms){
            const newKey = key + uniformPostfix;
            if (newKey in shader.uniforms) {
                console.log("WARNING: Key " + key + " already in rim light shader uniforms: ", shader.uniforms);
                continue;
            }
            type = "";
            // assignment = ""
            if (uniforms[key].value.isVector3) type = "vec3";
            else if (typeof uniforms[key].value === "number") type = "float";
            else {
                console.log("ERROR: injectFakeAO: Unknown type passed in uniforms as " + key + ":", uniforms[key], uniforms[key].value.isVector3, typeof uniforms[key].value);
                return;
            }
            declarations += "uniform " + type + " " + newKey + ";";
            shader.uniforms[newKey] = uniforms[key];
        }
        shader.vertexShader = shader.vertexShader.replace("void main() {", vPositionDef + "void main() {" + vPositionSet);
        // Modify frag shader
        shader.fragmentShader = shader.fragmentShader.replace("void main() {", declarations + uMatMatrix + vPositionDef + "void main() {");
        shader.fragmentShader = shader.fragmentShader.replace("#include <dithering_fragment>", "#include <dithering_fragment>" + fakeAOFrag);
    };
}();
const $022332a56efc487a$export$bb29e0e4b2cd6b86 = function() {
    const fakeAOFrag = `

float factor = vUv.x * vUv.x;
gl_FragColor.rgb = gl_FragColor.rgb * ((factor / 4.0) + 0.75);`;
    const uniforms = {
        color: {
            value: new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
        },
        center: {
            value: new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0)
        },
        // +x is right
        // +y is up
        // +z is away (don't use)
        attenuation: {
            value: 2
        },
        strength: {
            value: 0.25
        },
        startRadius: {
            value: 52
        }
    };
    const vUvDef = "\nvarying vec2 vUv;\n";
    const vUvSet = "\nvUv = uv;\n";
    const constantDeclarations = "\nvarying vec2 vUv;\n";
    const uniformPostfix = "";
    let declarations = "";
    let type = "";
    // let assignment = ""
    return function injectFakeAO(shader, renderer) {
        declarations = "";
        for(const key in uniforms){
            const newKey = key + uniformPostfix;
            if (newKey in shader.uniforms) {
                console.log("WARNING: Key " + key + " already in rim light shader uniforms: ", shader.uniforms);
                continue;
            }
            type = "";
            // assignment = ""
            if (uniforms[key].value.isVector3) type = "vec3";
            else if (typeof uniforms[key].value === "number") type = "float";
            else {
                console.log("ERROR: injectFakeAO: Unknown type passed in uniforms as " + key + ":", uniforms[key], uniforms[key].value.isVector3, typeof uniforms[key].value);
                return;
            }
            declarations += "uniform " + type + " " + newKey + ";";
            shader.uniforms[newKey] = uniforms[key];
        }
        shader.vertexShader = shader.vertexShader.replace("void main() {", vUvDef + "void main() {" + vUvSet);
        // Modify frag shader
        shader.fragmentShader = shader.fragmentShader.replace("void main() {", declarations + constantDeclarations + "void main() {");
        shader.fragmentShader = shader.fragmentShader.replace("#include <dithering_fragment>", "#include <dithering_fragment>" + fakeAOFrag);
    // console.log(shader.fragmentShader);
    };
}();


/**
 * @typedef {{signal?: AbortSignal}} AddCountiesOptions
 * @typedef {{signal?: AbortSignal}} AddIndividualCountyOption
 * @typedef {import("three/examples/jsm/loaders/GLTFLoader.js").GLTF} GLTF
 */ // Adds a label at the anchor point of mesh
function $da4e7fd06f292871$var$addLabel(mesh, text) {
    // Find the anchor
    const anchor = mesh.children.find($da4e7fd06f292871$var$isAnchor);
    // Error check
    if (!anchor) {
        console.warn("Tried to add label to " + mesh.name + " but no anchor found.");
        return;
    }
    // Create the label
    const div = document.createElement("div");
    div.className = "label";
    div.textContent = text;
    const label = new (0, $5859463f2a625df8$export$936f75e6792bf2dc)(div);
    label.userData.labelType = "name";
    label.visible = true;
    // Add the label as a child of anchor
    anchor.add(label);
}
function $da4e7fd06f292871$var$isBottomBorder(obj) {
    return obj.name.endsWith("_BottomBorder");
}
function $da4e7fd06f292871$var$isTopBorder(obj) {
    return obj.name.endsWith("_TopBorder");
}
function $da4e7fd06f292871$var$isAnchor(obj) {
    return obj.name.split("_").at(-1).startsWith("Anchor") && obj.children.length === 0;
}
function $da4e7fd06f292871$var$isTopLevel(obj, topLevelObj) {
    return obj.parent === topLevelObj;
}
function $da4e7fd06f292871$var$isFace(obj, topLevel) {
    return $da4e7fd06f292871$var$isTopLevel(obj, topLevel) && !$da4e7fd06f292871$var$isTopBorder(obj);
}
function $da4e7fd06f292871$var$processCountyFace(mesh) {
    // mesh.region = new Region(mesh)
    // mesh.children.forEach((obj) => (obj.region = mesh.region))
    // Query county info
    const fips = mesh.name;
    mesh.receiveShadow = true;
    // Find name using anchor
    const name = mesh.children.find($da4e7fd06f292871$var$isAnchor).name;
    const readableName = name.substring(0, name.length - 7).replace(/_/g, " ");
    $da4e7fd06f292871$var$addLabel(mesh, readableName);
    // Save county info
    mesh.userData.name = readableName;
    mesh.userData.fips = fips;
    // Save the scale that the states will lower to while they're interactive
    mesh.userData.loweredScale = mesh.scale.clone();
    // Save the scale that the states will transition to when clicked
    mesh.userData.clickedScale = mesh.scale.clone().multiplyScalar(1.01);
    // Save the initial scale
    mesh.userData.initialScale = mesh.scale.clone();
    // Save the scale that states will be when lowered
    mesh.userData.hiddenScale = mesh.scale.clone();
    // Save the randomized scale that the states will raise to when first presented afte zooming in
    const scale = 1.045 + Math.random() * 0.025;
    mesh.userData.randomScale = mesh.scale.clone().multiplyScalar(scale);
    mesh.userData.mapLevel = 0;
    mesh.tweens = new (0, $7ArpZ.Group)();
}
function $da4e7fd06f292871$var$processCountyObject(obj, gltf, topBorderMaterial, bottomBorderMaterial) {
    if (!obj.isMesh) return;
    const mesh = obj;
    /// //////////////////////////////////////////
    // Top-level mesh processing (face meshes)
    /// //////////////////////////////////////////
    if ($da4e7fd06f292871$var$isFace(mesh, gltf.scene)) {
        $da4e7fd06f292871$var$processCountyFace(mesh);
        /// ///////////////////////////////////////////
        // BottomBorder mesh processing
        /// ///////////////////////////////////////////
        mesh.children.filter($da4e7fd06f292871$var$isBottomBorder).forEach((bottomBorder)=>{
            bottomBorder.material = bottomBorderMaterial.clone();
            // Add radial gradient shader snippet to the bottom border material shader
            bottomBorder.material.onBeforeCompile = function(shader, renderer) {
                (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer);
            };
            bottomBorder.visible = false;
            bottomBorder.castShadow = true;
            bottomBorder.receiveShadow = true;
        });
        /// ///////////////////////////////////////////
        // TopBorder mesh processing
        /// ///////////////////////////////////////////
        mesh.children.filter($da4e7fd06f292871$var$isTopBorder).forEach((topBorder)=>{
            topBorder.material = topBorderMaterial.clone();
            // Add radial gradient shader snippet to the top border material shader
            const uniforms = {
                color: {
                    value: new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
                },
                center: {
                    value: new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0)
                },
                attenuation: {
                    value: 0.8
                },
                strength: {
                    value: 0.25
                },
                startRadius: {
                    value: 50.0
                }
            };
            topBorder.material.onBeforeCompile = function(shader, renderer) {
                (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer, uniforms);
            };
            topBorder.material.transparent = true;
            // topBorder.material.opacity = 0.5
            topBorder.material.blending = $8725869b83961a04$export$eda4864c68df1fa2;
            topBorder.material.blendEquation = $8725869b83961a04$export$99948c02fb51055f;
            topBorder.castShadow = true;
        });
    }
    /// ///////////////////////////////////////////
    // General mesh processing
    /// ///////////////////////////////////////////
    // Save the base color
    mesh.userData.baseColor = mesh.material.color.clone();
    if (mesh.material.emissive !== undefined) mesh.userData.baseEmissive = mesh.material.emissive.clone();
    // Save the color that the state should be when inactive (unhighlighted)
    mesh.userData.inactiveColor = mesh.material.color.clone();
    if (mesh.material.emissive !== undefined) mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
    // Set the type of the mesh
    // The type of the mesh (state, county, zip, city) is determined by what file it comes from
    // Since that information isn't automatically attached to the mesh, we need to add it here
    mesh.userData.type = "county";
}
function $da4e7fd06f292871$var$disposeOfTopBorder(topBorder) {
    topBorder.geometry.dispose();
    topBorder.material.dispose();
    topBorder.parent.remove(topBorder);
}
/**
 * Recursively call .dispose() on every object that has a dispose method.
 * Leaves will be disposed first, then proceed up the tree.
 * note: if there is a loop in obj's property tree, this will hang forever
 * @param {GLTF | THREE.Object3D | {dispose?: () => void, forEach?: (fn: (ele: any) => void) => void} obj 
 * @param {Set} [objects]
 * @returns {void}
 */ function $da4e7fd06f292871$var$dispose(obj, objects) {
    // Create a new array to hold all the objects we're touching
    if (objects === undefined) objects = new Set();
    // Short circuit if we've already disposed this object (loop breaker)
    if (objects.has(obj)) return;
    // Keep track that we've already disposed this object
    objects.add(obj);
    // Short circuit if we're not on an object
    if (typeof obj !== "object" || obj === null) return;
    if ("scene" in obj) // obj is a gltf
    // Dispose every scene
    obj.scenes.forEach((scene)=>$da4e7fd06f292871$var$dispose(scene, objects));
    else if ("children" in obj && "forEach" in obj.children) // obj is a THREE.Object3D
    // Dispose all children
    obj.children.forEach((child)=>$da4e7fd06f292871$var$dispose(child, objects));
    // If object can be forEach'd, dispose all of them
    if ("forEach" in obj) obj.forEach((ele)=>{
        $da4e7fd06f292871$var$dispose(ele, objects);
    });
    // Dispose every single property of obj
    Object.keys(obj).forEach((key)=>{
        $da4e7fd06f292871$var$dispose(obj[key], objects);
    });
    // Finally, call .dispose() on obj
    if ("dispose" in obj) {
        console.log({
            obj: obj
        }, "disposing");
        obj.dispose();
    }
}
/**
 * @typedef {{signal?: AbortSignal}} LoadMapTextureOptions
 */ /**
 * 
 * @param {*} url 
 * @param {*} loader 
 * @param {LoadMapTextureOptions} options 
 * @returns 
 */ async function $da4e7fd06f292871$var$loadMapTexture(url, loader, options) {
    return new Promise((resolve, reject)=>{
        loader.load(url, // success
        (texture)=>{
            if (options?.signal?.aborted) {
                $da4e7fd06f292871$var$dispose(texture);
                reject(options.signal.reason);
            }
            texture.flipY = false;
            texture.encoding = $8725869b83961a04$export$f32388edbb32674;
            resolve(texture);
        }, // progress
        null, // failure
        reject) // End load
        ;
    }) // End new Promise()
    ;
}
/**
 * @typedef {{signal?: AbortSignal}} SetFaceMaterialTexturesOnLoadOptions
 */ /**
 * 
 * @param {Promise<THREE.Texture>} texturePromise 
 * @param {Promise<GLTF>} glbPromise 
 * @param {SetFaceMaterialTexturesOnLoadOptions} options 
 * @returns {Promise<void> | Promise<[THREE.MeshStandardMaterial, GLTF]>}
 */ async function $da4e7fd06f292871$var$setFaceMaterialTexturesOnLoad(texturePromise, glbPromise, options) {
    return Promise.all([
        texturePromise,
        glbPromise
    ]).then(([texture, gltf])=>{
        if (options?.signal?.aborted) {
            console.warn("Aborted");
            throw new Error("Aborted");
        }
        // When both the texture and the model are loaded, connect them
        const material = new $8725869b83961a04$export$f2980790215acccd({
            map: texture,
            color: "#FFFFFF",
            emissive: "#000000"
        });
        gltf.scene.traverse((obj)=>{
            if (!obj.isMesh) return;
            const mesh = obj;
            if (mesh.parent === gltf.scene && mesh.children.length) mesh.material = material;
        }) // End traverse
        ;
        return [
            material,
            gltf
        ];
    });
}
class $da4e7fd06f292871$export$314320385c98bcc1 {
    constructor(globe, textureInitializer){
        this.scene = globe;
        this.textureInitializer = textureInitializer;
        this.textureLoader = new $8725869b83961a04$export$fd1bfc71f64c538c();
        this.loader = new (0, $f00a0cf390d4f349$export$aa93f11e7884f0f4)();
        this.loader.setMeshoptDecoder((0, $b9b5bad09e314aa5$export$1111800106ba519a));
        const dracoLoader = new (0, $88f4ea66493b0ee5$export$45c25de53be259ac)();
        dracoLoader.setDecoderPath("/vendor/draco/");
        this.loader.setDRACOLoader(dracoLoader);
        this.shaderLoader = new $8725869b83961a04$export$98435a25b5cf7b2b();
        $8725869b83961a04$export$94affb487e701bf2.enabled = true;
    }
    /**
     *
     * @param {Number} fips - Fips/GEOID code of the county
     * @param {AddIndividualCountyOption} [options]
     * @returns {Promise<THREE.Mesh>} - face mesh of the region
     */ async addIndividualCounty(fips, { signal: signal } = {}) {
        // Initialize the materials we'll need
        const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
            side: $8725869b83961a04$export$3b296b6f144d5b03,
            color: "#A0BDDA"
        });
        bottomBorderMaterial.onBeforeCompile = function(shader, renderer) {
            (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer);
        };
        const topBorderMaterial = new $8725869b83961a04$export$f2980790215acccd();
        // Add radial gradient shader snippet to the top border material shader
        const uniforms = {
            color: {
                value: new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
            },
            center: {
                value: new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0)
            },
            attenuation: {
                value: 0.8
            },
            strength: {
                value: 0.25
            },
            startRadius: {
                value: 50.0
            }
        };
        topBorderMaterial.onBeforeCompile = function(shader, renderer) {
            (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer, uniforms);
        };
        topBorderMaterial.transparent = true;
        topBorderMaterial.blending = $8725869b83961a04$export$eda4864c68df1fa2;
        topBorderMaterial.blendEquation = $8725869b83961a04$export$99948c02fb51055f;
        // Load geometry
        const gltf = await new Promise((resolve, reject)=>{
            this.loader.load("/assets/glb/globe/counties-individual/" + fips + ".glb", resolve, null, reject);
        });
        if (signal?.aborted === true) {
            console.warn(signal.reason);
            $da4e7fd06f292871$var$dispose(gltf);
            throw signal.reason;
        }
        const region = new (0, $7392ee50b9a2c168$export$b1f97c3099fc6872)(gltf.scene);
        // TODO: When Region refactor is done, these back-references can be removed
        region.face.region = region;
        region.face.userData.type = "individualCounty";
        region.bottomBorder.material = bottomBorderMaterial;
        region.topBorder.material = topBorderMaterial;
        // Scale up the whole region to raise it
        region.face.scale.multiplyScalar(52.2);
        region.bottomBorder.castShadow = true;
        region.bottomBorder.receiveShadow = true;
        // TODO: Region refactor, return region instead of region.face
        return region.face;
    }
    /**
     * @example
     * abort = new AbortController()
     * addCounties('MO', {signal: abort.signal})
     * @param {string} state state abbreviation
     * @param {AddCountiesOptions} [options]
     * @returns {Promise<GLTF>}
     */ addCounties(state, options) {
        const scope = this;
        const fips = (0, $12d34f3c78180d6b$export$37abc93a7593198c)[state].fips;
        const countiesGLBPromise = new Promise((resolve, reject)=>{
            this.loader.load("/assets/glb/globe/counties/" + fips + ".glb", // onLoad
            function(gltf) {
                if (options?.signal?.aborted) {
                    console.warn(options.signal.reason);
                    $da4e7fd06f292871$var$dispose(gltf);
                    throw options.signal.reason;
                }
                gltf.scene.userData.mapLevel = 0;
                // Initialize the materials we'll need
                const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
                    side: $8725869b83961a04$export$3b296b6f144d5b03,
                    color: "#A0BDDA"
                });
                const topBorderMaterial = new $8725869b83961a04$export$55cbcc9b622fe1f5();
                gltf.scene.traverse((obj)=>$da4e7fd06f292871$var$processCountyObject(obj, gltf, topBorderMaterial, bottomBorderMaterial));
                // Remove conjoined top border
                $da4e7fd06f292871$var$disposeOfTopBorder(gltf.scene.children.find($da4e7fd06f292871$var$isTopBorder));
                gltf.scene.scale.multiplyScalar(48.2);
                resolve(gltf);
            }, // onProgress - no Promise equivalent
            null, // onError
            function(error) {
                reject(error);
            }) // End loader.load()
            ;
        }) // End new Promise()
        ;
        const mergedBorderGLBPromise = new Promise((resolve, reject)=>{
            this.loader.load("/assets/glb/globe/counties-group-border/" + fips + ".glb", // onLoad
            function(gltf) {
                if (options?.signal?.aborted) {
                    console.warn(options.signal.reason);
                    $da4e7fd06f292871$var$dispose(gltf);
                    throw options.signal.reason;
                }
                // Initialize the materials we'll need
                const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
                    side: $8725869b83961a04$export$3b296b6f144d5b03,
                    color: "#A0BDDA"
                });
                bottomBorderMaterial.onBeforeCompile = function(shader, renderer) {
                    (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer);
                };
                gltf.scene.traverse((obj)=>{
                    if (!obj.isMesh) return;
                    obj.material = bottomBorderMaterial;
                    obj.castShadow = true;
                });
                // gltf.scene.scale.multiplyScalar(48.2)
                resolve(gltf);
            }, // onProgress - no Promise equivalent
            null, // onError
            function(error) {
                reject(error);
            }) // End loader.load()
            ;
        }) // End new Promise()
        ;
        // Start loading map texture
        const url = "/assets/glb/image/county-groups/1024/" + fips + ".webp";
        const texturePromise = $da4e7fd06f292871$var$loadMapTexture(url, scope.textureLoader, {
            signal: options.signal
        });
        // Put merged border as child of counties group
        Promise.all([
            countiesGLBPromise,
            mergedBorderGLBPromise
        ]).then(([counties, mergedBorder])=>{
            counties.scene.add(mergedBorder.scene);
        });
        // TODO: Add signal
        return $da4e7fd06f292871$var$setFaceMaterialTexturesOnLoad(texturePromise, countiesGLBPromise).then(([material, gltf])=>{
            if (options?.signal?.aborted) {
                console.warn("Aborted");
                throw new Error("Aborted");
            }
            // Make mesh faces transparent
            // const mat = new THREE.MeshStandardMaterial({
            //     transparent: true,
            //     opacity: 0,
            //     blending: THREE.CustomBlending,
            //     blendEquation: THREE.AddEquation,
            //     blendSrc: THREE.OneFactor,
            //     blendDst: THREE.ZeroFactor,
            // })
            gltf.scene.userData.materials = {};
            gltf.scene.userData.materials.active = [];
            gltf.scene.userData.materials.inactive = [];
            gltf.scene.userData.materials.holePunch = [];
            // Hole punch material
            // const holePunch = material.clone()
            // holePunch.transparent = false
            // holePunch.opacity = 0
            // holePunch.blending = THREE.CustomBlending
            // holePunch.blendEquation = THREE.AddEquation
            // holePunch.blendSrc = THREE.OneFactor
            // holePunch.blendDst = THREE.ZeroFactor
            const holePunch = new $8725869b83961a04$export$5023a9a8114806b8({
                transparent: false,
                opacity: 0,
                blending: $8725869b83961a04$export$eda4864c68df1fa2,
                blendEquation: $8725869b83961a04$export$20183a0484ce21a0,
                blendSrc: $8725869b83961a04$export$8805bad65e24940e,
                blendDst: $8725869b83961a04$export$2110f05edf778d3d,
                color: "#000",
                emissive: "#000"
            });
            // Materials for mapLevel=0
            gltf.scene.userData.materials.active.push(material);
            gltf.scene.userData.materials.inactive.push(material.clone());
            gltf.scene.userData.materials.holePunch.push(holePunch);
            // Materials for mapLevel=1
            gltf.scene.userData.materials.active.push(material.clone());
            gltf.scene.userData.materials.inactive.push(material.clone());
            gltf.scene.userData.materials.holePunch.push(holePunch.clone());
            gltf.scene.children.forEach((child)=>{
                if (!$da4e7fd06f292871$var$isFace(child, gltf.scene)) return;
                child.region = new (0, $7392ee50b9a2c168$export$7e0fd72fe0a85f54)(child, {
                    active: gltf.scene.userData.materials.active,
                    inactive: gltf.scene.userData.materials.inactive,
                    holePunch: gltf.scene.userData.materials.holePunch
                });
            });
            // Start loading higher resolution map texture
            this.textureLoader.load("/assets/glb/image/county-groups/4096/" + fips + ".webp", // success
            (texture)=>{
                if (options?.signal?.aborted) {
                    console.warn("Aborted");
                    $da4e7fd06f292871$var$dispose(texture);
                    return;
                }
                texture.flipY = false;
                texture.encoding = $8725869b83961a04$export$f32388edbb32674;
                gltf.scene.userData.materials.active[1].map = texture;
                gltf.scene.userData.materials.inactive[1].map = texture;
                // gltf.scene.userData.materials.holePunch[1].map = texture
                scope.textureInitializer.init(texture);
            }, null, (err)=>{
                console.error(err);
            });
            return gltf;
        }) // End Promise.all
        ;
    }
    async addZip(fips) {
        const glbPromise = new Promise((resolve, reject)=>{
            this.loader.load("/assets/glb/globe/zips/" + fips + ".glb", // onLoad
            function(gltf) {
                // Initialize the materials we'll need
                const bottomBorderMaterial = new $8725869b83961a04$export$5023a9a8114806b8({
                    side: $8725869b83961a04$export$3b296b6f144d5b03,
                    color: "#A0BDDA"
                });
                // Add radial gradient shader snippet to the bottom border material shader
                bottomBorderMaterial.onBeforeCompile = function(shader, renderer) {
                    (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer);
                };
                const topBorderMaterial = new $8725869b83961a04$export$f2980790215acccd();
                // Add radial gradient shader snippet to the top border material shader
                const uniforms = {
                    color: {
                        value: new $8725869b83961a04$export$64b5c384219d3699(1, 1, 1)
                    },
                    center: {
                        value: new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0)
                    },
                    attenuation: {
                        value: 0.8
                    },
                    strength: {
                        value: 0.25
                    },
                    startRadius: {
                        value: 50.0
                    }
                };
                topBorderMaterial.onBeforeCompile = function(shader, renderer) {
                    (0, $022332a56efc487a$export$2a3dc93c5bb503de)(shader, renderer, uniforms);
                };
                topBorderMaterial.transparent = true;
                topBorderMaterial.blending = $8725869b83961a04$export$eda4864c68df1fa2;
                topBorderMaterial.blendEquation = $8725869b83961a04$export$99948c02fb51055f;
                // Remove non-conjoined top borders
                const topBorders = gltf.scene.children.map((topLevel)=>topLevel.children).flat(1).filter($da4e7fd06f292871$var$isTopBorder);
                topBorders.forEach((topBorder)=>{
                    $da4e7fd06f292871$var$disposeOfTopBorder(topBorder);
                });
                gltf.scene.traverse((obj)=>{
                    if (!obj.isMesh) return;
                    const mesh = obj;
                    /// //////////////////////////////////////////
                    // Top-level mesh processing (face meshes)
                    /// //////////////////////////////////////////
                    if (mesh.parent === gltf.scene) {
                        // Region is part of the upcoming refactor
                        mesh.region = new (0, $7392ee50b9a2c168$export$b1f97c3099fc6872)(mesh);
                        mesh.children.forEach((obj)=>obj.region = mesh.region);
                        const readableName = mesh.name.replace(/_/g, " ");
                        $da4e7fd06f292871$var$addLabel(mesh, readableName);
                        // Save the scale that the states will lower to while they're interactive
                        mesh.userData.loweredScale = mesh.scale.clone();
                        // Save the scale that the states will transition to when clicked
                        mesh.userData.clickedScale = mesh.scale.clone();
                        // Save the initial scale
                        mesh.userData.initialScale = mesh.scale.clone();
                        // Save the scale that states will be when lowered
                        mesh.userData.hiddenScale = mesh.scale.clone();
                        // Save the randomized scale that the states will raise to when first presented afte zooming in
                        const scale = 1.015 + Math.random() * 0.025;
                        mesh.userData.randomScale = mesh.scale.clone().multiplyScalar(scale);
                        mesh.tweens = new (0, $7ArpZ.Group)();
                    }
                    /// ///////////////////////////////////////////
                    // BottomBorder mesh processing
                    /// ///////////////////////////////////////////
                    if ($da4e7fd06f292871$var$isBottomBorder(mesh)) {
                        mesh.material = bottomBorderMaterial;
                        mesh.castShadow = true;
                        mesh.receiveShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // TopBorder mesh processing
                    /// ///////////////////////////////////////////
                    if ($da4e7fd06f292871$var$isTopBorder(mesh)) {
                        mesh.material = topBorderMaterial;
                        mesh.castShadow = true;
                    }
                    /// ///////////////////////////////////////////
                    // General mesh processing
                    /// ///////////////////////////////////////////
                    // Save the base color
                    mesh.userData.baseColor = mesh.material.color.clone();
                    mesh.userData.baseEmissive = mesh.material.emissive.clone();
                    // Save the color that the state should be when inactive (unhighlighted)
                    mesh.userData.inactiveColor = mesh.material.color.clone();
                    mesh.userData.inactiveEmissive = mesh.material.emissive.clone();
                    // Set the type of the mesh
                    // The type of the mesh (state, county, zip, city) is determined by what file it comes from
                    // Since that information isn't automatically attached to the mesh, we need to add it here
                    mesh.userData.type = "zip";
                });
                gltf.scene.scale.multiplyScalar(52.2);
                // gltf.scene.rotation.x = -Math.PI * 0.003
                // gltf.scene.rotation.y = Math.PI * 0.006
                // gltf.scene.rotation.z = -Math.PI * 0.007
                resolve(gltf);
            }, // onProgress
            null, // onError
            function(error) {
                reject(error);
            });
        }) // end new Promise()
        ;
        const url = "/assets/glb/image/zip-groups/" + fips + ".webp";
        const texturePromise = $da4e7fd06f292871$var$loadMapTexture(url, this.textureLoader);
        return $da4e7fd06f292871$var$setFaceMaterialTexturesOnLoad(texturePromise, glbPromise).then(([material, gltf])=>{
            return gltf;
        });
    }
}


// Modified version of three.js OrbitControls
/// ////////////////////////////////////////
// Companion documentation can be found in
// /doc/orbitControls.md
/// ////////////////////////////////////////

/**
 * @file Resources for synchronizing a THREE.js camera with a maplibre/mabpox camera
 * @author Morgan Chesser for Round Three LLC
 * @license UNLICENSED
 * @typedef {import("maplibre-gl").Map} GLMap
 */ 

const $284c58eef2a1e870$var$MathHelpers = {};
// Constants
$284c58eef2a1e870$var$MathHelpers.DEG2RAD = Math.PI / 180;
$284c58eef2a1e870$var$MathHelpers.RAD2DEG = 180 / Math.PI;
// Calculates a vertical FOV from a fixed horizontal FOV and aspect ratio.
// By default, THREE.PerspectiveCamera works by specifying a fixed vertical FOV and aspect ratio.
// Once we get to a slim enough aspect ratio, we want to specify a fixed horizontal FOV instead.
$284c58eef2a1e870$var$MathHelpers.horizontalToVerticalFOV = function horizontalToVerticalFOV(horizontalFOV, aspectRatio) {
    return Math.atan(Math.tan(horizontalFOV * $284c58eef2a1e870$var$MathHelpers.DEG2RAD / 2) / aspectRatio) * $284c58eef2a1e870$var$MathHelpers.RAD2DEG * 2;
};
var $284c58eef2a1e870$export$2e2bcd8739ae039 = $284c58eef2a1e870$var$MathHelpers;



var $7ArpZ = parcelRequire("7ArpZ");
class $b2dc26e6bbd9abd7$export$2e2bcd8739ae039 {
    /**
     *
     * @param {GlobeControls} threeControls
     * @param {GLMap} map
     */ constructor(threeControls, map){
        /**
         * three.js camera controller
         * @type {GlobeControls}
         */ this.threeControls = threeControls;
        /**
         * Maplibregl map
         * @type {GLMap}
         */ this.map = map;
        this.focusRadiusOverride = -1;
        this.tweens = new (0, $7ArpZ.Group)();
        /**
         * @type {"globe" | "map"}
         */ this.master = "globe";
    }
    handleResize(event) {
    // this.verticalResolution =
    }
    handleMeshRaise(mesh) {
        // if(mesh.userData.type !== "county") {
        //     return
        // }
        this.tweens.removeAll();
        const geometry = mesh.geometry;
        if (!geometry) return;
        // Calculate distance from a single vertex
        const positionAttribute = geometry.getAttribute("position");
        const vertex = new $8725869b83961a04$export$64b5c384219d3699();
        vertex.fromBufferAttribute(positionAttribute, 0);
        mesh.localToWorld(vertex);
        vertex.sub(new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0));
        const startDist = vertex.length();
        const finalDist = startDist * (mesh.userData.clickedScale.x / mesh.scale.x);
        const threshold = 0.001;
        if (Math.abs(this.threeControls.focusRadius - finalDist) < threshold) return;
        new (0, $7ArpZ.Tween)(this.threeControls, this.tweens).to({
            focusRadius: finalDist
        }, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).start();
    }
    updateTweens() {
        this.tweens.update();
    }
    update() {
        if (this.master === "globe") this.syncMap();
        else this.syncGlobe();
    }
    /**
     * Set map params using the globe as master
     */ syncMap() {
        const trackData = this.threeControls.getTrackData();
        // Synchronize pitch
        const pitch = trackData.angle * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG;
        const extraThetaOffset = this.threeControls.getExtraThetaOffset();
        // Synchronize latitude and longitude
        const lat = $b2dc26e6bbd9abd7$export$154a0da1a2902c7(this.threeControls.getPolarAngle(), extraThetaOffset);
        const lng = $b2dc26e6bbd9abd7$export$1957a5a293f382a4(this.threeControls.getAzimuthalAngle());
        // TODO: Make a list object and mutate it instead of constructing a new list every frame
        const center = [
            lng,
            lat
        ];
        const distanceFromMap = trackData.distance - this.threeControls.focusRadius;
        // We can get vertical FOV (the total frustum angle subtended by the vertical length of our screen) from the camera parameters
        const cameraFOV = this.threeControls.camera.fov;
        // Convert globe "distance" to map "zoom level"
        const zoom = $b2dc26e6bbd9abd7$var$globeDistanceToMapZoom(cameraFOV, distanceFromMap, lat * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).DEG2RAD);
        // Synchronize zoom
        this.map.jumpTo({
            pitch: pitch,
            center: center,
            zoom: zoom
        }, {
            cause: "CameraSynchronizer"
        });
    }
    /**
     * Set globe params using map as master
     */ syncGlobe() {
        const focusRadius = this.threeControls.focusRadius;
        const extraThetaOffset = this.threeControls.getExtraThetaOffset();
        const cameraFOV = this.threeControls.camera.fov;
        const { lng: lng, lat: lat } = this.map.getCenter();
        const zoom = this.map.getZoom();
        const distanceFromMap = $b2dc26e6bbd9abd7$var$mapZoomToGlobeDistance(cameraFOV, zoom, lat * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).DEG2RAD);
        const trackDistance = distanceFromMap + focusRadius;
        let trackPos = this.threeControls.invertCameraTrack(trackDistance, this.threeControls.minDistance);
        if (isNaN(trackPos)) trackPos = 1;
        const globePolar = $b2dc26e6bbd9abd7$export$2aad8d5c978c5be9(lat, extraThetaOffset);
        const globeAzimuthal = $b2dc26e6bbd9abd7$export$232fe3c2ac5cbf38(lng);
        // Sync latitude and longitude
        this.threeControls.setPolarAngle(globePolar);
        this.threeControls.setAzimuthalAngle(globeAzimuthal);
        // Sync zoom
        this.threeControls.trackPos = trackPos;
    }
}
function $b2dc26e6bbd9abd7$export$154a0da1a2902c7(polarAngle, extraThetaOffset) {
    return 90 - (polarAngle + extraThetaOffset) * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG;
}
function $b2dc26e6bbd9abd7$export$2aad8d5c978c5be9(latitude, extraThetaOffset = 0) {
    return (90 - latitude) / (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG - extraThetaOffset;
}
function $b2dc26e6bbd9abd7$export$1957a5a293f382a4(azimuthalAngle) {
    return -90 + azimuthalAngle * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG;
}
function $b2dc26e6bbd9abd7$export$232fe3c2ac5cbf38(longitude) {
    return (longitude + 90) / (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG;
}
/**
 * Convert from sphere surface distance to map zoom level
 *
 * Inverse of mapZoomToGlobeDistance
 * @param {Number} cameraFOV
 * @param {Number} distance - Distance from the globe in arbitrary threejs units
 * @param {Number} latitude
 *
 */ function $b2dc26e6bbd9abd7$var$globeDistanceToMapZoom(cameraFOV, distance, latitude) {
    // Info related to converting map zoom level to screen-space distance
    // https://wiki.openstreetmap.org/wiki/Zoom_levels
    // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Resolution_and_Scale
    // map has 25 zoom levels, 0-24
    // 0 is all the way out, 24 is all the way in
    // Each zoom level in doubles the "screen size" of a tile
    // The resolution of the map in meters per pixel can be calculated with the following formula:
    // resolution (meters / pixel) = 156543.03 meters/pixel * cos(latitude) / (2 ^ zoomlevel)
    // It follows that, given a target resolution, the zoom level can be calculated from the following formula:
    // zoomLevel = log2(156543.03 meters/pixel * cos(latitude) / resolution)
    // Target resolution can be calculated using camera distance from the surface of the globe, horizontal fov of the camera, and horizontal pixel resolution of the screen.
    // First, we calculate what horizontal angle a known distance value subtends on the screen.
    // The entire globe is arbibrarily scaled to 100 "view units" (vunits) across
    const globeDiameter = 50 // vunits
    ;
    // The equatorial diameter of the earth is 12756274.000134174 meters
    const earthDiameter = 12756274.000134174 // meters
    ;
    const VUnitsPerMeter = globeDiameter / earthDiameter // Amount of vunits in one meter
    ;
    // View angle subtended by 1 meter can be found using trigonometry
    const viewRadiansPerMeter = 2 * Math.atan2(VUnitsPerMeter / 2, distance);
    const cameraVerticalFOV = cameraFOV * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).DEG2RAD // Radians
    ;
    // We can get vertical screen resolution by hooking into onWindowResize events
    const screenResolution = window.innerHeight // pixels
    ;
    // Calculate the fraction of the screen that one meter takes up
    const screenFractionPerMeter = viewRadiansPerMeter / cameraVerticalFOV // Fraction of vertical screen. 0 is none, 1 is all of it. Unit is meter^-1
    ;
    // Finally, we can convert view angle per meter into pixels per meter
    const pixelsPerMeter = screenFractionPerMeter * screenResolution;
    // Temp error correction for a weird fov-related effect I can't pin down
    // TODO: Figure out where this error is coming from
    const span = 0.74;
    const t = (cameraVerticalFOV - 0.76) / span;
    const errorCorrection = 1 - (1 - 0.85) * t;
    // console.log(theta)
    return Math.log2(156543.03 * Math.cos(latitude) * pixelsPerMeter * errorCorrection);
}
/**
 * Convert map zoom level to sphere surface distance
 *
 * Inverse of globeDistanceToMapZoom
 * @param {Number} cameraFOV
 * @param {Number} zoom
 * @param {Number} latitude
 * @returns
 */ function $b2dc26e6bbd9abd7$var$mapZoomToGlobeDistance(cameraFOV, zoom, latitude) {
    // The entire globe is arbibrarily scaled to 100 "view units" (vunits) across
    const globeDiameter = 50 // vunits
    ;
    // The equatorial diameter of the earth is 12756274.000134174 meters
    const earthDiameter = 12756274.000134174 // meters
    ;
    const VUnitsPerMeter = globeDiameter / earthDiameter // Amount of vunits in one meter
    ;
    const cameraVerticalFOV = cameraFOV * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).DEG2RAD;
    const screenResolution = window.innerHeight // pixels
    ;
    const span = 0.74;
    const t = (cameraVerticalFOV - 0.76) / span;
    const errorCorrection = 1 - (1 - 0.85) * t;
    const pixelsPerMeter = Math.pow(2, zoom) / (156543.03 * Math.cos(latitude) * errorCorrection);
    const screenFractionPerMeter = pixelsPerMeter / screenResolution;
    const viewRadiansPerMeter = screenFractionPerMeter * cameraVerticalFOV;
    const distance = VUnitsPerMeter / (2 * Math.tan(viewRadiansPerMeter / 2));
    return distance;
}


const $d6f1a4944061be51$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $d6f1a4944061be51$var$_seed = 1234567;
const $d6f1a4944061be51$export$460c4029b1a54a2e = Math.PI / 180;
const $d6f1a4944061be51$export$914076c8150813e5 = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d6f1a4944061be51$export$e73c8bd0f20705a() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d6f1a4944061be51$var$_lut[d0 & 0xff] + $d6f1a4944061be51$var$_lut[d0 >> 8 & 0xff] + $d6f1a4944061be51$var$_lut[d0 >> 16 & 0xff] + $d6f1a4944061be51$var$_lut[d0 >> 24 & 0xff] + "-" + $d6f1a4944061be51$var$_lut[d1 & 0xff] + $d6f1a4944061be51$var$_lut[d1 >> 8 & 0xff] + "-" + $d6f1a4944061be51$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d6f1a4944061be51$var$_lut[d1 >> 24 & 0xff] + "-" + $d6f1a4944061be51$var$_lut[d2 & 0x3f | 0x80] + $d6f1a4944061be51$var$_lut[d2 >> 8 & 0xff] + "-" + $d6f1a4944061be51$var$_lut[d2 >> 16 & 0xff] + $d6f1a4944061be51$var$_lut[d2 >> 24 & 0xff] + $d6f1a4944061be51$var$_lut[d3 & 0xff] + $d6f1a4944061be51$var$_lut[d3 >> 8 & 0xff] + $d6f1a4944061be51$var$_lut[d3 >> 16 & 0xff] + $d6f1a4944061be51$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d6f1a4944061be51$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d6f1a4944061be51$export$3c11354a743b7f4e(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d6f1a4944061be51$export$61343b3c0ad0a00a(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d6f1a4944061be51$export$c45b79d581bbb999(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d6f1a4944061be51$export$3a89f8d6f6bf6c9f(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d6f1a4944061be51$export$f81c1cb84e35b185(x, y, lambda, dt) {
    return $d6f1a4944061be51$export$3a89f8d6f6bf6c9f(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d6f1a4944061be51$export$1d919ae830ac5239(x, length = 1) {
    return length - Math.abs($d6f1a4944061be51$export$3c11354a743b7f4e(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d6f1a4944061be51$export$4053e36566dd3d9a(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d6f1a4944061be51$export$7509a5c452b9dce8(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d6f1a4944061be51$export$a85cdcada2f6e6d0(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d6f1a4944061be51$export$8dceb61b660164cc(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d6f1a4944061be51$export$f093f4e85c7dea5a(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d6f1a4944061be51$export$d3abb7a3a61fb0cb(s) {
    if (s !== undefined) $d6f1a4944061be51$var$_seed = s;
    // Mulberry32 generator
    let t = $d6f1a4944061be51$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d6f1a4944061be51$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * $d6f1a4944061be51$export$460c4029b1a54a2e;
}
function $d6f1a4944061be51$export$54390e3b44c4a9cb(radians) {
    return radians * $d6f1a4944061be51$export$914076c8150813e5;
}
function $d6f1a4944061be51$export$b9e43d1765415474(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d6f1a4944061be51$export$150eaaaf1e7bb6f7(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d6f1a4944061be51$export$b500f0356efda8ea(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d6f1a4944061be51$export$ef2201424fe649f7(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $d6f1a4944061be51$export$be8b9fcbce8e8f70(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $d6f1a4944061be51$export$a3295358bff77e(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $d6f1a4944061be51$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $d6f1a4944061be51$export$460c4029b1a54a2e,
    RAD2DEG: $d6f1a4944061be51$export$914076c8150813e5,
    generateUUID: $d6f1a4944061be51$export$e73c8bd0f20705a,
    clamp: $d6f1a4944061be51$export$7d15b64cf5a3a4c4,
    euclideanModulo: $d6f1a4944061be51$export$3c11354a743b7f4e,
    mapLinear: $d6f1a4944061be51$export$61343b3c0ad0a00a,
    inverseLerp: $d6f1a4944061be51$export$c45b79d581bbb999,
    lerp: $d6f1a4944061be51$export$3a89f8d6f6bf6c9f,
    damp: $d6f1a4944061be51$export$f81c1cb84e35b185,
    pingpong: $d6f1a4944061be51$export$1d919ae830ac5239,
    smoothstep: $d6f1a4944061be51$export$4053e36566dd3d9a,
    smootherstep: $d6f1a4944061be51$export$7509a5c452b9dce8,
    randInt: $d6f1a4944061be51$export$a85cdcada2f6e6d0,
    randFloat: $d6f1a4944061be51$export$8dceb61b660164cc,
    randFloatSpread: $d6f1a4944061be51$export$f093f4e85c7dea5a,
    seededRandom: $d6f1a4944061be51$export$d3abb7a3a61fb0cb,
    degToRad: $d6f1a4944061be51$export$e6bfdeff8bfc94f9,
    radToDeg: $d6f1a4944061be51$export$54390e3b44c4a9cb,
    isPowerOfTwo: $d6f1a4944061be51$export$b9e43d1765415474,
    ceilPowerOfTwo: $d6f1a4944061be51$export$150eaaaf1e7bb6f7,
    floorPowerOfTwo: $d6f1a4944061be51$export$b500f0356efda8ea,
    setQuaternionFromProperEuler: $d6f1a4944061be51$export$ef2201424fe649f7,
    normalize: $d6f1a4944061be51$export$a3295358bff77e,
    denormalize: $d6f1a4944061be51$export$be8b9fcbce8e8f70
};


// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $d8c40d4165631fec$var$_changeEvent = {
    type: "change"
};
const $d8c40d4165631fec$var$_startEvent = {
    type: "start"
};
const $d8c40d4165631fec$var$_endEvent = {
    type: "end"
};
const $d8c40d4165631fec$var$STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6,
    ANIMATING: 7,
    ANIMATION_ROTATE: 8,
    ANIMATION_FOCUS: 9
};
/* Scratch objects (for memory optimization) */ const $d8c40d4165631fec$var$_scratchSpherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
class $d8c40d4165631fec$export$4bce0fe8712eaf01 extends (0, $8725869b83961a04$export$ec8b666c5fe2c75a) {
    constructor(camera, domElement, globe){
        super();
        if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
        if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
        this.globe = globe;
        this.camera = camera;
        this.light = null;
        this.domElement = domElement;
        this.domElement.style.touchAction = "none" // disable touch scroll
        ;
        this.surfaceDist = 50;
        // Set to false to disable this control
        this.enabled = true;
        // Whether or not the camera is currently in a focusing maneuver
        this.isFocusing = false;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // The heigth at wich the camera is looking
        this.focusRadius = 51.5;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0 // radians
        ;
        this.maxPolarAngle = Math.PI // radians
        ;
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity // radians
        ;
        this.maxAzimuthAngle = Infinity // radians
        ;
        // How far the camera skews when zoomed in.
        this.minSkewAngle = 0;
        this.maxSkewAngle = 0.4;
        this.extraThetaOffset = Math.PI / 180;
        // When in the track the camera rotates
        this.startRotatingInitialMouse = 0.7;
        this.endRotatingInitialMouse = 0.9;
        this.startRotatingInitialTouch = 0.45;
        this.endRotatingInitialTouch = 1;
        this.startRotating = this.startRotatingInitialMouse;
        this.endRotating = this.endRotatingInitialMouse;
        // How far the camera leans back when zoomed in.
        // This can be updated by updateMaxThetaOffset to precisely focus on a point at a certain height.
        // this.minThetaOffset = 0;
        // this.maxThetaOffset = 0.15;
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.1;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true // if false, pan orthogonal to world-space direction camera.up
        ;
        this.keyPanSpeed = 7.0 // pixels moved per arrow key push
        ;
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0 // 30 seconds per orbit when fps is 60
        ;
        // For animations
        this.clock = new (0, $8725869b83961a04$export$9735c82c4bae3302)();
        this.trackAnimation = {
            startTime: 0,
            endTime: 0,
            startValue: 0,
            endValue: 0
        };
        this.trackPos = 0.13;
        this.distance = 0;
        this._sphericalDelta = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
        // current position in spherical coordinates
        this._spherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
        // Arcball ported members
        this._center = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._currentCursorPosition = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._startCursorPosition = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._currentCursorPositionFlick = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._startCursorPositionFlick = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._gizmoPosition = new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 50, 0);
        this._tbRadius = 50;
        // Used for flick animation calculations
        this._flickTbRadius = 50;
        this.radiusFactor = 0.67;
        // Animation
        this.enableAnimations = true;
        this._isFocusAnim = false;
        this._isFocusTrack = false;
        this._animationId = -1;
        this._timeStart = -1;
        this._timePrev = 0;
        this._timeCurrent = 0;
        // this._wHorizontalPrev = 0
        // this._wHorizontalCurr = 0
        // this._wVerticalPrev = 0
        // this._wVerticalCurr = 0
        this._wPrev = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._wCurr = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._wFlickPrev = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._wFlickCurr = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._cursorPosPrev = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._cursorPosCurr = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this.wMax = 0.1 // Max angular velocity allowed
        ;
        this.flickDeadZoneRadius = 0.01;
        this.tbDampingFactor = 0.2;
        this.focusDuration = 0.5 // Seconds
        ;
        // Globe info
        this._lngLat = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        // const templateAnimation = {
        // 	propertyName: "trackPos",
        // 	startTime: 0,
        // 	endTime: 0,
        // 	startValue: 0,
        // 	endValue: 0
        // }
        this.animations = [];
        // The four arrow keys
        this.keys = {
            LEFT: "ArrowLeft",
            UP: "ArrowUp",
            RIGHT: "ArrowRight",
            BOTTOM: "ArrowDown"
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $8725869b83961a04$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $8725869b83961a04$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $8725869b83961a04$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $8725869b83961a04$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_ROTATE
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.camera.position.clone();
        this.zoom0 = this.camera.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        // Workaround for the imperfect zoom algorithm
        // TODO: For increased accuracy, the bouning sphere of the actual mesh we're zooming on needs to be used
        // 	Currently the lower-level mesh is used because that's what's already being used and because it's a single mesh
        // 	whereas the new object being loaded in is a collection of meshes which will be harder to get an overall bounding sphere for
        this.focusMeshOffsets = new Map();
        // Add hard-coded offests
        this.focusMeshOffsets.set("MA", {
            radius: 0.9,
            phi: 0.01,
            theta: 0.016
        });
        // Scratch objects (for memory optimization)
        this._v2_1 = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._v2_2 = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._v3_1 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        this._v3_2 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        //
        // public methods
        //
        /**
         * Perform animation for rotation operation
         * @param {Number} time Instant in which this function is called as performance.now()
         * @param {Number} angularSpeed0 Initial angular speed
         * @param {Vector2} direction Direction of spin
         * @param {Number} flickSpeed0 speed of the flick gesture in flick space
         */ this.onRotationAnim = function(time, angularSpeed0, direction, flickSpeed0) {
            if (this._timeStart === -1) {
                // animation start
                // this._anglePrev = 0;
                this._angleCurrent = 0;
                this._timeStart = time;
            }
            if (this._state === $d8c40d4165631fec$var$STATE.ANIMATION_ROTATE) {
                // w = w0 + alpha * t
                const deltaTime = (time - this._timeStart) / 1000;
                // const wHorizontal = w0Horizontal - (w0Horizontal * (this.dampingFactor))
                // const wVertical = w0Vertical - (w0Vertical * (this.dampingFactor))
                // TODO: change for vector and diminish magnitude
                const flickSpeedToAngularSpeed = angularSpeed0 / flickSpeed0;
                const w = flickSpeed0 + -this.tbDampingFactor * deltaTime;
                // const wHorizontal = w0Horizontal + ( ( - this.tbDampingFactor ) * deltaTime );
                // const wVertical = w0Vertical + ( ( - this.tbDampingFactor ) * deltaTime );
                if (w > 0) {
                    // tetha = 0.5 * alpha * t^2 + w0 * t + tetha0
                    // const horizontalCurrent = 0.5 * ( - this.tbDampingFactor ) * Math.pow( deltaTime, 2 ) + w0Horizontal * deltaTime + 0;
                    // const verticalCurrent = 0.5 * ( - this.tbDampingFactor ) * Math.pow( deltaTime, 2 ) + w0Vertical * deltaTime + 0;
                    // const horizontalCurrent = w0.x - (this.tbDampingFactor * deltaTime)
                    // const verticalCurrent = w0.y - (this.tbDampingFactor * deltaTime)
                    this._v2_1.copy(direction).multiplyScalar(w * flickSpeedToAngularSpeed);
                    // console.log(wHorizontal)
                    // console.log(horizontalCurrent)
                    // this.applyTransformMatrix( this.rotate( rotationAxis, this._angleCurrent ) );
                    this.rotateLeft(this._v2_1.x);
                    this.rotateUp(this._v2_1.y);
                    this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
                    const self = this;
                    this._animationId = window.requestAnimationFrame(function(t) {
                        self.onRotationAnim(t, angularSpeed0, direction, flickSpeed0);
                    });
                } else {
                    this._animationId = -1;
                    this._timeStart = -1;
                    this.updateTbState($d8c40d4165631fec$var$STATE.NONE, false);
                    // this.activateGizmos( false );
                    this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
                }
            } else {
                // interrupt animation
                this._animationId = -1;
                this._timeStart = -1;
                if (this._state !== $d8c40d4165631fec$var$STATE.ROTATE) // this.activateGizmos( false );
                this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
            }
        };
        // Arcball methods
        /**
         * Set _center's x/y coordinates
         * @param {Number} clientX
         * @param {Number} clientY
         */ this.setCenter = function(clientX, clientY) {
            this._center.x = clientX;
            this._center.y = clientY;
        };
        // Drag surface should be set to the distance from the origin to the surface we're currently dragging.
        // This changes depending on whether we're dragging the globe itself, a state, a zip, etc.
        this.setDragSurfaceDist = function(dist) {
            this.surfaceDist = dist;
        };
        // Updates the amount that the camera slides back when fully zoomed in
        // based on the skew angle, minDistance, and the radius of the focus point
        // This should be called any time maxSkewAngle or minDistance change.
        this.calcThetaOffset = function() {
            const piOver2 = Math.PI / 2;
            // const twoPi = Math.PI * 2
            return function(angle, doc, dog, out) {
                // doc = distanceObjectToCamera;
                // dog = distanceObjectToGlobeCenter;
                // I have a piece of paper that explains why this works.
                // Too bad code comments can't contain images (just kidding, awful idea.)
                // Law of cosines: a^2 = b^2 + c^2 - 2ac*cos(A)
                const sinB = Math.sin(angle);
                let A = Math.asin(doc * sinB / dog);
                let H = dog * Math.sin(Math.PI - angle - A) / sinB;
                // Resolve the ambiguous case - A should never be > 90 degrees
                if (A > piOver2) // Find the complement
                A = Math.PI - A;
                if (H === Infinity) H = doc + dog;
                out[0] = A;
                out[1] = H;
                out[2] = angle + A;
                return out;
            // console.log('maxThetaOffset', scope.maxThetaOffset);
            };
        }();
        this.getMeshDistFromGlobeCenter = function() {
            return function getMeshDistFromGlobeCenter(mesh) {
                // TODO: To make this more portable, a bounding box center could be used instead of an anchor.
                const anchor = mesh.children[0];
                // TODO: pull this from the globe center
                const toCenter = new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 50, 0);
                const out = new (0, $8725869b83961a04$export$64b5c384219d3699)().copy(anchor.position);
                anchor.parent.updateWorldMatrix(true);
                anchor.parent.localToWorld(out);
                toCenter.sub(out);
                return toCenter.length();
            };
        }();
        this.onWindowResize = function() {
            this.vDistanceCoefficient = Math.sqrt(Math.pow(Math.cos(camera.fov * Math.PI / 180 / 2) / Math.sin(camera.fov * Math.PI / 180 / 2), 2) + 1);
            this.horizontalFov = 2 * Math.atan(Math.tan(camera.fov * Math.PI / 180 / 2) * camera.aspect) * 180 / Math.PI // degrees
            ;
            this.hDistanceCoefficient = Math.sqrt(Math.pow(Math.cos(this.horizontalFov * Math.PI / 180 / 2) / Math.sin(this.horizontalFov * Math.PI / 180 / 2), 2) + 1);
            this._screenDependantTbRadius = $d8c40d4165631fec$var$calculateTbRadius(this.camera, this._gizmoPosition, this.radiusFactor);
        };
        this.onWindowResize();
        this.focusLngLat = function(lng, lat, duration) {
            scope.focus(lng, lat);
            scope.trackInSlow(1, duration);
        };
        this.focusMesh = function() {
            const target = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            const tmpSpherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
            // TODO: Pull this from the actual globe origin instead of hardcoding
            const globeOrigin = new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 50, 0);
            // const twopi = Math.PI * 2
            return function focusMesh(mesh, duration = 1, changeRotation = true, usingMinDistance = 53.2, distanceScalar = 1.02) {
                // Process parameters
                if (!usingMinDistance) usingMinDistance = scope.minDistance;
                mesh.updateWorldMatrix(true);
                // Get the mesh pos and then focus it
                // State meshes are all positioned at 0, so we need to get a bounding box center instead.
                // Get the world pos of the center of the bounding sphere
                const geometry = mesh.geometry;
                geometry.computeBoundingSphere();
                target.copy(geometry.boundingSphere.center);
                mesh.localToWorld(target);
                // Extract scale from mesh matrixWorld
                const scale = new (0, $8725869b83961a04$export$64b5c384219d3699)();
                {
                    const position = new (0, $8725869b83961a04$export$64b5c384219d3699)();
                    const quaternion = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)();
                    mesh.matrixWorld.decompose(position, quaternion, scale);
                }
                // Add guide sphere
                const sphereGeometry = new (0, $8725869b83961a04$export$1b417fc3b307a251)(scale.x * geometry.boundingSphere.radius, 32, 32);
                const material = new (0, $8725869b83961a04$export$55cbcc9b622fe1f5)({
                    color: "#00FF00",
                    wireframe: true
                });
                const sphere = new (0, $8725869b83961a04$export$e176487c05830cc5)(sphereGeometry, material);
                sphere.position.copy(target);
                const obj = new (0, $8725869b83961a04$export$e4dd07dff30cc924)();
                obj.position.set(0, 50, 0);
                obj.visible = false;
                obj.attach(sphere);
                if (mesh.userData.clickedScale) obj.scale.multiplyScalar(mesh.userData.clickedScale.x / mesh.scale.x);
                camera.parent.add(obj);
                sphere.updateWorldMatrix(true);
                const target2 = new (0, $8725869b83961a04$export$64b5c384219d3699)();
                sphere.localToWorld(target2);
                target2.sub(new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 50, 0));
                // Calculate focus radius based on one vertex on the face of the region
                const positionAttribute = geometry.getAttribute("position");
                const vertex = new (0, $8725869b83961a04$export$64b5c384219d3699)();
                vertex.fromBufferAttribute(positionAttribute, 0);
                mesh.localToWorld(vertex);
                vertex.sub(new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 50, 0));
                const meshSurfaceDistance = vertex.length() * (mesh.userData.clickedScale.x / mesh.scale.x);
                // Check for workaround offset
                let offset;
                if (this.focusMeshOffsets.has(mesh.parent.abbr)) {
                    offset = this.focusMeshOffsets.get(mesh.parent.abbr);
                    // Apply offset to the mesh focus position
                    tmpSpherical.setFromVector3(target.sub(globeOrigin));
                    console.log("Focus mesh before", target, tmpSpherical, offset);
                    tmpSpherical.theta = tmpSpherical.theta + offset.theta // % twopi;
                    ;
                    tmpSpherical.phi = tmpSpherical.phi + offset.phi // % twopi;
                    ;
                    tmpSpherical.radius += offset.radius;
                    target.setFromSpherical(tmpSpherical);
                    console.log("Focus mesh after", target, tmpSpherical);
                    // Convert back to world pos
                    target.add(globeOrigin);
                }
                // End workaround
                // scope.isFocusing = true
                scope.setFocusingTrackFlag(true);
                scope.focus(target);
                let distanceCoefficient = this.vDistanceCoefficient;
                if (camera.fov > this.horizontalFov) {
                    distanceCoefficient = this.hDistanceCoefficient;
                    console.log("HORIZONTAL CHOSEN");
                }
                // Assumes scale is uniform
                const meshSizeScalar = scale.x;
                let framingDistance = geometry.boundingSphere.radius * distanceCoefficient * meshSizeScalar * distanceScalar + meshSurfaceDistance;
                if (offset) framingDistance += offset.radius;
                let trackTarget = Math.max(0, Math.min(1, scope.invertCameraTrack(framingDistance, usingMinDistance)));
                if (isNaN(trackTarget)) trackTarget = 1;
                if (changeRotation) {
                    const endRotating = trackTarget;
                    const startRotating = trackTarget - 0.2;
                    // animate start and end rotating
                    scope.animateTo("endRotating", endRotating, 1);
                    scope.animateTo("startRotating", startRotating, 1);
                }
                scope.trackInSlow(trackTarget, duration);
            };
        }();
        this.setExtraThetaOffset = function(targetExtraThetaOffset) {
            extraThetaOffsetDelta = targetExtraThetaOffset - this.extraThetaOffset;
        };
        this.setMinDistance = function(targetMinDistance) {
            minDistanceDelta = targetMinDistance - this.minDistance;
        };
        this.setFocusRadius = function(targetFocusRadius) {
            focusRadiusDelta = targetFocusRadius - this.focusRadius;
        };
        this.jumpToFocusRadius = function(radius) {
            this.focusRadius = radius;
        };
        this.focusZoom = function() {
            // const target = new Vector3()
            return function focusZoom(pos) {
                scope.focus(pos);
                pos.sub(scope.target);
                const dist = pos.length();
                scope.focusRadius = dist;
                // scope.updateMaxThetaOffset(dist);
                scope.trackInSlow(1, 2);
            };
        }();
        // Zoom in slowly using the animation system
        this.trackInSlow = function() {
            return function trackInSlow(amount, duration) {
                if (amount === 0) return;
                // const startTime = scope.clock.getElapsedTime()
                // const animation = {
                //     propertyName: "trackPos",
                //     startValue: Math.max(0, Math.min(1, scope.trackPos)),
                //     endValue: Math.max(0, Math.min(1, amount)),
                //     startTime,
                //     endTime: startTime + duration,
                // }
                scope.startAnimation("trackPos", Math.max(0, Math.min(1, scope.trackPos)), Math.max(0, Math.min(1, amount)), duration);
            };
        }();
        this.animateTo = function(propertyName, endValue, duration) {
            scope.startAnimation(propertyName, scope[propertyName], endValue, duration);
        };
        this.startAnimation = function(propertyName, startValue, endValue, duration) {
            const startTime = scope.clock.getElapsedTime();
            const animation = {
                propertyName: propertyName,
                startValue: startValue,
                endValue: endValue,
                startTime: startTime,
                endTime: startTime + duration
            };
            // Maybe we should clear the animation list here if state isn't animating so we clear old animations that were cancelled by a mouse movement
            this.animations.push(animation);
        // scope._state = STATE.ANIMATING;
        };
        this.abortAnimations = function() {
            this.animations = [];
        };
        // this.startAnimation = function(animation) {
        // 	// Maybe we should clear the animation list here if state isn't animating so we clear old animations that were cancelled by a mouse movement
        // 	this.animations.push(animation);
        // 	state = STATE.ANIMATING;
        // };
        // Carry out animations
        this.animate = function() {
            // if (scope._state !== STATE.ANIMATING
            // 	&& scope._state !== STATE.ANIMATION_FOCUS
            // )
            // 	return;
            if (this.animations.length === 0) return;
            const time = this.clock.getElapsedTime();
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                // console.log('carrying out', animation);
                // Check for expired animations
                if (time >= animation.endTime) {
                    // Set our animated property to the end value (could represent a half-frame of movement)
                    this[animation.propertyName] = animation.endValue;
                    // Remove this animation from the array
                    this.animations.splice(i, 1);
                    if (this.animations.length === 0) // No animations left, so reset our state and short circuit
                    // scope._state = STATE.NONE;
                    return;
                    // Decrement the i so next loop starts in the right place
                    i--;
                }
                // Carry out any animations in progress
                const progress = (time - animation.startTime) / (animation.endTime - animation.startTime);
                const sq = progress * progress;
                const curvedProgress = sq / (2 * (sq - progress) + 1);
                this[animation.propertyName] = curvedProgress * animation.endValue + (1 - curvedProgress) * animation.startValue;
            }
        };
        this.focus = function() {
            const focusSpherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
            const offset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            // const deltaPhi = 0;
            // const deltaTheta = 0;
            function focusVector3(vec, { animated: animated } = {
                animated: true
            }) {
                // We want the spherical to be relative to the center of the globe, i.e. scope.target
                offset.copy(vec).sub(scope.target);
                focusSpherical.setFromVector3(offset);
                focusSpherical.makeSafe();
                if (animated) {
                    const start = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(scope._spherical.theta, scope._spherical.phi);
                    const end = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(focusSpherical.theta, focusSpherical.phi);
                    const self = scope;
                    scope._animationId = window.requestAnimationFrame(function(t) {
                        self.updateTbState($d8c40d4165631fec$var$STATE.ANIMATION_FOCUS, true);
                        self.onFocusAnim(t, start, end);
                    });
                } else {
                    scope._spherical.phi = focusSpherical.phi;
                    scope._spherical.theta = focusSpherical.theta;
                }
                console.log("focusing", offset);
            }
            function focusLngLat(lng, lat, { animated: animated } = {
                animated: false
            }) {
                const polar = (0, $b2dc26e6bbd9abd7$export$2aad8d5c978c5be9)(lat);
                const azimuthal = (0, $b2dc26e6bbd9abd7$export$232fe3c2ac5cbf38)(lng);
                if (animated) {
                    const start = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(scope._spherical.theta, scope._spherical.phi);
                    const end = new (0, $8725869b83961a04$export$c977b3e384af9ae1)(azimuthal, polar);
                    const self = scope;
                    scope._animationId = window.requestAnimationFrame(function(t) {
                        self.updateTbState($d8c40d4165631fec$var$STATE.ANIMATION_FOCUS, true);
                        self.onFocusAnim(t, start, end);
                    });
                } else {
                    scope._spherical.phi = polar;
                    scope._spherical.theta = azimuthal;
                }
            }
            /**
             * @overload
             * @param {Vector3} input
             * @param {{animated: boolean}} [options]
             */ /**
             * @overload
             * @param {!number} lat
             * @param {!number} lng
             * @param {{animated: boolean}} [options]
             */ return function focus(input, options) {
                if (typeof input === "object" && input.isVector3) focusVector3(input, options);
                else if (typeof input === "object" || typeof input === "number") focusLngLat(...arguments);
            };
        }();
        this.setLight = function(light, sun) {
            this.light = light;
            this.sun = sun;
            this.lightDistance = this.light.position.distanceTo(this.target);
        };
        // Return the track value you need to get a certain distance
        this.invertCameraTrack = function() {
            return function invertCameraTrack(distance, minDistance) {
                let endDist = scope.minDistance;
                if (!(minDistance === undefined)) endDist = minDistance;
                const startDist = scope.maxDistance;
                // const endDist = scope.minDistance;
                const invLerp = (distance - startDist) / (endDist - startDist);
                // console.log("invLerp is " + invLerp);
                const t1 = 1 + Math.sqrt(4 - 4 * invLerp) / -2;
                const t2 = 1 + Math.sqrt(4 - 4 * t1) / -2;
                return t2;
            };
        }();
        this.cameraTrack = function() {
            const out = [];
            // const extraThetaOffset = Math.PI / 180;
            const maxExtraOffset = 3 * Math.PI / 180;
            return function cameraTrack(t, data) {
                // Inverse T
                // distance = startDist * (1 - tCurved) + endDist * tCurved
                // tCurved = (distance - startDist) / (endDist - startDist)
                // tCurved = 2*t * (1 - 0.5 * t);
                // 2*t * (1 - 0.5 * t) = (distance - startDist) / (endDist - startDist)
                // 2t - t**2 = (distance - startDist) / (endDist - startDist)
                // -t**2 + 2t - (distance - startDist) / (endDist - startDist) = 0
                // (distance - startDist) / (endDist - startDist) = invLerp
                // -t**2 + 2t - invLerp = 0
                // a =-1
                // b = 2
                // c = -invLerp
                // quadratic formula ->
                // t = 1 +- (sqrt(4 - 4*invLerp)) / -2;
                // t = -1 * (t * t) + 2 * t;
                // console.log(t);
                // Clamp betweeo 0 and 1
                t = Math.min(1, Math.max(0, t));
                const startDist = scope.maxDistance;
                const endDist = scope.minDistance;
                // const totalDistance = scope.maxDistance - scope.minDistance
                // console.log(startDist, endDist, t);
                // const startRotating = 0.7
                // const endRotating = 0.9 ;//- (10 / totalDistance);
                const totalRotating = scope.endRotating - scope.startRotating;
                const startAngle = scope.minSkewAngle;
                const endAngle = scope.maxSkewAngle;
                // TODO: This needs to vary with zoom level to accurately zoom to the surface of a state
                // const startTheta = scope.minThetaOffset;
                // const endTheta = scope.maxThetaOffset;
                const angleT = Math.min(1, Math.max(0, (t - scope.startRotating) / totalRotating));
                const angleTSquared = angleT * angleT;
                const angleTCurved = angleTSquared / (2 * (angleTSquared - angleT) + 1);
                // t overall curve
                t = -1 * (t * t) + 2 * t;
                const tCurved = 2 * t * (1 - 0.5 * t);
                // lerps
                const distance = Math.min(400, startDist * (1 - tCurved) + endDist * tCurved);
                const angle = startAngle * (1 - angleTCurved) + endAngle * angleTCurved;
                // Calculate theta offset based on angle and distance
                scope.calcThetaOffset(angle, distance - scope.focusRadius, scope.focusRadius, out);
                extraThetaOffset = Math.min(maxExtraOffset, scope.extraThetaOffset * (scope.getDistance() - scope.focusRadius));
                const thetaOffset = out[0] + extraThetaOffset;
                const offsetDistance = out[1];
                // console.log(scope.getDistance())
                // console.log(Math.min(maxExtraOffset, extraThetaOffset * (50 - scope.getDistance())))
                // console.log(angleT, t, startRotating, totalRotating);
                // distance = Math.min(distance, 400);
                if (data === null || data === undefined) data = {};
                data.distance = distance;
                data.angle = angle;
                data.thetaOffset = thetaOffset;
                data.offsetDistance = offsetDistance;
                return data;
            // console.log(data);
            };
        }();
        this.getPolarAngle = function() {
            return scope._spherical.phi;
        };
        this.setPolarAngle = function(angle) {
            scope._spherical.phi = angle;
        };
        this.getExtraThetaOffset = function() {
            return extraThetaOffset;
        };
        this.getAzimuthalAngle = function() {
            return scope._spherical.theta;
        };
        this.setAzimuthalAngle = function(angle) {
            scope._spherical.theta = angle;
        };
        this.getDistance = function() {
            // return this.object.position.distanceTo( this.target );
            return this.distance;
        };
        this.listenToKeyEvents = function(domElement) {
            domElement.addEventListener("keydown", onKeyDown);
            this._domElementKeyEvents = domElement;
        };
        this.saveState = function() {
            scope.target0.copy(scope.target);
            scope.position0.copy(scope.camera.position);
            scope.zoom0 = scope.camera.zoom;
        };
        this.reset = function() {
            scope.target.copy(scope.target0);
            scope.camera.position.copy(scope.position0);
            scope.camera.zoom = scope.zoom0;
            scope.camera.updateProjectionMatrix();
            scope.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
            scope.update();
            scope._state = $d8c40d4165631fec$var$STATE.NONE;
        };
        this.getTrackData = function() {
            return trackData;
        };
        // this method is exposed, but perhaps it would be better if we can make it private...
        this.update = function() {
            const offset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            const toTarget = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            const axis = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            const targetOffset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            // const sunTarget = new Vector3()
            const lightSpherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
            const lightOffset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            const offsetSpherical = new (0, $8725869b83961a04$export$d712cd887b4a00f7)();
            // so camera.up is the orbit axis
            const quat = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)().setFromUnitVectors(camera.up, new (0, $8725869b83961a04$export$64b5c384219d3699)(0, 1, 0));
            const quatInverse = quat.clone().invert();
            const lastPosition = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            const lastQuaternion = new (0, $8725869b83961a04$export$23d6a54f0bbc85a3)();
            const twoPI = 2 * Math.PI;
            return function update() {
                scope.animate();
                // Clamp the track position between 0 and 1
                scope.trackPos = Math.min(1, Math.max(0, scope.trackPos));
                // const trackPosCurved = Math.sqrt(scope.trackPos)
                scope.cameraTrack(scope.trackPos, trackData);
                this.distance = trackData.distance;
                const position = scope.camera.position;
                offset.copy(position).sub(scope.target);
                // rotate offset to "y-axis-is-up" space
                offset.applyQuaternion(quat);
                // angle from z-axis around y-axis
                // spherical.setFromVector3( offset );
                if (scope.autoRotate && scope._state === $d8c40d4165631fec$var$STATE.NONE) scope.rotateLeft(getAutoRotationAngle());
                if (scope.enableDamping) {
                    scope.minDistance += minDistanceDelta * scope.dampingFactor;
                    scope.focusRadius += focusRadiusDelta * scope.dampingFactor;
                    scope.extraThetaOffset += extraThetaOffsetDelta * scope.dampingFactor;
                // if ( minDistanceDelta != 0 ) {
                // 	scope.updateMaxThetaOffset();
                // }
                } else {
                    scope.minDistance += minDistanceDelta;
                    scope.focusRadius += focusRadiusDelta;
                    scope.extraThetaOffset += extraThetaOffsetDelta;
                }
                scope._spherical.theta += scope._sphericalDelta.theta;
                scope._spherical.phi += scope._sphericalDelta.phi;
                // restrict theta to be between desired limits
                let min = scope.minAzimuthAngle;
                let max = scope.maxAzimuthAngle;
                if (isFinite(min) && isFinite(max)) {
                    if (min < -Math.PI) min += twoPI;
                    else if (min > Math.PI) min -= twoPI;
                    if (max < -Math.PI) max += twoPI;
                    else if (max > Math.PI) max -= twoPI;
                    if (min <= max) scope._spherical.theta = Math.max(min, Math.min(max, scope._spherical.theta));
                    else scope._spherical.theta = scope._spherical.theta > (min + max) / 2 ? Math.max(min, scope._spherical.theta) : Math.min(max, scope._spherical.theta);
                }
                // This is to prevent the bug where the globe flips upside down near antarctica)
                scope.maxPolarAngle = Math.PI - (trackData.angle + trackData.thetaOffset + 0.1);
                // restrict phi to be between desired limits
                scope._spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, scope._spherical.phi));
                scope._spherical.makeSafe();
                // if (isNaN(trackPos))
                // 	trackPos = 0.32;
                // if (isNaN(scope.))
                if (scope.enableDamping) {
                    scope.trackPos += trackDelta * scope.dampingFactor;
                    // Only apply "mouse zoom center" calculations for zooming in with mouse
                    if (trackDelta > 0.0000000001 && pointers.length === 0) {
                        // TODO: Change _spherical based on how much trackDelta changed and current mouse position
                        const tmpTrackData = {
                            distance: 0
                        };
                        scope.cameraTrack(scope.trackPos, tmpTrackData);
                        // Get mouse LL before zoom
                        // TODO: Get this pre-calculated?
                        scope._v3_1.copy($d8c40d4165631fec$var$unprojectOnTbSurface(scope.camera.projectionMatrixInverse, scope.camera.type, trackData.distance, scope._center.x, scope._center.y, scope.domElement, scope._tbRadius, scope._gizmoPosition));
                        // scope._v3_2.copy(scope._v3_1).normalize()
                        // console.log([scope._v3_2.x, scope._v3_2.y, scope._v3_2.z])
                        // scope._v3_2.setFromSpherical(scope._spherical).normalize()
                        // console.log([scope._v3_2.x, scope._v3_2.y, scope._v3_2.z])
                        const lng = (0, $b2dc26e6bbd9abd7$export$1957a5a293f382a4)(scope._spherical.theta);
                        const lat = (0, $b2dc26e6bbd9abd7$export$154a0da1a2902c7)(scope._spherical.phi, scope.getExtraThetaOffset());
                        // v2_1 is lng/lat of camera
                        scope._v2_1.set(lng, lat);
                        // v2_2 is lng/lat of mouse
                        $d8c40d4165631fec$var$arcballPosToMouseLngLat(scope._v3_1, scope._v2_1, {
                            tmpSpherical: $d8c40d4165631fec$var$_scratchSpherical,
                            extraThetaOffset: scope.getExtraThetaOffset(),
                            out: scope._v2_2
                        });
                        // console.log(this._v2_2, this._lngLat)
                        // Get trackball position after zoom
                        scope._v3_2.copy($d8c40d4165631fec$var$unprojectOnTbSurface(scope.camera.projectionMatrixInverse, scope.camera.type, tmpTrackData.distance, scope._center.x, scope._center.y, scope.domElement, scope._tbRadius, scope._gizmoPosition));
                        // v2_1 new lng/lat of camera
                        $d8c40d4165631fec$var$arcballPosToCameraLngLat(scope._v3_2, scope._v2_2, {
                            tmpSpherical: $d8c40d4165631fec$var$_scratchSpherical,
                            extraThetaOffset: scope.getExtraThetaOffset(),
                            out: this._v2_1
                        });
                        const theta = (0, $b2dc26e6bbd9abd7$export$232fe3c2ac5cbf38)(this._v2_1.x);
                        const phi = (0, $b2dc26e6bbd9abd7$export$2aad8d5c978c5be9)(this._v2_1.y, scope.getExtraThetaOffset());
                        this._spherical.theta = theta;
                        this._spherical.phi = phi;
                    }
                // const change = tmpTrackData.distance - trackData.distance
                // const mouseAzi = lngToGlobeAzimuthal(scope._lngLat.x)
                // const mousePolar = latToGlobePolar(scope._lngLat.y)
                // scope._v2_1.set(mouseAzi, mousePolar)
                // scope._v2_2.set(
                //     scope._spherical.theta,
                //     scope._spherical.phi
                // )
                // scope._v2_2.sub(scope._v2_1)
                // scope._spherical.theta += scope._v2_2.x * change * 0.05 //* (trackData.distance - this._tbRadius)
                // scope._spherical.phi += scope._v2_2.y * change * 0.05 //* (trackData.distance - this._tbRadius)
                } else scope.trackPos += trackDelta;
                // console.log(trackData);
                scope._spherical.radius = trackData.offsetDistance // (scale - 1) * 100;
                ;
                // restrict radius to be between desired limits
                scope._spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, scope._spherical.radius));
                // move target to panned location
                if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
                else scope.target.add(panOffset);
                offsetSpherical.copy(scope._spherical);
                offsetSpherical.phi += trackData.thetaOffset;
                // restrict phi to be between desired limits
                offsetSpherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, offsetSpherical.phi));
                offset.setFromSpherical(offsetSpherical);
                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);
                position.copy(scope.target).add(offset);
                if (trackData.angle > 0) {
                    toTarget.copy(scope.target).sub(scope.camera.position);
                    axis.crossVectors(toTarget, scope.camera.up).normalize();
                    targetOffset.copy(toTarget).applyAxisAngle(axis, trackData.angle).add(scope.camera.position);
                    scope.camera.lookAt(targetOffset);
                } else scope.camera.lookAt(scope.target);
                if (scope.light) {
                    lightSpherical.copy(scope._spherical);
                    lightSpherical.radius = scope.lightDistance;
                    lightOffset.setFromSpherical(lightSpherical);
                    scope.light.position.copy(scope.target).add(lightOffset);
                    lightSpherical.radius = 50;
                    lightOffset.setFromSpherical(lightSpherical);
                    // console.log(lightOffset);
                    // sunTarget.copy(scope.target).add(lightOffset);
                    scope.sun.target.position.copy(scope.target).add(lightOffset);
                    scope.light.lookAt(scope.target);
                    // Shrink shadow camera bounds based on distance to maintain shadow quality
                    const dist = scope.getDistance() - 50;
                    let bound = dist * 1;
                    bound = Math.min(40, bound);
                    scope.sun.shadow.camera.top = -bound;
                    scope.sun.shadow.camera.left = -bound;
                    scope.sun.shadow.camera.right = bound;
                    scope.sun.shadow.camera.bottom = bound;
                    // scope.sun.shadow.camera.far = bound + 260;
                    scope.sun.shadow.camera.updateProjectionMatrix();
                    if (scope.sun.userData.helper) scope.sun.userData.helper.update();
                    scope.sun.shadow.bias = -0.0005 * (dist + 1) / 50;
                // console.log(bound);
                }
                if (scope.enableDamping === true) {
                    panOffset.multiplyScalar(1 - scope.dampingFactor);
                    trackDelta *= 1 - scope.dampingFactor;
                    minDistanceDelta *= 1 - scope.dampingFactor;
                    focusRadiusDelta *= 1 - scope.dampingFactor;
                    extraThetaOffsetDelta *= 1 - scope.dampingFactor;
                    // Test if focus manuever is over
                    if (scope._isFocusTrack) {
                        const threshold = 0.00000000001;
                        if (Math.abs(trackDelta) < threshold) scope.setFocusingTrackFlag(false);
                    }
                } else {
                    panOffset.set(0, 0, 0);
                    trackDelta = 0;
                    minDistanceDelta = 0;
                    focusRadiusDelta = 0;
                    extraThetaOffsetDelta = 0;
                }
                scope._sphericalDelta.set(0, 0, 0);
                scope._flickTbRadius = $d8c40d4165631fec$var$calculateTbRadius(scope.camera, scope._gizmoPosition, scope.radiusFactor);
                // scale = 1
                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8
                if (zoomChanged || lastPosition.distanceToSquared(scope.camera.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.camera.quaternion)) > EPS) {
                    scope.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
                    lastPosition.copy(scope.camera.position);
                    lastQuaternion.copy(scope.camera.quaternion);
                    zoomChanged = false;
                    return true;
                }
                return false;
            };
        }();
        this.dispose = function() {
            scope.domElement.removeEventListener("contextmenu", onContextMenu);
            scope.domElement.removeEventListener("pointerdown", onPointerDown);
            scope.domElement.removeEventListener("pointercancel", onPointerCancel);
            scope.domElement.removeEventListener("wheel", onMouseWheel);
            scope.domElement.removeEventListener("pointermove", onPointerMove);
            scope.domElement.removeEventListener("pointerup", onPointerUp);
            if (scope._domElementKeyEvents !== null) scope._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
        // scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
        };
        //
        // internals
        //
        const scope = this;
        const trackData = {
            distance: 100,
            angle: 0,
            thetaOffset: 0
        };
        let extraThetaOffset = 0;
        let extraThetaOffsetDelta = 0;
        // this.updateMaxThetaOffset();
        this._state = $d8c40d4165631fec$var$STATE.NONE;
        const EPS = 0.000001;
        // let scale = 1
        let trackDelta = 0;
        let minDistanceDelta = 0;
        var focusRadiusDelta = 0;
        const panOffset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
        let zoomChanged = false;
        const rotateStart = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const rotateEnd = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const rotateDelta = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const panStart = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const panEnd = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const panDelta = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const dollyStart = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        this._dollyStartDist = 0;
        const dollyEnd = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const dollyDelta = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
        const pointers = [];
        const pointerPositions = {};
        this._pointersLengthPrev = 0;
        function getAutoRotationAngle() {
            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
        }
        function getZoomScale() {
            return scope.zoomSpeed;
        }
        const panLeft = function() {
            const v = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            return function panLeft(distance, objectMatrix) {
                v.setFromMatrixColumn(objectMatrix, 0) // get X column of objectMatrix
                ;
                v.multiplyScalar(-distance);
                panOffset.add(v);
            };
        }();
        const panUp = function() {
            const v = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            return function panUp(distance, objectMatrix) {
                if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
                else {
                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.camera.up, v);
                }
                v.multiplyScalar(distance);
                panOffset.add(v);
            };
        }();
        // deltaX and deltaY are in pixels; right and down are positive
        const pan = function() {
            const offset = new (0, $8725869b83961a04$export$64b5c384219d3699)();
            return function pan(deltaX, deltaY) {
                const element = scope.domElement;
                if (scope.camera.isPerspectiveCamera) {
                    // perspective
                    const position = scope.camera.position;
                    offset.copy(position).sub(scope.target);
                    let targetDistance = offset.length();
                    // half of the fov is center to top of screen
                    targetDistance *= Math.tan(scope.camera.fov / 2 * Math.PI / 180.0);
                    // we use only clientHeight here so aspect ratio does not distort speed
                    panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.camera.matrix);
                    panUp(2 * deltaY * targetDistance / element.clientHeight, scope.camera.matrix);
                } else if (scope.camera.isOrthographicCamera) {
                    // orthographic
                    panLeft(deltaX * (scope.camera.right - scope.camera.left) / scope.camera.zoom / element.clientWidth, scope.camera.matrix);
                    panUp(deltaY * (scope.camera.top - scope.camera.bottom) / scope.camera.zoom / element.clientHeight, scope.camera.matrix);
                } else {
                    // camera neither orthographic nor perspective
                    console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
                    scope.enablePan = false;
                }
            };
        }();
        function dollyOut(dollyScale) {
            if (scope.camera.isPerspectiveCamera) {
                const nextDist = scope._dollyStartDist * (1 / dollyScale);
                const nextTrack = scope.invertCameraTrack(nextDist + scope._tbRadius);
                const nextDelta = nextTrack - scope.trackPos;
                console.log(dollyScale, scope._tbRadius);
                // const nextDelta = trackDelta + (dollyScale - 1)
                const minDelta = scope.trackPos * -1;
                const maxDelta = 1 - scope.trackPos;
                const clampedDelta = Math.min(maxDelta, Math.max(minDelta, nextDelta));
                // trackDelta += (dollyScale - 1);
                trackDelta = clampedDelta;
            } else if (scope.camera.isOrthographicCamera) {
                scope.camera.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.camera.zoom * dollyScale));
                scope.camera.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        function dollyIn(dollyScale) {
            if (scope.camera.isPerspectiveCamera) {
                const nextDelta = trackDelta - (dollyScale - 1);
                const minDelta = scope.trackPos * -1;
                const maxDelta = 1 - scope.trackPos;
                const clampedDelta = Math.min(maxDelta, Math.max(minDelta, nextDelta));
                // trackDelta += (dollyScale - 1);
                trackDelta = clampedDelta;
            } else if (scope.camera.isOrthographicCamera) {
                scope.camera.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.camera.zoom / dollyScale));
                scope.camera.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        //
        // event callbacks - update the object state
        //
        function handleMouseDownRotate(event) {
            scope.setCenter(event.clientX, event.clientY);
            updateStartArcballCursorPosition(scope._center.x, scope._center.y);
        }
        function handleMouseDownDolly(event) {
            dollyStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownPan(event) {
            panStart.set(event.clientX, event.clientY);
        }
        function handleMouseMoveRotate(event) {
            // scope.setCenter(event.clientX, event.clientY)
            updateCurrentArcballCursorPosition(scope._center.x, scope._center.y);
            {
                const distance = scope._startCursorPosition.distanceTo(scope._currentCursorPosition);
                const angle = scope._startCursorPosition.angleTo(scope._currentCursorPosition);
                const amount = Math.max(distance / scope._tbRadius, angle) // effective rotation angle
                ;
                rotateDelta.subVectors(scope._currentCursorPosition, scope._startCursorPosition);
                rotateDelta.normalize();
                rotateDelta.multiplyScalar(amount);
            }
            const rotateDeltaFlick = scope._v2_1;
            {
                const distance = scope._startCursorPositionFlick.distanceTo(scope._currentCursorPositionFlick);
                const angle = scope._startCursorPositionFlick.angleTo(scope._currentCursorPositionFlick);
                const amount = Math.max(distance / scope._flickTbRadius, angle) // effective rotation angle
                ;
                rotateDeltaFlick.subVectors(scope._currentCursorPositionFlick, scope._startCursorPositionFlick);
                rotateDeltaFlick.normalize();
                rotateDeltaFlick.multiplyScalar(amount);
            }
            scope._startCursorPosition.copy(scope._currentCursorPosition);
            scope._startCursorPositionFlick.copy(scope._currentCursorPositionFlick);
            rotateDelta.y *= -1;
            rotateDeltaFlick.y *= -1;
            const latCircumference = Math.sin((90 - Math.abs(scope._lngLat.y)) * (0, $d6f1a4944061be51$export$460c4029b1a54a2e)) * scope._tbRadius * 2 * Math.PI;
            const equatorCircumference = scope._tbRadius * 2 * Math.PI;
            let rotateLeftFactor = latCircumference / equatorCircumference;
            if (rotateLeftFactor < 0.4) // Workaround for weird bug
            rotateLeftFactor = 1;
            scope.rotateLeft(rotateDelta.x / rotateLeftFactor);
            scope.rotateUp(rotateDelta.y);
            rotateStart.copy(rotateEnd);
            if (scope.enableAnimations) {
                const horizontalSpeed = rotateDelta.x / rotateLeftFactor;
                const verticalSpeed = rotateDelta.y;
                scope._timePrev = scope._timeCurrent;
                scope._timeCurrent = performance.now();
                // scope._anglePrev = scope._angleCurrent;
                // scope._angleCurrent = amount;
                scope._cursorPosPrev.copy(scope._cursorPosCurr);
                scope._cursorPosCurr.copy(scope._currentCursorPosition);
                scope._wPrev.copy(scope._wCurr);
                scope._wCurr.set(horizontalSpeed, verticalSpeed);
                const horizontalFlickSpeed = rotateDeltaFlick.x / rotateLeftFactor;
                const verticalFlickSpeed = rotateDeltaFlick.y;
                scope._wFlickPrev.copy(scope._wFlickCurr);
                scope._wFlickCurr.set(horizontalFlickSpeed, verticalFlickSpeed);
            }
            scope.update();
        }
        function handleMouseMoveDolly(event) {
            dollyEnd.set(event.clientX, event.clientY);
            dollyDelta.subVectors(dollyEnd, dollyStart);
            if (dollyDelta.y > 0) dollyOut(getZoomScale());
            else if (dollyDelta.y < 0) dollyIn(getZoomScale());
            dollyStart.copy(dollyEnd);
            scope.update();
        }
        function handleMouseMovePan(event) {
            panEnd.set(event.clientX, event.clientY);
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
            scope.update();
        }
        function handleMouseWheel(event) {
            if (event.deltaY !== 0) dollyIn(getZoomScale() * event.deltaY / 4 / 530 + 1);
            // if ( event.deltaY < 0 ) {
            // 	dollyIn( getZoomScale() );
            // } else if ( event.deltaY > 0 ) {
            // 	dollyOut( getZoomScale() );
            // }
            scope.update();
        }
        function handleKeyDown(event) {
            let needsUpdate = false;
            switch(event.code){
                case scope.keys.UP:
                    pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.BOTTOM:
                    pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.LEFT:
                    pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
                case scope.keys.RIGHT:
                    pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
            }
            if (needsUpdate) {
                // prevent the browser from scrolling on cursor keys
                event.preventDefault();
                scope.update();
            }
        }
        function handleTouchStartRotate() {
            if (pointers.length === 1) scope.setCenter(pointers[0].clientX, pointers[0].clientY);
            else {
                const x = 0.5 * (pointers[0].clientX + pointers[1].clientX);
                const y = 0.5 * (pointers[0].clientY + pointers[1].clientY);
                scope.setCenter(x, y);
            }
            updateStartArcballCursorPosition(scope._center.x, scope._center.y);
            updateCurrentArcballCursorPosition(scope._center.x, scope._center.y);
        }
        function handleTouchStartPan() {
            if (pointers.length === 1) panStart.set(pointers[0].clientX, pointers[0].clientY);
            else {
                const x = 0.5 * (pointers[0].clientX + pointers[1].clientX);
                const y = 0.5 * (pointers[0].clientY + pointers[1].clientY);
                panStart.set(x, y);
            }
        }
        function handleTouchStartDolly() {
            const dx = pointers[0].clientX - pointers[1].clientX;
            const dy = pointers[0].clientY - pointers[1].clientY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            scope._dollyStartDist = trackData.distance - scope._tbRadius;
            dollyStart.set(0, distance);
        }
        function handleTouchStartDollyPan() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enablePan) handleTouchStartPan();
        }
        function handleTouchStartDollyRotate() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enableRotate) handleTouchStartRotate();
        }
        /**
         *
         * @param {Number} x
         * @param {Number} y
         */ function updateCurrentArcballCursorPosition(x, y) {
            const cameraDistance = scope.camera.position.distanceTo(scope._gizmoPosition);
            const cameraType = scope.camera.type;
            const projectionMatrixInverse = scope.camera.projectionMatrixInverse;
            scope._currentCursorPosition.copy($d8c40d4165631fec$var$unprojectOnTbSurface(projectionMatrixInverse, cameraType, cameraDistance, x, y, scope.domElement, scope._tbRadius, scope._gizmoPosition));
            scope._currentCursorPositionFlick.copy($d8c40d4165631fec$var$unprojectOnTbSurface(projectionMatrixInverse, cameraType, cameraDistance, x, y, scope.domElement, scope._flickTbRadius, scope._gizmoPosition));
        }
        /**
         *
         * @param {Number} x
         * @param {Number} y
         */ function updateStartArcballCursorPosition(x, y) {
            const cameraDistance = scope.camera.position.distanceTo(scope._gizmoPosition);
            const cameraType = scope.camera.type;
            const projectionMatrixInverse = scope.camera.projectionMatrixInverse;
            scope._startCursorPosition.copy($d8c40d4165631fec$var$unprojectOnTbSurface(projectionMatrixInverse, cameraType, cameraDistance, x, y, scope.domElement, scope._tbRadius, scope._gizmoPosition));
            scope._startCursorPositionFlick.copy($d8c40d4165631fec$var$unprojectOnTbSurface(projectionMatrixInverse, cameraType, cameraDistance, x, y, scope.domElement, scope._flickTbRadius, scope._gizmoPosition));
        }
        function handleTouchMoveRotate(event) {
            // scope.setCenter(event.clientX, event.clientY)
            // if (pointers.length == 1) {
            // rotateEnd.set(event.clientX, event.clientY);
            // } else {
            // 	const position = getSecondPointerPosition(event);
            // 	const x = 0.5 * (event.clientX + position.x);
            // 	const y = 0.5 * (event.clientY + position.y);
            // rotateEnd.set(x, y);
            // }
            if (pointers.length === 1) scope.setCenter(event.clientX, event.clientY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.clientX + position.x);
                const y = 0.5 * (event.clientY + position.y);
                scope.setCenter(x, y);
                if (scope._pointersLengthPrev === 1) // Prevent the view from "jumping" when a second pointer is added
                updateStartArcballCursorPosition(scope._center.x, scope._center.y);
            }
            scope._pointersLengthPrev = pointers.length;
            updateCurrentArcballCursorPosition(scope._center.x, scope._center.y);
            {
                const distance = scope._startCursorPosition.distanceTo(scope._currentCursorPosition);
                const angle = scope._startCursorPosition.angleTo(scope._currentCursorPosition);
                const amount = Math.max(distance / scope._tbRadius, angle) // effective rotation angle
                ;
                rotateDelta.subVectors(scope._currentCursorPosition, scope._startCursorPosition);
                rotateDelta.normalize();
                rotateDelta.multiplyScalar(amount);
            }
            const rotateDeltaFlick = scope._v2_1;
            {
                const distance = scope._startCursorPositionFlick.distanceTo(scope._currentCursorPositionFlick);
                const angle = scope._startCursorPositionFlick.angleTo(scope._currentCursorPositionFlick);
                const amount = Math.max(distance / scope._flickTbRadius, angle) // effective rotation angle
                ;
                rotateDeltaFlick.subVectors(scope._currentCursorPositionFlick, scope._startCursorPositionFlick);
                rotateDeltaFlick.normalize();
                rotateDeltaFlick.multiplyScalar(amount);
            }
            scope._startCursorPosition.copy(scope._currentCursorPosition);
            scope._startCursorPositionFlick.copy(scope._currentCursorPositionFlick);
            rotateDelta.y *= -1;
            rotateDeltaFlick.y *= -1;
            const latCircumference = Math.sin((90 - Math.abs(scope._lngLat.y)) * (0, $d6f1a4944061be51$export$460c4029b1a54a2e)) * scope._tbRadius * 2 * Math.PI;
            const equatorCircumference = scope._tbRadius * 2 * Math.PI;
            let rotateLeftFactor = latCircumference / equatorCircumference;
            if (rotateLeftFactor < 0.4) // Workaround for weird bug
            rotateLeftFactor = 1;
            scope.rotateLeft(rotateDelta.x / rotateLeftFactor);
            scope.rotateUp(rotateDelta.y);
            if (scope.enableAnimations) {
                const horizontalSpeed = rotateDelta.x / rotateLeftFactor;
                const verticalSpeed = rotateDelta.y;
                scope._timePrev = scope._timeCurrent;
                scope._timeCurrent = performance.now();
                // scope._anglePrev = scope._angleCurrent;
                // scope._angleCurrent = amount;
                scope._cursorPosPrev.copy(scope._cursorPosCurr);
                scope._cursorPosCurr.copy(scope._currentCursorPosition);
                scope._wPrev.copy(scope._wCurr);
                scope._wCurr.set(horizontalSpeed, verticalSpeed);
                const horizontalFlickSpeed = rotateDeltaFlick.x / rotateLeftFactor;
                const verticalFlickSpeed = rotateDeltaFlick.y;
                scope._wFlickPrev.copy(scope._wFlickCurr);
                scope._wFlickCurr.set(horizontalFlickSpeed, verticalFlickSpeed);
            }
        // rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
        // const element = scope.domElement;
        // rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
        // rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
        // rotateStart.copy(rotateEnd);
        }
        function handleTouchMovePan(event) {
            if (pointers.length === 1) panEnd.set(event.clientX, event.clientY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.clientX + position.x);
                const y = 0.5 * (event.clientY + position.y);
                panEnd.set(x, y);
            }
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
        }
        function handleTouchMoveDolly(event) {
            const position = getSecondPointerPosition(event);
            const dx = event.clientX - position.x;
            const dy = event.clientY - position.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyEnd.set(0, distance);
            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
            const nextDist = scope._dollyStartDist * (1 / dollyDelta.y);
            let nextTrack = scope.invertCameraTrack(nextDist + scope._tbRadius);
            if (isNaN(nextTrack)) nextTrack = 1;
            const nextDelta = nextTrack - scope.trackPos;
            // console.log(dollyScale, scope._tbRadius)
            // const nextDelta = trackDelta + (dollyScale - 1)
            const minDelta = scope.trackPos * -1;
            const maxDelta = 1 - scope.trackPos;
            const clampedDelta = Math.min(maxDelta, Math.max(minDelta, nextDelta));
            // trackDelta += (dollyScale - 1);
            trackDelta = clampedDelta;
            scope._dollyStartDist = scope.cameraTrack(nextTrack).distance - scope._tbRadius;
            dollyStart.copy(dollyEnd);
        }
        function handleTouchMoveDollyPan(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enablePan) handleTouchMovePan(event);
        }
        function handleTouchMoveDollyRotate(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enableRotate) handleTouchMoveRotate(event);
        }
        //
        // event handlers - FSM: listen for events and reset state
        //
        function onPointerDown(event) {
            if (scope.enabled === false) return;
            if (pointers.length === 0) {
                scope.domElement.setPointerCapture(event.pointerId);
                scope.domElement.addEventListener("pointermove", onPointerMove);
                scope.domElement.addEventListener("pointerup", onPointerUp);
            }
            //
            addPointer(event);
            if (event.pointerType === "touch") onTouchStart(event);
            else onMouseDown(event);
        }
        function onPointerMove(event) {
            if (scope.enabled === false) return;
            // "break" any focus maneuver
            if (scope.isFocusing) {
                // scope.isFocusing = false
                scope.setFocusingAnimFlag(false);
                scope.setFocusingTrackFlag(false);
            }
            if (event.pointerType === "touch") onTouchMove(event);
            else onMouseMove(event);
        }
        function onPointerUp(event) {
            removePointer(event);
            if (pointers.length === 1) {
                console.log("transition to rotate");
                const pos = getSecondPointerPosition(event);
                scope.setCenter(pos.x, pos.y);
                // console.log(scope._center)
                updateCurrentArcballCursorPosition(scope._center.x, scope._center.y);
                updateStartArcballCursorPosition(scope._center.x, scope._center.y);
                scope._state = $d8c40d4165631fec$var$STATE.ROTATE;
            }
            if (pointers.length === 0) {
                scope.onSinglePanEnd();
                scope.domElement.releasePointerCapture(event.pointerId);
                scope.domElement.removeEventListener("pointermove", onPointerMove);
                scope.domElement.removeEventListener("pointerup", onPointerUp);
                scope._state = $d8c40d4165631fec$var$STATE.NONE;
            }
            scope.dispatchEvent($d8c40d4165631fec$var$_endEvent);
        }
        function onPointerCancel(event) {
            /**
             * For some reason, on chrome (and maybe others), when there's two touch pointers,
             * a single pointercancel event can invalidate BOTH of them.
             * I don't know if it's a browser bug or what, but for simplicity' sake,
             * we'll just consider a pointercancel event as invalidating all active pointers.
             */ // TODO: Consider more complex cases, like multiple pointing devices
            removeAllPointers();
            scope.domElement.removeEventListener("pointermove", onPointerMove);
            scope.domElement.removeEventListener("pointerup", onPointerUp);
            scope._state = $d8c40d4165631fec$var$STATE.NONE;
        }
        function onMouseDown(event) {
            let mouseAction;
            switch(event.button){
                case 0:
                    mouseAction = scope.mouseButtons.LEFT;
                    break;
                case 1:
                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;
                case 2:
                    mouseAction = scope.mouseButtons.RIGHT;
                    break;
                default:
                    mouseAction = -1;
            }
            switch(mouseAction){
                case (0, $8725869b83961a04$export$7177b3e430c2d7ca).DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseDownDolly(event);
                    scope._state = $d8c40d4165631fec$var$STATE.DOLLY;
                    break;
                case (0, $8725869b83961a04$export$7177b3e430c2d7ca).ROTATE:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        scope._state = $d8c40d4165631fec$var$STATE.PAN;
                    } else {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        scope._state = $d8c40d4165631fec$var$STATE.ROTATE;
                    }
                    break;
                case (0, $8725869b83961a04$export$7177b3e430c2d7ca).PAN:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        scope._state = $d8c40d4165631fec$var$STATE.ROTATE;
                    } else {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        scope._state = $d8c40d4165631fec$var$STATE.PAN;
                    }
                    break;
                default:
                    scope._state = $d8c40d4165631fec$var$STATE.NONE;
            }
            if (scope._state !== $d8c40d4165631fec$var$STATE.NONE) scope.dispatchEvent($d8c40d4165631fec$var$_startEvent);
        }
        function onMouseMove(event) {
            scope.setCenter(event.clientX, event.clientY);
            // State is getting set to -1 here mid-rotate
            if (scope.enabled === false) return;
            switch(scope._state){
                case $d8c40d4165631fec$var$STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleMouseMoveRotate(event);
                    break;
                case $d8c40d4165631fec$var$STATE.DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseMoveDolly(event);
                    break;
                case $d8c40d4165631fec$var$STATE.PAN:
                    if (scope.enablePan === false) return;
                    handleMouseMovePan(event);
                    break;
            }
        }
        function onMouseWheel(event) {
            scope.setCenter(event.clientX, event.clientY);
            if (scope.enabled === false || scope.enableZoom === false || scope._state !== $d8c40d4165631fec$var$STATE.NONE) return;
            event.preventDefault();
            scope.dispatchEvent($d8c40d4165631fec$var$_startEvent);
            console.log("wheel");
            handleMouseWheel(event);
            scope.dispatchEvent($d8c40d4165631fec$var$_endEvent);
        }
        function onKeyDown(event) {
            if (scope.enabled === false || scope.enablePan === false) return;
            handleKeyDown(event);
        }
        function onTouchStart(event) {
            trackPointer(event);
            // When the first touch is detected, switch from mouse params to touch params
            if (scope.startRotating === scope.startRotatingInitialMouse && scope.endRotating === scope.endRotatingInitialMouse) {
                scope.startRotating = scope.startRotatingInitialTouch;
                scope.endRotating = scope.endRotatingInitialTouch;
            }
            switch(pointers.length){
                case 1:
                    switch(scope.touches.ONE){
                        case (0, $8725869b83961a04$export$d46bd3ead7cc759b).ROTATE:
                            if (scope.enableRotate === false) return;
                            handleTouchStartRotate();
                            scope._state = $d8c40d4165631fec$var$STATE.ROTATE;
                            break;
                        case (0, $8725869b83961a04$export$d46bd3ead7cc759b).PAN:
                            if (scope.enablePan === false) return;
                            handleTouchStartPan();
                            scope._state = $d8c40d4165631fec$var$STATE.TOUCH_PAN;
                            break;
                        default:
                            scope._state = $d8c40d4165631fec$var$STATE.NONE;
                    }
                    break;
                case 2:
                    switch(scope.touches.TWO){
                        case (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_PAN:
                            if (scope.enableZoom === false && scope.enablePan === false) return;
                            handleTouchStartDollyPan();
                            scope._state = $d8c40d4165631fec$var$STATE.TOUCH_DOLLY_PAN;
                            break;
                        case (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                            if (scope.enableZoom === false && scope.enableRotate === false) return;
                            handleTouchStartDollyRotate();
                            scope._state = $d8c40d4165631fec$var$STATE.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            scope._state = $d8c40d4165631fec$var$STATE.NONE;
                    }
                    break;
                default:
                    scope._state = $d8c40d4165631fec$var$STATE.NONE;
            }
            if (scope._state !== $d8c40d4165631fec$var$STATE.NONE) scope.dispatchEvent($d8c40d4165631fec$var$_startEvent);
        }
        function onTouchMove(event) {
            trackPointer(event);
            switch(scope._state){
                case $d8c40d4165631fec$var$STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleTouchMoveRotate(event);
                    scope.update();
                    break;
                case $d8c40d4165631fec$var$STATE.TOUCH_PAN:
                    if (scope.enablePan === false) return;
                    handleTouchMovePan(event);
                    scope.update();
                    break;
                case $d8c40d4165631fec$var$STATE.TOUCH_DOLLY_PAN:
                    if (scope.enableZoom === false && scope.enablePan === false) return;
                    handleTouchMoveDollyPan(event);
                    scope.update();
                    break;
                case $d8c40d4165631fec$var$STATE.TOUCH_DOLLY_ROTATE:
                    if (scope.enableZoom === false && scope.enableRotate === false) return;
                    handleTouchMoveDollyRotate(event);
                    scope.update();
                    break;
                default:
                    scope._state = $d8c40d4165631fec$var$STATE.NONE;
            }
        }
        function onContextMenu(event) {
        // if (scope.enabled === false) return
        // event.preventDefault();
        }
        function addPointer(event) {
            pointers.push(event);
        }
        function removePointer(event) {
            delete pointerPositions[event.pointerId];
            for(let i = 0; i < pointers.length; i++)if (pointers[i].pointerId === event.pointerId) {
                pointers.splice(i, 1);
                return;
            }
        }
        function removeAllPointers() {
            // Not doing
            // pointerPositions = {}
            // pointers = []
            // because I don't want to make these mutable
            for(let i = 0; i < pointers.length; i++)delete pointerPositions[i];
            pointers.length = 0;
        }
        function trackPointer(event) {
            let position = pointerPositions[event.pointerId];
            if (position === undefined) {
                position = new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
                pointerPositions[event.pointerId] = position;
            }
            position.set(event.clientX, event.clientY);
        }
        function getSecondPointerPosition(event) {
            const pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
            return pointerPositions[pointer.pointerId];
        }
        //
        scope.domElement.addEventListener("contextmenu", onContextMenu);
        scope.domElement.addEventListener("pointerdown", onPointerDown);
        // scope.domElement.addEventListener("pointermove", (event) => {
        // 	scope.setCenter(event.clientX, event.clientY)
        // })
        scope.domElement.addEventListener("pointercancel", onPointerCancel);
        scope.domElement.addEventListener("wheel", onMouseWheel, {
            passive: false
        });
        // force an update at start
        this.update();
    }
    setTBRadius(radius) {
        this._tbRadius = radius;
    }
    rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
    }
    rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
    }
    /**
     * Update the trackball FSA
     * @param {STATE} newState New state of the FSA
     * @param {Boolean} updateMatrices If matriices state should be updated
     */ updateTbState(newState, updateMatrices) {
        this._state = newState;
    // if ( updateMatrices ) {
    // 	this.updateMatrixState();
    // }
    }
    /**
     *
     * @param {*} time =
     * @param {Vector2} start start position
     * @param {Vector2} end end position
     */ onFocusAnim(time, start, end) {
        this.setFocusingAnimFlag(true);
        if (this._timeStart === -1) {
            // animation start
            // this._anglePrev = 0;
            this._angleCurrent = 0;
            this._timeStart = time;
        }
        if (this._state === $d8c40d4165631fec$var$STATE.ANIMATION_FOCUS) {
            // w = w0 + alpha * t
            const deltaTime = (time - this._timeStart) / 1000;
            // const wHorizontal = w0Horizontal - (w0Horizontal * (this.dampingFactor))
            // const wVertical = w0Vertical - (w0Vertical * (this.dampingFactor))
            // TODO: change for vector and diminish magnitude
            const offset0 = this._v2_1.copy(end).sub(start);
            const d0 = offset0.length();
            const normalizedTime = deltaTime / this.focusDuration;
            // Ease out: 1 - (1 - x)^2
            const easedTime = 1 - Math.pow(1 - normalizedTime, 3);
            const d = easedTime * d0;
            // const v = angularSpeed0 + ( ( - this.tbDampingFactor ) * deltaTime );
            // const wHorizontal = w0Horizontal + ( ( - this.tbDampingFactor ) * deltaTime );
            // const wVertical = w0Vertical + ( ( - this.tbDampingFactor ) * deltaTime );
            if (normalizedTime < 1) {
                // console.log({d, d0})
                // tetha = 0.5 * alpha * t^2 + w0 * t + tetha0
                // const horizontalCurrent = 0.5 * ( - this.tbDampingFactor ) * Math.pow( deltaTime, 2 ) + w0Horizontal * deltaTime + 0;
                // const verticalCurrent = 0.5 * ( - this.tbDampingFactor ) * Math.pow( deltaTime, 2 ) + w0Vertical * deltaTime + 0;
                // const horizontalCurrent = w0.x - (this.tbDampingFactor * deltaTime)
                // const verticalCurrent = w0.y - (this.tbDampingFactor * deltaTime)
                const offset = offset0.normalize().multiplyScalar(d).add(start);
                // console.log(wHorizontal)
                // console.log(horizontalCurrent)
                // this.applyTransformMatrix( this.rotate( rotationAxis, this._angleCurrent ) );
                this._spherical.theta = offset.x;
                this._spherical.phi = offset.y;
                this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
                const self = this;
                this._animationId = window.requestAnimationFrame(function(t) {
                    self.onFocusAnim(t, start, end);
                });
            } else {
                this.setFocusingAnimFlag(false);
                this._animationId = -1;
                this._timeStart = -1;
                this.updateTbState($d8c40d4165631fec$var$STATE.NONE, false);
                // this.activateGizmos( false );
                this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
            }
        } else {
            // interrupt animation
            this.setFocusingAnimFlag(false);
            this._animationId = -1;
            this._timeStart = -1;
            if (this._state !== $d8c40d4165631fec$var$STATE.ROTATE) // this.activateGizmos( false );
            this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
        }
    }
    setFocusingAnimFlag(value) {
        this._isFocusAnim = value;
        this.isFocusing = this._isFocusAnim || this._isFocusTrack;
    }
    setFocusingTrackFlag(value) {
        this._isFocusTrack = value;
        this.isFocusing = this._isFocusAnim || this._isFocusTrack;
    }
    onSinglePanEnd() {
        if (this._state === $d8c40d4165631fec$var$STATE.ROTATE) {
            if (!this.enableRotate) return;
            if (this.enableAnimations) {
                // perform rotation animation
                const deltaTime = performance.now() - this._timeCurrent;
                if (deltaTime < 120) {
                    // const wHorizontal = ( this._wHorizontalPrev + this._wHorizontalCurr ) / 2;
                    // const wVertical = ( this._wVerticalPrev + this._wVerticalCurr ) / 2;
                    this._v2_1.addVectors(this._wFlickCurr, this._wFlickPrev).multiplyScalar(0.5);
                    // this._v2_1.clampScalar(-Infinity, this.wMax)
                    const flickSpeedRaw = this._v2_1.length();
                    const flickSpeed = $d8c40d4165631fec$var$deadzoneClamp(flickSpeedRaw, -this.wMax, this.wMax, this.flickDeadZoneRadius);
                    // Average vectors
                    this._v2_1.addVectors(this._wCurr, this._wPrev).multiplyScalar(0.5);
                    let angularSpeed = this._v2_1.length();
                    const direction = new (0, $8725869b83961a04$export$c977b3e384af9ae1)().copy(this._v2_1).normalize();
                    // Scale down angular speed
                    if (flickSpeedRaw > flickSpeed) angularSpeed = angularSpeed * (flickSpeed / flickSpeedRaw);
                    const self = this;
                    this._animationId = window.requestAnimationFrame(function(t) {
                        self.updateTbState($d8c40d4165631fec$var$STATE.ANIMATION_ROTATE, true);
                        // const rotationAxis = self.calculateRotationAxis( self._cursorPosPrev, self._cursorPosCurr );
                        // Don't pass in this._v2_1 because this is effectively asynchronous
                        self.onRotationAnim(t, angularSpeed, direction, flickSpeed);
                    });
                } else {
                    // cursor has been standing still for over 120 ms since last movement
                    this.updateTbState($d8c40d4165631fec$var$STATE.NONE, false);
                    // this.activateGizmos( false );
                    this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
                }
            } else {
                this.updateTbState($d8c40d4165631fec$var$STATE.NONE, false);
                // this.activateGizmos( false );
                this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
            }
        } else if (this._state === $d8c40d4165631fec$var$STATE.PAN || this._state === $d8c40d4165631fec$var$STATE.NONE) {
            this.updateTbState($d8c40d4165631fec$var$STATE.NONE, false);
            this.enableGrid;
            // this.activateGizmos( false );
            this.dispatchEvent($d8c40d4165631fec$var$_changeEvent);
        }
        this.dispatchEvent($d8c40d4165631fec$var$_endEvent);
    }
}
/**
 * Convert from position on arcball surface to longitude and latitude
 * @param {Vector3} arcballPos
 * @param {Vector2} cameraLngLat
 * @param {{tmpSpherical: Spherical, extraThetaOffset: number, out: Vector2}} param2
 * @return {Vector2}
 */ function $d8c40d4165631fec$var$arcballPosToMouseLngLat(arcballPos, cameraLngLat, { tmpSpherical: tmpSpherical, extraThetaOffset: extraThetaOffset, out: out }) {
    tmpSpherical.setFromVector3(arcballPos);
    const mouseLng = (0, $b2dc26e6bbd9abd7$export$1957a5a293f382a4)(tmpSpherical.theta) + 90 + cameraLngLat.x;
    const mouseLat = (0, $b2dc26e6bbd9abd7$export$154a0da1a2902c7)(tmpSpherical.phi, extraThetaOffset) + cameraLngLat.y;
    out.set(mouseLng, mouseLat);
    return out;
}
/**
 * Determine camera pos necessary to line up a certain arcball mouse position with a given lat/lng point
 * @param {Vector3} arcballPos
 * @param {Vector2} mouseLngLat
 * @param {{tmpSpherical: Spherical, extraThetaOffset: number, out: Vector2}} param2
 * @return {Vector2}
 */ function $d8c40d4165631fec$var$arcballPosToCameraLngLat(arcballPos, mouseLngLat, { tmpSpherical: tmpSpherical, extraThetaOffset: extraThetaOffset, out: out }) {
    tmpSpherical.setFromVector3(arcballPos);
    const cameraLng = mouseLngLat.x - ((0, $b2dc26e6bbd9abd7$export$1957a5a293f382a4)(tmpSpherical.theta) + 90);
    const cameraLat = mouseLngLat.y - (0, $b2dc26e6bbd9abd7$export$154a0da1a2902c7)(tmpSpherical.phi, extraThetaOffset);
    out.set(cameraLng, cameraLat);
    return out;
}
function $d8c40d4165631fec$var$clamp(x, min, max) {
    return Math.min(Math.max(x, min), max);
}
/**
 *
 * @param {Number} x
 * @param {Number} radius
 */ function $d8c40d4165631fec$var$deadzone(x, radius) {
    if (Math.abs(x) < radius) return 0;
    return x;
}
function $d8c40d4165631fec$var$deadzoneClamp(x, min, max, deadzoneRadius) {
    return $d8c40d4165631fec$var$deadzone($d8c40d4165631fec$var$clamp(x, min, max), deadzoneRadius);
}
/**
 * Unproject the cursor on the trackball surface
 * @param {THREE.Matrix4} projectionMatrixInverse
 * @param {String} cameraType
 * @param {Number} cameraDistance
 * @param {Number} cursorX Cursor horizontal coordinate on screen
 * @param {Number} cursorY Cursor vertical coordinate on screen
 * @param {HTMLElement} canvas The canvas where the renderer draws its output
 * @param {number} tbRadius The trackball radius
 * @param {Vector3} gizmoPosition The gizmo position
 * @param {{v2_1: Vector2 | undefined, v3_1: Vector3 | undefined}} scratch Scratch values to use in computing and return, for performance. If not passed in, new objects will be created
 * @returns {Vector3} The unprojected point on the trackball surface
 */ // TODO: Adapt this to take into account camera tilt?
function $d8c40d4165631fec$var$unprojectOnTbSurface(projectionMatrixInverse, cameraType, cameraDistance, cursorX, cursorY, canvas, tbRadius, gizmoPosition, { v2_1: v2param, v3_1: v3param } = {}) {
    const v2 = v2param !== undefined ? v2param : new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
    const v3 = v3param !== undefined ? v3param : new (0, $8725869b83961a04$export$64b5c384219d3699)();
    if (cameraType === "OrthographicCamera") {
        v2.copy($d8c40d4165631fec$var$getCursorPosition(cursorX, cursorY, canvas));
        v3.set(v2.x, v2.y, 0);
        const x2 = Math.pow(v2.x, 2);
        const y2 = Math.pow(v2.y, 2);
        const r2 = Math.pow(this._tbRadius, 2);
        if (x2 + y2 <= r2 * 0.5) // intersection with sphere
        v3.setZ(Math.sqrt(r2 - (x2 + y2)));
        else // intersection with hyperboloid
        v3.setZ(r2 * 0.5 / Math.sqrt(x2 + y2));
        return v3;
    } else if (cameraType === "PerspectiveCamera") {
        // unproject cursor on the near plane
        $d8c40d4165631fec$var$getCursorNDC(cursorX, cursorY, canvas, v2);
        v3.set(v2.x, v2.y, -1);
        v3.applyMatrix4(projectionMatrixInverse);
        const rayDir = v3.clone().normalize() // unprojected ray direction
        ;
        const cameraGizmoDistance = cameraDistance;
        const radius2 = Math.pow(tbRadius, 2);
        //	  camera
        //		|\
        //		| \
        //		|  \
        //	h	|	\
        //		| 	 \
        //		| 	  \
        //	_ _ | _ _ _\ _ _  near plane
        //			l
        const h = v3.z;
        const l = Math.sqrt(Math.pow(v3.x, 2) + Math.pow(v3.y, 2));
        if (l === 0) {
            // ray aligned with camera
            rayDir.set(v3.x, v3.y, tbRadius);
            return rayDir;
        }
        const m = h / l;
        const q = cameraGizmoDistance;
        /*
         * calculate intersection point between unprojected ray and trackball surface
         *|y = m * x + q
         *|x^2 + y^2 = r^2
         *
         * (m^2 + 1) * x^2 + (2 * m * q) * x + q^2 - r^2 = 0
         */ let a = Math.pow(m, 2) + 1;
        let b = 2 * m * q;
        let c = Math.pow(q, 2) - radius2;
        let delta = Math.pow(b, 2) - 4 * a * c;
        if (delta >= 0) {
            // intersection with sphere
            v2.setX((-b - Math.sqrt(delta)) / (2 * a));
            v2.setY(m * v2.x + q);
            const angle = (0, $d6f1a4944061be51$export$914076c8150813e5) * v2.angle();
            if (angle >= 45) {
                // if angle between intersection point and X' axis is >= 45°, return that point
                // otherwise, calculate intersection point with hyperboloid
                const rayLength = Math.sqrt(Math.pow(v2.x, 2) + Math.pow(cameraGizmoDistance - v2.y, 2));
                rayDir.multiplyScalar(rayLength);
                rayDir.z += cameraGizmoDistance;
                return rayDir;
            }
        }
        // intersection with hyperboloid
        /*
         *|y = m * x + q
         *|y = (1 / x) * (r^2 / 2)
         *
         * m * x^2 + q * x - r^2 / 2 = 0
         */ a = m;
        b = q;
        c = -radius2 * 0.5;
        delta = Math.pow(b, 2) - 4 * a * c;
        v2.setX((-b - Math.sqrt(delta)) / (2 * a));
        v2.setY(m * v2.x + q);
        const rayLength = Math.sqrt(Math.pow(v2.x, 2) + Math.pow(cameraGizmoDistance - v2.y, 2));
        rayDir.multiplyScalar(rayLength);
        rayDir.z += cameraGizmoDistance;
        return rayDir;
    }
}
/**
 * Calculate the cursor position in NDC
 * @param {number} x Cursor horizontal coordinate within the canvas
 * @param {number} y Cursor vertical coordinate within the canvas
 * @param {HTMLElement} canvas The canvas where the renderer draws its output
 * @param {Vector2 | undefined} out Optional vector to use for output. If this is undefined, a new Vector2 is constructed
 * @returns {Vector2} Cursor normalized position inside the canvas
 */ function $d8c40d4165631fec$var$getCursorNDC(cursorX, cursorY, canvas, out) {
    const vec = out !== undefined ? out : new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
    const canvasRect = canvas.getBoundingClientRect();
    vec.setX((cursorX - canvasRect.left) / canvasRect.width * 2 - 1);
    vec.setY((canvasRect.bottom - cursorY) / canvasRect.height * 2 - 1);
    return vec;
}
/**
 * Calculate the cursor position inside the canvas x/y coordinates with the origin being in the center of the canvas
 * @param {Number} x Cursor horizontal coordinate within the canvas
 * @param {Number} y Cursor vertical coordinate within the canvas
 * @param {HTMLElement} canvas The canvas where the renderer draws its output
 * @param {Vector2 | undefined} out Optional vector to use for output. If this is undefined, a new Vector2 is constructed
 * @returns {Vector2} Cursor position inside the canvas
 */ // ts-expect-error
function $d8c40d4165631fec$var$getCursorPosition(cursorX, cursorY, canvas, out) {
    const vec = out !== undefined ? out : new (0, $8725869b83961a04$export$c977b3e384af9ae1)();
    vec.copy(this.getCursorNDC(cursorX, cursorY, canvas, out));
    vec.x *= (this.camera.right - this.camera.left) * 0.5;
    vec.y *= (this.camera.top - this.camera.bottom) * 0.5;
    return vec;
}
/**
 * Calculate the trackball radius so that gizmo's diamater will be 2/3 of the minimum side of the camera frustum
 * @param {Camera} camera
 * @param {Vector3} gizmoPosition
 * @param {Number} radiusFactor
 * @returns {Number} The trackball radius
 */ function $d8c40d4165631fec$var$calculateTbRadius(camera, gizmoPosition, radiusFactor) {
    const distance = camera.position.distanceTo(gizmoPosition);
    if (camera.type === "PerspectiveCamera") {
        const halfFovV = (0, $d6f1a4944061be51$export$460c4029b1a54a2e) * camera.fov * 0.5 // vertical fov/2 in radians
        ;
        const halfFovH = Math.atan(camera.aspect * Math.tan(halfFovV)) // horizontal fov/2 in radians
        ;
        return Math.tan(Math.min(halfFovV, halfFovH)) * distance * radiusFactor;
    } else if (camera.type === "OrthographicCamera") return Math.min(camera.top, camera.right) * radiusFactor;
}
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move
class $d8c40d4165631fec$export$7628ccdac312035f extends $d8c40d4165631fec$export$4bce0fe8712eaf01 {
    constructor(object, domElement){
        super(object, domElement);
        this.screenSpacePanning = false // pan orthogonal to world-space direction camera.up
        ;
        this.mouseButtons.LEFT = (0, $8725869b83961a04$export$7177b3e430c2d7ca).PAN;
        this.mouseButtons.RIGHT = (0, $8725869b83961a04$export$7177b3e430c2d7ca).ROTATE;
        this.touches.ONE = (0, $8725869b83961a04$export$d46bd3ead7cc759b).PAN;
        this.touches.TWO = (0, $8725869b83961a04$export$d46bd3ead7cc759b).DOLLY_ROTATE;
    }
}



class $dcb05fea3bbeea72$export$c35d437ae5945fcd {
    static STATE = {
        initial: 0,
        delaying: 1,
        started: 2,
        finished: 3
    };
    constructor(object, property, endValue, length, delay){
        this.clock = new (0, $8725869b83961a04$export$9735c82c4bae3302)();
        this.length = length;
        // If delay is falsy, this sets it to 0, otherwise sets it to delay.
        this.delay = delay || 0;
        this.property = property;
        this.object = object;
        // Error checks
        if (typeof object[property] === "undefined") {
            console.error("Object", object, " does not have property ", property);
            throw new Error("Object" + object + " does not have property " + property);
        }
        // The start value we clone so that we're not accidentally modifying startValue when we modify the property
        this.startValue = this.clone(object[property]);
        this.endValue = endValue;
        // Create a promise to resolve once the animation completes
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        this.state = $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.initial;
    }
    // Immediately stop an animation and sets its state to finished
    kill() {
        if (this.state == $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.finished) return;
        this.state = $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.finished;
        // Maybe should reject here?
        this.reject();
    }
    setEasing(func) {
        this.easing = func;
        return this;
    }
    // Create and return a new animation with this one's state and properties on a new object
    duplicateTo(obj) {
        const animation = new $dcb05fea3bbeea72$export$c35d437ae5945fcd(obj, this.property, this.endValue, this.length, this.delay);
        // Copy over values
        animation.state = this.state;
        animation.startValue = this.clone(this.startValue);
        animation.clock.autoStart = this.clock.autoStart;
        animation.clock.startTime = this.clock.startTime;
        animation.clock.oldTime = this.clock.oldTime;
        animation.clock.elapsedTime = this.clock.elapsedTime;
        animation.clock.running = this.clock.running;
        animation.easing = this.easing;
        return animation;
    }
    update() {
        if (this.state == $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.finished) return;
        else if (this.state == $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.initial) {
            // The point of the initial state is to make sure we never start animating on the frame that the animation was created.
            // That is one of the assumptions of promises and we are trying to honor that.
            this.state = $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.delaying;
            return;
        } else if (this.state == $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.delaying) {
            // Start the delay clock
            if (!this.clock.running) this.clock.start();
            // Delay until this.delay seconds have passed (if delay is 0, this immediately goes through)
            if (this.clock.getElapsedTime() < this.delay) return;
            // Restart the clock
            this.clock.start();
            this.state = $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.started;
        }
        const now = this.clock.getElapsedTime();
        // Check if the animation is complete
        if (now >= this.length) {
            this.state = $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.finished;
            // Finalize the animation
            this.setProperty(this.endValue);
            // Resolve the promise (for code that needs to run when the animation finishes)
            this.resolve();
            return;
        }
        // Convert to unit interval
        var unitNow = now / this.length;
        if (this.easing) unitNow = this.easing(unitNow);
        this.lerpProperty(unitNow);
    }
    // Helper to set different types of property
    setProperty(property2) {
        const property = this.object[this.property];
        if (property.isColor || property.isVector3) // Color & Vector3
        property.copy(property2);
        else // Default - assumed to be number
        this.object[this.property] = property2;
    }
    // Helper to copy different types of property
    clone(property) {
        if (property.isColor || property.isVector3) // Color & Vector3
        return property.clone();
        else // Default - assumed to be number
        return property;
    }
    // Helper that lerps differently depending on the type of object property
    lerpProperty(t) {
        const property = this.object[this.property];
        if (property.isColor) // Color
        property.lerpColors(this.startValue, this.endValue, t);
        else if (property.isVector3) // Vector3
        property.lerpVectors(this.startValue, this.endValue, t);
        else {
            // Default - assumed to be number
            const currentValue = (1 - t) * this.startValue + t * this.endValue;
            this.object[this.property] = currentValue;
        }
    }
}
class $dcb05fea3bbeea72$export$4e3f75a11a2fabf5 {
    constructor(){
        // Sparse array of animations
        this.animations = [];
        // How many animations to let finish before we condense the array
        this.flushAt = 1000;
        this.nFinished = 0;
    }
    add(animation) {
        this.animations.push(animation);
        return animation;
    }
    // Get all animations acting on this object
    getAll(...objects) {
        return this.animations.filter((animation)=>animation && objects.includes(animation.object));
    }
    // Kill all animations acting apon any of these objects
    killAll(...objects) {
        this.getAll(...objects).forEach((animation)=>animation.kill());
    }
    update() {
        for(var i = 0; i < this.animations.length; i++){
            if (!this.animations[i]) continue;
            this.animations[i].update();
            if (this.animations[i].state == $dcb05fea3bbeea72$export$c35d437ae5945fcd.STATE.finished) {
                this.nFinished++;
                this.animations[i] = null;
            }
        }
        // Remove finished animations from the array, condensing it
        if (this.nFinished >= this.flushAt) {
            this.animations = this.animations.filter((animation)=>animation != null);
            this.nFinished = 0;
        }
    }
}


// Represents the triple ballot-box present in the map and election pages
class $336556d68452d639$export$b6096f165c419050 {
    // This is the template for stuff 
    static template = `
<!--<button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="all">-->
<!--    <img src = "/assets/ballotBoxAe.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="all_el_count"></div>-->
<!--      <div class = "light-gray election-label">All Positions-->
<!--&lt;!&ndash;      <span class="r3-inline-block md:r3-hidden">Elections</span>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </button><button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="federal">-->
<!--    <img src = "/assets/ballotBoxFe.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="federal_el_count"></div>-->
<!--      <div class = "light-gray election-label">Federal Positions</div>-->
<!--    </div>-->
<!--  </button>-->
<!--  <button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="state">-->
<!--    <img src = "/assets/ballotBoxSt.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="state_el_count"></div>-->
<!--      <div class = "light-gray election-label">State Positions</div>-->
<!--    </div>-->
<!--  </button>-->
<!--  <button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="local">-->
<!--    <img src = "/assets/ballotBoxLo.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="local_el_count"></div>-->
<!--      <div class = "light-gray election-label">Local Positions</div>-->
<!--    </div>-->
<!--  </button>-->
  <div class = "r3-flex go_to_my_election r3-justify-center r3-bg-button hover:r3-bg-button-hover r3-items-center r3-w-full r3-border r3-border-gray-300 r3-border-solid r3-cursor-pointer r3-rounded-lg r3-py-3 r3-px-4" data-type="all">
    <img class="r3-w-[40px] r3-mr-4" src="/assets/ballotBoxAe.webp?v=1">
    <p class="left-text r3-font-medium r3-text-lg" style="font-family: 'Libre Caslon Text', Helvetica,serif">
      All Elections
    </p>
  </div>
`;
    // This is to make sure we don't conflict with other session-using features.
    static sessionVarPrefix = "ballotbox_";
    static sessionVars = [
        "zip",
        "state",
        "county",
        "city",
        "cityName",
        "abbr"
    ];
    constructor(div, state_abbr){
        if (!state_abbr) // Try pulling state abbreviation from session storage
        state_abbr = sessionStorage.getItem($336556d68452d639$export$b6096f165c419050.sessionVarPrefix + "abbr");
        this.div = div;
        this.electionsOverview = null;
        // Put the template html in the passed-in div
        div.innerHTML = $336556d68452d639$export$b6096f165c419050.template;
        // Set the state ballot box image
        // const state_ballot_box = div.querySelector("button:nth-child(3) > img");
        // state_ballot_box.setAttribute( "src", "/assets/state_icons/" + state_abbr + ".PNG" );
        // state_ballot_box.setAttribute("src", "/assets/ballotBoxSt.webp");
        this.onLocalClick = null;
        this.onStateClick = null;
        this.onFederalClick = null;
    }
    // Set this if you want to include an elections overview link with the ballot boxes
    setElectionsOverviewDiv(div) {
    // this.electionsOverview = div;
    }
    // Clear storage to make sure we only have the relevant params in there.
    clearStorage() {
        this.clearSession();
    }
    // Stores ballot box parameters in a way that can be loaded from other pages with load()
    store(params) {
        this.clearStorage();
        this.writeToSession(params);
    }
    // Read ballot box params from persistent storage
    load() {
        return this.readFromSession();
    }
    // Stores location data in session storage in a format that can be decoded by readFromSession()
    // This allows persistance across multiple pages
    writeToSession(params) {
        for(var i = 0; i < $336556d68452d639$export$b6096f165c419050.sessionVars.length; i++){
            const key = $336556d68452d639$export$b6096f165c419050.sessionVars[i];
            // Only store keys that are actually in params
            if (typeof params[key] === "undefined") continue;
            // Do the storage
            // This will throw an exception if the storage is full
            sessionStorage.setItem($336556d68452d639$export$b6096f165c419050.sessionVarPrefix + key, params[key]);
        }
    }
    // Extract parameters from sessionStorage
    readFromSession() {
        const params = {};
        for(var i = 0; i < $336556d68452d639$export$b6096f165c419050.sessionVars.length; i++){
            const key = $336556d68452d639$export$b6096f165c419050.sessionVars[i];
            const val = sessionStorage.getItem($336556d68452d639$export$b6096f165c419050.sessionVarPrefix + key);
            // Only store values that are actually in session storage
            if (!val) continue;
            params[key] = val;
        }
        return params;
    }
    clearSession() {
        for(var i = 0; i < $336556d68452d639$export$b6096f165c419050.sessionVars.length; i++){
            const key = $336556d68452d639$export$b6096f165c419050.sessionVars[i];
            sessionStorage.removeItem($336556d68452d639$export$b6096f165c419050.sessionVarPrefix + key);
        }
    }
    // Convenience method
    loadAndUpdate() {
        this.update(this.load());
    }
    // Convenience method
    updateAndStore(params) {
        this.store(params);
        this.update(params);
    }
    // Update the ballot boxes on this page with a new location
    update(params) {
        const zip = params.zip;
        const state = api.format(params.state);
        const county = api.format(params.county);
        const city = api.format(params.city);
        const cityName = api.format(params.cityName);
        // TODO: Remove abbr and lookup abbr from state name (for all cases of abbreviation use)
        const abbr = params.abbr;
        const today = new Date();
        const oneYearFromToday = new Date(today.getTime() + 31536000000);
        // This url will be used to set button hrefs
        const url = new URL(window.location + "#");
        url.searchParams.set("type", "map-location-elections");
        // url.searchParams.set("start_date", api.format(today));
        // url.searchParams.set("end_date", api.format(oneYearFromToday));
        url.searchParams.set("state_abbr", abbr);
        //to skip API to get counts for federal and state level
        let count_is_given = 0;
        //Local box
        if (city) {
            // Update with local = city-level
            const countElement = this.div.querySelector("button:nth-child(3) .left-text .num");
            const button = this.div.querySelector("button:nth-child(3)");
            // Update button href & onclick
            const search_result_item_text = cityName + ", " + abbr;
            url.searchParams.set("search_result_item_text", search_result_item_text);
            url.searchParams.set("local", true);
            url.searchParams.set("city_id", city);
            button.addEventListener("click", ()=>{
                this.onLocalClick && this.onLocalClick();
            });
            // Update election count with api call
            const params = {
                start_date: today,
                end_date: oneYearFromToday,
                city_id: city
            };
            api.get_election_counts_by_city(params).then((data)=>{
                this.div.querySelector(`button:nth-child(3) .left-text .num`).innerText = data.payload[1] ?? 0;
                this.div.querySelector(`button:nth-child(2) .left-text .num`).innerText = data.payload[2] ?? 0;
                this.div.querySelector(`button:nth-child(1) .left-text .num`).innerText = data.payload[3] ?? 0;
            });
            count_is_given = 1;
        } else if (zip) {
            console.log("zip!");
            // Update with local =  zip-level
            const countElement = this.div.querySelector("button:nth-child(3) .left-text .num");
            const button = this.div.querySelector("button:nth-child(3)");
            // Update button href & onclick
            const search_result_item_text = zip;
            url.searchParams.set("search_result_item_text", search_result_item_text);
            url.searchParams.set("local", true);
            url.searchParams.set("zip_code", zip);
            // Update election count with api call
            const params = {
                start_date: today,
                end_date: oneYearFromToday,
                zip: zip
            };
            this.div.querySelector(`button:nth-child(3) .left-text .num`).innerText = "";
            this.div.querySelector(`button:nth-child(2) .left-text .num`).innerText = "";
            this.div.querySelector(`button:nth-child(1) .left-text .num`).innerText = "";
            //
            //  api.get_election_counts_by_zip(params).then(data => {
            //     this.div.querySelector(`button:nth-child(3) .left-text .num`).innerText = data.payload[1]?? 0
            //     this.div.querySelector(`button:nth-child(2) .left-text .num`).innerText = data.payload[2]?? 0
            //     this.div.querySelector(`button:nth-child(1) .left-text .num`).innerText = data.payload[3]?? 0
            //
            // });
            count_is_given = 1;
        } else if (county) {
            // Update with local = county level
            // This api doesn't allow the use of county name
            // We need to look up the county ID by name first
            var counties;
            const params = {
                code: abbr
            };
            const search_result_item_text = county + " County, " + abbr;
            url.searchParams.set("search_result_item_text", search_result_item_text);
            url.searchParams.set("county_id", county);
            count_is_given = 1;
            api.get_counties_for_state_by_code(params).then((data)=>{
                const countyId = Object.keys(data.payload)[Object.values(data.payload).findIndex((value)=>value.name == county)];
                const button = this.div.querySelector("button:nth-child(3)");
                // Update button href & onclick
                url.searchParams.delete("local");
                url.searchParams.delete("state");
                url.searchParams.delete("federal");
                url.searchParams.set("local", true);
                url.searchParams.set("county_id", countyId);
                // Update election count
                const params = {
                    start_date: today,
                    end_date: oneYearFromToday,
                    county_id: countyId
                };
                api.get_election_counts_by_county(params).then((data)=>{
                    //local candidates
                    console.log("ELECTIONS BY COUNTY", data.payload[1]);
                    this.div.querySelector(`button:nth-child(3) .left-text .num`).innerHTML = data.payload[1] ?? " ";
                    this.div.querySelector(`button:nth-child(2) .left-text .num`).innerHTML = data.payload[2] ?? " ";
                    this.div.querySelector(`button:nth-child(1) .left-text .num`).innerHTML = data.payload[3] ?? " ";
                });
            });
        }
        console.log(url, county);
        // Update state ballot box button
        {
            const button = this.div.querySelector("button:nth-child(2)");
            button.addEventListener("click", ()=>{
                this.onStateClick && this.onStateClick();
            });
            // Update button href & onclick
            url.searchParams.delete("local");
            url.searchParams.delete("state");
            url.searchParams.delete("federal");
            url.searchParams.set("state", true);
        }
        // Update federal ballot box button
        {
            const button = this.div.querySelector("button:nth-child(1)");
            button.addEventListener("click", ()=>{
                this.onFederalClick && this.onFederalClick();
            });
            // Update button href & onclick
            url.searchParams.delete("local");
            url.searchParams.delete("state");
            url.searchParams.delete("federal");
            url.searchParams.set("federal", true);
        }
        if (!count_is_given) {
            const params = {
                start_date: today,
                end_date: oneYearFromToday,
                state: state,
                government_level_id: 2
            };
            api.get_election_counts_by_state(params).then((data)=>{
                const countElement = this.div.querySelector("button:nth-child(2) .left-text .num");
                countElement.innerText = data.payload[state];
            });
        }
        if (!count_is_given) {
            const params = {
                start_date: today,
                end_date: oneYearFromToday,
                state: state,
                government_level_id: 3
            };
            api.get_election_counts_by_state(params).then((data)=>{
                const countElement = this.div.querySelector("button:nth-child(1) .left-text .num");
                countElement.innerText = data.payload[state];
            });
        }
        // Update elections overview link
        if (this.electionsOverview) {
            const link = this.electionsOverview.querySelector("a");
            url.searchParams.delete("local");
            url.searchParams.delete("state");
            url.searchParams.delete("federal");
        // link.href = url;
        }
    }
}


function $07dced43e21b9570$export$57636bb43b1ccbb0(t) {
    return 1 - Math.pow(t - 1, 2);
}
function $07dced43e21b9570$export$673c70fc50d17c8(t) {
    return Math.cos(t * Math.PI + Math.PI) / 2 + 0.5;
}
function $07dced43e21b9570$export$d5e9a2a6230846a3(t) {
    return Math.cos(t * Math.PI / 2 - Math.PI / 2);
}
function $07dced43e21b9570$export$bca5043c8dbb51f0(t) {
    return Math.cos(t * Math.PI / 2 - Math.PI) + 1;
}



async function $13b202410cedebbf$export$c5ecc146ef527cac() {
    const result = await api.get_states();
    const states = result.payload;
    let state_list = document.getElementById("state_list");
    let ul = document.createElement("ul");
    for(let i = 0; i < states.length; i++){
        let a = document.createElement("span");
        a.setAttribute("class", "btn");
        const abbr = states[i].code;
        const state = states[i].name;
        let li = document.createElement("li");
        li.setAttribute("name", state);
        li.setAttribute("id", abbr);
        a.appendChild(document.createTextNode(states[i].name));
        li.appendChild(a);
        ul.appendChild(li);
    }
    state_list.appendChild(ul);
}
async function $13b202410cedebbf$export$2d6b09b1a118ce82(abb, state, addLink = false, options) {
    const response = await api.get_counties_for_state_by_code({
        code: abb
    }, options);
    const county_list = document.getElementById("county_list");
    const ul = document.createElement("ul");
    const data = response.payload;
    for (let [fips, county] of Object.entries(data)){
        let name = county.name;
        let id = name.replace(/\./g, "").replace(/ /g, "_");
        /**
         * Workaround for St. Louis, Missouri county name duplicate
         *
         * St. Louis city is an independent city meaning, it's at the same governance level as a county
         * St. Louis is also the name of a county in missouri.
         * Certain parts of the code break when counties within a state share a name.
         * This workaround renames St. Louis independent city to St Louis An in the bottom bar.
         * as of 4/4/2024 St Louis the independent city has fips code 29510
         * as of 4/4/2024 St Louis the county has fips code 29189
         * @todo Rework everthing to use FIPS instead of names
         */ if (fips === "29510") id = "St_Louis_An";
        // Workaround for API stripping fips initial 0
        if (fips.toString().length == 4) fips = "0" + fips;
        let a = document.createElement("span");
        a.setAttribute("class", "btn");
        let option = document.createElement("option");
        option.setAttribute("value", name);
        option.appendChild(document.createTextNode(name));
        if (addLink) a.setAttribute("href", "/?fips=" + fips);
        let li = document.createElement("li");
        if (name == county) {
            console.log(name, county);
            ul.setAttribute("class", "selected");
            li.setAttribute("class", "selected");
            option.selected = true;
        }
        li.setAttribute("id", id);
        li.setAttribute("fips", fips);
        a.appendChild(document.createTextNode(name.replace(/\./g, "")));
        li.appendChild(a);
        ul.appendChild(li);
    }
    county_list.appendChild(ul);
    return null;
}
function $13b202410cedebbf$var$emptyCountyList() {
    const list = document.querySelector(".county_list");
    if (list) list.innerText = "";
}
/**
 * Switch the nav list from states to counties, or from one county list to another
 * @param {String} stateAbbr Two-letter abbreviation of the US state containing the county
 * @param {String} countyFips Five-letter FIPS code of the county being switched to
 * @returns {Promise} Promise that switch is complete. true if a new county list was added, false if called on the same county list that is currently loaded.
 */ let $13b202410cedebbf$var$countyListAbortController = new AbortController();
function $13b202410cedebbf$export$a3be6965b053c4b2(stateAbbr, countyFIPS) {
    let lastState = "";
    // If the state is the same as the last state, bail
    if (stateAbbr === lastState && document.querySelector(".county_list").innerText !== "") return Promise.resolve(false);
    // Save the previous county list for future deletion
    const oldList = document.querySelector(".county_list ul");
    // Set the last state
    lastState = stateAbbr;
    // Add the new county list
    return $13b202410cedebbf$export$2d6b09b1a118ce82(stateAbbr, undefined, false, {
        signal: $13b202410cedebbf$var$countyListAbortController.signal
    }).then(()=>{
        $13b202410cedebbf$var$countyListAbortController.abort();
        $13b202410cedebbf$var$countyListAbortController = new AbortController();
        console.log("adding county list");
        // Remove the old list
        oldList?.remove();
        // Hide "United States of America"
        document.querySelector("#USA").classList.add("hidden");
        // Not sure what this does
        document.querySelector(".state_list ul").classList.add("selected");
        // Hide every other state button
        document.querySelectorAll(".state_list ul li").forEach((ele)=>{
            if (ele.getAttribute("id") === stateAbbr) {
                ele.classList.add("selected");
                ele.classList.remove("highlighted");
                ele.classList.remove("hidden");
                return;
            }
            ele.classList.remove("selected");
            ele.classList.add("hidden");
        });
        return true;
    });
}
function $13b202410cedebbf$export$4312e47d220a770(stateAbbr) {
    document.querySelector("#USA").classList.remove("hidden");
    document.querySelector(".state_list ul")?.classList.remove("selected");
    document.querySelectorAll(".state_list ul li").forEach((ele)=>{
        if (ele.getAttribute("id") === stateAbbr) {
            ele.classList.remove("selected");
            ele.classList.add("highlighted");
            ele.classList.remove("hidden");
            return;
        }
        ele.classList.remove("selected");
        ele.classList.remove("hidden");
    });
    document.querySelector(".county_list").innerText = "";
}
function $13b202410cedebbf$export$3eb846f1539800e9() {
    document.querySelector("#USA").classList.remove("hidden");
    document.querySelector(".state_list ul")?.classList.remove("selected");
    document.querySelectorAll(".state_list ul li").forEach((ele)=>{
        ele.classList.add("hidden");
        ele.classList.remove("highlighted");
        ele.classList.remove("selected");
    });
    document.querySelector(".county_list").innerText = "";
}
function $13b202410cedebbf$export$7e4b7e6b8ee74890(listName) {
    const ul = document.querySelector("." + listName + " ul");
    let li = document.querySelector("." + listName + " ul li.highlighted");
    if (!li) li = document.querySelector("." + listName + " ul li.selected");
    const r1 = ul.getBoundingClientRect();
    const r2 = li.getBoundingClientRect();
    if (!r2.height || !r1.height) return false;
    let position = r2.x - r1.x + ul.scrollLeft - window.innerWidth / 2 + r2.width / 2;
    ul.scrollTo({
        left: position,
        behavior: "smooth"
    });
    return true;
}
function $13b202410cedebbf$export$12a61d1debd08025(button) {
    const list = button.parentElement.querySelector(".drop-list");
    list.classList.toggle("hidden");
    const arrow = button.querySelector(".drop-arrow");
    arrow.classList.toggle("dropped");
}
function $13b202410cedebbf$export$d8d12a9e4b6ad77c(button) {
    const list = button.parentElement.querySelector(".drop-list");
    list.classList.remove("hidden");
    const arrow = button.querySelector(".drop-arrow");
    arrow.classList.add("dropped");
}
function $13b202410cedebbf$export$dd5f0da9fea03300(button) {
    const list = button.parentElement.querySelector(".drop-list");
    list.classList.add("hidden");
    const arrow = button.querySelector(".drop-arrow");
    arrow.classList.remove("dropped");
}





class $edff8fb537ccec3f$export$110709f040143804 {
    constructor(leftDiv, walkthroughVideo){
        this.leftDiv = leftDiv;
        this.walkthroughVideo = walkthroughVideo;
        // Set event listener for toggling the zip dropdown
        const button = leftDiv.querySelector("#zip-code-container > button");
        button.addEventListener("click", ()=>(0, $13b202410cedebbf$export$12a61d1debd08025)(button));
    }
    /**
     * Show the left panel
     */ hide() {
        this.leftDiv.classList.add("offscreen-left");
        this.walkthroughVideo.classList.remove("slide-right");
        $("#menu-bar-type-2").removeClass("bg-primary");
        let search = document.querySelector("#search_bar");
        search.classList.remove("hide-mobile");
        // $("#search_bar").show();
        $(".site-header-menu-bar").addClass("pushed");
        $(".wrapper").addClass("pushed");
        $("#map-container").addClass("pushed");
    }
    /**
     * Hide the left panel
     */ show() {
        this.leftDiv.classList.remove("offscreen-left");
        this.walkthroughVideo.classList.add("slide-right");
        $("#menu-bar-type-2").addClass("bg-primary");
        let search = document.querySelector("#search_bar");
        if (search) {
            search.classList.add("hide-mobile");
            search.classList.add("left-panel-open");
        }
        // $("#search_bar").hide();
        $(".site-header-menu-bar").removeClass("pushed");
        $(".wrapper").removeClass("pushed");
        $("#map-container").removeClass("pushed");
    }
    /**
     * Update the left panel with a new county's information
     * @param {String} name Name of the county
     */ setCounty(name) {
        const countyNameHeader = this.leftDiv.querySelector(".sidebar-header");
        countyNameHeader.innerText = name + " County";
    }
    setupZipButtons(geojson, onZipMouseOver, onZipMouseLeave, onZipClick) {
        const list = this.leftDiv.querySelector("#zip-drop-list ul");
        this.fillZipList(list, geojson, onZipMouseOver, onZipMouseLeave, onZipClick);
    }
    /**
     * Create a dropdown element used in the zip, city, and schoolboard dropdowns
     * @param {String} text text to display on the item
     * @returns {Element} the created li element
     */ createDropdownItem(text) {
        const item = document.createElement("li");
        item.classList.add("flex-row");
        item.classList.add("flex-space");
        const zipDiv = document.createElement("div");
        zipDiv.innerText = text;
        const arrow = document.createElement("img");
        arrow.setAttribute("src", "/assets/thin-arrow-gray.svg");
        const button = document.createElement("button");
        button.append(zipDiv);
        button.append(arrow);
        item.append(button);
        return item;
    }
    fillZipList(list, geojson, onZipMouseOver, onZipMouseLeave, onZipClick) {
        // Empty the previous zip list
        list.innerText = "";
        console.log(geojson);
        const features = geojson.features.map((feature, index)=>({
                zip: feature.properties.GEOID20,
                index: index
            }));
        features.sort((a, b)=>a.zip > b.zip ? 1 : -1);
        for(var i = 0; i < features.length; i++){
            const zip = features[i].zip;
            // id corresponds to the index of the feature within the geojson file
            // This is set with generateId: true in map.addSource
            const id = features[i].index;
            // Add the zipcode list element
            const item = this.createDropdownItem(zip);
            list.append(item);
            const button = item.querySelector("button");
            button.onmouseover = function() {
                onZipMouseOver(zip, id);
            };
            button.onmouseout = function() {
                onZipMouseLeave(zip, id);
            };
            button.onclick = function() {
                onZipClick(zip, id);
            // toggleDropdown(this.listDiv.querySelector("#zip-code-container button"));
            };
        }
    }
}


class $4ec851b782047d0d$export$19529cff8faf2696 {
    static _id = 0;
    constructor(obj){
        this.object = obj;
        this._id = $4ec851b782047d0d$export$19529cff8faf2696._id;
        $4ec851b782047d0d$export$19529cff8faf2696._id++;
    }
    is(loadEvent) {
        return this._id === loadEvent._id;
    }
}




var $7ArpZ = parcelRequire("7ArpZ");

// Helpers
// Get the screen-space rectangle that describes the window that the user can see on the canvas
var $4968fe2ddf6410c8$exports = {};
"use strict";
$4968fe2ddf6410c8$exports = $4968fe2ddf6410c8$var$Point;
/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */ function $4968fe2ddf6410c8$var$Point(x, y) {
    this.x = x;
    this.y = y;
}
$4968fe2ddf6410c8$var$Point.prototype = {
    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */ clone: function() {
        return new $4968fe2ddf6410c8$var$Point(this.x, this.y);
    },
    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ add: function(p) {
        return this.clone()._add(p);
    },
    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ sub: function(p) {
        return this.clone()._sub(p);
    },
    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ multByPoint: function(p) {
        return this.clone()._multByPoint(p);
    },
    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */ divByPoint: function(p) {
        return this.clone()._divByPoint(p);
    },
    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */ mult: function(k) {
        return this.clone()._mult(k);
    },
    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */ div: function(k) {
        return this.clone()._div(k);
    },
    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */ rotate: function(a) {
        return this.clone()._rotate(a);
    },
    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */ rotateAround: function(a, p) {
        return this.clone()._rotateAround(a, p);
    },
    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */ matMult: function(m) {
        return this.clone()._matMult(m);
    },
    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */ unit: function() {
        return this.clone()._unit();
    },
    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */ perp: function() {
        return this.clone()._perp();
    },
    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */ round: function() {
        return this.clone()._round();
    },
    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */ mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */ equals: function(other) {
        return this.x === other.x && this.y === other.y;
    },
    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */ dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },
    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */ distSqr: function(p) {
        var dx = p.x - this.x, dy = p.y - this.y;
        return dx * dx + dy * dy;
    },
    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */ angle: function() {
        return Math.atan2(this.y, this.x);
    },
    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */ angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },
    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */ angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },
    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */ angleWithSep: function(x, y) {
        return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
    },
    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y, y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },
    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },
    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },
    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },
    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },
    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },
    _unit: function() {
        this._div(this.mag());
        return this;
    },
    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },
    _rotate: function(angle) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },
    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y), y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },
    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};
/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */ $4968fe2ddf6410c8$var$Point.convert = function(a) {
    if (a instanceof $4968fe2ddf6410c8$var$Point) return a;
    if (Array.isArray(a)) return new $4968fe2ddf6410c8$var$Point(a[0], a[1]);
    return a;
};


var $30510d2f060a5cf8$exports = {};
/* MapLibre GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v3.1.0/LICENSE.txt */ (function(global, factory) {
    $30510d2f060a5cf8$exports = factory();
})($30510d2f060a5cf8$exports, function() {
    "use strict";
    /* eslint-disable */ var shared, worker, maplibregl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk);";
            var sharedChunk = {};
            shared(sharedChunk);
            maplibregl = chunk(sharedChunk);
            if (typeof window !== "undefined") maplibregl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        "use strict";
        function e1(t1) {
            return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
        }
        var r = n;
        function n(t1, e1) {
            this.x = t1, this.y = e1;
        }
        n.prototype = {
            clone: function() {
                return new n(this.x, this.y);
            },
            add: function(t1) {
                return this.clone()._add(t1);
            },
            sub: function(t1) {
                return this.clone()._sub(t1);
            },
            multByPoint: function(t1) {
                return this.clone()._multByPoint(t1);
            },
            divByPoint: function(t1) {
                return this.clone()._divByPoint(t1);
            },
            mult: function(t1) {
                return this.clone()._mult(t1);
            },
            div: function(t1) {
                return this.clone()._div(t1);
            },
            rotate: function(t1) {
                return this.clone()._rotate(t1);
            },
            rotateAround: function(t1, e1) {
                return this.clone()._rotateAround(t1, e1);
            },
            matMult: function(t1) {
                return this.clone()._matMult(t1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t1) {
                return this.x === t1.x && this.y === t1.y;
            },
            dist: function(t1) {
                return Math.sqrt(this.distSqr(t1));
            },
            distSqr: function(t1) {
                var e1 = t1.x - this.x, r = t1.y - this.y;
                return e1 * e1 + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t1) {
                return Math.atan2(this.y - t1.y, this.x - t1.x);
            },
            angleWith: function(t1) {
                return this.angleWithSep(t1.x, t1.y);
            },
            angleWithSep: function(t1, e1) {
                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
            },
            _matMult: function(t1) {
                var e1 = t1[2] * this.x + t1[3] * this.y;
                return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e1, this;
            },
            _add: function(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            },
            _sub: function(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            },
            _mult: function(t1) {
                return this.x *= t1, this.y *= t1, this;
            },
            _div: function(t1) {
                return this.x /= t1, this.y /= t1, this;
            },
            _multByPoint: function(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            },
            _divByPoint: function(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t1 = this.y;
                return this.y = this.x, this.x = -t1, this;
            },
            _rotate: function(t1) {
                var e1 = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e1 * this.y;
                return this.x = e1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t1, e1) {
                var r = Math.cos(t1), n = Math.sin(t1), i = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                return this.x = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, n.convert = function(t1) {
            return t1 instanceof n ? t1 : Array.isArray(t1) ? new n(t1[0], t1[1]) : t1;
        };
        var i = e1(r), a = s;
        function s(t1, e1, r, n) {
            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e1, this.p2x = r, this.p2y = n;
        }
        s.prototype = {
            sampleCurveX: function(t1) {
                return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
            },
            sampleCurveY: function(t1) {
                return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
            },
            sampleCurveDerivativeX: function(t1) {
                return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
            },
            solveCurveX: function(t1, e1) {
                if (void 0 === e1 && (e1 = 1e-6), t1 < 0) return 0;
                if (t1 > 1) return 1;
                for(var r = t1, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t1;
                    if (Math.abs(i) < e1) return r;
                    var a = this.sampleCurveDerivativeX(r);
                    if (Math.abs(a) < 1e-6) break;
                    r -= i / a;
                }
                var s = 0, o = 1;
                for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e1)); n++)t1 > i ? s = r : o = r, r = .5 * (o - s) + s;
                return r;
            },
            solve: function(t1, e1) {
                return this.sampleCurveY(this.solveCurveX(t1, e1));
            }
        };
        var o = e1(a);
        function l(t1, e1, r, n) {
            const i = new o(t1, e1, r, n);
            return function(t1) {
                return i.solve(t1);
            };
        }
        const u = l(.25, .1, .25, 1);
        function c(t1, e1, r) {
            return Math.min(r, Math.max(e1, t1));
        }
        function h(t1, e1, r) {
            const n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
            return i === e1 ? r : i;
        }
        function p(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        let f = 1;
        function d(t1, e1) {
            t1.forEach((t1)=>{
                e1[t1] && (e1[t1] = e1[t1].bind(e1));
            });
        }
        function y(t1, e1, r) {
            const n = {};
            for(const i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
            return n;
        }
        function m(t1, e1, r) {
            const n = {};
            for(const i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
            return n;
        }
        function g(t1) {
            return Array.isArray(t1) ? t1.map(g) : "object" == typeof t1 && t1 ? y(t1, g) : t1;
        }
        const x = {};
        function v(t1) {
            x[t1] || ("undefined" != typeof console && console.warn(t1), x[t1] = !0);
        }
        function b(t1, e1, r) {
            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
        }
        function w(t1) {
            let e1 = 0;
            for(let r, n, i = 0, a = t1.length, s = a - 1; i < a; s = i++)r = t1[i], n = t1[s], e1 += (n.x - r.x) * (r.y + n.y);
            return e1;
        }
        function _() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        let A = null;
        function k(t1) {
            if (null == A) {
                const e1 = t1.navigator ? t1.navigator.userAgent : null;
                A = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
            }
            return A;
        }
        function S(t1) {
            return "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap;
        }
        const I = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let z, M;
        const P = {
            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
            frame (t1) {
                const e1 = requestAnimationFrame(t1);
                return {
                    cancel: ()=>cancelAnimationFrame(e1)
                };
            },
            getImageData (t1, e1 = 0) {
                return this.getImageCanvasContext(t1).getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
            },
            getImageCanvasContext (t1) {
                const e1 = window.document.createElement("canvas"), r = e1.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!r) throw new Error("failed to create canvas 2d context");
                return e1.width = t1.width, e1.height = t1.height, r.drawImage(t1, 0, 0, t1.width, t1.height), r;
            },
            resolveURL: (t1)=>(z || (z = document.createElement("a")), z.href = t1, z.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return !!matchMedia && (null == M && (M = matchMedia("(prefers-reduced-motion: reduce)")), M.matches);
            }
        }, B = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        class C extends Error {
            constructor(t1, e1, r, n){
                super(`AJAXError: ${e1} (${t1}): ${r}`), this.status = t1, this.statusText = e1, this.url = r, this.body = n;
            }
        }
        const V = _() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === window.location.protocol ? window.parent : window).location.href, E = (t1)=>B.REGISTERED_PROTOCOLS[t1.substring(0, t1.indexOf("://"))];
        function F(t1, e1) {
            const r = new AbortController, n = new Request(t1.url, {
                method: t1.method || "GET",
                body: t1.body,
                credentials: t1.credentials,
                headers: t1.headers,
                referrer: V(),
                signal: r.signal
            });
            let i = !1, a = !1;
            "json" === t1.type && n.headers.set("Accept", "application/json");
            return a || fetch(n).then((r)=>r.ok ? ((r)=>{
                    ("arrayBuffer" === t1.type || "image" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then((t1)=>{
                        a || (i = !0, e1(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                    }).catch((t1)=>{
                        a || e1(new Error(t1.message));
                    });
                })(r) : r.blob().then((n)=>e1(new C(r.status, r.statusText, t1.url, n)))).catch((t1)=>{
                20 !== t1.code && e1(new Error(t1.message));
            }), {
                cancel: ()=>{
                    a = !0, i || r.abort();
                }
            };
        }
        const T = function(t1, e1) {
            if (/:\/\//.test(t1.url) && !/^https?:|^file:/.test(t1.url)) {
                if (_() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1);
                if (!_()) return (E(t1.url) || F)(t1, e1);
            }
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(V()) && !/^\w+:/.test(r))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return F(t1, e1);
                if (_() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1, void 0, !0);
            }
            var r;
            return function(t1, e1) {
                const r = new XMLHttpRequest;
                r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" !== t1.type && "image" !== t1.type || (r.responseType = "arraybuffer");
                for(const e1 in t1.headers)r.setRequestHeader(e1, t1.headers[e1]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = ()=>{
                    e1(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e1(t1);
                        }
                        e1(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else {
                        const n = new Blob([
                            r.response
                        ], {
                            type: r.getResponseHeader("Content-Type")
                        });
                        e1(new C(r.status, r.statusText, t1.url, n));
                    }
                }, r.send(t1.body), {
                    cancel: ()=>r.abort()
                };
            }(t1, e1);
        }, L = function(t1, e1) {
            return T(p(t1, {
                type: "arrayBuffer"
            }), e1);
        };
        function $(t1) {
            if (!t1 || t1.indexOf("://") <= 0 || 0 === t1.indexOf("data:image/") || 0 === t1.indexOf("blob:")) return !0;
            const e1 = new URL(t1), r = window.location;
            return e1.protocol === r.protocol && e1.host === r.host;
        }
        function D(t1, e1, r) {
            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
        }
        function O(t1, e1, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e1);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class U {
            constructor(t1, e1 = {}){
                p(this, e1), this.type = t1;
            }
        }
        class R extends U {
            constructor(t1, e1 = {}){
                super("error", p({
                    error: t1
                }, e1));
            }
        }
        class q {
            on(t1, e1) {
                return this._listeners = this._listeners || {}, D(t1, e1, this._listeners), this;
            }
            off(t1, e1) {
                return O(t1, e1, this._listeners), O(t1, e1, this._oneTimeListeners), this;
            }
            once(t1, e1) {
                return e1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, D(t1, e1, this._oneTimeListeners), this) : new Promise((e1)=>this.once(t1, e1));
            }
            fire(t1, e1) {
                "string" == typeof t1 && (t1 = new U(t1, e1 || {}));
                const r = t1.type;
                if (this.listens(r)) {
                    t1.target = this;
                    const e1 = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e1)r.call(this, t1);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e1 of n)O(r, e1, this._oneTimeListeners), e1.call(this, t1);
                    const i = this._eventedParent;
                    i && (p(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t1));
                } else t1 instanceof R && console.error(t1.error);
                return this;
            }
            listens(t1) {
                return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
            }
            setEventedParent(t1, e1) {
                return this._eventedParent = t1, this._eventedParentData = e1, this;
            }
        }
        var j = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {}
                    },
                    default: "mapbox"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {},
                    within: {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        const N = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function Z(t1, e1) {
            const r = {};
            for(const e1 in t1)"ref" !== e1 && (r[e1] = t1[e1]);
            return N.forEach((t1)=>{
                t1 in e1 && (r[t1] = e1[t1]);
            }), r;
        }
        function K(t1, e1) {
            if (Array.isArray(t1)) {
                if (!Array.isArray(e1) || t1.length !== e1.length) return !1;
                for(let r = 0; r < t1.length; r++)if (!K(t1[r], e1[r])) return !1;
                return !0;
            }
            if ("object" == typeof t1 && null !== t1 && null !== e1) {
                if ("object" != typeof e1) return !1;
                if (Object.keys(t1).length !== Object.keys(e1).length) return !1;
                for(const r in t1)if (!K(t1[r], e1[r])) return !1;
                return !0;
            }
            return t1 === e1;
        }
        const G = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
        };
        function J(t1, e1, r) {
            r.push({
                command: G.addSource,
                args: [
                    t1,
                    e1[t1]
                ]
            });
        }
        function X(t1, e1, r) {
            e1.push({
                command: G.removeSource,
                args: [
                    t1
                ]
            }), r[t1] = !0;
        }
        function Y(t1, e1, r, n) {
            X(t1, r, n), J(t1, e1, r);
        }
        function H(t1, e1, r) {
            let n;
            for(n in t1[r])if (Object.prototype.hasOwnProperty.call(t1[r], n) && "data" !== n && !K(t1[r][n], e1[r][n])) return !1;
            for(n in e1[r])if (Object.prototype.hasOwnProperty.call(e1[r], n) && "data" !== n && !K(t1[r][n], e1[r][n])) return !1;
            return !0;
        }
        function W(t1, e1, r, n, i, a) {
            let s;
            for(s in e1 = e1 || {}, t1 = t1 || {})Object.prototype.hasOwnProperty.call(t1, s) && (K(t1[s], e1[s]) || r.push({
                command: a,
                args: [
                    n,
                    s,
                    e1[s],
                    i
                ]
            }));
            for(s in e1)Object.prototype.hasOwnProperty.call(e1, s) && !Object.prototype.hasOwnProperty.call(t1, s) && (K(t1[s], e1[s]) || r.push({
                command: a,
                args: [
                    n,
                    s,
                    e1[s],
                    i
                ]
            }));
        }
        function Q(t1) {
            return t1.id;
        }
        function tt(t1, e1) {
            return t1[e1.id] = e1, t1;
        }
        class et {
            constructor(t1, e1, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
            }
        }
        function rt(t1, ...e1) {
            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
            return t1;
        }
        class nt extends Error {
            constructor(t1, e1){
                super(e1), this.message = e1, this.key = t1;
            }
        }
        class it {
            constructor(t1, e1 = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e1)this.bindings[t1] = r;
            }
            concat(t1) {
                return new it(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
        }
        const at = {
            kind: "null"
        }, st = {
            kind: "number"
        }, ot = {
            kind: "string"
        }, lt = {
            kind: "boolean"
        }, ut = {
            kind: "color"
        }, ct = {
            kind: "object"
        }, ht = {
            kind: "value"
        }, pt = {
            kind: "collator"
        }, ft = {
            kind: "formatted"
        }, dt = {
            kind: "padding"
        }, yt = {
            kind: "resolvedImage"
        };
        function mt(t1, e1) {
            return {
                kind: "array",
                itemType: t1,
                N: e1
            };
        }
        function gt(t1) {
            if ("array" === t1.kind) {
                const e1 = gt(t1.itemType);
                return "number" == typeof t1.N ? `array<${e1}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e1}>`;
            }
            return t1.kind;
        }
        const xt = [
            at,
            st,
            ot,
            lt,
            ut,
            ft,
            ct,
            mt(ht),
            dt,
            yt
        ];
        function vt(t1, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !vt(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
            } else {
                if (t1.kind === e1.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of xt)if (!vt(t1, e1)) return null;
                }
            }
            return `Expected ${gt(t1)} but found ${gt(e1)} instead.`;
        }
        function bt(t1, e1) {
            return e1.some((e1)=>e1.kind === t1.kind);
        }
        function wt(t1, e1) {
            return e1.some((e1)=>"null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1);
        }
        function _t(t1, e1) {
            return "array" === t1.kind && "array" === e1.kind ? t1.itemType.kind === e1.itemType.kind && "number" == typeof t1.N : t1.kind === e1.kind;
        }
        const At = .96422, kt = .82521, St = 4 / 29, It = 6 / 29, zt = 3 * It * It, Mt = It * It * It, Pt = Math.PI / 180, Bt = 180 / Math.PI;
        function Ct(t1) {
            return (t1 %= 360) < 0 && (t1 += 360), t1;
        }
        function Vt([t1, e1, r, n]) {
            let i, a;
            const s = Ft((.2225045 * (t1 = Et(t1)) + .7168786 * (e1 = Et(e1)) + .0606169 * (r = Et(r))) / 1);
            t1 === e1 && e1 === r ? i = a = s : (i = Ft((.4360747 * t1 + .3850649 * e1 + .1430804 * r) / At), a = Ft((.0139322 * t1 + .0971045 * e1 + .7141733 * r) / kt));
            const o = 116 * s - 16;
            return [
                o < 0 ? 0 : o,
                500 * (i - s),
                200 * (s - a),
                n
            ];
        }
        function Et(t1) {
            return t1 <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Ft(t1) {
            return t1 > Mt ? Math.pow(t1, 1 / 3) : t1 / zt + St;
        }
        function Tt([t1, e1, r, n]) {
            let i = (t1 + 16) / 116, a = isNaN(e1) ? i : i + e1 / 500, s = isNaN(r) ? i : i - r / 200;
            return i = 1 * $t(i), a = At * $t(a), s = kt * $t(s), [
                Lt(3.1338561 * a - 1.6168667 * i - .4906146 * s),
                Lt(-0.9787684 * a + 1.9161415 * i + .033454 * s),
                Lt(.0719453 * a - .2289914 * i + 1.4052427 * s),
                n
            ];
        }
        function Lt(t1) {
            return (t1 = t1 <= .00304 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055) < 0 ? 0 : t1 > 1 ? 1 : t1;
        }
        function $t(t1) {
            return t1 > It ? t1 * t1 * t1 : zt * (t1 - St);
        }
        function Dt(t1) {
            return parseInt(t1.padEnd(2, t1), 16) / 255;
        }
        function Ot(t1, e1) {
            return Ut(e1 ? t1 / 100 : t1, 0, 1);
        }
        function Ut(t1, e1, r) {
            return Math.min(Math.max(e1, t1), r);
        }
        function Rt(t1) {
            return !t1.some(Number.isNaN);
        }
        const qt = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        class jt {
            constructor(t1, e1, r, n = 1, i = !0){
                this.r = t1, this.g = e1, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                    t1,
                    e1,
                    r,
                    n
                ]));
            }
            static parse(t1) {
                if (t1 instanceof jt) return t1;
                if ("string" != typeof t1) return;
                const e1 = function(t1) {
                    if ("transparent" === (t1 = t1.toLowerCase())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const e1 = qt[t1];
                    if (e1) {
                        const [t1, r, n] = e1;
                        return [
                            t1 / 255,
                            r / 255,
                            n / 255,
                            1
                        ];
                    }
                    if (t1.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t1)) {
                        const e1 = t1.length < 6 ? 1 : 2;
                        let r = 1;
                        return [
                            Dt(t1.slice(r, r += e1)),
                            Dt(t1.slice(r, r += e1)),
                            Dt(t1.slice(r, r += e1)),
                            Dt(t1.slice(r, r + e1) || "ff")
                        ];
                    }
                    if (t1.startsWith("rgb")) {
                        const e1 = t1.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (e1) {
                            const [t1, r, n, i, a, s, o, l, u, c, h, p] = e1, f = [
                                i || " ",
                                o || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const t1 = [
                                    n,
                                    s,
                                    u
                                ].join(""), e1 = "%%%" === t1 ? 100 : "" === t1 ? 255 : 0;
                                if (e1) {
                                    const t1 = [
                                        Ut(+r / e1, 0, 1),
                                        Ut(+a / e1, 0, 1),
                                        Ut(+l / e1, 0, 1),
                                        h ? Ot(+h, p) : 1
                                    ];
                                    if (Rt(t1)) return t1;
                                }
                            }
                            return;
                        }
                    }
                    const r = t1.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (r) {
                        const [t1, e1, n, i, a, s, o, l, u] = r, c = [
                            n || " ",
                            a || " ",
                            o
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const t1 = [
                                +e1,
                                Ut(+i, 0, 100),
                                Ut(+s, 0, 100),
                                l ? Ot(+l, u) : 1
                            ];
                            if (Rt(t1)) return function([t1, e1, r, n]) {
                                function i(n) {
                                    const i = (n + t1 / 30) % 12, a = e1 * Math.min(r, 1 - r);
                                    return r - a * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return t1 = Ct(t1), e1 /= 100, r /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    n
                                ];
                            }(t1);
                        }
                    }
                }(t1);
                return e1 ? new jt(...e1, !1) : void 0;
            }
            get rgb() {
                const { r: t1, g: e1, b: r, a: n } = this, i = n || 1 / 0;
                return this.overwriteGetter("rgb", [
                    t1 / i,
                    e1 / i,
                    r / i,
                    n
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(t1) {
                    const [e1, r, n, i] = Vt(t1), a = Math.sqrt(r * r + n * n);
                    return [
                        Math.round(1e4 * a) ? Ct(Math.atan2(n, r) * Bt) : NaN,
                        a,
                        e1,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", Vt(this.rgb));
            }
            overwriteGetter(t1, e1) {
                return Object.defineProperty(this, t1, {
                    value: e1
                }), e1;
            }
            toString() {
                const [t1, e1, r, n] = this.rgb;
                return `rgba(${[
                    t1,
                    e1,
                    r
                ].map((t1)=>Math.round(255 * t1)).join(",")},${n})`;
            }
        }
        jt.black = new jt(0, 0, 0, 1), jt.white = new jt(1, 1, 1, 1), jt.transparent = new jt(0, 0, 0, 0), jt.red = new jt(1, 0, 0, 1);
        class Nt {
            constructor(t1, e1, r){
                this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t1, e1) {
                return this.collator.compare(t1, e1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Zt {
            constructor(t1, e1, r, n, i){
                this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Kt {
            constructor(t1){
                this.sections = t1;
            }
            static fromString(t1) {
                return new Kt([
                    new Zt(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && 0 !== t1.image.name.length);
            }
            static factory(t1) {
                return t1 instanceof Kt ? t1 : Kt.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
        }
        class Gt {
            constructor(t1){
                this.values = t1.slice();
            }
            static parse(t1) {
                if (t1 instanceof Gt) return t1;
                if ("number" == typeof t1) return new Gt([
                    t1,
                    t1,
                    t1,
                    t1
                ]);
                if (Array.isArray(t1) && !(t1.length < 1 || t1.length > 4)) {
                    for (const e1 of t1)if ("number" != typeof e1) return;
                    switch(t1.length){
                        case 1:
                            t1 = [
                                t1[0],
                                t1[0],
                                t1[0],
                                t1[0]
                            ];
                            break;
                        case 2:
                            t1 = [
                                t1[0],
                                t1[1],
                                t1[0],
                                t1[1]
                            ];
                            break;
                        case 3:
                            t1 = [
                                t1[0],
                                t1[1],
                                t1[2],
                                t1[1]
                            ];
                    }
                    return new Gt(t1);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        class Jt {
            constructor(t1){
                this.name = t1.name, this.available = t1.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t1) {
                return t1 ? new Jt({
                    name: t1,
                    available: !1
                }) : null;
            }
        }
        function Xt(t1, e1, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e1,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e1,
                r,
                n
            ] : [
                t1,
                e1,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Yt(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof jt) return !0;
            if (t1 instanceof Nt) return !0;
            if (t1 instanceof Kt) return !0;
            if (t1 instanceof Gt) return !0;
            if (t1 instanceof Jt) return !0;
            if (Array.isArray(t1)) {
                for (const e1 of t1)if (!Yt(e1)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e1 in t1)if (!Yt(t1[e1])) return !1;
                return !0;
            }
            return !1;
        }
        function Ht(t1) {
            if (null === t1) return at;
            if ("string" == typeof t1) return ot;
            if ("boolean" == typeof t1) return lt;
            if ("number" == typeof t1) return st;
            if (t1 instanceof jt) return ut;
            if (t1 instanceof Nt) return pt;
            if (t1 instanceof Kt) return ft;
            if (t1 instanceof Gt) return dt;
            if (t1 instanceof Jt) return yt;
            if (Array.isArray(t1)) {
                const e1 = t1.length;
                let r;
                for (const e1 of t1){
                    const t1 = Ht(e1);
                    if (r) {
                        if (r === t1) continue;
                        r = ht;
                        break;
                    }
                    r = t1;
                }
                return mt(r || ht, e1);
            }
            return ct;
        }
        function Wt(t1) {
            const e1 = typeof t1;
            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof jt || t1 instanceof Kt || t1 instanceof Gt || t1 instanceof Jt ? t1.toString() : JSON.stringify(t1);
        }
        class Qt {
            constructor(t1, e1){
                this.type = t1, this.value = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!Yt(t1[1])) return e1.error("invalid value");
                const r = t1[1];
                let n = Ht(r);
                const i = e1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Qt(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class te {
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
            toJSON() {
                return this.message;
            }
        }
        const ee = {
            string: ot,
            number: st,
            boolean: lt,
            object: ct
        };
        class re {
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, a;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in ee) || "object" === r) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = ee[r], n++;
                    } else i = ht;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                        a = t1[2], n++;
                    }
                    r = mt(i, a);
                } else {
                    if (!ee[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = ee[i];
                }
                const a = [];
                for(; n < t1.length; n++){
                    const r = e1.parse(t1[n], n, ht);
                    if (!r) return null;
                    a.push(r);
                }
                return new re(r, a);
            }
            evaluate(t1) {
                for(let e1 = 0; e1 < this.args.length; e1++){
                    const r = this.args[e1].evaluate(t1);
                    if (!vt(this.type, Ht(r))) return r;
                    if (e1 === this.args.length - 1) throw new te(`Expected value to be of type ${gt(this.type)}, but found ${gt(Ht(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
        }
        const ne = {
            "to-boolean": lt,
            "to-color": ut,
            "to-number": st,
            "to-string": ot
        };
        class ie {
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[0];
                if (!ne[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                const n = ne[r], i = [];
                for(let r = 1; r < t1.length; r++){
                    const n = e1.parse(t1[r], r, ht);
                    if (!n) return null;
                    i.push(n);
                }
                return new ie(n, i);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e1, r;
                    for (const n of this.args){
                        if (e1 = n.evaluate(t1), r = null, e1 instanceof jt) return e1;
                        if ("string" == typeof e1) {
                            const r = t1.parseColor(e1);
                            if (r) return r;
                        } else if (Array.isArray(e1) && (r = e1.length < 3 || e1.length > 4 ? `Invalid rbga value ${JSON.stringify(e1)}: expected an array containing either three or four numeric values.` : Xt(e1[0], e1[1], e1[2], e1[3]), !r)) return new jt(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                    }
                    throw new te(r || `Could not parse color from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                }
                if ("padding" === this.type.kind) {
                    let e1;
                    for (const r of this.args){
                        e1 = r.evaluate(t1);
                        const n = Gt.parse(e1);
                        if (n) return n;
                    }
                    throw new te(`Could not parse padding from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                }
                if ("number" === this.type.kind) {
                    let e1 = null;
                    for (const r of this.args){
                        if (e1 = r.evaluate(t1), null === e1) return 0;
                        const n = Number(e1);
                        if (!isNaN(n)) return n;
                    }
                    throw new te(`Could not convert ${JSON.stringify(e1)} to number.`);
                }
                return "formatted" === this.type.kind ? Kt.fromString(Wt(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? Jt.fromString(Wt(this.args[0].evaluate(t1))) : Wt(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
        }
        const ae = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class se {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? ae[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t1) {
                let e1 = this._parseColorCache[t1];
                return e1 || (e1 = this._parseColorCache[t1] = jt.parse(t1)), e1;
            }
        }
        class oe {
            constructor(t1, e1, r = [], n, i = new it, a = []){
                this.registry = t1, this.path = r, this.key = r.map((t1)=>`[${t1}]`).join(""), this.scope = i, this.errors = a, this.expectedType = n, this._isConstant = e1;
            }
            parse(t1, e1, r, n, i = {}) {
                return e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            _parse(t1, e1) {
                function r(t1, e1, r) {
                    return "assert" === r ? new re(e1, [
                        t1
                    ]) : "coerce" === r ? new ie(e1, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t1[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, i = n.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== i.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if ("padding" !== t1.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                        if (this.checkSubtype(t1, i)) return null;
                                    } else n = r(n, t1, e1.typeAnnotation || "coerce");
                                } else n = r(n, t1, e1.typeAnnotation || "coerce");
                            } else n = r(n, t1, e1.typeAnnotation || "assert");
                        }
                        if (!(n instanceof Qt) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                            const t1 = new se;
                            try {
                                n = new Qt(n.type, n.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e1, r) {
                const n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new oe(this.registry, this._isConstant, n, e1 || null, i, this.errors);
            }
            error(t1, ...e1) {
                const r = `${this.key}${e1.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new nt(r, t1));
            }
            checkSubtype(t1, e1) {
                const r = vt(t1, e1);
                return r && this.error(r), r;
            }
        }
        class le {
            constructor(t1, e1, r){
                this.type = pt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                const n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, lt);
                if (!n) return null;
                const i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, lt);
                if (!i) return null;
                let a = null;
                return r.locale && (a = e1.parse(r.locale, 1, ot), !a) ? null : new le(n, i, a);
            }
            evaluate(t1) {
                return new Nt(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        const ue = 8192;
        function ce(t1, e1) {
            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
        }
        function he(t1, e1) {
            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
        }
        function pe(t1, e1) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(r * i * ue),
                Math.round(n * i * ue)
            ];
        }
        function fe(t1, e1, r) {
            const n = t1[0] - e1[0], i = t1[1] - e1[1], a = t1[0] - r[0], s = t1[1] - r[1];
            return n * s - a * i == 0 && n * a <= 0 && i * s <= 0;
        }
        function de(t1, e1) {
            let r = !1;
            for(let s = 0, o = e1.length; s < o; s++){
                const o = e1[s];
                for(let e1 = 0, s = o.length; e1 < s - 1; e1++){
                    if (fe(t1, o[e1], o[e1 + 1])) return !1;
                    (i = o[e1])[1] > (n = t1)[1] != (a = o[e1 + 1])[1] > n[1] && n[0] < (a[0] - i[0]) * (n[1] - i[1]) / (a[1] - i[1]) + i[0] && (r = !r);
                }
            }
            var n, i, a;
            return r;
        }
        function ye(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (de(t1, e1[r])) return !0;
            return !1;
        }
        function me(t1, e1, r, n) {
            const i = n[0] - r[0], a = n[1] - r[1], s = (t1[0] - r[0]) * a - i * (t1[1] - r[1]), o = (e1[0] - r[0]) * a - i * (e1[1] - r[1]);
            return s > 0 && o < 0 || s < 0 && o > 0;
        }
        function ge(t1, e1, r) {
            for (const u of r)for(let r = 0; r < u.length - 1; ++r)if (0 != (o = [
                (s = u[r + 1])[0] - (a = u[r])[0],
                s[1] - a[1]
            ])[0] * (l = [
                (i = e1)[0] - (n = t1)[0],
                i[1] - n[1]
            ])[1] - o[1] * l[0] && me(n, i, a, s) && me(a, s, n, i)) return !0;
            var n, i, a, s, o, l;
            return !1;
        }
        function xe(t1, e1) {
            for(let r = 0; r < t1.length; ++r)if (!de(t1[r], e1)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (ge(t1[r], t1[r + 1], e1)) return !1;
            return !0;
        }
        function ve(t1, e1) {
            for(let r = 0; r < e1.length; r++)if (xe(t1, e1[r])) return !0;
            return !1;
        }
        function be(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const a = [];
                for(let n = 0; n < t1[i].length; n++){
                    const s = pe(t1[i][n], r);
                    ce(e1, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function we(t1, e1, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const a = be(t1[i], e1, r);
                n.push(a);
            }
            return n;
        }
        function _e(t1, e1, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e1 = .5 * n;
                let i = t1[0] - r[0] > e1 ? -n : r[0] - t1[0] > e1 ? n : 0;
                0 === i && (i = t1[0] - r[2] > e1 ? -n : r[2] - t1[0] > e1 ? n : 0), t1[0] += i;
            }
            ce(e1, t1);
        }
        function Ae(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * ue, a = [
                n.x * ue,
                n.y * ue
            ], s = [];
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + a[0],
                    t1.y + a[1]
                ];
                _e(n, e1, r, i), s.push(n);
            }
            return s;
        }
        function ke(t1, e1, r, n) {
            const i = Math.pow(2, n.z) * ue, a = [
                n.x * ue,
                n.y * ue
            ], s = [];
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + a[0],
                        n.y + a[1]
                    ];
                    ce(e1, r), t1.push(r);
                }
                s.push(t1);
            }
            if (e1[2] - e1[0] <= i / 2) {
                (o = e1)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t1 of s)for (const n of t1)_e(n, e1, r, i);
            }
            var o;
            return s;
        }
        class Se {
            constructor(t1, e1){
                this.type = lt, this.geojson = t1, this.geometries = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (Yt(t1[1])) {
                    const e1 = t1[1];
                    if ("FeatureCollection" === e1.type) for(let t1 = 0; t1 < e1.features.length; ++t1){
                        const r = e1.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Se(e1, e1.features[t1].geometry);
                    }
                    else if ("Feature" === e1.type) {
                        const t1 = e1.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new Se(e1, e1.geometry);
                    } else if ("Polygon" === e1.type || "MultiPolygon" === e1.type) return new Se(e1, e1);
                }
                return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if ("Polygon" === e1.type) {
                            const a = be(e1.coordinates, n, i), s = Ae(t1.geometry(), r, n, i);
                            if (!he(r, n)) return !1;
                            for (const t1 of s)if (!de(t1, a)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const a = we(e1.coordinates, n, i), s = Ae(t1.geometry(), r, n, i);
                            if (!he(r, n)) return !1;
                            for (const t1 of s)if (!ye(t1, a)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if ("Polygon" === e1.type) {
                            const a = be(e1.coordinates, n, i), s = ke(t1.geometry(), r, n, i);
                            if (!he(r, n)) return !1;
                            for (const t1 of s)if (!xe(t1, a)) return !1;
                        }
                        if ("MultiPolygon" === e1.type) {
                            const a = we(e1.coordinates, n, i), s = ke(t1.geometry(), r, n, i);
                            if (!he(r, n)) return !1;
                            for (const t1 of s)if (!ve(t1, a)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class Ie {
            constructor(t1, e1){
                this.type = e1.type, this.name = t1, this.boundExpression = e1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e1.scope.has(r) ? new Ie(r, e1.scope.get(r)) : e1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class ze {
            constructor(t1, e1, r, n){
                this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
            }
            evaluate(t1) {
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            static parse(t1, e1) {
                const r = t1[0], n = ze.definitions[r];
                if (!n) return e1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, a = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, s = a.filter(([e1])=>!Array.isArray(e1) || e1.length === t1.length - 1);
                let o = null;
                for (const [n, a] of s){
                    o = new oe(e1.registry, Me, e1.path, null, e1.scope);
                    const s = [];
                    let l = !1;
                    for(let e1 = 1; e1 < t1.length; e1++){
                        const r = t1[e1], i = Array.isArray(n) ? n[e1 - 1] : n.type, a = o.parse(r, 1 + s.length, i);
                        if (!a) {
                            l = !0;
                            break;
                        }
                        s.push(a);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== s.length) o.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < s.length; t1++){
                                const e1 = Array.isArray(n) ? n[t1] : n.type, r = s[t1];
                                o.concat(t1 + 1).checkSubtype(e1, r.type);
                            }
                            if (0 === o.errors.length) return new ze(r, i, a, s);
                        }
                    }
                }
                if (1 === s.length) e1.errors.push(...o.errors);
                else {
                    const r = (s.length ? s : a).map(([t1])=>{
                        var e1;
                        return e1 = t1, Array.isArray(e1) ? `(${e1.map(gt).join(", ")})` : `(${gt(e1.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e1.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(gt(i.type));
                    }
                    e1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e1) {
                ze.definitions = e1;
                for(const r in e1)t1[r] = ze;
            }
        }
        function Me(t1) {
            if (t1 instanceof Ie) return Me(t1.boundExpression);
            if (t1 instanceof ze && "error" === t1.name) return !1;
            if (t1 instanceof le) return !1;
            if (t1 instanceof Se) return !1;
            const e1 = t1 instanceof ie || t1 instanceof re;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e1 ? r && Me(t1) : r && t1 instanceof Qt;
            }), !!r && Pe(t1) && Ce(t1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function Pe(t1) {
            if (t1 instanceof ze) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof Se) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !Pe(t1) && (e1 = !1);
            }), e1;
        }
        function Be(t1) {
            if (t1 instanceof ze && "feature-state" === t1.name) return !1;
            let e1 = !0;
            return t1.eachChild((t1)=>{
                e1 && !Be(t1) && (e1 = !1);
            }), e1;
        }
        function Ce(t1, e1) {
            if (t1 instanceof ze && e1.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !Ce(t1, e1) && (r = !1);
            }), r;
        }
        function Ve(t1, e1) {
            const r = t1.length - 1;
            let n, i, a = 0, s = r, o = 0;
            for(; a <= s;)if (o = Math.floor((a + s) / 2), n = t1[o], i = t1[o + 1], n <= e1) {
                if (o === r || e1 < i) return o;
                a = o + 1;
            } else {
                if (!(n > e1)) throw new te("Input is not a number.");
                s = o - 1;
            }
            return 0;
        }
        class Ee {
            constructor(t1, e1, r){
                this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                for (const [t1, e1] of r)this.labels.push(t1), this.outputs.push(e1);
            }
            static parse(t1, e1) {
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                const r = e1.parse(t1[1], 1, st);
                if (!r) return null;
                const n = [];
                let i = null;
                e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const a = 1 === r ? -1 / 0 : t1[r], s = t1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof a) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= a) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e1.parse(s, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        a,
                        u
                    ]);
                }
                return new Ee(i, r, n);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[Ve(e1, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
        }
        function Fe(t1, e1, r) {
            return t1 + r * (e1 - t1);
        }
        function Te(t1, e1, r) {
            return t1.map((t1, n)=>Fe(t1, e1[n], r));
        }
        const Le = {
            number: Fe,
            color: function(t1, e1, r, n = "rgb") {
                switch(n){
                    case "rgb":
                        {
                            const [n, i, a, s] = Te(t1.rgb, e1.rgb, r);
                            return new jt(n, i, a, s, !1);
                        }
                    case "hcl":
                        {
                            const [n, i, a, s] = t1.hcl, [o, l, u, c] = e1.hcl;
                            let h, p;
                            if (isNaN(n) || isNaN(o)) isNaN(n) ? isNaN(o) ? h = NaN : (h = o, 1 !== a && 0 !== a || (p = l)) : (h = n, 1 !== u && 0 !== u || (p = i));
                            else {
                                let t1 = o - n;
                                o > n && t1 > 180 ? t1 -= 360 : o < n && n - o > 180 && (t1 += 360), h = n + r * t1;
                            }
                            const [f, d, y, m] = function([t1, e1, r, n]) {
                                return t1 = isNaN(t1) ? 0 : t1 * Pt, Tt([
                                    r,
                                    Math.cos(t1) * e1,
                                    Math.sin(t1) * e1,
                                    n
                                ]);
                            }([
                                h,
                                null != p ? p : Fe(i, l, r),
                                Fe(a, u, r),
                                Fe(s, c, r)
                            ]);
                            return new jt(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [n, i, a, s] = Tt(Te(t1.lab, e1.lab, r));
                            return new jt(n, i, a, s, !1);
                        }
                }
            },
            array: Te,
            padding: function(t1, e1, r) {
                return new Gt(Te(t1.values, e1.values, r));
            }
        };
        class $e {
            constructor(t1, e1, r, n, i){
                this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t1, e1] of i)this.labels.push(t1), this.outputs.push(e1);
            }
            static interpolationFactor(t1, e1, r, n) {
                let i = 0;
                if ("exponential" === t1.name) i = De(e1, t1.base, r, n);
                else if ("linear" === t1.name) i = De(e1, 1, r, n);
                else if ("cubic-bezier" === t1.name) {
                    const a = t1.controlPoints;
                    i = new o(a[0], a[1], a[2], a[3]).solve(De(e1, 1, r, n));
                }
                return i;
            }
            static parse(t1, e1) {
                let [r, n, i, ...a] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                if (i = e1.parse(i, 2, st), !i) return null;
                const s = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = ut : e1.expectedType && "value" !== e1.expectedType.kind && (o = e1.expectedType);
                for(let t1 = 0; t1 < a.length; t1 += 2){
                    const r = a[t1], n = a[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (s.length && s[s.length - 1][0] >= r) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e1.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, s.push([
                        r,
                        u
                    ]);
                }
                return _t(o, st) || _t(o, ut) || _t(o, dt) || _t(o, mt(st)) ? new $e(o, r, n, i, s) : e1.error(`Type ${gt(o)} is not interpolatable.`);
            }
            evaluate(t1) {
                const e1 = this.labels, r = this.outputs;
                if (1 === e1.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e1[0]) return r[0].evaluate(t1);
                const i = e1.length;
                if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                const a = Ve(e1, n), s = $e.interpolationFactor(this.interpolation, n, e1[a], e1[a + 1]), o = r[a].evaluate(t1), l = r[a + 1].evaluate(t1);
                switch(this.operator){
                    case "interpolate":
                        return Le[this.type.kind](o, l, s);
                    case "interpolate-hcl":
                        return Le.color(o, l, s, "hcl");
                    case "interpolate-lab":
                        return Le.color(o, l, s, "lab");
                }
            }
            eachChild(t1) {
                t1(this.input);
                for (const e1 of this.outputs)t1(e1);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
        }
        function De(t1, e1, r, n) {
            const i = n - r, a = t1 - r;
            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
        }
        class Oe {
            constructor(t1, e1){
                this.type = t1, this.args = e1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expectected at least one argument.");
                let r = null;
                const n = e1.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e1.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                if (!r) throw new Error("No output type");
                const a = n && i.some((t1)=>vt(n, t1.type));
                return new Oe(a ? ht : r, i);
            }
            evaluate(t1) {
                let e1, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(t1), r && r instanceof Jt && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null !== r) break;
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
        }
        class Ue {
            constructor(t1, e1){
                this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
            }
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e1 of this.bindings)t1(e1[1]);
                t1(this.result);
            }
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e1.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const a = e1.parse(t1[n + 1], n + 1);
                    if (!a) return null;
                    r.push([
                        i,
                        a
                    ]);
                }
                const n = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                return n ? new Ue(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class Re {
            constructor(t1, e1, r){
                this.type = t1, this.index = e1, this.input = r;
            }
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, st), n = e1.parse(t1[2], 2, mt(e1.expectedType || ht));
                return r && n ? new Re(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e1 < 0) throw new te(`Array index out of bounds: ${e1} < 0.`);
                if (e1 >= r.length) throw new te(`Array index out of bounds: ${e1} > ${r.length - 1}.`);
                if (e1 !== Math.floor(e1)) throw new te(`Array index must be an integer, but found ${e1} instead.`);
                return r[e1];
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class qe {
            constructor(t1, e1){
                this.type = lt, this.needle = t1, this.haystack = e1;
            }
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, ht), n = e1.parse(t1[2], 2, ht);
                return r && n ? bt(r.type, [
                    lt,
                    ot,
                    st,
                    at,
                    ht
                ]) ? new qe(r, n) : e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${gt(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!r) return !1;
                if (!wt(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new te(`Expected first argument to be of type boolean, string, number or null, but found ${gt(Ht(e1))} instead.`);
                if (!wt(r, [
                    "string",
                    "array"
                ])) throw new te(`Expected second argument to be of type array or string, but found ${gt(Ht(r))} instead.`);
                return r.indexOf(e1) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class je {
            constructor(t1, e1, r){
                this.type = st, this.needle = t1, this.haystack = e1, this.fromIndex = r;
            }
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, ht), n = e1.parse(t1[2], 2, ht);
                if (!r || !n) return null;
                if (!bt(r.type, [
                    lt,
                    ot,
                    st,
                    at,
                    ht
                ])) return e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${gt(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, st);
                    return i ? new je(r, n, i) : null;
                }
                return new je(r, n);
            }
            evaluate(t1) {
                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!wt(e1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new te(`Expected first argument to be of type boolean, string, number or null, but found ${gt(Ht(e1))} instead.`);
                if (!wt(r, [
                    "string",
                    "array"
                ])) throw new te(`Expected second argument to be of type array or string, but found ${gt(Ht(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e1, n);
                }
                return r.indexOf(e1);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ne {
            constructor(t1, e1, r, n, i, a){
                this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
            }
            static parse(t1, e1) {
                if (t1.length < 5) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                let r, n;
                e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                const i = {}, a = [];
                for(let s = 2; s < t1.length - 1; s += 2){
                    let o = t1[s];
                    const l = t1[s + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e1.concat(s);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t1 of o){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, Ht(t1))) return null;
                        } else r = Ht(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = a.length;
                    }
                    const c = e1.parse(l, s, n);
                    if (!c) return null;
                    n = n || c.type, a.push(c);
                }
                const s = e1.parse(t1[1], 1, ht);
                if (!s) return null;
                const o = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                return o ? "value" !== s.type.kind && e1.concat(1).checkSubtype(r, s.type) ? null : new Ne(r, n, s, i, a, o) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                return (Ht(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class Ze {
            constructor(t1, e1, r){
                this.type = t1, this.branches = e1, this.otherwise = r;
            }
            static parse(t1, e1) {
                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                let r;
                e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const a = e1.parse(t1[i], i, lt);
                    if (!a) return null;
                    const s = e1.parse(t1[i + 1], i + 1, r);
                    if (!s) return null;
                    n.push([
                        a,
                        s
                    ]), r = r || s.type;
                }
                const i = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new Ze(r, n, i);
            }
            evaluate(t1) {
                for (const [e1, r] of this.branches)if (e1.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e1, r] of this.branches)t1(e1), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e1])=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class Ke {
            constructor(t1, e1, r, n){
                this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t1, e1) {
                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1, ht), n = e1.parse(t1[2], 2, st);
                if (!r || !n) return null;
                if (!bt(r.type, [
                    mt(ht),
                    ot,
                    ht
                ])) return e1.error(`Expected first argument to be of type array or string, but found ${gt(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e1.parse(t1[3], 3, st);
                    return i ? new Ke(r.type, r, n, i) : null;
                }
                return new Ke(r.type, r, n);
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!wt(e1, [
                    "string",
                    "array"
                ])) throw new te(`Expected first argument to be of type array or string, but found ${gt(Ht(e1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e1.slice(r, n);
                }
                return e1.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function Ge(t1, e1) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function Je(t1, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function Xe(t1, e1, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                constructor(t1, e1, r){
                    this.type = lt, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                }
                static parse(t1, e1) {
                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                    const r = t1[0];
                    let a = e1.parse(t1[1], 1, ht);
                    if (!a) return null;
                    if (!Ge(r, a.type)) return e1.concat(1).error(`"${r}" comparisons are not supported for type '${gt(a.type)}'.`);
                    let s = e1.parse(t1[2], 2, ht);
                    if (!s) return null;
                    if (!Ge(r, s.type)) return e1.concat(2).error(`"${r}" comparisons are not supported for type '${gt(s.type)}'.`);
                    if (a.type.kind !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e1.error(`Cannot compare types '${gt(a.type)}' and '${gt(s.type)}'.`);
                    n && ("value" === a.type.kind && "value" !== s.type.kind ? a = new re(s.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === s.type.kind && (s = new re(a.type, [
                        s
                    ])));
                    let o = null;
                    if (4 === t1.length) {
                        if ("string" !== a.type.kind && "string" !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                        if (o = e1.parse(t1[3], 3, pt), !o) return null;
                    }
                    return new i(a, s, o);
                }
                evaluate(i) {
                    const a = this.lhs.evaluate(i), s = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e1 = Ht(a), r = Ht(s);
                        if (e1.kind !== r.kind || "string" !== e1.kind && "number" !== e1.kind) throw new te(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e1.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = Ht(a), r = Ht(s);
                        if ("string" !== t1.kind || "string" !== r.kind) return e1(i, a, s);
                    }
                    return this.collator ? r(i, a, s, this.collator.evaluate(i)) : e1(i, a, s);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const Ye = Xe("==", function(t1, e1, r) {
            return e1 === r;
        }, Je), He = Xe("!=", function(t1, e1, r) {
            return e1 !== r;
        }, function(t1, e1, r, n) {
            return !Je(0, e1, r, n);
        }), We = Xe("<", function(t1, e1, r) {
            return e1 < r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), Qe = Xe(">", function(t1, e1, r) {
            return e1 > r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), tr = Xe("<=", function(t1, e1, r) {
            return e1 <= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), er = Xe(">=", function(t1, e1, r) {
            return e1 >= r;
        }, function(t1, e1, r, n) {
            return n.compare(e1, r) >= 0;
        });
        class rr {
            constructor(t1, e1, r, n, i){
                this.type = ot, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            static parse(t1, e1) {
                if (3 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, st);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e1.parse(n.locale, 1, ot), !i)) return null;
                let a = null;
                if (n.currency && (a = e1.parse(n.currency, 1, ot), !a)) return null;
                let s = null;
                if (n["min-fraction-digits"] && (s = e1.parse(n["min-fraction-digits"], 1, st), !s)) return null;
                let o = null;
                return n["max-fraction-digits"] && (o = e1.parse(n["max-fraction-digits"], 1, st), !o) ? null : new rr(r, i, a, s, o);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class nr {
            constructor(t1){
                this.type = ft, this.sections = t1;
            }
            static parse(t1, e1) {
                if (t1.length < 2) return e1.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const a = t1[r];
                    if (i && "object" == typeof a && !Array.isArray(a)) {
                        i = !1;
                        let t1 = null;
                        if (a["font-scale"] && (t1 = e1.parse(a["font-scale"], 1, st), !t1)) return null;
                        let r = null;
                        if (a["text-font"] && (r = e1.parse(a["text-font"], 1, mt(ot)), !r)) return null;
                        let s = null;
                        if (a["text-color"] && (s = e1.parse(a["text-color"], 1, ut), !s)) return null;
                        const o = n[n.length - 1];
                        o.scale = t1, o.font = r, o.textColor = s;
                    } else {
                        const a = e1.parse(t1[r], 1, ht);
                        if (!a) return null;
                        const s = a.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: a,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new nr(n);
            }
            evaluate(t1) {
                return new Kt(this.sections.map((e1)=>{
                    const r = e1.content.evaluate(t1);
                    return Ht(r) === yt ? new Zt("", r, null, null, null) : new Zt(Wt(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e1 of this.sections)t1(e1.content), e1.scale && t1(e1.scale), e1.font && t1(e1.font), e1.textColor && t1(e1.textColor);
            }
            outputDefined() {
                return !1;
            }
        }
        class ir {
            constructor(t1){
                this.type = yt, this.input = t1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error("Expected two arguments.");
                const r = e1.parse(t1[1], 1, ot);
                return r ? new ir(r) : e1.error("No image name provided.");
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1), r = Jt.fromString(e1);
                return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class ar {
            constructor(t1){
                this.type = st, this.input = t1;
            }
            static parse(t1, e1) {
                if (2 !== t1.length) return e1.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e1.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error(`Expected argument of type string or array, but found ${gt(r.type)} instead.`) : new ar(r) : null;
            }
            evaluate(t1) {
                const e1 = this.input.evaluate(t1);
                if ("string" == typeof e1) return e1.length;
                if (Array.isArray(e1)) return e1.length;
                throw new te(`Expected value to be of type string or array, but found ${gt(Ht(e1))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const sr = {
            "==": Ye,
            "!=": He,
            ">": Qe,
            "<": We,
            ">=": er,
            "<=": tr,
            array: re,
            at: Re,
            boolean: re,
            case: Ze,
            coalesce: Oe,
            collator: le,
            format: nr,
            image: ir,
            in: qe,
            "index-of": je,
            interpolate: $e,
            "interpolate-hcl": $e,
            "interpolate-lab": $e,
            length: ar,
            let: Ue,
            literal: Qt,
            match: Ne,
            number: re,
            "number-format": rr,
            object: re,
            slice: Ke,
            step: Ee,
            string: re,
            "to-boolean": ie,
            "to-color": ie,
            "to-number": ie,
            "to-string": ie,
            var: Ie,
            within: Se
        };
        function or(t1, [e1, r, n, i]) {
            e1 = e1.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const a = i ? i.evaluate(t1) : 1, s = Xt(e1, r, n, a);
            if (s) throw new te(s);
            return new jt(e1 / 255, r / 255, n / 255, a, !1);
        }
        function lr(t1, e1) {
            return t1 in e1;
        }
        function ur(t1, e1) {
            const r = e1[t1];
            return void 0 === r ? null : r;
        }
        function cr(t1) {
            return {
                type: t1
            };
        }
        function hr(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function pr(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function fr(t1) {
            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
        }
        function dr(t1) {
            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
        }
        function yr(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function mr(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        function gr(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function xr(t1) {
            return t1;
        }
        function vr(t1, e1) {
            const r = "color" === e1.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), a = t1.type || (yr(e1) ? "exponential" : "interval");
            if (r || "padding" === e1.type) {
                const n = r ? jt.parse : Gt.parse;
                (t1 = rt({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                        t1[0],
                        n(t1[1])
                    ])), t1.default = n(t1.default ? t1.default : e1.default);
            }
            if (t1.colorSpace && "rgb" !== (s = t1.colorSpace) && "hcl" !== s && "lab" !== s) throw new Error(`Unknown color space: "${t1.colorSpace}"`);
            var s;
            let o, l, u;
            if ("exponential" === a) o = Ar;
            else if ("interval" === a) o = _r;
            else if ("categorical" === a) {
                o = wr, l = Object.create(null);
                for (const e1 of t1.stops)l[e1[0]] = e1[1];
                u = typeof t1.stops[0][0];
            } else {
                if ("identity" !== a) throw new Error(`Unknown function type "${a}"`);
                o = kr;
            }
            if (n) {
                const r = {}, n = [];
                for(let e1 = 0; e1 < t1.stops.length; e1++){
                    const i = t1.stops[e1], a = i[0].zoom;
                    void 0 === r[a] && (r[a] = {
                        zoom: a,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(a)), r[a].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    vr(r[t1], e1)
                ]);
                const a = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: a,
                    interpolationFactor: $e.interpolationFactor.bind(void 0, a),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>Ar({
                            stops: i,
                            base: t1.base
                        }, e1, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === a ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: $e.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>o(t1, e1, r, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? br(t1.default, e1.default) : o(t1, e1, i, l, u);
                }
            };
        }
        function br(t1, e1, r) {
            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function wr(t1, e1, r, n, i) {
            return br(typeof r === i ? n[r] : void 0, t1.default, e1.default);
        }
        function _r(t1, e1, r) {
            if ("number" !== mr(r)) return br(t1.default, e1.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = Ve(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function Ar(t1, e1, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== mr(r)) return br(t1.default, e1.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const a = Ve(t1.stops.map((t1)=>t1[0]), r), s = function(t1, e1, r, n) {
                const i = n - r, a = t1 - r;
                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), o = t1.stops[a][1], l = t1.stops[a + 1][1], u = Le[e1.type] || xr;
            return "function" == typeof o.evaluate ? {
                evaluate (...e1) {
                    const r = o.evaluate.apply(void 0, e1), n = l.evaluate.apply(void 0, e1);
                    if (void 0 !== r && void 0 !== n) return u(r, n, s, t1.colorSpace);
                }
            } : u(o, l, s, t1.colorSpace);
        }
        function kr(t1, e1, r) {
            switch(e1.type){
                case "color":
                    r = jt.parse(r);
                    break;
                case "formatted":
                    r = Kt.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = Jt.fromString(r.toString());
                    break;
                case "padding":
                    r = Gt.parse(r);
                    break;
                default:
                    mr(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0);
            }
            return br(r, t1.default, e1.default);
        }
        ze.register(sr, {
            error: [
                {
                    kind: "error"
                },
                [
                    ot
                ],
                (t1, [e1])=>{
                    throw new te(e1.evaluate(t1));
                }
            ],
            typeof: [
                ot,
                [
                    ht
                ],
                (t1, [e1])=>gt(Ht(e1.evaluate(t1)))
            ],
            "to-rgba": [
                mt(st, 4),
                [
                    ut
                ],
                (t1, [e1])=>{
                    const [r, n, i, a] = e1.evaluate(t1).rgb;
                    return [
                        255 * r,
                        255 * n,
                        255 * i,
                        a
                    ];
                }
            ],
            rgb: [
                ut,
                [
                    st,
                    st,
                    st
                ],
                or
            ],
            rgba: [
                ut,
                [
                    st,
                    st,
                    st,
                    st
                ],
                or
            ],
            has: {
                type: lt,
                overloads: [
                    [
                        [
                            ot
                        ],
                        (t1, [e1])=>lr(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ot,
                            ct
                        ],
                        (t1, [e1, r])=>lr(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: ht,
                overloads: [
                    [
                        [
                            ot
                        ],
                        (t1, [e1])=>ur(e1.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            ot,
                            ct
                        ],
                        (t1, [e1, r])=>ur(e1.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                ht,
                [
                    ot
                ],
                (t1, [e1])=>ur(e1.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                ct,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                ot,
                [],
                (t1)=>t1.geometryType()
            ],
            id: [
                ht,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                st,
                [],
                (t1)=>t1.globals.zoom
            ],
            "heatmap-density": [
                st,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                st,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            accumulated: [
                ht,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                st,
                cr(st),
                (t1, e1)=>{
                    let r = 0;
                    for (const n of e1)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                st,
                cr(st),
                (t1, e1)=>{
                    let r = 1;
                    for (const n of e1)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: st,
                overloads: [
                    [
                        [
                            st,
                            st
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            st
                        ],
                        (t1, [e1])=>-e1.evaluate(t1)
                    ]
                ]
            },
            "/": [
                st,
                [
                    st,
                    st
                ],
                (t1, [e1, r])=>e1.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                st,
                [
                    st,
                    st
                ],
                (t1, [e1, r])=>e1.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                st,
                [],
                ()=>Math.LN2
            ],
            pi: [
                st,
                [],
                ()=>Math.PI
            ],
            e: [
                st,
                [],
                ()=>Math.E
            ],
            "^": [
                st,
                [
                    st,
                    st
                ],
                (t1, [e1, r])=>Math.pow(e1.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.sqrt(e1.evaluate(t1))
            ],
            log10: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN10
            ],
            ln: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1))
            ],
            log2: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN2
            ],
            sin: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.sin(e1.evaluate(t1))
            ],
            cos: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.cos(e1.evaluate(t1))
            ],
            tan: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.tan(e1.evaluate(t1))
            ],
            asin: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.asin(e1.evaluate(t1))
            ],
            acos: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.acos(e1.evaluate(t1))
            ],
            atan: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.atan(e1.evaluate(t1))
            ],
            min: [
                st,
                cr(st),
                (t1, e1)=>Math.min(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            max: [
                st,
                cr(st),
                (t1, e1)=>Math.max(...e1.map((e1)=>e1.evaluate(t1)))
            ],
            abs: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.abs(e1.evaluate(t1))
            ],
            round: [
                st,
                [
                    st
                ],
                (t1, [e1])=>{
                    const r = e1.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.floor(e1.evaluate(t1))
            ],
            ceil: [
                st,
                [
                    st
                ],
                (t1, [e1])=>Math.ceil(e1.evaluate(t1))
            ],
            "filter-==": [
                lt,
                [
                    ot,
                    ht
                ],
                (t1, [e1, r])=>t1.properties()[e1.value] === r.value
            ],
            "filter-id-==": [
                lt,
                [
                    ht
                ],
                (t1, [e1])=>t1.id() === e1.value
            ],
            "filter-type-==": [
                lt,
                [
                    ot
                ],
                (t1, [e1])=>t1.geometryType() === e1.value
            ],
            "filter-<": [
                lt,
                [
                    ot,
                    ht
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                lt,
                [
                    ht
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                lt,
                [
                    ot,
                    ht
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                lt,
                [
                    ht
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                lt,
                [
                    ot,
                    ht
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                lt,
                [
                    ht
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                lt,
                [
                    ot,
                    ht
                ],
                (t1, [e1, r])=>{
                    const n = t1.properties()[e1.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                lt,
                [
                    ht
                ],
                (t1, [e1])=>{
                    const r = t1.id(), n = e1.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                lt,
                [
                    ht
                ],
                (t1, [e1])=>e1.value in t1.properties()
            ],
            "filter-has-id": [
                lt,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                lt,
                [
                    mt(ot)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                lt,
                [
                    mt(ht)
                ],
                (t1, [e1])=>e1.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                lt,
                [
                    ot,
                    mt(ht)
                ],
                (t1, [e1, r])=>r.value.indexOf(t1.properties()[e1.value]) >= 0
            ],
            "filter-in-large": [
                lt,
                [
                    ot,
                    mt(ht)
                ],
                (t1, [e1, r])=>(function(t1, e1, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e1[i] === t1) return !0;
                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e1.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: lt,
                overloads: [
                    [
                        [
                            lt,
                            lt
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        cr(lt),
                        (t1, e1)=>{
                            for (const r of e1)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: lt,
                overloads: [
                    [
                        [
                            lt,
                            lt
                        ],
                        (t1, [e1, r])=>e1.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        cr(lt),
                        (t1, e1)=>{
                            for (const r of e1)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                lt,
                [
                    lt
                ],
                (t1, [e1])=>!e1.evaluate(t1)
            ],
            "is-supported-script": [
                lt,
                [
                    ot
                ],
                (t1, [e1])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e1.evaluate(t1));
                }
            ],
            upcase: [
                ot,
                [
                    ot
                ],
                (t1, [e1])=>e1.evaluate(t1).toUpperCase()
            ],
            downcase: [
                ot,
                [
                    ot
                ],
                (t1, [e1])=>e1.evaluate(t1).toLowerCase()
            ],
            concat: [
                ot,
                cr(ht),
                (t1, e1)=>e1.map((e1)=>Wt(e1.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                ot,
                [
                    pt
                ],
                (t1, [e1])=>e1.evaluate(t1).resolvedLocale()
            ]
        });
        class Sr {
            constructor(t1, e1){
                var r;
                this.expression = t1, this._warningHistory = {}, this._evaluator = new se, this._defaultValue = e1 ? "color" === (r = e1).type && gr(r.default) ? new jt(0, 0, 0, 0) : "color" === r.type ? jt.parse(r.default) || null : "padding" === r.type ? Gt.parse(r.default) || null : void 0 === r.default ? null : r.default : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
            }
            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e1, r, n, i, a) {
                this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new te(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                }
            }
        }
        function Ir(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in sr;
        }
        function zr(t1, e1) {
            const r = new oe(sr, Me, [], e1 ? function(t1) {
                const e1 = {
                    color: ut,
                    string: ot,
                    number: st,
                    enum: ot,
                    boolean: lt,
                    formatted: ft,
                    padding: dt,
                    resolvedImage: yt
                };
                return "array" === t1.type ? mt(e1[t1.value] || ht, t1.length) : e1[t1.type];
            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? hr(new Sr(n, e1)) : pr(r.errors);
        }
        class Mr {
            constructor(t1, e1){
                this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !Be(e1.expression);
            }
            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
            }
            evaluate(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, a);
            }
        }
        class Pr {
            constructor(t1, e1, r, n){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !Be(e1.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
            }
            evaluate(t1, e1, r, n, i, a) {
                return this._styleExpression.evaluate(t1, e1, r, n, i, a);
            }
            interpolationFactor(t1, e1, r) {
                return this.interpolationType ? $e.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
            }
        }
        function Br(t1, e1) {
            const r = zr(t1, e1);
            if ("error" === r.result) return r;
            const n = r.value.expression, i = Pe(n);
            if (!i && !fr(e1)) return pr([
                new nt("", "data expressions not supported")
            ]);
            const a = Ce(n, [
                "zoom"
            ]);
            if (!a && !dr(e1)) return pr([
                new nt("", "zoom expressions not supported")
            ]);
            const s = Vr(n);
            return s || a ? s instanceof nt ? pr([
                s
            ]) : s instanceof $e && !yr(e1) ? pr([
                new nt("", '"interpolate" expressions cannot be used with this property')
            ]) : hr(s ? new Pr(i ? "camera" : "composite", r.value, s.labels, s instanceof $e ? s.interpolation : void 0) : new Mr(i ? "constant" : "source", r.value)) : pr([
                new nt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class Cr {
            constructor(t1, e1){
                this._parameters = t1, this._specification = e1, rt(this, vr(this._parameters, this._specification));
            }
            static deserialize(t1) {
                return new Cr(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
        }
        function Vr(t1) {
            let e1 = null;
            if (t1 instanceof Ue) e1 = Vr(t1.result);
            else if (t1 instanceof Oe) {
                for (const r of t1.args)if (e1 = Vr(r), e1) break;
            } else (t1 instanceof Ee || t1 instanceof $e) && t1.input instanceof ze && "zoom" === t1.input.name && (e1 = t1);
            return e1 instanceof nt || t1.eachChild((t1)=>{
                const r = Vr(t1);
                r instanceof nt ? e1 = r : !e1 && r ? e1 = new nt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && r && e1 !== r && (e1 = new nt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e1;
        }
        function Er(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e1 of t1.slice(1))if (!Er(e1) && "boolean" != typeof e1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const Fr = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function Tr(t1) {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1
            };
            Er(t1) || (t1 = Dr(t1));
            const e1 = zr(t1, Fr);
            if ("error" === e1.result) throw new Error(e1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
            return {
                filter: (t1, r, n)=>e1.value.evaluate(t1, r, {}, n),
                needGeometry: $r(t1)
            };
        }
        function Lr(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function $r(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0]) return !0;
            for(let e1 = 1; e1 < t1.length; e1++)if ($r(t1[e1])) return !0;
            return !1;
        }
        function Dr(t1) {
            if (!t1) return !0;
            const e1 = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e1 : "==" === e1 ? Or(t1[1], t1[2], "==") : "!=" === e1 ? qr(Or(t1[1], t1[2], "==")) : "<" === e1 || ">" === e1 || "<=" === e1 || ">=" === e1 ? Or(t1[1], t1[2], e1) : "any" === e1 ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(Dr))) : "all" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(Dr)) : "none" === e1 ? [
                "all"
            ].concat(t1.slice(1).map(Dr).map(qr)) : "in" === e1 ? Ur(t1[1], t1.slice(2)) : "!in" === e1 ? qr(Ur(t1[1], t1.slice(2))) : "has" === e1 ? Rr(t1[1]) : "!has" === e1 ? qr(Rr(t1[1])) : "within" !== e1 || t1;
        }
        function Or(t1, e1, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e1
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e1
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e1
                    ];
            }
        }
        function Ur(t1, e1) {
            if (0 === e1.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some((t1)=>typeof t1 != typeof e1[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e1.sort(Lr)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function Rr(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function qr(t1) {
            return [
                "!",
                t1
            ];
        }
        function jr(t1) {
            const e1 = typeof t1;
            if ("number" === e1 || "boolean" === e1 || "string" === e1 || null == t1) return JSON.stringify(t1);
            if (Array.isArray(t1)) {
                let e1 = "[";
                for (const r of t1)e1 += `${jr(r)},`;
                return `${e1}]`;
            }
            const r = Object.keys(t1).sort();
            let n = "{";
            for(let e1 = 0; e1 < r.length; e1++)n += `${JSON.stringify(r[e1])}:${jr(t1[r[e1]])},`;
            return `${n}}`;
        }
        function Nr(t1) {
            let e1 = "";
            for (const r of N)e1 += `/${jr(t1[r])}`;
            return e1;
        }
        function Zr(t1) {
            const e1 = t1.value;
            return e1 ? [
                new et(t1.key, e1, "constants have been deprecated as of v8")
            ] : [];
        }
        function Kr(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Gr(t1) {
            if (Array.isArray(t1)) return t1.map(Gr);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e1 = {};
                for(const r in t1)e1[r] = Gr(t1[r]);
                return e1;
            }
            return Kr(t1);
        }
        function Jr(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, s = t1.styleSpec, o = t1.validateSpec;
            let l = [];
            const u = mr(r);
            if ("object" !== u) return [
                new et(e1, r, `object expected, ${u} found`)
            ];
            for(const t1 in r){
                const u = t1.split(".")[0], c = n[u] || n["*"];
                let h;
                if (i[u]) h = i[u];
                else if (n[u]) h = o;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        l.push(new et(e1, r[t1], `unknown property "${t1}"`));
                        continue;
                    }
                    h = o;
                }
                l = l.concat(h({
                    key: (e1 ? `${e1}.` : e1) + t1,
                    value: r[t1],
                    valueSpec: c,
                    style: a,
                    styleSpec: s,
                    object: r,
                    objectKey: t1,
                    validateSpec: o
                }, r));
            }
            for(const t1 in n)i[t1] || n[t1].required && void 0 === n[t1].default && void 0 === r[t1] && l.push(new et(e1, r, `missing required property "${t1}"`));
            return l;
        }
        function Xr(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, a = t1.key, s = t1.arrayElementValidator || t1.validateSpec;
            if ("array" !== mr(e1)) return [
                new et(a, e1, `array expected, ${mr(e1)} found`)
            ];
            if (r.length && e1.length !== r.length) return [
                new et(a, e1, `array length ${r.length} expected, length ${e1.length} found`)
            ];
            if (r["min-length"] && e1.length < r["min-length"]) return [
                new et(a, e1, `array length at least ${r["min-length"]} expected, length ${e1.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (o.function = r.function), "object" === mr(r.value) && (o = r.value);
            let l = [];
            for(let r = 0; r < e1.length; r++)l = l.concat(s({
                array: e1,
                arrayIndex: r,
                value: e1[r],
                valueSpec: o,
                validateSpec: t1.validateSpec,
                style: n,
                styleSpec: i,
                key: `${a}[${r}]`
            }));
            return l;
        }
        function Yr(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec;
            let i = mr(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new et(e1, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new et(e1, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new et(e1, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function Hr(t1) {
            const e1 = t1.valueSpec, r = Kr(t1.value.type);
            let n, i, a, s = {};
            const o = "categorical" !== r && void 0 === t1.value.property, l = !o, u = "array" === mr(t1.value.stops) && "array" === mr(t1.value.stops[0]) && "object" === mr(t1.value.stops[0][0]), c = Jr({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                validateSpec: t1.validateSpec,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === r) return [
                            new et(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let e1 = [];
                        const n = t1.value;
                        return e1 = e1.concat(Xr({
                            key: t1.key,
                            value: n,
                            valueSpec: t1.valueSpec,
                            validateSpec: t1.validateSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: h
                        })), "array" === mr(n) && 0 === n.length && e1.push(new et(t1.key, n, "array must have at least one stop")), e1;
                    },
                    default: function(t1) {
                        return t1.validateSpec({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: e1,
                            validateSpec: t1.validateSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new et(t1.key, t1.value, 'missing required property "property"')), "identity" === r || t1.value.stops || c.push(new et(t1.key, t1.value, 'missing required property "stops"')), "exponential" === r && t1.valueSpec.expression && !yr(t1.valueSpec) && c.push(new et(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !fr(t1.valueSpec) ? c.push(new et(t1.key, t1.value, "property functions not supported")) : o && !dr(t1.valueSpec) && c.push(new et(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t1.value.property || c.push(new et(t1.key, t1.value, '"property" property is required')), c;
            function h(t1) {
                let r = [];
                const n = t1.value, o = t1.key;
                if ("array" !== mr(n)) return [
                    new et(o, n, `array expected, ${mr(n)} found`)
                ];
                if (2 !== n.length) return [
                    new et(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== mr(n[0])) return [
                        new et(o, n, `object expected, ${mr(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new et(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new et(o, n, "object stop key must have value")
                    ];
                    if (a && a > Kr(n[0].zoom)) return [
                        new et(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    Kr(n[0].zoom) !== a && (a = Kr(n[0].zoom), i = void 0, s = {}), r = r.concat(Jr({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t1.validateSpec,
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: Yr,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    validateSpec: t1.validateSpec,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, n));
                return Ir(Gr(n[1])) ? r.concat([
                    new et(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(t1.validateSpec({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e1,
                    validateSpec: t1.validateSpec,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function p(t1, a) {
                const o = mr(t1.value), l = Kr(t1.value), u = null !== t1.value ? t1.value : a;
                if (n) {
                    if (o !== n) return [
                        new et(t1.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new et(t1.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return fr(e1) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new et(t1.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
                    new et(t1.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in s ? [
                    new et(t1.key, u, "stop domain values must be unique")
                ] : (s[l] = !0, [])) : [
                    new et(t1.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function Wr(t1) {
            const e1 = ("property" === t1.expressionContext ? Br : zr)(Gr(t1.value), t1.valueSpec);
            if ("error" === e1.result) return e1.value.map((e1)=>new et(`${t1.key}${e1.key}`, t1.value, e1.message));
            const r = e1.value.expression || e1.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                new et(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !Be(r)) return [
                new et(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext && !Be(r)) return [
                new et(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!Ce(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new et(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !Pe(r)) return [
                    new et(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Qr(t1) {
            const e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(Kr(r)) && i.push(new et(e1, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(Kr(r)) && i.push(new et(e1, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function tn(t1) {
            return Er(Gr(t1.value)) ? Wr(rt({}, t1, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : en(t1);
        }
        function en(t1) {
            const e1 = t1.value, r = t1.key;
            if ("array" !== mr(e1)) return [
                new et(r, e1, `array expected, ${mr(e1)} found`)
            ];
            const n = t1.styleSpec;
            let i, a = [];
            if (e1.length < 1) return [
                new et(r, e1, "filter array must have at least 1 element")
            ];
            switch(a = a.concat(Qr({
                key: `${r}[0]`,
                value: e1[0],
                valueSpec: n.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), Kr(e1[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e1.length >= 2 && "$type" === Kr(e1[1]) && a.push(new et(r, e1, `"$type" cannot be use with operator "${e1[0]}"`));
                case "==":
                case "!=":
                    3 !== e1.length && a.push(new et(r, e1, `filter array for operator "${e1[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e1.length >= 2 && (i = mr(e1[1]), "string" !== i && a.push(new et(`${r}[1]`, e1[1], `string expected, ${i} found`)));
                    for(let s = 2; s < e1.length; s++)i = mr(e1[s]), "$type" === Kr(e1[1]) ? a = a.concat(Qr({
                        key: `${r}[${s}]`,
                        value: e1[s],
                        valueSpec: n.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && a.push(new et(`${r}[${s}]`, e1[s], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e1.length; n++)a = a.concat(en({
                        key: `${r}[${n}]`,
                        value: e1[n],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = mr(e1[1]), 2 !== e1.length ? a.push(new et(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "string" !== i && a.push(new et(`${r}[1]`, e1[1], `string expected, ${i} found`));
                    break;
                case "within":
                    i = mr(e1[1]), 2 !== e1.length ? a.push(new et(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "object" !== i && a.push(new et(`${r}[1]`, e1[1], `object expected, ${i} found`));
            }
            return a;
        }
        function rn(t1, e1) {
            const r = t1.key, n = t1.validateSpec, i = t1.style, a = t1.styleSpec, s = t1.value, o = t1.objectKey, l = a[`${e1}_${t1.layerType}`];
            if (!l) return [];
            const u = o.match(/^(.*)-transition$/);
            if ("paint" === e1 && u && l[u[1]] && l[u[1]].transition) return n({
                key: r,
                value: s,
                valueSpec: a.transition,
                style: i,
                styleSpec: a
            });
            const c = t1.valueSpec || l[o];
            if (!c) return [
                new et(r, s, `unknown property "${o}"`)
            ];
            let h;
            if ("string" === mr(s) && fr(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(s))) return [
                new et(r, s, `"${o}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === t1.layerType && ("text-field" === o && i && !i.glyphs && p.push(new et(r, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && gr(Gr(s)) && "identity" === Kr(s.type) && p.push(new et(r, s, '"text-font" does not support identity functions'))), p.concat(n({
                key: t1.key,
                value: s,
                valueSpec: c,
                style: i,
                styleSpec: a,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: o
            }));
        }
        function nn(t1) {
            return rn(t1, "paint");
        }
        function an(t1) {
            return rn(t1, "layout");
        }
        function sn(t1) {
            let e1 = [];
            const r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
            r.type || r.ref || e1.push(new et(n, r, 'either "type" or "ref" is required'));
            let s = Kr(r.type);
            const o = Kr(r.ref);
            if (r.id) {
                const a = Kr(r.id);
                for(let s = 0; s < t1.arrayIndex; s++){
                    const t1 = i.layers[s];
                    Kr(t1.id) === a && e1.push(new et(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in r && e1.push(new et(n, r[t1], `"${t1}" is prohibited for ref layers`));
                }), i.layers.forEach((e1)=>{
                    Kr(e1.id) === o && (t1 = e1);
                }), t1 ? t1.ref ? e1.push(new et(n, r.ref, "ref cannot reference another ref layer")) : s = Kr(t1.type) : e1.push(new et(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== s) {
                if (r.source) {
                    const t1 = i.sources && i.sources[r.source], a = t1 && Kr(t1.type);
                    t1 ? "vector" === a && "raster" === s ? e1.push(new et(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster" === a && "raster" !== s ? e1.push(new et(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== a || r["source-layer"] ? "raster-dem" === a && "hillshade" !== s ? e1.push(new et(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === a && t1.lineMetrics || e1.push(new et(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e1.push(new et(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e1.push(new et(n, r.source, `source "${r.source}" not found`));
                } else e1.push(new et(n, r, 'missing required property "source"'));
            }
            return e1 = e1.concat(Jr({
                key: n,
                value: r,
                valueSpec: a.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                validateSpec: t1.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>t1.validateSpec({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: a.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            validateSpec: t1.validateSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: tn,
                    layout: (t1)=>Jr({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            validateSpec: t1.validateSpec,
                            objectElementValidators: {
                                "*": (t1)=>an(rt({
                                        layerType: s
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>Jr({
                            layer: r,
                            key: t1.key,
                            value: t1.value,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            validateSpec: t1.validateSpec,
                            objectElementValidators: {
                                "*": (t1)=>nn(rt({
                                        layerType: s
                                    }, t1))
                            }
                        })
                }
            })), e1;
        }
        function on(t1) {
            const e1 = t1.value, r = t1.key, n = mr(e1);
            return "string" !== n ? [
                new et(r, e1, `string expected, ${n} found`)
            ] : [];
        }
        const ln = {
            promoteId: function({ key: t1, value: e1 }) {
                if ("string" === mr(e1)) return on({
                    key: t1,
                    value: e1
                });
                {
                    const r = [];
                    for(const n in e1)r.push(...on({
                        key: `${t1}.${n}`,
                        value: e1[n]
                    }));
                    return r;
                }
            }
        };
        function un(t1) {
            const e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style, a = t1.validateSpec;
            if (!e1.type) return [
                new et(r, e1, '"type" is required')
            ];
            const s = Kr(e1.type);
            let o;
            switch(s){
                case "vector":
                case "raster":
                case "raster-dem":
                    return o = Jr({
                        key: r,
                        value: e1,
                        valueSpec: n[`source_${s.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: n,
                        objectElementValidators: ln,
                        validateSpec: a
                    }), o;
                case "geojson":
                    if (o = Jr({
                        key: r,
                        value: e1,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        validateSpec: a,
                        objectElementValidators: ln
                    }), e1.cluster) for(const t1 in e1.clusterProperties){
                        const [n, i] = e1.clusterProperties[t1], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t1
                            ]
                        ] : n;
                        o.push(...Wr({
                            key: `${r}.${t1}.map`,
                            value: i,
                            validateSpec: a,
                            expressionContext: "cluster-map"
                        })), o.push(...Wr({
                            key: `${r}.${t1}.reduce`,
                            value: s,
                            validateSpec: a,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return o;
                case "video":
                    return Jr({
                        key: r,
                        value: e1,
                        valueSpec: n.source_video,
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
                case "image":
                    return Jr({
                        key: r,
                        value: e1,
                        valueSpec: n.source_image,
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new et(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Qr({
                        key: `${r}.type`,
                        value: e1.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
            }
        }
        function cn(t1) {
            const e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style;
            let a = [];
            const s = mr(e1);
            if (void 0 === e1) return a;
            if ("object" !== s) return a = a.concat([
                new et("light", e1, `object expected, ${s} found`)
            ]), a;
            for(const s in e1){
                const o = s.match(/^(.*)-transition$/);
                a = a.concat(o && n[o[1]] && n[o[1]].transition ? t1.validateSpec({
                    key: s,
                    value: e1[s],
                    valueSpec: r.transition,
                    validateSpec: t1.validateSpec,
                    style: i,
                    styleSpec: r
                }) : n[s] ? t1.validateSpec({
                    key: s,
                    value: e1[s],
                    valueSpec: n[s],
                    validateSpec: t1.validateSpec,
                    style: i,
                    styleSpec: r
                }) : [
                    new et(s, e1[s], `unknown property "${s}"`)
                ]);
            }
            return a;
        }
        function hn(t1) {
            const e1 = t1.value, r = t1.styleSpec, n = r.terrain, i = t1.style;
            let a = [];
            const s = mr(e1);
            if (void 0 === e1) return a;
            if ("object" !== s) return a = a.concat([
                new et("terrain", e1, `object expected, ${s} found`)
            ]), a;
            for(const s in e1)a = a.concat(n[s] ? t1.validateSpec({
                key: s,
                value: e1[s],
                valueSpec: n[s],
                validateSpec: t1.validateSpec,
                style: i,
                styleSpec: r
            }) : [
                new et(s, e1[s], `unknown property "${s}"`)
            ]);
            return a;
        }
        function pn(t1) {
            let e1 = [];
            const r = t1.value, n = t1.key;
            if (Array.isArray(r)) {
                const i = [], a = [];
                for(const s in r)r[s].id && i.includes(r[s].id) && e1.push(new et(n, r, `all the sprites' ids must be unique, but ${r[s].id} is duplicated`)), i.push(r[s].id), r[s].url && a.includes(r[s].url) && e1.push(new et(n, r, `all the sprites' URLs must be unique, but ${r[s].url} is duplicated`)), a.push(r[s].url), e1 = e1.concat(Jr({
                    key: `${n}[${s}]`,
                    value: r[s],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t1.validateSpec
                }));
                return e1;
            }
            return on({
                key: n,
                value: r
            });
        }
        const fn = {
            "*": ()=>[],
            array: Xr,
            boolean: function(t1) {
                const e1 = t1.value, r = t1.key, n = mr(e1);
                return "boolean" !== n ? [
                    new et(r, e1, `boolean expected, ${n} found`)
                ] : [];
            },
            number: Yr,
            color: function(t1) {
                const e1 = t1.key, r = t1.value, n = mr(r);
                return "string" !== n ? [
                    new et(e1, r, `color expected, ${n} found`)
                ] : jt.parse(String(r)) ? [] : [
                    new et(e1, r, `color expected, "${r}" found`)
                ];
            },
            constants: Zr,
            enum: Qr,
            filter: tn,
            function: Hr,
            layer: sn,
            object: Jr,
            source: un,
            light: cn,
            terrain: hn,
            string: on,
            formatted: function(t1) {
                return 0 === on(t1).length ? [] : Wr(t1);
            },
            resolvedImage: function(t1) {
                return 0 === on(t1).length ? [] : Wr(t1);
            },
            padding: function(t1) {
                const e1 = t1.key, r = t1.value;
                if ("array" === mr(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new et(e1, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const n = {
                        type: "number"
                    };
                    let i = [];
                    for(let a = 0; a < r.length; a++)i = i.concat(t1.validateSpec({
                        key: `${e1}[${a}]`,
                        value: r[a],
                        validateSpec: t1.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return Yr({
                    key: e1,
                    value: r,
                    valueSpec: {}
                });
            },
            sprite: pn
        };
        function dn(t1) {
            const e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            return t1.validateSpec = dn, r.expression && gr(Kr(e1)) ? Hr(t1) : r.expression && Ir(Gr(e1)) ? Wr(t1) : r.type && fn[r.type] ? fn[r.type](t1) : Jr(rt({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function yn(t1) {
            const e1 = t1.value, r = t1.key, n = on(t1);
            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new et(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new et(r, e1, '"glyphs" url must include a "{range}" token'))), n;
        }
        function mn(t1, e1 = j) {
            let r = [];
            return r = r.concat(dn({
                key: "",
                value: t1,
                valueSpec: e1.$root,
                styleSpec: e1,
                style: t1,
                validateSpec: dn,
                objectElementValidators: {
                    glyphs: yn,
                    "*": ()=>[]
                }
            })), t1.constants && (r = r.concat(Zr({
                key: "constants",
                value: t1.constants,
                style: t1,
                styleSpec: e1,
                validateSpec: dn
            }))), xn(r);
        }
        function gn(t1) {
            return function(e1) {
                return t1({
                    ...e1,
                    validateSpec: dn
                });
            };
        }
        function xn(t1) {
            return [].concat(t1).sort((t1, e1)=>t1.line - e1.line);
        }
        function vn(t1) {
            return function(...e1) {
                return xn(t1.apply(this, e1));
            };
        }
        mn.source = vn(gn(un)), mn.sprite = vn(gn(pn)), mn.glyphs = vn(gn(yn)), mn.light = vn(gn(cn)), mn.terrain = vn(gn(hn)), mn.layer = vn(gn(sn)), mn.filter = vn(gn(tn)), mn.paintProperty = vn(gn(nn)), mn.layoutProperty = vn(gn(an));
        const bn = mn, wn = bn.light, _n = bn.paintProperty, An = bn.layoutProperty;
        function kn(t1, e1) {
            let r = !1;
            if (e1 && e1.length) for (const n of e1)t1.fire(new R(new Error(n.message))), r = !0;
            return r;
        }
        class Sn {
            constructor(t1, e1, r){
                const n = this.cells = [];
                if (t1 instanceof ArrayBuffer) {
                    this.arrayBuffer = t1;
                    const i = new Int32Array(this.arrayBuffer);
                    t1 = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                    for(let t1 = 0; t1 < this.d * this.d; t1++){
                        const e1 = i[3 + t1], r = i[3 + t1 + 1];
                        n.push(e1 === r ? null : i.subarray(e1, r));
                    }
                    const a = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], a), this.bboxes = i.subarray(a), this.insert = this._insertReadonly;
                } else {
                    this.d = e1 + 2 * r;
                    for(let t1 = 0; t1 < this.d * this.d; t1++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
                const i = r / e1 * t1;
                this.min = -i, this.max = t1 + i;
            }
            insert(t1, e1, r, n, i) {
                this._forEachCell(e1, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t1, e1, r, n, i, a) {
                this.cells[i].push(a);
            }
            query(t1, e1, r, n, i) {
                const a = this.min, s = this.max;
                if (t1 <= a && e1 <= a && s <= r && s <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const a = [];
                    return this._forEachCell(t1, e1, r, n, this._queryCell, a, {}, i), a;
                }
            }
            _queryCell(t1, e1, r, n, i, a, s, o) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === s[h]) {
                            const l = 4 * h;
                            (o ? o(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t1 <= u[l + 2] && e1 <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (s[h] = !0, a.push(i[h])) : s[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(t1, e1, r, n, i, a, s, o) {
                const l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e1), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t1, e1, r, n, u, a, s, o)) return;
                }
            }
            _convertFromCellCoord(t1) {
                return (t1 - this.padding) / this.scale;
            }
            _convertToCellCoord(t1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let t1 = 0; t1 < this.cells.length; t1++)r += this.cells[t1].length;
                const n = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = e1;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1];
                    n[3 + e1] = i, n.set(r, i), i += r.length;
                }
                return n[3 + t1.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t1.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(t1, e1) {
                const r = t1.toArrayBuffer();
                return e1 && e1.push(r), {
                    buffer: r
                };
            }
            static deserialize(t1) {
                return new Sn(t1.buffer);
            }
        }
        const In = {};
        function zn(t1, e1, r = {}) {
            if (In[t1]) throw new Error(`${t1} is already registered.`);
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writeable: !1
            }), In[t1] = {
                klass: e1,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        zn("Object", Object), zn("TransferableGridIndex", Sn), zn("Color", jt), zn("Error", Error), zn("AJAXError", C), zn("ResolvedImage", Jt), zn("StylePropertyFunction", Cr), zn("StyleExpression", Sr, {
            omit: [
                "_evaluator"
            ]
        }), zn("ZoomDependentExpression", Pr), zn("ZoomConstantExpression", Mr), zn("CompoundExpression", ze, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in sr)sr[t1]._classRegistryKey || zn(`Expression_${t1}`, sr[t1]);
        function Mn(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function Pn(t1, e1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || t1 instanceof Blob) return t1;
            if (Mn(t1)) return e1 && e1.push(t1), t1;
            if (S(t1)) return e1 && e1.push(t1), t1;
            if (ArrayBuffer.isView(t1)) {
                const r = t1;
                return e1 && e1.push(r.buffer), r;
            }
            if (t1 instanceof ImageData) return e1 && e1.push(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const r = [];
                for (const n of t1)r.push(Pn(n, e1));
                return r;
            }
            if ("object" == typeof t1) {
                const r = t1.constructor, n = r._classRegistryKey;
                if (!n) throw new Error("can't serialize object of unregistered class");
                if (!In[n]) throw new Error(`${n} is not registered.`);
                const i = r.serialize ? r.serialize(t1, e1) : {};
                if (r.serialize) {
                    if (e1 && i === e1[e1.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                } else {
                    for(const r in t1){
                        if (!t1.hasOwnProperty(r)) continue;
                        if (In[n].omit.indexOf(r) >= 0) continue;
                        const a = t1[r];
                        i[r] = In[n].shallow.indexOf(r) >= 0 ? a : Pn(a, e1);
                    }
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function Bn(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || t1 instanceof Blob || Mn(t1) || S(t1) || ArrayBuffer.isView(t1) || t1 instanceof ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(Bn);
            if ("object" == typeof t1) {
                const e1 = t1.$name || "Object";
                if (!In[e1]) throw new Error(`can't deserialize unregistered class ${e1}`);
                const { klass: r } = In[e1];
                if (!r) throw new Error(`can't deserialize unregistered class ${e1}`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const r of Object.keys(t1)){
                    if ("$name" === r) continue;
                    const i = t1[r];
                    n[r] = In[e1].shallow.indexOf(r) >= 0 ? i : Bn(i);
                }
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        class Cn {
            constructor(){
                this.first = !0;
            }
            update(t1, e1) {
                const r = Math.floor(t1);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
            }
        }
        const Vn = {
            "Latin-1 Supplement": (t1)=>t1 >= 128 && t1 <= 255,
            Arabic: (t1)=>t1 >= 1536 && t1 <= 1791,
            "Arabic Supplement": (t1)=>t1 >= 1872 && t1 <= 1919,
            "Arabic Extended-A": (t1)=>t1 >= 2208 && t1 <= 2303,
            "Hangul Jamo": (t1)=>t1 >= 4352 && t1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t1)=>t1 >= 5120 && t1 <= 5759,
            Khmer: (t1)=>t1 >= 6016 && t1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t1)=>t1 >= 6320 && t1 <= 6399,
            "General Punctuation": (t1)=>t1 >= 8192 && t1 <= 8303,
            "Letterlike Symbols": (t1)=>t1 >= 8448 && t1 <= 8527,
            "Number Forms": (t1)=>t1 >= 8528 && t1 <= 8591,
            "Miscellaneous Technical": (t1)=>t1 >= 8960 && t1 <= 9215,
            "Control Pictures": (t1)=>t1 >= 9216 && t1 <= 9279,
            "Optical Character Recognition": (t1)=>t1 >= 9280 && t1 <= 9311,
            "Enclosed Alphanumerics": (t1)=>t1 >= 9312 && t1 <= 9471,
            "Geometric Shapes": (t1)=>t1 >= 9632 && t1 <= 9727,
            "Miscellaneous Symbols": (t1)=>t1 >= 9728 && t1 <= 9983,
            "Miscellaneous Symbols and Arrows": (t1)=>t1 >= 11008 && t1 <= 11263,
            "CJK Radicals Supplement": (t1)=>t1 >= 11904 && t1 <= 12031,
            "Kangxi Radicals": (t1)=>t1 >= 12032 && t1 <= 12255,
            "Ideographic Description Characters": (t1)=>t1 >= 12272 && t1 <= 12287,
            "CJK Symbols and Punctuation": (t1)=>t1 >= 12288 && t1 <= 12351,
            Hiragana: (t1)=>t1 >= 12352 && t1 <= 12447,
            Katakana: (t1)=>t1 >= 12448 && t1 <= 12543,
            Bopomofo: (t1)=>t1 >= 12544 && t1 <= 12591,
            "Hangul Compatibility Jamo": (t1)=>t1 >= 12592 && t1 <= 12687,
            Kanbun: (t1)=>t1 >= 12688 && t1 <= 12703,
            "Bopomofo Extended": (t1)=>t1 >= 12704 && t1 <= 12735,
            "CJK Strokes": (t1)=>t1 >= 12736 && t1 <= 12783,
            "Katakana Phonetic Extensions": (t1)=>t1 >= 12784 && t1 <= 12799,
            "Enclosed CJK Letters and Months": (t1)=>t1 >= 12800 && t1 <= 13055,
            "CJK Compatibility": (t1)=>t1 >= 13056 && t1 <= 13311,
            "CJK Unified Ideographs Extension A": (t1)=>t1 >= 13312 && t1 <= 19903,
            "Yijing Hexagram Symbols": (t1)=>t1 >= 19904 && t1 <= 19967,
            "CJK Unified Ideographs": (t1)=>t1 >= 19968 && t1 <= 40959,
            "Yi Syllables": (t1)=>t1 >= 40960 && t1 <= 42127,
            "Yi Radicals": (t1)=>t1 >= 42128 && t1 <= 42191,
            "Hangul Jamo Extended-A": (t1)=>t1 >= 43360 && t1 <= 43391,
            "Hangul Syllables": (t1)=>t1 >= 44032 && t1 <= 55215,
            "Hangul Jamo Extended-B": (t1)=>t1 >= 55216 && t1 <= 55295,
            "Private Use Area": (t1)=>t1 >= 57344 && t1 <= 63743,
            "CJK Compatibility Ideographs": (t1)=>t1 >= 63744 && t1 <= 64255,
            "Arabic Presentation Forms-A": (t1)=>t1 >= 64336 && t1 <= 65023,
            "Vertical Forms": (t1)=>t1 >= 65040 && t1 <= 65055,
            "CJK Compatibility Forms": (t1)=>t1 >= 65072 && t1 <= 65103,
            "Small Form Variants": (t1)=>t1 >= 65104 && t1 <= 65135,
            "Arabic Presentation Forms-B": (t1)=>t1 >= 65136 && t1 <= 65279,
            "Halfwidth and Fullwidth Forms": (t1)=>t1 >= 65280 && t1 <= 65519
        };
        function En(t1) {
            for (const e1 of t1)if (Ln(e1.charCodeAt(0))) return !0;
            return !1;
        }
        function Fn(t1) {
            for (const e1 of t1)if (!Tn(e1.charCodeAt(0))) return !1;
            return !0;
        }
        function Tn(t1) {
            return !(Vn.Arabic(t1) || Vn["Arabic Supplement"](t1) || Vn["Arabic Extended-A"](t1) || Vn["Arabic Presentation Forms-A"](t1) || Vn["Arabic Presentation Forms-B"](t1));
        }
        function Ln(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(Vn["Bopomofo Extended"](t1) || Vn.Bopomofo(t1) || Vn["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || Vn["CJK Compatibility Ideographs"](t1) || Vn["CJK Compatibility"](t1) || Vn["CJK Radicals Supplement"](t1) || Vn["CJK Strokes"](t1) || !(!Vn["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || Vn["CJK Unified Ideographs Extension A"](t1) || Vn["CJK Unified Ideographs"](t1) || Vn["Enclosed CJK Letters and Months"](t1) || Vn["Hangul Compatibility Jamo"](t1) || Vn["Hangul Jamo Extended-A"](t1) || Vn["Hangul Jamo Extended-B"](t1) || Vn["Hangul Jamo"](t1) || Vn["Hangul Syllables"](t1) || Vn.Hiragana(t1) || Vn["Ideographic Description Characters"](t1) || Vn.Kanbun(t1) || Vn["Kangxi Radicals"](t1) || Vn["Katakana Phonetic Extensions"](t1) || Vn.Katakana(t1) && 12540 !== t1 || !(!Vn["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!Vn["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || Vn["Unified Canadian Aboriginal Syllabics"](t1) || Vn["Unified Canadian Aboriginal Syllabics Extended"](t1) || Vn["Vertical Forms"](t1) || Vn["Yijing Hexagram Symbols"](t1) || Vn["Yi Syllables"](t1) || Vn["Yi Radicals"](t1))));
        }
        function $n(t1) {
            return !(Ln(t1) || function(t1) {
                return !!(Vn["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || Vn["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || Vn["Letterlike Symbols"](t1) || Vn["Number Forms"](t1) || Vn["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || Vn["Control Pictures"](t1) && 9251 !== t1 || Vn["Optical Character Recognition"](t1) || Vn["Enclosed Alphanumerics"](t1) || Vn["Geometric Shapes"](t1) || Vn["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || Vn["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || Vn["CJK Symbols and Punctuation"](t1) || Vn.Katakana(t1) || Vn["Private Use Area"](t1) || Vn["CJK Compatibility Forms"](t1) || Vn["Small Form Variants"](t1) || Vn["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function Dn(t1) {
            return t1 >= 1424 && t1 <= 2303 || Vn["Arabic Presentation Forms-A"](t1) || Vn["Arabic Presentation Forms-B"](t1);
        }
        function On(t1, e1) {
            return !(!e1 && Dn(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || Vn.Khmer(t1));
        }
        function Un(t1) {
            for (const e1 of t1)if (Dn(e1.charCodeAt(0))) return !0;
            return !1;
        }
        const Rn = "deferred", qn = "loading", jn = "loaded";
        let Nn = null, Zn = "unavailable", Kn = null;
        const Gn = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Zn = "error"), Nn && Nn(t1);
        };
        function Jn() {
            Xn.fire(new U("pluginStateChange", {
                pluginStatus: Zn,
                pluginURL: Kn
            }));
        }
        const Xn = new q, Yn = function() {
            return Zn;
        }, Hn = function() {
            if (Zn !== Rn || !Kn) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Zn = qn, Jn(), Kn && L({
                url: Kn
            }, (t1)=>{
                t1 ? Gn(t1) : (Zn = jn, Jn());
            });
        }, Wn = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Zn === jn || null != Wn.applyArabicShaping,
            isLoading: ()=>Zn === qn,
            setState (t1) {
                if (!_()) throw new Error("Cannot set the state of the rtl-text-plugin when not in the web-worker context");
                Zn = t1.pluginStatus, Kn = t1.pluginURL;
            },
            isParsed () {
                if (!_()) throw new Error("rtl-text-plugin is only parsed on the worker-threads");
                return null != Wn.applyArabicShaping && null != Wn.processBidirectionalText && null != Wn.processStyledBidirectionalText;
            },
            getPluginURL () {
                if (!_()) throw new Error("rtl-text-plugin url can only be queried from the worker threads");
                return Kn;
            }
        };
        class Qn {
            constructor(t1, e1){
                this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Cn, this.transition = {});
            }
            isSupportedScript(t1) {
                return function(t1, e1) {
                    for (const r of t1)if (!On(r.charCodeAt(0), e1)) return !1;
                    return !0;
                }(t1, Wn.isLoaded());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
                return t1 > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e1 + (1 - e1) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e1
                };
            }
        }
        class ti {
            constructor(t1, e1){
                this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                    if (gr(t1)) return new Cr(t1, e1);
                    if (Ir(t1)) {
                        const r = Br(t1, e1);
                        if ("error" === r.result) throw new Error(r.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t1;
                        return "color" === e1.type && "string" == typeof t1 ? r = jt.parse(t1) : "padding" !== e1.type || "number" != typeof t1 && !Array.isArray(t1) || (r = Gt.parse(t1)), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e1, r) {
                return this.property.possiblyEvaluate(this, t1, e1, r);
            }
        }
        class ei {
            constructor(t1){
                this.property = t1, this.value = new ti(t1, void 0);
            }
            transitioned(t1, e1) {
                return new ni(this.property, this.value, e1, p({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new ni(this.property, this.value, null, {}, 0);
            }
        }
        class ri {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
            }
            getValue(t1) {
                return g(this._values[t1].value.value);
            }
            setValue(t1, e1) {
                Object.prototype.hasOwnProperty.call(this._values, t1) || (this._values[t1] = new ei(this._values[t1].property)), this._values[t1].value = new ti(this._values[t1].property, null === e1 ? void 0 : g(e1));
            }
            getTransition(t1) {
                return g(this._values[t1].transition);
            }
            setTransition(t1, e1) {
                Object.prototype.hasOwnProperty.call(this._values, t1) || (this._values[t1] = new ei(this._values[t1].property)), this._values[t1].transition = g(e1) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                    const n = this.getTransition(e1);
                    void 0 !== n && (t1[`${e1}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e1) {
                const r = new ii(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e1._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new ii(this._properties);
                for (const e1 of Object.keys(this._values))t1._values[e1] = this._values[e1].untransitioned();
                return t1;
            }
        }
        class ni {
            constructor(t1, e1, r, n, i){
                this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t1, e1, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
                if (a) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                    {
                        const s = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                            if (t1 <= 0) return 0;
                            if (t1 >= 1) return 1;
                            const e1 = t1 * t1, r = e1 * t1;
                            return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                        }(s));
                    }
                }
                return i;
            }
        }
        class ii {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t1, e1, r) {
                const n = new oi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
        }
        class ai {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
            }
            getValue(t1) {
                return g(this._values[t1].value);
            }
            setValue(t1, e1) {
                this._values[t1] = new ti(this._values[t1].property, null === e1 ? void 0 : g(e1));
            }
            serialize() {
                const t1 = {};
                for (const e1 of Object.keys(this._values)){
                    const r = this.getValue(e1);
                    void 0 !== r && (t1[e1] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e1, r) {
                const n = new oi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                return n;
            }
        }
        class si {
            constructor(t1, e1, r){
                this.property = t1, this.value = e1, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e1, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
            }
        }
        class oi {
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
            get(t1) {
                return this._values[t1];
            }
        }
        class li {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e1) {
                if (t1.isDataDriven()) throw new Error("Value should not be data driven");
                return t1.expression.evaluate(e1);
            }
            interpolate(t1, e1, r) {
                const n = Le[this.specification.type];
                return n ? n(t1, e1, r) : t1;
            }
        }
        class ui {
            constructor(t1, e1){
                this.specification = t1, this.overrides = e1;
            }
            possiblyEvaluate(t1, e1, r, n) {
                return new si(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e1, null, {}, r, n)
                } : t1.expression, e1);
            }
            interpolate(t1, e1, r) {
                if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e1.value.value) return new si(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = Le[this.specification.type];
                if (n) {
                    const i = n(t1.value.value, e1.value.value, r);
                    return new si(this, {
                        kind: "constant",
                        value: i
                    }, t1.parameters);
                }
                return t1;
            }
            evaluate(t1, e1, r, n, i, a) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
            }
        }
        class ci extends ui {
            possiblyEvaluate(t1, e1, r, n) {
                if (void 0 === t1.value) return new si(this, {
                    kind: "constant",
                    value: void 0
                }, e1);
                if ("constant" === t1.expression.kind) {
                    const i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, s = this._calculate(a, a, a, e1);
                    return new si(this, {
                        kind: "constant",
                        value: s
                    }, e1);
                }
                if ("camera" === t1.expression.kind) {
                    const r = this._calculate(t1.expression.evaluate({
                        zoom: e1.zoom - 1
                    }), t1.expression.evaluate({
                        zoom: e1.zoom
                    }), t1.expression.evaluate({
                        zoom: e1.zoom + 1
                    }), e1);
                    return new si(this, {
                        kind: "constant",
                        value: r
                    }, e1);
                }
                return new si(this, t1.expression, e1);
            }
            evaluate(t1, e1, r, n, i, a) {
                if ("source" === t1.kind) {
                    const s = t1.evaluate(e1, r, n, i, a);
                    return this._calculate(s, s, s, e1);
                }
                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                    zoom: Math.floor(e1.zoom) - 1
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom)
                }, r, n), t1.evaluate({
                    zoom: Math.floor(e1.zoom) + 1
                }, r, n), e1) : t1.value;
            }
            _calculate(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }
            interpolate(t1) {
                return t1;
            }
        }
        class hi {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e1, r, n) {
                if (void 0 !== t1.value) {
                    if ("constant" === t1.expression.kind) {
                        const i = t1.expression.evaluate(e1, null, {}, r, n);
                        return this._calculate(i, i, i, e1);
                    }
                    return this._calculate(t1.expression.evaluate(new Qn(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new Qn(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new Qn(Math.floor(e1.zoom + 1), e1)), e1);
                }
            }
            _calculate(t1, e1, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t1,
                    to: e1
                } : {
                    from: r,
                    to: e1
                };
            }
            interpolate(t1) {
                return t1;
            }
        }
        class pi {
            constructor(t1){
                this.specification = t1;
            }
            possiblyEvaluate(t1, e1, r, n) {
                return !!t1.expression.evaluate(e1, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class fi {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e1 in t1){
                    const r = t1[e1];
                    r.specification.overridable && this.overridableProperties.push(e1);
                    const n = this.defaultPropertyValues[e1] = new ti(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new ei(r);
                    this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
                }
            }
        }
        zn("DataDrivenProperty", ui), zn("DataConstantProperty", li), zn("CrossFadedDataDrivenProperty", ci), zn("CrossFadedProperty", hi), zn("ColorRampProperty", pi);
        const di = "-transition";
        class yi extends q {
            constructor(t1, e1){
                if (super(), this.id = t1.id, this.type = t1.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1
                }, "custom" !== t1.type && (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, "background" !== t1.type && (this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter), e1.layout && (this._unevaluatedLayout = new ai(e1.layout)), e1.paint)) {
                    this._transitionablePaint = new ri(e1.paint);
                    for(const e1 in t1.paint)this.setPaintProperty(e1, t1.paint[e1], {
                        validate: !1
                    });
                    for(const e1 in t1.layout)this.setLayoutProperty(e1, t1.layout[e1], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new oi(e1.paint);
                }
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e1, r = {}) {
                null != e1 && this._validate(An, `layers.${this.id}.layout.${t1}`, t1, e1, r) || ("visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1);
            }
            getPaintProperty(t1) {
                return t1.endsWith(di) ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e1, r = {}) {
                if (null != e1 && this._validate(_n, `layers.${this.id}.paint.${t1}`, t1, e1, r)) return !1;
                if (t1.endsWith(di)) return this._transitionablePaint.setTransition(t1.slice(0, -11), e1 || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t1], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), a = r.value;
                    this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                    const s = this._transitionablePaint._values[t1].value;
                    return s.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t1, a, s);
                }
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e1) {
                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
            }
            serialize() {
                const t1 = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), m(t1, (t1, e1)=>!(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length));
            }
            _validate(t1, e1, r, n, i = {}) {
                return (!i || !1 !== i.validate) && kn(this, t1.call(bn, {
                    key: e1,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: j,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e1 = this.paint.get(t1);
                    if (e1 instanceof si && fr(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        const mi = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class gi {
            constructor(t1, e1){
                this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class xi {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t1, e1) {
                return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e1 = Object.create(this.prototype);
                return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e1 = this.uint8;
                    this._refreshViews(), e1 && this.uint8.set(e1);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
        }
        function vi(t1, e1 = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = mi[t1.type].BYTES_PER_ELEMENT, a = r = bi(r, Math.max(e1, i)), s = t1.components || 1;
                    return n = Math.max(n, i), r += i * s, {
                        name: t1.name,
                        type: t1.type,
                        components: s,
                        offset: a
                    };
                }),
                size: bi(r, Math.max(n, e1)),
                alignment: e1
            };
        }
        function bi(t1, e1) {
            return Math.ceil(t1 / e1) * e1;
        }
        class wi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
            }
        }
        wi.prototype.bytesPerElement = 4, zn("StructArrayLayout2i4", wi);
        class _i extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        _i.prototype.bytesPerElement = 6, zn("StructArrayLayout3i6", _i);
        class Ai extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const a = 4 * t1;
                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
            }
        }
        Ai.prototype.bytesPerElement = 8, zn("StructArrayLayout4i8", Ai);
        class ki extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i, a);
            }
            emplace(t1, e1, r, n, i, a, s) {
                const o = 6 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t1;
            }
        }
        ki.prototype.bytesPerElement = 12, zn("StructArrayLayout2i4i12", ki);
        class Si extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i, a);
            }
            emplace(t1, e1, r, n, i, a, s) {
                const o = 4 * t1, l = 8 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = s, t1;
            }
        }
        Si.prototype.bytesPerElement = 8, zn("StructArrayLayout2i4ub8", Si);
        class Ii extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
            }
        }
        Ii.prototype.bytesPerElement = 8, zn("StructArrayLayout2f8", Ii);
        class zi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t1, e1, r, n, i, a, s, o, l, u);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c) {
                const h = 10 * t1;
                return this.uint16[h + 0] = e1, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = a, this.uint16[h + 5] = s, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t1;
            }
        }
        zi.prototype.bytesPerElement = 20, zn("StructArrayLayout10ui20", zi);
        class Mi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e1, r, n, i, a, s, o, l, u, c, h);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = s, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        Mi.prototype.bytesPerElement = 24, zn("StructArrayLayout4i4ui4i24", Mi);
        class Pi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        Pi.prototype.bytesPerElement = 12, zn("StructArrayLayout3f12", Pi);
        class Bi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint32[1 * t1 + 0] = e1, t1;
            }
        }
        Bi.prototype.bytesPerElement = 4, zn("StructArrayLayout1ul4", Bi);
        class Ci extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t1, e1, r, n, i, a, s, o, l);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u) {
                const c = 10 * t1, h = 5 * t1;
                return this.int16[c + 0] = e1, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = a, this.int16[c + 5] = s, this.uint32[h + 3] = o, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t1;
            }
        }
        Ci.prototype.bytesPerElement = 20, zn("StructArrayLayout6i1ul2ui20", Ci);
        class Vi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e1, r, n, i, a);
            }
            emplace(t1, e1, r, n, i, a, s) {
                const o = 6 * t1;
                return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t1;
            }
        }
        Vi.prototype.bytesPerElement = 12, zn("StructArrayLayout2i2i2i12", Vi);
        class Ei extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
            }
            emplace(t1, e1, r, n, i, a) {
                const s = 4 * t1, o = 8 * t1;
                return this.float32[s + 0] = e1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = a, t1;
            }
        }
        Ei.prototype.bytesPerElement = 16, zn("StructArrayLayout2f1f2i16", Ei);
        class Fi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const a = 12 * t1, s = 3 * t1;
                return this.uint8[a + 0] = e1, this.uint8[a + 1] = r, this.float32[s + 1] = n, this.float32[s + 2] = i, t1;
            }
        }
        Fi.prototype.bytesPerElement = 12, zn("StructArrayLayout2ub2f12", Fi);
        class Ti extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        Ti.prototype.bytesPerElement = 6, zn("StructArrayLayout3ui6", Ti);
        class Li extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t1, v = 12 * t1, b = 48 * t1;
                return this.int16[x + 0] = e1, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = a, this.uint32[v + 3] = s, this.uint32[v + 4] = o, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t1;
            }
        }
        Li.prototype.bytesPerElement = 48, zn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Li);
        class $i extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, k, S, I, z) {
                const M = this.length;
                return this.resize(M + 1), this.emplace(M, t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, k, S, I, z);
            }
            emplace(t1, e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, k, S, I, z, M) {
                const P = 34 * t1, B = 17 * t1;
                return this.int16[P + 0] = e1, this.int16[P + 1] = r, this.int16[P + 2] = n, this.int16[P + 3] = i, this.int16[P + 4] = a, this.int16[P + 5] = s, this.int16[P + 6] = o, this.int16[P + 7] = l, this.uint16[P + 8] = u, this.uint16[P + 9] = c, this.uint16[P + 10] = h, this.uint16[P + 11] = p, this.uint16[P + 12] = f, this.uint16[P + 13] = d, this.uint16[P + 14] = y, this.uint16[P + 15] = m, this.uint16[P + 16] = g, this.uint16[P + 17] = x, this.uint16[P + 18] = v, this.uint16[P + 19] = b, this.uint16[P + 20] = w, this.uint16[P + 21] = _, this.uint16[P + 22] = A, this.uint32[B + 12] = k, this.float32[B + 13] = S, this.float32[B + 14] = I, this.float32[B + 15] = z, this.float32[B + 16] = M, t1;
            }
        }
        $i.prototype.bytesPerElement = 68, zn("StructArrayLayout8i15ui1ul4f68", $i);
        class Di extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.float32[1 * t1 + 0] = e1, t1;
            }
        }
        Di.prototype.bytesPerElement = 4, zn("StructArrayLayout1f4", Di);
        class Oi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e1, r);
            }
            emplace(t1, e1, r, n) {
                const i = 4 * t1;
                return this.uint32[2 * t1 + 0] = e1, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t1;
            }
        }
        Oi.prototype.bytesPerElement = 8, zn("StructArrayLayout1ul2ui8", Oi);
        class Ui extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e1);
            }
            emplace(t1, e1, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
            }
        }
        Ui.prototype.bytesPerElement = 4, zn("StructArrayLayout2ui4", Ui);
        class Ri extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e1 = this.length;
                return this.resize(e1 + 1), this.emplace(e1, t1);
            }
            emplace(t1, e1) {
                return this.uint16[1 * t1 + 0] = e1, t1;
            }
        }
        Ri.prototype.bytesPerElement = 2, zn("StructArrayLayout1ui2", Ri);
        class qi extends xi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
            }
            emplace(t1, e1, r, n, i) {
                const a = 4 * t1;
                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
            }
        }
        qi.prototype.bytesPerElement = 16, zn("StructArrayLayout4f16", qi);
        class ji extends gi {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new i(this.anchorPointX, this.anchorPointY);
            }
        }
        ji.prototype.size = 20;
        class Ni extends Ci {
            get(t1) {
                return new ji(this, t1);
            }
        }
        zn("CollisionBoxArray", Ni);
        class Zi extends gi {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 37] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 38] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 10] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        Zi.prototype.size = 48;
        class Ki extends Li {
            get(t1) {
                return new Zi(this, t1);
            }
        }
        zn("PlacedSymbolArray", Ki);
        class Gi extends gi {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 12] = t1;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 16];
            }
        }
        Gi.prototype.size = 68;
        class Ji extends $i {
            get(t1) {
                return new Gi(this, t1);
            }
        }
        zn("SymbolInstanceArray", Ji);
        class Xi extends Di {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        zn("GlyphOffsetArray", Xi);
        class Yi extends _i {
            getx(t1) {
                return this.int16[3 * t1 + 0];
            }
            gety(t1) {
                return this.int16[3 * t1 + 1];
            }
            gettileUnitDistanceFromAnchor(t1) {
                return this.int16[3 * t1 + 2];
            }
        }
        zn("SymbolLineVertexArray", Yi);
        class Hi extends gi {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        Hi.prototype.size = 8;
        class Wi extends Oi {
            get(t1) {
                return new Hi(this, t1);
            }
        }
        zn("FeatureIndexArray", Wi);
        class Qi extends wi {
        }
        class ta extends wi {
        }
        class ea extends wi {
        }
        class ra extends ki {
        }
        class na extends Si {
        }
        class ia extends Ii {
        }
        class aa extends zi {
        }
        class sa extends Mi {
        }
        class oa extends Pi {
        }
        class la extends Bi {
        }
        class ua extends Vi {
        }
        class ca extends Fi {
        }
        class ha extends Ti {
        }
        class pa extends Ui {
        }
        const fa = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: da } = fa;
        class ya {
            constructor(t1 = []){
                this.segments = t1;
            }
            prepareSegment(t1, e1, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > ya.MAX_VERTEX_ARRAY_LENGTH && v(`Max vertices per segment is ${ya.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > ya.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e1.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e1 in t1.vaos)t1.vaos[e1].destroy();
            }
            static simpleSegment(t1, e1, r, n) {
                return new ya([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e1,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function ma(t1, e1) {
            return 256 * (t1 = c(Math.floor(t1), 0, 255)) + c(Math.floor(e1), 0, 255);
        }
        ya.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, zn("SegmentVector", ya);
        const ga = vi([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]);
        var xa = {
            exports: {}
        }, va = {
            exports: {}
        };
        va.exports = function(t1, e1) {
            var r, n, i, a, s, o, l, u;
            for(n = t1.length - (r = 3 & t1.length), i = e1, s = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
            switch(l = 0, r){
                case 3:
                    l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                case 2:
                    l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                case 1:
                    i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
            }
            return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        };
        var ba = va.exports, wa = {
            exports: {}
        };
        wa.exports = function(t1, e1) {
            for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
            switch(n){
                case 3:
                    i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                case 2:
                    i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                case 1:
                    i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
            }
            return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        };
        var _a = ba, Aa = wa.exports;
        xa.exports = _a, xa.exports.murmur3 = _a, xa.exports.murmur2 = Aa;
        var ka = e1(xa.exports);
        class Sa {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t1, e1, r, n) {
                this.ids.push(Ia(t1)), this.positions.push(e1, r, n);
            }
            getPositions(t1) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e1 = Ia(t1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t1 = r + n >> 1;
                    this.ids[t1] >= e1 ? n = t1 : r = t1 + 1;
                }
                const i = [];
                for(; this.ids[r] === e1;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t1, e1) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return za(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e1 = new Sa;
                return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
            }
        }
        function Ia(t1) {
            const e1 = +t1;
            return !isNaN(e1) && e1 <= Number.MAX_SAFE_INTEGER ? e1 : ka(String(t1));
        }
        function za(t1, e1, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let a = r - 1, s = n + 1;
                for(;;){
                    do a++;
                    while (t1[a] < i);
                    do s--;
                    while (t1[s] > i);
                    if (a >= s) break;
                    Ma(t1, a, s), Ma(e1, 3 * a, 3 * s), Ma(e1, 3 * a + 1, 3 * s + 1), Ma(e1, 3 * a + 2, 3 * s + 2);
                }
                s - r < n - s ? (za(t1, e1, r, s), r = s + 1) : (za(t1, e1, s + 1, n), n = s);
            }
        }
        function Ma(t1, e1, r) {
            const n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        zn("FeaturePositionMap", Sa);
        class Pa {
            constructor(t1, e1){
                this.gl = t1.gl, this.location = e1;
            }
        }
        class Ba extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = 0;
            }
            set(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
            }
        }
        class Ca extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
            }
        }
        class Va extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = jt.transparent;
            }
            set(t1) {
                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
            }
        }
        const Ea = new Float32Array(16);
        function Fa(t1) {
            return [
                ma(255 * t1.r, 255 * t1.g),
                ma(255 * t1.b, 255 * t1.a)
            ];
        }
        class Ta {
            constructor(t1, e1, r){
                this.value = t1, this.uniformNames = e1.map((t1)=>`u_${t1}`), this.type = r;
            }
            setUniform(t1, e1, r) {
                t1.set(r.constantOr(this.value));
            }
            getBinding(t1, e1, r) {
                return "color" === this.type ? new Va(t1, e1) : new Ba(t1, e1);
            }
        }
        class La {
            constructor(t1, e1){
                this.uniformNames = e1.map((t1)=>`u_${t1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(t1, e1) {
                this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
            }
            setUniform(t1, e1, r, n) {
                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                i && t1.set(i);
            }
            getBinding(t1, e1, r) {
                return "u_pattern" === r.substr(0, 9) ? new Ca(t1, e1) : new Ba(t1, e1);
            }
        }
        class $a {
            constructor(t1, e1, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t1, e1, r, n, i) {
                const a = this.paintVertexArray.length, s = this.expression.evaluate(new Qn(0), e1, {}, n, [], i);
                this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, s);
            }
            updatePaintArray(t1, e1, r, n) {
                const i = this.expression.evaluate({
                    zoom: 0
                }, r, n);
                this._setPaintValue(t1, e1, i);
            }
            _setPaintValue(t1, e1, r) {
                if ("color" === this.type) {
                    const n = Fa(r);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t1; n < e1; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Da {
            constructor(t1, e1, r, n, i, a){
                this.expression = t1, this.uniformNames = e1.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new a;
            }
            populatePaintArray(t1, e1, r, n, i) {
                const a = this.expression.evaluate(new Qn(this.zoom), e1, {}, n, [], i), s = this.expression.evaluate(new Qn(this.zoom + 1), e1, {}, n, [], i), o = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(o, t1, a, s);
            }
            updatePaintArray(t1, e1, r, n) {
                const i = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n), a = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n);
                this._setPaintValue(t1, e1, i, a);
            }
            _setPaintValue(t1, e1, r, n) {
                if ("color" === this.type) {
                    const i = Fa(r), a = Fa(n);
                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, i[0], i[1], a[0], a[1]);
                } else {
                    for(let i = t1; i < e1; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e1) {
                const r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = c(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                t1.set(n);
            }
            getBinding(t1, e1, r) {
                return new Ba(t1, e1);
            }
        }
        class Oa {
            constructor(t1, e1, r, n, i, a){
                this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(t1, e1, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e1, r, n, i) {
                this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
            }
            _setPaintValues(t1, e1, r, n) {
                if (!n || !r) return;
                const { min: i, mid: a, max: s } = r, o = n[i], l = n[a], u = n[s];
                if (o && l && u) for(let r = t1; r < e1; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], l.pixelRatio, o.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], u.tl[0], u.tl[1], u.br[0], u.br[1], l.pixelRatio, u.pixelRatio);
            }
            upload(t1) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, ga.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, ga.members, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class Ua {
            constructor(t1, e1, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t1.paint._values){
                    if (!r(i)) continue;
                    const a = t1.paint.get(i);
                    if (!(a instanceof si && fr(a.property.specification))) continue;
                    const s = qa(i, t1.type), o = a.value, l = a.property.specification.type, u = a.property.useIntegerZoom, c = a.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === o.kind) this.binders[i] = h ? new La(o.value, s) : new Ta(o.value, s, l), n.push(`/u_${i}`);
                    else if ("source" === o.kind || h) {
                        const r = ja(i, l, "source");
                        this.binders[i] = h ? new Oa(o, l, u, e1, r, t1.id) : new $a(o, s, l, r), n.push(`/a_${i}`);
                    } else {
                        const t1 = ja(i, l, "composite");
                        this.binders[i] = new Da(o, s, l, u, e1, t1), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t1) {
                const e1 = this.binders[t1];
                return e1 instanceof $a || e1 instanceof Da ? e1.maxValue : 0;
            }
            populatePaintArrays(t1, e1, r, n, i) {
                for(const a in this.binders){
                    const s = this.binders[a];
                    (s instanceof $a || s instanceof Da || s instanceof Oa) && s.populatePaintArray(t1, e1, r, n, i);
                }
            }
            setConstantPatternPositions(t1, e1) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof La && n.setConstantPatternPositions(t1, e1);
                }
            }
            updatePaintArrays(t1, e1, r, n, i) {
                let a = !1;
                for(const s in t1){
                    const o = e1.getPositions(s);
                    for (const e1 of o){
                        const o = r.feature(e1.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof $a || l instanceof Da || l instanceof Oa) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(e1.start, e1.end, o, t1[s], i), a = !0;
                            }
                        }
                    }
                }
                return a;
            }
            defines() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof Ta || r instanceof La) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof $a || r instanceof Da) for(let e1 = 0; e1 < r.paintVertexAttributes.length; e1++)t1.push(r.paintVertexAttributes[e1].name);
                    else if (r instanceof Oa) for(let e1 = 0; e1 < ga.members.length; e1++)t1.push(ga.members[e1].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (r instanceof Ta || r instanceof La || r instanceof Da) for (const e1 of r.uniformNames)t1.push(e1);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1, e1) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Ta || i instanceof La || i instanceof Da) {
                        for (const a of i.uniformNames)if (e1[a]) {
                            const s = i.getBinding(t1, e1[a], a);
                            r.push({
                                name: a,
                                property: n,
                                binding: s
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(t1, e1, r, n) {
                for (const { name: t1, property: i, binding: a } of e1)this.binders[i].setUniform(a, n, r.get(i), t1);
            }
            updatePaintBuffers(t1) {
                this._buffers = [];
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    if (t1 && r instanceof Oa) {
                        const e1 = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e1 && this._buffers.push(e1);
                    } else (r instanceof $a || r instanceof Da) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t1) {
                for(const e1 in this.binders){
                    const r = this.binders[e1];
                    (r instanceof $a || r instanceof Da || r instanceof Oa) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e1 = this.binders[t1];
                    (e1 instanceof $a || e1 instanceof Da || e1 instanceof Oa) && e1.destroy();
                }
            }
        }
        class Ra {
            constructor(t1, e1, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new Ua(n, e1, r);
                this.needsUpload = !1, this._featureMap = new Sa, this._bufferOffset = 0;
            }
            populatePaintArrays(t1, e1, r, n, i, a) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e1, n, i, a);
                void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e1, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t1, this._featureMap, e1, i, n) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
        }
        function qa(t1, e1) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t1] || [
                t1.replace(`${e1}-`, "").replace(/-/g, "_")
            ];
        }
        function ja(t1, e1, r) {
            const n = {
                color: {
                    source: Ii,
                    composite: qi
                },
                number: {
                    source: Di,
                    composite: Ii
                }
            }, i = function(t1) {
                return ({
                    "line-pattern": {
                        source: aa,
                        composite: aa
                    },
                    "fill-pattern": {
                        source: aa,
                        composite: aa
                    },
                    "fill-extrusion-pattern": {
                        source: aa,
                        composite: aa
                    }
                })[t1];
            }(t1);
            return i && i[r] || n[e1][r];
        }
        zn("ConstantBinder", Ta), zn("CrossFadedConstantBinder", La), zn("SourceExpressionBinder", $a), zn("CrossFadedCompositeBinder", Oa), zn("CompositeExpressionBinder", Da), zn("ProgramConfiguration", Ua, {
            omit: [
                "_buffers"
            ]
        }), zn("ProgramConfigurationSet", Ra);
        var Na = 8192;
        const Za = Math.pow(2, 14) - 1, Ka = -Za - 1;
        function Ga(t1) {
            const e1 = Na / t1.extent, r = t1.loadGeometry();
            for(let t1 = 0; t1 < r.length; t1++){
                const n = r[t1];
                for(let t1 = 0; t1 < n.length; t1++){
                    const r = n[t1], i = Math.round(r.x * e1), a = Math.round(r.y * e1);
                    r.x = c(i, Ka, Za), r.y = c(a, Ka, Za), (i < r.x || i > r.x + 1 || a < r.y || a > r.y + 1) && v("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function Ja(t1, e1) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e1 ? Ga(t1) : []
            };
        }
        function Xa(t1, e1, r, n, i) {
            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        class Ya {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new ta, this.indexArray = new ha, this.segments = new ya, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            populate(t1, e1, r) {
                const n = this.layers[0], i = [];
                let a = null, s = !1;
                "circle" === n.type && (a = n.layout.get("circle-sort-key"), s = !a.isConstant());
                for (const { feature: e1, id: n, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Ja(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), u, r)) continue;
                    const c = s ? a.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : Ga(e1),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                s && i.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of i){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n, o = t1[a].feature;
                    this.addFeature(n, i, a, r), e1.featureIndex.insert(o, i, a, s, this.index);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, da), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e1, r, n) {
                for (const r of e1)for (const e1 of r){
                    const r = e1.x, n = e1.y;
                    if (r < 0 || r >= Na || n < 0 || n >= Na) continue;
                    const i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), a = i.vertexLength;
                    Xa(this.layoutVertexArray, r, n, -1, -1), Xa(this.layoutVertexArray, r, n, 1, -1), Xa(this.layoutVertexArray, r, n, 1, 1), Xa(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 3, a + 2), i.vertexLength += 4, i.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
            }
        }
        function Ha(t1, e1) {
            for(let r = 0; r < t1.length; r++)if (ss(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (ss(t1, e1[r])) return !0;
            return !!es(t1, e1);
        }
        function Wa(t1, e1, r) {
            return !!ss(t1, e1) || !!ns(e1, t1, r);
        }
        function Qa(t1, e1) {
            if (1 === t1.length) return as(e1, t1[0]);
            for(let r = 0; r < e1.length; r++){
                const n = e1[r];
                for(let e1 = 0; e1 < n.length; e1++)if (ss(t1, n[e1])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (as(e1, t1[r])) return !0;
            for(let r = 0; r < e1.length; r++)if (es(t1, e1[r])) return !0;
            return !1;
        }
        function ts(t1, e1, r) {
            if (t1.length > 1) {
                if (es(t1, e1)) return !0;
                for(let n = 0; n < e1.length; n++)if (ns(e1[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (ns(t1[n], e1, r)) return !0;
            return !1;
        }
        function es(t1, e1) {
            if (0 === t1.length || 0 === e1.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e1.length - 1; t1++)if (rs(n, i, e1[t1], e1[t1 + 1])) return !0;
            }
            return !1;
        }
        function rs(t1, e1, r, n) {
            return b(t1, r, n) !== b(e1, r, n) && b(t1, e1, r) !== b(t1, e1, n);
        }
        function ns(t1, e1, r) {
            const n = r * r;
            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
            for(let r = 1; r < e1.length; r++)if (is(t1, e1[r - 1], e1[r]) < n) return !0;
            return !1;
        }
        function is(t1, e1, r) {
            const n = e1.distSqr(r);
            if (0 === n) return t1.distSqr(e1);
            const i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
            return t1.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function as(t1, e1) {
            let r, n, i, a = !1;
            for(let s = 0; s < t1.length; s++){
                r = t1[s];
                for(let t1 = 0, s = r.length - 1; t1 < r.length; s = t1++)n = r[t1], i = r[s], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            }
            return a;
        }
        function ss(t1, e1) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const a = t1[n], s = t1[i];
                a.y > e1.y != s.y > e1.y && e1.x < (s.x - a.x) * (e1.y - a.y) / (s.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function os(t1, e1, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
            const a = b(t1, e1, r[0]);
            return a !== b(t1, e1, r[1]) || a !== b(t1, e1, r[2]) || a !== b(t1, e1, r[3]);
        }
        function ls(t1, e1, r) {
            const n = e1.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
        }
        function us(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function cs(t1, e1, r, n, a) {
            if (!e1[0] && !e1[1]) return t1;
            const s = i.convert(e1)._mult(a);
            "viewport" === r && s._rotate(-n);
            const o = [];
            for(let e1 = 0; e1 < t1.length; e1++)o.push(t1[e1].sub(s));
            return o;
        }
        let hs, ps;
        zn("CircleBucket", Ya, {
            omit: [
                "layers"
            ]
        });
        var fs = {
            get paint () {
                return ps = ps || new fi({
                    "circle-radius": new ui(j.paint_circle["circle-radius"]),
                    "circle-color": new ui(j.paint_circle["circle-color"]),
                    "circle-blur": new ui(j.paint_circle["circle-blur"]),
                    "circle-opacity": new ui(j.paint_circle["circle-opacity"]),
                    "circle-translate": new li(j.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new li(j.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new li(j.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new li(j.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new ui(j.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new ui(j.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new ui(j.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return hs = hs || new fi({
                    "circle-sort-key": new ui(j.layout_circle["circle-sort-key"])
                });
            }
        }, ds = 1e-6, ys = "undefined" != typeof Float32Array ? Float32Array : Array;
        function ms(t1) {
            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }
        function gs(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], s = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], y = e1[12], m = e1[13], g = e1[14], x = e1[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t1[0] = v * n + b * o + w * h + _ * y, t1[1] = v * i + b * l + w * p + _ * m, t1[2] = v * a + b * u + w * f + _ * g, t1[3] = v * s + b * c + w * d + _ * x, t1[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t1[5] = v * i + b * l + w * p + _ * m, t1[6] = v * a + b * u + w * f + _ * g, t1[7] = v * s + b * c + w * d + _ * x, t1[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t1[9] = v * i + b * l + w * p + _ * m, t1[10] = v * a + b * u + w * f + _ * g, t1[11] = v * s + b * c + w * d + _ * x, t1[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t1[13] = v * i + b * l + w * p + _ * m, t1[14] = v * a + b * u + w * f + _ * g, t1[15] = v * s + b * c + w * d + _ * x, t1;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t1 = 0, e1 = arguments.length; e1--;)t1 += arguments[e1] * arguments[e1];
            return Math.sqrt(t1);
        });
        var xs, vs = gs;
        function bs(t1, e1, r) {
            var n = e1[0], i = e1[1], a = e1[2], s = e1[3];
            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * s, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * s, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * s, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * s, t1;
        }
        function ws(t1, e1) {
            const r = bs([], [
                t1.x,
                t1.y,
                0,
                1
            ], e1);
            return new i(r[0] / r[3], r[1] / r[3]);
        }
        xs = new ys(4), ys != Float32Array && (xs[0] = 0, xs[1] = 0, xs[2] = 0, xs[3] = 0);
        class _s extends Ya {
        }
        let As;
        zn("HeatmapBucket", _s, {
            omit: [
                "layers"
            ]
        });
        var ks = {
            get paint () {
                return As = As || new fi({
                    "heatmap-radius": new ui(j.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new ui(j.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new li(j.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new pi(j.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new li(j.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function Ss(t1, { width: e1, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e1 * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e1 * r * n}`);
            } else i = new Uint8Array(e1 * r * n);
            return t1.width = e1, t1.height = r, t1.data = i, t1;
        }
        function Is(t1, { width: e1, height: r }, n) {
            if (e1 === t1.width && r === t1.height) return;
            const i = Ss({}, {
                width: e1,
                height: r
            }, n);
            zs(t1, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, e1),
                height: Math.min(t1.height, r)
            }, n), t1.width = e1, t1.height = r, t1.data = i.data;
        }
        function zs(t1, e1, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const s = t1.data, o = e1.data;
            if (s === o) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t1.width + r.x) * a, c = ((n.y + l) * e1.width + n.x) * a;
                for(let t1 = 0; t1 < i.width * a; t1++)o[c + t1] = s[u + t1];
            }
            return e1;
        }
        class Ms {
            constructor(t1, e1){
                Ss(this, t1, 1, e1);
            }
            resize(t1) {
                Is(this, t1, 1);
            }
            clone() {
                return new Ms({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                zs(t1, e1, r, n, i, 1);
            }
        }
        class Ps {
            constructor(t1, e1){
                Ss(this, t1, 4, e1);
            }
            resize(t1) {
                Is(this, t1, 4);
            }
            replace(t1, e1) {
                e1 ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new Ps({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e1, r, n, i) {
                zs(t1, e1, r, n, i, 4);
            }
        }
        function Bs(t1) {
            const e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new Ps({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const a = (r, n, a)=>{
                e1[t1.evaluationKey] = a;
                const s = t1.expression.evaluate(e1);
                i.data[r + n + 0] = Math.floor(255 * s.r / s.a), i.data[r + n + 1] = Math.floor(255 * s.g / s.a), i.data[r + n + 2] = Math.floor(255 * s.b / s.a), i.data[r + n + 3] = Math.floor(255 * s.a);
            };
            if (t1.clips) for(let e1 = 0, i = 0; e1 < n; ++e1, i += 4 * r)for(let n = 0, s = 0; n < r; n++, s += 4){
                const o = n / (r - 1), { start: l, end: u } = t1.clips[e1];
                a(i, s, l * (1 - o) + u * o);
            }
            else for(let t1 = 0, e1 = 0; t1 < r; t1++, e1 += 4)a(0, e1, t1 / (r - 1));
            return i;
        }
        let Cs;
        zn("AlphaImage", Ms), zn("RGBAImage", Ps);
        var Vs = {
            get paint () {
                return Cs = Cs || new fi({
                    "hillshade-illumination-direction": new li(j.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-anchor": new li(j.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new li(j.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new li(j.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new li(j.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new li(j.paint_hillshade["hillshade-accent-color"])
                });
            }
        };
        const Es = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Fs } = Es;
        var Ts = {
            exports: {}
        };
        function Ls(t1, e1, r) {
            r = r || 2;
            var n, i, a, s, o, l, u, c = e1 && e1.length, h = c ? e1[0] * r : t1.length, p = $s(t1, 0, h, r, !0), f = [];
            if (!p || p.next === p.prev) return f;
            if (c && (p = function(t1, e1, r, n) {
                var i, a, s, o = [];
                for(i = 0, a = e1.length; i < a; i++)(s = $s(t1, e1[i] * n, i < a - 1 ? e1[i + 1] * n : t1.length, n, !1)) === s.next && (s.steiner = !0), o.push(Js(s));
                for(o.sort(Ns), i = 0; i < o.length; i++)r = Zs(o[i], r);
                return r;
            }(t1, e1, p, r)), t1.length > 80 * r) {
                n = a = t1[0], i = s = t1[1];
                for(var d = r; d < h; d += r)(o = t1[d]) < n && (n = o), (l = t1[d + 1]) < i && (i = l), o > a && (a = o), l > s && (s = l);
                u = 0 !== (u = Math.max(a - n, s - i)) ? 32767 / u : 0;
            }
            return Os(p, f, r, n, i, u, 0), f;
        }
        function $s(t1, e1, r, n, i) {
            var a, s;
            if (i === oo(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)s = io(a, t1[a], t1[a + 1], s);
            else for(a = r - n; a >= e1; a -= n)s = io(a, t1[a], t1[a + 1], s);
            return s && Ws(s, s.next) && (ao(s), s = s.next), s;
        }
        function Ds(t1, e1) {
            if (!t1) return t1;
            e1 || (e1 = t1);
            var r, n = t1;
            do if (r = !1, n.steiner || !Ws(n, n.next) && 0 !== Hs(n.prev, n, n.next)) n = n.next;
            else {
                if (ao(n), (n = e1 = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e1);
            return e1;
        }
        function Os(t1, e1, r, n, i, a, s) {
            if (t1) {
                !s && a && function(t1, e1, r, n) {
                    var i = t1;
                    do 0 === i.z && (i.z = Gs(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t1);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                        var e1, r, n, i, a, s, o, l, u = 1;
                        do {
                            for(r = t1, t1 = null, a = null, s = 0; r;){
                                for(s++, n = r, o = 0, e1 = 0; e1 < u && (o++, n = n.nextZ); e1++);
                                for(l = u; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, o--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                r = n;
                            }
                            a.nextZ = null, u *= 2;
                        }while (s > 1);
                    }(i);
                }(t1, n, i, a);
                for(var o, l, u = t1; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, a ? Rs(t1, n, i, a) : Us(t1)) e1.push(o.i / r | 0), e1.push(t1.i / r | 0), e1.push(l.i / r | 0), ao(t1), t1 = l.next, u = l.next;
                else if ((t1 = l) === u) {
                    s ? 1 === s ? Os(t1 = qs(Ds(t1), e1, r), e1, r, n, i, a, 2) : 2 === s && js(t1, e1, r, n, i, a) : Os(Ds(t1), e1, r, n, i, a, 1);
                    break;
                }
            }
        }
        function Us(t1) {
            var e1 = t1.prev, r = t1, n = t1.next;
            if (Hs(e1, r, n) >= 0) return !1;
            for(var i = e1.x, a = r.x, s = n.x, o = e1.y, l = r.y, u = n.y, c = i < a ? i < s ? i : s : a < s ? a : s, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > a ? i > s ? i : s : a > s ? a : s, f = o > l ? o > u ? o : u : l > u ? l : u, d = n.next; d !== e1;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Xs(i, o, a, l, s, u, d.x, d.y) && Hs(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function Rs(t1, e1, r, n) {
            var i = t1.prev, a = t1, s = t1.next;
            if (Hs(i, a, s) >= 0) return !1;
            for(var o = i.x, l = a.x, u = s.x, c = i.y, h = a.y, p = s.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = Gs(f, d, e1, r, n), x = Gs(y, m, e1, r, n), v = t1.prevZ, b = t1.nextZ; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && Xs(o, c, l, h, u, p, v.x, v.y) && Hs(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && Xs(o, c, l, h, u, p, b.x, b.y) && Hs(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && Xs(o, c, l, h, u, p, v.x, v.y) && Hs(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && Xs(o, c, l, h, u, p, b.x, b.y) && Hs(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function qs(t1, e1, r) {
            var n = t1;
            do {
                var i = n.prev, a = n.next.next;
                !Ws(i, a) && Qs(i, n, n.next, a) && ro(i, a) && ro(a, i) && (e1.push(i.i / r | 0), e1.push(n.i / r | 0), e1.push(a.i / r | 0), ao(n), ao(n.next), n = t1 = a), n = n.next;
            }while (n !== t1);
            return Ds(n);
        }
        function js(t1, e1, r, n, i, a) {
            var s = t1;
            do {
                for(var o = s.next.next; o !== s.prev;){
                    if (s.i !== o.i && Ys(s, o)) {
                        var l = no(s, o);
                        return s = Ds(s, s.next), l = Ds(l, l.next), Os(s, e1, r, n, i, a, 0), void Os(l, e1, r, n, i, a, 0);
                    }
                    o = o.next;
                }
                s = s.next;
            }while (s !== t1);
        }
        function Ns(t1, e1) {
            return t1.x - e1.x;
        }
        function Zs(t1, e1) {
            var r = function(t1, e1) {
                var r, n = e1, i = t1.x, a = t1.y, s = -1 / 0;
                do {
                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                        var o = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (o <= i && o > s && (s = o, r = n.x < n.next.x ? n : n.next, o === i)) return r;
                    }
                    n = n.next;
                }while (n !== e1);
                if (!r) return null;
                var l, u = r, c = r.x, h = r.y, p = 1 / 0;
                n = r;
                do i >= n.x && n.x >= c && i !== n.x && Xs(a < h ? i : s, a, c, h, a < h ? s : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), ro(n, t1) && (l < p || l === p && (n.x > r.x || n.x === r.x && Ks(r, n))) && (r = n, p = l)), n = n.next;
                while (n !== u);
                return r;
            }(t1, e1);
            if (!r) return e1;
            var n = no(r, t1);
            return Ds(n, n.next), Ds(r, r.next);
        }
        function Ks(t1, e1) {
            return Hs(t1.prev, t1, e1.prev) < 0 && Hs(e1.next, t1, t1.next) < 0;
        }
        function Gs(t1, e1, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function Js(t1) {
            var e1 = t1, r = t1;
            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
            while (e1 !== t1);
            return r;
        }
        function Xs(t1, e1, r, n, i, a, s, o) {
            return (i - s) * (e1 - o) >= (t1 - s) * (a - o) && (t1 - s) * (n - o) >= (r - s) * (e1 - o) && (r - s) * (a - o) >= (i - s) * (n - o);
        }
        function Ys(t1, e1) {
            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                var r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && Qs(r, r.next, t1, e1)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e1) && (ro(t1, e1) && ro(e1, t1) && function(t1, e1) {
                var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e1) && (Hs(t1.prev, t1, e1.prev) || Hs(t1, e1.prev, e1)) || Ws(t1, e1) && Hs(t1.prev, t1, t1.next) > 0 && Hs(e1.prev, e1, e1.next) > 0);
        }
        function Hs(t1, e1, r) {
            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
        }
        function Ws(t1, e1) {
            return t1.x === e1.x && t1.y === e1.y;
        }
        function Qs(t1, e1, r, n) {
            var i = eo(Hs(t1, e1, r)), a = eo(Hs(t1, e1, n)), s = eo(Hs(r, n, t1)), o = eo(Hs(r, n, e1));
            return i !== a && s !== o || !(0 !== i || !to(t1, r, e1)) || !(0 !== a || !to(t1, n, e1)) || !(0 !== s || !to(r, t1, n)) || !(0 !== o || !to(r, e1, n));
        }
        function to(t1, e1, r) {
            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
        }
        function eo(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function ro(t1, e1) {
            return Hs(t1.prev, t1, t1.next) < 0 ? Hs(t1, e1, t1.next) >= 0 && Hs(t1, t1.prev, e1) >= 0 : Hs(t1, e1, t1.prev) < 0 || Hs(t1, t1.next, e1) < 0;
        }
        function no(t1, e1) {
            var r = new so(t1.i, t1.x, t1.y), n = new so(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function io(t1, e1, r, n) {
            var i = new so(t1, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function ao(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function so(t1, e1, r) {
            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function oo(t1, e1, r, n) {
            for(var i = 0, a = e1, s = r - n; a < r; a += n)i += (t1[s] - t1[a]) * (t1[a + 1] + t1[s + 1]), s = a;
            return i;
        }
        Ts.exports = Ls, Ts.exports.default = Ls, Ls.deviation = function(t1, e1, r, n) {
            var i = e1 && e1.length, a = Math.abs(oo(t1, 0, i ? e1[0] * r : t1.length, r));
            if (i) for(var s = 0, o = e1.length; s < o; s++)a -= Math.abs(oo(t1, e1[s] * r, s < o - 1 ? e1[s + 1] * r : t1.length, r));
            var l = 0;
            for(s = 0; s < n.length; s += 3){
                var u = n[s] * r, c = n[s + 1] * r, h = n[s + 2] * r;
                l += Math.abs((t1[u] - t1[h]) * (t1[c + 1] - t1[u + 1]) - (t1[u] - t1[c]) * (t1[h + 1] - t1[u + 1]));
            }
            return 0 === a && 0 === l ? 0 : Math.abs((l - a) / a);
        }, Ls.flatten = function(t1) {
            for(var e1 = t1[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e1
            }, n = 0, i = 0; i < t1.length; i++){
                for(var a = 0; a < t1[i].length; a++)for(var s = 0; s < e1; s++)r.vertices.push(t1[i][a][s]);
                i > 0 && r.holes.push(n += t1[i - 1].length);
            }
            return r;
        };
        var lo = e1(Ts.exports);
        function uo(t1, e1, r, n, i) {
            co(t1, e1, r || 0, n || t1.length - 1, i || po);
        }
        function co(t1, e1, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var a = n - r + 1, s = e1 - r + 1, o = Math.log(a), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (a - l) / a) * (s - a / 2 < 0 ? -1 : 1);
                    co(t1, e1, Math.max(r, Math.floor(e1 - s * l / a + u)), Math.min(n, Math.floor(e1 + (a - s) * l / a + u)), i);
                }
                var c = t1[e1], h = r, p = n;
                for(ho(t1, r, e1), i(t1[n], c) > 0 && ho(t1, r, n); h < p;){
                    for(ho(t1, h, p), h++, p--; i(t1[h], c) < 0;)h++;
                    for(; i(t1[p], c) > 0;)p--;
                }
                0 === i(t1[r], c) ? ho(t1, r, p) : ho(t1, ++p, n), p <= e1 && (r = p + 1), e1 <= p && (n = p - 1);
            }
        }
        function ho(t1, e1, r) {
            var n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function po(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function fo(t1, e1) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, a;
            for(let e1 = 0; e1 < r; e1++){
                const r = w(t1[e1]);
                0 !== r && (t1[e1].area = Math.abs(r), void 0 === a && (a = r < 0), a === r < 0 ? (i && n.push(i), i = [
                    t1[e1]
                ]) : i.push(t1[e1]));
            }
            if (i && n.push(i), e1 > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e1 || (uo(n[t1], e1, 1, n[t1].length - 1, yo), n[t1] = n[t1].slice(0, e1));
            return n;
        }
        function yo(t1, e1) {
            return e1.area - t1.area;
        }
        function mo(t1, e1, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e1){
                const e1 = r.paint.get(`${t1}-pattern`);
                e1.isConstant() || (i = !0);
                const a = e1.constantOr(null);
                a && (i = !0, n[a.to] = !0, n[a.from] = !0);
            }
            return i;
        }
        function go(t1, e1, r, n, i) {
            const a = i.patternDependencies;
            for (const s of e1){
                const e1 = s.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e1.kind) {
                    let t1 = e1.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e1.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e1.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, a[t1] = !0, a[o] = !0, a[l] = !0, r.patterns[s.id] = {
                        min: t1,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        class xo {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new ea, this.indexArray = new ha, this.indexArray2 = new pa, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.segments = new ya, this.segments2 = new ya, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            populate(t1, e1, r) {
                this.hasPattern = mo("fill", this.layers, e1);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: s, id: o, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = Ja(s, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, e1.availableImages) : void 0, p = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : Ga(s),
                        patterns: {},
                        sortKey: h
                    };
                    a.push(p);
                }
                i && a.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t1 = go("fill", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, a, r, {});
                    e1.featureIndex.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            addFeatures(t1, e1, r) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Fs), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t1, e1, r, n, i) {
                for (const t1 of fo(e1, 500)){
                    let e1 = 0;
                    for (const r of t1)e1 += r.length;
                    const r = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], a = [];
                    for (const e1 of t1){
                        if (0 === e1.length) continue;
                        e1 !== t1[0] && a.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e1.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), this.indexArray2.emplaceBack(n + e1.length - 1, n), i.push(e1[0].x), i.push(e1[0].y);
                        for(let t1 = 1; t1 < e1.length; t1++)this.layoutVertexArray.emplaceBack(e1[t1].x, e1[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e1[t1].x), i.push(e1[t1].y);
                        r.vertexLength += e1.length, r.primitiveLength += e1.length;
                    }
                    const s = lo(i, a);
                    for(let t1 = 0; t1 < s.length; t1 += 3)this.indexArray.emplaceBack(n + s[t1], n + s[t1 + 1], n + s[t1 + 2]);
                    r.vertexLength += e1, r.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
            }
        }
        let vo, bo;
        zn("FillBucket", xo, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var wo = {
            get paint () {
                return bo = bo || new fi({
                    "fill-antialias": new li(j.paint_fill["fill-antialias"]),
                    "fill-opacity": new ui(j.paint_fill["fill-opacity"]),
                    "fill-color": new ui(j.paint_fill["fill-color"]),
                    "fill-outline-color": new ui(j.paint_fill["fill-outline-color"]),
                    "fill-translate": new li(j.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new li(j.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new ci(j.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return vo = vo || new fi({
                    "fill-sort-key": new ui(j.layout_fill["fill-sort-key"])
                });
            }
        };
        const _o = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), Ao = vi([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: ko } = _o;
        var So = {}, Io = r, zo = Mo;
        function Mo(t1, e1, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(Po, this, e1);
        }
        function Po(t1, e1, r) {
            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                    e1.properties[n] = i;
                }
            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
        }
        function Bo(t1) {
            for(var e1, r, n = 0, i = 0, a = t1.length, s = a - 1; i < a; s = i++)n += ((r = t1[s]).x - (e1 = t1[i]).x) * (e1.y + r.y);
            return n;
        }
        Mo.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], Mo.prototype.loadGeometry = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1, r = t1.readVarint() + t1.pos, n = 1, i = 0, a = 0, s = 0, o = []; t1.pos < r;){
                if (i <= 0) {
                    var l = t1.readVarint();
                    n = 7 & l, i = l >> 3;
                }
                if (i--, 1 === n || 2 === n) a += t1.readSVarint(), s += t1.readSVarint(), 1 === n && (e1 && o.push(e1), e1 = []), e1.push(new Io(a, s));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e1 && e1.push(e1[0].clone());
                }
            }
            return e1 && o.push(e1), o;
        }, Mo.prototype.bbox = function() {
            var t1 = this._pbf;
            t1.pos = this._geometry;
            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e1;){
                if (n <= 0) {
                    var c = t1.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < s && (s = i), i > o && (o = i), (a += t1.readSVarint()) < l && (l = a), a > u && (u = a);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                s,
                l,
                o,
                u
            ];
        }, Mo.prototype.toGeoJSON = function(t1, e1, r) {
            var n, i, a = this.extent * Math.pow(2, r), s = this.extent * t1, o = this.extent * e1, l = this.loadGeometry(), u = Mo.types[this.type];
            function c(t1) {
                for(var e1 = 0; e1 < t1.length; e1++){
                    var r = t1[e1];
                    t1[e1] = [
                        360 * (r.x + s) / a - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / a) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t1) {
                        var e1 = t1.length;
                        if (e1 <= 1) return [
                            t1
                        ];
                        for(var r, n, i = [], a = 0; a < e1; a++){
                            var s = Bo(t1[a]);
                            0 !== s && (void 0 === n && (n = s < 0), n === s < 0 ? (r && i.push(r), r = [
                                t1[a]
                            ]) : r.push(t1[a]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var Co = zo, Vo = Eo;
        function Eo(t1, e1) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(Fo, this, e1), this.length = this._features.length;
        }
        function Fo(t1, e1, r) {
            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                    var n = t1.readVarint() >> 3;
                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                }
                return e1;
            }(r));
        }
        Eo.prototype.feature = function(t1) {
            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t1];
            var e1 = this._pbf.readVarint() + this._pbf.pos;
            return new Co(this._pbf, e1, this.extent, this._keys, this._values);
        };
        var To = Vo;
        function Lo(t1, e1, r) {
            if (3 === t1) {
                var n = new To(r, r.readVarint() + r.pos);
                n.length && (e1[n.name] = n);
            }
        }
        So.VectorTile = function(t1, e1) {
            this.layers = t1.readFields(Lo, {}, e1);
        }, So.VectorTileFeature = zo, So.VectorTileLayer = Vo;
        const $o = So.VectorTileFeature.types, Do = Math.pow(2, 13);
        function Oo(t1, e1, r, n, i, a, s, o) {
            t1.emplaceBack(e1, r, 2 * Math.floor(n * Do) + s, i * Do * 2, a * Do * 2, Math.round(o));
        }
        class Uo {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new ra, this.centroidVertexArray = new Qi, this.indexArray = new ha, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.segments = new ya, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            populate(t1, e1, r) {
                this.features = [], this.hasPattern = mo("fill-extrusion", this.layers, e1);
                for (const { feature: n, id: i, index: a, sourceLayerIndex: s } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, o = Ja(n, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), o, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: s,
                        index: a,
                        geometry: t1 ? o.geometry : Ga(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(go("fill-extrusion", this.layers, l, this.zoom, e1)) : this.addFeature(l, l.geometry, a, r, {}), e1.featureIndex.insert(n, l.geometry, a, s, this.index, !0);
                }
            }
            addFeatures(t1, e1, r) {
                for (const t1 of this.features){
                    const { geometry: n } = t1;
                    this.addFeature(t1, n, t1.index, e1, r);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ko), this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, Ao.members, !0), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t1, e1, r, n, i) {
                const a = {
                    x: 0,
                    y: 0,
                    vertexCount: 0
                };
                for (const r of fo(e1, 500)){
                    let e1 = 0;
                    for (const t1 of r)e1 += t1.length;
                    let n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                    for (const t1 of r){
                        if (0 === t1.length) continue;
                        if (qo(t1)) continue;
                        let e1 = 0;
                        for(let r = 0; r < t1.length; r++){
                            const i = t1[r];
                            if (r >= 1) {
                                const s = t1[r - 1];
                                if (!Ro(i, s)) {
                                    n.vertexLength + 4 > ya.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const t1 = i.sub(s)._perp()._unit(), r = s.dist(i);
                                    e1 + r > 32768 && (e1 = 0), Oo(this.layoutVertexArray, i.x, i.y, t1.x, t1.y, 0, 0, e1), Oo(this.layoutVertexArray, i.x, i.y, t1.x, t1.y, 0, 1, e1), a.x += 2 * i.x, a.y += 2 * i.y, a.vertexCount += 2, e1 += r, Oo(this.layoutVertexArray, s.x, s.y, t1.x, t1.y, 0, 0, e1), Oo(this.layoutVertexArray, s.x, s.y, t1.x, t1.y, 0, 1, e1), a.x += 2 * s.x, a.y += 2 * s.y, a.vertexCount += 2;
                                    const o = n.vertexLength;
                                    this.indexArray.emplaceBack(o, o + 2, o + 1), this.indexArray.emplaceBack(o + 1, o + 2, o + 3), n.vertexLength += 4, n.primitiveLength += 2;
                                }
                            }
                        }
                    }
                    if (n.vertexLength + e1 > ya.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray)), "Polygon" !== $o[t1.type]) continue;
                    const i = [], s = [], o = n.vertexLength;
                    for (const t1 of r)if (0 !== t1.length) {
                        t1 !== r[0] && s.push(i.length / 2);
                        for(let e1 = 0; e1 < t1.length; e1++){
                            const r = t1[e1];
                            Oo(this.layoutVertexArray, r.x, r.y, 0, 0, 1, 1, 0), a.x += r.x, a.y += r.y, a.vertexCount += 1, i.push(r.x), i.push(r.y);
                        }
                    }
                    const l = lo(i, s);
                    for(let t1 = 0; t1 < l.length; t1 += 3)this.indexArray.emplaceBack(o + l[t1], o + l[t1 + 2], o + l[t1 + 1]);
                    n.primitiveLength += l.length / 3, n.vertexLength += e1;
                }
                for(let t1 = 0; t1 < a.vertexCount; t1++)this.centroidVertexArray.emplaceBack(Math.floor(a.x / a.vertexCount), Math.floor(a.y / a.vertexCount));
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
            }
        }
        function Ro(t1, e1) {
            return t1.x === e1.x && (t1.x < 0 || t1.x > Na) || t1.y === e1.y && (t1.y < 0 || t1.y > Na);
        }
        function qo(t1) {
            return t1.every((t1)=>t1.x < 0) || t1.every((t1)=>t1.x > Na) || t1.every((t1)=>t1.y < 0) || t1.every((t1)=>t1.y > Na);
        }
        let jo;
        zn("FillExtrusionBucket", Uo, {
            omit: [
                "layers",
                "features"
            ]
        });
        var No = {
            get paint () {
                return jo = jo || new fi({
                    "fill-extrusion-opacity": new li(j["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new ui(j["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new li(j["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new li(j["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new ci(j["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new ui(j["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new ui(j["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new li(j["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        function Zo(t1, e1) {
            return t1.x * e1.x + t1.y * e1.y;
        }
        function Ko(t1, e1) {
            if (1 === t1.length) {
                let r = 0;
                const n = e1[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e1[r++], !i) return 1 / 0;
                for(; r < e1.length; r++){
                    const a = e1[r], s = t1[0], o = i.sub(n), l = a.sub(n), u = s.sub(n), c = Zo(o, o), h = Zo(o, l), p = Zo(l, l), f = Zo(u, o), d = Zo(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + a.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e1)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        const Go = vi([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: Jo } = Go, Xo = vi([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: Yo } = Xo, Ho = So.VectorTileFeature.types, Wo = Math.cos(Math.PI / 180 * 37.5), Qo = Math.pow(2, 14) / .5;
        class tl {
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new na, this.layoutVertexArray2 = new ia, this.indexArray = new ha, this.programConfigurations = new Ra(t1.layers, t1.zoom), this.segments = new ya, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
            populate(t1, e1, r) {
                this.hasPattern = mo("line", this.layers, e1);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: e1, id: s, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Ja(e1, t1);
                    if (!this.layers[0]._featureFilter.filter(new Qn(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: s,
                        properties: e1.properties,
                        type: e1.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : Ga(e1),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                i && a.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t1 = go("line", this.layers, n, this.zoom, e1);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, a, r, {});
                    e1.featureIndex.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
            }
            addFeatures(t1, e1, r) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Yo)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Jo), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && Object.prototype.hasOwnProperty.call(t1.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t1.properties, "mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e1, r, n, i) {
                const a = this.layers[0].layout, s = a.get("line-join").evaluate(t1, {}), o = a.get("line-cap"), l = a.get("line-miter-limit"), u = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1);
                for (const r of e1)this.addLine(r, t1, s, o, l, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
            }
            addLine(t1, e1, r, n, i, a) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e1 = 0; e1 < t1.length - 1; e1++)this.totalDistance += t1[e1].dist(t1[e1 + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const s = "Polygon" === Ho[e1.type];
                let o = t1.length;
                for(; o >= 2 && t1[o - 1].equals(t1[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t1[l].equals(t1[l + 1]);)l++;
                if (o < (s ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 15 * Na / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, s && (h = t1[o - 2], y = t1[l].sub(h)._unit()._perp());
                for(let e1 = l; e1 < o; e1++){
                    if (f = e1 === o - 1 ? s ? t1[l + 1] : void 0 : t1[e1 + 1], f && t1[e1].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t1[e1], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < Wo && p && f, _ = d.x * y.y - d.y * y.x > 0;
                    if (w && e1 > l) {
                        const t1 = h.dist(p);
                        if (t1 > 2 * u) {
                            const e1 = h.sub(h.sub(p)._mult(u / t1)._round());
                            this.updateDistance(p, e1), this.addCurrentVertex(e1, d, 0, 0, c), p = e1;
                        }
                    }
                    const A = p && f;
                    let k = A ? r : s ? "butt" : n;
                    if (A && "round" === k && (v < a ? k = "miter" : v <= 2 && (k = "fakeround")), "miter" === k && v > i && (k = "bevel"), "bevel" === k && (v > 2 && (k = "flipbevel"), v < i && (k = "miter")), p && this.updateDistance(p, h), "miter" === k) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === k) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t1 = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t1 * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === k || "fakeround" === k) {
                        const t1 = -Math.sqrt(v * v - 1), e1 = _ ? t1 : 0, r = _ ? 0 : t1;
                        if (p && this.addCurrentVertex(h, d, e1, r, c), "fakeround" === k) {
                            const t1 = Math.round(180 * b / Math.PI / 20);
                            for(let e1 = 1; e1 < t1; e1++){
                                let r = e1 / t1;
                                if (.5 !== r) {
                                    const t1 = r - .5;
                                    r += r * t1 * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t1 * t1 + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, _, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e1, -r, c);
                    } else if ("butt" === k) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === k) {
                        const t1 = p ? 1 : -1;
                        this.addCurrentVertex(h, m, t1, t1, c);
                    } else "round" === k && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (w && e1 < o - 1) {
                        const t1 = h.dist(f);
                        if (t1 > 2 * u) {
                            const e1 = h.add(f.sub(h)._mult(u / t1)._round());
                            this.updateDistance(h, e1), this.addCurrentVertex(e1, y, 0, 0, c), h = e1;
                        }
                    }
                }
            }
            addCurrentVertex(t1, e1, r, n, i, a = !1) {
                const s = e1.y * n - e1.x, o = -e1.y - e1.x * n;
                this.addHalfVertex(t1, e1.x + e1.y * r, e1.y - e1.x * r, a, !1, r, i), this.addHalfVertex(t1, s, o, a, !0, -n, i), this.distance > Qo / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t1, e1, r, n, i, a));
            }
            addHalfVertex({ x: t1, y: e1 }, r, n, i, a, s, o) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (Qo - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e1 << 1) + (a ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), a ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t1, e1) {
                this.distance += t1.dist(e1), this.updateScaledDistance();
            }
        }
        let el, rl;
        zn("LineBucket", tl, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var nl = {
            get paint () {
                return rl = rl || new fi({
                    "line-opacity": new ui(j.paint_line["line-opacity"]),
                    "line-color": new ui(j.paint_line["line-color"]),
                    "line-translate": new li(j.paint_line["line-translate"]),
                    "line-translate-anchor": new li(j.paint_line["line-translate-anchor"]),
                    "line-width": new ui(j.paint_line["line-width"]),
                    "line-gap-width": new ui(j.paint_line["line-gap-width"]),
                    "line-offset": new ui(j.paint_line["line-offset"]),
                    "line-blur": new ui(j.paint_line["line-blur"]),
                    "line-dasharray": new hi(j.paint_line["line-dasharray"]),
                    "line-pattern": new ci(j.paint_line["line-pattern"]),
                    "line-gradient": new pi(j.paint_line["line-gradient"])
                });
            },
            get layout () {
                return el = el || new fi({
                    "line-cap": new li(j.layout_line["line-cap"]),
                    "line-join": new ui(j.layout_line["line-join"]),
                    "line-miter-limit": new li(j.layout_line["line-miter-limit"]),
                    "line-round-limit": new li(j.layout_line["line-round-limit"]),
                    "line-sort-key": new ui(j.layout_line["line-sort-key"])
                });
            }
        };
        class il extends ui {
            possiblyEvaluate(t1, e1) {
                return e1 = new Qn(Math.floor(e1.zoom), {
                    now: e1.now,
                    fadeDuration: e1.fadeDuration,
                    zoomHistory: e1.zoomHistory,
                    transition: e1.transition
                }), super.possiblyEvaluate(t1, e1);
            }
            evaluate(t1, e1, r, n) {
                return e1 = p({}, e1, {
                    zoom: Math.floor(e1.zoom)
                }), super.evaluate(t1, e1, r, n);
            }
        }
        let al;
        function sl(t1, e1) {
            return e1 > 0 ? e1 + 2 * t1 : t1;
        }
        const ol = vi([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), ll = vi([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        vi([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const ul = vi([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]);
        vi([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const cl = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), hl = vi([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function pl(t1, e1, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e1, r) {
                    const n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), Wn.applyArabicShaping && (t1 = Wn.applyArabicShaping(t1)), t1;
                }(t1.text, e1, r);
            }), t1;
        }
        vi([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), vi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), vi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            }
        ]), vi([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), vi([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]);
        const fl = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        var dl = 24, yl = xl, ml = function(t1, e1, r, n, i) {
            var a, s, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e1 + h];
            for(h += p, a = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; a = 256 * a + t1[e1 + h], h += p, c -= 8);
            for(s = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; s = 256 * s + t1[e1 + h], h += p, c -= 8);
            if (0 === a) a = 1 - u;
            else {
                if (a === l) return s ? NaN : 1 / 0 * (f ? -1 : 1);
                s += Math.pow(2, n), a -= u;
            }
            return (f ? -1 : 1) * s * Math.pow(2, a - n);
        }, gl = function(t1, e1, r, n, i, a) {
            var s, o, l, u = 8 * a - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, d = n ? 1 : -1, y = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (o = isNaN(e1) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e1 += s + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (s++, l /= 2), s + h >= c ? (o = 0, s = c) : s + h >= 1 ? (o = (e1 * l - 1) * Math.pow(2, i), s += h) : (o = e1 * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t1[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(s = s << i | o, u += i; u > 0; t1[r + f] = 255 & s, f += d, s /= 256, u -= 8);
            t1[r + f - d] |= 128 * y;
        };
        function xl(t1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        xl.Varint = 0, xl.Fixed64 = 1, xl.Bytes = 2, xl.Fixed32 = 5;
        var vl = 4294967296, bl = 1 / vl, wl = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function _l(t1) {
            return t1.type === xl.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
        }
        function Al(t1, e1, r) {
            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
        }
        function kl(t1, e1, r) {
            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
        }
        function Sl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
        }
        function Il(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
        }
        function zl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
        }
        function Ml(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
        }
        function Pl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
        }
        function Bl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
        }
        function Cl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
        }
        function Vl(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
        }
        function El(t1, e1) {
            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
        }
        function Fl(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
        }
        function Tl(t1, e1, r) {
            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
        }
        function Ll(t1, e1) {
            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
        }
        xl.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t1, e1, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                }
                return e1;
            },
            readMessage: function(t1, e1) {
                return this.readFields(t1, e1, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t1 = Fl(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readSFixed32: function() {
                var t1 = Ll(this.buf, this.pos);
                return this.pos += 4, t1;
            },
            readFixed64: function() {
                var t1 = Fl(this.buf, this.pos) + Fl(this.buf, this.pos + 4) * vl;
                return this.pos += 8, t1;
            },
            readSFixed64: function() {
                var t1 = Fl(this.buf, this.pos) + Ll(this.buf, this.pos + 4) * vl;
                return this.pos += 8, t1;
            },
            readFloat: function() {
                var t1 = ml(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t1;
            },
            readDouble: function() {
                var t1 = ml(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t1;
            },
            readVarint: function(t1) {
                var e1, r, n = this.buf;
                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                    var n, i, a = r.buf;
                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return Al(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return Al(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return Al(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return Al(t1, n, e1);
                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return Al(t1, n, e1);
                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return Al(t1, n, e1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t1 = this.readVarint();
                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                return this.pos = t1, t1 - e1 >= 12 && wl ? function(t1, e1, r) {
                    return wl.decode(t1.subarray(e1, r));
                }(this.buf, e1, t1) : function(t1, e1, r) {
                    for(var n = "", i = e1; i < r;){
                        var a, s, o, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (a = t1[i + 1])) && (u = (31 & l) << 6 | 63 & a) <= 127 && (u = null) : 3 === c ? (s = t1[i + 2], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & s) && ((u = (15 & l) << 12 | (63 & a) << 6 | 63 & s) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (s = t1[i + 2], o = t1[i + 3], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & s) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & a) << 12 | (63 & s) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e1, t1);
            },
            readBytes: function() {
                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                return this.pos = t1, e1;
            },
            readPackedVarint: function(t1, e1) {
                if (this.type !== xl.Bytes) return t1.push(this.readVarint(e1));
                var r = _l(this);
                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                return t1;
            },
            readPackedSVarint: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readSVarint());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                return t1;
            },
            readPackedBoolean: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readBoolean());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                return t1;
            },
            readPackedFloat: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readFloat());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                return t1;
            },
            readPackedDouble: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readDouble());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                return t1;
            },
            readPackedFixed32: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readFixed32());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                return t1;
            },
            readPackedSFixed32: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readSFixed32());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                return t1;
            },
            readPackedFixed64: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readFixed64());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                return t1;
            },
            readPackedSFixed64: function(t1) {
                if (this.type !== xl.Bytes) return t1.push(this.readSFixed64());
                var e1 = _l(this);
                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                return t1;
            },
            skip: function(t1) {
                var e1 = 7 & t1;
                if (e1 === xl.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e1 === xl.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e1 === xl.Fixed32) this.pos += 4;
                else {
                    if (e1 !== xl.Fixed64) throw new Error("Unimplemented type: " + e1);
                    this.pos += 8;
                }
            },
            writeTag: function(t1, e1) {
                this.writeVarint(t1 << 3 | e1);
            },
            realloc: function(t1) {
                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                if (e1 !== this.length) {
                    var r = new Uint8Array(e1);
                    r.set(this.buf), this.buf = r, this.length = e1;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t1) {
                this.realloc(4), Tl(this.buf, t1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t1) {
                this.realloc(4), Tl(this.buf, t1, this.pos), this.pos += 4;
            },
            writeFixed64: function(t1) {
                this.realloc(8), Tl(this.buf, -1 & t1, this.pos), Tl(this.buf, Math.floor(t1 * bl), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t1) {
                this.realloc(8), Tl(this.buf, -1 & t1, this.pos), Tl(this.buf, Math.floor(t1 * bl), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t1) {
                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                    var r, n;
                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e1.realloc(10), function(t1, e1, r) {
                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                    }(r, 0, e1), function(t1, e1) {
                        var r = (7 & t1) << 4;
                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                    }(n, e1);
                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
            },
            writeSVarint: function(t1) {
                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
            },
            writeBoolean: function(t1) {
                this.writeVarint(Boolean(t1));
            },
            writeString: function(t1) {
                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                var e1 = this.pos;
                this.pos = function(t1, e1, r) {
                    for(var n, i, a = 0; a < e1.length; a++){
                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t1, this.pos);
                var r = this.pos - e1;
                r >= 128 && kl(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t1) {
                this.realloc(4), gl(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t1) {
                this.realloc(8), gl(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t1) {
                var e1 = t1.length;
                this.writeVarint(e1), this.realloc(e1);
                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
            },
            writeRawMessage: function(t1, e1) {
                this.pos++;
                var r = this.pos;
                t1(e1, this);
                var n = this.pos - r;
                n >= 128 && kl(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t1, e1, r) {
                this.writeTag(t1, xl.Bytes), this.writeRawMessage(e1, r);
            },
            writePackedVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, Sl, e1);
            },
            writePackedSVarint: function(t1, e1) {
                e1.length && this.writeMessage(t1, Il, e1);
            },
            writePackedBoolean: function(t1, e1) {
                e1.length && this.writeMessage(t1, Pl, e1);
            },
            writePackedFloat: function(t1, e1) {
                e1.length && this.writeMessage(t1, zl, e1);
            },
            writePackedDouble: function(t1, e1) {
                e1.length && this.writeMessage(t1, Ml, e1);
            },
            writePackedFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Bl, e1);
            },
            writePackedSFixed32: function(t1, e1) {
                e1.length && this.writeMessage(t1, Cl, e1);
            },
            writePackedFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, Vl, e1);
            },
            writePackedSFixed64: function(t1, e1) {
                e1.length && this.writeMessage(t1, El, e1);
            },
            writeBytesField: function(t1, e1) {
                this.writeTag(t1, xl.Bytes), this.writeBytes(e1);
            },
            writeFixed32Field: function(t1, e1) {
                this.writeTag(t1, xl.Fixed32), this.writeFixed32(e1);
            },
            writeSFixed32Field: function(t1, e1) {
                this.writeTag(t1, xl.Fixed32), this.writeSFixed32(e1);
            },
            writeFixed64Field: function(t1, e1) {
                this.writeTag(t1, xl.Fixed64), this.writeFixed64(e1);
            },
            writeSFixed64Field: function(t1, e1) {
                this.writeTag(t1, xl.Fixed64), this.writeSFixed64(e1);
            },
            writeVarintField: function(t1, e1) {
                this.writeTag(t1, xl.Varint), this.writeVarint(e1);
            },
            writeSVarintField: function(t1, e1) {
                this.writeTag(t1, xl.Varint), this.writeSVarint(e1);
            },
            writeStringField: function(t1, e1) {
                this.writeTag(t1, xl.Bytes), this.writeString(e1);
            },
            writeFloatField: function(t1, e1) {
                this.writeTag(t1, xl.Fixed32), this.writeFloat(e1);
            },
            writeDoubleField: function(t1, e1) {
                this.writeTag(t1, xl.Fixed64), this.writeDouble(e1);
            },
            writeBooleanField: function(t1, e1) {
                this.writeVarintField(t1, Boolean(e1));
            }
        };
        var $l = e1(yl);
        const Dl = 3;
        function Ol(t1, e1, r) {
            1 === t1 && r.readMessage(Ul, e1);
        }
        function Ul(t1, e1, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: a, left: s, top: o, advance: l } = r.readMessage(Rl, {});
                e1.push({
                    id: t1,
                    bitmap: new Ms({
                        width: i + 2 * Dl,
                        height: a + 2 * Dl
                    }, n),
                    metrics: {
                        width: i,
                        height: a,
                        left: s,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function Rl(t1, e1, r) {
            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
        }
        const ql = Dl;
        function jl(t1) {
            let e1 = 0, r = 0;
            for (const n of t1)e1 += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e1)=>e1.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, a = 0;
            for (const e1 of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e1.w > r.w || e1.h > r.h)) {
                    if (e1.x = r.x, e1.y = r.y, a = Math.max(a, e1.y + e1.h), i = Math.max(i, e1.x + e1.w), e1.w === r.w && e1.h === r.h) {
                        const e1 = n.pop();
                        t1 < n.length && (n[t1] = e1);
                    } else e1.h === r.h ? (r.x += e1.w, r.w -= e1.w) : e1.w === r.w ? (r.y += e1.h, r.h -= e1.h) : (n.push({
                        x: r.x + e1.w,
                        y: r.y,
                        w: r.w - e1.w,
                        h: e1.h
                    }), r.y += e1.h, r.h -= e1.h);
                    break;
                }
            }
            return {
                w: i,
                h: a,
                fill: e1 / (i * a) || 0
            };
        }
        const Nl = 1;
        class Zl {
            constructor(t1, { pixelRatio: e1, version: r, stretchX: n, stretchY: i, content: a }){
                this.paddedRect = t1, this.pixelRatio = e1, this.stretchX = n, this.stretchY = i, this.content = a, this.version = r;
            }
            get tl() {
                return [
                    this.paddedRect.x + Nl,
                    this.paddedRect.y + Nl
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - Nl,
                    this.paddedRect.y + this.paddedRect.h - Nl
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * Nl) / this.pixelRatio,
                    (this.paddedRect.h - 2 * Nl) / this.pixelRatio
                ];
            }
        }
        class Kl {
            constructor(t1, e1){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t1, r, i), this.addImages(e1, n, i);
                const { w: a, h: s } = jl(i), o = new Ps({
                    width: a || 1,
                    height: s || 1
                });
                for(const e1 in t1){
                    const n = t1[e1], i = r[e1].paddedRect;
                    Ps.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + Nl,
                        y: i.y + Nl
                    }, n.data);
                }
                for(const t1 in e1){
                    const r = e1[t1], i = n[t1].paddedRect, a = i.x + Nl, s = i.y + Nl, l = r.data.width, u = r.data.height;
                    Ps.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s
                    }, r.data), Ps.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: a,
                        y: s - 1
                    }, {
                        width: l,
                        height: 1
                    }), Ps.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s + u
                    }, {
                        width: l,
                        height: 1
                    }), Ps.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: a - 1,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    }), Ps.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + l,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(t1, e1, r) {
                for(const n in t1){
                    const i = t1[n], a = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2 * Nl,
                        h: i.data.height + 2 * Nl
                    };
                    r.push(a), e1[n] = new Zl(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t1, e1) {
                t1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
            }
            patchUpdatedImage(t1, e1, r) {
                if (!t1 || !e1) return;
                if (t1.version === e1.version) return;
                t1.version = e1.version;
                const [n, i] = t1.tl;
                r.update(e1.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        var Gl;
        zn("ImagePosition", Zl), zn("ImageAtlas", Kl), t1.WritingMode = void 0, (Gl = t1.WritingMode || (t1.WritingMode = {}))[Gl.none = 0] = "none", Gl[Gl.horizontal = 1] = "horizontal", Gl[Gl.vertical = 2] = "vertical", Gl[Gl.horizontalOnly = 3] = "horizontalOnly";
        const Jl = -17;
        class Xl {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(t1, e1) {
                const r = new Xl;
                return r.scale = t1 || 1, r.fontStack = e1, r;
            }
            static forImage(t1) {
                const e1 = new Xl;
                return e1.imageName = t1, e1;
            }
        }
        class Yl {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t1, e1) {
                const r = new Yl;
                for(let n = 0; n < t1.sections.length; n++){
                    const i = t1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCharCode(t1) {
                return this.text.charCodeAt(t1);
            }
            verticalizePunctuation() {
                this.text = function(t1) {
                    let e1 = "";
                    for(let r = 0; r < t1.length; r++){
                        const n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                        e1 += n && $n(n) && !fl[t1[r + 1]] || i && $n(i) && !fl[t1[r - 1]] || !fl[t1[r]] ? t1[r] : fl[t1[r]];
                    }
                    return e1;
                }(this.text);
            }
            trim() {
                let t1 = 0;
                for(let e1 = 0; e1 < this.text.length && Wl[this.text.charCodeAt(e1)]; e1++)t1++;
                let e1 = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && Wl[this.text.charCodeAt(r)]; r--)e1--;
                this.text = this.text.substring(t1, e1), this.sectionIndex = this.sectionIndex.slice(t1, e1);
            }
            substring(t1, e1) {
                const r = new Yl;
                return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e1)=>Math.max(t1, this.sections[e1].scale), 0);
            }
            addTextSection(t1, e1) {
                this.text += t1.text, this.sections.push(Xl.forText(t1.scale, t1.fontStack || e1));
                const r = this.sections.length - 1;
                for(let e1 = 0; e1 < t1.text.length; ++e1)this.sectionIndex.push(r);
            }
            addImageSection(t1) {
                const e1 = t1.image ? t1.image.name : "";
                if (0 === e1.length) return void v("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(Xl.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : v("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function Hl(e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
            const g = Yl.fromFeature(e1, a);
            let x;
            p === t1.WritingMode.vertical && g.verticalizePunctuation();
            const { processBidirectionalText: v, processStyledBidirectionalText: b } = Wn;
            if (v && 1 === g.sections.length) {
                x = [];
                const t1 = v(g.toString(), au(g, c, s, r, i, d, y));
                for (const e1 of t1){
                    const t1 = new Yl;
                    t1.text = e1, t1.sections = g.sections;
                    for(let r = 0; r < e1.length; r++)t1.sectionIndex.push(0);
                    x.push(t1);
                }
            } else if (b) {
                x = [];
                const t1 = b(g.text, g.sectionIndex, au(g, c, s, r, i, d, y));
                for (const e1 of t1){
                    const t1 = new Yl;
                    t1.text = e1[0], t1.sectionIndex = e1[1], t1.sections = g.sections, x.push(t1);
                }
            } else x = function(t1, e1) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e1)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(g, au(g, c, s, r, i, d, y));
            const w = [], _ = {
                positionedLines: w,
                text: g.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(e1, r, n, i, a, s, o, l, u, c, h, p) {
                let f = 0, d = Jl, y = 0, m = 0;
                const g = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = 0;
                for (const o of a){
                    o.trim();
                    const a = o.getMaxScale(), l = (a - 1) * dl, b = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[x] = b;
                    const w = b.positionedGlyphs;
                    let _ = 0;
                    if (!o.length()) {
                        d += s, ++x;
                        continue;
                    }
                    for(let s = 0; s < o.length(); s++){
                        const y = o.getSection(s), m = o.getSectionIndex(s), g = o.getCharCode(s);
                        let x = 0, b = null, A = null, k = null, S = dl;
                        const I = !(u === t1.WritingMode.horizontal || !h && !Ln(g) || h && (Wl[g] || (v = g, Vn.Arabic(v) || Vn["Arabic Supplement"](v) || Vn["Arabic Extended-A"](v) || Vn["Arabic Presentation Forms-A"](v) || Vn["Arabic Presentation Forms-B"](v))));
                        if (y.imageName) {
                            const t1 = i[y.imageName];
                            if (!t1) continue;
                            k = y.imageName, e1.iconsInText = e1.iconsInText || !0, A = t1.paddedRect;
                            const r = t1.displaySize;
                            y.scale = y.scale * dl / p, b = {
                                width: r[0],
                                height: r[1],
                                left: Nl,
                                top: -ql,
                                advance: I ? r[1] : r[0]
                            }, x = l + (dl - r[1] * y.scale), S = b.advance;
                            const n = I ? r[0] * y.scale - dl * a : r[1] * y.scale - dl * a;
                            n > 0 && n > _ && (_ = n);
                        } else {
                            const t1 = n[y.fontStack], e1 = t1 && t1[g];
                            if (e1 && e1.rect) A = e1.rect, b = e1.metrics;
                            else {
                                const t1 = r[y.fontStack], e1 = t1 && t1[g];
                                if (!e1) continue;
                                b = e1.metrics;
                            }
                            x = (a - y.scale) * dl;
                        }
                        I ? (e1.verticalizable = !0, w.push({
                            glyph: g,
                            imageName: k,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += S * y.scale + c) : (w.push({
                            glyph: g,
                            imageName: k,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += b.advance * y.scale + c);
                    }
                    0 !== w.length && (y = Math.max(f - c, y), ou(w, 0, w.length - 1, g, _)), f = 0;
                    const A = s * a + _;
                    b.lineOffset = Math.max(_, l), d += A, m = Math.max(A, m), ++x;
                }
                var v;
                const b = d - Jl, { horizontalAlign: w, verticalAlign: _ } = su(o);
                (function(t1, e1, r, n, i, a, s, o, l) {
                    const u = (e1 - r) * i;
                    let c = 0;
                    c = a !== s ? -o * n - Jl : (-n * l + .5) * s;
                    for (const e1 of t1)for (const t1 of e1.positionedGlyphs)t1.x += u, t1.y += c;
                })(e1.positionedLines, g, w, _, y, m, s, b, a.length), e1.top += -_ * b, e1.bottom = e1.top + b, e1.left += -w * y, e1.right = e1.left + y;
            }(_, r, n, i, x, o, l, u, p, c, f, m), !function(t1) {
                for (const e1 of t1)if (0 !== e1.positionedGlyphs.length) return !1;
                return !0;
            }(w) && _;
        }
        const Wl = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Ql = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function tu(t1, e1, r, n, i, a) {
            if (e1.imageName) {
                const t1 = n[e1.imageName];
                return t1 ? t1.displaySize[0] * e1.scale * dl / a + i : 0;
            }
            {
                const n = r[e1.fontStack], a = n && n[t1];
                return a ? a.metrics.advance * e1.scale + i : 0;
            }
        }
        function eu(t1, e1, r, n) {
            const i = Math.pow(t1 - e1, 2);
            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function ru(t1, e1, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
        }
        function nu(t1, e1, r, n, i, a) {
            let s = null, o = eu(e1, r, i, a);
            for (const t1 of n){
                const n = eu(e1 - t1.x, r, i, a) + t1.badness;
                n <= o && (s = t1, o = n);
            }
            return {
                index: t1,
                x: e1,
                priorBreak: s,
                badness: o
            };
        }
        function iu(t1) {
            return t1 ? iu(t1.priorBreak).concat(t1.index) : [];
        }
        function au(t1, e1, r, n, i, a, s) {
            if ("point" !== a) return [];
            if (!t1) return [];
            const o = [], l = function(t1, e1, r, n, i, a) {
                let s = 0;
                for(let r = 0; r < t1.length(); r++){
                    const o = t1.getSection(r);
                    s += tu(t1.getCharCode(r), o, n, i, e1, a);
                }
                return s / Math.max(1, Math.ceil(s / r));
            }(t1, e1, r, n, i, s), u = t1.text.indexOf("\u200B") >= 0;
            let c = 0;
            for(let r = 0; r < t1.length(); r++){
                const a = t1.getSection(r), p = t1.getCharCode(r);
                if (Wl[p] || (c += tu(p, a, n, i, e1, s)), r < t1.length() - 1) {
                    const e1 = !((h = p) < 11904 || !(Vn["Bopomofo Extended"](h) || Vn.Bopomofo(h) || Vn["CJK Compatibility Forms"](h) || Vn["CJK Compatibility Ideographs"](h) || Vn["CJK Compatibility"](h) || Vn["CJK Radicals Supplement"](h) || Vn["CJK Strokes"](h) || Vn["CJK Symbols and Punctuation"](h) || Vn["CJK Unified Ideographs Extension A"](h) || Vn["CJK Unified Ideographs"](h) || Vn["Enclosed CJK Letters and Months"](h) || Vn["Halfwidth and Fullwidth Forms"](h) || Vn.Hiragana(h) || Vn["Ideographic Description Characters"](h) || Vn["Kangxi Radicals"](h) || Vn["Katakana Phonetic Extensions"](h) || Vn.Katakana(h) || Vn["Vertical Forms"](h) || Vn["Yi Radicals"](h) || Vn["Yi Syllables"](h)));
                    (Ql[p] || e1 || a.imageName) && o.push(nu(r + 1, c, l, o, ru(p, t1.getCharCode(r + 1), e1 && u), !1));
                }
            }
            var h;
            return iu(nu(t1.length(), c, l, o, 0, !0));
        }
        function su(t1) {
            let e1 = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e1 = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e1,
                verticalAlign: r
            };
        }
        function ou(t1, e1, r, n, i) {
            if (!n && !i) return;
            const a = t1[r], s = (t1[r].x + a.metrics.advance * a.scale) * n;
            for(let n = e1; n <= r; n++)t1[n].x -= s, t1[n].y += i;
        }
        function lu(t1, e1, r) {
            const { horizontalAlign: n, verticalAlign: i } = su(r), a = e1[0] - t1.displaySize[0] * n, s = e1[1] - t1.displaySize[1] * i;
            return {
                image: t1,
                top: s,
                bottom: s + t1.displaySize[1],
                left: a,
                right: a + t1.displaySize[0]
            };
        }
        function uu(t1, e1, r, n, i, a) {
            const s = t1.image;
            let o;
            if (s.content) {
                const t1 = s.content, e1 = s.pixelRatio || 1;
                o = [
                    t1[0] / e1,
                    t1[1] / e1,
                    s.displaySize[0] - t1[2] / e1,
                    s.displaySize[1] - t1[3] / e1
                ];
            }
            const l = e1.left * a, u = e1.right * a;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - s.displaySize[0]) / 2, h = f + s.displaySize[0]);
            const d = e1.top * a, y = e1.bottom * a;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - s.displaySize[1]) / 2, p = c + s.displaySize[1]), {
                image: s,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        const cu = 255, hu = 128, pu = cu * hu;
        function fu(t1, e1) {
            const { expression: r } = e1;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Qn(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e1, interpolationType: n } = r;
                let i = 0;
                for(; i < e1.length && e1[i] <= t1;)i++;
                i = Math.max(0, i - 1);
                let a = i;
                for(; a < e1.length && e1[a] < t1 + 1;)a++;
                a = Math.min(e1.length - 1, a);
                const s = e1[i], o = e1[a];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: o,
                    minSize: r.evaluate(new Qn(s)),
                    maxSize: r.evaluate(new Qn(o)),
                    interpolationType: n
                };
            }
        }
        function du(t1, e1, r) {
            let n = "never";
            const i = t1.get(e1);
            return i ? n = i : t1.get(r) && (n = "always"), n;
        }
        const yu = So.VectorTileFeature.types, mu = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function gu(t1, e1, r, n, i, a, s, o, l, u, c, h, p) {
            const f = o ? Math.min(pu, Math.round(o[0])) : 0, d = o ? Math.min(pu, Math.round(o[1])) : 0;
            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, s, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function xu(t1, e1, r) {
            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
        }
        function vu(t1) {
            for (const e1 of t1.sections)if (Un(e1.text)) return !0;
            return !1;
        }
        class bu {
            constructor(t1){
                this.layoutVertexArray = new sa, this.indexArray = new ha, this.programConfigurations = t1, this.segments = new ya, this.dynamicLayoutVertexArray = new oa, this.opacityVertexArray = new la, this.hasVisibleVertices = !1, this.placedSymbolArray = new Ki;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t1, e1, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ol.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, ll.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, mu, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        zn("SymbolBuffers", bu);
        class wu {
            constructor(t1, e1, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new ya, this.collisionVertexArray = new ca;
            }
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, ul.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        zn("CollisionBuffers", wu);
        class _u {
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = ms([]), this.placementViewportMatrix = ms([]);
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = fu(this.zoom, r["text-size"]), this.iconSizeData = fu(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), a = n.get("symbol-z-order");
                this.canOverlap = "never" !== du(n, "text-overlap", "text-allow-overlap") || "never" !== du(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== a && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === a || "auto" === a && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e1)=>t1.WritingMode[e1])), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = e1.sourceID;
            }
            createArrays() {
                this.text = new bu(new Ra(this.layers, this.zoom, (t1)=>/^text/.test(t1))), this.icon = new bu(new Ra(this.layers, this.zoom, (t1)=>/^icon/.test(t1))), this.glyphOffsetArray = new Xi, this.lineVertexArray = new Yi, this.symbolInstances = new Ji;
            }
            calculateGlyphDependencies(t1, e1, r, n, i) {
                for(let a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                    const r = fl[t1.charAt(a)];
                    r && (e1[r.charCodeAt(0)] = !0);
                }
            }
            populate(e1, r, n) {
                const i = this.layers[0], a = i.layout, s = a.get("text-font"), o = a.get("text-field"), l = a.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof Kt && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== s.value.kind || s.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = a.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new Qn(this.zoom);
                for (const { feature: r, id: o, index: l, sourceLayerIndex: m } of e1){
                    const e1 = i._featureFilter.needGeometry, g = Ja(r, e1);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (e1 || (g.geometry = Ga(r)), u) {
                        const t1 = i.getValueAndResolveTokens("text-field", g, n, d), e1 = Kt.factory(t1);
                        vu(e1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Yn() || this.hasRTLText && Wn.isParsed()) && (x = pl(e1, i, g));
                    }
                    if (c) {
                        const t1 = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = t1 instanceof Jt ? t1 : Jt.fromString(t1);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: o,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: yu[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const e1 = s.evaluate(g, {}, n).join(","), r = "viewport" !== a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t1.WritingMode.vertical) >= 0;
                        for (const t1 of x.sections)if (t1.image) p[t1.image.name] = !0;
                        else {
                            const n = En(x.toString()), i = t1.fontStack || e1, a = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(t1.text, a, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === a.get("symbol-placement") && (this.features = function(t1) {
                    const e1 = {}, r = {}, n = [];
                    let i = 0;
                    function a(e1) {
                        n.push(t1[e1]), i++;
                    }
                    function s(t1, e1, i) {
                        const a = r[t1];
                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function o(t1, r, i) {
                        const a = e1[r];
                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function l(t1, e1, r) {
                        const n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            a(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e1 && r[f] !== e1[d]) {
                            const t1 = o(f, d, h), i = s(f, d, n[t1].geometry);
                            delete e1[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? s(f, d, h) : d in e1 ? o(f, d, h) : (a(u), e1[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e1)=>t1.sortKey - e1.sortKey);
            }
            update(t1, e1, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e1) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t1.segment) {
                    let r = t1.dist(e1[t1.segment + 1]), n = t1.dist(e1[t1.segment]);
                    const i = {};
                    for(let n = t1.segment + 1; n < e1.length; n++)i[n] = {
                        x: e1[n].x,
                        y: e1[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < e1.length - 1 && (r += e1[n + 1].dist(e1[n]));
                    for(let r = t1.segment || 0; r >= 0; r--)i[r] = {
                        x: e1[r].x,
                        y: e1[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += e1[r - 1].dist(e1[r]));
                    for(let t1 = 0; t1 < e1.length; t1++){
                        const e1 = i[t1];
                        this.lineVertexArray.emplaceBack(e1.x, e1.y, e1.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e1, r, n, i, a, s, o, l, u, c, h, p) {
                const f = e1.indexArray, d = e1.layoutVertexArray, y = e1.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? s.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && o === t1.WritingMode.vertical ? Math.PI / 2 : 0, v = s.text && s.text.sections;
                for(let t1 = 0; t1 < r.length; t1++){
                    const { tl: i, tr: a, bl: o, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: A } = r[t1], k = y.vertexLength, S = w[1];
                    gu(d, l.x, l.y, i.x, S + i.y, c.x, c.y, n, _, h.x, h.y, g, b), gu(d, l.x, l.y, a.x, S + a.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), gu(d, l.x, l.y, o.x, S + o.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), gu(d, l.x, l.y, u.x, S + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), xu(e1.dynamicLayoutVertexArray, l, x), f.emplaceBack(k, k + 1, k + 2), f.emplaceBack(k + 1, k + 2, k + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t1 !== r.length - 1 && A === r[t1 + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(d.length, s, s.index, {}, p, v && v[A]);
                }
                e1.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t1, e1, r, n, i, a) {
                return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
            }
            addCollisionDebugVertices(t1, e1, r, n, a, s, o) {
                const l = a.segments.prepareSegment(4, a.layoutVertexArray, a.indexArray), u = l.vertexLength, c = a.layoutVertexArray, h = a.collisionVertexArray, p = o.anchorX, f = o.anchorY;
                this._addCollisionDebugVertex(c, h, s, p, f, new i(t1, e1)), this._addCollisionDebugVertex(c, h, s, p, f, new i(r, e1)), this._addCollisionDebugVertex(c, h, s, p, f, new i(r, n)), this._addCollisionDebugVertex(c, h, s, p, f, new i(t1, n)), l.vertexLength += 4;
                const d = a.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t1, e1, r, n) {
                for(let i = t1; i < e1; i++){
                    const t1 = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t1.x1, t1.y1, t1.x2, t1.y2, n ? this.textCollisionBox : this.iconCollisionBox, t1.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new wu(ua, cl.members, pa), this.iconCollisionBox = new wu(ua, cl.members, pa);
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const e1 = this.symbolInstances.get(t1);
                    this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t1, e1, r, n, i, a, s, o, l) {
                const u = {};
                for(let n = e1; n < r; n++){
                    const e1 = t1.get(n);
                    u.textBox = {
                        x1: e1.x1,
                        y1: e1.y1,
                        x2: e1.x2,
                        y2: e1.y2,
                        anchorPointX: e1.anchorPointX,
                        anchorPointY: e1.anchorPointY
                    }, u.textFeatureIndex = e1.featureIndex;
                    break;
                }
                for(let e1 = n; e1 < i; e1++){
                    const r = t1.get(e1);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e1 = a; e1 < s; e1++){
                    const r = t1.get(e1);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e1 = o; e1 < l; e1++){
                    const r = t1.get(e1);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const r = this.symbolInstances.get(e1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t1, e1) {
                const r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e1 = r.vertexStartIndex; e1 < n; e1 += 4)t1.indexArray.emplaceBack(e1, e1 + 1, e1 + 2), t1.indexArray.emplaceBack(e1 + 1, e1 + 2, e1 + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    a.push(t1);
                    const s = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e1 * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
                }
                return a.sort((t1, e1)=>n[t1] - n[e1] || i[e1] - i[t1]), a;
            }
            addToSortKeyRanges(t1, e1) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e1,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e1 = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e1.featureIndex), [
                            e1.rightJustifiedTextSymbolIndex,
                            e1.centerJustifiedTextSymbolIndex,
                            e1.leftJustifiedTextSymbolIndex
                        ].forEach((t1, e1, r)=>{
                            t1 >= 0 && r.indexOf(t1) === e1 && this.addIndicesForPlacedSymbol(this.text, t1);
                        }), e1.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e1.verticalPlacedTextSymbolIndex), e1.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.placedIconSymbolIndex), e1.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let Au, ku;
        zn("SymbolBucket", _u, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), _u.MAX_GLYPHS = 65535, _u.addDynamicAttributes = xu;
        var Su = {
            get paint () {
                return ku = ku || new fi({
                    "icon-opacity": new ui(j.paint_symbol["icon-opacity"]),
                    "icon-color": new ui(j.paint_symbol["icon-color"]),
                    "icon-halo-color": new ui(j.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new ui(j.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new ui(j.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new li(j.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new li(j.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new ui(j.paint_symbol["text-opacity"]),
                    "text-color": new ui(j.paint_symbol["text-color"], {
                        runtimeType: ut,
                        getOverride: (t1)=>t1.textColor,
                        hasOverride: (t1)=>!!t1.textColor
                    }),
                    "text-halo-color": new ui(j.paint_symbol["text-halo-color"]),
                    "text-halo-width": new ui(j.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new ui(j.paint_symbol["text-halo-blur"]),
                    "text-translate": new li(j.paint_symbol["text-translate"]),
                    "text-translate-anchor": new li(j.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return Au = Au || new fi({
                    "symbol-placement": new li(j.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new li(j.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new li(j.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new ui(j.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new li(j.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new li(j.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new li(j.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new li(j.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new li(j.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new li(j.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new ui(j.layout_symbol["icon-size"]),
                    "icon-text-fit": new li(j.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new li(j.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new ui(j.layout_symbol["icon-image"]),
                    "icon-rotate": new ui(j.layout_symbol["icon-rotate"]),
                    "icon-padding": new ui(j.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new li(j.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new ui(j.layout_symbol["icon-offset"]),
                    "icon-anchor": new ui(j.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new li(j.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new li(j.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new li(j.layout_symbol["text-rotation-alignment"]),
                    "text-field": new ui(j.layout_symbol["text-field"]),
                    "text-font": new ui(j.layout_symbol["text-font"]),
                    "text-size": new ui(j.layout_symbol["text-size"]),
                    "text-max-width": new ui(j.layout_symbol["text-max-width"]),
                    "text-line-height": new li(j.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new ui(j.layout_symbol["text-letter-spacing"]),
                    "text-justify": new ui(j.layout_symbol["text-justify"]),
                    "text-radial-offset": new ui(j.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new li(j.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new ui(j.layout_symbol["text-anchor"]),
                    "text-max-angle": new li(j.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new li(j.layout_symbol["text-writing-mode"]),
                    "text-rotate": new ui(j.layout_symbol["text-rotate"]),
                    "text-padding": new li(j.layout_symbol["text-padding"]),
                    "text-keep-upright": new li(j.layout_symbol["text-keep-upright"]),
                    "text-transform": new ui(j.layout_symbol["text-transform"]),
                    "text-offset": new ui(j.layout_symbol["text-offset"]),
                    "text-allow-overlap": new li(j.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new li(j.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new li(j.layout_symbol["text-ignore-placement"]),
                    "text-optional": new li(j.layout_symbol["text-optional"])
                });
            }
        };
        class Iu {
            constructor(t1){
                if (void 0 === t1.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : at, this.defaultValue = t1;
            }
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e1 = this.defaultValue.property.overrides;
                    if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        zn("FormatSectionOverride", Iu, {
            omit: [
                "defaultValue"
            ]
        });
        class zu extends yi {
            constructor(t1){
                super(t1, Su);
            }
            recalculate(t1, e1) {
                if (super.recalculate(t1, e1), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t1 = this.layout.get("text-writing-mode");
                    if (t1) {
                        const e1 = [];
                        for (const r of t1)e1.indexOf(r) < 0 && e1.push(r);
                        this.layout._values["text-writing-mode"] = e1;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t1, e1, r, n) {
                const i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                return a.isDataDriven() || Ir(a.value) || !i ? i : function(t1, e1) {
                    return e1.replace(/{([^{}]+)}/g, (e1, r)=>r in t1 ? String(t1[r]) : "");
                }(e1.properties, i);
            }
            createBucket(t1) {
                return new _u(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t1 of Su.paint.overridableProperties){
                    if (!zu.hasPaintOverride(this.layout, t1)) continue;
                    const e1 = this.paint.get(t1), r = new Iu(e1), n = new Sr(r, e1.property.specification);
                    let i = null;
                    i = "constant" === e1.value.kind || "source" === e1.value.kind ? new Mr("source", n) : new Pr("composite", n, e1.value.zoomStops), this.paint._values[t1] = new si(e1.property, i, e1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                return !(!this.layout || e1.isDataDriven() || r.isDataDriven()) && zu.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e1) {
                const r = t1.get("text-field"), n = Su.paint.properties[e1];
                let i = !1;
                const a = (t1)=>{
                    for (const e1 of t1)if (n.overrides && n.overrides.hasOverride(e1)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Kt) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e1)=>{
                        i || (e1 instanceof Qt && Ht(e1.value) === ft ? a(e1.value.sections) : e1 instanceof nr ? a(e1.sections) : e1.eachChild(t1));
                    }, e1 = r.value;
                    e1._styleExpression && t1(e1._styleExpression.expression);
                }
                return i;
            }
        }
        let Mu;
        var Pu = {
            get paint () {
                return Mu = Mu || new fi({
                    "background-color": new li(j.paint_background["background-color"]),
                    "background-pattern": new hi(j.paint_background["background-pattern"]),
                    "background-opacity": new li(j.paint_background["background-opacity"])
                });
            }
        };
        let Bu;
        var Cu = {
            get paint () {
                return Bu = Bu || new fi({
                    "raster-opacity": new li(j.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new li(j.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new li(j.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new li(j.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new li(j.paint_raster["raster-saturation"]),
                    "raster-contrast": new li(j.paint_raster["raster-contrast"]),
                    "raster-resampling": new li(j.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new li(j.paint_raster["raster-fade-duration"])
                });
            }
        };
        class Vu extends yi {
            constructor(t1){
                super(t1, {}), this.onAdd = (t1)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
                }, this.onRemove = (t1)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
                }, this.implementation = t1;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        const Eu = {
            circle: class extends yi {
                constructor(t1){
                    super(t1, fs);
                }
                createBucket(t1) {
                    return new Ya(t1);
                }
                queryRadius(t1) {
                    const e1 = t1;
                    return ls("circle-radius", this, e1) + ls("circle-stroke-width", this, e1) + us(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, a, s, o) {
                    const l = cs(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, s), u = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), c = "map" === this.paint.get("circle-pitch-alignment"), h = c ? l : function(t1, e1) {
                        return t1.map((t1)=>ws(t1, e1));
                    }(l, o), p = c ? u * s : u;
                    for (const t1 of n)for (const e1 of t1){
                        const t1 = c ? e1 : ws(e1, o);
                        let r = p;
                        const n = bs([], [
                            e1.x,
                            e1.y,
                            0,
                            1
                        ], o);
                        if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= a.cameraToCenterDistance / n[3]), Wa(h, t1, r)) return !0;
                    }
                    return !1;
                }
            },
            heatmap: class extends yi {
                createBucket(t1) {
                    return new _s(t1);
                }
                constructor(t1){
                    super(t1, ks), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = Bs({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius() {
                    return 0;
                }
                queryIntersectsFeature() {
                    return !1;
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
            },
            hillshade: class extends yi {
                constructor(t1){
                    super(t1, Vs);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
            },
            fill: class extends yi {
                constructor(t1){
                    super(t1, wo);
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new xo(t1);
                }
                queryRadius() {
                    return us(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, i, a, s) {
                    return Qa(cs(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, s), n);
                }
                isTileClipped() {
                    return !0;
                }
            },
            "fill-extrusion": class extends yi {
                constructor(t1){
                    super(t1, No);
                }
                createBucket(t1) {
                    return new Uo(t1);
                }
                queryRadius() {
                    return us(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                queryIntersectsFeature(t1, e1, r, n, a, s, o, l) {
                    const u = cs(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, o), c = this.paint.get("fill-extrusion-height").evaluate(e1, r), h = this.paint.get("fill-extrusion-base").evaluate(e1, r), p = function(t1, e1, r, n) {
                        const a = [];
                        for (const r of t1){
                            const t1 = [
                                r.x,
                                r.y,
                                0,
                                1
                            ];
                            bs(t1, t1, e1), a.push(new i(t1[0] / t1[3], t1[1] / t1[3]));
                        }
                        return a;
                    }(u, l), f = function(t1, e1, r, n) {
                        const a = [], s = [], o = n[8] * e1, l = n[9] * e1, u = n[10] * e1, c = n[11] * e1, h = n[8] * r, p = n[9] * r, f = n[10] * r, d = n[11] * r;
                        for (const e1 of t1){
                            const t1 = [], r = [];
                            for (const a of e1){
                                const e1 = a.x, s = a.y, y = n[0] * e1 + n[4] * s + n[12], m = n[1] * e1 + n[5] * s + n[13], g = n[2] * e1 + n[6] * s + n[14], x = n[3] * e1 + n[7] * s + n[15], v = g + u, b = x + c, w = y + h, _ = m + p, A = g + f, k = x + d, S = new i((y + o) / b, (m + l) / b);
                                S.z = v / b, t1.push(S);
                                const I = new i(w / k, _ / k);
                                I.z = A / k, r.push(I);
                            }
                            a.push(t1), s.push(r);
                        }
                        return [
                            a,
                            s
                        ];
                    }(n, h, c, l);
                    return function(t1, e1, r) {
                        let n = 1 / 0;
                        Qa(r, e1) && (n = Ko(r, e1[0]));
                        for(let i = 0; i < e1.length; i++){
                            const a = e1[i], s = t1[i];
                            for(let t1 = 0; t1 < a.length - 1; t1++){
                                const e1 = a[t1], i = [
                                    e1,
                                    a[t1 + 1],
                                    s[t1 + 1],
                                    s[t1],
                                    e1
                                ];
                                Ha(r, i) && (n = Math.min(n, Ko(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(f[0], f[1], p);
                }
            },
            line: class extends yi {
                constructor(t1){
                    super(t1, nl), this.gradientVersion = 0, al || (al = new il(nl.paint.properties["line-width"].specification), al.useIntegerZoom = !0);
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "line-gradient" === t1 && (this.stepInterpolant = this._transitionablePaint._values["line-gradient"].value.expression._styleExpression.expression instanceof Ee, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER);
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                recalculate(t1, e1) {
                    super.recalculate(t1, e1), this.paint._values["line-floorwidth"] = al.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new tl(t1);
                }
                queryRadius(t1) {
                    const e1 = t1, r = sl(ls("line-width", this, e1), ls("line-gap-width", this, e1)), n = ls("line-offset", this, e1);
                    return r / 2 + Math.abs(n) + us(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e1, r, n, a, s, o) {
                    const l = cs(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, o), u = o / 2 * sl(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), c = this.paint.get("line-offset").evaluate(e1, r);
                    return c && (n = function(t1, e1) {
                        const r = [];
                        for(let n = 0; n < t1.length; n++){
                            const a = t1[n], s = [];
                            for(let t1 = 0; t1 < a.length; t1++){
                                const r = a[t1 - 1], n = a[t1], o = a[t1 + 1], l = 0 === t1 ? new i(0, 0) : n.sub(r)._unit()._perp(), u = t1 === a.length - 1 ? new i(0, 0) : o.sub(n)._unit()._perp(), c = l._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                                0 !== h && c._mult(1 / h), s.push(c._mult(e1)._add(n));
                            }
                            r.push(s);
                        }
                        return r;
                    }(n, c * o)), function(t1, e1, r) {
                        for(let n = 0; n < e1.length; n++){
                            const i = e1[n];
                            if (t1.length >= 3) {
                                for(let e1 = 0; e1 < i.length; e1++)if (ss(t1, i[e1])) return !0;
                            }
                            if (ts(t1, i, r)) return !0;
                        }
                        return !1;
                    }(l, n, u);
                }
                isTileClipped() {
                    return !0;
                }
            },
            symbol: zu,
            background: class extends yi {
                constructor(t1){
                    super(t1, Pu);
                }
            },
            raster: class extends yi {
                constructor(t1){
                    super(t1, Cu);
                }
            }
        };
        class Fu {
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                delete this._channel, this._callback = ()=>{};
            }
        }
        const Tu = 6371008.8;
        class Lu {
            constructor(t1, e1){
                if (isNaN(t1) || isNaN(e1)) throw new Error(`Invalid LngLat object: (${t1}, ${e1})`);
                if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new Lu(h(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                return Tu * Math.acos(Math.min(i, 1));
            }
            static convert(t1) {
                if (t1 instanceof Lu) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Lu(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Lu(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const $u = 2 * Math.PI * Tu;
        function Du(t1) {
            return $u * Math.cos(t1 * Math.PI / 180);
        }
        function Ou(t1) {
            return (180 + t1) / 360;
        }
        function Uu(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function Ru(t1, e1) {
            return t1 / Du(e1);
        }
        function qu(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        class ju {
            constructor(t1, e1, r = 0){
                this.x = +t1, this.y = +e1, this.z = +r;
            }
            static fromLngLat(t1, e1 = 0) {
                const r = Lu.convert(t1);
                return new ju(Ou(r.lng), Uu(r.lat), Ru(e1, r.lat));
            }
            toLngLat() {
                return new Lu(360 * this.x - 180, qu(this.y));
            }
            toAltitude() {
                return this.z * Du(qu(this.y));
            }
            meterInMercatorCoordinateUnits() {
                var t1;
                return 1 / $u * (t1 = qu(this.y), 1 / Math.cos(t1 * Math.PI / 180));
            }
        }
        function Nu(t1, e1, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t1 * n - 2 * Math.PI * 6378137 / 2,
                e1 * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class Zu {
            constructor(t1, e1, r){
                if (t1 < 0 || t1 > 25 || r < 0 || r >= Math.pow(2, t1) || e1 < 0 || e1 >= Math.pow(2, t1)) throw new Error(`x=${e1}, y=${r}, z=${t1} outside of bounds. 0<=x<${Math.pow(2, t1)}, 0<=y<${Math.pow(2, t1)} 0<=z<=25 `);
                this.z = t1, this.x = e1, this.y = r, this.key = Ju(0, t1, t1, e1, r);
            }
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e1, r) {
                const n = (a = this.y, s = this.z, o = Nu(256 * (i = this.x), 256 * (a = Math.pow(2, s) - a - 1), s), l = Nu(256 * (i + 1), 256 * (a + 1), s), o[0] + "," + o[1] + "," + l[0] + "," + l[1]);
                var i, a, s, o, l;
                const u = function(t1, e1, r) {
                    let n, i = "";
                    for(let a = t1; a > 0; a--)n = 1 << a - 1, i += (e1 & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e1 > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(t1) {
                const e1 = this.z - t1.z;
                return e1 > 0 && t1.x === this.x >> e1 && t1.y === this.y >> e1;
            }
            getTilePoint(t1) {
                const e1 = Math.pow(2, this.z);
                return new i((t1.x * e1 - this.x) * Na, (t1.y * e1 - this.y) * Na);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Ku {
            constructor(t1, e1){
                this.wrap = t1, this.canonical = e1, this.key = Ju(t1, e1.z, e1.z, e1.x, e1.y);
            }
        }
        class Gu {
            constructor(t1, e1, r, n, i){
                if (t1 < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t1}; z = ${r}`);
                this.overscaledZ = t1, this.wrap = e1, this.canonical = new Zu(r, +n, +i), this.key = Ju(e1, t1, r, n, i);
            }
            clone() {
                return new Gu(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                if (t1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t1}; overscaledZ = ${this.overscaledZ}`);
                const e1 = this.canonical.z - t1;
                return t1 > this.canonical.z ? new Gu(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Gu(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
            }
            calculateScaledKey(t1, e1) {
                if (t1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t1}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - t1;
                return t1 > this.canonical.z ? Ju(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : Ju(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e1 = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new Gu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new Gu(e1, this.wrap, e1, r, n),
                    new Gu(e1, this.wrap, e1, r + 1, n),
                    new Gu(e1, this.wrap, e1, r, n + 1),
                    new Gu(e1, this.wrap, e1, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new Gu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new Gu(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Ku(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t1) {
                return this.canonical.getTilePoint(new ju(t1.x - this.wrap, t1.y));
            }
        }
        function Ju(t1, e1, r, n, i) {
            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
            const a = 1 << r;
            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
        }
        zn("CanonicalTileID", Zu), zn("OverscaledTileID", Gu, {
            omit: [
                "posMatrix"
            ]
        });
        class Xu {
            constructor(t1, e1, r){
                if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void v(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e1.height;
                const n = this.dim = e1.height - 2;
                this.data = new Uint32Array(e1.data.buffer), this.encoding = r || "mapbox";
                for(let t1 = 0; t1 < n; t1++)this.data[this._idx(-1, t1)] = this.data[this._idx(0, t1)], this.data[this._idx(n, t1)] = this.data[this._idx(n - 1, t1)], this.data[this._idx(t1, -1)] = this.data[this._idx(t1, 0)], this.data[this._idx(t1, n)] = this.data[this._idx(t1, n - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t1 = 0; t1 < n; t1++)for(let e1 = 0; e1 < n; e1++){
                    const r = this.get(t1, e1);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
            get(t1, e1) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
                return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return "terrarium" === this.encoding ? [
                    256,
                    1,
                    1 / 256,
                    32768
                ] : [
                    6553.6,
                    25.6,
                    .1,
                    1e4
                ];
            }
            _idx(t1, e1) {
                if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e1 + 1) * this.stride + (t1 + 1);
            }
            _unpackMapbox(t1, e1, r) {
                return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
            }
            _unpackTerrarium(t1, e1, r) {
                return 256 * t1 + e1 + r / 256 - 32768;
            }
            getPixels() {
                return new Ps({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t1, e1, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, s = r * this.dim + this.dim;
                switch(e1){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        a = s - 1;
                        break;
                    case 1:
                        s = a + 1;
                }
                const o = -e1 * this.dim, l = -r * this.dim;
                for(let e1 = a; e1 < s; e1++)for(let r = n; r < i; r++)this.data[this._idx(r, e1)] = t1.data[this._idx(r + o, e1 + l)];
            }
        }
        zn("DEMData", Xu);
        class Yu {
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1];
                    this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                }
            }
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                if (t1 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t1} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t1];
            }
        }
        class Hu {
            constructor(t1, e1, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    geometry: this.geometry
                };
                for(const e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
                return t1;
            }
        }
        class Wu {
            constructor(t1, e1){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new Sn(Na, 16, 0), this.grid3D = new Sn(Na, 16, 0), this.featureIndexArray = new Wi, this.promoteId = e1;
            }
            insert(t1, e1, r, n, i, a) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const o = a ? this.grid3D : this.grid;
                for(let t1 = 0; t1 < e1.length; t1++){
                    const r = e1[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e1 = r[t1];
                        n[0] = Math.min(n[0], e1.x), n[1] = Math.min(n[1], e1.y), n[2] = Math.max(n[2], e1.x), n[3] = Math.max(n[3], e1.y);
                    }
                    n[0] < Na && n[1] < Na && n[2] >= 0 && n[3] >= 0 && o.insert(s, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = new So.VectorTile(new $l(this.rawTileData)).layers, this.sourceLayerCoder = new Yu(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    "_geojsonTileLayer"
                ])), this.vtLayers;
            }
            query(t1, e1, r, n) {
                this.loadVTLayers();
                const a = t1.params || {}, s = Na / t1.tileSize / t1.scale, o = Tr(a.filter), l = t1.queryGeometry, u = t1.queryPadding * s, c = tc(l), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = tc(t1.cameraQueryGeometry), f = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, (e1, r, n, a)=>(function(t1, e1, r, n, a) {
                        for (const i of t1)if (e1 <= i.x && r <= i.y && n >= i.x && a >= i.y) return !0;
                        const s = [
                            new i(e1, r),
                            new i(e1, a),
                            new i(n, a),
                            new i(n, r)
                        ];
                        if (t1.length > 2) {
                            for (const e1 of s)if (ss(t1, e1)) return !0;
                        }
                        for(let e1 = 0; e1 < t1.length - 1; e1++)if (os(t1[e1], t1[e1 + 1], s)) return !0;
                        return !1;
                    })(t1.cameraQueryGeometry, e1 - u, r - u, n + u, a + u));
                for (const t1 of f)h.push(t1);
                h.sort(ec);
                const d = {};
                let y;
                for(let i = 0; i < h.length; i++){
                    const u = h[i];
                    if (u === y) continue;
                    y = u;
                    const c = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(d, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, o, a.layers, a.availableImages, e1, r, n, (e1, r, n)=>(p || (p = Ga(e1)), r.queryIntersectsFeature(l, e1, n, p, this.z, t1.transform, s, t1.pixelPosMatrix)));
                }
                return d;
            }
            loadMatchingFeature(t1, e1, r, n, i, a, s, o, l, u, c) {
                const h = this.bucketLayerIDs[e1];
                if (a && !function(t1, e1) {
                    for(let r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                    return !1;
                }(a, h)) return;
                const f = this.sourceLayerCoder.decode(r), d = this.vtLayers[f].feature(n);
                if (i.needGeometry) {
                    const t1 = Ja(d, !0);
                    if (!i.filter(new Qn(this.tileID.overscaledZ), t1, this.tileID.canonical)) return;
                } else if (!i.filter(new Qn(this.tileID.overscaledZ), d)) return;
                const y = this.getId(d, f);
                for(let e1 = 0; e1 < h.length; e1++){
                    const r = h[e1];
                    if (a && a.indexOf(r) < 0) continue;
                    const i = o[r];
                    if (!i) continue;
                    let f = {};
                    y && u && (f = u.getState(i.sourceLayer || "_geojsonTileLayer", y));
                    const m = p({}, l[r]);
                    m.paint = Qu(m.paint, i.paint, d, f, s), m.layout = Qu(m.layout, i.layout, d, f, s);
                    const g = !c || c(d, i, f);
                    if (!g) continue;
                    const x = new Hu(d, this.z, this.x, this.y, y);
                    x.layer = m;
                    let v = t1[r];
                    void 0 === v && (v = t1[r] = []), v.push({
                        featureIndex: n,
                        feature: x,
                        intersectionZ: g
                    });
                }
            }
            lookupSymbolFeatures(t1, e1, r, n, i, a, s, o) {
                const l = {};
                this.loadVTLayers();
                const u = Tr(i);
                for (const i of t1)this.loadMatchingFeature(l, r, n, i, u, a, s, o, e1);
                return l;
            }
            hasLayer(t1) {
                for (const e1 of this.bucketLayerIDs)for (const r of e1)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e1) {
                let r = t1.id;
                return this.promoteId && (r = t1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]], "boolean" == typeof r && (r = Number(r))), r;
            }
        }
        function Qu(t1, e1, r, n, i) {
            return y(t1, (t1, a)=>{
                const s = e1 instanceof oi ? e1.get(a) : null;
                return s && s.evaluate ? s.evaluate(r, n, i) : s;
            });
        }
        function tc(t1) {
            let e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const a of t1)e1 = Math.min(e1, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
            return {
                minX: e1,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function ec(t1, e1) {
            return e1 - t1;
        }
        function rc(t1, e1, r, n, a) {
            const s = [];
            for(let o = 0; o < t1.length; o++){
                const l = t1[o];
                let u;
                for(let t1 = 0; t1 < l.length - 1; t1++){
                    let o = l[t1], c = l[t1 + 1];
                    o.x < e1 && c.x < e1 || (o.x < e1 ? o = new i(e1, o.y + (e1 - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x < e1 && (c = new i(e1, o.y + (e1 - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y < r && c.y < r || (o.y < r ? o = new i(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round() : c.y < r && (c = new i(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round()), o.x >= n && c.x >= n || (o.x >= n ? o = new i(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x >= n && (c = new i(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y >= a && c.y >= a || (o.y >= a ? o = new i(o.x + (a - o.y) / (c.y - o.y) * (c.x - o.x), a)._round() : c.y >= a && (c = new i(o.x + (a - o.y) / (c.y - o.y) * (c.x - o.x), a)._round()), u && o.equals(u[u.length - 1]) || (u = [
                        o
                    ], s.push(u)), u.push(c)))));
                }
            }
            return s;
        }
        zn("FeatureIndex", Wu, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class nc extends i {
            constructor(t1, e1, r, n){
                super(t1, e1), this.angle = r, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new nc(this.x, this.y, this.angle, this.segment);
            }
        }
        function ic(t1, e1, r, n, i) {
            if (void 0 === e1.segment) return !0;
            let a = e1, s = e1.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (s--, s < 0) return !1;
                o -= t1[s].dist(a), a = t1[s];
            }
            o += t1[s].dist(t1[s + 1]), s++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e1 = t1[s], r = t1[s + 1];
                if (!r) return !1;
                let a = t1[s - 1].angleTo(e1) - e1.angleTo(r);
                for(a = Math.abs((a + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: a
                }), u += a; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                s++, o += e1.dist(r);
            }
            return !0;
        }
        function ac(t1) {
            let e1 = 0;
            for(let r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
            return e1;
        }
        function sc(t1, e1, r) {
            return t1 ? .6 * e1 * r : 0;
        }
        function oc(t1, e1) {
            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function lc(t1, e1, r, n, i, a) {
            const s = sc(r, i, a), o = oc(r, n) * a;
            let l = 0;
            const u = ac(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], a = n.dist(i);
                if (l + a > u) {
                    const c = (u - l) / a, h = Le.number(n.x, i.x, c), p = Le.number(n.y, i.y, c), f = new nc(h, p, i.angleTo(n), r);
                    return f._round(), !s || ic(t1, f, o, s, e1) ? f : void 0;
                }
                l += a;
            }
        }
        function uc(t1, e1, r, n, i, a, s, o, l) {
            const u = sc(n, a, s), c = oc(n, i), h = c * s, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), cc(t1, p ? e1 / 2 * o % e1 : (c / 2 + 2 * a) * s * o % e1, e1, u, r, h, p, !1, l);
        }
        function cc(t1, e1, r, n, i, a, s, o, l) {
            const u = a / 2, c = ac(t1);
            let h = 0, p = e1 - r, f = [];
            for(let e1 = 0; e1 < t1.length - 1; e1++){
                const s = t1[e1], o = t1[e1 + 1], d = s.dist(o), y = o.angleTo(s);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = Le.number(s.x, o.x, m), x = Le.number(s.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new nc(g, x, y, e1);
                        r._round(), n && !ic(t1, r, a, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || s || (f = cc(t1, h / 2, r, n, i, a, s, !0, l)), f;
        }
        zn("Anchor", nc);
        const hc = Nl;
        function pc(t1, e1, r, n) {
            const a = [], s = t1.image, o = s.pixelRatio, l = s.paddedRect.w - 2 * hc, u = s.paddedRect.h - 2 * hc, c = t1.right - t1.left, h = t1.bottom - t1.top, p = s.stretchX || [
                [
                    0,
                    l
                ]
            ], f = s.stretchY || [
                [
                    0,
                    u
                ]
            ], d = (t1, e1)=>t1 + e1[1] - e1[0], y = p.reduce(d, 0), m = f.reduce(d, 0), g = l - y, x = u - m;
            let v = 0, b = y, w = 0, _ = m, A = 0, k = g, S = 0, I = x;
            if (s.content && n) {
                const t1 = s.content;
                v = fc(p, 0, t1[0]), w = fc(f, 0, t1[1]), b = fc(p, t1[0], t1[2]), _ = fc(f, t1[1], t1[3]), A = t1[0] - v, S = t1[1] - w, k = t1[2] - t1[0] - b, I = t1[3] - t1[1] - _;
            }
            const z = (n, a, l, u)=>{
                const p = yc(n.stretch - v, b, c, t1.left), f = mc(n.fixed - A, k, n.stretch, y), d = yc(a.stretch - w, _, h, t1.top), g = mc(a.fixed - S, I, a.stretch, m), x = yc(l.stretch - v, b, c, t1.left), z = mc(l.fixed - A, k, l.stretch, y), M = yc(u.stretch - w, _, h, t1.top), P = mc(u.fixed - S, I, u.stretch, m), B = new i(p, d), C = new i(x, d), V = new i(x, M), E = new i(p, M), F = new i(f / o, g / o), T = new i(z / o, P / o), L = e1 * Math.PI / 180;
                if (L) {
                    const t1 = Math.sin(L), e1 = Math.cos(L), r = [
                        e1,
                        -t1,
                        t1,
                        e1
                    ];
                    B._matMult(r), C._matMult(r), E._matMult(r), V._matMult(r);
                }
                const $ = n.stretch + n.fixed, D = a.stretch + a.fixed;
                return {
                    tl: B,
                    tr: C,
                    bl: E,
                    br: V,
                    tex: {
                        x: s.paddedRect.x + hc + $,
                        y: s.paddedRect.y + hc + D,
                        w: l.stretch + l.fixed - $,
                        h: u.stretch + u.fixed - D
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: T,
                    minFontScaleX: k / o / c,
                    minFontScaleY: I / o / h,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t1 = dc(p, g, y), e1 = dc(f, x, m);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], i = t1[r + 1];
                    for(let t1 = 0; t1 < e1.length - 1; t1++)a.push(z(n, e1[t1], i, e1[t1 + 1]));
                }
            } else a.push(z({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return a;
        }
        function fc(t1, e1, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e1, Math.min(r, i[1])) - Math.max(e1, Math.min(r, i[0]));
            return n;
        }
        function dc(t1, e1, r) {
            const n = [
                {
                    fixed: -hc,
                    stretch: 0
                }
            ];
            for (const [e1, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e1 - t1.stretch,
                    stretch: t1.stretch + (r - e1)
                });
            }
            return n.push({
                fixed: e1 + hc,
                stretch: r
            }), n;
        }
        function yc(t1, e1, r, n) {
            return t1 / e1 * r + n;
        }
        function mc(t1, e1, r, n) {
            return t1 - e1 * r / n;
        }
        class gc {
            constructor(t1, e1, r, n, a, s, o, l, u, c){
                if (this.boxStartIndex = t1.length, u) {
                    let t1 = s.top, e1 = s.bottom;
                    const r = s.collisionPadding;
                    r && (t1 -= r[1], e1 += r[3]);
                    let n = e1 - t1;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    let u = s.top * o - l[0], h = s.bottom * o + l[2], p = s.left * o - l[3], f = s.right * o + l[1];
                    const d = s.collisionPadding;
                    if (d && (p -= d[0] * o, u -= d[1] * o, f += d[2] * o, h += d[3] * o), c) {
                        const t1 = new i(p, u), e1 = new i(f, u), r = new i(p, h), n = new i(f, h), a = c * Math.PI / 180;
                        t1._rotate(a), e1._rotate(a), r._rotate(a), n._rotate(a), p = Math.min(t1.x, e1.x, r.x, n.x), f = Math.max(t1.x, e1.x, r.x, n.x), u = Math.min(t1.y, e1.y, r.y, n.y), h = Math.max(t1.y, e1.y, r.y, n.y);
                    }
                    t1.emplaceBack(e1.x, e1.y, p, u, f, h, r, n, a);
                }
                this.boxEndIndex = t1.length;
            }
        }
        class xc {
            constructor(t1 = [], e1 = vc){
                if (this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
            push(t1) {
                this.data.push(t1), this.length++, this._up(this.length - 1);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e1 = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e1, compare: r } = this, n = e1[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, a = e1[i];
                    if (r(n, a) >= 0) break;
                    e1[t1] = a, t1 = i;
                }
                e1[t1] = n;
            }
            _down(t1) {
                const { data: e1, compare: r } = this, n = this.length >> 1, i = e1[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1), a = e1[n];
                    const s = n + 1;
                    if (s < this.length && r(e1[s], a) < 0 && (n = s, a = e1[s]), r(a, i) >= 0) break;
                    e1[t1] = a, t1 = n;
                }
                e1[t1] = i;
            }
        }
        function vc(t1, e1) {
            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
        }
        function bc(t1, e1 = 1, r = !1) {
            let n = 1 / 0, a = 1 / 0, s = -1 / 0, o = -1 / 0;
            const l = t1[0];
            for(let t1 = 0; t1 < l.length; t1++){
                const e1 = l[t1];
                (!t1 || e1.x < n) && (n = e1.x), (!t1 || e1.y < a) && (a = e1.y), (!t1 || e1.x > s) && (s = e1.x), (!t1 || e1.y > o) && (o = e1.y);
            }
            const u = Math.min(s - n, o - a);
            let c = u / 2;
            const h = new xc([], wc);
            if (0 === u) return new i(n, a);
            for(let e1 = n; e1 < s; e1 += u)for(let r = a; r < o; r += u)h.push(new _c(e1 + c, r + c, c, t1));
            let p = function(t1) {
                let e1 = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, a = i.length, s = a - 1; t1 < a; s = t1++){
                    const a = i[t1], o = i[s], l = a.x * o.y - o.x * a.y;
                    r += (a.x + o.x) * l, n += (a.y + o.y) * l, e1 += 3 * l;
                }
                return new _c(r / e1, n / e1, 0, t1);
            }(t1), f = h.length;
            for(; h.length;){
                const n = h.pop();
                (n.d > p.d || !p.d) && (p = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, f)), n.max - p.d <= e1 || (c = n.h / 2, h.push(new _c(n.p.x - c, n.p.y - c, c, t1)), h.push(new _c(n.p.x + c, n.p.y - c, c, t1)), h.push(new _c(n.p.x - c, n.p.y + c, c, t1)), h.push(new _c(n.p.x + c, n.p.y + c, c, t1)), f += 4);
            }
            return r && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function wc(t1, e1) {
            return e1.max - t1.max;
        }
        function _c(t1, e1, r, n) {
            this.p = new i(t1, e1), this.h = r, this.d = function(t1, e1) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e1.length; i++){
                    const a = e1[i];
                    for(let e1 = 0, i = a.length, s = i - 1; e1 < i; s = e1++){
                        const i = a[e1], o = a[s];
                        i.y > t1.y != o.y > t1.y && t1.x < (o.x - i.x) * (t1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, is(t1, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        const Ac = Number.POSITIVE_INFINITY;
        function kc(t1, e1) {
            return e1[1] !== Ac ? function(t1, e1, r) {
                let n = 0, i = 0;
                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e1;
                }
                return [
                    n,
                    i
                ];
            }(t1, e1[0], e1[1]) : function(t1, e1) {
                let r = 0, n = 0;
                e1 < 0 && (e1 = 0);
                const i = e1 / Math.sqrt(2);
                switch(t1){
                    case "top-right":
                    case "top-left":
                        n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = 7 - i;
                        break;
                    case "bottom":
                        n = 7 - e1;
                        break;
                    case "top":
                        n = e1 - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e1;
                        break;
                    case "right":
                        r = -e1;
                }
                return [
                    r,
                    n
                ];
            }(t1, e1[0]);
        }
        function Sc(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Ic(e1, r, n, i, a, s, o, l, u, c, h) {
            let p = s.textMaxSize.evaluate(r, {});
            void 0 === p && (p = o);
            const f = e1.layers[0].layout, d = f.get("icon-offset").evaluate(r, {}, h), y = Mc(n.horizontal), m = o / 24, g = e1.tilePixelRatio * m, x = e1.tilePixelRatio * p / 24, b = e1.tilePixelRatio * l, w = e1.tilePixelRatio * f.get("symbol-spacing"), _ = f.get("text-padding") * e1.tilePixelRatio, A = function(t1, e1, r, n = 1) {
                const i = t1.get("icon-padding").evaluate(e1, {}, r), a = i && i.values;
                return [
                    a[0] * n,
                    a[1] * n,
                    a[2] * n,
                    a[3] * n
                ];
            }(f, r, h, e1.tilePixelRatio), k = f.get("text-max-angle") / 180 * Math.PI, S = "viewport" !== f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), I = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), z = f.get("symbol-placement"), M = w / 2, P = f.get("icon-text-fit");
            let B;
            i && "none" !== P && (e1.allowVerticalPlacement && n.vertical && (B = uu(i, n.vertical, P, f.get("icon-text-fit-padding"), d, m)), y && (i = uu(i, y, P, f.get("icon-text-fit-padding"), d, m)));
            const C = (l, p)=>{
                p.x < 0 || p.x >= Na || p.y < 0 || p.y >= Na || function(e1, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, b, w, _, A, k, S, I) {
                    const z = e1.addToLineVertexArray(r, n);
                    let M, P, B, C, V = 0, E = 0, F = 0, T = 0, L = -1, $ = -1;
                    const D = {};
                    let O = ka(""), U = 0, R = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [U, R] = l.layout.get("text-offset").evaluate(_, {}, S).map((t1)=>t1 * dl) : (U = l.layout.get("text-radial-offset").evaluate(_, {}, S) * dl, R = Ac), e1.allowVerticalPlacement && i.vertical) {
                        const t1 = l.layout.get("text-rotate").evaluate(_, {}, S) + 90;
                        B = new gc(u, r, c, h, p, i.vertical, f, d, y, t1), o && (C = new gc(u, r, c, h, p, o, g, x, y, t1));
                    }
                    if (a) {
                        const n = l.layout.get("icon-rotate").evaluate(_, {}), i = "none" !== l.layout.get("icon-text-fit"), s = pc(a, n, k, i), f = o ? pc(o, n, k, i) : void 0;
                        P = new gc(u, r, c, h, p, a, g, x, !1, n), V = 4 * s.length;
                        const d = e1.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            hu * l.layout.get("icon-size").evaluate(_, {})
                        ], y[0] > pu && v(`${e1.layerIds[0]}: Value for "icon-size" is >= ${cu}. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            hu * A.compositeIconSizes[0].evaluate(_, {}, S),
                            hu * A.compositeIconSizes[1].evaluate(_, {}, S)
                        ], (y[0] > pu || y[1] > pu) && v(`${e1.layerIds[0]}: Value for "icon-size" is >= ${cu}. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, s, y, w, b, _, t1.WritingMode.none, r, z.lineStartIndex, z.lineLength, -1, S), L = e1.icon.placedSymbolArray.length - 1, f && (E = 4 * f.length, e1.addSymbols(e1.icon, f, y, w, b, _, t1.WritingMode.vertical, r, z.lineStartIndex, z.lineLength, -1, S), $ = e1.icon.placedSymbolArray.length - 1);
                    }
                    const q = Object.keys(i.horizontal);
                    for (const n of q){
                        const a = i.horizontal[n];
                        if (!M) {
                            O = ka(a.text);
                            const t1 = l.layout.get("text-rotate").evaluate(_, {}, S);
                            M = new gc(u, r, c, h, p, a, f, d, y, t1);
                        }
                        const o = 1 === a.positionedLines.length;
                        if (F += zc(e1, r, a, s, l, y, _, m, z, i.vertical ? t1.WritingMode.horizontal : t1.WritingMode.horizontalOnly, o ? q : [
                            n
                        ], D, L, A, S), o) break;
                    }
                    i.vertical && (T += zc(e1, r, i.vertical, s, l, y, _, m, z, t1.WritingMode.vertical, [
                        "vertical"
                    ], D, $, A, S));
                    const j = M ? M.boxStartIndex : e1.collisionBoxArray.length, N = M ? M.boxEndIndex : e1.collisionBoxArray.length, Z = B ? B.boxStartIndex : e1.collisionBoxArray.length, K = B ? B.boxEndIndex : e1.collisionBoxArray.length, G = P ? P.boxStartIndex : e1.collisionBoxArray.length, J = P ? P.boxEndIndex : e1.collisionBoxArray.length, X = C ? C.boxStartIndex : e1.collisionBoxArray.length, Y = C ? C.boxEndIndex : e1.collisionBoxArray.length;
                    let H = -1;
                    const W = (t1, e1)=>t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                    H = W(M, H), H = W(B, H), H = W(P, H), H = W(C, H);
                    const Q = H > -1 ? 1 : 0;
                    Q && (H *= I / dl), e1.glyphOffsetArray.length >= _u.MAX_GLYPHS && v("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== _.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, _.sortKey), e1.symbolInstances.emplaceBack(r.x, r.y, D.right >= 0 ? D.right : -1, D.center >= 0 ? D.center : -1, D.left >= 0 ? D.left : -1, D.vertical || -1, L, $, O, j, N, Z, K, G, J, X, Y, c, F, T, V, E, Q, 0, f, U, R, H);
                }(e1, p, l, n, i, a, B, e1.layers[0], e1.collisionBoxArray, r.index, r.sourceLayerIndex, e1.index, g, [
                    _,
                    _,
                    _,
                    _
                ], S, u, b, A, I, d, r, s, c, h, o);
            };
            if ("line" === z) for (const t1 of rc(r.geometry, 0, 0, Na, Na)){
                const r = uc(t1, w, k, n.vertical || y, i, 24, x, e1.overscaling, Na);
                for (const n of r)y && Pc(e1, y.text, M, n) || C(t1, n);
            }
            else if ("line-center" === z) {
                for (const t1 of r.geometry)if (t1.length > 1) {
                    const e1 = lc(t1, k, n.vertical || y, i, 24, x);
                    e1 && C(t1, e1);
                }
            } else if ("Polygon" === r.type) for (const t1 of fo(r.geometry, 0)){
                const e1 = bc(t1, 16);
                C(t1[0], new nc(e1.x, e1.y, 0));
            }
            else if ("LineString" === r.type) for (const t1 of r.geometry)C(t1, new nc(t1[0].x, t1[0].y, 0));
            else if ("Point" === r.type) for (const t1 of r.geometry)for (const e1 of t1)C([
                e1
            ], new nc(e1.x, e1.y, 0));
        }
        function zc(t1, e1, r, n, a, s, o, l, u, c, h, p, f, d, y) {
            const m = function(t1, e1, r, n, a, s, o, l) {
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = [];
                for (const t1 of e1.positionedLines)for (const n of t1.positionedGlyphs){
                    if (!n.rect) continue;
                    const s = n.rect || {};
                    let h = ql + 1, p = !0, f = 1, d = 0;
                    const y = (a || l) && n.vertical, m = n.metrics.advance * n.scale / 2;
                    if (l && e1.verticalizable && (d = t1.lineOffset / 2 - (n.imageName ? -(dl - n.metrics.width * n.scale) / 2 : (n.scale - 1) * dl)), n.imageName) {
                        const t1 = o[n.imageName];
                        p = t1.sdf, f = t1.pixelRatio, h = Nl / f;
                    }
                    const g = a ? [
                        n.x + m,
                        n.y
                    ] : [
                        0,
                        0
                    ];
                    let x = a ? [
                        0,
                        0
                    ] : [
                        n.x + m + r[0],
                        n.y + r[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = (n.metrics.left - h) * n.scale - m + x[0], w = (-n.metrics.top - h) * n.scale + x[1], _ = b + s.w * n.scale / f, A = w + s.h * n.scale / f, k = new i(b, w), S = new i(_, w), I = new i(b, A), z = new i(_, A);
                    if (y) {
                        const t1 = new i(-m, m - Jl), e1 = -Math.PI / 2, r = dl / 2 - m, a = new i(5 - Jl - r, -(n.imageName ? r : 0)), s = new i(...v);
                        k._rotateAround(e1, t1)._add(a)._add(s), S._rotateAround(e1, t1)._add(a)._add(s), I._rotateAround(e1, t1)._add(a)._add(s), z._rotateAround(e1, t1)._add(a)._add(s);
                    }
                    if (u) {
                        const t1 = Math.sin(u), e1 = Math.cos(u), r = [
                            e1,
                            -t1,
                            t1,
                            e1
                        ];
                        k._matMult(r), S._matMult(r), I._matMult(r), z._matMult(r);
                    }
                    const M = new i(0, 0), P = new i(0, 0);
                    c.push({
                        tl: k,
                        tr: S,
                        bl: I,
                        br: z,
                        tex: s,
                        writingMode: e1.writingMode,
                        glyphOffset: g,
                        sectionIndex: n.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: M,
                        pixelOffsetBR: P,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, r, l, a, s, o, n, t1.allowVerticalPlacement), g = t1.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                hu * a.layout.get("text-size").evaluate(o, {})
            ], x[0] > pu && v(`${t1.layerIds[0]}: Value for "text-size" is >= ${cu}. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                hu * d.compositeTextSizes[0].evaluate(o, {}, y),
                hu * d.compositeTextSizes[1].evaluate(o, {}, y)
            ], (x[0] > pu || x[1] > pu) && v(`${t1.layerIds[0]}: Value for "text-size" is >= ${cu}. Reduce your "text-size".`)), t1.addSymbols(t1.text, m, x, l, s, o, c, e1, u.lineStartIndex, u.lineLength, f, y);
            for (const e1 of h)p[e1] = t1.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function Mc(t1) {
            for(const e1 in t1)return t1[e1];
            return null;
        }
        function Pc(t1, e1, r, n) {
            const i = t1.compareText;
            if (e1 in i) {
                const t1 = i[e1];
                for(let e1 = t1.length - 1; e1 >= 0; e1--)if (n.dist(t1[e1]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        const Bc = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class Cc {
            static from(t1) {
                if (!(t1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e1, r] = new Uint8Array(t1, 0, 2);
                if (219 !== e1) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = Bc[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [a] = new Uint16Array(t1, 2, 1), [s] = new Uint32Array(t1, 4, 1);
                return new Cc(s, a, i, t1);
            }
            constructor(t1, e1 = 64, r = Float64Array, n){
                if (isNaN(t1) || t1 < 0) throw new Error(`Unpexpected numItems value: ${t1}.`);
                this.numItems = +t1, this.nodeSize = Math.min(Math.max(+e1, 2), 65535), this.ArrayType = r, this.IndexArrayType = t1 < 65536 ? Uint16Array : Uint32Array;
                const i = Bc.indexOf(this.ArrayType), a = 2 * t1 * this.ArrayType.BYTES_PER_ELEMENT, s = t1 * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - s % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t1), this._pos = 2 * t1, this._finished = !0) : (this.data = new ArrayBuffer(8 + a + s + o), this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e1, new Uint32Array(this.data, 4, 1)[0] = t1);
            }
            add(t1, e1) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t1, this.coords[this._pos++] = e1, r;
            }
            finish() {
                const t1 = this._pos >> 1;
                if (t1 !== this.numItems) throw new Error(`Added ${t1} items when expected ${this.numItems}.`);
                return Vc(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t1, e1, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: a, nodeSize: s } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let s = h; s <= c; s++){
                            const o = a[2 * s], u = a[2 * s + 1];
                            o >= t1 && o <= r && u >= e1 && u <= n && l.push(i[s]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = a[2 * p], d = a[2 * p + 1];
                    f >= t1 && f <= r && d >= e1 && d <= n && l.push(i[p]), (0 === u ? t1 <= f : e1 <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t1, e1, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: a } = this, s = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; s.length;){
                    const u = s.pop() || 0, c = s.pop() || 0, h = s.pop() || 0;
                    if (c - h <= a) {
                        for(let r = h; r <= c; r++)Lc(i[2 * r], i[2 * r + 1], t1, e1) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    Lc(f, d, t1, e1) <= l && o.push(n[p]), (0 === u ? t1 - r <= f : e1 - r <= d) && (s.push(h), s.push(p - 1), s.push(1 - u)), (0 === u ? t1 + r >= f : e1 + r >= d) && (s.push(p + 1), s.push(c), s.push(1 - u));
                }
                return o;
            }
        }
        function Vc(t1, e1, r, n, i, a) {
            if (i - n <= r) return;
            const s = n + i >> 1;
            Ec(t1, e1, s, n, i, a), Vc(t1, e1, r, n, s - 1, 1 - a), Vc(t1, e1, r, s + 1, i, 1 - a);
        }
        function Ec(t1, e1, r, n, i, a) {
            for(; i > n;){
                if (i - n > 600) {
                    const s = i - n + 1, o = r - n + 1, l = Math.log(s), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (s - u) / s) * (o - s / 2 < 0 ? -1 : 1);
                    Ec(t1, e1, r, Math.max(n, Math.floor(r - o * u / s + c)), Math.min(i, Math.floor(r + (s - o) * u / s + c)), a);
                }
                const s = e1[2 * r + a];
                let o = n, l = i;
                for(Fc(t1, e1, n, r), e1[2 * i + a] > s && Fc(t1, e1, n, i); o < l;){
                    for(Fc(t1, e1, o, l), o++, l--; e1[2 * o + a] < s;)o++;
                    for(; e1[2 * l + a] > s;)l--;
                }
                e1[2 * n + a] === s ? Fc(t1, e1, n, l) : (l++, Fc(t1, e1, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function Fc(t1, e1, r, n) {
            Tc(t1, r, n), Tc(e1, 2 * r, 2 * n), Tc(e1, 2 * r + 1, 2 * n + 1);
        }
        function Tc(t1, e1, r) {
            const n = t1[e1];
            t1[e1] = t1[r], t1[r] = n;
        }
        function Lc(t1, e1, r, n) {
            const i = t1 - r, a = e1 - n;
            return i * i + a * a;
        }
        var $c;
        t1.PerformanceMarkers = void 0, ($c = t1.PerformanceMarkers || (t1.PerformanceMarkers = {})).create = "create", $c.load = "load", $c.fullLoad = "fullLoad";
        let Dc = null, Oc = [];
        const Uc = 1e3 / 60, Rc = "loadTime", qc = "fullLoadTime", jc = {
            mark (t1) {
                performance.mark(t1);
            },
            frame (t1) {
                const e1 = t1;
                null != Dc && Oc.push(e1 - Dc), Dc = e1;
            },
            clearMetrics () {
                Dc = null, Oc = [], performance.clearMeasures(Rc), performance.clearMeasures(qc);
                for(const e1 in t1.PerformanceMarkers)performance.clearMarks(t1.PerformanceMarkers[e1]);
            },
            getPerformanceMetrics () {
                performance.measure(Rc, t1.PerformanceMarkers.create, t1.PerformanceMarkers.load), performance.measure(qc, t1.PerformanceMarkers.create, t1.PerformanceMarkers.fullLoad);
                const e1 = performance.getEntriesByName(Rc)[0].duration, r = performance.getEntriesByName(qc)[0].duration, n = Oc.length, i = 1 / (Oc.reduce((t1, e1)=>t1 + e1, 0) / n / 1e3), a = Oc.filter((t1)=>t1 > Uc).reduce((t1, e1)=>t1 + (e1 - Uc) / Uc, 0);
                return {
                    loadTime: e1,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: a / (n + a) * 100,
                    totalFrames: n
                };
            }
        };
        t1.AJAXError = C, t1.ARRAY_TYPE = ys, t1.Actor = class {
            constructor(t1, e1, r){
                this.target = t1, this.parent = e1, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, d([
                    "receive",
                    "process"
                ], this), this.invoker = new Fu(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = _() ? t1 : window;
            }
            send(t1, e1, r, n, i = !1) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (this.callbacks[a] = r);
                const s = k(this.globalScope) ? void 0 : [];
                return this.target.postMessage({
                    id: a,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Pn(e1, s)
                }, s), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e1 = t1.data, r = e1.id;
                if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                    if ("<cancel>" === e1.type) {
                        delete this.tasks[r];
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1();
                    } else _() || e1.mustQueue ? (this.tasks[r] = e1, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e1);
                }
            }
            process() {
                if (!this.taskQueue.length) return;
                const t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), e1 && this.processTask(t1, e1);
            }
            processTask(t1, e1) {
                if ("<response>" === e1.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e1.error ? r(Bn(e1.error)) : r(null, Bn(e1.data)));
                } else {
                    let r = !1;
                    const n = k(this.globalScope) ? void 0 : [], i = e1.hasCallback ? (e1, i)=>{
                        r = !0, delete this.cancelCallbacks[t1], this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e1 ? Pn(e1) : null,
                            data: Pn(i, n)
                        }, n);
                    } : (t1)=>{
                        r = !0;
                    };
                    let a = null;
                    const s = Bn(e1.data);
                    if (this.parent[e1.type]) a = this.parent[e1.type](e1.sourceMapId, s, i);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e1.type.split(".");
                        a = this.parent.getWorkerSource(e1.sourceMapId, t1[0], s.source)[t1[1]](s, i);
                    } else i(new Error(`Could not find function ${e1.type}`));
                    !r && a && a.cancel && (this.cancelCallbacks[t1] = a.cancel);
                }
            }
            remove() {
                this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, t1.AlphaImage = Ms, t1.CanonicalTileID = Zu, t1.CollisionBoxArray = Ni, t1.CollisionCircleLayoutArray = class extends Ei {
        }, t1.Color = jt, t1.DEMData = Xu, t1.DataConstantProperty = li, t1.DictionaryCoder = Yu, t1.EXTENT = Na, t1.ErrorEvent = R, t1.EvaluationParameters = Qn, t1.Event = U, t1.Evented = q, t1.FeatureIndex = Wu, t1.FillBucket = xo, t1.FillExtrusionBucket = Uo, t1.GeoJSONFeature = Hu, t1.ImageAtlas = Kl, t1.ImagePosition = Zl, t1.KDBush = Cc, t1.LineBucket = tl, t1.LineStripIndexArray = class extends Ri {
        }, t1.LngLat = Lu, t1.MercatorCoordinate = ju, t1.ONE_EM = dl, t1.OverscaledTileID = Gu, t1.PerformanceUtils = jc, t1.Point = i, t1.Pos3dArray = class extends _i {
        }, t1.PosArray = Qi, t1.Properties = fi, t1.Protobuf = $l, t1.QuadTriangleArray = class extends Ti {
        }, t1.RGBAImage = Ps, t1.RasterBoundsArray = class extends Ai {
        }, t1.RequestPerformance = class {
            constructor(t1){
                this._marks = {
                    start: [
                        t1.url,
                        "start"
                    ].join("#"),
                    end: [
                        t1.url,
                        "end"
                    ].join("#"),
                    measure: t1.url.toString()
                }, performance.mark(this._marks.start);
            }
            finish() {
                performance.mark(this._marks.end);
                let t1 = performance.getEntriesByName(this._marks.measure);
                return 0 === t1.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t1;
            }
        }, t1.SegmentVector = ya, t1.SymbolBucket = _u, t1.Transitionable = ri, t1.TriangleIndexArray = ha, t1.Uniform1f = Ba, t1.Uniform1i = class extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = 0;
            }
            set(t1) {
                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
            }
        }, t1.Uniform2f = class extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = [
                    0,
                    0
                ];
            }
            set(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
            }
        }, t1.Uniform3f = class extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t1) {
                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
            }
        }, t1.Uniform4f = Ca, t1.UniformColor = Va, t1.UniformMatrix4f = class extends Pa {
            constructor(t1, e1){
                super(t1, e1), this.current = Ea;
            }
            set(t1) {
                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                for(let e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                    break;
                }
            }
        }, t1.UnwrappedTileID = Ku, t1.ValidationError = et, t1.ZoomHistory = Cn, t1.addDynamicAttributes = xu, t1.arrayBufferToImage = function(t1, e1) {
            const r = new Image;
            r.onload = ()=>{
                e1(null, r), URL.revokeObjectURL(r.src), r.onload = null, window.requestAnimationFrame(()=>{
                    r.src = I;
                });
            }, r.onerror = ()=>e1(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            const n = new Blob([
                new Uint8Array(t1)
            ], {
                type: "image/png"
            });
            r.src = t1.byteLength ? URL.createObjectURL(n) : I;
        }, t1.arrayBufferToImageBitmap = function(t1, e1) {
            const r = new Blob([
                new Uint8Array(t1)
            ], {
                type: "image/png"
            });
            createImageBitmap(r).then((t1)=>{
                e1(null, t1);
            }).catch((t1)=>{
                e1(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            });
        }, t1.asyncAll = function(t1, e1, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let a = null;
            t1.forEach((t1, s)=>{
                e1(t1, (t1, e1)=>{
                    t1 && (a = t1), i[s] = e1, 0 == --n && r(a, i);
                });
            });
        }, t1.bezier = l, t1.bindAll = d, t1.clamp = c, t1.clipLine = rc, t1.clone = function(t1) {
            var e1 = new ys(16);
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }, t1.clone$1 = g, t1.collisionCircleLayout = hl, t1.config = B, t1.copy = function(t1, e1) {
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }, t1.create = function() {
            var t1 = new ys(16);
            return ys != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
        }, t1.createExpression = zr, t1.createFilter = Tr, t1.createLayout = vi, t1.createStyleLayer = function(t1) {
            return "custom" === t1.type ? new Vu(t1) : new Eu[t1.type](t1);
        }, t1.deepEqual = function t1(e1, r) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                for(let n = 0; n < e1.length; n++)if (!t1(e1[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                for(const n in e1)if (!t1(e1[n], r[n])) return !1;
                return !0;
            }
            return e1 === r;
        }, t1.derefLayers = function(t1) {
            t1 = t1.slice();
            const e1 = Object.create(null);
            for(let r = 0; r < t1.length; r++)e1[t1[r].id] = t1[r];
            for(let r = 0; r < t1.length; r++)"ref" in t1[r] && (t1[r] = Z(t1[r], e1[t1[r].ref]));
            return t1;
        }, t1.diffStyles = function(t1, e1) {
            if (!t1) return [
                {
                    command: G.setStyle,
                    args: [
                        e1
                    ]
                }
            ];
            let r = [];
            try {
                if (!K(t1.version, e1.version)) return [
                    {
                        command: G.setStyle,
                        args: [
                            e1
                        ]
                    }
                ];
                K(t1.center, e1.center) || r.push({
                    command: G.setCenter,
                    args: [
                        e1.center
                    ]
                }), K(t1.zoom, e1.zoom) || r.push({
                    command: G.setZoom,
                    args: [
                        e1.zoom
                    ]
                }), K(t1.bearing, e1.bearing) || r.push({
                    command: G.setBearing,
                    args: [
                        e1.bearing
                    ]
                }), K(t1.pitch, e1.pitch) || r.push({
                    command: G.setPitch,
                    args: [
                        e1.pitch
                    ]
                }), K(t1.sprite, e1.sprite) || r.push({
                    command: G.setSprite,
                    args: [
                        e1.sprite
                    ]
                }), K(t1.glyphs, e1.glyphs) || r.push({
                    command: G.setGlyphs,
                    args: [
                        e1.glyphs
                    ]
                }), K(t1.transition, e1.transition) || r.push({
                    command: G.setTransition,
                    args: [
                        e1.transition
                    ]
                }), K(t1.light, e1.light) || r.push({
                    command: G.setLight,
                    args: [
                        e1.light
                    ]
                });
                const n = {}, i = [];
                !function(t1, e1, r, n) {
                    let i;
                    for(i in e1 = e1 || {}, t1 = t1 || {})Object.prototype.hasOwnProperty.call(t1, i) && (Object.prototype.hasOwnProperty.call(e1, i) || X(i, r, n));
                    for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t1, i) ? K(t1[i], e1[i]) || ("geojson" === t1[i].type && "geojson" === e1[i].type && H(t1, e1, i) ? r.push({
                        command: G.setGeoJSONSourceData,
                        args: [
                            i,
                            e1[i].data
                        ]
                    }) : Y(i, e1, r, n)) : J(i, e1, r));
                }(t1.sources, e1.sources, i, n);
                const a = [];
                t1.layers && t1.layers.forEach((t1)=>{
                    n[t1.source] ? r.push({
                        command: G.removeLayer,
                        args: [
                            t1.id
                        ]
                    }) : a.push(t1);
                }), r = r.concat(i), function(t1, e1, r) {
                    e1 = e1 || [];
                    const n = (t1 = t1 || []).map(Q), i = e1.map(Q), a = t1.reduce(tt, {}), s = e1.reduce(tt, {}), o = n.slice(), l = Object.create(null);
                    let u, c, h, p, f, d, y;
                    for(u = 0, c = 0; u < n.length; u++)h = n[u], Object.prototype.hasOwnProperty.call(s, h) ? c++ : (r.push({
                        command: G.removeLayer,
                        args: [
                            h
                        ]
                    }), o.splice(o.indexOf(h, c), 1));
                    for(u = 0, c = 0; u < i.length; u++)h = i[i.length - 1 - u], o[o.length - 1 - u] !== h && (Object.prototype.hasOwnProperty.call(a, h) ? (r.push({
                        command: G.removeLayer,
                        args: [
                            h
                        ]
                    }), o.splice(o.lastIndexOf(h, o.length - c), 1)) : c++, d = o[o.length - u], r.push({
                        command: G.addLayer,
                        args: [
                            s[h],
                            d
                        ]
                    }), o.splice(o.length - u, 0, h), l[h] = !0);
                    for(u = 0; u < i.length; u++)if (h = i[u], p = a[h], f = s[h], !l[h] && !K(p, f)) {
                        if (K(p.source, f.source) && K(p["source-layer"], f["source-layer"]) && K(p.type, f.type)) {
                            for(y in W(p.layout, f.layout, r, h, null, G.setLayoutProperty), W(p.paint, f.paint, r, h, null, G.setPaintProperty), K(p.filter, f.filter) || r.push({
                                command: G.setFilter,
                                args: [
                                    h,
                                    f.filter
                                ]
                            }), K(p.minzoom, f.minzoom) && K(p.maxzoom, f.maxzoom) || r.push({
                                command: G.setLayerZoomRange,
                                args: [
                                    h,
                                    f.minzoom,
                                    f.maxzoom
                                ]
                            }), p)Object.prototype.hasOwnProperty.call(p, y) && "layout" !== y && "paint" !== y && "filter" !== y && "metadata" !== y && "minzoom" !== y && "maxzoom" !== y && (0 === y.indexOf("paint.") ? W(p[y], f[y], r, h, y.slice(6), G.setPaintProperty) : K(p[y], f[y]) || r.push({
                                command: G.setLayerProperty,
                                args: [
                                    h,
                                    y,
                                    f[y]
                                ]
                            }));
                            for(y in f)Object.prototype.hasOwnProperty.call(f, y) && !Object.prototype.hasOwnProperty.call(p, y) && "layout" !== y && "paint" !== y && "filter" !== y && "metadata" !== y && "minzoom" !== y && "maxzoom" !== y && (0 === y.indexOf("paint.") ? W(p[y], f[y], r, h, y.slice(6), G.setPaintProperty) : K(p[y], f[y]) || r.push({
                                command: G.setLayerProperty,
                                args: [
                                    h,
                                    y,
                                    f[y]
                                ]
                            }));
                        } else r.push({
                            command: G.removeLayer,
                            args: [
                                h
                            ]
                        }), d = o[o.lastIndexOf(h) + 1], r.push({
                            command: G.addLayer,
                            args: [
                                f,
                                d
                            ]
                        });
                    }
                }(a, e1.layers, r);
            } catch (t1) {
                console.warn("Unable to compute style diff:", t1), r = [
                    {
                        command: G.setStyle,
                        args: [
                            e1
                        ]
                    }
                ];
            }
            return r;
        }, t1.dot = function(t1, e1) {
            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
        }, t1.earthRadius = Tu, t1.ease = u, t1.emitValidationErrors = kn, t1.emptyStyle = function() {
            const t1 = {}, e1 = j.$version;
            for(const r in j.$root){
                const n = j.$root[r];
                if (n.required) {
                    let i = null;
                    i = "version" === r ? e1 : "array" === n.type ? [] : {}, null != i && (t1[r] = i);
                }
            }
            return t1;
        }, t1.equals = function(t1, e1) {
            var r = t1[0], n = t1[1], i = t1[2], a = t1[3], s = t1[4], o = t1[5], l = t1[6], u = t1[7], c = t1[8], h = t1[9], p = t1[10], f = t1[11], d = t1[12], y = t1[13], m = t1[14], g = t1[15], x = e1[0], v = e1[1], b = e1[2], w = e1[3], _ = e1[4], A = e1[5], k = e1[6], S = e1[7], I = e1[8], z = e1[9], M = e1[10], P = e1[11], B = e1[12], C = e1[13], V = e1[14], E = e1[15];
            return Math.abs(r - x) <= ds * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= ds * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(i - b) <= ds * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - w) <= ds * Math.max(1, Math.abs(a), Math.abs(w)) && Math.abs(s - _) <= ds * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(o - A) <= ds * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(l - k) <= ds * Math.max(1, Math.abs(l), Math.abs(k)) && Math.abs(u - S) <= ds * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(c - I) <= ds * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - z) <= ds * Math.max(1, Math.abs(h), Math.abs(z)) && Math.abs(p - M) <= ds * Math.max(1, Math.abs(p), Math.abs(M)) && Math.abs(f - P) <= ds * Math.max(1, Math.abs(f), Math.abs(P)) && Math.abs(d - B) <= ds * Math.max(1, Math.abs(d), Math.abs(B)) && Math.abs(y - C) <= ds * Math.max(1, Math.abs(y), Math.abs(C)) && Math.abs(m - V) <= ds * Math.max(1, Math.abs(m), Math.abs(V)) && Math.abs(g - E) <= ds * Math.max(1, Math.abs(g), Math.abs(E));
        }, t1.evaluateSizeForFeature = function(t1, { uSize: e1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / hu : "composite" === t1.kind ? Le.number(n / hu, i / hu, r) : e1;
        }, t1.evaluateSizeForZoom = function(t1, e1) {
            let r = 0, n = 0;
            if ("constant" === t1.kind) n = t1.layoutSize;
            else if ("source" !== t1.kind) {
                const { interpolationType: i, minZoom: a, maxZoom: s } = t1, o = i ? c($e.interpolationFactor(i, e1, a, s), 0, 1) : 0;
                "camera" === t1.kind ? n = Le.number(t1.minSize, t1.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, t1.evaluateVariableOffset = kc, t1.evented = Xn, t1.exported = P, t1.extend = p, t1.filterObject = m, t1.findLineIntersection = function(t1, e1, r, n) {
            const a = e1.y - t1.y, s = e1.x - t1.x, o = n.y - r.y, l = n.x - r.x, u = o * s - l * a;
            if (0 === u) return null;
            const c = (l * (t1.y - r.y) - o * (t1.x - r.x)) / u;
            return new i(t1.x + c * s, t1.y + c * a);
        }, t1.fromScaling = function(t1, e1) {
            return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
        }, t1.getAnchorAlignment = su, t1.getAnchorJustification = Sc, t1.getArrayBuffer = L, t1.getDefaultExportFromCjs = e1, t1.getJSON = function(t1, e1) {
            return T(p(t1, {
                type: "json"
            }), e1);
        }, t1.getOverlapMode = du, t1.getProtocolAction = E, t1.getRTLTextPluginStatus = Yn, t1.getReferrer = V, t1.getVideo = function(t1, e1) {
            const r = window.document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e1(null, r);
            };
            for(let e1 = 0; e1 < t1.length; e1++){
                const n = window.document.createElement("source");
                $(t1[e1]) || (r.crossOrigin = "Anonymous"), n.src = t1[e1], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.groupByLayout = function(t1, e1) {
            const r = {};
            for(let n = 0; n < t1.length; n++){
                const i = e1 && e1[t1[n].id] || Nr(t1[n]);
                e1 && (e1[t1[n].id] = i);
                let a = r[i];
                a || (a = r[i] = []), a.push(t1[n]);
            }
            const n = [];
            for(const t1 in r)n.push(r[t1]);
            return n;
        }, t1.identity = ms, t1.interpolate = Le, t1.invert = function(t1, e1) {
            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], s = e1[4], o = e1[5], l = e1[6], u = e1[7], c = e1[8], h = e1[9], p = e1[10], f = e1[11], d = e1[12], y = e1[13], m = e1[14], g = e1[15], x = r * o - n * s, v = r * l - i * s, b = r * u - a * s, w = n * l - i * o, _ = n * u - a * o, A = i * u - a * l, k = c * y - h * d, S = c * m - p * d, I = c * g - f * d, z = h * m - p * y, M = h * g - f * y, P = p * g - f * m, B = x * P - v * M + b * z + w * I - _ * S + A * k;
            return B ? (t1[0] = (o * P - l * M + u * z) * (B = 1 / B), t1[1] = (i * M - n * P - a * z) * B, t1[2] = (y * A - m * _ + g * w) * B, t1[3] = (p * _ - h * A - f * w) * B, t1[4] = (l * I - s * P - u * S) * B, t1[5] = (r * P - i * I + a * S) * B, t1[6] = (m * b - d * A - g * v) * B, t1[7] = (c * A - p * b + f * v) * B, t1[8] = (s * M - o * I + u * k) * B, t1[9] = (n * I - r * M - a * k) * B, t1[10] = (d * _ - y * b + g * x) * B, t1[11] = (h * b - c * _ - f * x) * B, t1[12] = (o * S - s * z - l * k) * B, t1[13] = (r * z - n * S + i * k) * B, t1[14] = (y * v - d * w - m * x) * B, t1[15] = (c * w - h * v + p * x) * B, t1) : null;
        }, t1.isImageBitmap = S, t1.isSafari = k, t1.isWorker = _, t1.keysDifference = function(t1, e1) {
            const r = [];
            for(const n in t1)n in e1 || r.push(n);
            return r;
        }, t1.lazyLoadRTLTextPlugin = function() {
            Wn.isLoading() || Wn.isLoaded() || "deferred" !== Yn() || Hn();
        }, t1.makeRequest = T, t1.mapObject = y, t1.mercatorXfromLng = Ou, t1.mercatorYfromLat = Uu, t1.mercatorZfromAltitude = Ru, t1.mul = vs, t1.mul$1 = function(t1, e1, r) {
            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
        }, t1.multiply = gs, t1.nextPowerOfTwo = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }, t1.operations = G, t1.ortho = function(t1, e1, r, n, i, a, s) {
            var o = 1 / (e1 - r), l = 1 / (n - i), u = 1 / (a - s);
            return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e1 + r) * o, t1[13] = (i + n) * l, t1[14] = (s + a) * u, t1[15] = 1, t1;
        }, t1.parseCacheControl = function(t1) {
            const e1 = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const a = n || i;
                return e1[r] = !a || a.toLowerCase(), "";
            }), e1["max-age"]) {
                const t1 = parseInt(e1["max-age"], 10);
                isNaN(t1) ? delete e1["max-age"] : e1["max-age"] = t1;
            }
            return e1;
        }, t1.parseGlyphPbf = function(t1) {
            return new $l(t1).readFields(Ol, []);
        }, t1.pbf = yl, t1.performSymbolLayout = function(e1) {
            e1.bucket.createArrays(), e1.bucket.tilePixelRatio = Na / (512 * e1.bucket.overscaling), e1.bucket.compareText = {}, e1.bucket.iconsNeedLinear = !1;
            const r = e1.bucket.layers[0].layout, n = e1.bucket.layers[0]._unevaluatedLayout._values, i = {
                layoutIconSize: n["icon-size"].possiblyEvaluate(new Qn(e1.bucket.zoom + 1), e1.canonical),
                layoutTextSize: n["text-size"].possiblyEvaluate(new Qn(e1.bucket.zoom + 1), e1.canonical),
                textMaxSize: n["text-size"].possiblyEvaluate(new Qn(18))
            };
            if ("composite" === e1.bucket.textSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e1.bucket.textSizeData;
                i.compositeTextSizes = [
                    n["text-size"].possiblyEvaluate(new Qn(t1), e1.canonical),
                    n["text-size"].possiblyEvaluate(new Qn(r), e1.canonical)
                ];
            }
            if ("composite" === e1.bucket.iconSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e1.bucket.iconSizeData;
                i.compositeIconSizes = [
                    n["icon-size"].possiblyEvaluate(new Qn(t1), e1.canonical),
                    n["icon-size"].possiblyEvaluate(new Qn(r), e1.canonical)
                ];
            }
            const a = r.get("text-line-height") * dl, s = "viewport" !== r.get("text-rotation-alignment") && "point" !== r.get("symbol-placement"), o = r.get("text-keep-upright"), l = r.get("text-size");
            for (const n of e1.bucket.features){
                const u = r.get("text-font").evaluate(n, {}, e1.canonical).join(","), c = l.evaluate(n, {}, e1.canonical), h = i.layoutTextSize.evaluate(n, {}, e1.canonical), p = i.layoutIconSize.evaluate(n, {}, e1.canonical), f = {
                    horizontal: {},
                    vertical: void 0
                }, d = n.text;
                let y, m = [
                    0,
                    0
                ];
                if (d) {
                    const i = d.toString(), l = r.get("text-letter-spacing").evaluate(n, {}, e1.canonical) * dl, p = Fn(i) ? l : 0, y = r.get("text-anchor").evaluate(n, {}, e1.canonical), g = r.get("text-variable-anchor");
                    if (!g) {
                        const t1 = r.get("text-radial-offset").evaluate(n, {}, e1.canonical);
                        m = t1 ? kc(y, [
                            t1 * dl,
                            Ac
                        ]) : r.get("text-offset").evaluate(n, {}, e1.canonical).map((t1)=>t1 * dl);
                    }
                    let x = s ? "center" : r.get("text-justify").evaluate(n, {}, e1.canonical);
                    const v = r.get("symbol-placement"), b = "point" === v ? r.get("text-max-width").evaluate(n, {}, e1.canonical) * dl : 0, w = ()=>{
                        e1.bucket.allowVerticalPlacement && En(i) && (f.vertical = Hl(d, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, y, "left", p, m, t1.WritingMode.vertical, !0, v, h, c));
                    };
                    if (!s && g) {
                        const r = "auto" === x ? g.map((t1)=>Sc(t1)) : [
                            x
                        ];
                        let n = !1;
                        for(let i = 0; i < r.length; i++){
                            const s = r[i];
                            if (!f.horizontal[s]) {
                                if (n) f.horizontal[s] = f.horizontal[0];
                                else {
                                    const r = Hl(d, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, "center", s, p, m, t1.WritingMode.horizontal, !1, v, h, c);
                                    r && (f.horizontal[s] = r, n = 1 === r.positionedLines.length);
                                }
                            }
                        }
                        w();
                    } else {
                        "auto" === x && (x = Sc(y));
                        const r = Hl(d, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, y, x, p, m, t1.WritingMode.horizontal, !1, v, h, c);
                        r && (f.horizontal[x] = r), w(), En(i) && s && o && (f.vertical = Hl(d, e1.glyphMap, e1.glyphPositions, e1.imagePositions, u, b, a, y, x, p, m, t1.WritingMode.vertical, !1, v, h, c));
                    }
                }
                let g = !1;
                if (n.icon && n.icon.name) {
                    const t1 = e1.imageMap[n.icon.name];
                    t1 && (y = lu(e1.imagePositions[n.icon.name], r.get("icon-offset").evaluate(n, {}, e1.canonical), r.get("icon-anchor").evaluate(n, {}, e1.canonical)), g = !!t1.sdf, void 0 === e1.bucket.sdfIcons ? e1.bucket.sdfIcons = g : e1.bucket.sdfIcons !== g && v("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t1.pixelRatio !== e1.bucket.pixelRatio || 0 !== r.get("icon-rotate").constantOr(1)) && (e1.bucket.iconsNeedLinear = !0));
                }
                const x = Mc(f.horizontal) || f.vertical;
                e1.bucket.iconsInText = !!x && x.iconsInText, (x || y) && Ic(e1.bucket, n, f, y, e1.imageMap, i, h, p, m, g, e1.canonical);
            }
            e1.showCollisionBoxes && e1.bucket.generateCollisionDebugBuffers();
        }, t1.perspective = function(t1, e1, r, n, i) {
            var a, s = 1 / Math.tan(e1 / 2);
            return t1[0] = s / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = s, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (a = 1 / (n - i)), t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
        }, t1.pick = function(t1, e1) {
            const r = {};
            for(let n = 0; n < e1.length; n++){
                const i = e1[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.plugin = Wn, t1.pointGeometry = r, t1.polygonIntersectsPolygon = Ha, t1.potpack = jl, t1.register = zn, t1.registerForPluginStateChange = function(t1) {
            return t1({
                pluginStatus: Zn,
                pluginURL: Kn
            }), Xn.on("pluginStateChange", t1), t1;
        }, t1.renderColorRamp = Bs, t1.rotateX = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[4], s = e1[5], o = e1[6], l = e1[7], u = e1[8], c = e1[9], h = e1[10], p = e1[11];
            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + u * n, t1[5] = s * i + c * n, t1[6] = o * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - a * n, t1[9] = c * i - s * n, t1[10] = h * i - o * n, t1[11] = p * i - l * n, t1;
        }, t1.rotateZ = function(t1, e1, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e1[0], s = e1[1], o = e1[2], l = e1[3], u = e1[4], c = e1[5], h = e1[6], p = e1[7];
            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + u * n, t1[1] = s * i + c * n, t1[2] = o * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - a * n, t1[5] = c * i - s * n, t1[6] = h * i - o * n, t1[7] = p * i - l * n, t1;
        }, t1.sameOrigin = $, t1.scale = function(t1, e1, r) {
            var n = r[0], i = r[1], a = r[2];
            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }, t1.setRTLTextPlugin = function(t1, e1, r = !1) {
            if (Zn === Rn || Zn === qn || Zn === jn) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Kn = P.resolveURL(t1), Zn = Rn, Nn = e1, Jn(), r || Hn();
        }, t1.sphericalToCartesian = function([t1, e1, r]) {
            return e1 += 90, e1 *= Math.PI / 180, r *= Math.PI / 180, {
                x: t1 * Math.cos(e1) * Math.sin(r),
                y: t1 * Math.sin(e1) * Math.sin(r),
                z: t1 * Math.cos(r)
            };
        }, t1.toEvaluationFeature = Ja, t1.transformMat4 = bs, t1.translate = function(t1, e1, r) {
            var n, i, a, s, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e1 === t1 ? (t1[12] = e1[0] * y + e1[4] * m + e1[8] * g + e1[12], t1[13] = e1[1] * y + e1[5] * m + e1[9] * g + e1[13], t1[14] = e1[2] * y + e1[6] * m + e1[10] * g + e1[14], t1[15] = e1[3] * y + e1[7] * m + e1[11] * g + e1[15]) : (i = e1[1], a = e1[2], s = e1[3], o = e1[4], l = e1[5], u = e1[6], c = e1[7], h = e1[8], p = e1[9], f = e1[10], d = e1[11], t1[0] = n = e1[0], t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = o, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * y + o * m + h * g + e1[12], t1[13] = i * y + l * m + p * g + e1[13], t1[14] = a * y + u * m + f * g + e1[14], t1[15] = s * y + c * m + d * g + e1[15]), t1;
        }, t1.triggerPluginCompletionEvent = Gn, t1.unicodeBlockLookup = Vn, t1.uniqueId = function() {
            return f++;
        }, t1.v8Spec = j, t1.validateCustomStyleLayer = function(t1) {
            const e1 = [], r = t1.id;
            return void 0 === r && e1.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e1.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e1;
        }, t1.validateLight = wn, t1.validateStyle = bn, t1.vectorTile = So, t1.warnOnce = v, t1.wrap = h;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        class t1 {
            constructor(e1){
                this.keyCache = {}, e1 && this.replace(e1);
            }
            replace(e1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, []);
            }
            update(t1, o) {
                for (const o of t1){
                    this._layerConfigs[o.id] = o;
                    const t1 = this._layers[o.id] = e1.createStyleLayer(o);
                    t1._featureFilter = e1.createFilter(t1.filter), this.keyCache[o.id] && delete this.keyCache[o.id];
                }
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const i = e1.groupByLayout(Object.values(this._layerConfigs), this.keyCache);
                for (const e1 of i){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), o = t1[0];
                    if ("none" === o.visibility) continue;
                    const i = o.source || "";
                    let r = this.familiesBySource[i];
                    r || (r = this.familiesBySource[i] = {});
                    const s = o.sourceLayer || "_geojsonTileLayer";
                    let n = r[s];
                    n || (n = r[s] = []), n.push(t1);
                }
            }
        }
        class o {
            constructor(t1){
                const o = {}, i = [];
                for(const e1 in t1){
                    const r = t1[e1], s = o[e1] = {};
                    for(const e1 in r){
                        const t1 = r[+e1];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const o = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2,
                            h: t1.bitmap.height + 2
                        };
                        i.push(o), s[e1] = {
                            rect: o,
                            metrics: t1.metrics
                        };
                    }
                }
                const { w: r, h: s } = e1.potpack(i), n = new e1.AlphaImage({
                    width: r || 1,
                    height: s || 1
                });
                for(const i in t1){
                    const r = t1[i];
                    for(const t1 in r){
                        const s = r[+t1];
                        if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                        const a = o[i][t1].rect;
                        e1.AlphaImage.copy(s.bitmap, n, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, s.bitmap);
                    }
                }
                this.image = n, this.positions = o;
            }
        }
        e1.register("GlyphAtlas", o);
        class i {
            constructor(t1){
                this.tileID = new e1.OverscaledTileID(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.uid = t1.uid, this.zoom = t1.zoom, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.collectResourceTiming, this.returnDependencies = !!t1.returnDependencies, this.promoteId = t1.promoteId;
            }
            parse(t1, i, s, n, a) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new e1.CollisionBoxArray;
                const l = new e1.DictionaryCoder(Object.keys(t1.layers).sort()), c = new e1.FeatureIndex(this.tileID, this.promoteId);
                c.bucketLayerIDs = [];
                const u = {}, h = {
                    featureIndex: c,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    availableImages: s
                }, d = i.familiesBySource[this.source];
                for(const o in d){
                    const i = t1.layers[o];
                    if (!i) continue;
                    1 === i.version && e1.warnOnce(`Vector tile source "${this.source}" layer "${o}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const n = l.encode(o), a = [];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const t1 = i.feature(e1), r = c.getId(t1, o);
                        a.push({
                            feature: t1,
                            id: r,
                            index: e1,
                            sourceLayerIndex: n
                        });
                    }
                    for (const t1 of d[o]){
                        const o = t1[0];
                        o.source !== this.source && e1.warnOnce(`layer.source = ${o.source} does not equal this.source = ${this.source}`), o.minzoom && this.zoom < Math.floor(o.minzoom) || o.maxzoom && this.zoom >= o.maxzoom || "none" !== o.visibility && (r(t1, this.zoom, s), (u[o.id] = o.createBucket({
                            index: c.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: n,
                            sourceID: this.source
                        })).populate(a, h, this.tileID.canonical), c.bucketLayerIDs.push(t1.map((e1)=>e1.id)));
                    }
                }
                let p, f, g, m;
                const y = e1.mapObject(h.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                Object.keys(y).length ? n.send("getGlyphs", {
                    uid: this.uid,
                    stacks: y,
                    source: this.source,
                    tileID: this.tileID,
                    type: "glyphs"
                }, (e1, t1)=>{
                    p || (p = e1, f = t1, w.call(this));
                }) : f = {};
                const v = Object.keys(h.iconDependencies);
                v.length ? n.send("getImages", {
                    icons: v,
                    source: this.source,
                    tileID: this.tileID,
                    type: "icons"
                }, (e1, t1)=>{
                    p || (p = e1, g = t1, w.call(this));
                }) : g = {};
                const x = Object.keys(h.patternDependencies);
                function w() {
                    if (p) return a(p);
                    if (f && g && m) {
                        const t1 = new o(f), i = new e1.ImageAtlas(g, m);
                        for(const o in u){
                            const n = u[o];
                            n instanceof e1.SymbolBucket ? (r(n.layers, this.zoom, s), e1.performSymbolLayout({
                                bucket: n,
                                glyphMap: f,
                                glyphPositions: t1.positions,
                                imageMap: g,
                                imagePositions: i.iconPositions,
                                showCollisionBoxes: this.showCollisionBoxes,
                                canonical: this.tileID.canonical
                            })) : n.hasPattern && (n instanceof e1.LineBucket || n instanceof e1.FillBucket || n instanceof e1.FillExtrusionBucket) && (r(n.layers, this.zoom, s), n.addFeatures(h, this.tileID.canonical, i.patternPositions));
                        }
                        this.status = "done", a(null, {
                            buckets: Object.values(u).filter((e1)=>!e1.isEmpty()),
                            featureIndex: c,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t1.image,
                            imageAtlas: i,
                            glyphMap: this.returnDependencies ? f : null,
                            iconMap: this.returnDependencies ? g : null,
                            glyphPositions: this.returnDependencies ? t1.positions : null
                        });
                    }
                }
                x.length ? n.send("getImages", {
                    icons: x,
                    source: this.source,
                    tileID: this.tileID,
                    type: "patterns"
                }, (e1, t1)=>{
                    p || (p = e1, m = t1, w.call(this));
                }) : m = {}, w.call(this);
            }
        }
        function r(t1, o, i) {
            const r = new e1.EvaluationParameters(o);
            for (const e1 of t1)e1.recalculate(r, i);
        }
        function s(t1, o) {
            const i = e1.getArrayBuffer(t1.request, (t1, i, r, s)=>{
                t1 ? o(t1) : i && o(null, {
                    vectorTile: new e1.vectorTile.VectorTile(new e1.Protobuf(i)),
                    rawData: i,
                    cacheControl: r,
                    expires: s
                });
            });
            return ()=>{
                i.cancel(), o();
            };
        }
        class n {
            constructor(e1, t1, o, i){
                this.actor = e1, this.layerIndex = t1, this.availableImages = o, this.loadVectorData = i || s, this.loading = {}, this.loaded = {};
            }
            loadTile(t1, o) {
                const r = t1.uid;
                this.loading || (this.loading = {});
                const s = !!(t1 && t1.request && t1.request.collectResourceTiming) && new e1.RequestPerformance(t1.request), n = this.loading[r] = new i(t1);
                n.abort = this.loadVectorData(t1, (t1, i)=>{
                    if (delete this.loading[r], t1 || !i) return n.status = "done", this.loaded[r] = n, o(t1);
                    const a = i.rawData, l = {};
                    i.expires && (l.expires = i.expires), i.cacheControl && (l.cacheControl = i.cacheControl);
                    const c = {};
                    if (s) {
                        const e1 = s.finish();
                        e1 && (c.resourceTiming = JSON.parse(JSON.stringify(e1)));
                    }
                    n.vectorTile = i.vectorTile, n.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor, (t1, i)=>{
                        if (t1 || !i) return o(t1);
                        o(null, e1.extend({
                            rawTileData: a.slice(0)
                        }, i, l, c));
                    }), this.loaded = this.loaded || {}, this.loaded[r] = n;
                });
            }
            reloadTile(e1, t1) {
                const o = this.loaded, i = e1.uid, r = this;
                if (o && o[i]) {
                    const s = o[i];
                    s.showCollisionBoxes = e1.showCollisionBoxes;
                    const n = (e1, o)=>{
                        const i = s.reloadCallback;
                        i && (delete s.reloadCallback, s.parse(s.vectorTile, r.layerIndex, this.availableImages, r.actor, i)), t1(e1, o);
                    };
                    "parsing" === s.status ? s.reloadCallback = n : "done" === s.status && (s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, n) : n());
                }
            }
            abortTile(e1, t1) {
                const o = this.loading, i = e1.uid;
                o && o[i] && o[i].abort && (o[i].abort(), delete o[i]), t1();
            }
            removeTile(e1, t1) {
                const o = this.loaded, i = e1.uid;
                o && o[i] && delete o[i], t1();
            }
        }
        class a {
            constructor(){
                this.loaded = {};
            }
            loadTile(t1, o) {
                const { uid: i, encoding: r, rawImageData: s } = t1, n = e1.isImageBitmap(s) ? this.getImageData(s) : s, a = new e1.DEMData(i, n, r);
                this.loaded = this.loaded || {}, this.loaded[i] = a, o(null, a);
            }
            getImageData(t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(t1.width, t1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = t1.width, this.offscreenCanvas.height = t1.height, this.offscreenCanvasContext.drawImage(t1, 0, 0, t1.width, t1.height);
                const o = this.offscreenCanvasContext.getImageData(-1, -1, t1.width + 2, t1.height + 2);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new e1.RGBAImage({
                    width: o.width,
                    height: o.height
                }, o.data);
            }
            removeTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                t1 && t1[o] && delete t1[o];
            }
        }
        function l(e1, t1) {
            if (0 !== e1.length) {
                c(e1[0], t1);
                for(var o = 1; o < e1.length; o++)c(e1[o], !t1);
            }
        }
        function c(e1, t1) {
            for(var o = 0, i = 0, r = 0, s = e1.length, n = s - 1; r < s; n = r++){
                var a = (e1[r][0] - e1[n][0]) * (e1[n][1] + e1[r][1]), l = o + a;
                i += Math.abs(o) >= Math.abs(a) ? o - l + a : a - l + o, o = l;
            }
            o + i >= 0 != !!t1 && e1.reverse();
        }
        var u = e1.getDefaultExportFromCjs(function e1(t1, o) {
            var i, r = t1 && t1.type;
            if ("FeatureCollection" === r) for(i = 0; i < t1.features.length; i++)e1(t1.features[i], o);
            else if ("GeometryCollection" === r) for(i = 0; i < t1.geometries.length; i++)e1(t1.geometries[i], o);
            else if ("Feature" === r) e1(t1.geometry, o);
            else if ("Polygon" === r) l(t1.coordinates, o);
            else if ("MultiPolygon" === r) for(i = 0; i < t1.coordinates.length; i++)l(t1.coordinates[i], o);
            return t1;
        });
        const h = e1.vectorTile.VectorTileFeature.prototype.toGeoJSON;
        var d = {
            exports: {}
        }, p = e1.pointGeometry, f = e1.vectorTile.VectorTileFeature, g = m;
        function m(e1, t1) {
            this.options = t1 || {}, this.features = e1, this.length = e1.length;
        }
        function y(e1, t1) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t1 || 4096;
        }
        m.prototype.feature = function(e1) {
            return new y(this.features[e1], this.options.extent);
        }, y.prototype.loadGeometry = function() {
            var e1 = this.rawGeometry;
            this.geometry = [];
            for(var t1 = 0; t1 < e1.length; t1++){
                for(var o = e1[t1], i = [], r = 0; r < o.length; r++)i.push(new p(o[r][0], o[r][1]));
                this.geometry.push(i);
            }
            return this.geometry;
        }, y.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t1 = 1 / 0, o = -1 / 0, i = 1 / 0, r = -1 / 0, s = 0; s < e1.length; s++)for(var n = e1[s], a = 0; a < n.length; a++){
                var l = n[a];
                t1 = Math.min(t1, l.x), o = Math.max(o, l.x), i = Math.min(i, l.y), r = Math.max(r, l.y);
            }
            return [
                t1,
                i,
                o,
                r
            ];
        }, y.prototype.toGeoJSON = f.prototype.toGeoJSON;
        var v = e1.pbf, x = g;
        function w(e1) {
            var t1 = new v;
            return function(e1, t1) {
                for(var o in e1.layers)t1.writeMessage(3, S, e1.layers[o]);
            }(e1, t1), t1.finish();
        }
        function S(e1, t1) {
            var o;
            t1.writeVarintField(15, e1.version || 1), t1.writeStringField(1, e1.name || ""), t1.writeVarintField(5, e1.extent || 4096);
            var i = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(o = 0; o < e1.length; o++)i.feature = e1.feature(o), t1.writeMessage(2, b, i);
            var r = i.keys;
            for(o = 0; o < r.length; o++)t1.writeStringField(3, r[o]);
            var s = i.values;
            for(o = 0; o < s.length; o++)t1.writeMessage(4, T, s[o]);
        }
        function b(e1, t1) {
            var o = e1.feature;
            void 0 !== o.id && t1.writeVarintField(1, o.id), t1.writeMessage(2, I, e1), t1.writeVarintField(3, o.type), t1.writeMessage(4, k, o);
        }
        function I(e1, t1) {
            var o = e1.feature, i = e1.keys, r = e1.values, s = e1.keycache, n = e1.valuecache;
            for(var a in o.properties){
                var l = o.properties[a], c = s[a];
                if (null !== l) {
                    void 0 === c && (i.push(a), s[a] = c = i.length - 1), t1.writeVarint(c);
                    var u = typeof l;
                    "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                    var h = u + ":" + l, d = n[h];
                    void 0 === d && (r.push(l), n[h] = d = r.length - 1), t1.writeVarint(d);
                }
            }
        }
        function M(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function P(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function k(e1, t1) {
            for(var o = e1.loadGeometry(), i = e1.type, r = 0, s = 0, n = o.length, a = 0; a < n; a++){
                var l = o[a], c = 1;
                1 === i && (c = l.length), t1.writeVarint(M(1, c));
                for(var u = 3 === i ? l.length - 1 : l.length, h = 0; h < u; h++){
                    1 === h && 1 !== i && t1.writeVarint(M(2, u - 1));
                    var d = l[h].x - r, p = l[h].y - s;
                    t1.writeVarint(P(d)), t1.writeVarint(P(p)), r += d, s += p;
                }
                3 === i && t1.writeVarint(M(7, 1));
            }
        }
        function T(e1, t1) {
            var o = typeof e1;
            "string" === o ? t1.writeStringField(1, e1) : "boolean" === o ? t1.writeBooleanField(7, e1) : "number" === o && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        d.exports = w, d.exports.fromVectorTileJs = w, d.exports.fromGeojsonVt = function(e1, t1) {
            t1 = t1 || {};
            var o = {};
            for(var i in e1)o[i] = new x(e1[i].features, t1), o[i].name = i, o[i].version = t1.version, o[i].extent = t1.extent;
            return w({
                layers: o
            });
        }, d.exports.GeoJSONWrapper = x;
        var C = e1.getDefaultExportFromCjs(d.exports);
        const _ = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, D = Math.fround || (O = new Float32Array(1), (e1)=>(O[0] = +e1, O[0]));
        var O;
        const L = 3, F = 5, E = 6;
        class z {
            constructor(e1){
                this.options = Object.assign(Object.create(_), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e1) {
                const { log: t1, minZoom: o, maxZoom: i } = this.options;
                t1 && console.time("total time");
                const r = `prepare ${e1.length} points`;
                t1 && console.time(r), this.points = e1;
                const s = [];
                for(let t1 = 0; t1 < e1.length; t1++){
                    const o = e1[t1];
                    if (!o.geometry) continue;
                    const [i, r] = o.geometry.coordinates, n = D(B(i)), a = D(Z(r));
                    s.push(n, a, 1 / 0, t1, -1, 1), this.options.reduce && s.push(0);
                }
                let n = this.trees[i + 1] = this._createTree(s);
                t1 && console.timeEnd(r);
                for(let e1 = i; e1 >= o; e1--){
                    const o = +Date.now();
                    n = this.trees[e1] = this._createTree(this._cluster(n, e1)), t1 && console.log("z%d: %d clusters in %dms", e1, n.numItems, +Date.now() - o);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let o = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e1[1]));
                let r = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) o = -180, r = 180;
                else if (o > r) {
                    const e1 = this.getClusters([
                        o,
                        i,
                        180,
                        s
                    ], t1), n = this.getClusters([
                        -180,
                        i,
                        r,
                        s
                    ], t1);
                    return e1.concat(n);
                }
                const n = this.trees[this._limitZoom(t1)], a = n.range(B(o), Z(s), B(r), Z(i)), l = n.data, c = [];
                for (const e1 of a){
                    const t1 = this.stride * e1;
                    c.push(l[t1 + F] > 1 ? j(l, t1, this.clusterProps) : this.points[l[t1 + L]]);
                }
                return c;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), o = this._getOriginZoom(e1), i = "No cluster with the specified id.", r = this.trees[o];
                if (!r) throw new Error(i);
                const s = r.data;
                if (t1 * this.stride >= s.length) throw new Error(i);
                const n = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = r.within(s[t1 * this.stride], s[t1 * this.stride + 1], n), l = [];
                for (const t1 of a){
                    const o = t1 * this.stride;
                    s[o + 4] === e1 && l.push(s[o + F] > 1 ? j(s, o, this.clusterProps) : this.points[s[o + L]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e1, t1, o) {
                const i = [];
                return this._appendLeaves(i, e1, t1 = t1 || 10, o = o || 0, 0), i;
            }
            getTile(e1, t1, o) {
                const i = this.trees[this._limitZoom(e1)], r = Math.pow(2, e1), { extent: s, radius: n } = this.options, a = n / s, l = (o - a) / r, c = (o + 1 + a) / r, u = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / r, l, (t1 + 1 + a) / r, c), i.data, t1, o, r, u), 0 === t1 && this._addTileFeatures(i.range(1 - a / r, l, 1, c), i.data, r, o, r, u), t1 === r - 1 && this._addTileFeatures(i.range(0, l, a / r, c), i.data, -1, o, r, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const o = this.getChildren(e1);
                    if (t1++, 1 !== o.length) break;
                    e1 = o[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, o, i, r) {
                const s = this.getChildren(t1);
                for (const t1 of s){
                    const s = t1.properties;
                    if (s && s.cluster ? r + s.point_count <= i ? r += s.point_count : r = this._appendLeaves(e1, s.cluster_id, o, i, r) : r < i ? r++ : e1.push(t1), e1.length === o) break;
                }
                return r;
            }
            _createTree(t1) {
                const o = new e1.KDBush(t1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e1 = 0; e1 < t1.length; e1 += this.stride)o.add(t1[e1], t1[e1 + 1]);
                return o.finish(), o.data = t1, o;
            }
            _addTileFeatures(e1, t1, o, i, r, s) {
                for (const n of e1){
                    const e1 = n * this.stride, a = t1[e1 + F] > 1;
                    let l, c, u;
                    if (a) l = N(t1, e1, this.clusterProps), c = t1[e1], u = t1[e1 + 1];
                    else {
                        const o = this.points[t1[e1 + L]];
                        l = o.properties;
                        const [i, r] = o.geometry.coordinates;
                        c = B(i), u = Z(r);
                    }
                    const h = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * r - o)),
                                Math.round(this.options.extent * (u * r - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e1 + L] : this.points[t1[e1 + L]].id, void 0 !== d && (h.id = d), s.features.push(h);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t1) {
                const { radius: o, extent: i, reduce: r, minPoints: s } = this.options, n = o / (i * Math.pow(2, t1)), a = e1.data, l = [], c = this.stride;
                for(let o = 0; o < a.length; o += c){
                    if (a[o + 2] <= t1) continue;
                    a[o + 2] = t1;
                    const i = a[o], u = a[o + 1], h = e1.within(a[o], a[o + 1], n), d = a[o + F];
                    let p = d;
                    for (const e1 of h){
                        const o = e1 * c;
                        a[o + 2] > t1 && (p += a[o + F]);
                    }
                    if (p > d && p >= s) {
                        let e1, s = i * d, n = u * d, f = -1;
                        const g = ((o / c | 0) << 5) + (t1 + 1) + this.points.length;
                        for (const i of h){
                            const l = i * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const u = a[l + F];
                            s += a[l] * u, n += a[l + 1] * u, a[l + 4] = g, r && (e1 || (e1 = this._map(a, o, !0), f = this.clusterProps.length, this.clusterProps.push(e1)), r(e1, this._map(a, l)));
                        }
                        a[o + 4] = g, l.push(s / p, n / p, 1 / 0, g, -1, p), r && l.push(f);
                    } else {
                        for(let e1 = 0; e1 < c; e1++)l.push(a[o + e1]);
                        if (p > 1) for (const e1 of h){
                            const o = e1 * c;
                            if (!(a[o + 2] <= t1)) {
                                a[o + 2] = t1;
                                for(let e1 = 0; e1 < c; e1++)l.push(a[o + e1]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t1, o) {
                if (e1[t1 + F] > 1) {
                    const i = this.clusterProps[e1[t1 + E]];
                    return o ? Object.assign({}, i) : i;
                }
                const i = this.points[e1[t1 + L]].properties, r = this.options.map(i);
                return o && r === i ? Object.assign({}, r) : r;
            }
        }
        function j(e1, t1, o) {
            var i;
            return {
                type: "Feature",
                id: e1[t1 + L],
                properties: N(e1, t1, o),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e1[t1], 360 * (i - .5)),
                        A(e1[t1 + 1])
                    ]
                }
            };
        }
        function N(e1, t1, o) {
            const i = e1[t1 + F], r = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, s = e1[t1 + E], n = -1 === s ? {} : Object.assign({}, o[s]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e1[t1 + L],
                point_count: i,
                point_count_abbreviated: r
            });
        }
        function B(e1) {
            return e1 / 360 + .5;
        }
        function Z(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function A(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function G(e1, t1, o, i) {
            for(var r, s = i, n = o - t1 >> 1, a = o - t1, l = e1[t1], c = e1[t1 + 1], u = e1[o], h = e1[o + 1], d = t1 + 3; d < o; d += 3){
                var p = J(e1[d], e1[d + 1], l, c, u, h);
                if (p > s) r = d, s = p;
                else if (p === s) {
                    var f = Math.abs(d - n);
                    f < a && (r = d, a = f);
                }
            }
            s > i && (r - t1 > 3 && G(e1, t1, r, i), e1[r + 2] = s, o - r > 3 && G(e1, r, o, i));
        }
        function J(e1, t1, o, i, r, s) {
            var n = r - o, a = s - i;
            if (0 !== n || 0 !== a) {
                var l = ((e1 - o) * n + (t1 - i) * a) / (n * n + a * a);
                l > 1 ? (o = r, i = s) : l > 0 && (o += n * l, i += a * l);
            }
            return (n = e1 - o) * n + (a = t1 - i) * a;
        }
        function Y(e1, t1, o, i) {
            var r = {
                id: void 0 === e1 ? null : e1,
                type: t1,
                geometry: o,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e1) {
                var t1 = e1.geometry, o = e1.type;
                if ("Point" === o || "MultiPoint" === o || "LineString" === o) R(e1, t1);
                else if ("Polygon" === o || "MultiLineString" === o) for(var i = 0; i < t1.length; i++)R(e1, t1[i]);
                else if ("MultiPolygon" === o) for(i = 0; i < t1.length; i++)for(var r = 0; r < t1[i].length; r++)R(e1, t1[i][r]);
            }(r), r;
        }
        function R(e1, t1) {
            for(var o = 0; o < t1.length; o += 3)e1.minX = Math.min(e1.minX, t1[o]), e1.minY = Math.min(e1.minY, t1[o + 1]), e1.maxX = Math.max(e1.maxX, t1[o]), e1.maxY = Math.max(e1.maxY, t1[o + 1]);
        }
        function V(e1, t1, o, i) {
            if (t1.geometry) {
                var r = t1.geometry.coordinates, s = t1.geometry.type, n = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2), a = [], l = t1.id;
                if (o.promoteId ? l = t1.properties[o.promoteId] : o.generateId && (l = i || 0), "Point" === s) X(r, a);
                else if ("MultiPoint" === s) for(var c = 0; c < r.length; c++)X(r[c], a);
                else if ("LineString" === s) W(r, a, n, !1);
                else if ("MultiLineString" === s) {
                    if (o.lineMetrics) {
                        for(c = 0; c < r.length; c++)W(r[c], a = [], n, !1), e1.push(Y(l, "LineString", a, t1.properties));
                        return;
                    }
                    q(r, a, n, !1);
                } else if ("Polygon" === s) q(r, a, n, !0);
                else {
                    if ("MultiPolygon" !== s) {
                        if ("GeometryCollection" === s) {
                            for(c = 0; c < t1.geometry.geometries.length; c++)V(e1, {
                                id: l,
                                geometry: t1.geometry.geometries[c],
                                properties: t1.properties
                            }, o, i);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(c = 0; c < r.length; c++){
                        var u = [];
                        q(r[c], u, n, !0), a.push(u);
                    }
                }
                e1.push(Y(l, s, a, t1.properties));
            }
        }
        function X(e1, t1) {
            t1.push($(e1[0])), t1.push(U(e1[1])), t1.push(0);
        }
        function W(e1, t1, o, i) {
            for(var r, s, n = 0, a = 0; a < e1.length; a++){
                var l = $(e1[a][0]), c = U(e1[a][1]);
                t1.push(l), t1.push(c), t1.push(0), a > 0 && (n += i ? (r * c - l * s) / 2 : Math.sqrt(Math.pow(l - r, 2) + Math.pow(c - s, 2))), r = l, s = c;
            }
            var u = t1.length - 3;
            t1[2] = 1, G(t1, 0, u, o), t1[u + 2] = 1, t1.size = Math.abs(n), t1.start = 0, t1.end = t1.size;
        }
        function q(e1, t1, o, i) {
            for(var r = 0; r < e1.length; r++){
                var s = [];
                W(e1[r], s, o, i), t1.push(s);
            }
        }
        function $(e1) {
            return e1 / 360 + .5;
        }
        function U(e1) {
            var t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function K(e1, t1, o, i, r, s, n, a) {
            if (i /= t1, s >= (o /= t1) && n < i) return e1;
            if (n < o || s >= i) return null;
            for(var l = [], c = 0; c < e1.length; c++){
                var u = e1[c], h = u.geometry, d = u.type, p = 0 === r ? u.minX : u.minY, f = 0 === r ? u.maxX : u.maxY;
                if (p >= o && f < i) l.push(u);
                else if (!(f < o || p >= i)) {
                    var g = [];
                    if ("Point" === d || "MultiPoint" === d) H(h, g, o, i, r);
                    else if ("LineString" === d) Q(h, g, o, i, r, !1, a.lineMetrics);
                    else if ("MultiLineString" === d) te(h, g, o, i, r, !1);
                    else if ("Polygon" === d) te(h, g, o, i, r, !0);
                    else if ("MultiPolygon" === d) for(var m = 0; m < h.length; m++){
                        var y = [];
                        te(h[m], y, o, i, r, !0), y.length && g.push(y);
                    }
                    if (g.length) {
                        if (a.lineMetrics && "LineString" === d) {
                            for(m = 0; m < g.length; m++)l.push(Y(u.id, d, g[m], u.tags));
                            continue;
                        }
                        "LineString" !== d && "MultiLineString" !== d || (1 === g.length ? (d = "LineString", g = g[0]) : d = "MultiLineString"), "Point" !== d && "MultiPoint" !== d || (d = 3 === g.length ? "Point" : "MultiPoint"), l.push(Y(u.id, d, g, u.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function H(e1, t1, o, i, r) {
            for(var s = 0; s < e1.length; s += 3){
                var n = e1[s + r];
                n >= o && n <= i && (t1.push(e1[s]), t1.push(e1[s + 1]), t1.push(e1[s + 2]));
            }
        }
        function Q(e1, t1, o, i, r, s, n) {
            for(var a, l, c = ee(e1), u = 0 === r ? ie : re, h = e1.start, d = 0; d < e1.length - 3; d += 3){
                var p = e1[d], f = e1[d + 1], g = e1[d + 2], m = e1[d + 3], y = e1[d + 4], v = 0 === r ? p : f, x = 0 === r ? m : y, w = !1;
                n && (a = Math.sqrt(Math.pow(p - m, 2) + Math.pow(f - y, 2))), v < o ? x > o && (l = u(c, p, f, m, y, o), n && (c.start = h + a * l)) : v > i ? x < i && (l = u(c, p, f, m, y, i), n && (c.start = h + a * l)) : oe(c, p, f, g), x < o && v >= o && (l = u(c, p, f, m, y, o), w = !0), x > i && v <= i && (l = u(c, p, f, m, y, i), w = !0), !s && w && (n && (c.end = h + a * l), t1.push(c), c = ee(e1)), n && (h += a);
            }
            var S = e1.length - 3;
            p = e1[S], f = e1[S + 1], g = e1[S + 2], (v = 0 === r ? p : f) >= o && v <= i && oe(c, p, f, g), S = c.length - 3, s && S >= 3 && (c[S] !== c[0] || c[S + 1] !== c[1]) && oe(c, c[0], c[1], c[2]), c.length && t1.push(c);
        }
        function ee(e1) {
            var t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function te(e1, t1, o, i, r, s) {
            for(var n = 0; n < e1.length; n++)Q(e1[n], t1, o, i, r, s, !1);
        }
        function oe(e1, t1, o, i) {
            e1.push(t1), e1.push(o), e1.push(i);
        }
        function ie(e1, t1, o, i, r, s) {
            var n = (s - t1) / (i - t1);
            return e1.push(s), e1.push(o + (r - o) * n), e1.push(1), n;
        }
        function re(e1, t1, o, i, r, s) {
            var n = (s - o) / (r - o);
            return e1.push(t1 + (i - t1) * n), e1.push(s), e1.push(1), n;
        }
        function se(e1, t1) {
            for(var o = [], i = 0; i < e1.length; i++){
                var r, s = e1[i], n = s.type;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = ne(s.geometry, t1);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for(var a = 0; a < s.geometry.length; a++)r.push(ne(s.geometry[a], t1));
                } else if ("MultiPolygon" === n) for(r = [], a = 0; a < s.geometry.length; a++){
                    for(var l = [], c = 0; c < s.geometry[a].length; c++)l.push(ne(s.geometry[a][c], t1));
                    r.push(l);
                }
                o.push(Y(s.id, n, r, s.tags));
            }
            return o;
        }
        function ne(e1, t1) {
            var o = [];
            o.size = e1.size, void 0 !== e1.start && (o.start = e1.start, o.end = e1.end);
            for(var i = 0; i < e1.length; i += 3)o.push(e1[i] + t1, e1[i + 1], e1[i + 2]);
            return o;
        }
        function ae(e1, t1) {
            if (e1.transformed) return e1;
            var o, i, r, s = 1 << e1.z, n = e1.x, a = e1.y;
            for(o = 0; o < e1.features.length; o++){
                var l = e1.features[o], c = l.geometry, u = l.type;
                if (l.geometry = [], 1 === u) for(i = 0; i < c.length; i += 2)l.geometry.push(le(c[i], c[i + 1], t1, s, n, a));
                else for(i = 0; i < c.length; i++){
                    var h = [];
                    for(r = 0; r < c[i].length; r += 2)h.push(le(c[i][r], c[i][r + 1], t1, s, n, a));
                    l.geometry.push(h);
                }
            }
            return e1.transformed = !0, e1;
        }
        function le(e1, t1, o, i, r, s) {
            return [
                Math.round(o * (e1 * i - r)),
                Math.round(o * (t1 * i - s))
            ];
        }
        function ce(e1, t1, o, i, r) {
            for(var s = t1 === r.maxZoom ? 0 : r.tolerance / ((1 << t1) * r.extent), n = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: o,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, a = 0; a < e1.length; a++){
                n.numFeatures++, ue(n, e1[a], s, r);
                var l = e1[a].minX, c = e1[a].minY, u = e1[a].maxX, h = e1[a].maxY;
                l < n.minX && (n.minX = l), c < n.minY && (n.minY = c), u > n.maxX && (n.maxX = u), h > n.maxY && (n.maxY = h);
            }
            return n;
        }
        function ue(e1, t1, o, i) {
            var r = t1.geometry, s = t1.type, n = [];
            if ("Point" === s || "MultiPoint" === s) for(var a = 0; a < r.length; a += 3)n.push(r[a]), n.push(r[a + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === s) he(n, r, e1, o, !1, !1);
            else if ("MultiLineString" === s || "Polygon" === s) for(a = 0; a < r.length; a++)he(n, r[a], e1, o, "Polygon" === s, 0 === a);
            else if ("MultiPolygon" === s) for(var l = 0; l < r.length; l++){
                var c = r[l];
                for(a = 0; a < c.length; a++)he(n, c[a], e1, o, !0, 0 === a);
            }
            if (n.length) {
                var u = t1.tags || null;
                if ("LineString" === s && i.lineMetrics) {
                    for(var h in u = {}, t1.tags)u[h] = t1.tags[h];
                    u.mapbox_clip_start = r.start / r.size, u.mapbox_clip_end = r.end / r.size;
                }
                var d = {
                    geometry: n,
                    type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                    tags: u
                };
                null !== t1.id && (d.id = t1.id), e1.features.push(d);
            }
        }
        function he(e1, t1, o, i, r, s) {
            var n = i * i;
            if (i > 0 && t1.size < (r ? n : i)) o.numPoints += t1.length / 3;
            else {
                for(var a = [], l = 0; l < t1.length; l += 3)(0 === i || t1[l + 2] > n) && (o.numSimplified++, a.push(t1[l]), a.push(t1[l + 1])), o.numPoints++;
                r && function(e1, t1) {
                    for(var o = 0, i = 0, r = e1.length, s = r - 2; i < r; s = i, i += 2)o += (e1[i] - e1[s]) * (e1[i + 1] + e1[s + 1]);
                    if (o > 0 === t1) for(i = 0, r = e1.length; i < r / 2; i += 2){
                        var n = e1[i], a = e1[i + 1];
                        e1[i] = e1[r - 2 - i], e1[i + 1] = e1[r - 1 - i], e1[r - 2 - i] = n, e1[r - 1 - i] = a;
                    }
                }(a, s), e1.push(a);
            }
        }
        function de(e1, t1) {
            var o = (t1 = this.options = function(e1, t1) {
                for(var o in t1)e1[o] = t1[o];
                return e1;
            }(Object.create(this.options), t1)).debug;
            if (o && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var i = function(e1, t1) {
                var o = [];
                if ("FeatureCollection" === e1.type) for(var i = 0; i < e1.features.length; i++)V(o, e1.features[i], t1, i);
                else V(o, "Feature" === e1.type ? e1 : {
                    geometry: e1
                }, t1);
                return o;
            }(e1, t1);
            this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e1, t1) {
                var o = t1.buffer / t1.extent, i = e1, r = K(e1, 1, -1 - o, o, 0, -1, 2, t1), s = K(e1, 1, 1 - o, 2 + o, 0, -1, 2, t1);
                return (r || s) && (i = K(e1, 1, -o, 1 + o, 0, -1, 2, t1) || [], r && (i = se(r, 1).concat(i)), s && (i = i.concat(se(s, -1)))), i;
            }(i, t1), i.length && this.splitTile(i, 0, 0, 0), o && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function pe(e1, t1, o) {
            return 32 * ((1 << e1) * o + t1) + e1;
        }
        function fe(e1, t1) {
            return t1 ? e1.properties[t1] : e1.id;
        }
        function ge(e1, t1) {
            if (null == e1) return !0;
            if ("Feature" === e1.type) return null != fe(e1, t1);
            if ("FeatureCollection" === e1.type) {
                const o = new Set;
                for (const i of e1.features){
                    const e1 = fe(i, t1);
                    if (null == e1) return !1;
                    if (o.has(e1)) return !1;
                    o.add(e1);
                }
                return !0;
            }
            return !1;
        }
        function me(e1, t1) {
            const o = new Map;
            if (null == e1) ;
            else if ("Feature" === e1.type) o.set(fe(e1, t1), e1);
            else for (const i of e1.features)o.set(fe(i, t1), i);
            return o;
        }
        function ye(t1, o) {
            const i = t1.tileID.canonical;
            if (!this._geoJSONIndex) return o(null, null);
            const r = this._geoJSONIndex.getTile(i.z, i.x, i.y);
            if (!r) return o(null, null);
            const s = new class {
                constructor(t1){
                    this.layers = {
                        _geojsonTileLayer: this
                    }, this.name = "_geojsonTileLayer", this.extent = e1.EXTENT, this.length = t1.length, this._features = t1;
                }
                feature(t1) {
                    return new class {
                        constructor(t1){
                            this._feature = t1, this.extent = e1.EXTENT, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
                        }
                        loadGeometry() {
                            if (1 === this._feature.type) {
                                const t1 = [];
                                for (const o of this._feature.geometry)t1.push([
                                    new e1.Point(o[0], o[1])
                                ]);
                                return t1;
                            }
                            {
                                const t1 = [];
                                for (const o of this._feature.geometry){
                                    const i = [];
                                    for (const t1 of o)i.push(new e1.Point(t1[0], t1[1]));
                                    t1.push(i);
                                }
                                return t1;
                            }
                        }
                        toGeoJSON(e1, t1, o) {
                            return h.call(this, e1, t1, o);
                        }
                    }(this._features[t1]);
                }
            }(r.features);
            let n = C(s);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), o(null, {
                vectorTile: s,
                rawData: n.buffer
            });
        }
        de.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, de.prototype.splitTile = function(e1, t1, o, i, r, s, n) {
            for(var a = [
                e1,
                t1,
                o,
                i
            ], l = this.options, c = l.debug; a.length;){
                i = a.pop(), o = a.pop(), t1 = a.pop(), e1 = a.pop();
                var u = 1 << t1, h = pe(t1, o, i), d = this.tiles[h];
                if (!d && (c > 1 && console.time("creation"), d = this.tiles[h] = ce(e1, t1, o, i, l), this.tileCoords.push({
                    z: t1,
                    x: o,
                    y: i
                }), c)) {
                    c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, o, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                    var p = "z" + t1;
                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                }
                if (d.source = e1, r) {
                    if (t1 === l.maxZoom || t1 === r) continue;
                    var f = 1 << r - t1;
                    if (o !== Math.floor(s / f) || i !== Math.floor(n / f)) continue;
                } else if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                if (d.source = null, 0 !== e1.length) {
                    c > 1 && console.time("clipping");
                    var g, m, y, v, x, w, S = .5 * l.buffer / l.extent, b = .5 - S, I = .5 + S, M = 1 + S;
                    g = m = y = v = null, x = K(e1, u, o - S, o + I, 0, d.minX, d.maxX, l), w = K(e1, u, o + b, o + M, 0, d.minX, d.maxX, l), e1 = null, x && (g = K(x, u, i - S, i + I, 1, d.minY, d.maxY, l), m = K(x, u, i + b, i + M, 1, d.minY, d.maxY, l), x = null), w && (y = K(w, u, i - S, i + I, 1, d.minY, d.maxY, l), v = K(w, u, i + b, i + M, 1, d.minY, d.maxY, l), w = null), c > 1 && console.timeEnd("clipping"), a.push(g || [], t1 + 1, 2 * o, 2 * i), a.push(m || [], t1 + 1, 2 * o, 2 * i + 1), a.push(y || [], t1 + 1, 2 * o + 1, 2 * i), a.push(v || [], t1 + 1, 2 * o + 1, 2 * i + 1);
                }
            }
        }, de.prototype.getTile = function(e1, t1, o) {
            var i = this.options, r = i.extent, s = i.debug;
            if (e1 < 0 || e1 > 24) return null;
            var n = 1 << e1, a = pe(e1, t1 = (t1 % n + n) % n, o);
            if (this.tiles[a]) return ae(this.tiles[a], r);
            s > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, o);
            for(var l, c = e1, u = t1, h = o; !l && c > 0;)c--, u = Math.floor(u / 2), h = Math.floor(h / 2), l = this.tiles[pe(c, u, h)];
            return l && l.source ? (s > 1 && console.log("found parent tile z%d-%d-%d", c, u, h), s > 1 && console.time("drilling down"), this.splitTile(l.source, c, u, h, e1, t1, o), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ae(this.tiles[a], r) : null) : null;
        };
        class ve extends n {
            constructor(t1, o, i, r){
                super(t1, o, i, ye), this._dataUpdateable = new Map, this.loadGeoJSON = (t1, o)=>{
                    const { promoteId: i } = t1;
                    if (t1.request) return e1.getJSON(t1.request, (e1, t1, r, s)=>{
                        this._dataUpdateable = ge(t1, i) ? me(t1, i) : void 0, o(e1, t1, r, s);
                    });
                    if ("string" == typeof t1.data) try {
                        const e1 = JSON.parse(t1.data);
                        this._dataUpdateable = ge(e1, i) ? me(e1, i) : void 0, o(null, e1);
                    } catch (e1) {
                        o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    }
                    else t1.dataDiff ? this._dataUpdateable ? (function(e1, t1, o) {
                        var i, r, s, n;
                        if (t1.removeAll && e1.clear(), t1.remove) for (const o of t1.remove)e1.delete(o);
                        if (t1.add) for (const i of t1.add){
                            const t1 = fe(i, o);
                            null != t1 && e1.set(t1, i);
                        }
                        if (t1.update) for (const o of t1.update){
                            let t1 = e1.get(o.id);
                            if (null == t1) continue;
                            const a = !o.removeAllProperties && ((null === (i = o.removeProperties) || void 0 === i ? void 0 : i.length) > 0 || (null === (r = o.addOrUpdateProperties) || void 0 === r ? void 0 : r.length) > 0);
                            if ((o.newGeometry || o.removeAllProperties || a) && (t1 = {
                                ...t1
                            }, e1.set(o.id, t1), a && (t1.properties = {
                                ...t1.properties
                            })), o.newGeometry && (t1.geometry = o.newGeometry), o.removeAllProperties) t1.properties = {};
                            else if ((null === (s = o.removeProperties) || void 0 === s ? void 0 : s.length) > 0) for (const e1 of o.removeProperties)Object.prototype.hasOwnProperty.call(t1.properties, e1) && delete t1.properties[e1];
                            if ((null === (n = o.addOrUpdateProperties) || void 0 === n ? void 0 : n.length) > 0) for (const { key: e1, value: i } of o.addOrUpdateProperties)t1.properties[e1] = i;
                        }
                    }(this._dataUpdateable, t1.dataDiff, i), o(null, {
                        type: "FeatureCollection",
                        features: Array.from(this._dataUpdateable.values())
                    })) : o(new Error(`Cannot update existing geojson data in ${t1.source}`)) : o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    return {
                        cancel: ()=>{}
                    };
                }, r && (this.loadGeoJSON = r);
            }
            loadData(t1, o) {
                var i;
                null === (i = this._pendingRequest) || void 0 === i || i.cancel(), this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                });
                const r = !!(t1 && t1.request && t1.request.collectResourceTiming) && new e1.RequestPerformance(t1.request);
                this._pendingCallback = o, this._pendingRequest = this.loadGeoJSON(t1, (i, s)=>{
                    if (delete this._pendingCallback, delete this._pendingRequest, i || !s) return o(i);
                    if ("object" != typeof s) return o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    {
                        u(s, !0);
                        try {
                            if (t1.filter) {
                                const o = e1.createExpression(t1.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                const i = s.features.filter((e1)=>o.value.evaluate({
                                        zoom: 0
                                    }, e1));
                                s = {
                                    type: "FeatureCollection",
                                    features: i
                                };
                            }
                            this._geoJSONIndex = t1.cluster ? new z(function({ superclusterOptions: t1, clusterProperties: o }) {
                                if (!o || !t1) return t1;
                                const i = {}, r = {}, s = {
                                    accumulated: null,
                                    zoom: 0
                                }, n = {
                                    properties: null
                                }, a = Object.keys(o);
                                for (const t1 of a){
                                    const [s, n] = o[t1], a = e1.createExpression(n), l = e1.createExpression("string" == typeof s ? [
                                        s,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : s);
                                    i[t1] = a.value, r[t1] = l.value;
                                }
                                return t1.map = (e1)=>{
                                    n.properties = e1;
                                    const t1 = {};
                                    for (const e1 of a)t1[e1] = i[e1].evaluate(s, n);
                                    return t1;
                                }, t1.reduce = (e1, t1)=>{
                                    n.properties = t1;
                                    for (const t1 of a)s.accumulated = e1[t1], e1[t1] = r[t1].evaluate(s, n);
                                }, t1;
                            }(t1)).load(s.features) : function(e1, t1) {
                                return new de(e1, t1);
                            }(s, t1.geojsonVtOptions);
                        } catch (i) {
                            return o(i);
                        }
                        this.loaded = {};
                        const n = {};
                        if (r) {
                            const e1 = r.finish();
                            e1 && (n.resourceTiming = {}, n.resourceTiming[t1.source] = JSON.parse(JSON.stringify(e1)));
                        }
                        o(null, n);
                    }
                });
            }
            reloadTile(e1, t1) {
                const o = this.loaded;
                return o && o[e1.uid] ? super.reloadTile(e1, t1) : this.loadTile(e1, t1);
            }
            removeSource(e1, t1) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), t1();
            }
            getClusterExpansionZoom(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterChildren(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterLeaves(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }
        }
        class xe {
            constructor(t1){
                this.self = t1, this.actor = new e1.Actor(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                    vector: n,
                    geojson: ve
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e1, t1)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                    e1.plugin.applyArabicShaping = t1.applyArabicShaping, e1.plugin.processBidirectionalText = t1.processBidirectionalText, e1.plugin.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                };
            }
            setReferrer(e1, t1) {
                this.referrer = t1;
            }
            setImages(e1, t1, o) {
                this.availableImages[e1] = t1;
                for(const o in this.workerSources[e1]){
                    const i = this.workerSources[e1][o];
                    for(const e1 in i)i[e1].availableImages = t1;
                }
                o();
            }
            setLayers(e1, t1, o) {
                this.getLayerIndex(e1).replace(t1), o();
            }
            updateLayers(e1, t1, o) {
                this.getLayerIndex(e1).update(t1.layers, t1.removedIds), o();
            }
            loadTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).loadTile(t1, o);
            }
            loadDEMTile(e1, t1, o) {
                this.getDEMWorkerSource(e1, t1.source).loadTile(t1, o);
            }
            reloadTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).reloadTile(t1, o);
            }
            abortTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).abortTile(t1, o);
            }
            removeTile(e1, t1, o) {
                this.getWorkerSource(e1, t1.type, t1.source).removeTile(t1, o);
            }
            removeDEMTile(e1, t1) {
                this.getDEMWorkerSource(e1, t1.source).removeTile(t1);
            }
            removeSource(e1, t1, o) {
                if (!this.workerSources[e1] || !this.workerSources[e1][t1.type] || !this.workerSources[e1][t1.type][t1.source]) return;
                const i = this.workerSources[e1][t1.type][t1.source];
                delete this.workerSources[e1][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, o) : o();
            }
            loadWorkerSource(e1, t1, o) {
                try {
                    this.self.importScripts(t1.url), o();
                } catch (e1) {
                    o(e1.toString());
                }
            }
            syncRTLPluginState(t1, o, i) {
                try {
                    e1.plugin.setState(o);
                    const t1 = e1.plugin.getPluginURL();
                    if (e1.plugin.isLoaded() && !e1.plugin.isParsed() && null != t1) {
                        this.self.importScripts(t1);
                        const o = e1.plugin.isParsed();
                        i(o ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t1}`), o);
                    }
                } catch (e1) {
                    i(e1.toString());
                }
            }
            getAvailableImages(e1) {
                let t1 = this.availableImages[e1];
                return t1 || (t1 = []), t1;
            }
            getLayerIndex(e1) {
                let o = this.layerIndexes[e1];
                return o || (o = this.layerIndexes[e1] = new t1), o;
            }
            getWorkerSource(e1, t1, o) {
                if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t1] || (this.workerSources[e1][t1] = {}), !this.workerSources[e1][t1][o]) {
                    const i = {
                        send: (t1, o, i)=>{
                            this.actor.send(t1, o, i, e1);
                        }
                    };
                    this.workerSources[e1][t1][o] = new this.workerSourceTypes[t1](i, this.getLayerIndex(e1), this.getAvailableImages(e1));
                }
                return this.workerSources[e1][t1][o];
            }
            getDEMWorkerSource(e1, t1) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t1] || (this.demWorkerSources[e1][t1] = new a), this.demWorkerSources[e1][t1];
            }
        }
        return e1.isWorker() && (self.worker = new xe(self)), xe;
    });
    define([
        "./shared"
    ], function(t1) {
        "use strict";
        var e1 = "3.1.0";
        class i {
            static testProp(t1) {
                if (!i.docStyle) return t1[0];
                for(let e1 = 0; e1 < t1.length; e1++)if (t1[e1] in i.docStyle) return t1[e1];
                return t1[0];
            }
            static create(t1, e1, i) {
                const s = window.document.createElement(t1);
                return void 0 !== e1 && (s.className = e1), i && i.appendChild(s), s;
            }
            static createNS(t1, e1) {
                return window.document.createElementNS(t1, e1);
            }
            static disableDrag() {
                i.docStyle && i.selectProp && (i.userSelect = i.docStyle[i.selectProp], i.docStyle[i.selectProp] = "none");
            }
            static enableDrag() {
                i.docStyle && i.selectProp && (i.docStyle[i.selectProp] = i.userSelect);
            }
            static setTransform(t1, e1) {
                t1.style[i.transformProp] = e1;
            }
            static addEventListener(t1, e1, i, s = {}) {
                t1.addEventListener(e1, i, "passive" in s ? s : s.capture);
            }
            static removeEventListener(t1, e1, i, s = {}) {
                t1.removeEventListener(e1, i, "passive" in s ? s : s.capture);
            }
            static suppressClickInternal(t1) {
                t1.preventDefault(), t1.stopPropagation(), window.removeEventListener("click", i.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", i.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", i.suppressClickInternal, !0);
                }, 0);
            }
            static mousePos(e1, i) {
                const s = e1.getBoundingClientRect();
                return new t1.Point(i.clientX - s.left - e1.clientLeft, i.clientY - s.top - e1.clientTop);
            }
            static touchPos(e1, i) {
                const s = e1.getBoundingClientRect(), a = [];
                for(let o = 0; o < i.length; o++)a.push(new t1.Point(i[o].clientX - s.left - e1.clientLeft, i[o].clientY - s.top - e1.clientTop));
                return a;
            }
            static mouseButton(t1) {
                return t1.button;
            }
            static remove(t1) {
                t1.parentNode && t1.parentNode.removeChild(t1);
            }
        }
        i.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, i.selectProp = i.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), i.transformProp = i.testProp([
            "transform",
            "WebkitTransform"
        ]);
        const s = {
            supported: !1,
            testSupport: function(t1) {
                !r && o && (n ? l(t1) : a = t1);
            }
        };
        let a, o, r = !1, n = !1;
        function l(t1) {
            const e1 = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e1);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, o), t1.isContextLost()) return;
                s.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e1), r = !0;
        }
        var c;
        "undefined" != typeof document && (o = document.createElement("img"), o.onload = function() {
            a && l(a), a = null, n = !0;
        }, o.onerror = function() {
            r = !0, a = null;
        }, o.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e1) {
            let i, a, o, r;
            e1.resetRequestQueue = ()=>{
                i = [], a = 0, o = 0, r = {};
            }, e1.addThrottleControl = (t1)=>{
                const e1 = o++;
                return r[e1] = t1, e1;
            }, e1.removeThrottleControl = (t1)=>{
                delete r[t1], c();
            }, e1.getImage = (t1, e1, o = !0)=>{
                s.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*");
                const r = {
                    requestParameters: t1,
                    supportImageRefresh: o,
                    callback: e1,
                    cancelled: !1,
                    completed: !1,
                    cancel: ()=>{
                        r.completed || r.cancelled || (r.cancelled = !0, r.innerRequest && (r.innerRequest.cancel(), a--), c());
                    }
                };
                return i.push(r), c(), r;
            };
            const n = (e1)=>{
                const { requestParameters: i, supportImageRefresh: s, callback: a } = e1;
                return t1.extend(i, {
                    type: "image"
                }), (!1 !== s || t1.isWorker() || t1.getProtocolAction(i.url) || i.headers && !Object.keys(i.headers).reduce((t1, e1)=>t1 && "accept" === e1, !0) ? t1.makeRequest : h)(i, (t1, i, s, o)=>{
                    l(e1, a, t1, i, s, o);
                });
            }, l = (e1, i, s, o, r, n)=>{
                s ? i(s) : o instanceof HTMLImageElement || o instanceof ImageBitmap ? i(null, o) : o && ((e1, i)=>{
                    "function" == typeof createImageBitmap ? t1.arrayBufferToImageBitmap(e1, i) : t1.arrayBufferToImage(e1, i);
                })(o, (t1, e1)=>{
                    null != t1 ? i(t1) : null != e1 && i(null, e1, {
                        cacheControl: r,
                        expires: n
                    });
                }), e1.cancelled || (e1.completed = !0, a--, c());
            }, c = ()=>{
                const e1 = (()=>{
                    const t1 = Object.keys(r);
                    let e1 = !1;
                    if (t1.length > 0) {
                        for (const i of t1)if (e1 = r[i](), e1) break;
                    }
                    return e1;
                })() ? t1.config.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let t1 = a; t1 < e1 && i.length > 0; t1++){
                    const e1 = i.shift();
                    if (e1.cancelled) {
                        t1--;
                        continue;
                    }
                    const s = n(e1);
                    a++, e1.innerRequest = s;
                }
            }, h = (e1, i)=>{
                const s = new Image, a = e1.url;
                let o = !1;
                const r = e1.credentials;
                return r && "include" === r ? s.crossOrigin = "use-credentials" : (r && "same-origin" === r || !t1.sameOrigin(a)) && (s.crossOrigin = "anonymous"), s.fetchPriority = "high", s.onload = ()=>{
                    i(null, s), s.onerror = s.onload = null;
                }, s.onerror = ()=>{
                    o || i(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")), s.onerror = s.onload = null;
                }, s.src = a, {
                    cancel: ()=>{
                        o = !0, s.src = "";
                    }
                };
            };
        }(c || (c = {})), c.resetRequestQueue();
        var h, u = c;
        !function(t1) {
            t1.Glyphs = "Glyphs", t1.Image = "Image", t1.Source = "Source", t1.SpriteImage = "SpriteImage", t1.SpriteJSON = "SpriteJSON", t1.Style = "Style", t1.Tile = "Tile", t1.Unknown = "Unknown";
        }(h || (h = {}));
        class d {
            constructor(t1){
                this._transformRequestFn = t1;
            }
            transformRequest(t1, e1) {
                return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                    url: t1
                };
            }
            normalizeSpriteURL(t1, e1, i) {
                const s = function(t1) {
                    const e1 = t1.match(_);
                    if (!e1) throw new Error(`Unable to parse URL "${t1}"`);
                    return {
                        protocol: e1[1],
                        authority: e1[2],
                        path: e1[3] || "/",
                        params: e1[4] ? e1[4].split("&") : []
                    };
                }(t1);
                return s.path += `${e1}${i}`, function(t1) {
                    const e1 = t1.params.length ? `?${t1.params.join("&")}` : "";
                    return `${t1.protocol}://${t1.authority}${t1.path}${e1}`;
                }(s);
            }
            setTransformRequest(t1) {
                this._transformRequestFn = t1;
            }
        }
        const _ = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function m(e1) {
            var i = new t1.ARRAY_TYPE(3);
            return i[0] = e1[0], i[1] = e1[1], i[2] = e1[2], i;
        }
        var p, f = function(t1, e1, i) {
            return t1[0] = e1[0] - i[0], t1[1] = e1[1] - i[1], t1[2] = e1[2] - i[2], t1;
        };
        p = new t1.ARRAY_TYPE(3), t1.ARRAY_TYPE != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0);
        var g = function(t1) {
            var e1 = t1[0], i = t1[1];
            return e1 * e1 + i * i;
        };
        function v(t1) {
            const e1 = [];
            if ("string" == typeof t1) e1.push({
                id: "default",
                url: t1
            });
            else if (t1 && t1.length > 0) {
                const i = [];
                for (const { id: s, url: a } of t1){
                    const t1 = `${s}${a}`;
                    -1 === i.indexOf(t1) && (i.push(t1), e1.push({
                        id: s,
                        url: a
                    }));
                }
            }
            return e1;
        }
        function x(e1, i, s, a, o) {
            if (a) return void e1(a);
            if (o !== Object.values(i).length || o !== Object.values(s).length) return;
            const r = {};
            for(const e1 in i){
                r[e1] = {};
                const a = t1.exported.getImageCanvasContext(s[e1]), o = i[e1];
                for(const t1 in o){
                    const { width: i, height: s, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: _ } = o[t1];
                    r[e1][t1] = {
                        data: null,
                        pixelRatio: h,
                        sdf: c,
                        stretchX: u,
                        stretchY: d,
                        content: _,
                        spriteData: {
                            width: i,
                            height: s,
                            x: n,
                            y: l,
                            context: a
                        }
                    };
                }
            }
            e1(null, r);
        }
        !function() {
            var e1 = new t1.ARRAY_TYPE(2);
            t1.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0);
        }();
        class y {
            constructor(t1, e1, i, s){
                this.context = t1, this.format = i, this.texture = t1.gl.createTexture(), this.update(e1, s);
            }
            update(e1, i, s) {
                const { width: a, height: o } = e1, r = !(this.size && this.size[0] === a && this.size[1] === o || s), { context: n } = this, { gl: l } = n;
                if (this.useMipmap = Boolean(i && i.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), n.pixelStoreUnpackFlipY.set(!1), n.pixelStoreUnpack.set(1), n.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!i || !1 !== i.premultiply)), r) this.size = [
                    a,
                    o
                ], e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || t1.isImageBitmap(e1) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, e1) : l.texImage2D(l.TEXTURE_2D, 0, this.format, a, o, 0, this.format, l.UNSIGNED_BYTE, e1.data);
                else {
                    const { x: i, y: r } = s || {
                        x: 0,
                        y: 0
                    };
                    e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || t1.isImageBitmap(e1) ? l.texSubImage2D(l.TEXTURE_2D, 0, i, r, l.RGBA, l.UNSIGNED_BYTE, e1) : l.texSubImage2D(l.TEXTURE_2D, 0, i, r, a, o, l.RGBA, l.UNSIGNED_BYTE, e1.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D);
            }
            bind(t1, e1, i) {
                const { context: s } = this, { gl: a } = s;
                a.bindTexture(a.TEXTURE_2D, this.texture), i !== a.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = a.LINEAR), t1 !== this.filter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t1), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, i || t1), this.filter = t1), e1 !== this.wrap && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, e1), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, e1), this.wrap = e1);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
        }
        function b(t1) {
            const { userImage: e1 } = t1;
            return !!(e1 && e1.render && e1.render()) && (t1.data.replace(new Uint8Array(e1.data.buffer)), !0);
        }
        class w extends t1.Evented {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t1.RGBAImage({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(t1) {
                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                    for (const { ids: t1, callback: e1 } of this.requestors)this._notify(t1, e1);
                    this.requestors = [];
                }
            }
            getImage(e1) {
                const i = this.images[e1];
                if (i && !i.data && i.spriteData) {
                    const e1 = i.spriteData;
                    i.data = new t1.RGBAImage({
                        width: e1.width,
                        height: e1.height
                    }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(t1, e1) {
                if (this.images[t1]) throw new Error(`Image id ${t1} already exist, use updateImage instead`);
                this._validate(t1, e1) && (this.images[t1] = e1);
            }
            _validate(e1, i) {
                let s = !0;
                const a = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, a && a.width) || (this.fire(new t1.ErrorEvent(new Error(`Image "${e1}" has invalid "stretchX" value`))), s = !1), this._validateStretch(i.stretchY, a && a.height) || (this.fire(new t1.ErrorEvent(new Error(`Image "${e1}" has invalid "stretchY" value`))), s = !1), this._validateContent(i.content, i) || (this.fire(new t1.ErrorEvent(new Error(`Image "${e1}" has invalid "content" value`))), s = !1), s;
            }
            _validateStretch(t1, e1) {
                if (!t1) return !0;
                let i = 0;
                for (const s of t1){
                    if (s[0] < i || s[1] < s[0] || e1 < s[1]) return !1;
                    i = s[1];
                }
                return !0;
            }
            _validateContent(t1, e1) {
                if (!t1) return !0;
                if (4 !== t1.length) return !1;
                const i = e1.spriteData, s = i && i.width || e1.data.width, a = i && i.height || e1.data.height;
                return !(t1[0] < 0 || s < t1[0] || t1[1] < 0 || a < t1[1] || t1[2] < 0 || s < t1[2] || t1[3] < 0 || a < t1[3] || t1[2] < t1[0] || t1[3] < t1[1]);
            }
            updateImage(t1, e1, i = !0) {
                const s = this.getImage(t1);
                if (i && (s.data.width !== e1.data.width || s.data.height !== e1.data.height)) throw new Error(`size mismatch between old image (${s.data.width}x${s.data.height}) and new image (${e1.data.width}x${e1.data.height}).`);
                e1.version = s.version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
            }
            removeImage(t1) {
                const e1 = this.images[t1];
                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(t1, e1) {
                let i = !0;
                if (!this.isLoaded()) for (const e1 of t1)this.images[e1] || (i = !1);
                this.isLoaded() || i ? this._notify(t1, e1) : this.requestors.push({
                    ids: t1,
                    callback: e1
                });
            }
            _notify(e1, i) {
                const s = {};
                for (const i of e1){
                    let e1 = this.getImage(i);
                    e1 || (this.fire(new t1.Event("styleimagemissing", {
                        id: i
                    })), e1 = this.getImage(i)), e1 ? s[i] = {
                        data: e1.data.clone(),
                        pixelRatio: e1.pixelRatio,
                        sdf: e1.sdf,
                        version: e1.version,
                        stretchX: e1.stretchX,
                        stretchY: e1.stretchY,
                        content: e1.content,
                        hasRenderCallback: Boolean(e1.userImage && e1.userImage.render)
                    } : t1.warnOnce(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, s);
            }
            getPixelSize() {
                const { width: t1, height: e1 } = this.atlasImage;
                return {
                    width: t1,
                    height: e1
                };
            }
            getPattern(e1) {
                const i = this.patterns[e1], s = this.getImage(e1);
                if (!s) return null;
                if (i && i.position.version === s.version) return i.position;
                if (i) i.position.version = s.version;
                else {
                    const i = {
                        w: s.data.width + 2,
                        h: s.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t1.ImagePosition(i, s);
                    this.patterns[e1] = {
                        bin: i,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e1].position;
            }
            bind(t1) {
                const e1 = t1.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new y(t1, this.atlasImage, e1.RGBA), this.atlasTexture.bind(e1.LINEAR, e1.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e1 = [];
                for(const t1 in this.patterns)e1.push(this.patterns[t1].bin);
                const { w: i, h: s } = t1.potpack(e1), a = this.atlasImage;
                a.resize({
                    width: i || 1,
                    height: s || 1
                });
                for(const e1 in this.patterns){
                    const { bin: i } = this.patterns[e1], s = i.x + 1, o = i.y + 1, r = this.getImage(e1).data, n = r.width, l = r.height;
                    t1.RGBAImage.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o
                    }, {
                        width: n,
                        height: l
                    }), t1.RGBAImage.copy(r, a, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: s,
                        y: o - 1
                    }, {
                        width: n,
                        height: 1
                    }), t1.RGBAImage.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o + l
                    }, {
                        width: n,
                        height: 1
                    }), t1.RGBAImage.copy(r, a, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), t1.RGBAImage.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + n,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e1) {
                for (const i of e1){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e1 = this.getImage(i);
                    e1 || t1.warnOnce(`Image with ID: "${i}" was not found`), b(e1) && this.updateImage(i, e1);
                }
            }
        }
        const T = 1e20;
        function E(t1, e1, i, s, a, o, r, n, l) {
            for(let c = e1; c < e1 + s; c++)I(t1, i * o + c, o, a, r, n, l);
            for(let c = i; c < i + a; c++)I(t1, c * o + e1, 1, s, r, n, l);
        }
        function I(t1, e1, i, s, a, o, r) {
            o[0] = 0, r[0] = -T, r[1] = T, a[0] = t1[e1];
            for(let n = 1, l = 0, c = 0; n < s; n++){
                a[n] = t1[e1 + n * i];
                const s = n * n;
                do {
                    const t1 = o[l];
                    c = (a[n] - a[t1] + s - t1 * t1) / (n - t1) / 2;
                }while (c <= r[l] && --l > -1);
                l++, o[l] = n, r[l] = c, r[l + 1] = T;
            }
            for(let n = 0, l = 0; n < s; n++){
                for(; r[l + 1] < n;)l++;
                const s = o[l], c = n - s;
                t1[e1 + n * i] = a[s] + c * c;
            }
        }
        class S {
            constructor(t1, e1){
                this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
            }
            setURL(t1) {
                this.url = t1;
            }
            getGlyphs(e1, i) {
                const s = [];
                for(const t1 in e1)for (const i of e1[t1])s.push({
                    stack: t1,
                    id: i
                });
                t1.asyncAll(s, ({ stack: t1, id: e1 }, i)=>{
                    let s = this.entries[t1];
                    s || (s = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let a = s.glyphs[e1];
                    if (void 0 !== a) return void i(null, {
                        stack: t1,
                        id: e1,
                        glyph: a
                    });
                    if (a = this._tinySDF(s, t1, e1), a) return s.glyphs[e1] = a, void i(null, {
                        stack: t1,
                        id: e1,
                        glyph: a
                    });
                    const o = Math.floor(e1 / 256);
                    if (256 * o > 65535) return void i(new Error("glyphs > 65535 not supported"));
                    if (s.ranges[o]) return void i(null, {
                        stack: t1,
                        id: e1,
                        glyph: a
                    });
                    if (!this.url) return void i(new Error("glyphsUrl is not set"));
                    let r = s.requests[o];
                    r || (r = s.requests[o] = [], S.loadGlyphRange(t1, o, this.url, this.requestManager, (t1, e1)=>{
                        if (e1) {
                            for(const t1 in e1)this._doesCharSupportLocalGlyph(+t1) || (s.glyphs[+t1] = e1[+t1]);
                            s.ranges[o] = !0;
                        }
                        for (const i of r)i(t1, e1);
                        delete s.requests[o];
                    })), r.push((s, a)=>{
                        s ? i(s) : a && i(null, {
                            stack: t1,
                            id: e1,
                            glyph: a[e1] || null
                        });
                    });
                }, (t1, e1)=>{
                    if (t1) i(t1);
                    else if (e1) {
                        const t1 = {};
                        for (const { stack: i, id: s, glyph: a } of e1)(t1[i] || (t1[i] = {}))[s] = a && {
                            id: a.id,
                            bitmap: a.bitmap.clone(),
                            metrics: a.metrics
                        };
                        i(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e1) {
                return !!this.localIdeographFontFamily && (t1.unicodeBlockLookup["CJK Unified Ideographs"](e1) || t1.unicodeBlockLookup["Hangul Syllables"](e1) || t1.unicodeBlockLookup.Hiragana(e1) || t1.unicodeBlockLookup.Katakana(e1));
            }
            _tinySDF(e1, i, s) {
                const a = this.localIdeographFontFamily;
                if (!a) return;
                if (!this._doesCharSupportLocalGlyph(s)) return;
                let o = e1.tinySDF;
                if (!o) {
                    let t1 = "400";
                    /bold/i.test(i) ? t1 = "900" : /medium/i.test(i) ? t1 = "500" : /light/i.test(i) && (t1 = "200"), o = e1.tinySDF = new S.TinySDF({
                        fontSize: 24,
                        buffer: 3,
                        radius: 8,
                        cutoff: .25,
                        fontFamily: a,
                        fontWeight: t1
                    });
                }
                const r = o.draw(String.fromCharCode(s));
                return {
                    id: s,
                    bitmap: new t1.AlphaImage({
                        width: r.width || 30,
                        height: r.height || 30
                    }, r.data),
                    metrics: {
                        width: r.glyphWidth || 24,
                        height: r.glyphHeight || 24,
                        left: r.glyphLeft || 0,
                        top: r.glyphTop - 27 || -8,
                        advance: r.glyphAdvance || 24
                    }
                };
            }
        }
        S.loadGlyphRange = function(e1, i, s, a, o) {
            const r = 256 * i, n = r + 255, l = a.transformRequest(s.replace("{fontstack}", e1).replace("{range}", `${r}-${n}`), h.Glyphs);
            t1.getArrayBuffer(l, (e1, i)=>{
                if (e1) o(e1);
                else if (i) {
                    const e1 = {};
                    for (const s of t1.parseGlyphPbf(i))e1[s.id] = s;
                    o(null, e1);
                }
            });
        }, S.TinySDF = class {
            constructor({ fontSize: t1 = 24, buffer: e1 = 3, radius: i = 8, cutoff: s = .25, fontFamily: a = "sans-serif", fontWeight: o = "normal", fontStyle: r = "normal" } = {}){
                this.buffer = e1, this.cutoff = s, this.radius = i;
                const n = this.size = t1 + 4 * e1, l = this._createCanvas(n), c = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${r} ${o} ${t1}px ${a}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Uint16Array(n);
            }
            _createCanvas(t1) {
                const e1 = document.createElement("canvas");
                return e1.width = e1.height = t1, e1;
            }
            draw(t1) {
                const { width: e1, actualBoundingBoxAscent: i, actualBoundingBoxDescent: s, actualBoundingBoxLeft: a, actualBoundingBoxRight: o } = this.ctx.measureText(t1), r = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - a))), l = Math.min(this.size - this.buffer, r + Math.ceil(s)), c = n + 2 * this.buffer, h = l + 2 * this.buffer, u = Math.max(c * h, 0), d = new Uint8ClampedArray(u), _ = {
                    data: d,
                    width: c,
                    height: h,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: r,
                    glyphLeft: 0,
                    glyphAdvance: e1
                };
                if (0 === n || 0 === l) return _;
                const { ctx: m, buffer: p, gridInner: f, gridOuter: g } = this;
                m.clearRect(p, p, n, l), m.fillText(t1, p, p + r);
                const v = m.getImageData(p, p, n, l);
                g.fill(T, 0, u), f.fill(0, 0, u);
                for(let t1 = 0; t1 < l; t1++)for(let e1 = 0; e1 < n; e1++){
                    const i = v.data[4 * (t1 * n + e1) + 3] / 255;
                    if (0 === i) continue;
                    const s = (t1 + p) * c + e1 + p;
                    if (1 === i) g[s] = 0, f[s] = T;
                    else {
                        const t1 = .5 - i;
                        g[s] = t1 > 0 ? t1 * t1 : 0, f[s] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                E(g, 0, 0, c, h, c, this.f, this.v, this.z), E(f, p, p, n, l, c, this.f, this.v, this.z);
                for(let t1 = 0; t1 < u; t1++){
                    const e1 = Math.sqrt(g[t1]) - Math.sqrt(f[t1]);
                    d[t1] = Math.round(255 - 255 * (e1 / this.radius + this.cutoff));
                }
                return _;
            }
        };
        class C {
            constructor(){
                this.specification = t1.v8Spec.light.position;
            }
            possiblyEvaluate(e1, i) {
                return t1.sphericalToCartesian(e1.expression.evaluate(i));
            }
            interpolate(e1, i, s) {
                return {
                    x: t1.interpolate.number(e1.x, i.x, s),
                    y: t1.interpolate.number(e1.y, i.y, s),
                    z: t1.interpolate.number(e1.z, i.z, s)
                };
            }
        }
        let P, D;
        class z extends t1.Evented {
            constructor(e1){
                super(), P = P || new t1.Properties({
                    anchor: new t1.DataConstantProperty(t1.v8Spec.light.anchor),
                    position: new C,
                    color: new t1.DataConstantProperty(t1.v8Spec.light.color),
                    intensity: new t1.DataConstantProperty(t1.v8Spec.light.intensity)
                }), this._transitionable = new t1.Transitionable(P), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, i = {}) {
                if (!this._validate(t1.validateLight, e1, i)) for(const t1 in e1){
                    const i = e1[t1];
                    t1.endsWith("-transition") ? this._transitionable.setTransition(t1.slice(0, -11), i) : this._transitionable.setValue(t1, i);
                }
            }
            updateTransitions(t1) {
                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(t1) {
                this.properties = this._transitioning.possiblyEvaluate(t1);
            }
            _validate(e1, i, s) {
                return (!s || !1 !== s.validate) && t1.emitValidationErrors(this, e1.call(t1.validateStyle, t1.extend({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t1.v8Spec
                })));
            }
        }
        class M {
            constructor(t1, e1){
                this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(t1, e1) {
                const i = t1.join(",") + String(e1);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t1, e1)), this.dashEntry[i];
            }
            getDashRanges(t1, e1, i) {
                const s = [];
                let a = t1.length % 2 == 1 ? -t1[t1.length - 1] * i : 0, o = t1[0] * i, r = !0;
                s.push({
                    left: a,
                    right: o,
                    isDash: r,
                    zeroLength: 0 === t1[0]
                });
                let n = t1[0];
                for(let e1 = 1; e1 < t1.length; e1++){
                    r = !r;
                    const l = t1[e1];
                    a = n * i, n += l, o = n * i, s.push({
                        left: a,
                        right: o,
                        isDash: r,
                        zeroLength: 0 === l
                    });
                }
                return s;
            }
            addRoundDash(t1, e1, i) {
                const s = e1 / 2;
                for(let e1 = -i; e1 <= i; e1++){
                    const a = this.width * (this.nextRow + i + e1);
                    let o = 0, r = t1[o];
                    for(let n = 0; n < this.width; n++){
                        n / r.right > 1 && (r = t1[++o]);
                        const l = Math.abs(n - r.left), c = Math.abs(n - r.right), h = Math.min(l, c);
                        let u;
                        const d = e1 / i * (s + 1);
                        if (r.isDash) {
                            const t1 = s - Math.abs(d);
                            u = Math.sqrt(h * h + t1 * t1);
                        } else u = s - Math.sqrt(h * h + d * d);
                        this.data[a + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(t1) {
                for(let e1 = t1.length - 1; e1 >= 0; --e1){
                    const i = t1[e1], s = t1[e1 + 1];
                    i.zeroLength ? t1.splice(e1, 1) : s && s.isDash === i.isDash && (s.left = i.left, t1.splice(e1, 1));
                }
                const e1 = t1[0], i = t1[t1.length - 1];
                e1.isDash === i.isDash && (e1.left = i.left - this.width, i.right = e1.right + this.width);
                const s = this.width * this.nextRow;
                let a = 0, o = t1[a];
                for(let e1 = 0; e1 < this.width; e1++){
                    e1 / o.right > 1 && (o = t1[++a]);
                    const i = Math.abs(e1 - o.left), r = Math.abs(e1 - o.right), n = Math.min(i, r);
                    this.data[s + e1] = Math.max(0, Math.min(255, (o.isDash ? n : -n) + 128));
                }
            }
            addDash(e1, i) {
                const s = i ? 7 : 0, a = 2 * s + 1;
                if (this.nextRow + a > this.height) return t1.warnOnce("LineAtlas out of space"), null;
                let o = 0;
                for(let t1 = 0; t1 < e1.length; t1++)o += e1[t1];
                if (0 !== o) {
                    const t1 = this.width / o, a = this.getDashRanges(e1, this.width, t1);
                    i ? this.addRoundDash(a, t1, s) : this.addRegularDash(a);
                }
                const r = {
                    y: (this.nextRow + s + .5) / this.height,
                    height: 2 * s / this.height,
                    width: o
                };
                return this.nextRow += a, this.dirty = !0, r;
            }
            bind(t1) {
                const e1 = t1.gl;
                this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
            }
        }
        class A {
            constructor(t1, e1, i){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = i;
                const s = this.workerPool.acquire(i);
                for(let t1 = 0; t1 < s.length; t1++){
                    const a = new A.Actor(s[t1], e1, i);
                    a.name = `Worker ${t1}`, this.actors.push(a);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(e1, i, s) {
                t1.asyncAll(this.actors, (t1, s)=>{
                    t1.send(e1, i, s);
                }, s = s || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(t1 = !0) {
                this.actors.forEach((t1)=>{
                    t1.remove();
                }), this.actors = [], t1 && this.workerPool.release(this.id);
            }
        }
        function L(e1, i, s) {
            const a = function(i, a) {
                if (i) return s(i);
                if (a) {
                    const i = t1.pick(t1.extend(a, e1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    a.vector_layers && (i.vectorLayers = a.vector_layers, i.vectorLayerIds = i.vectorLayers.map((t1)=>t1.id)), s(null, i);
                }
            };
            return e1.url ? t1.getJSON(i.transformRequest(e1.url, h.Source), a) : t1.exported.frame(()=>a(null, e1));
        }
        A.Actor = t1.Actor;
        class R {
            constructor(t1, e1){
                t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : Array.isArray(t1) && (4 === t1.length ? this.setSouthWest([
                    t1[0],
                    t1[1]
                ]).setNorthEast([
                    t1[2],
                    t1[3]
                ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1])));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof t1.LngLat ? new t1.LngLat(e1.lng, e1.lat) : t1.LngLat.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof t1.LngLat ? new t1.LngLat(e1.lng, e1.lat) : t1.LngLat.convert(e1), this;
            }
            extend(e1) {
                const i = this._sw, s = this._ne;
                let a, o;
                if (e1 instanceof t1.LngLat) a = e1, o = e1;
                else {
                    if (!(e1 instanceof R)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(R.convert(e1)) : this.extend(t1.LngLat.convert(e1)) : e1 && ("lng" in e1 || "lon" in e1) && "lat" in e1 ? this.extend(t1.LngLat.convert(e1)) : this;
                    if (a = e1._sw, o = e1._ne, !a || !o) return this;
                }
                return i || s ? (i.lng = Math.min(a.lng, i.lng), i.lat = Math.min(a.lat, i.lat), s.lng = Math.max(o.lng, s.lng), s.lat = Math.max(o.lat, s.lat)) : (this._sw = new t1.LngLat(a.lng, a.lat), this._ne = new t1.LngLat(o.lng, o.lat)), this;
            }
            getCenter() {
                return new t1.LngLat((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new t1.LngLat(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new t1.LngLat(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: i, lat: s } = t1.LngLat.convert(e1);
                let a = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (a = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= s && s <= this._ne.lat && a;
            }
            static convert(t1) {
                return t1 instanceof R ? t1 : t1 ? new R(t1) : t1;
            }
            static fromLngLat(e1, i = 0) {
                const s = 360 * i / 40075017, a = s / Math.cos(Math.PI / 180 * e1.lat);
                return new R(new t1.LngLat(e1.lng - a, e1.lat - s), new t1.LngLat(e1.lng + a, e1.lat + s));
            }
        }
        class k {
            constructor(t1, e1, i){
                this.bounds = R.convert(this.validateBounds(t1)), this.minzoom = e1 || 0, this.maxzoom = i || 24;
            }
            validateBounds(t1) {
                return Array.isArray(t1) && 4 === t1.length ? [
                    Math.max(-180, t1[0]),
                    Math.max(-90, t1[1]),
                    Math.min(180, t1[2]),
                    Math.min(90, t1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                const i = Math.pow(2, e1.z), s = Math.floor(t1.mercatorXfromLng(this.bounds.getWest()) * i), a = Math.floor(t1.mercatorYfromLat(this.bounds.getNorth()) * i), o = Math.ceil(t1.mercatorXfromLng(this.bounds.getEast()) * i), r = Math.ceil(t1.mercatorYfromLat(this.bounds.getSouth()) * i);
                return e1.x >= s && e1.x < o && e1.y >= a && e1.y < r;
            }
        }
        class B extends t1.Evented {
            constructor(e1, i, s, a){
                if (super(), this.id = e1, this.dispatcher = s, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t1.extend(this, t1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t1.extend({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
            load() {
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = L(this._options, this.map._requestManager, (e1, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), e1 ? this.fire(new t1.ErrorEvent(e1)) : i && (t1.extend(this, i), i.bounds && (this.tileBounds = new k(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            setSourceProperty(t1) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t1(), this.load();
            }
            setTiles(t1) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t1;
                }), this;
            }
            setUrl(t1) {
                return this.setSourceProperty(()=>{
                    this.url = t1, this._options.url = t1;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            serialize() {
                return t1.extend({}, this._options);
            }
            loadTile(t1, e1) {
                const i = t1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), s = {
                    request: this.map._requestManager.transformRequest(i, h.Tile),
                    uid: t1.uid,
                    tileID: t1.tileID,
                    zoom: t1.tileID.overscaledZ,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                function a(i, s) {
                    return delete t1.request, t1.aborted ? e1(null) : i && 404 !== i.status ? e1(i) : (s && s.resourceTiming && (t1.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t1.setExpiryData(s), t1.loadVectorData(s, this.map.painter), e1(null), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
                s.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state ? "loading" === t1.state ? t1.reloadCallback = e1 : t1.request = t1.actor.send("reloadTile", s, a.bind(this)) : (t1.actor = this.dispatcher.getActor(), t1.request = t1.actor.send("loadTile", s, a.bind(this)));
            }
            abortTile(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.actor && t1.actor.send("abortTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            unloadTile(t1) {
                t1.unloadVectorData(), t1.actor && t1.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            hasTransition() {
                return !1;
            }
        }
        class F extends t1.Evented {
            constructor(e1, i, s, a){
                super(), this.id = e1, this.dispatcher = s, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t1.extend({
                    type: "raster"
                }, i), t1.extend(this, t1.pick(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = L(this._options, this.map._requestManager, (e1, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, e1 ? this.fire(new t1.ErrorEvent(e1)) : i && (t1.extend(this, i), i.bounds && (this.tileBounds = new k(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new t1.Event("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            serialize() {
                return t1.extend({}, this._options);
            }
            hasTile(t1) {
                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
            }
            loadTile(t1, e1) {
                const i = t1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                t1.request = u.getImage(this.map._requestManager.transformRequest(i, h.Tile), (i, s, a)=>{
                    if (delete t1.request, t1.aborted) t1.state = "unloaded", e1(null);
                    else if (i) t1.state = "errored", e1(i);
                    else if (s) {
                        this.map._refreshExpiredTiles && a && t1.setExpiryData(a);
                        const i = this.map.painter.context, o = i.gl;
                        t1.texture = this.map.painter.getTileTexture(s.width), t1.texture ? t1.texture.update(s, {
                            useMipmap: !0
                        }) : (t1.texture = new y(i, s, o.RGBA, {
                            useMipmap: !0
                        }), t1.texture.bind(o.LINEAR, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), i.extTextureFilterAnisotropic && o.texParameterf(o.TEXTURE_2D, i.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, i.extTextureFilterAnisotropicMax)), t1.state = "loaded", e1(null);
                    }
                }, this.map._refreshExpiredTiles);
            }
            abortTile(t1, e1) {
                t1.request && (t1.request.cancel(), delete t1.request), e1();
            }
            unloadTile(t1, e1) {
                t1.texture && this.map.painter.saveTileTexture(t1.texture), e1();
            }
            hasTransition() {
                return !1;
            }
        }
        class U extends F {
            constructor(e1, i, s, a){
                super(e1, i, s, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t1.extend({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox";
            }
            serialize() {
                return {
                    type: "raster-dem",
                    url: this.url,
                    tileSize: this.tileSize,
                    tiles: this.tiles,
                    bounds: this.bounds,
                    encoding: this.encoding
                };
            }
            loadTile(e1, i) {
                const s = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                function a(t1, s) {
                    t1 && (e1.state = "errored", i(t1)), s && (e1.dem = s, e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.state = "loaded", i(null));
                }
                e1.request = u.getImage(this.map._requestManager.transformRequest(s, h.Tile), (function(s, o) {
                    if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                    else if (s) e1.state = "errored", i(s);
                    else if (o) {
                        this.map._refreshExpiredTiles && e1.setExpiryData(o), delete o.cacheControl, delete o.expires;
                        const i = t1.isImageBitmap(o) && (null == D && (D = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), D) ? o : t1.exported.getImageData(o, 1), s = {
                            uid: e1.uid,
                            coord: e1.tileID,
                            source: this.id,
                            rawImageData: i,
                            encoding: this.encoding
                        };
                        e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", s, a.bind(this)));
                    }
                }).bind(this), this.map._refreshExpiredTiles), e1.neighboringTiles = this._getNeighboringTiles(e1.tileID);
            }
            _getNeighboringTiles(e1) {
                const i = e1.canonical, s = Math.pow(2, i.z), a = (i.x - 1 + s) % s, o = 0 === i.x ? e1.wrap - 1 : e1.wrap, r = (i.x + 1 + s) % s, n = i.x + 1 === s ? e1.wrap + 1 : e1.wrap, l = {};
                return l[new t1.OverscaledTileID(e1.overscaledZ, o, i.z, a, i.y).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, n, i.z, r, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t1.OverscaledTileID(e1.overscaledZ, o, i.z, a, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, n, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < s && (l[new t1.OverscaledTileID(e1.overscaledZ, o, i.z, a, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t1.OverscaledTileID(e1.overscaledZ, n, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(t1) {
                t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && t1.actor.send("removeDEMTile", {
                    uid: t1.uid,
                    source: this.id
                });
            }
        }
        class O extends t1.Evented {
            constructor(e1, i, s, a){
                super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = s.getActor(), this.setEventedParent(a), this._data = i.data, this._options = t1.extend({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                const o = t1.EXTENT / this.tileSize;
                this.workerOptions = t1.extend({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== i.buffer ? i.buffer : 128) * o,
                        tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * o,
                        extent: t1.EXTENT,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t1.EXTENT,
                        radius: (i.clusterRadius || 50) * o,
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
            }
            load() {
                this._updateWorkerData();
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            setData(t1) {
                return this._data = t1, this._updateWorkerData(), this;
            }
            updateData(t1) {
                return this._updateWorkerData(t1), this;
            }
            setClusterOptions(t1) {
                return this.workerOptions.cluster = t1.cluster, t1 && (void 0 !== t1.clusterRadius && (this.workerOptions.superclusterOptions.radius = t1.clusterRadius), void 0 !== t1.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = t1.clusterMaxZoom)), this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(t1, e1) {
                return this.actor.send("geojson.getClusterExpansionZoom", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }
            getClusterChildren(t1, e1) {
                return this.actor.send("geojson.getClusterChildren", {
                    clusterId: t1,
                    source: this.id
                }, e1), this;
            }
            getClusterLeaves(t1, e1, i, s) {
                return this.actor.send("geojson.getClusterLeaves", {
                    source: this.id,
                    clusterId: t1,
                    limit: e1,
                    offset: i
                }, s), this;
            }
            _updateWorkerData(e1) {
                const i = t1.extend({}, this.workerOptions);
                e1 ? i.dataDiff = e1 : "string" == typeof this._data ? (i.request = this.map._requestManager.transformRequest(t1.exported.resolveURL(this._data), h.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this.actor.send(`${this.type}.loadData`, i, (e1, i)=>{
                    if (this._pendingLoads--, this._removed || i && i.abandoned) return void this.fire(new t1.Event("dataabort", {
                        dataType: "source"
                    }));
                    let s = null;
                    if (i && i.resourceTiming && i.resourceTiming[this.id] && (s = i.resourceTiming[this.id].slice(0)), e1) return void this.fire(new t1.ErrorEvent(e1));
                    const a = {
                        dataType: "source"
                    };
                    this._collectResourceTiming && s && s.length > 0 && t1.extend(a, {
                        resourceTiming: s
                    }), this.fire(new t1.Event("data", {
                        ...a,
                        sourceDataType: "metadata"
                    })), this.fire(new t1.Event("data", {
                        ...a,
                        sourceDataType: "content"
                    }));
                });
            }
            loaded() {
                return 0 === this._pendingLoads;
            }
            loadTile(t1, e1) {
                const i = t1.actor ? "reloadTile" : "loadTile";
                t1.actor = this.actor;
                const s = {
                    type: this.type,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    tileSize: this.tileSize,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                t1.request = this.actor.send(i, s, (s, a)=>(delete t1.request, t1.unloadVectorData(), t1.aborted ? e1(null) : s ? e1(s) : (t1.loadVectorData(a, this.map.painter, "reloadTile" === i), e1(null))));
            }
            abortTile(t1) {
                t1.request && (t1.request.cancel(), delete t1.request), t1.aborted = !0;
            }
            unloadTile(t1) {
                t1.unloadVectorData(), this.actor.send("removeTile", {
                    uid: t1.uid,
                    type: this.type,
                    source: this.id
                });
            }
            onRemove() {
                this._removed = !0, this.actor.send("removeSource", {
                    type: this.type,
                    source: this.id
                });
            }
            serialize() {
                return t1.extend({}, this._options, {
                    type: this.type,
                    data: this._data
                });
            }
            hasTransition() {
                return !1;
            }
        }
        var N = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class G extends t1.Evented {
            constructor(t1, e1, i, s){
                super(), this.id = t1, this.dispatcher = i, this.coordinates = e1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(s), this.options = e1;
            }
            load(e1, i) {
                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, this._request = u.getImage(this.map._requestManager.transformRequest(this.url, h.Image), (s, a)=>{
                    this._request = null, this._loaded = !0, s ? this.fire(new t1.ErrorEvent(s)) : a && (this.image = a, e1 && (this.coordinates = e1), i && i(), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t1) {
                return t1.url ? (this._request && (this._request.cancel(), this._request = null), this.options.url = t1.url, this.load(t1.coordinates, ()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            onRemove() {
                this._request && (this._request.cancel(), this._request = null);
            }
            setCoordinates(e1) {
                this.coordinates = e1;
                const i = e1.map(t1.MercatorCoordinate.fromLngLat);
                this.tileID = function(e1) {
                    let i = 1 / 0, s = 1 / 0, a = -1 / 0, o = -1 / 0;
                    for (const t1 of e1)i = Math.min(i, t1.x), s = Math.min(s, t1.y), a = Math.max(a, t1.x), o = Math.max(o, t1.y);
                    const r = Math.max(a - i, o - s), n = Math.max(0, Math.floor(-Math.log(r) / Math.LN2)), l = Math.pow(2, n);
                    return new t1.CanonicalTileID(n, Math.floor((i + a) / 2 * l), Math.floor((s + o) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z;
                const s = i.map((t1)=>this.tileID.getTilePoint(t1)._round());
                return this._boundsArray = new t1.RasterBoundsArray, this._boundsArray.emplaceBack(s[0].x, s[0].y, 0, 0), this._boundsArray.emplaceBack(s[1].x, s[1].y, t1.EXTENT, 0), this._boundsArray.emplaceBack(s[3].x, s[3].y, 0, t1.EXTENT), this._boundsArray.emplaceBack(s[2].x, s[2].y, t1.EXTENT, t1.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, N.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new y(e1, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let s = !1;
                for(const t1 in this.tiles){
                    const e1 = this.tiles[t1];
                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture, s = !0);
                }
                s && this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            loadTile(t1, e1) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e1(null)) : (t1.state = "errored", e1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
        }
        class Z extends G {
            constructor(t1, e1, i, s){
                super(t1, e1, i, s), this.roundZoom = !0, this.type = "video", this.options = e1;
            }
            load() {
                this._loaded = !1;
                const e1 = this.options;
                this.urls = [];
                for (const t1 of e1.urls)this.urls.push(this.map._requestManager.transformRequest(t1, h.Source).url);
                t1.getVideo(this.urls, (e1, i)=>{
                    this._loaded = !0, e1 ? this.fire(new t1.ErrorEvent(e1)) : i && (this.video = i, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                        this.map.triggerRepaint();
                    }), this.map && this.video.play(), this._finishLoading());
                });
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e1) {
                if (this.video) {
                    const i = this.video.seekable;
                    e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e1;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(t1) {
                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                const e1 = this.map.painter.context, i = e1.gl;
                this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, N.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new y(e1, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let s = !1;
                for(const t1 in this.tiles){
                    const e1 = this.tiles[t1];
                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture, s = !0);
                }
                s && this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class V extends G {
            constructor(e1, i, s, a){
                super(e1, i, s, a), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((t1)=>!Array.isArray(t1) || 2 !== t1.length || t1.some((t1)=>"number" != typeof t1)) || this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            load() {
                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                    this._playing = !0, this.map.triggerRepaint();
                }, this.pause = function() {
                    this._playing && (this.prepare(), this._playing = !1);
                }, this._finishLoading());
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(t1) {
                this.map = t1, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            prepare() {
                let e1 = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions()) return;
                if (0 === Object.keys(this.tiles).length) return;
                const i = this.map.painter.context, s = i.gl;
                this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, N.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                    premultiply: !0
                }) : this.texture = new y(i, this.canvas, s.RGBA, {
                    premultiply: !0
                });
                let a = !1;
                for(const t1 in this.tiles){
                    const e1 = this.tiles[t1];
                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture, a = !0);
                }
                a && this.fire(new t1.Event("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "canvas",
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const t1 of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(t1) || t1 <= 0) return !0;
                return !1;
            }
        }
        const q = {
            vector: B,
            raster: F,
            "raster-dem": U,
            geojson: O,
            video: Z,
            image: G,
            canvas: V
        };
        function j(e1, i) {
            const s = t1.create();
            return t1.translate(s, s, [
                1,
                1,
                0
            ]), t1.scale(s, s, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), t1.multiply(s, s, e1.calculatePosMatrix(i.toUnwrapped()));
        }
        function $(t1, e1, i, s, a, o) {
            const r = function(t1, e1, i) {
                if (t1) for (const s of t1){
                    const t1 = e1[s];
                    if (t1 && t1.source === i && "fill-extrusion" === t1.type) return !0;
                }
                else for(const t1 in e1){
                    const s = e1[t1];
                    if (s.source === i && "fill-extrusion" === s.type) return !0;
                }
                return !1;
            }(a && a.layers, e1, t1.id), n = o.maxPitchScaleFactor(), l = t1.tilesIn(s, n, r);
            l.sort(X);
            const c = [];
            for (const s of l)c.push({
                wrappedTileID: s.tileID.wrapped().key,
                queryResults: s.tile.queryRenderedFeatures(e1, i, t1._state, s.queryGeometry, s.cameraQueryGeometry, s.scale, a, o, n, j(t1.transform, s.tileID))
            });
            const h = function(t1) {
                const e1 = {}, i = {};
                for (const s of t1){
                    const t1 = s.queryResults, a = s.wrappedTileID, o = i[a] = i[a] || {};
                    for(const i in t1){
                        const s = t1[i], a = o[i] = o[i] || {}, r = e1[i] = e1[i] || [];
                        for (const t1 of s)a[t1.featureIndex] || (a[t1.featureIndex] = !0, r.push(t1));
                    }
                }
                return e1;
            }(c);
            for(const e1 in h)h[e1].forEach((e1)=>{
                const i = e1.feature, s = t1.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = s;
            });
            return h;
        }
        function X(t1, e1) {
            const i = t1.tileID, s = e1.tileID;
            return i.overscaledZ - s.overscaledZ || i.canonical.y - s.canonical.y || i.wrap - s.wrap || i.canonical.x - s.canonical.x;
        }
        class W {
            constructor(e1, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = e1, this.uid = t1.uniqueId(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            registerFadeDuration(t1) {
                const e1 = t1 + this.timeAdded;
                e1 < this.fadeEndTime || (this.fadeEndTime = e1);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(t1) {
                this.demTexture && t1.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(e1, i, s) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e1) {
                    e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(t1, e1) {
                        const i = {};
                        if (!e1) return i;
                        for (const s of t1){
                            const t1 = s.layerIds.map((t1)=>e1.getLayer(t1)).filter(Boolean);
                            if (0 !== t1.length) {
                                s.layers = t1, s.stateDependentLayerIds && (s.stateDependentLayers = s.stateDependentLayerIds.map((e1)=>t1.filter((t1)=>t1.id === e1)[0]));
                                for (const e1 of t1)i[e1.id] = s;
                            }
                        }
                        return i;
                    }(e1.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const e1 in this.buckets){
                        const i = this.buckets[e1];
                        if (i instanceof t1.SymbolBucket) {
                            if (this.hasSymbolBuckets = !0, !s) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                        const i = this.buckets[e1];
                        if (i instanceof t1.SymbolBucket && i.hasRTLText) {
                            this.hasRTLText = !0, t1.lazyLoadRTLTextPlugin();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t1 in this.buckets){
                        const e1 = this.buckets[t1];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(t1).queryRadius(e1));
                    }
                    e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage);
                } else this.collisionBoxArray = new t1.CollisionBoxArray;
            }
            unloadVectorData() {
                for(const t1 in this.buckets)this.buckets[t1].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(t1) {
                return this.buckets[t1.id];
            }
            upload(t1) {
                for(const e1 in this.buckets){
                    const i = this.buckets[e1];
                    i.uploadPending() && i.upload(t1);
                }
                const e1 = t1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new y(t1, this.imageAtlas.image, e1.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new y(t1, this.glyphAtlasImage, e1.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(t1) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t1, e1, i, s, a, o, r, n, l, c) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: s,
                    cameraQueryGeometry: a,
                    scale: o,
                    tileSize: this.tileSize,
                    pixelPosMatrix: c,
                    transform: n,
                    params: r,
                    queryPadding: this.queryPadding * l
                }, t1, e1, i) : {};
            }
            querySourceFeatures(e1, i) {
                const s = this.latestFeatureIndex;
                if (!s || !s.rawTileData) return;
                const a = s.loadVTLayers(), o = i && i.sourceLayer ? i.sourceLayer : "", r = a._geojsonTileLayer || a[o];
                if (!r) return;
                const n = t1.createFilter(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < r.length; i++){
                    const a = r.feature(i);
                    if (n.needGeometry) {
                        const e1 = t1.toEvaluationFeature(a, !0);
                        if (!n.filter(new t1.EvaluationParameters(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t1.EvaluationParameters(this.tileID.overscaledZ), a)) continue;
                    const d = s.getId(a, o), _ = new t1.GeoJSONFeature(a, l, c, h, d);
                    _.tile = u, e1.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e1) {
                const i = this.expirationTime;
                if (e1.cacheControl) {
                    const i = t1.parseCacheControl(e1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const t1 = Date.now();
                    let e1 = !1;
                    if (this.expirationTime > t1) e1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) e1 = !0;
                        else {
                            const s = this.expirationTime - i;
                            s ? this.expirationTime = t1 + Math.max(s, 3e4) : e1 = !0;
                        }
                    } else e1 = !0;
                    e1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t1, e1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t1).length) return;
                const i = this.latestFeatureIndex.loadVTLayers();
                for(const s in this.buckets){
                    if (!e1.style.hasLayer(s)) continue;
                    const a = this.buckets[s], o = a.layers[0].sourceLayer || "_geojsonTileLayer", r = i[o], n = t1[o];
                    if (!r || !n || 0 === Object.keys(n).length) continue;
                    a.update(n, r, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    const l = e1 && e1.style && e1.style.getLayer(s);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < t1.exported.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e1) {
                this.symbolFadeHoldUntil = t1.exported.now() + e1;
            }
            setDependencies(t1, e1) {
                const i = {};
                for (const t1 of e1)i[t1] = !0;
                this.dependencies[t1] = i;
            }
            hasDependency(t1, e1) {
                for (const i of t1){
                    const t1 = this.dependencies[i];
                    if (t1) {
                        for (const i of e1)if (t1[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class H {
            constructor(t1, e1){
                this.max = t1, this.onRemove = e1, this.reset();
            }
            reset() {
                for(const t1 in this.data)for (const e1 of this.data[t1])e1.timeout && clearTimeout(e1.timeout), this.onRemove(e1.value);
                return this.data = {}, this.order = [], this;
            }
            add(t1, e1, i) {
                const s = t1.wrapped().key;
                void 0 === this.data[s] && (this.data[s] = []);
                const a = {
                    value: e1,
                    timeout: void 0
                };
                if (void 0 !== i && (a.timeout = setTimeout(()=>{
                    this.remove(t1, a);
                }, i)), this.data[s].push(a), this.order.push(s), this.order.length > this.max) {
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            has(t1) {
                return t1.wrapped().key in this.data;
            }
            getAndRemove(t1) {
                return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
            }
            _getAndRemoveByKey(t1) {
                const e1 = this.data[t1].shift();
                return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
            }
            getByKey(t1) {
                const e1 = this.data[t1];
                return e1 ? e1[0].value : null;
            }
            get(t1) {
                return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
            }
            remove(t1, e1) {
                if (!this.has(t1)) return this;
                const i = t1.wrapped().key, s = void 0 === e1 ? 0 : this.data[i].indexOf(e1), a = this.data[i][s];
                return this.data[i].splice(s, 1), a.timeout && clearTimeout(a.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(a.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(t1) {
                for(this.max = t1; this.order.length > this.max;){
                    const t1 = this._getAndRemoveByKey(this.order[0]);
                    t1 && this.onRemove(t1);
                }
                return this;
            }
            filter(t1) {
                const e1 = [];
                for(const i in this.data)for (const s of this.data[i])t1(s.value) || e1.push(s);
                for (const t1 of e1)this.remove(t1.value.tileID, t1);
            }
        }
        class K {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e1, i, s) {
                const a = String(i);
                if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][a] = this.stateChanges[e1][a] || {}, t1.extend(this.stateChanges[e1][a], s), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t1 in this.state[e1])t1 !== a && (this.deletedStates[e1][t1] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][a]) {
                    this.deletedStates[e1][a] = {};
                    for(const t1 in this.state[e1][a])s[t1] || (this.deletedStates[e1][a][t1] = null);
                } else for(const t1 in s)this.deletedStates[e1] && this.deletedStates[e1][a] && null === this.deletedStates[e1][a][t1] && delete this.deletedStates[e1][a][t1];
            }
            removeFeatureState(t1, e1, i) {
                if (null === this.deletedStates[t1]) return;
                const s = String(e1);
                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, i && void 0 !== e1) null !== this.deletedStates[t1][s] && (this.deletedStates[t1][s] = this.deletedStates[t1][s] || {}, this.deletedStates[t1][s][i] = null);
                else if (void 0 !== e1) {
                    if (this.stateChanges[t1] && this.stateChanges[t1][s]) for(i in this.deletedStates[t1][s] = {}, this.stateChanges[t1][s])this.deletedStates[t1][s][i] = null;
                    else this.deletedStates[t1][s] = null;
                } else this.deletedStates[t1] = null;
            }
            getState(e1, i) {
                const s = String(i), a = t1.extend({}, (this.state[e1] || {})[s], (this.stateChanges[e1] || {})[s]);
                if (null === this.deletedStates[e1]) return {};
                if (this.deletedStates[e1]) {
                    const t1 = this.deletedStates[e1][i];
                    if (null === t1) return {};
                    for(const e1 in t1)delete a[e1];
                }
                return a;
            }
            initializeTileState(t1, e1) {
                t1.setFeatureState(this.state, e1);
            }
            coalesceChanges(e1, i) {
                const s = {};
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || {};
                    const i = {};
                    for(const s in this.stateChanges[e1])this.state[e1][s] || (this.state[e1][s] = {}), t1.extend(this.state[e1][s], this.stateChanges[e1][s]), i[s] = this.state[e1][s];
                    s[e1] = i;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || {};
                    const i = {};
                    if (null === this.deletedStates[e1]) for(const t1 in this.state[e1])i[t1] = {}, this.state[e1][t1] = {};
                    else for(const t1 in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][t1]) this.state[e1][t1] = {};
                        else for (const i of Object.keys(this.deletedStates[e1][t1]))delete this.state[e1][t1][i];
                        i[t1] = this.state[e1][t1];
                    }
                    s[e1] = s[e1] || {}, t1.extend(s[e1], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(s).length) for(const t1 in e1)e1[t1].setFeatureState(s, i);
            }
        }
        class Y extends t1.Evented {
            constructor(e1, i, s){
                super(), this.id = e1, this.dispatcher = s, this.on("data", (t1)=>{
                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
                }), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = function(e1, i, s, a) {
                    const o = new q[i.type](e1, i, s, a);
                    if (o.id !== e1) throw new Error(`Expected Source id to be ${e1} instead of ${o.id}`);
                    return t1.bindAll([
                        "load",
                        "abort",
                        "unload",
                        "serialize",
                        "prepare"
                    ], o), o;
                }(e1, i, s, this), this._tiles = {}, this._cache = new H(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new K, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(t1) {
                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = t1 ? t1._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(t1);
            }
            onRemove(t1) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(t1);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for(const t1 in this._tiles){
                    const e1 = this._tiles[t1];
                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(t1, e1) {
                return this._source.loadTile(t1, e1);
            }
            _unloadTile(t1) {
                if (this._source.unloadTile) return this._source.unloadTile(t1, ()=>{});
            }
            _abortTile(e1) {
                this._source.abortTile && this._source.abortTile(e1, ()=>{}), this._source.fire(new t1.Event("dataabort", {
                    tile: e1,
                    coord: e1.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const e1 in this._tiles){
                    const i = this._tiles[e1];
                    i.upload(t1), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((t1)=>t1.tileID).sort(J).map((t1)=>t1.key);
            }
            getRenderableIds(e1) {
                const i = [];
                for(const t1 in this._tiles)this._isIdRenderable(t1, e1) && i.push(this._tiles[t1]);
                return e1 ? i.sort((e1, i)=>{
                    const s = e1.tileID, a = i.tileID, o = new t1.Point(s.canonical.x, s.canonical.y)._rotate(this.transform.angle), r = new t1.Point(a.canonical.x, a.canonical.y)._rotate(this.transform.angle);
                    return s.overscaledZ - a.overscaledZ || r.y - o.y || r.x - o.x;
                }).map((t1)=>t1.tileID.key) : i.map((t1)=>t1.tileID).sort(J).map((t1)=>t1.key);
            }
            hasRenderableParent(t1) {
                const e1 = this.findLoadedParent(t1, 0);
                return !!e1 && this._isIdRenderable(e1.tileID.key);
            }
            _isIdRenderable(t1, e1) {
                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t1 in this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
                }
            }
            _reloadTile(t1, e1) {
                const i = this._tiles[t1];
                i && ("loading" !== i.state && (i.state = e1), this._loadTile(i, this._tileLoaded.bind(this, i, t1, e1)));
            }
            _tileLoaded(e1, i, s, a) {
                if (a) return e1.state = "errored", void (404 !== a.status ? this._source.fire(new t1.ErrorEvent(a, {
                    tile: e1
                })) : this.update(this.transform, this.terrain));
                e1.timeAdded = t1.exported.now(), "expired" === s && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new t1.Event("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID
                }));
            }
            _backfillDEM(t1) {
                const e1 = this.getRenderableIds();
                for(let s = 0; s < e1.length; s++){
                    const a = e1[s];
                    if (t1.neighboringTiles && t1.neighboringTiles[a]) {
                        const e1 = this.getTileByID(a);
                        i(t1, e1), i(e1, t1);
                    }
                }
                function i(t1, e1) {
                    t1.needsHillshadePrepare = !0, t1.needsTerrainPrepare = !0;
                    let i = e1.tileID.canonical.x - t1.tileID.canonical.x;
                    const s = e1.tileID.canonical.y - t1.tileID.canonical.y, a = Math.pow(2, t1.tileID.canonical.z), o = e1.tileID.key;
                    0 === i && 0 === s || Math.abs(s) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + a) ? i += a : 1 === Math.abs(i - a) && (i -= a)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, i, s), t1.neighboringTiles && t1.neighboringTiles[o] && (t1.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(t1) {
                return this.getTileByID(t1.key);
            }
            getTileByID(t1) {
                return this._tiles[t1];
            }
            _retainLoadedChildren(t1, e1, i, s) {
                for(const a in this._tiles){
                    let o = this._tiles[a];
                    if (s[a] || !o.hasData() || o.tileID.overscaledZ <= e1 || o.tileID.overscaledZ > i) continue;
                    let r = o.tileID;
                    for(; o && o.tileID.overscaledZ > e1 + 1;){
                        const t1 = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[t1.key], o && o.hasData() && (r = t1);
                    }
                    let n = r;
                    for(; n.overscaledZ > e1;)if (n = n.scaledTo(n.overscaledZ - 1), t1[n.key]) {
                        s[r.key] = r;
                        break;
                    }
                }
            }
            findLoadedParent(t1, e1) {
                if (t1.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[t1.key];
                    return i && i.tileID.overscaledZ >= e1 ? i : null;
                }
                for(let i = t1.overscaledZ - 1; i >= e1; i--){
                    const e1 = t1.scaledTo(i), s = this._getLoadedTile(e1);
                    if (s) return s;
                }
            }
            _getLoadedTile(t1) {
                const e1 = this._tiles[t1.key];
                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
            }
            updateCacheSize(e1) {
                const i = Math.ceil(e1.width / this._source.tileSize) + 1, s = Math.ceil(e1.height / this._source.tileSize) + 1, a = Math.floor(i * s * (null === this._maxTileCacheZoomLevels ? t1.config.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, a) : a;
                this._cache.setMaxSize(o);
            }
            handleWrapJump(t1) {
                const e1 = Math.round((t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360);
                if (this._prevLng = t1, e1) {
                    const t1 = {};
                    for(const i in this._tiles){
                        const s = this._tiles[i];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + e1), t1[s.tileID.key] = s;
                    }
                    this._tiles = t1;
                    for(const t1 in this._timers)clearTimeout(this._timers[t1]), delete this._timers[t1];
                    for(const t1 in this._tiles)this._setTileReloadTimer(t1, this._tiles[t1]);
                }
            }
            update(e1, i) {
                if (this.transform = e1, this.terrain = i, !this._sourceLoaded || this._paused) return;
                let s;
                this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? s = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new t1.OverscaledTileID(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (s = e1.coveringTiles({
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i
                }), this._source.hasTile && (s = s.filter((t1)=>this._source.hasTile(t1)))) : s = [];
                const a = e1.coveringZoomLevel(this._source), o = Math.max(a - Y.maxOverzooming, this._source.minzoom), r = Math.max(a + Y.maxUnderzooming, this._source.minzoom);
                if (this.usedForTerrain) {
                    const t1 = {};
                    for (const e1 of s)if (e1.canonical.z > this._source.minzoom) {
                        const i = e1.scaledTo(e1.canonical.z - 1);
                        t1[i.key] = i;
                        const s = e1.scaledTo(Math.max(this._source.minzoom, Math.min(e1.canonical.z, 5)));
                        t1[s.key] = s;
                    }
                    s = s.concat(Object.values(t1));
                }
                const n = 0 === s.length && !this._updated && this._didEmitContent;
                this._updated = !0, n && this.fire(new t1.Event("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const l = this._updateRetainedTiles(s, a);
                if (Q(this._source.type)) {
                    const e1 = {}, n = {}, c = Object.keys(l), h = t1.exported.now();
                    for (const t1 of c){
                        const i = l[t1], s = this._tiles[t1];
                        if (!s || 0 !== s.fadeEndTime && s.fadeEndTime <= h) continue;
                        const a = this.findLoadedParent(i, o);
                        a && (this._addTile(a.tileID), e1[a.tileID.key] = a.tileID), n[t1] = i;
                    }
                    this._retainLoadedChildren(n, a, r, l);
                    for(const t1 in e1)l[t1] || (this._coveredTiles[t1] = !0, l[t1] = e1[t1]);
                    if (i) {
                        const t1 = {}, e1 = {};
                        for (const i of s)this._tiles[i.key].hasData() ? t1[i.key] = i : e1[i.key] = i;
                        for(const i in e1){
                            const s = e1[i].children(this._source.maxzoom);
                            this._tiles[s[0].key] && this._tiles[s[1].key] && this._tiles[s[2].key] && this._tiles[s[3].key] && (t1[s[0].key] = l[s[0].key] = s[0], t1[s[1].key] = l[s[1].key] = s[1], t1[s[2].key] = l[s[2].key] = s[2], t1[s[3].key] = l[s[3].key] = s[3], delete e1[i]);
                        }
                        for(const i in e1){
                            const s = this.findLoadedParent(e1[i], this._source.minzoom);
                            if (s) {
                                t1[s.tileID.key] = l[s.tileID.key] = s.tileID;
                                for(const e1 in t1)t1[e1].isChildOf(s.tileID) && delete t1[e1];
                            }
                        }
                        for(const e1 in this._tiles)t1[e1] || (this._coveredTiles[e1] = !0);
                    }
                }
                for(const t1 in l)this._tiles[t1].clearFadeHold();
                const c = t1.keysDifference(this._tiles, l);
                for (const t1 of c){
                    const e1 = this._tiles[t1];
                    e1.hasSymbolBuckets && !e1.holdingForFade() ? e1.setHoldDuration(this.map._fadeDuration) : e1.hasSymbolBuckets && !e1.symbolFadeFinished() || this._removeTile(t1);
                }
                this._updateLoadedParentTileCache();
            }
            releaseSymbolFadeTiles() {
                for(const t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
            }
            _updateRetainedTiles(t1, e1) {
                const i = {}, s = {}, a = Math.max(e1 - Y.maxOverzooming, this._source.minzoom), o = Math.max(e1 + Y.maxUnderzooming, this._source.minzoom), r = {};
                for (const s of t1){
                    const t1 = this._addTile(s);
                    i[s.key] = s, t1.hasData() || e1 < this._source.maxzoom && (r[s.key] = s);
                }
                this._retainLoadedChildren(r, e1, o, i);
                for (const o of t1){
                    let t1 = this._tiles[o.key];
                    if (t1.hasData()) continue;
                    if (e1 + 1 > this._source.maxzoom) {
                        const t1 = o.children(this._source.maxzoom)[0], e1 = this.getTile(t1);
                        if (e1 && e1.hasData()) {
                            i[t1.key] = t1;
                            continue;
                        }
                    } else {
                        const t1 = o.children(this._source.maxzoom);
                        if (i[t1[0].key] && i[t1[1].key] && i[t1[2].key] && i[t1[3].key]) continue;
                    }
                    let r = t1.wasRequested();
                    for(let e1 = o.overscaledZ - 1; e1 >= a; --e1){
                        const a = o.scaledTo(e1);
                        if (s[a.key]) break;
                        if (s[a.key] = !0, t1 = this.getTile(a), !t1 && r && (t1 = this._addTile(a)), t1) {
                            const e1 = t1.hasData();
                            if ((r || e1) && (i[a.key] = a), r = t1.wasRequested(), e1) break;
                        }
                    }
                }
                return i;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t1 in this._tiles){
                    const e1 = [];
                    let i, s = this._tiles[t1].tileID;
                    for(; s.overscaledZ > 0;){
                        if (s.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[s.key];
                            break;
                        }
                        e1.push(s.key);
                        const t1 = s.scaledTo(s.overscaledZ - 1);
                        if (i = this._getLoadedTile(t1), i) break;
                        s = t1;
                    }
                    for (const t1 of e1)this._loadedParentTiles[t1] = i;
                }
            }
            _addTile(e1) {
                let i = this._tiles[e1.key];
                if (i) return i;
                i = this._cache.getAndRemove(e1), i && (this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, i)));
                const s = i;
                return i || (i = new W(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, this._tileLoaded.bind(this, i, e1.key, i.state))), i.uses++, this._tiles[e1.key] = i, s || this._source.fire(new t1.Event("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(t1, e1) {
                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                const i = e1.getExpiryTimeout();
                i && (this._timers[t1] = setTimeout(()=>{
                    this._reloadTile(t1, "expired"), delete this._timers[t1];
                }, i));
            }
            _removeTile(t1) {
                const e1 = this._tiles[t1];
                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t1 in this._tiles)this._removeTile(t1);
                this._cache.reset();
            }
            tilesIn(e1, i, s) {
                const a = [], o = this.transform;
                if (!o) return a;
                const r = s ? o.getCameraQueryGeometry(e1) : e1, n = e1.map((t1)=>o.pointCoordinate(t1, this.terrain)), l = r.map((t1)=>o.pointCoordinate(t1, this.terrain)), c = this.getIds();
                let h = 1 / 0, u = 1 / 0, d = -1 / 0, _ = -1 / 0;
                for (const t1 of l)h = Math.min(h, t1.x), u = Math.min(u, t1.y), d = Math.max(d, t1.x), _ = Math.max(_, t1.y);
                for(let e1 = 0; e1 < c.length; e1++){
                    const s = this._tiles[c[e1]];
                    if (s.holdingForFade()) continue;
                    const r = s.tileID, m = Math.pow(2, o.zoom - s.tileID.overscaledZ), p = i * s.queryPadding * t1.EXTENT / s.tileSize / m, f = [
                        r.getTilePoint(new t1.MercatorCoordinate(h, u)),
                        r.getTilePoint(new t1.MercatorCoordinate(d, _))
                    ];
                    if (f[0].x - p < t1.EXTENT && f[0].y - p < t1.EXTENT && f[1].x + p >= 0 && f[1].y + p >= 0) {
                        const t1 = n.map((t1)=>r.getTilePoint(t1)), e1 = l.map((t1)=>r.getTilePoint(t1));
                        a.push({
                            tile: s,
                            tileID: r,
                            queryGeometry: t1,
                            cameraQueryGeometry: e1,
                            scale: m
                        });
                    }
                }
                return a;
            }
            getVisibleCoordinates(t1) {
                const e1 = this.getRenderableIds(t1).map((t1)=>this._tiles[t1].tileID);
                for (const t1 of e1)t1.posMatrix = this.transform.calculatePosMatrix(t1.toUnwrapped());
                return e1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Q(this._source.type)) {
                    const e1 = t1.exported.now();
                    for(const t1 in this._tiles)if (this._tiles[t1].fadeEndTime >= e1) return !0;
                }
                return !1;
            }
            setFeatureState(t1, e1, i) {
                this._state.updateState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }
            removeFeatureState(t1, e1, i) {
                this._state.removeFeatureState(t1 = t1 || "_geojsonTileLayer", e1, i);
            }
            getFeatureState(t1, e1) {
                return this._state.getState(t1 = t1 || "_geojsonTileLayer", e1);
            }
            setDependencies(t1, e1, i) {
                const s = this._tiles[t1];
                s && s.setDependencies(e1, i);
            }
            reloadTilesForDependencies(t1, e1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(t1, e1) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(t1, e1));
            }
        }
        function J(t1, e1) {
            const i = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), s = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t1.overscaledZ - e1.overscaledZ || s - i || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
        }
        function Q(t1) {
            return "raster" === t1 || "image" === t1 || "video" === t1;
        }
        Y.maxOverzooming = 10, Y.maxUnderzooming = 3;
        const tt = "mapboxgl_preloaded_worker_pool";
        class et {
            constructor(){
                this.active = {};
            }
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < et.workerCount;)this.workers.push(new Worker(t1.config.WORKER_URL));
                return this.active[e1] = !0, this.workers.slice();
            }
            release(t1) {
                delete this.active[t1], 0 === this.numActive() && (this.workers.forEach((t1)=>{
                    t1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[tt];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const it = Math.floor(t1.exported.hardwareConcurrency / 2);
        let st;
        function at() {
            return st || (st = new et), st;
        }
        et.workerCount = t1.isSafari(globalThis) ? Math.max(Math.min(it, 3), 1) : 1;
        class ot {
            constructor(t1, e1){
                this.reset(t1, e1);
            }
            reset(t1, e1) {
                this.points = t1 || [], this._distances = [
                    0
                ];
                for(let t1 = 1; t1 < this.points.length; t1++)this._distances[t1] = this._distances[t1 - 1] + this.points[t1].dist(this.points[t1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e1) {
                if (1 === this.points.length) return this.points[0];
                e1 = t1.clamp(e1, 0, 1);
                let i = 1, s = this._distances[i];
                const a = e1 * this.paddedLength + this.padding;
                for(; s < a && i < this._distances.length;)s = this._distances[++i];
                const o = i - 1, r = this._distances[o], n = s - r, l = n > 0 ? (a - r) / n : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function rt(t1, e1) {
            let i = !0;
            return "always" === t1 || "never" !== t1 && "never" !== e1 || (i = !1), i;
        }
        class nt {
            constructor(t1, e1, i){
                const s = this.boxCells = [], a = this.circleCells = [];
                this.xCellCount = Math.ceil(t1 / i), this.yCellCount = Math.ceil(e1 / i);
                for(let t1 = 0; t1 < this.xCellCount * this.yCellCount; t1++)s.push([]), a.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(t1, e1, i, s, a) {
                this._forEachCell(e1, i, s, a, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(i), this.bboxes.push(s), this.bboxes.push(a);
            }
            insertCircle(t1, e1, i, s) {
                this._forEachCell(e1 - s, i - s, e1 + s, i + s, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(i), this.circles.push(s);
            }
            _insertBoxCell(t1, e1, i, s, a, o) {
                this.boxCells[a].push(o);
            }
            _insertCircleCell(t1, e1, i, s, a, o) {
                this.circleCells[a].push(o);
            }
            _query(t1, e1, i, s, a, o, r) {
                if (i < 0 || t1 > this.width || s < 0 || e1 > this.height) return [];
                const n = [];
                if (t1 <= 0 && e1 <= 0 && this.width <= i && this.height <= s) {
                    if (a) return [
                        {
                            key: null,
                            x1: t1,
                            y1: e1,
                            x2: i,
                            y2: s
                        }
                    ];
                    for(let t1 = 0; t1 < this.boxKeys.length; t1++)n.push({
                        key: this.boxKeys[t1],
                        x1: this.bboxes[4 * t1],
                        y1: this.bboxes[4 * t1 + 1],
                        x2: this.bboxes[4 * t1 + 2],
                        y2: this.bboxes[4 * t1 + 3]
                    });
                    for(let t1 = 0; t1 < this.circleKeys.length; t1++){
                        const e1 = this.circles[3 * t1], i = this.circles[3 * t1 + 1], s = this.circles[3 * t1 + 2];
                        n.push({
                            key: this.circleKeys[t1],
                            x1: e1 - s,
                            y1: i - s,
                            x2: e1 + s,
                            y2: i + s
                        });
                    }
                } else this._forEachCell(t1, e1, i, s, this._queryCell, n, {
                    hitTest: a,
                    overlapMode: o,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r);
                return n;
            }
            query(t1, e1, i, s) {
                return this._query(t1, e1, i, s, !1, null);
            }
            hitTest(t1, e1, i, s, a, o) {
                return this._query(t1, e1, i, s, !0, a, o).length > 0;
            }
            hitTestCircle(t1, e1, i, s, a) {
                const o = t1 - i, r = t1 + i, n = e1 - i, l = e1 + i;
                if (r < 0 || o > this.width || l < 0 || n > this.height) return !1;
                const c = [];
                return this._forEachCell(o, n, r, l, this._queryCellCircle, c, {
                    hitTest: !0,
                    overlapMode: s,
                    circle: {
                        x: t1,
                        y: e1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, a), c.length > 0;
            }
            _queryCell(t1, e1, i, s, a, o, r, n) {
                const { seenUids: l, hitTest: c, overlapMode: h } = r, u = this.boxCells[a];
                if (null !== u) {
                    const a = this.bboxes;
                    for (const r of u)if (!l.box[r]) {
                        l.box[r] = !0;
                        const u = 4 * r, d = this.boxKeys[r];
                        if (t1 <= a[u + 2] && e1 <= a[u + 3] && i >= a[u + 0] && s >= a[u + 1] && (!n || n(d)) && (!c || !rt(h, d.overlapMode)) && (o.push({
                            key: d,
                            x1: a[u],
                            y1: a[u + 1],
                            x2: a[u + 2],
                            y2: a[u + 3]
                        }), c)) return !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const a = this.circles;
                    for (const r of d)if (!l.circle[r]) {
                        l.circle[r] = !0;
                        const u = 3 * r, d = this.circleKeys[r];
                        if (this._circleAndRectCollide(a[u], a[u + 1], a[u + 2], t1, e1, i, s) && (!n || n(d)) && (!c || !rt(h, d.overlapMode))) {
                            const t1 = a[u], e1 = a[u + 1], i = a[u + 2];
                            if (o.push({
                                key: d,
                                x1: t1 - i,
                                y1: e1 - i,
                                x2: t1 + i,
                                y2: e1 + i
                            }), c) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(t1, e1, i, s, a, o, r, n) {
                const { circle: l, seenUids: c, overlapMode: h } = r, u = this.boxCells[a];
                if (null !== u) {
                    const t1 = this.bboxes;
                    for (const e1 of u)if (!c.box[e1]) {
                        c.box[e1] = !0;
                        const i = 4 * e1, s = this.boxKeys[e1];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, t1[i + 0], t1[i + 1], t1[i + 2], t1[i + 3]) && (!n || n(s)) && !rt(h, s.overlapMode)) return o.push(!0), !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const t1 = this.circles;
                    for (const e1 of d)if (!c.circle[e1]) {
                        c.circle[e1] = !0;
                        const i = 3 * e1, s = this.circleKeys[e1];
                        if (this._circlesCollide(t1[i], t1[i + 1], t1[i + 2], l.x, l.y, l.radius) && (!n || n(s)) && !rt(h, s.overlapMode)) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(t1, e1, i, s, a, o, r, n) {
                const l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(s);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (a.call(this, t1, e1, i, s, this.xCellCount * l + d, o, r, n)) return;
            }
            _convertToXCellCoord(t1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
            }
            _convertToYCellCoord(t1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
            }
            _circlesCollide(t1, e1, i, s, a, o) {
                const r = s - t1, n = a - e1, l = i + o;
                return l * l > r * r + n * n;
            }
            _circleAndRectCollide(t1, e1, i, s, a, o, r) {
                const n = (o - s) / 2, l = Math.abs(t1 - (s + n));
                if (l > n + i) return !1;
                const c = (r - a) / 2, h = Math.abs(e1 - (a + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
        }
        function lt(e1, i, s, a, o) {
            const r = t1.create();
            return i ? (t1.scale(r, r, [
                1 / o,
                1 / o,
                1
            ]), s || t1.rotateZ(r, r, a.angle)) : t1.multiply(r, a.labelPlaneMatrix, e1), r;
        }
        function ct(e1, i, s, a, o) {
            if (i) {
                const i = t1.clone(e1);
                return t1.scale(i, i, [
                    o,
                    o,
                    1
                ]), s || t1.rotateZ(i, i, -a.angle), i;
            }
            return a.glCoordMatrix;
        }
        function ht(e1, i, s) {
            let a;
            s ? (a = [
                e1.x,
                e1.y,
                s(e1.x, e1.y),
                1
            ], t1.transformMat4(a, a, i)) : (a = [
                e1.x,
                e1.y,
                0,
                1
            ], Et(a, a, i));
            const o = a[3];
            return {
                point: new t1.Point(a[0] / o, a[1] / o),
                signedDistanceFromCamera: o
            };
        }
        function ut(t1, e1) {
            return .5 + t1 / e1 * .5;
        }
        function dt(t1, e1) {
            const i = t1[0] / t1[3], s = t1[1] / t1[3];
            return i >= -e1[0] && i <= e1[0] && s >= -e1[1] && s <= e1[1];
        }
        function _t(e1, i, s, a, o, r, n, l, c, h) {
            const u = a ? e1.textSizeData : e1.iconSizeData, d = t1.evaluateSizeForZoom(u, s.transform.zoom), _ = [
                256 / s.width * 2 + 1,
                256 / s.height * 2 + 1
            ], m = a ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            m.clear();
            const p = e1.lineVertexArray, f = a ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, g = s.transform.width / s.transform.height;
            let v = !1;
            for(let a = 0; a < f.length; a++){
                const x = f.get(a);
                if (x.hidden || x.writingMode === t1.WritingMode.vertical && !v) {
                    Tt(x.numGlyphs, m);
                    continue;
                }
                let y;
                if (v = !1, h ? (y = [
                    x.anchorX,
                    x.anchorY,
                    h(x.anchorX, x.anchorY),
                    1
                ], t1.transformMat4(y, y, i)) : (y = [
                    x.anchorX,
                    x.anchorY,
                    0,
                    1
                ], Et(y, y, i)), !dt(y, _)) {
                    Tt(x.numGlyphs, m);
                    continue;
                }
                const b = ut(s.transform.cameraToCenterDistance, y[3]), w = t1.evaluateSizeForFeature(u, d, x), T = n ? w / b : w * b, E = new t1.Point(x.anchorX, x.anchorY), I = ht(E, o, h).point, S = {
                    projections: {},
                    offsets: {}
                }, C = ft(x, T, !1, l, i, o, r, e1.glyphOffsetArray, p, m, I, E, S, g, c, h);
                v = C.useVertical, (C.notEnoughRoom || v || C.needsFlipping && ft(x, T, !0, l, i, o, r, e1.glyphOffsetArray, p, m, I, E, S, g, c, h).notEnoughRoom) && Tt(x.numGlyphs, m);
            }
            a ? e1.text.dynamicLayoutVertexBuffer.updateData(m) : e1.icon.dynamicLayoutVertexBuffer.updateData(m);
        }
        function mt(t1, e1, i, s, a, o, r, n, l, c, h, u, d) {
            const _ = n.glyphStartIndex + n.numGlyphs, m = n.lineStartIndex, p = n.lineStartIndex + n.lineLength, f = e1.getoffsetX(n.glyphStartIndex), g = e1.getoffsetX(_ - 1), v = bt(t1 * f, i, s, a, o, r, n.segment, m, p, l, c, h, u, d);
            if (!v) return null;
            const x = bt(t1 * g, i, s, a, o, r, n.segment, m, p, l, c, h, u, d);
            return x ? {
                first: v,
                last: x
            } : null;
        }
        function pt(e1, i, s, a) {
            return e1 === t1.WritingMode.horizontal && Math.abs(s.y - i.y) > Math.abs(s.x - i.x) * a ? {
                useVertical: !0
            } : (e1 === t1.WritingMode.vertical ? i.y < s.y : i.x > s.x) ? {
                needsFlipping: !0
            } : null;
        }
        function ft(e1, i, s, a, o, r, n, l, c, h, u, d, _, m, p, f) {
            const g = i / 24, v = e1.lineOffsetX * g, x = e1.lineOffsetY * g;
            let y;
            if (e1.numGlyphs > 1) {
                const t1 = e1.glyphStartIndex + e1.numGlyphs, i = e1.lineStartIndex, o = e1.lineStartIndex + e1.lineLength, h = mt(g, l, v, x, s, u, d, e1, c, r, _, p, f);
                if (!h) return {
                    notEnoughRoom: !0
                };
                const b = ht(h.first.point, n, f).point, w = ht(h.last.point, n, f).point;
                if (a && !s) {
                    const t1 = pt(e1.writingMode, b, w, m);
                    if (t1) return t1;
                }
                y = [
                    h.first
                ];
                for(let a = e1.glyphStartIndex + 1; a < t1 - 1; a++)y.push(bt(g * l.getoffsetX(a), v, x, s, u, d, e1.segment, i, o, c, r, _, p, f));
                y.push(h.last);
            } else {
                if (a && !s) {
                    const i = ht(d, o, f).point, s = e1.lineStartIndex + e1.segment + 1, a = new t1.Point(c.getx(s), c.gety(s)), r = ht(a, o, f), n = r.signedDistanceFromCamera > 0 ? r.point : gt(d, a, i, 1, o, f), l = pt(e1.writingMode, i, n, m);
                    if (l) return l;
                }
                const i = bt(g * l.getoffsetX(e1.glyphStartIndex), v, x, s, u, d, e1.segment, e1.lineStartIndex, e1.lineStartIndex + e1.lineLength, c, r, _, p, f);
                if (!i) return {
                    notEnoughRoom: !0
                };
                y = [
                    i
                ];
            }
            for (const e1 of y)t1.addDynamicAttributes(h, e1.point, e1.angle);
            return {};
        }
        function gt(t1, e1, i, s, a, o) {
            const r = ht(t1.add(t1.sub(e1)._unit()), a, o).point, n = i.sub(r);
            return i.add(n._mult(s / n.mag()));
        }
        function vt(e1, i) {
            const { projectionCache: s, lineVertexArray: a, labelPlaneMatrix: o, tileAnchorPoint: r, distanceFromAnchor: n, getElevation: l, previousVertex: c, direction: h, absOffsetX: u } = i;
            if (s.projections[e1]) return s.projections[e1];
            const d = new t1.Point(a.getx(e1), a.gety(e1)), _ = ht(d, o, l);
            if (_.signedDistanceFromCamera > 0) return s.projections[e1] = _.point, _.point;
            const m = e1 - h;
            return gt(0 === n ? r : new t1.Point(a.getx(m), a.gety(m)), d, c, u - n + 1, o, l);
        }
        function xt(t1, e1, i) {
            return t1._unit()._perp()._mult(e1 * i);
        }
        function yt(e1, i, s, a, o, r, n, l) {
            const { projectionCache: c, direction: h } = l;
            if (c.offsets[e1]) return c.offsets[e1];
            const u = s.add(i);
            if (e1 + h < a || e1 + h >= o) return c.offsets[e1] = u, u;
            const d = vt(e1 + h, l), _ = xt(d.sub(s), n, h), m = s.add(_), p = d.add(_);
            return c.offsets[e1] = t1.findLineIntersection(r, u, m, p) || u, c.offsets[e1];
        }
        function bt(t1, e1, i, s, a, o, r, n, l, c, h, u, d, _) {
            const m = s ? t1 - e1 : t1 + e1;
            let p = m > 0 ? 1 : -1, f = 0;
            s && (p *= -1, f = Math.PI), p < 0 && (f += Math.PI);
            let g, v, x = p > 0 ? n + r : n + r + 1, y = a, b = a, w = 0, T = 0;
            const E = Math.abs(m), I = [];
            let S;
            for(; w + T <= E;){
                if (x += p, x < n || x >= l) return null;
                w += T, b = y, v = g;
                const t1 = {
                    projectionCache: u,
                    lineVertexArray: c,
                    labelPlaneMatrix: h,
                    tileAnchorPoint: o,
                    distanceFromAnchor: w,
                    getElevation: _,
                    previousVertex: b,
                    direction: p,
                    absOffsetX: E
                };
                if (y = vt(x, t1), 0 === i) I.push(b), S = y.sub(b);
                else {
                    let e1;
                    const s = y.sub(b);
                    e1 = 0 === s.mag() ? xt(vt(x + p, t1).sub(y), i, p) : xt(s, i, p), v || (v = b.add(e1)), g = yt(x, e1, y, n, l, v, i, t1), I.push(v), S = g.sub(v);
                }
                T = S.mag();
            }
            const C = S._mult((E - w) / T)._add(v || b), P = f + Math.atan2(y.y - b.y, y.x - b.x);
            return I.push(C), {
                point: C,
                angle: d ? P : 0,
                path: I
            };
        }
        const wt = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function Tt(t1, e1) {
            for(let i = 0; i < t1; i++){
                const t1 = e1.length;
                e1.resize(t1 + 4), e1.float32.set(wt, 3 * t1);
            }
        }
        function Et(t1, e1, i) {
            const s = e1[0], a = e1[1];
            return t1[0] = i[0] * s + i[4] * a + i[12], t1[1] = i[1] * s + i[5] * a + i[13], t1[3] = i[3] * s + i[7] * a + i[15], t1;
        }
        const It = 100;
        class St {
            constructor(t1, e1 = new nt(t1.width + 200, t1.height + 200, 25), i = new nt(t1.width + 200, t1.height + 200, 25)){
                this.transform = t1, this.grid = e1, this.ignoredGrid = i, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + It, this.screenBottomBoundary = t1.height + It, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(t1, e1, i, s, a, o) {
                const r = this.projectAndGetPerspectiveRatio(s, t1.anchorPointX, t1.anchorPointY, o), n = i * r.perspectiveRatio, l = t1.x1 * n + r.point.x, c = t1.y1 * n + r.point.y, h = t1.x2 * n + r.point.x, u = t1.y2 * n + r.point.y;
                return !this.isInsideGrid(l, c, h, u) || "always" !== e1 && this.grid.hitTest(l, c, h, u, e1, a) || r.perspectiveRatio < this.perspectiveRatioCutoff ? {
                    box: [],
                    offscreen: !1
                } : {
                    box: [
                        l,
                        c,
                        h,
                        u
                    ],
                    offscreen: this.isOffscreen(l, c, h, u)
                };
            }
            placeCollisionCircles(e1, i, s, a, o, r, n, l, c, h, u, d, _, m) {
                const p = [], f = new t1.Point(i.anchorX, i.anchorY), g = ht(f, r, m), v = ut(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera), x = (h ? o / v : o * v) / t1.ONE_EM, y = ht(f, n, m).point, b = mt(x, a, i.lineOffsetX * x, i.lineOffsetY * x, !1, y, f, i, s, n, {
                    projections: {},
                    offsets: {}
                }, !1, m);
                let w = !1, T = !1, E = !0;
                if (b) {
                    const i = .5 * d * v + _, s = new t1.Point(-100, -100), a = new t1.Point(this.screenRightBoundary, this.screenBottomBoundary), o = new ot, r = b.first, n = b.last;
                    let h = [];
                    for(let t1 = r.path.length - 1; t1 >= 1; t1--)h.push(r.path[t1]);
                    for(let t1 = 1; t1 < n.path.length; t1++)h.push(n.path[t1]);
                    const f = 2.5 * i;
                    if (l) {
                        const t1 = h.map((t1)=>ht(t1, l, m));
                        h = t1.some((t1)=>t1.signedDistanceFromCamera <= 0) ? [] : t1.map((t1)=>t1.point);
                    }
                    let g = [];
                    if (h.length > 0) {
                        const e1 = h[0].clone(), i = h[0].clone();
                        for(let t1 = 1; t1 < h.length; t1++)e1.x = Math.min(e1.x, h[t1].x), e1.y = Math.min(e1.y, h[t1].y), i.x = Math.max(i.x, h[t1].x), i.y = Math.max(i.y, h[t1].y);
                        g = e1.x >= s.x && i.x <= a.x && e1.y >= s.y && i.y <= a.y ? [
                            h
                        ] : i.x < s.x || e1.x > a.x || i.y < s.y || e1.y > a.y ? [] : t1.clipLine([
                            h
                        ], s.x, s.y, a.x, a.y);
                    }
                    for (const t1 of g){
                        o.reset(t1, .25 * i);
                        let s = 0;
                        s = o.length <= .5 * i ? 1 : Math.ceil(o.paddedLength / f) + 1;
                        for(let t1 = 0; t1 < s; t1++){
                            const a = t1 / Math.max(s - 1, 1), r = o.lerp(a), n = r.x + It, l = r.y + It;
                            p.push(n, l, i, 0);
                            const h = n - i, d = l - i, _ = n + i, m = l + i;
                            if (E = E && this.isOffscreen(h, d, _, m), T = T || this.isInsideGrid(h, d, _, m), "always" !== e1 && this.grid.hitTestCircle(n, l, i, e1, u) && (w = !0, !c)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: w
                            };
                        }
                    }
                }
                return {
                    circles: !c && w || !T || v < this.perspectiveRatioCutoff ? [] : p,
                    offscreen: E,
                    collisionDetected: w
                };
            }
            queryRenderedSymbols(e1) {
                if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let s = 1 / 0, a = 1 / 0, o = -1 / 0, r = -1 / 0;
                for (const n of e1){
                    const e1 = new t1.Point(n.x + It, n.y + It);
                    s = Math.min(s, e1.x), a = Math.min(a, e1.y), o = Math.max(o, e1.x), r = Math.max(r, e1.y), i.push(e1);
                }
                const n = this.grid.query(s, a, o, r).concat(this.ignoredGrid.query(s, a, o, r)), l = {}, c = {};
                for (const e1 of n){
                    const s = e1.key;
                    if (void 0 === l[s.bucketInstanceId] && (l[s.bucketInstanceId] = {}), l[s.bucketInstanceId][s.featureIndex]) continue;
                    const a = [
                        new t1.Point(e1.x1, e1.y1),
                        new t1.Point(e1.x2, e1.y1),
                        new t1.Point(e1.x2, e1.y2),
                        new t1.Point(e1.x1, e1.y2)
                    ];
                    t1.polygonIntersectsPolygon(i, a) && (l[s.bucketInstanceId][s.featureIndex] = !0, void 0 === c[s.bucketInstanceId] && (c[s.bucketInstanceId] = []), c[s.bucketInstanceId].push(s.featureIndex));
                }
                return c;
            }
            insertCollisionBox(t1, e1, i, s, a, o) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: s,
                    featureIndex: a,
                    collisionGroupID: o,
                    overlapMode: e1
                }, t1[0], t1[1], t1[2], t1[3]);
            }
            insertCollisionCircles(t1, e1, i, s, a, o) {
                const r = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: s,
                    featureIndex: a,
                    collisionGroupID: o,
                    overlapMode: e1
                };
                for(let e1 = 0; e1 < t1.length; e1 += 4)r.insertCircle(n, t1[e1], t1[e1 + 1], t1[e1 + 2]);
            }
            projectAndGetPerspectiveRatio(e1, i, s, a) {
                let o;
                return a ? (o = [
                    i,
                    s,
                    a(i, s),
                    1
                ], t1.transformMat4(o, o, e1)) : (o = [
                    i,
                    s,
                    0,
                    1
                ], Et(o, o, e1)), {
                    point: new t1.Point((o[0] / o[3] + 1) / 2 * this.transform.width + It, (-o[1] / o[3] + 1) / 2 * this.transform.height + It),
                    perspectiveRatio: .5 + this.transform.cameraToCenterDistance / o[3] * .5
                };
            }
            isOffscreen(t1, e1, i, s) {
                return i < It || t1 >= this.screenRightBoundary || s < It || e1 > this.screenBottomBoundary;
            }
            isInsideGrid(t1, e1, i, s) {
                return i >= 0 && t1 < this.gridRightBoundary && s >= 0 && e1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e1 = t1.identity([]);
                return t1.translate(e1, e1, [
                    -100,
                    -100,
                    0
                ]), e1;
            }
        }
        function Ct(e1, i, s) {
            return i * (t1.EXTENT / (e1.tileSize * Math.pow(2, s - e1.tileID.overscaledZ)));
        }
        class Pt {
            constructor(t1, e1, i, s){
                this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : s && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Dt {
            constructor(t1, e1, i, s, a){
                this.text = new Pt(t1 ? t1.text : null, e1, i, a), this.icon = new Pt(t1 ? t1.icon : null, e1, s, a);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class zt {
            constructor(t1, e1, i){
                this.text = t1, this.icon = e1, this.skipFade = i;
            }
        }
        class Mt {
            constructor(){
                this.invProjMatrix = t1.create(), this.viewportMatrix = t1.create(), this.circles = [];
            }
        }
        class At {
            constructor(t1, e1, i, s, a){
                this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = i, this.bucketIndex = s, this.tileID = a;
            }
        }
        class Lt {
            constructor(t1){
                this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(t1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[t1]) {
                    const e1 = ++this.maxGroupID;
                    this.collisionGroups[t1] = {
                        ID: e1,
                        predicate: (t1)=>t1.collisionGroupID === e1
                    };
                }
                return this.collisionGroups[t1];
            }
        }
        function Rt(e1, i, s, a, o) {
            const { horizontalAlign: r, verticalAlign: n } = t1.getAnchorAlignment(e1), l = -(r - .5) * i, c = -(n - .5) * s, h = t1.evaluateVariableOffset(e1, a);
            return new t1.Point(l + h[0] * o, c + h[1] * o);
        }
        function kt(e1, i, s, a, o, r) {
            const { x1: n, x2: l, y1: c, y2: h, anchorPointX: u, anchorPointY: d } = e1, _ = new t1.Point(i, s);
            return a && _._rotate(o ? r : -r), {
                x1: n + _.x,
                y1: c + _.y,
                x2: l + _.x,
                y2: h + _.y,
                anchorPointX: u,
                anchorPointY: d
            };
        }
        class Bt {
            constructor(t1, e1, i, s, a){
                this.transform = t1.clone(), this.terrain = e1, this.collisionIndex = new St(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new Lt(s), this.collisionCircleArrays = {}, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(e1, i, s, a) {
                const o = s.getBucket(i), r = s.latestFeatureIndex;
                if (!o || !r || i.id !== o.layerIds[0]) return;
                const n = s.collisionBoxArray, l = o.layers[0].layout, c = Math.pow(2, this.transform.zoom - s.tileID.overscaledZ), h = s.tileSize / t1.EXTENT, u = this.transform.calculatePosMatrix(s.tileID.toUnwrapped()), d = "map" === l.get("text-pitch-alignment"), _ = "map" === l.get("text-rotation-alignment"), m = Ct(s, 1, this.transform.zoom), p = lt(u, d, _, this.transform, m);
                let f = null;
                if (d) {
                    const e1 = ct(u, d, _, this.transform, m);
                    f = t1.multiply([], this.transform.labelPlaneMatrix, e1);
                }
                this.retainedQueryData[o.bucketInstanceId] = new At(o.bucketInstanceId, r, o.sourceLayerIndex, o.index, s.tileID);
                const g = {
                    bucket: o,
                    layout: l,
                    posMatrix: u,
                    textLabelPlaneMatrix: p,
                    labelToScreenMatrix: f,
                    scale: c,
                    textPixelRatio: h,
                    holdingForFade: s.holdingForFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t1.evaluateSizeForZoom(o.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(o.sourceID)
                };
                if (a) for (const t1 of o.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: s, symbolInstanceEnd: a } = t1;
                    e1.push({
                        sortKey: i,
                        symbolInstanceStart: s,
                        symbolInstanceEnd: a,
                        parameters: g
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: o.symbolInstances.length,
                    parameters: g
                });
            }
            attemptAnchorPlacement(t1, e1, i, s, a, o, r, n, l, c, h, u, d, _, m, p) {
                const f = [
                    u.textOffset0,
                    u.textOffset1
                ], g = Rt(t1, i, s, f, a), v = this.collisionIndex.placeCollisionBox(kt(e1, g.x, g.y, o, r, this.transform.angle), h, n, l, c.predicate, p);
                if ((!m || 0 !== this.collisionIndex.placeCollisionBox(kt(m, g.x, g.y, o, r, this.transform.angle), h, n, l, c.predicate, p).box.length) && v.box.length > 0) {
                    let e1;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[u.crossTileID] && this.prevPlacement.placements[u.crossTileID] && this.prevPlacement.placements[u.crossTileID].text && (e1 = this.prevPlacement.variableOffsets[u.crossTileID].anchor), 0 === u.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[u.crossTileID] = {
                        textOffset: f,
                        width: i,
                        height: s,
                        anchor: t1,
                        textBoxScale: a,
                        prevAnchor: e1
                    }, this.markUsedJustification(d, t1, u, _), d.allowVerticalPlacement && (this.markUsedOrientation(d, _, u), this.placedOrientations[u.crossTileID] = _), {
                        shift: g,
                        placedGlyphBoxes: v
                    };
                }
            }
            placeLayerBucketPart(e1, i, s) {
                const { bucket: a, layout: o, posMatrix: r, textLabelPlaneMatrix: n, labelToScreenMatrix: l, textPixelRatio: c, holdingForFade: h, collisionBoxArray: u, partiallyEvaluatedTextSize: d, collisionGroup: _ } = e1.parameters, m = o.get("text-optional"), p = o.get("icon-optional"), f = t1.getOverlapMode(o, "text-overlap", "text-allow-overlap"), g = "always" === f, v = t1.getOverlapMode(o, "icon-overlap", "icon-allow-overlap"), x = "always" === v, y = "map" === o.get("text-rotation-alignment"), b = "map" === o.get("text-pitch-alignment"), w = "none" !== o.get("icon-text-fit"), T = "viewport-y" === o.get("symbol-z-order"), E = g && (x || !a.hasIconData() || p), I = x && (g || !a.hasTextData() || m);
                !a.collisionArrays && u && a.deserializeCollisionBoxes(u);
                const S = this.retainedQueryData[a.bucketInstanceId].tileID, C = this.terrain ? (t1, e1)=>this.terrain.getElevation(S, t1, e1) : null, P = (e1, u)=>{
                    if (i[e1.crossTileID]) return;
                    if (h) return void (this.placements[e1.crossTileID] = new zt(!1, !1, !1));
                    let x = !1, T = !1, S = !0, P = null, D = {
                        box: null,
                        offscreen: null
                    }, z = {
                        box: null,
                        offscreen: null
                    }, M = null, A = null, L = null, R = 0, k = 0, B = 0;
                    u.textFeatureIndex ? R = u.textFeatureIndex : e1.useRuntimeCollisionCircles && (R = e1.featureIndex), u.verticalTextFeatureIndex && (k = u.verticalTextFeatureIndex);
                    const F = u.textBox;
                    if (F) {
                        const i = (i)=>{
                            let s = t1.WritingMode.horizontal;
                            if (a.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t1 = this.prevPlacement.placedOrientations[e1.crossTileID];
                                t1 && (this.placedOrientations[e1.crossTileID] = t1, s = t1, this.markUsedOrientation(a, s, e1));
                            }
                            return s;
                        }, s = (i, s)=>{
                            if (a.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && u.verticalTextBox) {
                                for (const e1 of a.writingModes)if (e1 === t1.WritingMode.vertical ? (D = s(), z = D) : D = i(), D && D.box && D.box.length) break;
                            } else D = i();
                        };
                        if (o.get("text-variable-anchor")) {
                            let n = o.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[e1.crossTileID]) {
                                const t1 = this.prevPlacement.variableOffsets[e1.crossTileID];
                                n.indexOf(t1.anchor) > 0 && (n = n.filter((e1)=>e1 !== t1.anchor), n.unshift(t1.anchor));
                            }
                            const l = (t1, i, s)=>{
                                const o = t1.x2 - t1.x1, l = t1.y2 - t1.y1, h = e1.textBoxScale, u = w && "never" === v ? i : null;
                                let d = {
                                    box: [],
                                    offscreen: !1
                                };
                                const m = "never" !== f ? 2 * n.length : n.length;
                                for(let i = 0; i < m; ++i){
                                    const m = this.attemptAnchorPlacement(n[i % n.length], t1, o, l, h, y, b, c, r, _, i >= n.length ? f : "never", e1, a, s, u, C);
                                    if (m && (d = m.placedGlyphBoxes, d && d.box && d.box.length)) {
                                        x = !0, P = m.shift;
                                        break;
                                    }
                                }
                                return d;
                            };
                            s(()=>l(F, u.iconBox, t1.WritingMode.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && !(D && D.box && D.box.length) && e1.numVerticalGlyphVertices > 0 && i ? l(i, u.verticalIconBox, t1.WritingMode.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), D && (x = D.box, S = D.offscreen);
                            const h = i(D && D.box);
                            if (!x && this.prevPlacement) {
                                const t1 = this.prevPlacement.variableOffsets[e1.crossTileID];
                                t1 && (this.variableOffsets[e1.crossTileID] = t1, this.markUsedJustification(a, t1.anchor, e1, h));
                            }
                        } else {
                            const o = (t1, i)=>{
                                const s = this.collisionIndex.placeCollisionBox(t1, f, c, r, _.predicate, C);
                                return s && s.box && s.box.length && (this.markUsedOrientation(a, i, e1), this.placedOrientations[e1.crossTileID] = i), s;
                            };
                            s(()=>o(F, t1.WritingMode.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && i ? o(i, t1.WritingMode.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(D && D.box && D.box.length);
                        }
                    }
                    if (M = D, x = M && M.box && M.box.length > 0, S = M && M.offscreen, e1.useRuntimeCollisionCircles) {
                        const i = a.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), c = t1.evaluateSizeForFeature(a.textSizeData, d, i), h = o.get("text-padding");
                        A = this.collisionIndex.placeCollisionCircles(f, i, a.lineVertexArray, a.glyphOffsetArray, c, r, n, l, s, b, _.predicate, e1.collisionCircleDiameter, h, C), A.circles.length && A.collisionDetected && !s && t1.warnOnce("Collisions detected, but collision boxes are not shown"), x = g || A.circles.length > 0 && !A.collisionDetected, S = S && A.offscreen;
                    }
                    if (u.iconFeatureIndex && (B = u.iconFeatureIndex), u.iconBox) {
                        const t1 = (t1)=>{
                            const e1 = w && P ? kt(t1, P.x, P.y, y, b, this.transform.angle) : t1;
                            return this.collisionIndex.placeCollisionBox(e1, v, c, r, _.predicate, C);
                        };
                        z && z.box && z.box.length && u.verticalIconBox ? (L = t1(u.verticalIconBox), T = L.box.length > 0) : (L = t1(u.iconBox), T = L.box.length > 0), S = S && L.offscreen;
                    }
                    const U = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, O = p || 0 === e1.numIconVertices;
                    if (U || O ? O ? U || (T = T && x) : x = T && x : T = x = T && x, x && M && M.box && this.collisionIndex.insertCollisionBox(M.box, f, o.get("text-ignore-placement"), a.bucketInstanceId, z && z.box && k ? k : R, _.ID), T && L && this.collisionIndex.insertCollisionBox(L.box, v, o.get("icon-ignore-placement"), a.bucketInstanceId, B, _.ID), A && (x && this.collisionIndex.insertCollisionCircles(A.circles, f, o.get("text-ignore-placement"), a.bucketInstanceId, R, _.ID), s)) {
                        const t1 = a.bucketInstanceId;
                        let e1 = this.collisionCircleArrays[t1];
                        void 0 === e1 && (e1 = this.collisionCircleArrays[t1] = new Mt);
                        for(let t1 = 0; t1 < A.circles.length; t1 += 4)e1.circles.push(A.circles[t1 + 0]), e1.circles.push(A.circles[t1 + 1]), e1.circles.push(A.circles[t1 + 2]), e1.circles.push(A.collisionDetected ? 1 : 0);
                    }
                    if (0 === e1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === a.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e1.crossTileID] = new zt(x || E, T || I, S || a.justReloaded), i[e1.crossTileID] = !0;
                };
                if (T) {
                    if (0 !== e1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t1 = a.getSortedSymbolIndexes(this.transform.angle);
                    for(let e1 = t1.length - 1; e1 >= 0; --e1){
                        const i = t1[e1];
                        P(a.symbolInstances.get(i), a.collisionArrays[i]);
                    }
                } else for(let t1 = e1.symbolInstanceStart; t1 < e1.symbolInstanceEnd; t1++)P(a.symbolInstances.get(t1), a.collisionArrays[t1]);
                if (s && a.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[a.bucketInstanceId];
                    t1.invert(e1.invProjMatrix, r), e1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                a.justReloaded = !1;
            }
            markUsedJustification(e1, i, s, a) {
                let o;
                o = a === t1.WritingMode.vertical ? s.verticalPlacedTextSymbolIndex : ({
                    left: s.leftJustifiedTextSymbolIndex,
                    center: s.centerJustifiedTextSymbolIndex,
                    right: s.rightJustifiedTextSymbolIndex
                })[t1.getAnchorJustification(i)];
                const r = [
                    s.leftJustifiedTextSymbolIndex,
                    s.centerJustifiedTextSymbolIndex,
                    s.rightJustifiedTextSymbolIndex,
                    s.verticalPlacedTextSymbolIndex
                ];
                for (const t1 of r)t1 >= 0 && (e1.text.placedSymbolArray.get(t1).crossTileID = o >= 0 && t1 !== o ? 0 : s.crossTileID);
            }
            markUsedOrientation(e1, i, s) {
                const a = i === t1.WritingMode.horizontal || i === t1.WritingMode.horizontalOnly ? i : 0, o = i === t1.WritingMode.vertical ? i : 0, r = [
                    s.leftJustifiedTextSymbolIndex,
                    s.centerJustifiedTextSymbolIndex,
                    s.rightJustifiedTextSymbolIndex
                ];
                for (const t1 of r)e1.text.placedSymbolArray.get(t1).placedOrientation = a;
                s.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(s.verticalPlacedTextSymbolIndex).placedOrientation = o);
            }
            commit(t1) {
                this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const e1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
                const s = e1 ? e1.symbolFadeChange(t1) : 1, a = e1 ? e1.opacities : {}, o = e1 ? e1.variableOffsets : {}, r = e1 ? e1.placedOrientations : {};
                for(const t1 in this.placements){
                    const e1 = this.placements[t1], o = a[t1];
                    o ? (this.opacities[t1] = new Dt(o, s, e1.text, e1.icon), i = i || e1.text !== o.text.placed || e1.icon !== o.icon.placed) : (this.opacities[t1] = new Dt(null, s, e1.text, e1.icon, e1.skipFade), i = i || e1.text || e1.icon);
                }
                for(const t1 in a){
                    const e1 = a[t1];
                    if (!this.opacities[t1]) {
                        const a = new Dt(e1, s, !1, !1);
                        a.isHidden() || (this.opacities[t1] = a, i = i || e1.text.placed || e1.icon.placed);
                    }
                }
                for(const t1 in o)this.variableOffsets[t1] || !this.opacities[t1] || this.opacities[t1].isHidden() || (this.variableOffsets[t1] = o[t1]);
                for(const t1 in r)this.placedOrientations[t1] || !this.opacities[t1] || this.opacities[t1].isHidden() || (this.placedOrientations[t1] = r[t1]);
                if (e1 && void 0 === e1.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
            }
            updateLayerOpacities(t1, e1) {
                const i = {};
                for (const s of e1){
                    const e1 = s.getBucket(t1);
                    e1 && s.latestFeatureIndex && t1.id === e1.layerIds[0] && this.updateBucketOpacities(e1, i, s.collisionBoxArray);
                }
            }
            updateBucketOpacities(e1, i, s) {
                e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                const a = e1.layers[0].layout, o = new Dt(null, 0, !1, !1, !0), r = a.get("text-allow-overlap"), n = a.get("icon-allow-overlap"), l = a.get("text-variable-anchor"), c = "map" === a.get("text-rotation-alignment"), h = "map" === a.get("text-pitch-alignment"), u = "none" !== a.get("icon-text-fit"), d = new Dt(null, 0, r && (n || !e1.hasIconData() || a.get("icon-optional")), n && (r || !e1.hasTextData() || a.get("text-optional")), !0);
                !e1.collisionArrays && s && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(s);
                const _ = (t1, e1, i)=>{
                    for(let s = 0; s < e1 / 4; s++)t1.opacityVertexArray.emplaceBack(i);
                    t1.hasVisibleVertices = t1.hasVisibleVertices || i !== $t;
                };
                for(let s = 0; s < e1.symbolInstances.length; s++){
                    const a = e1.symbolInstances.get(s), { numHorizontalGlyphVertices: r, numVerticalGlyphVertices: n, crossTileID: m } = a;
                    let p = this.opacities[m];
                    i[m] ? p = o : p || (p = d, this.opacities[m] = p), i[m] = !0;
                    const f = a.numIconVertices > 0, g = this.placedOrientations[a.crossTileID], v = g === t1.WritingMode.vertical, x = g === t1.WritingMode.horizontal || g === t1.WritingMode.horizontalOnly;
                    if (r > 0 || n > 0) {
                        const t1 = jt(p.text);
                        _(e1.text, r, v ? $t : t1), _(e1.text, n, x ? $t : t1);
                        const i = p.text.isHidden();
                        [
                            a.rightJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.leftJustifiedTextSymbolIndex
                        ].forEach((t1)=>{
                            t1 >= 0 && (e1.text.placedSymbolArray.get(t1).hidden = i || v ? 1 : 0);
                        }), a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = i || x ? 1 : 0);
                        const s = this.variableOffsets[a.crossTileID];
                        s && this.markUsedJustification(e1, s.anchor, a, g);
                        const o = this.placedOrientations[a.crossTileID];
                        o && (this.markUsedJustification(e1, "left", a, o), this.markUsedOrientation(e1, o, a));
                    }
                    if (f) {
                        const t1 = jt(p.icon), i = !(u && a.verticalPlacedIconSymbolIndex && v);
                        a.placedIconSymbolIndex >= 0 && (_(e1.icon, a.numIconVertices, i ? t1 : $t), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = p.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (_(e1.icon, a.numVerticalIconVertices, i ? $t : t1), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = p.icon.isHidden());
                    }
                    if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                        const i = e1.collisionArrays[s];
                        if (i) {
                            let s = new t1.Point(0, 0);
                            if (i.textBox || i.verticalTextBox) {
                                let t1 = !0;
                                if (l) {
                                    const e1 = this.variableOffsets[m];
                                    e1 ? (s = Rt(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), c && s._rotate(h ? this.transform.angle : -this.transform.angle)) : t1 = !1;
                                }
                                i.textBox && Ft(e1.textCollisionBox.collisionVertexArray, p.text.placed, !t1 || v, s.x, s.y), i.verticalTextBox && Ft(e1.textCollisionBox.collisionVertexArray, p.text.placed, !t1 || x, s.x, s.y);
                            }
                            const a = Boolean(!x && i.verticalIconBox);
                            i.iconBox && Ft(e1.iconCollisionBox.collisionVertexArray, p.icon.placed, a, u ? s.x : 0, u ? s.y : 0), i.verticalIconBox && Ft(e1.iconCollisionBox.collisionVertexArray, p.icon.placed, !a, u ? s.x : 0, u ? s.y : 0);
                        }
                    }
                }
                if (e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
                if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
                if (e1.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[e1.bucketInstanceId];
                    e1.placementInvProjMatrix = t1.invProjMatrix, e1.placementViewportMatrix = t1.viewportMatrix, e1.collisionCircleArray = t1.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
                }
            }
            symbolFadeChange(t1) {
                return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(t1) {
                return Math.max(0, (this.transform.zoom - t1) / 1.5);
            }
            hasTransitions(t1) {
                return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(t1, e1) {
                const i = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
                return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * i > t1;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function Ft(t1, e1, i, s, a) {
            t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t1.emplaceBack(e1 ? 1 : 0, i ? 1 : 0, s || 0, a || 0);
        }
        const Ut = Math.pow(2, 25), Ot = Math.pow(2, 24), Nt = Math.pow(2, 17), Gt = Math.pow(2, 16), Zt = Math.pow(2, 9), Vt = Math.pow(2, 8), qt = Math.pow(2, 1);
        function jt(t1) {
            if (0 === t1.opacity && !t1.placed) return 0;
            if (1 === t1.opacity && t1.placed) return 4294967295;
            const e1 = t1.placed ? 1 : 0, i = Math.floor(127 * t1.opacity);
            return i * Ut + e1 * Ot + i * Nt + e1 * Gt + i * Zt + e1 * Vt + i * qt + e1;
        }
        const $t = 0;
        class Xt {
            constructor(t1){
                this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && !t1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(t1, e1, i, s, a) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < t1.length;)if (e1.getBucketParts(o, s, t1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, a()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((t1, e1)=>t1.sortKey - e1.sortKey)); this._currentPartIndex < o.length;)if (e1.placeLayerBucketPart(o[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, a()) return !0;
                return !1;
            }
        }
        class Wt {
            constructor(t1, e1, i, s, a, o, r, n){
                this.placement = new Bt(t1, e1, o, r, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = s, this._showCollisionBoxes = a, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e1, i, s) {
                const a = t1.exported.now(), o = ()=>!this._forceFullPlacement && t1.exported.now() - a > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const t1 = i[e1[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === t1.type && (!t1.minzoom || t1.minzoom <= a) && (!t1.maxzoom || t1.maxzoom > a)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new Xt(t1)), this._inProgressLayer.continuePlacement(s[t1.source], this.placement, this._showCollisionBoxes, t1, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(t1) {
                return this.placement.commit(t1), this.placement;
            }
        }
        const Ht = 512 / t1.EXTENT / 2;
        class Kt {
            constructor(e1, i, s){
                this.tileID = e1, this.bucketInstanceId = s, this._symbolsByKey = {};
                const a = new Map;
                for(let t1 = 0; t1 < i.length; t1++){
                    const e1 = i.get(t1), s = e1.key, o = a.get(s);
                    o ? o.push(e1) : a.set(s, [
                        e1
                    ]);
                }
                for (const [e1, i] of a){
                    const s = {
                        positions: i.map((t1)=>({
                                x: Math.floor(t1.anchorX * Ht),
                                y: Math.floor(t1.anchorY * Ht)
                            })),
                        crossTileIDs: i.map((t1)=>t1.crossTileID)
                    };
                    if (s.positions.length > 128) {
                        const e1 = new t1.KDBush(s.positions.length, 16, Uint16Array);
                        for (const { x: t1, y: i } of s.positions)e1.add(t1, i);
                        e1.finish(), delete s.positions, s.index = e1;
                    }
                    this._symbolsByKey[e1] = s;
                }
            }
            getScaledCoordinates(e1, i) {
                const { x: s, y: a, z: o } = this.tileID.canonical, { x: r, y: n, z: l } = i.canonical, c = Ht / Math.pow(2, l - o), h = (n * t1.EXTENT + e1.anchorY) * c, u = a * t1.EXTENT * Ht;
                return {
                    x: Math.floor((r * t1.EXTENT + e1.anchorX) * c - s * t1.EXTENT * Ht),
                    y: Math.floor(h - u)
                };
            }
            findMatches(t1, e1, i) {
                const s = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z);
                for(let a = 0; a < t1.length; a++){
                    const o = t1.get(a);
                    if (o.crossTileID) continue;
                    const r = this._symbolsByKey[o.key];
                    if (!r) continue;
                    const n = this.getScaledCoordinates(o, e1);
                    if (r.index) {
                        const t1 = r.index.range(n.x - s, n.y - s, n.x + s, n.y + s).sort();
                        for (const e1 of t1){
                            const t1 = r.crossTileIDs[e1];
                            if (!i[t1]) {
                                i[t1] = !0, o.crossTileID = t1;
                                break;
                            }
                        }
                    } else if (r.positions) for(let t1 = 0; t1 < r.positions.length; t1++){
                        const e1 = r.positions[t1], a = r.crossTileIDs[t1];
                        if (Math.abs(e1.x - n.x) <= s && Math.abs(e1.y - n.y) <= s && !i[a]) {
                            i[a] = !0, o.crossTileID = a;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: t1 })=>t1);
            }
        }
        class Yt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Jt {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(t1) {
                const e1 = Math.round((t1 - this.lng) / 360);
                if (0 !== e1) for(const t1 in this.indexes){
                    const i = this.indexes[t1], s = {};
                    for(const t1 in i){
                        const a = i[t1];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + e1), s[a.tileID.key] = a;
                    }
                    this.indexes[t1] = s;
                }
                this.lng = t1;
            }
            addBucket(t1, e1, i) {
                if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                    if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
                }
                for(let t1 = 0; t1 < e1.symbolInstances.length; t1++)e1.symbolInstances.get(t1).crossTileID = 0;
                this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
                const s = this.usedCrossTileIDs[t1.overscaledZ];
                for(const i in this.indexes){
                    const a = this.indexes[i];
                    if (Number(i) > t1.overscaledZ) for(const i in a){
                        const o = a[i];
                        o.tileID.isChildOf(t1) && o.findMatches(e1.symbolInstances, t1, s);
                    }
                    else {
                        const o = a[t1.scaledTo(Number(i)).key];
                        o && o.findMatches(e1.symbolInstances, t1, s);
                    }
                }
                for(let t1 = 0; t1 < e1.symbolInstances.length; t1++){
                    const a = e1.symbolInstances.get(t1);
                    a.crossTileID || (a.crossTileID = i.generate(), s[a.crossTileID] = !0);
                }
                return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new Kt(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(t1, e1) {
                for (const i of e1.getCrossTileIDsLists())for (const e1 of i)delete this.usedCrossTileIDs[t1][e1];
            }
            removeStaleBuckets(t1) {
                let e1 = !1;
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    for(const a in s)t1[s[a].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, s[a]), delete s[a], e1 = !0);
                }
                return e1;
            }
        }
        class Qt {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Yt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(t1, e1, i) {
                let s = this.layerIndexes[t1.id];
                void 0 === s && (s = this.layerIndexes[t1.id] = new Jt);
                let a = !1;
                const o = {};
                s.handleWrapJump(i);
                for (const i of e1){
                    const e1 = i.getBucket(t1);
                    e1 && t1.id === e1.layerIds[0] && (e1.bucketInstanceId || (e1.bucketInstanceId = ++this.maxBucketInstanceId), s.addBucket(i.tileID, e1, this.crossTileIDs) && (a = !0), o[e1.bucketInstanceId] = !0);
                }
                return s.removeStaleBuckets(o) && (a = !0), a;
            }
            pruneUnusedLayers(t1) {
                const e1 = {};
                t1.forEach((t1)=>{
                    e1[t1] = !0;
                });
                for(const t1 in this.layerIndexes)e1[t1] || delete this.layerIndexes[t1];
            }
        }
        const te = (e1, i)=>t1.emitValidationErrors(e1, i && i.filter((t1)=>"source.canvas" !== t1.identifier)), ee = t1.pick(t1.operations, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setGlyphs",
            "setSprite"
        ]), ie = t1.pick(t1.operations, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), se = t1.emptyStyle();
        class ae extends t1.Evented {
            constructor(e1, i = {}){
                super(), this.map = e1, this.dispatcher = new A(at(), this, e1._getMapId()), this.imageManager = new w, this.imageManager.setEventedParent(this), this.glyphManager = new S(e1._requestManager, i.localIdeographFontFamily), this.lineAtlas = new M(256, 512), this.crossTileSymbolIndex = new Qt, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t1.getReferrer());
                const s = this;
                this._rtlTextPluginCallback = ae.registerForPluginStateChange((e1)=>{
                    s.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e1.pluginStatus,
                        pluginURL: e1.pluginURL
                    }, (e1, i)=>{
                        if (t1.triggerPluginCompletionEvent(e1), i && i.every((t1)=>t1)) for(const t1 in s.sourceCaches){
                            const e1 = s.sourceCaches[t1].getSource().type;
                            "vector" !== e1 && "geojson" !== e1 || s.sourceCaches[t1].reload();
                        }
                    });
                }), this.on("data", (t1)=>{
                    if ("source" !== t1.dataType || "metadata" !== t1.sourceDataType) return;
                    const e1 = this.sourceCaches[t1.sourceId];
                    if (!e1) return;
                    const i = e1.getSource();
                    if (i && i.vectorLayerIds) for(const t1 in this._layers){
                        const e1 = this._layers[t1];
                        e1.source === i.id && this._validateLayer(e1);
                    }
                });
            }
            loadURL(e1, i = {}, s) {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), i.validate = "boolean" != typeof i.validate || i.validate;
                const a = this.map._requestManager.transformRequest(e1, h.Style);
                this._request = t1.getJSON(a, (e1, a)=>{
                    this._request = null, e1 ? this.fire(new t1.ErrorEvent(e1)) : a && this._load(a, i, s);
                });
            }
            loadJSON(e1, i = {}, s) {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._request = t1.exported.frame(()=>{
                    this._request = null, i.validate = !1 !== i.validate, this._load(e1, i, s);
                });
            }
            loadEmpty() {
                this.fire(new t1.Event("dataloading", {
                    dataType: "style"
                })), this._load(se, {
                    validate: !1
                });
            }
            _load(e1, i, s) {
                const a = i.transformStyle ? i.transformStyle(s, e1) : e1;
                if (!i.validate || !te(this, t1.validateStyle(a))) {
                    this._loaded = !0, this.stylesheet = a;
                    for(const t1 in a.sources)this.addSource(t1, a.sources[t1], {
                        validate: !1
                    });
                    a.sprite ? this._loadSprite(a.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(a.glyphs), this._createLayers(), this.light = new z(this.stylesheet.light), this.map.setTerrain(this.stylesheet.terrain), this.fire(new t1.Event("data", {
                        dataType: "style"
                    })), this.fire(new t1.Event("style.load"));
                }
            }
            _createLayers() {
                const e1 = t1.derefLayers(this.stylesheet.layers);
                this.dispatcher.broadcast("setLayers", e1), this._order = e1.map((t1)=>t1.id), this._layers = {}, this._serializedLayers = null;
                for (const i of e1){
                    const e1 = t1.createStyleLayer(i);
                    e1.setEventedParent(this, {
                        layer: {
                            id: i.id
                        }
                    }), this._layers[i.id] = e1;
                }
            }
            _loadSprite(e1, i = !1, s) {
                this.imageManager.setLoaded(!1), this._spriteRequest = function(e1, i, s, a) {
                    const o = v(e1), r = o.length, n = s > 1 ? "@2x" : "", l = {}, c = {}, d = {};
                    for (const { id: e1, url: s } of o){
                        const o = i.transformRequest(i.normalizeSpriteURL(s, n, ".json"), h.SpriteJSON), _ = `${e1}_${o.url}`;
                        l[_] = t1.getJSON(o, (t1, i)=>{
                            delete l[_], c[e1] = i, x(a, c, d, t1, r);
                        });
                        const m = i.transformRequest(i.normalizeSpriteURL(s, n, ".png"), h.SpriteImage), p = `${e1}_${m.url}`;
                        l[p] = u.getImage(m, (t1, i)=>{
                            delete l[p], d[e1] = i, x(a, c, d, t1, r);
                        });
                    }
                    return {
                        cancel () {
                            for (const t1 of Object.values(l))t1.cancel();
                        }
                    };
                }(e1, this.map._requestManager, this.map.getPixelRatio(), (e1, a)=>{
                    if (this._spriteRequest = null, e1) this.fire(new t1.ErrorEvent(e1));
                    else if (a) for(const t1 in a){
                        this._spritesImagesIds[t1] = [];
                        const e1 = this._spritesImagesIds[t1] ? this._spritesImagesIds[t1].filter((t1)=>!(t1 in a)) : [];
                        for (const t1 of e1)this.imageManager.removeImage(t1), this._changedImages[t1] = !0;
                        for(const e1 in a[t1]){
                            const s = "default" === t1 ? e1 : `${t1}:${e1}`;
                            this._spritesImagesIds[t1].push(s), s in this.imageManager.images ? this.imageManager.updateImage(s, a[t1][e1], !1) : this.imageManager.addImage(s, a[t1][e1]), i && (this._changedImages[s] = !0);
                        }
                    }
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                        dataType: "style"
                    })), s && s(e1);
                });
            }
            _unloadSprite() {
                for (const t1 of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(t1), this._changedImages[t1] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(e1) {
                const i = this.sourceCaches[e1.source];
                if (!i) return;
                const s = e1.sourceLayer;
                if (!s) return;
                const a = i.getSource();
                ("geojson" === a.type || a.vectorLayerIds && -1 === a.vectorLayerIds.indexOf(s)) && this.fire(new t1.ErrorEvent(new Error(`Source layer "${s}" does not exist on source "${a.id}" as specified by style layer "${e1.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeByIds(t1) {
                const e1 = this._serializedAllLayers();
                if (!t1 || 0 === t1.length) return Object.values(e1);
                const i = [];
                for (const s of t1)e1[s] && i.push(e1[s]);
                return i;
            }
            _serializedAllLayers() {
                let t1 = this._serializedLayers;
                if (t1) return t1;
                t1 = this._serializedLayers = {};
                const e1 = Object.keys(this._layers);
                for (const i of e1){
                    const e1 = this._layers[i];
                    "custom" !== e1.type && (t1[i] = e1.serialize());
                }
                return t1;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                for(const t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                for(const t1 in this._layers)if (this._layers[t1].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e1) {
                if (!this._loaded) return;
                const i = this._changed;
                if (this._changed) {
                    const t1 = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t1.length || i.length) && this._updateWorkerLayers(t1, i);
                    for(const t1 in this._updatedSources){
                        const e1 = this._updatedSources[t1];
                        if ("reload" === e1) this._reloadSource(t1);
                        else {
                            if ("clear" !== e1) throw new Error(`Invalid action ${e1}`);
                            this._clearSource(t1);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const t1 in this._updatedPaintProps)this._layers[t1].updateTransitions(e1);
                    this.light.updateTransitions(e1), this._resetUpdates();
                }
                const s = {};
                for(const t1 in this.sourceCaches){
                    const e1 = this.sourceCaches[t1];
                    s[t1] = e1.used, e1.used = !1;
                }
                for (const t1 of this._order){
                    const i = this._layers[t1];
                    i.recalculate(e1, this._availableImages), !i.isHidden(e1.zoom) && i.source && (this.sourceCaches[i.source].used = !0);
                }
                for(const e1 in s){
                    const i = this.sourceCaches[e1];
                    s[e1] !== i.used && i.fire(new t1.Event("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e1
                    }));
                }
                this.light.recalculate(e1), this.z = e1.zoom, i && this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const t1 = Object.keys(this._changedImages);
                if (t1.length) {
                    for(const e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t1);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const t1 in this.sourceCaches)this.sourceCaches[t1].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(t1, e1) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeByIds(t1),
                    removedIds: e1
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(e1, i = {}) {
                this._checkLoaded();
                const s = this.serialize();
                if (e1 = i.transformStyle ? i.transformStyle(s, e1) : e1, te(this, t1.validateStyle(e1))) return !1;
                (e1 = t1.clone$1(e1)).layers = t1.derefLayers(e1.layers);
                const a = t1.diffStyles(s, e1).filter((t1)=>!(t1.command in ie));
                if (0 === a.length) return !1;
                const o = a.filter((t1)=>!(t1.command in ee));
                if (o.length > 0) throw new Error(`Unimplemented: ${o.map((t1)=>t1.command).join(", ")}.`);
                for (const t1 of a)"setTransition" !== t1.command && this[t1.command].apply(this, t1.args);
                return this.stylesheet = e1, !0;
            }
            addImage(e1, i) {
                if (this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error(`An image named "${e1}" already exists.`)));
                this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
            }
            updateImage(t1, e1) {
                this.imageManager.updateImage(t1, e1);
            }
            getImage(t1) {
                return this.imageManager.getImage(t1);
            }
            removeImage(e1) {
                if (!this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error(`An image named "${e1}" does not exist.`)));
                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
            }
            _afterImageUpdated(e1) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e1, i, s = {}) {
                if (this._checkLoaded(), void 0 !== this.sourceCaches[e1]) throw new Error(`Source "${e1}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t1.validateStyle.source, `sources.${e1}`, i, null, s)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const a = this.sourceCaches[e1] = new Y(e1, i, this.dispatcher);
                a.style = this, a.setEventedParent(this, ()=>({
                        isSourceLoaded: a.loaded(),
                        source: a.serialize(),
                        sourceId: e1
                    })), a.onAdd(this.map), this._changed = !0;
            }
            removeSource(e1) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e1]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === e1) return this.fire(new t1.ErrorEvent(new Error(`Source "${e1}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.sourceCaches[e1];
                delete this.sourceCaches[e1], delete this._updatedSources[e1], i.fire(new t1.Event("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e1
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(t1, e1) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[t1]) throw new Error(`There is no source with this ID=${t1}`);
                const i = this.sourceCaches[t1].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(e1), this._changed = !0;
            }
            getSource(t1) {
                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
            }
            addLayer(e1, i, s = {}) {
                this._checkLoaded();
                const a = e1.id;
                if (this.getLayer(a)) return void this.fire(new t1.ErrorEvent(new Error(`Layer "${a}" already exists on this map.`)));
                let o;
                if ("custom" === e1.type) {
                    if (te(this, t1.validateCustomStyleLayer(e1))) return;
                    o = t1.createStyleLayer(e1);
                } else {
                    if ("object" == typeof e1.source && (this.addSource(a, e1.source), e1 = t1.clone$1(e1), e1 = t1.extend(e1, {
                        source: a
                    })), this._validate(t1.validateStyle.layer, `layers.${a}`, e1, {
                        arrayIndex: -1
                    }, s)) return;
                    o = t1.createStyleLayer(e1), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: a
                        }
                    });
                }
                const r = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === r) this.fire(new t1.ErrorEvent(new Error(`Cannot add layer "${a}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(r, 0, a), this._layerOrderChanged = !0, this._layers[a] = o, this._removedLayers[a] && o.source && "custom" !== o.type) {
                        const t1 = this._removedLayers[a];
                        delete this._removedLayers[a], t1.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload", this.sourceCaches[o.source].pause());
                    }
                    this._updateLayer(o), o.onAdd && o.onAdd(this.map);
                }
            }
            moveLayer(e1, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) return void this.fire(new t1.ErrorEvent(new Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
                if (e1 === i) return;
                const s = this._order.indexOf(e1);
                this._order.splice(s, 1);
                const a = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === a ? this.fire(new t1.ErrorEvent(new Error(`Cannot move layer "${e1}" before non-existing layer "${i}".`))) : (this._order.splice(a, 0, e1), this._layerOrderChanged = !0);
            }
            removeLayer(e1) {
                this._checkLoaded();
                const i = this._layers[e1];
                if (!i) return void this.fire(new t1.ErrorEvent(new Error(`Cannot remove non-existing layer "${e1}".`)));
                i.setEventedParent(null);
                const s = this._order.indexOf(e1);
                this._order.splice(s, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
            }
            getLayer(t1) {
                return this._layers[t1];
            }
            hasLayer(t1) {
                return t1 in this._layers;
            }
            setLayerZoomRange(e1, i, s) {
                this._checkLoaded();
                const a = this.getLayer(e1);
                a ? a.minzoom === i && a.maxzoom === s || (null != i && (a.minzoom = i), null != s && (a.maxzoom = s), this._updateLayer(a)) : this.fire(new t1.ErrorEvent(new Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            }
            setFilter(e1, i, s = {}) {
                this._checkLoaded();
                const a = this.getLayer(e1);
                if (a) {
                    if (!t1.deepEqual(a.filter, i)) return null == i ? (a.filter = void 0, void this._updateLayer(a)) : void (this._validate(t1.validateStyle.filter, `layers.${a.id}.filter`, i, null, s) || (a.filter = t1.clone$1(i), this._updateLayer(a)));
                } else this.fire(new t1.ErrorEvent(new Error(`Cannot filter non-existing layer "${e1}".`)));
            }
            getFilter(e1) {
                return t1.clone$1(this.getLayer(e1).filter);
            }
            setLayoutProperty(e1, i, s, a = {}) {
                this._checkLoaded();
                const o = this.getLayer(e1);
                o ? t1.deepEqual(o.getLayoutProperty(i), s) || (o.setLayoutProperty(i, s, a), this._updateLayer(o)) : this.fire(new t1.ErrorEvent(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            getLayoutProperty(e1, i) {
                const s = this.getLayer(e1);
                if (s) return s.getLayoutProperty(i);
                this.fire(new t1.ErrorEvent(new Error(`Cannot get style of non-existing layer "${e1}".`)));
            }
            setPaintProperty(e1, i, s, a = {}) {
                this._checkLoaded();
                const o = this.getLayer(e1);
                o ? t1.deepEqual(o.getPaintProperty(i), s) || (o.setPaintProperty(i, s, a) && this._updateLayer(o), this._changed = !0, this._updatedPaintProps[e1] = !0) : this.fire(new t1.ErrorEvent(new Error(`Cannot style non-existing layer "${e1}".`)));
            }
            getPaintProperty(t1, e1) {
                return this.getLayer(t1).getPaintProperty(e1);
            }
            setFeatureState(e1, i) {
                this._checkLoaded();
                const s = e1.source, a = e1.sourceLayer, o = this.sourceCaches[s];
                if (void 0 === o) return void this.fire(new t1.ErrorEvent(new Error(`The source '${s}' does not exist in the map's style.`)));
                const r = o.getSource().type;
                "geojson" === r && a ? this.fire(new t1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== r || a ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), o.setFeatureState(a, e1.id, i)) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e1, i) {
                this._checkLoaded();
                const s = e1.source, a = this.sourceCaches[s];
                if (void 0 === a) return void this.fire(new t1.ErrorEvent(new Error(`The source '${s}' does not exist in the map's style.`)));
                const o = a.getSource().type, r = "vector" === o ? e1.sourceLayer : void 0;
                "vector" !== o || r ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t1.ErrorEvent(new Error("A feature id is required to remove its specific state property."))) : a.removeFeatureState(r, e1.id, i) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e1) {
                this._checkLoaded();
                const i = e1.source, s = e1.sourceLayer, a = this.sourceCaches[i];
                if (void 0 !== a) return "vector" !== a.getSource().type || s ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), a.getFeatureState(s, e1.id)) : void this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t1.ErrorEvent(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return t1.extend({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                const e1 = t1.mapObject(this.sourceCaches, (t1)=>t1.serialize()), i = this._serializeByIds(this._order), s = this.stylesheet;
                return t1.filterObject({
                    version: s.version,
                    name: s.name,
                    metadata: s.metadata,
                    light: s.light,
                    center: s.center,
                    zoom: s.zoom,
                    bearing: s.bearing,
                    pitch: s.pitch,
                    sprite: s.sprite,
                    glyphs: s.glyphs,
                    transition: s.transition,
                    sources: e1,
                    layers: i
                }, (t1)=>void 0 !== t1);
            }
            _updateLayer(t1) {
                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(t1) {
                const e1 = (t1)=>"fill-extrusion" === this._layers[t1].type, i = {}, s = [];
                for(let a = this._order.length - 1; a >= 0; a--){
                    const o = this._order[a];
                    if (e1(o)) {
                        i[o] = a;
                        for (const e1 of t1){
                            const t1 = e1[o];
                            if (t1) for (const e1 of t1)s.push(e1);
                        }
                    }
                }
                s.sort((t1, e1)=>e1.intersectionZ - t1.intersectionZ);
                const a = [];
                for(let o = this._order.length - 1; o >= 0; o--){
                    const r = this._order[o];
                    if (e1(r)) for(let t1 = s.length - 1; t1 >= 0; t1--){
                        const e1 = s[t1].feature;
                        if (i[e1.layer.id] < o) break;
                        a.push(e1), s.pop();
                    }
                    else for (const e1 of t1){
                        const t1 = e1[r];
                        if (t1) for (const e1 of t1)a.push(e1.feature);
                    }
                }
                return a;
            }
            queryRenderedFeatures(e1, i, s) {
                i && i.filter && this._validate(t1.validateStyle.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const a = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new t1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                    for (const e1 of i.layers){
                        const i = this._layers[e1];
                        if (!i) return this.fire(new t1.ErrorEvent(new Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        a[i.source] = !0;
                    }
                }
                const o = [];
                i.availableImages = this._availableImages;
                const r = this._serializedAllLayers();
                for(const t1 in this.sourceCaches)i.layers && !a[t1] || o.push($(this.sourceCaches[t1], this._layers, r, e1, i, s));
                return this.placement && o.push(function(t1, e1, i, s, a, o, r) {
                    const n = {}, l = o.queryRenderedSymbols(s), c = [];
                    for (const t1 of Object.keys(l).map(Number))c.push(r[t1]);
                    c.sort(X);
                    for (const i of c){
                        const s = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e1, i.bucketIndex, i.sourceLayerIndex, a.filter, a.layers, a.availableImages, t1);
                        for(const t1 in s){
                            const e1 = n[t1] = n[t1] || [], a = s[t1];
                            a.sort((t1, e1)=>{
                                const s = i.featureSortOrder;
                                if (s) {
                                    const i = s.indexOf(t1.featureIndex);
                                    return s.indexOf(e1.featureIndex) - i;
                                }
                                return e1.featureIndex - t1.featureIndex;
                            });
                            for (const t1 of a)e1.push(t1);
                        }
                    }
                    for(const e1 in n)n[e1].forEach((s)=>{
                        const a = s.feature, o = i[t1[e1].source].getFeatureState(a.layer["source-layer"], a.id);
                        a.source = a.layer.source, a.layer["source-layer"] && (a.sourceLayer = a.layer["source-layer"]), a.state = o;
                    });
                    return n;
                }(this._layers, r, this.sourceCaches, e1, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o);
            }
            querySourceFeatures(e1, i) {
                i && i.filter && this._validate(t1.validateStyle.filter, "querySourceFeatures.filter", i.filter, null, i);
                const s = this.sourceCaches[e1];
                return s ? function(t1, e1) {
                    const i = t1.getRenderableIds().map((e1)=>t1.getTileByID(e1)), s = [], a = {};
                    for(let t1 = 0; t1 < i.length; t1++){
                        const o = i[t1], r = o.tileID.canonical.key;
                        a[r] || (a[r] = !0, o.querySourceFeatures(s, e1));
                    }
                    return s;
                }(s, i) : [];
            }
            addSourceType(t1, e1, i) {
                return ae.getSourceType(t1) ? i(new Error(`A source type called "${t1}" already exists.`)) : (ae.setSourceType(t1, e1), e1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: t1,
                    url: e1.workerSourceURL
                }, i) : i(null, null));
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e1, i = {}) {
                this._checkLoaded();
                const s = this.light.getLight();
                let a = !1;
                for(const i in e1)if (!t1.deepEqual(e1[i], s[i])) {
                    a = !0;
                    break;
                }
                if (!a) return;
                const o = {
                    now: t1.exported.now(),
                    transition: t1.extend({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e1, i), this.light.updateTransitions(o);
            }
            _validate(e1, i, s, a, o = {}) {
                return (!o || !1 !== o.validate) && te(this, e1.call(t1.validateStyle, t1.extend({
                    key: i,
                    style: this.serialize(),
                    value: s,
                    styleSpec: t1.v8Spec
                }, a)));
            }
            _remove(e1 = !0) {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t1.evented.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const t1 in this._layers)this._layers[t1].setEventedParent(null);
                for(const t1 in this.sourceCaches){
                    const e1 = this.sourceCaches[t1];
                    e1.setEventedParent(null), e1.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove(e1);
            }
            _clearSource(t1) {
                this.sourceCaches[t1].clearTiles();
            }
            _reloadSource(t1) {
                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
            }
            _updateSources(t1) {
                for(const e1 in this.sourceCaches)this.sourceCaches[e1].update(t1, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const t1 in this.sourceCaches)this._reloadSource(t1);
            }
            _updatePlacement(e1, i, s, a, o = !1) {
                let r = !1, n = !1;
                const l = {};
                for (const t1 of this._order){
                    const i = this._layers[t1];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const t1 = this.sourceCaches[i.source];
                        l[i.source] = t1.getRenderableIds(!0).map((e1)=>t1.getTileByID(e1)).sort((t1, e1)=>e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1));
                    }
                    const s = this.crossTileSymbolIndex.addLayer(i, l[i.source], e1.center.lng);
                    r = r || s;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((o = o || this._layerOrderChanged || 0 === s) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t1.exported.now(), e1.zoom)) && (this.pauseablePlacement = new Wt(e1, this.map.terrain, this._order, o, i, s, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t1.exported.now()), n = !0), r && this.pauseablePlacement.placement.setStale()), n || r) for (const t1 of this._order){
                    const e1 = this._layers[t1];
                    "symbol" === e1.type && this.placement.updateLayerOpacities(e1, l[e1.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t1.exported.now());
            }
            _releaseSymbolFadeTiles() {
                for(const t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
            }
            getImages(t1, e1, i) {
                this.imageManager.getImages(e1.icons, i), this._updateTilesForChangedImages();
                const s = this.sourceCaches[e1.source];
                s && s.setDependencies(e1.tileID.key, e1.type, e1.icons);
            }
            getGlyphs(t1, e1, i) {
                this.glyphManager.getGlyphs(e1.stacks, i);
                const s = this.sourceCaches[e1.source];
                s && s.setDependencies(e1.tileID.key, e1.type, [
                    ""
                ]);
            }
            getResource(e1, i, s) {
                return t1.makeRequest(i, s);
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(e1, i = {}) {
                this._checkLoaded(), e1 && this._validate(t1.validateStyle.glyphs, "glyphs", e1, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
            }
            addSprite(e1, i, s = {}, a) {
                this._checkLoaded();
                const o = [
                    {
                        id: e1,
                        url: i
                    }
                ], r = [
                    ...v(this.stylesheet.sprite),
                    ...o
                ];
                this._validate(t1.validateStyle.sprite, "sprite", r, null, s) || (this.stylesheet.sprite = r, this._loadSprite(o, !0, a));
            }
            removeSprite(e1) {
                this._checkLoaded();
                const i = v(this.stylesheet.sprite);
                if (i.find((t1)=>t1.id === e1)) {
                    if (this._spritesImagesIds[e1]) for (const t1 of this._spritesImagesIds[e1])this.imageManager.removeImage(t1), this._changedImages[t1] = !0;
                    i.splice(i.findIndex((t1)=>t1.id === e1), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e1], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                        dataType: "style"
                    }));
                } else this.fire(new t1.ErrorEvent(new Error(`Sprite "${e1}" doesn't exists on this map.`)));
            }
            getSprite() {
                return v(this.stylesheet.sprite);
            }
            setSprite(e1, i = {}, s) {
                this._checkLoaded(), e1 && this._validate(t1.validateStyle.sprite, "sprite", e1, null, i) || (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, s) : (this._unloadSprite(), s && s(null)));
            }
        }
        ae.getSourceType = function(t1) {
            return q[t1];
        }, ae.setSourceType = function(t1, e1) {
            q[t1] = e1;
        }, ae.registerForPluginStateChange = t1.registerForPluginStateChange;
        var oe = t1.createLayout([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), re = "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_depth;void main() {float extent=8192.0;float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/extent;gl_Position=u_matrix*vec4(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}";
        const ne = {
            prelude: le("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\n", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}"),
            background: le("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            backgroundPattern: le("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: le("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: le("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: le("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
            heatmapTexture: le("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: le("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,get_elevation(a_pos),1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: le("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: le("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
            fill: le("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
            fillOutline: le("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillOutlinePattern: le("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillPattern: le("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: le("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: le("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: le("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: le("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
            line: le("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: le("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: le("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: le("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
            raster: le("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: le("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),z,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: le("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: le("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: le("uniform sampler2D u_texture;varying vec2 v_texture_pos;void main() {gl_FragColor=texture2D(u_texture,v_texture_pos);}", re),
            terrainDepth: le("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", re),
            terrainCoords: le("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", re)
        };
        function le(t1, e1) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, s = e1.match(/attribute ([\w]+) ([\w]+)/g), a = t1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = o ? o.concat(a) : a, n = {};
            return {
                fragmentSource: t1 = t1.replace(i, (t1, e1, i, s, a)=>(n[a] = !0, "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${a}\nvarying ${i} ${s} ${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = u_${a};\n#endif\n`)),
                vertexSource: e1 = e1.replace(i, (t1, e1, i, s, a)=>{
                    const o = "float" === s ? "vec2" : "vec4", r = a.match(/color/) ? "color" : o;
                    return n[a] ? "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${o} a_${a};\nvarying ${i} ${s} ${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = a_${a};\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = unpack_mix_${r}(a_${a}, u_${a}_t);\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${o} a_${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = a_${a};\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = unpack_mix_${r}(a_${a}, u_${a}_t);\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n`;
                }),
                staticAttributes: s,
                staticUniforms: r
            };
        }
        class ce {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(t1, e1, i, s, a, o, r, n, l) {
                this.context = t1;
                let c = this.boundPaintVertexBuffers.length !== s.length;
                for(let t1 = 0; !c && t1 < s.length; t1++)this.boundPaintVertexBuffers[t1] !== s[t1] && (c = !0);
                !this.vao || this.boundProgram !== e1 || this.boundLayoutVertexBuffer !== i || c || this.boundIndexBuffer !== a || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== r || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(e1, i, s, a, o, r, n, l) : (t1.bindVertexArray.set(this.vao), r && r.bind(), a && a.dynamicDraw && a.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(t1, e1, i, s, a, o, r, n) {
                const l = t1.numAttributes, c = this.context, h = c.gl;
                this.vao && this.destroy(), this.vao = c.createVertexArray(), c.bindVertexArray.set(this.vao), this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = s, this.boundVertexOffset = a, this.boundDynamicVertexBuffer = o, this.boundDynamicVertexBuffer2 = r, this.boundDynamicVertexBuffer3 = n, e1.enableAttributes(h, t1);
                for (const e1 of i)e1.enableAttributes(h, t1);
                o && o.enableAttributes(h, t1), r && r.enableAttributes(h, t1), n && n.enableAttributes(h, t1), e1.bind(), e1.setVertexAttribPointers(h, t1, a);
                for (const e1 of i)e1.bind(), e1.setVertexAttribPointers(h, t1, a);
                o && (o.bind(), o.setVertexAttribPointers(h, t1, a)), s && s.bind(), r && (r.bind(), r.setVertexAttribPointers(h, t1, a)), n && (n.bind(), n.setVertexAttribPointers(h, t1, a)), c.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function he(t1) {
            const e1 = [];
            for(let i = 0; i < t1.length; i++){
                if (null === t1[i]) continue;
                const s = t1[i].split(" ");
                e1.push(s.pop());
            }
            return e1;
        }
        class ue {
            constructor(e1, i, s, a, o, r, n){
                const l = e1.gl;
                this.program = l.createProgram();
                const c = he(s.staticAttributes), h = a ? a.getBinderAttributes() : [], u = c.concat(h), d = ne.prelude.staticUniforms ? he(ne.prelude.staticUniforms) : [], _ = s.staticUniforms ? he(s.staticUniforms) : [], m = a ? a.getBinderUniforms() : [], p = d.concat(_).concat(m), f = [];
                for (const t1 of p)f.indexOf(t1) < 0 && f.push(t1);
                const g = a ? a.defines() : [];
                r && g.push("#define OVERDRAW_INSPECTOR;"), n && g.push("#define TERRAIN3D;");
                const v = g.concat(ne.prelude.fragmentSource, s.fragmentSource).join("\n"), x = g.concat(ne.prelude.vertexSource, s.vertexSource).join("\n"), y = l.createShader(l.FRAGMENT_SHADER);
                if (l.isContextLost()) return void (this.failedToCreate = !0);
                l.shaderSource(y, v), l.compileShader(y), l.attachShader(this.program, y);
                const b = l.createShader(l.VERTEX_SHADER);
                if (l.isContextLost()) return void (this.failedToCreate = !0);
                l.shaderSource(b, x), l.compileShader(b), l.attachShader(this.program, b), this.attributes = {};
                const w = {};
                this.numAttributes = u.length;
                for(let t1 = 0; t1 < this.numAttributes; t1++)u[t1] && (l.bindAttribLocation(this.program, t1, u[t1]), this.attributes[u[t1]] = t1);
                l.linkProgram(this.program), l.deleteShader(b), l.deleteShader(y);
                for(let t1 = 0; t1 < f.length; t1++){
                    const e1 = f[t1];
                    if (e1 && !w[e1]) {
                        const t1 = l.getUniformLocation(this.program, e1);
                        t1 && (w[e1] = t1);
                    }
                }
                this.fixedUniforms = o(e1, w), this.terrainUniforms = ((e1, i)=>({
                        u_depth: new t1.Uniform1i(e1, i.u_depth),
                        u_terrain: new t1.Uniform1i(e1, i.u_terrain),
                        u_terrain_dim: new t1.Uniform1f(e1, i.u_terrain_dim),
                        u_terrain_matrix: new t1.UniformMatrix4f(e1, i.u_terrain_matrix),
                        u_terrain_unpack: new t1.Uniform4f(e1, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t1.Uniform1f(e1, i.u_terrain_exaggeration)
                    }))(e1, w), this.binderUniforms = a ? a.getUniforms(e1, w) : [];
            }
            draw(t1, e1, i, s, a, o, r, n, l, c, h, u, d, _, m, p, f, g) {
                const v = t1.gl;
                if (this.failedToCreate) return;
                if (t1.program.set(this.program), t1.setDepthMode(i), t1.setStencilMode(s), t1.setColorMode(a), t1.setCullFace(o), n) {
                    t1.activeTexture.set(v.TEXTURE2), v.bindTexture(v.TEXTURE_2D, n.depthTexture), t1.activeTexture.set(v.TEXTURE3), v.bindTexture(v.TEXTURE_2D, n.texture);
                    for(const t1 in this.terrainUniforms)this.terrainUniforms[t1].set(n[t1]);
                }
                for(const t1 in this.fixedUniforms)this.fixedUniforms[t1].set(r[t1]);
                m && m.setUniforms(t1, this.binderUniforms, d, {
                    zoom: _
                });
                let x = 0;
                switch(e1){
                    case v.LINES:
                        x = 2;
                        break;
                    case v.TRIANGLES:
                        x = 3;
                        break;
                    case v.LINE_STRIP:
                        x = 1;
                }
                for (const i of u.get()){
                    const s = i.vaos || (i.vaos = {});
                    (s[l] || (s[l] = new ce)).bind(t1, this, c, m ? m.getPaintVertexBuffers() : [], h, i.vertexOffset, p, f, g), v.drawElements(e1, i.primitiveLength * x, v.UNSIGNED_SHORT, i.primitiveOffset * x * 2);
                }
            }
        }
        function de(t1, e1, i) {
            const s = 1 / Ct(i, 1, e1.transform.tileZoom), a = Math.pow(2, i.tileID.overscaledZ), o = i.tileSize * Math.pow(2, e1.transform.tileZoom) / a, r = o * (i.tileID.canonical.x + i.tileID.wrap * a), n = o * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    s,
                    t1.fromScale,
                    t1.toScale
                ],
                u_fade: t1.t,
                u_pixel_coord_upper: [
                    r >> 16,
                    n >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & r,
                    65535 & n
                ]
            };
        }
        const _e = (e1, i, s, a)=>{
            const o = i.style.light, r = o.properties.get("position"), n = [
                r.x,
                r.y,
                r.z
            ], l = function() {
                var e1 = new t1.ARRAY_TYPE(9);
                return t1.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
            }();
            "viewport" === o.properties.get("anchor") && function(t1, e1) {
                var i = Math.sin(e1), s = Math.cos(e1);
                t1[0] = s, t1[1] = i, t1[2] = 0, t1[3] = -i, t1[4] = s, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1;
            }(l, -i.transform.angle), function(t1, e1, i) {
                var s = e1[0], a = e1[1], o = e1[2];
                t1[0] = s * i[0] + a * i[3] + o * i[6], t1[1] = s * i[1] + a * i[4] + o * i[7], t1[2] = s * i[2] + a * i[5] + o * i[8];
            }(n, n, l);
            const c = o.properties.get("color");
            return {
                u_matrix: e1,
                u_lightpos: n,
                u_lightintensity: o.properties.get("intensity"),
                u_lightcolor: [
                    c.r,
                    c.g,
                    c.b
                ],
                u_vertical_gradient: +s,
                u_opacity: a
            };
        }, me = (e1, i, s, a, o, r, n)=>t1.extend(_e(e1, i, s, a), de(r, i, n), {
                u_height_factor: -Math.pow(2, o.overscaledZ) / n.tileSize / 8
            }), pe = (t1)=>({
                u_matrix: t1
            }), fe = (e1, i, s, a)=>t1.extend(pe(e1), de(s, i, a)), ge = (t1, e1)=>({
                u_matrix: t1,
                u_world: e1
            }), ve = (e1, i, s, a, o)=>t1.extend(fe(e1, i, s, a), {
                u_world: o
            }), xe = (t1, e1, i, s)=>{
            const a = t1.transform;
            let o, r;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                const t1 = Ct(i, 1, a.zoom);
                o = !0, r = [
                    t1,
                    t1
                ];
            } else o = !1, r = a.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: a.cameraToCenterDistance,
                u_scale_with_map: +("map" === s.paint.get("circle-pitch-scale")),
                u_matrix: t1.translatePosMatrix(e1.posMatrix, i, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +o,
                u_device_pixel_ratio: t1.pixelRatio,
                u_extrude_scale: r
            };
        }, ye = (t1, e1, i)=>{
            const s = Ct(i, 1, e1.zoom), a = Math.pow(2, e1.zoom - i.tileID.overscaledZ), o = i.tileID.overscaleFactor();
            return {
                u_matrix: t1,
                u_camera_to_center_distance: e1.cameraToCenterDistance,
                u_pixels_to_tile_units: s,
                u_extrude_scale: [
                    e1.pixelsToGLUnits[0] / (s * a),
                    e1.pixelsToGLUnits[1] / (s * a)
                ],
                u_overscale_factor: o
            };
        }, be = (t1, e1, i = 1)=>({
                u_matrix: t1,
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: i
            }), we = (t1)=>({
                u_matrix: t1
            }), Te = (t1, e1, i, s)=>({
                u_matrix: t1,
                u_extrude_scale: Ct(e1, 1, i),
                u_intensity: s
            });
        function Ee(e1, i) {
            const s = Math.pow(2, i.canonical.z), a = i.canonical.y;
            return [
                new t1.MercatorCoordinate(0, a / s).toLngLat().lat,
                new t1.MercatorCoordinate(0, (a + 1) / s).toLngLat().lat
            ];
        }
        const Ie = (t1, e1, i, s)=>{
            const a = t1.transform;
            return {
                u_matrix: ze(t1, e1, i, s),
                u_ratio: 1 / Ct(e1, 1, a.zoom),
                u_device_pixel_ratio: t1.pixelRatio,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, Se = (e1, i, s, a, o)=>t1.extend(Ie(e1, i, s, o), {
                u_image: 0,
                u_image_height: a
            }), Ce = (t1, e1, i, s, a)=>{
            const o = t1.transform, r = De(e1, o);
            return {
                u_matrix: ze(t1, e1, i, a),
                u_texsize: e1.imageAtlasTexture.size,
                u_ratio: 1 / Ct(e1, 1, o.zoom),
                u_device_pixel_ratio: t1.pixelRatio,
                u_image: 0,
                u_scale: [
                    r,
                    s.fromScale,
                    s.toScale
                ],
                u_fade: s.t,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ]
            };
        }, Pe = (e1, i, s, a, o, r)=>{
            const n = e1.lineAtlas, l = De(i, e1.transform), c = "round" === s.layout.get("line-cap"), h = n.getDash(a.from, c), u = n.getDash(a.to, c), d = h.width * o.fromScale, _ = u.width * o.toScale;
            return t1.extend(Ie(e1, i, s, r), {
                u_patternscale_a: [
                    l / d,
                    -h.height / 2
                ],
                u_patternscale_b: [
                    l / _,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(d, _) * e1.pixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: h.y,
                u_tex_y_b: u.y,
                u_mix: o.t
            });
        };
        function De(t1, e1) {
            return 1 / Ct(t1, 1, e1.tileZoom);
        }
        function ze(t1, e1, i, s) {
            return t1.translatePosMatrix(s ? s.posMatrix : e1.tileID.posMatrix, e1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Me = (t1, e1, i, s, a)=>{
            var o, r;
            return {
                u_matrix: t1,
                u_tl_parent: e1,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: s.mix,
                u_opacity: s.opacity * a.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: a.paint.get("raster-brightness-min"),
                u_brightness_high: a.paint.get("raster-brightness-max"),
                u_saturation_factor: (r = a.paint.get("raster-saturation"), r > 0 ? 1 - 1 / (1.001 - r) : -r),
                u_contrast_factor: (o = a.paint.get("raster-contrast"), o > 0 ? 1 / (1 - o) : 1 + o),
                u_spin_weights: Ae(a.paint.get("raster-hue-rotate"))
            };
        };
        function Ae(t1) {
            t1 *= Math.PI / 180;
            const e1 = Math.sin(t1), i = Math.cos(t1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e1 - i + 1) / 3,
                (Math.sqrt(3) * e1 - i + 1) / 3
            ];
        }
        const Le = (t1, e1, i, s, a, o, r, n, l, c)=>{
            const h = a.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: e1 ? e1.uSizeT : 0,
                u_size: e1 ? e1.uSize : 0,
                u_camera_to_center_distance: h.cameraToCenterDistance,
                u_pitch: h.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: h.width / h.height,
                u_fade_change: a.options.fadeDuration ? a.symbolFadeChange : 1,
                u_matrix: o,
                u_label_plane_matrix: r,
                u_coord_matrix: n,
                u_is_text: +l,
                u_pitch_with_map: +s,
                u_texsize: c,
                u_texture: 0
            };
        }, Re = (e1, i, s, a, o, r, n, l, c, h, u)=>{
            const d = o.transform;
            return t1.extend(Le(e1, i, s, a, o, r, n, l, c, h), {
                u_gamma_scale: a ? Math.cos(d._pitch) * d.cameraToCenterDistance : 1,
                u_device_pixel_ratio: o.pixelRatio,
                u_is_halo: +u
            });
        }, ke = (e1, i, s, a, o, r, n, l, c, h)=>t1.extend(Re(e1, i, s, a, o, r, n, l, !0, c, !0), {
                u_texsize_icon: h,
                u_texture_icon: 1
            }), Be = (t1, e1, i)=>({
                u_matrix: t1,
                u_opacity: e1,
                u_color: i
            }), Fe = (e1, i, s, a, o, r)=>t1.extend(function(t1, e1, i, s) {
                const a = i.imageManager.getPattern(t1.from.toString()), o = i.imageManager.getPattern(t1.to.toString()), { width: r, height: n } = i.imageManager.getPixelSize(), l = Math.pow(2, s.tileID.overscaledZ), c = s.tileSize * Math.pow(2, i.transform.tileZoom) / l, h = c * (s.tileID.canonical.x + s.tileID.wrap * l), u = c * s.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: a.tl,
                    u_pattern_br_a: a.br,
                    u_pattern_tl_b: o.tl,
                    u_pattern_br_b: o.br,
                    u_texsize: [
                        r,
                        n
                    ],
                    u_mix: e1.t,
                    u_pattern_size_a: a.displaySize,
                    u_pattern_size_b: o.displaySize,
                    u_scale_a: e1.fromScale,
                    u_scale_b: e1.toScale,
                    u_tile_units_to_pixels: 1 / Ct(s, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        h >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & h,
                        65535 & u
                    ]
                };
            }(a, r, s, o), {
                u_matrix: e1,
                u_opacity: i
            }), Ue = {
            fillExtrusion: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                }),
            fillExtrusionPattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_lightpos: new t1.Uniform3f(e1, i.u_lightpos),
                    u_lightintensity: new t1.Uniform1f(e1, i.u_lightintensity),
                    u_lightcolor: new t1.Uniform3f(e1, i.u_lightcolor),
                    u_vertical_gradient: new t1.Uniform1f(e1, i.u_vertical_gradient),
                    u_height_factor: new t1.Uniform1f(e1, i.u_height_factor),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                }),
            fill: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            fillPattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                }),
            fillOutline: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world)
                }),
            fillOutlinePattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                }),
            circle: (e1, i)=>({
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t1.Uniform1i(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            collisionBox: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pixels_to_tile_units: new t1.Uniform1f(e1, i.u_pixels_to_tile_units),
                    u_extrude_scale: new t1.Uniform2f(e1, i.u_extrude_scale),
                    u_overscale_factor: new t1.Uniform1f(e1, i.u_overscale_factor)
                }),
            collisionCircle: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_inv_matrix: new t1.UniformMatrix4f(e1, i.u_inv_matrix),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_viewport_size: new t1.Uniform2f(e1, i.u_viewport_size)
                }),
            debug: (e1, i)=>({
                    u_color: new t1.UniformColor(e1, i.u_color),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_overlay: new t1.Uniform1i(e1, i.u_overlay),
                    u_overlay_scale: new t1.Uniform1f(e1, i.u_overlay_scale)
                }),
            clippingMask: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            heatmap: (e1, i)=>({
                    u_extrude_scale: new t1.Uniform1f(e1, i.u_extrude_scale),
                    u_intensity: new t1.Uniform1f(e1, i.u_intensity),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix)
                }),
            heatmapTexture: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_world: new t1.Uniform2f(e1, i.u_world),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_color_ramp: new t1.Uniform1i(e1, i.u_color_ramp),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity)
                }),
            hillshade: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_latrange: new t1.Uniform2f(e1, i.u_latrange),
                    u_light: new t1.Uniform2f(e1, i.u_light),
                    u_shadow: new t1.UniformColor(e1, i.u_shadow),
                    u_highlight: new t1.UniformColor(e1, i.u_highlight),
                    u_accent: new t1.UniformColor(e1, i.u_accent)
                }),
            hillshadePrepare: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_dimension: new t1.Uniform2f(e1, i.u_dimension),
                    u_zoom: new t1.Uniform1f(e1, i.u_zoom),
                    u_unpack: new t1.Uniform4f(e1, i.u_unpack)
                }),
            line: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels)
                }),
            lineGradient: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_image_height: new t1.Uniform1f(e1, i.u_image_height)
                }),
            linePattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_scale: new t1.Uniform3f(e1, i.u_scale),
                    u_fade: new t1.Uniform1f(e1, i.u_fade)
                }),
            lineSDF: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ratio: new t1.Uniform1f(e1, i.u_ratio),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t1.Uniform2f(e1, i.u_units_to_pixels),
                    u_patternscale_a: new t1.Uniform2f(e1, i.u_patternscale_a),
                    u_patternscale_b: new t1.Uniform2f(e1, i.u_patternscale_b),
                    u_sdfgamma: new t1.Uniform1f(e1, i.u_sdfgamma),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_tex_y_a: new t1.Uniform1f(e1, i.u_tex_y_a),
                    u_tex_y_b: new t1.Uniform1f(e1, i.u_tex_y_b),
                    u_mix: new t1.Uniform1f(e1, i.u_mix)
                }),
            raster: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_tl_parent: new t1.Uniform2f(e1, i.u_tl_parent),
                    u_scale_parent: new t1.Uniform1f(e1, i.u_scale_parent),
                    u_buffer_scale: new t1.Uniform1f(e1, i.u_buffer_scale),
                    u_fade_t: new t1.Uniform1f(e1, i.u_fade_t),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image0: new t1.Uniform1i(e1, i.u_image0),
                    u_image1: new t1.Uniform1i(e1, i.u_image1),
                    u_brightness_low: new t1.Uniform1f(e1, i.u_brightness_low),
                    u_brightness_high: new t1.Uniform1f(e1, i.u_brightness_high),
                    u_saturation_factor: new t1.Uniform1f(e1, i.u_saturation_factor),
                    u_contrast_factor: new t1.Uniform1f(e1, i.u_contrast_factor),
                    u_spin_weights: new t1.Uniform3f(e1, i.u_spin_weights)
                }),
            symbolIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture)
                }),
            symbolSDF: (e1, i)=>({
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                }),
            symbolTextAndIcon: (e1, i)=>({
                    u_is_size_zoom_constant: new t1.Uniform1i(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t1.Uniform1i(e1, i.u_is_size_feature_constant),
                    u_size_t: new t1.Uniform1f(e1, i.u_size_t),
                    u_size: new t1.Uniform1f(e1, i.u_size),
                    u_camera_to_center_distance: new t1.Uniform1f(e1, i.u_camera_to_center_distance),
                    u_pitch: new t1.Uniform1f(e1, i.u_pitch),
                    u_rotate_symbol: new t1.Uniform1i(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t1.Uniform1f(e1, i.u_aspect_ratio),
                    u_fade_change: new t1.Uniform1f(e1, i.u_fade_change),
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t1.UniformMatrix4f(e1, i.u_coord_matrix),
                    u_is_text: new t1.Uniform1i(e1, i.u_is_text),
                    u_pitch_with_map: new t1.Uniform1i(e1, i.u_pitch_with_map),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_texsize_icon: new t1.Uniform2f(e1, i.u_texsize_icon),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_texture_icon: new t1.Uniform1i(e1, i.u_texture_icon),
                    u_gamma_scale: new t1.Uniform1f(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t1.Uniform1f(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t1.Uniform1i(e1, i.u_is_halo)
                }),
            background: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_color: new t1.UniformColor(e1, i.u_color)
                }),
            backgroundPattern: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_opacity: new t1.Uniform1f(e1, i.u_opacity),
                    u_image: new t1.Uniform1i(e1, i.u_image),
                    u_pattern_tl_a: new t1.Uniform2f(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t1.Uniform2f(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t1.Uniform2f(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t1.Uniform2f(e1, i.u_pattern_br_b),
                    u_texsize: new t1.Uniform2f(e1, i.u_texsize),
                    u_mix: new t1.Uniform1f(e1, i.u_mix),
                    u_pattern_size_a: new t1.Uniform2f(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t1.Uniform2f(e1, i.u_pattern_size_b),
                    u_scale_a: new t1.Uniform1f(e1, i.u_scale_a),
                    u_scale_b: new t1.Uniform1f(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t1.Uniform2f(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t1.Uniform2f(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t1.Uniform1f(e1, i.u_tile_units_to_pixels)
                }),
            terrain: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_ele_delta: new t1.Uniform1f(e1, i.u_ele_delta)
                }),
            terrainDepth: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_ele_delta: new t1.Uniform1f(e1, i.u_ele_delta)
                }),
            terrainCoords: (e1, i)=>({
                    u_matrix: new t1.UniformMatrix4f(e1, i.u_matrix),
                    u_texture: new t1.Uniform1i(e1, i.u_texture),
                    u_terrain_coords_id: new t1.Uniform1f(e1, i.u_terrain_coords_id),
                    u_ele_delta: new t1.Uniform1f(e1, i.u_ele_delta)
                })
        };
        class Oe {
            constructor(t1, e1, i){
                this.context = t1;
                const s = t1.gl;
                this.buffer = s.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), s.bufferData(s.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(t1) {
                const e1 = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Ne = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Ge {
            constructor(t1, e1, i, s){
                this.length = e1.length, this.attributes = i, this.itemSize = e1.bytesPerElement, this.dynamicDraw = s, this.context = t1;
                const a = t1.gl;
                this.buffer = a.createBuffer(), t1.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(t1) {
                if (t1.length !== this.length) throw new Error(`Length of new data is ${t1.length}, which doesn't match current length of ${this.length}`);
                const e1 = this.context.gl;
                this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
            }
            enableAttributes(t1, e1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const s = e1.attributes[this.attributes[i].name];
                    void 0 !== s && t1.enableVertexAttribArray(s);
                }
            }
            setVertexAttribPointers(t1, e1, i) {
                for(let s = 0; s < this.attributes.length; s++){
                    const a = this.attributes[s], o = e1.attributes[a.name];
                    void 0 !== o && t1.vertexAttribPointer(o, a.components, t1[Ne[a.type]], !1, this.itemSize, a.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Ze = new WeakMap;
        function Ve(t1) {
            if (Ze.has(t1)) return Ze.get(t1);
            {
                const e1 = t1.getParameter(t1.VERSION).startsWith("WebGL 2.0");
                return Ze.set(t1, e1), e1;
            }
        }
        class qe {
            constructor(t1){
                this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(t1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class je extends qe {
            getDefault() {
                return t1.Color.transparent;
            }
            set(t1) {
                const e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }
        }
        class $e extends qe {
            getDefault() {
                return 1;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
            }
        }
        class Xe extends qe {
            getDefault() {
                return 0;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
            }
        }
        class We extends qe {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }
        }
        class He extends qe {
            getDefault() {
                return !0;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
            }
        }
        class Ke extends qe {
            getDefault() {
                return 255;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
            }
        }
        class Ye extends qe {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(t1) {
                const e1 = this.current;
                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
            }
        }
        class Je extends qe {
            getDefault() {
                const t1 = this.gl;
                return [
                    t1.KEEP,
                    t1.KEEP,
                    t1.KEEP
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
            }
        }
        class Qe extends qe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
            }
        }
        class ti extends qe {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }
        }
        class ei extends qe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
            }
        }
        class ii extends qe {
            getDefault() {
                return this.gl.LESS;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
            }
        }
        class si extends qe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
            }
        }
        class ai extends qe {
            getDefault() {
                const t1 = this.gl;
                return [
                    t1.ONE,
                    t1.ZERO
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
            }
        }
        class oi extends qe {
            getDefault() {
                return t1.Color.transparent;
            }
            set(t1) {
                const e1 = this.current;
                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
            }
        }
        class ri extends qe {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
            }
        }
        class ni extends qe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
            }
        }
        class li extends qe {
            getDefault() {
                return this.gl.BACK;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
            }
        }
        class ci extends qe {
            getDefault() {
                return this.gl.CCW;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
            }
        }
        class hi extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
            }
        }
        class ui extends qe {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(t1) {
                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
            }
        }
        class di extends qe {
            getDefault() {
                const t1 = this.gl;
                return [
                    0,
                    0,
                    t1.drawingBufferWidth,
                    t1.drawingBufferHeight
                ];
            }
            set(t1) {
                const e1 = this.current;
                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
            }
        }
        class _i extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class mi extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class pi extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
            }
        }
        class fi extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class gi extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                const e1 = this.gl;
                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class vi extends qe {
            getDefault() {
                return null;
            }
            set(t1) {
                var e1;
                if (t1 === this.current && !this.dirty) return;
                const i = this.gl;
                Ve(i) ? i.bindVertexArray(t1) : null === (e1 = i.getExtension("OES_vertex_array_object")) || void 0 === e1 || e1.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1;
            }
        }
        class xi extends qe {
            getDefault() {
                return 4;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
            }
        }
        class yi extends qe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
            }
        }
        class bi extends qe {
            getDefault() {
                return !1;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                const e1 = this.gl;
                e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
            }
        }
        class wi extends qe {
            constructor(t1, e1){
                super(t1), this.context = t1, this.parent = e1;
            }
            getDefault() {
                return null;
            }
        }
        class Ti extends wi {
            setDirty() {
                this.dirty = !0;
            }
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e1 = this.gl;
                e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
            }
        }
        class Ei extends wi {
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e1 = this.gl;
                e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class Ii extends wi {
            set(t1) {
                if (t1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e1 = this.gl;
                e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
            }
        }
        class Si {
            constructor(t1, e1, i, s, a){
                this.context = t1, this.width = e1, this.height = i;
                const o = t1.gl, r = this.framebuffer = o.createFramebuffer();
                if (this.colorAttachment = new Ti(t1, r), s) this.depthAttachment = a ? new Ii(t1, r) : new Ei(t1, r);
                else if (a) throw new Error("Stencil cannot be setted without depth");
                if (o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
            }
            destroy() {
                const t1 = this.context.gl, e1 = this.colorAttachment.get();
                if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                    const e1 = this.depthAttachment.get();
                    e1 && t1.deleteRenderbuffer(e1);
                }
                t1.deleteFramebuffer(this.framebuffer);
            }
        }
        class Ci {
            constructor(t1, e1, i){
                this.blendFunction = t1, this.blendColor = e1, this.mask = i;
            }
        }
        Ci.Replace = [
            1,
            0
        ], Ci.disabled = new Ci(Ci.Replace, t1.Color.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Ci.unblended = new Ci(Ci.Replace, t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Ci.alphaBlended = new Ci([
            1,
            771
        ], t1.Color.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Pi {
            constructor(t1){
                var e1, i;
                if (this.gl = t1, this.clearColor = new je(this), this.clearDepth = new $e(this), this.clearStencil = new Xe(this), this.colorMask = new We(this), this.depthMask = new He(this), this.stencilMask = new Ke(this), this.stencilFunc = new Ye(this), this.stencilOp = new Je(this), this.stencilTest = new Qe(this), this.depthRange = new ti(this), this.depthTest = new ei(this), this.depthFunc = new ii(this), this.blend = new si(this), this.blendFunc = new ai(this), this.blendColor = new oi(this), this.blendEquation = new ri(this), this.cullFace = new ni(this), this.cullFaceSide = new li(this), this.frontFace = new ci(this), this.program = new hi(this), this.activeTexture = new ui(this), this.viewport = new di(this), this.bindFramebuffer = new _i(this), this.bindRenderbuffer = new mi(this), this.bindTexture = new pi(this), this.bindVertexBuffer = new fi(this), this.bindElementBuffer = new gi(this), this.bindVertexArray = new vi(this), this.pixelStoreUnpack = new xi(this), this.pixelStoreUnpackPremultiplyAlpha = new yi(this), this.pixelStoreUnpackFlipY = new bi(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = t1.getParameter(t1.MAX_TEXTURE_SIZE), Ve(t1)) {
                    this.HALF_FLOAT = t1.HALF_FLOAT;
                    const s = t1.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (e1 = t1.RGBA16F) && void 0 !== e1 ? e1 : null == s ? void 0 : s.RGBA16F_EXT, this.RGB16F = null !== (i = t1.RGB16F) && void 0 !== i ? i : null == s ? void 0 : s.RGB16F_EXT, t1.getExtension("EXT_color_buffer_float");
                } else {
                    t1.getExtension("EXT_color_buffer_half_float"), t1.getExtension("OES_texture_half_float_linear");
                    const e1 = t1.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == e1 ? void 0 : e1.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(t1, e1) {
                return new Oe(this, t1, e1);
            }
            createVertexBuffer(t1, e1, i) {
                return new Ge(this, t1, e1, i);
            }
            createRenderbuffer(t1, e1, i) {
                const s = this.gl, a = s.createRenderbuffer();
                return this.bindRenderbuffer.set(a), s.renderbufferStorage(s.RENDERBUFFER, t1, e1, i), this.bindRenderbuffer.set(null), a;
            }
            createFramebuffer(t1, e1, i, s) {
                return new Si(this, t1, e1, i, s);
            }
            clear({ color: t1, depth: e1, stencil: i }) {
                const s = this.gl;
                let a = 0;
                t1 && (a |= s.COLOR_BUFFER_BIT, this.clearColor.set(t1), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== e1 && (a |= s.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(e1), this.depthMask.set(!0)), void 0 !== i && (a |= s.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), s.clear(a);
            }
            setCullFace(t1) {
                !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
            }
            setDepthMode(t1) {
                t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(t1) {
                t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                    t1.fail,
                    t1.depthFail,
                    t1.pass
                ]), this.stencilFunc.set({
                    func: t1.test.func,
                    ref: t1.ref,
                    mask: t1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e1) {
                t1.deepEqual(e1.blendFunction, Ci.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
            }
            createVertexArray() {
                var t1;
                return Ve(this.gl) ? this.gl.createVertexArray() : null === (t1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t1 ? void 0 : t1.createVertexArrayOES();
            }
            deleteVertexArray(t1) {
                var e1;
                return Ve(this.gl) ? this.gl.deleteVertexArray(t1) : null === (e1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e1 ? void 0 : e1.deleteVertexArrayOES(t1);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        class Di {
            constructor(t1, e1, i){
                this.func = t1, this.mask = e1, this.range = i;
            }
        }
        Di.ReadOnly = !1, Di.ReadWrite = !0, Di.disabled = new Di(519, Di.ReadOnly, [
            0,
            1
        ]);
        const zi = 7680;
        class Mi {
            constructor(t1, e1, i, s, a, o){
                this.test = t1, this.ref = e1, this.mask = i, this.fail = s, this.depthFail = a, this.pass = o;
            }
        }
        Mi.disabled = new Mi({
            func: 519,
            mask: 0
        }, 0, 0, zi, zi, zi);
        class Ai {
            constructor(t1, e1, i){
                this.enable = t1, this.mode = e1, this.frontFace = i;
            }
        }
        let Li;
        function Ri(e1, i, s, a, o, r, n) {
            const l = e1.context, c = l.gl, h = e1.useProgram("collisionBox"), u = [];
            let d = 0, _ = 0;
            for(let m = 0; m < a.length; m++){
                const p = a[m], f = i.getTile(p), g = f.getBucket(s);
                if (!g) continue;
                let v = p.posMatrix;
                0 === o[0] && 0 === o[1] || (v = e1.translatePosMatrix(p.posMatrix, f, o, r));
                const x = n ? g.textCollisionBox : g.iconCollisionBox, y = g.collisionCircleArray;
                if (y.length > 0) {
                    const i = t1.create(), s = v;
                    t1.mul(i, g.placementInvProjMatrix, e1.transform.glCoordMatrix), t1.mul(i, i, g.placementViewportMatrix), u.push({
                        circleArray: y,
                        circleOffset: _,
                        transform: s,
                        invTransform: i,
                        coord: p
                    }), d += y.length / 4, _ = d;
                }
                x && h.draw(l, c.LINES, Di.disabled, Mi.disabled, e1.colorModeForRenderPass(), Ai.disabled, ye(v, e1.transform, f), e1.style.map.terrain && e1.style.map.terrain.getTerrainData(p), s.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, e1.transform.zoom, null, null, x.collisionVertexBuffer);
            }
            if (!n || !u.length) return;
            const m = e1.useProgram("collisionCircle"), p = new t1.CollisionCircleLayoutArray;
            p.resize(4 * d), p._trim();
            let f = 0;
            for (const t1 of u)for(let e1 = 0; e1 < t1.circleArray.length / 4; e1++){
                const i = 4 * e1, s = t1.circleArray[i + 0], a = t1.circleArray[i + 1], o = t1.circleArray[i + 2], r = t1.circleArray[i + 3];
                p.emplace(f++, s, a, o, r, 0), p.emplace(f++, s, a, o, r, 1), p.emplace(f++, s, a, o, r, 2), p.emplace(f++, s, a, o, r, 3);
            }
            (!Li || Li.length < 2 * d) && (Li = function(e1) {
                const i = 2 * e1, s = new t1.QuadTriangleArray;
                s.resize(i), s._trim();
                for(let t1 = 0; t1 < i; t1++){
                    const e1 = 6 * t1;
                    s.uint16[e1 + 0] = 4 * t1 + 0, s.uint16[e1 + 1] = 4 * t1 + 1, s.uint16[e1 + 2] = 4 * t1 + 2, s.uint16[e1 + 3] = 4 * t1 + 2, s.uint16[e1 + 4] = 4 * t1 + 3, s.uint16[e1 + 5] = 4 * t1 + 0;
                }
                return s;
            }(d));
            const g = l.createIndexBuffer(Li, !0), v = l.createVertexBuffer(p, t1.collisionCircleLayout.members, !0);
            for (const i of u){
                const a = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (x = e1.transform).cameraToCenterDistance,
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                m.draw(l, c.TRIANGLES, Di.disabled, Mi.disabled, e1.colorModeForRenderPass(), Ai.disabled, a, e1.style.map.terrain && e1.style.map.terrain.getTerrainData(i.coord), s.id, v, g, t1.SegmentVector.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
            }
            var x;
            v.destroy(), g.destroy();
        }
        Ai.disabled = new Ai(!1, 1029, 2305), Ai.backCCW = new Ai(!0, 1029, 2305);
        const ki = t1.identity(new Float32Array(16));
        function Bi(e1, i, s, a, o, r) {
            const { horizontalAlign: n, verticalAlign: l } = t1.getAnchorAlignment(e1), c = -(n - .5) * i, h = -(l - .5) * s, u = t1.evaluateVariableOffset(e1, a);
            return new t1.Point((c / o + u[0]) * r, (h / o + u[1]) * r);
        }
        function Fi(e1, i, s, a, o, r, n, l, c, h, u) {
            const d = e1.text.placedSymbolArray, _ = e1.text.dynamicLayoutVertexArray, m = e1.icon.dynamicLayoutVertexArray, p = {};
            _.clear();
            for(let m = 0; m < d.length; m++){
                const f = d.get(m), g = f.hidden || !f.crossTileID || e1.allowVerticalPlacement && !f.placedOrientation ? null : a[f.crossTileID];
                if (g) {
                    const a = new t1.Point(f.anchorX, f.anchorY), d = ht(a, s ? n : r, u), m = ut(o.cameraToCenterDistance, d.signedDistanceFromCamera);
                    let v = t1.evaluateSizeForFeature(e1.textSizeData, c, f) * m / t1.ONE_EM;
                    s && (v *= e1.tilePixelRatio / l);
                    const { width: x, height: y, anchor: b, textOffset: w, textBoxScale: T } = g, E = Bi(b, x, y, w, T, v), I = s ? ht(a.add(E), r, u).point : d.point.add(i ? E.rotate(-o.angle) : E), S = e1.allowVerticalPlacement && f.placedOrientation === t1.WritingMode.vertical ? Math.PI / 2 : 0;
                    for(let e1 = 0; e1 < f.numGlyphs; e1++)t1.addDynamicAttributes(_, I, S);
                    h && f.associatedIconIndex >= 0 && (p[f.associatedIconIndex] = {
                        shiftedAnchor: I,
                        angle: S
                    });
                } else Tt(f.numGlyphs, _);
            }
            if (h) {
                m.clear();
                const i = e1.icon.placedSymbolArray;
                for(let e1 = 0; e1 < i.length; e1++){
                    const s = i.get(e1);
                    if (s.hidden) Tt(s.numGlyphs, m);
                    else {
                        const i = p[e1];
                        if (i) for(let e1 = 0; e1 < s.numGlyphs; e1++)t1.addDynamicAttributes(m, i.shiftedAnchor, i.angle);
                        else Tt(s.numGlyphs, m);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(m);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(_);
        }
        function Ui(t1, e1, i) {
            return i.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
        }
        function Oi(e1, i, s, a, o, r, n, l, c, h, u, d) {
            const _ = e1.context, m = _.gl, p = e1.transform, f = "map" === l, g = "map" === c, v = "viewport" !== l && "point" !== s.layout.get("symbol-placement"), x = f && !g && !v, y = !s.layout.get("symbol-sort-key").isConstant();
            let b = !1;
            const w = e1.depthModeForSublayer(0, Di.ReadOnly), T = s.layout.get("text-variable-anchor"), E = [];
            for (const l of a){
                const a = i.getTile(l), c = a.getBucket(s);
                if (!c) continue;
                const u = o ? c.text : c.icon;
                if (!u || !u.segments.get().length || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(s.id), _ = o || c.sdfIcons, w = o ? c.textSizeData : c.iconSizeData, I = g || 0 !== p.pitch, S = e1.useProgram(Ui(_, o, c), d), C = t1.evaluateSizeForZoom(w, p.zoom), P = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(l);
                let D, z, M, A, L = [
                    0,
                    0
                ], R = null;
                if (o) z = a.glyphAtlasTexture, M = m.LINEAR, D = a.glyphAtlasTexture.size, c.iconsInText && (L = a.imageAtlasTexture.size, R = a.imageAtlasTexture, A = I || e1.options.rotating || e1.options.zooming || "composite" === w.kind || "camera" === w.kind ? m.LINEAR : m.NEAREST);
                else {
                    const t1 = 1 !== s.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                    z = a.imageAtlasTexture, M = _ || e1.options.rotating || e1.options.zooming || t1 || I ? m.LINEAR : m.NEAREST, D = a.imageAtlasTexture.size;
                }
                const k = Ct(a, 1, e1.transform.zoom), B = lt(l.posMatrix, g, f, e1.transform, k), F = ct(l.posMatrix, g, f, e1.transform, k), U = T && c.hasTextData(), O = "none" !== s.layout.get("icon-text-fit") && U && c.hasIconData();
                if (v) {
                    const t1 = e1.style.map.terrain ? (t1, i)=>e1.style.map.terrain.getElevation(l, t1, i) : null, i = "map" === s.layout.get("text-rotation-alignment");
                    _t(c, l.posMatrix, e1, o, B, F, g, h, i, t1);
                }
                const N = e1.translatePosMatrix(l.posMatrix, a, r, n), G = v || o && T || O ? ki : B, Z = e1.translatePosMatrix(F, a, r, n, !0), V = _ && 0 !== s.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let q;
                q = _ ? c.iconsInText ? ke(w.kind, C, x, g, e1, N, G, Z, D, L) : Re(w.kind, C, x, g, e1, N, G, Z, o, D, !0) : Le(w.kind, C, x, g, e1, N, G, Z, o, D);
                const j = {
                    program: S,
                    buffers: u,
                    uniformValues: q,
                    atlasTexture: z,
                    atlasTextureIcon: R,
                    atlasInterpolation: M,
                    atlasInterpolationIcon: A,
                    isSDF: _,
                    hasHalo: V
                };
                if (y && c.canOverlap) {
                    b = !0;
                    const e1 = u.segments.get();
                    for (const i of e1)E.push({
                        segments: new t1.SegmentVector([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: j,
                        terrainData: P
                    });
                } else E.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: j,
                    terrainData: P
                });
            }
            b && E.sort((t1, e1)=>t1.sortKey - e1.sortKey);
            for (const t1 of E){
                const i = t1.state;
                if (_.activeTexture.set(m.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, m.CLAMP_TO_EDGE), i.atlasTextureIcon && (_.activeTexture.set(m.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, m.CLAMP_TO_EDGE)), i.isSDF) {
                    const a = i.uniformValues;
                    i.hasHalo && (a.u_is_halo = 1, Ni(i.buffers, t1.segments, s, e1, i.program, w, u, d, a, t1.terrainData)), a.u_is_halo = 0;
                }
                Ni(i.buffers, t1.segments, s, e1, i.program, w, u, d, i.uniformValues, t1.terrainData);
            }
        }
        function Ni(t1, e1, i, s, a, o, r, n, l, c) {
            const h = s.context;
            a.draw(h, h.gl.TRIANGLES, o, r, n, Ai.disabled, l, c, i.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, i.paint, s.transform.zoom, t1.programConfigurations.get(i.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
        }
        function Gi(t1, e1, i, s, a) {
            if (!i || !s || !s.imageAtlas) return;
            const o = s.imageAtlas.patternPositions;
            let r = o[i.to.toString()], n = o[i.from.toString()];
            if (!r || !n) {
                const t1 = a.getPaintProperty(e1);
                r = o[t1], n = o[t1];
            }
            r && n && t1.setConstantPatternPositions(r, n);
        }
        function Zi(t1, e1, i, s, a, o, r) {
            const n = t1.context.gl, l = "fill-pattern", c = i.paint.get(l), h = c && c.constantOr(1), u = i.getCrossfadeParameters();
            let d, _, m, p, f;
            r ? (_ = h && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", d = n.LINES) : (_ = h ? "fillPattern" : "fill", d = n.TRIANGLES);
            const g = c.constantOr(null);
            for (const c of s){
                const s = e1.getTile(c);
                if (h && !s.patternsLoaded()) continue;
                const v = s.getBucket(i);
                if (!v) continue;
                const x = v.programConfigurations.get(i.id), y = t1.useProgram(_, x), b = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(c);
                h && (t1.context.activeTexture.set(n.TEXTURE0), s.imageAtlasTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x.updatePaintBuffers(u)), Gi(x, l, g, s, i);
                const w = b ? c : null, T = t1.translatePosMatrix(w ? w.posMatrix : c.posMatrix, s, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                if (r) {
                    p = v.indexBuffer2, f = v.segments2;
                    const e1 = [
                        n.drawingBufferWidth,
                        n.drawingBufferHeight
                    ];
                    m = "fillOutlinePattern" === _ && h ? ve(T, t1, u, s, e1) : ge(T, e1);
                } else p = v.indexBuffer, f = v.segments, m = h ? fe(T, t1, u, s) : pe(T);
                y.draw(t1.context, d, a, t1.stencilModeForClipping(c), o, Ai.disabled, m, b, i.id, v.layoutVertexBuffer, p, f, i.paint, t1.transform.zoom, x);
            }
        }
        function Vi(t1, e1, i, s, a, o, r) {
            const n = t1.context, l = n.gl, c = "fill-extrusion-pattern", h = i.paint.get(c), u = h.constantOr(1), d = i.getCrossfadeParameters(), _ = i.paint.get("fill-extrusion-opacity"), m = h.constantOr(null);
            for (const h of s){
                const s = e1.getTile(h), p = s.getBucket(i);
                if (!p) continue;
                const f = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(h), g = p.programConfigurations.get(i.id), v = t1.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", g);
                u && (t1.context.activeTexture.set(l.TEXTURE0), s.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), g.updatePaintBuffers(d)), Gi(g, c, m, s, i);
                const x = t1.translatePosMatrix(h.posMatrix, s, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), y = i.paint.get("fill-extrusion-vertical-gradient"), b = u ? me(x, t1, y, _, h, d, s) : _e(x, t1, y, _);
                v.draw(n, n.gl.TRIANGLES, a, o, r, Ai.backCCW, b, f, i.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, i.paint, t1.transform.zoom, g, t1.style.map.terrain && p.centroidVertexBuffer);
            }
        }
        function qi(t1, e1, i, s, a, o, r) {
            const n = t1.context, l = n.gl, c = i.fbo;
            if (!c) return;
            const h = t1.useProgram("hillshade"), u = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(e1);
            n.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get()), h.draw(n, l.TRIANGLES, a, o, r, Ai.disabled, ((t1, e1, i, s)=>{
                const a = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), r = i.paint.get("hillshade-accent-color");
                let n = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (n -= t1.transform.angle);
                const l = !t1.options.moving;
                return {
                    u_matrix: s ? s.posMatrix : t1.transform.calculatePosMatrix(e1.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: Ee(0, e1.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        n
                    ],
                    u_shadow: a,
                    u_highlight: o,
                    u_accent: r
                };
            })(t1, i, s, u ? e1 : null), u, s.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
        }
        function ji(e1, i, s, a, o, r) {
            const n = e1.context, l = n.gl, c = i.dem;
            if (c && c.data) {
                const h = c.dim, u = c.stride, d = c.getPixels();
                if (n.activeTexture.set(l.TEXTURE1), n.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e1.getTileTexture(u), i.demTexture) {
                    const t1 = i.demTexture;
                    t1.update(d, {
                        premultiply: !1
                    }), t1.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new y(n, d, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                n.activeTexture.set(l.TEXTURE0);
                let _ = i.fbo;
                if (!_) {
                    const t1 = new y(n, {
                        width: h,
                        height: h,
                        data: null
                    }, l.RGBA);
                    t1.bind(l.LINEAR, l.CLAMP_TO_EDGE), _ = i.fbo = n.createFramebuffer(h, h, !0, !1), _.colorAttachment.set(t1.texture);
                }
                n.bindFramebuffer.set(_.framebuffer), n.viewport.set([
                    0,
                    0,
                    h,
                    h
                ]), e1.useProgram("hillshadePrepare").draw(n, l.TRIANGLES, a, o, r, Ai.disabled, ((e1, i)=>{
                    const s = i.stride, a = t1.create();
                    return t1.ortho(a, 0, t1.EXTENT, -t1.EXTENT, 0, 0, 1), t1.translate(a, a, [
                        0,
                        -t1.EXTENT,
                        0
                    ]), {
                        u_matrix: a,
                        u_image: 1,
                        u_dimension: [
                            s,
                            s
                        ],
                        u_zoom: e1.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                })(i.tileID, c), null, s.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function $i(e1, i, s, a, o, r) {
            const n = a.paint.get("raster-fade-duration");
            if (!r && n > 0) {
                const a = t1.exported.now(), r = (a - e1.timeAdded) / n, l = i ? (a - i.timeAdded) / n : -1, c = s.getSource(), h = o.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(e1.tileID.overscaledZ - h), d = u && e1.refreshedUponExpiration ? 1 : t1.clamp(u ? r : 1 - l, 0, 1);
                return e1.refreshedUponExpiration && r >= 1 && (e1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        const Xi = new t1.Color(1, 0, 0, 1), Wi = new t1.Color(0, 1, 0, 1), Hi = new t1.Color(0, 0, 1, 1), Ki = new t1.Color(1, 0, 1, 1), Yi = new t1.Color(0, 1, 1, 1);
        function Ji(t1, e1, i, s) {
            ts(t1, 0, e1 + i / 2, t1.transform.width, i, s);
        }
        function Qi(t1, e1, i, s) {
            ts(t1, e1 - i / 2, 0, i, t1.transform.height, s);
        }
        function ts(t1, e1, i, s, a, o) {
            const r = t1.context, n = r.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(e1 * t1.pixelRatio, i * t1.pixelRatio, s * t1.pixelRatio, a * t1.pixelRatio), r.clear({
                color: o
            }), n.disable(n.SCISSOR_TEST);
        }
        function es(e1, i, s) {
            const a = e1.context, o = a.gl, r = s.posMatrix, n = e1.useProgram("debug"), l = Di.disabled, c = Mi.disabled, h = e1.colorModeForRenderPass(), u = "$debug", d = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(s);
            a.activeTexture.set(o.TEXTURE0);
            const _ = i.getTileByID(s.key).latestRawTileData, m = Math.floor((_ && _.byteLength || 0) / 1024), p = i.getTile(s).tileSize, f = 512 / Math.min(p, 512) * (s.overscaledZ / e1.transform.zoom) * .5;
            let g = s.canonical.toString();
            s.overscaledZ !== s.canonical.z && (g += ` => ${s.overscaledZ}`), function(t1, e1) {
                t1.initDebugOverlayCanvas();
                const i = t1.debugOverlayCanvas, s = t1.context.gl, a = t1.debugOverlayCanvas.getContext("2d");
                a.clearRect(0, 0, i.width, i.height), a.shadowColor = "white", a.shadowBlur = 2, a.lineWidth = 1.5, a.strokeStyle = "white", a.textBaseline = "top", a.font = "bold 36px Open Sans, sans-serif", a.fillText(e1, 5, 5), a.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(i), t1.debugOverlayTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            }(e1, `${g} ${m}kB`), n.draw(a, o.TRIANGLES, l, c, Ci.alphaBlended, Ai.disabled, be(r, t1.Color.transparent, f), null, u, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), n.draw(a, o.LINE_STRIP, l, c, h, Ai.disabled, be(r, t1.Color.red), d, u, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
        }
        function is(t1, e1, i) {
            const s = t1.context, a = s.gl, o = t1.colorModeForRenderPass(), r = new Di(a.LEQUAL, Di.ReadWrite, t1.depthRangeFor3D), n = t1.useProgram("terrain"), l = e1.getTerrainMesh();
            s.bindFramebuffer.set(null), s.viewport.set([
                0,
                0,
                t1.width,
                t1.height
            ]);
            for (const c of i){
                const i = t1.renderToTexture.getTexture(c), h = e1.getTerrainData(c.tileID);
                s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, i.texture);
                const u = {
                    u_matrix: t1.transform.calculatePosMatrix(c.tileID.toUnwrapped()),
                    u_texture: 0,
                    u_ele_delta: e1.getMeshFrameDelta(t1.transform.zoom)
                };
                n.draw(s, a.TRIANGLES, r, Mi.disabled, o, Ai.backCCW, u, h, "terrain", l.vertexBuffer, l.indexBuffer, l.segments);
            }
        }
        const ss = {
            symbol: function(e1, i, s, a, o) {
                if ("translucent" !== e1.renderPass) return;
                const r = Mi.disabled, n = e1.colorModeForRenderPass();
                s.layout.get("text-variable-anchor") && function(e1, i, s, a, o, r, n) {
                    const l = i.transform, c = "map" === o, h = "map" === r;
                    for (const o of e1){
                        const e1 = a.getTile(o), r = e1.getBucket(s);
                        if (!r || !r.text || !r.text.segments.get().length) continue;
                        const u = t1.evaluateSizeForZoom(r.textSizeData, l.zoom), d = Ct(e1, 1, i.transform.zoom), _ = lt(o.posMatrix, h, c, i.transform, d), m = "none" !== s.layout.get("icon-text-fit") && r.hasIconData();
                        if (u) {
                            const t1 = Math.pow(2, l.zoom - e1.tileID.overscaledZ);
                            Fi(r, c, h, n, l, _, o.posMatrix, t1, u, m, i.style.map.terrain ? (t1, e1)=>i.style.map.terrain.getElevation(o, t1, e1) : null);
                        }
                    }
                }(a, e1, s, i, s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), o), 0 !== s.paint.get("icon-opacity").constantOr(1) && Oi(e1, i, s, a, !1, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), s.layout.get("icon-rotation-alignment"), s.layout.get("icon-pitch-alignment"), s.layout.get("icon-keep-upright"), r, n), 0 !== s.paint.get("text-opacity").constantOr(1) && Oi(e1, i, s, a, !0, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), s.layout.get("text-keep-upright"), r, n), i.map.showCollisionBoxes && (Ri(e1, i, s, a, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), !0), Ri(e1, i, s, a, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(e1, i, s, a) {
                if ("translucent" !== e1.renderPass) return;
                const o = s.paint.get("circle-opacity"), r = s.paint.get("circle-stroke-width"), n = s.paint.get("circle-stroke-opacity"), l = !s.layout.get("circle-sort-key").isConstant();
                if (0 === o.constantOr(1) && (0 === r.constantOr(1) || 0 === n.constantOr(1))) return;
                const c = e1.context, h = c.gl, u = e1.depthModeForSublayer(0, Di.ReadOnly), d = Mi.disabled, _ = e1.colorModeForRenderPass(), m = [];
                for(let o = 0; o < a.length; o++){
                    const r = a[o], n = i.getTile(r), c = n.getBucket(s);
                    if (!c) continue;
                    const h = c.programConfigurations.get(s.id), u = e1.useProgram("circle", h), d = c.layoutVertexBuffer, _ = c.indexBuffer, p = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(r), f = {
                        programConfiguration: h,
                        program: u,
                        layoutVertexBuffer: d,
                        indexBuffer: _,
                        uniformValues: xe(e1, r, n, s),
                        terrainData: p
                    };
                    if (l) {
                        const e1 = c.segments.get();
                        for (const i of e1)m.push({
                            segments: new t1.SegmentVector([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: f
                        });
                    } else m.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: f
                    });
                }
                l && m.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                for (const t1 of m){
                    const { programConfiguration: i, program: a, layoutVertexBuffer: o, indexBuffer: r, uniformValues: n, terrainData: l } = t1.state;
                    a.draw(c, h.TRIANGLES, u, d, _, Ai.disabled, n, l, s.id, o, r, t1.segments, s.paint, e1.transform.zoom, i);
                }
            },
            heatmap: function(e1, i, s, a) {
                if (0 !== s.paint.get("heatmap-opacity")) {
                    if ("offscreen" === e1.renderPass) {
                        const o = e1.context, r = o.gl, n = Mi.disabled, l = new Ci([
                            r.ONE,
                            r.ONE
                        ], t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(t1, e1, i) {
                            const s = t1.gl;
                            t1.activeTexture.set(s.TEXTURE1), t1.viewport.set([
                                0,
                                0,
                                e1.width / 4,
                                e1.height / 4
                            ]);
                            let a = i.heatmapFbo;
                            if (a) s.bindTexture(s.TEXTURE_2D, a.colorAttachment.get()), t1.bindFramebuffer.set(a.framebuffer);
                            else {
                                const o = s.createTexture();
                                s.bindTexture(s.TEXTURE_2D, o), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), a = i.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1, !1), function(t1, e1, i, s) {
                                    var a, o;
                                    const r = t1.gl, n = null !== (a = t1.HALF_FLOAT) && void 0 !== a ? a : r.UNSIGNED_BYTE, l = null !== (o = t1.RGBA16F) && void 0 !== o ? o : r.RGBA;
                                    r.texImage2D(r.TEXTURE_2D, 0, l, e1.width / 4, e1.height / 4, 0, r.RGBA, n, null), s.colorAttachment.set(i);
                                }(t1, e1, o, a);
                            }
                        }(o, e1, s), o.clear({
                            color: t1.Color.transparent
                        });
                        for(let t1 = 0; t1 < a.length; t1++){
                            const c = a[t1];
                            if (i.hasRenderableParent(c)) continue;
                            const h = i.getTile(c), u = h.getBucket(s);
                            if (!u) continue;
                            const d = u.programConfigurations.get(s.id), _ = e1.useProgram("heatmap", d), { zoom: m } = e1.transform;
                            _.draw(o, r.TRIANGLES, Di.disabled, n, l, Ai.disabled, Te(c.posMatrix, h, m, s.paint.get("heatmap-intensity")), null, s.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, s.paint, e1.transform.zoom, d);
                        }
                        o.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, i) {
                        const s = e1.context, a = s.gl, o = i.heatmapFbo;
                        if (!o) return;
                        s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, o.colorAttachment.get()), s.activeTexture.set(a.TEXTURE1);
                        let r = i.colorRampTexture;
                        r || (r = i.colorRampTexture = new y(s, i.colorRamp, a.RGBA)), r.bind(a.LINEAR, a.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(s, a.TRIANGLES, Di.disabled, Mi.disabled, e1.colorModeForRenderPass(), Ai.disabled, ((e1, i, s, a)=>{
                            const o = t1.create();
                            t1.ortho(o, 0, e1.width, e1.height, 0, 0, 1);
                            const r = e1.context.gl;
                            return {
                                u_matrix: o,
                                u_world: [
                                    r.drawingBufferWidth,
                                    r.drawingBufferHeight
                                ],
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: i.paint.get("heatmap-opacity")
                            };
                        })(e1, i), null, i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom);
                    }(e1, s));
                }
            },
            line: function(e1, i, s, a) {
                if ("translucent" !== e1.renderPass) return;
                const o = s.paint.get("line-opacity"), r = s.paint.get("line-width");
                if (0 === o.constantOr(1) || 0 === r.constantOr(1)) return;
                const n = e1.depthModeForSublayer(0, Di.ReadOnly), l = e1.colorModeForRenderPass(), c = s.paint.get("line-dasharray"), h = s.paint.get("line-pattern"), u = h.constantOr(1), d = s.paint.get("line-gradient"), _ = s.getCrossfadeParameters(), m = u ? "linePattern" : c ? "lineSDF" : d ? "lineGradient" : "line", p = e1.context, f = p.gl;
                let g = !0;
                for (const o of a){
                    const a = i.getTile(o);
                    if (u && !a.patternsLoaded()) continue;
                    const r = a.getBucket(s);
                    if (!r) continue;
                    const v = r.programConfigurations.get(s.id), x = e1.context.program.get(), b = e1.useProgram(m, v), w = g || b.program !== x, T = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(o), E = h.constantOr(null);
                    if (E && a.imageAtlas) {
                        const t1 = a.imageAtlas, e1 = t1.patternPositions[E.to.toString()], i = t1.patternPositions[E.from.toString()];
                        e1 && i && v.setConstantPatternPositions(e1, i);
                    }
                    const I = T ? o : null, S = u ? Ce(e1, a, s, _, I) : c ? Pe(e1, a, s, c, _, I) : d ? Se(e1, a, s, r.lineClipsArray.length, I) : Ie(e1, a, s, I);
                    if (u) p.activeTexture.set(f.TEXTURE0), a.imageAtlasTexture.bind(f.LINEAR, f.CLAMP_TO_EDGE), v.updatePaintBuffers(_);
                    else if (c && (w || e1.lineAtlas.dirty)) p.activeTexture.set(f.TEXTURE0), e1.lineAtlas.bind(p);
                    else if (d) {
                        const a = r.gradients[s.id];
                        let n = a.texture;
                        if (s.gradientVersion !== a.version) {
                            let l = 256;
                            if (s.stepInterpolant) {
                                const s = i.getSource().maxzoom, a = o.canonical.z === s ? Math.ceil(1 << e1.transform.maxZoom - o.canonical.z) : 1;
                                l = t1.clamp(t1.nextPowerOfTwo(r.maxLineLength / t1.EXTENT * 1024 * a), 256, p.maxTextureSize);
                            }
                            a.gradient = t1.renderColorRamp({
                                expression: s.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: l,
                                image: a.gradient || void 0,
                                clips: r.lineClipsArray
                            }), a.texture ? a.texture.update(a.gradient) : a.texture = new y(p, a.gradient, f.RGBA), a.version = s.gradientVersion, n = a.texture;
                        }
                        p.activeTexture.set(f.TEXTURE0), n.bind(s.stepInterpolant ? f.NEAREST : f.LINEAR, f.CLAMP_TO_EDGE);
                    }
                    b.draw(p, f.TRIANGLES, n, e1.stencilModeForClipping(o), l, Ai.disabled, S, T, s.id, r.layoutVertexBuffer, r.indexBuffer, r.segments, s.paint, e1.transform.zoom, v, r.layoutVertexBuffer2), g = !1;
                }
            },
            fill: function(e1, i, s, a) {
                const o = s.paint.get("fill-color"), r = s.paint.get("fill-opacity");
                if (0 === r.constantOr(1)) return;
                const n = e1.colorModeForRenderPass(), l = s.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === o.constantOr(t1.Color.transparent).a && 1 === r.constantOr(0) ? "opaque" : "translucent";
                if (e1.renderPass === c) {
                    const t1 = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? Di.ReadWrite : Di.ReadOnly);
                    Zi(e1, i, s, a, t1, n, !1);
                }
                if ("translucent" === e1.renderPass && s.paint.get("fill-antialias")) {
                    const t1 = e1.depthModeForSublayer(s.getPaintProperty("fill-outline-color") ? 2 : 0, Di.ReadOnly);
                    Zi(e1, i, s, a, t1, n, !0);
                }
            },
            "fill-extrusion": function(t1, e1, i, s) {
                const a = i.paint.get("fill-extrusion-opacity");
                if (0 !== a && "translucent" === t1.renderPass) {
                    const o = new Di(t1.context.gl.LEQUAL, Di.ReadWrite, t1.depthRangeFor3D);
                    if (1 !== a || i.paint.get("fill-extrusion-pattern").constantOr(1)) Vi(t1, e1, i, s, o, Mi.disabled, Ci.disabled), Vi(t1, e1, i, s, o, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                    else {
                        const a = t1.colorModeForRenderPass();
                        Vi(t1, e1, i, s, o, Mi.disabled, a);
                    }
                }
            },
            hillshade: function(t1, e1, i, s) {
                if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                const a = t1.context, o = t1.depthModeForSublayer(0, Di.ReadOnly), r = t1.colorModeForRenderPass(), [n, l] = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(s) : [
                    {},
                    s
                ];
                for (const s of l){
                    const a = e1.getTile(s);
                    void 0 !== a.needsHillshadePrepare && a.needsHillshadePrepare && "offscreen" === t1.renderPass ? ji(t1, a, i, o, Mi.disabled, r) : "translucent" === t1.renderPass && qi(t1, s, a, i, o, n[s.overscaledZ], r);
                }
                a.viewport.set([
                    0,
                    0,
                    t1.width,
                    t1.height
                ]);
            },
            raster: function(t1, e1, i, s) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === i.paint.get("raster-opacity")) return;
                if (!s.length) return;
                const a = t1.context, o = a.gl, r = e1.getSource(), n = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), [c, h] = r instanceof G ? [
                    {},
                    s
                ] : t1.stencilConfigForOverlap(s), u = h[h.length - 1].overscaledZ, d = !t1.options.moving;
                for (const s of h){
                    const h = t1.depthModeForSublayer(s.overscaledZ - u, 1 === i.paint.get("raster-opacity") ? Di.ReadWrite : Di.ReadOnly, o.LESS), _ = e1.getTile(s);
                    _.registerFadeDuration(i.paint.get("raster-fade-duration"));
                    const m = e1.findLoadedParent(s, 0), p = $i(_, m, e1, i, t1.transform, t1.style.map.terrain);
                    let f, g;
                    const v = "nearest" === i.paint.get("raster-resampling") ? o.NEAREST : o.LINEAR;
                    a.activeTexture.set(o.TEXTURE0), _.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), a.activeTexture.set(o.TEXTURE1), m ? (m.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), f = Math.pow(2, m.tileID.overscaledZ - _.tileID.overscaledZ), g = [
                        _.tileID.canonical.x * f % 1,
                        _.tileID.canonical.y * f % 1
                    ]) : _.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST);
                    const x = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(s), y = x ? s : null, b = y ? y.posMatrix : t1.transform.calculatePosMatrix(s.toUnwrapped(), d), w = Me(b, g || [
                        0,
                        0
                    ], f || 1, p, i);
                    r instanceof G ? n.draw(a, o.TRIANGLES, h, Mi.disabled, l, Ai.disabled, w, x, i.id, r.boundsBuffer, t1.quadTriangleIndexBuffer, r.boundsSegments) : n.draw(a, o.TRIANGLES, h, c[s.overscaledZ], l, Ai.disabled, w, x, i.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                }
            },
            background: function(t1, e1, i, s) {
                const a = i.paint.get("background-color"), o = i.paint.get("background-opacity");
                if (0 === o) return;
                const r = t1.context, n = r.gl, l = t1.transform, c = l.tileSize, h = i.paint.get("background-pattern");
                if (t1.isPatternMissing(h)) return;
                const u = !h && 1 === a.a && 1 === o && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== u) return;
                const d = Mi.disabled, _ = t1.depthModeForSublayer(0, "opaque" === u ? Di.ReadWrite : Di.ReadOnly), m = t1.colorModeForRenderPass(), p = t1.useProgram(h ? "backgroundPattern" : "background"), f = s || l.coveringTiles({
                    tileSize: c,
                    terrain: t1.style.map.terrain
                });
                h && (r.activeTexture.set(n.TEXTURE0), t1.imageManager.bind(t1.context));
                const g = i.getCrossfadeParameters();
                for (const e1 of f){
                    const l = s ? e1.posMatrix : t1.transform.calculatePosMatrix(e1.toUnwrapped()), u = h ? Fe(l, o, t1, h, {
                        tileID: e1,
                        tileSize: c
                    }, g) : Be(l, o, a), f = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(e1);
                    p.draw(r, n.TRIANGLES, _, d, m, Ai.disabled, u, f, i.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                }
            },
            debug: function(t1, e1, i) {
                for(let s = 0; s < i.length; s++)es(t1, e1, i[s]);
            },
            custom: function(t1, e1, i) {
                const s = t1.context, a = i.implementation;
                if ("offscreen" === t1.renderPass) {
                    const e1 = a.prerender;
                    e1 && (t1.setCustomLayerDefaults(), s.setColorMode(t1.colorModeForRenderPass()), e1.call(a, s.gl, t1.transform.customLayerMatrix()), s.setDirty(), t1.setBaseState());
                } else if ("translucent" === t1.renderPass) {
                    t1.setCustomLayerDefaults(), s.setColorMode(t1.colorModeForRenderPass()), s.setStencilMode(Mi.disabled);
                    const e1 = "3d" === a.renderingMode ? new Di(t1.context.gl.LEQUAL, Di.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Di.ReadOnly);
                    s.setDepthMode(e1), a.render(s.gl, t1.transform.customLayerMatrix()), s.setDirty(), t1.setBaseState(), s.bindFramebuffer.set(null);
                }
            }
        };
        class as {
            constructor(e1, i){
                this.context = new Pi(e1), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t1.create(),
                    renderTime: 0
                }, this.setup(), this.numSublayers = Y.maxUnderzooming + Y.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Qt;
            }
            resize(t1, e1, i) {
                if (this.width = t1 * i, this.height = e1 * i, this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const t1 of this.style._order)this.style._layers[t1].resize();
            }
            setup() {
                const e1 = this.context, i = new t1.PosArray;
                i.emplaceBack(0, 0), i.emplaceBack(t1.EXTENT, 0), i.emplaceBack(0, t1.EXTENT), i.emplaceBack(t1.EXTENT, t1.EXTENT), this.tileExtentBuffer = e1.createVertexBuffer(i, oe.members), this.tileExtentSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const s = new t1.PosArray;
                s.emplaceBack(0, 0), s.emplaceBack(t1.EXTENT, 0), s.emplaceBack(0, t1.EXTENT), s.emplaceBack(t1.EXTENT, t1.EXTENT), this.debugBuffer = e1.createVertexBuffer(s, oe.members), this.debugSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 5);
                const a = new t1.RasterBoundsArray;
                a.emplaceBack(0, 0, 0, 0), a.emplaceBack(t1.EXTENT, 0, t1.EXTENT, 0), a.emplaceBack(0, t1.EXTENT, 0, t1.EXTENT), a.emplaceBack(t1.EXTENT, t1.EXTENT, t1.EXTENT, t1.EXTENT), this.rasterBoundsBuffer = e1.createVertexBuffer(a, N.members), this.rasterBoundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const o = new t1.PosArray;
                o.emplaceBack(0, 0), o.emplaceBack(1, 0), o.emplaceBack(0, 1), o.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(o, oe.members), this.viewportSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                const r = new t1.LineStripIndexArray;
                r.emplaceBack(0), r.emplaceBack(1), r.emplaceBack(3), r.emplaceBack(2), r.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(r);
                const n = new t1.TriangleIndexArray;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(n);
                const l = this.context.gl;
                this.stencilClearMode = new Mi({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
            }
            clearStencil() {
                const e1 = this.context, i = e1.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const s = t1.create();
                t1.ortho(s, 0, this.width, this.height, 0, 0, 1), t1.scale(s, s, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]), this.useProgram("clippingMask").draw(e1, i.TRIANGLES, Di.disabled, this.stencilClearMode, Ci.disabled, Ai.disabled, we(s), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(t1, e1) {
                if (this.currentStencilSource === t1.source || !t1.isTileClipped() || !e1 || !e1.length) return;
                this.currentStencilSource = t1.source;
                const i = this.context, s = i.gl;
                this.nextStencilID + e1.length > 256 && this.clearStencil(), i.setColorMode(Ci.disabled), i.setDepthMode(Di.disabled);
                const a = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t1 of e1){
                    const e1 = this._tileClippingMaskIDs[t1.key] = this.nextStencilID++, o = this.style.map.terrain && this.style.map.terrain.getTerrainData(t1);
                    a.draw(i, s.TRIANGLES, Di.disabled, new Mi({
                        func: s.ALWAYS,
                        mask: 0
                    }, e1, 255, s.KEEP, s.KEEP, s.REPLACE), Ci.disabled, Ai.disabled, we(t1.posMatrix), o, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t1 = this.nextStencilID++, e1 = this.context.gl;
                return new Mi({
                    func: e1.NOTEQUAL,
                    mask: 255
                }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
            }
            stencilModeForClipping(t1) {
                const e1 = this.context.gl;
                return new Mi({
                    func: e1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
            }
            stencilConfigForOverlap(t1) {
                const e1 = this.context.gl, i = t1.sort((t1, e1)=>e1.overscaledZ - t1.overscaledZ), s = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - s + 1;
                if (a > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                    const t1 = {};
                    for(let i = 0; i < a; i++)t1[i + s] = new Mi({
                        func: e1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
                    return this.nextStencilID += a, [
                        t1,
                        i
                    ];
                }
                return [
                    {
                        [s]: Mi.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Ci([
                        e1.CONSTANT_COLOR,
                        e1.ONE
                    ], new t1.Color(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Ci.unblended : Ci.alphaBlended;
            }
            depthModeForSublayer(t1, e1, i) {
                if (!this.opaquePassEnabledForLayer()) return Di.disabled;
                const s = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                return new Di(i || this.context.gl.LEQUAL, e1, [
                    s,
                    s
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e1, i) {
                this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(t1.exported.now()), this.imageManager.beginFrame();
                const s = this.style._order, a = this.style.sourceCaches, o = {}, r = {}, n = {};
                for(const t1 in a){
                    const e1 = a[t1];
                    e1.used && e1.prepare(this.context), o[t1] = e1.getVisibleCoordinates(), r[t1] = o[t1].slice().reverse(), n[t1] = e1.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let t1 = 0; t1 < s.length; t1++)if (this.style._layers[s[t1]].is3D()) {
                    this.opaquePassCutoff = t1;
                    break;
                }
                if (this.renderToTexture) {
                    this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0;
                    const e1 = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime);
                    (this.terrainFacilitator.dirty || !t1.equals(this.terrainFacilitator.matrix, this.transform.projMatrix) || e1.length) && (t1.copy(this.terrainFacilitator.matrix, this.transform.projMatrix), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e1, i) {
                        const s = e1.context, a = s.gl, o = Ci.unblended, r = new Di(a.LEQUAL, Di.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.sourceCache.getRenderableTiles(), c = e1.useProgram("terrainDepth");
                        s.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), s.viewport.set([
                            0,
                            0,
                            e1.width / devicePixelRatio,
                            e1.height / devicePixelRatio
                        ]), s.clear({
                            color: t1.Color.transparent,
                            depth: 1
                        });
                        for (const t1 of l){
                            const l = i.getTerrainData(t1.tileID), h = {
                                u_matrix: e1.transform.calculatePosMatrix(t1.tileID.toUnwrapped()),
                                u_ele_delta: i.getMeshFrameDelta(e1.transform.zoom)
                            };
                            c.draw(s, a.TRIANGLES, r, Mi.disabled, o, Ai.backCCW, h, l, "terrain", n.vertexBuffer, n.indexBuffer, n.segments);
                        }
                        s.bindFramebuffer.set(null), s.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    }(this, this.style.map.terrain), function(e1, i) {
                        const s = e1.context, a = s.gl, o = Ci.unblended, r = new Di(a.LEQUAL, Di.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.getCoordsTexture(), c = i.sourceCache.getRenderableTiles(), h = e1.useProgram("terrainCoords");
                        s.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), s.viewport.set([
                            0,
                            0,
                            e1.width / devicePixelRatio,
                            e1.height / devicePixelRatio
                        ]), s.clear({
                            color: t1.Color.transparent,
                            depth: 1
                        }), i.coordsIndex = [];
                        for (const t1 of c){
                            const c = i.getTerrainData(t1.tileID);
                            s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, l.texture);
                            const u = {
                                u_matrix: e1.transform.calculatePosMatrix(t1.tileID.toUnwrapped()),
                                u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                                u_texture: 0,
                                u_ele_delta: i.getMeshFrameDelta(e1.transform.zoom)
                            };
                            h.draw(s, a.TRIANGLES, r, Mi.disabled, o, Ai.backCCW, u, c, "terrain", n.vertexBuffer, n.indexBuffer, n.segments), i.coordsIndex.push(t1.tileID.key);
                        }
                        s.bindFramebuffer.set(null), s.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    }(this, this.style.map.terrain));
                }
                this.renderPass = "offscreen";
                for (const t1 of s){
                    const e1 = this.style._layers[t1];
                    if (!e1.hasOffscreenPass() || e1.isHidden(this.transform.zoom)) continue;
                    const i = r[e1.source];
                    ("custom" === e1.type || i.length) && this.renderLayer(this, a[e1.source], e1, i);
                }
                if (this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t1.Color.black : t1.Color.transparent,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = s.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t1 = this.style._layers[s[this.currentLayer]], e1 = a[t1.source], i = o[t1.source];
                    this._renderTileClippingMasks(t1, i), this.renderLayer(this, e1, t1, i);
                }
                for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < s.length; this.currentLayer++){
                    const t1 = this.style._layers[s[this.currentLayer]], e1 = a[t1.source];
                    if (this.renderToTexture && this.renderToTexture.renderLayer(t1)) continue;
                    const i = ("symbol" === t1.type ? n : r)[t1.source];
                    this._renderTileClippingMasks(t1, o[t1.source]), this.renderLayer(this, e1, t1, i);
                }
                if (this.options.showTileBoundaries) {
                    const t1 = function(t1, e1) {
                        let i = null;
                        const s = Object.values(t1._layers).flatMap((i)=>i.source && !i.isHidden(e1) ? [
                                t1.sourceCaches[i.source]
                            ] : []), a = s.filter((t1)=>"vector" === t1.getSource().type), o = s.filter((t1)=>"vector" !== t1.getSource().type), r = (t1)=>{
                            (!i || i.getSource().maxzoom < t1.getSource().maxzoom) && (i = t1);
                        };
                        return a.forEach((t1)=>r(t1)), i || o.forEach((t1)=>r(t1)), i;
                    }(this.style, this.transform.zoom);
                    t1 && ss.debug(this, t1, t1.getVisibleCoordinates());
                }
                this.options.showPadding && function(t1) {
                    const e1 = t1.transform.padding;
                    Ji(t1, t1.transform.height - (e1.top || 0), 3, Xi), Ji(t1, e1.bottom || 0, 3, Wi), Qi(t1, e1.left || 0, 3, Hi), Qi(t1, t1.transform.width - (e1.right || 0), 3, Ki);
                    const i = t1.transform.centerPoint;
                    !function(t1, e1, i, s) {
                        ts(t1, e1 - 1, i - 10, 2, 20, s), ts(t1, e1 - 10, i - 1, 20, 2, s);
                    }(t1, i.x, t1.transform.height - i.y, Yi);
                }(this), this.context.setDefault();
            }
            renderLayer(t1, e1, i, s) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "custom" === i.type || (s || []).length) && (this.id = i.id, ss[i.type](t1, e1, i, s, this.style.placement.variableOffsets));
            }
            translatePosMatrix(e1, i, s, a, o) {
                if (!s[0] && !s[1]) return e1;
                const r = o ? "map" === a ? this.transform.angle : 0 : "viewport" === a ? -this.transform.angle : 0;
                if (r) {
                    const t1 = Math.sin(r), e1 = Math.cos(r);
                    s = [
                        s[0] * e1 - s[1] * t1,
                        s[0] * t1 + s[1] * e1
                    ];
                }
                const n = [
                    o ? s[0] : Ct(i, s[0], this.transform.zoom),
                    o ? s[1] : Ct(i, s[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return t1.translate(l, e1, n), l;
            }
            saveTileTexture(t1) {
                const e1 = this._tileTextures[t1.size[0]];
                e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                    t1
                ];
            }
            getTileTexture(t1) {
                const e1 = this._tileTextures[t1];
                return e1 && e1.length > 0 ? e1.pop() : null;
            }
            isPatternMissing(t1) {
                if (!t1) return !1;
                if (!t1.from || !t1.to) return !0;
                const e1 = this.imageManager.getPattern(t1.from.toString()), i = this.imageManager.getPattern(t1.to.toString());
                return !e1 || !i;
            }
            useProgram(t1, e1) {
                this.cache = this.cache || {};
                const i = t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
                return this.cache[i] || (this.cache[i] = new ue(this.context, t1, ne[t1], e1, Ue[t1], this._showOverdrawInspector, this.style.map.terrain)), this.cache[i];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const t1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(t1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new y(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
            }
        }
        class os {
            constructor(t1, e1){
                this.points = t1, this.planes = e1;
            }
            static fromInvProjectionMatrix(e1, i, s) {
                const a = Math.pow(2, s), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((s)=>{
                    const o = 1 / (s = t1.transformMat4([], s, e1))[3] / i * a;
                    return t1.mul$1(s, s, [
                        o,
                        o,
                        1 / s[3],
                        o
                    ]);
                }), r = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t1)=>{
                    const e1 = function(t1, e1) {
                        var i = e1[0], s = e1[1], a = e1[2], o = i * i + s * s + a * a;
                        return o > 0 && (o = 1 / Math.sqrt(o)), t1[0] = e1[0] * o, t1[1] = e1[1] * o, t1[2] = e1[2] * o, t1;
                    }([], function(t1, e1, i) {
                        var s = e1[0], a = e1[1], o = e1[2], r = i[0], n = i[1], l = i[2];
                        return t1[0] = a * l - o * n, t1[1] = o * r - s * l, t1[2] = s * n - a * r, t1;
                    }([], f([], o[t1[0]], o[t1[1]]), f([], o[t1[2]], o[t1[1]]))), i = -((s = e1)[0] * (a = o[t1[1]])[0] + s[1] * a[1] + s[2] * a[2]);
                    var s, a;
                    return e1.concat(i);
                });
                return new os(o, r);
            }
        }
        class rs {
            constructor(t1, e1){
                this.min = t1, this.max = e1, this.center = function(t1, e1, i) {
                    return t1[0] = .5 * e1[0], t1[1] = .5 * e1[1], t1[2] = .5 * e1[2], t1;
                }([], function(t1, e1, i) {
                    return t1[0] = e1[0] + i[0], t1[1] = e1[1] + i[1], t1[2] = e1[2] + i[2], t1;
                }([], this.min, this.max));
            }
            quadrant(t1) {
                const e1 = [
                    t1 % 2 == 0,
                    t1 < 2
                ], i = m(this.min), s = m(this.max);
                for(let t1 = 0; t1 < e1.length; t1++)i[t1] = e1[t1] ? this.min[t1] : this.center[t1], s[t1] = e1[t1] ? this.center[t1] : this.max[t1];
                return s[2] = this.max[2], new rs(i, s);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            intersects(e1) {
                const i = [
                    [
                        this.min[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.max[2],
                        1
                    ]
                ];
                let s = !0;
                for(let a = 0; a < e1.planes.length; a++){
                    const o = e1.planes[a];
                    let r = 0;
                    for(let e1 = 0; e1 < i.length; e1++)t1.dot(o, i[e1]) >= 0 && r++;
                    if (0 === r) return 0;
                    r !== i.length && (s = !1);
                }
                if (s) return 2;
                for(let t1 = 0; t1 < 3; t1++){
                    let i = Number.MAX_VALUE, s = -Number.MAX_VALUE;
                    for(let a = 0; a < e1.points.length; a++){
                        const o = e1.points[a][t1] - this.min[t1];
                        i = Math.min(i, o), s = Math.max(s, o);
                    }
                    if (s < 0 || i > this.max[t1] - this.min[t1]) return 0;
                }
                return 1;
            }
        }
        class ns {
            constructor(t1 = 0, e1 = 0, i = 0, s = 0){
                if (isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(i) || i < 0 || isNaN(s) || s < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = t1, this.bottom = e1, this.left = i, this.right = s;
            }
            interpolate(e1, i, s) {
                return null != i.top && null != e1.top && (this.top = t1.interpolate.number(e1.top, i.top, s)), null != i.bottom && null != e1.bottom && (this.bottom = t1.interpolate.number(e1.bottom, i.bottom, s)), null != i.left && null != e1.left && (this.left = t1.interpolate.number(e1.left, i.left, s)), null != i.right && null != e1.right && (this.right = t1.interpolate.number(e1.right, i.right, s)), this;
            }
            getCenter(e1, i) {
                const s = t1.clamp((this.left + e1 - this.right) / 2, 0, e1), a = t1.clamp((this.top + i - this.bottom) / 2, 0, i);
                return new t1.Point(s, a);
            }
            equals(t1) {
                return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
            }
            clone() {
                return new ns(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        class ls {
            constructor(e1, i, s, a, o){
                this.tileSize = 512, this.maxValidLatitude = 85.051129, this.freezeElevation = !1, this._renderWorldCopies = void 0 === o || !!o, this._minZoom = e1 || 0, this._maxZoom = i || 22, this._minPitch = null == s ? 0 : s, this._maxPitch = null == a ? 60 : a, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t1.LngLat(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new ns, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
            clone() {
                const t1 = new ls(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                return t1.apply(this), t1;
            }
            apply(t1) {
                this.tileSize = t1.tileSize, this.latRange = t1.latRange, this.width = t1.width, this.height = t1.height, this._center = t1._center, this._elevation = t1._elevation, this.zoom = t1.zoom, this.angle = t1.angle, this._fov = t1._fov, this._pitch = t1._pitch, this._unmodified = t1._unmodified, this._edgeInsets = t1._edgeInsets.clone(), this._calcMatrices();
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(t1) {
                this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(t1) {
                this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(t1) {
                this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(t1) {
                this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            set renderWorldCopies(t1) {
                void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t1.Point(this.width, this.height);
            }
            get bearing() {
                return -this.angle / Math.PI * 180;
            }
            set bearing(e1) {
                const i = -t1.wrap(e1, -180, 180) * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = function() {
                    var e1 = new t1.ARRAY_TYPE(4);
                    return t1.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
                }(), function(t1, e1, i) {
                    var s = e1[0], a = e1[1], o = e1[2], r = e1[3], n = Math.sin(i), l = Math.cos(i);
                    t1[0] = s * l + o * n, t1[1] = a * l + r * n, t1[2] = s * -n + o * l, t1[3] = a * -n + r * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e1) {
                const i = t1.clamp(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(t1) {
                const e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
                this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.tileZoom = Math.max(0, Math.floor(e1)), this.scale = this.zoomScale(e1), this._constrain(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            set center(t1) {
                t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(t1) {
                t1 !== this._elevation && (this._elevation = t1, this._constrain(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(t1) {
                this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            isPaddingEqual(t1) {
                return this._edgeInsets.equals(t1);
            }
            interpolatePadding(t1, e1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(t1) {
                const e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
                return Math.max(0, e1);
            }
            getVisibleUnwrappedCoordinates(e1) {
                const i = [
                    new t1.UnwrappedTileID(0, e1)
                ];
                if (this._renderWorldCopies) {
                    const s = this.pointCoordinate(new t1.Point(0, 0)), a = this.pointCoordinate(new t1.Point(this.width, 0)), o = this.pointCoordinate(new t1.Point(this.width, this.height)), r = this.pointCoordinate(new t1.Point(0, this.height)), n = Math.floor(Math.min(s.x, a.x, o.x, r.x)), l = Math.floor(Math.max(s.x, a.x, o.x, r.x)), c = 1;
                    for(let s = n - c; s <= l + c; s++)0 !== s && i.push(new t1.UnwrappedTileID(s, e1));
                }
                return i;
            }
            coveringTiles(e1) {
                var i, s;
                let a = this.coveringZoomLevel(e1);
                const o = a;
                if (void 0 !== e1.minzoom && a < e1.minzoom) return [];
                void 0 !== e1.maxzoom && a > e1.maxzoom && (a = e1.maxzoom);
                const r = this.pointCoordinate(this.getCameraPoint()), n = t1.MercatorCoordinate.fromLngLat(this.center), l = Math.pow(2, a), c = [
                    l * r.x,
                    l * r.y,
                    0
                ], h = [
                    l * n.x,
                    l * n.y,
                    0
                ], u = os.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, a);
                let d = e1.minzoom || 0;
                !e1.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (d = a);
                const _ = e1.terrain ? 2 / Math.min(this.tileSize, e1.tileSize) * this.tileSize : 3, m = (t1)=>({
                        aabb: new rs([
                            t1 * l,
                            0,
                            0
                        ], [
                            (t1 + 1) * l,
                            l,
                            0
                        ]),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        wrap: t1,
                        fullyVisible: !1
                    }), p = [], f = [], v = a, x = e1.reparseOverscaled ? o : a;
                if (this._renderWorldCopies) for(let t1 = 1; t1 <= 3; t1++)p.push(m(-t1)), p.push(m(t1));
                for(p.push(m(0)); p.length > 0;){
                    const a = p.pop(), o = a.x, r = a.y;
                    let n = a.fullyVisible;
                    if (!n) {
                        const t1 = a.aabb.intersects(u);
                        if (0 === t1) continue;
                        n = 2 === t1;
                    }
                    const l = e1.terrain ? c : h, m = a.aabb.distanceX(l), y = a.aabb.distanceY(l), b = Math.max(Math.abs(m), Math.abs(y));
                    if (a.zoom === v || b > _ + (1 << v - a.zoom) - 2 && a.zoom >= d) {
                        const e1 = v - a.zoom, i = c[0] - .5 - (o << e1), s = c[1] - .5 - (r << e1);
                        f.push({
                            tileID: new t1.OverscaledTileID(a.zoom === v ? x : a.zoom, a.wrap, a.zoom, o, r),
                            distanceSq: g([
                                h[0] - .5 - o,
                                h[1] - .5 - r
                            ]),
                            tileDistanceToCamera: Math.sqrt(i * i + s * s)
                        });
                    } else for(let l = 0; l < 4; l++){
                        const c = (o << 1) + l % 2, h = (r << 1) + (l >> 1), u = a.zoom + 1;
                        let d = a.aabb.quadrant(l);
                        if (e1.terrain) {
                            const o = new t1.OverscaledTileID(u, a.wrap, u, c, h), r = e1.terrain.getMinMaxElevation(o), n = null !== (i = r.minElevation) && void 0 !== i ? i : this.elevation, l = null !== (s = r.maxElevation) && void 0 !== s ? s : this.elevation;
                            d = new rs([
                                d.min[0],
                                d.min[1],
                                n
                            ], [
                                d.max[0],
                                d.max[1],
                                l
                            ]);
                        }
                        p.push({
                            aabb: d,
                            zoom: u,
                            x: c,
                            y: h,
                            wrap: a.wrap,
                            fullyVisible: n
                        });
                    }
                }
                return f.sort((t1, e1)=>t1.distanceSq - e1.distanceSq).map((t1)=>t1.tileID);
            }
            resize(t1, e1) {
                this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                    2 / t1,
                    -2 / e1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(t1) {
                return Math.pow(2, t1);
            }
            scaleZoom(t1) {
                return Math.log(t1) / Math.LN2;
            }
            project(e1) {
                const i = t1.clamp(e1.lat, -this.maxValidLatitude, this.maxValidLatitude);
                return new t1.Point(t1.mercatorXfromLng(e1.lng) * this.worldSize, t1.mercatorYfromLat(i) * this.worldSize);
            }
            unproject(e1) {
                return new t1.MercatorCoordinate(e1.x / this.worldSize, e1.y / this.worldSize).toLngLat();
            }
            get point() {
                return this.project(this.center);
            }
            updateElevation(t1) {
                this.freezeElevation || (this.elevation = t1 ? this.getElevation(this._center, t1) : 0);
            }
            getElevation(e1, i) {
                const s = t1.MercatorCoordinate.fromLngLat(e1.wrap()), a = (1 << this.tileZoom) * t1.EXTENT, o = s.x * a, r = s.y * a, n = Math.floor(o / t1.EXTENT), l = Math.floor(r / t1.EXTENT), c = new t1.OverscaledTileID(this.tileZoom, 0, this.tileZoom, n, l);
                return i.getElevation(c, o % t1.EXTENT, r % t1.EXTENT, t1.EXTENT);
            }
            getCameraPosition() {
                return {
                    lngLat: this.pointLocation(this.getCameraPoint()),
                    altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                };
            }
            recalculateZoom(e1) {
                const i = this.pointLocation(this.centerPoint, e1), s = this.getElevation(i, e1);
                if (!(this.elevation - s)) return;
                const a = this.getCameraPosition(), o = t1.MercatorCoordinate.fromLngLat(a.lngLat, a.altitude), r = t1.MercatorCoordinate.fromLngLat(i, s), n = o.x - r.x, l = o.y - r.y, c = o.z - r.z, h = Math.sqrt(n * n + l * l + c * c), u = this.scaleZoom(this.cameraToCenterDistance / h / this.tileSize);
                this._elevation = s, this._center = i, this.zoom = u;
            }
            setLocationAtPoint(e1, i) {
                const s = this.pointCoordinate(i), a = this.pointCoordinate(this.centerPoint), o = this.locationCoordinate(e1), r = new t1.MercatorCoordinate(o.x - (s.x - a.x), o.y - (s.y - a.y));
                this.center = this.coordinateLocation(r), this._renderWorldCopies && (this.center = this.center.wrap());
            }
            locationPoint(t1, e1) {
                return e1 ? this.coordinatePoint(this.locationCoordinate(t1), this.getElevation(t1, e1), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(t1));
            }
            pointLocation(t1, e1) {
                return this.coordinateLocation(this.pointCoordinate(t1, e1));
            }
            locationCoordinate(e1) {
                return t1.MercatorCoordinate.fromLngLat(e1);
            }
            coordinateLocation(t1) {
                return t1 && t1.toLngLat();
            }
            pointCoordinate(e1, i) {
                if (i) {
                    const t1 = i.pointCoordinate(e1);
                    if (null != t1) return t1;
                }
                const s = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], a = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                t1.transformMat4(s, s, this.pixelMatrixInverse), t1.transformMat4(a, a, this.pixelMatrixInverse);
                const o = s[3], r = a[3], n = s[1] / o, l = a[1] / r, c = s[2] / o, h = a[2] / r, u = c === h ? 0 : (0 - c) / (h - c);
                return new t1.MercatorCoordinate(t1.interpolate.number(s[0] / o, a[0] / r, u) / this.worldSize, t1.interpolate.number(n, l, u) / this.worldSize);
            }
            coordinatePoint(e1, i = 0, s = this.pixelMatrix) {
                const a = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i,
                    1
                ];
                return t1.transformMat4(a, a, s), new t1.Point(a[0] / a[3], a[1] / a[3]);
            }
            getBounds() {
                const e1 = Math.max(0, this.height / 2 - this.getHorizon());
                return (new R).extend(this.pointLocation(new t1.Point(0, e1))).extend(this.pointLocation(new t1.Point(this.width, e1))).extend(this.pointLocation(new t1.Point(this.width, this.height))).extend(this.pointLocation(new t1.Point(0, this.height)));
            }
            getMaxBounds() {
                return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new R([
                    this.lngRange[0],
                    this.latRange[0]
                ], [
                    this.lngRange[1],
                    this.latRange[1]
                ]) : null;
            }
            getHorizon() {
                return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
            }
            setMaxBounds(t1) {
                t1 ? (this.lngRange = [
                    t1.getWest(),
                    t1.getEast()
                ], this.latRange = [
                    t1.getSouth(),
                    t1.getNorth()
                ], this._constrain()) : (this.lngRange = null, this.latRange = [
                    -this.maxValidLatitude,
                    this.maxValidLatitude
                ]);
            }
            calculatePosMatrix(e1, i = !1) {
                const s = e1.key, a = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (a[s]) return a[s];
                const o = e1.canonical, r = this.worldSize / this.zoomScale(o.z), n = o.x + Math.pow(2, o.z) * e1.wrap, l = t1.identity(new Float64Array(16));
                return t1.translate(l, l, [
                    n * r,
                    o.y * r,
                    0
                ]), t1.scale(l, l, [
                    r / t1.EXTENT,
                    r / t1.EXTENT,
                    1
                ]), t1.multiply(l, i ? this.alignedProjMatrix : this.projMatrix, l), a[s] = new Float32Array(l), a[s];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                let e1, i, s, a, o = -90, r = 90, n = -180, l = 180;
                const c = this.size, h = this._unmodified;
                if (this.latRange) {
                    const i = this.latRange;
                    o = t1.mercatorYfromLat(i[1]) * this.worldSize, r = t1.mercatorYfromLat(i[0]) * this.worldSize, e1 = r - o < c.y ? c.y / (r - o) : 0;
                }
                if (this.lngRange) {
                    const e1 = this.lngRange;
                    n = t1.wrap(t1.mercatorXfromLng(e1[0]) * this.worldSize, 0, this.worldSize), l = t1.wrap(t1.mercatorXfromLng(e1[1]) * this.worldSize, 0, this.worldSize), l < n && (l += this.worldSize), i = l - n < c.x ? c.x / (l - n) : 0;
                }
                const u = this.point, d = Math.max(i || 0, e1 || 0);
                if (d) return this.center = this.unproject(new t1.Point(i ? (l + n) / 2 : u.x, e1 ? (r + o) / 2 : u.y)), this.zoom += this.scaleZoom(d), this._unmodified = h, void (this._constraining = !1);
                if (this.latRange) {
                    const t1 = u.y, e1 = c.y / 2;
                    t1 - e1 < o && (a = o + e1), t1 + e1 > r && (a = r - e1);
                }
                if (this.lngRange) {
                    const e1 = (n + l) / 2, i = t1.wrap(u.x, e1 - this.worldSize / 2, e1 + this.worldSize / 2), a = c.x / 2;
                    i - a < n && (s = n + a), i + a > l && (s = l - a);
                }
                void 0 === s && void 0 === a || (this.center = this.unproject(new t1.Point(void 0 !== s ? s : u.x, void 0 !== a ? a : u.y)).wrap()), this._unmodified = h, this._constraining = !1;
            }
            _calcMatrices() {
                if (!this.height) return;
                const e1 = this.centerOffset, i = this.point.x, s = this.point.y;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = t1.mercatorZfromAltitude(1, this.center.lat) * this.worldSize;
                let a = t1.identity(new Float64Array(16));
                t1.scale(a, a, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), t1.translate(a, a, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = a, a = t1.identity(new Float64Array(16)), t1.scale(a, a, [
                    1,
                    -1,
                    1
                ]), t1.translate(a, a, [
                    -1,
                    -1,
                    0
                ]), t1.scale(a, a, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = a, this.cameraToSeaLevelDistance = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch);
                const o = this._elevation < 0 ? this.cameraToCenterDistance : this.cameraToSeaLevelDistance, r = Math.PI / 2 + this._pitch, n = this._fov * (.5 + e1.y / this.height), l = Math.sin(n) * o / Math.sin(t1.clamp(Math.PI - r - n, .01, Math.PI - .01)), c = this.getHorizon(), h = 2 * Math.atan(c / this.cameraToCenterDistance) * (.5 + e1.y / (2 * c)), u = Math.sin(h) * o / Math.sin(t1.clamp(Math.PI - r - h, .01, Math.PI - .01)), d = Math.min(l, u), _ = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * d + o), m = this.height / 50;
                a = new Float64Array(16), t1.perspective(a, this._fov, this.width / this.height, m, _), a[8] = 2 * -e1.x / this.width, a[9] = 2 * e1.y / this.height, t1.scale(a, a, [
                    1,
                    -1,
                    1
                ]), t1.translate(a, a, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t1.rotateX(a, a, this._pitch), t1.rotateZ(a, a, this.angle), t1.translate(a, a, [
                    -i,
                    -s,
                    0
                ]), this.mercatorMatrix = t1.scale([], a, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t1.scale(a, a, [
                    1,
                    1,
                    this._pixelPerMeter
                ]), this.pixelMatrix = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, a), t1.translate(a, a, [
                    0,
                    0,
                    -this.elevation
                ]), this.projMatrix = a, this.invProjMatrix = t1.invert([], a), this.pixelMatrix3D = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, a);
                const p = this.width % 2 / 2, f = this.height % 2 / 2, g = Math.cos(this.angle), v = Math.sin(this.angle), x = i - Math.round(i) + g * p + v * f, y = s - Math.round(s) + g * f + v * p, b = new Float64Array(a);
                if (t1.translate(b, b, [
                    x > .5 ? x - 1 : x,
                    y > .5 ? y - 1 : y,
                    0
                ]), this.alignedProjMatrix = b, a = t1.invert(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = a, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
            maxPitchScaleFactor() {
                if (!this.pixelMatrixInverse) return 1;
                const e1 = this.pointCoordinate(new t1.Point(0, 0)), i = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    0,
                    1
                ];
                return t1.transformMat4(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
            }
            getCameraPoint() {
                const e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t1.Point(0, e1));
            }
            getCameraQueryGeometry(e1) {
                const i = this.getCameraPoint();
                if (1 === e1.length) return [
                    e1[0],
                    i
                ];
                {
                    let s = i.x, a = i.y, o = i.x, r = i.y;
                    for (const t1 of e1)s = Math.min(s, t1.x), a = Math.min(a, t1.y), o = Math.max(o, t1.x), r = Math.max(r, t1.y);
                    return [
                        new t1.Point(s, a),
                        new t1.Point(o, a),
                        new t1.Point(o, r),
                        new t1.Point(s, r),
                        new t1.Point(s, a)
                    ];
                }
            }
        }
        class cs {
            constructor(e1){
                this._hashName = e1 && encodeURIComponent(e1), t1.bindAll([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = function(t1, e1) {
                    let i = !1, s = null;
                    const a = ()=>{
                        s = null, i && (t1(), s = setTimeout(a, 300), i = !1);
                    };
                    return ()=>(i = !0, s || a(), s);
                }(this._updateHashUnthrottled.bind(this));
            }
            addTo(t1) {
                return this._map = t1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
            }
            getHashString(t1) {
                const e1 = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, s = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, s), o = Math.round(e1.lng * a) / a, r = Math.round(e1.lat * a) / a, n = this._map.getBearing(), l = this._map.getPitch();
                let c = "";
                if (c += t1 ? `/${o}/${r}/${i}` : `${i}/${r}/${o}`, (n || l) && (c += "/" + Math.round(10 * n) / 10), l && (c += `/${Math.round(l)}`), this._hashName) {
                    const t1 = this._hashName;
                    let e1 = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const s = i.split("=")[0];
                        return s === t1 ? (e1 = !0, `${s}=${c}`) : i;
                    }).filter((t1)=>t1);
                    return e1 || i.push(`${t1}=${c}`), `#${i.join("&")}`;
                }
                return `#${c}`;
            }
            _getCurrentHash() {
                const t1 = window.location.hash.replace("#", "");
                if (this._hashName) {
                    let e1;
                    return t1.split("&").map((t1)=>t1.split("=")).forEach((t1)=>{
                        t1[0] === this._hashName && (e1 = t1);
                    }), (e1 && e1[1] || "").split("/");
                }
                return t1.split("/");
            }
            _onHashChange() {
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((t1)=>isNaN(t1))) {
                    const e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                    return this._map.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: e1,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                const t1 = window.location.href.replace(/(#.+)?$/, this.getHashString());
                try {
                    window.history.replaceState(window.history.state, null, t1);
                } catch (t1) {}
            }
        }
        const hs = {
            linearity: .3,
            easing: t1.bezier(0, 0, .3, 1)
        }, us = t1.extend({
            deceleration: 2500,
            maxSpeed: 1400
        }, hs), ds = t1.extend({
            deceleration: 20,
            maxSpeed: 1400
        }, hs), _s = t1.extend({
            deceleration: 1e3,
            maxSpeed: 360
        }, hs), ms = t1.extend({
            deceleration: 1e3,
            maxSpeed: 90
        }, hs);
        class ps {
            constructor(t1){
                this._map = t1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: t1.exported.now(),
                    settings: e1
                });
            }
            _drainInertiaBuffer() {
                const e1 = this._inertiaBuffer, i = t1.exported.now();
                for(; e1.length > 0 && i - e1[0].time > 160;)e1.shift();
            }
            _onMoveEnd(e1) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new t1.Point(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: t1 } of this._inertiaBuffer)i.zoom += t1.zoomDelta || 0, i.bearing += t1.bearingDelta || 0, i.pitch += t1.pitchDelta || 0, t1.panDelta && i.pan._add(t1.panDelta), t1.around && (i.around = t1.around), t1.pinchAround && (i.pinchAround = t1.pinchAround);
                const s = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, a = {};
                if (i.pan.mag()) {
                    const o = gs(i.pan.mag(), s, t1.extend({}, us, e1 || {}));
                    a.offset = i.pan.mult(o.amount / i.pan.mag()), a.center = this._map.transform.center, fs(a, o);
                }
                if (i.zoom) {
                    const t1 = gs(i.zoom, s, ds);
                    a.zoom = this._map.transform.zoom + t1.amount, fs(a, t1);
                }
                if (i.bearing) {
                    const e1 = gs(i.bearing, s, _s);
                    a.bearing = this._map.transform.bearing + t1.clamp(e1.amount, -179, 179), fs(a, e1);
                }
                if (i.pitch) {
                    const t1 = gs(i.pitch, s, ms);
                    a.pitch = this._map.transform.pitch + t1.amount, fs(a, t1);
                }
                if (a.zoom || a.bearing) {
                    const t1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    a.around = t1 ? this._map.unproject(t1) : this._map.getCenter();
                }
                return this.clear(), t1.extend(a, {
                    noMoveStart: !0
                });
            }
        }
        function fs(t1, e1) {
            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
        }
        function gs(e1, i, s) {
            const { maxSpeed: a, linearity: o, deceleration: r } = s, n = t1.clamp(e1 * o / (i / 1e3), -a, a), l = Math.abs(n) / (r * o);
            return {
                easing: s.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class vs extends t1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, s, a, o = {}){
                const r = i.mousePos(s.getCanvasContainer(), a), n = s.unproject(r);
                super(e1, t1.extend({
                    point: r,
                    lngLat: n,
                    originalEvent: a
                }, o)), this._defaultPrevented = !1, this.target = s;
            }
        }
        class xs extends t1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, s, a){
                const o = "touchend" === e1 ? a.changedTouches : a.touches, r = i.touchPos(s.getCanvasContainer(), o), n = r.map((t1)=>s.unproject(t1)), l = r.reduce((t1, e1, i, s)=>t1.add(e1.div(s.length)), new t1.Point(0, 0));
                super(e1, {
                    points: r,
                    point: l,
                    lngLats: n,
                    lngLat: s.unproject(l),
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
        }
        class ys extends t1.Event {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, e1, i){
                super(t1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class bs {
            constructor(t1, e1){
                this._map = t1, this._clickTolerance = e1.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(t1) {
                return this._firePreventable(new ys(t1.type, this._map, t1));
            }
            mousedown(t1, e1) {
                return this._mousedownPos = e1, this._firePreventable(new vs(t1.type, this._map, t1));
            }
            mouseup(t1) {
                this._map.fire(new vs(t1.type, this._map, t1));
            }
            click(t1, e1) {
                this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new vs(t1.type, this._map, t1));
            }
            dblclick(t1) {
                return this._firePreventable(new vs(t1.type, this._map, t1));
            }
            mouseover(t1) {
                this._map.fire(new vs(t1.type, this._map, t1));
            }
            mouseout(t1) {
                this._map.fire(new vs(t1.type, this._map, t1));
            }
            touchstart(t1) {
                return this._firePreventable(new xs(t1.type, this._map, t1));
            }
            touchmove(t1) {
                this._map.fire(new xs(t1.type, this._map, t1));
            }
            touchend(t1) {
                this._map.fire(new xs(t1.type, this._map, t1));
            }
            touchcancel(t1) {
                this._map.fire(new xs(t1.type, this._map, t1));
            }
            _firePreventable(t1) {
                if (this._map.fire(t1), t1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class ws {
            constructor(t1){
                this._map = t1;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(t1) {
                this._map.fire(new vs(t1.type, this._map, t1));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new vs("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(t1) {
                this._delayContextMenu ? this._contextMenuEvent = t1 : this._ignoreContextMenu || this._map.fire(new vs(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Ts {
            constructor(t1){
                this._map = t1;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(e1) {
                return this.transform.pointLocation(t1.Point.convert(e1), this._map.terrain);
            }
        }
        class Es {
            constructor(t1, e1){
                this._map = t1, this._tr = new Ts(t1), this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(t1, e1) {
                this.isEnabled() && t1.shiftKey && 0 === t1.button && (i.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
            }
            mousemoveWindow(t1, e1) {
                if (!this._active) return;
                const s = e1;
                if (this._lastPos.equals(s) || !this._box && s.dist(this._startPos) < this._clickTolerance) return;
                const a = this._startPos;
                this._lastPos = s, this._box || (this._box = i.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", t1));
                const o = Math.min(a.x, s.x), r = Math.max(a.x, s.x), n = Math.min(a.y, s.y), l = Math.max(a.y, s.y);
                i.setTransform(this._box, `translate(${o}px,${n}px)`), this._box.style.width = r - o + "px", this._box.style.height = l - n + "px";
            }
            mouseupWindow(e1, s) {
                if (!this._active) return;
                if (0 !== e1.button) return;
                const a = this._startPos, o = s;
                if (this.reset(), i.suppressClick(), a.x !== o.x || a.y !== o.y) return this._map.fire(new t1.Event("boxzoomend", {
                    originalEvent: e1
                })), {
                    cameraAnimation: (t1)=>t1.fitScreenCoordinates(a, o, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e1);
            }
            keydown(t1) {
                this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (i.remove(this._box), this._box = null), i.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e1, i) {
                return this._map.fire(new t1.Event(e1, {
                    originalEvent: i
                }));
            }
        }
        function Is(t1, e1) {
            if (t1.length !== e1.length) throw new Error(`The number of touches and points are not equal - touches ${t1.length}, points ${e1.length}`);
            const i = {};
            for(let s = 0; s < t1.length; s++)i[t1[s].identifier] = e1[s];
            return i;
        }
        class Ss {
            constructor(t1){
                this.reset(), this.numTouches = t1.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e1, i, s) {
                (this.centroid || s.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), s.length === this.numTouches && (this.centroid = function(e1) {
                    const i = new t1.Point(0, 0);
                    for (const t1 of e1)i._add(t1);
                    return i.div(e1.length);
                }(i), this.touches = Is(s, i)));
            }
            touchmove(t1, e1, i) {
                if (this.aborted || !this.centroid) return;
                const s = Is(i, e1);
                for(const t1 in this.touches){
                    const e1 = s[t1];
                    (!e1 || e1.dist(this.touches[t1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(t1, e1, i) {
                if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const t1 = !this.aborted && this.centroid;
                    if (this.reset(), t1) return t1;
                }
            }
        }
        class Cs {
            constructor(t1){
                this.singleTap = new Ss(t1), this.numTaps = t1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(t1, e1, i) {
                this.singleTap.touchstart(t1, e1, i);
            }
            touchmove(t1, e1, i) {
                this.singleTap.touchmove(t1, e1, i);
            }
            touchend(t1, e1, i) {
                const s = this.singleTap.touchend(t1, e1, i);
                if (s) {
                    const e1 = t1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(s) < 30;
                    if (e1 && i || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = s, this.count === this.numTaps) return this.reset(), s;
                }
            }
        }
        class Ps {
            constructor(t1){
                this._tr = new Ts(t1), this._zoomIn = new Cs({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Cs({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(t1, e1, i) {
                this._zoomIn.touchstart(t1, e1, i), this._zoomOut.touchstart(t1, e1, i);
            }
            touchmove(t1, e1, i) {
                this._zoomIn.touchmove(t1, e1, i), this._zoomOut.touchmove(t1, e1, i);
            }
            touchend(t1, e1, i) {
                const s = this._zoomIn.touchend(t1, e1, i), a = this._zoomOut.touchend(t1, e1, i), o = this._tr;
                return s ? (this._active = !0, t1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e1)=>e1.easeTo({
                            duration: 300,
                            zoom: o.zoom + 1,
                            around: o.unproject(s)
                        }, {
                            originalEvent: t1
                        })
                }) : a ? (this._active = !0, t1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e1)=>e1.easeTo({
                            duration: 300,
                            zoom: o.zoom - 1,
                            around: o.unproject(a)
                        }, {
                            originalEvent: t1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ds {
            constructor(t1){
                this._enabled = !!t1.enable, this._moveStateManager = t1.moveStateManager, this._clickTolerance = t1.clickTolerance || 1, this._moveFunction = t1.move, this._activateOnStart = !!t1.activateOnStart, t1.assignEvents(this), this.reset();
            }
            reset(t1) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(t1);
            }
            _move(...t1) {
                const e1 = this._moveFunction(...t1);
                if (e1.bearingDelta || e1.pitchDelta || e1.around || e1.panDelta) return this._active = !0, e1;
            }
            dragStart(t1, e1) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(t1) && (this._moveStateManager.startMove(t1), this._lastPoint = e1.length ? e1[0] : e1, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(t1, e1) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (t1.preventDefault(), !this._moveStateManager.isValidMoveEvent(t1)) return void this.reset(t1);
                const s = e1.length ? e1[0] : e1;
                return !this._moved && s.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = s, this._move(i, s));
            }
            dragEnd(t1) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(t1) && (this._moved && i.suppressClick(), this.reset(t1));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const zs = {
            0: 1,
            2: 2
        };
        class Ms {
            constructor(t1){
                this._correctEvent = t1.checkCorrectEvent;
            }
            startMove(t1) {
                const e1 = i.mouseButton(t1);
                this._eventButton = e1;
            }
            endMove(t1) {
                delete this._eventButton;
            }
            isValidStartEvent(t1) {
                return this._correctEvent(t1);
            }
            isValidMoveEvent(t1) {
                return !function(t1, e1) {
                    const i = zs[e1];
                    return void 0 === t1.buttons || (t1.buttons & i) !== i;
                }(t1, this._eventButton);
            }
            isValidEndEvent(t1) {
                return i.mouseButton(t1) === this._eventButton;
            }
        }
        class As {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(t1) {
                return 1 === t1.targetTouches.length;
            }
            _isSameTouchEvent(t1) {
                return t1.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(t1) {
                this._firstTouch = t1.targetTouches[0].identifier;
            }
            endMove(t1) {
                delete this._firstTouch;
            }
            isValidStartEvent(t1) {
                return this._isOneFingerTouch(t1);
            }
            isValidMoveEvent(t1) {
                return this._isOneFingerTouch(t1) && this._isSameTouchEvent(t1);
            }
            isValidEndEvent(t1) {
                return this._isOneFingerTouch(t1) && this._isSameTouchEvent(t1);
            }
        }
        const Ls = (t1)=>{
            t1.mousedown = t1.dragStart, t1.mousemoveWindow = t1.dragMove, t1.mouseup = t1.dragEnd, t1.contextmenu = function(t1) {
                t1.preventDefault();
            };
        }, Rs = ({ enable: t1, clickTolerance: e1, bearingDegreesPerPixelMoved: s = .8 })=>{
            const a = new Ms({
                checkCorrectEvent: (t1)=>0 === i.mouseButton(t1) && t1.ctrlKey || 2 === i.mouseButton(t1)
            });
            return new Ds({
                clickTolerance: e1,
                move: (t1, e1)=>({
                        bearingDelta: (e1.x - t1.x) * s
                    }),
                moveStateManager: a,
                enable: t1,
                assignEvents: Ls
            });
        }, ks = ({ enable: t1, clickTolerance: e1, pitchDegreesPerPixelMoved: s = -0.5 })=>{
            const a = new Ms({
                checkCorrectEvent: (t1)=>0 === i.mouseButton(t1) && t1.ctrlKey || 2 === i.mouseButton(t1)
            });
            return new Ds({
                clickTolerance: e1,
                move: (t1, e1)=>({
                        pitchDelta: (e1.y - t1.y) * s
                    }),
                moveStateManager: a,
                enable: t1,
                assignEvents: Ls
            });
        };
        class Bs {
            constructor(t1, e1){
                this._minTouches = t1.cooperativeGestures ? 2 : 1, this._clickTolerance = t1.clickTolerance || 1, this._map = e1, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t1.Point(0, 0), setTimeout(()=>{
                    this._cancelCooperativeMessage = !1;
                }, 200);
            }
            touchstart(t1, e1, i) {
                return this._calculateTransform(t1, e1, i);
            }
            touchmove(t1, e1, i) {
                if (this._map._cooperativeGestures && (2 === this._minTouches && i.length < 2 && !this._cancelCooperativeMessage ? this._map._onCooperativeGesture(t1, !1, i.length) : this._cancelCooperativeMessage || (this._cancelCooperativeMessage = !0)), this._active && !(i.length < this._minTouches)) return t1.preventDefault(), this._calculateTransform(t1, e1, i);
            }
            touchend(t1, e1, i) {
                this._calculateTransform(t1, e1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e1, i, s) {
                s.length > 0 && (this._active = !0);
                const a = Is(s, i), o = new t1.Point(0, 0), r = new t1.Point(0, 0);
                let n = 0;
                for(const t1 in a){
                    const e1 = a[t1], i = this._touches[t1];
                    i && (o._add(e1), r._add(e1.sub(i)), n++, a[t1] = e1);
                }
                if (this._touches = a, n < this._minTouches || !r.mag()) return;
                const l = r.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Fs {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            _start(t1) {}
            _move(t1, e1, i) {
                return {};
            }
            touchstart(t1, e1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    e1[0],
                    e1[1]
                ]));
            }
            touchmove(t1, e1, i) {
                if (!this._firstTwoTouches) return;
                t1.preventDefault();
                const [s, a] = this._firstTwoTouches, o = Us(i, e1, s), r = Us(i, e1, a);
                if (!o || !r) return;
                const n = this._aroundCenter ? null : o.add(r).div(2);
                return this._move([
                    o,
                    r
                ], n, t1);
            }
            touchend(t1, e1, s) {
                if (!this._firstTwoTouches) return;
                const [a, o] = this._firstTwoTouches, r = Us(s, e1, a), n = Us(s, e1, o);
                r && n || (this._active && i.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(t1) {
                this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Us(t1, e1, i) {
            for(let s = 0; s < t1.length; s++)if (t1[s].identifier === i) return e1[s];
        }
        function Os(t1, e1) {
            return Math.log(t1 / e1) / Math.LN2;
        }
        class Ns extends Fs {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(t1) {
                this._startDistance = this._distance = t1[0].dist(t1[1]);
            }
            _move(t1, e1) {
                const i = this._distance;
                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs(Os(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Os(this._distance, i),
                    pinchAround: e1
                };
            }
        }
        function Gs(t1, e1) {
            return 180 * t1.angleWith(e1) / Math.PI;
        }
        class Zs extends Fs {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(t1) {
                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
            }
            _move(t1, e1) {
                const i = this._vector;
                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: Gs(this._vector, i),
                    pinchAround: e1
                };
            }
            _isBelowThreshold(t1) {
                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                const e1 = 25 / (Math.PI * this._minDiameter) * 360, i = Gs(t1, this._startVector);
                return Math.abs(i) < e1;
            }
        }
        function Vs(t1) {
            return Math.abs(t1.y) > Math.abs(t1.x);
        }
        class qs extends Fs {
            constructor(t1){
                super(), this._map = t1;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(t1, e1, i) {
                super.touchstart(t1, e1, i), this._currentTouchCount = i.length;
            }
            _start(t1) {
                this._lastPoints = t1, Vs(t1[0].sub(t1[1])) && (this._valid = !1);
            }
            _move(t1, e1, i) {
                if (this._map._cooperativeGestures && this._currentTouchCount < 3) return;
                const s = t1[0].sub(this._lastPoints[0]), a = t1[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(s, a, i.timeStamp), this._valid ? (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (s.y + a.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(t1, e1, i) {
                if (void 0 !== this._valid) return this._valid;
                const s = t1.mag() >= 2, a = e1.mag() >= 2;
                if (!s && !a) return;
                if (!s || !a) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = t1.y > 0 == e1.y > 0;
                return Vs(t1) && Vs(e1) && o;
            }
        }
        const js = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class $s {
            constructor(t1){
                this._tr = new Ts(t1);
                const e1 = js;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(t1) {
                if (t1.altKey || t1.ctrlKey || t1.metaKey) return;
                let e1 = 0, i = 0, s = 0, a = 0, o = 0;
                switch(t1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        e1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        e1 = -1;
                        break;
                    case 37:
                        t1.shiftKey ? i = -1 : (t1.preventDefault(), a = -1);
                        break;
                    case 39:
                        t1.shiftKey ? i = 1 : (t1.preventDefault(), a = 1);
                        break;
                    case 38:
                        t1.shiftKey ? s = 1 : (t1.preventDefault(), o = -1);
                        break;
                    case 40:
                        t1.shiftKey ? s = -1 : (t1.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, s = 0), {
                    cameraAnimation: (r)=>{
                        const n = this._tr;
                        r.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Xs,
                            zoom: e1 ? Math.round(n.zoom) + e1 * (t1.shiftKey ? 2 : 1) : n.zoom,
                            bearing: n.bearing + i * this._bearingStep,
                            pitch: n.pitch + s * this._pitchStep,
                            offset: [
                                -a * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.center
                        }, {
                            originalEvent: t1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function Xs(t1) {
            return t1 * (2 - t1);
        }
        const Ws = 4.000244140625;
        class Hs {
            constructor(e1, i){
                this._map = e1, this._tr = new Ts(e1), this._el = e1.getCanvasContainer(), this._handler = i, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, t1.bindAll([
                    "_onTimeout"
                ], this);
            }
            setZoomRate(t1) {
                this._defaultZoomRate = t1;
            }
            setWheelZoomRate(t1) {
                this._wheelZoomRate = t1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(t1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = t1 && "center" === t1.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            wheel(e1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!e1[this._map._metaKey]) return;
                    e1.preventDefault();
                }
                let i = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                const s = t1.exported.now(), a = s - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = s, 0 !== i && i % Ws == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(a * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= i, this._active || this._start(e1)), e1.preventDefault();
            }
            _onTimeout(t1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const s = i.mousePos(this._el, e1), a = this._tr;
                this._around = t1.LngLat.convert(this._aroundCenter ? a.center : a.unproject(s)), this._aroundPoint = a.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e1 = this._tr.transform;
                if (0 !== this._delta) {
                    const t1 = "wheel" === this._type && Math.abs(this._delta) > Ws ? this._wheelZoomRate : this._defaultZoomRate;
                    let i = 2 / (1 + Math.exp(-Math.abs(this._delta * t1)));
                    this._delta < 0 && 0 !== i && (i = 1 / i);
                    const s = "number" == typeof this._targetZoom ? e1.zoomScale(this._targetZoom) : e1.scale;
                    this._targetZoom = Math.min(e1.maxZoom, Math.max(e1.minZoom, e1.scaleZoom(s * i))), "wheel" === this._type && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : e1.zoom, s = this._startZoom, a = this._easing;
                let o, r = !1;
                if ("wheel" === this._type && s && a) {
                    const e1 = Math.min((t1.exported.now() - this._lastWheelEventTime) / 200, 1), n = a(e1);
                    o = t1.interpolate.number(s, i, n), e1 < 1 ? this._frameId || (this._frameId = !0) : r = !0;
                } else o = i, r = !0;
                return this._active = !0, r && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !r,
                    zoomDelta: o - e1.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e1) {
                let i = t1.ease;
                if (this._prevEase) {
                    const e1 = this._prevEase, s = (t1.exported.now() - e1.start) / e1.duration, a = e1.easing(s + .01) - e1.easing(s), o = .27 / Math.sqrt(a * a + 1e-4) * .01, r = Math.sqrt(.0729 - o * o);
                    i = t1.bezier(o, r, .25, 1);
                }
                return this._prevEase = {
                    start: t1.exported.now(),
                    duration: e1,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1;
            }
        }
        class Ks {
            constructor(t1, e1){
                this._clickZoom = t1, this._tapZoom = e1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Ys {
            constructor(t1){
                this._tr = new Ts(t1), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(t1, e1) {
                return t1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: this._tr.zoom + (t1.shiftKey ? -1 : 1),
                            around: this._tr.unproject(e1)
                        }, {
                            originalEvent: t1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Js {
            constructor(){
                this._tap = new Cs({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
            }
            touchstart(t1, e1, i) {
                this._swipePoint || (this._tapTime && t1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = e1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(t1, e1, i));
            }
            touchmove(t1, e1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const s = e1[0], a = s.y - this._swipePoint.y;
                        return this._swipePoint = s, t1.preventDefault(), this._active = !0, {
                            zoomDelta: a / 128
                        };
                    }
                } else this._tap.touchmove(t1, e1, i);
            }
            touchend(t1, e1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(t1, e1, i) && (this._tapTime = t1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Qs {
            constructor(t1, e1, i){
                this._el = t1, this._mousePan = e1, this._touchPan = i;
            }
            enable(t1) {
                this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class ta {
            constructor(t1, e1, i){
                this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class ea {
            constructor(t1, e1, i, s){
                this._el = t1, this._touchZoom = e1, this._touchRotate = i, this._tapDragZoom = s, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(t1) {
                this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const ia = (t1)=>t1.zoom || t1.drag || t1.pitch || t1.rotate;
        class sa extends t1.Event {
        }
        function aa(t1) {
            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
        }
        class oa {
            constructor(e1, s){
                this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ps(e1), this._bearingSnap = s.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(s), t1.bindAll([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const a = this._el;
                this._listeners = [
                    [
                        a,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        a,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        a,
                        "touchend",
                        void 0
                    ],
                    [
                        a,
                        "touchcancel",
                        void 0
                    ],
                    [
                        a,
                        "mousedown",
                        void 0
                    ],
                    [
                        a,
                        "mousemove",
                        void 0
                    ],
                    [
                        a,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        a,
                        "mouseover",
                        void 0
                    ],
                    [
                        a,
                        "mouseout",
                        void 0
                    ],
                    [
                        a,
                        "dblclick",
                        void 0
                    ],
                    [
                        a,
                        "click",
                        void 0
                    ],
                    [
                        a,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        a,
                        "keyup",
                        void 0
                    ],
                    [
                        a,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        a,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t1, e1, s] of this._listeners)i.addEventListener(t1, e1, t1 === document ? this.handleWindowEvent : this.handleEvent, s);
            }
            destroy() {
                for (const [t1, e1, s] of this._listeners)i.removeEventListener(t1, e1, t1 === document ? this.handleWindowEvent : this.handleEvent, s);
            }
            _addDefaultHandlers(t1) {
                const e1 = this._map, s = e1.getCanvasContainer();
                this._add("mapEvent", new bs(e1, t1));
                const a = e1.boxZoom = new Es(e1, t1);
                this._add("boxZoom", a);
                const o = new Ps(e1), r = new Ys(e1);
                e1.doubleClickZoom = new Ks(r, o), this._add("tapZoom", o), this._add("clickZoom", r);
                const n = new Js;
                this._add("tapDragZoom", n);
                const l = e1.touchPitch = new qs(e1);
                this._add("touchPitch", l);
                const c = Rs(t1), h = ks(t1);
                e1.dragRotate = new ta(t1, c, h), this._add("mouseRotate", c, [
                    "mousePitch"
                ]), this._add("mousePitch", h, [
                    "mouseRotate"
                ]);
                const u = (({ enable: t1, clickTolerance: e1 })=>{
                    const s = new Ms({
                        checkCorrectEvent: (t1)=>0 === i.mouseButton(t1) && !t1.ctrlKey
                    });
                    return new Ds({
                        clickTolerance: e1,
                        move: (t1, e1)=>({
                                around: e1,
                                panDelta: e1.sub(t1)
                            }),
                        activateOnStart: !0,
                        moveStateManager: s,
                        enable: t1,
                        assignEvents: Ls
                    });
                })(t1), d = new Bs(t1, e1);
                e1.dragPan = new Qs(s, u, d), this._add("mousePan", u), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const _ = new Zs, m = new Ns;
                e1.touchZoomRotate = new ea(s, m, _, n), this._add("touchRotate", _, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", m, [
                    "touchPan",
                    "touchRotate"
                ]);
                const p = e1.scrollZoom = new Hs(e1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const f = e1.keyboard = new $s(e1);
                this._add("keyboard", f), this._add("blockableMapEvent", new ws(e1));
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])t1.interactive && t1[i] && e1[i].enable(t1[i]);
            }
            _add(t1, e1, i) {
                this._handlers.push({
                    handlerName: t1,
                    handler: e1,
                    allowed: i
                }), this._handlersById[t1] = e1;
            }
            stop(t1) {
                if (!this._updatingCamera) {
                    for (const { handler: t1 } of this._handlers)t1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, t1), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: t1 } of this._handlers)if (t1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(ia(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(t1, e1, i) {
                for(const s in t1)if (s !== i && (!e1 || e1.indexOf(s) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(t1) {
                this.handleEvent(t1, `${t1.type}Window`);
            }
            _getMapTouches(t1) {
                const e1 = [];
                for (const i of t1)this._el.contains(i.target) && e1.push(i);
                return e1;
            }
            handleEvent(t1, e1) {
                if ("blur" === t1.type) return void this.stop(!0);
                this._updatingCamera = !0;
                const s = "renderFrame" === t1.type ? void 0 : t1, a = {
                    needsRenderFrame: !1
                }, o = {}, r = {}, n = t1.touches, l = n ? this._getMapTouches(n) : void 0, c = l ? i.touchPos(this._el, l) : i.mousePos(this._el, t1);
                for (const { handlerName: i, handler: n, allowed: h } of this._handlers){
                    if (!n.isEnabled()) continue;
                    let u;
                    this._blockedByActive(r, h, i) ? n.reset() : n[e1 || t1.type] && (u = n[e1 || t1.type](t1, c, l), this.mergeHandlerResult(a, o, u, i, s), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || n.isActive()) && (r[i] = n);
                }
                const h = {};
                for(const t1 in this._previousActiveHandlers)r[t1] || (h[t1] = s);
                this._previousActiveHandlers = r, (Object.keys(h).length || aa(a)) && (this._changes.push([
                    a,
                    o,
                    h
                ]), this._triggerRenderFrame()), (Object.keys(r).length || aa(a)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: u } = a;
                u && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], u(this._map));
            }
            mergeHandlerResult(e1, i, s, a, o) {
                if (!s) return;
                t1.extend(e1, s);
                const r = {
                    handlerName: a,
                    originalEvent: s.originalEvent || o
                };
                void 0 !== s.zoomDelta && (i.zoom = r), void 0 !== s.panDelta && (i.drag = r), void 0 !== s.pitchDelta && (i.pitch = r), void 0 !== s.bearingDelta && (i.rotate = r);
            }
            _applyChanges() {
                const e1 = {}, i = {}, s = {};
                for (const [a, o, r] of this._changes)a.panDelta && (e1.panDelta = (e1.panDelta || new t1.Point(0, 0))._add(a.panDelta)), a.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + a.zoomDelta), a.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + a.bearingDelta), a.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + a.pitchDelta), void 0 !== a.around && (e1.around = a.around), void 0 !== a.pinchAround && (e1.pinchAround = a.pinchAround), a.noInertia && (e1.noInertia = a.noInertia), t1.extend(i, o), t1.extend(s, r);
                this._updateMapTransform(e1, i, s), this._changes = [];
            }
            _updateMapTransform(t1, e1, i) {
                const s = this._map, a = s._getTransformForUpdate(), o = s.terrain;
                if (!(aa(t1) || o && this._terrainMovement)) return this._fireEvents(e1, i, !0);
                let { panDelta: r, zoomDelta: n, bearingDelta: l, pitchDelta: c, around: h, pinchAround: u } = t1;
                void 0 !== u && (h = u), s._stop(!0), h = h || s.transform.centerPoint;
                const d = a.pointLocation(r ? h.sub(r) : h);
                l && (a.bearing += l), c && (a.pitch += c), n && (a.zoom += n), o ? this._terrainMovement || !e1.drag && !e1.zoom ? e1.drag && this._terrainMovement ? a.center = a.pointLocation(a.centerPoint.sub(r)) : a.setLocationAtPoint(d, h) : (this._terrainMovement = !0, a.freezeElevation = !0, a.setLocationAtPoint(d, h), this._map.once("moveend", ()=>{
                    a.freezeElevation = !1, this._terrainMovement = !1, a.recalculateZoom(s.terrain);
                })) : a.setLocationAtPoint(d, h), s._applyUpdatedTransform(a), this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(e1, i, !0);
            }
            _fireEvents(e1, i, s) {
                const a = ia(this._eventsInProgress), o = ia(e1), r = {};
                for(const t1 in e1){
                    const { originalEvent: i } = e1[t1];
                    this._eventsInProgress[t1] || (r[`${t1}start`] = i), this._eventsInProgress[t1] = e1[t1];
                }
                !a && o && this._fireEvent("movestart", o.originalEvent);
                for(const t1 in r)this._fireEvent(t1, r[t1]);
                o && this._fireEvent("move", o.originalEvent);
                for(const t1 in e1){
                    const { originalEvent: i } = e1[t1];
                    this._fireEvent(t1, i);
                }
                const n = {};
                let l;
                for(const t1 in this._eventsInProgress){
                    const { handlerName: e1, originalEvent: s } = this._eventsInProgress[t1];
                    this._handlersById[e1].isActive() || (delete this._eventsInProgress[t1], l = i[e1] || s, n[`${t1}end`] = l);
                }
                for(const t1 in n)this._fireEvent(t1, n[t1]);
                const c = ia(this._eventsInProgress);
                if (s && (a || o) && !c) {
                    this._updatingCamera = !0;
                    const e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (t1)=>0 !== t1 && -this._bearingSnap < t1 && t1 < this._bearingSnap;
                    e1 ? (i(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                        originalEvent: l
                    })) : (this._map.fire(new t1.Event("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(e1, i) {
                this._map.fire(new t1.Event(e1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((t1)=>{
                    delete this._frameId, this.handleEvent(new sa("renderFrame", {
                        timeStamp: t1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const ra = {
            extend: (e1, ...i)=>t1.extend(e1, ...i),
            run (t1) {
                t1();
            },
            logToElement (t1, e1 = !1, i = "log") {
                const s = window.document.getElementById(i);
                s && (e1 && (s.innerHTML = ""), s.innerHTML += `<br>${t1}`);
            }
        };
        class na extends t1.Evented {
            constructor(e1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = e1, this._bearingSnap = i.bearingSnap, t1.bindAll([
                    "_renderFrameCallback"
                ], this), this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            getCenter() {
                return new t1.LngLat(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(t1, e1) {
                return this.jumpTo({
                    center: t1
                }, e1);
            }
            panBy(e1, i, s) {
                return e1 = t1.Point.convert(e1).mult(-1), this.panTo(this.transform.center, t1.extend({
                    offset: e1
                }, i), s);
            }
            panTo(e1, i, s) {
                return this.easeTo(t1.extend({
                    center: e1
                }, i), s);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(t1, e1) {
                return this.jumpTo({
                    zoom: t1
                }, e1), this;
            }
            zoomTo(e1, i, s) {
                return this.easeTo(t1.extend({
                    zoom: e1
                }, i), s);
            }
            zoomIn(t1, e1) {
                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
            }
            zoomOut(t1, e1) {
                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(t1, e1) {
                return this.jumpTo({
                    bearing: t1
                }, e1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(t1, e1) {
                return this.jumpTo({
                    padding: t1
                }, e1), this;
            }
            rotateTo(e1, i, s) {
                return this.easeTo(t1.extend({
                    bearing: e1
                }, i), s);
            }
            resetNorth(e1, i) {
                return this.rotateTo(0, t1.extend({
                    duration: 1e3
                }, e1), i), this;
            }
            resetNorthPitch(e1, i) {
                return this.easeTo(t1.extend({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), i), this;
            }
            snapToNorth(t1, e1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(t1, e1) {
                return this.jumpTo({
                    pitch: t1
                }, e1), this;
            }
            cameraForBounds(t1, e1) {
                t1 = R.convert(t1);
                const i = e1 && e1.bearing || 0;
                return this._cameraForBoxAndBearing(t1.getNorthWest(), t1.getSouthEast(), i, e1);
            }
            _cameraForBoxAndBearing(e1, i, s, a) {
                const o = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (a = t1.extend({
                    padding: o,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, a)).padding) {
                    const t1 = a.padding;
                    a.padding = {
                        top: t1,
                        bottom: t1,
                        right: t1,
                        left: t1
                    };
                }
                a.padding = t1.extend(o, a.padding);
                const r = this.transform, n = r.padding, l = r.project(t1.LngLat.convert(e1)), c = r.project(t1.LngLat.convert(i)), h = l.rotate(-s * Math.PI / 180), u = c.rotate(-s * Math.PI / 180), d = new t1.Point(Math.max(h.x, u.x), Math.max(h.y, u.y)), _ = new t1.Point(Math.min(h.x, u.x), Math.min(h.y, u.y)), m = d.sub(_), p = (r.width - (n.left + n.right + a.padding.left + a.padding.right)) / m.x, f = (r.height - (n.top + n.bottom + a.padding.top + a.padding.bottom)) / m.y;
                if (f < 0 || p < 0) return void t1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                const g = Math.min(r.scaleZoom(r.scale * Math.min(p, f)), a.maxZoom), v = t1.Point.convert(a.offset), x = new t1.Point((a.padding.left - a.padding.right) / 2, (a.padding.top - a.padding.bottom) / 2).rotate(s * Math.PI / 180), y = v.add(x).mult(r.scale / r.zoomScale(g));
                return {
                    center: r.unproject(l.add(c).div(2).sub(y)),
                    zoom: g,
                    bearing: s
                };
            }
            fitBounds(t1, e1, i) {
                return this._fitInternal(this.cameraForBounds(t1, e1), e1, i);
            }
            fitScreenCoordinates(e1, i, s, a, o) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t1.Point.convert(e1)), this.transform.pointLocation(t1.Point.convert(i)), s, a), a, o);
            }
            _fitInternal(e1, i, s) {
                return e1 ? (delete (i = t1.extend(e1, i)).padding, i.linear ? this.easeTo(i, s) : this.flyTo(i, s)) : this;
            }
            jumpTo(e1, i) {
                this.stop();
                const s = this._getTransformForUpdate();
                let a = !1, o = !1, r = !1;
                return "zoom" in e1 && s.zoom !== +e1.zoom && (a = !0, s.zoom = +e1.zoom), void 0 !== e1.center && (s.center = t1.LngLat.convert(e1.center)), "bearing" in e1 && s.bearing !== +e1.bearing && (o = !0, s.bearing = +e1.bearing), "pitch" in e1 && s.pitch !== +e1.pitch && (r = !0, s.pitch = +e1.pitch), null == e1.padding || s.isPaddingEqual(e1.padding) || (s.padding = e1.padding), this._applyUpdatedTransform(s), this.fire(new t1.Event("movestart", i)).fire(new t1.Event("move", i)), a && this.fire(new t1.Event("zoomstart", i)).fire(new t1.Event("zoom", i)).fire(new t1.Event("zoomend", i)), o && this.fire(new t1.Event("rotatestart", i)).fire(new t1.Event("rotate", i)).fire(new t1.Event("rotateend", i)), r && this.fire(new t1.Event("pitchstart", i)).fire(new t1.Event("pitch", i)).fire(new t1.Event("pitchend", i)), this.fire(new t1.Event("moveend", i));
            }
            calculateCameraOptionsFromTo(e1, i, s, a = 0) {
                const o = t1.MercatorCoordinate.fromLngLat(e1, i), r = t1.MercatorCoordinate.fromLngLat(s, a), n = r.x - o.x, l = r.y - o.y, c = r.z - o.z, h = Math.hypot(n, l, c);
                if (0 === h) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = this.transform.scaleZoom(this.transform.cameraToCenterDistance / h / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let m = 180 * Math.acos(u / h) / Math.PI;
                return m = c < 0 ? 90 - m : 90 + m, {
                    center: r.toLngLat(),
                    zoom: d,
                    pitch: m,
                    bearing: _
                };
            }
            easeTo(e1, i) {
                this._stop(!1, e1.easeId), (!1 === (e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t1.ease
                }, e1)).animate || !e1.essential && t1.exported.prefersReducedMotion) && (e1.duration = 0);
                const s = this._getTransformForUpdate(), a = this.getZoom(), o = this.getBearing(), r = this.getPitch(), n = this.getPadding(), l = "zoom" in e1 ? +e1.zoom : a, c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, o) : o, h = "pitch" in e1 ? +e1.pitch : r, u = "padding" in e1 ? e1.padding : s.padding, d = t1.Point.convert(e1.offset);
                let _ = s.centerPoint.add(d);
                const m = s.pointLocation(_), p = t1.LngLat.convert(e1.center || m);
                this._normalizeCenter(p);
                const f = s.project(m), g = s.project(p).sub(f), v = s.zoomScale(l - a);
                let x, y;
                e1.around && (x = t1.LngLat.convert(e1.around), y = s.locationPoint(x));
                const b = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || l !== a, this._rotating = this._rotating || o !== c, this._pitching = this._pitching || h !== r, this._padding = !s.isPaddingEqual(u), this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, b), this.terrain && this._prepareElevation(p), this._ease((m)=>{
                    if (this._zooming && (s.zoom = t1.interpolate.number(a, l, m)), this._rotating && (s.bearing = t1.interpolate.number(o, c, m)), this._pitching && (s.pitch = t1.interpolate.number(r, h, m)), this._padding && (s.interpolatePadding(n, u, m), _ = s.centerPoint.add(d)), this.terrain && !e1.freezeElevation && this._updateElevation(m), x) s.setLocationAtPoint(x, y);
                    else {
                        const t1 = s.zoomScale(s.zoom - a), e1 = l > a ? Math.min(2, v) : Math.max(.5, v), i = Math.pow(e1, 1 - m), o = s.unproject(f.add(g.mult(m * i)).mult(t1));
                        s.setLocationAtPoint(s.renderWorldCopies ? o.wrap() : o, _);
                    }
                    this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, (t1)=>{
                    this.terrain && this._finalizeElevation(), this._afterEase(i, t1);
                }, e1), this;
            }
            _prepareEase(e1, i, s = {}) {
                this._moving = !0, i || s.moving || this.fire(new t1.Event("movestart", e1)), this._zooming && !s.zooming && this.fire(new t1.Event("zoomstart", e1)), this._rotating && !s.rotating && this.fire(new t1.Event("rotatestart", e1)), this._pitching && !s.pitching && this.fire(new t1.Event("pitchstart", e1));
            }
            _prepareElevation(t1) {
                this._elevationCenter = t1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.transform.getElevation(t1, this.terrain), this.transform.freezeElevation = !0;
            }
            _updateElevation(e1) {
                const i = this.transform.getElevation(this._elevationCenter, this.terrain);
                if (e1 < 1 && i !== this._elevationTarget) {
                    const t1 = this._elevationTarget - this._elevationStart;
                    this._elevationStart += e1 * (t1 - (i - (t1 * e1 + this._elevationStart)) / (1 - e1)), this._elevationTarget = i;
                }
                this.transform.elevation = t1.interpolate.number(this._elevationStart, this._elevationTarget, e1);
            }
            _finalizeElevation() {
                this.transform.freezeElevation = !1, this.transform.recalculateZoom(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _applyUpdatedTransform(t1) {
                if (!this.transformCameraUpdate) return;
                const e1 = t1.clone(), { center: i, zoom: s, pitch: a, bearing: o, elevation: r } = this.transformCameraUpdate(e1);
                i && (e1.center = i), void 0 !== s && (e1.zoom = s), void 0 !== a && (e1.pitch = a), void 0 !== o && (e1.bearing = o), void 0 !== r && (e1.elevation = r), this.transform.apply(e1);
            }
            _fireMoveEvents(e1) {
                this.fire(new t1.Event("move", e1)), this._zooming && this.fire(new t1.Event("zoom", e1)), this._rotating && this.fire(new t1.Event("rotate", e1)), this._pitching && this.fire(new t1.Event("pitch", e1));
            }
            _afterEase(e1, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const s = this._zooming, a = this._rotating, o = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, s && this.fire(new t1.Event("zoomend", e1)), a && this.fire(new t1.Event("rotateend", e1)), o && this.fire(new t1.Event("pitchend", e1)), this.fire(new t1.Event("moveend", e1));
            }
            flyTo(e1, i) {
                if (!e1.essential && t1.exported.prefersReducedMotion) {
                    const s = t1.pick(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(s, i);
                }
                this.stop(), e1 = t1.extend({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t1.ease
                }, e1);
                const s = this._getTransformForUpdate(), a = this.getZoom(), o = this.getBearing(), r = this.getPitch(), n = this.getPadding(), l = "zoom" in e1 ? t1.clamp(+e1.zoom, s.minZoom, s.maxZoom) : a, c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, o) : o, h = "pitch" in e1 ? +e1.pitch : r, u = "padding" in e1 ? e1.padding : s.padding, d = s.zoomScale(l - a), _ = t1.Point.convert(e1.offset);
                let m = s.centerPoint.add(_);
                const p = s.pointLocation(m), f = t1.LngLat.convert(e1.center || p);
                this._normalizeCenter(f);
                const g = s.project(p), v = s.project(f).sub(g);
                let x = e1.curve;
                const y = Math.max(s.width, s.height), b = y / d, w = v.mag();
                if ("minZoom" in e1) {
                    const i = t1.clamp(Math.min(e1.minZoom, a, l), s.minZoom, s.maxZoom), o = y / s.zoomScale(i - a);
                    x = Math.sqrt(o / w * 2);
                }
                const T = x * x;
                function E(t1) {
                    const e1 = (b * b - y * y + (t1 ? -1 : 1) * T * T * w * w) / (2 * (t1 ? b : y) * T * w);
                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                }
                function I(t1) {
                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                }
                function S(t1) {
                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                }
                const C = E(0);
                let P = function(t1) {
                    return S(C) / S(C + x * t1);
                }, D = function(t1) {
                    var e1;
                    return y * ((S(C) * (I(e1 = C + x * t1) / S(e1)) - I(C)) / T) / w;
                }, z = (E(1) - C) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(z)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(e1, i);
                    const t1 = b < y ? -1 : 1;
                    z = Math.abs(Math.log(b / y)) / x, D = function() {
                        return 0;
                    }, P = function(e1) {
                        return Math.exp(t1 * x * e1);
                    };
                }
                return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * z / ("screenSpeed" in e1 ? +e1.screenSpeed / x : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = o !== c, this._pitching = h !== r, this._padding = !s.isPaddingEqual(u), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f), this._ease((d)=>{
                    const p = d * z, x = 1 / P(p);
                    s.zoom = 1 === d ? l : a + s.scaleZoom(x), this._rotating && (s.bearing = t1.interpolate.number(o, c, d)), this._pitching && (s.pitch = t1.interpolate.number(r, h, d)), this._padding && (s.interpolatePadding(n, u, d), m = s.centerPoint.add(_)), this.terrain && !e1.freezeElevation && this._updateElevation(d);
                    const y = 1 === d ? f : s.unproject(g.add(v.mult(D(p))).mult(x));
                    s.setLocationAtPoint(s.renderWorldCopies ? y.wrap() : y, m), this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && this._finalizeElevation(), this._afterEase(i);
                }, e1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(t1, e1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const t1 = this._onEaseEnd;
                    delete this._onEaseEnd, t1.call(this, e1);
                }
                if (!t1) {
                    const t1 = this.handlers;
                    t1 && t1.stop(!1);
                }
                return this;
            }
            _ease(e1, i, s) {
                !1 === s.animate || 0 === s.duration ? (e1(1), i()) : (this._easeStart = t1.exported.now(), this._easeOptions = s, this._onEaseFrame = e1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const e1 = Math.min((t1.exported.now() - this._easeStart) / this._easeOptions.duration, 1);
                this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(e1, i) {
                e1 = t1.wrap(e1, -180, 180);
                const s = Math.abs(e1 - i);
                return Math.abs(e1 - 360 - i) < s && (e1 -= 360), Math.abs(e1 + 360 - i) < s && (e1 += 360), e1;
            }
            _normalizeCenter(t1) {
                const e1 = this.transform;
                if (!e1.renderWorldCopies || e1.lngRange) return;
                const i = t1.lng - e1.center.lng;
                t1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            queryTerrainElevation(e1) {
                return this.terrain ? this.transform.getElevation(t1.LngLat.convert(e1), this.terrain) - this.transform.elevation : null;
            }
        }
        class la {
            constructor(e1 = {}){
                this.options = e1, t1.bindAll([
                    "_toggleAttribution",
                    "_updateData",
                    "_updateCompact",
                    "_updateCompactMinimize"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(t1) {
                return this._map = t1, this._compact = this.options && this.options.compact, this._container = i.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = i.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = i.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(t1, e1) {
                const i = this._map._getUIString(`AttributionControl.${e1}`);
                t1.title = i, t1.setAttribute("aria-label", i);
            }
            _toggleAttribution() {
                this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
            }
            _updateData(t1) {
                !t1 || "metadata" !== t1.sourceDataType && "visibility" !== t1.sourceDataType && "style" !== t1.dataType && "terrain" !== t1.type || this._updateAttributions();
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let t1 = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map((t1)=>"string" != typeof t1 ? "" : t1)) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const t1 = this._map.style.stylesheet;
                    this.styleOwner = t1.owner, this.styleId = t1.id;
                }
                const e1 = this._map.style.sourceCaches;
                for(const i in e1){
                    const s = e1[i];
                    if (s.used || s.usedForTerrain) {
                        const e1 = s.getSource();
                        e1.attribution && t1.indexOf(e1.attribution) < 0 && t1.push(e1.attribution);
                    }
                }
                t1 = t1.filter((t1)=>String(t1).trim()), t1.sort((t1, e1)=>t1.length - e1.length), t1 = t1.filter((e1, i)=>{
                    for(let s = i + 1; s < t1.length; s++)if (t1[s].indexOf(e1) >= 0) return !1;
                    return !0;
                });
                const i = t1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, t1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
            }
            _updateCompactMinimize() {
                this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
            }
        }
        class ca {
            constructor(e1 = {}){
                this.options = e1, t1.bindAll([
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t1) {
                this._map = t1, this._compact = this.options && this.options.compact, this._container = i.create("div", "maplibregl-ctrl");
                const e1 = i.create("a", "maplibregl-ctrl-logo");
                return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://maplibre.org/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
            _updateCompact() {
                const t1 = this._container.children;
                if (t1.length) {
                    const e1 = t1[0];
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && e1.classList.add("maplibregl-compact") : e1.classList.remove("maplibregl-compact");
                }
            }
        }
        class ha {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(t1) {
                const e1 = ++this._id;
                return this._queue.push({
                    callback: t1,
                    id: e1,
                    cancelled: !1
                }), e1;
            }
            remove(t1) {
                const e1 = this._currentlyRunning, i = e1 ? this._queue.concat(e1) : this._queue;
                for (const e1 of i)if (e1.id === t1) return void (e1.cancelled = !0);
            }
            run(t1 = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const e1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of e1)if (!i.cancelled && (i.callback(t1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        const ua = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "TerrainControl.enableTerrain": "Enable terrain",
            "TerrainControl.disableTerrain": "Disable terrain"
        };
        var da = t1.createLayout([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class _a extends t1.Evented {
            constructor(t1){
                super(), this.sourceCache = t1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, t1.usedForTerrain = !0, t1.tileSize = this.tileSize * 2 ** this.deltaZoom;
            }
            destruct() {
                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
            }
            update(e1, i) {
                this.sourceCache.update(e1, i), this._renderableTilesKeys = [];
                const s = {};
                for (const a of e1.coveringTiles({
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i
                }))s[a.key] = !0, this._renderableTilesKeys.push(a.key), this._tiles[a.key] || (a.posMatrix = new Float64Array(16), t1.ortho(a.posMatrix, 0, t1.EXTENT, 0, t1.EXTENT, 0, 1), this._tiles[a.key] = new W(a, this.tileSize));
                for(const t1 in this._tiles)s[t1] || delete this._tiles[t1];
            }
            freeRtt(t1) {
                for(const e1 in this._tiles){
                    const i = this._tiles[e1];
                    (!t1 || i.tileID.equals(t1) || i.tileID.isChildOf(t1) || t1.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((t1)=>this.getTileByID(t1));
            }
            getTileByID(t1) {
                return this._tiles[t1];
            }
            getTerrainCoords(e1) {
                const i = {};
                for (const s of this._renderableTilesKeys){
                    const a = this._tiles[s].tileID;
                    if (a.canonical.equals(e1.canonical)) {
                        const a = e1.clone();
                        a.posMatrix = new Float64Array(16), t1.ortho(a.posMatrix, 0, t1.EXTENT, 0, t1.EXTENT, 0, 1), i[s] = a;
                    } else if (a.canonical.isChildOf(e1.canonical)) {
                        const o = e1.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = a.canonical.z - e1.canonical.z, n = a.canonical.x - (a.canonical.x >> r << r), l = a.canonical.y - (a.canonical.y >> r << r), c = t1.EXTENT >> r;
                        t1.ortho(o.posMatrix, 0, c, 0, c, 0, 1), t1.translate(o.posMatrix, o.posMatrix, [
                            -n * c,
                            -l * c,
                            0
                        ]), i[s] = o;
                    } else if (e1.canonical.isChildOf(a.canonical)) {
                        const o = e1.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = e1.canonical.z - a.canonical.z, n = e1.canonical.x - (e1.canonical.x >> r << r), l = e1.canonical.y - (e1.canonical.y >> r << r), c = t1.EXTENT >> r;
                        t1.ortho(o.posMatrix, 0, t1.EXTENT, 0, t1.EXTENT, 0, 1), t1.translate(o.posMatrix, o.posMatrix, [
                            n * c,
                            l * c,
                            0
                        ]), t1.scale(o.posMatrix, o.posMatrix, [
                            1 / 2 ** r,
                            1 / 2 ** r,
                            0
                        ]), i[s] = o;
                    }
                }
                return i;
            }
            getSourceTile(t1, e1) {
                const i = this.sourceCache._source;
                let s = t1.overscaledZ - this.deltaZoom;
                if (s > i.maxzoom && (s = i.maxzoom), s < i.minzoom) return null;
                this._sourceTileCache[t1.key] || (this._sourceTileCache[t1.key] = t1.scaledTo(s).key);
                let a = this.sourceCache.getTileByID(this._sourceTileCache[t1.key]);
                if ((!a || !a.dem) && e1) for(; s >= i.minzoom && (!a || !a.dem);)a = this.sourceCache.getTileByID(t1.scaledTo(s--).key);
                return a;
            }
            tilesAfterTime(t1 = Date.now()) {
                return Object.values(this._tiles).filter((e1)=>e1.timeAdded >= t1);
            }
        }
        class ma {
            constructor(t1, e1, i){
                this.painter = t1, this.sourceCache = new _a(e1), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            getDEMElevation(e1, i, s, a = t1.EXTENT) {
                if (!(i >= 0 && i < a && s >= 0 && s < a)) return 0;
                let o = 0;
                const r = this.getTerrainData(e1);
                if (r.tile && r.tile.dem) {
                    const e1 = function(t1, e1, i) {
                        var s = e1[0], a = e1[1];
                        return t1[0] = i[0] * s + i[4] * a + i[12], t1[1] = i[1] * s + i[5] * a + i[13], t1;
                    }([], [
                        i / a * t1.EXTENT,
                        s / a * t1.EXTENT
                    ], r.u_terrain_matrix), n = [
                        e1[0] * r.tile.dem.dim,
                        e1[1] * r.tile.dem.dim
                    ], l = [
                        Math.floor(n[0]),
                        Math.floor(n[1])
                    ], c = r.tile.dem.get(l[0], l[1]), h = r.tile.dem.get(l[0], l[1] + 1), u = r.tile.dem.get(l[0] + 1, l[1]), d = r.tile.dem.get(l[0] + 1, l[1] + 1);
                    o = t1.interpolate.number(t1.interpolate.number(c, h, n[0] - l[0]), t1.interpolate.number(u, d, n[0] - l[0]), n[1] - l[1]);
                }
                return o;
            }
            getElevation(e1, i, s, a = t1.EXTENT) {
                return this.getDEMElevation(e1, i, s, a) * this.exaggeration;
            }
            getTerrainData(e1) {
                if (!this._emptyDemTexture) {
                    const e1 = this.painter.context, i = new t1.RGBAImage({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new y(e1, i, e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new y(e1, new t1.RGBAImage({
                        width: 1,
                        height: 1
                    }), e1.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t1.identity([]);
                }
                const i = this.sourceCache.getSourceTile(e1, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const t1 = this.painter.context;
                    i.demTexture = this.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new y(t1, i.dem.getPixels(), t1.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(t1.gl.NEAREST, t1.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const s = i && i + i.tileID.key + e1.key;
                if (s && !this._demMatrixCache[s]) {
                    const s = this.sourceCache.sourceCache._source.maxzoom;
                    let a = e1.canonical.z - i.tileID.canonical.z;
                    e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= s ? a = e1.canonical.z - s : t1.warnOnce("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const o = e1.canonical.x - (e1.canonical.x >> a << a), r = e1.canonical.y - (e1.canonical.y >> a << a), n = t1.fromScaling(new Float64Array(16), [
                        1 / (t1.EXTENT << a),
                        1 / (t1.EXTENT << a),
                        0
                    ]);
                    t1.translate(n, n, [
                        o * t1.EXTENT,
                        r * t1.EXTENT,
                        0
                    ]), this._demMatrixCache[e1.key] = {
                        matrix: n,
                        coord: e1
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: s ? this._demMatrixCache[e1.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getFramebuffer(t1) {
                const e1 = this.painter, i = e1.width / devicePixelRatio, s = e1.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === i && this._fbo.height === s || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new y(e1.context, {
                    width: i,
                    height: s,
                    data: null
                }, e1.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new y(e1.context, {
                    width: i,
                    height: s,
                    data: null
                }, e1.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e1.context.createFramebuffer(i, s, !0, !1), this._fbo.depthAttachment.set(e1.context.createRenderbuffer(e1.context.gl.DEPTH_COMPONENT16, i, s))), this._fbo.colorAttachment.set("coords" === t1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e1 = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let t1 = 0, e1 = 0; t1 < this._coordsTextureSize; t1++)for(let s = 0; s < this._coordsTextureSize; s++, e1 += 4)i[e1 + 0] = 255 & s, i[e1 + 1] = 255 & t1, i[e1 + 2] = s >> 8 << 4 | t1 >> 8, i[e1 + 3] = 0;
                const s = new t1.RGBAImage({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), a = new y(e1, s, e1.gl.RGBA, {
                    premultiply: !1
                });
                return a.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._coordsTexture = a, a;
            }
            pointCoordinate(e1) {
                const i = new Uint8Array(4), s = this.painter.context, a = s.gl;
                s.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), a.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, i), s.bindFramebuffer.set(null);
                const o = i[0] + (i[2] >> 4 << 8), r = i[1] + ((15 & i[2]) << 8), n = this.coordsIndex[255 - i[3]], l = n && this.sourceCache.getTileByID(n);
                if (!l) return null;
                const c = this._coordsTextureSize, h = (1 << l.tileID.canonical.z) * c;
                return new t1.MercatorCoordinate((l.tileID.canonical.x * c + o) / h, (l.tileID.canonical.y * c + r) / h, this.getElevation(l.tileID, o, r, c));
            }
            getTerrainMesh() {
                if (this._mesh) return this._mesh;
                const e1 = this.painter.context, i = new t1.Pos3dArray, s = new t1.TriangleIndexArray, a = this.meshSize, o = t1.EXTENT / a, r = a * a;
                for(let t1 = 0; t1 <= a; t1++)for(let e1 = 0; e1 <= a; e1++)i.emplaceBack(e1 * o, t1 * o, 0);
                for(let t1 = 0; t1 < r; t1 += a + 1)for(let e1 = 0; e1 < a; e1++)s.emplaceBack(e1 + t1, a + e1 + t1 + 1, a + e1 + t1 + 2), s.emplaceBack(e1 + t1, a + e1 + t1 + 2, e1 + t1 + 1);
                const n = i.length, l = n + 2 * (a + 1);
                for (const e1 of [
                    0,
                    1
                ])for(let s = 0; s <= a; s++)for (const a of [
                    0,
                    1
                ])i.emplaceBack(s * o, e1 * t1.EXTENT, a);
                for(let t1 = 0; t1 < 2 * a; t1 += 2)s.emplaceBack(l + t1, l + t1 + 1, l + t1 + 3), s.emplaceBack(l + t1, l + t1 + 3, l + t1 + 2), s.emplaceBack(n + t1, n + t1 + 3, n + t1 + 1), s.emplaceBack(n + t1, n + t1 + 2, n + t1 + 3);
                const c = i.length, h = c + 2 * (a + 1);
                for (const e1 of [
                    0,
                    1
                ])for(let s = 0; s <= a; s++)for (const a of [
                    0,
                    1
                ])i.emplaceBack(e1 * t1.EXTENT, s * o, a);
                for(let t1 = 0; t1 < 2 * a; t1 += 2)s.emplaceBack(c + t1, c + t1 + 1, c + t1 + 3), s.emplaceBack(c + t1, c + t1 + 3, c + t1 + 2), s.emplaceBack(h + t1, h + t1 + 3, h + t1 + 1), s.emplaceBack(h + t1, h + t1 + 2, h + t1 + 3);
                return this._mesh = {
                    indexBuffer: e1.createIndexBuffer(s),
                    vertexBuffer: e1.createVertexBuffer(i, da.members),
                    segments: t1.SegmentVector.simpleSegment(0, 0, i.length, s.length)
                }, this._mesh;
            }
            getMeshFrameDelta(e1) {
                return 2 * Math.PI * t1.earthRadius / Math.pow(2, e1) / 5;
            }
            getMinMaxElevation(t1) {
                const e1 = this.getTerrainData(t1).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return e1 && e1.dem && (i.minElevation = e1.dem.min * this.exaggeration, i.maxElevation = e1.dem.max * this.exaggeration), i;
            }
        }
        class pa {
            constructor(t1, e1, i){
                this._context = t1, this._size = e1, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const t1 of this._objects)t1.texture.destroy(), t1.fbo.destroy();
            }
            _createObject(t1) {
                const e1 = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), i = new y(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return i.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), e1.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), e1.colorAttachment.set(i.texture), {
                    id: t1,
                    fbo: e1,
                    texture: i,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(t1) {
                return this._objects[t1];
            }
            useObject(t1) {
                t1.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((e1)=>t1.id !== e1), this._recentlyUsed.push(t1.id);
            }
            stampObject(t1) {
                t1.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const t1 of this._recentlyUsed)if (!this._objects[t1].inUse) return this._objects[t1];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const t1 = this._createObject(this._objects.length);
                return this._objects.push(t1), t1;
            }
            freeObject(t1) {
                t1.inUse = !1;
            }
            freeAllObjects() {
                for (const t1 of this._objects)this.freeObject(t1);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((t1)=>!t1.inUse);
            }
        }
        const fa = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0
        };
        class ga {
            constructor(t1, e1){
                this.painter = t1, this.terrain = e1, this.pool = new pa(t1.context, 30, e1.sourceCache.tileSize * e1.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(t1) {
                return this.pool.getObjectForId(t1.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(t1, e1) {
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = t1._order.filter((i)=>!t1._layers[i].isHidden(e1)), this._coordsDescendingInv = {};
                for(const e1 in t1.sourceCaches){
                    this._coordsDescendingInv[e1] = {};
                    const i = t1.sourceCaches[e1].getVisibleCoordinates();
                    for (const t1 of i){
                        const i = this.terrain.sourceCache.getTerrainCoords(t1);
                        for(const t1 in i)this._coordsDescendingInv[e1][t1] || (this._coordsDescendingInv[e1][t1] = []), this._coordsDescendingInv[e1][t1].push(i[t1]);
                    }
                }
                this._coordsDescendingInvStr = {};
                for (const e1 of t1._order){
                    const i = t1._layers[e1], s = i.source;
                    if (fa[i.type] && !this._coordsDescendingInvStr[s]) {
                        this._coordsDescendingInvStr[s] = {};
                        for(const t1 in this._coordsDescendingInv[s])this._coordsDescendingInvStr[s][t1] = this._coordsDescendingInv[s][t1].map((t1)=>t1.key).sort().join();
                    }
                }
                for (const t1 of this._renderableTiles)for(const e1 in this._coordsDescendingInvStr){
                    const i = this._coordsDescendingInvStr[e1][t1.tileID.key];
                    i && i !== t1.rttCoords[e1] && (t1.rtt = []);
                }
            }
            renderLayer(e1) {
                if (e1.isHidden(this.painter.transform.zoom)) return !1;
                const i = e1.type, s = this.painter, a = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
                if (fa[i] && (this._prevType && fa[this._prevType] || this._stacks.push([]), this._prevType = i, this._stacks[this._stacks.length - 1].push(e1.id), !a)) return !0;
                if (fa[this._prevType] || fa[i] && a) {
                    this._prevType = i;
                    const e1 = this._stacks.length - 1, a = this._stacks[e1] || [];
                    for (const i of this._renderableTiles){
                        if (this.pool.isFull() && (is(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(i), i.rtt[e1]) {
                            const t1 = this.pool.getObjectForId(i.rtt[e1].id);
                            if (t1.stamp === i.rtt[e1].stamp) {
                                this.pool.useObject(t1);
                                continue;
                            }
                        }
                        const o = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(o), this.pool.stampObject(o), i.rtt[e1] = {
                            id: o.id,
                            stamp: o.stamp
                        }, s.context.bindFramebuffer.set(o.fbo.framebuffer), s.context.clear({
                            color: t1.Color.transparent,
                            stencil: 0
                        }), s.currentStencilSource = void 0;
                        for(let t1 = 0; t1 < a.length; t1++){
                            const e1 = s.style._layers[a[t1]], r = e1.source ? this._coordsDescendingInv[e1.source][i.tileID.key] : [
                                i.tileID
                            ];
                            s.context.viewport.set([
                                0,
                                0,
                                o.fbo.width,
                                o.fbo.height
                            ]), s._renderTileClippingMasks(e1, r), s.renderLayer(s, s.style.sourceCaches[e1.source], e1, r), e1.source && (i.rttCoords[e1.source] = this._coordsDescendingInvStr[e1.source][i.tileID.key]);
                        }
                    }
                    return is(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), fa[i];
                }
                return !1;
            }
        }
        const va = e1, xa = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: void 0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            maplibreLogo: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t1.config.MAX_TILE_CACHE_ZOOM_LEVELS,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            transformCameraUpdate: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            validateStyle: !0
        }, ya = (t1)=>{
            t1.touchstart = t1.dragStart, t1.touchmoveWindow = t1.dragMove, t1.touchend = t1.dragEnd;
        }, ba = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class wa {
            constructor(e1, s, a = !1){
                this._clickTolerance = 10;
                const o = e1.dragRotate._mouseRotate.getClickTolerance(), r = e1.dragRotate._mousePitch.getClickTolerance();
                this.element = s, this.mouseRotate = Rs({
                    clickTolerance: o,
                    enable: !0
                }), this.touchRotate = (({ enable: t1, clickTolerance: e1, bearingDegreesPerPixelMoved: i = .8 })=>{
                    const s = new As;
                    return new Ds({
                        clickTolerance: e1,
                        move: (t1, e1)=>({
                                bearingDelta: (e1.x - t1.x) * i
                            }),
                        moveStateManager: s,
                        enable: t1,
                        assignEvents: ya
                    });
                })({
                    clickTolerance: o,
                    enable: !0
                }), this.map = e1, a && (this.mousePitch = ks({
                    clickTolerance: r,
                    enable: !0
                }), this.touchPitch = (({ enable: t1, clickTolerance: e1, pitchDegreesPerPixelMoved: i = -0.5 })=>{
                    const s = new As;
                    return new Ds({
                        clickTolerance: e1,
                        move: (t1, e1)=>({
                                pitchDelta: (e1.y - t1.y) * i
                            }),
                        moveStateManager: s,
                        enable: t1,
                        assignEvents: ya
                    });
                })({
                    clickTolerance: r,
                    enable: !0
                })), t1.bindAll([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener(s, "mousedown", this.mousedown), i.addEventListener(s, "touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener(s, "touchcancel", this.reset);
            }
            startMouse(t1, e1) {
                this.mouseRotate.dragStart(t1, e1), this.mousePitch && this.mousePitch.dragStart(t1, e1), i.disableDrag();
            }
            startTouch(t1, e1) {
                this.touchRotate.dragStart(t1, e1), this.touchPitch && this.touchPitch.dragStart(t1, e1), i.disableDrag();
            }
            moveMouse(t1, e1) {
                const i = this.map, { bearingDelta: s } = this.mouseRotate.dragMove(t1, e1) || {};
                if (s && i.setBearing(i.getBearing() + s), this.mousePitch) {
                    const { pitchDelta: s } = this.mousePitch.dragMove(t1, e1) || {};
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            moveTouch(t1, e1) {
                const i = this.map, { bearingDelta: s } = this.touchRotate.dragMove(t1, e1) || {};
                if (s && i.setBearing(i.getBearing() + s), this.touchPitch) {
                    const { pitchDelta: s } = this.touchPitch.dragMove(t1, e1) || {};
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            off() {
                const t1 = this.element;
                i.removeEventListener(t1, "mousedown", this.mousedown), i.removeEventListener(t1, "touchstart", this.touchstart, {
                    passive: !1
                }), i.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.removeEventListener(window, "touchend", this.touchend), i.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                i.enableDrag(), i.removeEventListener(window, "mousemove", this.mousemove), i.removeEventListener(window, "mouseup", this.mouseup), i.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.removeEventListener(window, "touchend", this.touchend);
            }
            mousedown(e1) {
                this.startMouse(t1.extend({}, e1, {
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }), i.mousePos(this.element, e1)), i.addEventListener(window, "mousemove", this.mousemove), i.addEventListener(window, "mouseup", this.mouseup);
            }
            mousemove(t1) {
                this.moveMouse(t1, i.mousePos(this.element, t1));
            }
            mouseup(t1) {
                this.mouseRotate.dragEnd(t1), this.mousePitch && this.mousePitch.dragEnd(t1), this.offTemp();
            }
            touchstart(t1) {
                1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = i.touchPos(this.element, t1.targetTouches)[0], this.startTouch(t1, this._startPos), i.addEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.addEventListener(window, "touchend", this.touchend));
            }
            touchmove(t1) {
                1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = i.touchPos(this.element, t1.targetTouches)[0], this.moveTouch(t1, this._lastPos));
            }
            touchend(t1) {
                0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        let Ta;
        function Ea(e1, i, s) {
            if (e1 = new t1.LngLat(e1.lng, e1.lat), i) {
                const a = new t1.LngLat(e1.lng - 360, e1.lat), o = new t1.LngLat(e1.lng + 360, e1.lat), r = s.locationPoint(e1).distSqr(i);
                s.locationPoint(a).distSqr(i) < r ? e1 = a : s.locationPoint(o).distSqr(i) < r && (e1 = o);
            }
            for(; Math.abs(e1.lng - s.center.lng) > 180;){
                const t1 = s.locationPoint(e1);
                if (t1.x >= 0 && t1.y >= 0 && t1.x <= s.width && t1.y <= s.height) break;
                e1.lng > s.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1;
        }
        const Ia = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function Sa(t1, e1, i) {
            const s = t1.classList;
            for(const t1 in Ia)s.remove(`maplibregl-${i}-anchor-${t1}`);
            s.add(`maplibregl-${i}-anchor-${e1}`);
        }
        class Ca extends t1.Evented {
            constructor(e1, s){
                if (super(), (e1 instanceof HTMLElement || s) && (e1 = t1.extend({
                    element: e1
                }, s)), t1.bindAll([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress"
                ], this), this._anchor = e1 && e1.anchor || "center", this._color = e1 && e1.color || "#3FB1CE", this._scale = e1 && e1.scale || 1, this._draggable = e1 && e1.draggable || !1, this._clickTolerance = e1 && e1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = e1 && e1.rotation || 0, this._rotationAlignment = e1 && e1.rotationAlignment || "auto", this._pitchAlignment = e1 && e1.pitchAlignment && "auto" !== e1.pitchAlignment ? e1.pitchAlignment : this._rotationAlignment, e1 && e1.element) this._element = e1.element, this._offset = t1.Point.convert(e1 && e1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = i.create("div"), this._element.setAttribute("aria-label", "Map marker");
                    const s = i.createNS("http://www.w3.org/2000/svg", "svg"), a = 41, o = 27;
                    s.setAttributeNS(null, "display", "block"), s.setAttributeNS(null, "height", `${a}px`), s.setAttributeNS(null, "width", `${o}px`), s.setAttributeNS(null, "viewBox", `0 0 ${o} ${a}`);
                    const r = i.createNS("http://www.w3.org/2000/svg", "g");
                    r.setAttributeNS(null, "stroke", "none"), r.setAttributeNS(null, "stroke-width", "1"), r.setAttributeNS(null, "fill", "none"), r.setAttributeNS(null, "fill-rule", "evenodd");
                    const n = i.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "fill-rule", "nonzero");
                    const l = i.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    const c = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const t1 of c){
                        const e1 = i.createNS("http://www.w3.org/2000/svg", "ellipse");
                        e1.setAttributeNS(null, "opacity", "0.04"), e1.setAttributeNS(null, "cx", "10.5"), e1.setAttributeNS(null, "cy", "5.80029008"), e1.setAttributeNS(null, "rx", t1.rx), e1.setAttributeNS(null, "ry", t1.ry), l.appendChild(e1);
                    }
                    const h = i.createNS("http://www.w3.org/2000/svg", "g");
                    h.setAttributeNS(null, "fill", this._color);
                    const u = i.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), h.appendChild(u);
                    const d = i.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const _ = i.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    const m = i.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), m.setAttributeNS(null, "fill", "#FFFFFF");
                    const p = i.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = i.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = i.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), p.appendChild(f), p.appendChild(g), n.appendChild(l), n.appendChild(h), n.appendChild(d), n.appendChild(m), n.appendChild(p), s.appendChild(n), s.setAttributeNS(null, "height", a * this._scale + "px"), s.setAttributeNS(null, "width", o * this._scale + "px"), this._element.appendChild(s), this._offset = t1.Point.convert(e1 && e1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (t1)=>{
                    t1.preventDefault();
                }), this._element.addEventListener("mousedown", (t1)=>{
                    t1.preventDefault();
                }), Sa(this._element, this._anchor, "marker"), this._popup = null;
            }
            addTo(t1) {
                return this.remove(), this._map = t1, t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), i.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(t1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                    if (!("offset" in t1.options)) {
                        const e1 = 38.1, i = 13.5, s = Math.sqrt(Math.pow(i, 2) / 2);
                        t1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -e1
                            ],
                            "bottom-left": [
                                s,
                                -1 * (e1 - i + s)
                            ],
                            "bottom-right": [
                                -s,
                                -1 * (e1 - i + s)
                            ],
                            left: [
                                i,
                                -1 * (e1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (e1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = t1, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            _onKeyPress(t1) {
                const e1 = t1.code, i = t1.charCode || t1.keyCode;
                "Space" !== e1 && "Enter" !== e1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(t1) {
                const e1 = t1.originalEvent.target, i = this._element;
                this._popup && (e1 === i || i.contains(e1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const t1 = this._popup;
                return t1 ? (t1.isOpen() ? t1.remove() : t1.addTo(this._map), this) : this;
            }
            _update(t1) {
                if (!this._map) return;
                this._map.transform.renderWorldCopies && (this._lngLat = Ea(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                let e1 = "";
                "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e1 = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (e1 = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                let s = "";
                "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? s = "rotateX(0deg)" : "map" === this._pitchAlignment && (s = `rotateX(${this._map.getPitch()}deg)`), t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), i.setTransform(this._element, `${Ia[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${s} ${e1}`), this._map.terrain && !this._opacityTimeout && (this._opacityTimeout = setTimeout(()=>{
                    const t1 = this._map.unproject(this._pos), e1 = 40075016.686 * Math.abs(Math.cos(this._lngLat.lat * Math.PI / 180)) / Math.pow(2, this._map.transform.tileZoom + 8);
                    this._element.style.opacity = t1.distanceTo(this._lngLat) > 20 * e1 ? "0.2" : "1.0", this._opacityTimeout = null;
                }, 100));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e1) {
                return this._offset = t1.Point.convert(e1), this._update(), this;
            }
            _onMove(e1) {
                if (!this._isDragging) {
                    const t1 = this._clickTolerance || this._map._clickTolerance;
                    this._isDragging = e1.point.dist(this._pointerdownPos) >= t1;
                }
                this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t1.Event("dragstart"))), this.fire(new t1.Event("drag")));
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t1.Event("dragend")), this._state = "inactive";
            }
            _addDragHandler(t1) {
                this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._pointerdownPos = t1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
            }
            setDraggable(t1) {
                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(t1) {
                return this._rotation = t1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(t1) {
                return this._rotationAlignment = t1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(t1) {
                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
        }
        const Pa = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let Da = 0, za = !1;
        const Ma = {
            maxWidth: 100,
            unit: "metric"
        };
        function Aa(t1, e1, i) {
            const s = i && i.maxWidth || 100, a = t1._container.clientHeight / 2, o = t1.unproject([
                0,
                a
            ]), r = t1.unproject([
                s,
                a
            ]), n = o.distanceTo(r);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * n;
                i > 5280 ? La(e1, s, i / 5280, t1._getUIString("ScaleControl.Miles")) : La(e1, s, i, t1._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? La(e1, s, n / 1852, t1._getUIString("ScaleControl.NauticalMiles")) : n >= 1e3 ? La(e1, s, n / 1e3, t1._getUIString("ScaleControl.Kilometers")) : La(e1, s, n, t1._getUIString("ScaleControl.Meters"));
        }
        function La(t1, e1, i, s) {
            const a = function(t1) {
                const e1 = Math.pow(10, `${Math.floor(t1)}`.length - 1);
                let i = t1 / e1;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(t1) {
                    const e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                    return Math.round(t1 * e1) / e1;
                }(i), e1 * i;
            }(i);
            t1.style.width = e1 * (a / i) + "px", t1.innerHTML = `${a}&nbsp;${s}`;
        }
        const Ra = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, ka = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Ba(e1) {
            if (e1) {
                if ("number" == typeof e1) {
                    const i = Math.round(Math.sqrt(.5 * Math.pow(e1, 2)));
                    return {
                        center: new t1.Point(0, 0),
                        top: new t1.Point(0, e1),
                        "top-left": new t1.Point(i, i),
                        "top-right": new t1.Point(-i, i),
                        bottom: new t1.Point(0, -e1),
                        "bottom-left": new t1.Point(i, -i),
                        "bottom-right": new t1.Point(-i, -i),
                        left: new t1.Point(e1, 0),
                        right: new t1.Point(-e1, 0)
                    };
                }
                if (e1 instanceof t1.Point || Array.isArray(e1)) {
                    const i = t1.Point.convert(e1);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t1.Point.convert(e1.center || [
                        0,
                        0
                    ]),
                    top: t1.Point.convert(e1.top || [
                        0,
                        0
                    ]),
                    "top-left": t1.Point.convert(e1["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t1.Point.convert(e1["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t1.Point.convert(e1.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t1.Point.convert(e1["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t1.Point.convert(e1["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t1.Point.convert(e1.left || [
                        0,
                        0
                    ]),
                    right: t1.Point.convert(e1.right || [
                        0,
                        0
                    ])
                };
            }
            return Ba(new t1.Point(0, 0));
        }
        const Fa = e1, Ua = {
            setRTLTextPlugin: t1.setRTLTextPlugin,
            getRTLTextPluginStatus: t1.getRTLTextPluginStatus,
            Map: class extends na {
                constructor(e1){
                    var i;
                    if (t1.PerformanceUtils.mark(t1.PerformanceMarkers.create), null != (e1 = t1.extend({}, xa, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != e1.maxPitch && e1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (super(new ls(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies), {
                        bearingSnap: e1.bearingSnap
                    }), this._interactive = e1.interactive, this._cooperativeGestures = e1.cooperativeGestures, this._metaKey = 0 === navigator.platform.indexOf("Mac") ? "metaKey" : "ctrlKey", this._maxTileCacheSize = e1.maxTileCacheSize, this._maxTileCacheZoomLevels = e1.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._crossSourceCollisions = e1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e1.collectResourceTiming, this._renderTaskQueue = new ha, this._controls = [], this._mapId = t1.uniqueId(), this._locale = t1.extend({}, ua, e1.locale), this._clickTolerance = e1.clickTolerance, this._pixelRatio = null !== (i = e1.pixelRatio) && void 0 !== i ? i : devicePixelRatio, this.transformCameraUpdate = e1.transformCameraUpdate, this._imageQueueHandle = u.addThrottleControl(()=>this.isMoving()), this._requestManager = new d(e1.transformRequest), "string" == typeof e1.container) {
                        if (this._container = document.getElementById(e1.container), !this._container) throw new Error(`Container '${e1.container}' not found.`);
                    } else {
                        if (!(e1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = e1.container;
                    }
                    if (e1.maxBounds && this.setMaxBounds(e1.maxBounds), t1.bindAll([
                        "_onWindowOnline",
                        "_onMapScroll",
                        "_cooperativeGesturesOnWheel",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                        this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                    }), this.once("idle", ()=>{
                        this._idleTriggered = !0;
                    }), "undefined" != typeof window) {
                        addEventListener("online", this._onWindowOnline, !1);
                        let t1 = !1;
                        this._resizeObserver = new ResizeObserver((e1)=>{
                            t1 ? this._trackResize && this.resize(e1)._update() : t1 = !0;
                        }), this._resizeObserver.observe(this._container);
                    }
                    this.handlers = new oa(this, e1), this._cooperativeGestures && this._setupCooperativeGestures(), this._hash = e1.hash && new cs("string" == typeof e1.hash && e1.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                        center: e1.center,
                        zoom: e1.zoom,
                        bearing: e1.bearing,
                        pitch: e1.pitch
                    }), e1.bounds && (this.resize(), this.fitBounds(e1.bounds, t1.extend({}, e1.fitBoundsOptions, {
                        duration: 0
                    })))), this.resize(), this._localIdeographFontFamily = e1.localIdeographFontFamily, this._validateStyle = e1.validateStyle, e1.style && this.setStyle(e1.style, {
                        localIdeographFontFamily: e1.localIdeographFontFamily
                    }), e1.attributionControl && this.addControl(new la({
                        customAttribution: e1.customAttribution
                    })), e1.maplibreLogo && this.addControl(new ca, e1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                    }), this.on("data", (e1)=>{
                        this._update("style" === e1.dataType), this.fire(new t1.Event(`${e1.dataType}data`, e1));
                    }), this.on("dataloading", (e1)=>{
                        this.fire(new t1.Event(`${e1.dataType}dataloading`, e1));
                    }), this.on("dataabort", (e1)=>{
                        this.fire(new t1.Event("sourcedataabort", e1));
                    });
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(e1, i) {
                    if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const s = e1.onAdd(this);
                    this._controls.push(e1);
                    const a = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? a.insertBefore(s, a.firstChild) : a.appendChild(s), this;
                }
                removeControl(e1) {
                    if (!e1 || !e1.onRemove) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(e1);
                    return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
                }
                hasControl(t1) {
                    return this._controls.indexOf(t1) > -1;
                }
                calculateCameraOptionsFromTo(t1, e1, i, s) {
                    return null == s && this.terrain && (s = this.transform.getElevation(i, this.terrain)), super.calculateCameraOptionsFromTo(t1, e1, i, s);
                }
                resize(e1) {
                    var i;
                    const s = this._containerDimensions(), a = s[0], o = s[1];
                    this._resizeCanvas(a, o, this.getPixelRatio()), this.transform.resize(a, o), null === (i = this._requestedCameraState) || void 0 === i || i.resize(a, o), this.painter.resize(a, o, this.getPixelRatio());
                    const r = !this._moving;
                    return r && (this.stop(), this.fire(new t1.Event("movestart", e1)).fire(new t1.Event("move", e1))), this.fire(new t1.Event("resize", e1)), r && this.fire(new t1.Event("moveend", e1)), this;
                }
                getPixelRatio() {
                    return this._pixelRatio;
                }
                setPixelRatio(t1) {
                    const [e1, i] = this._containerDimensions();
                    this._pixelRatio = t1, this._resizeCanvas(e1, i, t1), this.painter.resize(e1, i, t1);
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds();
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(R.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = null == t1 ? 60 : t1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                    throw new Error("maxPitch must be greater than the current minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(t1) {
                    return this.transform.renderWorldCopies = t1, this._update();
                }
                getCooperativeGestures() {
                    return this._cooperativeGestures;
                }
                setCooperativeGestures(t1) {
                    return this._cooperativeGestures = t1, this._cooperativeGestures ? this._setupCooperativeGestures() : this._destroyCooperativeGestures(), this;
                }
                project(e1) {
                    return this.transform.locationPoint(t1.LngLat.convert(e1), this.style && this.terrain);
                }
                unproject(e1) {
                    return this.transform.pointLocation(t1.Point.convert(e1), this.terrain);
                }
                isMoving() {
                    var t1;
                    return this._moving || (null === (t1 = this.handlers) || void 0 === t1 ? void 0 : t1.isMoving());
                }
                isZooming() {
                    var t1;
                    return this._zooming || (null === (t1 = this.handlers) || void 0 === t1 ? void 0 : t1.isZooming());
                }
                isRotating() {
                    var t1;
                    return this._rotating || (null === (t1 = this.handlers) || void 0 === t1 ? void 0 : t1.isRotating());
                }
                _createDelegatedListener(t1, e1, i) {
                    if ("mouseenter" === t1 || "mouseover" === t1) {
                        let s = !1;
                        const a = (a)=>{
                            const o = this.getLayer(e1) ? this.queryRenderedFeatures(a.point, {
                                layers: [
                                    e1
                                ]
                            }) : [];
                            o.length ? s || (s = !0, i.call(this, new vs(t1, this, a.originalEvent, {
                                features: o
                            }))) : s = !1;
                        };
                        return {
                            layer: e1,
                            listener: i,
                            delegates: {
                                mousemove: a,
                                mouseout: ()=>{
                                    s = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === t1 || "mouseout" === t1) {
                        let s = !1;
                        const a = (a)=>{
                            (this.getLayer(e1) ? this.queryRenderedFeatures(a.point, {
                                layers: [
                                    e1
                                ]
                            }) : []).length ? s = !0 : s && (s = !1, i.call(this, new vs(t1, this, a.originalEvent)));
                        }, o = (e1)=>{
                            s && (s = !1, i.call(this, new vs(t1, this, e1.originalEvent)));
                        };
                        return {
                            layer: e1,
                            listener: i,
                            delegates: {
                                mousemove: a,
                                mouseout: o
                            }
                        };
                    }
                    {
                        const s = (t1)=>{
                            const s = this.getLayer(e1) ? this.queryRenderedFeatures(t1.point, {
                                layers: [
                                    e1
                                ]
                            }) : [];
                            s.length && (t1.features = s, i.call(this, t1), delete t1.features);
                        };
                        return {
                            layer: e1,
                            listener: i,
                            delegates: {
                                [t1]: s
                            }
                        };
                    }
                }
                on(t1, e1, i) {
                    if (void 0 === i) return super.on(t1, e1);
                    const s = this._createDelegatedListener(t1, e1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(s);
                    for(const t1 in s.delegates)this.on(t1, s.delegates[t1]);
                    return this;
                }
                once(t1, e1, i) {
                    if (void 0 === i) return super.once(t1, e1);
                    const s = this._createDelegatedListener(t1, e1, i);
                    for(const t1 in s.delegates)this.once(t1, s.delegates[t1]);
                    return this;
                }
                off(t1, e1, i) {
                    return void 0 === i ? super.off(t1, e1) : (this._delegatedListeners && this._delegatedListeners[t1] && ((s)=>{
                        const a = this._delegatedListeners[t1];
                        for(let t1 = 0; t1 < a.length; t1++){
                            const s = a[t1];
                            if (s.layer === e1 && s.listener === i) {
                                for(const t1 in s.delegates)this.off(t1, s.delegates[t1]);
                                return a.splice(t1, 1), this;
                            }
                        }
                    })(), this);
                }
                queryRenderedFeatures(e1, i) {
                    if (!this.style) return [];
                    let s;
                    const a = e1 instanceof t1.Point || Array.isArray(e1), o = a ? e1 : [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ];
                    if (i = i || (a ? {} : e1) || {}, o instanceof t1.Point || "number" == typeof o[0]) s = [
                        t1.Point.convert(o)
                    ];
                    else {
                        const e1 = t1.Point.convert(o[0]), i = t1.Point.convert(o[1]);
                        s = [
                            e1,
                            new t1.Point(i.x, e1.y),
                            i,
                            new t1.Point(e1.x, i.y),
                            e1
                        ];
                    }
                    return this.style.queryRenderedFeatures(s, i, this.transform);
                }
                querySourceFeatures(t1, e1) {
                    return this.style.querySourceFeatures(t1, e1);
                }
                setStyle(e1, i) {
                    return !1 !== (i = t1.extend({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        validate: this._validateStyle
                    }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
                }
                setTransformRequest(t1) {
                    return this._requestManager.setTransformRequest(t1), this;
                }
                _getUIString(t1) {
                    const e1 = this._locale[t1];
                    if (null == e1) throw new Error(`Missing UI string '${t1}'`);
                    return e1;
                }
                _updateStyle(t1, e1) {
                    if (e1.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(t1, e1));
                    const i = this.style && e1.transformStyle ? this.style.serialize() : void 0;
                    return this.style && (this.style.setEventedParent(null), this.style._remove(!t1)), t1 ? (this.style = new ae(this, e1 || {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), "string" == typeof t1 ? this.style.loadURL(t1, e1, i) : this.style.loadJSON(t1, e1, i), this) : (delete this.style, this);
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new ae(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                _diffStyle(e1, i) {
                    if ("string" == typeof e1) {
                        const s = this._requestManager.transformRequest(e1, h.Style);
                        t1.getJSON(s, (e1, s)=>{
                            e1 ? this.fire(new t1.ErrorEvent(e1)) : s && this._updateDiff(s, i);
                        });
                    } else "object" == typeof e1 && this._updateDiff(e1, i);
                }
                _updateDiff(e1, i) {
                    try {
                        this.style.setState(e1, i) && this._update(!0);
                    } catch (s) {
                        t1.warnOnce(`Unable to perform style diff: ${s.message || s.error || s}.  Rebuilding the style from scratch.`), this._updateStyle(e1, i);
                    }
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : t1.warnOnce("There is no style added to the map.");
                }
                addSource(t1, e1) {
                    return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
                }
                isSourceLoaded(e1) {
                    const i = this.style && this.style.sourceCaches[e1];
                    if (void 0 !== i) return i.loaded();
                    this.fire(new t1.ErrorEvent(new Error(`There is no source with ID '${e1}'`)));
                }
                setTerrain(e1) {
                    if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e1) {
                        const i = this.style.sourceCaches[e1.source];
                        if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
                        for(const i in this.style._layers){
                            const s = this.style._layers[i];
                            "hillshade" === s.type && s.source === e1.source && t1.warnOnce("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                        }
                        this.terrain = new ma(this.painter, i, e1), this.painter.renderToTexture = new ga(this.painter, this.terrain), this.transform.updateElevation(this.terrain), this._terrainDataCallback = (t1)=>{
                            "style" === t1.dataType ? this.terrain.sourceCache.freeRtt() : "source" === t1.dataType && t1.tile && (t1.sourceId === e1.source && this.transform.updateElevation(this.terrain), this.terrain.sourceCache.freeRtt(t1.tile.tileID));
                        }, this.style.on("data", this._terrainDataCallback);
                    } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.updateElevation(this.terrain);
                    return this.fire(new t1.Event("terrain", {
                        terrain: e1
                    })), this;
                }
                getTerrain() {
                    return this.terrain && this.terrain.options;
                }
                areTilesLoaded() {
                    const t1 = this.style && this.style.sourceCaches;
                    for(const e1 in t1){
                        const i = t1[e1]._tiles;
                        for(const t1 in i){
                            const e1 = i[t1];
                            if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                        }
                    }
                    return !0;
                }
                addSourceType(t1, e1, i) {
                    return this._lazyInitEmptyStyle(), this.style.addSourceType(t1, e1, i);
                }
                removeSource(t1) {
                    return this.style.removeSource(t1), this._update(!0);
                }
                getSource(t1) {
                    return this.style.getSource(t1);
                }
                addImage(e1, i, { pixelRatio: s = 1, sdf: a = !1, stretchX: o, stretchY: r, content: n } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof HTMLImageElement || t1.isImageBitmap(i)) {
                        const { width: l, height: c, data: h } = t1.exported.getImageData(i);
                        this.style.addImage(e1, {
                            data: new t1.RGBAImage({
                                width: l,
                                height: c
                            }, h),
                            pixelRatio: s,
                            stretchX: o,
                            stretchY: r,
                            content: n,
                            sdf: a,
                            version: 0
                        });
                    } else {
                        if (void 0 === i.width || void 0 === i.height) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                        {
                            const { width: l, height: c, data: h } = i, u = i;
                            this.style.addImage(e1, {
                                data: new t1.RGBAImage({
                                    width: l,
                                    height: c
                                }, new Uint8Array(h)),
                                pixelRatio: s,
                                stretchX: o,
                                stretchY: r,
                                content: n,
                                sdf: a,
                                version: 0,
                                userImage: u
                            }), u.onAdd && u.onAdd(this, e1);
                        }
                    }
                }
                updateImage(e1, i) {
                    const s = this.style.getImage(e1);
                    if (!s) return this.fire(new t1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const a = i instanceof HTMLImageElement || t1.isImageBitmap(i) ? t1.exported.getImageData(i) : i, { width: o, height: r, data: n } = a;
                    if (void 0 === o || void 0 === r) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (o !== s.data.width || r !== s.data.height) return this.fire(new t1.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                    const l = !(i instanceof HTMLImageElement || t1.isImageBitmap(i));
                    s.data.replace(n, l), this.style.updateImage(e1, s);
                }
                getImage(t1) {
                    return this.style.getImage(t1);
                }
                hasImage(e1) {
                    return e1 ? !!this.style.getImage(e1) : (this.fire(new t1.ErrorEvent(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(t1);
                }
                loadImage(t1, e1) {
                    u.getImage(this._requestManager.transformRequest(t1, h.Image), e1);
                }
                listImages() {
                    return this.style.listImages();
                }
                addLayer(t1, e1) {
                    return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
                }
                moveLayer(t1, e1) {
                    return this.style.moveLayer(t1, e1), this._update(!0);
                }
                removeLayer(t1) {
                    return this.style.removeLayer(t1), this._update(!0);
                }
                getLayer(t1) {
                    return this.style.getLayer(t1);
                }
                setLayerZoomRange(t1, e1, i) {
                    return this.style.setLayerZoomRange(t1, e1, i), this._update(!0);
                }
                setFilter(t1, e1, i = {}) {
                    return this.style.setFilter(t1, e1, i), this._update(!0);
                }
                getFilter(t1) {
                    return this.style.getFilter(t1);
                }
                setPaintProperty(t1, e1, i, s = {}) {
                    return this.style.setPaintProperty(t1, e1, i, s), this._update(!0);
                }
                getPaintProperty(t1, e1) {
                    return this.style.getPaintProperty(t1, e1);
                }
                setLayoutProperty(t1, e1, i, s = {}) {
                    return this.style.setLayoutProperty(t1, e1, i, s), this._update(!0);
                }
                getLayoutProperty(t1, e1) {
                    return this.style.getLayoutProperty(t1, e1);
                }
                setGlyphs(t1, e1 = {}) {
                    return this._lazyInitEmptyStyle(), this.style.setGlyphs(t1, e1), this._update(!0);
                }
                getGlyphs() {
                    return this.style.getGlyphsUrl();
                }
                addSprite(t1, e1, i = {}) {
                    return this._lazyInitEmptyStyle(), this.style.addSprite(t1, e1, i, (t1)=>{
                        t1 || this._update(!0);
                    }), this;
                }
                removeSprite(t1) {
                    return this._lazyInitEmptyStyle(), this.style.removeSprite(t1), this._update(!0);
                }
                getSprite() {
                    return this.style.getSprite();
                }
                setSprite(t1, e1 = {}) {
                    return this._lazyInitEmptyStyle(), this.style.setSprite(t1, e1, (t1)=>{
                        t1 || this._update(!0);
                    }), this;
                }
                setLight(t1, e1 = {}) {
                    return this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
                }
                getLight() {
                    return this.style.getLight();
                }
                setFeatureState(t1, e1) {
                    return this.style.setFeatureState(t1, e1), this._update();
                }
                removeFeatureState(t1, e1) {
                    return this.style.removeFeatureState(t1, e1), this._update();
                }
                getFeatureState(t1) {
                    return this.style.getFeatureState(t1);
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                _containerDimensions() {
                    let t1 = 0, e1 = 0;
                    return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                        t1,
                        e1
                    ];
                }
                _setupContainer() {
                    const t1 = this._container;
                    t1.classList.add("maplibregl-map");
                    const e1 = this._canvasContainer = i.create("div", "maplibregl-canvas-container", t1);
                    this._interactive && e1.classList.add("maplibregl-interactive"), this._canvas = i.create("canvas", "maplibregl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                    const s = this._containerDimensions();
                    this._resizeCanvas(s[0], s[1], this.getPixelRatio());
                    const a = this._controlContainer = i.create("div", "maplibregl-control-container", t1), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ].forEach((t1)=>{
                        o[t1] = i.create("div", `maplibregl-ctrl-${t1} `, a);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _cooperativeGesturesOnWheel(t1) {
                    this._onCooperativeGesture(t1, t1[this._metaKey], 1);
                }
                _setupCooperativeGestures() {
                    this._cooperativeGesturesScreen = i.create("div", "maplibregl-cooperative-gesture-screen", this._container);
                    let t1 = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.windowsHelpText ? this._cooperativeGestures.windowsHelpText : "Use Ctrl + scroll to zoom the map";
                    0 === navigator.platform.indexOf("Mac") && (t1 = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.macHelpText ? this._cooperativeGestures.macHelpText : "Use \u2318 + scroll to zoom the map"), this._cooperativeGesturesScreen.innerHTML = `\n            <div class="maplibregl-desktop-message">${t1}</div>\n            <div class="maplibregl-mobile-message">${"boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.mobileHelpText ? this._cooperativeGestures.mobileHelpText : "Use two fingers to move the map"}</div>\n        `, this._canvasContainer.addEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.add("maplibregl-cooperative-gestures");
                }
                _destroyCooperativeGestures() {
                    i.remove(this._cooperativeGesturesScreen), this._canvasContainer.removeEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.remove("maplibregl-cooperative-gestures");
                }
                _resizeCanvas(t1, e1, i) {
                    this._canvas.width = i * t1, this._canvas.height = i * e1, this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${e1}px`;
                }
                _setupPainter() {
                    const t1 = {
                        alpha: !0,
                        stencil: !0,
                        depth: !0,
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    };
                    let e1 = null;
                    this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                        e1 = {
                            requestedAttributes: t1
                        }, i && (e1.statusMessage = i.statusMessage, e1.type = i.type);
                    }, {
                        once: !0
                    });
                    const i = this._canvas.getContext("webgl2", t1) || this._canvas.getContext("webgl", t1);
                    if (!i) {
                        const t1 = "Failed to initialize WebGL";
                        throw e1 ? (e1.message = t1, new Error(JSON.stringify(e1))) : new Error(t1);
                    }
                    this.painter = new as(i, this.transform), s.testSupport(i);
                }
                _contextLost(e1) {
                    e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t1.Event("webglcontextlost", {
                        originalEvent: e1
                    }));
                }
                _contextRestored(e1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new t1.Event("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }
                _onMapScroll(t1) {
                    if (t1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                _onCooperativeGesture(t1, e1, i) {
                    return !e1 && i < 2 && (this._cooperativeGesturesScreen.classList.add("maplibregl-show"), setTimeout(()=>{
                        this._cooperativeGesturesScreen.classList.remove("maplibregl-show");
                    }, 100)), !1;
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                _update(t1) {
                    return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(t1) {
                    return this._update(), this._renderTaskQueue.add(t1);
                }
                _cancelRenderFrame(t1) {
                    this._renderTaskQueue.remove(t1);
                }
                _render(e1) {
                    const i = this._idleTriggered ? this._fadeDuration : 0;
                    if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
                    let s = !1;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const e1 = this.transform.zoom, a = t1.exported.now();
                        this.style.zoomHistory.update(e1, a);
                        const o = new t1.EvaluationParameters(e1, {
                            now: a,
                            fadeDuration: i,
                            zoomHistory: this.style.zoomHistory,
                            transition: this.style.getTransition()
                        }), r = o.crossFadingFactor();
                        1 === r && r === this._crossFadingFactor || (s = !0, this._crossFadingFactor = r), this.style.update(o);
                    }
                    this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain && this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.updateElevation(this.terrain), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, i, this._crossSourceCollisions), this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showOverdrawInspector: this._showOverdrawInspector,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: i,
                        showPadding: this.showPadding
                    }), this.fire(new t1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, t1.PerformanceUtils.mark(t1.PerformanceMarkers.load), this.fire(new t1.Event("load"))), this.style && (this.style.hasTransitions() || s) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                    const a = this._sourcesDirty || this._styleDirty || this._placementDirty;
                    return a || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t1.Event("idle")), !this._loaded || this._fullyLoaded || a || (this._fullyLoaded = !0, t1.PerformanceUtils.mark(t1.PerformanceMarkers.fullLoad)), this;
                }
                redraw() {
                    return this.style && (this._frame && (this._frame.cancel(), this._frame = null), this._render(0)), this;
                }
                remove() {
                    var e1;
                    this._hash && this._hash.remove();
                    for (const t1 of this._controls)t1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), u.removeThrottleControl(this._imageQueueHandle), null === (e1 = this._resizeObserver) || void 0 === e1 || e1.disconnect();
                    const s = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    s && s.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), i.remove(this._canvasContainer), i.remove(this._controlContainer), this._cooperativeGestures && this._destroyCooperativeGestures(), this._container.classList.remove("maplibregl-map"), t1.PerformanceUtils.clearMetrics(), this._removed = !0, this.fire(new t1.Event("remove"));
                }
                triggerRepaint() {
                    this.style && !this._frame && (this._frame = t1.exported.frame((e1)=>{
                        t1.PerformanceUtils.frame(e1), this._frame = null, this._render(e1);
                    }));
                }
                _onWindowOnline() {
                    this._update();
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(t1) {
                    this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(t1) {
                    this._showPadding !== t1 && (this._showPadding = t1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(t1) {
                    this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(t1) {
                    this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(t1) {
                    this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(t1) {
                    this._vertices = t1, this._update();
                }
                get version() {
                    return va;
                }
                getCameraTargetElevation() {
                    return this.transform.elevation;
                }
            },
            NavigationControl: class {
                constructor(e1){
                    this.options = t1.extend({}, ba, e1), this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (t1)=>t1.preventDefault()), this.options.showZoom && (t1.bindAll([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (t1)=>this._map.zoomIn({}, {
                            originalEvent: t1
                        })), i.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (t1)=>this._map.zoomOut({}, {
                            originalEvent: t1
                        })), i.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (t1.bindAll([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("maplibregl-ctrl-compass", (t1)=>{
                        this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                            originalEvent: t1
                        }) : this._map.resetNorth({}, {
                            originalEvent: t1
                        });
                    }), this._compassIcon = i.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const t1 = this._map.getZoom(), e1 = t1 === this._map.getMaxZoom(), i = t1 === this._map.getMinZoom();
                    this._zoomInButton.disabled = e1, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e1.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }
                _rotateCompassArrow() {
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                    this._compassIcon.style.transform = t1;
                }
                onAdd(t1) {
                    return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new wa(this._map, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    i.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                }
                _createButton(t1, e1) {
                    const s = i.create("button", t1, this._container);
                    return s.type = "button", s.addEventListener("click", e1), s;
                }
                _setButtonTitle(t1, e1) {
                    const i = this._map._getUIString(`NavigationControl.${e1}`);
                    t1.title = i, t1.setAttribute("aria-label", i);
                }
            },
            GeolocateControl: class extends t1.Evented {
                constructor(e1){
                    super(), this.options = t1.extend({}, Pa, e1), t1.bindAll([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker"
                    ], this);
                }
                onAdd(t1) {
                    return this._map = t1, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), function(t1, e1 = !1) {
                        void 0 === Ta || e1 ? void 0 !== window.navigator.permissions ? window.navigator.permissions.query({
                            name: "geolocation"
                        }).then((e1)=>{
                            Ta = "denied" !== e1.state, t1(Ta);
                        }).catch(()=>{
                            Ta = !!window.navigator.geolocation, t1(Ta);
                        }) : (Ta = !!window.navigator.geolocation, t1(Ta)) : t1(Ta);
                    }(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), i.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Da = 0, za = !1;
                }
                _isOutOfMapMaxBounds(t1) {
                    const e1 = this._map.getMaxBounds(), i = t1.coords;
                    return e1 && (i.longitude < e1.getWest() || i.longitude > e1.getEast() || i.latitude < e1.getSouth() || i.latitude > e1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                            break;
                        case "ACTIVE_ERROR":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                }
                _onSuccess(e1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t1.Event("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t1.Event("geolocate", e1)), this._finish();
                    }
                }
                _updateCamera(e1) {
                    const i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude), s = e1.coords.accuracy, a = this._map.getBearing(), o = t1.extend({
                        bearing: a
                    }, this.options.fitBoundsOptions), r = R.fromLngLat(i, s);
                    this._map.fitBounds(r, o, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(e1) {
                    if (e1) {
                        const i = new t1.LngLat(e1.coords.longitude, e1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.getBounds(), e1 = t1.getSouthEast(), i = t1.getNorthEast(), s = e1.distanceTo(i), a = Math.ceil(this._accuracy / (s / this._map._container.clientHeight) * 2);
                    this._circleElement.style.width = `${a}px`, this._circleElement.style.height = `${a}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _onError(e1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e1.code && za) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t1.Event("error", e1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(e1) {
                    if (this._map) {
                        if (this._container.addEventListener("contextmenu", (t1)=>t1.preventDefault()), this._geolocateButton = i.create("button", "maplibregl-ctrl-geolocate", this._container), i.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === e1) {
                            t1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                        } else {
                            const t1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = i.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Ca(this._dotElement), this._circleElement = i.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Ca({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e1)=>{
                            e1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e1.originalEvent && "resize" === e1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t1.Event("trackuserlocationend")));
                        });
                    }
                }
                trigger() {
                    if (!this._setup) return t1.warnOnce("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new t1.Event("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                Da--, za = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t1.Event("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t1.Event("trackuserlocationstart"));
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "OFF":
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let t1;
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Da++, Da > 1 ? (t1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, za = !0) : (t1 = this.options.positionOptions, za = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t1);
                        }
                    } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                    return !0;
                }
                _clearWatch() {
                    window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: la,
            LogoControl: ca,
            ScaleControl: class {
                constructor(e1){
                    this.options = t1.extend({}, Ma, e1), t1.bindAll([
                        "_onMove",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _onMove() {
                    Aa(this._map, this._container, this.options);
                }
                onAdd(t1) {
                    return this._map = t1, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                }
                onRemove() {
                    i.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                }
                setUnit(t1) {
                    this.options.unit = t1, Aa(this._map, this._container, this.options);
                }
            },
            FullscreenControl: class extends t1.Evented {
                constructor(e1 = {}){
                    super(), this._onFullscreenChange = ()=>{
                        (window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement) === this._container !== this._fullscreen && this._handleFullscreenChange();
                    }, this._onClickFullscreen = ()=>{
                        this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                    }, this._fullscreen = !1, e1 && e1.container && (e1.container instanceof HTMLElement ? this._container = e1.container : t1.warnOnce("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
                }
                onRemove() {
                    i.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
                }
                _setupUI() {
                    const t1 = this._fullscreenButton = i.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                    i.create("span", "maplibregl-ctrl-icon", t1).setAttribute("aria-hidden", "true"), t1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
                }
                _updateTitle() {
                    const t1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _handleFullscreenChange() {
                    this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t1.Event("fullscreenstart")), this._map._cooperativeGestures && (this._prevCooperativeGestures = this._map._cooperativeGestures, this._map.setCooperativeGestures())) : (this.fire(new t1.Event("fullscreenend")), this._prevCooperativeGestures && (this._map.setCooperativeGestures(this._prevCooperativeGestures), delete this._prevCooperativeGestures));
                }
                _exitFullscreen() {
                    window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
                }
                _requestFullscreen() {
                    this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
                }
                _togglePseudoFullScreen() {
                    this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
                }
            },
            TerrainControl: class {
                constructor(e1){
                    this.options = e1, t1.bindAll([
                        "_toggleTerrain",
                        "_updateTerrainIcon"
                    ], this);
                }
                onAdd(t1) {
                    return this._map = t1, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = i.create("button", "maplibregl-ctrl-terrain", this._container), i.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                }
                onRemove() {
                    i.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                }
                _toggleTerrain() {
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }
                _updateTerrainIcon() {
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.disableTerrain")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.enableTerrain"));
                }
            },
            Popup: class extends t1.Evented {
                constructor(e1){
                    super(), this.options = t1.extend(Object.create(Ra), e1), t1.bindAll([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseMove",
                        "_onMouseUp",
                        "_onDrag"
                    ], this);
                }
                addTo(e1) {
                    return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t1.Event("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    return this._content && i.remove(this._content), this._container && (i.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t1.Event("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(e1) {
                    return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
                }
                trackPointer() {
                    return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(t1) {
                    return this.setDOMContent(document.createTextNode(t1));
                }
                setHTML(t1) {
                    const e1 = document.createDocumentFragment(), i = document.createElement("body");
                    let s;
                    for(i.innerHTML = t1; s = i.firstChild, s;)e1.appendChild(s);
                    return this.setDOMContent(e1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(t1) {
                    return this.options.maxWidth = t1, this._update(), this;
                }
                setDOMContent(t1) {
                    if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                    else this._content = i.create("div", "maplibregl-popup-content", this._container);
                    return this._content.appendChild(t1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                }
                addClassName(t1) {
                    this._container && this._container.classList.add(t1);
                }
                removeClassName(t1) {
                    this._container && this._container.classList.remove(t1);
                }
                setOffset(t1) {
                    return this.options.offset = t1, this._update(), this;
                }
                toggleClassName(t1) {
                    if (this._container) return this._container.classList.toggle(t1);
                }
                _createCloseButton() {
                    this.options.closeButton && (this._closeButton = i.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                }
                _onMouseUp(t1) {
                    this._update(t1.point);
                }
                _onMouseMove(t1) {
                    this._update(t1.point);
                }
                _onDrag(t1) {
                    this._update(t1.point);
                }
                _update(t1) {
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (this._container || (this._container = i.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = i.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach((t1)=>this._container.classList.add(t1)), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Ea(this._lngLat, this._pos, this._map.transform)), this._trackPointer && !t1) return;
                    const e1 = this._pos = this._trackPointer && t1 ? t1 : this._map.project(this._lngLat);
                    let s = this.options.anchor;
                    const a = Ba(this.options.offset);
                    if (!s) {
                        const t1 = this._container.offsetWidth, i = this._container.offsetHeight;
                        let o;
                        o = e1.y + a.bottom.y < i ? [
                            "top"
                        ] : e1.y > this._map.transform.height - i ? [
                            "bottom"
                        ] : [], e1.x < t1 / 2 ? o.push("left") : e1.x > this._map.transform.width - t1 / 2 && o.push("right"), s = 0 === o.length ? "bottom" : o.join("-");
                    }
                    const o = e1.add(a[s]).round();
                    i.setTransform(this._container, `${Ia[s]} translate(${o.x}px,${o.y}px)`), Sa(this._container, s, "popup");
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const t1 = this._container.querySelector(ka);
                    t1 && t1.focus();
                }
                _onClose() {
                    this.remove();
                }
            },
            Marker: Ca,
            Style: ae,
            LngLat: t1.LngLat,
            LngLatBounds: R,
            Point: t1.Point,
            MercatorCoordinate: t1.MercatorCoordinate,
            Evented: t1.Evented,
            AJAXError: t1.AJAXError,
            config: t1.config,
            CanvasSource: V,
            GeoJSONSource: O,
            ImageSource: G,
            RasterDEMTileSource: U,
            RasterTileSource: F,
            VectorTileSource: B,
            VideoSource: Z,
            prewarm: function() {
                at().acquire(tt);
            },
            clearPrewarmedResources: function() {
                const t1 = st;
                t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(tt), st = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get version () {
                return Fa;
            },
            get workerCount () {
                return et.workerCount;
            },
            set workerCount (t){
                et.workerCount = t;
            },
            get maxParallelImageRequests () {
                return t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (e){
                t1.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },
            get workerUrl () {
                return t1.config.WORKER_URL;
            },
            set workerUrl (e){
                t1.config.WORKER_URL = e;
            },
            addProtocol (e1, i) {
                t1.config.REGISTERED_PROTOCOLS[e1] = i;
            },
            removeProtocol (e1) {
                delete t1.config.REGISTERED_PROTOCOLS[e1];
            }
        };
        return ra.extend(Ua, {
            isSafari: t1.isSafari,
            getPerformanceMetrics: t1.PerformanceUtils.getPerformanceMetrics
        }), Ua;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});



function $3e645b0309771ac1$export$58d8663b36235b13({ point: point, map: map, zoom: zoom }) {
    function mercatorXfromLng(lng) {
        return (180 + lng) / 360;
    }
    function lngFromMercatorX(x) {
        return x * 360 - 180;
    }
    function mercatorYfromLat(lat) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
    }
    function latFromMercatorY(y) {
        const lat = (Math.atan(Math.exp((180 - y * 360) / (180 / Math.PI))) - Math.PI / 4) * 360 / Math.PI;
        return lat;
    }
    function wrap(n, min, max) {
        const d = max - min;
        const w = ((n - min) % d + d) % d + min;
        return w === min ? max : w;
    }
    const worldSize = map.transform.zoomScale(zoom) * map.transform.tileSize;
    const viewport = $3e645b0309771ac1$export$c02eeb5f98d59b89();
    const viewportCenter = new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))((viewport.left + viewport.right) / 2, (viewport.top + viewport.bottom) / 2);
    // TODO: Account for nudge
    const mapRect = document.querySelector("#map canvas")?.getBoundingClientRect();
    if (typeof mapRect === "undefined") throw new Error("Map canvas not found");
    const mapCenter = new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))((mapRect.left + mapRect.right) / 2, (mapRect.top + mapRect.bottom) / 2);
    const centerDiff = mapCenter.sub(viewportCenter);
    console.log({
        centerDiff: centerDiff
    });
    const pixelsPoint = new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))(mercatorXfromLng(point.lng) * worldSize, mercatorYfromLat(point.lat) * worldSize).add(centerDiff);
    return {
        lng: lngFromMercatorX(pixelsPoint.x / worldSize),
        lat: latFromMercatorY(pixelsPoint.y / worldSize)
    };
}
function $3e645b0309771ac1$export$c02eeb5f98d59b89() {
    // TODO optimization: Implement some kind of cacheing or object reuse, this function is called a lot
    const viewableRect = {};
    let leftPanel = document.querySelector("#left-panel");
    // Row mode is where the left bar column moves to the top of the page as a row
    // As seen on mobile devices
    const rowMode = leftPanel === null ? false : getComputedStyle(leftPanel).display === "block";
    let rightPanel = null;
    let topPanel = null;
    if (rowMode) {
        const searchBar = document.querySelector("#search_bar");
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!searchBar?.classList.contains("hide-mobile")) topPanel = searchBar;
        else topPanel = leftPanel;
        leftPanel = null;
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (topPanel?.classList.contains("offscreen-left")) topPanel = document.querySelector(".site-header-menu-bar");
    } else rightPanel = document.querySelector("#right-small-panel");
    const topRect = topPanel?.getBoundingClientRect();
    const leftRect = leftPanel?.getBoundingClientRect();
    const rightRect = rightPanel?.getBoundingClientRect();
    const bottomElements = [
        document.querySelector("div.footer"),
        document.querySelector(".footer-popup"),
        document.querySelector(".navigation_list")
    ].filter((el)=>{
        return el !== null;
    });
    // Find the bottom element with the highest top
    const topEdges = bottomElements.map((element)=>{
        if (element.classList.contains("hidden")) return Infinity;
        if (element.style.display === "none") return Infinity;
        if (element.style.visibility === "hidden") return Infinity;
        return element.getBoundingClientRect().top;
    });
    viewableRect.bottom = topEdges.reduce((prev, curr)=>curr === 0 ? prev : Math.min(prev, curr), window.innerHeight);
    if (typeof leftRect !== "undefined") {
        let zoom = 1;
        const style = getComputedStyle(leftPanel);
        if ("zoom" in style) zoom = parseFloat(style.zoom);
        viewableRect.left = leftRect.right * zoom;
    } else viewableRect.left = 0;
    if (typeof rightRect !== "undefined") {
        let zoom = 1;
        {
            const style = getComputedStyle(leftPanel);
            if ("zoom" in style) zoom *= parseFloat(style.zoom);
        }
        {
            const style = getComputedStyle(rightPanel);
            if ("zoom" in style) zoom *= parseFloat(style.zoom);
        }
        viewableRect.right = window.innerWidth - rightRect.width * zoom;
    } else viewableRect.right = window.innerWidth;
    if (typeof topRect !== "undefined") {
        let zoom = 1;
        const style = getComputedStyle(topPanel);
        if ("zoom" in style) zoom *= parseFloat(style.zoom);
        viewableRect.top = topRect.bottom * zoom;
    } else viewableRect.top = 0;
    viewableRect.center = {
        x: (viewableRect.left + viewableRect.right) / 2,
        y: (viewableRect.top + viewableRect.bottom) / 2
    };
    return viewableRect;
}
function $3e645b0309771ac1$export$1e044b7877db048c(el, rect) {
    el.style.position = "absolute";
    el.style.left = `${rect.left}px`;
    el.style.top = `${rect.top}px`;
    el.style.width = `${rect.right - rect.left}px`;
    el.style.height = `${rect.bottom - rect.top}px`;
}
function $3e645b0309771ac1$export$84259018ecaf03f3(rect) {
    let el = document.querySelector(".debug_rect");
    if (el === null) {
        el = document.createElement("div");
        document.body.append(el);
    }
    el.classList.add("debug_rect");
    el.style.backgroundColor = "rgba(255, 255, 0, 0.2)";
    el.style.zIndex = "1000000000000000";
    el.style.pointerEvents = "none";
    $3e645b0309771ac1$export$1e044b7877db048c(el, rect);
}
function $3e645b0309771ac1$export$97b11e94efcd56a9(map, bounds) {
    const view = $3e645b0309771ac1$export$c02eeb5f98d59b89();
    const mapRect = map.getCanvas().getBoundingClientRect();
    // Transform the longitude
    // TODO: Make this work with Alaska/wrapped bounds
    /**
     * Width of the screen
     */ const width = view.right - view.left;
    /**
     * Total longitude subtended by bounds
     */ const lngSpan = bounds.getEast() - bounds.getWest();
    /**
     * Degrees of longitude per view pixel
     */ const lngPerViewPixel = lngSpan / width;
    /**
     * Amount of pixels the map is offset to the left (relative to the view rect)
     */ const leftPixelOffset = mapRect.left - view.left;
    /**
     * Amount of longitude the map is offset to the west (relative to the view rect)
     */ const westLngOffset = lngPerViewPixel * leftPixelOffset;
    const w = bounds.getWest() + westLngOffset;
    // Same process for east side
    const rightPixelOffset = mapRect.right - view.right;
    const eastLngOffset = lngPerViewPixel * rightPixelOffset;
    const e = bounds.getEast() + eastLngOffset;
    // Transform the latitude
    const isoN = $3e645b0309771ac1$var$isometricLatitude(bounds.getNorth());
    const isoS = $3e645b0309771ac1$var$isometricLatitude(bounds.getSouth());
    // Same process with latitude, with the extra step of converting to and from isometric latitude
    const height = view.bottom - view.top;
    const latSpan = isoN - isoS;
    const latPerViewPixel = latSpan / height;
    const topPixelOffset = mapRect.top - view.top;
    const northLatOffset = latPerViewPixel * topPixelOffset;
    const n = $3e645b0309771ac1$var$latitudeFromIsometricLat(isoN + northLatOffset);
    const bottomPixelOffset = mapRect.bottom - view.bottom;
    const southLatOffset = latPerViewPixel * bottomPixelOffset;
    const s = $3e645b0309771ac1$var$latitudeFromIsometricLat(isoS - southLatOffset);
    // debugger
    return new (0, $30510d2f060a5cf8$exports.LngLatBounds)([
        w,
        s,
        e,
        n
    ]);
}
/** Convert from latitude to iso~metric latitude
 *
 * Every unit of isometric latitude spans the same "mercator map distance" as one unit of longitude
 * @param lat latitude in degrees
 * @returns isometric latitude in degrees
 */ function $3e645b0309771ac1$var$isometricLatitude(lat) {
    return (0, $d6f1a4944061be51$export$914076c8150813e5) * Math.log(Math.tan(Math.PI / 4 + (0, $d6f1a4944061be51$export$460c4029b1a54a2e) * lat / 2));
}
/**
 * The inverse of isometricLatitude()
 * @param isoLat isometric latutide in degrees
 * @returns latitude in degrees
 */ function $3e645b0309771ac1$var$latitudeFromIsometricLat(isoLat) {
    // isoLat = RAD2DEG * Math.log(Math.tan(Math.PI / 4 + (DEG2RAD * lat) / 2))
    // isoLat * DEG2RAD = Math.log(Math.tan(Math.PI / 4 + (DEG2RAD * lat) / 2))
    // Math.exp(isoLat * DEG2RAD) = Math.tan(Math.PI / 4 + (DEG2RAD * lat) / 2)
    const lat = (0, $d6f1a4944061be51$export$914076c8150813e5) * (Math.PI / 2 - 2 * Math.atan(Math.exp(isoLat * (0, $d6f1a4944061be51$export$460c4029b1a54a2e))));
    if (isoLat >= 0) return lat * -1;
    if (isoLat < 0) return lat;
    return 0;
}


class $468000f96106f3c9$export$ceeabc2fb0f8d70f {
    constructor(element, footerTop){
        this.element = element;
        this.updateBounds(footerTop);
        document.addEventListener("footerchange", (event)=>{
            this.onfooterchange(event);
        });
    }
    updateBounds(footerTop) {
        const initialBottom = parseFloat(this.element.style.bottom === "" ? window.getComputedStyle(this.element).bottom : this.element.style.bottom);
        this.spacing = initialBottom - (window.innerHeight - footerTop);
    }
    onfooterchange(event) {
        const footerTop = window.innerHeight - event.detail;
        this.element.style.bottom = `${this.spacing + footerTop}px`;
    }
    // TODO: Remove if the OSM page bug where the page starts too tall and is resized is fixed
    fixOSMPage() {
        const bottom = window.innerHeight * 0.5 - 245;
        this.element.style.bottom = `${bottom + 500}px`;
        this.updateBounds(bottom);
    }
}
class $468000f96106f3c9$export$f12881f3d9af5d9 {
    /**
     *
     * @param element Div that will take on the dimensions of the footer
     */ constructor(element){
        this.element = element;
        document.addEventListener("footerchange", (event)=>{
            this.onfooterchange(event);
        });
    }
    onfooterchange(event) {
        this.element.style.height = `${window.innerHeight - event.detail}px`;
    }
}
function $468000f96106f3c9$var$debugDrawRect(rect) {
    let el = document.querySelector(".debug_rect");
    if (el === null) {
        el = document.createElement("div");
        document.body.append(el);
    }
    el.classList.add("debug_rect");
    el.style.pointerEvents = "none";
    el.style.backgroundColor = "rgba(255, 255, 0, 0.2)";
    el.style.zIndex = "1000000000000000";
    (0, $3e645b0309771ac1$export$1e044b7877db048c)(el, rect);
}
function $468000f96106f3c9$export$4fefa8b88b0d4af1() {
    const rect = (0, $3e645b0309771ac1$export$c02eeb5f98d59b89)();
    // debugDrawRect(rect)
    const event = new CustomEvent("footerchange", {
        detail: rect.bottom
    });
    document.dispatchEvent(event);
}
function $468000f96106f3c9$export$1f1e22974349d794() {
    function raiseFooterPopup() {
        if (window.innerWidth < 768) {
            $(".footer").hide();
            $(".footer-popup").animate({
                height: "350px"
            }, {
                duration: 400,
                progress: $468000f96106f3c9$export$4fefa8b88b0d4af1,
                complete: $468000f96106f3c9$export$4fefa8b88b0d4af1
            });
        } else {
            $(".footer").hide();
            $(".footer-popup").animate({
                height: "222px"
            }, {
                duration: 400,
                progress: $468000f96106f3c9$export$4fefa8b88b0d4af1,
                complete: $468000f96106f3c9$export$4fefa8b88b0d4af1
            });
        }
    }
    function lowerFooterPopup() {
        $(".footer").show();
        $(".footer-popup").animate({
            height: "0"
        }, {
            duration: 400,
            progress: $468000f96106f3c9$export$4fefa8b88b0d4af1,
            complete: $468000f96106f3c9$export$4fefa8b88b0d4af1
        });
    }
    // Swap the onclick to something that suits my needs
    // This is aggressive
    const popupOpenButton = document.querySelector(".frame-6346517.nonselectable");
    if (popupOpenButton === null) throw new ReferenceError("No popup open button found");
    popupOpenButton.setAttribute("onclick", "");
    popupOpenButton.onclick = raiseFooterPopup;
    const popupCloseButton = document.querySelector(".frame-6346498.pointer");
    if (popupCloseButton === null) throw new ReferenceError("No popup close button found");
    popupCloseButton.setAttribute("onclick", "");
    popupCloseButton.onclick = lowerFooterPopup;
}
function $468000f96106f3c9$export$59448e33b5cd8368() {
    const header = document.querySelector(".site-header-menu-bar");
    // Header does not exit in Mobile App
    if (header) {
        const observer = new ResizeObserver((entries, observer)=>{
            $468000f96106f3c9$export$4fefa8b88b0d4af1();
        });
        observer.observe(header);
    }
}





var $7ArpZ = parcelRequire("7ArpZ");

// Workaround for tween group type weirdness
const $be68dac03006aaff$var$tweenGroup = new (0, $7ArpZ.Group)();
function $be68dac03006aaff$export$b86006a140a6bac4(obj) {
    if ("tweens" in obj) return obj.tweens;
    else throw new Error("Object has no tween group");
}
function $be68dac03006aaff$export$b3d257225ea880da(obj) {
    obj.tweens = new (0, $7ArpZ.Group)();
}
function $be68dac03006aaff$export$d4a625cede2da71b(obj) {
    if ("region" in obj) return obj.region;
    else throw new Error("Object has no region");
}
function $be68dac03006aaff$export$1ae571a23e1cddb5(obj) {
    obj.traverse((obj)=>{
        if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
        // if (obj.tweens) {
        //     new Tween(obj, obj.tweens)
        //         .to({
        //             material: {
        //                 color: obj.userData.baseColor,
        //                 emissive: obj.userData.baseEmissive,
        //             },
        //             userData: {
        //                 inactiveColor: obj.userData.baseColor,
        //                 inactiveEmissive: obj.userData.baseEmissive,
        //             },
        //         }, 500)
        //         .easing(Easing.Quadratic.Out)
        //         .start();
        // } else {
        obj.material.color.copy(obj.userData.baseColor);
        obj.material.emissive.copy(obj.userData.baseEmissive);
        obj.userData.inactiveColor.copy(obj.userData.baseColor);
        obj.userData.inactiveEmissive.copy(obj.userData.baseEmissive);
    // }
    });
}
async function $be68dac03006aaff$export$8d2fff1477b88ccf(source, destination) {
    const tweens = $be68dac03006aaff$export$b86006a140a6bac4(source).getAll();
    if (tweens.length !== 0) {
        // Transfer scales
        const endValue = destination.scale.clone().multiplyScalar(source.userData.clickedScale.x / source.userData.initialScale.x);
        const startValue = destination.scale.clone().multiplyScalar(source.scale.x / source.userData.initialScale.x);
        // Transfer animation
        // const animation = source.userData.animation.duplicateTo(destination);
        // animation.endValue = endValue;
        // animation.startValue = startValue;
        // this.ANIMATIONS.add(animation);
        destination.scale.copy(startValue);
        const oldTween = tweens[0];
        await new Promise((resolve)=>{
            new (0, $7ArpZ.Tween)(destination, $be68dac03006aaff$export$b86006a140a6bac4(destination)).to({
                scale: endValue
            }).copyTimingAndStart(oldTween).onComplete(()=>{
                resolve();
            }).onStop(()=>{
                resolve();
            });
        });
    // newTween._duration = oldTween._duration;
    // newTween._startTime = oldTween._startTime;
    } else destination.scale.multiplyScalar(source.userData.clickedScale.x / source.userData.initialScale.x);
}
function $be68dac03006aaff$export$1f7546cb86a68804(group) {
    return group.userData.materials !== undefined;
}
function $be68dac03006aaff$export$2f8501431017a005(obj) {
    if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return false;
    return !obj.name.includes("_") && obj.parent?.userData.materials !== undefined;
}
function $be68dac03006aaff$export$e473b9a2e4b251c6(mesh) {
    return !$be68dac03006aaff$export$2f8501431017a005(mesh);
}
function $be68dac03006aaff$export$5bca2f41e52f6bfd(mesh) {
    return mesh.name.endsWith("_TopBorder");
}
function $be68dac03006aaff$export$5fadb491a87317bf(obj, topLevelObj) {
    return obj.parent === topLevelObj;
}
function $be68dac03006aaff$export$d95d9322a7a4ea19(obj, topLevel) {
    if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return false;
    return $be68dac03006aaff$export$5fadb491a87317bf(obj, topLevel) && !$be68dac03006aaff$export$5bca2f41e52f6bfd(obj);
} // export function unGray(obj: THREE.Object3D): void {
 //     obj.traverse((obj) => {
 //         if (!("isMesh" in obj)) return
 //         if (obj.name.endsWith("_BottomBorder")) return
 //         const region = getRegion(obj)
 //         if (region instanceof MapRegion) {
 //             // obj.material = obj.parent.userData.materials.active[obj.parent.userData.mapLevel]
 //             // obj.userData.inactive = false
 //             region.activate()
 //         } else {
 //             new Tween(obj, getTweenGroup(obj))
 //                 .to(
 //                     {
 //                         material: {
 //                             color: obj.userData.baseColor,
 //                             emissive: obj.userData.baseEmissive,
 //                         },
 //                         userData: {
 //                             inactiveColor: obj.userData.baseColor,
 //                             inactiveEmissive: obj.userData.baseEmissive,
 //                         },
 //                     },
 //                     500
 //                 )
 //                 .easing(Easing.Quadratic.Out)
 //                 .start()
 //         }
 //     })
 // }



var $8NFma = parcelRequire("8NFma");

var $6T1J1 = parcelRequire("6T1J1");

var $1IdZj = parcelRequire("1IdZj");

var $8NFma = parcelRequire("8NFma");


var $b17e6a596d5c918d$export$83d89fbfd8236492;
var $b17e6a596d5c918d$export$80e7718417253a51;
var $b17e6a596d5c918d$export$eb3a06aef9e6ee51;
var $b17e6a596d5c918d$export$307591e98609eddd;
var $b17e6a596d5c918d$export$b23711c915539651;
var $b17e6a596d5c918d$export$7020a3240b287705;
"use strict";
var $b17e6a596d5c918d$var$l, $b17e6a596d5c918d$var$s;

$b17e6a596d5c918d$var$l = (parcelRequire("9RWW6"));

$b17e6a596d5c918d$var$s = (parcelRequire("bBFZG"));
$b17e6a596d5c918d$export$83d89fbfd8236492 = $b17e6a596d5c918d$var$l.version;
$b17e6a596d5c918d$export$80e7718417253a51 = $b17e6a596d5c918d$var$l.renderToString;
$b17e6a596d5c918d$export$eb3a06aef9e6ee51 = $b17e6a596d5c918d$var$l.renderToStaticMarkup;
$b17e6a596d5c918d$export$307591e98609eddd = $b17e6a596d5c918d$var$l.renderToNodeStream;
$b17e6a596d5c918d$export$b23711c915539651 = $b17e6a596d5c918d$var$l.renderToStaticNodeStream;
$b17e6a596d5c918d$export$7020a3240b287705 = $b17e6a596d5c918d$var$s.renderToReadableStream;



var $b6d45e1af0433d6c$export$ea1d1004ed602ef8;
(function(TapHelperLabelKind) {
    TapHelperLabelKind[TapHelperLabelKind["Vertical"] = 0] = "Vertical";
    TapHelperLabelKind[TapHelperLabelKind["Left"] = 1] = "Left";
    TapHelperLabelKind[TapHelperLabelKind["Right"] = 2] = "Right";
})($b6d45e1af0433d6c$export$ea1d1004ed602ef8 || ($b6d45e1af0433d6c$export$ea1d1004ed602ef8 = {}));
class $b6d45e1af0433d6c$export$320db79caa55ae92 extends (0, $8725869b83961a04$export$e4dd07dff30cc924) {
    #batonRootElement;
    #batonLineElement;
    #labelRadius;
    #tmp1Vector3;
    #tmp2Vector3;
    #tmp1Vector2;
    #tmp2Vector2;
    constructor(point1, point2, camera, label, labelContainer, lineContainer, onClick){
        super();
        this.#labelRadius = 25;
        // Create Bubble CSS2DObject
        this.label = new (0, $5859463f2a625df8$export$936f75e6792bf2dc)(labelContainer);
        this.label.position.copy(point1);
        this.add(this.label);
        // Create line CSS2DObject
        this.line = new (0, $5859463f2a625df8$export$936f75e6792bf2dc)(lineContainer);
        this.line.position.copy(point2);
        this.add(this.line);
        // Create roots
        this.labelContainer = labelContainer;
        this.lineContainer = lineContainer;
        this.renderHTML(label, this.#labelRadius, onClick, 100, 3, 0);
        this.updateLine(point1, point2, camera);
    }
    /**
     * Update the angle and length of the line to connect point1 to point2 in screen space
     * @param point1
     * @param point2
     * @param camera
     */ updateLine(point1, point2, camera) {
        // Calculate angle and length required to connect point1 and point2 in screen space
        this.#tmp1Vector3 = new (0, $8725869b83961a04$export$64b5c384219d3699)().copy(point1);
        this.#tmp2Vector3 = new (0, $8725869b83961a04$export$64b5c384219d3699)().copy(point2);
        // Convert to NDC
        this.#tmp1Vector3.project(camera);
        this.#tmp2Vector3.project(camera);
        // Convert to screen space
        this.#tmp1Vector2 = new (0, $8725869b83961a04$export$c977b3e384af9ae1)((this.#tmp1Vector3.x / 2 + 0.5) * window.innerWidth, (this.#tmp1Vector3.y / 2 + 0.5) * window.innerHeight);
        this.#tmp2Vector2 = new (0, $8725869b83961a04$export$c977b3e384af9ae1)((this.#tmp2Vector3.x / 2 + 0.5) * window.innerWidth, (this.#tmp2Vector3.y / 2 + 0.5) * window.innerHeight);
        // console.log(this.#tmp2Vector2)
        this.#tmp1Vector2.sub(this.#tmp2Vector2);
        const angle = 180 - this.#tmp1Vector2.angle() * (0, $d6f1a4944061be51$export$914076c8150813e5);
        const length = this.#tmp1Vector2.length() - this.#labelRadius;
        this.#batonRootElement.style.transform = `translateX(-50%) rotate(${angle}deg)`;
        this.#batonLineElement.style.transform = `scaleX(${length}%)`;
    }
    renderHTML(label, radius, onClick, width, height, angle) {
        this.lineContainer.innerHTML = (0, $b17e6a596d5c918d$export$eb3a06aef9e6ee51)(/*#__PURE__*/ (0, $1IdZj.jsx)($b6d45e1af0433d6c$var$CSSBaton, {
            width: width,
            height: height,
            startColor: "#2E3541",
            endColor: "#2E354140",
            angle: angle
        }));
        this.labelContainer.innerHTML = (0, $b17e6a596d5c918d$export$eb3a06aef9e6ee51)(/*#__PURE__*/ (0, $1IdZj.jsx)($b6d45e1af0433d6c$var$LabelBubble, {
            label: label,
            radius: this.#labelRadius,
            onClick: onClick
        }));
        // Extract HTML elements from rendered HTML
        {
            const tmp = this.line.element.querySelector(".pin-baton-root");
            if (tmp === null) throw Error("could not find pin baton root");
            this.#batonRootElement = tmp;
        }
        {
            const tmp = this.line.element.querySelector(".pin-baton-line");
            if (tmp === null) throw Error("could not find pin baton line");
            this.#batonLineElement = tmp;
        }
        // renderToStaticMarkup doesn't attach event listers, so we have to do it manually
        {
            const tmp = this.label.element.querySelector(".label-link");
            if (tmp === null) throw Error("could not find label link");
            tmp.addEventListener("click", onClick);
        }
    }
}
class $b6d45e1af0433d6c$var$TapHelperLabel extends (0, $8NFma.Component) {
    render() {
        if (this.props.kind === 0) return /*#__PURE__*/ (0, $1IdZj.jsxs)($b6d45e1af0433d6c$var$ColumnDiv, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)($b6d45e1af0433d6c$var$LabelBubble, {
                    label: this.props.label,
                    onClick: this.props.onClick,
                    radius: 25
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                    src: "assets/baton.svg",
                    alt: "baton-svg"
                })
            ]
        });
        else if (this.props.kind === 1) return /*#__PURE__*/ (0, $1IdZj.jsxs)($b6d45e1af0433d6c$var$RTLRowDiv, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)($b6d45e1af0433d6c$var$LabelBubble, {
                    label: this.props.label,
                    onClick: this.props.onClick
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)($b6d45e1af0433d6c$var$CSSBaton, {
                    width: this.props.size,
                    height: 3,
                    startColor: "#2E3541",
                    endColor: "#2E354140",
                    angle: 0
                })
            ]
        });
        else return /*#__PURE__*/ (0, $1IdZj.jsxs)($b6d45e1af0433d6c$var$ColumnDiv, {
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)($b6d45e1af0433d6c$var$LabelBubble, {
                    label: this.props.label,
                    onClick: this.props.onClick
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("img", {
                    src: "assets/baton.svg",
                    alt: "baton-svg"
                })
            ]
        });
    }
}
// class StretchyBaton extends Component<{
//     height: number
//     width: number
//     startColor: string
//     endColor: string
//     angleDeg: AngleDegrees
// }> {}
class $b6d45e1af0433d6c$var$CSSBaton extends (0, $8NFma.Component) {
    render() {
        return /*#__PURE__*/ (0, $1IdZj.jsxs)("div", {
            className: "pin-baton-root",
            style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                transformOrigin: "right",
                transform: `translateX(-50%) rotate(${this.props.angle}deg)`
            },
            children: [
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    className: "pin-baton-line",
                    style: {
                        height: this.props.height,
                        width: "100px",
                        transformOrigin: "right",
                        transform: `scaleX(${this.props.width}%)`,
                        backgroundImage: `linear-gradient(45deg, ${this.props.startColor}, ${this.props.startColor}, ${this.props.endColor})`
                    }
                }),
                /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                    style: {
                        height: this.props.height * 3,
                        width: this.props.height * 3,
                        backgroundColor: this.props.endColor,
                        borderRadius: this.props.height * 1.5
                    }
                })
            ]
        });
    }
}
class $b6d45e1af0433d6c$var$ColumnDiv extends (0, $8NFma.Component) {
    render() {
        return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: "label globe-pin",
            style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                transform: "translateY(-50%)"
            },
            children: this.props.children
        });
    }
}
class $b6d45e1af0433d6c$var$RTLRowDiv extends (0, $8NFma.Component) {
    render() {
        return /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
            className: "label globe-pin",
            style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                transform: "translateX(-50%)"
            },
            children: this.props.children
        });
    }
}
class $b6d45e1af0433d6c$var$LabelBubble extends (0, $8NFma.Component) {
    render() {
        return /*#__PURE__*/ (0, $1IdZj.jsx)("span", {
            className: "label-link",
            style: {
                pointerEvents: "all"
            },
            onClick: this.props.onClick,
            children: /*#__PURE__*/ (0, $1IdZj.jsx)("div", {
                style: {
                    userSelect: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#2E3541",
                    width: `${this.props.radius * 2}px`,
                    height: `${this.props.radius * 2}px`,
                    borderRadius: `${this.props.radius}px`,
                    fontFamily: "sans-serif",
                    fontWeight: 500,
                    fontSize: 22
                },
                children: this.props.label
            })
        });
    }
}
var $b6d45e1af0433d6c$export$2e2bcd8739ae039 = $b6d45e1af0433d6c$var$TapHelperLabel;




// Use an array for lookup performance
var $f6be72ae2d6fc0cb$var$c = [];
$f6be72ae2d6fc0cb$var$c[31039] = "Cuming";
$f6be72ae2d6fc0cb$var$c[53069] = "Wahkiakum";
$f6be72ae2d6fc0cb$var$c[35011] = "De Baca";
$f6be72ae2d6fc0cb$var$c[31109] = "Lancaster";
$f6be72ae2d6fc0cb$var$c[31129] = "Nuckolls";
$f6be72ae2d6fc0cb$var$c[72085] = "Las Piedras";
$f6be72ae2d6fc0cb$var$c[46099] = "Minnehaha";
$f6be72ae2d6fc0cb$var$c[48327] = "Menard";
$f6be72ae2d6fc0cb$var$c[6091] = "Sierra";
$f6be72ae2d6fc0cb$var$c[21053] = "Clinton";
$f6be72ae2d6fc0cb$var$c[39063] = "Hancock";
$f6be72ae2d6fc0cb$var$c[48189] = "Hale";
$f6be72ae2d6fc0cb$var$c[1027] = "Clay";
$f6be72ae2d6fc0cb$var$c[48011] = "Armstrong";
$f6be72ae2d6fc0cb$var$c[39003] = "Allen";
$f6be72ae2d6fc0cb$var$c[13189] = "McDuffie";
$f6be72ae2d6fc0cb$var$c[55111] = "Sauk";
$f6be72ae2d6fc0cb$var$c[5137] = "Stone";
$f6be72ae2d6fc0cb$var$c[41063] = "Wallowa";
$f6be72ae2d6fc0cb$var$c[42007] = "Beaver";
$f6be72ae2d6fc0cb$var$c[28061] = "Jasper";
$f6be72ae2d6fc0cb$var$c[29083] = "Henry";
$f6be72ae2d6fc0cb$var$c[8109] = "Saguache";
$f6be72ae2d6fc0cb$var$c[37037] = "Chatham";
$f6be72ae2d6fc0cb$var$c[49033] = "Rich";
$f6be72ae2d6fc0cb$var$c[40001] = "Adair";
$f6be72ae2d6fc0cb$var$c[39085] = "Lake";
$f6be72ae2d6fc0cb$var$c[51775] = "Salem";
$f6be72ae2d6fc0cb$var$c[51121] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[47065] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[35035] = "Otero";
$f6be72ae2d6fc0cb$var$c[35003] = "Catron";
$f6be72ae2d6fc0cb$var$c[1091] = "Marengo";
$f6be72ae2d6fc0cb$var$c[56023] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[29011] = "Barton";
$f6be72ae2d6fc0cb$var$c[48057] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[51735] = "Poquoson";
$f6be72ae2d6fc0cb$var$c[54075] = "Pocahontas";
$f6be72ae2d6fc0cb$var$c[48077] = "Clay";
$f6be72ae2d6fc0cb$var$c[51095] = "James City";
$f6be72ae2d6fc0cb$var$c[31101] = "Keith";
$f6be72ae2d6fc0cb$var$c[31137] = "Phelps";
$f6be72ae2d6fc0cb$var$c[22019] = "Calcasieu";
$f6be72ae2d6fc0cb$var$c[22111] = "Union";
$f6be72ae2d6fc0cb$var$c[40135] = "Sequoyah";
$f6be72ae2d6fc0cb$var$c[1049] = "DeKalb";
$f6be72ae2d6fc0cb$var$c[36101] = "Steuben";
$f6be72ae2d6fc0cb$var$c[42053] = "Forest";
$f6be72ae2d6fc0cb$var$c[22105] = "Tangipahoa";
$f6be72ae2d6fc0cb$var$c[51179] = "Stafford";
$f6be72ae2d6fc0cb$var$c[26109] = "Menominee";
$f6be72ae2d6fc0cb$var$c[18073] = "Jasper";
$f6be72ae2d6fc0cb$var$c[13025] = "Brantley";
$f6be72ae2d6fc0cb$var$c[13171] = "Lamar";
$f6be72ae2d6fc0cb$var$c[18151] = "Steuben";
$f6be72ae2d6fc0cb$var$c[48361] = "Orange";
$f6be72ae2d6fc0cb$var$c[39047] = "Fayette";
$f6be72ae2d6fc0cb$var$c[25015] = "Hampshire";
$f6be72ae2d6fc0cb$var$c[21003] = "Allen";
$f6be72ae2d6fc0cb$var$c[37001] = "Alamance";
$f6be72ae2d6fc0cb$var$c[20073] = "Greenwood";
$f6be72ae2d6fc0cb$var$c[25025] = "Suffolk";
$f6be72ae2d6fc0cb$var$c[16051] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[48177] = "Gonzales";
$f6be72ae2d6fc0cb$var$c[47115] = "Marion";
$f6be72ae2d6fc0cb$var$c[26007] = "Alpena";
$f6be72ae2d6fc0cb$var$c[21231] = "Wayne";
$f6be72ae2d6fc0cb$var$c[47185] = "White";
$f6be72ae2d6fc0cb$var$c[48147] = "Fannin";
$f6be72ae2d6fc0cb$var$c[20043] = "Doniphan";
$f6be72ae2d6fc0cb$var$c[48265] = "Kerr";
$f6be72ae2d6fc0cb$var$c[12053] = "Hernando";
$f6be72ae2d6fc0cb$var$c[12129] = "Wakulla";
$f6be72ae2d6fc0cb$var$c[12131] = "Walton";
$f6be72ae2d6fc0cb$var$c[28017] = "Chickasaw";
$f6be72ae2d6fc0cb$var$c[2130] = "Ketchikan Gateway";
$f6be72ae2d6fc0cb$var$c[26035] = "Clare";
$f6be72ae2d6fc0cb$var$c[20157] = "Republic";
$f6be72ae2d6fc0cb$var$c[12127] = "Volusia";
$f6be72ae2d6fc0cb$var$c[40017] = "Canadian";
$f6be72ae2d6fc0cb$var$c[72115] = "Quebradillas";
$f6be72ae2d6fc0cb$var$c[78030] = "St. Thomas";
$f6be72ae2d6fc0cb$var$c[13115] = "Floyd";
$f6be72ae2d6fc0cb$var$c[32001] = "Churchill";
$f6be72ae2d6fc0cb$var$c[31181] = "Webster";
$f6be72ae2d6fc0cb$var$c[17067] = "Hancock";
$f6be72ae2d6fc0cb$var$c[46067] = "Hutchinson";
$f6be72ae2d6fc0cb$var$c[41013] = "Crook";
$f6be72ae2d6fc0cb$var$c[50011] = "Franklin";
$f6be72ae2d6fc0cb$var$c[26103] = "Marquette";
$f6be72ae2d6fc0cb$var$c[9007] = "Middlesex";
$f6be72ae2d6fc0cb$var$c[37057] = "Davidson";
$f6be72ae2d6fc0cb$var$c[17025] = "Clay";
$f6be72ae2d6fc0cb$var$c[29103] = "Knox";
$f6be72ae2d6fc0cb$var$c[29117] = "Livingston";
$f6be72ae2d6fc0cb$var$c[42117] = "Tioga";
$f6be72ae2d6fc0cb$var$c[31043] = "Dakota";
$f6be72ae2d6fc0cb$var$c[26089] = "Leelanau";
$f6be72ae2d6fc0cb$var$c[51181] = "Surry";
$f6be72ae2d6fc0cb$var$c[48391] = "Refugio";
$f6be72ae2d6fc0cb$var$c[39017] = "Butler";
$f6be72ae2d6fc0cb$var$c[13273] = "Terrell";
$f6be72ae2d6fc0cb$var$c[13063] = "Clayton";
$f6be72ae2d6fc0cb$var$c[56013] = "Fremont";
$f6be72ae2d6fc0cb$var$c[18115] = "Ohio";
$f6be72ae2d6fc0cb$var$c[13073] = "Columbia";
$f6be72ae2d6fc0cb$var$c[8115] = "Sedgwick";
$f6be72ae2d6fc0cb$var$c[30065] = "Musselshell";
$f6be72ae2d6fc0cb$var$c[42043] = "Dauphin";
$f6be72ae2d6fc0cb$var$c[46101] = "Moody";
$f6be72ae2d6fc0cb$var$c[54079] = "Putnam";
$f6be72ae2d6fc0cb$var$c[34037] = "Sussex";
$f6be72ae2d6fc0cb$var$c[20039] = "Decatur";
$f6be72ae2d6fc0cb$var$c[18123] = "Perry";
$f6be72ae2d6fc0cb$var$c[28145] = "Union";
$f6be72ae2d6fc0cb$var$c[31015] = "Boyd";
$f6be72ae2d6fc0cb$var$c[27095] = "Mille Lacs";
$f6be72ae2d6fc0cb$var$c[38099] = "Walsh";
$f6be72ae2d6fc0cb$var$c[39115] = "Morgan";
$f6be72ae2d6fc0cb$var$c[39133] = "Portage";
$f6be72ae2d6fc0cb$var$c[56041] = "Uinta";
$f6be72ae2d6fc0cb$var$c[32013] = "Humboldt";
$f6be72ae2d6fc0cb$var$c[48247] = "Jim Hogg";
$f6be72ae2d6fc0cb$var$c[8017] = "Cheyenne";
$f6be72ae2d6fc0cb$var$c[41005] = "Clackamas";
$f6be72ae2d6fc0cb$var$c[5113] = "Polk";
$f6be72ae2d6fc0cb$var$c[13193] = "Macon";
$f6be72ae2d6fc0cb$var$c[18007] = "Benton";
$f6be72ae2d6fc0cb$var$c[47129] = "Morgan";
$f6be72ae2d6fc0cb$var$c[46043] = "Douglas";
$f6be72ae2d6fc0cb$var$c[24047] = "Worcester";
$f6be72ae2d6fc0cb$var$c[17185] = "Wabash";
$f6be72ae2d6fc0cb$var$c[18069] = "Huntington";
$f6be72ae2d6fc0cb$var$c[21209] = "Scott";
$f6be72ae2d6fc0cb$var$c[19053] = "Decatur";
$f6be72ae2d6fc0cb$var$c[18169] = "Wabash";
$f6be72ae2d6fc0cb$var$c[18003] = "Allen";
$f6be72ae2d6fc0cb$var$c[18099] = "Marshall";
$f6be72ae2d6fc0cb$var$c[31171] = "Thomas";
$f6be72ae2d6fc0cb$var$c[38085] = "Sioux";
$f6be72ae2d6fc0cb$var$c[48127] = "Dimmit";
$f6be72ae2d6fc0cb$var$c[27045] = "Fillmore";
$f6be72ae2d6fc0cb$var$c[45023] = "Chester";
$f6be72ae2d6fc0cb$var$c[27073] = "Lac qui Parle";
$f6be72ae2d6fc0cb$var$c[49005] = "Cache";
$f6be72ae2d6fc0cb$var$c[55093] = "Pierce";
$f6be72ae2d6fc0cb$var$c[13049] = "Charlton";
$f6be72ae2d6fc0cb$var$c[13233] = "Polk";
$f6be72ae2d6fc0cb$var$c[17113] = "McLean";
$f6be72ae2d6fc0cb$var$c[23001] = "Androscoggin";
$f6be72ae2d6fc0cb$var$c[16055] = "Kootenai";
$f6be72ae2d6fc0cb$var$c[32003] = "Clark";
$f6be72ae2d6fc0cb$var$c[20147] = "Phillips";
$f6be72ae2d6fc0cb$var$c[31089] = "Holt";
$f6be72ae2d6fc0cb$var$c[29101] = "Johnson";
$f6be72ae2d6fc0cb$var$c[55063] = "La Crosse";
$f6be72ae2d6fc0cb$var$c[22021] = "Caldwell";
$f6be72ae2d6fc0cb$var$c[21061] = "Edmonson";
$f6be72ae2d6fc0cb$var$c[17005] = "Bond";
$f6be72ae2d6fc0cb$var$c[17009] = "Brown";
$f6be72ae2d6fc0cb$var$c[27085] = "McLeod";
$f6be72ae2d6fc0cb$var$c[55033] = "Dunn";
$f6be72ae2d6fc0cb$var$c[8027] = "Custer";
$f6be72ae2d6fc0cb$var$c[29123] = "Madison";
$f6be72ae2d6fc0cb$var$c[48353] = "Nolan";
$f6be72ae2d6fc0cb$var$c[42127] = "Wayne";
$f6be72ae2d6fc0cb$var$c[36091] = "Saratoga";
$f6be72ae2d6fc0cb$var$c[48041] = "Brazos";
$f6be72ae2d6fc0cb$var$c[40095] = "Marshall";
$f6be72ae2d6fc0cb$var$c[24001] = "Allegany";
$f6be72ae2d6fc0cb$var$c[54103] = "Wetzel";
$f6be72ae2d6fc0cb$var$c[55053] = "Jackson";
$f6be72ae2d6fc0cb$var$c[41007] = "Clatsop";
$f6be72ae2d6fc0cb$var$c[53041] = "Lewis";
$f6be72ae2d6fc0cb$var$c[36003] = "Allegany";
$f6be72ae2d6fc0cb$var$c[19031] = "Cedar";
$f6be72ae2d6fc0cb$var$c[18117] = "Orange";
$f6be72ae2d6fc0cb$var$c[13089] = "DeKalb";
$f6be72ae2d6fc0cb$var$c[13227] = "Pickens";
$f6be72ae2d6fc0cb$var$c[30015] = "Chouteau";
$f6be72ae2d6fc0cb$var$c[31017] = "Brown";
$f6be72ae2d6fc0cb$var$c[47013] = "Campbell";
$f6be72ae2d6fc0cb$var$c[37069] = "Franklin";
$f6be72ae2d6fc0cb$var$c[24510] = "Baltimore";
$f6be72ae2d6fc0cb$var$c[20111] = "Lyon";
$f6be72ae2d6fc0cb$var$c[19027] = "Carroll";
$f6be72ae2d6fc0cb$var$c[22107] = "Tensas";
$f6be72ae2d6fc0cb$var$c[47123] = "Monroe";
$f6be72ae2d6fc0cb$var$c[20075] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[19151] = "Pocahontas";
$f6be72ae2d6fc0cb$var$c[16045] = "Gem";
$f6be72ae2d6fc0cb$var$c[5063] = "Independence";
$f6be72ae2d6fc0cb$var$c[5085] = "Lonoke";
$f6be72ae2d6fc0cb$var$c[18111] = "Newton";
$f6be72ae2d6fc0cb$var$c[13119] = "Franklin";
$f6be72ae2d6fc0cb$var$c[12051] = "Hendry";
$f6be72ae2d6fc0cb$var$c[13265] = "Taliaferro";
$f6be72ae2d6fc0cb$var$c[48245] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[30059] = "Meagher";
$f6be72ae2d6fc0cb$var$c[8067] = "La Plata";
$f6be72ae2d6fc0cb$var$c[48027] = "Bell";
$f6be72ae2d6fc0cb$var$c[28069] = "Kemper";
$f6be72ae2d6fc0cb$var$c[5019] = "Clark";
$f6be72ae2d6fc0cb$var$c[41035] = "Klamath";
$f6be72ae2d6fc0cb$var$c[36075] = "Oswego";
$f6be72ae2d6fc0cb$var$c[72105] = "Naranjito";
$f6be72ae2d6fc0cb$var$c[1019] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[48019] = "Bandera";
$f6be72ae2d6fc0cb$var$c[30087] = "Rosebud";
$f6be72ae2d6fc0cb$var$c[35059] = "Union";
$f6be72ae2d6fc0cb$var$c[26153] = "Schoolcraft";
$f6be72ae2d6fc0cb$var$c[36111] = "Ulster";
$f6be72ae2d6fc0cb$var$c[34007] = "Camden";
$f6be72ae2d6fc0cb$var$c[17083] = "Jersey";
$f6be72ae2d6fc0cb$var$c[51085] = "Hanover";
$f6be72ae2d6fc0cb$var$c[20199] = "Wallace";
$f6be72ae2d6fc0cb$var$c[26003] = "Alger";
$f6be72ae2d6fc0cb$var$c[5049] = "Fulton";
$f6be72ae2d6fc0cb$var$c[48215] = "Hidalgo";
$f6be72ae2d6fc0cb$var$c[37155] = "Robeson";
$f6be72ae2d6fc0cb$var$c[26123] = "Newaygo";
$f6be72ae2d6fc0cb$var$c[41049] = "Morrow";
$f6be72ae2d6fc0cb$var$c[27153] = "Todd";
$f6be72ae2d6fc0cb$var$c[5083] = "Logan";
$f6be72ae2d6fc0cb$var$c[37109] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[5091] = "Miller";
$f6be72ae2d6fc0cb$var$c[12095] = "Orange";
$f6be72ae2d6fc0cb$var$c[8111] = "San Juan";
$f6be72ae2d6fc0cb$var$c[16041] = "Franklin";
$f6be72ae2d6fc0cb$var$c[13045] = "Carroll";
$f6be72ae2d6fc0cb$var$c[20161] = "Riley";
$f6be72ae2d6fc0cb$var$c[48413] = "Schleicher";
$f6be72ae2d6fc0cb$var$c[51167] = "Russell";
$f6be72ae2d6fc0cb$var$c[37027] = "Caldwell";
$f6be72ae2d6fc0cb$var$c[16065] = "Madison";
$f6be72ae2d6fc0cb$var$c[18173] = "Warrick";
$f6be72ae2d6fc0cb$var$c[21001] = "Adair";
$f6be72ae2d6fc0cb$var$c[21077] = "Gallatin";
$f6be72ae2d6fc0cb$var$c[21097] = "Harrison";
$f6be72ae2d6fc0cb$var$c[23023] = "Sagadahoc";
$f6be72ae2d6fc0cb$var$c[30097] = "Sweet Grass";
$f6be72ae2d6fc0cb$var$c[48181] = "Grayson";
$f6be72ae2d6fc0cb$var$c[42059] = "Greene";
$f6be72ae2d6fc0cb$var$c[2188] = "Northwest Arctic";
$f6be72ae2d6fc0cb$var$c[20051] = "Ellis";
$f6be72ae2d6fc0cb$var$c[1065] = "Hale";
$f6be72ae2d6fc0cb$var$c[1105] = "Perry";
$f6be72ae2d6fc0cb$var$c[1033] = "Colbert";
$f6be72ae2d6fc0cb$var$c[20151] = "Pratt";
$f6be72ae2d6fc0cb$var$c[21017] = "Bourbon";
$f6be72ae2d6fc0cb$var$c[47149] = "Rutherford";
$f6be72ae2d6fc0cb$var$c[13075] = "Cook";
$f6be72ae2d6fc0cb$var$c[20101] = "Lane";
$f6be72ae2d6fc0cb$var$c[40059] = "Harper";
$f6be72ae2d6fc0cb$var$c[17147] = "Piatt";
$f6be72ae2d6fc0cb$var$c[48107] = "Crosby";
$f6be72ae2d6fc0cb$var$c[72053] = "Fajardo";
$f6be72ae2d6fc0cb$var$c[1063] = "Greene";
$f6be72ae2d6fc0cb$var$c[16033] = "Clark";
$f6be72ae2d6fc0cb$var$c[19109] = "Kossuth";
$f6be72ae2d6fc0cb$var$c[72151] = "Yabucoa";
$f6be72ae2d6fc0cb$var$c[38013] = "Burke";
$f6be72ae2d6fc0cb$var$c[37063] = "Durham";
$f6be72ae2d6fc0cb$var$c[19085] = "Harrison";
$f6be72ae2d6fc0cb$var$c[31103] = "Keya Paha";
$f6be72ae2d6fc0cb$var$c[19187] = "Webster";
$f6be72ae2d6fc0cb$var$c[17151] = "Pope";
$f6be72ae2d6fc0cb$var$c[47159] = "Smith";
$f6be72ae2d6fc0cb$var$c[51089] = "Henry";
$f6be72ae2d6fc0cb$var$c[51510] = "Alexandria";
$f6be72ae2d6fc0cb$var$c[19101] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[30049] = "Lewis and Clark";
$f6be72ae2d6fc0cb$var$c[49013] = "Duchesne";
$f6be72ae2d6fc0cb$var$c[40003] = "Alfalfa";
$f6be72ae2d6fc0cb$var$c[48119] = "Delta";
$f6be72ae2d6fc0cb$var$c[47169] = "Trousdale";
$f6be72ae2d6fc0cb$var$c[21193] = "Perry";
$f6be72ae2d6fc0cb$var$c[46039] = "Deuel";
$f6be72ae2d6fc0cb$var$c[41029] = "Jackson";
$f6be72ae2d6fc0cb$var$c[72067] = "Hormigueros";
$f6be72ae2d6fc0cb$var$c[48507] = "Zavala";
$f6be72ae2d6fc0cb$var$c[31007] = "Banner";
$f6be72ae2d6fc0cb$var$c[19121] = "Madison";
$f6be72ae2d6fc0cb$var$c[12011] = "Broward";
$f6be72ae2d6fc0cb$var$c[13279] = "Toombs";
$f6be72ae2d6fc0cb$var$c[26151] = "Sanilac";
$f6be72ae2d6fc0cb$var$c[48397] = "Rockwall";
$f6be72ae2d6fc0cb$var$c[26163] = "Wayne";
$f6be72ae2d6fc0cb$var$c[27105] = "Nobles";
$f6be72ae2d6fc0cb$var$c[27001] = "Aitkin";
$f6be72ae2d6fc0cb$var$c[38071] = "Ramsey";
$f6be72ae2d6fc0cb$var$c[37145] = "Person";
$f6be72ae2d6fc0cb$var$c[20195] = "Trego";
$f6be72ae2d6fc0cb$var$c[28151] = "Washington";
$f6be72ae2d6fc0cb$var$c[48133] = "Eastland";
$f6be72ae2d6fc0cb$var$c[28055] = "Issaquena";
$f6be72ae2d6fc0cb$var$c[48123] = "DeWitt";
$f6be72ae2d6fc0cb$var$c[48005] = "Angelina";
$f6be72ae2d6fc0cb$var$c[45081] = "Saluda";
$f6be72ae2d6fc0cb$var$c[29125] = "Maries";
$f6be72ae2d6fc0cb$var$c[5001] = "Arkansas";
$f6be72ae2d6fc0cb$var$c[29109] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[51540] = "Charlottesville";
$f6be72ae2d6fc0cb$var$c[17011] = "Bureau";
$f6be72ae2d6fc0cb$var$c[39145] = "Scioto";
$f6be72ae2d6fc0cb$var$c[37115] = "Madison";
$f6be72ae2d6fc0cb$var$c[16053] = "Jerome";
$f6be72ae2d6fc0cb$var$c[39163] = "Vinton";
$f6be72ae2d6fc0cb$var$c[48309] = "McLennan";
$f6be72ae2d6fc0cb$var$c[16037] = "Custer";
$f6be72ae2d6fc0cb$var$c[19089] = "Howard";
$f6be72ae2d6fc0cb$var$c[12099] = "Palm Beach";
$f6be72ae2d6fc0cb$var$c[13181] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[1013] = "Butler";
$f6be72ae2d6fc0cb$var$c[47165] = "Sumner";
$f6be72ae2d6fc0cb$var$c[51097] = "King and Queen";
$f6be72ae2d6fc0cb$var$c[5015] = "Carroll";
$f6be72ae2d6fc0cb$var$c[51820] = "Waynesboro";
$f6be72ae2d6fc0cb$var$c[2220] = "Sitka";
$f6be72ae2d6fc0cb$var$c[41051] = "Multnomah";
$f6be72ae2d6fc0cb$var$c[47061] = "Grundy";
$f6be72ae2d6fc0cb$var$c[27057] = "Hubbard";
$f6be72ae2d6fc0cb$var$c[38081] = "Sargent";
$f6be72ae2d6fc0cb$var$c[36089] = "St. Lawrence";
$f6be72ae2d6fc0cb$var$c[29179] = "Reynolds";
$f6be72ae2d6fc0cb$var$c[6067] = "Sacramento";
$f6be72ae2d6fc0cb$var$c[39125] = "Paulding";
$f6be72ae2d6fc0cb$var$c[18179] = "Wells";
$f6be72ae2d6fc0cb$var$c[51063] = "Floyd";
$f6be72ae2d6fc0cb$var$c[6083] = "Santa Barbara";
$f6be72ae2d6fc0cb$var$c[54005] = "Boone";
$f6be72ae2d6fc0cb$var$c[28009] = "Benton";
$f6be72ae2d6fc0cb$var$c[21055] = "Crittenden";
$f6be72ae2d6fc0cb$var$c[19147] = "Palo Alto";
$f6be72ae2d6fc0cb$var$c[19159] = "Ringgold";
$f6be72ae2d6fc0cb$var$c[37151] = "Randolph";
$f6be72ae2d6fc0cb$var$c[24015] = "Cecil";
$f6be72ae2d6fc0cb$var$c[18171] = "Warren";
$f6be72ae2d6fc0cb$var$c[31077] = "Greeley";
$f6be72ae2d6fc0cb$var$c[31095] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[31151] = "Saline";
$f6be72ae2d6fc0cb$var$c[21119] = "Knott";
$f6be72ae2d6fc0cb$var$c[19045] = "Clinton";
$f6be72ae2d6fc0cb$var$c[27063] = "Jackson";
$f6be72ae2d6fc0cb$var$c[27039] = "Dodge";
$f6be72ae2d6fc0cb$var$c[27047] = "Freeborn";
$f6be72ae2d6fc0cb$var$c[6009] = "Calaveras";
$f6be72ae2d6fc0cb$var$c[25001] = "Barnstable";
$f6be72ae2d6fc0cb$var$c[51119] = "Middlesex";
$f6be72ae2d6fc0cb$var$c[42065] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[18089] = "Lake";
$f6be72ae2d6fc0cb$var$c[47003] = "Bedford";
$f6be72ae2d6fc0cb$var$c[47027] = "Clay";
$f6be72ae2d6fc0cb$var$c[17029] = "Coles";
$f6be72ae2d6fc0cb$var$c[47097] = "Lauderdale";
$f6be72ae2d6fc0cb$var$c[41001] = "Baker";
$f6be72ae2d6fc0cb$var$c[36097] = "Schuyler";
$f6be72ae2d6fc0cb$var$c[26159] = "Van Buren";
$f6be72ae2d6fc0cb$var$c[17131] = "Mercer";
$f6be72ae2d6fc0cb$var$c[21127] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[21175] = "Morgan";
$f6be72ae2d6fc0cb$var$c[21177] = "Muhlenberg";
$f6be72ae2d6fc0cb$var$c[17049] = "Effingham";
$f6be72ae2d6fc0cb$var$c[47105] = "Loudon";
$f6be72ae2d6fc0cb$var$c[46025] = "Clark";
$f6be72ae2d6fc0cb$var$c[15003] = "Honolulu";
$f6be72ae2d6fc0cb$var$c[12041] = "Gilchrist";
$f6be72ae2d6fc0cb$var$c[18157] = "Tippecanoe";
$f6be72ae2d6fc0cb$var$c[42109] = "Snyder";
$f6be72ae2d6fc0cb$var$c[48277] = "Lamar";
$f6be72ae2d6fc0cb$var$c[12086] = "Miami-Dade";
$f6be72ae2d6fc0cb$var$c[31057] = "Dundy";
$f6be72ae2d6fc0cb$var$c[48289] = "Leon";
$f6be72ae2d6fc0cb$var$c[8097] = "Pitkin";
$f6be72ae2d6fc0cb$var$c[38035] = "Grand Forks";
$f6be72ae2d6fc0cb$var$c[18091] = "LaPorte";
$f6be72ae2d6fc0cb$var$c[18057] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[51595] = "Emporia";
$f6be72ae2d6fc0cb$var$c[40081] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[20071] = "Greeley";
$f6be72ae2d6fc0cb$var$c[13145] = "Harris";
$f6be72ae2d6fc0cb$var$c[13251] = "Screven";
$f6be72ae2d6fc0cb$var$c[72127] = "San Juan";
$f6be72ae2d6fc0cb$var$c[48433] = "Stonewall";
$f6be72ae2d6fc0cb$var$c[39069] = "Henry";
$f6be72ae2d6fc0cb$var$c[33009] = "Grafton";
$f6be72ae2d6fc0cb$var$c[29145] = "Newton";
$f6be72ae2d6fc0cb$var$c[18129] = "Posey";
$f6be72ae2d6fc0cb$var$c[48311] = "McMullen";
$f6be72ae2d6fc0cb$var$c[17035] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[13297] = "Walton";
$f6be72ae2d6fc0cb$var$c[27121] = "Pope";
$f6be72ae2d6fc0cb$var$c[51157] = "Rappahannock";
$f6be72ae2d6fc0cb$var$c[51009] = "Amherst";
$f6be72ae2d6fc0cb$var$c[6111] = "Ventura";
$f6be72ae2d6fc0cb$var$c[17033] = "Crawford";
$f6be72ae2d6fc0cb$var$c[8093] = "Park";
$f6be72ae2d6fc0cb$var$c[6037] = "Los Angeles";
$f6be72ae2d6fc0cb$var$c[4027] = "Yuma";
$f6be72ae2d6fc0cb$var$c[13129] = "Gordon";
$f6be72ae2d6fc0cb$var$c[19025] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[12055] = "Highlands";
$f6be72ae2d6fc0cb$var$c[51580] = "Covington";
$f6be72ae2d6fc0cb$var$c[50017] = "Orange";
$f6be72ae2d6fc0cb$var$c[20113] = "McPherson";
$f6be72ae2d6fc0cb$var$c[4021] = "Pinal";
$f6be72ae2d6fc0cb$var$c[39051] = "Fulton";
$f6be72ae2d6fc0cb$var$c[8003] = "Alamosa";
$f6be72ae2d6fc0cb$var$c[12017] = "Citrus";
$f6be72ae2d6fc0cb$var$c[72049] = "Culebra";
$f6be72ae2d6fc0cb$var$c[72051] = "Dorado";
$f6be72ae2d6fc0cb$var$c[47041] = "DeKalb";
$f6be72ae2d6fc0cb$var$c[42031] = "Clarion";
$f6be72ae2d6fc0cb$var$c[46097] = "Miner";
$f6be72ae2d6fc0cb$var$c[46073] = "Jerauld";
$f6be72ae2d6fc0cb$var$c[18031] = "Decatur";
$f6be72ae2d6fc0cb$var$c[18037] = "Dubois";
$f6be72ae2d6fc0cb$var$c[51057] = "Essex";
$f6be72ae2d6fc0cb$var$c[45089] = "Williamsburg";
$f6be72ae2d6fc0cb$var$c[36031] = "Essex";
$f6be72ae2d6fc0cb$var$c[19195] = "Worth";
$f6be72ae2d6fc0cb$var$c[40063] = "Hughes";
$f6be72ae2d6fc0cb$var$c[51027] = "Buchanan";
$f6be72ae2d6fc0cb$var$c[51005] = "Alleghany";
$f6be72ae2d6fc0cb$var$c[28087] = "Lowndes";
$f6be72ae2d6fc0cb$var$c[18143] = "Scott";
$f6be72ae2d6fc0cb$var$c[8099] = "Prowers";
$f6be72ae2d6fc0cb$var$c[48435] = "Sutton";
$f6be72ae2d6fc0cb$var$c[72121] = "Sabana Grande";
$f6be72ae2d6fc0cb$var$c[40101] = "Muskogee";
$f6be72ae2d6fc0cb$var$c[29043] = "Christian";
$f6be72ae2d6fc0cb$var$c[72039] = "Ciales";
$f6be72ae2d6fc0cb$var$c[28073] = "Lamar";
$f6be72ae2d6fc0cb$var$c[18137] = "Ripley";
$f6be72ae2d6fc0cb$var$c[38057] = "Mercer";
$f6be72ae2d6fc0cb$var$c[13147] = "Hart";
$f6be72ae2d6fc0cb$var$c[22049] = "Jackson";
$f6be72ae2d6fc0cb$var$c[51133] = "Northumberland";
$f6be72ae2d6fc0cb$var$c[48157] = "Fort Bend";
$f6be72ae2d6fc0cb$var$c[55047] = "Green Lake";
$f6be72ae2d6fc0cb$var$c[30073] = "Pondera";
$f6be72ae2d6fc0cb$var$c[55127] = "Walworth";
$f6be72ae2d6fc0cb$var$c[32021] = "Mineral";
$f6be72ae2d6fc0cb$var$c[17057] = "Fulton";
$f6be72ae2d6fc0cb$var$c[36103] = "Suffolk";
$f6be72ae2d6fc0cb$var$c[18161] = "Union";
$f6be72ae2d6fc0cb$var$c[29119] = "McDonald";
$f6be72ae2d6fc0cb$var$c[31157] = "Scotts Bluff";
$f6be72ae2d6fc0cb$var$c[35047] = "San Miguel";
$f6be72ae2d6fc0cb$var$c[1081] = "Lee";
$f6be72ae2d6fc0cb$var$c[48367] = "Parker";
$f6be72ae2d6fc0cb$var$c[38021] = "Dickey";
$f6be72ae2d6fc0cb$var$c[38003] = "Barnes";
$f6be72ae2d6fc0cb$var$c[27143] = "Sibley";
$f6be72ae2d6fc0cb$var$c[13293] = "Upson";
$f6be72ae2d6fc0cb$var$c[6097] = "Sonoma";
$f6be72ae2d6fc0cb$var$c[26033] = "Chippewa";
$f6be72ae2d6fc0cb$var$c[16019] = "Bonneville";
$f6be72ae2d6fc0cb$var$c[13013] = "Barrow";
$f6be72ae2d6fc0cb$var$c[13183] = "Long";
$f6be72ae2d6fc0cb$var$c[48271] = "Kinney";
$f6be72ae2d6fc0cb$var$c[40115] = "Ottawa";
$f6be72ae2d6fc0cb$var$c[42033] = "Clearfield";
$f6be72ae2d6fc0cb$var$c[26037] = "Clinton";
$f6be72ae2d6fc0cb$var$c[72133] = "Santa Isabel";
$f6be72ae2d6fc0cb$var$c[17135] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[28003] = "Alcorn";
$f6be72ae2d6fc0cb$var$c[28071] = "Lafayette";
$f6be72ae2d6fc0cb$var$c[22043] = "Grant";
$f6be72ae2d6fc0cb$var$c[29005] = "Atchison";
$f6be72ae2d6fc0cb$var$c[17115] = "Macon";
$f6be72ae2d6fc0cb$var$c[26149] = "St. Joseph";
$f6be72ae2d6fc0cb$var$c[17055] = "Franklin";
$f6be72ae2d6fc0cb$var$c[30033] = "Garfield";
$f6be72ae2d6fc0cb$var$c[31001] = "Adams";
$f6be72ae2d6fc0cb$var$c[27109] = "Olmsted";
$f6be72ae2d6fc0cb$var$c[34039] = "Union";
$f6be72ae2d6fc0cb$var$c[72139] = "Trujillo Alto";
$f6be72ae2d6fc0cb$var$c[1097] = "Mobile";
$f6be72ae2d6fc0cb$var$c[46087] = "McCook";
$f6be72ae2d6fc0cb$var$c[1057] = "Fayette";
$f6be72ae2d6fc0cb$var$c[1017] = "Chambers";
$f6be72ae2d6fc0cb$var$c[37131] = "Northampton";
$f6be72ae2d6fc0cb$var$c[8081] = "Moffat";
$f6be72ae2d6fc0cb$var$c[21087] = "Green";
$f6be72ae2d6fc0cb$var$c[18047] = "Franklin";
$f6be72ae2d6fc0cb$var$c[37013] = "Beaufort";
$f6be72ae2d6fc0cb$var$c[72073] = "Jayuya";
$f6be72ae2d6fc0cb$var$c[38015] = "Burleigh";
$f6be72ae2d6fc0cb$var$c[37159] = "Rowan";
$f6be72ae2d6fc0cb$var$c[26071] = "Iron";
$f6be72ae2d6fc0cb$var$c[27067] = "Kandiyohi";
$f6be72ae2d6fc0cb$var$c[21237] = "Wolfe";
$f6be72ae2d6fc0cb$var$c[48149] = "Fayette";
$f6be72ae2d6fc0cb$var$c[46081] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[23029] = "Washington";
$f6be72ae2d6fc0cb$var$c[48045] = "Briscoe";
$f6be72ae2d6fc0cb$var$c[26131] = "Ontonagon";
$f6be72ae2d6fc0cb$var$c[28015] = "Carroll";
$f6be72ae2d6fc0cb$var$c[41003] = "Benton";
$f6be72ae2d6fc0cb$var$c[27133] = "Rock";
$f6be72ae2d6fc0cb$var$c[42063] = "Indiana";
$f6be72ae2d6fc0cb$var$c[22061] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[42099] = "Perry";
$f6be72ae2d6fc0cb$var$c[46137] = "Ziebach";
$f6be72ae2d6fc0cb$var$c[48203] = "Harrison";
$f6be72ae2d6fc0cb$var$c[26013] = "Baraga";
$f6be72ae2d6fc0cb$var$c[40131] = "Rogers";
$f6be72ae2d6fc0cb$var$c[29019] = "Boone";
$f6be72ae2d6fc0cb$var$c[72097] = "Mayag\xfcez";
$f6be72ae2d6fc0cb$var$c[40015] = "Caddo";
$f6be72ae2d6fc0cb$var$c[8059] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[54011] = "Cabell";
$f6be72ae2d6fc0cb$var$c[48383] = "Reagan";
$f6be72ae2d6fc0cb$var$c[5141] = "Van Buren";
$f6be72ae2d6fc0cb$var$c[8117] = "Summit";
$f6be72ae2d6fc0cb$var$c[20035] = "Cowley";
$f6be72ae2d6fc0cb$var$c[5071] = "Johnson";
$f6be72ae2d6fc0cb$var$c[36041] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[51045] = "Craig";
$f6be72ae2d6fc0cb$var$c[48083] = "Coleman";
$f6be72ae2d6fc0cb$var$c[2290] = "Yukon-Koyukuk";
$f6be72ae2d6fc0cb$var$c[4017] = "Navajo";
$f6be72ae2d6fc0cb$var$c[28085] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[48357] = "Ochiltree";
$f6be72ae2d6fc0cb$var$c[48103] = "Crane";
$f6be72ae2d6fc0cb$var$c[56003] = "Big Horn";
$f6be72ae2d6fc0cb$var$c[47081] = "Hickman";
$f6be72ae2d6fc0cb$var$c[28143] = "Tunica";
$f6be72ae2d6fc0cb$var$c[29081] = "Harrison";
$f6be72ae2d6fc0cb$var$c[72029] = "Can\xf3vanas";
$f6be72ae2d6fc0cb$var$c[18005] = "Bartholomew";
$f6be72ae2d6fc0cb$var$c[13223] = "Paulding";
$f6be72ae2d6fc0cb$var$c[39015] = "Brown";
$f6be72ae2d6fc0cb$var$c[47141] = "Putnam";
$f6be72ae2d6fc0cb$var$c[38101] = "Ward";
$f6be72ae2d6fc0cb$var$c[25027] = "Worcester";
$f6be72ae2d6fc0cb$var$c[39091] = "Logan";
$f6be72ae2d6fc0cb$var$c[6031] = "Kings";
$f6be72ae2d6fc0cb$var$c[6073] = "San Diego";
$f6be72ae2d6fc0cb$var$c[72123] = "Salinas";
$f6be72ae2d6fc0cb$var$c[13079] = "Crawford";
$f6be72ae2d6fc0cb$var$c[72103] = "Naguabo";
$f6be72ae2d6fc0cb$var$c[29037] = "Cass";
$f6be72ae2d6fc0cb$var$c[36027] = "Dutchess";
$f6be72ae2d6fc0cb$var$c[48477] = "Washington";
$f6be72ae2d6fc0cb$var$c[8101] = "Pueblo";
$f6be72ae2d6fc0cb$var$c[29067] = "Douglas";
$f6be72ae2d6fc0cb$var$c[38009] = "Bottineau";
$f6be72ae2d6fc0cb$var$c[37051] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[56017] = "Hot Springs";
$f6be72ae2d6fc0cb$var$c[26001] = "Alcona";
$f6be72ae2d6fc0cb$var$c[6061] = "Placer";
$f6be72ae2d6fc0cb$var$c[5129] = "Searcy";
$f6be72ae2d6fc0cb$var$c[48305] = "Lynn";
$f6be72ae2d6fc0cb$var$c[36077] = "Otsego";
$f6be72ae2d6fc0cb$var$c[37153] = "Richmond";
$f6be72ae2d6fc0cb$var$c[37093] = "Hoke";
$f6be72ae2d6fc0cb$var$c[31131] = "Otoe";
$f6be72ae2d6fc0cb$var$c[42023] = "Cameron";
$f6be72ae2d6fc0cb$var$c[45035] = "Dorchester";
$f6be72ae2d6fc0cb$var$c[27161] = "Waseca";
$f6be72ae2d6fc0cb$var$c[46015] = "Brule";
$f6be72ae2d6fc0cb$var$c[47177] = "Warren";
$f6be72ae2d6fc0cb$var$c[17023] = "Clark";
$f6be72ae2d6fc0cb$var$c[21201] = "Robertson";
$f6be72ae2d6fc0cb$var$c[47095] = "Lake";
$f6be72ae2d6fc0cb$var$c[45015] = "Berkeley";
$f6be72ae2d6fc0cb$var$c[5051] = "Garland";
$f6be72ae2d6fc0cb$var$c[20139] = "Osage";
$f6be72ae2d6fc0cb$var$c[39155] = "Trumbull";
$f6be72ae2d6fc0cb$var$c[48333] = "Mills";
$f6be72ae2d6fc0cb$var$c[48359] = "Oldham";
$f6be72ae2d6fc0cb$var$c[42019] = "Butler";
$f6be72ae2d6fc0cb$var$c[16049] = "Idaho";
$f6be72ae2d6fc0cb$var$c[20115] = "Marion";
$f6be72ae2d6fc0cb$var$c[51029] = "Buckingham";
$f6be72ae2d6fc0cb$var$c[37025] = "Cabarrus";
$f6be72ae2d6fc0cb$var$c[29225] = "Webster";
$f6be72ae2d6fc0cb$var$c[49011] = "Davis";
$f6be72ae2d6fc0cb$var$c[27033] = "Cottonwood";
$f6be72ae2d6fc0cb$var$c[12093] = "Okeechobee";
$f6be72ae2d6fc0cb$var$c[13291] = "Union";
$f6be72ae2d6fc0cb$var$c[19013] = "Black Hawk";
$f6be72ae2d6fc0cb$var$c[48403] = "Sabine";
$f6be72ae2d6fc0cb$var$c[39131] = "Pike";
$f6be72ae2d6fc0cb$var$c[1125] = "Tuscaloosa";
$f6be72ae2d6fc0cb$var$c[1131] = "Wilcox";
$f6be72ae2d6fc0cb$var$c[28097] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[31099] = "Kearney";
$f6be72ae2d6fc0cb$var$c[31087] = "Hitchcock";
$f6be72ae2d6fc0cb$var$c[10003] = "New Castle";
$f6be72ae2d6fc0cb$var$c[16081] = "Teton";
$f6be72ae2d6fc0cb$var$c[17161] = "Rock Island";
$f6be72ae2d6fc0cb$var$c[51073] = "Gloucester";
$f6be72ae2d6fc0cb$var$c[5133] = "Sevier";
$f6be72ae2d6fc0cb$var$c[18017] = "Cass";
$f6be72ae2d6fc0cb$var$c[16077] = "Power";
$f6be72ae2d6fc0cb$var$c[18015] = "Carroll";
$f6be72ae2d6fc0cb$var$c[42101] = "Philadelphia";
$f6be72ae2d6fc0cb$var$c[56043] = "Washakie";
$f6be72ae2d6fc0cb$var$c[37029] = "Camden";
$f6be72ae2d6fc0cb$var$c[36109] = "Tompkins";
$f6be72ae2d6fc0cb$var$c[5069] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[5079] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[55123] = "Vernon";
$f6be72ae2d6fc0cb$var$c[29093] = "Iron";
$f6be72ae2d6fc0cb$var$c[48223] = "Hopkins";
$f6be72ae2d6fc0cb$var$c[36001] = "Albany";
$f6be72ae2d6fc0cb$var$c[48225] = "Houston";
$f6be72ae2d6fc0cb$var$c[39111] = "Monroe";
$f6be72ae2d6fc0cb$var$c[20165] = "Rush";
$f6be72ae2d6fc0cb$var$c[18107] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[20187] = "Stanton";
$f6be72ae2d6fc0cb$var$c[21129] = "Lee";
$f6be72ae2d6fc0cb$var$c[27071] = "Koochiching";
$f6be72ae2d6fc0cb$var$c[48029] = "Bexar";
$f6be72ae2d6fc0cb$var$c[8013] = "Boulder";
$f6be72ae2d6fc0cb$var$c[47089] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[40097] = "Mayes";
$f6be72ae2d6fc0cb$var$c[27165] = "Watonwan";
$f6be72ae2d6fc0cb$var$c[16013] = "Blaine";
$f6be72ae2d6fc0cb$var$c[22053] = "Jefferson Davis";
$f6be72ae2d6fc0cb$var$c[46119] = "Sully";
$f6be72ae2d6fc0cb$var$c[8031] = "Denver";
$f6be72ae2d6fc0cb$var$c[40029] = "Coal";
$f6be72ae2d6fc0cb$var$c[30011] = "Carter";
$f6be72ae2d6fc0cb$var$c[48461] = "Upton";
$f6be72ae2d6fc0cb$var$c[18051] = "Gibson";
$f6be72ae2d6fc0cb$var$c[31105] = "Kimball";
$f6be72ae2d6fc0cb$var$c[17093] = "Kendall";
$f6be72ae2d6fc0cb$var$c[11001] = "District of Columbia";
$f6be72ae2d6fc0cb$var$c[8085] = "Montrose";
$f6be72ae2d6fc0cb$var$c[27171] = "Wright";
$f6be72ae2d6fc0cb$var$c[55059] = "Kenosha";
$f6be72ae2d6fc0cb$var$c[8037] = "Eagle";
$f6be72ae2d6fc0cb$var$c[6075] = "San Francisco";
$f6be72ae2d6fc0cb$var$c[8113] = "San Miguel";
$f6be72ae2d6fc0cb$var$c[2020] = "Anchorage";
$f6be72ae2d6fc0cb$var$c[12109] = "St. Johns";
$f6be72ae2d6fc0cb$var$c[28019] = "Choctaw";
$f6be72ae2d6fc0cb$var$c[29079] = "Grundy";
$f6be72ae2d6fc0cb$var$c[26085] = "Lake";
$f6be72ae2d6fc0cb$var$c[26139] = "Ottawa";
$f6be72ae2d6fc0cb$var$c[17031] = "Cook";
$f6be72ae2d6fc0cb$var$c[17059] = "Gallatin";
$f6be72ae2d6fc0cb$var$c[45047] = "Greenwood";
$f6be72ae2d6fc0cb$var$c[20059] = "Franklin";
$f6be72ae2d6fc0cb$var$c[27027] = "Clay";
$f6be72ae2d6fc0cb$var$c[47075] = "Haywood";
$f6be72ae2d6fc0cb$var$c[49003] = "Box Elder";
$f6be72ae2d6fc0cb$var$c[28139] = "Tippah";
$f6be72ae2d6fc0cb$var$c[54051] = "Marshall";
$f6be72ae2d6fc0cb$var$c[54035] = "Jackson";
$f6be72ae2d6fc0cb$var$c[16039] = "Elmore";
$f6be72ae2d6fc0cb$var$c[24005] = "Baltimore";
$f6be72ae2d6fc0cb$var$c[38005] = "Benson";
$f6be72ae2d6fc0cb$var$c[29163] = "Pike";
$f6be72ae2d6fc0cb$var$c[39087] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[29201] = "Scott";
$f6be72ae2d6fc0cb$var$c[39001] = "Adams";
$f6be72ae2d6fc0cb$var$c[48143] = "Erath";
$f6be72ae2d6fc0cb$var$c[13137] = "Habersham";
$f6be72ae2d6fc0cb$var$c[13319] = "Wilkinson";
$f6be72ae2d6fc0cb$var$c[54061] = "Monongalia";
$f6be72ae2d6fc0cb$var$c[39033] = "Crawford";
$f6be72ae2d6fc0cb$var$c[12027] = "DeSoto";
$f6be72ae2d6fc0cb$var$c[9011] = "New London";
$f6be72ae2d6fc0cb$var$c[39059] = "Guernsey";
$f6be72ae2d6fc0cb$var$c[26015] = "Barry";
$f6be72ae2d6fc0cb$var$c[29209] = "Stone";
$f6be72ae2d6fc0cb$var$c[51760] = "Richmond";
$f6be72ae2d6fc0cb$var$c[37169] = "Stokes";
$f6be72ae2d6fc0cb$var$c[19039] = "Clarke";
$f6be72ae2d6fc0cb$var$c[19065] = "Fayette";
$f6be72ae2d6fc0cb$var$c[6041] = "Marin";
$f6be72ae2d6fc0cb$var$c[48381] = "Randall";
$f6be72ae2d6fc0cb$var$c[48401] = "Rusk";
$f6be72ae2d6fc0cb$var$c[19181] = "Warren";
$f6be72ae2d6fc0cb$var$c[39161] = "Van Wert";
$f6be72ae2d6fc0cb$var$c[12043] = "Glades";
$f6be72ae2d6fc0cb$var$c[13199] = "Meriwether";
$f6be72ae2d6fc0cb$var$c[8023] = "Costilla";
$f6be72ae2d6fc0cb$var$c[48099] = "Coryell";
$f6be72ae2d6fc0cb$var$c[19001] = "Adair";
$f6be72ae2d6fc0cb$var$c[13053] = "Chattahoochee";
$f6be72ae2d6fc0cb$var$c[6043] = "Mariposa";
$f6be72ae2d6fc0cb$var$c[29089] = "Howard";
$f6be72ae2d6fc0cb$var$c[41047] = "Marion";
$f6be72ae2d6fc0cb$var$c[55079] = "Milwaukee";
$f6be72ae2d6fc0cb$var$c[27139] = "Scott";
$f6be72ae2d6fc0cb$var$c[39129] = "Pickaway";
$f6be72ae2d6fc0cb$var$c[51145] = "Powhatan";
$f6be72ae2d6fc0cb$var$c[8014] = "Broomfield";
$f6be72ae2d6fc0cb$var$c[47099] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[26009] = "Antrim";
$f6be72ae2d6fc0cb$var$c[45069] = "Marlboro";
$f6be72ae2d6fc0cb$var$c[16009] = "Benewah";
$f6be72ae2d6fc0cb$var$c[17103] = "Lee";
$f6be72ae2d6fc0cb$var$c[31127] = "Nemaha";
$f6be72ae2d6fc0cb$var$c[37031] = "Carteret";
$f6be72ae2d6fc0cb$var$c[20149] = "Pottawatomie";
$f6be72ae2d6fc0cb$var$c[26075] = "Jackson";
$f6be72ae2d6fc0cb$var$c[48091] = "Comal";
$f6be72ae2d6fc0cb$var$c[25019] = "Nantucket";
$f6be72ae2d6fc0cb$var$c[45009] = "Bamberg";
$f6be72ae2d6fc0cb$var$c[48007] = "Aransas";
$f6be72ae2d6fc0cb$var$c[13019] = "Berrien";
$f6be72ae2d6fc0cb$var$c[18165] = "Vermillion";
$f6be72ae2d6fc0cb$var$c[26143] = "Roscommon";
$f6be72ae2d6fc0cb$var$c[37005] = "Alleghany";
$f6be72ae2d6fc0cb$var$c[6035] = "Lassen";
$f6be72ae2d6fc0cb$var$c[51610] = "Falls Church";
$f6be72ae2d6fc0cb$var$c[12081] = "Manatee";
$f6be72ae2d6fc0cb$var$c[39119] = "Muskingum";
$f6be72ae2d6fc0cb$var$c[8015] = "Chaffee";
$f6be72ae2d6fc0cb$var$c[8025] = "Crowley";
$f6be72ae2d6fc0cb$var$c[8043] = "Fremont";
$f6be72ae2d6fc0cb$var$c[28109] = "Pearl River";
$f6be72ae2d6fc0cb$var$c[28111] = "Perry";
$f6be72ae2d6fc0cb$var$c[31041] = "Custer";
$f6be72ae2d6fc0cb$var$c[12013] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[21117] = "Kenton";
$f6be72ae2d6fc0cb$var$c[19037] = "Chickasaw";
$f6be72ae2d6fc0cb$var$c[17037] = "DeKalb";
$f6be72ae2d6fc0cb$var$c[19081] = "Hancock";
$f6be72ae2d6fc0cb$var$c[38089] = "Stark";
$f6be72ae2d6fc0cb$var$c[26095] = "Luce";
$f6be72ae2d6fc0cb$var$c[40019] = "Carter";
$f6be72ae2d6fc0cb$var$c[37139] = "Pasquotank";
$f6be72ae2d6fc0cb$var$c[35055] = "Taos";
$f6be72ae2d6fc0cb$var$c[28011] = "Bolivar";
$f6be72ae2d6fc0cb$var$c[32023] = "Nye";
$f6be72ae2d6fc0cb$var$c[47073] = "Hawkins";
$f6be72ae2d6fc0cb$var$c[38011] = "Bowman";
$f6be72ae2d6fc0cb$var$c[42057] = "Fulton";
$f6be72ae2d6fc0cb$var$c[22055] = "Lafayette";
$f6be72ae2d6fc0cb$var$c[48237] = "Jack";
$f6be72ae2d6fc0cb$var$c[17175] = "Stark";
$f6be72ae2d6fc0cb$var$c[40055] = "Greer";
$f6be72ae2d6fc0cb$var$c[48211] = "Hemphill";
$f6be72ae2d6fc0cb$var$c[16069] = "Nez Perce";
$f6be72ae2d6fc0cb$var$c[46129] = "Walworth";
$f6be72ae2d6fc0cb$var$c[6055] = "Napa";
$f6be72ae2d6fc0cb$var$c[40033] = "Cotton";
$f6be72ae2d6fc0cb$var$c[29221] = "Washington";
$f6be72ae2d6fc0cb$var$c[36011] = "Cayuga";
$f6be72ae2d6fc0cb$var$c[48417] = "Shackelford";
$f6be72ae2d6fc0cb$var$c[48407] = "San Jacinto";
$f6be72ae2d6fc0cb$var$c[19061] = "Dubuque";
$f6be72ae2d6fc0cb$var$c[51075] = "Goochland";
$f6be72ae2d6fc0cb$var$c[20181] = "Sherman";
$f6be72ae2d6fc0cb$var$c[39139] = "Richland";
$f6be72ae2d6fc0cb$var$c[17001] = "Adams";
$f6be72ae2d6fc0cb$var$c[39021] = "Champaign";
$f6be72ae2d6fc0cb$var$c[33019] = "Sullivan";
$f6be72ae2d6fc0cb$var$c[17075] = "Iroquois";
$f6be72ae2d6fc0cb$var$c[19157] = "Poweshiek";
$f6be72ae2d6fc0cb$var$c[39169] = "Wayne";
$f6be72ae2d6fc0cb$var$c[13113] = "Fayette";
$f6be72ae2d6fc0cb$var$c[13141] = "Hancock";
$f6be72ae2d6fc0cb$var$c[48259] = "Kendall";
$f6be72ae2d6fc0cb$var$c[36039] = "Greene";
$f6be72ae2d6fc0cb$var$c[51137] = "Orange";
$f6be72ae2d6fc0cb$var$c[40089] = "McCurtain";
$f6be72ae2d6fc0cb$var$c[13277] = "Tift";
$f6be72ae2d6fc0cb$var$c[31025] = "Cass";
$f6be72ae2d6fc0cb$var$c[46077] = "Kingsbury";
$f6be72ae2d6fc0cb$var$c[56009] = "Converse";
$f6be72ae2d6fc0cb$var$c[36043] = "Herkimer";
$f6be72ae2d6fc0cb$var$c[38047] = "Logan";
$f6be72ae2d6fc0cb$var$c[26053] = "Gogebic";
$f6be72ae2d6fc0cb$var$c[27005] = "Becker";
$f6be72ae2d6fc0cb$var$c[1095] = "Marshall";
$f6be72ae2d6fc0cb$var$c[47173] = "Union";
$f6be72ae2d6fc0cb$var$c[54057] = "Mineral";
$f6be72ae2d6fc0cb$var$c[55003] = "Ashland";
$f6be72ae2d6fc0cb$var$c[17053] = "Ford";
$f6be72ae2d6fc0cb$var$c[38029] = "Emmons";
$f6be72ae2d6fc0cb$var$c[6089] = "Shasta";
$f6be72ae2d6fc0cb$var$c[22113] = "Vermilion";
$f6be72ae2d6fc0cb$var$c[5121] = "Randolph";
$f6be72ae2d6fc0cb$var$c[55085] = "Oneida";
$f6be72ae2d6fc0cb$var$c[22035] = "East Carroll";
$f6be72ae2d6fc0cb$var$c[22037] = "East Feliciana";
$f6be72ae2d6fc0cb$var$c[22087] = "St. Bernard";
$f6be72ae2d6fc0cb$var$c[48481] = "Wharton";
$f6be72ae2d6fc0cb$var$c[2198] = "Prince of Wales-Hyder";
$f6be72ae2d6fc0cb$var$c[2195] = "Petersburg";
$f6be72ae2d6fc0cb$var$c[48153] = "Floyd";
$f6be72ae2d6fc0cb$var$c[2275] = "Wrangell";
$f6be72ae2d6fc0cb$var$c[21151] = "Madison";
$f6be72ae2d6fc0cb$var$c[47009] = "Blount";
$f6be72ae2d6fc0cb$var$c[30031] = "Gallatin";
$f6be72ae2d6fc0cb$var$c[45031] = "Darlington";
$f6be72ae2d6fc0cb$var$c[1053] = "Escambia";
$f6be72ae2d6fc0cb$var$c[13143] = "Haralson";
$f6be72ae2d6fc0cb$var$c[20001] = "Allen";
$f6be72ae2d6fc0cb$var$c[17041] = "Douglas";
$f6be72ae2d6fc0cb$var$c[51079] = "Greene";
$f6be72ae2d6fc0cb$var$c[66010] = "Guam";
$f6be72ae2d6fc0cb$var$c[55137] = "Waushara";
$f6be72ae2d6fc0cb$var$c[5065] = "Izard";
$f6be72ae2d6fc0cb$var$c[6053] = "Monterey";
$f6be72ae2d6fc0cb$var$c[35017] = "Grant";
$f6be72ae2d6fc0cb$var$c[29131] = "Miller";
$f6be72ae2d6fc0cb$var$c[37193] = "Wilkes";
$f6be72ae2d6fc0cb$var$c[2110] = "Juneau";
$f6be72ae2d6fc0cb$var$c[29165] = "Platte";
$f6be72ae2d6fc0cb$var$c[29021] = "Buchanan";
$f6be72ae2d6fc0cb$var$c[1083] = "Limestone";
$f6be72ae2d6fc0cb$var$c[18065] = "Henry";
$f6be72ae2d6fc0cb$var$c[31143] = "Polk";
$f6be72ae2d6fc0cb$var$c[39123] = "Ottawa";
$f6be72ae2d6fc0cb$var$c[27107] = "Norman";
$f6be72ae2d6fc0cb$var$c[19165] = "Shelby";
$f6be72ae2d6fc0cb$var$c[24013] = "Carroll";
$f6be72ae2d6fc0cb$var$c[19011] = "Benton";
$f6be72ae2d6fc0cb$var$c[21159] = "Martin";
$f6be72ae2d6fc0cb$var$c[27025] = "Chisago";
$f6be72ae2d6fc0cb$var$c[21189] = "Owsley";
$f6be72ae2d6fc0cb$var$c[42015] = "Bradford";
$f6be72ae2d6fc0cb$var$c[54029] = "Hancock";
$f6be72ae2d6fc0cb$var$c[29051] = "Cole";
$f6be72ae2d6fc0cb$var$c[26021] = "Berrien";
$f6be72ae2d6fc0cb$var$c[42061] = "Huntingdon";
$f6be72ae2d6fc0cb$var$c[31045] = "Dawes";
$f6be72ae2d6fc0cb$var$c[51141] = "Patrick";
$f6be72ae2d6fc0cb$var$c[26119] = "Montmorency";
$f6be72ae2d6fc0cb$var$c[26135] = "Oscoda";
$f6be72ae2d6fc0cb$var$c[35007] = "Colfax";
$f6be72ae2d6fc0cb$var$c[17163] = "St. Clair";
$f6be72ae2d6fc0cb$var$c[17189] = "Washington";
$f6be72ae2d6fc0cb$var$c[42009] = "Bedford";
$f6be72ae2d6fc0cb$var$c[5127] = "Scott";
$f6be72ae2d6fc0cb$var$c[20099] = "Labette";
$f6be72ae2d6fc0cb$var$c[42073] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[39067] = "Harrison";
$f6be72ae2d6fc0cb$var$c[37003] = "Alexander";
$f6be72ae2d6fc0cb$var$c[34009] = "Cape May";
$f6be72ae2d6fc0cb$var$c[33005] = "Cheshire";
$f6be72ae2d6fc0cb$var$c[27089] = "Marshall";
$f6be72ae2d6fc0cb$var$c[51101] = "King William";
$f6be72ae2d6fc0cb$var$c[8055] = "Huerfano";
$f6be72ae2d6fc0cb$var$c[48255] = "Karnes";
$f6be72ae2d6fc0cb$var$c[47023] = "Chester";
$f6be72ae2d6fc0cb$var$c[17171] = "Scott";
$f6be72ae2d6fc0cb$var$c[49027] = "Millard";
$f6be72ae2d6fc0cb$var$c[49029] = "Morgan";
$f6be72ae2d6fc0cb$var$c[48257] = "Kaufman";
$f6be72ae2d6fc0cb$var$c[4011] = "Greenlee";
$f6be72ae2d6fc0cb$var$c[4013] = "Maricopa";
$f6be72ae2d6fc0cb$var$c[26129] = "Ogemaw";
$f6be72ae2d6fc0cb$var$c[47087] = "Jackson";
$f6be72ae2d6fc0cb$var$c[17159] = "Richland";
$f6be72ae2d6fc0cb$var$c[1009] = "Blount";
$f6be72ae2d6fc0cb$var$c[30051] = "Liberty";
$f6be72ae2d6fc0cb$var$c[48131] = "Duval";
$f6be72ae2d6fc0cb$var$c[29173] = "Ralls";
$f6be72ae2d6fc0cb$var$c[48251] = "Johnson";
$f6be72ae2d6fc0cb$var$c[13061] = "Clay";
$f6be72ae2d6fc0cb$var$c[41023] = "Grant";
$f6be72ae2d6fc0cb$var$c[41011] = "Coos";
$f6be72ae2d6fc0cb$var$c[48159] = "Franklin";
$f6be72ae2d6fc0cb$var$c[36113] = "Warren";
$f6be72ae2d6fc0cb$var$c[51113] = "Madison";
$f6be72ae2d6fc0cb$var$c[40005] = "Atoka";
$f6be72ae2d6fc0cb$var$c[17129] = "Menard";
$f6be72ae2d6fc0cb$var$c[13015] = "Bartow";
$f6be72ae2d6fc0cb$var$c[12069] = "Lake";
$f6be72ae2d6fc0cb$var$c[40111] = "Okmulgee";
$f6be72ae2d6fc0cb$var$c[38083] = "Sheridan";
$f6be72ae2d6fc0cb$var$c[18049] = "Fulton";
$f6be72ae2d6fc0cb$var$c[20091] = "Johnson";
$f6be72ae2d6fc0cb$var$c[24009] = "Calvert";
$f6be72ae2d6fc0cb$var$c[55129] = "Washburn";
$f6be72ae2d6fc0cb$var$c[53031] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[72003] = "Aguada";
$f6be72ae2d6fc0cb$var$c[27169] = "Winona";
$f6be72ae2d6fc0cb$var$c[28149] = "Warren";
$f6be72ae2d6fc0cb$var$c[29003] = "Andrew";
$f6be72ae2d6fc0cb$var$c[29139] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[20021] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[37083] = "Halifax";
$f6be72ae2d6fc0cb$var$c[35043] = "Sandoval";
$f6be72ae2d6fc0cb$var$c[21051] = "Clay";
$f6be72ae2d6fc0cb$var$c[42035] = "Clinton";
$f6be72ae2d6fc0cb$var$c[41043] = "Linn";
$f6be72ae2d6fc0cb$var$c[55065] = "Lafayette";
$f6be72ae2d6fc0cb$var$c[40147] = "Washington";
$f6be72ae2d6fc0cb$var$c[54077] = "Preston";
$f6be72ae2d6fc0cb$var$c[69100] = "Rota";
$f6be72ae2d6fc0cb$var$c[55135] = "Waupaca";
$f6be72ae2d6fc0cb$var$c[48137] = "Edwards";
$f6be72ae2d6fc0cb$var$c[41037] = "Lake";
$f6be72ae2d6fc0cb$var$c[29153] = "Ozark";
$f6be72ae2d6fc0cb$var$c[48473] = "Waller";
$f6be72ae2d6fc0cb$var$c[1099] = "Monroe";
$f6be72ae2d6fc0cb$var$c[50009] = "Essex";
$f6be72ae2d6fc0cb$var$c[51111] = "Lunenburg";
$f6be72ae2d6fc0cb$var$c[38097] = "Traill";
$f6be72ae2d6fc0cb$var$c[13139] = "Hall";
$f6be72ae2d6fc0cb$var$c[13283] = "Treutlen";
$f6be72ae2d6fc0cb$var$c[13037] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[55125] = "Vilas";
$f6be72ae2d6fc0cb$var$c[27007] = "Beltrami";
$f6be72ae2d6fc0cb$var$c[72043] = "Coamo";
$f6be72ae2d6fc0cb$var$c[72055] = "Gu\xe1nica";
$f6be72ae2d6fc0cb$var$c[24019] = "Dorchester";
$f6be72ae2d6fc0cb$var$c[42037] = "Columbia";
$f6be72ae2d6fc0cb$var$c[39023] = "Clark";
$f6be72ae2d6fc0cb$var$c[48323] = "Maverick";
$f6be72ae2d6fc0cb$var$c[4019] = "Pima";
$f6be72ae2d6fc0cb$var$c[35006] = "Cibola";
$f6be72ae2d6fc0cb$var$c[34005] = "Burlington";
$f6be72ae2d6fc0cb$var$c[50021] = "Rutland";
$f6be72ae2d6fc0cb$var$c[13099] = "Early";
$f6be72ae2d6fc0cb$var$c[25007] = "Dukes";
$f6be72ae2d6fc0cb$var$c[38049] = "McHenry";
$f6be72ae2d6fc0cb$var$c[31179] = "Wayne";
$f6be72ae2d6fc0cb$var$c[38045] = "LaMoure";
$f6be72ae2d6fc0cb$var$c[16023] = "Butte";
$f6be72ae2d6fc0cb$var$c[33007] = "Coos";
$f6be72ae2d6fc0cb$var$c[38043] = "Kidder";
$f6be72ae2d6fc0cb$var$c[48273] = "Kleberg";
$f6be72ae2d6fc0cb$var$c[18127] = "Porter";
$f6be72ae2d6fc0cb$var$c[28101] = "Newton";
$f6be72ae2d6fc0cb$var$c[37163] = "Sampson";
$f6be72ae2d6fc0cb$var$c[47127] = "Moore";
$f6be72ae2d6fc0cb$var$c[12103] = "Pinellas";
$f6be72ae2d6fc0cb$var$c[72019] = "Barranquitas";
$f6be72ae2d6fc0cb$var$c[17065] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[5105] = "Perry";
$f6be72ae2d6fc0cb$var$c[20023] = "Cheyenne";
$f6be72ae2d6fc0cb$var$c[8029] = "Delta";
$f6be72ae2d6fc0cb$var$c[19185] = "Wayne";
$f6be72ae2d6fc0cb$var$c[48165] = "Gaines";
$f6be72ae2d6fc0cb$var$c[1093] = "Marion";
$f6be72ae2d6fc0cb$var$c[37189] = "Watauga";
$f6be72ae2d6fc0cb$var$c[51770] = "Roanoke";
$f6be72ae2d6fc0cb$var$c[48317] = "Martin";
$f6be72ae2d6fc0cb$var$c[48037] = "Bowie";
$f6be72ae2d6fc0cb$var$c[49057] = "Weber";
$f6be72ae2d6fc0cb$var$c[29127] = "Marion";
$f6be72ae2d6fc0cb$var$c[36045] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[19097] = "Jackson";
$f6be72ae2d6fc0cb$var$c[38063] = "Nelson";
$f6be72ae2d6fc0cb$var$c[36019] = "Clinton";
$f6be72ae2d6fc0cb$var$c[8045] = "Garfield";
$f6be72ae2d6fc0cb$var$c[29177] = "Ray";
$f6be72ae2d6fc0cb$var$c[39073] = "Hocking";
$f6be72ae2d6fc0cb$var$c[1085] = "Lowndes";
$f6be72ae2d6fc0cb$var$c[13043] = "Candler";
$f6be72ae2d6fc0cb$var$c[19113] = "Linn";
$f6be72ae2d6fc0cb$var$c[6105] = "Trinity";
$f6be72ae2d6fc0cb$var$c[13215] = "Muscogee";
$f6be72ae2d6fc0cb$var$c[28135] = "Tallahatchie";
$f6be72ae2d6fc0cb$var$c[20005] = "Atchison";
$f6be72ae2d6fc0cb$var$c[72081] = "Lares";
$f6be72ae2d6fc0cb$var$c[48003] = "Andrews";
$f6be72ae2d6fc0cb$var$c[39109] = "Miami";
$f6be72ae2d6fc0cb$var$c[48375] = "Potter";
$f6be72ae2d6fc0cb$var$c[40133] = "Seminole";
$f6be72ae2d6fc0cb$var$c[45003] = "Aiken";
$f6be72ae2d6fc0cb$var$c[60020] = "Manu'a";
$f6be72ae2d6fc0cb$var$c[6045] = "Mendocino";
$f6be72ae2d6fc0cb$var$c[51550] = "Chesapeake";
$f6be72ae2d6fc0cb$var$c[69120] = "Tinian";
$f6be72ae2d6fc0cb$var$c[72153] = "Yauco";
$f6be72ae2d6fc0cb$var$c[56037] = "Sweetwater";
$f6be72ae2d6fc0cb$var$c[48169] = "Garza";
$f6be72ae2d6fc0cb$var$c[54031] = "Hardy";
$f6be72ae2d6fc0cb$var$c[72001] = "Adjuntas";
$f6be72ae2d6fc0cb$var$c[55089] = "Ozaukee";
$f6be72ae2d6fc0cb$var$c[47163] = "Sullivan";
$f6be72ae2d6fc0cb$var$c[45059] = "Laurens";
$f6be72ae2d6fc0cb$var$c[56011] = "Crook";
$f6be72ae2d6fc0cb$var$c[55117] = "Sheboygan";
$f6be72ae2d6fc0cb$var$c[25013] = "Hampden";
$f6be72ae2d6fc0cb$var$c[48055] = "Caldwell";
$f6be72ae2d6fc0cb$var$c[20029] = "Cloud";
$f6be72ae2d6fc0cb$var$c[6027] = "Inyo";
$f6be72ae2d6fc0cb$var$c[1037] = "Coosa";
$f6be72ae2d6fc0cb$var$c[19059] = "Dickinson";
$f6be72ae2d6fc0cb$var$c[21095] = "Harlan";
$f6be72ae2d6fc0cb$var$c[20061] = "Geary";
$f6be72ae2d6fc0cb$var$c[42011] = "Berks";
$f6be72ae2d6fc0cb$var$c[47019] = "Carter";
$f6be72ae2d6fc0cb$var$c[27083] = "Lyon";
$f6be72ae2d6fc0cb$var$c[51037] = "Charlotte";
$f6be72ae2d6fc0cb$var$c[47179] = "Washington";
$f6be72ae2d6fc0cb$var$c[45071] = "Newberry";
$f6be72ae2d6fc0cb$var$c[51093] = "Isle of Wight";
$f6be72ae2d6fc0cb$var$c[41069] = "Wheeler";
$f6be72ae2d6fc0cb$var$c[29023] = "Butler";
$f6be72ae2d6fc0cb$var$c[22047] = "Iberville";
$f6be72ae2d6fc0cb$var$c[28125] = "Sharkey";
$f6be72ae2d6fc0cb$var$c[51061] = "Fauquier";
$f6be72ae2d6fc0cb$var$c[51750] = "Radford";
$f6be72ae2d6fc0cb$var$c[32005] = "Douglas";
$f6be72ae2d6fc0cb$var$c[12037] = "Franklin";
$f6be72ae2d6fc0cb$var$c[18055] = "Greene";
$f6be72ae2d6fc0cb$var$c[18139] = "Rush";
$f6be72ae2d6fc0cb$var$c[55131] = "Washington";
$f6be72ae2d6fc0cb$var$c[29105] = "Laclede";
$f6be72ae2d6fc0cb$var$c[42085] = "Mercer";
$f6be72ae2d6fc0cb$var$c[5031] = "Craighead";
$f6be72ae2d6fc0cb$var$c[29195] = "Saline";
$f6be72ae2d6fc0cb$var$c[17193] = "White";
$f6be72ae2d6fc0cb$var$c[17039] = "De Witt";
$f6be72ae2d6fc0cb$var$c[32033] = "White Pine";
$f6be72ae2d6fc0cb$var$c[27049] = "Goodhue";
$f6be72ae2d6fc0cb$var$c[37173] = "Swain";
$f6be72ae2d6fc0cb$var$c[12101] = "Pasco";
$f6be72ae2d6fc0cb$var$c[12119] = "Sumter";
$f6be72ae2d6fc0cb$var$c[36059] = "Nassau";
$f6be72ae2d6fc0cb$var$c[38091] = "Steele";
$f6be72ae2d6fc0cb$var$c[18163] = "Vanderburgh";
$f6be72ae2d6fc0cb$var$c[29071] = "Franklin";
$f6be72ae2d6fc0cb$var$c[37011] = "Avery";
$f6be72ae2d6fc0cb$var$c[54107] = "Wood";
$f6be72ae2d6fc0cb$var$c[55007] = "Bayfield";
$f6be72ae2d6fc0cb$var$c[47161] = "Stewart";
$f6be72ae2d6fc0cb$var$c[55097] = "Portage";
$f6be72ae2d6fc0cb$var$c[45063] = "Lexington";
$f6be72ae2d6fc0cb$var$c[24003] = "Anne Arundel";
$f6be72ae2d6fc0cb$var$c[55039] = "Fond du Lac";
$f6be72ae2d6fc0cb$var$c[54101] = "Webster";
$f6be72ae2d6fc0cb$var$c[55061] = "Kewaunee";
$f6be72ae2d6fc0cb$var$c[48369] = "Parmer";
$f6be72ae2d6fc0cb$var$c[40151] = "Woods";
$f6be72ae2d6fc0cb$var$c[21063] = "Elliott";
$f6be72ae2d6fc0cb$var$c[25003] = "Berkshire";
$f6be72ae2d6fc0cb$var$c[29041] = "Chariton";
$f6be72ae2d6fc0cb$var$c[8103] = "Rio Blanco";
$f6be72ae2d6fc0cb$var$c[8087] = "Morgan";
$f6be72ae2d6fc0cb$var$c[41045] = "Malheur";
$f6be72ae2d6fc0cb$var$c[34023] = "Middlesex";
$f6be72ae2d6fc0cb$var$c[20167] = "Russell";
$f6be72ae2d6fc0cb$var$c[17155] = "Putnam";
$f6be72ae2d6fc0cb$var$c[46055] = "Haakon";
$f6be72ae2d6fc0cb$var$c[47111] = "Macon";
$f6be72ae2d6fc0cb$var$c[5023] = "Cleburne";
$f6be72ae2d6fc0cb$var$c[1109] = "Pike";
$f6be72ae2d6fc0cb$var$c[16003] = "Adams";
$f6be72ae2d6fc0cb$var$c[25005] = "Bristol";
$f6be72ae2d6fc0cb$var$c[42107] = "Schuylkill";
$f6be72ae2d6fc0cb$var$c[38103] = "Wells";
$f6be72ae2d6fc0cb$var$c[37045] = "Cleveland";
$f6be72ae2d6fc0cb$var$c[5059] = "Hot Spring";
$f6be72ae2d6fc0cb$var$c[24021] = "Frederick";
$f6be72ae2d6fc0cb$var$c[17169] = "Schuyler";
$f6be72ae2d6fc0cb$var$c[6051] = "Mono";
$f6be72ae2d6fc0cb$var$c[6109] = "Tuolumne";
$f6be72ae2d6fc0cb$var$c[35013] = "Do\xf1a Ana";
$f6be72ae2d6fc0cb$var$c[13081] = "Crisp";
$f6be72ae2d6fc0cb$var$c[5027] = "Columbia";
$f6be72ae2d6fc0cb$var$c[38039] = "Griggs";
$f6be72ae2d6fc0cb$var$c[6095] = "Solano";
$f6be72ae2d6fc0cb$var$c[19043] = "Clayton";
$f6be72ae2d6fc0cb$var$c[48449] = "Titus";
$f6be72ae2d6fc0cb$var$c[54027] = "Hampshire";
$f6be72ae2d6fc0cb$var$c[37125] = "Moore";
$f6be72ae2d6fc0cb$var$c[20009] = "Barton";
$f6be72ae2d6fc0cb$var$c[38087] = "Slope";
$f6be72ae2d6fc0cb$var$c[22083] = "Richland";
$f6be72ae2d6fc0cb$var$c[31071] = "Garfield";
$f6be72ae2d6fc0cb$var$c[22099] = "St. Martin";
$f6be72ae2d6fc0cb$var$c[1119] = "Sumter";
$f6be72ae2d6fc0cb$var$c[1133] = "Winston";
$f6be72ae2d6fc0cb$var$c[12117] = "Seminole";
$f6be72ae2d6fc0cb$var$c[28035] = "Forrest";
$f6be72ae2d6fc0cb$var$c[26065] = "Ingham";
$f6be72ae2d6fc0cb$var$c[20177] = "Shawnee";
$f6be72ae2d6fc0cb$var$c[46061] = "Hanson";
$f6be72ae2d6fc0cb$var$c[27061] = "Itasca";
$f6be72ae2d6fc0cb$var$c[8073] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[36053] = "Madison";
$f6be72ae2d6fc0cb$var$c[36115] = "Washington";
$f6be72ae2d6fc0cb$var$c[18081] = "Johnson";
$f6be72ae2d6fc0cb$var$c[48445] = "Terry";
$f6be72ae2d6fc0cb$var$c[35021] = "Harding";
$f6be72ae2d6fc0cb$var$c[1121] = "Talladega";
$f6be72ae2d6fc0cb$var$c[55067] = "Langlade";
$f6be72ae2d6fc0cb$var$c[48155] = "Foard";
$f6be72ae2d6fc0cb$var$c[19021] = "Buena Vista";
$f6be72ae2d6fc0cb$var$c[19129] = "Mills";
$f6be72ae2d6fc0cb$var$c[48385] = "Real";
$f6be72ae2d6fc0cb$var$c[39041] = "Delaware";
$f6be72ae2d6fc0cb$var$c[37067] = "Forsyth";
$f6be72ae2d6fc0cb$var$c[32510] = "Carson City";
$f6be72ae2d6fc0cb$var$c[19049] = "Dallas";
$f6be72ae2d6fc0cb$var$c[48065] = "Carson";
$f6be72ae2d6fc0cb$var$c[13261] = "Sumter";
$f6be72ae2d6fc0cb$var$c[29223] = "Wayne";
$f6be72ae2d6fc0cb$var$c[45007] = "Anderson";
$f6be72ae2d6fc0cb$var$c[56007] = "Carbon";
$f6be72ae2d6fc0cb$var$c[30093] = "Silver Bow";
$f6be72ae2d6fc0cb$var$c[17177] = "Stephenson";
$f6be72ae2d6fc0cb$var$c[26087] = "Lapeer";
$f6be72ae2d6fc0cb$var$c[22027] = "Claiborne";
$f6be72ae2d6fc0cb$var$c[28161] = "Yalobusha";
$f6be72ae2d6fc0cb$var$c[72093] = "Maricao";
$f6be72ae2d6fc0cb$var$c[26079] = "Kalkaska";
$f6be72ae2d6fc0cb$var$c[72005] = "Aguadilla";
$f6be72ae2d6fc0cb$var$c[22039] = "Evangeline";
$f6be72ae2d6fc0cb$var$c[47069] = "Hardeman";
$f6be72ae2d6fc0cb$var$c[4003] = "Cochise";
$f6be72ae2d6fc0cb$var$c[35023] = "Hidalgo";
$f6be72ae2d6fc0cb$var$c[38023] = "Divide";
$f6be72ae2d6fc0cb$var$c[6071] = "San Bernardino";
$f6be72ae2d6fc0cb$var$c[8083] = "Montezuma";
$f6be72ae2d6fc0cb$var$c[28023] = "Clarke";
$f6be72ae2d6fc0cb$var$c[19125] = "Marion";
$f6be72ae2d6fc0cb$var$c[31055] = "Douglas";
$f6be72ae2d6fc0cb$var$c[51600] = "Fairfax";
$f6be72ae2d6fc0cb$var$c[40057] = "Harmon";
$f6be72ae2d6fc0cb$var$c[29039] = "Cedar";
$f6be72ae2d6fc0cb$var$c[13059] = "Clarke";
$f6be72ae2d6fc0cb$var$c[16085] = "Valley";
$f6be72ae2d6fc0cb$var$c[48275] = "Knox";
$f6be72ae2d6fc0cb$var$c[5103] = "Ouachita";
$f6be72ae2d6fc0cb$var$c[39037] = "Darke";
$f6be72ae2d6fc0cb$var$c[40071] = "Kay";
$f6be72ae2d6fc0cb$var$c[46041] = "Dewey";
$f6be72ae2d6fc0cb$var$c[41057] = "Tillamook";
$f6be72ae2d6fc0cb$var$c[13077] = "Coweta";
$f6be72ae2d6fc0cb$var$c[28127] = "Simpson";
$f6be72ae2d6fc0cb$var$c[28131] = "Stone";
$f6be72ae2d6fc0cb$var$c[6013] = "Contra Costa";
$f6be72ae2d6fc0cb$var$c[47017] = "Carroll";
$f6be72ae2d6fc0cb$var$c[51087] = "Henrico";
$f6be72ae2d6fc0cb$var$c[18119] = "Owen";
$f6be72ae2d6fc0cb$var$c[36119] = "Westchester";
$f6be72ae2d6fc0cb$var$c[29017] = "Bollinger";
$f6be72ae2d6fc0cb$var$c[54047] = "McDowell";
$f6be72ae2d6fc0cb$var$c[54033] = "Harrison";
$f6be72ae2d6fc0cb$var$c[37077] = "Granville";
$f6be72ae2d6fc0cb$var$c[9009] = "New Haven";
$f6be72ae2d6fc0cb$var$c[31139] = "Pierce";
$f6be72ae2d6fc0cb$var$c[13023] = "Bleckley";
$f6be72ae2d6fc0cb$var$c[13033] = "Burke";
$f6be72ae2d6fc0cb$var$c[17181] = "Union";
$f6be72ae2d6fc0cb$var$c[17091] = "Kankakee";
$f6be72ae2d6fc0cb$var$c[38051] = "McIntosh";
$f6be72ae2d6fc0cb$var$c[31141] = "Platte";
$f6be72ae2d6fc0cb$var$c[37185] = "Warren";
$f6be72ae2d6fc0cb$var$c[72009] = "Aibonito";
$f6be72ae2d6fc0cb$var$c[13197] = "Marion";
$f6be72ae2d6fc0cb$var$c[46027] = "Clay";
$f6be72ae2d6fc0cb$var$c[10005] = "Sussex";
$f6be72ae2d6fc0cb$var$c[13159] = "Jasper";
$f6be72ae2d6fc0cb$var$c[29175] = "Randolph";
$f6be72ae2d6fc0cb$var$c[20015] = "Butler";
$f6be72ae2d6fc0cb$var$c[48209] = "Hays";
$f6be72ae2d6fc0cb$var$c[48325] = "Medina";
$f6be72ae2d6fc0cb$var$c[26105] = "Mason";
$f6be72ae2d6fc0cb$var$c[45013] = "Beaufort";
$f6be72ae2d6fc0cb$var$c[46135] = "Yankton";
$f6be72ae2d6fc0cb$var$c[55105] = "Rock";
$f6be72ae2d6fc0cb$var$c[45077] = "Pickens";
$f6be72ae2d6fc0cb$var$c[53013] = "Columbia";
$f6be72ae2d6fc0cb$var$c[18023] = "Clinton";
$f6be72ae2d6fc0cb$var$c[17027] = "Clinton";
$f6be72ae2d6fc0cb$var$c[16067] = "Minidoka";
$f6be72ae2d6fc0cb$var$c[42113] = "Sullivan";
$f6be72ae2d6fc0cb$var$c[28121] = "Rankin";
$f6be72ae2d6fc0cb$var$c[48345] = "Motley";
$f6be72ae2d6fc0cb$var$c[41039] = "Lane";
$f6be72ae2d6fc0cb$var$c[48485] = "Wichita";
$f6be72ae2d6fc0cb$var$c[26155] = "Shiawassee";
$f6be72ae2d6fc0cb$var$c[20089] = "Jewell";
$f6be72ae2d6fc0cb$var$c[20123] = "Mitchell";
$f6be72ae2d6fc0cb$var$c[12007] = "Bradford";
$f6be72ae2d6fc0cb$var$c[28091] = "Marion";
$f6be72ae2d6fc0cb$var$c[28039] = "George";
$f6be72ae2d6fc0cb$var$c[17085] = "Jo Daviess";
$f6be72ae2d6fc0cb$var$c[18059] = "Hancock";
$f6be72ae2d6fc0cb$var$c[51620] = "Franklin";
$f6be72ae2d6fc0cb$var$c[48329] = "Midland";
$f6be72ae2d6fc0cb$var$c[20171] = "Scott";
$f6be72ae2d6fc0cb$var$c[30013] = "Cascade";
$f6be72ae2d6fc0cb$var$c[51660] = "Harrisonburg";
$f6be72ae2d6fc0cb$var$c[17199] = "Williamson";
$f6be72ae2d6fc0cb$var$c[30029] = "Flathead";
$f6be72ae2d6fc0cb$var$c[72111] = "Pe\xf1uelas";
$f6be72ae2d6fc0cb$var$c[20189] = "Stevens";
$f6be72ae2d6fc0cb$var$c[21067] = "Fayette";
$f6be72ae2d6fc0cb$var$c[21091] = "Hancock";
$f6be72ae2d6fc0cb$var$c[46013] = "Brown";
$f6be72ae2d6fc0cb$var$c[54001] = "Barbour";
$f6be72ae2d6fc0cb$var$c[47181] = "Wayne";
$f6be72ae2d6fc0cb$var$c[31013] = "Box Butte";
$f6be72ae2d6fc0cb$var$c[42097] = "Northumberland";
$f6be72ae2d6fc0cb$var$c[48469] = "Victoria";
$f6be72ae2d6fc0cb$var$c[51530] = "Buena Vista";
$f6be72ae2d6fc0cb$var$c[26147] = "St. Clair";
$f6be72ae2d6fc0cb$var$c[31173] = "Thurston";
$f6be72ae2d6fc0cb$var$c[50015] = "Lamoille";
$f6be72ae2d6fc0cb$var$c[51067] = "Franklin";
$f6be72ae2d6fc0cb$var$c[40011] = "Blaine";
$f6be72ae2d6fc0cb$var$c[53037] = "Kittitas";
$f6be72ae2d6fc0cb$var$c[18135] = "Randolph";
$f6be72ae2d6fc0cb$var$c[49025] = "Kane";
$f6be72ae2d6fc0cb$var$c[54093] = "Tucker";
$f6be72ae2d6fc0cb$var$c[72113] = "Ponce";
$f6be72ae2d6fc0cb$var$c[55023] = "Crawford";
$f6be72ae2d6fc0cb$var$c[1071] = "Jackson";
$f6be72ae2d6fc0cb$var$c[19123] = "Mahaska";
$f6be72ae2d6fc0cb$var$c[20045] = "Douglas";
$f6be72ae2d6fc0cb$var$c[21059] = "Daviess";
$f6be72ae2d6fc0cb$var$c[21197] = "Powell";
$f6be72ae2d6fc0cb$var$c[29097] = "Jasper";
$f6be72ae2d6fc0cb$var$c[41061] = "Union";
$f6be72ae2d6fc0cb$var$c[13151] = "Henry";
$f6be72ae2d6fc0cb$var$c[38001] = "Adams";
$f6be72ae2d6fc0cb$var$c[37137] = "Pamlico";
$f6be72ae2d6fc0cb$var$c[21083] = "Graves";
$f6be72ae2d6fc0cb$var$c[42021] = "Cambria";
$f6be72ae2d6fc0cb$var$c[47107] = "McMinn";
$f6be72ae2d6fc0cb$var$c[26093] = "Livingston";
$f6be72ae2d6fc0cb$var$c[8001] = "Adams";
$f6be72ae2d6fc0cb$var$c[42069] = "Lackawanna";
$f6be72ae2d6fc0cb$var$c[40123] = "Pontotoc";
$f6be72ae2d6fc0cb$var$c[40037] = "Creek";
$f6be72ae2d6fc0cb$var$c[48457] = "Tyler";
$f6be72ae2d6fc0cb$var$c[47175] = "Van Buren";
$f6be72ae2d6fc0cb$var$c[40125] = "Pottawatomie";
$f6be72ae2d6fc0cb$var$c[9013] = "Tolland";
$f6be72ae2d6fc0cb$var$c[35053] = "Socorro";
$f6be72ae2d6fc0cb$var$c[13003] = "Atkinson";
$f6be72ae2d6fc0cb$var$c[12031] = "Duval";
$f6be72ae2d6fc0cb$var$c[48145] = "Falls";
$f6be72ae2d6fc0cb$var$c[5149] = "Yell";
$f6be72ae2d6fc0cb$var$c[20033] = "Comanche";
$f6be72ae2d6fc0cb$var$c[21113] = "Jessamine";
$f6be72ae2d6fc0cb$var$c[21171] = "Monroe";
$f6be72ae2d6fc0cb$var$c[40075] = "Kiowa";
$f6be72ae2d6fc0cb$var$c[46079] = "Lake";
$f6be72ae2d6fc0cb$var$c[37033] = "Caswell";
$f6be72ae2d6fc0cb$var$c[48377] = "Presidio";
$f6be72ae2d6fc0cb$var$c[39057] = "Greene";
$f6be72ae2d6fc0cb$var$c[48489] = "Willacy";
$f6be72ae2d6fc0cb$var$c[72021] = "Bayam\xf3n";
$f6be72ae2d6fc0cb$var$c[35028] = "Los Alamos";
$f6be72ae2d6fc0cb$var$c[2122] = "Kenai Peninsula";
$f6be72ae2d6fc0cb$var$c[1003] = "Baldwin";
$f6be72ae2d6fc0cb$var$c[19007] = "Appanoose";
$f6be72ae2d6fc0cb$var$c[78010] = "St. Croix";
$f6be72ae2d6fc0cb$var$c[51127] = "New Kent";
$f6be72ae2d6fc0cb$var$c[13263] = "Talbot";
$f6be72ae2d6fc0cb$var$c[36049] = "Lewis";
$f6be72ae2d6fc0cb$var$c[54015] = "Clay";
$f6be72ae2d6fc0cb$var$c[18077] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[51019] = "Bedford";
$f6be72ae2d6fc0cb$var$c[35033] = "Mora";
$f6be72ae2d6fc0cb$var$c[31011] = "Boone";
$f6be72ae2d6fc0cb$var$c[29149] = "Oregon";
$f6be72ae2d6fc0cb$var$c[47083] = "Houston";
$f6be72ae2d6fc0cb$var$c[42131] = "Wyoming";
$f6be72ae2d6fc0cb$var$c[37107] = "Lenoir";
$f6be72ae2d6fc0cb$var$c[18167] = "Vigo";
$f6be72ae2d6fc0cb$var$c[18039] = "Elkhart";
$f6be72ae2d6fc0cb$var$c[51077] = "Grayson";
$f6be72ae2d6fc0cb$var$c[48303] = "Lubbock";
$f6be72ae2d6fc0cb$var$c[27093] = "Meeker";
$f6be72ae2d6fc0cb$var$c[39005] = "Ashland";
$f6be72ae2d6fc0cb$var$c[31119] = "Madison";
$f6be72ae2d6fc0cb$var$c[12085] = "Martin";
$f6be72ae2d6fc0cb$var$c[8079] = "Mineral";
$f6be72ae2d6fc0cb$var$c[13085] = "Dawson";
$f6be72ae2d6fc0cb$var$c[13167] = "Johnson";
$f6be72ae2d6fc0cb$var$c[5095] = "Monroe";
$f6be72ae2d6fc0cb$var$c[29059] = "Dallas";
$f6be72ae2d6fc0cb$var$c[51143] = "Pittsylvania";
$f6be72ae2d6fc0cb$var$c[2068] = "Denali";
$f6be72ae2d6fc0cb$var$c[20145] = "Pawnee";
$f6be72ae2d6fc0cb$var$c[20209] = "Wyandotte";
$f6be72ae2d6fc0cb$var$c[12029] = "Dixie";
$f6be72ae2d6fc0cb$var$c[26157] = "Tuscola";
$f6be72ae2d6fc0cb$var$c[2240] = "Southeast Fairbanks";
$f6be72ae2d6fc0cb$var$c[20065] = "Graham";
$f6be72ae2d6fc0cb$var$c[22097] = "St. Landry";
$f6be72ae2d6fc0cb$var$c[47055] = "Giles";
$f6be72ae2d6fc0cb$var$c[39095] = "Lucas";
$f6be72ae2d6fc0cb$var$c[5093] = "Mississippi";
$f6be72ae2d6fc0cb$var$c[72117] = "Rinc\xf3n";
$f6be72ae2d6fc0cb$var$c[18043] = "Floyd";
$f6be72ae2d6fc0cb$var$c[20129] = "Morton";
$f6be72ae2d6fc0cb$var$c[21081] = "Grant";
$f6be72ae2d6fc0cb$var$c[21217] = "Taylor";
$f6be72ae2d6fc0cb$var$c[37075] = "Graham";
$f6be72ae2d6fc0cb$var$c[54045] = "Logan";
$f6be72ae2d6fc0cb$var$c[54073] = "Pleasants";
$f6be72ae2d6fc0cb$var$c[51071] = "Giles";
$f6be72ae2d6fc0cb$var$c[54019] = "Fayette";
$f6be72ae2d6fc0cb$var$c[53061] = "Snohomish";
$f6be72ae2d6fc0cb$var$c[35015] = "Eddy";
$f6be72ae2d6fc0cb$var$c[31117] = "McPherson";
$f6be72ae2d6fc0cb$var$c[31145] = "Red Willow";
$f6be72ae2d6fc0cb$var$c[31149] = "Rock";
$f6be72ae2d6fc0cb$var$c[47085] = "Humphreys";
$f6be72ae2d6fc0cb$var$c[17125] = "Mason";
$f6be72ae2d6fc0cb$var$c[51197] = "Wythe";
$f6be72ae2d6fc0cb$var$c[13303] = "Washington";
$f6be72ae2d6fc0cb$var$c[53077] = "Yakima";
$f6be72ae2d6fc0cb$var$c[5143] = "Washington";
$f6be72ae2d6fc0cb$var$c[48213] = "Henderson";
$f6be72ae2d6fc0cb$var$c[55035] = "Eau Claire";
$f6be72ae2d6fc0cb$var$c[47153] = "Sequatchie";
$f6be72ae2d6fc0cb$var$c[48471] = "Walker";
$f6be72ae2d6fc0cb$var$c[4005] = "Coconino";
$f6be72ae2d6fc0cb$var$c[20191] = "Sumner";
$f6be72ae2d6fc0cb$var$c[26127] = "Oceana";
$f6be72ae2d6fc0cb$var$c[27065] = "Kanabec";
$f6be72ae2d6fc0cb$var$c[39007] = "Ashtabula";
$f6be72ae2d6fc0cb$var$c[6003] = "Alpine";
$f6be72ae2d6fc0cb$var$c[48167] = "Galveston";
$f6be72ae2d6fc0cb$var$c[1011] = "Bullock";
$f6be72ae2d6fc0cb$var$c[17105] = "Livingston";
$f6be72ae2d6fc0cb$var$c[39135] = "Preble";
$f6be72ae2d6fc0cb$var$c[39079] = "Jackson";
$f6be72ae2d6fc0cb$var$c[48201] = "Harris";
$f6be72ae2d6fc0cb$var$c[25017] = "Middlesex";
$f6be72ae2d6fc0cb$var$c[72145] = "Vega Baja";
$f6be72ae2d6fc0cb$var$c[48115] = "Dawson";
$f6be72ae2d6fc0cb$var$c[36069] = "Ontario";
$f6be72ae2d6fc0cb$var$c[1001] = "Autauga";
$f6be72ae2d6fc0cb$var$c[20121] = "Miami";
$f6be72ae2d6fc0cb$var$c[13091] = "Dodge";
$f6be72ae2d6fc0cb$var$c[36023] = "Cortland";
$f6be72ae2d6fc0cb$var$c[13039] = "Camden";
$f6be72ae2d6fc0cb$var$c[26161] = "Washtenaw";
$f6be72ae2d6fc0cb$var$c[18087] = "LaGrange";
$f6be72ae2d6fc0cb$var$c[48371] = "Pecos";
$f6be72ae2d6fc0cb$var$c[13225] = "Peach";
$f6be72ae2d6fc0cb$var$c[13311] = "White";
$f6be72ae2d6fc0cb$var$c[13163] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[55083] = "Oconto";
$f6be72ae2d6fc0cb$var$c[48347] = "Nacogdoches";
$f6be72ae2d6fc0cb$var$c[44009] = "Washington";
$f6be72ae2d6fc0cb$var$c[53047] = "Okanogan";
$f6be72ae2d6fc0cb$var$c[53063] = "Spokane";
$f6be72ae2d6fc0cb$var$c[55041] = "Forest";
$f6be72ae2d6fc0cb$var$c[55113] = "Sawyer";
$f6be72ae2d6fc0cb$var$c[34017] = "Hudson";
$f6be72ae2d6fc0cb$var$c[39151] = "Stark";
$f6be72ae2d6fc0cb$var$c[48187] = "Guadalupe";
$f6be72ae2d6fc0cb$var$c[53029] = "Island";
$f6be72ae2d6fc0cb$var$c[54037] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[51153] = "Prince William";
$f6be72ae2d6fc0cb$var$c[42029] = "Chester";
$f6be72ae2d6fc0cb$var$c[54055] = "Mercer";
$f6be72ae2d6fc0cb$var$c[47145] = "Roane";
$f6be72ae2d6fc0cb$var$c[53009] = "Clallam";
$f6be72ae2d6fc0cb$var$c[53065] = "Stevens";
$f6be72ae2d6fc0cb$var$c[19177] = "Van Buren";
$f6be72ae2d6fc0cb$var$c[31073] = "Gosper";
$f6be72ae2d6fc0cb$var$c[28095] = "Monroe";
$f6be72ae2d6fc0cb$var$c[12033] = "Escambia";
$f6be72ae2d6fc0cb$var$c[48439] = "Tarrant";
$f6be72ae2d6fc0cb$var$c[24033] = "Prince George's";
$f6be72ae2d6fc0cb$var$c[51169] = "Scott";
$f6be72ae2d6fc0cb$var$c[48239] = "Jackson";
$f6be72ae2d6fc0cb$var$c[40085] = "Love";
$f6be72ae2d6fc0cb$var$c[13289] = "Twiggs";
$f6be72ae2d6fc0cb$var$c[39099] = "Mahoning";
$f6be72ae2d6fc0cb$var$c[1087] = "Macon";
$f6be72ae2d6fc0cb$var$c[17191] = "Wayne";
$f6be72ae2d6fc0cb$var$c[48437] = "Swisher";
$f6be72ae2d6fc0cb$var$c[29151] = "Osage";
$f6be72ae2d6fc0cb$var$c[17089] = "Kane";
$f6be72ae2d6fc0cb$var$c[6017] = "El Dorado";
$f6be72ae2d6fc0cb$var$c[45055] = "Kershaw";
$f6be72ae2d6fc0cb$var$c[37073] = "Gates";
$f6be72ae2d6fc0cb$var$c[8089] = "Otero";
$f6be72ae2d6fc0cb$var$c[41019] = "Douglas";
$f6be72ae2d6fc0cb$var$c[42089] = "Monroe";
$f6be72ae2d6fc0cb$var$c[5101] = "Newton";
$f6be72ae2d6fc0cb$var$c[38019] = "Cavalier";
$f6be72ae2d6fc0cb$var$c[40103] = "Noble";
$f6be72ae2d6fc0cb$var$c[20063] = "Gove";
$f6be72ae2d6fc0cb$var$c[22077] = "Pointe Coupee";
$f6be72ae2d6fc0cb$var$c[31067] = "Gage";
$f6be72ae2d6fc0cb$var$c[1115] = "St. Clair";
$f6be72ae2d6fc0cb$var$c[28123] = "Scott";
$f6be72ae2d6fc0cb$var$c[13095] = "Dougherty";
$f6be72ae2d6fc0cb$var$c[18061] = "Harrison";
$f6be72ae2d6fc0cb$var$c[16017] = "Bonner";
$f6be72ae2d6fc0cb$var$c[13047] = "Catoosa";
$f6be72ae2d6fc0cb$var$c[22059] = "LaSalle";
$f6be72ae2d6fc0cb$var$c[23027] = "Waldo";
$f6be72ae2d6fc0cb$var$c[24027] = "Howard";
$f6be72ae2d6fc0cb$var$c[49035] = "Salt Lake";
$f6be72ae2d6fc0cb$var$c[9003] = "Hartford";
$f6be72ae2d6fc0cb$var$c[9015] = "Windham";
$f6be72ae2d6fc0cb$var$c[12087] = "Monroe";
$f6be72ae2d6fc0cb$var$c[39157] = "Tuscarawas";
$f6be72ae2d6fc0cb$var$c[36085] = "Richmond";
$f6be72ae2d6fc0cb$var$c[39071] = "Highland";
$f6be72ae2d6fc0cb$var$c[27077] = "Lake of the Woods";
$f6be72ae2d6fc0cb$var$c[16011] = "Bingham";
$f6be72ae2d6fc0cb$var$c[72023] = "Cabo Rojo";
$f6be72ae2d6fc0cb$var$c[72069] = "Humacao";
$f6be72ae2d6fc0cb$var$c[72077] = "Juncos";
$f6be72ae2d6fc0cb$var$c[45045] = "Greenville";
$f6be72ae2d6fc0cb$var$c[46085] = "Lyman";
$f6be72ae2d6fc0cb$var$c[55121] = "Trempealeau";
$f6be72ae2d6fc0cb$var$c[6113] = "Yolo";
$f6be72ae2d6fc0cb$var$c[48431] = "Sterling";
$f6be72ae2d6fc0cb$var$c[48495] = "Winkler";
$f6be72ae2d6fc0cb$var$c[46071] = "Jackson";
$f6be72ae2d6fc0cb$var$c[49041] = "Sevier";
$f6be72ae2d6fc0cb$var$c[51036] = "Charles City";
$f6be72ae2d6fc0cb$var$c[1023] = "Choctaw";
$f6be72ae2d6fc0cb$var$c[18083] = "Knox";
$f6be72ae2d6fc0cb$var$c[31047] = "Dawson";
$f6be72ae2d6fc0cb$var$c[20057] = "Ford";
$f6be72ae2d6fc0cb$var$c[38105] = "Williams";
$f6be72ae2d6fc0cb$var$c[38017] = "Cass";
$f6be72ae2d6fc0cb$var$c[17069] = "Hardin";
$f6be72ae2d6fc0cb$var$c[31005] = "Arthur";
$f6be72ae2d6fc0cb$var$c[48163] = "Frio";
$f6be72ae2d6fc0cb$var$c[19103] = "Johnson";
$f6be72ae2d6fc0cb$var$c[20133] = "Neosho";
$f6be72ae2d6fc0cb$var$c[21089] = "Greenup";
$f6be72ae2d6fc0cb$var$c[20107] = "Linn";
$f6be72ae2d6fc0cb$var$c[49017] = "Garfield";
$f6be72ae2d6fc0cb$var$c[32011] = "Eureka";
$f6be72ae2d6fc0cb$var$c[31085] = "Hayes";
$f6be72ae2d6fc0cb$var$c[8095] = "Phillips";
$f6be72ae2d6fc0cb$var$c[5013] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[2090] = "Fairbanks North Star";
$f6be72ae2d6fc0cb$var$c[21101] = "Henderson";
$f6be72ae2d6fc0cb$var$c[28051] = "Holmes";
$f6be72ae2d6fc0cb$var$c[28105] = "Oktibbeha";
$f6be72ae2d6fc0cb$var$c[72037] = "Ceiba";
$f6be72ae2d6fc0cb$var$c[72047] = "Corozal";
$f6be72ae2d6fc0cb$var$c[30027] = "Fergus";
$f6be72ae2d6fc0cb$var$c[24023] = "Garrett";
$f6be72ae2d6fc0cb$var$c[22119] = "Webster";
$f6be72ae2d6fc0cb$var$c[26059] = "Hillsdale";
$f6be72ae2d6fc0cb$var$c[21141] = "Logan";
$f6be72ae2d6fc0cb$var$c[46033] = "Custer";
$f6be72ae2d6fc0cb$var$c[33013] = "Merrimack";
$f6be72ae2d6fc0cb$var$c[42133] = "York";
$f6be72ae2d6fc0cb$var$c[37161] = "Rutherford";
$f6be72ae2d6fc0cb$var$c[46005] = "Beadle";
$f6be72ae2d6fc0cb$var$c[1043] = "Cullman";
$f6be72ae2d6fc0cb$var$c[13097] = "Douglas";
$f6be72ae2d6fc0cb$var$c[31097] = "Johnson";
$f6be72ae2d6fc0cb$var$c[37187] = "Washington";
$f6be72ae2d6fc0cb$var$c[46075] = "Jones";
$f6be72ae2d6fc0cb$var$c[37007] = "Anson";
$f6be72ae2d6fc0cb$var$c[2100] = "Haines";
$f6be72ae2d6fc0cb$var$c[38007] = "Billings";
$f6be72ae2d6fc0cb$var$c[31003] = "Antelope";
$f6be72ae2d6fc0cb$var$c[29073] = "Gasconade";
$f6be72ae2d6fc0cb$var$c[21031] = "Butler";
$f6be72ae2d6fc0cb$var$c[78020] = "St. John";
$f6be72ae2d6fc0cb$var$c[56005] = "Campbell";
$f6be72ae2d6fc0cb$var$c[13211] = "Morgan";
$f6be72ae2d6fc0cb$var$c[5037] = "Cross";
$f6be72ae2d6fc0cb$var$c[5107] = "Phillips";
$f6be72ae2d6fc0cb$var$c[22093] = "St. James";
$f6be72ae2d6fc0cb$var$c[6115] = "Yuba";
$f6be72ae2d6fc0cb$var$c[1117] = "Shelby";
$f6be72ae2d6fc0cb$var$c[8091] = "Ouray";
$f6be72ae2d6fc0cb$var$c[35009] = "Curry";
$f6be72ae2d6fc0cb$var$c[40149] = "Washita";
$f6be72ae2d6fc0cb$var$c[37135] = "Orange";
$f6be72ae2d6fc0cb$var$c[18131] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[26019] = "Benzie";
$f6be72ae2d6fc0cb$var$c[36029] = "Erie";
$f6be72ae2d6fc0cb$var$c[24031] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[51685] = "Manassas Park";
$f6be72ae2d6fc0cb$var$c[51013] = "Arlington";
$f6be72ae2d6fc0cb$var$c[51035] = "Carroll";
$f6be72ae2d6fc0cb$var$c[29183] = "St. Charles";
$f6be72ae2d6fc0cb$var$c[6069] = "San Benito";
$f6be72ae2d6fc0cb$var$c[24035] = "Queen Anne's";
$f6be72ae2d6fc0cb$var$c[20013] = "Brown";
$f6be72ae2d6fc0cb$var$c[13031] = "Bulloch";
$f6be72ae2d6fc0cb$var$c[21071] = "Floyd";
$f6be72ae2d6fc0cb$var$c[30007] = "Broadwater";
$f6be72ae2d6fc0cb$var$c[13309] = "Wheeler";
$f6be72ae2d6fc0cb$var$c[37049] = "Craven";
$f6be72ae2d6fc0cb$var$c[29087] = "Holt";
$f6be72ae2d6fc0cb$var$c[48295] = "Lipscomb";
$f6be72ae2d6fc0cb$var$c[41009] = "Columbia";
$f6be72ae2d6fc0cb$var$c[45041] = "Florence";
$f6be72ae2d6fc0cb$var$c[38061] = "Mountrail";
$f6be72ae2d6fc0cb$var$c[49053] = "Washington";
$f6be72ae2d6fc0cb$var$c[30003] = "Big Horn";
$f6be72ae2d6fc0cb$var$c[42047] = "Elk";
$f6be72ae2d6fc0cb$var$c[31165] = "Sioux";
$f6be72ae2d6fc0cb$var$c[28031] = "Covington";
$f6be72ae2d6fc0cb$var$c[72099] = "Moca";
$f6be72ae2d6fc0cb$var$c[18013] = "Brown";
$f6be72ae2d6fc0cb$var$c[18019] = "Clark";
$f6be72ae2d6fc0cb$var$c[21021] = "Boyle";
$f6be72ae2d6fc0cb$var$c[21065] = "Estill";
$f6be72ae2d6fc0cb$var$c[48087] = "Collingsworth";
$f6be72ae2d6fc0cb$var$c[48089] = "Colorado";
$f6be72ae2d6fc0cb$var$c[17063] = "Grundy";
$f6be72ae2d6fc0cb$var$c[27081] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[13109] = "Evans";
$f6be72ae2d6fc0cb$var$c[48497] = "Wise";
$f6be72ae2d6fc0cb$var$c[2050] = "Bethel";
$f6be72ae2d6fc0cb$var$c[13307] = "Webster";
$f6be72ae2d6fc0cb$var$c[13169] = "Jones";
$f6be72ae2d6fc0cb$var$c[13135] = "Gwinnett";
$f6be72ae2d6fc0cb$var$c[55095] = "Polk";
$f6be72ae2d6fc0cb$var$c[55045] = "Green";
$f6be72ae2d6fc0cb$var$c[72107] = "Orocovis";
$f6be72ae2d6fc0cb$var$c[36079] = "Putnam";
$f6be72ae2d6fc0cb$var$c[51700] = "Newport News";
$f6be72ae2d6fc0cb$var$c[8011] = "Bent";
$f6be72ae2d6fc0cb$var$c[40065] = "Jackson";
$f6be72ae2d6fc0cb$var$c[30089] = "Sanders";
$f6be72ae2d6fc0cb$var$c[48173] = "Glasscock";
$f6be72ae2d6fc0cb$var$c[5047] = "Franklin";
$f6be72ae2d6fc0cb$var$c[40093] = "Major";
$f6be72ae2d6fc0cb$var$c[47125] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[53051] = "Pend Oreille";
$f6be72ae2d6fc0cb$var$c[38055] = "McLean";
$f6be72ae2d6fc0cb$var$c[41027] = "Hood River";
$f6be72ae2d6fc0cb$var$c[19197] = "Wright";
$f6be72ae2d6fc0cb$var$c[48419] = "Shelby";
$f6be72ae2d6fc0cb$var$c[29055] = "Crawford";
$f6be72ae2d6fc0cb$var$c[51017] = "Bath";
$f6be72ae2d6fc0cb$var$c[27111] = "Otter Tail";
$f6be72ae2d6fc0cb$var$c[22075] = "Plaquemines";
$f6be72ae2d6fc0cb$var$c[28115] = "Pontotoc";
$f6be72ae2d6fc0cb$var$c[22067] = "Morehouse";
$f6be72ae2d6fc0cb$var$c[21029] = "Bullitt";
$f6be72ae2d6fc0cb$var$c[1047] = "Dallas";
$f6be72ae2d6fc0cb$var$c[48093] = "Comanche";
$f6be72ae2d6fc0cb$var$c[30053] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[72129] = "San Lorenzo";
$f6be72ae2d6fc0cb$var$c[72135] = "Toa Alta";
$f6be72ae2d6fc0cb$var$c[27021] = "Cass";
$f6be72ae2d6fc0cb$var$c[8007] = "Archuleta";
$f6be72ae2d6fc0cb$var$c[28163] = "Yazoo";
$f6be72ae2d6fc0cb$var$c[55087] = "Outagamie";
$f6be72ae2d6fc0cb$var$c[29107] = "Lafayette";
$f6be72ae2d6fc0cb$var$c[37195] = "Wilson";
$f6be72ae2d6fc0cb$var$c[39117] = "Morrow";
$f6be72ae2d6fc0cb$var$c[30039] = "Granite";
$f6be72ae2d6fc0cb$var$c[38031] = "Foster";
$f6be72ae2d6fc0cb$var$c[5033] = "Crawford";
$f6be72ae2d6fc0cb$var$c[48053] = "Burnet";
$f6be72ae2d6fc0cb$var$c[29186] = "Ste. Genevieve";
$f6be72ae2d6fc0cb$var$c[48179] = "Gray";
$f6be72ae2d6fc0cb$var$c[17109] = "McDonough";
$f6be72ae2d6fc0cb$var$c[19137] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[5067] = "Jackson";
$f6be72ae2d6fc0cb$var$c[48229] = "Hudspeth";
$f6be72ae2d6fc0cb$var$c[22079] = "Rapides";
$f6be72ae2d6fc0cb$var$c[31111] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[48067] = "Cass";
$f6be72ae2d6fc0cb$var$c[47079] = "Henry";
$f6be72ae2d6fc0cb$var$c[51840] = "Winchester";
$f6be72ae2d6fc0cb$var$c[37061] = "Duplin";
$f6be72ae2d6fc0cb$var$c[37087] = "Haywood";
$f6be72ae2d6fc0cb$var$c[27037] = "Dakota";
$f6be72ae2d6fc0cb$var$c[41025] = "Harney";
$f6be72ae2d6fc0cb$var$c[72095] = "Maunabo";
$f6be72ae2d6fc0cb$var$c[55001] = "Adams";
$f6be72ae2d6fc0cb$var$c[29045] = "Clark";
$f6be72ae2d6fc0cb$var$c[21015] = "Boone";
$f6be72ae2d6fc0cb$var$c[21229] = "Washington";
$f6be72ae2d6fc0cb$var$c[22009] = "Avoyelles";
$f6be72ae2d6fc0cb$var$c[28137] = "Tate";
$f6be72ae2d6fc0cb$var$c[29227] = "Worth";
$f6be72ae2d6fc0cb$var$c[31163] = "Sherman";
$f6be72ae2d6fc0cb$var$c[46021] = "Campbell";
$f6be72ae2d6fc0cb$var$c[46063] = "Harding";
$f6be72ae2d6fc0cb$var$c[26057] = "Gratiot";
$f6be72ae2d6fc0cb$var$c[19175] = "Union";
$f6be72ae2d6fc0cb$var$c[17127] = "Massac";
$f6be72ae2d6fc0cb$var$c[31113] = "Logan";
$f6be72ae2d6fc0cb$var$c[31121] = "Merrick";
$f6be72ae2d6fc0cb$var$c[31161] = "Sheridan";
$f6be72ae2d6fc0cb$var$c[21039] = "Carlisle";
$f6be72ae2d6fc0cb$var$c[56025] = "Natrona";
$f6be72ae2d6fc0cb$var$c[13321] = "Worth";
$f6be72ae2d6fc0cb$var$c[18109] = "Morgan";
$f6be72ae2d6fc0cb$var$c[48139] = "Ellis";
$f6be72ae2d6fc0cb$var$c[13229] = "Pierce";
$f6be72ae2d6fc0cb$var$c[60010] = "Eastern";
$f6be72ae2d6fc0cb$var$c[18053] = "Grant";
$f6be72ae2d6fc0cb$var$c[12035] = "Flagler";
$f6be72ae2d6fc0cb$var$c[28077] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[22127] = "Winn";
$f6be72ae2d6fc0cb$var$c[17073] = "Henry";
$f6be72ae2d6fc0cb$var$c[41041] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[23031] = "York";
$f6be72ae2d6fc0cb$var$c[46029] = "Codington";
$f6be72ae2d6fc0cb$var$c[13231] = "Pike";
$f6be72ae2d6fc0cb$var$c[13259] = "Stewart";
$f6be72ae2d6fc0cb$var$c[34025] = "Monmouth";
$f6be72ae2d6fc0cb$var$c[5021] = "Clay";
$f6be72ae2d6fc0cb$var$c[5045] = "Faulkner";
$f6be72ae2d6fc0cb$var$c[40041] = "Delaware";
$f6be72ae2d6fc0cb$var$c[19107] = "Keokuk";
$f6be72ae2d6fc0cb$var$c[17061] = "Greene";
$f6be72ae2d6fc0cb$var$c[27075] = "Lake";
$f6be72ae2d6fc0cb$var$c[13285] = "Troup";
$f6be72ae2d6fc0cb$var$c[6023] = "Humboldt";
$f6be72ae2d6fc0cb$var$c[47043] = "Dickson";
$f6be72ae2d6fc0cb$var$c[27003] = "Anoka";
$f6be72ae2d6fc0cb$var$c[46009] = "Bon Homme";
$f6be72ae2d6fc0cb$var$c[47059] = "Greene";
$f6be72ae2d6fc0cb$var$c[51183] = "Sussex";
$f6be72ae2d6fc0cb$var$c[18141] = "St. Joseph";
$f6be72ae2d6fc0cb$var$c[38067] = "Pembina";
$f6be72ae2d6fc0cb$var$c[46007] = "Bennett";
$f6be72ae2d6fc0cb$var$c[22115] = "Vernon";
$f6be72ae2d6fc0cb$var$c[23019] = "Penobscot";
$f6be72ae2d6fc0cb$var$c[24041] = "Talbot";
$f6be72ae2d6fc0cb$var$c[13257] = "Stephens";
$f6be72ae2d6fc0cb$var$c[6065] = "Riverside";
$f6be72ae2d6fc0cb$var$c[5005] = "Baxter";
$f6be72ae2d6fc0cb$var$c[28007] = "Attala";
$f6be72ae2d6fc0cb$var$c[19169] = "Story";
$f6be72ae2d6fc0cb$var$c[20011] = "Bourbon";
$f6be72ae2d6fc0cb$var$c[51049] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[45085] = "Sumter";
$f6be72ae2d6fc0cb$var$c[2164] = "Lake and Peninsula";
$f6be72ae2d6fc0cb$var$c[54109] = "Wyoming";
$f6be72ae2d6fc0cb$var$c[6029] = "Kern";
$f6be72ae2d6fc0cb$var$c[48097] = "Cooke";
$f6be72ae2d6fc0cb$var$c[45075] = "Orangeburg";
$f6be72ae2d6fc0cb$var$c[55119] = "Taylor";
$f6be72ae2d6fc0cb$var$c[27099] = "Mower";
$f6be72ae2d6fc0cb$var$c[27101] = "Murray";
$f6be72ae2d6fc0cb$var$c[44007] = "Providence";
$f6be72ae2d6fc0cb$var$c[29161] = "Phelps";
$f6be72ae2d6fc0cb$var$c[28117] = "Prentiss";
$f6be72ae2d6fc0cb$var$c[21235] = "Whitley";
$f6be72ae2d6fc0cb$var$c[18149] = "Starke";
$f6be72ae2d6fc0cb$var$c[48491] = "Williamson";
$f6be72ae2d6fc0cb$var$c[72109] = "Patillas";
$f6be72ae2d6fc0cb$var$c[19131] = "Mitchell";
$f6be72ae2d6fc0cb$var$c[13107] = "Emanuel";
$f6be72ae2d6fc0cb$var$c[22025] = "Catahoula";
$f6be72ae2d6fc0cb$var$c[42025] = "Carbon";
$f6be72ae2d6fc0cb$var$c[31133] = "Pawnee";
$f6be72ae2d6fc0cb$var$c[47171] = "Unicoi";
$f6be72ae2d6fc0cb$var$c[45083] = "Spartanburg";
$f6be72ae2d6fc0cb$var$c[55073] = "Marathon";
$f6be72ae2d6fc0cb$var$c[32007] = "Elko";
$f6be72ae2d6fc0cb$var$c[54007] = "Braxton";
$f6be72ae2d6fc0cb$var$c[26165] = "Wexford";
$f6be72ae2d6fc0cb$var$c[48079] = "Cochran";
$f6be72ae2d6fc0cb$var$c[42013] = "Blair";
$f6be72ae2d6fc0cb$var$c[29085] = "Hickory";
$f6be72ae2d6fc0cb$var$c[29009] = "Barry";
$f6be72ae2d6fc0cb$var$c[27123] = "Ramsey";
$f6be72ae2d6fc0cb$var$c[5081] = "Little River";
$f6be72ae2d6fc0cb$var$c[32019] = "Lyon";
$f6be72ae2d6fc0cb$var$c[12071] = "Lee";
$f6be72ae2d6fc0cb$var$c[41033] = "Josephine";
$f6be72ae2d6fc0cb$var$c[72091] = "Manat\xed";
$f6be72ae2d6fc0cb$var$c[28113] = "Pike";
$f6be72ae2d6fc0cb$var$c[47031] = "Coffee";
$f6be72ae2d6fc0cb$var$c[16059] = "Lemhi";
$f6be72ae2d6fc0cb$var$c[21183] = "Ohio";
$f6be72ae2d6fc0cb$var$c[31153] = "Sarpy";
$f6be72ae2d6fc0cb$var$c[13071] = "Colquitt";
$f6be72ae2d6fc0cb$var$c[27167] = "Wilkin";
$f6be72ae2d6fc0cb$var$c[17157] = "Randolph";
$f6be72ae2d6fc0cb$var$c[23011] = "Kennebec";
$f6be72ae2d6fc0cb$var$c[51173] = "Smyth";
$f6be72ae2d6fc0cb$var$c[35041] = "Roosevelt";
$f6be72ae2d6fc0cb$var$c[42111] = "Somerset";
$f6be72ae2d6fc0cb$var$c[51191] = "Washington";
$f6be72ae2d6fc0cb$var$c[37081] = "Guilford";
$f6be72ae2d6fc0cb$var$c[16001] = "Ada";
$f6be72ae2d6fc0cb$var$c[40039] = "Custer";
$f6be72ae2d6fc0cb$var$c[39101] = "Marion";
$f6be72ae2d6fc0cb$var$c[17149] = "Pike";
$f6be72ae2d6fc0cb$var$c[17203] = "Woodford";
$f6be72ae2d6fc0cb$var$c[13245] = "Richmond";
$f6be72ae2d6fc0cb$var$c[1107] = "Pickens";
$f6be72ae2d6fc0cb$var$c[40045] = "Ellis";
$f6be72ae2d6fc0cb$var$c[17145] = "Perry";
$f6be72ae2d6fc0cb$var$c[19075] = "Grundy";
$f6be72ae2d6fc0cb$var$c[8107] = "Routt";
$f6be72ae2d6fc0cb$var$c[34035] = "Somerset";
$f6be72ae2d6fc0cb$var$c[6011] = "Colusa";
$f6be72ae2d6fc0cb$var$c[17087] = "Johnson";
$f6be72ae2d6fc0cb$var$c[8053] = "Hinsdale";
$f6be72ae2d6fc0cb$var$c[16031] = "Cassia";
$f6be72ae2d6fc0cb$var$c[27059] = "Isanti";
$f6be72ae2d6fc0cb$var$c[42049] = "Erie";
$f6be72ae2d6fc0cb$var$c[28029] = "Copiah";
$f6be72ae2d6fc0cb$var$c[48467] = "Van Zandt";
$f6be72ae2d6fc0cb$var$c[51161] = "Roanoke";
$f6be72ae2d6fc0cb$var$c[51015] = "Augusta";
$f6be72ae2d6fc0cb$var$c[2060] = "Bristol Bay";
$f6be72ae2d6fc0cb$var$c[49031] = "Piute";
$f6be72ae2d6fc0cb$var$c[21161] = "Mason";
$f6be72ae2d6fc0cb$var$c[27009] = "Benton";
$f6be72ae2d6fc0cb$var$c[48129] = "Donley";
$f6be72ae2d6fc0cb$var$c[12005] = "Bay";
$f6be72ae2d6fc0cb$var$c[1077] = "Lauderdale";
$f6be72ae2d6fc0cb$var$c[18045] = "Fountain";
$f6be72ae2d6fc0cb$var$c[17173] = "Shelby";
$f6be72ae2d6fc0cb$var$c[17051] = "Fayette";
$f6be72ae2d6fc0cb$var$c[39127] = "Perry";
$f6be72ae2d6fc0cb$var$c[51590] = "Danville";
$f6be72ae2d6fc0cb$var$c[13011] = "Banks";
$f6be72ae2d6fc0cb$var$c[13305] = "Wayne";
$f6be72ae2d6fc0cb$var$c[40109] = "Oklahoma";
$f6be72ae2d6fc0cb$var$c[40069] = "Johnston";
$f6be72ae2d6fc0cb$var$c[37099] = "Jackson";
$f6be72ae2d6fc0cb$var$c[49043] = "Summit";
$f6be72ae2d6fc0cb$var$c[29167] = "Polk";
$f6be72ae2d6fc0cb$var$c[32015] = "Lander";
$f6be72ae2d6fc0cb$var$c[19191] = "Winneshiek";
$f6be72ae2d6fc0cb$var$c[21023] = "Bracken";
$f6be72ae2d6fc0cb$var$c[55037] = "Florence";
$f6be72ae2d6fc0cb$var$c[54087] = "Roane";
$f6be72ae2d6fc0cb$var$c[27159] = "Wadena";
$f6be72ae2d6fc0cb$var$c[51670] = "Hopewell";
$f6be72ae2d6fc0cb$var$c[17201] = "Winnebago";
$f6be72ae2d6fc0cb$var$c[4007] = "Gila";
$f6be72ae2d6fc0cb$var$c[24045] = "Wicomico";
$f6be72ae2d6fc0cb$var$c[21043] = "Carter";
$f6be72ae2d6fc0cb$var$c[37097] = "Iredell";
$f6be72ae2d6fc0cb$var$c[51083] = "Halifax";
$f6be72ae2d6fc0cb$var$c[37091] = "Hertford";
$f6be72ae2d6fc0cb$var$c[36057] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[27113] = "Pennington";
$f6be72ae2d6fc0cb$var$c[53073] = "Whatcom";
$f6be72ae2d6fc0cb$var$c[41021] = "Gilliam";
$f6be72ae2d6fc0cb$var$c[34029] = "Ocean";
$f6be72ae2d6fc0cb$var$c[5009] = "Boone";
$f6be72ae2d6fc0cb$var$c[40031] = "Comanche";
$f6be72ae2d6fc0cb$var$c[48253] = "Jones";
$f6be72ae2d6fc0cb$var$c[48185] = "Grimes";
$f6be72ae2d6fc0cb$var$c[26049] = "Genesee";
$f6be72ae2d6fc0cb$var$c[22007] = "Assumption";
$f6be72ae2d6fc0cb$var$c[28013] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[28041] = "Greene";
$f6be72ae2d6fc0cb$var$c[30017] = "Custer";
$f6be72ae2d6fc0cb$var$c[46109] = "Roberts";
$f6be72ae2d6fc0cb$var$c[17141] = "Ogle";
$f6be72ae2d6fc0cb$var$c[38077] = "Richland";
$f6be72ae2d6fc0cb$var$c[55005] = "Barron";
$f6be72ae2d6fc0cb$var$c[55051] = "Iron";
$f6be72ae2d6fc0cb$var$c[27157] = "Wabasha";
$f6be72ae2d6fc0cb$var$c[6015] = "Del Norte";
$f6be72ae2d6fc0cb$var$c[40127] = "Pushmataha";
$f6be72ae2d6fc0cb$var$c[53007] = "Chelan";
$f6be72ae2d6fc0cb$var$c[26141] = "Presque Isle";
$f6be72ae2d6fc0cb$var$c[40027] = "Cleveland";
$f6be72ae2d6fc0cb$var$c[36105] = "Sullivan";
$f6be72ae2d6fc0cb$var$c[37149] = "Polk";
$f6be72ae2d6fc0cb$var$c[37165] = "Scotland";
$f6be72ae2d6fc0cb$var$c[37085] = "Harnett";
$f6be72ae2d6fc0cb$var$c[37105] = "Lee";
$f6be72ae2d6fc0cb$var$c[18159] = "Tipton";
$f6be72ae2d6fc0cb$var$c[20027] = "Clay";
$f6be72ae2d6fc0cb$var$c[40145] = "Wagoner";
$f6be72ae2d6fc0cb$var$c[30083] = "Richland";
$f6be72ae2d6fc0cb$var$c[5003] = "Ashley";
$f6be72ae2d6fc0cb$var$c[5041] = "Desha";
$f6be72ae2d6fc0cb$var$c[72147] = "Vieques";
$f6be72ae2d6fc0cb$var$c[47135] = "Perry";
$f6be72ae2d6fc0cb$var$c[27163] = "Washington";
$f6be72ae2d6fc0cb$var$c[51740] = "Portsmouth";
$f6be72ae2d6fc0cb$var$c[42051] = "Fayette";
$f6be72ae2d6fc0cb$var$c[54023] = "Grant";
$f6be72ae2d6fc0cb$var$c[51171] = "Shenandoah";
$f6be72ae2d6fc0cb$var$c[48235] = "Irion";
$f6be72ae2d6fc0cb$var$c[29025] = "Caldwell";
$f6be72ae2d6fc0cb$var$c[12107] = "Putnam";
$f6be72ae2d6fc0cb$var$c[18025] = "Crawford";
$f6be72ae2d6fc0cb$var$c[29111] = "Lewis";
$f6be72ae2d6fc0cb$var$c[31075] = "Grant";
$f6be72ae2d6fc0cb$var$c[72087] = "Lo\xedza";
$f6be72ae2d6fc0cb$var$c[16071] = "Oneida";
$f6be72ae2d6fc0cb$var$c[17139] = "Moultrie";
$f6be72ae2d6fc0cb$var$c[21107] = "Hopkins";
$f6be72ae2d6fc0cb$var$c[16035] = "Clearwater";
$f6be72ae2d6fc0cb$var$c[21013] = "Bell";
$f6be72ae2d6fc0cb$var$c[27035] = "Crow Wing";
$f6be72ae2d6fc0cb$var$c[60050] = "Western";
$f6be72ae2d6fc0cb$var$c[72011] = "A\xf1asco";
$f6be72ae2d6fc0cb$var$c[4009] = "Graham";
$f6be72ae2d6fc0cb$var$c[5123] = "St. Francis";
$f6be72ae2d6fc0cb$var$c[13101] = "Echols";
$f6be72ae2d6fc0cb$var$c[2070] = "Dillingham";
$f6be72ae2d6fc0cb$var$c[20105] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[20183] = "Smith";
$f6be72ae2d6fc0cb$var$c[12065] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[72041] = "Cidra";
$f6be72ae2d6fc0cb$var$c[28005] = "Amite";
$f6be72ae2d6fc0cb$var$c[5097] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[26025] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[1029] = "Cleburne";
$f6be72ae2d6fc0cb$var$c[8123] = "Weld";
$f6be72ae2d6fc0cb$var$c[40009] = "Beckham";
$f6be72ae2d6fc0cb$var$c[6049] = "Modoc";
$f6be72ae2d6fc0cb$var$c[19153] = "Polk";
$f6be72ae2d6fc0cb$var$c[13179] = "Liberty";
$f6be72ae2d6fc0cb$var$c[48349] = "Navarro";
$f6be72ae2d6fc0cb$var$c[48047] = "Brooks";
$f6be72ae2d6fc0cb$var$c[47187] = "Williamson";
$f6be72ae2d6fc0cb$var$c[56021] = "Laramie";
$f6be72ae2d6fc0cb$var$c[53003] = "Asotin";
$f6be72ae2d6fc0cb$var$c[27155] = "Traverse";
$f6be72ae2d6fc0cb$var$c[17017] = "Cass";
$f6be72ae2d6fc0cb$var$c[13247] = "Rockdale";
$f6be72ae2d6fc0cb$var$c[42067] = "Juniata";
$f6be72ae2d6fc0cb$var$c[42083] = "McKean";
$f6be72ae2d6fc0cb$var$c[40049] = "Garvin";
$f6be72ae2d6fc0cb$var$c[31021] = "Burt";
$f6be72ae2d6fc0cb$var$c[35045] = "San Juan";
$f6be72ae2d6fc0cb$var$c[36073] = "Orleans";
$f6be72ae2d6fc0cb$var$c[22031] = "De Soto";
$f6be72ae2d6fc0cb$var$c[6019] = "Fresno";
$f6be72ae2d6fc0cb$var$c[13105] = "Elbert";
$f6be72ae2d6fc0cb$var$c[1005] = "Barbour";
$f6be72ae2d6fc0cb$var$c[37017] = "Bladen";
$f6be72ae2d6fc0cb$var$c[48111] = "Dallam";
$f6be72ae2d6fc0cb$var$c[17167] = "Sangamon";
$f6be72ae2d6fc0cb$var$c[40035] = "Craig";
$f6be72ae2d6fc0cb$var$c[47035] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[26137] = "Otsego";
$f6be72ae2d6fc0cb$var$c[19161] = "Sac";
$f6be72ae2d6fc0cb$var$c[49015] = "Emery";
$f6be72ae2d6fc0cb$var$c[53019] = "Ferry";
$f6be72ae2d6fc0cb$var$c[30109] = "Wibaux";
$f6be72ae2d6fc0cb$var$c[35027] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[40021] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[27173] = "Yellow Medicine";
$f6be72ae2d6fc0cb$var$c[48231] = "Hunt";
$f6be72ae2d6fc0cb$var$c[48335] = "Mitchell";
$f6be72ae2d6fc0cb$var$c[48499] = "Wood";
$f6be72ae2d6fc0cb$var$c[40113] = "Osage";
$f6be72ae2d6fc0cb$var$c[37039] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[26107] = "Mecosta";
$f6be72ae2d6fc0cb$var$c[21195] = "Pike";
$f6be72ae2d6fc0cb$var$c[12067] = "Lafayette";
$f6be72ae2d6fc0cb$var$c[37035] = "Catawba";
$f6be72ae2d6fc0cb$var$c[21025] = "Breathitt";
$f6be72ae2d6fc0cb$var$c[48075] = "Childress";
$f6be72ae2d6fc0cb$var$c[29181] = "Ripley";
$f6be72ae2d6fc0cb$var$c[17179] = "Tazewell";
$f6be72ae2d6fc0cb$var$c[48243] = "Jeff Davis";
$f6be72ae2d6fc0cb$var$c[51678] = "Lexington";
$f6be72ae2d6fc0cb$var$c[5135] = "Sharp";
$f6be72ae2d6fc0cb$var$c[8069] = "Larimer";
$f6be72ae2d6fc0cb$var$c[37177] = "Tyrrell";
$f6be72ae2d6fc0cb$var$c[27131] = "Rice";
$f6be72ae2d6fc0cb$var$c[29219] = "Warren";
$f6be72ae2d6fc0cb$var$c[21227] = "Warren";
$f6be72ae2d6fc0cb$var$c[22017] = "Caddo";
$f6be72ae2d6fc0cb$var$c[46121] = "Todd";
$f6be72ae2d6fc0cb$var$c[19127] = "Marshall";
$f6be72ae2d6fc0cb$var$c[40141] = "Tillman";
$f6be72ae2d6fc0cb$var$c[37113] = "Macon";
$f6be72ae2d6fc0cb$var$c[54063] = "Monroe";
$f6be72ae2d6fc0cb$var$c[18155] = "Switzerland";
$f6be72ae2d6fc0cb$var$c[21105] = "Hickman";
$f6be72ae2d6fc0cb$var$c[1061] = "Geneva";
$f6be72ae2d6fc0cb$var$c[17099] = "LaSalle";
$f6be72ae2d6fc0cb$var$c[19055] = "Delaware";
$f6be72ae2d6fc0cb$var$c[20127] = "Morris";
$f6be72ae2d6fc0cb$var$c[19051] = "Davis";
$f6be72ae2d6fc0cb$var$c[16015] = "Boise";
$f6be72ae2d6fc0cb$var$c[55081] = "Monroe";
$f6be72ae2d6fc0cb$var$c[37143] = "Perquimans";
$f6be72ae2d6fc0cb$var$c[12047] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[2170] = "Matanuska-Susitna";
$f6be72ae2d6fc0cb$var$c[18035] = "Delaware";
$f6be72ae2d6fc0cb$var$c[12075] = "Levy";
$f6be72ae2d6fc0cb$var$c[72063] = "Gurabo";
$f6be72ae2d6fc0cb$var$c[72065] = "Hatillo";
$f6be72ae2d6fc0cb$var$c[28045] = "Hancock";
$f6be72ae2d6fc0cb$var$c[13315] = "Wilcox";
$f6be72ae2d6fc0cb$var$c[22081] = "Red River";
$f6be72ae2d6fc0cb$var$c[47093] = "Knox";
$f6be72ae2d6fc0cb$var$c[23017] = "Oxford";
$f6be72ae2d6fc0cb$var$c[29095] = "Jackson";
$f6be72ae2d6fc0cb$var$c[13281] = "Towns";
$f6be72ae2d6fc0cb$var$c[28129] = "Smith";
$f6be72ae2d6fc0cb$var$c[16075] = "Payette";
$f6be72ae2d6fc0cb$var$c[16079] = "Shoshone";
$f6be72ae2d6fc0cb$var$c[37095] = "Hyde";
$f6be72ae2d6fc0cb$var$c[19067] = "Floyd";
$f6be72ae2d6fc0cb$var$c[21145] = "McCracken";
$f6be72ae2d6fc0cb$var$c[21225] = "Union";
$f6be72ae2d6fc0cb$var$c[46125] = "Turner";
$f6be72ae2d6fc0cb$var$c[47029] = "Cocke";
$f6be72ae2d6fc0cb$var$c[47067] = "Hancock";
$f6be72ae2d6fc0cb$var$c[47071] = "Hardin";
$f6be72ae2d6fc0cb$var$c[45067] = "Marion";
$f6be72ae2d6fc0cb$var$c[72057] = "Guayama";
$f6be72ae2d6fc0cb$var$c[22117] = "Washington";
$f6be72ae2d6fc0cb$var$c[29207] = "Stoddard";
$f6be72ae2d6fc0cb$var$c[13093] = "Dooly";
$f6be72ae2d6fc0cb$var$c[27145] = "Stearns";
$f6be72ae2d6fc0cb$var$c[31155] = "Saunders";
$f6be72ae2d6fc0cb$var$c[27141] = "Sherburne";
$f6be72ae2d6fc0cb$var$c[46035] = "Davison";
$f6be72ae2d6fc0cb$var$c[47025] = "Claiborne";
$f6be72ae2d6fc0cb$var$c[48337] = "Montague";
$f6be72ae2d6fc0cb$var$c[48049] = "Brown";
$f6be72ae2d6fc0cb$var$c[55101] = "Racine";
$f6be72ae2d6fc0cb$var$c[55115] = "Shawano";
$f6be72ae2d6fc0cb$var$c[19009] = "Audubon";
$f6be72ae2d6fc0cb$var$c[48207] = "Haskell";
$f6be72ae2d6fc0cb$var$c[40083] = "Logan";
$f6be72ae2d6fc0cb$var$c[36065] = "Oneida";
$f6be72ae2d6fc0cb$var$c[8065] = "Lake";
$f6be72ae2d6fc0cb$var$c[40121] = "Pittsburg";
$f6be72ae2d6fc0cb$var$c[54017] = "Doddridge";
$f6be72ae2d6fc0cb$var$c[54105] = "Wirt";
$f6be72ae2d6fc0cb$var$c[33003] = "Carroll";
$f6be72ae2d6fc0cb$var$c[54095] = "Tyler";
$f6be72ae2d6fc0cb$var$c[69085] = "Northern Islands";
$f6be72ae2d6fc0cb$var$c[27079] = "Le Sueur";
$f6be72ae2d6fc0cb$var$c[53017] = "Douglas";
$f6be72ae2d6fc0cb$var$c[36009] = "Cattaraugus";
$f6be72ae2d6fc0cb$var$c[55027] = "Dodge";
$f6be72ae2d6fc0cb$var$c[19105] = "Jones";
$f6be72ae2d6fc0cb$var$c[20007] = "Barber";
$f6be72ae2d6fc0cb$var$c[29169] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[1045] = "Dale";
$f6be72ae2d6fc0cb$var$c[20109] = "Logan";
$f6be72ae2d6fc0cb$var$c[6039] = "Madera";
$f6be72ae2d6fc0cb$var$c[29075] = "Gentry";
$f6be72ae2d6fc0cb$var$c[31009] = "Blaine";
$f6be72ae2d6fc0cb$var$c[49009] = "Daggett";
$f6be72ae2d6fc0cb$var$c[56031] = "Platte";
$f6be72ae2d6fc0cb$var$c[37071] = "Gaston";
$f6be72ae2d6fc0cb$var$c[35019] = "Guadalupe";
$f6be72ae2d6fc0cb$var$c[30037] = "Golden Valley";
$f6be72ae2d6fc0cb$var$c[37101] = "Johnston";
$f6be72ae2d6fc0cb$var$c[6085] = "Santa Clara";
$f6be72ae2d6fc0cb$var$c[45019] = "Charleston";
$f6be72ae2d6fc0cb$var$c[53005] = "Benton";
$f6be72ae2d6fc0cb$var$c[29001] = "Adair";
$f6be72ae2d6fc0cb$var$c[39043] = "Erie";
$f6be72ae2d6fc0cb$var$c[17183] = "Vermilion";
$f6be72ae2d6fc0cb$var$c[29189] = "St. Louis";
$f6be72ae2d6fc0cb$var$c[17007] = "Boone";
$f6be72ae2d6fc0cb$var$c[6103] = "Tehama";
$f6be72ae2d6fc0cb$var$c[55025] = "Dane";
$f6be72ae2d6fc0cb$var$c[48151] = "Fisher";
$f6be72ae2d6fc0cb$var$c[22085] = "Sabine";
$f6be72ae2d6fc0cb$var$c[17137] = "Morgan";
$f6be72ae2d6fc0cb$var$c[13235] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[37015] = "Bertie";
$f6be72ae2d6fc0cb$var$c[37167] = "Stanly";
$f6be72ae2d6fc0cb$var$c[47143] = "Rhea";
$f6be72ae2d6fc0cb$var$c[37079] = "Greene";
$f6be72ae2d6fc0cb$var$c[21131] = "Leslie";
$f6be72ae2d6fc0cb$var$c[24039] = "Somerset";
$f6be72ae2d6fc0cb$var$c[17123] = "Marshall";
$f6be72ae2d6fc0cb$var$c[21143] = "Lyon";
$f6be72ae2d6fc0cb$var$c[48095] = "Concho";
$f6be72ae2d6fc0cb$var$c[48081] = "Coke";
$f6be72ae2d6fc0cb$var$c[47133] = "Overton";
$f6be72ae2d6fc0cb$var$c[26063] = "Huron";
$f6be72ae2d6fc0cb$var$c[26069] = "Iosco";
$f6be72ae2d6fc0cb$var$c[13069] = "Coffee";
$f6be72ae2d6fc0cb$var$c[13299] = "Ware";
$f6be72ae2d6fc0cb$var$c[38037] = "Grant";
$f6be72ae2d6fc0cb$var$c[22051] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[22103] = "St. Tammany";
$f6be72ae2d6fc0cb$var$c[19083] = "Hardin";
$f6be72ae2d6fc0cb$var$c[22023] = "Cameron";
$f6be72ae2d6fc0cb$var$c[39027] = "Clinton";
$f6be72ae2d6fc0cb$var$c[27137] = "St. Louis";
$f6be72ae2d6fc0cb$var$c[39093] = "Lorain";
$f6be72ae2d6fc0cb$var$c[72143] = "Vega Alta";
$f6be72ae2d6fc0cb$var$c[19015] = "Boone";
$f6be72ae2d6fc0cb$var$c[48373] = "Polk";
$f6be72ae2d6fc0cb$var$c[31051] = "Dixon";
$f6be72ae2d6fc0cb$var$c[24025] = "Harford";
$f6be72ae2d6fc0cb$var$c[45037] = "Edgefield";
$f6be72ae2d6fc0cb$var$c[51001] = "Accomack";
$f6be72ae2d6fc0cb$var$c[55015] = "Calumet";
$f6be72ae2d6fc0cb$var$c[21121] = "Knox";
$f6be72ae2d6fc0cb$var$c[26067] = "Ionia";
$f6be72ae2d6fc0cb$var$c[37129] = "New Hanover";
$f6be72ae2d6fc0cb$var$c[47131] = "Obion";
$f6be72ae2d6fc0cb$var$c[21035] = "Calloway";
$f6be72ae2d6fc0cb$var$c[51003] = "Albemarle";
$f6be72ae2d6fc0cb$var$c[47147] = "Robertson";
$f6be72ae2d6fc0cb$var$c[51043] = "Clarke";
$f6be72ae2d6fc0cb$var$c[53023] = "Garfield";
$f6be72ae2d6fc0cb$var$c[21109] = "Jackson";
$f6be72ae2d6fc0cb$var$c[27031] = "Cook";
$f6be72ae2d6fc0cb$var$c[45073] = "Oconee";
$f6be72ae2d6fc0cb$var$c[22033] = "East Baton Rouge";
$f6be72ae2d6fc0cb$var$c[28021] = "Claiborne";
$f6be72ae2d6fc0cb$var$c[24037] = "St. Mary's";
$f6be72ae2d6fc0cb$var$c[26081] = "Kent";
$f6be72ae2d6fc0cb$var$c[37147] = "Pitt";
$f6be72ae2d6fc0cb$var$c[30009] = "Carbon";
$f6be72ae2d6fc0cb$var$c[31167] = "Stanton";
$f6be72ae2d6fc0cb$var$c[13001] = "Appling";
$f6be72ae2d6fc0cb$var$c[19099] = "Jasper";
$f6be72ae2d6fc0cb$var$c[28153] = "Wayne";
$f6be72ae2d6fc0cb$var$c[48101] = "Cottle";
$f6be72ae2d6fc0cb$var$c[51081] = "Greensville";
$f6be72ae2d6fc0cb$var$c[12105] = "Polk";
$f6be72ae2d6fc0cb$var$c[48503] = "Young";
$f6be72ae2d6fc0cb$var$c[1123] = "Tallapoosa";
$f6be72ae2d6fc0cb$var$c[33015] = "Rockingham";
$f6be72ae2d6fc0cb$var$c[8105] = "Rio Grande";
$f6be72ae2d6fc0cb$var$c[19149] = "Plymouth";
$f6be72ae2d6fc0cb$var$c[36123] = "Yates";
$f6be72ae2d6fc0cb$var$c[53033] = "King";
$f6be72ae2d6fc0cb$var$c[41017] = "Deschutes";
$f6be72ae2d6fc0cb$var$c[19155] = "Pottawattamie";
$f6be72ae2d6fc0cb$var$c[29229] = "Wright";
$f6be72ae2d6fc0cb$var$c[30101] = "Toole";
$f6be72ae2d6fc0cb$var$c[36107] = "Tioga";
$f6be72ae2d6fc0cb$var$c[48287] = "Lee";
$f6be72ae2d6fc0cb$var$c[13121] = "Fulton";
$f6be72ae2d6fc0cb$var$c[48073] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[29007] = "Audrain";
$f6be72ae2d6fc0cb$var$c[45029] = "Colleton";
$f6be72ae2d6fc0cb$var$c[55055] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[5055] = "Greene";
$f6be72ae2d6fc0cb$var$c[48191] = "Hall";
$f6be72ae2d6fc0cb$var$c[55013] = "Burnett";
$f6be72ae2d6fc0cb$var$c[35057] = "Torrance";
$f6be72ae2d6fc0cb$var$c[53049] = "Pacific";
$f6be72ae2d6fc0cb$var$c[37141] = "Pender";
$f6be72ae2d6fc0cb$var$c[48221] = "Hood";
$f6be72ae2d6fc0cb$var$c[46117] = "Stanley";
$f6be72ae2d6fc0cb$var$c[32031] = "Washoe";
$f6be72ae2d6fc0cb$var$c[21007] = "Ballard";
$f6be72ae2d6fc0cb$var$c[48009] = "Archer";
$f6be72ae2d6fc0cb$var$c[48023] = "Baylor";
$f6be72ae2d6fc0cb$var$c[48405] = "San Augustine";
$f6be72ae2d6fc0cb$var$c[32029] = "Storey";
$f6be72ae2d6fc0cb$var$c[13249] = "Schley";
$f6be72ae2d6fc0cb$var$c[9001] = "Fairfield";
$f6be72ae2d6fc0cb$var$c[48313] = "Madison";
$f6be72ae2d6fc0cb$var$c[6077] = "San Joaquin";
$f6be72ae2d6fc0cb$var$c[28159] = "Winston";
$f6be72ae2d6fc0cb$var$c[21103] = "Henry";
$f6be72ae2d6fc0cb$var$c[21167] = "Mercer";
$f6be72ae2d6fc0cb$var$c[31183] = "Wheeler";
$f6be72ae2d6fc0cb$var$c[21135] = "Lewis";
$f6be72ae2d6fc0cb$var$c[27051] = "Grant";
$f6be72ae2d6fc0cb$var$c[28053] = "Humphreys";
$f6be72ae2d6fc0cb$var$c[1025] = "Clarke";
$f6be72ae2d6fc0cb$var$c[20017] = "Chase";
$f6be72ae2d6fc0cb$var$c[21221] = "Trigg";
$f6be72ae2d6fc0cb$var$c[1069] = "Houston";
$f6be72ae2d6fc0cb$var$c[46003] = "Aurora";
$f6be72ae2d6fc0cb$var$c[2013] = "Aleutians East";
$f6be72ae2d6fc0cb$var$c[31061] = "Franklin";
$f6be72ae2d6fc0cb$var$c[24029] = "Kent";
$f6be72ae2d6fc0cb$var$c[20037] = "Crawford";
$f6be72ae2d6fc0cb$var$c[27023] = "Chippewa";
$f6be72ae2d6fc0cb$var$c[46103] = "Pennington";
$f6be72ae2d6fc0cb$var$c[45049] = "Hampton";
$f6be72ae2d6fc0cb$var$c[16043] = "Fremont";
$f6be72ae2d6fc0cb$var$c[13029] = "Bryan";
$f6be72ae2d6fc0cb$var$c[51053] = "Dinwiddie";
$f6be72ae2d6fc0cb$var$c[12111] = "St. Lucie";
$f6be72ae2d6fc0cb$var$c[36055] = "Monroe";
$f6be72ae2d6fc0cb$var$c[46083] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[55017] = "Chippewa";
$f6be72ae2d6fc0cb$var$c[20207] = "Woodson";
$f6be72ae2d6fc0cb$var$c[21157] = "Marshall";
$f6be72ae2d6fc0cb$var$c[13065] = "Clinch";
$f6be72ae2d6fc0cb$var$c[13185] = "Lowndes";
$f6be72ae2d6fc0cb$var$c[15005] = "Kalawao";
$f6be72ae2d6fc0cb$var$c[15007] = "Kauai";
$f6be72ae2d6fc0cb$var$c[26099] = "Macomb";
$f6be72ae2d6fc0cb$var$c[13287] = "Turner";
$f6be72ae2d6fc0cb$var$c[17079] = "Jasper";
$f6be72ae2d6fc0cb$var$c[48331] = "Milam";
$f6be72ae2d6fc0cb$var$c[18147] = "Spencer";
$f6be72ae2d6fc0cb$var$c[21099] = "Hart";
$f6be72ae2d6fc0cb$var$c[21137] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[30005] = "Blaine";
$f6be72ae2d6fc0cb$var$c[51710] = "Norfolk";
$f6be72ae2d6fc0cb$var$c[48389] = "Reeves";
$f6be72ae2d6fc0cb$var$c[51155] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[37179] = "Union";
$f6be72ae2d6fc0cb$var$c[38053] = "McKenzie";
$f6be72ae2d6fc0cb$var$c[12091] = "Okaloosa";
$f6be72ae2d6fc0cb$var$c[6001] = "Alameda";
$f6be72ae2d6fc0cb$var$c[17013] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[18085] = "Kosciusko";
$f6be72ae2d6fc0cb$var$c[28103] = "Noxubee";
$f6be72ae2d6fc0cb$var$c[5147] = "Woodruff";
$f6be72ae2d6fc0cb$var$c[34015] = "Gloucester";
$f6be72ae2d6fc0cb$var$c[33011] = "Hillsborough";
$f6be72ae2d6fc0cb$var$c[30045] = "Judith Basin";
$f6be72ae2d6fc0cb$var$c[37121] = "Mitchell";
$f6be72ae2d6fc0cb$var$c[30077] = "Powell";
$f6be72ae2d6fc0cb$var$c[41053] = "Polk";
$f6be72ae2d6fc0cb$var$c[41065] = "Wasco";
$f6be72ae2d6fc0cb$var$c[46105] = "Perkins";
$f6be72ae2d6fc0cb$var$c[19173] = "Taylor";
$f6be72ae2d6fc0cb$var$c[1129] = "Washington";
$f6be72ae2d6fc0cb$var$c[39039] = "Defiance";
$f6be72ae2d6fc0cb$var$c[54025] = "Greenbrier";
$f6be72ae2d6fc0cb$var$c[17121] = "Marion";
$f6be72ae2d6fc0cb$var$c[51051] = "Dickenson";
$f6be72ae2d6fc0cb$var$c[51007] = "Amelia";
$f6be72ae2d6fc0cb$var$c[13243] = "Randolph";
$f6be72ae2d6fc0cb$var$c[35029] = "Luna";
$f6be72ae2d6fc0cb$var$c[48355] = "Nueces";
$f6be72ae2d6fc0cb$var$c[56045] = "Weston";
$f6be72ae2d6fc0cb$var$c[72137] = "Toa Baja";
$f6be72ae2d6fc0cb$var$c[17187] = "Warren";
$f6be72ae2d6fc0cb$var$c[1089] = "Madison";
$f6be72ae2d6fc0cb$var$c[47189] = "Wilson";
$f6be72ae2d6fc0cb$var$c[48063] = "Camp";
$f6be72ae2d6fc0cb$var$c[40067] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[54085] = "Ritchie";
$f6be72ae2d6fc0cb$var$c[19145] = "Page";
$f6be72ae2d6fc0cb$var$c[20087] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[22045] = "Iberia";
$f6be72ae2d6fc0cb$var$c[2158] = "Kusilvak";
$f6be72ae2d6fc0cb$var$c[37133] = "Onslow";
$f6be72ae2d6fc0cb$var$c[27043] = "Faribault";
$f6be72ae2d6fc0cb$var$c[47057] = "Grainger";
$f6be72ae2d6fc0cb$var$c[48161] = "Freestone";
$f6be72ae2d6fc0cb$var$c[42087] = "Mifflin";
$f6be72ae2d6fc0cb$var$c[1041] = "Crenshaw";
$f6be72ae2d6fc0cb$var$c[51520] = "Bristol";
$f6be72ae2d6fc0cb$var$c[48399] = "Runnels";
$f6be72ae2d6fc0cb$var$c[48443] = "Terrell";
$f6be72ae2d6fc0cb$var$c[20153] = "Rawlins";
$f6be72ae2d6fc0cb$var$c[20193] = "Thomas";
$f6be72ae2d6fc0cb$var$c[13161] = "Jeff Davis";
$f6be72ae2d6fc0cb$var$c[19035] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[5145] = "White";
$f6be72ae2d6fc0cb$var$c[28083] = "Leflore";
$f6be72ae2d6fc0cb$var$c[29053] = "Cooper";
$f6be72ae2d6fc0cb$var$c[26043] = "Dickinson";
$f6be72ae2d6fc0cb$var$c[17197] = "Will";
$f6be72ae2d6fc0cb$var$c[48117] = "Deaf Smith";
$f6be72ae2d6fc0cb$var$c[46011] = "Brookings";
$f6be72ae2d6fc0cb$var$c[29047] = "Clay";
$f6be72ae2d6fc0cb$var$c[28027] = "Coahoma";
$f6be72ae2d6fc0cb$var$c[18011] = "Boone";
$f6be72ae2d6fc0cb$var$c[19057] = "Des Moines";
$f6be72ae2d6fc0cb$var$c[19163] = "Scott";
$f6be72ae2d6fc0cb$var$c[20143] = "Ottawa";
$f6be72ae2d6fc0cb$var$c[12023] = "Columbia";
$f6be72ae2d6fc0cb$var$c[12059] = "Holmes";
$f6be72ae2d6fc0cb$var$c[28047] = "Harrison";
$f6be72ae2d6fc0cb$var$c[72141] = "Utuado";
$f6be72ae2d6fc0cb$var$c[47011] = "Bradley";
$f6be72ae2d6fc0cb$var$c[27017] = "Carlton";
$f6be72ae2d6fc0cb$var$c[48315] = "Marion";
$f6be72ae2d6fc0cb$var$c[36095] = "Schoharie";
$f6be72ae2d6fc0cb$var$c[40117] = "Pawnee";
$f6be72ae2d6fc0cb$var$c[36007] = "Broome";
$f6be72ae2d6fc0cb$var$c[48291] = "Liberty";
$f6be72ae2d6fc0cb$var$c[39009] = "Athens";
$f6be72ae2d6fc0cb$var$c[39081] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[54083] = "Randolph";
$f6be72ae2d6fc0cb$var$c[54049] = "Marion";
$f6be72ae2d6fc0cb$var$c[34011] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[6057] = "Nevada";
$f6be72ae2d6fc0cb$var$c[55031] = "Douglas";
$f6be72ae2d6fc0cb$var$c[21199] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[37065] = "Edgecombe";
$f6be72ae2d6fc0cb$var$c[48241] = "Jasper";
$f6be72ae2d6fc0cb$var$c[49001] = "Beaver";
$f6be72ae2d6fc0cb$var$c[13213] = "Murray";
$f6be72ae2d6fc0cb$var$c[18075] = "Jay";
$f6be72ae2d6fc0cb$var$c[26117] = "Montcalm";
$f6be72ae2d6fc0cb$var$c[36083] = "Rensselaer";
$f6be72ae2d6fc0cb$var$c[12021] = "Collier";
$f6be72ae2d6fc0cb$var$c[35031] = "McKinley";
$f6be72ae2d6fc0cb$var$c[13017] = "Ben Hill";
$f6be72ae2d6fc0cb$var$c[5077] = "Lee";
$f6be72ae2d6fc0cb$var$c[12003] = "Baker";
$f6be72ae2d6fc0cb$var$c[13173] = "Lanier";
$f6be72ae2d6fc0cb$var$c[20159] = "Rice";
$f6be72ae2d6fc0cb$var$c[1015] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[28059] = "Jackson";
$f6be72ae2d6fc0cb$var$c[21037] = "Campbell";
$f6be72ae2d6fc0cb$var$c[21057] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[28107] = "Panola";
$f6be72ae2d6fc0cb$var$c[48195] = "Hansford";
$f6be72ae2d6fc0cb$var$c[48071] = "Chambers";
$f6be72ae2d6fc0cb$var$c[13239] = "Quitman";
$f6be72ae2d6fc0cb$var$c[48199] = "Hardin";
$f6be72ae2d6fc0cb$var$c[9005] = "Litchfield";
$f6be72ae2d6fc0cb$var$c[39143] = "Sandusky";
$f6be72ae2d6fc0cb$var$c[23021] = "Piscataquis";
$f6be72ae2d6fc0cb$var$c[17153] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[40107] = "Okfuskee";
$f6be72ae2d6fc0cb$var$c[26145] = "Saginaw";
$f6be72ae2d6fc0cb$var$c[35039] = "Rio Arriba";
$f6be72ae2d6fc0cb$var$c[50005] = "Caledonia";
$f6be72ae2d6fc0cb$var$c[51023] = "Botetourt";
$f6be72ae2d6fc0cb$var$c[17119] = "Madison";
$f6be72ae2d6fc0cb$var$c[48085] = "Collin";
$f6be72ae2d6fc0cb$var$c[45001] = "Abbeville";
$f6be72ae2d6fc0cb$var$c[31053] = "Dodge";
$f6be72ae2d6fc0cb$var$c[12115] = "Sarasota";
$f6be72ae2d6fc0cb$var$c[55077] = "Marquette";
$f6be72ae2d6fc0cb$var$c[4015] = "Mohave";
$f6be72ae2d6fc0cb$var$c[4025] = "Yavapai";
$f6be72ae2d6fc0cb$var$c[45051] = "Horry";
$f6be72ae2d6fc0cb$var$c[42091] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[16061] = "Lewis";
$f6be72ae2d6fc0cb$var$c[72013] = "Arecibo";
$f6be72ae2d6fc0cb$var$c[51720] = "Norton";
$f6be72ae2d6fc0cb$var$c[34027] = "Morris";
$f6be72ae2d6fc0cb$var$c[29211] = "Sullivan";
$f6be72ae2d6fc0cb$var$c[20135] = "Ness";
$f6be72ae2d6fc0cb$var$c[48039] = "Brazoria";
$f6be72ae2d6fc0cb$var$c[51790] = "Staunton";
$f6be72ae2d6fc0cb$var$c[31029] = "Chase";
$f6be72ae2d6fc0cb$var$c[39113] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[48447] = "Throckmorton";
$f6be72ae2d6fc0cb$var$c[13221] = "Oglethorpe";
$f6be72ae2d6fc0cb$var$c[5029] = "Conway";
$f6be72ae2d6fc0cb$var$c[29147] = "Nodaway";
$f6be72ae2d6fc0cb$var$c[38073] = "Ransom";
$f6be72ae2d6fc0cb$var$c[26017] = "Bay";
$f6be72ae2d6fc0cb$var$c[47157] = "Shelby";
$f6be72ae2d6fc0cb$var$c[6007] = "Butte";
$f6be72ae2d6fc0cb$var$c[27115] = "Pine";
$f6be72ae2d6fc0cb$var$c[48021] = "Bastrop";
$f6be72ae2d6fc0cb$var$c[53039] = "Klickitat";
$f6be72ae2d6fc0cb$var$c[53055] = "San Juan";
$f6be72ae2d6fc0cb$var$c[55009] = "Brown";
$f6be72ae2d6fc0cb$var$c[20205] = "Wilson";
$f6be72ae2d6fc0cb$var$c[22069] = "Natchitoches";
$f6be72ae2d6fc0cb$var$c[22109] = "Terrebonne";
$f6be72ae2d6fc0cb$var$c[13155] = "Irwin";
$f6be72ae2d6fc0cb$var$c[2185] = "North Slope";
$f6be72ae2d6fc0cb$var$c[26011] = "Arenac";
$f6be72ae2d6fc0cb$var$c[19111] = "Lee";
$f6be72ae2d6fc0cb$var$c[20141] = "Osborne";
$f6be72ae2d6fc0cb$var$c[26047] = "Emmet";
$f6be72ae2d6fc0cb$var$c[19071] = "Fremont";
$f6be72ae2d6fc0cb$var$c[23015] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[36099] = "Seneca";
$f6be72ae2d6fc0cb$var$c[21125] = "Laurel";
$f6be72ae2d6fc0cb$var$c[47121] = "Meigs";
$f6be72ae2d6fc0cb$var$c[29213] = "Taney";
$f6be72ae2d6fc0cb$var$c[13269] = "Taylor";
$f6be72ae2d6fc0cb$var$c[51830] = "Williamsburg";
$f6be72ae2d6fc0cb$var$c[48415] = "Scurry";
$f6be72ae2d6fc0cb$var$c[8047] = "Gilpin";
$f6be72ae2d6fc0cb$var$c[40087] = "McClain";
$f6be72ae2d6fc0cb$var$c[54071] = "Pendleton";
$f6be72ae2d6fc0cb$var$c[51139] = "Page";
$f6be72ae2d6fc0cb$var$c[40079] = "Le Flore";
$f6be72ae2d6fc0cb$var$c[54089] = "Summers";
$f6be72ae2d6fc0cb$var$c[37119] = "Mecklenburg";
$f6be72ae2d6fc0cb$var$c[34013] = "Essex";
$f6be72ae2d6fc0cb$var$c[29115] = "Linn";
$f6be72ae2d6fc0cb$var$c[13209] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[41055] = "Sherman";
$f6be72ae2d6fc0cb$var$c[13133] = "Greene";
$f6be72ae2d6fc0cb$var$c[46017] = "Buffalo";
$f6be72ae2d6fc0cb$var$c[46095] = "Mellette";
$f6be72ae2d6fc0cb$var$c[48135] = "Ector";
$f6be72ae2d6fc0cb$var$c[48293] = "Limestone";
$f6be72ae2d6fc0cb$var$c[53027] = "Grays Harbor";
$f6be72ae2d6fc0cb$var$c[54003] = "Berkeley";
$f6be72ae2d6fc0cb$var$c[72149] = "Villalba";
$f6be72ae2d6fc0cb$var$c[30067] = "Park";
$f6be72ae2d6fc0cb$var$c[48121] = "Denton";
$f6be72ae2d6fc0cb$var$c[45021] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[37199] = "Yancey";
$f6be72ae2d6fc0cb$var$c[48387] = "Red River";
$f6be72ae2d6fc0cb$var$c[48321] = "Matagorda";
$f6be72ae2d6fc0cb$var$c[27149] = "Stevens";
$f6be72ae2d6fc0cb$var$c[13301] = "Warren";
$f6be72ae2d6fc0cb$var$c[48197] = "Hardeman";
$f6be72ae2d6fc0cb$var$c[17133] = "Monroe";
$f6be72ae2d6fc0cb$var$c[13165] = "Jenkins";
$f6be72ae2d6fc0cb$var$c[21085] = "Grayson";
$f6be72ae2d6fc0cb$var$c[48363] = "Palo Pinto";
$f6be72ae2d6fc0cb$var$c[13149] = "Heard";
$f6be72ae2d6fc0cb$var$c[1079] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[72061] = "Guaynabo";
$f6be72ae2d6fc0cb$var$c[28093] = "Marshall";
$f6be72ae2d6fc0cb$var$c[20025] = "Clark";
$f6be72ae2d6fc0cb$var$c[20081] = "Haskell";
$f6be72ae2d6fc0cb$var$c[22013] = "Bienville";
$f6be72ae2d6fc0cb$var$c[13295] = "Walker";
$f6be72ae2d6fc0cb$var$c[19095] = "Iowa";
$f6be72ae2d6fc0cb$var$c[31019] = "Buffalo";
$f6be72ae2d6fc0cb$var$c[40007] = "Beaver";
$f6be72ae2d6fc0cb$var$c[19023] = "Butler";
$f6be72ae2d6fc0cb$var$c[30085] = "Roosevelt";
$f6be72ae2d6fc0cb$var$c[72017] = "Barceloneta";
$f6be72ae2d6fc0cb$var$c[53015] = "Cowlitz";
$f6be72ae2d6fc0cb$var$c[48297] = "Live Oak";
$f6be72ae2d6fc0cb$var$c[29135] = "Moniteau";
$f6be72ae2d6fc0cb$var$c[51193] = "Westmoreland";
$f6be72ae2d6fc0cb$var$c[37197] = "Yadkin";
$f6be72ae2d6fc0cb$var$c[6047] = "Merced";
$f6be72ae2d6fc0cb$var$c[40043] = "Dewey";
$f6be72ae2d6fc0cb$var$c[37023] = "Burke";
$f6be72ae2d6fc0cb$var$c[37191] = "Wayne";
$f6be72ae2d6fc0cb$var$c[42123] = "Warren";
$f6be72ae2d6fc0cb$var$c[5061] = "Howard";
$f6be72ae2d6fc0cb$var$c[37059] = "Davie";
$f6be72ae2d6fc0cb$var$c[37111] = "McDowell";
$f6be72ae2d6fc0cb$var$c[5099] = "Nevada";
$f6be72ae2d6fc0cb$var$c[8125] = "Yuma";
$f6be72ae2d6fc0cb$var$c[48421] = "Sherman";
$f6be72ae2d6fc0cb$var$c[48463] = "Uvalde";
$f6be72ae2d6fc0cb$var$c[39011] = "Auglaize";
$f6be72ae2d6fc0cb$var$c[22015] = "Bossier";
$f6be72ae2d6fc0cb$var$c[19063] = "Emmet";
$f6be72ae2d6fc0cb$var$c[20169] = "Saline";
$f6be72ae2d6fc0cb$var$c[21153] = "Magoffin";
$f6be72ae2d6fc0cb$var$c[48017] = "Bailey";
$f6be72ae2d6fc0cb$var$c[29027] = "Callaway";
$f6be72ae2d6fc0cb$var$c[56001] = "Albany";
$f6be72ae2d6fc0cb$var$c[56029] = "Park";
$f6be72ae2d6fc0cb$var$c[42093] = "Montour";
$f6be72ae2d6fc0cb$var$c[36081] = "Queens";
$f6be72ae2d6fc0cb$var$c[12121] = "Suwannee";
$f6be72ae2d6fc0cb$var$c[26031] = "Cheboygan";
$f6be72ae2d6fc0cb$var$c[26051] = "Gladwin";
$f6be72ae2d6fc0cb$var$c[21173] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[45057] = "Lancaster";
$f6be72ae2d6fc0cb$var$c[21123] = "Larue";
$f6be72ae2d6fc0cb$var$c[19193] = "Woodbury";
$f6be72ae2d6fc0cb$var$c[12123] = "Taylor";
$f6be72ae2d6fc0cb$var$c[17003] = "Alexander";
$f6be72ae2d6fc0cb$var$c[29099] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[29113] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[13051] = "Chatham";
$f6be72ae2d6fc0cb$var$c[12125] = "Union";
$f6be72ae2d6fc0cb$var$c[36037] = "Genesee";
$f6be72ae2d6fc0cb$var$c[19041] = "Clay";
$f6be72ae2d6fc0cb$var$c[30025] = "Fallon";
$f6be72ae2d6fc0cb$var$c[46107] = "Potter";
$f6be72ae2d6fc0cb$var$c[48109] = "Culberson";
$f6be72ae2d6fc0cb$var$c[23005] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[48013] = "Atascosa";
$f6be72ae2d6fc0cb$var$c[20095] = "Kingman";
$f6be72ae2d6fc0cb$var$c[13241] = "Rabun";
$f6be72ae2d6fc0cb$var$c[54097] = "Upshur";
$f6be72ae2d6fc0cb$var$c[29215] = "Texas";
$f6be72ae2d6fc0cb$var$c[5119] = "Pulaski";
$f6be72ae2d6fc0cb$var$c[19047] = "Crawford";
$f6be72ae2d6fc0cb$var$c[16005] = "Bannock";
$f6be72ae2d6fc0cb$var$c[39055] = "Geauga";
$f6be72ae2d6fc0cb$var$c[72035] = "Cayey";
$f6be72ae2d6fc0cb$var$c[6107] = "Tulare";
$f6be72ae2d6fc0cb$var$c[72015] = "Arroyo";
$f6be72ae2d6fc0cb$var$c[72125] = "San Germ\xe1n";
$f6be72ae2d6fc0cb$var$c[36117] = "Wayne";
$f6be72ae2d6fc0cb$var$c[51163] = "Rockbridge";
$f6be72ae2d6fc0cb$var$c[38095] = "Towner";
$f6be72ae2d6fc0cb$var$c[42045] = "Delaware";
$f6be72ae2d6fc0cb$var$c[36063] = "Niagara";
$f6be72ae2d6fc0cb$var$c[50003] = "Bennington";
$f6be72ae2d6fc0cb$var$c[12019] = "Clay";
$f6be72ae2d6fc0cb$var$c[37183] = "Wake";
$f6be72ae2d6fc0cb$var$c[39061] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[34003] = "Bergen";
$f6be72ae2d6fc0cb$var$c[32017] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[2180] = "Nome";
$f6be72ae2d6fc0cb$var$c[30055] = "McCone";
$f6be72ae2d6fc0cb$var$c[19019] = "Buchanan";
$f6be72ae2d6fc0cb$var$c[17043] = "DuPage";
$f6be72ae2d6fc0cb$var$c[46047] = "Fall River";
$f6be72ae2d6fc0cb$var$c[27069] = "Kittson";
$f6be72ae2d6fc0cb$var$c[13219] = "Oconee";
$f6be72ae2d6fc0cb$var$c[48493] = "Wilson";
$f6be72ae2d6fc0cb$var$c[31059] = "Fillmore";
$f6be72ae2d6fc0cb$var$c[12079] = "Madison";
$f6be72ae2d6fc0cb$var$c[72031] = "Carolina";
$f6be72ae2d6fc0cb$var$c[18153] = "Sullivan";
$f6be72ae2d6fc0cb$var$c[4012] = "La Paz";
$f6be72ae2d6fc0cb$var$c[13027] = "Brooks";
$f6be72ae2d6fc0cb$var$c[2016] = "Aleutians West";
$f6be72ae2d6fc0cb$var$c[2150] = "Kodiak Island";
$f6be72ae2d6fc0cb$var$c[20185] = "Stafford";
$f6be72ae2d6fc0cb$var$c[13271] = "Telfair";
$f6be72ae2d6fc0cb$var$c[26115] = "Monroe";
$f6be72ae2d6fc0cb$var$c[18181] = "White";
$f6be72ae2d6fc0cb$var$c[18113] = "Noble";
$f6be72ae2d6fc0cb$var$c[21139] = "Livingston";
$f6be72ae2d6fc0cb$var$c[13201] = "Miller";
$f6be72ae2d6fc0cb$var$c[47103] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[21211] = "Shelby";
$f6be72ae2d6fc0cb$var$c[31185] = "York";
$f6be72ae2d6fc0cb$var$c[42001] = "Adams";
$f6be72ae2d6fc0cb$var$c[45005] = "Allendale";
$f6be72ae2d6fc0cb$var$c[47037] = "Davidson";
$f6be72ae2d6fc0cb$var$c[49047] = "Uintah";
$f6be72ae2d6fc0cb$var$c[49049] = "Utah";
$f6be72ae2d6fc0cb$var$c[18021] = "Clay";
$f6be72ae2d6fc0cb$var$c[36047] = "Kings";
$f6be72ae2d6fc0cb$var$c[29141] = "Morgan";
$f6be72ae2d6fc0cb$var$c[39075] = "Holmes";
$f6be72ae2d6fc0cb$var$c[19143] = "Osceola";
$f6be72ae2d6fc0cb$var$c[18079] = "Jennings";
$f6be72ae2d6fc0cb$var$c[16083] = "Twin Falls";
$f6be72ae2d6fc0cb$var$c[17165] = "Saline";
$f6be72ae2d6fc0cb$var$c[26077] = "Kalamazoo";
$f6be72ae2d6fc0cb$var$c[45061] = "Lee";
$f6be72ae2d6fc0cb$var$c[56019] = "Johnson";
$f6be72ae2d6fc0cb$var$c[18027] = "Daviess";
$f6be72ae2d6fc0cb$var$c[26055] = "Grand Traverse";
$f6be72ae2d6fc0cb$var$c[22003] = "Allen";
$f6be72ae2d6fc0cb$var$c[46065] = "Hughes";
$f6be72ae2d6fc0cb$var$c[46069] = "Hyde";
$f6be72ae2d6fc0cb$var$c[45027] = "Clarendon";
$f6be72ae2d6fc0cb$var$c[30095] = "Stillwater";
$f6be72ae2d6fc0cb$var$c[47007] = "Bledsoe";
$f6be72ae2d6fc0cb$var$c[21219] = "Todd";
$f6be72ae2d6fc0cb$var$c[47183] = "Weakley";
$f6be72ae2d6fc0cb$var$c[29077] = "Greene";
$f6be72ae2d6fc0cb$var$c[42077] = "Lehigh";
$f6be72ae2d6fc0cb$var$c[31159] = "Seward";
$f6be72ae2d6fc0cb$var$c[36015] = "Chemung";
$f6be72ae2d6fc0cb$var$c[36121] = "Wyoming";
$f6be72ae2d6fc0cb$var$c[6099] = "Stanislaus";
$f6be72ae2d6fc0cb$var$c[42095] = "Northampton";
$f6be72ae2d6fc0cb$var$c[1103] = "Morgan";
$f6be72ae2d6fc0cb$var$c[21027] = "Breckinridge";
$f6be72ae2d6fc0cb$var$c[28043] = "Grenada";
$f6be72ae2d6fc0cb$var$c[21213] = "Simpson";
$f6be72ae2d6fc0cb$var$c[50013] = "Grand Isle";
$f6be72ae2d6fc0cb$var$c[39029] = "Columbiana";
$f6be72ae2d6fc0cb$var$c[51125] = "Nelson";
$f6be72ae2d6fc0cb$var$c[12097] = "Osceola";
$f6be72ae2d6fc0cb$var$c[5053] = "Grant";
$f6be72ae2d6fc0cb$var$c[13175] = "Laurens";
$f6be72ae2d6fc0cb$var$c[36061] = "New York";
$f6be72ae2d6fc0cb$var$c[5007] = "Benton";
$f6be72ae2d6fc0cb$var$c[72071] = "Isabela";
$f6be72ae2d6fc0cb$var$c[12083] = "Marion";
$f6be72ae2d6fc0cb$var$c[51135] = "Nottoway";
$f6be72ae2d6fc0cb$var$c[34041] = "Warren";
$f6be72ae2d6fc0cb$var$c[36021] = "Columbia";
$f6be72ae2d6fc0cb$var$c[51690] = "Martinsville";
$f6be72ae2d6fc0cb$var$c[40023] = "Choctaw";
$f6be72ae2d6fc0cb$var$c[20041] = "Dickinson";
$f6be72ae2d6fc0cb$var$c[48427] = "Starr";
$f6be72ae2d6fc0cb$var$c[13103] = "Effingham";
$f6be72ae2d6fc0cb$var$c[40129] = "Roger Mills";
$f6be72ae2d6fc0cb$var$c[55103] = "Richland";
$f6be72ae2d6fc0cb$var$c[35025] = "Lea";
$f6be72ae2d6fc0cb$var$c[1075] = "Lamar";
$f6be72ae2d6fc0cb$var$c[72054] = "Florida";
$f6be72ae2d6fc0cb$var$c[47117] = "Marshall";
$f6be72ae2d6fc0cb$var$c[51011] = "Appomattox";
$f6be72ae2d6fc0cb$var$c[5087] = "Madison";
$f6be72ae2d6fc0cb$var$c[56033] = "Sheridan";
$f6be72ae2d6fc0cb$var$c[42041] = "Cumberland";
$f6be72ae2d6fc0cb$var$c[42055] = "Franklin";
$f6be72ae2d6fc0cb$var$c[42079] = "Luzerne";
$f6be72ae2d6fc0cb$var$c[26039] = "Crawford";
$f6be72ae2d6fc0cb$var$c[1113] = "Russell";
$f6be72ae2d6fc0cb$var$c[39019] = "Carroll";
$f6be72ae2d6fc0cb$var$c[51065] = "Fluvanna";
$f6be72ae2d6fc0cb$var$c[17097] = "Lake";
$f6be72ae2d6fc0cb$var$c[13195] = "Madison";
$f6be72ae2d6fc0cb$var$c[5039] = "Dallas";
$f6be72ae2d6fc0cb$var$c[8057] = "Jackson";
$f6be72ae2d6fc0cb$var$c[8063] = "Kit Carson";
$f6be72ae2d6fc0cb$var$c[16073] = "Owyhee";
$f6be72ae2d6fc0cb$var$c[55141] = "Wood";
$f6be72ae2d6fc0cb$var$c[36013] = "Chautauqua";
$f6be72ae2d6fc0cb$var$c[13067] = "Cobb";
$f6be72ae2d6fc0cb$var$c[47091] = "Johnson";
$f6be72ae2d6fc0cb$var$c[39013] = "Belmont";
$f6be72ae2d6fc0cb$var$c[51195] = "Wise";
$f6be72ae2d6fc0cb$var$c[29035] = "Carter";
$f6be72ae2d6fc0cb$var$c[40013] = "Bryan";
$f6be72ae2d6fc0cb$var$c[31035] = "Clay";
$f6be72ae2d6fc0cb$var$c[24017] = "Charles";
$f6be72ae2d6fc0cb$var$c[19033] = "Cerro Gordo";
$f6be72ae2d6fc0cb$var$c[19073] = "Greene";
$f6be72ae2d6fc0cb$var$c[21205] = "Rowan";
$f6be72ae2d6fc0cb$var$c[49055] = "Wayne";
$f6be72ae2d6fc0cb$var$c[29031] = "Cape Girardeau";
$f6be72ae2d6fc0cb$var$c[53071] = "Walla Walla";
$f6be72ae2d6fc0cb$var$c[29133] = "Mississippi";
$f6be72ae2d6fc0cb$var$c[5025] = "Cleveland";
$f6be72ae2d6fc0cb$var$c[48113] = "Dallas";
$f6be72ae2d6fc0cb$var$c[72079] = "Lajas";
$f6be72ae2d6fc0cb$var$c[18033] = "DeKalb";
$f6be72ae2d6fc0cb$var$c[22073] = "Ouachita";
$f6be72ae2d6fc0cb$var$c[22095] = "St. John the Baptist";
$f6be72ae2d6fc0cb$var$c[22091] = "St. Helena";
$f6be72ae2d6fc0cb$var$c[29197] = "Schuyler";
$f6be72ae2d6fc0cb$var$c[1059] = "Franklin";
$f6be72ae2d6fc0cb$var$c[21041] = "Carroll";
$f6be72ae2d6fc0cb$var$c[8019] = "Clear Creek";
$f6be72ae2d6fc0cb$var$c[48267] = "Kimble";
$f6be72ae2d6fc0cb$var$c[26097] = "Mackinac";
$f6be72ae2d6fc0cb$var$c[48307] = "McCulloch";
$f6be72ae2d6fc0cb$var$c[28141] = "Tishomingo";
$f6be72ae2d6fc0cb$var$c[48105] = "Crockett";
$f6be72ae2d6fc0cb$var$c[48217] = "Hill";
$f6be72ae2d6fc0cb$var$c[8075] = "Logan";
$f6be72ae2d6fc0cb$var$c[20055] = "Finney";
$f6be72ae2d6fc0cb$var$c[20125] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[45039] = "Fairfield";
$f6be72ae2d6fc0cb$var$c[31033] = "Cheyenne";
$f6be72ae2d6fc0cb$var$c[27091] = "Martin";
$f6be72ae2d6fc0cb$var$c[47155] = "Sevier";
$f6be72ae2d6fc0cb$var$c[47139] = "Polk";
$f6be72ae2d6fc0cb$var$c[48263] = "Kent";
$f6be72ae2d6fc0cb$var$c[30099] = "Teton";
$f6be72ae2d6fc0cb$var$c[31069] = "Garden";
$f6be72ae2d6fc0cb$var$c[17117] = "Macoupin";
$f6be72ae2d6fc0cb$var$c[39141] = "Ross";
$f6be72ae2d6fc0cb$var$c[17195] = "Whiteside";
$f6be72ae2d6fc0cb$var$c[48141] = "El Paso";
$f6be72ae2d6fc0cb$var$c[48301] = "Loving";
$f6be72ae2d6fc0cb$var$c[40077] = "Latimer";
$f6be72ae2d6fc0cb$var$c[39167] = "Washington";
$f6be72ae2d6fc0cb$var$c[29091] = "Howell";
$f6be72ae2d6fc0cb$var$c[20047] = "Edwards";
$f6be72ae2d6fc0cb$var$c[21111] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[17107] = "Logan";
$f6be72ae2d6fc0cb$var$c[55139] = "Winnebago";
$f6be72ae2d6fc0cb$var$c[21075] = "Fulton";
$f6be72ae2d6fc0cb$var$c[20079] = "Harvey";
$f6be72ae2d6fc0cb$var$c[30021] = "Dawson";
$f6be72ae2d6fc0cb$var$c[54091] = "Taylor";
$f6be72ae2d6fc0cb$var$c[26111] = "Midland";
$f6be72ae2d6fc0cb$var$c[28119] = "Quitman";
$f6be72ae2d6fc0cb$var$c[21093] = "Hardin";
$f6be72ae2d6fc0cb$var$c[17081] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[46057] = "Hamlin";
$f6be72ae2d6fc0cb$var$c[55069] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[36033] = "Franklin";
$f6be72ae2d6fc0cb$var$c[51630] = "Fredericksburg";
$f6be72ae2d6fc0cb$var$c[54081] = "Raleigh";
$f6be72ae2d6fc0cb$var$c[35005] = "Chaves";
$f6be72ae2d6fc0cb$var$c[35049] = "Santa Fe";
$f6be72ae2d6fc0cb$var$c[6059] = "Orange";
$f6be72ae2d6fc0cb$var$c[4023] = "Santa Cruz";
$f6be72ae2d6fc0cb$var$c[37053] = "Currituck";
$f6be72ae2d6fc0cb$var$c[17101] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[18067] = "Howard";
$f6be72ae2d6fc0cb$var$c[18125] = "Pike";
$f6be72ae2d6fc0cb$var$c[21047] = "Christian";
$f6be72ae2d6fc0cb$var$c[26045] = "Eaton";
$f6be72ae2d6fc0cb$var$c[19179] = "Wapello";
$f6be72ae2d6fc0cb$var$c[6025] = "Imperial";
$f6be72ae2d6fc0cb$var$c[26027] = "Cass";
$f6be72ae2d6fc0cb$var$c[28157] = "Wilkinson";
$f6be72ae2d6fc0cb$var$c[2282] = "Yakutat";
$f6be72ae2d6fc0cb$var$c[20179] = "Sheridan";
$f6be72ae2d6fc0cb$var$c[28079] = "Leake";
$f6be72ae2d6fc0cb$var$c[72025] = "Caguas";
$f6be72ae2d6fc0cb$var$c[72027] = "Camuy";
$f6be72ae2d6fc0cb$var$c[28025] = "Clay";
$f6be72ae2d6fc0cb$var$c[28037] = "Franklin";
$f6be72ae2d6fc0cb$var$c[28099] = "Neshoba";
$f6be72ae2d6fc0cb$var$c[46045] = "Edmunds";
$f6be72ae2d6fc0cb$var$c[72119] = "R\xedo Grande";
$f6be72ae2d6fc0cb$var$c[1035] = "Conecuh";
$f6be72ae2d6fc0cb$var$c[18029] = "Dearborn";
$f6be72ae2d6fc0cb$var$c[18071] = "Jackson";
$f6be72ae2d6fc0cb$var$c[28081] = "Lee";
$f6be72ae2d6fc0cb$var$c[22125] = "West Feliciana";
$f6be72ae2d6fc0cb$var$c[5035] = "Crittenden";
$f6be72ae2d6fc0cb$var$c[12063] = "Jackson";
$f6be72ae2d6fc0cb$var$c[48125] = "Dickens";
$f6be72ae2d6fc0cb$var$c[51115] = "Mathews";
$f6be72ae2d6fc0cb$var$c[38075] = "Renville";
$f6be72ae2d6fc0cb$var$c[48283] = "La Salle";
$f6be72ae2d6fc0cb$var$c[36067] = "Onondaga";
$f6be72ae2d6fc0cb$var$c[19087] = "Henry";
$f6be72ae2d6fc0cb$var$c[31083] = "Harlan";
$f6be72ae2d6fc0cb$var$c[30075] = "Powder River";
$f6be72ae2d6fc0cb$var$c[72075] = "Juana D\xedaz";
$f6be72ae2d6fc0cb$var$c[55091] = "Pepin";
$f6be72ae2d6fc0cb$var$c[4001] = "Apache";
$f6be72ae2d6fc0cb$var$c[29121] = "Macon";
$f6be72ae2d6fc0cb$var$c[48279] = "Lamb";
$f6be72ae2d6fc0cb$var$c[20097] = "Kiowa";
$f6be72ae2d6fc0cb$var$c[48015] = "Austin";
$f6be72ae2d6fc0cb$var$c[29061] = "Daviess";
$f6be72ae2d6fc0cb$var$c[13253] = "Seminole";
$f6be72ae2d6fc0cb$var$c[26101] = "Manistee";
$f6be72ae2d6fc0cb$var$c[19119] = "Lyon";
$f6be72ae2d6fc0cb$var$c[48233] = "Hutchinson";
$f6be72ae2d6fc0cb$var$c[40139] = "Texas";
$f6be72ae2d6fc0cb$var$c[40153] = "Woodward";
$f6be72ae2d6fc0cb$var$c[19003] = "Adams";
$f6be72ae2d6fc0cb$var$c[6101] = "Sutter";
$f6be72ae2d6fc0cb$var$c[42105] = "Potter";
$f6be72ae2d6fc0cb$var$c[48465] = "Val Verde";
$f6be72ae2d6fc0cb$var$c[20077] = "Harper";
$f6be72ae2d6fc0cb$var$c[19133] = "Monona";
$f6be72ae2d6fc0cb$var$c[49023] = "Juab";
$f6be72ae2d6fc0cb$var$c[40137] = "Stephens";
$f6be72ae2d6fc0cb$var$c[36017] = "Chenango";
$f6be72ae2d6fc0cb$var$c[17143] = "Peoria";
$f6be72ae2d6fc0cb$var$c[19091] = "Humboldt";
$f6be72ae2d6fc0cb$var$c[31177] = "Washington";
$f6be72ae2d6fc0cb$var$c[55049] = "Iowa";
$f6be72ae2d6fc0cb$var$c[27097] = "Morrison";
$f6be72ae2d6fc0cb$var$c[42003] = "Allegheny";
$f6be72ae2d6fc0cb$var$c[29205] = "Shelby";
$f6be72ae2d6fc0cb$var$c[39097] = "Madison";
$f6be72ae2d6fc0cb$var$c[20201] = "Washington";
$f6be72ae2d6fc0cb$var$c[17019] = "Champaign";
$f6be72ae2d6fc0cb$var$c[16087] = "Washington";
$f6be72ae2d6fc0cb$var$c[17045] = "Edgar";
$f6be72ae2d6fc0cb$var$c[8121] = "Washington";
$f6be72ae2d6fc0cb$var$c[39065] = "Hardin";
$f6be72ae2d6fc0cb$var$c[26113] = "Missaukee";
$f6be72ae2d6fc0cb$var$c[38093] = "Stutsman";
$f6be72ae2d6fc0cb$var$c[29203] = "Shannon";
$f6be72ae2d6fc0cb$var$c[48423] = "Smith";
$f6be72ae2d6fc0cb$var$c[40143] = "Tulsa";
$f6be72ae2d6fc0cb$var$c[40091] = "McIntosh";
$f6be72ae2d6fc0cb$var$c[48395] = "Robertson";
$f6be72ae2d6fc0cb$var$c[48171] = "Gillespie";
$f6be72ae2d6fc0cb$var$c[26125] = "Oakland";
$f6be72ae2d6fc0cb$var$c[38033] = "Golden Valley";
$f6be72ae2d6fc0cb$var$c[56027] = "Niobrara";
$f6be72ae2d6fc0cb$var$c[27117] = "Pipestone";
$f6be72ae2d6fc0cb$var$c[51099] = "King George";
$f6be72ae2d6fc0cb$var$c[53025] = "Grant";
$f6be72ae2d6fc0cb$var$c[27129] = "Renville";
$f6be72ae2d6fc0cb$var$c[12001] = "Alachua";
$f6be72ae2d6fc0cb$var$c[31091] = "Hooker";
$f6be72ae2d6fc0cb$var$c[51147] = "Prince Edward";
$f6be72ae2d6fc0cb$var$c[49007] = "Carbon";
$f6be72ae2d6fc0cb$var$c[42017] = "Bucks";
$f6be72ae2d6fc0cb$var$c[46059] = "Hand";
$f6be72ae2d6fc0cb$var$c[42081] = "Lycoming";
$f6be72ae2d6fc0cb$var$c[16057] = "Latah";
$f6be72ae2d6fc0cb$var$c[13237] = "Putnam";
$f6be72ae2d6fc0cb$var$c[51640] = "Galax";
$f6be72ae2d6fc0cb$var$c[35037] = "Quay";
$f6be72ae2d6fc0cb$var$c[48269] = "King";
$f6be72ae2d6fc0cb$var$c[5073] = "Lafayette";
$f6be72ae2d6fc0cb$var$c[48451] = "Tom Green";
$f6be72ae2d6fc0cb$var$c[12049] = "Hardee";
$f6be72ae2d6fc0cb$var$c[39025] = "Clermont";
$f6be72ae2d6fc0cb$var$c[48501] = "Yoakum";
$f6be72ae2d6fc0cb$var$c[41071] = "Yamhill";
$f6be72ae2d6fc0cb$var$c[19115] = "Louisa";
$f6be72ae2d6fc0cb$var$c[20049] = "Elk";
$f6be72ae2d6fc0cb$var$c[39121] = "Noble";
$f6be72ae2d6fc0cb$var$c[39137] = "Putnam";
$f6be72ae2d6fc0cb$var$c[48425] = "Somervell";
$f6be72ae2d6fc0cb$var$c[42075] = "Lebanon";
$f6be72ae2d6fc0cb$var$c[30035] = "Glacier";
$f6be72ae2d6fc0cb$var$c[32027] = "Pershing";
$f6be72ae2d6fc0cb$var$c[27087] = "Mahnomen";
$f6be72ae2d6fc0cb$var$c[34031] = "Passaic";
$f6be72ae2d6fc0cb$var$c[30047] = "Lake";
$f6be72ae2d6fc0cb$var$c[48261] = "Kenedy";
$f6be72ae2d6fc0cb$var$c[48033] = "Borden";
$f6be72ae2d6fc0cb$var$c[29157] = "Perry";
$f6be72ae2d6fc0cb$var$c[48411] = "San Saba";
$f6be72ae2d6fc0cb$var$c[40073] = "Kingfisher";
$f6be72ae2d6fc0cb$var$c[48051] = "Burleson";
$f6be72ae2d6fc0cb$var$c[36035] = "Fulton";
$f6be72ae2d6fc0cb$var$c[28133] = "Sunflower";
$f6be72ae2d6fc0cb$var$c[27053] = "Hennepin";
$f6be72ae2d6fc0cb$var$c[42027] = "Centre";
$f6be72ae2d6fc0cb$var$c[48025] = "Bee";
$f6be72ae2d6fc0cb$var$c[47077] = "Henderson";
$f6be72ae2d6fc0cb$var$c[19171] = "Tama";
$f6be72ae2d6fc0cb$var$c[20175] = "Seward";
$f6be72ae2d6fc0cb$var$c[19135] = "Monroe";
$f6be72ae2d6fc0cb$var$c[31147] = "Richardson";
$f6be72ae2d6fc0cb$var$c[17021] = "Christian";
$f6be72ae2d6fc0cb$var$c[12089] = "Nassau";
$f6be72ae2d6fc0cb$var$c[12133] = "Washington";
$f6be72ae2d6fc0cb$var$c[13007] = "Baker";
$f6be72ae2d6fc0cb$var$c[13275] = "Thomas";
$f6be72ae2d6fc0cb$var$c[21005] = "Anderson";
$f6be72ae2d6fc0cb$var$c[21185] = "Oldham";
$f6be72ae2d6fc0cb$var$c[13057] = "Cherokee";
$f6be72ae2d6fc0cb$var$c[38065] = "Oliver";
$f6be72ae2d6fc0cb$var$c[26133] = "Osceola";
$f6be72ae2d6fc0cb$var$c[47109] = "McNairy";
$f6be72ae2d6fc0cb$var$c[53001] = "Adams";
$f6be72ae2d6fc0cb$var$c[29057] = "Dade";
$f6be72ae2d6fc0cb$var$c[22101] = "St. Mary";
$f6be72ae2d6fc0cb$var$c[50007] = "Chittenden";
$f6be72ae2d6fc0cb$var$c[72045] = "Comer\xedo";
$f6be72ae2d6fc0cb$var$c[15009] = "Maui";
$f6be72ae2d6fc0cb$var$c[22057] = "Lafourche";
$f6be72ae2d6fc0cb$var$c[19139] = "Muscatine";
$f6be72ae2d6fc0cb$var$c[12113] = "Santa Rosa";
$f6be72ae2d6fc0cb$var$c[18101] = "Martin";
$f6be72ae2d6fc0cb$var$c[21203] = "Rockcastle";
$f6be72ae2d6fc0cb$var$c[21223] = "Trimble";
$f6be72ae2d6fc0cb$var$c[13055] = "Chattooga";
$f6be72ae2d6fc0cb$var$c[45033] = "Dillon";
$f6be72ae2d6fc0cb$var$c[37103] = "Jones";
$f6be72ae2d6fc0cb$var$c[29199] = "Scotland";
$f6be72ae2d6fc0cb$var$c[20131] = "Nemaha";
$f6be72ae2d6fc0cb$var$c[20137] = "Norton";
$f6be72ae2d6fc0cb$var$c[72007] = "Aguas Buenas";
$f6be72ae2d6fc0cb$var$c[72033] = "Cata\xf1o";
$f6be72ae2d6fc0cb$var$c[31065] = "Furnas";
$f6be72ae2d6fc0cb$var$c[13087] = "Decatur";
$f6be72ae2d6fc0cb$var$c[18177] = "Wayne";
$f6be72ae2d6fc0cb$var$c[21009] = "Barren";
$f6be72ae2d6fc0cb$var$c[31093] = "Howard";
$f6be72ae2d6fc0cb$var$c[38025] = "Dunn";
$f6be72ae2d6fc0cb$var$c[6005] = "Amador";
$f6be72ae2d6fc0cb$var$c[47049] = "Fentress";
$f6be72ae2d6fc0cb$var$c[20031] = "Coffey";
$f6be72ae2d6fc0cb$var$c[26023] = "Branch";
$f6be72ae2d6fc0cb$var$c[51031] = "Campbell";
$f6be72ae2d6fc0cb$var$c[39105] = "Meigs";
$f6be72ae2d6fc0cb$var$c[54067] = "Nicholas";
$f6be72ae2d6fc0cb$var$c[40053] = "Grant";
$f6be72ae2d6fc0cb$var$c[46115] = "Spink";
$f6be72ae2d6fc0cb$var$c[50027] = "Windsor";
$f6be72ae2d6fc0cb$var$c[48455] = "Trinity";
$f6be72ae2d6fc0cb$var$c[35001] = "Bernalillo";
$f6be72ae2d6fc0cb$var$c[13205] = "Mitchell";
$f6be72ae2d6fc0cb$var$c[15001] = "Hawaii";
$f6be72ae2d6fc0cb$var$c[21147] = "McCreary";
$f6be72ae2d6fc0cb$var$c[21191] = "Pendleton";
$f6be72ae2d6fc0cb$var$c[21215] = "Spencer";
$f6be72ae2d6fc0cb$var$c[30041] = "Hill";
$f6be72ae2d6fc0cb$var$c[31175] = "Valley";
$f6be72ae2d6fc0cb$var$c[48069] = "Castro";
$f6be72ae2d6fc0cb$var$c[24043] = "Washington";
$f6be72ae2d6fc0cb$var$c[21133] = "Letcher";
$f6be72ae2d6fc0cb$var$c[34033] = "Salem";
$f6be72ae2d6fc0cb$var$c[51680] = "Lynchburg";
$f6be72ae2d6fc0cb$var$c[5125] = "Saline";
$f6be72ae2d6fc0cb$var$c[54053] = "Mason";
$f6be72ae2d6fc0cb$var$c[54021] = "Gilmer";
$f6be72ae2d6fc0cb$var$c[28063] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[38079] = "Rolette";
$f6be72ae2d6fc0cb$var$c[30103] = "Treasure";
$f6be72ae2d6fc0cb$var$c[21049] = "Clark";
$f6be72ae2d6fc0cb$var$c[72101] = "Morovis";
$f6be72ae2d6fc0cb$var$c[26005] = "Allegan";
$f6be72ae2d6fc0cb$var$c[47005] = "Benton";
$f6be72ae2d6fc0cb$var$c[27015] = "Brown";
$f6be72ae2d6fc0cb$var$c[47137] = "Pickett";
$f6be72ae2d6fc0cb$var$c[51109] = "Louisa";
$f6be72ae2d6fc0cb$var$c[18145] = "Shelby";
$f6be72ae2d6fc0cb$var$c[39049] = "Franklin";
$f6be72ae2d6fc0cb$var$c[49021] = "Iron";
$f6be72ae2d6fc0cb$var$c[32009] = "Esmeralda";
$f6be72ae2d6fc0cb$var$c[26083] = "Keweenaw";
$f6be72ae2d6fc0cb$var$c[49039] = "Sanpete";
$f6be72ae2d6fc0cb$var$c[20093] = "Kearny";
$f6be72ae2d6fc0cb$var$c[12009] = "Brevard";
$f6be72ae2d6fc0cb$var$c[18105] = "Monroe";
$f6be72ae2d6fc0cb$var$c[19117] = "Lucas";
$f6be72ae2d6fc0cb$var$c[21239] = "Woodford";
$f6be72ae2d6fc0cb$var$c[45053] = "Jasper";
$f6be72ae2d6fc0cb$var$c[48043] = "Brewster";
$f6be72ae2d6fc0cb$var$c[45065] = "McCormick";
$f6be72ae2d6fc0cb$var$c[45087] = "Union";
$f6be72ae2d6fc0cb$var$c[27103] = "Nicollet";
$f6be72ae2d6fc0cb$var$c[55075] = "Marinette";
$f6be72ae2d6fc0cb$var$c[53011] = "Clark";
$f6be72ae2d6fc0cb$var$c[55099] = "Price";
$f6be72ae2d6fc0cb$var$c[18103] = "Miami";
$f6be72ae2d6fc0cb$var$c[20053] = "Ellsworth";
$f6be72ae2d6fc0cb$var$c[22123] = "West Carroll";
$f6be72ae2d6fc0cb$var$c[12077] = "Liberty";
$f6be72ae2d6fc0cb$var$c[20083] = "Hodgeman";
$f6be72ae2d6fc0cb$var$c[20119] = "Meade";
$f6be72ae2d6fc0cb$var$c[21149] = "McLean";
$f6be72ae2d6fc0cb$var$c[28001] = "Adams";
$f6be72ae2d6fc0cb$var$c[72083] = "Las Mar\xedas";
$f6be72ae2d6fc0cb$var$c[28057] = "Itawamba";
$f6be72ae2d6fc0cb$var$c[21073] = "Franklin";
$f6be72ae2d6fc0cb$var$c[23009] = "Hancock";
$f6be72ae2d6fc0cb$var$c[23013] = "Knox";
$f6be72ae2d6fc0cb$var$c[13217] = "Newton";
$f6be72ae2d6fc0cb$var$c[46049] = "Faulk";
$f6be72ae2d6fc0cb$var$c[26061] = "Houghton";
$f6be72ae2d6fc0cb$var$c[30061] = "Mineral";
$f6be72ae2d6fc0cb$var$c[47051] = "Franklin";
$f6be72ae2d6fc0cb$var$c[22029] = "Concordia";
$f6be72ae2d6fc0cb$var$c[22063] = "Livingston";
$f6be72ae2d6fc0cb$var$c[25009] = "Essex";
$f6be72ae2d6fc0cb$var$c[46019] = "Butte";
$f6be72ae2d6fc0cb$var$c[8035] = "Douglas";
$f6be72ae2d6fc0cb$var$c[45079] = "Richland";
$f6be72ae2d6fc0cb$var$c[18095] = "Madison";
$f6be72ae2d6fc0cb$var$c[40099] = "Murray";
$f6be72ae2d6fc0cb$var$c[54009] = "Brooke";
$f6be72ae2d6fc0cb$var$c[54013] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[51021] = "Bland";
$f6be72ae2d6fc0cb$var$c[30111] = "Yellowstone";
$f6be72ae2d6fc0cb$var$c[54043] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[6033] = "Lake";
$f6be72ae2d6fc0cb$var$c[13131] = "Grady";
$f6be72ae2d6fc0cb$var$c[8021] = "Conejos";
$f6be72ae2d6fc0cb$var$c[49037] = "San Juan";
$f6be72ae2d6fc0cb$var$c[18133] = "Putnam";
$f6be72ae2d6fc0cb$var$c[16047] = "Gooding";
$f6be72ae2d6fc0cb$var$c[47167] = "Tipton";
$f6be72ae2d6fc0cb$var$c[22121] = "West Baton Rouge";
$f6be72ae2d6fc0cb$var$c[29171] = "Putnam";
$f6be72ae2d6fc0cb$var$c[56039] = "Teton";
$f6be72ae2d6fc0cb$var$c[55043] = "Grant";
$f6be72ae2d6fc0cb$var$c[38059] = "Morton";
$f6be72ae2d6fc0cb$var$c[37041] = "Chowan";
$f6be72ae2d6fc0cb$var$c[37021] = "Buncombe";
$f6be72ae2d6fc0cb$var$c[6063] = "Plumas";
$f6be72ae2d6fc0cb$var$c[51730] = "Petersburg";
$f6be72ae2d6fc0cb$var$c[50023] = "Washington";
$f6be72ae2d6fc0cb$var$c[46093] = "Meade";
$f6be72ae2d6fc0cb$var$c[18097] = "Marion";
$f6be72ae2d6fc0cb$var$c[5017] = "Chicot";
$f6be72ae2d6fc0cb$var$c[13021] = "Bibb";
$f6be72ae2d6fc0cb$var$c[72059] = "Guayanilla";
$f6be72ae2d6fc0cb$var$c[72131] = "San Sebasti\xe1n";
$f6be72ae2d6fc0cb$var$c[5115] = "Pope";
$f6be72ae2d6fc0cb$var$c[51175] = "Southampton";
$f6be72ae2d6fc0cb$var$c[48183] = "Gregg";
$f6be72ae2d6fc0cb$var$c[36087] = "Rockland";
$f6be72ae2d6fc0cb$var$c[5089] = "Marion";
$f6be72ae2d6fc0cb$var$c[51800] = "Suffolk";
$f6be72ae2d6fc0cb$var$c[8041] = "El Paso";
$f6be72ae2d6fc0cb$var$c[29187] = "St. Francois";
$f6be72ae2d6fc0cb$var$c[48475] = "Ward";
$f6be72ae2d6fc0cb$var$c[8061] = "Kiowa";
$f6be72ae2d6fc0cb$var$c[48487] = "Wilbarger";
$f6be72ae2d6fc0cb$var$c[41015] = "Curry";
$f6be72ae2d6fc0cb$var$c[8119] = "Teller";
$f6be72ae2d6fc0cb$var$c[29049] = "Clinton";
$f6be72ae2d6fc0cb$var$c[49051] = "Wasatch";
$f6be72ae2d6fc0cb$var$c[16029] = "Caribou";
$f6be72ae2d6fc0cb$var$c[37157] = "Rockingham";
$f6be72ae2d6fc0cb$var$c[5117] = "Prairie";
$f6be72ae2d6fc0cb$var$c[5011] = "Bradley";
$f6be72ae2d6fc0cb$var$c[48193] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[24011] = "Caroline";
$f6be72ae2d6fc0cb$var$c[27041] = "Douglas";
$f6be72ae2d6fc0cb$var$c[30043] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[51059] = "Fairfax";
$f6be72ae2d6fc0cb$var$c[30023] = "Deer Lodge";
$f6be72ae2d6fc0cb$var$c[47001] = "Anderson";
$f6be72ae2d6fc0cb$var$c[39077] = "Huron";
$f6be72ae2d6fc0cb$var$c[13005] = "Bacon";
$f6be72ae2d6fc0cb$var$c[10001] = "Kent";
$f6be72ae2d6fc0cb$var$c[39173] = "Wood";
$f6be72ae2d6fc0cb$var$c[13157] = "Jackson";
$f6be72ae2d6fc0cb$var$c[20003] = "Anderson";
$f6be72ae2d6fc0cb$var$c[17095] = "Knox";
$f6be72ae2d6fc0cb$var$c[30107] = "Wheatland";
$f6be72ae2d6fc0cb$var$c[47015] = "Cannon";
$f6be72ae2d6fc0cb$var$c[23007] = "Franklin";
$f6be72ae2d6fc0cb$var$c[21165] = "Menifee";
$f6be72ae2d6fc0cb$var$c[46089] = "McPherson";
$f6be72ae2d6fc0cb$var$c[8051] = "Gunnison";
$f6be72ae2d6fc0cb$var$c[26029] = "Charlevoix";
$f6be72ae2d6fc0cb$var$c[27151] = "Swift";
$f6be72ae2d6fc0cb$var$c[39147] = "Seneca";
$f6be72ae2d6fc0cb$var$c[13267] = "Tattnall";
$f6be72ae2d6fc0cb$var$c[48429] = "Stephens";
$f6be72ae2d6fc0cb$var$c[37117] = "Martin";
$f6be72ae2d6fc0cb$var$c[30081] = "Ravalli";
$f6be72ae2d6fc0cb$var$c[13317] = "Wilkes";
$f6be72ae2d6fc0cb$var$c[53043] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[6081] = "San Mateo";
$f6be72ae2d6fc0cb$var$c[39171] = "Williams";
$f6be72ae2d6fc0cb$var$c[8009] = "Baca";
$f6be72ae2d6fc0cb$var$c[16021] = "Boundary";
$f6be72ae2d6fc0cb$var$c[16007] = "Bear Lake";
$f6be72ae2d6fc0cb$var$c[39159] = "Union";
$f6be72ae2d6fc0cb$var$c[39035] = "Cuyahoga";
$f6be72ae2d6fc0cb$var$c[48285] = "Lavaca";
$f6be72ae2d6fc0cb$var$c[40105] = "Nowata";
$f6be72ae2d6fc0cb$var$c[13125] = "Glascock";
$f6be72ae2d6fc0cb$var$c[41059] = "Umatilla";
$f6be72ae2d6fc0cb$var$c[46102] = "Oglala Lakota";
$f6be72ae2d6fc0cb$var$c[20117] = "Marshall";
$f6be72ae2d6fc0cb$var$c[22065] = "Madison";
$f6be72ae2d6fc0cb$var$c[30105] = "Valley";
$f6be72ae2d6fc0cb$var$c[13313] = "Whitfield";
$f6be72ae2d6fc0cb$var$c[20203] = "Wichita";
$f6be72ae2d6fc0cb$var$c[46023] = "Charles Mix";
$f6be72ae2d6fc0cb$var$c[31027] = "Cedar";
$f6be72ae2d6fc0cb$var$c[53035] = "Kitsap";
$f6be72ae2d6fc0cb$var$c[17111] = "McHenry";
$f6be72ae2d6fc0cb$var$c[30069] = "Petroleum";
$f6be72ae2d6fc0cb$var$c[29033] = "Carroll";
$f6be72ae2d6fc0cb$var$c[53075] = "Whitman";
$f6be72ae2d6fc0cb$var$c[27147] = "Steele";
$f6be72ae2d6fc0cb$var$c[31169] = "Thayer";
$f6be72ae2d6fc0cb$var$c[47033] = "Crockett";
$f6be72ae2d6fc0cb$var$c[19079] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[39165] = "Warren";
$f6be72ae2d6fc0cb$var$c[13255] = "Spalding";
$f6be72ae2d6fc0cb$var$c[34019] = "Hunterdon";
$f6be72ae2d6fc0cb$var$c[29217] = "Vernon";
$f6be72ae2d6fc0cb$var$c[18121] = "Parke";
$f6be72ae2d6fc0cb$var$c[19069] = "Franklin";
$f6be72ae2d6fc0cb$var$c[13035] = "Butts";
$f6be72ae2d6fc0cb$var$c[8039] = "Elbert";
$f6be72ae2d6fc0cb$var$c[44001] = "Bristol";
$f6be72ae2d6fc0cb$var$c[48035] = "Bosque";
$f6be72ae2d6fc0cb$var$c[44005] = "Newport";
$f6be72ae2d6fc0cb$var$c[39045] = "Fairfield";
$f6be72ae2d6fc0cb$var$c[38069] = "Pierce";
$f6be72ae2d6fc0cb$var$c[17015] = "Carroll";
$f6be72ae2d6fc0cb$var$c[27125] = "Red Lake";
$f6be72ae2d6fc0cb$var$c[41031] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[47021] = "Cheatham";
$f6be72ae2d6fc0cb$var$c[46127] = "Union";
$f6be72ae2d6fc0cb$var$c[1051] = "Elmore";
$f6be72ae2d6fc0cb$var$c[13187] = "Lumpkin";
$f6be72ae2d6fc0cb$var$c[39083] = "Knox";
$f6be72ae2d6fc0cb$var$c[19017] = "Bremer";
$f6be72ae2d6fc0cb$var$c[48175] = "Goliad";
$f6be72ae2d6fc0cb$var$c[37089] = "Henderson";
$f6be72ae2d6fc0cb$var$c[12061] = "Indian River";
$f6be72ae2d6fc0cb$var$c[48393] = "Roberts";
$f6be72ae2d6fc0cb$var$c[31049] = "Deuel";
$f6be72ae2d6fc0cb$var$c[36051] = "Livingston";
$f6be72ae2d6fc0cb$var$c[19141] = "O'Brien";
$f6be72ae2d6fc0cb$var$c[48059] = "Callahan";
$f6be72ae2d6fc0cb$var$c[48379] = "Rains";
$f6be72ae2d6fc0cb$var$c[20067] = "Grant";
$f6be72ae2d6fc0cb$var$c[51105] = "Lee";
$f6be72ae2d6fc0cb$var$c[35051] = "Sierra";
$f6be72ae2d6fc0cb$var$c[5043] = "Drew";
$f6be72ae2d6fc0cb$var$c[31123] = "Morrill";
$f6be72ae2d6fc0cb$var$c[29015] = "Benton";
$f6be72ae2d6fc0cb$var$c[5109] = "Pike";
$f6be72ae2d6fc0cb$var$c[8077] = "Mesa";
$f6be72ae2d6fc0cb$var$c[29065] = "Dent";
$f6be72ae2d6fc0cb$var$c[51185] = "Tazewell";
$f6be72ae2d6fc0cb$var$c[42103] = "Pike";
$f6be72ae2d6fc0cb$var$c[42115] = "Susquehanna";
$f6be72ae2d6fc0cb$var$c[48343] = "Morris";
$f6be72ae2d6fc0cb$var$c[42125] = "Washington";
$f6be72ae2d6fc0cb$var$c[50001] = "Addison";
$f6be72ae2d6fc0cb$var$c[20103] = "Leavenworth";
$f6be72ae2d6fc0cb$var$c[26121] = "Muskegon";
$f6be72ae2d6fc0cb$var$c[2066] = "Copper River";
$f6be72ae2d6fc0cb$var$c[2063] = "Chugach";
$f6be72ae2d6fc0cb$var$c[28049] = "Hinds";
$f6be72ae2d6fc0cb$var$c[48281] = "Lampasas";
$f6be72ae2d6fc0cb$var$c[51107] = "Loudoun";
$f6be72ae2d6fc0cb$var$c[29185] = "St. Clair";
$f6be72ae2d6fc0cb$var$c[36025] = "Delaware";
$f6be72ae2d6fc0cb$var$c[30071] = "Phillips";
$f6be72ae2d6fc0cb$var$c[29129] = "Mercer";
$f6be72ae2d6fc0cb$var$c[53045] = "Mason";
$f6be72ae2d6fc0cb$var$c[37127] = "Nash";
$f6be72ae2d6fc0cb$var$c[51199] = "York";
$f6be72ae2d6fc0cb$var$c[29159] = "Pettis";
$f6be72ae2d6fc0cb$var$c[30063] = "Missoula";
$f6be72ae2d6fc0cb$var$c[20019] = "Chautauqua";
$f6be72ae2d6fc0cb$var$c[48459] = "Upshur";
$f6be72ae2d6fc0cb$var$c[51047] = "Culpeper";
$f6be72ae2d6fc0cb$var$c[40061] = "Haskell";
$f6be72ae2d6fc0cb$var$c[54069] = "Ohio";
$f6be72ae2d6fc0cb$var$c[54065] = "Morgan";
$f6be72ae2d6fc0cb$var$c[51165] = "Rockingham";
$f6be72ae2d6fc0cb$var$c[18183] = "Whitley";
$f6be72ae2d6fc0cb$var$c[6093] = "Siskiyou";
$f6be72ae2d6fc0cb$var$c[46037] = "Day";
$f6be72ae2d6fc0cb$var$c[22071] = "Orleans";
$f6be72ae2d6fc0cb$var$c[1073] = "Jefferson";
$f6be72ae2d6fc0cb$var$c[1127] = "Walker";
$f6be72ae2d6fc0cb$var$c[29063] = "DeKalb";
$f6be72ae2d6fc0cb$var$c[12039] = "Gadsden";
$f6be72ae2d6fc0cb$var$c[13083] = "Dade";
$f6be72ae2d6fc0cb$var$c[28033] = "DeSoto";
$f6be72ae2d6fc0cb$var$c[51187] = "Warren";
$f6be72ae2d6fc0cb$var$c[17047] = "Edwards";
$f6be72ae2d6fc0cb$var$c[47113] = "Madison";
$f6be72ae2d6fc0cb$var$c[69110] = "Saipan";
$f6be72ae2d6fc0cb$var$c[1111] = "Randolph";
$f6be72ae2d6fc0cb$var$c[37009] = "Ashe";
$f6be72ae2d6fc0cb$var$c[8033] = "Dolores";
$f6be72ae2d6fc0cb$var$c[39089] = "Licking";
$f6be72ae2d6fc0cb$var$c[51683] = "Manassas";
$f6be72ae2d6fc0cb$var$c[5139] = "Union";
$f6be72ae2d6fc0cb$var$c[17071] = "Henderson";
$f6be72ae2d6fc0cb$var$c[1101] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[8005] = "Arapahoe";
$f6be72ae2d6fc0cb$var$c[21155] = "Marion";
$f6be72ae2d6fc0cb$var$c[53057] = "Skagit";
$f6be72ae2d6fc0cb$var$c[28067] = "Jones";
$f6be72ae2d6fc0cb$var$c[55021] = "Columbia";
$f6be72ae2d6fc0cb$var$c[37019] = "Brunswick";
$f6be72ae2d6fc0cb$var$c[27029] = "Clearwater";
$f6be72ae2d6fc0cb$var$c[51131] = "Northampton";
$f6be72ae2d6fc0cb$var$c[20163] = "Rooks";
$f6be72ae2d6fc0cb$var$c[18041] = "Fayette";
$f6be72ae2d6fc0cb$var$c[31079] = "Hall";
$f6be72ae2d6fc0cb$var$c[31081] = "Hamilton";
$f6be72ae2d6fc0cb$var$c[31115] = "Loup";
$f6be72ae2d6fc0cb$var$c[30091] = "Sheridan";
$f6be72ae2d6fc0cb$var$c[31063] = "Frontier";
$f6be72ae2d6fc0cb$var$c[72089] = "Luquillo";
$f6be72ae2d6fc0cb$var$c[1007] = "Bibb";
$f6be72ae2d6fc0cb$var$c[28075] = "Lauderdale";
$f6be72ae2d6fc0cb$var$c[27011] = "Big Stone";
$f6be72ae2d6fc0cb$var$c[27013] = "Blue Earth";
$f6be72ae2d6fc0cb$var$c[51091] = "Highland";
$f6be72ae2d6fc0cb$var$c[51177] = "Spotsylvania";
$f6be72ae2d6fc0cb$var$c[33017] = "Strafford";
$f6be72ae2d6fc0cb$var$c[13153] = "Houston";
$f6be72ae2d6fc0cb$var$c[26041] = "Delta";
$f6be72ae2d6fc0cb$var$c[5131] = "Sebastian";
$f6be72ae2d6fc0cb$var$c[6087] = "Santa Cruz";
$f6be72ae2d6fc0cb$var$c[13191] = "McIntosh";
$f6be72ae2d6fc0cb$var$c[13207] = "Monroe";
$f6be72ae2d6fc0cb$var$c[29069] = "Dunklin";
$f6be72ae2d6fc0cb$var$c[48483] = "Wheeler";
$f6be72ae2d6fc0cb$var$c[13117] = "Forsyth";
$f6be72ae2d6fc0cb$var$c[48409] = "San Patricio";
$f6be72ae2d6fc0cb$var$c[28147] = "Walthall";
$f6be72ae2d6fc0cb$var$c[29137] = "Monroe";
$f6be72ae2d6fc0cb$var$c[26073] = "Isabella";
$f6be72ae2d6fc0cb$var$c[48341] = "Moore";
$f6be72ae2d6fc0cb$var$c[45017] = "Calhoun";
$f6be72ae2d6fc0cb$var$c[56035] = "Sublette";
$f6be72ae2d6fc0cb$var$c[21069] = "Fleming";
$f6be72ae2d6fc0cb$var$c[55019] = "Clark";
$f6be72ae2d6fc0cb$var$c[45091] = "York";
$f6be72ae2d6fc0cb$var$c[18001] = "Adams";
$f6be72ae2d6fc0cb$var$c[22005] = "Ascension";
$f6be72ae2d6fc0cb$var$c[42119] = "Union";
$f6be72ae2d6fc0cb$var$c[51041] = "Chesterfield";
$f6be72ae2d6fc0cb$var$c[22001] = "Acadia";
$f6be72ae2d6fc0cb$var$c[42039] = "Crawford";
$f6be72ae2d6fc0cb$var$c[46123] = "Tripp";
$f6be72ae2d6fc0cb$var$c[19077] = "Guthrie";
$f6be72ae2d6fc0cb$var$c[19183] = "Washington";
$f6be72ae2d6fc0cb$var$c[46111] = "Sanborn";
$f6be72ae2d6fc0cb$var$c[40051] = "Grady";
$f6be72ae2d6fc0cb$var$c[54039] = "Kanawha";
$f6be72ae2d6fc0cb$var$c[55109] = "St. Croix";
$f6be72ae2d6fc0cb$var$c[42121] = "Venango";
$f6be72ae2d6fc0cb$var$c[39153] = "Summit";
$f6be72ae2d6fc0cb$var$c[13127] = "Glynn";
$f6be72ae2d6fc0cb$var$c[48479] = "Webb";
$f6be72ae2d6fc0cb$var$c[37123] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[23003] = "Aroostook";
$f6be72ae2d6fc0cb$var$c[28065] = "Jefferson Davis";
$f6be72ae2d6fc0cb$var$c[18175] = "Washington";
$f6be72ae2d6fc0cb$var$c[48031] = "Blanco";
$f6be72ae2d6fc0cb$var$c[51025] = "Brunswick";
$f6be72ae2d6fc0cb$var$c[47045] = "Dyer";
$f6be72ae2d6fc0cb$var$c[47053] = "Gibson";
$f6be72ae2d6fc0cb$var$c[51149] = "Prince George";
$f6be72ae2d6fc0cb$var$c[5075] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[38027] = "Eddy";
$f6be72ae2d6fc0cb$var$c[53053] = "Pierce";
$f6be72ae2d6fc0cb$var$c[16063] = "Lincoln";
$f6be72ae2d6fc0cb$var$c[42071] = "Lancaster";
$f6be72ae2d6fc0cb$var$c[55057] = "Juneau";
$f6be72ae2d6fc0cb$var$c[47151] = "Scott";
$f6be72ae2d6fc0cb$var$c[46031] = "Corson";
$f6be72ae2d6fc0cb$var$c[46053] = "Gregory";
$f6be72ae2d6fc0cb$var$c[37181] = "Vance";
$f6be72ae2d6fc0cb$var$c[21033] = "Caldwell";
$f6be72ae2d6fc0cb$var$c[45011] = "Barnwell";
$f6be72ae2d6fc0cb$var$c[47039] = "Decatur";
$f6be72ae2d6fc0cb$var$c[18009] = "Blackford";
$f6be72ae2d6fc0cb$var$c[1055] = "Etowah";
$f6be72ae2d6fc0cb$var$c[16025] = "Camas";
$f6be72ae2d6fc0cb$var$c[20155] = "Reno";
$f6be72ae2d6fc0cb$var$c[47119] = "Maury";
$f6be72ae2d6fc0cb$var$c[56015] = "Goshen";
$f6be72ae2d6fc0cb$var$c[55107] = "Rusk";
$f6be72ae2d6fc0cb$var$c[55133] = "Waukesha";
$f6be72ae2d6fc0cb$var$c[21079] = "Garrard";
$f6be72ae2d6fc0cb$var$c[25021] = "Norfolk";
$f6be72ae2d6fc0cb$var$c[18063] = "Hendricks";
$f6be72ae2d6fc0cb$var$c[17077] = "Jackson";
$f6be72ae2d6fc0cb$var$c[45043] = "Georgetown";
$f6be72ae2d6fc0cb$var$c[38041] = "Hettinger";
$f6be72ae2d6fc0cb$var$c[49019] = "Grand";
$f6be72ae2d6fc0cb$var$c[49045] = "Tooele";
$f6be72ae2d6fc0cb$var$c[51650] = "Hampton";
$f6be72ae2d6fc0cb$var$c[55011] = "Buffalo";
$f6be72ae2d6fc0cb$var$c[51069] = "Frederick";
$f6be72ae2d6fc0cb$var$c[54041] = "Lewis";
$f6be72ae2d6fc0cb$var$c[27119] = "Polk";
$f6be72ae2d6fc0cb$var$c[27127] = "Redwood";
$f6be72ae2d6fc0cb$var$c[47047] = "Fayette";
$f6be72ae2d6fc0cb$var$c[60040] = "Swains Island";
$f6be72ae2d6fc0cb$var$c[22089] = "St. Charles";
$f6be72ae2d6fc0cb$var$c[5111] = "Poinsett";
$f6be72ae2d6fc0cb$var$c[12045] = "Gulf";
$f6be72ae2d6fc0cb$var$c[47063] = "Hamblen";
$f6be72ae2d6fc0cb$var$c[1021] = "Chilton";
$f6be72ae2d6fc0cb$var$c[48351] = "Newton";
$f6be72ae2d6fc0cb$var$c[48219] = "Hockley";
$f6be72ae2d6fc0cb$var$c[13009] = "Baldwin";
$f6be72ae2d6fc0cb$var$c[37175] = "Transylvania";
$f6be72ae2d6fc0cb$var$c[37171] = "Surry";
$f6be72ae2d6fc0cb$var$c[1031] = "Coffee";
$f6be72ae2d6fc0cb$var$c[39149] = "Shelby";
$f6be72ae2d6fc0cb$var$c[16027] = "Canyon";
$f6be72ae2d6fc0cb$var$c[30019] = "Daniels";
$f6be72ae2d6fc0cb$var$c[12073] = "Leon";
$f6be72ae2d6fc0cb$var$c[40119] = "Payne";
$f6be72ae2d6fc0cb$var$c[1039] = "Covington";
$f6be72ae2d6fc0cb$var$c[18093] = "Lawrence";
$f6be72ae2d6fc0cb$var$c[20069] = "Gray";
$f6be72ae2d6fc0cb$var$c[21045] = "Casey";
$f6be72ae2d6fc0cb$var$c[21169] = "Metcalfe";
$f6be72ae2d6fc0cb$var$c[21207] = "Russell";
$f6be72ae2d6fc0cb$var$c[22011] = "Beauregard";
$f6be72ae2d6fc0cb$var$c[23025] = "Somerset";
$f6be72ae2d6fc0cb$var$c[40025] = "Cimarron";
$f6be72ae2d6fc0cb$var$c[21163] = "Meade";
$f6be72ae2d6fc0cb$var$c[21179] = "Nelson";
$f6be72ae2d6fc0cb$var$c[21187] = "Owen";
$f6be72ae2d6fc0cb$var$c[29155] = "Pemiscot";
$f6be72ae2d6fc0cb$var$c[31125] = "Nance";
$f6be72ae2d6fc0cb$var$c[55078] = "Menominee";
$f6be72ae2d6fc0cb$var$c[48365] = "Panola";
$f6be72ae2d6fc0cb$var$c[21011] = "Bath";
$f6be72ae2d6fc0cb$var$c[48001] = "Anderson";
$f6be72ae2d6fc0cb$var$c[51033] = "Caroline";
$f6be72ae2d6fc0cb$var$c[19167] = "Sioux";
$f6be72ae2d6fc0cb$var$c[6021] = "Glenn";
$f6be72ae2d6fc0cb$var$c[29510] = "St. Louis";
$f6be72ae2d6fc0cb$var$c[13111] = "Fannin";
$f6be72ae2d6fc0cb$var$c[46051] = "Grant";
$f6be72ae2d6fc0cb$var$c[46091] = "Marshall";
$f6be72ae2d6fc0cb$var$c[53067] = "Thurston";
$f6be72ae2d6fc0cb$var$c[31107] = "Knox";
$f6be72ae2d6fc0cb$var$c[35061] = "Valencia";
$f6be72ae2d6fc0cb$var$c[30079] = "Prairie";
$f6be72ae2d6fc0cb$var$c[19005] = "Allamakee";
$f6be72ae2d6fc0cb$var$c[48061] = "Cameron";
$f6be72ae2d6fc0cb$var$c[48339] = "Montgomery";
$f6be72ae2d6fc0cb$var$c[8071] = "Las Animas";
$f6be72ae2d6fc0cb$var$c[48299] = "Llano";
$f6be72ae2d6fc0cb$var$c[48319] = "Mason";
$f6be72ae2d6fc0cb$var$c[37043] = "Clay";
$f6be72ae2d6fc0cb$var$c[36071] = "Orange";
$f6be72ae2d6fc0cb$var$c[36093] = "Schenectady";
$f6be72ae2d6fc0cb$var$c[54059] = "Mingo";
$f6be72ae2d6fc0cb$var$c[20197] = "Wabaunsee";
$f6be72ae2d6fc0cb$var$c[27055] = "Houston";
$f6be72ae2d6fc0cb$var$c[21181] = "Nicholas";
$f6be72ae2d6fc0cb$var$c[25023] = "Plymouth";
$f6be72ae2d6fc0cb$var$c[36005] = "Bronx";
$f6be72ae2d6fc0cb$var$c[37055] = "Dare";
$f6be72ae2d6fc0cb$var$c[39103] = "Medina";
$f6be72ae2d6fc0cb$var$c[42005] = "Armstrong";
$f6be72ae2d6fc0cb$var$c[34001] = "Atlantic";
$f6be72ae2d6fc0cb$var$c[55071] = "Manitowoc";
$f6be72ae2d6fc0cb$var$c[55029] = "Door";
$f6be72ae2d6fc0cb$var$c[37047] = "Columbus";
$f6be72ae2d6fc0cb$var$c[39053] = "Gallia";
$f6be72ae2d6fc0cb$var$c[48441] = "Taylor";
$f6be72ae2d6fc0cb$var$c[51570] = "Colonial Heights";
$f6be72ae2d6fc0cb$var$c[39031] = "Coshocton";
$f6be72ae2d6fc0cb$var$c[31135] = "Perkins";
$f6be72ae2d6fc0cb$var$c[48205] = "Hartley";
$f6be72ae2d6fc0cb$var$c[8049] = "Grand";
$f6be72ae2d6fc0cb$var$c[48249] = "Jim Wells";
$f6be72ae2d6fc0cb$var$c[19189] = "Winnebago";
$f6be72ae2d6fc0cb$var$c[6079] = "San Luis Obispo";
$f6be72ae2d6fc0cb$var$c[1067] = "Henry";
$f6be72ae2d6fc0cb$var$c[39175] = "Wyandot";
$f6be72ae2d6fc0cb$var$c[48505] = "Zapata";
$f6be72ae2d6fc0cb$var$c[13177] = "Lee";
$f6be72ae2d6fc0cb$var$c[21019] = "Boyd";
$f6be72ae2d6fc0cb$var$c[27019] = "Carver";
$f6be72ae2d6fc0cb$var$c[31037] = "Colfax";
$f6be72ae2d6fc0cb$var$c[45025] = "Chesterfield";
$f6be72ae2d6fc0cb$var$c[47101] = "Lewis";
$f6be72ae2d6fc0cb$var$c[41067] = "Washington";
$f6be72ae2d6fc0cb$var$c[51810] = "Virginia Beach";
$f6be72ae2d6fc0cb$var$c[30057] = "Madison";
$f6be72ae2d6fc0cb$var$c[51103] = "Lancaster";
$f6be72ae2d6fc0cb$var$c[29013] = "Bates";
$f6be72ae2d6fc0cb$var$c[33001] = "Belknap";
$f6be72ae2d6fc0cb$var$c[51159] = "Richmond";
$f6be72ae2d6fc0cb$var$c[2230] = "Skagway";
$f6be72ae2d6fc0cb$var$c[2105] = "Hoonah-Angoon";
$f6be72ae2d6fc0cb$var$c[53021] = "Franklin";
$f6be72ae2d6fc0cb$var$c[19093] = "Ida";
$f6be72ae2d6fc0cb$var$c[20173] = "Sedgwick";
$f6be72ae2d6fc0cb$var$c[48453] = "Travis";
$f6be72ae2d6fc0cb$var$c[12057] = "Hillsborough";
$f6be72ae2d6fc0cb$var$c[34021] = "Mercer";
$f6be72ae2d6fc0cb$var$c[31023] = "Butler";
$f6be72ae2d6fc0cb$var$c[42129] = "Westmoreland";
$f6be72ae2d6fc0cb$var$c[12015] = "Charlotte";
$f6be72ae2d6fc0cb$var$c[19029] = "Cass";
$f6be72ae2d6fc0cb$var$c[39107] = "Mercer";
$f6be72ae2d6fc0cb$var$c[60030] = "Rose Island";
$f6be72ae2d6fc0cb$var$c[21115] = "Johnson";
$f6be72ae2d6fc0cb$var$c[44003] = "Kent";
$f6be72ae2d6fc0cb$var$c[50025] = "Windham";
$f6be72ae2d6fc0cb$var$c[50019] = "Orleans";
$f6be72ae2d6fc0cb$var$c[20085] = "Jackson";
$f6be72ae2d6fc0cb$var$c[22041] = "Franklin";
$f6be72ae2d6fc0cb$var$c[28155] = "Webster";
$f6be72ae2d6fc0cb$var$c[25011] = "Franklin";
$f6be72ae2d6fc0cb$var$c[31031] = "Cherry";
$f6be72ae2d6fc0cb$var$c[30001] = "Beaverhead";
$f6be72ae2d6fc0cb$var$c[29143] = "New Madrid";
$f6be72ae2d6fc0cb$var$c[5057] = "Hempstead";
$f6be72ae2d6fc0cb$var$c[29029] = "Camden";
$f6be72ae2d6fc0cb$var$c[51117] = "Mecklenburg";
$f6be72ae2d6fc0cb$var$c[21233] = "Webster";
$f6be72ae2d6fc0cb$var$c[40047] = "Garfield";
$f6be72ae2d6fc0cb$var$c[53059] = "Skamania";
$f6be72ae2d6fc0cb$var$c[26091] = "Lenawee";
$f6be72ae2d6fc0cb$var$c[13123] = "Gilmer";
$f6be72ae2d6fc0cb$var$c[27135] = "Roseau";
$f6be72ae2d6fc0cb$var$c[28089] = "Madison";
$f6be72ae2d6fc0cb$var$c[48227] = "Howard";
$f6be72ae2d6fc0cb$var$c[54099] = "Wayne";
const $f6be72ae2d6fc0cb$export$28dadf98ec90a935 = $f6be72ae2d6fc0cb$var$c;


function $f8c3ad16b21eebd6$export$fe344857c0f24c65(fips) {
    const stateFIPS = $f8c3ad16b21eebd6$export$4452f0e5115f709c(fips);
    const usState = (0, $12d34f3c78180d6b$export$b4c789cd45f7243f)[stateFIPS].name;
    if (fips.length < 5) return {
        usState: usState
    };
    const usCounty = (0, $f6be72ae2d6fc0cb$export$28dadf98ec90a935)[parseInt(fips)];
    return {
        usState: usState,
        usCounty: usCounty
    };
}
function $f8c3ad16b21eebd6$export$4452f0e5115f709c(fips) {
    return fips.substring(0, 2);
}
function $f8c3ad16b21eebd6$export$7390371c8432f07c(fips) {
    if (fips === undefined) {
        const err = new Error("fips was undefined");
        console.error({
            err: err,
            fips: fips
        });
        throw err;
    }
    if (fips === null) {
        const err = new Error("fips was null");
        console.error({
            err: err,
            fips: fips
        });
        throw err;
    }
    if (typeof fips !== "string") {
        const err = new Error("typeof fips was not 'string'");
        console.error({
            err: err,
            fips: fips,
            type: typeof fips
        });
        throw err;
    }
    if (fips.length !== 2 && fips.length !== 5) {
        const err = new Error("invalid FIPS length");
        console.error({
            err: err,
            fips: fips
        });
        throw err;
    }
}




var $ed93617e655b9b33$export$8a87ade5aef88514;
(function(HistoryStateType) {
    HistoryStateType[HistoryStateType["initial"] = 0] = "initial";
    HistoryStateType[HistoryStateType["globe"] = 1] = "globe";
    HistoryStateType[HistoryStateType["map"] = 2] = "map";
})($ed93617e655b9b33$export$8a87ade5aef88514 || ($ed93617e655b9b33$export$8a87ade5aef88514 = {}));
function $ed93617e655b9b33$export$1a80fb49a1ce56f8() {
    return {
        type: 0,
        prev: null
    };
}
function $ed93617e655b9b33$var$fillGlobeHistoryStateOptions(options) {
    if (options.prev === undefined) options.prev = null;
    return options;
}
function $ed93617e655b9b33$export$4e41f2e73cf74a15(options) {
    const filledOptions = $ed93617e655b9b33$var$fillGlobeHistoryStateOptions(options);
    return {
        ...filledOptions,
        type: 1
    };
}
function $ed93617e655b9b33$var$fillMapHistoryStateOptions(options) {
    if (options.prev === undefined) options.prev = null;
    return options;
}
function $ed93617e655b9b33$export$4f66cbedd33211f4(options) {
    const filledOptions = $ed93617e655b9b33$var$fillMapHistoryStateOptions(options);
    return {
        ...filledOptions,
        type: 2
    };
}
/**
 * The popstate inaction flag is necessary to
 */ let $ed93617e655b9b33$var$historyPopInactionCounter = 0;
function $ed93617e655b9b33$export$bcfd0fa613720960(n) {
    $ed93617e655b9b33$var$historyPopInactionCounter += n;
}
function $ed93617e655b9b33$export$4f1147583dbb39cb() {
    return $ed93617e655b9b33$var$historyPopInactionCounter > 0;
}
function $ed93617e655b9b33$export$5cef967c927bea35() {
    $ed93617e655b9b33$var$historyPopInactionCounter -= 1;
}
let $ed93617e655b9b33$var$historyOnNextPopstate = null;
function $ed93617e655b9b33$export$26fc24427008d69c(historyState) {
    $ed93617e655b9b33$var$historyOnNextPopstate = historyState;
}
function $ed93617e655b9b33$export$92f097fcdc5e5bcb() {
    $ed93617e655b9b33$var$historyOnNextPopstate = null;
}
let $ed93617e655b9b33$var$prevHistoryState = $ed93617e655b9b33$export$f4895e37fc87f733(window.location.href);
function $ed93617e655b9b33$export$d140a9f6968c1121() {
    return $ed93617e655b9b33$var$prevHistoryState;
}
function $ed93617e655b9b33$export$7d129b75de5d16aa(historyState) {
    $ed93617e655b9b33$var$prevHistoryState = $ed93617e655b9b33$export$7f03fe29ac020f44(historyState);
}
function $ed93617e655b9b33$export$71e6d8acbd6e437c(historyState) {
    const state = $ed93617e655b9b33$export$7f03fe29ac020f44(historyState);
    if (state.type === 0) return "";
    else if (state.type === 1) return `?fips=${state.fips}`;
    else if (state.type === 2) {
        const lat = state.lat;
        const lon = state.lon;
        const usCounty = state.usCounty.replaceAll(" ", "_");
        const usState = state.usState;
        const districtId = state.districtId;
        const electionFilter = state.electionFilter;
        const electionType = state.electionType;
        return `?lng=${lon}&lat=${lat}&county=${usCounty}&state=${usState}&district_id=${districtId}&election_filter=${electionFilter}&election_type=${electionType}`;
    }
    return "";
}
function $ed93617e655b9b33$export$f4895e37fc87f733(url) {
    // Type validation
    if (typeof url === "string") url = new URL(url);
    else if (!(url instanceof URL)) {
        const err = new Error("url param was neither string nor typeof URL");
        console.error({
            err: err,
            url: url
        });
        return $ed93617e655b9b33$export$1a80fb49a1ce56f8();
    }
    const searchParams = url.searchParams;
    // Case: Initial
    if (searchParams.size === 0) return $ed93617e655b9b33$export$1a80fb49a1ce56f8();
    // Case: Globe state (county level, zip code level)
    if (searchParams.has("fips")) return $ed93617e655b9b33$export$4e41f2e73cf74a15({
        fips: searchParams.get("fips")
    });
    // Case: Map state
    const lat = Number(searchParams.get("lat"));
    const lng = Number(searchParams.get("lng"));
    const usCounty = searchParams.get("county");
    if (usCounty === null) {
        const err = new Error("invalid URL parameter");
        console.error({
            err: err,
            usCounty: usCounty
        });
        return $ed93617e655b9b33$export$1a80fb49a1ce56f8();
    }
    const usState = searchParams.get("state");
    if (usState === null) {
        const err = new Error("invalid URL parameter");
        console.error({
            err: err,
            usState: usState
        });
        return $ed93617e655b9b33$export$1a80fb49a1ce56f8();
    }
    let districtId = searchParams.get("district_id");
    if (districtId === null) districtId = "null";
    let electionFilter = searchParams.get("election_filter");
    if (electionFilter === null) electionFilter = "null";
    const electionType = Number(searchParams.get("election_type"));
    const state = $ed93617e655b9b33$export$4f66cbedd33211f4({
        lat: lat,
        lon: lng,
        usCounty: usCounty,
        usState: usState,
        districtId: districtId,
        electionFilter: electionFilter,
        electionType: electionType
    });
    return $ed93617e655b9b33$export$7f03fe29ac020f44(state);
}
function $ed93617e655b9b33$export$7f03fe29ac020f44(historyState) {
    const clone = JSON.parse(JSON.stringify(historyState));
    if (clone.type === 2) {
        if (isNaN(clone.electionType)) clone.electionType = 0;
    }
    return clone;
}
function $ed93617e655b9b33$export$a104c684a09de9be(historyState) {
    console.log({
        historyState: historyState,
        prevHistoryState: $ed93617e655b9b33$var$prevHistoryState
    }, "update history");
    const next = $ed93617e655b9b33$export$7f03fe29ac020f44(historyState);
    const diff = $ed93617e655b9b33$var$historyDiff(historyState);
    const url = $ed93617e655b9b33$export$71e6d8acbd6e437c(historyState);
    if (diff === 0) {
        // Case: moving to a history state at the same stack level
        // Hand off the .prev of our old history state to our new history state
        if ($ed93617e655b9b33$var$prevHistoryState === null) next.prev = null;
        else next.prev = $ed93617e655b9b33$var$prevHistoryState.prev;
        history.replaceState(next, "", url);
    } else if (diff < 0) {
        // Case: moving to a history state up the stack (toward the past)
        // sanity check
        if (history.state.prev === undefined) {
            const err = new Error("history state prev was undefined");
            throw err;
        }
        // traverse back up the stack
        let nBack = 0;
        let prev = history.state;
        for(let i = 0; i < diff * -1; i++){
            prev = prev.prev;
            if (prev !== null) // Pop diff amount of states
            nBack += 1;
        }
        // Preserve prev
        if (prev === null) next.prev = null;
        else next.prev = prev.prev;
        if (nBack > 0) {
            $ed93617e655b9b33$export$bcfd0fa613720960(1);
            history.go(nBack * -1);
        }
        // Change our current state to our destination state
        // history.go is asynchronous, so we can't just history.replaceState right away
        addEventListener("popstate", (event)=>{
            history.replaceState(next, "", url);
        }, {
            once: true
        });
    } else if (diff > 0) {
        // Case: moving to a history state down the stack (toward the future)
        next.prev = $ed93617e655b9b33$var$prevHistoryState;
        history.pushState(next, "", url);
    }
    $ed93617e655b9b33$var$prevHistoryState = next;
}
/**
 * Calculate the integer difference in the history stack from one state to another
 * @param historyState
 */ function $ed93617e655b9b33$var$historyDiff(historyState) {
    if ($ed93617e655b9b33$var$prevHistoryState === null) return 1;
    return $ed93617e655b9b33$var$historyStackPos(historyState) - $ed93617e655b9b33$var$historyStackPos($ed93617e655b9b33$var$prevHistoryState);
}
/**
 * Get the stack position of this history state
 * @param historyState
 */ function $ed93617e655b9b33$var$historyStackPos(historyState) {
    if (historyState.type === 0) // Initial level
    return 0;
    if (historyState.type === 1) {
        const fips = historyState.fips;
        const layer = (0, $145f47ad8b66c035$export$ef5980cc2bda34be)(fips);
        if (layer === (0, $145f47ad8b66c035$export$620b10f5169ebe26).COUNTIES) // County overview level
        return 1;
        else // Individual county level (zip level)
        return 2;
    }
    // Map level
    return 3;
}
/**
 * Return a historyState one level up
 * @param historyState
 * @returns
 */ function $ed93617e655b9b33$var$upOne(historyState) {
    const stackPos = $ed93617e655b9b33$var$historyStackPos(historyState);
    if (stackPos === 0) {
        console.warn("already at the top of the stack");
        return historyState;
    }
    if (historyState.type === 2) {
        const next = {
            type: 1,
            fips: historyState.fips
        };
        return next;
    }
    if (historyState.type === 1) {
        const layer = (0, $145f47ad8b66c035$export$ef5980cc2bda34be)(historyState.fips);
        if (layer === (0, $145f47ad8b66c035$export$620b10f5169ebe26).INDIVIDUAL_COUNTY) {
            const next = {
                type: 1,
                fips: (0, $f8c3ad16b21eebd6$export$4452f0e5115f709c)(historyState.fips)
            };
            return next;
        } else if (layer === (0, $145f47ad8b66c035$export$620b10f5169ebe26).COUNTIES) {
            const next = {
                type: 0
            };
            return next;
        }
    }
    return $ed93617e655b9b33$export$7f03fe29ac020f44(historyState);
}
/**
 * Generate sequence to get from a higher history state to a lower one.
 *
 * @param start
 * @param end
 */ function $ed93617e655b9b33$var$historyRange(start, end) {
    let current = end;
    const states = [];
    states.unshift(current);
    while($ed93617e655b9b33$var$historyStackPos(current) > $ed93617e655b9b33$var$historyStackPos(start)){
        current = $ed93617e655b9b33$var$upOne(current);
        states.unshift(current);
    }
    return states;
}


const $145f47ad8b66c035$export$af080c80f57b2cc9 = "https://api.maptiler.com/maps/ad5c3dd1-fb81-4d7e-8e51-dc6a0e3a60df/static/";
const $145f47ad8b66c035$export$eeb5f976af57978e = "1NF19JtA2hQtGW5PyEp2";
var $145f47ad8b66c035$export$620b10f5169ebe26;
(function(LayerKind) {
    LayerKind[LayerKind["COUNTRIES"] = 0] = "COUNTRIES";
    LayerKind[LayerKind["STATES"] = 1] = "STATES";
    LayerKind[LayerKind["COUNTIES"] = 2] = "COUNTIES";
    LayerKind[LayerKind["INDIVIDUAL_COUNTY"] = 3] = "INDIVIDUAL_COUNTY";
})($145f47ad8b66c035$export$620b10f5169ebe26 || ($145f47ad8b66c035$export$620b10f5169ebe26 = {}));
function $145f47ad8b66c035$export$ef5980cc2bda34be(fips) {
    if (fips.length === 2) return 2;
    else if (fips.length === 5) return 3;
    throw new Error(`invalid fips code ${fips}`);
}
class $145f47ad8b66c035$export$3bc50e457b7f164b extends EventTarget {
    get statesLoaded() {
        return this.STATE_GROUP !== undefined && this.STATE_GROUP.children.length > 0;
    }
    get currentLayerKind() {
        if (this.state.zoomLevel === 0) return 0;
        if (!this.areCountiesLoaded()) return 1;
        if (!this.areZipsLoaded()) return 2;
        return 3;
    }
    get currentLayerGroup() {
        const kind = this.currentLayerKind;
        switch(kind){
            case 0:
                return this.COUNTRIES;
            case 1:
                return this.STATE_GROUP;
            case 2:
                return this.COUNTY_GROUP;
            case 3:
                if (this.INDIVIDUAL_COUNTY === null) throw new Error("currentLayerKind is INDIVIDUAL_COUNTY but this.INDIVIDUAL_COUNTY was null");
                return this.INDIVIDUAL_COUNTY.face;
        }
    }
    get highlightedLabel() {
        if (this.INTERSECTED == null) return null;
        return (0, $be68dac03006aaff$export$d4a625cede2da71b)(this.INTERSECTED).label;
    }
    /**
     * Update the internal state of the globe to match a HistoryState
     * @param historyState
     */ async setFromHistoryState(historyState, modifyHistory = false) {
        const prevHistoryState = (0, $ed93617e655b9b33$export$d140a9f6968c1121)();
        console.log({
            historyState: historyState,
            prevHistoryState: prevHistoryState,
            modifyHistory: modifyHistory
        }, "set from history state");
        // Branch by HistoryState type
        if (historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).initial) this.reset(modifyHistory);
        else if (historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).globe) await this.flyTo(historyState, modifyHistory);
        else if (historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).map) {
            const lat = historyState.lat;
            const lon = historyState.lon;
            const usCounty = historyState.usCounty;
            const usState = historyState.usState;
            window.smoothlyGoToMapPoint(lat, lon, 13.24, usCounty, usState, {
                modifyHistory: modifyHistory
            }).catch((err)=>{
                console.warn(err);
            });
        }
    }
    /**
     * Set globe state based on a GlobeHistoryState
     * @param historyState
     */ async flyTo(historyState, modifyHistory = true) {
        const fips = historyState.fips;
        const prevHistoryState = (0, $ed93617e655b9b33$export$d140a9f6968c1121)();
        try {
            (0, $f8c3ad16b21eebd6$export$7390371c8432f07c)(fips);
        } catch (err) {
            console.error({
                err: err
            }, "fips was not valid");
        }
        if (prevHistoryState?.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).map) {
            this.cameraSynchronizer.master = "globe";
            this.cameraSynchronizer.syncGlobe();
            this.animate(100000000);
        }
        // Globe -> Globe
        const toLayer = $145f47ad8b66c035$export$ef5980cc2bda34be(historyState.fips);
        const { usState: usState, usCounty: usCounty } = (0, $f8c3ad16b21eebd6$export$fe344857c0f24c65)(fips);
        if (toLayer === 2) await this.loadCounties(usState, true, false);
        else if (toLayer === 3) {
            if (usCounty === undefined) {
                console.error("fips code was not a county code");
                return;
            }
            const promises = this.loadCountiesWithRaisePromise(usState, false, {
                modifyHistory: modifyHistory,
                modifyTutorial: true
            });
            await Promise.all(promises);
            const countyMesh = this.getCountyByName(usCounty);
            if (countyMesh === undefined) {
                console.error("county mesh could not be found");
                return;
            }
            await this.loadZips(countyMesh, {
                modifyHistory: modifyHistory
            });
        }
    }
    /**
     * Load all globe resources at a point down to the specified layer
     *
     * Equivalent to navigating to that point, but without the camera changes
     */ async load(pos, toLayer = 3) {
        const lngLat = (0, $30510d2f060a5cf8$exports.LngLat).convert(pos);
        // Convert from latitude/longitude to globe spherical
        const polar = (0, $b2dc26e6bbd9abd7$export$2aad8d5c978c5be9)(lngLat.lat);
        const azimuthal = (0, $b2dc26e6bbd9abd7$export$232fe3c2ac5cbf38)(lngLat.lng);
        // Direction to the center of the globe
        const direction = new $8725869b83961a04$export$64b5c384219d3699().setFromSpherical(new $8725869b83961a04$export$d712cd887b4a00f7(1, polar, azimuthal)).negate();
        const eulerPos = new $8725869b83961a04$export$64b5c384219d3699().setFromSpherical(new $8725869b83961a04$export$d712cd887b4a00f7(60, polar, azimuthal)).sub(new $8725869b83961a04$export$64b5c384219d3699(0, 0, 50));
        let toRaycast;
        if (this.currentLayerGroup instanceof $8725869b83961a04$export$e176487c05830cc5) toRaycast = [
            this.currentLayerGroup
        ];
        else toRaycast = this.currentLayerGroup.children;
        this.raycaster.set(eulerPos, direction);
        this.raycaster.intersectObjects(toRaycast);
    }
    /**
     * Navigate instantly to a point on the globe
     *
     * Resolves when the lowest level has been loaded
     */ async jumpTo(pos) {
        const lngLat = (0, $30510d2f060a5cf8$exports.LngLat).convert(pos);
        await this.load(lngLat);
        this.controls.focus(lngLat.lng, lngLat.lat);
    // Todo: The rest of the camera params
    // Zoom
    // minDistance
    // maxDistance
    // focusRadius
    // startRotating
    // endRotating
    }
    getStateByName(name) {
        // Replace any spaces with _
        // name = name.replace(/ /g, "_");
        const nChildren = this.STATE_GROUP.children.length;
        for(let i = 0; i < nChildren; i++){
            const state = this.STATE_GROUP.children[i];
            if (state.userData.name === name) {
                if (!(state instanceof $8725869b83961a04$export$e176487c05830cc5)) throw new Error("State object was not a mesh");
                return state;
            }
        }
        throw new Error(`No state with name ${name}`);
    }
    // Updates the intersectable array to contain all objects in the scene with labels.
    // Should be called after any modification of the scene that may have added or removed an object with a label.
    // TODO: Could be further optimized by only adding and removing objects that changed rather than clearing the whole array
    updateIntersectable() {
        // Clear out the old array
        this.RAYCAST_INTERSECTABLE = [];
        if (this.areCountiesLoaded()) this.COUNTY_GROUP.traverse((obj)=>{
            if (this.getLabel(obj) === null) return;
            if (!obj.visible) return;
            this.RAYCAST_INTERSECTABLE.push(obj);
        });
        if (this.statesLoaded && this.state.zoomLevel === 1) this.STATE_GROUP.traverse((obj)=>{
            if (this.getLabel(obj) === null) return;
            if (!obj.visible) return;
            this.RAYCAST_INTERSECTABLE.push(obj);
        });
        if (this.statesLoaded && this.state.zoomLevel === 0) this.STATE_GROUP.traverse((obj)=>{
            if (this.getLabel(obj) === null) return;
            if (!obj.visible) return;
            if (!(0, $65867f75b82a314a$export$bafb4b606f8af778).includes(obj.userData.abbr)) return;
            this.RAYCAST_INTERSECTABLE.push(obj);
        });
        if (this.state.zoomLevel === 0) this.USA.traverse((obj)=>{
            if (this.getLabel(obj) === null) return;
            if (!obj.visible) return;
            this.RAYCAST_INTERSECTABLE.push(obj);
        });
        if (this.areZipsLoaded() && this.INDIVIDUAL_COUNTY !== null) this.RAYCAST_INTERSECTABLE.push(this.INDIVIDUAL_COUNTY.face);
        this.RAYCAST_INTERSECTABLE.push(this.WATER);
    }
    getLabel(mesh) {
        if (!(mesh instanceof $8725869b83961a04$export$e176487c05830cc5)) return null;
        let label = null;
        mesh.traverse((obj)=>{
            if (obj instanceof (0, $5859463f2a625df8$export$936f75e6792bf2dc)) label = obj;
        });
        return label;
    }
    areZipsLoaded() {
        return this.INDIVIDUAL_COUNTY !== null && !this.INDIVIDUAL_COUNTY.disposed;
    }
    areCountiesLoaded() {
        return this.COUNTY_GROUP.children.length !== 0;
    }
    areCountriesLoaded() {
        return this.COUNTRIES.children.length !== 0;
    }
    attachMapPins(layer) {
        // Select only pins on this layer
        this.mapPinData.filter((pin)=>pin.layer === layer).forEach((pin)=>{
            // Create pin container
            const container = document.createElement("div");
            container.classList.add("tab-helper-root");
            container.style.position = "absolute";
            this.labelRenderer.domElement.appendChild(container);
            const bubbleContainer = document.createElement("div");
            bubbleContainer.classList.add("tab-helper-root");
            bubbleContainer.style.position = "absolute";
            // bubbleContainer.style.zIndex = "19"
            this.labelRenderer.domElement.appendChild(bubbleContainer);
            // Look up mesh associated with the pin
            let mesh;
            switch(layer){
                case 1:
                    mesh = this.getStateByFIPS(pin.fips);
                    break;
                default:
                    mesh = this.getStateByFIPS(pin.fips);
            }
            const onClick = ()=>{
                this.state.aStateHasBeenClicked = true;
                this.loadCounties(mesh, true, true);
            };
            if (pin.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Vertical) {
                const tabHelperRoot = $6T1J1.createRoot(container);
                tabHelperRoot.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $b6d45e1af0433d6c$export$2e2bcd8739ae039), {
                    label: "DC",
                    onClick: onClick,
                    kind: pin.pinKind,
                    size: 200
                }));
                // Create pin CSS2DOjbect
                const obj = new (0, $5859463f2a625df8$export$936f75e6792bf2dc)(container);
                obj.userData.labelType = "taphelper";
                this.getChildAnchor(mesh)?.add(obj);
                this.mapPins.push({
                    obj: obj,
                    data: {
                        ...pin,
                        region: (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh)
                    },
                    root: tabHelperRoot,
                    onClick: onClick
                });
            } else if (pin.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Left || pin.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Right) {
                const point1 = pin.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Left ? new $8725869b83961a04$export$64b5c384219d3699(-1.5, 0, 2) : new $8725869b83961a04$export$64b5c384219d3699(1.5, 2.25, -1.5);
                const point2 = new $8725869b83961a04$export$64b5c384219d3699();
                const myPin = new (0, $b6d45e1af0433d6c$export$320db79caa55ae92)(point1, point2, this.camera, "DC", bubbleContainer, container, onClick);
                this.mapPins.push({
                    obj: myPin,
                    data: {
                        ...pin,
                        region: (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh)
                    },
                    onClick: onClick
                });
                this.getChildAnchor(mesh)?.add(myPin);
            }
        });
    }
    connectCameraSynchronizer(cameraSynchronizer) {
        this.cameraSynchronizer = cameraSynchronizer;
    }
    /**
     *
     * @param {THREE.Scene} scene The parent group to contain all globe objects.
     * @param {HTMLElement} domElement The canvas element rendering the globe.
     * @param {HTMLElement} resetButton A button to reset the globe on click.
     * @param {PerformanceManager} performanceManager
     * @param {*} gpuTier
     * @param {*} settings
     */ constructor(scene, domElement, resetButton, performanceManager, gpuTier, settings, textureInitializer, tutorial, camera){
        super();
        this.mapPinData = [
            {
                layer: 1,
                pinKind: (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Vertical,
                label: "DC",
                fips: "11",
                exclude: [
                    "DC"
                ],
                angularThreshold: 13 * (0, $d6f1a4944061be51$export$460c4029b1a54a2e),
                distanceThreshold: {
                    near: 0,
                    far: 90
                }
            },
            {
                layer: 2,
                pinKind: (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Vertical,
                label: "DC",
                fips: "11",
                exclude: [
                    "MD",
                    "VA",
                    "DC"
                ],
                angularThreshold: 13 * (0, $d6f1a4944061be51$export$460c4029b1a54a2e),
                distanceThreshold: {
                    near: 0,
                    far: 90
                }
            },
            {
                layer: 2,
                pinKind: (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Left,
                label: "DC",
                fips: "11",
                onlyWhileRaised: "MD",
                angularThreshold: 13 * (0, $d6f1a4944061be51$export$460c4029b1a54a2e),
                distanceThreshold: {
                    near: 0,
                    far: 90
                }
            },
            {
                layer: 2,
                pinKind: (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Right,
                label: "DC",
                fips: "11",
                onlyWhileRaised: "VA",
                angularThreshold: 13 * (0, $d6f1a4944061be51$export$460c4029b1a54a2e),
                distanceThreshold: {
                    near: 0,
                    far: 90
                }
            }
        ];
        this.mapPins = [];
        this.scene = scene;
        this.canvas = domElement;
        /**
         * The button that resets the globe on click.
         * @type {HTMLElement}
         */ this.resetButton = resetButton;
        this.gpuTier = gpuTier;
        this.settings = settings;
        // TODO refactor major: move the center to 0, 0, 0
        this.center = new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0);
        this._tempSpherical = new $8725869b83961a04$export$d712cd887b4a00f7();
        this._tempVector3 = new $8725869b83961a04$export$64b5c384219d3699();
        this._temp2Vector3 = new $8725869b83961a04$export$64b5c384219d3699();
        this.lowerColor = new $8725869b83961a04$export$892596cec99bc70e("#111");
        this.lowerEmissive = new $8725869b83961a04$export$892596cec99bc70e("#050505");
        this.unfadeColor = new $8725869b83961a04$export$892596cec99bc70e("#FFF");
        this.unfadeEmissive = new $8725869b83961a04$export$892596cec99bc70e("#000000");
        domElement.addEventListener("pointerdown", (event)=>{
            this.onPointerDown(event);
        });
        domElement.addEventListener("pointermove", (event)=>{
            this.onPointerMove(event);
        });
        domElement.addEventListener("mouseleave", (event)=>{
            this.onMouseLeave(event);
        });
        domElement.addEventListener("wheel", (event)=>{
            this.onMouseWheel(event);
        });
        /**
         * State information for the globe.
         *
         * This does not represent a comprehensize globe state.
         * The state is scattered through the code.
         * My tentative plan is to slowly consolidate the globe state in this object.
         * For now, consider these read-only.
         * @type {{
         *  zoomLevel: number,
         *  aStateHasBeenClicked: boolean,
         * }}
         */ this.state = {
            // TODO: Possibly add more zoom levels - 2 for county level, 3 for zip level, etc.
            /**
             * 0 is initial/completely zoomed out, 1 is state level
             * @type {number}
             */ zoomLevel: 0,
            /**
             * @type {boolean}
             */ aStateHasBeenClicked: false,
            /**
             * @type {boolean}
             */ resetButtonShown: false,
            /**
             * @type {{holePunchedRegion: Region, closeEnough: Boolean}}
             */ map: {
                region: null,
                closeEnough: true
            }
        };
        this.materials = {
            holePunch: new $8725869b83961a04$export$5023a9a8114806b8({
                transparent: false,
                opacity: 0,
                blending: $8725869b83961a04$export$eda4864c68df1fa2,
                blendEquation: $8725869b83961a04$export$20183a0484ce21a0,
                blendSrc: $8725869b83961a04$export$8805bad65e24940e,
                blendDst: $8725869b83961a04$export$2110f05edf778d3d,
                color: "#000",
                emissive: "#000"
            })
        };
        // Set up reset button event listener
        this.resetButton.addEventListener("click", (event)=>{
            this.reset();
            this.tutorial.state.send("RESET");
        });
        this.mouseDownBool = false;
        this.pointerXOnPointerDown = 0;
        this.pointerYOnPointerDown = 0;
        this.pointerDragDistance = 0;
        this.pointerDelta = new $8725869b83961a04$export$c977b3e384af9ae1();
        this.pointer = new $8725869b83961a04$export$c977b3e384af9ae1(-1000, -1000);
        /**
         * Helper to detect cases where a new load is triggered before the old one finishes.
         *
         * This is set on load. A reference copy is saved, and checked on load finish.
         * A mostRecentLoad not equaling the reference copy indicates a new superceding load.
         * @type {LoadEvent}
         */ this.mostRecentLoad = null;
        this.historyStatePushed = false;
        this.group = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
        this.group.position.y = 50;
        scene.add(this.group);
        this.leftPanel = new (0, $edff8fb537ccec3f$export$110709f040143804)(document.querySelector(".left-panel"), document.querySelector(".walkthrough-question-mark-container"));
        this.tutorial = tutorial;
        // Create label renderer for floating country/state/county/zip labels
        this.labelRenderer = new (0, $5859463f2a625df8$export$508520281a983506)();
        this.labelRenderer.setSize(innerWidth, innerHeight);
        this.labelRenderer.domElement.style.position = "absolute";
        this.labelRenderer.domElement.style.top = "0px";
        this.labelRenderer.domElement.style.pointerEvents = "none";
        this.labelRenderer.domElement.style.zIndex = "0";
        this.labelRenderer.domElement.classList.add("floating-label-container");
        document.body.appendChild(this.labelRenderer.domElement);
        // An array of what we want to consider in our raycast
        this.RAYCAST_INTERSECTABLE = [];
        // This is the position in 3D space that the cursor is currently touching/intersecting.
        // If the cursor is not interesecting anything, this will be set to (0, 0, 0)
        this.CURSOR_POS_3D = new $8725869b83961a04$export$64b5c384219d3699(0, 0, 0);
        this.ANIMATIONS = new (0, $dcb05fea3bbeea72$export$4e3f75a11a2fabf5)();
        this.raycaster = new $8725869b83961a04$export$8b7aaceff00bd2f();
        this.SELECTED_ZIP = "";
        // Set camera and controls
        this.base_fov = 40;
        let fov = this.base_fov;
        // mobile view footer height consideration
        const renderHeight = document.documentElement.clientHeight;
        const aspectRatio = document.documentElement.clientWidth / renderHeight;
        // For anything less-than-square, start expanding the vertical FOV
        if (aspectRatio < 1) // By default, PerspectiveCamera works by specifying a fixed vertical FOV and aspect ratio.
        // Once we get to a slim enough aspect ratio, we want to specify a fixed horizontal FOV instead.
        // This calculates a vertical FOV from a fixed horizontal FOV and aspect ratio.
        fov = (0, $284c58eef2a1e870$export$2e2bcd8739ae039).horizontalToVerticalFOV(this.base_fov, aspectRatio);
        this.camera = camera;
        this.camera.fov = fov;
        this.camera.aspect = aspectRatio;
        this.camera.updateProjectionMatrix();
        // this.camera.position.set(0, 50, 170);
        scene.add(this.camera);
        this.controls = new (0, $d8c40d4165631fec$export$4bce0fe8712eaf01)(camera, domElement, this);
        this.controls.enablePan = false;
        this.controls.enableDamping = true;
        this.controls.target = new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0);
        this.controls.rotateSpeed = 0.5;
        this.controls.maxDistance = 300;
        this.controls.minDistance = 75;
        this.controls.zoomSpeed = 1;
        this.controls.extraThetaOffset = 0.1 * Math.PI / 180;
        // Hide the state list initially
        this.nav_list = document.querySelector("#state_list");
        this.nav_list.classList.add("hidden");
        // Groups of objects
        // TODO: Standardize group hierarchies and initial conditions
        this.INTERSECTED = null;
        this.CLICKED = null;
        this.INDIVIDUAL_COUNTY = null;
        this.COUNTY_GROUP = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
        this.COUNTY_GROUP.userData.mapLevel = 0;
        (0, $be68dac03006aaff$export$b3d257225ea880da)(this.COUNTY_GROUP);
        this.CITY_GROUP = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
        this.group.add(this.CITY_GROUP);
        this.ZIP_GROUP = null;
        this.USA = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
        this.USA.userData.state = "visible";
        this.group.add(this.USA);
        (0, $be68dac03006aaff$export$b3d257225ea880da)(this.USA);
        this.COUNTRIES = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
        this.group.add(this.COUNTRIES);
        this.textureInitializer = textureInitializer;
        // TODO: Merge these?
        this.globeLoader = new (0, $65867f75b82a314a$export$315d320af4304b5)(this.group);
        this.stateLoader = new (0, $da4e7fd06f292871$export$314320385c98bcc1)(this.group, this.textureInitializer);
        const shadowMapSize = (()=>{
            if (this.gpuTier.isMobile === true) return new $8725869b83961a04$export$c977b3e384af9ae1(2048, 2048);
            else return new $8725869b83961a04$export$c977b3e384af9ae1(4096, 4096);
        })();
        console.log({
            shadowMapSize: shadowMapSize
        });
        // TODO: Promisify this?
        this.globeLoader.addLights(scene, this.controls, performanceManager, {
            shadowMapSize: shadowMapSize
        });
        // Load countries
        // this.globeLoader.addGlobe(this.COUNTRIES)
        this.WATER = new $8725869b83961a04$export$eb2fcfdbd7ba97d4();
        // Load water
        const waterPromise = this.globeLoader.addWater().then((gltf)=>{
            gltf.scene.traverse((obj)=>{
                if (obj.name === "Sphere") this.WATER = obj.children[0];
            });
        });
        this.addStateListPromise = (0, $13b202410cedebbf$export$c5ecc146ef527cac)();
        this.loadStatesPromise = this.globeLoader.addStatesV2().then((gltf)=>{
            this.STATE_GROUP = gltf.scene;
            this.group.add(this.STATE_GROUP);
            this.attachMapPins(1);
            this.attachMapPins(2);
            this.updateIntersectable();
        });
        this.loadUSAPromise = new Promise((resolve, reject)=>{
            this.loadUSAPromiseResolve = resolve;
            this.loadUSAPromiseReject = reject;
        });
        // Load mainland
        this.globeLoader.addMainland().then((gltf)=>{
            gltf.scene.traverse((obj)=>{
                if (obj.parent === gltf.scene) this.USA.add(obj);
            });
            this.USA.scale.multiplyScalar(49.5);
            this.updateIntersectable();
            this.loadUSAPromiseResolve(gltf);
        });
        // Load countries
        this.loadCountriesPromise = this.globeLoader.addCountries("/assets/glb/globe/front_countries.glb").then((gltf)=>{
            this.COUNTRIES.add(gltf.scene);
            this.updateIntersectable();
        });
        /**
         * This promise represents all the resources that need to load before the globe can be seen interacted with
         */ const essentialsLoadedPromise = Promise.all([
            this.loadCountriesPromise,
            this.loadStatesPromise,
            waterPromise,
            this.loadUSAPromise
        ]);
        // Notify that globe is ready to be interacted with
        essentialsLoadedPromise.then(()=>{
            window.dispatchEvent(new CustomEvent("globeinteractive"));
        });
        // TODO: Move this old code somewhere more relevant
        // I think #loaded contains the bottom bar among other things
        essentialsLoadedPromise.then(()=>{
            document.getElementById("loaded")?.classList.remove("hidden");
        });
        // Load non-essential resources
        essentialsLoadedPromise.then(async ()=>{
            return await this.globeLoader.addCountries("/assets/glb/globe/back_countries.glb");
        }).then((gltf)=>{
            const currentState = (0, $ed93617e655b9b33$export$f4895e37fc87f733)(window.location.href);
            this.COUNTRIES.add(gltf.scene);
            this.updateIntersectable();
            // TODO: Handle transition into the scene based on current globe state
            if (currentState.type !== (0, $ed93617e655b9b33$export$8a87ade5aef88514).initial) {
                // Set all children to "gray lowered" state
                console.log(gltf, "back countries");
                gltf.scene.children.forEach((child)=>{
                    child.scale.copy(child.userData.loweredScale);
                    child.material.color.copy(this.lowerColor);
                    child.material.emissive.set(this.lowerEmissive);
                    child.children.forEach((child)=>{
                        child.material?.color.copy(this.lowerColor);
                        child.material?.emissive.set(this.lowerEmissive);
                    });
                });
            }
        });
        this.globe_svg = document.querySelector("#globe_svg");
        this.globe_svg_g = document.querySelector("#globe_svg g");
        this.globe_svg_container = document.querySelector("#globe_svg_container");
        this.globe_ring = document.querySelector(".globe_ring");
        if (this.globe_svg != null) {
            this.globe_svg.style.width = `${document.documentElement.clientWidth}px`;
            this.globe_svg.style.height = `${document.documentElement.clientHeight}px`;
        }
        const pageUrl = new URL(window.location.href);
        const abbr = pageUrl.searchParams.get("abbr");
        /// ////////////////////////
        // Initialize ballot boxes
        /// ////////////////////////
        if (document.querySelector(".ballot-row") != null) {
            this.BALLOT_BOXES = new (0, $336556d68452d639$export$b6096f165c419050)(document.querySelector(".ballot-row"), abbr);
            const electionsOverviewDiv = document.querySelector(".elections-overview");
            this.BALLOT_BOXES.setElectionsOverviewDiv(electionsOverviewDiv);
        // this.BALLOT_BOXES.updateAndStore({
        //     state: url_state,
        //     abbr: abbr,
        //     county: countyName
        // });
        }
        this.pointerUpListener = (event)=>{
            this.onPointerUp(event);
        };
        this.controls.addEventListener("change", ()=>{
            this.onCameraChange();
        });
        // Hook up self event listeners
        this.addEventListener("zoomlevelchange", (event)=>{
            this.onZoomLevelChange(event);
        });
        this.dispatchFooterChangeEvent();
    }
    // dispose(): void {
    //     this.canvas.
    // }
    /**
     * Reset the globe to its initial state
     */ reset(modifyHistory = true) {
        // Reset URL state
        if (modifyHistory) {
            const historyState = (0, $ed93617e655b9b33$export$1a80fb49a1ce56f8)();
            (0, $ed93617e655b9b33$export$a104c684a09de9be)(historyState);
        }
        this._optimizationShowCountries();
        this.tutorial.state.send("RESET");
        // Reset bottom bar
        (0, $13b202410cedebbf$export$3eb846f1539800e9)();
        this.dispatchFooterChangeEvent();
        // Reset camera parameters
        this.controls.setMinDistance(75);
        this.controls.setFocusRadius(51.5);
        // Cancel all tweens
        this.scene.traverse((object)=>{
            try {
                (0, $be68dac03006aaff$export$b86006a140a6bac4)(object).removeAll();
            } catch  {}
        });
        this.controls.abortAnimations();
        // Reset state variables
        this.state.aStateHasBeenClicked = false;
        // Reset the double load safeguard
        // As a side effect, this handles the case where reset is pressed during a load
        // The load will complete, but the assets loaded will immediately be discarded
        this.mostRecentLoad = null;
        /// /////////////////////////////////////
        // Handle the currently raised state
        /// /////////////////////////////////////
        // Get the currently raised state object
        const state = this.getStateByAbbr(this.COUNTY_GROUP.userData.abbr);
        if (state !== null) $145f47ad8b66c035$var$makeVisible((0, $be68dac03006aaff$export$d4a625cede2da71b)(state));
        /// /////////////////////////////////////
        // End handling the currently raised state
        /// /////////////////////////////////////
        // Remove county meshes
        if (this.areCountiesLoaded()) this.removeCountyGroup(this.COUNTY_GROUP);
        // Remove zip meshes
        if (this.areZipsLoaded()) this.INDIVIDUAL_COUNTY?.dispose(false, false);
        // Move the camera to the initial orientation
        this.controls.focus(new $8725869b83961a04$export$64b5c384219d3699(0, 51, 1.5));
        // Move the camera to the initial distance from the globe
        this.controls.animateTo("trackPos", 0.13, 0.9);
        // Reset everything that was gray to its initial color
        (0, $be68dac03006aaff$export$1ae571a23e1cddb5)(this.STATE_GROUP);
        (0, $be68dac03006aaff$export$1ae571a23e1cddb5)(this.COUNTRIES);
    }
    /**
     * @returns Canvas that the globe is rendering to
     */ getCanvas() {
        return this.canvas;
    }
    getCountyByName(name) {
        let county;
        this.COUNTY_GROUP.traverse((obj)=>{
            if ("isMesh" in obj && obj.isMesh === false) return;
            if (obj.userData.name === name) county = obj;
        });
        return county;
    }
    getLatLon(point) {
        this._tempVector3.copy(point);
        this.group.updateWorldMatrix(true, false);
        // point = scope.group.worldToLocal(point);
        this._tempVector3.y -= 50;
        this._tempSpherical.setFromVector3(this._tempVector3);
        const lon = -90 + $8725869b83961a04$export$6a7ef315a0d1ef07.radToDeg(this._tempSpherical.theta);
        const lat = 90 - $8725869b83961a04$export$6a7ef315a0d1ef07.radToDeg(this._tempSpherical.phi);
        return {
            latitude: lat,
            longitude: lon
        };
    }
    // Bandaid for the transition between landing page and map page
    encodeControlParams(url, position) {
        const controls = this.controls;
        const camera = this.camera;
        url.searchParams.append("trackPos", controls.trackPos.toString());
        this._tempSpherical.setFromVector3(position);
        url.searchParams.append("phi", this._tempSpherical.phi.toString());
        url.searchParams.append("theta", this._tempSpherical.theta.toString());
        url.searchParams.append("x", camera.position.x.toString());
        url.searchParams.append("y", camera.position.y.toString());
        url.searchParams.append("z", camera.position.z.toString());
    }
    getCityMesh(name) {
        let mesh;
        // Replace spaces with _
        name = name.replace(/ /g, "_");
        this.CITY_GROUP.traverse((obj)=>{
            console.log(obj.name);
            if (obj.name.split("$")[0] === name) mesh = obj;
        });
        return mesh;
    }
    isUSA(obj) {
        if (obj.parent === this.USA) return true;
        return false;
    }
    isAnchor(obj) {
        const words = obj.name.split("_");
        const suffix = words[words.length - 1];
        return suffix !== "" && suffix.startsWith("Anchor");
    }
    getChildAnchor(obj) {
        for(let i = 0; i < obj.children.length; i++){
            if (this.isAnchor(obj.children[i])) return obj.children[i];
        }
    }
    getMeshType(mesh) {
        return mesh.userData.type;
    }
    onPointerMove(event) {
        const bounds = this.canvas.getBoundingClientRect();
        const x = event.clientX - bounds.left;
        const y = event.clientY - bounds.top;
        const newX = x / document.documentElement.clientWidth * 2 - 1;
        const newY = -(y / document.documentElement.clientHeight) * 2 + 1;
        if (this.mouseDownBool) {
            this.pointerDelta.x = newX - this.pointer.x;
            this.pointerDelta.y = newY - this.pointer.y;
            // Use lengthSq instead of length because it's faster
            this.pointerDragDistance += this.pointerDelta.lengthSq();
        }
        this.pointer.x = newX;
        this.pointer.y = newY;
    }
    onStateClicked(event) {
        this.state.aStateHasBeenClicked = true;
        if (this.INTERSECTED === null) {
            console.error("INTERSECTED was null");
            return;
        }
        this.loadCounties(this.INTERSECTED, true, true);
    }
    onMouseWheel(event) {
        const radius = new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0).sub(this.CURSOR_POS_3D).length();
        this._tempVector3.copy(this.CURSOR_POS_3D).sub(this.center);
        this._tempSpherical.setFromVector3(this._tempVector3);
        this._tempSpherical.makeSafe();
        const lat = (0, $b2dc26e6bbd9abd7$export$154a0da1a2902c7)(this._tempSpherical.phi, 0);
        const lng = (0, $b2dc26e6bbd9abd7$export$1957a5a293f382a4)(this._tempSpherical.theta);
        this.controls.setTBRadius(radius);
        this.controls._lngLat.set(lng, lat);
    }
    onPointerUp(event) {
        if (!event.isPrimary) return;
        this.mouseDownBool = false;
        document.removeEventListener("pointerup", this.pointerUpListener);
        /// //////////////////////////////
        // Drag / click disambiguation
        /// //////////////////////////////
        {
            // Final cursor position must be within this many pixels to be considered a "click"
            // This is so people can click and drag the map without accidentally clicking on a state
            // It's squared because calculating distance squared is faster than calculating distance
            const clickDragDistanceToleranceSquared = 0.00003;
            // Short circuit if the distance is too far to be considered a click
            if (this.pointerDragDistance > clickDragDistanceToleranceSquared) return;
            if (event.pointerType === "touch") {
                const bounds = this.canvas.getBoundingClientRect();
                const x = event.clientX - bounds.left;
                const y = event.clientY - bounds.top;
                this.pointer.x = x / document.documentElement.clientWidth * 2 - 1;
                this.pointer.y = -(y / document.documentElement.clientHeight) * 2 + 1;
                this.castMouseRay();
            }
        }
        /// //////////////////////////////
        // End Drag / click disambiguation
        /// //////////////////////////////
        this.pointer.x = -1000;
        this.pointer.y = -1000;
        // Stop here if we aren't mousing over anthing we can click
        if (this.INTERSECTED == null) return;
        // Disambiguate what kind of mesh we've clicked on
        const type = this.getMeshType(this.INTERSECTED);
        if (this.isUSA(this.INTERSECTED)) {
            const output = new $8725869b83961a04$export$64b5c384219d3699().copy(this.CURSOR_POS_3D);
            // output.y += 50;
            this.controls.focus(output);
            this.controls.trackInSlow(0.45, 1);
        } else if (type === "state") this.onStateClicked(event);
        else if (type === "county") this.loadZips(this.INTERSECTED);
        else if (type === "individualCounty") {
            // Send map clicked event
            const mapClickEvent = new CustomEvent("mapclick", {
                detail: {
                    pointerUpEvent: event
                }
            });
            this.dispatchEvent(mapClickEvent);
        } else if (type === "zip") {
            // Get the zip code from the mesh name
            // const zip = this.INTERSECTED.name.split("$")[0]
            // Set the active zip code, load in cities, update ballot boxes
            // this.selectZip(zip);
            const { latitude: latitude, longitude: longitude } = this.getLatLon(this.CURSOR_POS_3D);
            // Redirect to MapTiler page
            const county = this.ZIP_GROUP?.userData.fips;
            const origin = window.location.origin;
            const state = this.COUNTY_GROUP.userData.state_name;
            window.location.href = `${origin}/pages/osm.php?lat=${latitude}&lng=${longitude}&state=${state}&county=${county}`;
        // this.collapseDropdown(document.querySelector("#zip-code-container button"));
        }
    }
    onPointerDown(event) {
        let isStartingDrag = false;
        if (!event.isPrimary) return;
        if (event.pointerType === "touch") {
            isStartingDrag = true;
            const bounds = this.canvas.getBoundingClientRect();
            const x = event.clientX - bounds.left;
            const y = event.clientY - bounds.top;
            this.pointer.x = x / document.documentElement.clientWidth * 2 - 1;
            this.pointer.y = -(y / document.documentElement.clientHeight) * 2 + 1;
            this.castMouseRay();
        } else switch(event.button){
            case 0:
                isStartingDrag = true;
                break;
            case 1:
                break;
            case 2:
                break;
        }
        if (isStartingDrag) {
            this.mouseDownBool = true;
            this.pointerDragDistance = 0;
            this.pointerXOnPointerDown = this.pointer.x;
            this.pointerYOnPointerDown = this.pointer.y;
        // Set the drag surface distance
        // This improves drag precision for meshes away from the surface of the globe
        }
        // Send custom pointer down event for controls
        // TODO: handle multi touch?
        const radius = new $8725869b83961a04$export$64b5c384219d3699(0, 50, 0).sub(this.CURSOR_POS_3D).length();
        this._tempVector3.copy(this.CURSOR_POS_3D).sub(this.center);
        this._tempSpherical.setFromVector3(this._tempVector3);
        this._tempSpherical.makeSafe();
        const lat = (0, $b2dc26e6bbd9abd7$export$154a0da1a2902c7)(this._tempSpherical.phi, 0);
        const lng = (0, $b2dc26e6bbd9abd7$export$1957a5a293f382a4)(this._tempSpherical.theta);
        this.controls.setTBRadius(radius);
        this.controls._lngLat.set(lng, lat);
        // const customEvent = new CustomEvent("pointerdown", {
        //     ...event,
        //     detail: { lng, lat, radius },
        // })
        // this.dispatchEvent(customEvent)
        document.addEventListener("pointerup", this.pointerUpListener);
    }
    onWindowResize() {
        const aspectRatio = document.documentElement.clientWidth / document.documentElement.clientHeight;
        let fov = this.base_fov;
        // For anything less-than-square, start expanding the vertical FOV
        if (aspectRatio < 1) // By default, PerspectiveCamera works by specifying a fixed vertical FOV and aspect ratio.
        // Once we get to a slim enough aspect ratio, we want to specify a fixed horizontal FOV instead.
        // This calculates a vertical FOV from a fixed horizontal FOV and aspect ratio.
        fov = (0, $284c58eef2a1e870$export$2e2bcd8739ae039).horizontalToVerticalFOV(this.base_fov, aspectRatio);
        this.camera.fov = fov;
        this.camera.aspect = aspectRatio;
        this.camera.updateProjectionMatrix();
        this.controls.onWindowResize();
        this.labelRenderer.setSize(innerWidth, innerHeight);
        // Send out bottom bar change event
        this.dispatchFooterChangeEvent();
    }
    onMouseLeave(event) {
        this.pointer.x = -1000;
        this.pointer.y = -1000;
    }
    /**
     * "Lowers" a region like a state or county.
     * Used to lower regions that were previously raised.
     *
     * TODO: Refactor this to be part of region code?
     */ lower(obj, lowerDelay, grayDelay) {
        obj.userData.state = "lowered";
        // Stop all previous tweens on this object
        (0, $be68dac03006aaff$export$b86006a140a6bac4)(obj).removeAll();
        const region = (0, $be68dac03006aaff$export$d4a625cede2da71b)(obj);
        // Lower this object
        new (0, $7ArpZ.Tween)(obj.scale, (0, $be68dac03006aaff$export$b86006a140a6bac4)(obj)).to(obj.userData.loweredScale, 500).delay(lowerDelay * 1000).onComplete(()=>{
            if (region.face.userData.type === "county") region.bottomBorder.visible = false;
        }).start();
        // Turn all the children gray
        if (region instanceof (0, $7392ee50b9a2c168$export$7e0fd72fe0a85f54)) {
            obj.userData.active = false;
            region.deactivate();
            this.changeMapState({
                region: null
            });
            this.jumpToGray(obj);
            this.jumpToGray(obj.children.find((child)=>child instanceof $8725869b83961a04$export$e176487c05830cc5 && (0, $be68dac03006aaff$export$5bca2f41e52f6bfd)(child)));
        } else obj.traverse((child)=>{
            if (!("isMesh" in child) || child.isMesh === false) return;
            new (0, $7ArpZ.Tween)(child, (0, $be68dac03006aaff$export$b86006a140a6bac4)(obj)).to({
                material: {
                    color: this.lowerColor,
                    emissive: this.lowerEmissive
                },
                userData: {
                    inactiveColor: this.lowerColor,
                    inactiveEmissive: this.lowerEmissive
                }
            }, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).delay(grayDelay * 1000).start();
        });
    }
    restoreAndLower(object) {
        $145f47ad8b66c035$var$makeVisible((0, $be68dac03006aaff$export$d4a625cede2da71b)(object));
        this.lower(object, 0, 0);
    }
    /**
     * Raises a region, for example when a user selects the region, or when a reset happens.
     * @param object
     */ async raise(object) {
        this.dispatchEvent(new CustomEvent("regionraise", {
            detail: object
        }));
        // if(object.region) {
        //     // Make mesh faces transparent
        //     const mat = new THREE.MeshStandardMaterial({
        //         transparent: true,
        //         opacity: 0,
        //         blending: THREE.CustomBlending,
        //         blendEquation: THREE.AddEquation,
        //         blendSrc: THREE.OneFactor,
        //         blendDst: THREE.ZeroFactor
        //     })
        //     object.region.face.material = mat
        //     console.log('REGION!')
        // }
        (0, $be68dac03006aaff$export$d4a625cede2da71b)(object).bottomBorder.visible = true;
        (0, $be68dac03006aaff$export$b86006a140a6bac4)(object)?.removeAll();
        await new Promise((resolve, reject)=>{
            new (0, $7ArpZ.Tween)(object.scale, (0, $be68dac03006aaff$export$b86006a140a6bac4)(object)).to(object.userData.clickedScale, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).start().onComplete(()=>{
                console.log("tween complete");
                resolve();
                try {
                    const region = (0, $be68dac03006aaff$export$d4a625cede2da71b)(object);
                    if (!("isMapRegion" in region)) return;
                    this.changeMapState({
                        region: region
                    });
                } catch (err) {
                // No region
                }
            }).onStop(()=>{
                console.log("tween stop");
                resolve();
            });
        });
    }
    animateLowerInWave(group, center, doNotAnimateMe, speed = 0.5) {
        for(let i = 0; i < group.children.length; i++){
            const obj = group.children[i];
            if (doNotAnimateMe != null && doNotAnimateMe !== undefined && obj.name === doNotAnimateMe.name) continue;
            const anchor = this.getChildAnchor(obj);
            if (anchor === undefined) throw new Error("Object did not have anchor");
            const delay = anchor.position.angleTo(center) * (1 / speed);
            if (obj instanceof $8725869b83961a04$export$e176487c05830cc5) this.lower(obj, delay + 0.5, delay);
        }
    }
    lowerStatesAndCountries() {
        // Handle the case where states are "lowered" before they're actually raised
        if (this.state.zoomLevel === 0) this.STATE_GROUP.children.map((state)=>(0, $be68dac03006aaff$export$d4a625cede2da71b)(state)).forEach((region)=>{
            region.face.scale.copy(region.face.userData.randomScale);
        });
        if (!this.areCountiesLoaded()) {
            const anchor = this.getChildAnchor(this.CLICKED);
            if (anchor === undefined) throw new Error("Object had no anchor");
            this.loadStatesPromise.then(()=>{
                this.animateLowerInWave(this.STATE_GROUP, anchor.position, this.CLICKED === null ? undefined : this.CLICKED);
            });
            this.loadCountriesPromise.then(()=>{
                // for (var i = 0; i < this.COUNTRIES.children[0].children.length; i++) {
                //     const country = this.COUNTRIES.children[0].children[i];
                //     // Special case for russia to make sure it doesnt clip into water
                //     if (country.name == "Russian_Federation")
                //         country.userData.loweredScale.set(.01022, .01022, .01022);
                // }
                this.animateLowerInWave(this.COUNTRIES.children[0], anchor.position);
            });
        // if(this.areCountriesLoaded()) {
        //     for (var i = 0; i < this.COUNTRIES.children[0].children.length; i++) {
        //         const country = this.COUNTRIES.children[0].children[i];
        //         // Special case for russia to make sure it doesnt clip into water
        //         if (country.name == "Russian_Federation")
        //             country.userData.loweredScale.set(.01022, .01022, .01022);
        //     }
        //     this.animateLowerInWave(this.COUNTRIES.children[0], this.getChildAnchor(this.CLICKED).position, null);
        // }
        }
    }
    lowerAnythingRaised() {
        // Initial "gray wave" animation
        this.lowerStatesAndCountries();
        this.lowerZips();
        // Handle raised counties
        if (this.areCountiesLoaded()) {
            const state = this.getStateByAbbr(this.COUNTY_GROUP.userData.abbr);
            if (state === null) {
                console.error("state is null");
                return;
            }
            if (!(state instanceof $8725869b83961a04$export$e176487c05830cc5)) {
                console.error("state is not a mesh");
                return;
            }
            this.ANIMATIONS.killAll(state, state.material, state.userData);
            state.traverse((obj)=>{
                this.ANIMATIONS.killAll(obj, obj.userData);
                if (obj instanceof $8725869b83961a04$export$e176487c05830cc5) this.ANIMATIONS.killAll(obj.material);
            });
            this.restoreAndLower(state);
            this.removeCountyGroup(this.COUNTY_GROUP);
        }
    }
    lowerZips() {
        if (!this.areZipsLoaded()) {
            if (this.CLICKED?.userData.type === "county") this.restoreAndLower(this.CLICKED);
            return;
        }
        const county = this.CLICKED;
        if (county !== null) {
            this.ANIMATIONS.killAll(county, county.material, county.userData);
            county.traverse((obj)=>{
                if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
                this.ANIMATIONS.killAll(obj, obj.material, obj.userData);
            });
            this.restoreAndLower(county);
        }
        this.INDIVIDUAL_COUNTY?.dispose(false, false);
        this.ZIP_GROUP = null;
    }
    fadeOut(obj) {
        // if (!obj.isMesh)
        //     return;
        // const mesh = obj;
        // mesh.castShadow = false;
        // mesh.receiveShadow = false;
        // // Bottom border material is shared, so we swap material during fade to avoid affecting the other meshes
        // mesh.userData.oldMaterial = mesh.material;
        // mesh.material = mesh.material.clone();
        // if (mesh.name.endsWith("_BottomBorder")) {
        //     // Add radial gradient shader snippet to the bottom border material shader
        //     mesh.material.onBeforeCompile = function (shader, renderer) {
        //         injectFakeAO(shader, renderer);
        //     };
        // }
        // // mesh.material.transparent = true;
        // const animation = new Animation(mesh.material, "opacity", 0, 0.1, 0);
        // animation.promise.then(() => {
        //     const oldMaterial = mesh.material;
        //     mesh.material = mesh.userData.oldMaterial;
        //     oldMaterial.dispose();
        //     mesh.visible = false;
        //     this.updateIntersectable();
        // });
        // this.ANIMATIONS.add(animation);
        obj.visible = false;
    }
    /**
     * Handles functionality relating to the display of map textures on MapRegions
     * @param param0
     * @returns
     */ changeMapState({ region: region, closeEnough: closeEnough }) {
        if (region !== undefined && closeEnough !== undefined) {
            console.error("changeMapState can't change multiple state values simultaneously but tried", region, closeEnough);
            return;
        }
        const regionChanged = region !== undefined && region !== this.state.map.region;
        const closeEnoughChanged = closeEnough !== undefined && closeEnough !== this.state.map.closeEnough;
        if (closeEnoughChanged) {
            if (closeEnough === false) // Camera went too far to show map
            {
                if (this.state.map.region !== null) {
                    this.state.map.region.unHolePunch();
                    this.dispatchEvent(new CustomEvent("mapleave"));
                }
            } else if (closeEnough === true) // Camera came close enough to show map
            {
                if (this.state.map.region != null) {
                    this.dispatchEvent(new CustomEvent("mapenter"));
                    // Wait one frame before hole punching to give the map time to update
                    requestAnimationFrame(()=>{
                        this.state.map.region?.holePunch();
                    });
                }
            }
            this.state.map.closeEnough = closeEnough;
            return;
        }
        if (regionChanged) {
            if (this.state.map.closeEnough) {
                if (region === null) {
                    // Old region stopped displaying map
                    this.state.map.region?.unHolePunch();
                    this.dispatchEvent(new CustomEvent("mapleave"));
                } else {
                    // New region started displaying map
                    region.holePunch();
                    this.dispatchEvent(new CustomEvent("mapenter"));
                }
            }
            this.state.map.region = region;
        }
    }
    // TODO: Refactor into a loader library?
    async safeLoad(promise) {
        // Set safety guard
        this.mostRecentLoad = new (0, $4ec851b782047d0d$export$19529cff8faf2696)(this.CLICKED);
        const currentLoad = this.mostRecentLoad;
        // Do load
        const resource = await promise;
        // Check safety guard
        if (!(this.mostRecentLoad === currentLoad)) {
            if (resource instanceof Object && "scene" in resource && resource.scene instanceof $8725869b83961a04$export$e4dd07dff30cc924) this.removeCountyGroup(resource.scene);
            throw new Error("A different region was clicked while this one was loading");
        }
        return resource;
    }
    // TODO: Refactor into a loader library?
    isDoubleLoad(obj) {
        return this.mostRecentLoad?.object === obj;
    }
    loadCountiesWithRaisePromise(state, zoom = true, options) {
        const { modifyHistory: modifyHistory = true, modifyTutorial: modifyTutorial = true, signal: signal } = options;
        let stateMesh;
        if (typeof state === "string") stateMesh = this.getStateByName(state);
        else stateMesh = state;
        // if (this.isDoubleLoad(stateMesh)) return null
        // Special case for DC, which only has one county. Don't add county history step.
        if (stateMesh.userData.fips === "11") ;
        else if (modifyHistory) {
            const historyState = (0, $ed93617e655b9b33$export$4e41f2e73cf74a15)({
                fips: stateMesh.userData.fips
            });
            (0, $ed93617e655b9b33$export$a104c684a09de9be)(historyState);
        }
        if (modifyTutorial) this.tutorial.state.send("LOAD_COUNTIES");
        this.dispatchEvent(new CustomEvent("entercounties"));
        this.changeMapState({
            region: null
        });
        /// ////////////////////////////
        // Update bottom menu
        /// ////////////////////////////
        // Switch to state list
        // switchToStateList()
        // // Unhighlight the old button
        // {
        //     const button = document.querySelector(
        //         ".state_list ul li.highlighted"
        //     )
        //     // No need for error handling; this is expected to be null the first time
        //     button?.classList.remove("highlighted")
        // }
        // // Select and scroll to new button
        // const button = document.querySelector(
        //     `.state_list ul li#${stateMesh.userData.abbr as string}`
        // )
        // if (button === null) {
        //     // Handle error - highly unexpected
        //     console.error(
        //         stateMesh.userData.abbr,
        //         "Could not find state button"
        //     )
        // } else {
        //     button.classList.add("highlighted")
        //     scrollBottomBarToHighlighted("state_list")
        // }
        this._optimizationHideCountries();
        // TODO: #abort Abort
        const countyListPromise = (0, $13b202410cedebbf$export$a3be6965b053c4b2)(stateMesh.userData.abbr, "").then((firstLoad)=>{
            // Show state header (which is the state list for some reason, ew)
            const list = document.querySelector(".state_list");
            if (list === null) // Handle error - highly unexpected
            console.error("State list element not found");
            else list.classList.remove("hidden");
            // TODO: #abort Pass in abort signal
            this.dispatchFooterChangeEvent();
            return firstLoad;
        });
        /// //////////////////////
        // Zoom camera
        /// //////////////////////
        if (zoom) {
            this.controls.setMinDistance(53.2);
            this.controls.focusMesh(stateMesh, 1, true);
        }
        if (this.areCountiesLoaded() && stateMesh.userData.fips === this.COUNTY_GROUP.userData.fips) {
            // Go back to state level being active
            this.lowerZips();
            // Unset region. This will indicate that the map is no longer visible.
            this.changeMapState({
                region: null
            });
            // Update tutorial state. This has the side effect of sliding back the left panel
            this.INDIVIDUAL_COUNTY?.dispose(false, false);
            this.unFadeToGray(this.COUNTY_GROUP);
            this.updateIntersectable();
            return [
                Promise.resolve(null),
                Promise.resolve()
            ];
        }
        this.CLICKED = stateMesh;
        // Play animations
        this.lowerAnythingRaised();
        /// /////////////////////////////////////////////////////////////////
        // Special case - don't load counties in screenshot mode
        /// /////////////////////////////////////////////////////////////////
        if (this.ballot_screenshot_mode !== null && this.ballot_screenshot_mode !== "") {
            setTimeout(()=>{
                if (this.CLICKED === null) {
                    console.error("CLICKED is null");
                    return;
                }
                this.CLICKED.scale.copy(this.CLICKED.userData.clickedScale);
                if ("color" in this.CLICKED.material) {
                    const color = this.CLICKED.material.color;
                    color.set("rgb(60, 52, 43)");
                } else console.error("CLICKED.material has no color");
            }, 1000);
            return [
                Promise.resolve(null),
                Promise.resolve()
            ];
        }
        const raisePromise = this.raise(stateMesh);
        /// //////////////////////
        // Load in new counties
        /// //////////////////////
        let gltfPromise = this.safeLoad(this.stateLoader.addCounties(this.CLICKED.userData.abbr, {
            signal: options.signal
        }));
        gltfPromise = gltfPromise.then((gltf)=>{
            if (this.CLICKED === null) throw new Error("CLICKED is null");
            if (options?.signal?.aborted !== null && options?.signal?.aborted !== undefined && options.signal.aborted) {
                console.warn("Aborted");
                throw new Error(options.signal.reason);
            }
            // Put the new counties in the scene
            this.COUNTY_GROUP = gltf.scene;
            (0, $be68dac03006aaff$export$b3d257225ea880da)(this.COUNTY_GROUP);
            this.COUNTY_GROUP.userData.state_name = this.CLICKED.userData.name.replace(/_/g, " ");
            this.COUNTY_GROUP.userData.abbr = this.CLICKED.userData.abbr;
            this.COUNTY_GROUP.userData.fips = this.CLICKED.userData.fips;
            this.group.add(this.COUNTY_GROUP);
            this.updateIntersectable();
            (0, $be68dac03006aaff$export$8d2fff1477b88ccf)(this.CLICKED, gltf.scene);
            // Fade out state meshes
            this.CLICKED.traverse((obj)=>{
                this.fadeOut(obj);
            });
            // Special case for DC, which only has one county. Immediately load zips.
            if (stateMesh.userData.fips === "11") // Wait for the "county" to raise before loading zips
            // TODO: Fix the root cause preventing immediate loading
            raisePromise.then(async ()=>{
                // TODO: Add signal
                await this.loadZips(gltf.scene.children[0], {
                    modifyHistory: modifyHistory,
                    signal: signal
                });
            });
            return gltf;
        }).catch((err)=>{
            throw err;
        });
        // Set up county list callbacks when both county list and gltf are loaded
        Promise.all([
            gltfPromise,
            countyListPromise
        ]).then(([_, firstLoad])=>{
            signal?.throwIfAborted();
            if (!firstLoad) return;
            // Set up county list callbacks
            document.querySelectorAll(".county_list li").forEach((element)=>{
                const a = element.querySelector("span");
                if (a === null) {
                    console.error("County list <li> did not have <span> child");
                    return;
                }
                const fips = element.getAttribute("fips");
                if (fips === null) {
                    console.error("County list <li> did not have fips attribute");
                    return;
                }
                const mesh = this.getMeshByFips(fips);
                if (mesh === null) {
                    console.error(`No mesh corresponding to fips code ${fips} found`);
                    return;
                }
                a.addEventListener("mouseover", (event)=>{
                    this.highlight(mesh);
                });
                a.addEventListener("mouseout", (event)=>{
                    this.unhighlight(mesh);
                });
                a.addEventListener("click", (event)=>{
                    this.loadZips(mesh);
                });
            });
        }).catch((err)=>{
            console.warn(err);
        });
        return [
            gltfPromise,
            raisePromise
        ];
    }
    async loadCounties(state, zoom = true, modifyHistoryOrOptions) {
        let modifyHistory = true;
        let modifyTutorial = true;
        let signal;
        if (modifyHistoryOrOptions === undefined) modifyHistory = true;
        else if (typeof modifyHistoryOrOptions === "boolean") modifyHistory = modifyHistoryOrOptions;
        else ({ modifyHistory: modifyHistory = true, modifyTutorial: modifyTutorial = true, signal: signal } = modifyHistoryOrOptions);
        const [gltfPromise] = this.loadCountiesWithRaisePromise(state, zoom, {
            modifyHistory: modifyHistory,
            modifyTutorial: modifyTutorial,
            signal: signal
        });
        return await gltfPromise;
    }
    getMeshByFips(fips) {
        let mesh = null;
        if (fips.length === 5) this.COUNTY_GROUP.traverse((obj)=>{
            if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
            if (obj.name === fips) mesh = obj;
        });
        return mesh;
    }
    isRegionSpecifiedInUrl() {
        // const url = new URL(window.location);
        // return url.searchParams.has("fips")
        //     || url.searchParams.has("state");
        return true;
    }
    fadeToGray(group) {
        if (!(0, $be68dac03006aaff$export$1f7546cb86a68804)(group)) {
            console.warn("fadeToGray on non-map groups not implemented");
            return;
        }
        group.userData.materials.inactive.forEach((material)=>{
            new (0, $7ArpZ.Tween)(material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(group)).to({
                color: this.lowerColor,
                emissive: this.lowerEmissive
            }, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).start();
        });
        group.children.filter((0, $be68dac03006aaff$export$2f8501431017a005)).map((obj)=>obj.children.find((0, $be68dac03006aaff$export$5bca2f41e52f6bfd))).forEach((topBorder)=>{
            if (topBorder === undefined) {
                console.error("Map mesh did not have top border");
                return;
            }
            if (!(topBorder instanceof $8725869b83961a04$export$e176487c05830cc5)) {
                console.error("Top border was not a mesh");
                return;
            }
            new (0, $7ArpZ.Tween)(topBorder.material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(group)).to({
                color: this.lowerColor,
                emissive: this.lowerEmissive
            }, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).start();
        });
        group.children.filter((obj)=>{
            try {
                return (0, $be68dac03006aaff$export$d4a625cede2da71b)(obj) instanceof (0, $7392ee50b9a2c168$export$7e0fd72fe0a85f54);
            } catch  {
                return false;
            }
        }).forEach((mesh)=>{
            (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh).deactivate();
        });
    }
    unFadeToGray(group) {
        if (!(0, $be68dac03006aaff$export$1f7546cb86a68804)(group)) {
            console.warn("unFadeToGray on non-map groups not implemented");
            return;
        }
        group.userData.materials.inactive.forEach((material)=>{
            new (0, $7ArpZ.Tween)(material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(group)).to({
                color: this.unfadeColor,
                emissive: this.unfadeEmissive
            }, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).start();
        });
        group.children.filter((0, $be68dac03006aaff$export$2f8501431017a005)).map((obj)=>obj.children.find((0, $be68dac03006aaff$export$5bca2f41e52f6bfd))).forEach((topBorder)=>{
            if (topBorder === undefined) {
                console.error("Map mesh did not have top border");
                return;
            }
            if (!(topBorder instanceof $8725869b83961a04$export$e176487c05830cc5)) {
                console.error("Top border was not a mesh");
                return;
            }
            new (0, $7ArpZ.Tween)(topBorder.material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(group)).to({
                color: this.unfadeColor,
                emissive: this.unfadeEmissive
            }, 500).easing((0, $7ArpZ.Easing).Quadratic.Out).start();
        });
        group.children.filter((obj)=>{
            try {
                return (0, $be68dac03006aaff$export$d4a625cede2da71b)(obj) instanceof (0, $7392ee50b9a2c168$export$7e0fd72fe0a85f54);
            } catch  {
                return false;
            }
        }).forEach((mesh)=>{
            (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh).activate();
        });
    }
    jumpToGray(mesh) {
        if (mesh.parent === null) {
            console.warn("Mesh had no parent");
            return;
        }
        if ((0, $be68dac03006aaff$export$2f8501431017a005)(mesh)) mesh.material = mesh.parent.userData.materials.inactive[mesh.parent.userData.mapLevel];
        else {
            if (!("color" in mesh.material)) {
                console.warn("Mesh material did not have color");
                return;
            }
            const color = mesh.material.color;
            color.copy(this.lowerColor);
            if (!("emissive" in mesh.material)) // This is the case for basic materials
            return;
            const emissive = mesh.material.emissive;
            emissive.copy(this.lowerEmissive);
        }
    }
    async loadZips(countyMesh, { modifyHistory: modifyHistory = true, modifyTutorial: modifyTutorial = true, signal: signal } = {}) {
        this.dispatchEvent(new CustomEvent("regionload", {
            detail: {
                type: "zip",
                id: countyMesh.userData.fips,
                name: countyMesh.userData.name,
                county: countyMesh.userData.fips,
                state: this.COUNTY_GROUP.userData.state_name
            }
        }));
        // if (this.isDoubleLoad(countyMesh))
        //     return null;
        if (modifyHistory) {
            const historyState = (0, $ed93617e655b9b33$export$4e41f2e73cf74a15)({
                fips: countyMesh.userData.fips
            });
            (0, $ed93617e655b9b33$export$a104c684a09de9be)(historyState);
        }
        // TODO: #abort Abort
        this.lowerZips();
        // Highlight county on bottom bar
        const prevSelected = document.querySelector(".county_list .selected");
        prevSelected?.classList.remove("selected");
        const ele = document.querySelector(`li[fips='${countyMesh.userData.fips}']`);
        if (ele != null) {
            ele.classList.add("selected");
            (0, $13b202410cedebbf$export$7e4b7e6b8ee74890)("county_list");
        } else console.warn(`Mesh with fips ${countyMesh.userData.fips} and name ${countyMesh.userData.name} has no corresponding bottom bar entry`);
        this.tutorial.state.send("LOAD_ZIPS");
        // TODO: #abort Add abort signal to CustomEvent
        this.dispatchEvent(new CustomEvent("loadzips"));
        this.CLICKED = countyMesh;
        if (!this.areZipsLoaded()) // TODO: #abort Pass in abort signal
        this.fadeToGray(this.COUNTY_GROUP);
        // TODO: #abort Pass in abort signal
        const raisePromise = this.raise(countyMesh);
        this.controls.setMinDistance(53.15);
        this.controls.focusMesh(countyMesh, 1, true, 53.2, 1.5);
        const promise = this.safeLoad(this.stateLoader.addIndividualCounty(countyMesh.userData.fips, {
            signal: signal
        }));
        // TODO: Fix this for map geojson
        // this.leftPanel.setCounty(countyMesh.userData.name, promise, this);
        let mesh;
        try {
            mesh = await promise;
        } catch (error) {
            console.warn(error);
            return;
        }
        signal?.throwIfAborted();
        await raisePromise;
        signal?.throwIfAborted();
        const region = (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh);
        (0, $be68dac03006aaff$export$d4a625cede2da71b)(this.CLICKED).hide();
        region.face.scale.copy(new $8725869b83961a04$export$64b5c384219d3699().copy(this.CLICKED.scale).multiplyScalar(this.COUNTY_GROUP.scale.x));
        region.face.material = this.materials.holePunch;
        this.group.add(region.face);
        this.INDIVIDUAL_COUNTY = region;
        this.updateIntersectable();
    // // Make mesh faces transparent
    // const mat = new THREE.MeshStandardMaterial({
    //     transparent: true,
    //     opacity: 0,
    //     blending: THREE.CustomBlending,
    //     blendEquation: THREE.AddEquation,
    //     blendSrc: THREE.OneFactor,
    //     blendDst: THREE.ZeroFactor
    // })
    // this.ZIP_GROUP.region.faces.forEach(face => {
    //     face.material = mat
    // })
    // return gltf;
    }
    /**
     * Highlights a mesh, for example when mousing over it.
     */ highlight(mesh) {
        try {
            (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh).highlight(this.settings.hoverColor.color);
        } catch  {
            // TODO: Check if this code is still needed
            if ("color" in mesh.material) {
                const color = mesh.material.color;
                color.set(this.settings.hoverColor.color);
            }
        }
        // Show the label
        const intersectedLabel = (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh)?.label;
        if (intersectedLabel != null) {
            intersectedLabel.visible = true;
            this.labelRenderer.render(intersectedLabel, this.camera);
        }
    }
    unhighlight(mesh) {
        try {
            (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh).unhighlight();
        } catch  {
            // TODO: Check if this code is still needed
            if ("color" in mesh.material) {
                const color = mesh.material.color;
                color.copy(mesh.userData.inactiveColor);
            }
        }
        const intersectedLabel = (0, $be68dac03006aaff$export$d4a625cede2da71b)(mesh)?.label;
        if (intersectedLabel != null) {
            intersectedLabel.visible = false;
            this.labelRenderer.render(intersectedLabel, this.camera);
        }
    }
    castMouseRay() {
        // Position the raycaster
        this.raycaster.setFromCamera(this.pointer, this.camera);
        // Do the raycast
        const intersections = this.raycaster.intersectObjects(this.RAYCAST_INTERSECTABLE, false);
        let object;
        if (intersections.length !== 0) {
            // Convenience variable for later
            object = intersections[0].object;
            // Update CURSOR_POS_3D
            this.CURSOR_POS_3D.copy(intersections[0].point);
        } else // Clear CURSOR_POS_3D
        this.CURSOR_POS_3D.set(0, 0, 0);
        // Short circuit if we're still intersecting the same old object
        if (this.INTERSECTED === object) return;
        if (this.INTERSECTED != null) // Un-highlight the previously highlighted mesh
        this.unhighlight(this.INTERSECTED);
        // Short circuit if we intersected water
        if (object === this.WATER) {
            this.INTERSECTED = null;
            return;
        }
        // Store intersected object as a global variable for events to interact with
        // This line also unsets INTERSECTED if we're not intersecting anything
        if (object instanceof $8725869b83961a04$export$e176487c05830cc5) {
            this.INTERSECTED = object != null ? object : null;
            this.highlight(object);
        } else this.INTERSECTED = null;
    }
    /**
     * Main render entrypoint
     * @param elapsed
     */ render(renderer) {
        renderer.render(this.scene, this.camera);
        // Render region labels
        if (this.INTERSECTED != null) {
            if (this.highlightedLabel !== null && this.highlightedLabel !== undefined) this.labelRenderer.render(this.highlightedLabel, this.camera);
        }
        // Render map pins
        for (const pin of this.mapPins){
            const region = pin.data.region;
            // Get distance between camera and anchor
            region.anchor.getWorldPosition(this._tempVector3);
            this.camera.getWorldPosition(this._temp2Vector3);
            this._tempVector3.sub(this._temp2Vector3);
            const distance = this._tempVector3.length();
            // Get the fips of the currently raised region
            const raisedAbbr = this.currentLayerGroup.userData.abbr;
            if (// angularDistance < pin.data.angularThreshold &&
            distance < pin.data.distanceThreshold.far && distance >= pin.data.distanceThreshold.near && (pin.data.onlyWhileRaised === undefined || pin.data.onlyWhileRaised === raisedAbbr) && (pin.data.exclude === undefined || !pin.data.exclude.includes(raisedAbbr)) && pin.data.layer === this.currentLayerKind) {
                if (pin.data.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Vertical) {
                    const obj = pin.obj;
                    obj.visible = true;
                    this.labelRenderer.render(obj, this.camera);
                } else if (pin.data.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Left || pin.data.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Right) {
                    const obj = pin.obj;
                    obj.visible = true;
                    obj.label.visible = true;
                    obj.line.visible = true;
                    this.labelRenderer.render(obj, this.camera);
                    obj.label.getWorldPosition(this._tempVector3);
                    obj.line.getWorldPosition(this._temp2Vector3);
                    obj.updateLine(this._tempVector3, this._temp2Vector3, this.camera);
                }
            } else {
                if (pin.data.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Vertical) {
                    const obj = pin.obj;
                    obj.visible = false;
                    this.labelRenderer.render(obj, this.camera);
                } else if (pin.data.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Left || pin.data.pinKind === (0, $b6d45e1af0433d6c$export$ea1d1004ed602ef8).Right) {
                    const obj = pin.obj;
                    obj.visible = false;
                    obj.label.visible = false;
                    obj.line.visible = false;
                    this.labelRenderer.render(pin.obj, this.camera);
                }
            }
        }
    }
    fadeOutRing() {
        if (this.globe_ring === null) {
            console.warn("globe_ring was null");
            return;
        }
        this.globe_ring.classList.remove("fade-in");
        this.globe_ring.classList.add("fade-out");
    }
    fadeInRing() {
        if (this.globe_ring === null) {
            console.warn("globe_ring was null");
            return;
        }
        this.globe_ring.classList.remove("fade-out");
        this.globe_ring.classList.add("fade-in");
    }
    fadeOutTapHelpers() {
        const eles = document.querySelectorAll(".tab-helper-root");
        eles.forEach((ele)=>{
            // ele.classList.remove("fade-in")
            ele.classList.add("fade-out");
            ele.style.pointerEvents = "none";
        });
    }
    fadeInTapHelpers() {
        const eles = document.querySelectorAll(".tab-helper-root");
        eles.forEach((ele)=>{
            // ele.classList.add("fade-in")
            ele.classList.remove("fade-out");
            ele.style.pointerEvents = "";
        });
    }
    updateTweens() {
        this.ANIMATIONS.update();
        /* Update tweens */ (0, $7ArpZ.update)();
        (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA).update();
        this.STATE_GROUP?.children.forEach((state)=>{
            (0, $be68dac03006aaff$export$b86006a140a6bac4)(state).update();
        });
        this.COUNTRIES.children[0]?.children.forEach((country)=>{
            (0, $be68dac03006aaff$export$b86006a140a6bac4)(country).update();
        });
        try {
            (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.COUNTY_GROUP).update();
        } catch  {}
        this.COUNTY_GROUP?.children.forEach((county)=>{
            if (!(0, $be68dac03006aaff$export$2f8501431017a005)(county)) return;
            (0, $be68dac03006aaff$export$b86006a140a6bac4)(county).update();
        });
        this.ZIP_GROUP?.children.forEach((zip)=>{
            (0, $be68dac03006aaff$export$b86006a140a6bac4)(zip).update();
        });
    }
    /**
     *
     * @param elapsed Do all animation
     */ animate(elapsed) {
        if (this.gpuTier.isMobile === false) // Find if the mouse is intersecting with anything
        this.castMouseRay();
        this.controls.update();
        this.updateTweens();
        /* Rotate the ring around the globe */ if (this.globe_ring != null) {
            let dist = this.controls.getDistance();
            let scale;
            if (dist >= 170) scale = 170 / dist;
            else {
                dist = Math.pow(dist, 2);
                scale = 28900 / dist;
            }
            // One rotation every 8 seconds
            const angle = elapsed * 360 / 8 % 360;
            this.globe_ring.style.setProperty("transform", `translate(-50%,-50%) scale(${scale}) rotate(${angle}deg)`);
        }
        /* Do map texture swaps */ const dist = this.controls.getDistance();
        // TODO OPTIMIZATION-CPU: Calculate this once for each county group
        let sqrt = Math.sqrt(this.COUNTY_GROUP.children[0]?.userData.groupMapArea);
        if (isNaN(sqrt)) sqrt = 0;
        const distCutoff = 54 + sqrt / 4;
        if (dist < distCutoff && this.COUNTY_GROUP.userData.mapLevel === 0) {
            this.COUNTY_GROUP.userData.mapLevel = 1;
            const materials = this.COUNTY_GROUP.userData.materials;
            if (materials?.active[this.COUNTY_GROUP.userData.mapLevel] != null) this.COUNTY_GROUP.children.forEach((obj)=>{
                if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
                if (!(0, $be68dac03006aaff$export$2f8501431017a005)(obj)) return;
                try {
                    const region = (0, $be68dac03006aaff$export$d4a625cede2da71b)(obj);
                    if (region instanceof (0, $7392ee50b9a2c168$export$7e0fd72fe0a85f54)) region.setMapLevel(this.COUNTY_GROUP.userData.mapLevel);
                    else console.error("County child was not a map region");
                } catch  {}
            });
        } else if (dist > distCutoff + 1 && this.COUNTY_GROUP.userData.mapLevel === 1) {
            this.COUNTY_GROUP.userData.mapLevel = 0;
            const materials = this.COUNTY_GROUP.userData.materials;
            if (materials?.active[this.COUNTY_GROUP.userData.mapLevel] != null) this.COUNTY_GROUP.children.forEach((obj)=>{
                if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
                if (!(0, $be68dac03006aaff$export$2f8501431017a005)(obj)) return;
                try {
                    const region = (0, $be68dac03006aaff$export$d4a625cede2da71b)(obj);
                    if (region instanceof (0, $7392ee50b9a2c168$export$7e0fd72fe0a85f54)) region.setMapLevel(this.COUNTY_GROUP.userData.mapLevel);
                    else console.error("County child was not a map region");
                } catch  {}
            });
        }
        /* Auto-hide individual county region (keywords: auto lower, autolower) */ if (!this.controls.isFocusing && this.INDIVIDUAL_COUNTY != null && !this.INDIVIDUAL_COUNTY.disposed && this.INDIVIDUAL_COUNTY.id !== "11001" // Exception for District of Columbia
        ) {
            // console.log(this.INDIVIDUAL_COUNTY.id)
            const threshold = 0.25 // degrees latitude/longitude
            ;
            const lat = 90 - (this.controls.getPolarAngle() + this.controls.getExtraThetaOffset()) * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG;
            const lon = -90 + this.controls.getAzimuthalAngle() * (0, $284c58eef2a1e870$export$2e2bcd8739ae039).RAD2DEG;
            const { minx: minx, miny: miny, maxx: maxx, maxy: maxy } = this.INDIVIDUAL_COUNTY.face.userData;
            if (!this.isInBounds(lon, minx, maxx, threshold) || !this.isInBounds(lat, miny, maxy, threshold)) {
                // Go back to state level being active
                this.lowerZips();
                // Unset region. This will indicate that the map is no longer visible.
                this.changeMapState({
                    region: null
                });
                // Update tutorial state. This has the side effect of sliding back the left panel
                this.tutorial.state.send("LOAD_COUNTIES");
                this.INDIVIDUAL_COUNTY.dispose(false, false);
                this.unFadeToGray(this.COUNTY_GROUP);
                this.updateIntersectable();
                // Update history state
                const state = (0, $ed93617e655b9b33$export$4e41f2e73cf74a15)({
                    fips: this.COUNTY_GROUP.userData.fips
                });
                (0, $ed93617e655b9b33$export$a104c684a09de9be)(state);
            }
        }
    }
    performMapTextureSwap(mesh, mapLevel) {
        if (mesh.parent === null) {
            console.error("Mesh had no parent");
            return;
        }
        let materials;
        if (mesh.userData.inactive !== undefined && !mesh.userData.highlighted) materials = mesh.parent.userData.materials.inactive;
        else materials = mesh.parent.userData.materials.active;
        mesh.material = materials[mapLevel];
    }
    // TODO: Refactor to a math library
    isInBounds(val, low, high, threshold) {
        return val > low - threshold && val < high + threshold;
    }
    /**
     * Remove a group of counties
     * Also disposes of county geometry, labels and textures
     */ removeCountyGroup(countyGroup) {
        countyGroup.traverse((obj)=>{
            // Dispose geometry
            if ("geometry" in obj && obj.geometry instanceof $8725869b83961a04$export$b7be63a67df8959) obj.geometry.dispose();
            // Dispose material
            if ("material" in obj && obj.material instanceof $8725869b83961a04$export$a2d8b23205c25948) {
                if ("map" in obj.material && obj.material.map instanceof $8725869b83961a04$export$5431306cf43de24a) obj.material.map.dispose();
                obj.material.dispose();
            }
            // Remove label
            const label = this.getLabel(obj);
            if (label != null) label.parent?.remove(label);
        });
        countyGroup.parent?.remove(countyGroup);
        countyGroup.remove(...countyGroup.children);
        this.updateIntersectable();
    // this.COUNTY_GROUP = new THREE.Group();
    }
    onZoomLevelChange(event) {
        this.updateIntersectable();
        const navList = document.querySelector(".navigation_list");
        const bottomCurves = document.querySelectorAll(".curve-left, .curve-right, img.l, img.r");
        /// //////////////////////////////////////////
        // Handle going from zoomed out to zoomed in
        /// //////////////////////////////////////////
        if (event.detail.oldZoomLevel === 0 && event.detail.newZoomLevel === 1) {
            // Show the reset button
            if (!this.state.resetButtonShown) {
                this.resetButton.classList.remove("hidden");
                this.resetButton.classList.add("visible");
                this.state.resetButtonShown = true;
            }
            // Do stuff
            this.loadUSAPromise.then(()=>{
                if (this.USA.userData.state === "visible") {
                    this.USA.userData.state = "hidden";
                    // Stop all current tweens
                    (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA).removeAll();
                    this.USA.traverse((obj)=>{
                        if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
                        const tween1 = new (0, $7ArpZ.Tween)(obj.material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA)).to({
                            opacity: 0.5
                        }, 120).onComplete(()=>{
                            obj.castShadow = false;
                            obj.receiveShadow = false;
                        });
                        const tween2 = new (0, $7ArpZ.Tween)(obj.material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA)).to({
                            opacity: 0
                        }, 120).onComplete(()=>{
                            this.USA.visible = false;
                        });
                        tween1.chain(tween2);
                        tween1.start();
                    });
                    if (!this.areCountiesLoaded()) // Raise the states
                    this.STATE_GROUP.traverse((obj)=>{
                        // Filter out all but top level (face) meshes
                        if (obj.parent !== this.STATE_GROUP) return;
                        new (0, $7ArpZ.Tween)(obj.scale, (0, $be68dac03006aaff$export$b86006a140a6bac4)(obj)).to(obj.userData.randomScale, 200).start();
                    });
                }
            });
            // Change the color of the countries
            this.COUNTRIES.children[0].children.filter((child)=>(0, $be68dac03006aaff$export$d95d9322a7a4ea19)(child, this.COUNTRIES.children[0])).forEach((face)=>{
                if (!("color" in face.material)) {
                    console.warn("Mesh material did not have color");
                    return;
                }
                const color = face.material.color;
                color.set("#141a1f");
                if (!("emissive" in face.material)) // This is the case for basic materials
                return;
                const emissive = face.material.emissive;
                emissive.set("#141a1f");
            });
            this.tutorial.state.send("ZOOM_IN");
            // Show the bottom bar
            if (navList !== null) navList.classList.remove("hidden");
            else console.error("navList was null");
            this.dispatchFooterChangeEvent();
            // Hide the curves on the overlay to make the bottom bar blend in better
            bottomCurves.forEach((element)=>{
                element.style.display = "none";
            });
        }
        /// //////////////////////////////////////////
        // End handling going from zoomed out to zoomed in
        /// //////////////////////////////////////////
        /// //////////////////////////////////////////
        // Handle going from zoomed in to zoomed out
        /// //////////////////////////////////////////
        if (event.detail.oldZoomLevel === 1 && event.detail.newZoomLevel === 0) {
            if (this.USA.userData.state === "hidden") {
                this.USA.visible = true;
                this.USA.userData.state = "visible";
                // Stop all current tweens
                (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA).removeAll();
                this.USA.traverse((obj)=>{
                    if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
                    const tween1 = new (0, $7ArpZ.Tween)(obj.material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA)).to({
                        opacity: 0.5
                    }, 50).onComplete(()=>{
                        obj.receiveShadow = true;
                        if (obj.parent === this.USA) obj.castShadow = true;
                    });
                    const tween2 = new (0, $7ArpZ.Tween)(obj.material, (0, $be68dac03006aaff$export$b86006a140a6bac4)(this.USA)).to({
                        opacity: 1
                    }, 50);
                    tween1.chain(tween2);
                    tween1.start();
                });
                // Lower the states
                this.STATE_GROUP.traverse((obj)=>{
                    // Filter out all but top level (face) meshes
                    if (obj.parent !== this.STATE_GROUP) return;
                    this.ANIMATIONS.add(new (0, $dcb05fea3bbeea72$export$c35d437ae5945fcd)(obj, "scale", obj.userData.hiddenScale, 0.2, 0).setEasing((0, $07dced43e21b9570$export$57636bb43b1ccbb0)));
                });
            }
            // Change the colors of the countries
            this.COUNTRIES.children[0].children.filter((child)=>(0, $be68dac03006aaff$export$d95d9322a7a4ea19)(child, this.COUNTRIES.children[0])).forEach((face)=>{
                if (!("color" in face.material)) {
                    console.warn("Mesh material did not have color");
                    return;
                }
                const color = face.material.color;
                color.copy(face.userData.baseColor);
                if (!("emissive" in face.material)) // This is the case for basic materials
                return;
                const emissive = face.material.emissive;
                emissive.copy(face.userData.baseEmissive);
            });
            this.tutorial.state.send("ZOOM_OUT");
            // Hide the bottom bar
            if (navList !== null) navList.classList.add("hidden");
            else console.error("navList was null");
            this.dispatchFooterChangeEvent();
            // repositionBottomMenuCurves();
            // Bring back the curves on the overlay
            bottomCurves.forEach((element)=>{
                element.style.display = "initial";
            });
        }
    }
    getStateByAbbr(abbr) {
        const nChildren = this.STATE_GROUP.children.length;
        for(let i = 0; i < nChildren; i++){
            const state = this.STATE_GROUP.children[i];
            if (state.userData.abbr === abbr) return state;
        }
        return null;
    }
    getStateByFIPS(fips) {
        return this.getStateByName((0, $12d34f3c78180d6b$export$b4c789cd45f7243f)[fips].name);
    }
    onCameraChange() {
        const dist = this.controls.getDistance();
        this.controls.rotateSpeed = (dist - this.controls.surfaceDist) * 0.0035;
        // Set camera far clip (optimization attempt)
        this.camera.far = dist;
        this.camera.updateProjectionMatrix();
        // Short circuit if countries aren't loaded yet
        if (this.COUNTRIES.children.length === 0) return;
        let newZoomLevel;
        // Set the zoom level depending on how far away we are
        if (dist >= 140) newZoomLevel = 0;
        else newZoomLevel = 1;
        // Cancel the zoom level change if we're zooming all the way out and a state has been clicked
        if (this.state.aStateHasBeenClicked && newZoomLevel === 0) newZoomLevel = this.state.zoomLevel;
        // Dispatch a zoomlevelchanged event if the new zoom level is different from the old one
        if (this.state.zoomLevel !== newZoomLevel) {
            const oldZoomLevel = this.state.zoomLevel;
            this.state.zoomLevel = newZoomLevel;
            this.dispatchEvent(new CustomEvent("zoomlevelchange", {
                detail: {
                    oldZoomLevel: oldZoomLevel,
                    newZoomLevel: newZoomLevel
                }
            }));
        }
    }
    dispatchFooterChangeEvent() {
        (0, $468000f96106f3c9$export$4fefa8b88b0d4af1)();
    }
    _optimizationHideCountries() {
        const exceptions = [
            "Mexico",
            "Canada",
            "Cuba",
            "Jamaica",
            "Haiti",
            "Dominican_Republic",
            "Guatemala",
            "Honduras",
            "El_Salvador",
            "Nicaragua",
            "Costa_Rica",
            "Panama",
            "Russian_Federation",
            "Greenland",
            "Iceland",
            "Colombia",
            "Venezuela",
            "Ecuador",
            "Guyana",
            "Suriname",
            "French_Guiana",
            "Peru",
            "Brazil",
            "Bolivia",
            "Paraguay",
            "Chile",
            "Argentina",
            "Uruguay"
        ];
        this.loadCountriesPromise.then(()=>{
            this.COUNTRIES.children[0].children.forEach((country)=>{
                // console.log(country)
                // Short circuit if country in exceptions
                if (exceptions.includes(country.name)) return;
                // Hide the country
                country.visible = false;
            });
        });
    }
    _optimizationShowCountries() {
        this.COUNTRIES.children[0].children.forEach((country)=>{
            // Hide the country
            country.visible = true;
        });
    }
}
function $145f47ad8b66c035$var$makeVisible(region) {
    // Face shadows: Recieve, but don't cast
    region.face.receiveShadow = true;
    // Bottom border shadows
    region.bottomBorder.receiveShadow = true;
    region.bottomBorder.castShadow = true;
    // Top border shadows
    region.topBorder.castShadow = true;
    if (region.face.userData.type !== "county") region.topBorder.receiveShadow = true;
    region.face.visible = true;
    region.bottomBorder.visible = true;
    region.topBorder.visible = true;
}




// NOTE Usage:
//  remapMaterialUVs(child.material, {
//    'emissiveMap': 'texcoord_2', // <- fourth UV map
//    'roughnessMap': 'texcoord_3' // <- fifth UV map
//  });
// remapMaterialUVs is under MIT license - https://codepen.io/mjurczyk/pen/PoRrmvy?editors=0010
const $2492d6dd6dfc23ba$var$remapMaterialUVs = (material, remapUVs, { uvAttributePrefix: uvAttributePrefix, uvAttributeOffset: uvAttributeOffset } = {})=>{
    const _uvAttributePrefix = uvAttributePrefix || "texcoord_";
    const _uvAttributeOffset = 2;
    material.customProgramCacheKey = ()=>Math.random();
    material.onBeforeCompile = (shader, context)=>{
        const resolveIncludes = (shader)=>{
            // NOTE Straight from three/WebGLProgram.js
            const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
            return shader.replace(includePattern, (match, include)=>{
                const string = (0, $8725869b83961a04$export$955f9f2e84c43c8b)[include];
                if (!string) return;
                return resolveIncludes(string);
            });
        };
        let maxTexCoordIndex = 0;
        const texCoordSwaps = [];
        Object.entries(remapUVs).forEach(([textureType, uvMap])=>{
            if (!uvMap.startsWith(_uvAttributePrefix)) {
                console.warn("Invalid UVMap name", uvMap);
                return;
            }
            const texCoordIndex = parseFloat(uvMap.split(new RegExp(`${_uvAttributePrefix}\\D*`, "gi")).join(""));
            maxTexCoordIndex = Math.max(texCoordIndex, maxTexCoordIndex);
            texCoordSwaps[textureType] = texCoordIndex;
        });
        if (maxTexCoordIndex - 1 <= 0) return;
        shader.vertexShader = shader.vertexShader.replace(`#include <uv2_pars_vertex>`, `
        ${Array(maxTexCoordIndex - 1).fill(0).map((_, index)=>`
          attribute vec2 ${_uvAttributePrefix}${index + _uvAttributeOffset};
          varying vec2 vTexCoord${index + _uvAttributeOffset};
        `).join("\n")}
  
        #include <uv2_pars_vertex>
      `).replace(`#include <uv2_vertex>`, `
        ${Array(maxTexCoordIndex - 1).fill(0).map((_, index)=>`
          vTexCoord${index + _uvAttributeOffset} = ( vec3( ${_uvAttributePrefix}${index + _uvAttributeOffset}, 1 ) ).xy;
        `).join("\n")}
  
        #include <uv2_vertex>
      `);
        shader.fragmentShader = shader.fragmentShader.replace(`#include <uv2_pars_fragment>`, `
        ${Array(maxTexCoordIndex - 1).fill(0).map((_, index)=>`
          varying vec2 vTexCoord${index + _uvAttributeOffset};
        `).join("\n")}
  
        #include <uv2_pars_fragment>
      `);
        shader.vertexShader = resolveIncludes(shader.vertexShader);
        shader.fragmentShader = resolveIncludes(shader.fragmentShader);
        Object.entries(texCoordSwaps).forEach(([textureType, texCoordIndex])=>{
            shader.fragmentShader = shader.fragmentShader.replaceAll(`texture2D( ${textureType}, vUv )`, `texture2D( ${textureType}, vTexCoord${texCoordIndex} )`).replaceAll(`texture2D( ${textureType}, vUv2 )`, `texture2D( ${textureType}, vTexCoord${texCoordIndex} )`);
        });
    };
};
/**
 * 
 * @param {Mesh} mesh 
 * @param {Material} material 
 * @param {TextureInitializer} textureInitializer 
 * @returns 
 */ function $2492d6dd6dfc23ba$var$setMaterialTextureOnMeshRender(mesh, material, texture, textureInitializer, mapLevel) {
    if (mesh.userData.materialSwapInProgress) {
        console.warn("setMaterialOnRender called on mesh with material swap in progress", mesh);
        return;
    }
    mesh.userData.materialSwapInProgress = true;
    mesh.onBeforeRender = function() {
        textureInitializer.init(texture).then(()=>{
            material.map = texture;
            if (mesh.mapLevel != mapLevel) return;
            mesh.material = material;
            this.userData.materialSwapInProgress = false;
        });
        delete this.onBeforeRender;
    };
}
function $2492d6dd6dfc23ba$var$setMaterialOnRender(mesh, material, mapLevel) {
    if (mesh.userData.materialSwapInProgress) {
        console.warn("setMaterialOnRender called on mesh with material swap in progress", mesh);
        return;
    }
    mesh.userData.materialSwapInProgress = true;
    mesh.onBeforeRender = function() {
        if (mesh.mapLevel != mapLevel) return;
        this.material = material;
        delete this.onBeforeRender;
        this.userData.materialSwapInProgress = false;
    };
}
class $2492d6dd6dfc23ba$export$b500149b4779ac29 {
    /**
     * 
     * @param {WebGLRenderer} renderer 
     * @param {number} frameDelay - number of frames in between each initialization
     */ constructor(renderer, frameDelay){
        /**
         * @type WebGLRenderer
         */ this.renderer = renderer;
        this.queue = [];
        this.frameDelay = frameDelay;
        this.frameCounter = 0;
    }
    async init(texture) {
        let resolve, reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        this.queue.push({
            resolve: resolve,
            reject: reject,
            texture: texture
        });
        return promise;
    }
    process({ resolve: resolve, reject: reject, texture: texture }) {
        this.renderer.initTexture(texture);
        resolve();
    }
    update() {
        if (this.queue.length === 0) return;
        this.frameCounter += 1;
        if (this.frameCounter < this.frameDelay) return;
        this.frameCounter = 0;
        this.process(this.queue.pop());
    }
}
class $2492d6dd6dfc23ba$export$ee2c6187b80ae18a {
    /**
     * 
     * @param {Material} initialMaterial 
     * @param {Array} webTexData 
     * @param {TextureLoader} textureLoader
     * @param {TextureInitializer} textureInitializer
     */ constructor(initialMaterial, webTexData, textureLoader, textureInitializer){
        /**
         * @type Material
         */ this.initialMaterial = initialMaterial;
        /**
         * @type Array
         */ this.webTexData = webTexData;
        /**
         * @type Array< Material | undefined>
         */ this.materials = Array(webTexData.length);
        /**
         * @type Array<Promise>
         */ this.promises = Array(webTexData.length);
        /**
         * @type Number
         */ this.activeMaterial = 0;
        /**
         * @type TextureLoader
         */ this.loader = textureLoader;
        /**
         * @type TextureInitializer
         */ this.textureInitializer = textureInitializer;
        /**
         * @type boolean
         */ this.aborted = false;
    }
    /**
     * Apply the active material to a mesh
     * @param {Mesh} mesh 
     */ async applyTo(mesh) {
        mesh.mapLevel = this.activeMaterial;
        if (mesh.userData.materialSwapInProgress) mesh.userData.materialSwapInProgress = false;
        if (this.activeMaterial === 0) {
            $2492d6dd6dfc23ba$var$setMaterialOnRender(mesh, this.initialMaterial, mesh.mapLevel);
            return true;
        }
        if (this.materials[this.activeMaterial] !== undefined) {
            $2492d6dd6dfc23ba$var$setMaterialOnRender(mesh, this.materials[this.activeMaterial], mesh.mapLevel);
            return true;
        }
        const texture = await this.promises[this.activeMaterial];
        texture.flipY = false;
        texture.encoding = (0, $8725869b83961a04$export$f32388edbb32674);
        if (this.aborted) return false;
        const material = new (0, $8725869b83961a04$export$f2980790215acccd)({
            color: "#FFFFFF",
            emissive: "#000000"
        });
        $2492d6dd6dfc23ba$var$remapMaterialUVs(material, {
            map: `texcoord_${this.activeMaterial + 1}`
        });
        this.materials[this.activeMaterial] = material;
        if (mesh.mapLevel !== this.activeMaterial) return false;
        $2492d6dd6dfc23ba$var$setMaterialTextureOnMeshRender(mesh, material, texture, this.textureInitializer, mesh.mapLevel);
        return true;
    }
    /**
     * Change active material
     * 
     * Triggers a load of that material if it hasn't been loaded yet
     * @param {number} index 
     */ swap(index) {
        this.activeMaterial = index;
        // Short circuit if index is 0, indicating initialMaterial
        if (index === 0) return;
        // Short circuit if a load for this material has already been started
        if (this.promises[index] !== undefined) return;
        // Begin loading the texture
        this.promises[index] = new Promise((resolve, reject)=>{
            const url = this.webTexData[index - 1].url;
            this.loader.load(url, resolve, null, reject);
        });
    }
    /**
     * Stop all ongoing asynchronous operations, or cause them to have no effect when finished
     * 
     * After calling this, the object becomes useless and should be discarded
     */ abort() {
        this.aborted = true;
    }
}



/**
 * @typedef {import("./Globe").Globe} Globe
 * @typedef {import("maplibre-gl").Map} GLMap
 * @typedef {import("./CameraSynchronizer").default CameraSynchronizer}
 */ class $35c808bb5c29a6a4$export$2e2bcd8739ae039 extends EventTarget {
    /**
     * @param {Globe} globe
     * @param {GLMap} map
     * @param {string} fadeOutClass - class name that will cause a fade in animation when appended
     * @param {string} fadeInClass - class name that will cause a fade out animation when appended
     * @param {CameraSynchronizer} cameraSynchronizer
     */ constructor(globe, map, fadeOutClass, fadeInClass, cameraSynchronizer){
        super();
        /**
         * @type Globe
         */ this.globe = globe;
        /** @type GLMap */ this.map = map;
        /**
         * @type string
         */ this.fadeOutClass = fadeOutClass;
        /**
         * @type string
         */ this.fadeInClass = fadeInClass;
        /**
         * @type boolean
         */ this.mapVisible = true;
        /**
         * @type boolean
         */ this.globeVisible = true;
        /**
         * @type HTMLCanvasElement
         */ this.globeCanvas = globe.getCanvas();
        /**
         * @type HTMLCanvasElement
         */ this.mapCanvas = map.getCanvas();
        /**
         * @type CameraSynchronizer
         */ this.cameraSynchronizer = cameraSynchronizer;
        this.onGlobeAnimationEnd = (function(event) {
            // Short circuit on any animation that isn't fade out
            if (event.animationName !== this.fadeOutClass) return;
            this.globeVisible = false;
        }).bind(this);
        // Use the animationend event to tell when the globe has become fully invisible
        this.globeCanvas.addEventListener("animationend", this.onGlobeAnimationEnd);
    }
    swapToMap() {
        this.globe.fadeOutRing();
        this.globe.fadeOutTapHelpers();
        this.globeCanvas.classList.remove(this.fadeInClass);
        this.globeCanvas.classList.add(this.fadeOutClass);
        this.globeCanvas.style.pointerEvents = "none";
        this.cameraSynchronizer.master = "map";
    }
    swapToMapImmediately() {
        this.globeCanvas.classList.remove(this.fadeInClass);
        this.globeCanvas.classList.add(this.fadeOutClass);
        this.globeCanvas.style.visibility = "hidden";
        this.globeVisible = false;
        this.globeCanvas.style.pointerEvents = "none";
        this.cameraSynchronizer.master = "map";
    }
    swapToGlobe() {
        this.globe.fadeInRing();
        this.globe.fadeInTapHelpers();
        this.globeVisible = true;
        this.globeCanvas.classList.add(this.fadeInClass);
        this.globeCanvas.classList.remove(this.fadeOutClass);
        this.globeCanvas.style.removeProperty("visibility");
        this.globeCanvas.style.pointerEvents = "auto";
        this.cameraSynchronizer.master = "globe";
        // Unbound the map
        this.map.setMaxBounds();
    // this.cameraSynchronizer.syncGlobe()
    }
    /**
     * Remove event listeners and other associated data so that the object can be cleanly disposed of
     */ cleanup() {
        this.globeCanvas.removeEventListener("animationend", this.onGlobeAnimationEnd);
    }
}



var $7xV53 = parcelRequire("7xV53");
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $6ec05ae0eb260f21$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $6ec05ae0eb260f21$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $6ec05ae0eb260f21$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $6ec05ae0eb260f21$export$5a6391da70c130da(values, valueof) {
    const adder = new $6ec05ae0eb260f21$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


var $57fa69a7e776893c$export$6c421550c66a327d = 1e-6;
var $57fa69a7e776893c$export$92c06fba281fe81b = 1e-12;
var $57fa69a7e776893c$export$18c7bea995a110f = Math.PI;
var $57fa69a7e776893c$export$e51408a300e8929a = $57fa69a7e776893c$export$18c7bea995a110f / 2;
var $57fa69a7e776893c$export$c39a5cba78ea0fc2 = $57fa69a7e776893c$export$18c7bea995a110f / 4;
var $57fa69a7e776893c$export$a4b4b4d4d776fe92 = $57fa69a7e776893c$export$18c7bea995a110f * 2;
var $57fa69a7e776893c$export$41fc368e1a942b97 = 180 / $57fa69a7e776893c$export$18c7bea995a110f;
var $57fa69a7e776893c$export$8449e153fbd325fc = $57fa69a7e776893c$export$18c7bea995a110f / 180;
var $57fa69a7e776893c$export$2335f513bbd82c6d = Math.abs;
var $57fa69a7e776893c$export$628dc4eed22b0fbd = Math.atan;
var $57fa69a7e776893c$export$b8b770ee6a0d9760 = Math.atan2;
var $57fa69a7e776893c$export$50d414a77b60d802 = Math.cos;
var $57fa69a7e776893c$export$803ce6b71a0a94b2 = Math.ceil;
var $57fa69a7e776893c$export$b310ec824aaee37f = Math.exp;
var $57fa69a7e776893c$export$a3fe094919f356fd = Math.floor;
var $57fa69a7e776893c$export$f95c7888b62f8e9a = Math.hypot;
var $57fa69a7e776893c$export$bef1f36f5486a6a3 = Math.log;
var $57fa69a7e776893c$export$9c297f60e22e3389 = Math.pow;
var $57fa69a7e776893c$export$5de3937cb4b592ed = Math.sin;
var $57fa69a7e776893c$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $57fa69a7e776893c$export$eba8049fb5020b81 = Math.sqrt;
var $57fa69a7e776893c$export$fcdd3b0b3246a325 = Math.tan;
function $57fa69a7e776893c$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $57fa69a7e776893c$export$18c7bea995a110f : Math.acos(x);
}
function $57fa69a7e776893c$export$41726bdb1fc63f(x) {
    return x > 1 ? $57fa69a7e776893c$export$e51408a300e8929a : x < -1 ? -$57fa69a7e776893c$export$e51408a300e8929a : Math.asin(x);
}
function $57fa69a7e776893c$export$e808712c2966e662(x) {
    return (x = $57fa69a7e776893c$export$5de3937cb4b592ed(x / 2)) * x;
}


function $b28aa413bde10d03$export$2e2bcd8739ae039() {}


function $a9c4f90c46b9891b$var$streamGeometry(geometry, stream) {
    if (geometry && $a9c4f90c46b9891b$var$streamGeometryType.hasOwnProperty(geometry.type)) $a9c4f90c46b9891b$var$streamGeometryType[geometry.type](geometry, stream);
}
var $a9c4f90c46b9891b$var$streamObjectType = {
    Feature: function(object, stream) {
        $a9c4f90c46b9891b$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamGeometry(features[i].geometry, stream);
    }
};
var $a9c4f90c46b9891b$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $a9c4f90c46b9891b$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $a9c4f90c46b9891b$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$a9c4f90c46b9891b$var$streamGeometry(geometries[i], stream);
    }
};
function $a9c4f90c46b9891b$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $a9c4f90c46b9891b$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$a9c4f90c46b9891b$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $a9c4f90c46b9891b$export$2e2bcd8739ae039(object, stream) {
    if (object && $a9c4f90c46b9891b$var$streamObjectType.hasOwnProperty(object.type)) $a9c4f90c46b9891b$var$streamObjectType[object.type](object, stream);
    else $a9c4f90c46b9891b$var$streamGeometry(object, stream);
}


var $90031fd84727d8f8$export$bf8f994332070c7f = new (0, $6ec05ae0eb260f21$export$bda7ba77fb86c375)();
// hello?
var $90031fd84727d8f8$var$areaSum = new (0, $6ec05ae0eb260f21$export$bda7ba77fb86c375)(), $90031fd84727d8f8$var$lambda00, $90031fd84727d8f8$var$phi00, $90031fd84727d8f8$var$lambda0, $90031fd84727d8f8$var$cosPhi0, $90031fd84727d8f8$var$sinPhi0;
var $90031fd84727d8f8$export$cb67cfa750ae69dc = {
    point: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineStart: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    lineEnd: (0, $b28aa413bde10d03$export$2e2bcd8739ae039),
    polygonStart: function() {
        $90031fd84727d8f8$export$bf8f994332070c7f = new (0, $6ec05ae0eb260f21$export$bda7ba77fb86c375)();
        $90031fd84727d8f8$export$cb67cfa750ae69dc.lineStart = $90031fd84727d8f8$var$areaRingStart;
        $90031fd84727d8f8$export$cb67cfa750ae69dc.lineEnd = $90031fd84727d8f8$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$90031fd84727d8f8$export$bf8f994332070c7f;
        $90031fd84727d8f8$var$areaSum.add(areaRing < 0 ? (0, $57fa69a7e776893c$export$a4b4b4d4d776fe92) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $b28aa413bde10d03$export$2e2bcd8739ae039);
    },
    sphere: function() {
        $90031fd84727d8f8$var$areaSum.add((0, $57fa69a7e776893c$export$a4b4b4d4d776fe92));
    }
};
function $90031fd84727d8f8$var$areaRingStart() {
    $90031fd84727d8f8$export$cb67cfa750ae69dc.point = $90031fd84727d8f8$var$areaPointFirst;
}
function $90031fd84727d8f8$var$areaRingEnd() {
    $90031fd84727d8f8$var$areaPoint($90031fd84727d8f8$var$lambda00, $90031fd84727d8f8$var$phi00);
}
function $90031fd84727d8f8$var$areaPointFirst(lambda, phi) {
    $90031fd84727d8f8$export$cb67cfa750ae69dc.point = $90031fd84727d8f8$var$areaPoint;
    $90031fd84727d8f8$var$lambda00 = lambda, $90031fd84727d8f8$var$phi00 = phi;
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    $90031fd84727d8f8$var$lambda0 = lambda, $90031fd84727d8f8$var$cosPhi0 = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi = phi / 2 + (0, $57fa69a7e776893c$export$c39a5cba78ea0fc2)), $90031fd84727d8f8$var$sinPhi0 = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi);
}
function $90031fd84727d8f8$var$areaPoint(lambda, phi) {
    lambda *= (0, $57fa69a7e776893c$export$8449e153fbd325fc), phi *= (0, $57fa69a7e776893c$export$8449e153fbd325fc);
    phi = phi / 2 + (0, $57fa69a7e776893c$export$c39a5cba78ea0fc2); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $90031fd84727d8f8$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi), sinPhi = (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi), k = $90031fd84727d8f8$var$sinPhi0 * sinPhi, u = $90031fd84727d8f8$var$cosPhi0 * cosPhi + k * (0, $57fa69a7e776893c$export$50d414a77b60d802)(adLambda), v = k * sdLambda * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(adLambda);
    $90031fd84727d8f8$export$bf8f994332070c7f.add((0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(v, u));
    // Advance the previous points.
    $90031fd84727d8f8$var$lambda0 = lambda, $90031fd84727d8f8$var$cosPhi0 = cosPhi, $90031fd84727d8f8$var$sinPhi0 = sinPhi;
}
function $90031fd84727d8f8$export$2e2bcd8739ae039(object) {
    $90031fd84727d8f8$var$areaSum = new (0, $6ec05ae0eb260f21$export$bda7ba77fb86c375)();
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(object, $90031fd84727d8f8$export$cb67cfa750ae69dc);
    return $90031fd84727d8f8$var$areaSum * 2;
}




function $8f5c680d84651994$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $57fa69a7e776893c$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $57fa69a7e776893c$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $8f5c680d84651994$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $57fa69a7e776893c$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $57fa69a7e776893c$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(lambda),
        (0, $57fa69a7e776893c$export$5de3937cb4b592ed)(phi)
    ];
}
function $8f5c680d84651994$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $8f5c680d84651994$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $8f5c680d84651994$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $8f5c680d84651994$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $8f5c680d84651994$export$6789498aec2cb34b(d) {
    var l = (0, $57fa69a7e776893c$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}




var $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$phi0, $47339db63dfc5d6d$var$lambda1, $47339db63dfc5d6d$var$phi1, $47339db63dfc5d6d$var$lambda2, $47339db63dfc5d6d$var$lambda00, $47339db63dfc5d6d$var$phi00, $47339db63dfc5d6d$var$p0, $47339db63dfc5d6d$var$deltaSum, $47339db63dfc5d6d$var$ranges, $47339db63dfc5d6d$var$range;
var $47339db63dfc5d6d$var$boundsStream = {
    point: $47339db63dfc5d6d$var$boundsPoint,
    lineStart: $47339db63dfc5d6d$var$boundsLineStart,
    lineEnd: $47339db63dfc5d6d$var$boundsLineEnd,
    polygonStart: function() {
        $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$boundsRingPoint;
        $47339db63dfc5d6d$var$boundsStream.lineStart = $47339db63dfc5d6d$var$boundsRingStart;
        $47339db63dfc5d6d$var$boundsStream.lineEnd = $47339db63dfc5d6d$var$boundsRingEnd;
        $47339db63dfc5d6d$var$deltaSum = new (0, $6ec05ae0eb260f21$export$bda7ba77fb86c375)();
        (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).polygonStart();
    },
    polygonEnd: function() {
        (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).polygonEnd();
        $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$boundsPoint;
        $47339db63dfc5d6d$var$boundsStream.lineStart = $47339db63dfc5d6d$var$boundsLineStart;
        $47339db63dfc5d6d$var$boundsStream.lineEnd = $47339db63dfc5d6d$var$boundsLineEnd;
        if ((0, $90031fd84727d8f8$export$bf8f994332070c7f) < 0) $47339db63dfc5d6d$var$lambda0 = -($47339db63dfc5d6d$var$lambda1 = 180), $47339db63dfc5d6d$var$phi0 = -($47339db63dfc5d6d$var$phi1 = 90);
        else if ($47339db63dfc5d6d$var$deltaSum > (0, $57fa69a7e776893c$export$6c421550c66a327d)) $47339db63dfc5d6d$var$phi1 = 90;
        else if ($47339db63dfc5d6d$var$deltaSum < -(0, $57fa69a7e776893c$export$6c421550c66a327d)) $47339db63dfc5d6d$var$phi0 = -90;
        $47339db63dfc5d6d$var$range[0] = $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$range[1] = $47339db63dfc5d6d$var$lambda1;
    },
    sphere: function() {
        $47339db63dfc5d6d$var$lambda0 = -($47339db63dfc5d6d$var$lambda1 = 180), $47339db63dfc5d6d$var$phi0 = -($47339db63dfc5d6d$var$phi1 = 90);
    }
};
function $47339db63dfc5d6d$var$boundsPoint(lambda, phi) {
    $47339db63dfc5d6d$var$ranges.push($47339db63dfc5d6d$var$range = [
        $47339db63dfc5d6d$var$lambda0 = lambda,
        $47339db63dfc5d6d$var$lambda1 = lambda
    ]);
    if (phi < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phi;
    if (phi > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phi;
}
function $47339db63dfc5d6d$var$linePoint(lambda, phi) {
    var p = (0, $8f5c680d84651994$export$6e6697ef026a96)([
        lambda * (0, $57fa69a7e776893c$export$8449e153fbd325fc),
        phi * (0, $57fa69a7e776893c$export$8449e153fbd325fc)
    ]);
    if ($47339db63dfc5d6d$var$p0) {
        var normal = (0, $8f5c680d84651994$export$4763f5351b14293f)($47339db63dfc5d6d$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $8f5c680d84651994$export$4763f5351b14293f)(equatorial, normal);
        (0, $8f5c680d84651994$export$6789498aec2cb34b)(inflection);
        inflection = (0, $8f5c680d84651994$export$12f9ad44fe773943)(inflection);
        var delta = lambda - $47339db63dfc5d6d$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $57fa69a7e776893c$export$41fc368e1a942b97) * sign, phii, antimeridian = (0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta) > 180;
        if (antimeridian ^ (sign * $47339db63dfc5d6d$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $57fa69a7e776893c$export$41fc368e1a942b97);
            if (phii > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $47339db63dfc5d6d$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $57fa69a7e776893c$export$41fc368e1a942b97);
            if (phii < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phii;
        } else {
            if (phi < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phi;
            if (phi > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $47339db63dfc5d6d$var$lambda2) {
                if ($47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, lambda) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda1 = lambda;
            } else if ($47339db63dfc5d6d$var$angle(lambda, $47339db63dfc5d6d$var$lambda1) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda0 = lambda;
        } else if ($47339db63dfc5d6d$var$lambda1 >= $47339db63dfc5d6d$var$lambda0) {
            if (lambda < $47339db63dfc5d6d$var$lambda0) $47339db63dfc5d6d$var$lambda0 = lambda;
            if (lambda > $47339db63dfc5d6d$var$lambda1) $47339db63dfc5d6d$var$lambda1 = lambda;
        } else {
            if (lambda > $47339db63dfc5d6d$var$lambda2) {
                if ($47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, lambda) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda1 = lambda;
            } else if ($47339db63dfc5d6d$var$angle(lambda, $47339db63dfc5d6d$var$lambda1) > $47339db63dfc5d6d$var$angle($47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$lambda1)) $47339db63dfc5d6d$var$lambda0 = lambda;
        }
    } else $47339db63dfc5d6d$var$ranges.push($47339db63dfc5d6d$var$range = [
        $47339db63dfc5d6d$var$lambda0 = lambda,
        $47339db63dfc5d6d$var$lambda1 = lambda
    ]);
    if (phi < $47339db63dfc5d6d$var$phi0) $47339db63dfc5d6d$var$phi0 = phi;
    if (phi > $47339db63dfc5d6d$var$phi1) $47339db63dfc5d6d$var$phi1 = phi;
    $47339db63dfc5d6d$var$p0 = p, $47339db63dfc5d6d$var$lambda2 = lambda;
}
function $47339db63dfc5d6d$var$boundsLineStart() {
    $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$linePoint;
}
function $47339db63dfc5d6d$var$boundsLineEnd() {
    $47339db63dfc5d6d$var$range[0] = $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$range[1] = $47339db63dfc5d6d$var$lambda1;
    $47339db63dfc5d6d$var$boundsStream.point = $47339db63dfc5d6d$var$boundsPoint;
    $47339db63dfc5d6d$var$p0 = null;
}
function $47339db63dfc5d6d$var$boundsRingPoint(lambda, phi) {
    if ($47339db63dfc5d6d$var$p0) {
        var delta = lambda - $47339db63dfc5d6d$var$lambda2;
        $47339db63dfc5d6d$var$deltaSum.add((0, $57fa69a7e776893c$export$2335f513bbd82c6d)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $47339db63dfc5d6d$var$lambda00 = lambda, $47339db63dfc5d6d$var$phi00 = phi;
    (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).point(lambda, phi);
    $47339db63dfc5d6d$var$linePoint(lambda, phi);
}
function $47339db63dfc5d6d$var$boundsRingStart() {
    (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).lineStart();
}
function $47339db63dfc5d6d$var$boundsRingEnd() {
    $47339db63dfc5d6d$var$boundsRingPoint($47339db63dfc5d6d$var$lambda00, $47339db63dfc5d6d$var$phi00);
    (0, $90031fd84727d8f8$export$cb67cfa750ae69dc).lineEnd();
    if ((0, $57fa69a7e776893c$export$2335f513bbd82c6d)($47339db63dfc5d6d$var$deltaSum) > (0, $57fa69a7e776893c$export$6c421550c66a327d)) $47339db63dfc5d6d$var$lambda0 = -($47339db63dfc5d6d$var$lambda1 = 180);
    $47339db63dfc5d6d$var$range[0] = $47339db63dfc5d6d$var$lambda0, $47339db63dfc5d6d$var$range[1] = $47339db63dfc5d6d$var$lambda1;
    $47339db63dfc5d6d$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $47339db63dfc5d6d$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $47339db63dfc5d6d$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $47339db63dfc5d6d$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $47339db63dfc5d6d$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $47339db63dfc5d6d$var$phi1 = $47339db63dfc5d6d$var$lambda1 = -($47339db63dfc5d6d$var$lambda0 = $47339db63dfc5d6d$var$phi0 = Infinity);
    $47339db63dfc5d6d$var$ranges = [];
    (0, $a9c4f90c46b9891b$export$2e2bcd8739ae039)(feature, $47339db63dfc5d6d$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $47339db63dfc5d6d$var$ranges.length) {
        $47339db63dfc5d6d$var$ranges.sort($47339db63dfc5d6d$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $47339db63dfc5d6d$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $47339db63dfc5d6d$var$ranges[i];
            if ($47339db63dfc5d6d$var$rangeContains(a, b[0]) || $47339db63dfc5d6d$var$rangeContains(a, b[1])) {
                if ($47339db63dfc5d6d$var$angle(a[0], b[1]) > $47339db63dfc5d6d$var$angle(a[0], a[1])) a[1] = b[1];
                if ($47339db63dfc5d6d$var$angle(b[0], a[1]) > $47339db63dfc5d6d$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $47339db63dfc5d6d$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $47339db63dfc5d6d$var$lambda0 = b[0], $47339db63dfc5d6d$var$lambda1 = a[1];
        }
    }
    $47339db63dfc5d6d$var$ranges = $47339db63dfc5d6d$var$range = null;
    return $47339db63dfc5d6d$var$lambda0 === Infinity || $47339db63dfc5d6d$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $47339db63dfc5d6d$var$lambda0,
            $47339db63dfc5d6d$var$phi0
        ],
        [
            $47339db63dfc5d6d$var$lambda1,
            $47339db63dfc5d6d$var$phi1
        ]
    ];
}




var $iUSsr = parcelRequire("iUSsr");
var $ce3b64eb948e58bc$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ 
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else $ce3b64eb948e58bc$exports = factory((parcelRequire("iUSsr")));
})(function($) {
    "use strict";
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: "slick-dots",
                draggable: true,
                easing: "linear",
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: false,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = "hidden";
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = "visibilitychange";
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data("slick") || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== "undefined") {
                _.hidden = "mozHidden";
                _.visibilityChange = "mozvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                _.hidden = "webkitHidden";
                _.visibilityChange = "webkitvisibilitychange";
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            "tabindex": "0"
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === "boolean") {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === "number") {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr("data-slick-index", index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = "translate(" + now + "px, 0px)";
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = "translate(0px," + now + "px)";
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = "translate3d(" + targetLeft + "px, 0px, 0px)";
            else animProps[_.animType] = "translate3d(0px," + targetLeft + "px, 0px)";
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && typeof asNavFor === "object") asNavFor.each(function() {
            var target = $(this).slick("getSlick");
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + " " + _.options.speed + "ms " + _.options.cssEase;
        else transition[_.transitionType] = "opacity " + _.options.speed + "ms " + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass("slick-arrow");
            _.$nextArrow = $(_.options.nextArrow).addClass("slick-arrow");
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");
                _.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true");
            } else _.$prevArrow.add(_.$nextArrow).addClass("slick-hidden").attr({
                "aria-disabled": "true",
                "tabindex": "-1"
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass("slick-dotted");
            dot = $("<ul />").addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($("<li />").append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find("li").first().addClass("slick-active");
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ":not(.slick-cloned)").addClass("slick-slide");
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr("data-slick-index", index).data("originalStyling", $(element).attr("style") || "");
        });
        _.$slider.addClass("slick-slider");
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css("opacity", 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $("img[data-lazy]", _.$slider).not("[src]").addClass("slick-loading");
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === "number" ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass("draggable");
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement("div");
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement("div");
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                "width": 100 / _.options.slidesPerRow + "%",
                "display": "inline-block"
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === "window") respondToWidth = windowWidth;
        else if (_.respondTo === "slider") respondToWidth = sliderWidth;
        else if (_.respondTo === "min") respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === "unslick") _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === "unslick") _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger("breakpoint", [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is("a")) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is("li")) $target = $target.closest("li");
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case "previous":
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case "next":
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case "index":
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger("focus");
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $("li", _.$dots).off("click.slick", _.changeSlide).off("mouseenter.slick", $.proxy(_.interrupt, _, true)).off("mouseleave.slick", $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off("keydown.slick", _.keyHandler);
        }
        _.$slider.off("focus.slick blur.slick");
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off("click.slick", _.changeSlide);
            _.$nextArrow && _.$nextArrow.off("click.slick", _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off("keydown.slick", _.keyHandler);
                _.$nextArrow && _.$nextArrow.off("keydown.slick", _.keyHandler);
            }
        }
        _.$list.off("touchstart.slick mousedown.slick", _.swipeHandler);
        _.$list.off("touchmove.slick mousemove.slick", _.swipeHandler);
        _.$list.off("touchend.slick mouseup.slick", _.swipeHandler);
        _.$list.off("touchcancel.slick mouseleave.slick", _.swipeHandler);
        _.$list.off("click.slick", _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off("keydown.slick", _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off("click.slick", _.selectHandler);
        $(window).off("orientationchange.slick.slick-" + _.instanceUid, _.orientationChange);
        $(window).off("resize.slick.slick-" + _.instanceUid, _.resize);
        $("[draggable!=true]", _.$slideTrack).off("dragstart", _.preventDefault);
        $(window).off("load.slick.slick-" + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off("mouseenter.slick", $.proxy(_.interrupt, _, true));
        _.$list.off("mouseleave.slick", $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr("style");
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $(".slick-cloned", _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", "");
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", "");
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                $(this).attr("style", $(this).data("originalStyling"));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass("slick-slider");
        _.$slider.removeClass("slick-initialized");
        _.$slider.removeClass("slick-dotted");
        _.unslicked = true;
        if (!refresh) _.$slider.trigger("destroy", [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = "";
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(":focus");
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
            else targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
                else targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find(".slick-slide").each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr("data-slick-index") - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: "index",
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass("slick-initialized")) {
            $(_.$slider).addClass("slick-initialized");
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger("init", [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            "tabindex": "-1"
        }).find("a, input, button, select").attr({
            "tabindex": "-1"
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find(".slick-cloned")).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    "role": "tabpanel",
                    "id": "slick-slide" + _.instanceUid + i,
                    "tabindex": -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = "slick-slide-control" + _.instanceUid + slideControlIndex;
                    if ($("#" + ariaButtonControl).length) $(this).attr({
                        "aria-describedby": ariaButtonControl
                    });
                }
            });
            _.$dots.attr("role", "tablist").find("li").each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    "role": "presentation"
                });
                $(this).find("button").first().attr({
                    "role": "tab",
                    "id": "slick-slide-control" + _.instanceUid + i,
                    "aria-controls": "slick-slide" + _.instanceUid + mappedSlideIndex,
                    "aria-label": i + 1 + " of " + numDotGroups,
                    "aria-selected": null,
                    "tabindex": "-1"
                });
            }).eq(_.currentSlide).find("button").attr({
                "aria-selected": "true",
                "tabindex": "0"
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            "tabindex": "0"
        });
        else _.$slides.eq(i).removeAttr("tabindex");
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off("click.slick").on("click.slick", {
                message: "previous"
            }, _.changeSlide);
            _.$nextArrow.off("click.slick").on("click.slick", {
                message: "next"
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on("keydown.slick", _.keyHandler);
                _.$nextArrow.on("keydown.slick", _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $("li", _.$dots).on("click.slick", {
                message: "index"
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on("keydown.slick", _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $("li", _.$dots).on("mouseenter.slick", $.proxy(_.interrupt, _, true)).on("mouseleave.slick", $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on("mouseenter.slick", $.proxy(_.interrupt, _, true));
            _.$list.on("mouseleave.slick", $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, _.swipeHandler);
        _.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, _.swipeHandler);
        _.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, _.swipeHandler);
        _.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, _.swipeHandler);
        _.$list.on("click.slick", _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on("keydown.slick", _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on("click.slick", _.selectHandler);
        $(window).on("orientationchange.slick.slick-" + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on("resize.slick.slick-" + _.instanceUid, $.proxy(_.resize, _));
        $("[draggable!=true]", _.$slideTrack).on("dragstart", _.preventDefault);
        $(window).on("load.slick.slick-" + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match("TEXTAREA|INPUT|SELECT")) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? "next" : "previous"
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? "previous" : "next"
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $("img[data-lazy]", imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr("data-lazy"), imageSrcSet = $(this).attr("data-srcset"), imageSizes = $(this).attr("data-sizes") || _.$slider.attr("data-sizes"), imageToLoad = document.createElement("img");
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr("srcset", imageSrcSet);
                            if (imageSizes) image.attr("sizes", imageSizes);
                        }
                        image.attr("src", imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                        });
                        _.$slider.trigger("lazyLoaded", [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");
                    _.$slider.trigger("lazyLoadError", [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find(".slick-slide").slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === "anticipated") {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find(".slick-slide");
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find(".slick-slide");
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find(".slick-cloned").slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find(".slick-cloned").slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass("slick-loading");
        _.initUI();
        if (_.options.lazyLoad === "progressive") _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: "next"
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger("afterChange", [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr("tabindex", 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: "previous"
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $("img[data-lazy]", _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr("data-lazy");
            imageSrcSet = image.attr("data-srcset");
            imageSizes = image.attr("data-sizes") || _.$slider.attr("data-sizes");
            imageToLoad = document.createElement("img");
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr("srcset", imageSrcSet);
                    if (imageSizes) image.attr("sizes", imageSizes);
                }
                image.attr("src", imageSource).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger("lazyLoaded", [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");
                    _.$slider.trigger("lazyLoadError", [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger("allImagesLoaded", [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: "index",
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === "array" && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || "window";
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass("slick-slide");
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on("click.slick", _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === "number" ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger("reInit", [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === "boolean") {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == "left" ? Math.ceil(position) + "px" : "0px";
        y = _.positionProp == "top" ? Math.ceil(position) + "px" : "0px";
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = "translate(" + x + ", " + y + ")";
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = "translate3d(" + x + ", " + y + ", 0px)";
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: "0px " + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + " 0px"
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children(".slick-slide").length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children(".slick-slide").length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children(".slick-slide").width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: "relative",
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: "relative",
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css("height", targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === "object") {
            option = arguments[0];
            refresh = arguments[1];
            type = "multiple";
        } else if ($.type(arguments[0]) === "string") {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === "responsive" && $.type(arguments[1]) === "array") type = "responsive";
            else if (typeof arguments[1] !== "undefined") type = "single";
        }
        if (type === "single") _.options[option] = value;
        else if (type === "multiple") $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === "responsive") {
            for(item in value)if ($.type(_.options.responsive) !== "array") _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger("setPosition", [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? "top" : "left";
        if (_.positionProp === "top") _.$slider.addClass("slick-vertical");
        else _.$slider.removeClass("slick-vertical");
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === "number") {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = "OTransform";
            _.transformType = "-o-transform";
            _.transitionType = "OTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = "MozTransform";
            _.transformType = "-moz-transform";
            _.transitionType = "MozTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = "webkitTransform";
            _.transformType = "-webkit-transform";
            _.transitionType = "webkitTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = "msTransform";
            _.transformType = "-ms-transform";
            _.transitionType = "msTransition";
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = "transform";
            _.transformType = "transform";
            _.transitionType = "transition";
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
        _.$slides.eq(index).addClass("slick-current");
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass("slick-active").attr("aria-hidden", "false");
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass("slick-active").attr("aria-hidden", "false");
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass("slick-center");
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass("slick-center");
            }
            _.$slides.eq(index).addClass("slick-center");
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false");
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass("slick-active").attr("aria-hidden", "false");
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass("slick-active").attr("aria-hidden", "false");
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false");
            }
        }
        if (_.options.lazyLoad === "ondemand" || _.options.lazyLoad === "anticipated") _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr("id", "").attr("data-slick-index", slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass("slick-cloned");
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr("id", "").attr("data-slick-index", slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass("slick-cloned");
                }
                _.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                    $(this).attr("id", "");
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is(".slick-slide") ? $(event.target) : $(event.target).parents(".slick-slide");
        var index = parseInt(targetElement.attr("data-slick-index"));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger("beforeChange", [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick("getSlick");
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass("slick-loading");
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? "left" : "right";
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? "left" : "right";
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? "right" : "left";
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return "down";
            else return "up";
        }
        return "vertical";
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger("edge", [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case "left":
                case "down":
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != "vertical") {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger("swipe", [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || "ontouchend" in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf("mouse") !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case "start":
                _.swipeStart(event);
                break;
            case "move":
                _.swipeMove(event);
                break;
            case "end":
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === "right" || _.currentSlide >= _.getDotCount() && swipeDirection === "left") {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $(".slick-cloned", _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger("unslick", [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            _.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                _.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
                _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find("li").removeClass("slick-active").end();
            _.$dots.find("li").eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass("slick-active");
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if (typeof opt == "object" || typeof opt == "undefined") _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != "undefined") return ret;
        }
        return _;
    };
});




function $5cdfe2a3ab2113ff$export$3430efaea0213ce6(polygon) {
    polygon.coordinates.forEach((ring)=>{
        ring.forEach((coord)=>{
            if (coord[0] > 0) coord[0] -= 360;
        });
    });
}
function $5cdfe2a3ab2113ff$export$c9170f63127e2182(polygon, border) {
    $5cdfe2a3ab2113ff$export$3430efaea0213ce6(polygon);
    let [[w, s], [e, n]] = (0, $47339db63dfc5d6d$export$2e2bcd8739ae039)(polygon);
    if (e > 0) e -= 360;
    if (w > 0) w -= 360;
    console.log(n, e, s, w, border);
    // Offset bounds by threshold
    n += border;
    e += border;
    s -= border;
    w -= border;
    console.log(n, e, s, w, border);
    const boxCoordinates = [
        [
            w,
            n
        ],
        [
            e,
            n
        ],
        [
            e,
            s
        ],
        [
            w,
            s
        ],
        [
            w,
            n
        ]
    ];
    const polyWithHole = {
        type: "Polygon",
        coordinates: [
            boxCoordinates,
            ...polygon.coordinates
        ]
    };
    console.log(polyWithHole);
    return polyWithHole;
}



let $95298b233eb5daae$var$districts;
/**
 * @type {maplibregl.Popup}
 */ const $95298b233eb5daae$var$params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop)=>searchParams.get(prop)
});
let $95298b233eb5daae$var$init_district_id = $95298b233eb5daae$var$params.district_id ?? null;
let $95298b233eb5daae$var$election_filter = $95298b233eb5daae$var$params.election_filter ?? null;
let $95298b233eb5daae$var$election_type = isNaN($95298b233eb5daae$var$params.election_type) ? 0 : $95298b233eb5daae$var$params.electionType ?? 0;
let $95298b233eb5daae$var$popup;
let $95298b233eb5daae$var$tutorial;
let $95298b233eb5daae$var$selected_vtd;
let $95298b233eb5daae$var$selected_lat, $95298b233eb5daae$var$selected_lng;
let $95298b233eb5daae$var$current_district_id;
let $95298b233eb5daae$var$mobile_current_district_id;
let $95298b233eb5daae$var$selected_voting_precinct;
let $95298b233eb5daae$var$selected_vtd_unit;
let $95298b233eb5daae$var$mapControl = null;
const $95298b233eb5daae$var$osmServerApiHost = "/api";
const $95298b233eb5daae$var$apiHost = "/api";
const $95298b233eb5daae$var$today = new Date();
const $95298b233eb5daae$var$start_date_obj = $95298b233eb5daae$var$today;
const $95298b233eb5daae$var$end_date_obj = new Date($95298b233eb5daae$var$today.getTime() + 31536000000);
let $95298b233eb5daae$var$start_date = $95298b233eb5daae$var$start_date_obj.getFullYear() + "-" + (parseInt($95298b233eb5daae$var$start_date_obj.getMonth()) + 1) + "-" + $95298b233eb5daae$var$start_date_obj.getDate();
let $95298b233eb5daae$var$end_date = $95298b233eb5daae$var$end_date_obj.getFullYear() + "-" + (parseInt($95298b233eb5daae$var$end_date_obj.getMonth()) + 1) + "-" + $95298b233eb5daae$var$end_date_obj.getDate();
let $95298b233eb5daae$var$selected_geo_ids;
let $95298b233eb5daae$var$elections = [];
let $95298b233eb5daae$var$precinctlist = [];
let $95298b233eb5daae$var$position = 0;
let $95298b233eb5daae$var$touched = false;
let $95298b233eb5daae$var$election_data_loaded = false;
let $95298b233eb5daae$var$initDistrict = false;
let $95298b233eb5daae$var$pageInitialLoading = true;
// Initialize slick carousels
// TODO: Hook into window resize to slick these
if (window.innerWidth < 991) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 5,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        swipeToSlide: true,
        draggable: true,
        mobileFirst: true,
        touchMove: true
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 5,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        swipeToSlide: true,
        draggable: true,
        mobileFirst: true,
        touchMove: true
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-overview-div").show();
// Initialize election filter
function $95298b233eb5daae$var$resetElectionFilter() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#year_filter_value").html("Upcoming (Next 12 months)");
    $95298b233eb5daae$var$resetStartDate("upcoming");
}
function $95298b233eb5daae$var$initElectionFilter() {
    if ($95298b233eb5daae$var$election_filter && $95298b233eb5daae$var$election_filter !== "null") {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#election_filter_dropdown").hide();
        if ($95298b233eb5daae$var$election_filter == "upcoming") (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#year_filter_value").html("Upcoming (Next 12 months)");
        else if ($95298b233eb5daae$var$election_filter == "past") (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#year_filter_value").html("Past (Previous 12 months)");
        else if ($95298b233eb5daae$var$election_filter !== "null") (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#year_filter_value").text($95298b233eb5daae$var$election_filter);
        $95298b233eb5daae$var$resetStartDate($95298b233eb5daae$var$election_filter);
    } else $95298b233eb5daae$var$resetElectionFilter();
}
$95298b233eb5daae$var$resetElectionFilter();
$95298b233eb5daae$var$initElectionFilter();
if ($95298b233eb5daae$var$election_type) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.type_value[data-value="${$95298b233eb5daae$var$election_type}"]`).addClass("r3-bg-primary-bg r3-text-white");
else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.type_value[data-value="0"]`).addClass("r3-bg-primary-bg r3-text-white");
class $95298b233eb5daae$var$AbortManager {
    /**
     * @type {AbortController[]}
     */ #abortables;
    constructor(){
        this.#abortables = [];
    }
    register() {
        const abortable = new AbortController();
        this.#abortables.push(abortable);
        return abortable;
    }
    /**
     *
     * @param {AbortController} abortable
     * @returns
     */ check(abortable) {
        return abortable.signal.aborted;
    }
    /**
     *
     * @param {AbortController} abortable
     * @returns
     */ finalCheck(abortable) {
        const index = this.#abortables.findIndex((item)=>item === abortable);
        this.#abortables.splice(index, 1);
        return abortable.signal.aborted;
    }
    abortAll() {
        // this.#abortables.forEach((abortable) => abortable.abort())
        $95298b233eb5daae$var$handleLatLngClickAbortController.abort();
    }
}
const $95298b233eb5daae$var$abortManager = new $95298b233eb5daae$var$AbortManager();
let $95298b233eb5daae$export$ffc4d0086f1a4c9;
function $95298b233eb5daae$export$7b06fe4c55835ecb() {
    // Signal every abortable to abort
    $95298b233eb5daae$var$abortManager.abortAll();
}
/**
 * @type {AbortController}
 */ let $95298b233eb5daae$var$handleLatLngClickAbortController = new AbortController();
async function $95298b233eb5daae$export$2d678771816e1c96(lat, lng, map, options) {
    const { modifyHistory: modifyHistory = true } = options === undefined ? {} : options;
    if ($95298b233eb5daae$export$ffc4d0086f1a4c9) $95298b233eb5daae$export$ffc4d0086f1a4c9.remove();
    document.getElementById("right-small-panel").classList.add("active");
    document.getElementById("list_switch_container").classList.add("show");
    document.getElementById("search_bar").classList.add("right-panel-open");
    document.getElementById("center-window").classList.add("right-panel-open");
    if ($95298b233eb5daae$var$pageInitialLoading) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#trans_screen_loading").show();
    $95298b233eb5daae$var$selected_lat = lat;
    $95298b233eb5daae$var$selected_lng = lng;
    $95298b233eb5daae$var$onStateChange({
        modifyHistory: modifyHistory
    });
    const marker_el = document.createElement("div");
    marker_el.className = "marker";
    marker_el.style.backgroundImage = "url(/img/marker.svg)";
    marker_el.style.backgroundRepeat = "no-repeat";
    marker_el.style.backgroundPosition = "bottom";
    marker_el.style.width = "30px";
    marker_el.style.height = "50px";
    $95298b233eb5daae$export$ffc4d0086f1a4c9 = new $30510d2f060a5cf8$exports.Marker({
        element: marker_el,
        anchor: "bottom"
    }).setLngLat([
        lng,
        lat
    ]).addTo(map);
    if ($95298b233eb5daae$var$pageInitialLoading) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#map .marker").addClass("!r3-hidden test");
    // Abort any previous latLngClick
    $95298b233eb5daae$var$handleLatLngClickAbortController.abort("clearing old lat lng click");
    $95298b233eb5daae$var$handleLatLngClickAbortController = new AbortController();
    const abortable = $95298b233eb5daae$var$handleLatLngClickAbortController;
    if (window.innerWidth > 991) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#list_elections").html("Election Dates");
    let response2;
    try {
        response2 = await fetch(`${$95298b233eb5daae$var$apiHost}/voting_precincts?lat=${lat}&lon=${lng}`, {
            signal: abortable.signal
        });
    } catch (err) {
        console.warn(err, "fetch voting precincts rejected");
        return;
    }
    const data2 = await response2.json();
    // Check if aborted
    if (abortable.signal.aborted) {
        console.warn("aborted while deserializing");
        return;
    }
    if (data2.status === 200) {
        console.log("response2", data2.payload);
        if (data2.payload && data2.payload.precinct && data2.payload.precinct.polling_address) {
            const precinctresult = data2.payload.precinct;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#view_on_google_map").show();
            if (window.innerWidth > 991) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#go-to-voting-precinct").removeClass("hidden");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").css({
                    "maxHeight": "calc(100vh - 560px)"
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#precinct_name").html(precinctresult.polling_address);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#view_on_google_map").attr("href", "http://maps.google.com/?q=" + encodeURIComponent(precinctresult.polling_address));
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label").data("address", precinctresult.polling_address);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label").data("lat", precinctresult.lat);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label").data("lon", precinctresult.lon);
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#go-to-voting-precinct").addClass("hidden");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#precinct_name").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#go-to-voting-precinct").attr("href", "#");
                document.getElementById("elections_list").innerHTML = `<div class="election-item"  data-index="0">
                <div class="ballot-row-2" >
                    <div class="w-100p r3-px-4">
                        <p class="r3-px-2 r3-text-[8px] r3-text-gray-400">${precinctresult.polling_address}</p>
                        <div class="text-center r3-bg-gray-800 r3-text-white r3-px-2 r3-text-[12px] r3-py-1 r3-rounded r3-my-2 go-to-voting-precinct-label mobile-menu">View Polling Location</div>
                        <a href="${"http://maps.google.com/?q=" + encodeURIComponent(precinctresult.polling_address)}" target="_blank" class="r3-my-2 r3-text-[10px] r3-flex r3-justify-center">
                            View on Google Map
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="r3-w-3 r3-h-3 r3-ml-1">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>`;
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label.mobile-menu").data("address", precinctresult.polling_address);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label.mobile-menu").data("lat", precinctresult.lat);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label.mobile-menu").data("lon", precinctresult.lon);
            }
        } else {
            $95298b233eb5daae$var$precinctlist = data2.payload.list;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#view_on_google_map").hide();
            if (window.innerWidth > 991) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").css({
                    "maxHeight": "calc(100vh - 455px)"
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#go-to-voting-precinct").removeClass("hidden");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#precinct_name").html($95298b233eb5daae$var$precinctlist.length + " addresses");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label").data("address", null);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label").data("lat", null);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label").data("lon", null);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#view_on_google_map").attr("href", "http://maps.google.com");
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#go-to-voting-precinct").addClass("hidden");
                document.getElementById("elections_list").innerHTML = `<div class="election-item"  data-index="0">
                <div class="ballot-row-2" >
                    <div class="w-100p r3-px-4">
                        <div class="text-center r3-bg-gray-800 r3-text-white r3-px-2 r3-text-[12px] r3-py-1 r3-rounded r3-my-2 go-to-voting-precinct-label mobile-menu">View Polling Location</div>
                    </div>
                </div>
            </div>`;
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label.mobile-menu").data("address", null);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label.mobile-menu").data("lat", null);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go-to-voting-precinct-label.mobile-menu").data("lon", null);
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#go-to-voting-precinct").attr("href", "#");
        }
    }
    let response;
    try {
        response = await fetch(`${$95298b233eb5daae$var$apiHost}/voting_districts?lat=${lat}&lon=${lng}`, {
            signal: abortable.signal
        });
    } catch (err) {
        console.warn(err, "fetch voting districts rejected");
        return;
    }
    const data = await response.json();
    // Check if aborted
    if (abortable.signal.aborted) {
        console.warn("aborted while turning response into json");
        return;
    }
    console.log("payload", data.payload);
    if (data.status === 200) {
        $95298b233eb5daae$var$districts = data.payload;
        if (!$95298b233eb5daae$var$districts.length) return;
        $95298b233eb5daae$var$districts.sort((a, b)=>{
            return a.order - b.order;
        });
        console.log($95298b233eb5daae$var$districts);
        $95298b233eb5daae$var$selected_vtd_unit = $95298b233eb5daae$var$districts[0]?.district_id;
        if ($95298b233eb5daae$var$init_district_id) $95298b233eb5daae$var$selected_vtd = $95298b233eb5daae$var$districts.find((district)=>district.district_id == $95298b233eb5daae$var$init_district_id) || $95298b233eb5daae$var$districts[0];
        else $95298b233eb5daae$var$selected_vtd = $95298b233eb5daae$var$districts[0];
        console.log($95298b233eb5daae$var$districts);
        console.log("voting district", $95298b233eb5daae$var$selected_vtd);
        $95298b233eb5daae$var$renderDistricts($95298b233eb5daae$var$districts);
        $95298b233eb5daae$var$showDistrict($95298b233eb5daae$var$selected_vtd, lng, lat, map, {
            signal: abortable.signal
        });
        // Pass abort signal into all of these
        $95298b233eb5daae$var$getElectionByVotingDistrictIDs($95298b233eb5daae$var$getDistrictIds($95298b233eb5daae$var$districts), {
            signal: abortable.signal
        });
        // let first_new_url = updateQueryStringParameter($("#election-overview-div button.flex-row:nth-of-type(1)").attr("href"), 'zip_code', 0)
        //  first_new_url = updateQueryStringParameter(first_new_url, 'latlon', lat + ',' + lng)
        // $("#election-overview-div button.flex-row:nth-of-type(1)").attr("href", first_new_url)
        // let second_new_url = updateQueryStringParameter($("#election-overview-div button.flex-row:nth-of-type(2)").attr("href"), 'zip_code', 0)
        // second_new_url = updateQueryStringParameter(second_new_url, 'latlon', lat + ',' + lng)
        // $("#election-overview-div button.flex-row:nth-of-type(2)").attr("href", second_new_url)
        // let third_new_url = updateQueryStringParameter($("#election-overview-div button.flex-row:nth-of-type(3)").attr("href"), 'zip_code', 0)
        // third_new_url = updateQueryStringParameter(third_new_url, 'latlon', lat + ',' + lng)
        // $("#election-overview-div button.flex-row:nth-of-type(3)").attr("href", third_new_url)
        return data;
    }
}
class $95298b233eb5daae$var$OSMMapControl {
    #listeners;
    #map;
    #handleEvent;
    constructor(map){
        this.#listeners = [];
        this.#map = map;
        this.#handleEvent = false;
    }
    #ondblclick(e) {
        e.preventDefault();
        $95298b233eb5daae$var$handleOnMapEvent(e, this.#map);
    }
    #ontouchend(e) {
        if (this.#handleEvent) $95298b233eb5daae$var$handleOnMapEvent(e, this.#map);
        return false;
    }
    #ontouchstart() {
        this.#handleEvent = true;
        return false;
    }
    #ontouchmove(e) {
        this.#handleEvent = false;
        return false;
    }
    #addHandler(name, handler) {
        this.#listeners.push([
            name,
            handler
        ]);
        this.#map.on(name, handler);
    }
    attach() {
        this.#addHandler("dblclick", (e)=>this.#ondblclick(e));
        this.#addHandler("touchend", (e)=>this.#ontouchend(e));
        this.#addHandler("touchstart", (e)=>this.#ontouchstart(e));
        this.#addHandler("touchmove", (e)=>this.#ontouchmove(e));
    }
    detach() {
        this.#listeners.forEach((listener)=>{
            this.#map.off(...listener);
        });
    }
}
function $95298b233eb5daae$var$clickSaveVotingPrecinctBtn() {
    if (getCookie("user_id")) {
        let search = window.location.search;
        search = search.replace(/&election_filter=\d+-?\d*&?/, "&");
        if (search.endsWith("&")) search = search.slice(0, -1);
        let data = {
            district_id: $95298b233eb5daae$var$selected_vtd_unit,
            city: $95298b233eb5daae$var$selected_voting_precinct.city ?? null,
            county: $95298b233eb5daae$var$selected_voting_precinct.county ?? null,
            lat: $95298b233eb5daae$var$selected_voting_precinct.lat ?? null,
            lon: $95298b233eb5daae$var$selected_voting_precinct.lon ?? null,
            formatted: $95298b233eb5daae$var$selected_voting_precinct.formatted ?? null,
            state: $95298b233eb5daae$var$selected_voting_precinct.state ?? null,
            street: $95298b233eb5daae$var$selected_voting_precinct.street ?? null,
            zip: $95298b233eb5daae$var$selected_voting_precinct.zip ?? null,
            url: window.location.pathname + search
        };
        saveMyVotingPrecinct(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_voting_precinct_modal").fadeOut();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save_location_btn").remove();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save-my-voting-precinct-label").html("My Voting Precinct");
        if (window.flutter_inappwebview) window.flutter_inappwebview.callHandler("saveMyVotingPrecinct", data.url);
    } else displayLogin();
}
function $95298b233eb5daae$export$2b560c01ee33d8d0(map) {
    $95298b233eb5daae$var$mapControl = new $95298b233eb5daae$var$OSMMapControl(map);
    $95298b233eb5daae$var$mapControl.attach();
    let following_blank_elections = [];
    if (getCookie("user_id")) api.get("elections/following").then((response)=>{
        return response.json();
    }).then((data)=>{
        following_blank_elections = data.payload.blank_elections;
        console.log("blanks", following_blank_elections);
    }).catch(function(error) {});
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-overview-div").removeClass("hidden");
    // $(".type_value").on("click.osm", function (e) {
    //     if ($(this).hasClass("disabled")) {
    //         e.preventDefault();
    //         return false;
    //     }
    //     const type = $(this).data("value")
    //     $(this).siblings().removeClass('r3-bg-primary-bg r3-text-white')
    //     $(this).addClass('r3-bg-primary-bg r3-text-white')
    //     election_type = type
    //     onStateChange({modifyHistory: true})
    //     getElectionByVotingDistrictIDs()
    //
    //     if (type == 2) {
    //         $("#year_filter_dropdown .election-filter-option").addClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2027']").removeClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2026']").removeClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2025']").removeClass("disabled")
    //         $("#year_filter_dropdown .election-filter-option[data-value='2024-2']").removeClass("disabled")
    //     } else {
    //         $("#year_filter_dropdown .election-filter-option").removeClass("disabled")
    //     }
    // })
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".year_value").on("click.osm", function(e) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("disabled")) {
            e.preventDefault();
            return false;
        }
        const year = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("value");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#year_filter_value").html((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).html());
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#year_filter_dropdown").hide();
        $95298b233eb5daae$var$resetStartDate(year);
        $95298b233eb5daae$var$election_filter = year;
        $95298b233eb5daae$var$onStateChange({
            modifyHistory: true
        });
        $95298b233eb5daae$var$getElectionByVotingDistrictIDs();
        if (year == "2027" || year == "2026" || year == "2025" || year == "2024") (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#type_filter_dropdown .election-filter-option").removeClass("disabled");
        else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#type_filter_dropdown .election-filter-option[data-value='2']").addClass("disabled");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#left-panel").on("click.osm", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-filter-options-list").slideUp();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).on("click.osm", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-filter-options-list").slideUp();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-filter-dropdown-selector").on("click.osm", function(e) {
        e.stopPropagation();
        if (!$95298b233eb5daae$var$election_data_loaded) return;
        const target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("target");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("target")).slideToggle();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-filter-options-list:not(" + target + ")").slideUp();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").on("afterChange.osm", function(event, slick, currentSlide) {
        const index = currentSlide % $95298b233eb5daae$var$districts.length;
        if (!index) return;
        $95298b233eb5daae$var$showDistrict($95298b233eb5daae$var$districts[index], null, null, map);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".district_item", function(e) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("active")) return;
        if (window.innerWidth < 991) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#map-arrow").click();
            const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("index");
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".slick-center.district_item").data("index") == index) return;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_item").removeClass("slick-center");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_item[data-index=" + index + "]").addClass("slick-center");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").animate({
                scrollTop: index == 0 ? 0 : (index - 1) * 32
            }, 150);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_item").removeClass("active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("active");
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("index");
        // if (window.innerWidth < 991) {
        //     const clickedIndex = $(this).data("slick-index")
        //     $("#districts_list").slick("slickGoTo", clickedIndex)
        // }
        $95298b233eb5daae$var$selected_vtd = $95298b233eb5daae$var$districts[index];
        $95298b233eb5daae$var$onStateChange({
            modifyHistory: true
        });
        $95298b233eb5daae$var$showDistrict($95298b233eb5daae$var$selected_vtd, null, null, map);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".election-item", function() {
        if (window.innerWidth < 991) {
            const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("index");
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".slick-center.election-item").data("index") == index) return;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-item").removeClass("slick-center");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-item[data-index=" + index + "]").addClass("slick-center");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").animate({
                scrollTop: index == 0 ? 0 : (index - 1) * 26
            }, 150);
            const district_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("district");
            if ($95298b233eb5daae$var$mobile_current_district_id != district_id) {
                $95298b233eb5daae$var$mobile_current_district_id = district_id;
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`#districts_list .district_item[data-id=${$95298b233eb5daae$var$mobile_current_district_id}]`).click();
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".go-to-voting-precinct-label", async function(e) {
        let address = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("address");
        let lat = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("lat");
        let lon = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("lon");
        console.log(address, lat, lon);
        if (address) $95298b233eb5daae$var$showPrecinctMarker(address, map, lon, lat);
        else if ($95298b233eb5daae$var$precinctlist.length) {
            let modalContent = `
                        <div class="modal-content r3-fixed r3-inset-0 r3-bg-black/50 r3-flex r3-items-center r3-justify-center">
                            <div class="r3-bg-white r3-rounded-lg r3-w-[640px] r3-mx-4">
                                <div class="r3-relative r3-py-4 r3-px-4 md:r3-px-8">
                                    <button type="button" class="cancel_polling_location_list_modal_btn r3-absolute r3-right-4 r3-top-4">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="r3-w-6 r3-h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                    
                                    <div class="r3-text-center r3-mb-6">
                                        <h2 class="r3-text-xl r3-font-medium r3-mb-2">There are ${$95298b233eb5daae$var$precinctlist.length} voting precinct locations</h2>
                                        <p class="r3-text-gray-600">Currently available data shows the address of your local polling locations. <br>Our team is working hard to collect your local voting precinct maps. Please reach out to your local election office for your official voting location. </p>
                                    </div>
                    
                                    <div class="r3-space-y-3 r3-max-h-[280px] md:r3-max-h-[480px] r3-overflow-y-auto">
                                        ${$95298b233eb5daae$var$precinctlist.map((precinct)=>`
                                            <div class="precinct-item r3-p-4 r3-border r3-border-gray-200 r3-rounded r3-cursor-pointer hover:r3-bg-gray-50" 
                                                data-address="${precinct.address}"
                                                data-district="${precinct.district}"
                                                data-id="${precinct.id}">
                                                <div class="r3-flex r3-items-center r3-gap-3">
                                                    <div style="padding: 5px">
                                                        <img src="/assets/voting_precinct.webp" style="width: 40px"/>
                                                    </div>
                                                    <div class="r3-flex-1 r3-text-sm r3-text-gray-600">${precinct.address}</div>
                                                    <a href="http://maps.google.com/?q=${encodeURIComponent(precinct.address)}" target="_blank" class="r3-text-sm r3-text-gray-600 hover:r3-text-gray-950 r3-flex r3-items-center r3-gap-1">
                                                            <span class="r3-hidden md:r3-inline-block">Google Map</span>
                                                            <svg title="View on Google Map" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="r3-w-3 r3-h-3 r3-ml-1">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                                                            </svg>
                                                        </a>
                                                </div>
                                            </div>
                                        `).join("")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
            // Show modal
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#polling_location_list_modal").html(modalContent).show();
        } else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#polling_location_modal").show();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").on("touchstart.osm", function() {
        $95298b233eb5daae$var$position = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").scrollTop();
        $95298b233eb5daae$var$touched = true;
    }).on("touchmove.osm", function() {
        if ($95298b233eb5daae$var$touched) {
            // $("#districts_list").css("paddingTop", "32px")
            // $("#districts_list").css("paddingBottom", "32px")
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").scrollTop($95298b233eb5daae$var$position + 32);
            $95298b233eb5daae$var$touched = false;
        }
        const currentPosition = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").scrollTop();
        let index = Math.round(currentPosition / 32);
        if (index >= $95298b233eb5daae$var$elections.length) index = $95298b233eb5daae$var$elections.length - 1;
        if (index < 0) index = 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_item").removeClass("slick-center");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_item[data-index=" + index + "]").addClass("slick-center");
    }).on("touchend.osm", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").css("paddingTop", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").css("paddingBottom", 0);
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_item.slick-center").data("index");
        // $("#districts_list").animate(
        //     {
        //         scrollTop: index == 0 ? 0 : (index - 1) * 32,
        //     },
        //     300
        // )
        $95298b233eb5daae$var$selected_vtd = $95298b233eb5daae$var$districts[index];
        $95298b233eb5daae$var$showDistrict($95298b233eb5daae$var$selected_vtd, null, null, map);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").on("touchstart.osm", function() {
        $95298b233eb5daae$var$position = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").scrollTop();
        $95298b233eb5daae$var$touched = true;
    }).on("touchmove.osm", function() {
        if ($95298b233eb5daae$var$touched) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").css("paddingTop", "26px");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").css("paddingBottom", "26px");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").scrollTop($95298b233eb5daae$var$position + 26);
            $95298b233eb5daae$var$touched = false;
        }
        const currentPosition = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").scrollTop();
        let index = Math.round(currentPosition / 26);
        if (index >= $95298b233eb5daae$var$elections.length) index = $95298b233eb5daae$var$elections.length - 1;
        if (index < 0) index = 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-item").removeClass("slick-center");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-item[data-index=" + index + "]").addClass("slick-center");
    }).on("touchend.osm", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").css("paddingTop", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").css("paddingBottom", 0);
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-item.slick-center").data("index");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").animate({
            scrollTop: index == 0 ? 0 : (index - 1) * 26
        }, 300);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).on("click.osm", function() {
        document.getElementById("left-panel").classList.remove("active");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", "#left-panel", function(e) {
        e.stopPropagation();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".list_switch_container", function(e) {
        e.stopPropagation();
        if (window.innerWidth > 991) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").show();
        else {
            // if (document.getElementById("list_elections").classList.contains("no-elections")) {
            //     displayNoPollingLocation()
            // } else {
            //     $(".list_switch_container").toggleClass("active")
            //     $("#elections_list").toggle()
            //     $("#districts_list").hide()
            //     $(".district_container").removeClass("active")
            //     $("#elections_list").slick("resize")
            // }
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".list_switch_container").toggleClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").toggle();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_container").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").slick("resize");
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".district_container", function(e) {
        e.stopPropagation();
        if (window.innerWidth > 991) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").show();
        else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_container").toggleClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").toggle();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".list_switch_container").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").slick("resize");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").slick("slickGoTo", length);
            if ($95298b233eb5daae$var$initDistrict) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").animate({
                    scrollTop: 0
                }, 150);
                $95298b233eb5daae$var$initDistrict = false;
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", "#map-arrow", function(e) {
        e.stopPropagation();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-list").hasClass("hide")) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-list").removeClass("hide");
        else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-list").addClass("hide");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save-my-voting-precinct").on("click.osm", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_voting_precinct_modal").fadeIn();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".go_to_my_election", function(e) {
        const type = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("type");
        let url = `/pages/my-elections?type=${type}&election_filter=${$95298b233eb5daae$var$election_filter}&start_date=${$95298b233eb5daae$var$start_date}&end_date=${$95298b233eb5daae$var$end_date}&district_id=${$95298b233eb5daae$var$selected_geo_ids}&election_type=${$95298b233eb5daae$var$election_type}`;
        if (e.ctrlKey || e.which == 2 || e.button == 4) window.open(url, "_blank");
        else window.location.href = url;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".election-item .election-link", function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("blank") == 1) {
            let election_date = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("date");
            console.log(election_date);
            if (election_date) {
                let today = new Date().toISOString().split("T")[0];
                console.log("is past", election_date < today);
                if (election_date < today) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-title").text("Past Election");
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-text").text("Due to different stages of development, some past election data is not available at this time.");
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-title").text("Up for Election");
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-text").html('We are continuing to gather candidate information for this election.Candidate information can become available as close as 30 days prior to the election. <br><br>Please check back soon.<br><br>Click the "Follow" button to get notifications as candidates are added to this election.');
                }
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-title").text("No Election Data");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-text").text("There is no data for this election.");
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal").show();
            const follow_btn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#follow_blank_election_modal_btn");
            const id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("id");
            follow_btn.data("id", id);
            const alreadyFollowing = following_blank_elections.some((element)=>element == id);
            follow_btn.data("action", alreadyFollowing ? "unfollow" : "follow");
            follow_btn.text(alreadyFollowing ? "Unfollow" : "Follow");
            return;
        }
        const link = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("href");
        if (!link) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("subdistricted") == 1) {
            const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("index");
            const electionIndex = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list .slick-center").data("index");
            if (index !== electionIndex) return;
            window.location.href = link;
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#prioritize_location_id").val((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("location"));
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#prioritize_my_area").data("link", link);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_subdistrict_modal").show();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".cancel_subdistrict_modal_btn", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_subdistrict_modal").hide();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".cancel_blank_election_modal_btn", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal").hide();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".cancel_polling_location_modal_btn", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#polling_location_modal").hide();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".cancel_polling_location_list_modal_btn", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#polling_location_list_modal").hide();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".cancel_canceled_election_modal_btn", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#canceled_election_modal").hide();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", "#follow_blank_election_modal_btn", function(e) {
        e.preventDefault();
        let election_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("id");
        let action = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("action");
        if (getCookie("user_id")) {
            if (action === "follow") api.put("election/0" + election_id + "/follow")// .then(response => response.json())
            .then(function(response) {
                customAlert("You are now following this election!", ()=>{
                    window.location.reload();
                });
            }).catch(function(error) {});
            else api.delete("/election/0" + election_id + "/follow").then(function(response) {
                customAlert("You have unfollowed this election!", ()=>{
                    window.location.reload();
                });
            }).catch(function(error) {});
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal").hide();
            customAlert("Please log in or create a free account to access this feature!", ()=>{
                displayLogin();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".popup.login form").attr("action", 'javascript:userLogin(".login", "' + window.location.href + '")'); // Redirect to current page upon login
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", "#prioritize_my_area", function(e) {
        e.preventDefault();
        let location_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#prioritize_location_id").val();
        let link = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("link");
        api.post("user/prioritize/" + location_id + "/location").then(function(response) {
            window.location.href = link;
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click.osm", ".election_candidate_a", function(e) {
        e.preventDefault();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("blank") == 1) {
            console.log($95298b233eb5daae$var$response_elections);
            let blank_election = $95298b233eb5daae$var$response_blank_elections.find((x)=>x.id == (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("id"));
            let election_date = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("date");
            console.log("election date: ", election_date);
            if (election_date) {
                let today = new Date().toISOString().split("T")[0];
                console.log("is past", election_date < today);
                if (election_date < today) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-title").text("Past Election");
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-text").text("Due to different stages of development, some past election data is not available at this time.");
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-title").text("Up for Election");
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-text").html('We are continuing to gather candidate information for this election.Candidate information can become available as close as 30 days prior to the election. <br><br>Please check back soon.<br><br>Click the "Follow" button to get notifications as candidates are added to this election.');
                }
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-title").text("No Election Data");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal .modal-text").text("There is no data for this election.");
            }
            if (!blank_election) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal").show();
                const follow_btn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#follow_blank_election_modal_btn");
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("id");
                follow_btn.data("id", id);
                const alreadyFollowing = following_blank_elections.some((element)=>element == id);
                follow_btn.data("action", alreadyFollowing ? "unfollow" : "follow");
                follow_btn.text(alreadyFollowing ? "Unfollow" : "Follow");
                return;
            }
            console.log(blank_election);
            if (blank_election.is_canceled == "1") {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#canceled_election_modal").show();
                return;
            }
            let filtered_elections_by_blank;
            if (blank_election.government_level_id == 3 && blank_election.election_name.includes("President")) filtered_elections_by_blank = $95298b233eb5daae$var$response_elections.filter((x)=>x.government_level_id == 3 && x.branch_id == 1 && x.election_type_id == blank_election.election_type_id && x.election_date.substring(0, 4) == blank_election.election_date.substring(0, 4));
            else filtered_elections_by_blank = $95298b233eb5daae$var$response_elections.filter((x)=>x.government_level_id == blank_election.government_level_id && x.election_type_id == blank_election.election_type_id && x.election_date.substring(0, 7) == blank_election.election_date.substring(0, 7));
            if (!filtered_elections_by_blank.length) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#blank_election_modal").show();
                const follow_btn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#follow_blank_election_modal_btn");
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("id");
                follow_btn.data("id", id);
                const alreadyFollowing = following_blank_elections.some((element)=>element == id);
                follow_btn.data("action", alreadyFollowing ? "unfollow" : "follow");
                follow_btn.text(alreadyFollowing ? "Unfollow" : "Follow");
                return;
            }
            // if(filtered_elections_by_blank.length == 1) {
            //     window.location.href = "/pages/election-candidates/index.php?election_id=" + filtered_elections_by_blank[0].election_id;
            //     return;
            // }
            // if
            // let type;
            // if (blank_election.government_level_id == 1) {
            //     type = 'local'
            // } else if (blank_election.government_level_id == 2) {
            //     type = 'state'
            // } else {
            //     type = 'federal'
            // }
            let url = `/pages/my-elections?election_filter=${$95298b233eb5daae$var$election_filter}&start_date=${$95298b233eb5daae$var$start_date}&end_date=${$95298b233eb5daae$var$end_date}&district_id=${$95298b233eb5daae$var$selected_geo_ids}&election_type=${$95298b233eb5daae$var$election_type}&election_date=${blank_election.election_date}#grid${blank_election.election_date}`;
            if (e.ctrlKey || e.which == 2 || e.button == 4) window.open(url, "_blank");
            else window.location.href = url;
            return;
        }
        const link = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("href");
        if (!link) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("subdistricted") == 1) {
            if (e.ctrlKey || e.which == 2 || e.button == 4) window.open(link, "_blank");
            else window.location.href = link;
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#prioritize_location_id").val((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("location"));
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#prioritize_my_area").data("link", link);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_subdistrict_modal").show();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("mouseover.osm", ".election_candidate_a", function(e) {
        const district_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("district");
        if ($95298b233eb5daae$var$current_district_id != district_id) {
            $95298b233eb5daae$var$current_district_id = district_id;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`#districts_list .district_item[data-id=${$95298b233eb5daae$var$current_district_id}]`).trigger("click");
        }
    });
}
function $95298b233eb5daae$var$onStateChange(options) {
    console.log("onStateChange");
    const { modifyHistory: modifyHistory = true } = options;
    if (modifyHistory) {
        const prevState = (0, $ed93617e655b9b33$export$d140a9f6968c1121)();
        const state = {
            type: (0, $ed93617e655b9b33$export$8a87ade5aef88514).map,
            lon: $95298b233eb5daae$var$selected_lng,
            lat: $95298b233eb5daae$var$selected_lat,
            usCounty: history.state.usCounty,
            usState: history.state.usState,
            districtId: $95298b233eb5daae$var$selected_vtd ? $95298b233eb5daae$var$selected_vtd.district_id : null,
            electionFilter: $95298b233eb5daae$var$election_filter,
            electionType: $95298b233eb5daae$var$election_type
        };
        let newUrl = $95298b233eb5daae$var$updateQueryStringParameter(window.location.href, "lng", $95298b233eb5daae$var$selected_lng);
        newUrl = $95298b233eb5daae$var$updateQueryStringParameter(newUrl, "lat", $95298b233eb5daae$var$selected_lat);
        newUrl = $95298b233eb5daae$var$updateQueryStringParameter(newUrl, "district_id", $95298b233eb5daae$var$selected_vtd ? $95298b233eb5daae$var$selected_vtd.district_id : null);
        newUrl = $95298b233eb5daae$var$updateQueryStringParameter(newUrl, "election_filter", $95298b233eb5daae$var$election_filter);
        newUrl = $95298b233eb5daae$var$updateQueryStringParameter(newUrl, "election_type", $95298b233eb5daae$var$election_type);
        (0, $ed93617e655b9b33$export$a104c684a09de9be)(state);
    }
}
function $95298b233eb5daae$var$disableOSMUIControls() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".type_value").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".year_value").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#left-panel").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-filter-dropdown-selector").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save-my-voting-precinct").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).off(".osm");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).off(".osm");
    $95298b233eb5daae$var$mapControl?.detach();
}
function $95298b233eb5daae$export$aad8462122ac592b(map) {
    $95298b233eb5daae$var$popup?.remove();
    $95298b233eb5daae$export$ffc4d0086f1a4c9?.remove();
    $95298b233eb5daae$var$disableOSMUIControls();
    const polygonSource = map.getSource("polygon");
    if (polygonSource) {
        map.removeLayer("polygon");
        map.removeSource("polygon");
    }
    // Hide right panel
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#right-small-panel").removeClass("active");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#list_switch_container").removeClass("show");
    // Don't empty district list in mobile UI, as it breaks slick
    // TODO: Figure out a way to work with slick
    if (window.innerWidth >= 991) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").empty();
    // Remove election counts
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".go_to_my_election .num").empty();
    // Hide save my voting precinct button
    document.querySelector("#save-my-voting-precinct").classList.add("hidden");
    $95298b233eb5daae$export$7b06fe4c55835ecb();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#trans_screen_loading").hide();
}
function $95298b233eb5daae$export$34863fc904f5f35f(tut) {
    $95298b233eb5daae$var$tutorial = tut;
}
let $95298b233eb5daae$var$another_marker;
async function $95298b233eb5daae$var$showPrecinctMarker(address, map, lon = null, lat = null) {
    if ($95298b233eb5daae$var$another_marker) $95298b233eb5daae$var$another_marker.remove();
    const marker_el = document.createElement("div");
    marker_el.className = "marker2";
    marker_el.style.backgroundImage = "url(/img/voting_precinct.svg)";
    marker_el.style.backgroundRepeat = "no-repeat";
    marker_el.style.backgroundPosition = "bottom";
    marker_el.style.width = "30px";
    marker_el.style.height = "50px";
    if (!lat || !lon) {
        let locationResult = await api.get("search/address?q=" + encodeURIComponent(address));
        locationResult = await locationResult.json();
        let locationData = locationResult.payload;
        //
        // let locationResult = await fetch("https://api.geocod.io/v1.7/geocode?q=" + encodeURIComponent(address) + "&api_key=6c8c5dd680c66dfed667da6d6765aee5e800a7d&limit=3&country=US")
        // let locationData = await locationResult.json()
        lat = locationData.results[0].location.lat;
        lon = locationData.results[0].location.lng;
    // let address_components = locationData.results[0].address_components?? null
    //
    // let county = address_components.county.replace(" County", "")
    // let usState = address_components.state
    }
    $95298b233eb5daae$var$another_marker = new $30510d2f060a5cf8$exports.Marker({
        element: marker_el,
        anchor: "bottom"
    }).setLngLat([
        lon,
        lat
    ]).addTo(map);
    window.smoothlyGoToViewPoint(lat, lon, 13.24);
}
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "#save_location_btn", function(e) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_voting_precinct_modal").fadeIn();
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "#save_precinct_btn", function(e) {
    e.preventDefault();
    $95298b233eb5daae$var$clickSaveVotingPrecinctBtn();
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".cancel_precinct_btn", function(e) {
    e.preventDefault();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#confirm_voting_precinct_modal").fadeOut();
});
function $95298b233eb5daae$var$fixPolygonWithInnerRingsThatShouldTheExteriorRingsOfSeparatePolygonsInAMultiPolygon(polygon) {
    return {
        type: "MultiPolygon",
        coordinates: [
            ...polygon.coordinates.map((coord)=>[
                    coord
                ])
        ]
    };
}
/**
 * Options for ShowDistrict
 * @typedef {{signal?: AbortSignal}} ShowDistrictOptions
 */ /**
 *
 * @param {*} vtd
 * @param {*} lng
 * @param {*} lat
 * @param {*} map
 * @param {ShowDistrictOptions} [options]
 * @returns
 */ function $95298b233eb5daae$var$showDistrict(vtd, lng, lat, map, options) {
    /**
     * @type {AbortSignal | undefined}
     */ let signal;
    if (options !== undefined) ({ signal: signal } = options);
    if (!vtd) return;
    const displayName = $95298b233eb5daae$var$getDistrictName(vtd) + vtd.location_name;
    if (!$95298b233eb5daae$var$popup) $95298b233eb5daae$var$popup = new $30510d2f060a5cf8$exports.Popup({
        anchor: "bottom",
        offset: {
            bottom: [
                0,
                -20
            ]
        },
        closeButton: false,
        closeOnClick: false,
        className: "pb28"
    }).addTo(map);
    else if (!$95298b233eb5daae$var$popup.isOpen()) $95298b233eb5daae$var$popup.addTo(map);
    if (lng && lat) $95298b233eb5daae$var$popup.setLngLat([
        lng,
        lat
    ]);
    console.log("my_vtd_lat/my_vtd_lon", [
        my_vtd_lat,
        my_vtd_lon
    ]);
    console.log("lat/lon", [
        lat,
        lng
    ]);
    // DOM Mutation
    if (lat && lng) {
        if (my_vtd_lat && my_vtd_lon && my_vtd_lat.toFixed(8) == lat.toFixed(8) && my_vtd_lon.toFixed(8) == lng.toFixed(8)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save-my-voting-precinct-label").html("My Voting Precinct");
            $95298b233eb5daae$var$popup.setHTML(`<h1>${displayName}</h1>`);
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save-my-voting-precinct-label").html("Save As My Voting Precinct");
            $95298b233eb5daae$var$popup.setHTML(`<h1>${displayName}</h1><div class="r3-cursor-pointer r3-border r3-border-solid r3-w-full r3-px-2 r3-py-0 r3-border-primary-dark-grey10 r3-rounded r3-mt-2 r3-flex r3-justify-between r3-items-center" id="save_location_btn">Save Location <input type="radio" class="r3-ml-1"></div>`);
        }
        if ($95298b233eb5daae$var$pageInitialLoading) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#map .maplibregl-popup").addClass("!r3-hidden osm_popup");
            $95298b233eb5daae$var$pageInitialLoading = false;
        }
        api.get(`geocode/geoapify-reverse?lat=${parseFloat(lat)}&lon=${parseFloat(lng)}`).then((response)=>response.json()).then(async (result)=>{
            $95298b233eb5daae$var$selected_voting_precinct = result.features[0].properties ?? null;
            api.get(`geocode/geocodio-reverse?lat=${parseFloat(lat)}&lon=${parseFloat(lng)}`).then((response)=>response.json()).then((result2)=>{
                console.log("result2", result2);
                const resultItem = result2.results[0];
                let address_components = resultItem.address_components;
                address_components.county = address_components.county.replace(" County", "");
                $95298b233eb5daae$var$selected_voting_precinct.zip = address_components.zip ?? "";
                $95298b233eb5daae$var$selected_voting_precinct = address_components;
                $95298b233eb5daae$var$selected_voting_precinct.lat = parseFloat(lat);
                $95298b233eb5daae$var$selected_voting_precinct.lon = parseFloat(lng);
                $95298b233eb5daae$var$selected_voting_precinct.formatted = resultItem.formatted_address;
                console.log("selected_voting_precinct", $95298b233eb5daae$var$selected_voting_precinct);
                document.getElementById("vtd_name").innerText = resultItem.formatted_address;
            }).catch((err)=>{
                console.warn(err);
            });
        }).catch((err)=>{
            console.warn(err);
        });
    }
    // document.getElementById("vtd_name").innerText = displayName
    const polygonSource = map.getSource("polygon");
    let polygon = JSON.parse(vtd.polygon);
    if (polygon.coordinates.length > 1) polygon = $95298b233eb5daae$var$fixPolygonWithInnerRingsThatShouldTheExteriorRingsOfSeparatePolygonsInAMultiPolygon(polygon);
    if (polygonSource) {
        map.removeLayer("polygon");
        map.removeSource("polygon");
    }
    try {
        map.addSource(`polygon`, {
            type: "geojson",
            data: {
                type: "Feature",
                geometry: polygon
            }
        });
        map.addLayer({
            id: `polygon`,
            type: "fill",
            source: `polygon`,
            layout: {},
            paint: {
                "fill-color": "#FFFFFF",
                // 'fill-color': '#A7A9AC',
                "fill-opacity": 0.5
            }
        });
    } catch (e) {
        console.log(e);
    }
}
function $95298b233eb5daae$var$getDistrictName(district) {
    if (district.type_id == 1) {
        if ($95298b233eb5daae$var$isInt(district.name)) return "District " + district.name + ", ";
        else return district.name + ", ";
    } else return "";
}
function $95298b233eb5daae$var$handleOnMapEvent(e, map) {
    // tutorial.state.send("SELECT_HOME")
    const { lng: lng, lat: lat } = e.lngLat;
    $95298b233eb5daae$var$initDistrict = true;
    $95298b233eb5daae$export$2d678771816e1c96(lat, lng, map);
}
function $95298b233eb5daae$var$updateQueryStringParameter(uri, key, value) {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) return uri.replace(re, "$1" + key + "=" + value + "$2");
    else return uri + separator + key + "=" + value;
}
function $95298b233eb5daae$var$isInt(value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
}
// Inspection point
function $95298b233eb5daae$var$resetStartDate(year = null) {
    year = year.toString();
    let start_date_obj, end_date_obj;
    switch(year){
        case "2027":
            $95298b233eb5daae$var$start_date = "2027-01-01";
            $95298b233eb5daae$var$end_date = "2027-12-31";
            break;
        case "2026":
            $95298b233eb5daae$var$start_date = "2026-01-01";
            $95298b233eb5daae$var$end_date = "2026-12-31";
            break;
        case "2025":
            $95298b233eb5daae$var$start_date = "2025-01-01";
            $95298b233eb5daae$var$end_date = "2025-12-31";
            break;
        case "upcoming":
            start_date_obj = $95298b233eb5daae$var$today;
            end_date_obj = new Date($95298b233eb5daae$var$today.getTime() + 31536000000);
            $95298b233eb5daae$var$start_date = start_date_obj.getFullYear() + "-" + (parseInt(start_date_obj.getMonth()) + 1) + "-" + start_date_obj.getDate();
            $95298b233eb5daae$var$end_date = end_date_obj.getFullYear() + "-" + (parseInt(end_date_obj.getMonth()) + 1) + "-" + end_date_obj.getDate();
            break;
        case "past":
            start_date_obj = new Date($95298b233eb5daae$var$today.getTime() - 31536000000);
            end_date_obj = new Date($95298b233eb5daae$var$today.getTime() - 86400000);
            $95298b233eb5daae$var$start_date = start_date_obj.getFullYear() + "-" + (parseInt(start_date_obj.getMonth()) + 1) + "-" + start_date_obj.getDate();
            $95298b233eb5daae$var$end_date = end_date_obj.getFullYear() + "-" + (parseInt(end_date_obj.getMonth()) + 1) + "-" + end_date_obj.getDate();
            break;
        case "2024":
            $95298b233eb5daae$var$start_date = "2024-01-01";
            $95298b233eb5daae$var$end_date = "2024-12-31";
            break;
        case "2023":
            $95298b233eb5daae$var$start_date = "2023-01-01";
            $95298b233eb5daae$var$end_date = "2023-12-31";
            break;
        case "2022":
            $95298b233eb5daae$var$start_date = "2022-01-01";
            $95298b233eb5daae$var$end_date = "2022-12-31";
            break;
        case "2021":
            $95298b233eb5daae$var$start_date = "2021-01-01";
            $95298b233eb5daae$var$end_date = "2021-12-31";
            break;
        case "2020":
            $95298b233eb5daae$var$start_date = "2020-01-01";
            $95298b233eb5daae$var$end_date = "2020-12-31";
            break;
        case "2019":
            $95298b233eb5daae$var$start_date = "2019-01-01";
            $95298b233eb5daae$var$end_date = "2019-12-31";
            break;
        case "2018":
            $95298b233eb5daae$var$start_date = "2018-01-01";
            $95298b233eb5daae$var$end_date = "2018-12-31";
            break;
        default:
            start_date_obj = $95298b233eb5daae$var$today;
            end_date_obj = new Date($95298b233eb5daae$var$today.getTime() + 31536000000);
            $95298b233eb5daae$var$start_date = start_date_obj.getFullYear() + "-" + (parseInt(start_date_obj.getMonth()) + 1) + "-" + start_date_obj.getDate();
            $95298b233eb5daae$var$end_date = end_date_obj.getFullYear() + "-" + (parseInt(end_date_obj.getMonth()) + 1) + "-" + end_date_obj.getDate();
    }
    console.log($95298b233eb5daae$var$start_date, $95298b233eb5daae$var$end_date);
}
function $95298b233eb5daae$var$getGovernmentLevelImg(level) {
    if (level === "Local") return `<img src="/assets/ballotBoxL.webp" class="election_img">`;
    else if (level === "State") return `<img src="/assets/ballotBoxS.webp" class="election_img">`;
    else if (level === "Federal") return `<img src="/assets/ballotBoxF.webp" class="election_img">`;
    else return `<img src="/assets/ballotBoxA.png" class="election_img">`;
}
function $95298b233eb5daae$var$getDistrictIds(districts) {
    if (!districts.length) return "";
    const ids = [];
    districts.map((district, index)=>{
        ids.push(district.district_id);
    });
    return ids.join();
}
function $95298b233eb5daae$var$getDistrictImage(type) {
    if ([
        "Congressional House District"
    ].includes(type)) return `<img src="/assets/ballotBoxF.webp" class="district_img">`;
    else if ([
        "State Legislative Lower District",
        "State Legislative Upper District",
        "State District"
    ].includes(type)) return `<img src="/assets/ballotBoxS.webp" class="district_img">`;
    else return `<img src="/assets/ballotBoxL.webp" class="district_img">`;
}
function $95298b233eb5daae$var$renderDistricts(districts) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-list").show();
    if (window.innerWidth < 991) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".district_container").removeClass("active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".list_switch_container").removeClass("active");
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#districts_list").show();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".election-list").removeClass("hide");
    }
    // if (window.innerWidth < 600) {
    //     $('#districts_list').slick('removeSlide', null, null, true);
    //     $("#districts_list").slick('unslick')
    //     $("#districts_list").slick({
    //         centerMode: true,
    //         centerPadding: 0,
    //         slidesToShow: 3,
    //         vertical: true,
    //         verticalSwiping: true,
    //         arrows: false,
    //         swipeToSlide: true,
    //         infinite: true,
    //         initialSlide: 0
    //     });
    // }
    let districts_list = "";
    districts.map((district, index)=>{
        let active;
        if ($95298b233eb5daae$var$init_district_id) active = district.district_id == $95298b233eb5daae$var$init_district_id;
        else active = index == 0;
        if (window.innerWidth < 991) districts_list += `<div class="district_item ballot-row-2 ${active ? "active" : ""} ${!index ? "slick-center" : ""}" data-index="${index}">
            <div class="img-election-type">
                ${$95298b233eb5daae$var$getDistrictImage(district.type)}
            </div>
            <div class="w-100p">
                <p class="election-name-cls">${$95298b233eb5daae$var$getDistrictName(district)} ${district.location_name}</p>
                <div class="district-box">
                    <p class="election-label-gray text-left">Type</p>
                    <p class="district-type">${district.type}</p>
                </div>
            </div>
        </div>`;
        else districts_list += `<div>
                <a  href="javascript:void(0);" class="district_item ballot-row-2 ${active ? "active" : ""}" data-index="${index}" data-id="${district.district_id}">
                    <div class="img-election-type">
                    ${$95298b233eb5daae$var$getDistrictImage(district.type)}
                    </div>
                    <div class="w-100p">
                        <p class="election-name-cls">${$95298b233eb5daae$var$getDistrictName(district)} ${district.location_name}</p>
                        <div class="district-box">
                            <p class="election-label-gray text-left">Type</p>
                            <p class="district-type">${district.type}</p>
                        </div>
                    </div>
                </a>
            </div>`;
    });
    document.getElementById("districts_list").innerHTML = districts_list;
    document.getElementById("list_districts").innerHTML = `Districts (${districts.length})`;
    length = districts.length;
    if (window.innerWidth > 991) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#save-my-voting-precinct").removeClass("hidden");
    document.getElementById("list_districts").style.display = "block";
    document.getElementById("election-overview-div").style.visibility = "visible";
}
function $95298b233eb5daae$var$getGroupByResult(elections) {
    let groupedElections = elections.reduce(function(acc, cur) {
        if (cur.subdistricted == "1") var key = cur.state_id + "-" + Math.random().toString(36).substr(2, 9) + cur.subdistricted;
        else {
            if (cur.city_id) var key = cur.state_id + "-" + "city-" + cur.city_id + "-" + cur.office_title + cur.subdistricted;
            else if (cur.county_id) var key = cur.state_id + "-" + "county-" + cur.county_id + "-" + cur.office_title + cur.subdistricted;
            else var key = cur.state_id + "-" + "county-" + cur.county_id + "-city-" + cur.city_id + "-" + cur.office_title + cur.subdistricted;
        }
        console.log("key", key);
        if (!acc[key]) {
            acc[key] = cur;
            acc[key].election_ids = [];
        }
        acc[key].election_ids.push(cur.election_id);
        return acc;
    }, {});
    return Object.values(groupedElections);
}
function $95298b233eb5daae$var$getLinkForElection(election) {
    if (election.subdistricted == "0" && election.election_ids) return `/pages/election-candidates/index.php?election_ids=${election.election_ids}`;
    else return `/pages/election-candidates/index.php?election_id=${election.election_id}`;
}
function $95298b233eb5daae$var$renderElections(list) {
    $95298b233eb5daae$var$elections = $95298b233eb5daae$var$getGroupByResult(list);
    // elections = list
    // let federal_count = 0
    // let state_count = 0
    // let local_count = 0
    // let all_count = 0
    let all_election_dates = [];
    $95298b233eb5daae$var$elections.sort((a, b)=>{
        return b.district_order - a.district_order;
    });
    let elections_list = "";
    console.log($95298b233eb5daae$var$elections);
    $95298b233eb5daae$var$elections.map((election, index)=>{
        // if (election.government_level === "Federal") {
        //     federal_count++
        // } else if (election.government_level === "State") {
        //     state_count++
        // } else {
        //     local_count++
        // }
        // all_count++
        all_election_dates.push(election.election_date);
        if (window.innerWidth < 991) ;
        else // elections_list += `<li>
        //     <a  href="${getLinkForElection(election)}" class="ballot-row-2 election_candidate_a" data-subdistricted="${election.subdistricted}" data-elections="${election.election_ids}" data-district="${
        //     election.district_id
        // }" data-location="${election.location_id}">
        //         <div class="img-election-type">
        //             ${getGovernmentLevelImg(election.government_level)}
        //         </div>
        //         <div class="w-100p">
        //             <p class="election-name-cls">${getOfficeTitle(election)}</p>
        //             <div class="election-date">
        //                 <div class="election-type">
        //                     <p class = "election-label-gray">Election Type</p>
        //                     <p class="text-left">${
        //                         election.election_type
        //                     }</p>
        //                 </div>
        //                 <div class="el-second-bar">
        //                     <p class = "election-label-gray show">Election Date</p>
        //                     <p class="text-left">${
        //                         election.election_date
        //                     }</p>
        //                 </div>
        //             </div>
        //         </div>
        //     </a>
        // </li>`
        document.getElementById("elections_list").innerHTML = elections_list;
    });
    console.log("all_election_dates", all_election_dates);
// document.getElementById("all_el_count").innerHTML = all_count ?? 0
// document.getElementById("all_el_count_mobile").innerHTML = "(" + [...new Set(all_election_dates)].length + ")"
// document.getElementById("federal_el_count").innerHTML = federal_count ?? 0
// document.getElementById("state_el_count").innerHTML = state_count ?? 0
// document.getElementById("local_el_count").innerHTML = local_count ?? 0
}
const $95298b233eb5daae$var$getOfficeTitle = (election)=>{
    if (election.subdistricted) // return election.office_title + (election.division? ' (' + election.division + ')': '')
    return election.office_title;
    else return election.office_title + ' <span class="r3-block r3-w-full r3-text-xs">(' + (election.district ?? "") + " " + (election.division ?? "") + ")</span>";
};
let $95298b233eb5daae$var$response_elections = [];
let $95298b233eb5daae$var$response_blank_elections = [];
/**
 * @typedef {signal?: AbortSignal} GetElectionByVotingDistrictIDsOptions
 */ /**
 *
 * @param {*} new_geo_ids
 * @param {GetElectionByVotingDistrictIDsOptions} [options]
 * @returns
 */ async function $95298b233eb5daae$var$getElectionByVotingDistrictIDs(new_geo_ids = null, options) {
    /**
     * @type {AbortSignal | undefined}
     */ let signal;
    if (options !== undefined) ({ signal: signal } = options);
    $95298b233eb5daae$var$election_data_loaded = false;
    if (new_geo_ids) $95298b233eb5daae$var$selected_geo_ids = new_geo_ids;
    console.log("geo_ids", new_geo_ids);
    const geo_ids = new_geo_ids ?? $95298b233eb5daae$var$selected_geo_ids;
    let response;
    try {
        response = await fetch(`${$95298b233eb5daae$var$apiHost}/elections?district_id=${geo_ids}&start_date=${$95298b233eb5daae$var$start_date}&end_date=${$95298b233eb5daae$var$end_date}&type=${$95298b233eb5daae$var$election_type}&require_candidates=1&include_blank=1`, {
            signal: signal
        });
    } catch (err) {
        console.warn({
            err: err
        }, "fetch election rejected");
        return;
    }
    const data = await response.json();
    if (signal && signal.aborted) {
        console.warn("aborted while interpreting response as json");
        return;
    }
    console.log(data.payload);
    $95298b233eb5daae$var$election_data_loaded = true;
    if (data.status === 200) {
        if (data.payload) {
            const totalElections = [
                ...data.payload?.elections
            ];
            $95298b233eb5daae$var$response_elections = data.payload?.elections;
            $95298b233eb5daae$var$response_blank_elections = data.payload?.blank_elections;
            if ($95298b233eb5daae$var$response_elections.length) $95298b233eb5daae$var$response_elections.forEach((election)=>{
                $95298b233eb5daae$var$response_blank_elections.findIndex((blank_election)=>blank_election.election_date == election.election_date && blank_election.government_level_id == election.government_level_id && blank_election.election_type_id == election.election_type_id) === -1 && $95298b233eb5daae$var$response_blank_elections.push({
                    id: "fake-" + election.election_id,
                    election_date: election.election_date,
                    election_name: election.government_level + " " + election.election_type + " Election",
                    election_type_id: election.election_type_id,
                    government_level: election.government_level,
                    government_level_id: election.government_level_id,
                    election_month: election.election_month,
                    election_type: election.election_type,
                    state_id: election.state_id,
                    state_name: election.state_name
                });
            });
            // let totalElections = [...data.payload, ...upperLevelElections];
            if (totalElections.length) {
                $95298b233eb5daae$var$renderElections(totalElections);
                document.getElementById("list_elections").classList.remove("no-elections");
            } else // document.getElementById("all_el_count").innerHTML = 0
            // document.getElementById("all_el_count_mobile").innerHTML = 0
            // document.getElementById("federal_el_count").innerHTML = 0
            // document.getElementById("state_el_count").innerHTML = 0
            // document.getElementById("local_el_count").innerHTML = 0
            if (!data.payload?.blank_elections.length) {
                if (window.innerWidth > 991) {
                    const year = $95298b233eb5daae$var$election_filter === "upcoming" || $95298b233eb5daae$var$election_filter === "past" ? "2025" : $95298b233eb5daae$var$election_filter;
                    document.getElementById("elections_list").innerHTML = `<div class="light-gray" style="padding:5px;font-size:16px;">This district does not have any elections in ${year}. We will add your 2026 elections as soon as they are available.<div style="margin-top:14px; text-align:center;"><img src="/img/view-next.svg" style="width:22px;margin:auto;"/></div></div>`;
                } else document.getElementById("list_elections").classList.add("no-elections");
            }
            if (data.payload?.blank_elections.length) {
                if (window.innerWidth < 991) ;
                else {
                    if (!totalElections.length) document.getElementById("elections_list").innerHTML = ``;
                    let blank_election_div = "";
                    let blank_elections_by_date = data.payload?.blank_elections || [];
                    // Sort by election_date
                    blank_elections_by_date.sort((a, b)=>new Date(a.election_date) - new Date(b.election_date));
                    // Group by election_date
                    let groupedElections = blank_elections_by_date.reduce((groups, election)=>{
                        let date = election.election_date;
                        if (!groups[date]) groups[date] = [];
                        groups[date].push(election);
                        return groups;
                    }, {});
                    console.log("groupedElections", groupedElections);
                    console.log("blank_elections", data.payload?.blank_elections);
                    Object.entries(groupedElections).forEach(([date, elections], index)=>{
                        blank_election_div += `<div class="r3-py-3"><details class="r3-group" ${index === 0 ? "open" : ""}>
                        <summary class="r3-flex r3-justify-between r3-items-center r3-font-medium r3-cursor-pointer r3-list-none">
                                ${date}
                            <span class="r3-transition group-open:r3-rotate-180">
                <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg></span></summary><div>`;
                        elections.map((blank_election, index)=>{
                            blank_election_div += `<li>
                                <a  href="#" class="ballot-row-2 election_candidate_a" data-blank="1" data-date="${blank_election.election_date ? blank_election.election_date : ""}" data-id="${blank_election.id}">
                                    <div class="img-election-type">
                                        ${$95298b233eb5daae$var$getGovernmentLevelImg("r3")}
                                    </div>
                                    <div class="w-100p">
                                        <p class="election-name-cls">${blank_election.election_name ?? "Upcoming Election"}</p>
                                        <div class="election-date">
                                            <div class="election-type">
                                                <p class = "election-label-gray">Election Type</p>
                                                <p class="text-left">${blank_election.election_type ?? "Unknown"}</p>
                                            </div>
                                            <div class="el-second-bar">
                                                <p class = "election-label-gray show">Election Date</p>
                                                <p class="text-left">${blank_election.election_date}</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>`;
                        });
                        blank_election_div += `</div></details></div>`;
                    });
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#elections_list").prepend(blank_election_div);
                }
            //
            // document.getElementById("all_el_count").innerHTML = data.payload?.blank_elections.length
            // document.getElementById("all_el_count_mobile").innerHTML = data.payload?.blank_elections.length
            }
            (0, $468000f96106f3c9$export$4fefa8b88b0d4af1)();
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#trans_screen_loading").hide();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#map .marker").removeClass("!r3-hidden");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#map .maplibregl-popup").removeClass("!r3-hidden");
}
function $95298b233eb5daae$var$initPage() {
    // Add left and bottom panels
    /// //////////////////////
    // Add ballot boxes
    /// //////////////////////
    // Initialize
    const url = new URL(window.location);
    const ballotRow = document.querySelector(".ballot-row");
    const electionsOverview = document.querySelector(".elections-overview");
    const ballotBoxes = new BallotBoxPanel(ballotRow);
    ballotBoxes.setElectionsOverviewDiv(electionsOverview);
    // Election Filter
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#election_filter_dropdown").hide();
    // Update ballot boxes
    const state = url.searchParams.get("state");
    const abbr = STATE_FIPS_BY_NAME[state].abbr;
    // const params = {
    //     state: state,
    //     abbr: abbr,
    // };
    // if(p_type === 'zip')
    // {
    //     params.zip = p_value
    // }else if(p_type === 'place')
    // {
    //     params.city = p_value;
    // }else if(p_type === 'county')
    // {
    //     params.county = p_value;
    // }else if(p_type === 'state')
    // {
    //     params.state = p_value;
    // }
    //
    // ballotBoxes.update(params);
    /// //////////////////////
    // End adding ballot boxes
    /// //////////////////////
    /// //////////////////////
    // Add bottom bar
    /// //////////////////////
    addCountyList(abbr, state, true).then(()=>{
        const urlCounty = url.searchParams.get("county");
        const buttons = document.querySelectorAll(".county_list li");
        let countyName;
        // Find the button with the correct county in its href
        const button = Array.from(buttons).find((element)=>{
            const a = element.querySelector("a");
            const href = new URL(a.href);
            const buttonCounty = href.searchParams.get("fips");
            const buttonId = element.id;
            if (buttonCounty === urlCounty || buttonId === urlCounty) countyName = buttonId;
            return buttonCounty === urlCounty || buttonId === urlCounty;
        });
        // Highlight the button
        if (!button) return;
        if (countyName) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".county-name").text(countyName + " County");
        button.classList.add("selected");
        // Scroll to the button
        const rect = button.getBoundingClientRect();
        const position = (rect.left + rect.right) / 2 - window.innerWidth / 2;
        document.querySelector(".county_list ul").scroll({
            left: position,
            behavior: "smooth"
        });
        /// //////////////////////
        // Add tutorial
        /// //////////////////////
        const help = document.querySelector(".how-it-works-mini");
        // tutorial = new OSMTutorial()
        // help.style.bottom = "-180px";
        new FooterGlue(help, window.innerWidth - 56).fixOSMPage();
        /// //////////////////////
        // End adding tutorial
        /// //////////////////////
        (0, $468000f96106f3c9$export$4fefa8b88b0d4af1)();
    });
    /// //////////////////////
    // End adding bottom bar
    /// //////////////////////
    // Set left panel text
    document.querySelector(".state_list ul li span").innerText = state;
// if (window.innerWidth <=600 ) {
//     const districtsHeight = window.innerHeight * 5 / 3 - 406
//     $('#districts_list').css({ "maxHeight": districtsHeight + 'px' })
//     const electionsHeight = window.innerHeight - 290 * 0.6 - 70
//     $('#elections_list').css({ "maxHeight": electionsHeight + 'px' })
// }
}





var $864964d0fc66cc2e$exports = {};
"use strict";
$864964d0fc66cc2e$exports = $864964d0fc66cc2e$var$UnitBezier;
function $864964d0fc66cc2e$var$UnitBezier(p1x, p1y, p2x, p2y) {
    // Calculate the polynomial coefficients, implicit first and last control points are (0,0) and (1,1).
    this.cx = 3.0 * p1x;
    this.bx = 3.0 * (p2x - p1x) - this.cx;
    this.ax = 1.0 - this.cx - this.bx;
    this.cy = 3.0 * p1y;
    this.by = 3.0 * (p2y - p1y) - this.cy;
    this.ay = 1.0 - this.cy - this.by;
    this.p1x = p1x;
    this.p1y = p1y;
    this.p2x = p2x;
    this.p2y = p2y;
}
$864964d0fc66cc2e$var$UnitBezier.prototype = {
    sampleCurveX: function(t) {
        // `ax t^3 + bx t^2 + cx t' expanded using Horner's rule.
        return ((this.ax * t + this.bx) * t + this.cx) * t;
    },
    sampleCurveY: function(t) {
        return ((this.ay * t + this.by) * t + this.cy) * t;
    },
    sampleCurveDerivativeX: function(t) {
        return (3.0 * this.ax * t + 2.0 * this.bx) * t + this.cx;
    },
    solveCurveX: function(x, epsilon) {
        if (epsilon === undefined) epsilon = 1e-6;
        if (x < 0.0) return 0.0;
        if (x > 1.0) return 1.0;
        var t = x;
        // First try a few iterations of Newton's method - normally very fast.
        for(var i = 0; i < 8; i++){
            var x2 = this.sampleCurveX(t) - x;
            if (Math.abs(x2) < epsilon) return t;
            var d2 = this.sampleCurveDerivativeX(t);
            if (Math.abs(d2) < 1e-6) break;
            t = t - x2 / d2;
        }
        // Fall back to the bisection method for reliability.
        var t0 = 0.0;
        var t1 = 1.0;
        t = x;
        for(i = 0; i < 20; i++){
            x2 = this.sampleCurveX(t);
            if (Math.abs(x2 - x) < epsilon) break;
            if (x > x2) t0 = t;
            else t1 = t;
            t = (t1 - t0) * 0.5 + t0;
        }
        return t;
    },
    solve: function(x, epsilon) {
        return this.sampleCurveY(this.solveCurveX(x, epsilon));
    }
};


function $895133474e42d10c$export$76084b6169b84edf(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    const t2 = t * t, t3 = t2 * t;
    return 4 * (t < 0.5 ? t3 : 3 * (t - t2) + t3 - 0.75);
}
function $895133474e42d10c$export$b9c5f84610baddaf(p1x, p1y, p2x, p2y) {
    const bezier = new (0, (/*@__PURE__*/$parcel$interopDefault($864964d0fc66cc2e$exports)))(p1x, p1y, p2x, p2y);
    return function(t) {
        return bezier.solve(t);
    };
}
const $895133474e42d10c$export$b0f87bb1f6530fd8 = $895133474e42d10c$export$b9c5f84610baddaf(0.25, 0.1, 0.25, 1);
function $895133474e42d10c$export$7d15b64cf5a3a4c4(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
function $895133474e42d10c$export$4997ffc0176396a6(n, min, max) {
    const d = max - min;
    const w = ((n - min) % d + d) % d + min;
    return w === min ? max : w;
}
function $895133474e42d10c$export$15567f2991715e71(array, fn, callback) {
    if (!array.length) return callback(null, []);
    let remaining = array.length;
    const results = new Array(array.length);
    let error = null;
    array.forEach((item, i)=>{
        fn(item, (err, result)=>{
            if (err) error = err;
            results[i] = result; // https://github.com/facebook/flow/issues/2123
            if (--remaining === 0) callback(error, results);
        });
    });
}
function $895133474e42d10c$export$ff9f646618a882b2(obj, other) {
    const difference = [];
    for(const i in obj)if (!(i in other)) difference.push(i);
    return difference;
}
function $895133474e42d10c$export$8b58be045bf06082(dest, ...sources) {
    for (const src of sources)for(const k in src)dest[k] = src[k];
    return dest;
}
function $895133474e42d10c$export$357523c63a2253b9(src, properties) {
    const result = {};
    for(let i = 0; i < properties.length; i++){
        const k = properties[i];
        if (k in src) result[k] = src[k];
    }
    return result;
}
let $895133474e42d10c$var$id = 1;
function $895133474e42d10c$export$8b15d37bc3f197d4() {
    return $895133474e42d10c$var$id++;
}
function $895133474e42d10c$export$b9e43d1765415474(value) {
    return Math.log(value) / Math.LN2 % 1 === 0;
}
function $895133474e42d10c$export$239a7ba740cbf2bf(value) {
    if (value <= 1) return 1;
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $895133474e42d10c$export$c2f8db24c062c209(fns, context) {
    fns.forEach((fn)=>{
        if (!context[fn]) return;
        context[fn] = context[fn].bind(context);
    });
}
function $895133474e42d10c$export$d6051a0f7a227332(input, iterator, context) {
    const output = {};
    for(const key in input)output[key] = iterator.call(context || this, input[key], key, input);
    return output;
}
function $895133474e42d10c$export$1039dc7987464938(input, iterator, context) {
    const output = {};
    for(const key in input)if (iterator.call(context || this, input[key], key, input)) output[key] = input[key];
    return output;
}
function $895133474e42d10c$export$9cb4719e2e525b7a(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$895133474e42d10c$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    }
    if (typeof a === "object" && a !== null && b !== null) {
        if (!(typeof b === "object")) return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) return false;
        for(const key in a){
            if (!$895133474e42d10c$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return a === b;
}
function $895133474e42d10c$export$9cd59f9826255e47(input) {
    if (Array.isArray(input)) return input.map($895133474e42d10c$export$9cd59f9826255e47);
    else if (typeof input === "object" && input) return $895133474e42d10c$export$d6051a0f7a227332(input, $895133474e42d10c$export$9cd59f9826255e47);
    else return input;
}
function $895133474e42d10c$export$838fc23161230236(a, b) {
    for(let l = 0; l < a.length; l++){
        if (b.indexOf(a[l]) >= 0) return true;
    }
    return false;
}
/**
 * Print a warning message to the console and ensure duplicate warning messages
 * are not printed.
 *
 * @private
 */ const $895133474e42d10c$var$warnOnceHistory = {};
function $895133474e42d10c$export$5b28268982f175ba(message) {
    if (!$895133474e42d10c$var$warnOnceHistory[message]) {
        // console isn't defined in some WebWorkers, see #2558
        if (typeof console !== "undefined") console.warn(message);
        $895133474e42d10c$var$warnOnceHistory[message] = true;
    }
}
function $895133474e42d10c$export$619503be6eb7db03(a, b, c) {
    return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
}
function $895133474e42d10c$export$7dc603e29092a528(a1, a2, b1, b2) {
    const aDeltaY = a2.y - a1.y;
    const aDeltaX = a2.x - a1.x;
    const bDeltaY = b2.y - b1.y;
    const bDeltaX = b2.x - b1.x;
    const denominator = bDeltaY * aDeltaX - bDeltaX * aDeltaY;
    if (denominator === 0) // Lines are parallel
    return null;
    const originDeltaY = a1.y - b1.y;
    const originDeltaX = a1.x - b1.x;
    const aInterpolation = (bDeltaX * originDeltaY - bDeltaY * originDeltaX) / denominator;
    // Find intersection by projecting out from origin of first segment
    return new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))(a1.x + aInterpolation * aDeltaX, a1.y + aInterpolation * aDeltaY);
}
function $895133474e42d10c$export$54b74d0655a76592(ring) {
    let sum = 0;
    for(let i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++){
        p1 = ring[i];
        p2 = ring[j];
        sum += (p2.x - p1.x) * (p1.y + p2.y);
    }
    return sum;
}
function $895133474e42d10c$export$ebfacc30370dba57(points) {
    // If it is 2 points that are the same then it is a point
    // If it is 3 points with start and end the same then it is a line
    if (points.length < 4) return false;
    const p1 = points[0];
    const p2 = points[points.length - 1];
    if (Math.abs(p1.x - p2.x) > 0 || Math.abs(p1.y - p2.y) > 0) return false;
    // polygon simplification can produce polygons with zero area and more than 3 points
    return Math.abs($895133474e42d10c$export$54b74d0655a76592(points)) > 0.01;
}
function $895133474e42d10c$export$250b4d16a1daece5([r, azimuthal, polar]) {
    // We abstract "north"/"up" (compass-wise) to be 0° when really this is 90° (π/2):
    // correct for that here
    azimuthal += 90;
    // Convert azimuthal and polar angles to radians
    azimuthal *= Math.PI / 180;
    polar *= Math.PI / 180;
    return {
        x: r * Math.cos(azimuthal) * Math.sin(polar),
        y: r * Math.sin(azimuthal) * Math.sin(polar),
        z: r * Math.cos(polar)
    };
}
function $895133474e42d10c$export$3c901a5f01941a06() {
    // @ts-ignore
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
function $895133474e42d10c$export$f1cde52d31bc1bcb(cacheControl) {
    // Taken from [Wreck](https://github.com/hapijs/wreck)
    const re = /(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g;
    const header = {};
    cacheControl.replace(re, ($0, $1, $2, $3)=>{
        const value = $2 || $3;
        header[$1] = value ? value.toLowerCase() : true;
        return "";
    });
    if (header["max-age"]) {
        const maxAge = parseInt(header["max-age"], 10);
        if (isNaN(maxAge)) delete header["max-age"];
        else header["max-age"] = maxAge;
    }
    return header;
}
let $895133474e42d10c$var$_isSafari = null;
function $895133474e42d10c$export$95df08bae54cb4df(scope) {
    if ($895133474e42d10c$var$_isSafari == null) {
        const userAgent = scope.navigator ? scope.navigator.userAgent : null;
        $895133474e42d10c$var$_isSafari = !!scope.safari || !!(userAgent && (/\b(iPad|iPhone|iPod)\b/.test(userAgent) || !!userAgent.match("Safari") && !userAgent.match("Chrome")));
    }
    return $895133474e42d10c$var$_isSafari;
}
function $895133474e42d10c$export$3f1985e3ee38d114(type) {
    try {
        const storage = window[type];
        storage.setItem("_mapbox_test_", 1);
        storage.removeItem("_mapbox_test_");
        return true;
    } catch (e) {
        return false;
    }
}
function $895133474e42d10c$export$38098dc5f10fc10c(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1)=>{
        return String.fromCharCode(Number("0x" + p1)); //eslint-disable-line
    }));
}
function $895133474e42d10c$export$87a6309fb3fed996(str) {
    return decodeURIComponent(atob(str).split("").map((c)=>{
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2); //eslint-disable-line
    }).join(""));
}
function $895133474e42d10c$export$4c394cd787f4a4b7(image) {
    return typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap;
}
function $895133474e42d10c$export$f5cf024a3818bd4b(data, callback) {
    const blob = new Blob([
        new Uint8Array(data)
    ], {
        type: "image/png"
    });
    createImageBitmap(blob).then((imgBitmap)=>{
        callback(null, imgBitmap);
    }).catch((e)=>{
        callback(new Error(`Could not load image because of ${e.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
    });
}
const $895133474e42d10c$var$transparentPngUrl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
function $895133474e42d10c$export$c61d81e523255ea9(data, callback) {
    const img = new Image();
    img.onload = ()=>{
        callback(null, img);
        URL.revokeObjectURL(img.src);
        // prevent image dataURI memory leak in Safari;
        // but don't free the image immediately because it might be uploaded in the next frame
        // https://github.com/mapbox/mapbox-gl-js/issues/10226
        img.onload = null;
        window.requestAnimationFrame(()=>{
            img.src = $895133474e42d10c$var$transparentPngUrl;
        });
    };
    img.onerror = ()=>callback(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
    const blob = new Blob([
        new Uint8Array(data)
    ], {
        type: "image/png"
    });
    img.src = data.byteLength ? URL.createObjectURL(blob) : $895133474e42d10c$var$transparentPngUrl;
}


function $a5683043349b8d65$var$_addEventListener(type, listener, listenerList) {
    const listenerExists = listenerList[type] && listenerList[type].indexOf(listener) !== -1;
    if (!listenerExists) {
        listenerList[type] = listenerList[type] || [];
        listenerList[type].push(listener);
    }
}
function $a5683043349b8d65$var$_removeEventListener(type, listener, listenerList) {
    if (listenerList && listenerList[type]) {
        const index = listenerList[type].indexOf(listener);
        if (index !== -1) listenerList[type].splice(index, 1);
    }
}
class $a5683043349b8d65$export$d61e24a684f9e51 {
    constructor(type, data = {}){
        (0, $895133474e42d10c$export$8b58be045bf06082)(this, data);
        this.type = type;
    }
}
class $a5683043349b8d65$export$4c6f5e6e10fb9fd0 extends $a5683043349b8d65$export$d61e24a684f9e51 {
    constructor(error, data = {}){
        super("error", (0, $895133474e42d10c$export$8b58be045bf06082)({
            error: error
        }, data));
    }
}
class $a5683043349b8d65$export$ebcc362d8f4c4311 {
    /**
     * Adds a listener to a specified event type.
     *
     * @param {string} type The event type to add a listen for.
     * @param {Function} listener The function to be called when the event is fired.
     * The listener function is called with the data object passed to `fire`,
     * extended with `target` and `type` properties.
     * @returns {Object} `this`
     */ on(type, listener) {
        this._listeners = this._listeners || {};
        $a5683043349b8d65$var$_addEventListener(type, listener, this._listeners);
        return this;
    }
    /**
     * Removes a previously registered event listener.
     *
     * @param {string} type The event type to remove listeners for.
     * @param {Function} listener The listener function to remove.
     * @returns {Object} `this`
     */ off(type, listener) {
        $a5683043349b8d65$var$_removeEventListener(type, listener, this._listeners);
        $a5683043349b8d65$var$_removeEventListener(type, listener, this._oneTimeListeners);
        return this;
    }
    /**
     * Adds a listener that will be called only once to a specified event type.
     *
     * The listener will be called first time the event fires after the listener is registered.
     *
     * @param {string} type The event type to listen for.
     * @param {Function} listener The function to be called when the event is fired the first time.
     * @returns {Object} `this` or a promise if a listener is not provided
     */ once(type, listener) {
        if (!listener) return new Promise((resolve)=>this.once(type, resolve));
        this._oneTimeListeners = this._oneTimeListeners || {};
        $a5683043349b8d65$var$_addEventListener(type, listener, this._oneTimeListeners);
        return this;
    }
    fire(event, properties) {
        // Compatibility with (type: string, properties: Object) signature from previous versions.
        // See https://github.com/mapbox/mapbox-gl-js/issues/6522,
        //     https://github.com/mapbox/mapbox-gl-draw/issues/766
        if (typeof event === "string") event = new $a5683043349b8d65$export$d61e24a684f9e51(event, properties || {});
        const type = event.type;
        if (this.listens(type)) {
            event.target = this;
            // make sure adding or removing listeners inside other listeners won't cause an infinite loop
            const listeners = this._listeners && this._listeners[type] ? this._listeners[type].slice() : [];
            for (const listener of listeners)listener.call(this, event);
            const oneTimeListeners = this._oneTimeListeners && this._oneTimeListeners[type] ? this._oneTimeListeners[type].slice() : [];
            for (const listener of oneTimeListeners){
                $a5683043349b8d65$var$_removeEventListener(type, listener, this._oneTimeListeners);
                listener.call(this, event);
            }
            const parent = this._eventedParent;
            if (parent) {
                (0, $895133474e42d10c$export$8b58be045bf06082)(event, typeof this._eventedParentData === "function" ? this._eventedParentData() : this._eventedParentData);
                parent.fire(event);
            }
        // To ensure that no error events are dropped, print them to the
        // console if they have no listeners.
        } else if (event instanceof $a5683043349b8d65$export$4c6f5e6e10fb9fd0) console.error(event.error);
        return this;
    }
    /**
     * Returns a true if this instance of Evented or any forwardeed instances of Evented have a listener for the specified type.
     *
     * @param {string} type The event type
     * @returns {boolean} `true` if there is at least one registered listener for specified event type, `false` otherwise
     * @private
     */ listens(type) {
        return this._listeners && this._listeners[type] && this._listeners[type].length > 0 || this._oneTimeListeners && this._oneTimeListeners[type] && this._oneTimeListeners[type].length > 0 || this._eventedParent && this._eventedParent.listens(type);
    }
    /**
     * Bubble all events fired by this instance of Evented to this parent instance of Evented.
     *
     * @private
     * @returns {Object} `this`
     * @private
     */ setEventedParent(parent, data) {
        this._eventedParent = parent;
        this._eventedParentData = data;
        return this;
    }
}



function $fdb1b306f96b8b4f$var$mercatorXfromLng(lng) {
    return (180 + lng) / 360;
}
function $fdb1b306f96b8b4f$var$mercatorYfromLat(lat) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
}
/**
 * constrain n to the given range, excluding the minimum, via modular arithmetic
 *
 * @param n value
 * @param min the minimum value to be returned, exclusive
 * @param max the maximum value to be returned, inclusive
 * @returns constrained number
 * @private
 */ function $fdb1b306f96b8b4f$var$wrap(n, min, max) {
    const d = max - min;
    const w = ((n - min) % d + d) % d + min;
    return w === min ? max : w;
}
/**
 * Interprets if the user is trying to "stubbornly" return to the globe by zooming out
 */ class $fdb1b306f96b8b4f$var$StubbornZoomHandler extends EventTarget {
    #onZoomCount;
    #onZoomStartCount;
    constructor(){
        super();
        this.#onZoomCount = 0;
        this.#onZoomStartCount = 0;
    }
    onZoom() {
        this.#onZoomCount++;
        if (this.shouldStubbornZoom()) this.doStubbornZoom();
    }
    onZoomStart() {
        this.#onZoomStartCount++;
        if (this.shouldStubbornZoom()) this.doStubbornZoom();
    }
    shouldStubbornZoom() {
        return this.#onZoomCount > 50 && this.#onZoomStartCount >= 2 || this.#onZoomCount > 1000;
    }
    doStubbornZoom() {
        this.dispatchEvent(new CustomEvent("stubbornzoom", {
            detail: null
        }));
        this.reset();
    }
    reset() {
        this.#onZoomCount = 0;
        this.#onZoomStartCount = 0;
    }
}
class $fdb1b306f96b8b4f$export$a5c7b93649eaf8f8 extends (0, $30510d2f060a5cf8$exports.Map) {
    #listeners;
    constructor(options){
        super(options);
        this.#listeners = [];
        this.stubbornZoomHandler = new $fdb1b306f96b8b4f$var$StubbornZoomHandler();
        this.stubbornZoomHandler.addEventListener("stubbornzoom", (event)=>{
            this.fire(new (0, $a5683043349b8d65$export$d61e24a684f9e51)("stubbornzoom"));
        });
        this.on("zoom", (event)=>{
            if (event.cause !== undefined) return;
            if (!this.atMaxBounds()) return;
            this.stubbornZoomHandler.onZoom();
        });
        this.on("zoomstart", (event)=>{
            if (event.cause !== undefined) return;
            if (!this.atMaxBounds()) return;
            this.stubbornZoomHandler.onZoomStart();
        });
    }
    trackedOn(type, layer, listener) {
        super.on(type, layer, listener);
        this.#listeners.push([
            type,
            layer,
            listener
        ]);
    }
    trackedOff(type, layer, listener) {
        super.off(type, layer, listener);
        // Remove just the entry where all the parameters match
        this.#listeners = this.#listeners.filter(([t, lay, lis])=>!(t === type && lay === layer && lis === listener));
    }
    atMaxBounds() {
        const viewport = (0, $3e645b0309771ac1$export$c02eeb5f98d59b89)();
        const viewportHeight = viewport.bottom - viewport.top;
        const viewportWidth = viewport.right - viewport.left;
        const latRange = this.transform.latRange;
        const lngRange = this.transform.lngRange;
        if (latRange === null || lngRange === null) return false;
        const minY = $fdb1b306f96b8b4f$var$mercatorYfromLat(latRange[1]) * this.transform.worldSize;
        const maxY = $fdb1b306f96b8b4f$var$mercatorYfromLat(latRange[0]) * this.transform.worldSize;
        const minX = $fdb1b306f96b8b4f$var$wrap($fdb1b306f96b8b4f$var$mercatorXfromLng(lngRange[0]) * this.transform.worldSize, 0, this.transform.worldSize);
        let maxX = $fdb1b306f96b8b4f$var$wrap($fdb1b306f96b8b4f$var$mercatorXfromLng(lngRange[1]) * this.transform.worldSize, 0, this.transform.worldSize);
        if (maxX < minX) maxX += this.transform.worldSize;
        const atLngBound = viewportWidth >= maxX - minX - 0.1;
        const atLatBound = viewportHeight >= maxY - minY - 0.1;
        return atLngBound && atLatBound;
    }
    /**
     * Remove all user-added event listeners
     */ offAll() {
        this.#listeners.forEach((entry)=>{
            super.off(...entry);
            console.log("removed event listener", entry);
        });
        this.#listeners = [];
    }
}



var $iUSsr = parcelRequire("iUSsr");
class $936fb2977bd9e74f$export$80f8a8bc75250cf0 {
    /**
     * 
     * @param {Boolean} visible 
     */ constructor(visible){
        this.visible = visible;
        // Instantiate the main walkthrough HTMLParagraphElement
        this.element = document.createElement("p");
        this.element.classList.add("walkthrough-speech-bubble");
        if (!visible) this.element.classList.add("hidden");
        // Setup callback to fade in additional text after speech bubble pop in is finished.
        // Workaround for drop shadow flicker when animations on multiple nested elements coincide.
        this.element.addEventListener("animationend", (event)=>{
            if (event.animationName === "pop-in") this.fadeInSpans();
        });
    }
    setText(text) {
        this.element.textContent = text;
    }
    setInnerHTML(html) {
        this.element.innerHTML = html;
    }
    setChildren(element) {
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        this.element.appendChild(element);
    }
    popIn() {
        this.visible = true;
        this.element.classList.remove("hidden");
        this.element.classList.remove("pop-out");
        this.element.classList.add("pop-in");
    }
    popOut() {
        this.visible = false;
        // Fade out the bubble itself
        this.element.classList.remove("pop-in");
        this.element.classList.add("pop-out");
        // Clean up the fade-in class we added
        this.element.querySelectorAll("span").forEach((element)=>{
            element.classList.remove("fade-in");
        });
    }
    /**
     * Trigger all spans to fade in
     */ fadeInSpans() {
        this.element.querySelectorAll("span").forEach((element)=>{
            element.classList.add("fade-in");
        });
    }
    isVisible() {
        return this.visible;
    }
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $6412c8f28830752c$export$18ce0697a983be9b = function() {
    $6412c8f28830752c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6412c8f28830752c$export$18ce0697a983be9b.apply(this, arguments);
};
function $6412c8f28830752c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6412c8f28830752c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6412c8f28830752c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6412c8f28830752c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}



var $a25360e382d35ff4$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($a25360e382d35ff4$export$1385d81a6c6bbcd4 || ($a25360e382d35ff4$export$1385d81a6c6bbcd4 = {}));
var $a25360e382d35ff4$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($a25360e382d35ff4$export$79f5baa747fbdd45 || ($a25360e382d35ff4$export$79f5baa747fbdd45 = {}));



var $2f911635cac44292$export$b3571188c770cc5a = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Start;
var $2f911635cac44292$export$fa6813432f753b0d = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Stop;
var $2f911635cac44292$export$66313c302b2ea154 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Raise;
var $2f911635cac44292$export$89db4734f6c919c4 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Send;
var $2f911635cac44292$export$70b61ad426ddbe54 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Cancel;
var $2f911635cac44292$export$9477ceca5dcd796a = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).NullEvent;
var $2f911635cac44292$export$e6e34fd1f2686227 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Assign;
var $2f911635cac44292$export$742acabee3dd6465 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).After;
var $2f911635cac44292$export$de2557b5933c9ac6 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).DoneState;
var $2f911635cac44292$export$bef1f36f5486a6a3 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Log;
var $2f911635cac44292$export$2cd8252107eb640b = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Init;
var $2f911635cac44292$export$468cda29b159ee5d = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Invoke;
var $2f911635cac44292$export$aca059ee6fbf94e8 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).ErrorExecution;
var $2f911635cac44292$export$503a23d0e5cd1226 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).ErrorPlatform;
var $2f911635cac44292$export$a3bc9b8ed74fc = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).ErrorCustom;
var $2f911635cac44292$export$722fbec263ad908a = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Update;
var $2f911635cac44292$export$7877a478dd30fd3d = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Choose;
var $2f911635cac44292$export$48ec4a2b1cfc6557 = (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Pure;


var $d6847f857d89b9db$export$b060f3cec92ef5c9 = ".";
var $d6847f857d89b9db$export$505a390a702f4a23 = {};
var $d6847f857d89b9db$export$656461011b562379 = "xstate.guard";
var $d6847f857d89b9db$export$31935b4577455331 = "";


var $57d670cc9d015c76$export$9b5f2e1c20ef6571 = true;


var $f3de07296b675fa8$var$_a;
function $f3de07296b675fa8$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $f3de07296b675fa8$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $d6847f857d89b9db$export$b060f3cec92ef5c9);
    var parentStateValue = $f3de07296b675fa8$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $f3de07296b675fa8$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($f3de07296b675fa8$export$844ec244b1367d54(childStateValue)) {
        if ($f3de07296b675fa8$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($f3de07296b675fa8$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $f3de07296b675fa8$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $f3de07296b675fa8$export$7193fc8c8cd445e9(event) {
    try {
        return $f3de07296b675fa8$export$844ec244b1367d54(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function $f3de07296b675fa8$export$e303144c5506946a(action) {
    try {
        return $f3de07296b675fa8$export$844ec244b1367d54(action) || typeof action === "number" ? "".concat(action) : $f3de07296b675fa8$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function $f3de07296b675fa8$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($f3de07296b675fa8$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $f3de07296b675fa8$export$e080e3931a079c9b(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function $f3de07296b675fa8$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($f3de07296b675fa8$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($f3de07296b675fa8$export$43bee75e5e14138e(stateValue)) return $f3de07296b675fa8$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = $f3de07296b675fa8$export$304cde62ecda7af8(stateValue, delimiter);
    return $f3de07296b675fa8$export$f2ee84fc53c45e74(statePath);
}
function $f3de07296b675fa8$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $f3de07296b675fa8$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $f3de07296b675fa8$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $f3de07296b675fa8$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $f3de07296b675fa8$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $f3de07296b675fa8$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($f3de07296b675fa8$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $f3de07296b675fa8$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $f3de07296b675fa8$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $f3de07296b675fa8$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $f3de07296b675fa8$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(array), false));
}
function $f3de07296b675fa8$export$2c0b6b2f4faf21e1(value) {
    if ($f3de07296b675fa8$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $f3de07296b675fa8$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $f3de07296b675fa8$export$2c0b6b2f4faf21e1(value);
}
function $f3de07296b675fa8$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($f3de07296b675fa8$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($f3de07296b675fa8$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $f3de07296b675fa8$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $f3de07296b675fa8$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($f3de07296b675fa8$export$f6e2535fb5126e54(value) || typeof value === "object") && $f3de07296b675fa8$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $f3de07296b675fa8$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function $f3de07296b675fa8$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $6412c8f28830752c$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $f3de07296b675fa8$export$3737909a0074eb1(hist, stateValue) {
    return $f3de07296b675fa8$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($f3de07296b675fa8$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $f3de07296b675fa8$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $f3de07296b675fa8$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $f3de07296b675fa8$export$3737909a0074eb1(hist, stateValue)
    };
}
function $f3de07296b675fa8$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) $f3de07296b675fa8$export$c106dd0671a0fc2d(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($f3de07296b675fa8$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $f3de07296b675fa8$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $f3de07296b675fa8$export$c106dd0671a0fc2d = function() {};
if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) $f3de07296b675fa8$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $f3de07296b675fa8$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $f3de07296b675fa8$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $f3de07296b675fa8$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $f3de07296b675fa8$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($f3de07296b675fa8$export$844ec244b1367d54(condition)) return {
        type: (0, $d6847f857d89b9db$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($f3de07296b675fa8$export$f6e2535fb5126e54(condition)) return {
        type: (0, $d6847f857d89b9db$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $f3de07296b675fa8$export$5cd057a6046189f9(value) {
    try {
        return "subscribe" in value && $f3de07296b675fa8$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $f3de07296b675fa8$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $f3de07296b675fa8$export$a6273dafbee7f61e = ($f3de07296b675fa8$var$_a = {}, $f3de07296b675fa8$var$_a[$f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
    return this;
}, $f3de07296b675fa8$var$_a[Symbol.observable] = function() {
    return this;
}, $f3de07296b675fa8$var$_a);
function $f3de07296b675fa8$export$2163e7903738b5df(value) {
    return !!value && "__xstatenode" in value;
}
function $f3de07296b675fa8$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === "function";
}
var $f3de07296b675fa8$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $f3de07296b675fa8$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($f3de07296b675fa8$export$844ec244b1367d54(event) || typeof event === "number") return (0, $6412c8f28830752c$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $f3de07296b675fa8$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$f3de07296b675fa8$export$844ec244b1367d54(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = $f3de07296b675fa8$export$5a4ea50826a01d14(event);
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function $f3de07296b675fa8$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $f3de07296b675fa8$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || $f3de07296b675fa8$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $f3de07296b675fa8$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $d6847f857d89b9db$export$31935b4577455331)) return undefined;
    return $f3de07296b675fa8$export$45b10814cc054894(target);
}
function $f3de07296b675fa8$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $f3de07296b675fa8$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $d6847f857d89b9db$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $f3de07296b675fa8$export$436e852aa2feda95(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function $f3de07296b675fa8$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $f3de07296b675fa8$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $f3de07296b675fa8$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $2f911635cac44292$export$66313c302b2ea154) || action.type === (0, $2f911635cac44292$export$89db4734f6c919c4) && action.to === (0, $a25360e382d35ff4$export$79f5baa747fbdd45).Internal) && typeof action.delay !== "number";
}







var $bd97a8330b060e00$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === "atomic" || stateNode.type === "final";
};
function $bd97a8330b060e00$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $bd97a8330b060e00$export$f8cf48ee793b41be(stateNode) {
    return $bd97a8330b060e00$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== "history";
    });
}
function $bd97a8330b060e00$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($bd97a8330b060e00$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $f3de07296b675fa8$export$bffa455ba8c619a6)($bd97a8330b060e00$export$f8cf48ee793b41be(stateNode).map($bd97a8330b060e00$export$3de19bba299e3801)));
}
function $bd97a8330b060e00$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $bd97a8330b060e00$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $bd97a8330b060e00$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === "compound" && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === "parallel") try {
                    for(var _e = (e_3 = void 0, (0, $6412c8f28830752c$export$19a8beecd37a4c45)($bd97a8330b060e00$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $bd97a8330b060e00$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === "compound") {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($bd97a8330b060e00$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $bd97a8330b060e00$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $bd97a8330b060e00$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $bd97a8330b060e00$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $bd97a8330b060e00$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $bd97a8330b060e00$var$getValueFromAdj(rootNode, $bd97a8330b060e00$export$b837d8c2d0189d63(config));
}
function $bd97a8330b060e00$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $bd97a8330b060e00$export$c661ab6895e3ed73(configuration) {
    return (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(new Set((0, $f3de07296b675fa8$export$bffa455ba8c619a6)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $bd97a8330b060e00$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === "compound") return $bd97a8330b060e00$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === "final" && $bd97a8330b060e00$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === "parallel") return $bd97a8330b060e00$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $bd97a8330b060e00$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $bd97a8330b060e00$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $bd97a8330b060e00$export$5301196121335ca0(configuration) {
    return new Set((0, $f3de07296b675fa8$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}







var $86d294a5ef9fa172$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $f3de07296b675fa8$export$eaf22249b410f633)({
    type: (0, $2f911635cac44292$export$2cd8252107eb640b)
});
function $86d294a5ef9fa172$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $86d294a5ef9fa172$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(action) || typeof action === "number") {
        var exec = $86d294a5ef9fa172$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $86d294a5ef9fa172$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(exec)) actionObject = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $86d294a5ef9fa172$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $f3de07296b675fa8$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $86d294a5ef9fa172$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $86d294a5ef9fa172$export$e81fdd8937d44864(action) {
    var actionObject = $86d294a5ef9fa172$export$b38b66cc2da3ede7(action);
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({
        id: (0, $f3de07296b675fa8$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $86d294a5ef9fa172$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $2f911635cac44292$export$66313c302b2ea154),
        event: typeof event === "function" ? event : (0, $f3de07296b675fa8$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $86d294a5ef9fa172$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $f3de07296b675fa8$export$eaf22249b410f633)((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, action), {
        type: (0, $2f911635cac44292$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $86d294a5ef9fa172$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $2f911635cac44292$export$89db4734f6c919c4),
        event: (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(event) ? event : (0, $f3de07296b675fa8$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(event) ? event.name : (0, $f3de07296b675fa8$export$7193fc8c8cd445e9)(event)
    };
}
function $86d294a5ef9fa172$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $f3de07296b675fa8$export$eaf22249b410f633)((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $86d294a5ef9fa172$export$408d8d51fa351f53(event, options) {
    return $86d294a5ef9fa172$export$89db4734f6c919c4(event, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, options), {
        to: (0, $a25360e382d35ff4$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $86d294a5ef9fa172$export$daa976aaff721e41(actor, event, options) {
    return $86d294a5ef9fa172$export$89db4734f6c919c4(event, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $86d294a5ef9fa172$export$7f8b724299523eb6() {
    return $86d294a5ef9fa172$export$408d8d51fa351f53((0, $2f911635cac44292$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $86d294a5ef9fa172$export$72b816ae90496f19(event, options) {
    return $86d294a5ef9fa172$export$89db4734f6c919c4(event, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $86d294a5ef9fa172$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $86d294a5ef9fa172$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $86d294a5ef9fa172$var$defaultLogExpr;
    return {
        type: (0, $2f911635cac44292$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $86d294a5ef9fa172$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, action), {
        value: (0, $f3de07296b675fa8$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $86d294a5ef9fa172$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $2f911635cac44292$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $86d294a5ef9fa172$export$b3571188c770cc5a(activity) {
    var activityDef = $86d294a5ef9fa172$export$e81fdd8937d44864(activity);
    return {
        type: (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $86d294a5ef9fa172$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(actorRef) ? actorRef : $86d294a5ef9fa172$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $86d294a5ef9fa172$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $86d294a5ef9fa172$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $2f911635cac44292$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $86d294a5ef9fa172$export$6e816592f80fc079(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $86d294a5ef9fa172$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat((0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $86d294a5ef9fa172$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $86d294a5ef9fa172$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $86d294a5ef9fa172$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $86d294a5ef9fa172$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $86d294a5ef9fa172$export$eb147b7589db8e8a(target, options) {
    if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571) && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $86d294a5ef9fa172$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $86d294a5ef9fa172$export$f514678a4137c4d6(errorData, options) {
    return $86d294a5ef9fa172$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $2f911635cac44292$export$a3bc9b8ed74fc),
            data: (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, options), {
        to: (0, $a25360e382d35ff4$export$79f5baa747fbdd45).Parent
    }));
}
function $86d294a5ef9fa172$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $86d294a5ef9fa172$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $2f911635cac44292$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $86d294a5ef9fa172$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $86d294a5ef9fa172$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $f3de07296b675fa8$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $2f911635cac44292$export$66313c302b2ea154:
                var raisedAction = $86d294a5ef9fa172$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $2f911635cac44292$export$89db4734f6c919c4:
                var sendAction = $86d294a5ef9fa172$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!(0, $f3de07296b675fa8$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $a25360e382d35ff4$export$79f5baa747fbdd45).Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $2f911635cac44292$export$bef1f36f5486a6a3:
                var resolved = $86d294a5ef9fa172$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $2f911635cac44292$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $f3de07296b675fa8$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $f3de07296b675fa8$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $6412c8f28830752c$export$8d051b38c9118094)($86d294a5ef9fa172$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $86d294a5ef9fa172$export$aa68691f32e6c459((0, $f3de07296b675fa8$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $2f911635cac44292$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $6412c8f28830752c$export$8d051b38c9118094)($86d294a5ef9fa172$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $86d294a5ef9fa172$export$aa68691f32e6c459((0, $f3de07296b675fa8$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $2f911635cac44292$export$fa6813432f753b0d:
                var resolved = $86d294a5ef9fa172$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $2f911635cac44292$export$e6e34fd1f2686227:
                updatedContext = (0, $f3de07296b675fa8$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $86d294a5ef9fa172$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $6412c8f28830752c$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $6412c8f28830752c$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $0acde92687924d50$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(a) || (0, $f3de07296b675fa8$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $0acde92687924d50$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $0acde92687924d50$export$4c86eb6450eda77a(state) {
    if (typeof state !== "object" || state === null) return false;
    return "value" in state && "_event" in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $0acde92687924d50$export$e5d60a6bbabd36f = $0acde92687924d50$export$4c86eb6450eda77a;
function $0acde92687924d50$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $0acde92687924d50$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $d6847f857d89b9db$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $d6847f857d89b9db$export$505a390a702f4a23);
        this.meta = (0, $bd97a8330b060e00$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, "nextEvents", {
            get: function() {
                return (0, $bd97a8330b060e00$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $86d294a5ef9fa172$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $86d294a5ef9fa172$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = ".";
        if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $6412c8f28830752c$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $f3de07296b675fa8$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $57d670cc9d015c76$export$9b5f2e1c20ef6571) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();









/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $6c037fe9ada47c96$var$serviceStack = [];
var $6c037fe9ada47c96$export$abe1e183e22e10ad = function(service, fn) {
    $6c037fe9ada47c96$var$serviceStack.push(service);
    var result = fn(service);
    $6c037fe9ada47c96$var$serviceStack.pop();
    return result;
};
var $6c037fe9ada47c96$export$e11e6a155c5c4d9d = function(fn) {
    return fn($6c037fe9ada47c96$var$serviceStack[$6c037fe9ada47c96$var$serviceStack.length - 1]);
};


function $32a234c9e2e44def$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $32a234c9e2e44def$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $f3de07296b675fa8$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $f3de07296b675fa8$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $32a234c9e2e44def$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $32a234c9e2e44def$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $32a234c9e2e44def$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $32a234c9e2e44def$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $f3de07296b675fa8$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $6c037fe9ada47c96$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $32a234c9e2e44def$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === "function";
    } catch (e) {
        return false;
    }
}
function $32a234c9e2e44def$export$b0f989039dc164f9(item) {
    return $32a234c9e2e44def$export$e769f6913f14f1b7(item) && "id" in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $32a234c9e2e44def$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: "anonymous",
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}







function $28974de1e54bc944$export$436e852aa2feda95(src) {
    if (typeof src === "string") {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $28974de1e54bc944$export$4c73f685ba879446(invokeConfig) {
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({
        type: (0, $2f911635cac44292$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $6412c8f28830752c$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $2f911635cac44292$export$468cda29b159ee5d),
                src: $28974de1e54bc944$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $ebf7bf4165262fa0$var$NULL_EVENT = "";
var $ebf7bf4165262fa0$var$STATE_IDENTIFIER = "#";
var $ebf7bf4165262fa0$var$WILDCARD = "*";
var $ebf7bf4165262fa0$var$EMPTY_OBJECT = {};
var $ebf7bf4165262fa0$var$isStateId = function(str) {
    return str[0] === $ebf7bf4165262fa0$var$STATE_IDENTIFIER;
};
var $ebf7bf4165262fa0$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $ebf7bf4165262fa0$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !("cond" in transition) && !("in" in transition) && ((0, $f3de07296b675fa8$export$844ec244b1367d54)(transition.target) || (0, $f3de07296b675fa8$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $ebf7bf4165262fa0$var$NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
    (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $ebf7bf4165262fa0$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = "context" in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($ebf7bf4165262fa0$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $d6847f857d89b9db$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $6412c8f28830752c$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $6412c8f28830752c$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $f3de07296b675fa8$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $6412c8f28830752c$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $ebf7bf4165262fa0$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)((0, $bd97a8330b060e00$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? "shallow" : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $ebf7bf4165262fa0$var$NULL_EVENT;
        }) : $ebf7bf4165262fa0$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $f3de07296b675fa8$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $86d294a5ef9fa172$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $f3de07296b675fa8$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $86d294a5ef9fa172$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === "final" ? this.config.data : undefined;
        this.invoke = (0, $f3de07296b675fa8$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $f3de07296b675fa8$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $f3de07296b675fa8$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $6412c8f28830752c$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $28974de1e54bc944$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $f3de07296b675fa8$export$107b54c5097f9157)(_this.id, i);
                return (0, $28974de1e54bc944$export$4c73f685ba879446)((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $f3de07296b675fa8$export$2163e7903738b5df)(invokeConfig.src) || (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $f3de07296b675fa8$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $6412c8f28830752c$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $28974de1e54bc944$export$4c73f685ba879446)((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $28974de1e54bc944$export$4c73f685ba879446)((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({
                    id: (0, $f3de07296b675fa8$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $f3de07296b675fa8$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $86d294a5ef9fa172$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $f3de07296b675fa8$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $bd97a8330b060e00$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $f3de07296b675fa8$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $ebf7bf4165262fa0$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $ebf7bf4165262fa0$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $86d294a5ef9fa172$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $86d294a5ef9fa172$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $86d294a5ef9fa172$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $f3de07296b675fa8$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $f3de07296b675fa8$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $f3de07296b675fa8$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $0acde92687924d50$export$7254cc27399e90bd) ? state.value : (0, $f3de07296b675fa8$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)((0, $f3de07296b675fa8$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $f3de07296b675fa8$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $0acde92687924d50$export$7254cc27399e90bd) ? state : (0, $0acde92687924d50$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $bd97a8330b060e00$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $0acde92687924d50$export$7254cc27399e90bd)((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $bd97a8330b060e00$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $bd97a8330b060e00$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $f3de07296b675fa8$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $f3de07296b675fa8$export$844ec244b1367d54)(stateIn) && $ebf7bf4165262fa0$var$isStateId(stateIn) ? state.matches((0, $f3de07296b675fa8$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $f3de07296b675fa8$export$2870710bf0eac88e)((0, $f3de07296b675fa8$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $f3de07296b675fa8$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $f3de07296b675fa8$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $bd97a8330b060e00$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $bd97a8330b060e00$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $bd97a8330b060e00$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $bd97a8330b060e00$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $bd97a8330b060e00$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== "final") return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $86d294a5ef9fa172$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $86d294a5ef9fa172$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $f3de07296b675fa8$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === "parallel") {
                if ((0, $bd97a8330b060e00$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $bd97a8330b060e00$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $86d294a5ef9fa172$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $86d294a5ef9fa172$export$b3571188c770cc5a)(activity);
            });
            return {
                type: "entry",
                actions: (0, $86d294a5ef9fa172$export$aa68691f32e6c459)(predictableExec ? (0, $6412c8f28830752c$export$1216008129fb82ed)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(entryActions), false), (0, $6412c8f28830752c$export$8d051b38c9118094)(invokeActions), false) : (0, $6412c8f28830752c$export$1216008129fb82ed)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(invokeActions), false), (0, $6412c8f28830752c$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: "state_done",
            actions: doneEvents.map(function(event) {
                return (0, $86d294a5ef9fa172$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: "exit",
                actions: (0, $86d294a5ef9fa172$export$aa68691f32e6c459)((0, $6412c8f28830752c$export$1216008129fb82ed)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(stateNode.onExit), false), (0, $6412c8f28830752c$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $86d294a5ef9fa172$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: "transition",
            actions: (0, $86d294a5ef9fa172$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $86d294a5ef9fa172$export$aa68691f32e6c459)((0, $f3de07296b675fa8$export$bffa455ba8c619a6)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $f3de07296b675fa8$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: "stop",
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $f3de07296b675fa8$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $0acde92687924d50$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $0acde92687924d50$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $f3de07296b675fa8$export$844ec244b1367d54)(state) ? this.resolve((0, $f3de07296b675fa8$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $0acde92687924d50$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571) && _event.name === $ebf7bf4165262fa0$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($ebf7bf4165262fa0$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $f3de07296b675fa8$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $bd97a8330b060e00$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $bd97a8330b060e00$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $86d294a5ef9fa172$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $bd97a8330b060e00$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $bd97a8330b060e00$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $6412c8f28830752c$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $6412c8f28830752c$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $2f911635cac44292$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $2f911635cac44292$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $6412c8f28830752c$export$8d051b38c9118094)((0, $86d294a5ef9fa172$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $6412c8f28830752c$export$8d051b38c9118094)((0, $f3de07296b675fa8$export$b29f828819edca8d)(resolvedActions, (0, $f3de07296b675fa8$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $2f911635cac44292$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $2f911635cac44292$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $32a234c9e2e44def$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $6412c8f28830752c$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $0acde92687924d50$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $f3de07296b675fa8$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $bd97a8330b060e00$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $2f911635cac44292$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $ebf7bf4165262fa0$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $2f911635cac44292$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $0acde92687924d50$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($ebf7bf4165262fa0$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $ebf7bf4165262fa0$var$isStateId(stateId) ? stateId.slice($ebf7bf4165262fa0$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === "string" && $ebf7bf4165262fa0$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $f3de07296b675fa8$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $ebf7bf4165262fa0$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case "parallel":
                return (0, $f3de07296b675fa8$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $ebf7bf4165262fa0$var$EMPTY_OBJECT;
                });
            case "compound":
                if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === "parallel" || subStateNode.type === "compound") return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $f3de07296b675fa8$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $ebf7bf4165262fa0$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $ebf7bf4165262fa0$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($ebf7bf4165262fa0$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($ebf7bf4165262fa0$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $f3de07296b675fa8$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === "parallel") initialStateValue = (0, $f3de07296b675fa8$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $ebf7bf4165262fa0$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === "history");
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $bd97a8330b060e00$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === "history") {
                var historyConfig = this.config;
                if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(historyConfig.target)) target = $ebf7bf4165262fa0$var$isStateId(historyConfig.target) ? (0, $f3de07296b675fa8$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $bd97a8330b060e00$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === "compound" && !this.initial) {
                if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $f3de07296b675fa8$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $6412c8f28830752c$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === "history") return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $f3de07296b675fa8$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $f3de07296b675fa8$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== "history") return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $f3de07296b675fa8$export$bffa455ba8c619a6)((0, $f3de07296b675fa8$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $f3de07296b675fa8$export$314d0a1a7c835392)(parent.path, "states")(historyValue).current;
        if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $f3de07296b675fa8$export$bffa455ba8c619a6)((0, $f3de07296b675fa8$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $6412c8f28830752c$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $f3de07296b675fa8$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $f3de07296b675fa8$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $f3de07296b675fa8$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $86d294a5ef9fa172$export$aa68691f32e6c459)((0, $f3de07296b675fa8$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $f3de07296b675fa8$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $ebf7bf4165262fa0$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $6412c8f28830752c$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571) && key === $ebf7bf4165262fa0$var$NULL_EVENT) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
                var transitionConfigArray = (0, $f3de07296b675fa8$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) $ebf7bf4165262fa0$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $f3de07296b675fa8$export$3822a36ea084a4d5)($ebf7bf4165262fa0$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $f3de07296b675fa8$export$3822a36ea084a4d5)("", this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $f3de07296b675fa8$export$3822a36ea084a4d5)(String((0, $86d294a5ef9fa172$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
        var invokeConfig = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)((0, $f3de07296b675fa8$export$3822a36ea084a4d5)(String((0, $86d294a5ef9fa172$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)((0, $f3de07296b675fa8$export$3822a36ea084a4d5)(String((0, $86d294a5ef9fa172$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)((0, $6412c8f28830752c$export$1216008129fb82ed)((0, $6412c8f28830752c$export$1216008129fb82ed)((0, $6412c8f28830752c$export$1216008129fb82ed)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(doneConfig), false), (0, $6412c8f28830752c$export$8d051b38c9118094)(invokeConfig), false), (0, $6412c8f28830752c$export$8d051b38c9118094)(onConfig), false), (0, $6412c8f28830752c$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $f3de07296b675fa8$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $13316a4e195faefc$var$warned = false;
function $13316a4e195faefc$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $ebf7bf4165262fa0$export$342f24f5edd47b1)(config, options, initialContext);
}
function $13316a4e195faefc$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571) && !("predictableActionArguments" in config) && !$13316a4e195faefc$var$warned) {
        $13316a4e195faefc$var$warned = true;
        console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
    }
    return new (0, $ebf7bf4165262fa0$export$342f24f5edd47b1)(config, options);
}









var $da7a5cfc2f17e623$var$defaultOptions = {
    deferEvents: false
};
var $da7a5cfc2f17e623$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, $da7a5cfc2f17e623$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error("Event queue should be empty when it is not processing events");
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();



var $8c80c2ed14fec4ad$var$children = /*#__PURE__*/ new Map();
var $8c80c2ed14fec4ad$var$sessionIdIndex = 0;
var $8c80c2ed14fec4ad$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($8c80c2ed14fec4ad$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $8c80c2ed14fec4ad$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $8c80c2ed14fec4ad$var$children.get(id);
    },
    free: function(id) {
        $8c80c2ed14fec4ad$var$children.delete(id);
    }
};



function $cb009b9ac5d62a23$export$a4e55266d2135a7f() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function $cb009b9ac5d62a23$var$getDevTools() {
    var global1 = $cb009b9ac5d62a23$export$a4e55266d2135a7f();
    if (global1 && "__xstate__" in global1) return global1.__xstate__;
    return undefined;
}
function $cb009b9ac5d62a23$export$4d7a7d14704ebc13(service) {
    if (!$cb009b9ac5d62a23$export$a4e55266d2135a7f()) return;
    var devTools = $cb009b9ac5d62a23$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $112249db11d43762$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $112249db11d43762$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: "pending"
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case "fulfill":
                    parent === null || parent === void 0 || parent.send((0, $86d294a5ef9fa172$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: "fulfilled"
                    };
                case "reject":
                    parent === null || parent === void 0 || parent.send((0, $86d294a5ef9fa172$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: "rejected"
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: "fulfill",
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: "reject",
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $112249db11d43762$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $32a234c9e2e44def$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $f3de07296b675fa8$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || "anonymous",
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $81c9b1abe2fc3c4d$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $81c9b1abe2fc3c4d$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($81c9b1abe2fc3c4d$export$7a567c9c5088a551 || ($81c9b1abe2fc3c4d$export$7a567c9c5088a551 = {}));
var $81c9b1abe2fc3c4d$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $81c9b1abe2fc3c4d$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $f3de07296b675fa8$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $f3de07296b675fa8$export$eaf22249b410f633)((0, $f3de07296b675fa8$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $a25360e382d35ff4$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $f3de07296b675fa8$export$844ec244b1367d54)(to) ? to === (0, $a25360e382d35ff4$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $8c80c2ed14fec4ad$export$4bb7493d241fd8a5).get(to) : (0, $f3de07296b675fa8$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ("machine" in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $2f911635cac44292$export$a3bc9b8ed74fc) ? "".concat((0, $86d294a5ef9fa172$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $86d294a5ef9fa172$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: "xstate.error",
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $2f911635cac44292$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $2f911635cac44292$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === "number") {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $86d294a5ef9fa172$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $2f911635cac44292$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $2f911635cac44292$export$b3571188c770cc5a:
                    if (_this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $a25360e382d35ff4$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $f3de07296b675fa8$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!("forward" in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $f3de07296b675fa8$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === "string") // TODO: warn
                        return;
                        var source = (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $f3de07296b675fa8$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $2f911635cac44292$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $2f911635cac44292$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $da7a5cfc2f17e623$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $8c80c2ed14fec4ad$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $6c037fe9ada47c96$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $86d294a5ef9fa172$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === "final" && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $f3de07296b675fa8$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $86d294a5ef9fa172$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $8c80c2ed14fec4ad$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $f3de07296b675fa8$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $8c80c2ed14fec4ad$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $6c037fe9ada47c96$export$abe1e183e22e10ad)(this, function() {
            return (0, $0acde92687924d50$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $0acde92687924d50$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $86d294a5ef9fa172$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $da7a5cfc2f17e623$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $f3de07296b675fa8$export$eaf22249b410f633)({
                type: "xstate.stop"
            });
            var nextState = (0, $6c037fe9ada47c96$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $f3de07296b675fa8$export$bffa455ba8c619a6)((0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $86d294a5ef9fa172$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $6412c8f28830752c$export$8d051b38c9118094)((0, $86d294a5ef9fa172$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: "exit",
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $0acde92687924d50$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $f3de07296b675fa8$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $8c80c2ed14fec4ad$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        } else if (this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $f3de07296b675fa8$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $6c037fe9ada47c96$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $6412c8f28830752c$export$1216008129fb82ed)([], (0, $6412c8f28830752c$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $0acde92687924d50$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $f3de07296b675fa8$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $f3de07296b675fa8$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $2f911635cac44292$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $2f911635cac44292$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $6c037fe9ada47c96$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $6412c8f28830752c$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ("to" in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $81c9b1abe2fc3c4d$export$7a567c9c5088a551.Running) return (0, $32a234c9e2e44def$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $f3de07296b675fa8$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $32a234c9e2e44def$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $f3de07296b675fa8$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $f3de07296b675fa8$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $f3de07296b675fa8$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, $81c9b1abe2fc3c4d$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $2f911635cac44292$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $112249db11d43762$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)((0, $86d294a5ef9fa172$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $86d294a5ef9fa172$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $f3de07296b675fa8$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $f3de07296b675fa8$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $86d294a5ef9fa172$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $f3de07296b675fa8$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $f3de07296b675fa8$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $f3de07296b675fa8$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)((0, $86d294a5ef9fa172$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $f3de07296b675fa8$export$eaf22249b410f633)((0, $86d294a5ef9fa172$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $cb009b9ac5d62a23$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $6412c8f28830752c$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $cb009b9ac5d62a23$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $f3de07296b675fa8$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $81c9b1abe2fc3c4d$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $81c9b1abe2fc3c4d$export$67beed298888a38b;
    return Interpreter;
}();
var $81c9b1abe2fc3c4d$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $f3de07296b675fa8$export$844ec244b1367d54)(nameOrOptions)) return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, $81c9b1abe2fc3c4d$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)((0, $6412c8f28830752c$export$18ce0697a983be9b)({}, $81c9b1abe2fc3c4d$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $f3de07296b675fa8$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $81c9b1abe2fc3c4d$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $81c9b1abe2fc3c4d$var$resolveSpawnOptions(nameOrOptions);
    return (0, $6c037fe9ada47c96$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $57d670cc9d015c76$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $f3de07296b675fa8$export$2163e7903738b5df)(entity) || (0, $f3de07296b675fa8$export$f6e2535fb5126e54)(entity);
            (0, $f3de07296b675fa8$export$c106dd0671a0fc2d)(!!service || isLazyEntity, 'Attempted to spawn an Actor (ID: "'.concat((0, $f3de07296b675fa8$export$2163e7903738b5df)(entity) ? entity.id : "undefined", '") outside of a service. This will have no effect.'));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $32a234c9e2e44def$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $81c9b1abe2fc3c4d$export$67beed298888a38b(machine, options) {
    var interpreter = new $81c9b1abe2fc3c4d$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}


class $272f31bde53b6e17$var$OneBubbleTutorial extends EventTarget {
    constructor(){
        super();
        this.bubble = new (0, $936fb2977bd9e74f$export$80f8a8bc75250cf0)();
        this.bubble_html = [];
    }
    switchToBubble(index) {
        const container = document.createElement("div");
        container.classList.add("how-it-works-modal");
        const title = document.createElement("h2");
        title.textContent = "How It Works";
        title.classList.add("title");
        container.appendChild(title);
        const divider = document.createElement("hr");
        container.appendChild(divider);
        const description = document.createElement("div");
        description.innerHTML = this.bubble_html[index];
        description.classList.add("description");
        container.appendChild(description);
        const button = document.createElement("button");
        button.textContent = "close";
        button.classList.add("close");
        button.addEventListener("click", ()=>{
            this.state.send("TOGGLE");
        });
        container.appendChild(button);
        this.bubble.setChildren(container);
        if (this.bubble.isVisible()) this.bubble.fadeInSpans();
    }
    // Hide the tutorial window
    clear(context, event) {
        this.bubble.popOut();
    }
    // Make the tutorial window visible
    open(context, event) {
        this.bubble.popIn();
    }
}
class $272f31bde53b6e17$export$2e01aa4c1d0ac16b extends $272f31bde53b6e17$var$OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ],
                                RESET: {
                                    target: "initial",
                                    actions: [
                                        "onReset"
                                    ]
                                }
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden",
                            RESET: {
                                target: "initial",
                                actions: [
                                    "onReset",
                                    "clear"
                                ]
                            }
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {
                        on: {
                            NEXT: "state_explanation",
                            ZOOM_IN: "state_explanation",
                            LOAD_COUNTIES: "county_explanation",
                            ENTER_MAP: "map_explanation"
                        },
                        entry: [
                            "onFirstView"
                        ]
                    },
                    state_explanation: {
                        on: {
                            ZOOM_OUT: "first_view",
                            LOAD_COUNTIES: "county_explanation",
                            ENTER_MAP: "map_explanation",
                            RESET: {
                                target: "first_view",
                                actions: [
                                    "onReset"
                                ]
                            }
                        },
                        entry: [
                            "onStateExplanation"
                        ]
                    },
                    county_explanation: {
                        on: {
                            LOAD_ZIPS: "zip_explanation",
                            ENTER_MAP: "map_explanation",
                            RESET: {
                                target: "first_view",
                                actions: [
                                    "onReset"
                                ]
                            }
                        },
                        entry: [
                            "onCountyExplanation"
                        ]
                    },
                    zip_explanation: {
                        on: {
                            LOAD_COUNTIES: "county_explanation",
                            ENTER_MAP: "map_explanation",
                            RESET: {
                                target: "first_view",
                                actions: [
                                    "onReset"
                                ]
                            }
                        },
                        entry: [
                            "onZipExplanation"
                        ]
                    },
                    map_explanation: {
                        on: {
                            SELECT_HOME: "select_election_explanation",
                            LEAVE_MAP: "zip_explanation",
                            LOAD_ZIPS: "zip_explanation",
                            LOAD_COUNTIES: "county_explanation",
                            RESET: {
                                target: "first_view",
                                actions: [
                                    "onReset"
                                ]
                            }
                        },
                        entry: [
                            "onMapExplanation"
                        ]
                    },
                    select_election_explanation: {
                        on: {
                            LEAVE_MAP: "zip_explanation",
                            LOAD_ZIPS: "zip_explanation",
                            RESET: {
                                target: "first_view",
                                actions: [
                                    "onReset"
                                ]
                            }
                        },
                        entry: [
                            "onSelectElectionExplanation"
                        ]
                    }
                }
            }
        }
    };
    constructor(){
        super();
        const scope = this;
        // Define the content that will be shown in the speech bubble at each step of the tutorial
        this.bubble_html = [
            "Who can you vote for? <br> <br> Enter your address in the search bar or click on the United States to find out",
            "Select the state you wish to explore.",
            "Select your county will narrow your search.</span>",
            "Choose your zip code for elections specific in your area.</span>",
            "Filter elections by year and type, Explore the various districts you vote in. Select an election on the right to see a list of candidates.",
            "Select an election on the right to see your candidates or explore your districts on the left."
        ];
        // Attach bubble to parent
        document.querySelector("#how-it-works").prepend(this.bubble.element);
        // TODO: Detect veteran users with cookies?
        // Connect state machine actions to the functions in this class
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$2e01aa4c1d0ac16b.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{
                    this.onFirstView(context, event);
                },
                onStateExplanation: (context, event)=>{
                    this.onStateExplanation(context, event);
                },
                onCountyExplanation: (context, event)=>{
                    this.onCountyExplanation(context, event);
                },
                onZipExplanation: (context, event)=>{
                    this.onZipExplanation(context, event);
                },
                onMapExplanation: (context, event)=>{
                    this.onMapExplanation(context, event);
                },
                onSelectElectionExplanation: (context, event)=>{
                    this.onSelectElectionExplanation(context, event);
                },
                onReset: (context, event)=>{
                    this.onReset(context, event);
                }
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state)).start();
    // Setup callback on question mark button
    // const button = document.querySelector(".walkthrough-question-mark");
    // button.addEventListener("click", () => scope.state.send("TOGGLE"));
    }
    // Actions
    // These are the functions that run on state transitions
    onFirstView(context, event) {
        this.switchToBubble(0);
        this.dispatchEvent(new CustomEvent("firstview", {
            context: context,
            event: event
        }));
    }
    onStateExplanation(context, event) {
        this.switchToBubble(1);
        this.dispatchEvent(new CustomEvent("stateexplanation", {
            context: context,
            event: event
        }));
    }
    onCountyExplanation(context, event) {
        this.switchToBubble(2);
        this.dispatchEvent(new CustomEvent("countyexplanation", {
            context: context,
            event: event
        }));
    }
    onZipExplanation(context, event) {
        this.switchToBubble(3);
        this.dispatchEvent(new CustomEvent("zipexplanation", {
            context: context,
            event: event
        }));
    }
    onMapExplanation(context, event) {
        this.switchToBubble(4);
        this.dispatchEvent(new CustomEvent("mapexplanation", {
            context: context,
            event: event
        }));
    }
    onSelectElectionExplanation(context, event) {
        this.switchToBubble(5);
        this.dispatchEvent(new CustomEvent("selectelectionexplanation", {
            context: context,
            event: event
        }));
    }
    onReset(context, event) {
        this.dispatchEvent(new CustomEvent("reset", {
            context: context,
            event: event
        }));
    }
}
class $272f31bde53b6e17$export$7476b42f0b57230f {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {
                        on: {
                            SELECT_HOME: "candidate_overview_explanation"
                        }
                    },
                    candidate_overview_explanation: {
                        entry: [
                            "onCandidateOverviewExplanation"
                        ]
                    }
                }
            }
        }
    };
    constructor(){
        this.bubbles = [];
        parent = document.querySelector(".how-it-works-mini");
        // Create images
        var img;
        img = document.createElement("img");
        img.classList.add("walkthrough-bubble");
        img.classList.add("mini");
        img.classList.add("hidden");
        img.classList.add("no-animation");
        img.setAttribute("src", "/assets/walkthrough/osm/find-home-address.png");
        parent.prepend(img);
        this.bubbles.push(img);
        this.bubble_src = [
            "/assets/walkthrough/osm/find-home-address.png",
            "/assets/walkthrough/osm/candidate-overview.png"
        ];
        this.currentBubble = this.bubbles[0];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$7476b42f0b57230f.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{},
                onCandidateOverviewExplanation: (context, event)=>{
                    this.onCandidateOverviewExplanation();
                }
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark-container-mini");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
    }
    switchToBubble(index) {
        this.currentBubble.setAttribute("src", this.bubble_src[index]);
    }
    // Hide the tutorial window
    clear(context, event) {
        this.currentBubble.classList.add("pop-out");
    }
    // Make the tutorial window visible
    open(context, event) {
        this.currentBubble.classList.remove("hidden");
        this.currentBubble.classList.remove("pop-out");
        this.currentBubble.classList.remove("no-animation");
    }
    onCandidateOverviewExplanation(context, event) {
        console.log("onCandidateOverviewExplanation");
        this.switchToBubble(1);
    }
}
class $272f31bde53b6e17$export$262fc91096ddd6ea {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {
                        on: {
                            SELECT_CANDIDATE: "select_candidate_explanation"
                        }
                    },
                    select_candidate_explanation: {
                        entry: [
                            "onSelectCandidateExplanation"
                        ]
                    }
                }
            }
        }
    };
    constructor(){
        this.bubbles = [];
        parent = document.querySelector(".how-it-works-wrapper-mini.bubble-wrapper");
        // Create images
        var img;
        img = document.createElement("img");
        img.classList.add("walkthrough-bubble");
        img.classList.add("mini");
        img.classList.add("hidden");
        img.classList.add("no-animation");
        img.setAttribute("src", "/assets/walkthrough/elections-search/qualified-elections.png");
        parent.prepend(img);
        this.bubbles.push(img);
        this.bubble_src = [
            "/assets/walkthrough/elections-search/qualified-elections.png",
            "/assets/walkthrough/elections-search/select-a-candidate.png"
        ];
        this.currentBubble = this.bubbles[0];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$262fc91096ddd6ea.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{},
                onSelectCandidateExplanation: (context, event)=>{
                    this.onSelectCandidateExplanation();
                }
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark-container-mini");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
    }
    switchToBubble(index) {
        this.currentBubble.setAttribute("src", this.bubble_src[index]);
    }
    // Hide the tutorial window
    clear(context, event) {
        this.currentBubble.classList.add("pop-out");
    }
    // Make the tutorial window visible
    open(context, event) {
        this.currentBubble.classList.remove("hidden");
        this.currentBubble.classList.remove("pop-out");
        this.currentBubble.classList.remove("no-animation");
    }
    onSelectCandidateExplanation(context, event) {
        console.log("onSelectCandidateExplanation");
        this.switchToBubble(1);
    }
}
class $272f31bde53b6e17$export$300c7ba394e60a04 extends $272f31bde53b6e17$var$OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {}
                }
            }
        }
    };
    constructor(){
        super();
        document.querySelector(".how-it-works").prepend(this.bubble.element);
        this.bubble_html = [
            "Explore campaign details, watch candidate videos, follow or add a specific candidate to your ballot, donate."
        ];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$300c7ba394e60a04.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{}
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
        this.switchToBubble(0);
    }
}
class $272f31bde53b6e17$export$3e161808a7bace01 extends $272f31bde53b6e17$var$OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {}
                }
            }
        }
    };
    constructor(){
        super();
        document.querySelector(".how-it-works").prepend(this.bubble.element);
        this.bubble_html = [
            "Save candidate here for a stress-free day at the polls. You can also share your ballot so others can vote for your favorite candidate too."
        ];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$3e161808a7bace01.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{}
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
        this.switchToBubble(0);
    }
}
class $272f31bde53b6e17$export$43fec2fbe9a8b109 extends $272f31bde53b6e17$var$OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {}
                }
            }
        }
    };
    constructor(){
        super();
        document.querySelector(".how-it-works").prepend(this.bubble.element);
        this.bubble_html = [
            "Follow an election, flip the cards, compare a group of candidates, or click on a specific candidate for more details"
        ];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$3e161808a7bace01.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{}
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
        this.switchToBubble(0);
    }
}
class $272f31bde53b6e17$export$4f8dc67b3c57952 extends $272f31bde53b6e17$var$OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {}
                }
            }
        }
    };
    constructor(){
        super();
        document.querySelector(".how-it-works").prepend(this.bubble.element);
        this.bubble_html = [
            "Visit your feed to see updates to the candidates and elections you follow."
        ];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$4f8dc67b3c57952.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{}
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
        this.switchToBubble(0);
    }
}
class $272f31bde53b6e17$export$af0ac4dda674eb23 extends $272f31bde53b6e17$var$OneBubbleTutorial {
    // Set up state machine
    static stateMachineParams = {
        id: "tutorial",
        type: "parallel",
        states: {
            // States dealing with visibility of the tutorial
            visible: {
                initial: "initial",
                states: {
                    initial: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        }
                    },
                    hidden: {
                        on: {
                            TOGGLE: {
                                target: "visible",
                                actions: [
                                    "open"
                                ]
                            }
                        },
                        entry: [
                            "clear"
                        ]
                    },
                    visible: {
                        on: {
                            TOGGLE: "hidden"
                        }
                    }
                }
            },
            // States dealing with the content of the tutorial
            view: {
                initial: "first_view",
                states: {
                    first_view: {}
                }
            }
        }
    };
    constructor(){
        super();
        document.querySelector(".how-it-works").prepend(this.bubble.element);
        this.bubble_html = [
            "Select a candidate to learn more about them. Verified candidates have been confirmed by Ballot Builder to be on your ballot."
        ];
        this.stateMachine = (0, $13316a4e195faefc$export$aaa7fa18f8e9b2e8)($272f31bde53b6e17$export$3e161808a7bace01.stateMachineParams, {
            actions: {
                open: (context, event)=>{
                    this.open(context, event);
                },
                clear: (context, event)=>{
                    this.clear(context, event);
                },
                onFirstView: (context, event)=>{}
            }
        });
        // Create stateful tracking service from our state machine
        // This is what's doing the heavy lifting of the state machine
        this.state = (0, $81c9b1abe2fc3c4d$export$67beed298888a38b)(this.stateMachine).onTransition((state)=>console.log("state transition:", state.value)).start();
        // Setup callback on question mark button
        const scope = this;
        const button = document.querySelector(".walkthrough-question-mark");
        button.addEventListener("click", ()=>scope.state.send("TOGGLE"));
        this.switchToBubble(0);
    }
}





/* eslint-disable @typescript-eslint/strict-boolean-expressions */ /**
 * This file contains various hacks made to our dependencies.
 *
 * These would be better as modifications to the libraries themselves, ie. we should fork the libary, but take this form instead in the interest of time.
 * These may break if the libraries they modify are updated.
 */ 

function $b291be538931221c$export$236aeff48d2a8653(map) {
    function mercatorXfromLng(lng) {
        return (180 + lng) / 360;
    }
    function mercatorYfromLat(lat) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
    }
    /**
     * constrain n to the given range, excluding the minimum, via modular arithmetic
     *
     * @param n value
     * @param min the minimum value to be returned, exclusive
     * @param max the maximum value to be returned, inclusive
     * @returns constrained number
     * @private
     */ function wrap(n, min, max) {
        const d = max - min;
        const w = ((n - min) % d + d) % d + min;
        return w === min ? max : w;
    }
    // Overwrite the Transform._constrain function
    map.transform._constrain = (function() {
        // Demo code to show how perfect this is
        // document.querySelector("#map").parentElement.style.zIndex="10000000"; debug_map.setPitch(0)
        if (!this.center || !this.width || !this.height || this._constraining) return;
        this._constraining = true;
        let minY = -90;
        let maxY = 90;
        let minX = -180;
        let maxX = 180;
        let sy, sx, x2, y2;
        const size = this.size;
        const unmodified = this._unmodified;
        const viewport = (0, $3e645b0309771ac1$export$c02eeb5f98d59b89)();
        const viewportHeight = viewport.bottom - viewport.top;
        const viewportWidth = viewport.right - viewport.left;
        const viewportCenter = new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))((viewport.left + viewport.right) / 2, (viewport.top + viewport.bottom) / 2);
        // TODO: Account for nudge
        const mapRect = document.querySelector("#map canvas")?.getBoundingClientRect();
        if (typeof mapRect === "undefined") throw new Error("Map canvas not found");
        const mapCenter = new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))((mapRect.left + mapRect.right) / 2, (mapRect.top + mapRect.bottom) / 2);
        const centerDiff = mapCenter.sub(viewportCenter);
        const dl = viewport.left - mapRect.left;
        const dr = mapRect.right - viewport.right;
        const dt = viewport.top - mapRect.top;
        const db = mapRect.bottom - viewport.bottom;
        const ol = dl * size.x / (size.x - dl);
        const or = dr * size.x / (size.x - dr);
        const ot = dt * size.y / (size.y - dt);
        const ob = db * size.y / (size.y - db);
        const dx = ol + or;
        const dy = ot + ob;
        if (this.latRange) {
            const latRange = this.latRange;
            minY = mercatorYfromLat(latRange[1]) * this.worldSize;
            maxY = mercatorYfromLat(latRange[0]) * this.worldSize;
            sy = maxY - minY < viewportHeight ? viewportHeight / (maxY - minY) : 0;
        }
        if (this.lngRange) {
            const lngRange = this.lngRange;
            minX = wrap(mercatorXfromLng(lngRange[0]) * this.worldSize, 0, this.worldSize);
            maxX = wrap(mercatorXfromLng(lngRange[1]) * this.worldSize, 0, this.worldSize);
            if (maxX < minX) maxX += this.worldSize;
            // English description
            // If the pixel bounds span less width than the screen,
            // find the ratio of screen width to bounds width.
            sx = maxX - minX < viewportWidth ? viewportWidth / (maxX - minX) : 0;
        }
        const point = this.point;
        // how much the map should scale to fit the screen into given latitude/longitude ranges
        const s = viewportHeight / viewportWidth > (maxY - minY) / (maxX - minX) ? sx : sy // Math.max(sx || 0, sy || 0)
        ;
        if (s) {
            // Set the map center (lngLat) such that the center of our bounds is in the center of the viewport
            this.center = this.unproject(new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))(sx ? (maxX + minX) / 2 : point.x, sy ? (maxY + minY) / 2 : point.y).add(centerDiff));
            this.zoom += this.scaleZoom(s);
            this._unmodified = unmodified;
            this._constraining = false;
        }
        if (this.latRange) {
            // y is the map point at the center of the viewport
            const y = point.y - centerDiff.y;
            const h2 = viewportHeight / 2;
            // const ob = 0
            const top = y - h2;
            const bottom = y + h2;
            // English description
            // If the bottom viewport bound exceeds the bottom pixel bound,
            // move the screen back so that the bottom viewport bound equals the bottom pixel bound
            if (viewportHeight > maxY - minY) y2 = (minY + maxY) / 2 + centerDiff.y;
            else {
                if (top < minY) y2 = minY + h2 + centerDiff.y;
                if (bottom > maxY) y2 = maxY - h2 + centerDiff.y;
            }
        }
        if (this.lngRange) {
            const centerX = (minX + maxX) / 2 + centerDiff.x;
            const x = wrap(point.x - centerDiff.x, centerX - this.worldSize / 2, centerX + this.worldSize / 2);
            const w2 = viewportWidth / 2;
            if (viewportWidth > maxX - minX) x2 = centerX;
            else {
                if (x - w2 < minX) x2 = minX + w2 + centerDiff.x;
                if (x + w2 > maxX) x2 = maxX - w2 + centerDiff.x;
            }
        }
        // pan the map if the screen goes off the range
        if (x2 !== undefined || y2 !== undefined) this.center = this.unproject(new (0, (/*@__PURE__*/$parcel$interopDefault($4968fe2ddf6410c8$exports)))(x2 !== undefined ? x2 : point.x, y2 !== undefined ? y2 : point.y)).wrap();
        this._unmodified = unmodified;
        this._constraining = false;
    }).bind(map.transform);
}





var $b8e13ffc5d653b23$var$BoundKind;
(function(BoundKind) {
    BoundKind[BoundKind["NONE"] = 0] = "NONE";
    BoundKind[BoundKind["COUNTY"] = 1] = "COUNTY";
    BoundKind[BoundKind["POLYGON"] = 2] = "POLYGON";
})($b8e13ffc5d653b23$var$BoundKind || ($b8e13ffc5d653b23$var$BoundKind = {}));
// get URL params
// TODO: Remove this before production
const $b8e13ffc5d653b23$var$pageUrl = new URL(window.location.href);
const $b8e13ffc5d653b23$var$URL_PARAMS = $b8e13ffc5d653b23$var$pageUrl.searchParams;
const $b8e13ffc5d653b23$var$DEBUG = $b8e13ffc5d653b23$var$pageUrl.searchParams.get("debug") === "true";
const $b8e13ffc5d653b23$var$settings = {
    hoverColor: {
        emissive: "#2b1c05",
        color: "#ffffff"
    }
};
const $b8e13ffc5d653b23$var$returnToGlobePopup = new $30510d2f060a5cf8$exports.Popup({
    closeOnClick: false,
    closeButton: false,
    focusAfterOpen: false
}).setHTML("\u2B06 Return to Globe");
const $b8e13ffc5d653b23$var$state = {
    map: {
        /**
         * True when the user is fully in the map and the globe is not visible
         */ immersed: false,
        visible: false,
        visibleSoon: false,
        /**
         * When true, will automatically go from map view to globe view if the user zooms out far enough
         */ autoLeave: true,
        bounded: false,
        boundsPromise: null,
        boundsPromiseSignal: null,
        bounds: [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ]
    }
};
function $b8e13ffc5d653b23$var$disableAutoLeave() {
    $b8e13ffc5d653b23$var$state.map.autoLeave = false;
}
function $b8e13ffc5d653b23$var$enableAutoLeave() {
    $b8e13ffc5d653b23$var$state.map.autoLeave = true;
}
function $b8e13ffc5d653b23$var$setMapBounds(bounds, { signal: signal }) {
    $b8e13ffc5d653b23$var$state.map.boundsPromise = bounds;
    $b8e13ffc5d653b23$var$state.map.boundsPromiseSignal = signal !== undefined ? signal : null;
}
async function $b8e13ffc5d653b23$var$enableMapBounds({ signal: signal } = {}) {
    if ($b8e13ffc5d653b23$var$state.map.boundsPromise === null) throw new Error("enableMapBounds called but state.map.boundsPromise was null");
    if (signal === undefined) signal = $b8e13ffc5d653b23$var$state.map.boundsPromiseSignal !== null ? $b8e13ffc5d653b23$var$state.map.boundsPromiseSignal : undefined;
    signal?.throwIfAborted();
    // Save the current bounds promise before awaiting
    const savedMapBoundsPromise = $b8e13ffc5d653b23$var$state.map.boundsPromise;
    let bounds;
    try {
        bounds = await $b8e13ffc5d653b23$var$state.map.boundsPromise;
    } catch (err) {
        // Bounds promise rejected, probably due to an error/abort of a map click (handleLatlngClick)
        console.warn(err, "map bounds promise rejected");
        return;
    }
    signal?.throwIfAborted();
    // Check that the saved bounds promise matches with the most current one
    if (savedMapBoundsPromise !== $b8e13ffc5d653b23$var$state.map.boundsPromise) // The bounds promise has been replaced by a new one - abort
    throw new Error("Bounds promise superceded");
    // eslint-disable-next-line no-autofix/prefer-const
    let [[w, s], [e, n]] = bounds;
    if (isNaN(w) || isNaN(s) || isNaN(e) || isNaN(n)) {
        console.error({
            bounds: bounds
        }, "NaN in map bounds");
        return;
    }
    const lngRange = e - w;
    const latRange = n - s;
    // Add % margin
    w -= lngRange * 0.05;
    e += lngRange * 0.05;
    s -= latRange * 0.05;
    // n += 1
    $b8e13ffc5d653b23$var$map.setMaxBounds([
        [
            w,
            s
        ],
        [
            e,
            n
        ]
    ]);
    $b8e13ffc5d653b23$var$state.map.bounded = true;
    $b8e13ffc5d653b23$var$state.map.bounds = bounds;
}
async function $b8e13ffc5d653b23$var$updateMapBounds() {
    if ($b8e13ffc5d653b23$var$state.map.boundsPromise !== null) await $b8e13ffc5d653b23$var$enableMapBounds();
}
window.addEventListener("resize", ()=>{
    $b8e13ffc5d653b23$var$updateMapBounds();
});
// document.addEventListener("footerchange", () => {
//     void updateMapBounds()
// })
function $b8e13ffc5d653b23$var$disableMapBounds() {
    $b8e13ffc5d653b23$var$state.map.bounded = false;
    $b8e13ffc5d653b23$var$state.map.boundsPromise = null;
    $b8e13ffc5d653b23$var$state.map.bounds = [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ];
    $b8e13ffc5d653b23$var$map.setMaxBounds();
}
function $b8e13ffc5d653b23$var$querySelectorThrow(...parameters) {
    const res = document.querySelector(...parameters);
    if (res === null) throw new ReferenceError(`querySelector (${parameters.join(", ")}) returned null`);
    return res;
}
function $b8e13ffc5d653b23$var$boundMap(countyOrPolygon, { signal: signal }) {
    let rawBoundsPromise;
    if (countyOrPolygon instanceof Promise) rawBoundsPromise = countyOrPolygon.then((polygon)=>{
        signal?.throwIfAborted();
        return (0, $47339db63dfc5d6d$export$2e2bcd8739ae039)(polygon);
    });
    else if ("type" in countyOrPolygon && countyOrPolygon.type === "Polygon") rawBoundsPromise = Promise.resolve((0, $47339db63dfc5d6d$export$2e2bcd8739ae039)(countyOrPolygon));
    else if (countyOrPolygon instanceof (0, $7392ee50b9a2c168$export$b1f97c3099fc6872)) rawBoundsPromise = Promise.resolve([
        [
            countyOrPolygon.face.userData.minx,
            countyOrPolygon.face.userData.miny
        ],
        [
            countyOrPolygon.face.userData.maxx,
            countyOrPolygon.face.userData.maxy
        ]
    ]);
    else throw new TypeError("boundMap expects Region or Polygon");
    $b8e13ffc5d653b23$var$setMapBounds(rawBoundsPromise, {
        signal: signal
    });
}
const $b8e13ffc5d653b23$var$fpsClock = new $8725869b83961a04$export$9735c82c4bae3302();
/**
 Example gpuTier:
 {
 "tier": 1,
 "isMobile": false,
 "type": "BENCHMARK",
 "fps": 21,
 "gpu": "intel iris graphics 6100"
 }
 */ let $b8e13ffc5d653b23$var$gpuTier;
let $b8e13ffc5d653b23$var$gui;
let $b8e13ffc5d653b23$var$GLOBE;
let $b8e13ffc5d653b23$var$TEXTURE_INITIALIZER;
let $b8e13ffc5d653b23$var$scene;
let $b8e13ffc5d653b23$var$renderer;
let $b8e13ffc5d653b23$var$screenQuad;
let $b8e13ffc5d653b23$var$elapsedTime = 0;
let $b8e13ffc5d653b23$var$cameraSynchronizer;
let $b8e13ffc5d653b23$var$map;
let $b8e13ffc5d653b23$var$swapper;
// const stats = new Stats()
// stats.showPanel(0)
// document.body.appendChild(stats.dom)
// Run init when DOM is ready
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(()=>{
    $b8e13ffc5d653b23$var$init();
});
// TODO: Return map, return promise? return SOMETHING
function $b8e13ffc5d653b23$var$initializeMap({ returnToGlobePopup: returnToGlobePopup, resetButton: resetButton, enableAutoLeave: enableAutoLeave, enableMapBounds: enableMapBounds }) {
    const osmServerApiHost = "/api";
    const defaultPitch = 23 // degrees
    ;
    const map = new (0, $fdb1b306f96b8b4f$export$a5c7b93649eaf8f8)({
        container: "map",
        style: `${osmServerApiHost}/maps/R3/style.json`,
        center: [
            -86.42816507327348,
            35.84716452652847
        ],
        zoom: 6.24,
        pitch: defaultPitch,
        bearing: 0,
        maxPitch: 85,
        maxZoom: 20
    });
    // Change map bounds from fit to cover ?
    (0, $b291be538931221c$export$236aeff48d2a8653)(map);
    // Hook up return to globe button
    map.on("mouseover", "county-cutout", (event)=>{
        returnToGlobePopup.addTo(map);
        returnToGlobePopup.setLngLat(event.lngLat);
    });
    map.on("mousemove", "county-cutout", (event)=>{
        returnToGlobePopup.setLngLat(event.lngLat);
    });
    map.on("mouseout", "county-cutout", (event)=>{
        returnToGlobePopup.remove();
    });
    map.on("click", "county-cutout", (event)=>{
        // Do up to globe
        $b8e13ffc5d653b23$var$querySelectorThrow(`#county_list li.selected span`).click();
    });
    returnToGlobePopup.on("open", ()=>{
        map.getCanvas().style.cursor = "pointer";
    });
    returnToGlobePopup.on("close", ()=>{
        map.getCanvas().style.cursor = "";
    });
    // Hack to move mapgl attribution in the DOM
    const attribution = $b8e13ffc5d653b23$var$querySelectorThrow(".maplibregl-ctrl-attrib");
    const centerWindow = $b8e13ffc5d653b23$var$querySelectorThrow("#center-window");
    centerWindow.append(attribution);
    // Hide attribution at first
    attribution.classList.add("hidden");
    resetButton.addEventListener("click", ()=>attribution.classList.add("hidden"));
    const firstSymbolPromise = new Promise((resolve, reject)=>map.on("load", ()=>{
            const layers = map.getStyle().layers;
            // Find the index of the first symbol layer in the map style
            let firstSymbolId;
            for(let i = 0; i < layers.length; i++)if (layers[i].type === "symbol") {
                firstSymbolId = layers[i].id;
                break;
            }
            let firstLineId;
            for(let i = 0; i < layers.length; i++)if (layers[i].type === "line") {
                firstLineId = layers[i].id;
                break;
            }
            resolve([
                firstSymbolId,
                firstLineId
            ]);
        }));
    map.on("zoomend", (event)=>{
        if (event.signal?.aborted === true) return;
        // Enable autoLeave when a zoom ends.
        // This is mostly for avoiding premature autoLeave during initial zoom
        // Also helps achieve the "any user input enables auto leave" function
        if ((event.cause === "enterMap" || event.cause === "smoothlyGoToMapPoint") && $b8e13ffc5d653b23$var$state.map.immersed) {
            enableAutoLeave();
            enableMapBounds({
                signal: event.signal
            });
        }
    });
    map.on("zoomend", (event)=>{
        if (event.signal?.aborted === true) return;
        // Enable autoLeave when a zoom ends.
        // This is mostly for avoiding premature autoLeave during initial zoom
        // Also helps achieve the "any user input enables auto leave" function
        if ((event.cause === "enterMap" || event.cause === "smoothlyGoToMapPoint") && $b8e13ffc5d653b23$var$state.map.immersed) {
            enableAutoLeave();
            enableMapBounds({
                signal: event.signal
            });
        }
    });
    return [
        map,
        firstSymbolPromise
    ];
}
// There's circular dependencies
// so I'm separating all init code that requires both the map and globe into this function
// TODO: Return swapper, cameraSynchronizer
function $b8e13ffc5d653b23$var$connectMapGlobe({ GLOBE: GLOBE, map: map, resetButton: resetButton, tutorial: tutorial, firstSymbolPromise: firstSymbolPromise }) {
    // This only depends on map
    // but it's here because it's a dependency of later globe+map code
    // I could put it in initializeMap but then I'd have to return it from that function
    // and add it to this one as a parameter
    map.transform._fov = GLOBE.camera.fov * $8725869b83961a04$export$6a7ef315a0d1ef07.DEG2RAD;
    map.transform._unmodified = false;
    map.transform._calcMatrices();
    const zipLabel = new $30510d2f060a5cf8$exports.Popup({
        closeButton: false,
        closeOnClick: false,
        className: "z-2 map_zip_popup"
    });
    zipLabel.on("open", (event)=>{
        $b8e13ffc5d653b23$var$querySelectorThrow("#popup-container").append($b8e13ffc5d653b23$var$querySelectorThrow(".maplibregl-popup"));
    });
    $b8e13ffc5d653b23$var$cameraSynchronizer = new (0, $b2dc26e6bbd9abd7$export$2e2bcd8739ae039)(GLOBE.controls, map);
    GLOBE.connectCameraSynchronizer($b8e13ffc5d653b23$var$cameraSynchronizer);
    const swapper = new (0, $35c808bb5c29a6a4$export$2e2bcd8739ae039)(GLOBE, map, "fade-out", "fade-in", $b8e13ffc5d653b23$var$cameraSynchronizer);
    const { onRegionLoad: onRegionLoad, enterMap: enterMap } = $b8e13ffc5d653b23$var$createGlobeFuncs({
        zipLabel: zipLabel,
        map: map,
        resetButton: resetButton,
        swapper: swapper,
        tutorial: tutorial
    });
    // Show/hide attribution depending on whether map data is visible
    const attribution = $b8e13ffc5d653b23$var$querySelectorThrow(".maplibregl-ctrl-attrib");
    GLOBE.addEventListener("entercounties", ()=>{
        attribution.classList.remove("hidden");
    });
    GLOBE.addEventListener("regionload", (event)=>{
        $b8e13ffc5d653b23$var$state.map.visibleSoon = true;
        firstSymbolPromise.then(async ([firstSymbolId, firstLineId])=>{
            await onRegionLoad(event, firstSymbolId, firstLineId);
        }).catch((err)=>{
            console.error(err);
        });
    });
    GLOBE.addEventListener("mapclick", (event)=>{
        map.getCanvas().dispatchEvent(new PointerEvent("click", event.detail.pointerUpEvent));
    });
    GLOBE.addEventListener("mapenter", (event)=>{
        $b8e13ffc5d653b23$var$state.map.visible = true;
        $b8e13ffc5d653b23$var$state.map.visibleSoon = false;
    });
    GLOBE.addEventListener("mapleave", (event)=>{
        $b8e13ffc5d653b23$var$state.map.visible = false;
        zipLabel.remove();
    });
    GLOBE.addEventListener("regionraise", (event)=>{
        $b8e13ffc5d653b23$var$cameraSynchronizer.handleMeshRaise(event.detail);
    });
    GLOBE.getCanvas().addEventListener("mousemove", (e)=>{
        if ($b8e13ffc5d653b23$var$state.map.visible) {
            const eventCopy = new MouseEvent("mousemove", e);
            map.getCanvas().dispatchEvent(eventCopy);
        }
    });
    return [
        swapper,
        $b8e13ffc5d653b23$var$cameraSynchronizer,
        enterMap
    ];
}
async function $b8e13ffc5d653b23$var$init() {
    (0, $468000f96106f3c9$export$59448e33b5cd8368)();
    // Hook into transition events to send footer change events every frame
    let transitions = 0;
    document.addEventListener("transitionstart", (event)=>{
        transitions += 1;
    });
    document.addEventListener("transitionend", (event)=>{
        transitions -= 1;
        (0, $468000f96106f3c9$export$4fefa8b88b0d4af1)();
    });
    document.addEventListener("transitioncancel", (event)=>{
        transitions -= 1;
        (0, $468000f96106f3c9$export$4fefa8b88b0d4af1)();
    });
    function fn() {
        requestAnimationFrame(fn);
        if (transitions > 0) {
            console.log("TRANSITIONS", transitions);
            (0, $468000f96106f3c9$export$4fefa8b88b0d4af1)();
        }
    }
    fn();
    // window.addEventListener("beforeunload", (e) => {
    //     const loadingScreen = document.getElementById("loading-screen")
    //     if (loadingScreen !== null) {
    //         loadingScreen.style.visibility = "visible"
    //     }
    // })
    $b8e13ffc5d653b23$var$gpuTier = await (0, $bd03118be7dadc3f$export$3c749a0234c63713)();
    // Debug GUI stuff
    if ($b8e13ffc5d653b23$var$DEBUG) {
        $b8e13ffc5d653b23$var$gui = new (0, $5804bae86b063b2c$export$983832d820c96993)();
        $b8e13ffc5d653b23$var$gui.domElement.parentElement.style.zIndex = "1000";
        const rolloverFolder = $b8e13ffc5d653b23$var$gui.addFolder("rollover color");
        rolloverFolder.addColor($b8e13ffc5d653b23$var$settings.hoverColor, "color");
        rolloverFolder.addColor($b8e13ffc5d653b23$var$settings.hoverColor, "emissive");
        rolloverFolder.open();
    }
    $b8e13ffc5d653b23$var$fpsClock.start();
    // Glue the UI buttons to the footer
    // eslint-disable-next-line no-new
    new (0, $468000f96106f3c9$export$ceeabc2fb0f8d70f)($b8e13ffc5d653b23$var$querySelectorThrow(".btn-column.absolute.control"), document.documentElement.clientHeight - 56);
    // eslint-disable-next-line no-new
    new (0, $468000f96106f3c9$export$ceeabc2fb0f8d70f)($b8e13ffc5d653b23$var$querySelectorThrow(".walkthrough-question-mark-container"), document.documentElement.clientHeight - 65);
    // eslint-disable-next-line no-new
    new (0, $468000f96106f3c9$export$f12881f3d9af5d9)($b8e13ffc5d653b23$var$querySelectorThrow(".footer-spacer"));
    (function() {
        const _updateMatrixWorld = $8725869b83961a04$export$e4dd07dff30cc924.prototype.updateMatrixWorld;
        $8725869b83961a04$export$e4dd07dff30cc924.prototype.updateMatrixWorld = function() {
            if (this.visible === false) return;
            _updateMatrixWorld.apply(this);
        };
    })();
    $b8e13ffc5d653b23$var$scene = new $8725869b83961a04$export$38af1803e3442a7f();
    //* ======Render Settings=======*/
    const renderSettings = {
        antialias: true,
        preserveDrawingBuffer: true,
        alpha: true
    };
    if ($b8e13ffc5d653b23$var$gpuTier.isMobile === true) renderSettings.antialias = false;
    const renderHeight = document.documentElement.clientHeight;
    const renderWidth = document.documentElement.clientWidth;
    $8725869b83961a04$export$5e6fd513f44698c.enabled = false;
    $b8e13ffc5d653b23$var$renderer = new $8725869b83961a04$export$f6cc00ef28d7cf97(renderSettings);
    const container = $b8e13ffc5d653b23$var$querySelectorThrow("#globe");
    container.appendChild($b8e13ffc5d653b23$var$renderer.domElement);
    $b8e13ffc5d653b23$var$renderer.setPixelRatio(window.devicePixelRatio);
    $b8e13ffc5d653b23$var$renderer.setSize(renderWidth, renderHeight);
    $b8e13ffc5d653b23$var$renderer.toneMapping = $8725869b83961a04$export$a0d98fe6d7e4af64;
    $b8e13ffc5d653b23$var$renderer.toneMappingExposure = 1;
    // renderer.outputEncoding = THREE.sRGBEncoding
    $b8e13ffc5d653b23$var$renderer.outputColorSpace = $8725869b83961a04$export$561f394b24edfcaa;
    $b8e13ffc5d653b23$var$renderer.shadowMap.enabled = true;
    $b8e13ffc5d653b23$var$renderer.setClearColor("rgb(20, 20, 22)", 1);
    $b8e13ffc5d653b23$var$screenQuad = new $8725869b83961a04$export$e176487c05830cc5(new $8725869b83961a04$export$967d831af31f69ce(2, 2));
    $b8e13ffc5d653b23$var$screenQuad.frustumCulled = false;
    $b8e13ffc5d653b23$var$screenQuad.renderOrder = -1;
    $b8e13ffc5d653b23$var$scene.add($b8e13ffc5d653b23$var$screenQuad);
    const performanceManager = new (0, $266bd460549734c2$export$d1fdfb5c73f8786f)($b8e13ffc5d653b23$var$renderer, $b8e13ffc5d653b23$var$gpuTier);
    // Performance overlay
    if ($b8e13ffc5d653b23$var$URL_PARAMS.get("showPerfLevel") === "1") {
        $b8e13ffc5d653b23$var$gui = new (0, $5804bae86b063b2c$export$983832d820c96993)();
        $b8e13ffc5d653b23$var$gui.domElement.parentElement.style.zIndex = "1000";
        // Create performance folder
        {
            const folder = $b8e13ffc5d653b23$var$gui.addFolder("Performance");
            folder.add(performanceManager.performanceMonitorData, "currentQuality").listen();
            folder.open();
        }
        // Create renderer info folder
        {
            const folder = $b8e13ffc5d653b23$var$gui.addFolder("Renderer Info");
            folder.add($b8e13ffc5d653b23$var$renderer.info.memory, "geometries").listen();
            folder.add($b8e13ffc5d653b23$var$renderer.info.memory, "textures").listen();
            folder.add($b8e13ffc5d653b23$var$renderer.info.render, "calls").listen();
            folder.add($b8e13ffc5d653b23$var$renderer.info.render, "triangles").listen();
            folder.add($b8e13ffc5d653b23$var$renderer.info.render, "points").listen();
            folder.add($b8e13ffc5d653b23$var$renderer.info.render, "lines").listen();
            folder.add($b8e13ffc5d653b23$var$renderer.info.render, "frame").listen();
            folder.open();
        }
        {
            const folder = $b8e13ffc5d653b23$var$gui.addFolder("Shadows");
            folder.add($b8e13ffc5d653b23$var$renderer.shadowMap, "enabled").listen();
        }
    }
    const resetButton = $b8e13ffc5d653b23$var$querySelectorThrow("#globe_reset_button");
    const tutorial = new (0, $272f31bde53b6e17$export$2e01aa4c1d0ac16b)();
    // TODO: Extract logic that isn't explicitly tutorial-related from these tutorial event handlers
    // On tutorial county explanation
    tutorial.addEventListener("countyexplanation", ()=>{
        // Minimize walkthrough ui
        // querySelectorThrow(".how-it-works").classList.add("minimized")
        // querySelectorThrow(
        //     ".walkthrough-question-mark-container"
        // ).classList.add("minimized")
        // // Fade out "build your ballot" text
        // querySelectorThrow(".build-your-ballot-wrapper").classList.add(
        //     "fade-out"
        // )
        // Hide left panel
        $b8e13ffc5d653b23$var$GLOBE.leftPanel.hide();
        // Slide canvas back in place
        $b8e13ffc5d653b23$var$querySelectorThrow("#popup-container").classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$querySelectorThrow("#map").classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.canvas.classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.labelRenderer.domElement.classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.globe_svg_container.classList.remove("nudge-right");
    });
    // On tutorial zip explanation
    tutorial.addEventListener("zipexplanation", ()=>{
        // Show left panel
        $b8e13ffc5d653b23$var$GLOBE.leftPanel.show();
        // Slide canvas to the right to keep globe elements centered
        $b8e13ffc5d653b23$var$querySelectorThrow("#popup-container").classList.add("nudge-right");
        $b8e13ffc5d653b23$var$querySelectorThrow("#map").classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.canvas.classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.labelRenderer.domElement.classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.globe_svg_container.classList.add("nudge-right");
    });
    // On tutorial reset
    tutorial.addEventListener("reset", ()=>{
        // Maximize walkthrough ui
        // querySelectorThrow(".how-it-works").classList.remove("minimized")
        // querySelectorThrow(
        //     ".walkthrough-question-mark-container"
        // ).classList.remove("minimized")
        // // Bring back "build your ballot" text
        // querySelectorThrow(".build-your-ballot-wrapper").classList.remove(
        //     "fade-out"
        // )
        // Hide left panel
        $b8e13ffc5d653b23$var$GLOBE.leftPanel.hide();
        // Slide canvas back in place
        $b8e13ffc5d653b23$var$querySelectorThrow("#popup-container").classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$querySelectorThrow("#map").classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.canvas.classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.labelRenderer.domElement.classList.remove("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.globe_svg_container.classList.remove("nudge-right");
    });
    $b8e13ffc5d653b23$var$TEXTURE_INITIALIZER = new (0, $2492d6dd6dfc23ba$export$b500149b4779ac29)($b8e13ffc5d653b23$var$renderer, 2);
    (0, $95298b233eb5daae$export$34863fc904f5f35f)(tutorial);
    const camera = new $8725869b83961a04$export$74e4ae24825f68d7(40, 1, 0.03, 300);
    $b8e13ffc5d653b23$var$GLOBE = new (0, $145f47ad8b66c035$export$3bc50e457b7f164b)($b8e13ffc5d653b23$var$scene, $b8e13ffc5d653b23$var$renderer.domElement, resetButton, performanceManager, $b8e13ffc5d653b23$var$gpuTier, $b8e13ffc5d653b23$var$settings, $b8e13ffc5d653b23$var$TEXTURE_INITIALIZER, tutorial, camera);
    const globeInteractivePromise = new Promise((resolve)=>{
        window.addEventListener("globeinteractive", resolve, {
            once: true
        });
    });
    /// //////////////////
    // Set up maplibregl
    /// //////////////////
    function doMapSetup() {
        let firstSymbolPromise;
        {
            const ret = $b8e13ffc5d653b23$var$initializeMap({
                returnToGlobePopup: $b8e13ffc5d653b23$var$returnToGlobePopup,
                resetButton: resetButton,
                enableAutoLeave: $b8e13ffc5d653b23$var$enableAutoLeave,
                enableMapBounds: $b8e13ffc5d653b23$var$enableMapBounds
            });
            // Set global variable
            $b8e13ffc5d653b23$var$map = ret[0];
            firstSymbolPromise = ret[1];
        }
        let enterMap;
        // Set up everything that requires both map and globe
        {
            const ret = $b8e13ffc5d653b23$var$connectMapGlobe({
                GLOBE: $b8e13ffc5d653b23$var$GLOBE,
                map: $b8e13ffc5d653b23$var$map,
                resetButton: resetButton,
                tutorial: tutorial,
                firstSymbolPromise: firstSymbolPromise
            });
            // Set global variables
            $b8e13ffc5d653b23$var$swapper = ret[0];
            $b8e13ffc5d653b23$var$cameraSynchronizer = ret[1];
            enterMap = ret[2];
        }
        return enterMap;
    }
    const historyState = (0, $ed93617e655b9b33$export$f4895e37fc87f733)(window.location.href);
    let enterMapPromise;
    if (historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).map) // If we're in a map state, immediately set up map
    enterMapPromise = Promise.resolve(doMapSetup());
    else // If we're in a globe state, defer map load until after globe is interactive
    // Reduces apparent load time
    enterMapPromise = globeInteractivePromise.then(doMapSetup);
    $b8e13ffc5d653b23$var$initFromURLParams($b8e13ffc5d653b23$var$GLOBE, {
        enterMapPromise: enterMapPromise,
        tutorial: tutorial
    });
    // This is for debug-purposes only
    window.swapper = $b8e13ffc5d653b23$var$swapper;
    // Add screen quad
    $8725869b83961a04$export$94affb487e701bf2.enabled = true;
    Promise.all([
        fetch("/assets/shaders/screenquad.vert").then(async (response)=>await response.text()),
        fetch("/assets/shaders/screenquad.frag").then(async (response)=>await response.text()),
        new Promise((resolve, reject)=>{
            const texture = new $8725869b83961a04$export$5431306cf43de24a();
            const img = document.querySelector("#globeBackgroundImagePreload");
            texture.image = img;
            texture.needsUpdate = true;
            resolve(texture);
        })
    ]).then(([vert, frag, tex])=>{
        const uniforms = {
            tex: {
                type: "t",
                value: tex
            },
            aspect: {
                type: "f",
                // Hardcoded to avoid an issue where this code was run before the image fully loaded,
                // causing a NaN to get passed into the shader, which caused the image to display as vertical bars.
                // This will have to be changed manually if the image is updated
                // Or you could write some code that handles the case where the image isn't fully loaded and updates the uniform when the image gets loaded :)
                // value: tex.image.width / tex.image.height,
                value: 1920 / 1080
            },
            screenAspect: {
                type: "f",
                value: $b8e13ffc5d653b23$var$GLOBE.camera.aspect
            }
        };
        const mat = new $8725869b83961a04$export$83c7d75d550a8b0d({
            vertexShader: vert,
            fragmentShader: frag,
            depthWrite: false,
            depthTest: false,
            uniforms: uniforms
        });
        $b8e13ffc5d653b23$var$screenQuad.material = mat;
    // Set clear color to transparent
    // This allows the map to be seen under the globe canvas
    // renderer.setClearColor(0, 0)
    }).catch((err)=>{
        console.error(err);
    });
    /* = =====Light======= */ const light = new $8725869b83961a04$export$af279bfef9ec2c96(0x161718, 15) // soft white light
    ;
    light.position.set(0, 75, 0);
    $b8e13ffc5d653b23$var$scene.add(light);
    // container.style.touchAction = "none"
    window.addEventListener("resize", $b8e13ffc5d653b23$var$onWindowResize, false);
    const canvas = $b8e13ffc5d653b23$var$querySelectorThrow("canvas");
    const aspectRatio = document.documentElement.clientWidth / document.documentElement.clientHeight;
    if (aspectRatio < 1.55) canvas.classList.add("tall");
    else canvas.classList.remove("tall");
    $b8e13ffc5d653b23$var$animate(0);
}
function $b8e13ffc5d653b23$var$readURLParams(url) {
    // make sure url is always type URL
    if (typeof url === "string") url = new URL(url);
    const search = url.searchParams;
    const params = {};
    const paramShapeData = [
        {
            key: "fips"
        },
        {
            key: "lng",
            transformer: (p)=>parseFloat(p ?? "")
        },
        {
            key: "lat",
            transformer: (p)=>parseFloat(p ?? "")
        },
        {
            key: "county"
        },
        {
            key: "state"
        },
        {
            key: "district_id"
        },
        {
            key: "election_filter"
        },
        {
            key: "election_type"
        },
        {
            key: "ballot_screenshot_mode"
        },
        {
            key: "animated",
            transformer: (p)=>p === "true"
        }
    ];
    paramShapeData.forEach((shape)=>{
        if (search.has(shape.key)) {
            const value = shape.transformer != null ? shape.transformer(search.get(shape.key)) : search.get(shape.key);
            params[shape.key] = value;
        }
    });
    return params;
}
async function $b8e13ffc5d653b23$var$initFromURLParams(globe, options) {
    const params = $b8e13ffc5d653b23$var$readURLParams(window.location.href);
    // Process URL params
    globe.ballot_screenshot_mode = params.ballot_screenshot_mode !== undefined ? params.ballot_screenshot_mode : null;
    let usState = params.state;
    /* Calculate usState from URL params */ if (params.fips !== undefined) {
        // Get just the state part of the fips, ie. 01 from 01023
        const stateFips = params.fips.substring(0, 2);
        if (Object.keys((0, $12d34f3c78180d6b$export$b4c789cd45f7243f)).includes(stateFips)) usState = (0, $12d34f3c78180d6b$export$b4c789cd45f7243f)[stateFips].name;
    } else if (usState !== undefined && !Object.keys((0, $12d34f3c78180d6b$export$c84b72fba115a40e)).includes(usState)) {
        // Treat state like it's an abbreviation
        if (usState in (0, $12d34f3c78180d6b$export$37abc93a7593198c)) usState = (0, $12d34f3c78180d6b$export$37abc93a7593198c)[usState].name;
        else usState = "";
    }
    /* Set initial history state */ const historyState = (0, $ed93617e655b9b33$export$f4895e37fc87f733)(window.location.href);
    if (history.state === null) {
        historyState.prev = null;
        history.replaceState(historyState, "", (0, $ed93617e655b9b33$export$71e6d8acbd6e437c)(historyState));
    }
    /* Set globe state */ if (historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).initial) // Case: initial load
    // Swing the camera towards the USA
    globe.controls.focus(new $8725869b83961a04$export$64b5c384219d3699(0, 51, 1.5), {
        animated: false
    });
    else if (historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).globe || historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).map) {
        if (params.animated === true) {
            if (params.lat === undefined || params.lng === undefined) {
                console.error({
                    params: params
                }, "lat or lng was undefined");
                return;
            }
            if (isNaN(params.lat) || isNaN(params.lng)) {
                console.error({
                    params: params
                }, "lat or lng was NaN");
                return;
            }
            if (usState === undefined) throw new Error("No state search param");
            const county = params.county;
            if (county === undefined) throw new Error("No county search param");
            // globe.controls.setPolarAngle(params.lat * DEG2RAD)
            // globe.controls.setAzimuthalAngle(params.lng * DEG2RAD)
            const polar = (0, $b2dc26e6bbd9abd7$export$2aad8d5c978c5be9)(params.lat);
            const azimuthal = (0, $b2dc26e6bbd9abd7$export$232fe3c2ac5cbf38)(params.lng);
            globe.controls.setAzimuthalAngle(azimuthal);
            globe.controls.setPolarAngle(polar);
            // Wait till both countries and states are loaded before zooming in
            await globe.loadStatesPromise;
            await globe.loadCountriesPromise;
            // Wait just a bit extra for good measure
            await new Promise((resolve)=>{
                setTimeout(resolve, 100);
            });
            window.smoothlyGoToMapPoint(params.lat, params.lng, 13.14, county, usState, {
                modifyHistory: true
            });
            return;
        }
        // Case: county or zip mode
        // Set "state clicked" state variable
        globe.state.aStateHasBeenClicked = true;
        // Globe loads states and countries by itself during constructor
        // Wait till the state list and states are loaded, then load counties
        const countyLoadPromise = Promise.all([
            globe.loadStatesPromise,
            globe.addStateListPromise
        ]).then(async (results)=>{
            const stateMesh = globe.getStateByName(usState);
            /* Put state list into state mode */ const list = document.querySelector(".state_list");
            if (list === null) {
                console.error("State list was null");
                return;
            }
            list.classList.remove("hidden");
            const button = document.querySelector(`.state_list ul li#${stateMesh.userData.abbr}`);
            if (button === null) {
                console.error("Button with abbr not found");
                return;
            }
            button.classList.add("highlighted");
            setTimeout(()=>{
                (0, $13b202410cedebbf$export$7e4b7e6b8ee74890)("state_list");
            }, 1000);
            /* Load counties */ const doZoom = params.fips !== undefined && (params.fips === null || params.fips === "" || !(params.fips.length === 5));
            const [loadCountiesPromise, raisePromise] = // County list is replaced by state list here
            globe.loadCountiesWithRaisePromise(stateMesh, doZoom, {
                modifyHistory: false,
                modifyTutorial: historyState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).globe
            });
            globe.loadCountiesPromise = loadCountiesPromise;
            return await Promise.all([
                loadCountiesPromise,
                raisePromise
            ]);
        }).then((gltf)=>{
            if (params.fips === null || params.fips === "" || params.fips === undefined) return;
            if (gltf === null || gltf === undefined) return;
            /* load zips */ if (params.fips.length === 5) // Load zip
            globe.COUNTY_GROUP.traverse((obj)=>{
                if (!(obj instanceof $8725869b83961a04$export$e176487c05830cc5)) return;
                if (obj.name === params.fips) globe.loadZips(obj, {
                    modifyHistory: false
                });
            });
        }).catch((err)=>{
            console.error(err);
            throw err;
        });
        /* End of globe mode stuff, now do map mode */ if (historyState.type !== (0, $ed93617e655b9b33$export$8a87ade5aef88514).map) return;
        if (params.lat === undefined || params.lng === undefined) {
            console.error({
                params: params
            }, "lat or lng was undefined");
            return;
        }
        if (isNaN(params.lat) || isNaN(params.lng)) {
            console.error({
                params: params
            }, "lat or lng was NaN");
            return;
        }
        if (usState === undefined) throw new Error("No state search param");
        const county = params.county;
        if (county === undefined) throw new Error("No county search param");
        if (usState.length === 2) {
            usState = (0, $12d34f3c78180d6b$export$37abc93a7593198c)[usState].name;
            if (usState === null) throw new Error("couldn't find state fips by abbr");
        }
        const abbr = (0, $12d34f3c78180d6b$export$c84b72fba115a40e)[usState].abbr;
        const zoom = 13.24;
        // This won't be available until both the map and the globe have been initialized
        const enterMap = await options.enterMapPromise;
        // Swapper gets initialized w/ map
        $b8e13ffc5d653b23$var$swapper.swapToMapImmediately();
        $b8e13ffc5d653b23$var$map.jumpTo({
            center: [
                params.lng,
                params.lat
            ],
            zoom: zoom
        });
        enterMap({
            lat: params.lat,
            lng: params.lng,
            zoom: 13.24,
            usCounty: county,
            usState: usState,
            doFlyTo: true,
            boundKind: 2,
            waitForZoomToBoundMap: false,
            modifyHistory: false
        });
        // Go straight to the map page
        $b8e13ffc5d653b23$var$enableAutoLeave();
        $b8e13ffc5d653b23$var$GLOBE.leftPanel.show();
        const ring = $b8e13ffc5d653b23$var$querySelectorThrow(".globe_ring");
        ring.style.transform = "translate(-50%, -50%) scale(100) rotate(30.96deg)";
        // Show attribution
        const attribution = $b8e13ffc5d653b23$var$querySelectorThrow(".maplibregl-ctrl-attrib");
        attribution.classList.remove("hidden");
        // Show bottom bar
        const navList = $b8e13ffc5d653b23$var$querySelectorThrow(".navigation_list");
        // Slide canvas to the right to keep globe elements centered
        $b8e13ffc5d653b23$var$querySelectorThrow("#popup-container").classList.add("nudge-right");
        $b8e13ffc5d653b23$var$querySelectorThrow("#map").classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.canvas.classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.labelRenderer.domElement.classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.globe_svg_container.classList.add("nudge-right");
        $b8e13ffc5d653b23$var$GLOBE.addStateListPromise.then(async ()=>{
            // County list is first added here
            await countyLoadPromise;
        }).then(async ()=>{
            return await (0, $13b202410cedebbf$export$a3be6965b053c4b2)(abbr);
        }).then(async ()=>{
            try {
                const prevSelected = $b8e13ffc5d653b23$var$querySelectorThrow(".county_list .selected");
                prevSelected?.classList.remove("selected");
            } catch (e) {
            // console.error(e)
            }
            const ele = $b8e13ffc5d653b23$var$querySelectorThrow(`li#${CSS.escape(county)}`);
            if (ele != null) {
                ele.classList.add("selected");
                navList.classList.remove("hidden");
                $b8e13ffc5d653b23$var$querySelectorThrow("#loaded").classList.remove("hidden");
                (0, $13b202410cedebbf$export$7e4b7e6b8ee74890)("county_list");
            }
            $b8e13ffc5d653b23$var$GLOBE.dispatchFooterChangeEvent();
            return await Promise.all([
                $b8e13ffc5d653b23$var$GLOBE.loadStatesPromise,
                $b8e13ffc5d653b23$var$GLOBE.addStateListPromise
            ]);
        }).then(async ()=>{
            return await $b8e13ffc5d653b23$var$GLOBE.loadCountiesPromise;
        }).then(()=>{
            // cameraSynchronizer.syncGlobe()
            // GLOBE.animate(1000000000)
            // Cancel all tweens
            // GLOBE.scene.traverse((object) => {
            //     try {
            //         getTweenGroup(object)
            //             .getAll()
            //             .forEach((tween) => {
            //                 tween.end()
            //             })
            //     } catch {}
            // })
            // GLOBE.ANIMATIONS.killAll()
            $b8e13ffc5d653b23$var$GLOBE.state.aStateHasBeenClicked = true;
            $b8e13ffc5d653b23$var$GLOBE.state.zoomLevel = 1;
            // Lower states to their flat state
            $b8e13ffc5d653b23$var$GLOBE.STATE_GROUP.children.forEach((child)=>{
                child.scale.copy(child.userData.loweredScale);
                child.userData.state = "lowered";
            });
            // Set up county list callbacks
            document.querySelectorAll(".county_list li").forEach((element)=>{
                const a = element.querySelector("span");
                const fips = element.getAttribute("fips");
                if (fips === null) {
                    console.error("Could not get fips attribute from list element");
                    return;
                }
                const mesh = $b8e13ffc5d653b23$var$GLOBE.getMeshByFips(fips);
                if (mesh === null) {
                    console.error("Could not get mesh associated with fips");
                    return;
                }
                if (a === null) throw new ReferenceError("County list anchor element not found");
                a.addEventListener("mouseover", (event)=>{
                    $b8e13ffc5d653b23$var$GLOBE.highlight(mesh);
                });
                a.addEventListener("mouseout", (event)=>{
                    $b8e13ffc5d653b23$var$GLOBE.unhighlight(mesh);
                });
                a.addEventListener("click", (event)=>{
                    $b8e13ffc5d653b23$var$cameraSynchronizer.syncGlobe();
                    $b8e13ffc5d653b23$var$GLOBE.animate(100000000);
                    $b8e13ffc5d653b23$var$GLOBE.loadZips(mesh);
                    options.tutorial.state.send("LEAVE_MAP");
                });
            });
        }).catch((err)=>{
            console.log(err);
        });
    }
}
function $b8e13ffc5d653b23$var$getLabelPositions(geojson, precision) {
    // Type check
    if (geojson.type !== "FeatureCollection") {
        console.warn("getLabelPositions: geojson type was not FeatureCollection", geojson.type);
        return null;
    }
    const labelPositions = new Map();
    geojson.features.forEach((feature)=>{
        if (feature.geometry.type === "Polygon") labelPositions.set(feature.properties.GEOID20, (0, (/*@__PURE__*/$parcel$interopDefault($7xV53)))(feature.geometry.coordinates, precision));
        if (feature.geometry.type !== "MultiPolygon") return null;
        // Find the polylabel of the biggest polygon
        const areas = feature.geometry.coordinates.map((coords)=>(0, $90031fd84727d8f8$export$2e2bcd8739ae039)(coords));
        const biggest = areas.reduce((acc, area, index)=>{
            if (area > acc.area) {
                acc.area = area;
                acc.index = index;
            }
            return acc;
        }, {
            area: -1,
            index: -1
        });
        if (biggest.index === -1) {
            console.warn("Zero-area zip code found at county", feature.properties.GEOID, "at zip", feature.properties.GEOID20);
            return null;
        }
        labelPositions.set(feature.properties.GEOID20, (0, (/*@__PURE__*/$parcel$interopDefault($7xV53)))(feature.geometry.coordinates[biggest.index], precision));
    });
    return labelPositions;
}
// TODO: Refactor so this returns relevant functions and doesn't need extraneous parameters
// A lot of the logic in here should be external
// Some functions it should return: reset, smoothlyGoToMapPoint
function $b8e13ffc5d653b23$var$createGlobeFuncs({ zipLabel: zipLabel, map: map, resetButton: resetButton, swapper: swapper, tutorial: tutorial }) {
    let lastLoad = null;
    let lastLoaded = null;
    let hoveredStateId = null;
    let labelPositions = null;
    $b8e13ffc5d653b23$var$waitAndSetUpUICallbacks(0, {
        tutorial: tutorial
    });
    const onMouseEnterZip = function(zip) {
        const labelPos = labelPositions?.get(zip);
        // TODO: Find solution for zips with no geometry
        if (labelPos != null) zipLabel.setLngLat(labelPos).setHTML(zip).addTo(map);
    };
    function clearMap() {
        if (lastLoaded !== null) {
            const { id: id } = lastLoaded;
            map.offAll();
            // Remove zips
            map.removeLayer(`${id}-fills`);
            map.removeLayer(`${id}-borders`);
            lastLoad = null;
            lastLoaded = null;
            hoveredStateId = null;
            labelPositions = null;
            map.removeSource(id);
            try {
                $b8e13ffc5d653b23$var$disableMapBounds();
            } catch (err) {
                console.error(err);
            }
        }
        if (typeof map.getLayer("county-cutout") !== "undefined") {
            map.removeLayer("county-cutout");
            map.removeSource("county-cutout");
        }
        $b8e13ffc5d653b23$var$returnToGlobePopup.remove();
        zipLabel.remove();
    }
    function reset() {
        smoothlyGoToMapPointAbortController.abort("reset");
        clearMap();
        // Hide OSM left panel elements
        $b8e13ffc5d653b23$var$querySelectorThrow("#filter-row").classList.add("hidden");
        $b8e13ffc5d653b23$var$querySelectorThrow("#district-list").classList.add("hidden");
        $b8e13ffc5d653b23$var$querySelectorThrow("#election-overview-div").classList.add("hidden");
        $b8e13ffc5d653b23$var$querySelectorThrow("#filters").classList.add("hidden");
        (0, $95298b233eb5daae$export$aad8462122ac592b)(map);
        // Show Globe left panel elements
        $b8e13ffc5d653b23$var$querySelectorThrow("#left-panel-header").classList.remove("hidden");
        $b8e13ffc5d653b23$var$querySelectorThrow("#zip-code-container").classList.remove("hidden");
        $b8e13ffc5d653b23$var$state.map.immersed = false;
        $b8e13ffc5d653b23$var$state.map.visible = false;
        $b8e13ffc5d653b23$var$state.map.visibleSoon = false;
    }
    window.addEventListener("popstate", (event)=>{
        console.log({
            event: event,
            prevState: (0, $ed93617e655b9b33$export$d140a9f6968c1121)()
        }, "popstate");
        if ((0, $ed93617e655b9b33$export$4f1147583dbb39cb)()) {
            (0, $ed93617e655b9b33$export$5cef967c927bea35)();
            return;
        }
        const prevState = (0, $ed93617e655b9b33$export$d140a9f6968c1121)();
        if (event.state.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).initial || event.state.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).globe && prevState !== null && prevState.type === (0, $ed93617e655b9b33$export$8a87ade5aef88514).map) {
            reset();
            swapper.swapToGlobe();
        }
        $b8e13ffc5d653b23$var$GLOBE.setFromHistoryState(event.state, false);
        (0, $ed93617e655b9b33$export$7d129b75de5d16aa)(event.state);
    });
    function enterMap(options) {
        const { lat: lat, lng: lng, zoom: zoom, usCounty: usCounty, usState: usState, doFlyTo: doFlyTo = true, boundKind: boundKind = 1, waitForZoomToBoundMap: waitForZoomToBoundMap = true, modifyHistory: modifyHistory = true, signal: signal } = options;
        tutorial.state.send("ENTER_MAP");
        clearMap();
        // We start at a high enough zoom level to trigger autoLeave, so we want to disable it until the initial zoom finishes.
        $b8e13ffc5d653b23$var$disableAutoLeave();
        $b8e13ffc5d653b23$var$state.map.immersed = true;
        $b8e13ffc5d653b23$var$state.map.visible = true;
        if (modifyHistory) {
            const historyState = (0, $ed93617e655b9b33$export$4f66cbedd33211f4)({
                lon: lng,
                lat: lat,
                usCounty: usCounty,
                usState: usState,
                districtId: "null",
                electionFilter: "null",
                electionType: 0
            });
            (0, $ed93617e655b9b33$export$a104c684a09de9be)(historyState);
        }
        (0, $95298b233eb5daae$export$2b560c01ee33d8d0)(map);
        swapper.swapToMap();
        // if (boundKind === BoundKind.COUNTY) {
        //     const county = GLOBE.INDIVIDUAL_COUNTY
        //     if (county === null) {
        //         throw new Error(xd
        //             "enterMap called with boundKind of COUNTY but GLOBE.INDIVIDUAL_COUNTY was null"
        //         )
        //     }
        //     boundMap(county)
        // }
        if (doFlyTo) // Delay one frame as a workaround for the animation being cancelled on mobile
        // TODO: Figure out why this is necessary on mobile
        setTimeout(()=>{
            if (signal?.aborted === true) return;
            const point = (0, $3e645b0309771ac1$export$58d8663b36235b13)({
                point: {
                    lng: lng,
                    lat: lat
                },
                map: map,
                zoom: zoom
            });
            map.flyTo({
                center: point,
                zoom: zoom
            }, {
                cause: "enterMap",
                signal: signal
            });
        }, 50);
        // Add inverted county polygon
        const promise = (0, $95298b233eb5daae$export$2d678771816e1c96)(lat, lng, map, {
            modifyHistory: modifyHistory,
            signal: signal
        }).then((data)=>{
            signal?.throwIfAborted();
            let foundPolygon = null;
            data.payload.forEach((district)=>{
                if (district.type === "State District") {
                    const polygon = JSON.parse(district.polygon);
                    const inverted = (0, $5cdfe2a3ab2113ff$export$c9170f63127e2182)(polygon, 30);
                    map.addSource("county-cutout", {
                        type: "geojson",
                        data: inverted
                    });
                    map.addLayer({
                        id: "county-cutout",
                        type: "fill",
                        source: "county-cutout",
                        layout: {},
                        paint: {
                            "fill-color": "#444",
                            "fill-opacity": 0.8
                        }
                    });
                    foundPolygon = polygon;
                }
            });
            if (foundPolygon === null) throw new Error("State District not found in payload");
            return foundPolygon;
        }).catch((err)=>{
            console.warn({
                err: err
            }, "handleLatLngClick aborted");
        // map.stop()
        });
        // if (boundKind === BoundKind.POLYGON) {
        $b8e13ffc5d653b23$var$boundMap(promise, {
            signal: signal
        });
        if (!waitForZoomToBoundMap) $b8e13ffc5d653b23$var$enableMapBounds({
            signal: signal
        });
        // }
        // Show OSM left panel elements
        $b8e13ffc5d653b23$var$querySelectorThrow("#filter-row").classList.remove("hidden");
        $b8e13ffc5d653b23$var$querySelectorThrow("#district-list").classList.remove("hidden");
        // Hide Globe left panel elements
        $b8e13ffc5d653b23$var$querySelectorThrow("#left-panel-header").classList.add("hidden");
        $b8e13ffc5d653b23$var$querySelectorThrow("#zip-code-container").classList.add("hidden");
    }
    let smoothlyGoToMapPointAbortController = new AbortController();
    // misc.js uses this to zoom into the map when a search bar entry is clicked
    async function smoothlyGoToMapPoint(lat, lng, zoom, usCounty, usState, options) {
        if (typeof lat === "string") lat = parseFloat(lat);
        else if (typeof lat !== "number") throw new TypeError("lat was not the correct type");
        if (typeof lng === "string") lng = parseFloat(lng);
        else if (typeof lng !== "number") throw new TypeError("lng was not the correct type");
        const defaultOptions = {
            modifyHistory: true
        };
        if (options === undefined) options = defaultOptions;
        if (usState.length === 2) usState = (0, $12d34f3c78180d6b$export$37abc93a7593198c)[usState].name;
        smoothlyGoToMapPointAbortController.abort("New smoothlyGoToMapPoint started");
        smoothlyGoToMapPointAbortController = new AbortController();
        const signal = smoothlyGoToMapPointAbortController.signal;
        const abbr = (0, $12d34f3c78180d6b$export$c84b72fba115a40e)[usState].abbr;
        if ($b8e13ffc5d653b23$var$state.map.immersed) {
            // Case: We're already in the map
            // Disable map bounds while we fly
            $b8e13ffc5d653b23$var$disableMapBounds();
            try {
                map.removeLayer("county-cutout");
                map.removeSource("county-cutout");
            } catch (err) {
                console.error(err);
            }
            $b8e13ffc5d653b23$var$returnToGlobePopup.remove();
            // flyTo can cause us to zoom out far enough that autoLeave is triggered, so we disable it until the zoom finishes.
            $b8e13ffc5d653b23$var$disableAutoLeave();
            const point = (0, $3e645b0309771ac1$export$58d8663b36235b13)({
                point: {
                    lng: lng,
                    lat: lat
                },
                map: map,
                zoom: 13.24
            });
            // TODO: Abort (not sure about this one)
            map.flyTo({
                center: point,
                zoom: 13.24
            }, {
                cause: "smoothlyGoToMapPoint",
                signal: signal
            });
            (0, $95298b233eb5daae$export$2d678771816e1c96)(lat, lng, map, {
                modifyHistory: options.modifyHistory,
                signal: signal
            }).then((data)=>{
                signal.throwIfAborted();
                data.payload.forEach((district)=>{
                    if (district.type === "State District") {
                        const polygon = JSON.parse(district.polygon);
                        const inverted = (0, $5cdfe2a3ab2113ff$export$c9170f63127e2182)(polygon, 30);
                        map.addSource("county-cutout", {
                            type: "geojson",
                            data: inverted
                        });
                        map.addLayer({
                            id: "county-cutout",
                            type: "fill",
                            source: "county-cutout",
                            layout: {},
                            paint: {
                                "fill-color": "#444",
                                "fill-opacity": 0.8
                            }
                        });
                        $b8e13ffc5d653b23$var$boundMap(polygon, {
                            signal: signal
                        });
                    }
                });
            }).catch((err)=>{
                console.error(err);
            });
            $b8e13ffc5d653b23$var$GLOBE.loadCounties(usState, false, {
                modifyHistory: false,
                modifyTutorial: false,
                signal: signal
            }).catch((err)=>{
                console.error(err);
            });
        } else if ($b8e13ffc5d653b23$var$state.map.visible) {
            // Case: We're at the zip code level (map is visible, but still in the globe)
            // Use BoundKind.POLYGON to indicate that we should bound the map based on Junior's GeoJSON county polygon
            // TODO: Abort
            enterMap({
                lat: lat,
                lng: lng,
                zoom: zoom,
                usCounty: usCounty,
                usState: usState,
                doFlyTo: true,
                boundKind: 2,
                waitForZoomToBoundMap: true,
                modifyHistory: options.modifyHistory,
                signal: signal
            });
            if (abbr === $b8e13ffc5d653b23$var$GLOBE.COUNTY_GROUP.userData.abbr) return;
        } else {
            // Case: We're in any other globe layer
            // Begin preloading the map
            $b8e13ffc5d653b23$var$cameraSynchronizer.syncMap();
            $b8e13ffc5d653b23$var$state.map.visibleSoon = true;
            if ($b8e13ffc5d653b23$var$GLOBE.areCountiesLoaded()) {
                $b8e13ffc5d653b23$var$GLOBE.leftPanel.show();
                enterMap({
                    lat: lat,
                    lng: lng,
                    zoom: zoom,
                    usCounty: usCounty,
                    usState: usState,
                    doFlyTo: true,
                    signal: signal
                });
            } else {
                $b8e13ffc5d653b23$var$GLOBE.controls.setExtraThetaOffset(0);
                $b8e13ffc5d653b23$var$GLOBE.controls.setMinDistance(53.2);
                $b8e13ffc5d653b23$var$GLOBE.controls.focusLngLat(lng, lat, 2);
                await new Promise((resolve)=>setTimeout(resolve, 750));
                signal.throwIfAborted();
                $b8e13ffc5d653b23$var$GLOBE.leftPanel.show();
                enterMap({
                    lat: lat,
                    lng: lng,
                    zoom: zoom,
                    usCounty: usCounty,
                    usState: usState,
                    doFlyTo: true,
                    boundKind: 2,
                    signal: signal
                });
            }
            // UI management
            $b8e13ffc5d653b23$var$querySelectorThrow(".navigation_list").classList.remove("hidden");
            const list = $b8e13ffc5d653b23$var$querySelectorThrow(".state_list");
            list.classList.remove("hidden");
            const button = $b8e13ffc5d653b23$var$querySelectorThrow(`.state_list ul li#${abbr}`);
            button.classList.add("highlighted");
            // TODO: Abort
            setTimeout(()=>{
                if (signal.aborted) return;
                (0, $13b202410cedebbf$export$7e4b7e6b8ee74890)("state_list");
            }, 1000);
            // Show attribution
            const attribution = $b8e13ffc5d653b23$var$querySelectorThrow(".maplibregl-ctrl-attrib");
            attribution.classList.remove("hidden");
        }
        const navList = $b8e13ffc5d653b23$var$querySelectorThrow(".navigation_list");
        // TODO: Abort
        await new Promise((resolve)=>setTimeout(resolve, 2500));
        signal.throwIfAborted();
        Promise.all([
            $b8e13ffc5d653b23$var$GLOBE.loadStatesPromise,
            $b8e13ffc5d653b23$var$GLOBE.addStateListPromise
        ])// TODO: Abort
        .then(async ()=>{
            signal.throwIfAborted();
            // TODO: Abort
            await $b8e13ffc5d653b23$var$GLOBE.loadCounties(usState, false, {
                modifyHistory: false,
                modifyTutorial: false,
                signal: signal
            }).catch((err)=>{
                console.log(err);
            });
        })// TODO: Abort
        .then(async ()=>{
            signal.throwIfAborted();
            // Slide canvas to the right to keep globe elements centered
            $b8e13ffc5d653b23$var$querySelectorThrow("#popup-container").classList.add("nudge-right");
            $b8e13ffc5d653b23$var$querySelectorThrow("#map").classList.add("nudge-right");
            $b8e13ffc5d653b23$var$GLOBE.canvas.classList.add("nudge-right");
            $b8e13ffc5d653b23$var$GLOBE.labelRenderer.domElement.classList.add("nudge-right");
            $b8e13ffc5d653b23$var$GLOBE.globe_svg_container.classList.add("nudge-right");
            // TODO: Abort
            return await (0, $13b202410cedebbf$export$a3be6965b053c4b2)(abbr);
        }).then(()=>{
            signal.throwIfAborted();
            try {
                const prevSelected = $b8e13ffc5d653b23$var$querySelectorThrow(".county_list .selected");
                prevSelected.classList.remove("selected");
            } catch (e) {
                console.log(e);
            }
            const ele = $b8e13ffc5d653b23$var$querySelectorThrow("li[id='" + usCounty + "']");
            if (ele != null) {
                ele.classList.add("selected");
                navList.classList.remove("hidden");
                $b8e13ffc5d653b23$var$querySelectorThrow("#loaded").classList.remove("hidden");
                (0, $13b202410cedebbf$export$7e4b7e6b8ee74890)("county_list");
            }
            $b8e13ffc5d653b23$var$GLOBE.dispatchFooterChangeEvent();
        }).then(()=>{
            signal.throwIfAborted();
            // Set up county list callbacks
            document.querySelectorAll(".county_list li").forEach((element)=>{
                const a = element.querySelector("span");
                if (a === null) throw new Error("Nav list li did not have an anchor");
                const fips = element.getAttribute("fips");
                if (fips === null) {
                    console.error("List element did not have fips attribute");
                    return;
                }
                const mesh = $b8e13ffc5d653b23$var$GLOBE.getMeshByFips(fips);
                if (mesh === null) {
                    console.error("Could not get mesh by fips");
                    return;
                }
                a.addEventListener("mouseover", (event)=>{
                    $b8e13ffc5d653b23$var$GLOBE.highlight(mesh);
                });
                a.addEventListener("mouseout", (event)=>{
                    $b8e13ffc5d653b23$var$GLOBE.unhighlight(mesh);
                });
                a.addEventListener("click", (event)=>{
                    $b8e13ffc5d653b23$var$cameraSynchronizer.master = "globe";
                    $b8e13ffc5d653b23$var$cameraSynchronizer.syncGlobe();
                    $b8e13ffc5d653b23$var$GLOBE.animate(100000000);
                    // TODO: Abort?
                    $b8e13ffc5d653b23$var$GLOBE.loadZips(mesh);
                    tutorial.state.send("LEAVE_MAP");
                });
            });
        }).catch((err)=>{
            console.log(err);
        });
    }
    // Expose as a global variable so misc.js can use it
    window.smoothlyGoToMapPoint = smoothlyGoToMapPoint;
    window.smoothlyGoToViewPoint = function(lat, lng, zoom) {
        const point = (0, $3e645b0309771ac1$export$58d8663b36235b13)({
            point: {
                lng: lng,
                lat: lat
            },
            map: map,
            zoom: zoom
        });
        map.flyTo({
            zoom: zoom,
            center: point
        });
    };
    resetButton.addEventListener("click", ()=>{
        reset();
        swapper.swapToGlobe();
    });
    $b8e13ffc5d653b23$var$GLOBE.addEventListener("loadzips", ()=>{
        if ($b8e13ffc5d653b23$var$state.map.immersed) {
            swapper.swapToGlobe();
            reset();
            $b8e13ffc5d653b23$var$state.map.immersed = false;
            $b8e13ffc5d653b23$var$state.map.visible = true;
        }
    });
    map.on("stubbornzoom", (event)=>{
        // const historyState = globeHistoryState({
        //     fips: GLOBE.CLICKED?.userData.fips,
        // })
        // updateHistory(historyState)
        // if (GLOBE.isRegionSpecifiedInUrl()) {
        //     history.replaceState(
        //         { fips: GLOBE.CLICKED?.userData.fips },
        //         "",
        //         `?fips=${GLOBE.CLICKED?.userData.fips as number}`
        //     )
        // } else {
        //     history.pushState(
        //         { fips: GLOBE.CLICKED?.userData.fips },
        //         "",
        //         `?fips=${GLOBE.CLICKED?.userData.fips as number}`
        //     )
        //     // this.historyStatePushed = true;
        // }
        $b8e13ffc5d653b23$var$cameraSynchronizer.syncGlobe();
        reset();
        swapper.swapToGlobe();
        $b8e13ffc5d653b23$var$GLOBE.tutorial.state.send("LEAVE_MAP");
        $b8e13ffc5d653b23$var$state.map.immersed = false;
        $b8e13ffc5d653b23$var$state.map.visible = true;
    });
    document.addEventListener("mapunimmerse", ()=>{
        // GLOBE.dispatchEvent(
        //     new CustomEvent("regionload", {
        //         detail: {
        //             type: "zip",
        //             id: GLOBE.CLICKED.userData.fips,
        //             name: GLOBE.CLICKED.userData.name,
        //             county: GLOBE.CLICKED.userData.fips,
        //             state: GLOBE.COUNTY_GROUP.userData.state_name,
        //         },
        //     })
        // )
        // if (GLOBE.isRegionSpecifiedInUrl()) {
        //     history.replaceState(
        //         { fips: GLOBE.CLICKED.userData.fips },
        //         "",
        //         `?fips=${GLOBE.CLICKED.userData.fips}`
        //     )
        // } else {
        //     history.pushState(
        //         { fips: GLOBE.CLICKED.userData.fips },
        //         "",
        //         `?fips=${GLOBE.CLICKED.userData.fips}`
        //     )
        //     // this.historyStatePushed = true;
        // }
        // cameraSynchronizer.syncGlobe()
        // reset()
        // swapper.swapToGlobe()
        // GLOBE.tutorial.state.send("LEAVE_MAP")
        // state.map.immersed = false
        // state.map.visible = true
        $b8e13ffc5d653b23$var$querySelectorThrow(`#county_list li.selected a`).click();
    // state.map.pendingUnimmerse = false
    });
    // initFromURLParams(GLOBE, {
    //     enterMap,
    //     tutorial,
    // })
    async function onRegionLoad(event, firstSymbolId, firstLineId) {
        if (lastLoaded !== null) {
            const { id: id } = lastLoaded;
            map.offAll();
            map.removeLayer(`${id}-fills`);
            map.removeLayer(`${id}-borders`);
            try {
                map.removeSource(id);
            } catch (err) {
                console.error(err);
            }
            zipLabel.remove();
        }
        lastLoad = event.detail;
        const thisLoad = event.detail;
        const { id: id, name: name } = event.detail;
        const usState = event.detail.state;
        // Immediately set the left panel county name
        $b8e13ffc5d653b23$var$GLOBE.leftPanel.setCounty(name);
        // When the user moves their mouse over the state-fill layer, we'll update the
        // feature state for the feature under the mouse.
        const onMouseMove = function(e) {
            if (typeof e.features === "undefined") return;
            if (e.features.length > 0) {
                if (hoveredStateId !== null && hoveredStateId !== e.features[0].id) {
                    // Un-highlight the old feature
                    map.setFeatureState({
                        source: id,
                        id: hoveredStateId
                    }, {
                        hover: false
                    });
                    zipLabel.remove();
                }
                if (hoveredStateId !== e.features[0].id) {
                    onMouseEnterZip(e.features[0].properties.GEOID20);
                    // Highlight the new feature
                    hoveredStateId = e.features[0].id;
                    map.setFeatureState({
                        source: id,
                        id: hoveredStateId
                    }, {
                        hover: true
                    });
                }
            }
        };
        map.on("mousemove", "test", (event)=>{});
        // When the mouse leaves the state-fill layer, update the feature state of the
        // previously hovered feature.
        const onMouseLeave = function() {
            if (hoveredStateId !== null) map.setFeatureState({
                source: id,
                id: hoveredStateId
            }, {
                hover: false
            });
            hoveredStateId = null;
            zipLabel.remove();
        };
        const onClick = function(event) {
            event.preventDefault();
            const { lng: lng, lat: lat } = event.lngLat;
            enterMap({
                lat: lat,
                lng: lng,
                zoom: 13.24,
                usCounty: name,
                usState: usState
            });
        };
        const response = await fetch(`/assets/geojson/zip-intersection/GEOID_${id}.geojson`);
        // Error checks
        if (!response.ok) {
            console.error("Response not ok", response);
            return;
        }
        if (lastLoad !== thisLoad) {
            console.warn("Load", thisLoad, "superceded by new load", lastLoad);
            return;
        }
        const geojson = await response.json();
        labelPositions = $b8e13ffc5d653b23$var$getLabelPositions(geojson, 0.00001);
        map.addSource(id, {
            type: "geojson",
            data: geojson,
            generateId: true
        });
        lastLoaded = lastLoad;
        map.addLayer({
            id: `${id}-fills`,
            type: "fill",
            source: id,
            layout: {},
            paint: {
                "fill-color": "#9F9888",
                "fill-opacity": [
                    "case",
                    [
                        "boolean",
                        [
                            "feature-state",
                            "hover"
                        ],
                        false
                    ],
                    1,
                    0.1
                ]
            }
        }, firstLineId);
        map.addLayer({
            id: `${id}-borders`,
            type: "line",
            source: id,
            layout: {},
            paint: {
                "line-color": "#9F9888",
                "line-width": 3,
                "line-opacity": 1
            }
        }, firstSymbolId);
        map.trackedOn("mousemove", `${id}-fills`, onMouseMove);
        map.trackedOn("mouseleave", `${id}-fills`, onMouseLeave);
        map.trackedOn("click", `${id}-fills`, onClick);
        $b8e13ffc5d653b23$var$GLOBE.leftPanel.setupZipButtons(geojson, // On mouse enter a zip button
        (zip, featureId)=>{
            onMouseEnterZip(zip);
            hoveredStateId = featureId;
            map.setFeatureState({
                source: id,
                id: hoveredStateId
            }, {
                hover: true
            });
        }, // On mouse leave a zip button
        onMouseLeave, // On zip button click
        (zip, id)=>{
            if (labelPositions === null) {
                console.error("labelPositions was null");
                return;
            }
            const res = labelPositions.get(zip);
            if (res === undefined) {
                console.error("Could not get label positions from zip");
                return;
            }
            const [lng, lat] = res;
            enterMap({
                lat: lat,
                lng: lng,
                zoom: 13.24,
                usCounty: name,
                usState: usState
            });
        });
    }
    return {
        onRegionLoad: onRegionLoad,
        enterMap: enterMap
    };
}
function $b8e13ffc5d653b23$var$waitAndSetUpUICallbacks(nTimes = 0, options) {
    // TODO: Set this up with a proper promise-based system that fires after the state list is loaded
    // console.log(`wait ${nTimes}`);
    if (nTimes >= 300) {
        console.log("ERROR: Waited 30 seconds but state list didn't load in. Giving up.");
        return;
    }
    const stateList = document.getElementById("state_list");
    if (stateList === null) {
        console.log("ERROR: state_list not found, could not setup callbacks");
        // Wait another 100ms for the state list to load in
        setTimeout(()=>{
            $b8e13ffc5d653b23$var$waitAndSetUpUICallbacks(nTimes + 1, options);
        });
        return;
    }
    const buttons = stateList.querySelectorAll("span");
    if (buttons === null || buttons.length === 0) {
        console.log("ERROR: buttons length is 0, could not setup callbacks");
        // Wait another 100ms for the state list to load in
        setTimeout(()=>{
            $b8e13ffc5d653b23$var$waitAndSetUpUICallbacks(nTimes + 1, options);
        });
        return;
    }
    const nChildren = buttons.length;
    for(let i = 0; i < nChildren; i++){
        buttons[i].addEventListener("click", function(e) {
            if ($b8e13ffc5d653b23$var$state.map.immersed) {
                $b8e13ffc5d653b23$var$cameraSynchronizer.master = "globe";
                $b8e13ffc5d653b23$var$cameraSynchronizer.syncGlobe();
                $b8e13ffc5d653b23$var$GLOBE.animate(100000000);
                $b8e13ffc5d653b23$var$swapper.swapToGlobe();
                options.tutorial.state.send("LEAVE_MAP");
            }
            const stateName = this.innerText;
            const stateMesh = $b8e13ffc5d653b23$var$GLOBE.getStateByName(stateName);
            $b8e13ffc5d653b23$var$GLOBE.loadCounties(stateMesh);
        });
        buttons[i].addEventListener("mouseover", function() {
            const stateName = this.innerText;
            const stateMesh = $b8e13ffc5d653b23$var$GLOBE.getStateByName(stateName);
            $b8e13ffc5d653b23$var$GLOBE.highlight(stateMesh);
        });
        buttons[i].addEventListener("mouseout", function() {
            const stateName = this.innerText;
            const stateMesh = $b8e13ffc5d653b23$var$GLOBE.getStateByName(stateName);
            $b8e13ffc5d653b23$var$GLOBE.unhighlight(stateMesh);
        });
    }
}
function $b8e13ffc5d653b23$var$onWindowResize() {
    $b8e13ffc5d653b23$var$renderer.setSize(document.documentElement.clientWidth, document.documentElement.clientHeight);
    const aspectRatio = document.documentElement.clientWidth / document.documentElement.clientHeight;
    $b8e13ffc5d653b23$var$GLOBE.onWindowResize();
    // const fov = MathHelpers.horizontalToVerticalFOV(
    //     GLOBE.camera.fov,
    //     GLOBE.camera.aspect
    // )
    $b8e13ffc5d653b23$var$map.transform._fov = $b8e13ffc5d653b23$var$GLOBE.camera.fov * $8725869b83961a04$export$6a7ef315a0d1ef07.DEG2RAD;
    $b8e13ffc5d653b23$var$map.transform._unmodified = false;
    $b8e13ffc5d653b23$var$map.transform._calcMatrices();
    if (aspectRatio < 1.55) {
        const canvas = $b8e13ffc5d653b23$var$querySelectorThrow("canvas");
        canvas.classList.add("tall");
    } else {
        const canvas = $b8e13ffc5d653b23$var$querySelectorThrow("canvas");
        canvas.classList.remove("tall");
    }
    if ($b8e13ffc5d653b23$var$screenQuad.material instanceof $8725869b83961a04$export$83c7d75d550a8b0d) $b8e13ffc5d653b23$var$screenQuad.material.uniforms.screenAspect.value = $b8e13ffc5d653b23$var$GLOBE.camera.aspect;
}
/**
 * Frame entrypoint
 * @param elapsed
 */ function $b8e13ffc5d653b23$var$animate(elapsed) {
    // stats.begin()
    requestAnimationFrame($b8e13ffc5d653b23$var$animate);
    if (!window.paused) {
        const delta = $b8e13ffc5d653b23$var$fpsClock.getDelta();
        $b8e13ffc5d653b23$var$elapsedTime += delta;
        $b8e13ffc5d653b23$var$TEXTURE_INITIALIZER.update();
        if ($b8e13ffc5d653b23$var$swapper === undefined || $b8e13ffc5d653b23$var$swapper.globeVisible) $b8e13ffc5d653b23$var$GLOBE.animate($b8e13ffc5d653b23$var$elapsedTime);
        else $b8e13ffc5d653b23$var$GLOBE.updateTweens();
        if ($b8e13ffc5d653b23$var$state.map.visible || $b8e13ffc5d653b23$var$state.map.visibleSoon) $b8e13ffc5d653b23$var$cameraSynchronizer?.update();
        $b8e13ffc5d653b23$var$cameraSynchronizer?.updateTweens();
        if ($b8e13ffc5d653b23$var$swapper === undefined || $b8e13ffc5d653b23$var$swapper.globeVisible) $b8e13ffc5d653b23$var$render();
        else $b8e13ffc5d653b23$var$GLOBE.controls.update();
    }
// stats.end()
}
function $b8e13ffc5d653b23$var$render() {
    // Render globe
    $b8e13ffc5d653b23$var$GLOBE.render($b8e13ffc5d653b23$var$renderer);
}

})();
//# sourceMappingURL=index.js.map
